// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[8].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[8].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[8].use[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[8].use[4]!../../node_modules/slick-carousel/slick/slick.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[8].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[8].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[8].use[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[8].use[4]!../../node_modules/slick-carousel/slick/slick-theme.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%2328a745%27 d=%27M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%274%27 height=%275%27 viewBox=%270 0 4 5%27%3e%3cpath fill=%27%23343a40%27 d=%27M2 0L0 2h4zm0 5L0 3h4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23dc3545%27 viewBox=%270 0 12 12%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23dc3545%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23fff%27 d=%27M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%274%27 height=%274%27 viewBox=%270 0 4 4%27%3e%3cpath stroke=%27%23fff%27 d=%27M0 2h4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2730%27 height=%2730%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%280, 0, 0, 0.5%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2730%27 height=%2730%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.5%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("@mdi/font/fonts/materialdesignicons-webfont.eot?v=4.9.95", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("@mdi/font/fonts/materialdesignicons-webfont.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("@mdi/font/fonts/materialdesignicons-webfont.woff2?v=4.9.95", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("@mdi/font/fonts/materialdesignicons-webfont.woff?v=4.9.95", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("@mdi/font/fonts/materialdesignicons-webfont.ttf?v=4.9.95", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../assets/images/auth/login-bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../assets/images/auth/register-bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../assets/images/auth/lockscreen-bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/gif;base64,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", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Rubik:300,400,500,700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___, { hash: "?#iefix&v=4.9.95" });
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
@keyframes flash {
  0% {
    opacity: 1;
  }
  25% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  75% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes bounce {
  0% {
    transform: translateY(0);
  }
  20% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-30px);
  }
  50% {
    transform: translateY(0);
  }
  60% {
    transform: translateY(-15px);
  }
  80% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(0);
  }
}
@keyframes shake {
  0% {
    transform: translateX(0);
  }
  10% {
    transform: translateX(-10px);
  }
  20% {
    transform: translateX(10px);
  }
  30% {
    transform: translateX(-10px);
  }
  40% {
    transform: translateX(10px);
  }
  50% {
    transform: translateX(-10px);
  }
  60% {
    transform: translateX(10px);
  }
  70% {
    transform: translateX(-10px);
  }
  80% {
    transform: translateX(10px);
  }
  90% {
    transform: translateX(-10px);
  }
  100% {
    transform: translateX(0);
  }
}
@keyframes tada {
  0% {
    transform: scale(1, 1);
  }
  10% {
    transform: scale(0.9) rotate(-3deg);
  }
  20% {
    transform: scale(0.9) rotate(-3deg);
  }
  30% {
    transform: scale(1.1) rotate(3deg);
  }
  40% {
    transform: scale(1.1) rotate(-3deg);
  }
  50% {
    transform: scale(1.1) rotate(3deg);
  }
  60% {
    transform: scale(1.1) rotate(-3deg);
  }
  70% {
    transform: scale(1.1) rotate(3deg);
  }
  80% {
    transform: scale(1.1) rotate(-3deg);
  }
  90% {
    transform: scale(1.1) rotate(3deg);
  }
  100% {
    transform: scale(1) rotate(0);
  }
}
@keyframes swing {
  20%, 40%, 60%, 80%, 100% {
    transform-origin: top center 50%;
  }
  20% {
    transform: rotate(15deg);
  }
  40% {
    transform: rotate(-10deg);
  }
  60% {
    transform: rotate(5deg);
  }
  80% {
    transform: rotate(-5deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
@keyframes wobble {
  0% {
    transform: translateX(0%);
  }
  15% {
    transform: translateX(-25%) rotate(-5deg);
  }
  30% {
    transform: translateX(20%) rotate(3deg);
  }
  45% {
    transform: translateX(-15%) rotate(-3deg);
  }
  60% {
    transform: translateX(10%) rotate(2deg);
  }
  75% {
    transform: translateX(-5%) rotate(-1deg);
  }
  100% {
    transform: translateX(0%);
  }
}
@keyframes pulse {
  0% {
    transform: scale(1, 1);
  }
  50% {
    transform: scale(1.1, 1.1);
  }
  100% {
    transform: scale(1, 1);
  }
}
@keyframes wiggle {
  0% {
    transform: skewX(9deg);
  }
  10% {
    transform: skewX(-8deg);
  }
  20% {
    transform: skewX(7deg);
  }
  30% {
    transform: skewX(-6deg);
  }
  40% {
    transform: skewX(5deg);
  }
  50% {
    transform: skewX(-4deg);
  }
  60% {
    transform: skewX(3deg);
  }
  70% {
    transform: skewX(-2deg);
  }
  80% {
    transform: skewX(1deg);
  }
  90% {
    transform: skewX(0deg);
  }
  100% {
    transform: skewX(0deg);
  }
}
@keyframes bounceOut {
  0% {
    transform: scale(1, 1);
  }
  25% {
    transform: scale(0.95, 0.95);
  }
  50% {
    opacity: 1;
    transform: scale(1.1, 1.1);
  }
  100% {
    opacity: 0;
    transform: scale(0.3, 0.3);
  }
}
@keyframes bounceOutUp {
  0% {
    transform: translateY(0);
  }
  20% {
    opacity: 1;
    transform: translateY(20px);
  }
  100% {
    opacity: 0;
    transform: translateY(-2000px);
  }
}
@keyframes bounceOutDown {
  0% {
    transform: translateY(0);
  }
  20% {
    opacity: 1;
    transform: translateY(-20px);
  }
  100% {
    opacity: 0;
    transform: translateY(2000px);
  }
}
@keyframes bounceOutLeft {
  0% {
    transform: translateX(0);
  }
  20% {
    opacity: 1;
    transform: translateX(20px);
  }
  100% {
    opacity: 0;
    transform: translateX(-2000px);
  }
}
@keyframes bounceOutRight {
  0% {
    transform: translateX(0);
  }
  20% {
    opacity: 1;
    transform: translateX(-20px);
  }
  100% {
    opacity: 0;
    transform: translateX(2000px);
  }
}
@keyframes bounceIn {
  0% {
    opacity: 0;
    transform: scale(0.3, 0.3);
  }
  50% {
    opacity: 1;
    transform: scale(1.05, 1.05);
  }
  70% {
    transform: scale(0.9, 0.9);
  }
  100% {
    transform: scale(1, 1);
  }
}
@keyframes bounceInDown {
  0% {
    opacity: 0;
    transform: translateY(-2000px);
  }
  60% {
    opacity: 1;
    transform: translateY(30px);
  }
  80% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(0);
  }
}
@keyframes bounceInUp {
  0% {
    opacity: 0;
    transform: translateY(2000px);
  }
  60% {
    opacity: 1;
    transform: translateY(-30px);
  }
  80% {
    transform: translateY(10px);
  }
  100% {
    transform: translateY(0);
  }
}
@keyframes bounceInRight {
  0% {
    opacity: 0;
    transform: translateX(2000px);
  }
  60% {
    opacity: 1;
    transform: translateX(-30px);
  }
  80% {
    transform: translateX(10px);
  }
  100% {
    transform: translateX(0);
  }
}
@keyframes bounceInLeft {
  0% {
    opacity: 0;
    transform: translateX(-2000px);
  }
  60% {
    opacity: 1;
    transform: translateX(30px);
  }
  80% {
    transform: translateX(-10px);
  }
  100% {
    transform: translateX(0);
  }
}
@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes fadeOutUp {
  0% {
    transform: translateY(0);
    opacity: 1;
  }
  100% {
    transform: translateY(-20px);
    opacity: 0;
  }
}
@keyframes fadeOutDown {
  0% {
    transform: translateY(0);
    opacity: 1;
  }
  100% {
    transform: translateY(20px);
    opacity: 0;
  }
}
@keyframes fadeOutRight {
  0% {
    transform: translateX(0);
    opacity: 1;
  }
  100% {
    transform: translateX(20px);
    opacity: 0;
  }
}
@keyframes fadeOutLeft {
  0% {
    transform: translateX(0);
    opacity: 1;
  }
  100% {
    transform: translateX(-20px);
    opacity: 0;
  }
}
@keyframes fadeOutUpBig {
  0% {
    transform: translateY(0);
    opacity: 1;
  }
  100% {
    transform: translateY(-2000px);
    opacity: 0;
  }
}
@keyframes fadeOutDownBig {
  0% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(2000px);
  }
}
@keyframes fadeOutRightBig {
  0% {
    opacity: 1;
    transform: translateX(0);
  }
  100% {
    opacity: 0;
    transform: translateX(2000px);
  }
}
@keyframes fadeOutLeftBig {
  0% {
    opacity: 1;
    transform: translateX(0);
  }
  100% {
    opacity: 0;
    transform: translateX(-2000px);
  }
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadeInUp {
  0% {
    transform: translateY(20px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
@keyframes fadeInDown {
  0% {
    transform: translateY(-20px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
@keyframes fadeInRight {
  0% {
    transform: translateX(20px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
@keyframes fadeInLeft {
  0% {
    transform: translateX(-20px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
@keyframes fadeInUpBig {
  0% {
    transform: translateY(2000px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
@keyframes fadeInDownBig {
  0% {
    opacity: 0;
    transform: translateY(-2000px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes fadeInRightBig {
  0% {
    opacity: 0;
    transform: translateX(2000px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes fadeInLeftBig {
  0% {
    opacity: 0;
    transform: translateX(-2000px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes flip {
  0% {
    transform: perspective(400px) rotateY(0);
    animation-timing-function: ease-out;
  }
  40% {
    transform: perspective(400px) translateZ(150px) rotateY(170deg);
    animation-timing-function: ease-out;
  }
  50% {
    transform: perspective(400px) translateZ(150px) rotateY(190deg) scale(1);
    animation-timing-function: ease-in;
  }
  80% {
    transform: perspective(400px) rotateY(360deg) scale(0.95);
    animation-timing-function: ease-in;
  }
  100% {
    transform: perspective(400px) scale(1);
    animation-timing-function: ease-in;
  }
}
@keyframes flipInX {
  0% {
    transform: perspective(400px) rotateX(90deg);
    filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=0);
    opacity: 0;
  }
  40% {
    transform: perspective(400px) rotateX(-10deg);
  }
  70% {
    transform: perspective(400px) rotateX(10deg);
  }
  100% {
    transform: perspective(400px) rotateX(0deg);
    filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
    opacity: 1;
  }
}
@keyframes flipOutX {
  0% {
    transform: perspective(400px) rotateX(0deg);
    filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
    opacity: 1;
  }
  100% {
    transform: perspective(400px) rotateX(90deg);
    filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=0);
    opacity: 0;
  }
}
@keyframes flipInY {
  0% {
    transform: perspective(400px) rotateY(90deg);
    filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=0);
    opacity: 0;
  }
  40% {
    transform: perspective(400px) rotateY(-10deg);
  }
  70% {
    transform: perspective(400px) rotateY(10deg);
  }
  100% {
    transform: perspective(400px) rotateY(0deg);
    filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
    opacity: 1;
  }
}
@keyframes flipOutY {
  0% {
    transform: perspective(400px) rotateY(0deg);
    filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
    opacity: 1;
  }
  100% {
    transform: perspective(400px) rotateY(90deg);
    filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=0);
    opacity: 0;
  }
}
@keyframes lightSpeedIn {
  0% {
    transform: translateX(100%) skewX(-30deg);
    filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=0);
    opacity: 0;
  }
  60% {
    transform: translateX(-20%) skewX(30deg);
    filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
    opacity: 1;
  }
  80% {
    transform: translateX(0%) skewX(-15deg);
    filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
    opacity: 1;
  }
  100% {
    transform: translateX(0%) skewX(0deg);
    filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
    opacity: 1;
  }
}
@keyframes lightSpeedOut {
  0% {
    transform: translateX(0%) skewX(0deg);
    filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
    opacity: 1;
  }
  100% {
    transform: translateX(100%) skewX(-30deg);
    filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=0);
    opacity: 0;
  }
}
@keyframes rotateOut {
  0% {
    transform-origin: center center 50%;
    transform: rotate(0);
    opacity: 1;
  }
  100% {
    transform-origin: center center 50%;
    transform: rotate(200deg);
    opacity: 0;
  }
}
@keyframes rotateOutDownLeft {
  0% {
    transform-origin: left bottom 50%;
    transform: rotate(0);
    opacity: 1;
  }
  100% {
    transform-origin: left bottom 50%;
    transform: rotate(90deg);
    opacity: 0;
  }
}
@keyframes rotateOutUpLeft {
  0% {
    transform-origin: left bottom 50%;
    transform: rotate(0);
    opacity: 1;
  }
  100% {
    transform-origin: left bottom 50%;
    transform: rotate(-90deg);
    opacity: 0;
  }
}
@keyframes rotateOutDownRight {
  0% {
    transform-origin: right bottom 50%;
    transform: rotate(0);
    opacity: 1;
  }
  100% {
    transform-origin: right bottom 50%;
    transform: rotate(-90deg);
    opacity: 0;
  }
}
@keyframes rotateOutUpRight {
  0% {
    transform-origin: right bottom 50%;
    transform: rotate(0);
    opacity: 1;
  }
  100% {
    transform-origin: right bottom 50%;
    transform: rotate(90deg);
    opacity: 0;
  }
}
@keyframes rotateIn {
  0% {
    transform-origin: center center 50%;
    transform: rotate(-200deg);
    opacity: 0;
  }
  100% {
    transform-origin: center center 50%;
    transform: rotate(0);
    opacity: 1;
  }
}
@keyframes rotateInDownLeft {
  0% {
    transform-origin: left bottom 50%;
    transform: rotate(-90deg);
    opacity: 0;
  }
  100% {
    transform-origin: left bottom 50%;
    transform: rotate(0);
    opacity: 1;
  }
}
@keyframes rotateInUpLeft {
  0% {
    transform-origin: left bottom 50%;
    transform: rotate(90deg);
    opacity: 0;
  }
  100% {
    transform-origin: left bottom 50%;
    transform: rotate(0);
    opacity: 1;
  }
}
@keyframes rotateInUpRight {
  0% {
    transform-origin: right bottom 50%;
    transform: rotate(-90deg);
    opacity: 0;
  }
  100% {
    transform-origin: right bottom 50%;
    transform: rotate(0);
    opacity: 1;
  }
}
@keyframes rotateInDownRight {
  0% {
    transform-origin: right bottom 50%;
    transform: rotate(90deg);
    opacity: 0;
  }
  100% {
    transform-origin: right bottom 50%;
    transform: rotate(0);
    opacity: 1;
  }
}
@keyframes hinge {
  0% {
    transform: rotate(0);
    transform-origin: top left 50%;
    animation-timing-function: ease-in-out;
  }
  20%, 60% {
    transform: rotate(80deg);
    transform-origin: top left 50%;
    animation-timing-function: ease-in-out;
  }
  40% {
    transform: rotate(60deg);
    transform-origin: top left 50%;
    animation-timing-function: ease-in-out;
  }
  80% {
    transform: rotate(60deg) translateY(0);
    filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
    opacity: 1;
    transform-origin: top left 50%;
    animation-timing-function: ease-in-out;
  }
  100% {
    transform: translateY(700px);
    filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=0);
    opacity: 0;
  }
}
@keyframes rollIn {
  0% {
    filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=0);
    opacity: 0;
    transform: translateX(-100%) rotate(-120deg);
  }
  100% {
    filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
    opacity: 1;
    transform: translateX(0px) rotate(0deg);
  }
}
@keyframes rollOut {
  0% {
    filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
    opacity: 1;
    transform: translateX(0px) rotate(0deg);
  }
  100% {
    filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=0);
    opacity: 0;
    transform: translateX(-100%) rotate(-120deg);
  }
}
/*!
 * Bootstrap v4.6.2 (https://getbootstrap.com/)
 * Copyright 2011-2022 The Bootstrap Authors
 * Copyright 2011-2022 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root {
  --blue: #5E50F9;
  --indigo: #6610f2;
  --purple: #6a008a;
  --pink: #E91E63;
  --red: #f96868;
  --orange: #f2a654;
  --yellow: #f6e84e;
  --green: #46c35f;
  --teal: #58d8a3;
  --cyan: #57c7d4;
  --white: #ffffff;
  --gray: #6c757d;
  --gray-dark: #12151e;
  --blue: #5E50F9;
  --indigo: #6610f2;
  --purple: #6a008a;
  --pink: #E91E63;
  --red: #f96868;
  --orange: #f2a654;
  --yellow: #f6e84e;
  --green: #46c35f;
  --teal: #58d8a3;
  --cyan: #57c7d4;
  --white: #ffffff;
  --gray: #434a54;
  --gray-light: #aab2bd;
  --gray-lighter: #e8eff4;
  --gray-lightest: #e6e9ed;
  --black: #000000;
  --primary: #0090e7;
  --secondary: #e4eaec;
  --success: #00d25b;
  --info: #8f5fe8;
  --warning: #ffab00;
  --danger: #fc424a;
  --light: #ffffff;
  --dark: #0d0d0d;
  --breakpoint-xs: 0;
  --breakpoint-sm: 576px;
  --breakpoint-md: 768px;
  --breakpoint-lg: 992px;
  --breakpoint-xl: 1200px;
  --font-family-sans-serif: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  font-family: sans-serif;
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

article, aside, figcaption, figure, footer, header, hgroup, main, nav, section {
  display: block;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #2e383e;
  text-align: left;
  background-color: #fff;
}

[tabindex="-1"]:focus:not(:focus-visible) {
  outline: 0 !important;
}

hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible;
}

h1, h2, h3, h4, h5, h6 {
  margin-top: 0;
  margin-bottom: 0.5rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title],
abbr[data-original-title] {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  border-bottom: 0;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small {
  font-size: 80%;
}

sub,
sup {
  position: relative;
  font-size: 75%;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: #007bff;
  text-decoration: none;
  background-color: transparent;
}
a:hover {
  color: #0056b3;
  text-decoration: underline;
}

a:not([href]):not([class]) {
  color: inherit;
  text-decoration: none;
}
a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 1em;
}

pre {
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  -ms-overflow-style: scrollbar;
}

figure {
  margin: 0 0 1rem;
}

img {
  vertical-align: middle;
  border-style: none;
}

svg {
  overflow: hidden;
  vertical-align: middle;
}

table {
  border-collapse: collapse;
}

caption {
  padding-top: 0.9375rem;
  padding-bottom: 0.9375rem;
  color: #6c757d;
  text-align: left;
  caption-side: bottom;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

label {
  display: inline-block;
  margin-bottom: 0.5rem;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
input {
  overflow: visible;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}

button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

button::-moz-focus-inner,
[type=button]::-moz-focus-inner,
[type=reset]::-moz-focus-inner,
[type=submit]::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

input[type=radio],
input[type=checkbox] {
  box-sizing: border-box;
  padding: 0;
}

textarea {
  overflow: auto;
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  display: block;
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: 1.5rem;
  line-height: inherit;
  color: inherit;
  white-space: normal;
}

progress {
  vertical-align: baseline;
}

[type=number]::-webkit-inner-spin-button,
[type=number]::-webkit-outer-spin-button {
  height: auto;
}

[type=search] {
  outline-offset: -2px;
  -webkit-appearance: none;
}

[type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

summary {
  display: list-item;
  cursor: pointer;
}

template {
  display: none;
}

[hidden] {
  display: none !important;
}

h1, h2, h3, h4, h5, h6,
.h1, .h2, .h3, .h4, .h5, .h6 {
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
}

h1, .h1 {
  font-size: 2.5rem;
}

h2, .h2 {
  font-size: 2rem;
}

h3, .h3 {
  font-size: 1.75rem;
}

h4, .h4 {
  font-size: 1.5rem;
}

h5, .h5 {
  font-size: 1.25rem;
}

h6, .h6 {
  font-size: 1rem;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
}

.display-1 {
  font-size: 6rem;
  font-weight: 300;
  line-height: 1.2;
}

.display-2 {
  font-size: 5.5rem;
  font-weight: 300;
  line-height: 1.2;
}

.display-3 {
  font-size: 4.5rem;
  font-weight: 300;
  line-height: 1.2;
}

.display-4 {
  font-size: 3.5rem;
  font-weight: 300;
  line-height: 1.2;
}

hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

small,
.small {
  font-size: 0.875em;
  font-weight: 400;
}

mark,
.mark {
  padding: 0.2em;
  background-color: #fcf8e3;
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 90%;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}

.blockquote-footer {
  display: block;
  font-size: 0.875em;
  color: #6c757d;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: #fff;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 90%;
  color: #6c757d;
}

code {
  font-size: 87.5%;
  color: #e83e8c;
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.2rem 0.4rem;
  font-size: 87.5%;
  color: #fff;
  background-color: #212529;
  border-radius: 0.2rem;
}
kbd kbd {
  padding: 0;
  font-size: 100%;
  font-weight: 700;
}

pre {
  display: block;
  font-size: 87.5%;
  color: #212529;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

.pre-scrollable {
  max-height: 340px;
  overflow-y: scroll;
}

.container,
.container-fluid,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  width: 100%;
  padding-right: 0.75rem;
  padding-left: 0.75rem;
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -0.75rem;
  margin-left: -0.75rem;
}

.no-gutters {
  margin-right: 0;
  margin-left: 0;
}
.no-gutters > .col,
.no-gutters > [class*=col-] {
  padding-right: 0;
  padding-left: 0;
}

.col-xl,
.col-xl-auto, .col-xl-12, .col-xl-11, .col-xl-10, .col-xl-9, .col-xl-8, .col-xl-7, .col-xl-6, .col-xl-5, .col-xl-4, .col-xl-3, .col-xl-2, .col-xl-1, .col-lg,
.col-lg-auto, .col-lg-12, .col-lg-11, .col-lg-10, .col-lg-9, .col-lg-8, .col-lg-7, .col-lg-6, .col-lg-5, .col-lg-4, .col-lg-3, .col-lg-2, .col-lg-1, .col-md,
.col-md-auto, .col-md-12, .col-md-11, .col-md-10, .col-md-9, .col-md-8, .col-md-7, .col-md-6, .col-md-5, .col-md-4, .col-md-3, .col-md-2, .col-md-1, .col-sm,
.col-sm-auto, .col-sm-12, .col-sm-11, .col-sm-10, .col-sm-9, .col-sm-8, .col-sm-7, .col-sm-6, .col-sm-5, .col-sm-4, .col-sm-3, .col-sm-2, .col-sm-1, .col,
.col-auto, .col-12, .col-11, .col-10, .col-9, .col-8, .col-7, .col-6, .col-5, .col-4, .col-3, .col-2, .col-1 {
  position: relative;
  width: 100%;
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.col {
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
}

.row-cols-1 > * {
  flex: 0 0 100%;
  max-width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 50%;
  max-width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 33.3333333333%;
  max-width: 33.3333333333%;
}

.row-cols-4 > * {
  flex: 0 0 25%;
  max-width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 20%;
  max-width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 16.6666666667%;
  max-width: 16.6666666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
  max-width: 100%;
}

.col-1 {
  flex: 0 0 8.33333333%;
  max-width: 8.33333333%;
}

.col-2 {
  flex: 0 0 16.66666667%;
  max-width: 16.66666667%;
}

.col-3 {
  flex: 0 0 25%;
  max-width: 25%;
}

.col-4 {
  flex: 0 0 33.33333333%;
  max-width: 33.33333333%;
}

.col-5 {
  flex: 0 0 41.66666667%;
  max-width: 41.66666667%;
}

.col-6 {
  flex: 0 0 50%;
  max-width: 50%;
}

.col-7 {
  flex: 0 0 58.33333333%;
  max-width: 58.33333333%;
}

.col-8 {
  flex: 0 0 66.66666667%;
  max-width: 66.66666667%;
}

.col-9 {
  flex: 0 0 75%;
  max-width: 75%;
}

.col-10 {
  flex: 0 0 83.33333333%;
  max-width: 83.33333333%;
}

.col-11 {
  flex: 0 0 91.66666667%;
  max-width: 91.66666667%;
}

.col-12 {
  flex: 0 0 100%;
  max-width: 100%;
}

.order-first {
  order: -1;
}

.order-last {
  order: 13;
}

.order-0 {
  order: 0;
}

.order-1 {
  order: 1;
}

.order-2 {
  order: 2;
}

.order-3 {
  order: 3;
}

.order-4 {
  order: 4;
}

.order-5 {
  order: 5;
}

.order-6 {
  order: 6;
}

.order-7 {
  order: 7;
}

.order-8 {
  order: 8;
}

.order-9 {
  order: 9;
}

.order-10 {
  order: 10;
}

.order-11 {
  order: 11;
}

.order-12 {
  order: 12;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

@media (min-width: 576px) {
  .col-sm {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-sm-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-sm-first {
    order: -1;
  }
  .order-sm-last {
    order: 13;
  }
  .order-sm-0 {
    order: 0;
  }
  .order-sm-1 {
    order: 1;
  }
  .order-sm-2 {
    order: 2;
  }
  .order-sm-3 {
    order: 3;
  }
  .order-sm-4 {
    order: 4;
  }
  .order-sm-5 {
    order: 5;
  }
  .order-sm-6 {
    order: 6;
  }
  .order-sm-7 {
    order: 7;
  }
  .order-sm-8 {
    order: 8;
  }
  .order-sm-9 {
    order: 9;
  }
  .order-sm-10 {
    order: 10;
  }
  .order-sm-11 {
    order: 11;
  }
  .order-sm-12 {
    order: 12;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-md-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-md-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-md-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-md-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-md-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-md-first {
    order: -1;
  }
  .order-md-last {
    order: 13;
  }
  .order-md-0 {
    order: 0;
  }
  .order-md-1 {
    order: 1;
  }
  .order-md-2 {
    order: 2;
  }
  .order-md-3 {
    order: 3;
  }
  .order-md-4 {
    order: 4;
  }
  .order-md-5 {
    order: 5;
  }
  .order-md-6 {
    order: 6;
  }
  .order-md-7 {
    order: 7;
  }
  .order-md-8 {
    order: 8;
  }
  .order-md-9 {
    order: 9;
  }
  .order-md-10 {
    order: 10;
  }
  .order-md-11 {
    order: 11;
  }
  .order-md-12 {
    order: 12;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-lg-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-lg-first {
    order: -1;
  }
  .order-lg-last {
    order: 13;
  }
  .order-lg-0 {
    order: 0;
  }
  .order-lg-1 {
    order: 1;
  }
  .order-lg-2 {
    order: 2;
  }
  .order-lg-3 {
    order: 3;
  }
  .order-lg-4 {
    order: 4;
  }
  .order-lg-5 {
    order: 5;
  }
  .order-lg-6 {
    order: 6;
  }
  .order-lg-7 {
    order: 7;
  }
  .order-lg-8 {
    order: 8;
  }
  .order-lg-9 {
    order: 9;
  }
  .order-lg-10 {
    order: 10;
  }
  .order-lg-11 {
    order: 11;
  }
  .order-lg-12 {
    order: 12;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-xl-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-xl-first {
    order: -1;
  }
  .order-xl-last {
    order: 13;
  }
  .order-xl-0 {
    order: 0;
  }
  .order-xl-1 {
    order: 1;
  }
  .order-xl-2 {
    order: 2;
  }
  .order-xl-3 {
    order: 3;
  }
  .order-xl-4 {
    order: 4;
  }
  .order-xl-5 {
    order: 5;
  }
  .order-xl-6 {
    order: 6;
  }
  .order-xl-7 {
    order: 7;
  }
  .order-xl-8 {
    order: 8;
  }
  .order-xl-9 {
    order: 9;
  }
  .order-xl-10 {
    order: 10;
  }
  .order-xl-11 {
    order: 11;
  }
  .order-xl-12 {
    order: 12;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
}
.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
}
.table th,
.table td {
  padding: 0.9375rem;
  vertical-align: top;
  border-top: 1px solid #2c2e33;
}
.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #2c2e33;
}
.table tbody + tbody {
  border-top: 2px solid #2c2e33;
}

.table-sm th,
.table-sm td {
  padding: 0.3rem;
}

.table-bordered {
  border: 1px solid #2c2e33;
}
.table-bordered th,
.table-bordered td {
  border: 1px solid #2c2e33;
}
.table-bordered thead th,
.table-bordered thead td {
  border-bottom-width: 2px;
}

.table-borderless th,
.table-borderless td,
.table-borderless thead th,
.table-borderless tbody + tbody {
  border: 0;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: #f8f8f8;
}

.table-hover tbody tr:hover {
  color: #212529;
  background-color: #f8f8f8;
}

.table-primary,
.table-primary > th,
.table-primary > td {
  background-color: #b8e0f8;
}
.table-primary th,
.table-primary td,
.table-primary thead th,
.table-primary tbody + tbody {
  border-color: #7ac5f3;
}

.table-hover .table-primary:hover {
  background-color: #a1d6f6;
}
.table-hover .table-primary:hover > td,
.table-hover .table-primary:hover > th {
  background-color: #a1d6f6;
}

.table-secondary,
.table-secondary > th,
.table-secondary > td {
  background-color: #f7f9fa;
}
.table-secondary th,
.table-secondary td,
.table-secondary thead th,
.table-secondary tbody + tbody {
  border-color: #f1f4f5;
}

.table-hover .table-secondary:hover {
  background-color: #e7edf0;
}
.table-hover .table-secondary:hover > td,
.table-hover .table-secondary:hover > th {
  background-color: #e7edf0;
}

.table-success,
.table-success > th,
.table-success > td {
  background-color: #b8f2d1;
}
.table-success th,
.table-success td,
.table-success thead th,
.table-success tbody + tbody {
  border-color: #7ae8aa;
}

.table-hover .table-success:hover {
  background-color: #a2eec3;
}
.table-hover .table-success:hover > td,
.table-hover .table-success:hover > th {
  background-color: #a2eec3;
}

.table-info,
.table-info > th,
.table-info > td {
  background-color: #e0d2f9;
}
.table-info th,
.table-info td,
.table-info thead th,
.table-info tbody + tbody {
  border-color: #c5acf3;
}

.table-hover .table-info:hover {
  background-color: #d1bcf6;
}
.table-hover .table-info:hover > td,
.table-hover .table-info:hover > th {
  background-color: #d1bcf6;
}

.table-warning,
.table-warning > th,
.table-warning > td {
  background-color: #ffe7b8;
}
.table-warning th,
.table-warning td,
.table-warning thead th,
.table-warning tbody + tbody {
  border-color: #ffd37a;
}

.table-hover .table-warning:hover {
  background-color: #ffde9f;
}
.table-hover .table-warning:hover > td,
.table-hover .table-warning:hover > th {
  background-color: #ffde9f;
}

.table-danger,
.table-danger > th,
.table-danger > td {
  background-color: #fecacc;
}
.table-danger th,
.table-danger td,
.table-danger thead th,
.table-danger tbody + tbody {
  border-color: #fd9da1;
}

.table-hover .table-danger:hover {
  background-color: #feb1b4;
}
.table-hover .table-danger:hover > td,
.table-hover .table-danger:hover > th {
  background-color: #feb1b4;
}

.table-light,
.table-light > th,
.table-light > td {
  background-color: white;
}
.table-light th,
.table-light td,
.table-light thead th,
.table-light tbody + tbody {
  border-color: white;
}

.table-hover .table-light:hover {
  background-color: #f2f2f2;
}
.table-hover .table-light:hover > td,
.table-hover .table-light:hover > th {
  background-color: #f2f2f2;
}

.table-dark,
.table-dark > th,
.table-dark > td {
  background-color: #bbbbbb;
}
.table-dark th,
.table-dark td,
.table-dark thead th,
.table-dark tbody + tbody {
  border-color: #818181;
}

.table-hover .table-dark:hover {
  background-color: #aeaeae;
}
.table-hover .table-dark:hover > td,
.table-hover .table-dark:hover > th {
  background-color: #aeaeae;
}

.table-active,
.table-active > th,
.table-active > td {
  background-color: rgba(0, 0, 0, 0.075);
}

.table-hover .table-active:hover {
  background-color: rgba(0, 0, 0, 0.075);
}
.table-hover .table-active:hover > td,
.table-hover .table-active:hover > th {
  background-color: rgba(0, 0, 0, 0.075);
}

.table .thead-dark th {
  color: #fff;
  background-color: #343a40;
  border-color: #454d55;
}
.table .thead-light th {
  color: #495057;
  background-color: #e9ecef;
  border-color: #2c2e33;
}

.table-dark {
  color: #fff;
  background-color: #343a40;
}
.table-dark th,
.table-dark td,
.table-dark thead th {
  border-color: #454d55;
}
.table-dark.table-bordered {
  border: 0;
}
.table-dark.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(255, 255, 255, 0.05);
}
.table-dark.table-hover tbody tr:hover {
  color: #fff;
  background-color: rgba(255, 255, 255, 0.075);
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-sm > .table-bordered {
    border: 0;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-md > .table-bordered {
    border: 0;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-lg > .table-bordered {
    border: 0;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-xl > .table-bordered {
    border: 0;
  }
}
.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.table-responsive > .table-bordered {
  border: 0;
}

.form-control {
  display: block;
  width: 100%;
  height: 2.875rem;
  padding: 0.56rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #2c2e33;
  border-radius: 2px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control::-ms-expand {
  background-color: transparent;
  border: 0;
}
.form-control:focus {
  color: #495057;
  background-color: #fff;
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.form-control::placeholder {
  color: #2e383e;
  opacity: 1;
}
.form-control:disabled, .form-control[readonly] {
  background-color: #e9ecef;
  opacity: 1;
}

input[type=date].form-control,
input[type=time].form-control,
input[type=datetime-local].form-control,
input[type=month].form-control {
  appearance: none;
}

select.form-control:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #495057;
}
select.form-control:focus::-ms-value {
  color: #495057;
  background-color: #fff;
}

.form-control-file,
.form-control-range {
  display: block;
  width: 100%;
}

.col-form-label {
  padding-top: calc(0.56rem + 1px);
  padding-bottom: calc(0.56rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1;
}

.col-form-label-lg {
  padding-top: calc(0.94rem + 1px);
  padding-bottom: calc(0.94rem + 1px);
  font-size: 1.25rem;
  line-height: 1.5;
}

.col-form-label-sm {
  padding-top: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + 1px);
  font-size: 0.875rem;
  line-height: 1.5;
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.56rem 0;
  margin-bottom: 0;
  font-size: 0.875rem;
  line-height: 1;
  color: #212529;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  height: 2.575rem;
  padding: 0.5rem 0.81rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}

.form-control-lg {
  height: 3.175rem;
  padding: 0.94rem 1.94rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.3rem;
}

select.form-control[size], select.form-control[multiple] {
  height: auto;
}

textarea.form-control {
  height: auto;
}

.form-group {
  margin-bottom: 1rem;
}

.form-text {
  display: block;
  margin-top: 0.25rem;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}
.form-row > .col,
.form-row > [class*=col-] {
  padding-right: 5px;
  padding-left: 5px;
}

.form-check {
  position: relative;
  display: block;
  padding-left: 1.25rem;
}

.form-check-input {
  position: absolute;
  margin-top: 0.3rem;
  margin-left: -1.25rem;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  color: #6c7293;
}

.form-check-label {
  margin-bottom: 0;
}

.form-check-inline {
  display: inline-flex;
  align-items: center;
  padding-left: 0;
  margin-right: 0.75rem;
}
.form-check-inline .form-check-input {
  position: static;
  margin-top: 0;
  margin-right: 0.3125rem;
  margin-left: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #28a745;
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #fff;
  background-color: rgba(40, 167, 69, 0.9);
  border-radius: 0.25rem;
}
.form-row > .col > .valid-tooltip, .form-row > [class*=col-] > .valid-tooltip {
  left: 5px;
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: #28a745;
  padding-right: calc(1.5em + 0.75rem) !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: #28a745;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}

.was-validated select.form-control:valid, select.form-control.is-valid {
  padding-right: 3rem !important;
  background-position: right 1.5rem center;
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .custom-select:valid, .custom-select.is-valid {
  border-color: #28a745;
  padding-right: calc(0.75em + 2.3125rem) !important;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) right 0.75rem center/8px 10px no-repeat, #fff url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem) no-repeat;
}
.was-validated .custom-select:valid:focus, .custom-select.is-valid:focus {
  border-color: #28a745;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}

.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: #28a745;
}
.was-validated .form-check-input:valid ~ .valid-feedback,
.was-validated .form-check-input:valid ~ .valid-tooltip, .form-check-input.is-valid ~ .valid-feedback,
.form-check-input.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .custom-control-input:valid ~ .custom-control-label, .custom-control-input.is-valid ~ .custom-control-label {
  color: #28a745;
}
.was-validated .custom-control-input:valid ~ .custom-control-label::before, .custom-control-input.is-valid ~ .custom-control-label::before {
  border-color: #28a745;
}
.was-validated .custom-control-input:valid:checked ~ .custom-control-label::before, .custom-control-input.is-valid:checked ~ .custom-control-label::before {
  border-color: #34ce57;
  background-color: #34ce57;
}
.was-validated .custom-control-input:valid:focus ~ .custom-control-label::before, .custom-control-input.is-valid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}
.was-validated .custom-control-input:valid:focus:not(:checked) ~ .custom-control-label::before, .custom-control-input.is-valid:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #28a745;
}

.was-validated .custom-file-input:valid ~ .custom-file-label, .custom-file-input.is-valid ~ .custom-file-label {
  border-color: #28a745;
}
.was-validated .custom-file-input:valid:focus ~ .custom-file-label, .custom-file-input.is-valid:focus ~ .custom-file-label {
  border-color: #28a745;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #dc3545;
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #fff;
  background-color: rgba(220, 53, 69, 0.9);
  border-radius: 0.25rem;
}
.form-row > .col > .invalid-tooltip, .form-row > [class*=col-] > .invalid-tooltip {
  left: 5px;
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: #dc3545;
  padding-right: calc(1.5em + 0.75rem) !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.was-validated select.form-control:invalid, select.form-control.is-invalid {
  padding-right: 3rem !important;
  background-position: right 1.5rem center;
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .custom-select:invalid, .custom-select.is-invalid {
  border-color: #dc3545;
  padding-right: calc(0.75em + 2.3125rem) !important;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) right 0.75rem center/8px 10px no-repeat, #fff url(${___CSS_LOADER_URL_REPLACEMENT_2___}) center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem) no-repeat;
}
.was-validated .custom-select:invalid:focus, .custom-select.is-invalid:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: #dc3545;
}
.was-validated .form-check-input:invalid ~ .invalid-feedback,
.was-validated .form-check-input:invalid ~ .invalid-tooltip, .form-check-input.is-invalid ~ .invalid-feedback,
.form-check-input.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .custom-control-input:invalid ~ .custom-control-label, .custom-control-input.is-invalid ~ .custom-control-label {
  color: #dc3545;
}
.was-validated .custom-control-input:invalid ~ .custom-control-label::before, .custom-control-input.is-invalid ~ .custom-control-label::before {
  border-color: #dc3545;
}
.was-validated .custom-control-input:invalid:checked ~ .custom-control-label::before, .custom-control-input.is-invalid:checked ~ .custom-control-label::before {
  border-color: #e4606d;
  background-color: #e4606d;
}
.was-validated .custom-control-input:invalid:focus ~ .custom-control-label::before, .custom-control-input.is-invalid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}
.was-validated .custom-control-input:invalid:focus:not(:checked) ~ .custom-control-label::before, .custom-control-input.is-invalid:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #dc3545;
}

.was-validated .custom-file-input:invalid ~ .custom-file-label, .custom-file-input.is-invalid ~ .custom-file-label {
  border-color: #dc3545;
}
.was-validated .custom-file-input:invalid:focus ~ .custom-file-label, .custom-file-input.is-invalid:focus ~ .custom-file-label {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.form-inline {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
}
.form-inline .form-check {
  width: 100%;
}
@media (min-width: 576px) {
  .form-inline label {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0;
  }
  .form-inline .form-group {
    display: flex;
    flex: 0 0 auto;
    flex-flow: row wrap;
    align-items: center;
    margin-bottom: 0;
  }
  .form-inline .form-control {
    display: inline-block;
    width: auto;
    vertical-align: middle;
  }
  .form-inline .form-control-plaintext {
    display: inline-block;
  }
  .form-inline .input-group,
  .form-inline .custom-select {
    width: auto;
  }
  .form-inline .form-check {
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    padding-left: 0;
  }
  .form-inline .form-check-input {
    position: relative;
    flex-shrink: 0;
    margin-top: 0;
    margin-right: 0.25rem;
    margin-left: 0;
  }
  .form-inline .custom-control {
    align-items: center;
    justify-content: center;
  }
  .form-inline .custom-control-label {
    margin-bottom: 0;
  }
}

.btn {
  display: inline-block;
  font-weight: 400;
  color: #2e383e;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
          user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 0.9375rem;
  line-height: 1;
  border-radius: 0.1875rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: #2e383e;
  text-decoration: none;
}
.btn:focus, .btn.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.btn.disabled, .btn:disabled {
  opacity: 0.65;
}
.btn:not(:disabled):not(.disabled) {
  cursor: pointer;
}
a.btn.disabled,
fieldset:disabled a.btn {
  pointer-events: none;
}

.btn-primary, .custom-file .custom-file-label:after {
  color: #fff;
  background-color: #0090e7;
  border-color: #0090e7;
}
.btn-primary:hover, .custom-file .custom-file-label:hover:after {
  color: #fff;
  background-color: #0078c1;
  border-color: #0070b4;
}
.btn-primary:focus, .custom-file .custom-file-label:focus:after, .btn-primary.focus, .custom-file .focus.custom-file-label:after {
  color: #fff;
  background-color: #0078c1;
  border-color: #0070b4;
  box-shadow: 0 0 0 0.2rem rgba(38, 161, 235, 0.5);
}
.btn-primary.disabled, .custom-file .disabled.custom-file-label:after, .btn-primary:disabled, .custom-file .custom-file-label:disabled:after {
  color: #fff;
  background-color: #0090e7;
  border-color: #0090e7;
}
.btn-primary:not(:disabled):not(.disabled):active, .custom-file .custom-file-label:not(:disabled):not(.disabled):active:after, .btn-primary:not(:disabled):not(.disabled).active, .custom-file .custom-file-label:not(:disabled):not(.disabled).active:after, .show > .btn-primary.dropdown-toggle, .custom-file .show > .dropdown-toggle.custom-file-label:after {
  color: #fff;
  background-color: #0070b4;
  border-color: #0068a7;
}
.btn-primary:not(:disabled):not(.disabled):active:focus, .custom-file .custom-file-label:not(:disabled):not(.disabled):active:focus:after, .btn-primary:not(:disabled):not(.disabled).active:focus, .custom-file .custom-file-label:not(:disabled):not(.disabled).active:focus:after, .show > .btn-primary.dropdown-toggle:focus, .custom-file .show > .dropdown-toggle.custom-file-label:focus:after {
  box-shadow: 0 0 0 0.2rem rgba(38, 161, 235, 0.5);
}

.btn-secondary {
  color: #212529;
  background-color: #e4eaec;
  border-color: #e4eaec;
}
.btn-secondary:hover {
  color: #212529;
  background-color: #ced9dc;
  border-color: #c6d3d7;
}
.btn-secondary:focus, .btn-secondary.focus {
  color: #212529;
  background-color: #ced9dc;
  border-color: #c6d3d7;
  box-shadow: 0 0 0 0.2rem rgba(199, 204, 207, 0.5);
}
.btn-secondary.disabled, .btn-secondary:disabled {
  color: #212529;
  background-color: #e4eaec;
  border-color: #e4eaec;
}
.btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle {
  color: #212529;
  background-color: #c6d3d7;
  border-color: #bfcdd2;
}
.btn-secondary:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(199, 204, 207, 0.5);
}

.btn-success {
  color: #fff;
  background-color: #00d25b;
  border-color: #00d25b;
}
.btn-success:hover {
  color: #fff;
  background-color: #00ac4a;
  border-color: #009f45;
}
.btn-success:focus, .btn-success.focus {
  color: #fff;
  background-color: #00ac4a;
  border-color: #009f45;
  box-shadow: 0 0 0 0.2rem rgba(38, 217, 116, 0.5);
}
.btn-success.disabled, .btn-success:disabled {
  color: #fff;
  background-color: #00d25b;
  border-color: #00d25b;
}
.btn-success:not(:disabled):not(.disabled):active, .btn-success:not(:disabled):not(.disabled).active, .show > .btn-success.dropdown-toggle {
  color: #fff;
  background-color: #009f45;
  border-color: #00923f;
}
.btn-success:not(:disabled):not(.disabled):active:focus, .btn-success:not(:disabled):not(.disabled).active:focus, .show > .btn-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(38, 217, 116, 0.5);
}

.btn-info {
  color: #fff;
  background-color: #8f5fe8;
  border-color: #8f5fe8;
}
.btn-info:hover {
  color: #fff;
  background-color: #783ee3;
  border-color: #7032e2;
}
.btn-info:focus, .btn-info.focus {
  color: #fff;
  background-color: #783ee3;
  border-color: #7032e2;
  box-shadow: 0 0 0 0.2rem rgba(160, 119, 235, 0.5);
}
.btn-info.disabled, .btn-info:disabled {
  color: #fff;
  background-color: #8f5fe8;
  border-color: #8f5fe8;
}
.btn-info:not(:disabled):not(.disabled):active, .btn-info:not(:disabled):not(.disabled).active, .show > .btn-info.dropdown-toggle {
  color: #fff;
  background-color: #7032e2;
  border-color: #6827e0;
}
.btn-info:not(:disabled):not(.disabled):active:focus, .btn-info:not(:disabled):not(.disabled).active:focus, .show > .btn-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(160, 119, 235, 0.5);
}

.btn-warning {
  color: #212529;
  background-color: #ffab00;
  border-color: #ffab00;
}
.btn-warning:hover {
  color: #fff;
  background-color: #d99100;
  border-color: #cc8900;
}
.btn-warning:focus, .btn-warning.focus {
  color: #fff;
  background-color: #d99100;
  border-color: #cc8900;
  box-shadow: 0 0 0 0.2rem rgba(222, 151, 6, 0.5);
}
.btn-warning.disabled, .btn-warning:disabled {
  color: #212529;
  background-color: #ffab00;
  border-color: #ffab00;
}
.btn-warning:not(:disabled):not(.disabled):active, .btn-warning:not(:disabled):not(.disabled).active, .show > .btn-warning.dropdown-toggle {
  color: #fff;
  background-color: #cc8900;
  border-color: #bf8000;
}
.btn-warning:not(:disabled):not(.disabled):active:focus, .btn-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(222, 151, 6, 0.5);
}

.btn-danger {
  color: #fff;
  background-color: #fc424a;
  border-color: #fc424a;
}
.btn-danger:hover {
  color: #fff;
  background-color: #fb1c26;
  border-color: #fb101a;
}
.btn-danger:focus, .btn-danger.focus {
  color: #fff;
  background-color: #fb1c26;
  border-color: #fb101a;
  box-shadow: 0 0 0 0.2rem rgba(252, 94, 101, 0.5);
}
.btn-danger.disabled, .btn-danger:disabled {
  color: #fff;
  background-color: #fc424a;
  border-color: #fc424a;
}
.btn-danger:not(:disabled):not(.disabled):active, .btn-danger:not(:disabled):not(.disabled).active, .show > .btn-danger.dropdown-toggle {
  color: #fff;
  background-color: #fb101a;
  border-color: #fa040f;
}
.btn-danger:not(:disabled):not(.disabled):active:focus, .btn-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(252, 94, 101, 0.5);
}

.btn-light {
  color: #212529;
  background-color: #ffffff;
  border-color: #ffffff;
}
.btn-light:hover {
  color: #212529;
  background-color: #ececec;
  border-color: #e6e6e6;
}
.btn-light:focus, .btn-light.focus {
  color: #212529;
  background-color: #ececec;
  border-color: #e6e6e6;
  box-shadow: 0 0 0 0.2rem rgba(222, 222, 223, 0.5);
}
.btn-light.disabled, .btn-light:disabled {
  color: #212529;
  background-color: #ffffff;
  border-color: #ffffff;
}
.btn-light:not(:disabled):not(.disabled):active, .btn-light:not(:disabled):not(.disabled).active, .show > .btn-light.dropdown-toggle {
  color: #212529;
  background-color: #e6e6e6;
  border-color: #dfdfdf;
}
.btn-light:not(:disabled):not(.disabled):active:focus, .btn-light:not(:disabled):not(.disabled).active:focus, .show > .btn-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(222, 222, 223, 0.5);
}

.btn-dark {
  color: #fff;
  background-color: #0d0d0d;
  border-color: #0d0d0d;
}
.btn-dark:hover {
  color: #fff;
  background-color: black;
  border-color: black;
}
.btn-dark:focus, .btn-dark.focus {
  color: #fff;
  background-color: black;
  border-color: black;
  box-shadow: 0 0 0 0.2rem rgba(49, 49, 49, 0.5);
}
.btn-dark.disabled, .btn-dark:disabled {
  color: #fff;
  background-color: #0d0d0d;
  border-color: #0d0d0d;
}
.btn-dark:not(:disabled):not(.disabled):active, .btn-dark:not(:disabled):not(.disabled).active, .show > .btn-dark.dropdown-toggle {
  color: #fff;
  background-color: black;
  border-color: black;
}
.btn-dark:not(:disabled):not(.disabled):active:focus, .btn-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(49, 49, 49, 0.5);
}

.btn-outline-primary {
  color: #0090e7;
  border-color: #0090e7;
}
.btn-outline-primary:hover {
  color: #fff;
  background-color: #0090e7;
  border-color: #0090e7;
}
.btn-outline-primary:focus, .btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 144, 231, 0.5);
}
.btn-outline-primary.disabled, .btn-outline-primary:disabled {
  color: #0090e7;
  background-color: transparent;
}
.btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .btn-outline-primary.dropdown-toggle {
  color: #fff;
  background-color: #0090e7;
  border-color: #0090e7;
}
.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 144, 231, 0.5);
}

.btn-outline-secondary {
  color: #e4eaec;
  border-color: #e4eaec;
}
.btn-outline-secondary:hover {
  color: #212529;
  background-color: #e4eaec;
  border-color: #e4eaec;
}
.btn-outline-secondary:focus, .btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(228, 234, 236, 0.5);
}
.btn-outline-secondary.disabled, .btn-outline-secondary:disabled {
  color: #e4eaec;
  background-color: transparent;
}
.btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .btn-outline-secondary.dropdown-toggle {
  color: #212529;
  background-color: #e4eaec;
  border-color: #e4eaec;
}
.btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(228, 234, 236, 0.5);
}

.btn-outline-success {
  color: #00d25b;
  border-color: #00d25b;
}
.btn-outline-success:hover {
  color: #fff;
  background-color: #00d25b;
  border-color: #00d25b;
}
.btn-outline-success:focus, .btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 210, 91, 0.5);
}
.btn-outline-success.disabled, .btn-outline-success:disabled {
  color: #00d25b;
  background-color: transparent;
}
.btn-outline-success:not(:disabled):not(.disabled):active, .btn-outline-success:not(:disabled):not(.disabled).active, .show > .btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #00d25b;
  border-color: #00d25b;
}
.btn-outline-success:not(:disabled):not(.disabled):active:focus, .btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 210, 91, 0.5);
}

.btn-outline-info {
  color: #8f5fe8;
  border-color: #8f5fe8;
}
.btn-outline-info:hover {
  color: #fff;
  background-color: #8f5fe8;
  border-color: #8f5fe8;
}
.btn-outline-info:focus, .btn-outline-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(143, 95, 232, 0.5);
}
.btn-outline-info.disabled, .btn-outline-info:disabled {
  color: #8f5fe8;
  background-color: transparent;
}
.btn-outline-info:not(:disabled):not(.disabled):active, .btn-outline-info:not(:disabled):not(.disabled).active, .show > .btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #8f5fe8;
  border-color: #8f5fe8;
}
.btn-outline-info:not(:disabled):not(.disabled):active:focus, .btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(143, 95, 232, 0.5);
}

.btn-outline-warning {
  color: #ffab00;
  border-color: #ffab00;
}
.btn-outline-warning:hover {
  color: #212529;
  background-color: #ffab00;
  border-color: #ffab00;
}
.btn-outline-warning:focus, .btn-outline-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 171, 0, 0.5);
}
.btn-outline-warning.disabled, .btn-outline-warning:disabled {
  color: #ffab00;
  background-color: transparent;
}
.btn-outline-warning:not(:disabled):not(.disabled):active, .btn-outline-warning:not(:disabled):not(.disabled).active, .show > .btn-outline-warning.dropdown-toggle {
  color: #212529;
  background-color: #ffab00;
  border-color: #ffab00;
}
.btn-outline-warning:not(:disabled):not(.disabled):active:focus, .btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 171, 0, 0.5);
}

.btn-outline-danger {
  color: #fc424a;
  border-color: #fc424a;
}
.btn-outline-danger:hover {
  color: #fff;
  background-color: #fc424a;
  border-color: #fc424a;
}
.btn-outline-danger:focus, .btn-outline-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(252, 66, 74, 0.5);
}
.btn-outline-danger.disabled, .btn-outline-danger:disabled {
  color: #fc424a;
  background-color: transparent;
}
.btn-outline-danger:not(:disabled):not(.disabled):active, .btn-outline-danger:not(:disabled):not(.disabled).active, .show > .btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #fc424a;
  border-color: #fc424a;
}
.btn-outline-danger:not(:disabled):not(.disabled):active:focus, .btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(252, 66, 74, 0.5);
}

.btn-outline-light {
  color: #ffffff;
  border-color: #ffffff;
}
.btn-outline-light:hover {
  color: #212529;
  background-color: #ffffff;
  border-color: #ffffff;
}
.btn-outline-light:focus, .btn-outline-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
}
.btn-outline-light.disabled, .btn-outline-light:disabled {
  color: #ffffff;
  background-color: transparent;
}
.btn-outline-light:not(:disabled):not(.disabled):active, .btn-outline-light:not(:disabled):not(.disabled).active, .show > .btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #ffffff;
  border-color: #ffffff;
}
.btn-outline-light:not(:disabled):not(.disabled):active:focus, .btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
}

.btn-outline-dark {
  color: #0d0d0d;
  border-color: #0d0d0d;
}
.btn-outline-dark:hover {
  color: #fff;
  background-color: #0d0d0d;
  border-color: #0d0d0d;
}
.btn-outline-dark:focus, .btn-outline-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(13, 13, 13, 0.5);
}
.btn-outline-dark.disabled, .btn-outline-dark:disabled {
  color: #0d0d0d;
  background-color: transparent;
}
.btn-outline-dark:not(:disabled):not(.disabled):active, .btn-outline-dark:not(:disabled):not(.disabled).active, .show > .btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #0d0d0d;
  border-color: #0d0d0d;
}
.btn-outline-dark:not(:disabled):not(.disabled):active:focus, .btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(13, 13, 13, 0.5);
}

.btn-link {
  font-weight: 400;
  color: #007bff;
  text-decoration: none;
}
.btn-link:hover {
  color: #0056b3;
  text-decoration: underline;
}
.btn-link:focus, .btn-link.focus {
  text-decoration: underline;
}
.btn-link:disabled, .btn-link.disabled {
  color: #6c757d;
  pointer-events: none;
}

.btn-lg, .btn-group-lg > .btn {
  padding: 1rem 3rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.1875rem;
}

.btn-sm, .btn-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.1875rem;
}

.btn-block {
  display: block;
  width: 100%;
}
.btn-block + .btn-block {
  margin-top: 0.5rem;
}

input[type=submit].btn-block,
input[type=reset].btn-block,
input[type=button].btn-block {
  width: 100%;
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  position: relative;
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.width {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.width {
    transition: none;
  }
}

.dropup,
.dropright,
.dropdown,
.dropleft {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 1rem;
  color: #2e383e;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #2c2e33;
  border-radius: 0.25rem;
}

.dropdown-menu-left {
  right: auto;
  left: 0;
}

.dropdown-menu-right {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-right {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 0.125rem;
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropright .dropdown-menu {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: 0.125rem;
}
.dropright .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.dropright .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropright .dropdown-toggle::after {
  vertical-align: 0;
}

.dropleft .dropdown-menu {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: 0.125rem;
}
.dropleft .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.dropleft .dropdown-toggle::after {
  display: none;
}
.dropleft .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.dropleft .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropleft .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-menu[x-placement^=top], .dropdown-menu[x-placement^=right], .dropdown-menu[x-placement^=bottom], .dropdown-menu[x-placement^=left] {
  right: auto;
  bottom: auto;
}

.dropdown-divider {
  height: 0;
  margin: 0.5rem 0;
  overflow: hidden;
  border-top: 1px solid #2c2e33;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.25rem 1.5rem;
  clear: both;
  font-weight: 400;
  color: #2e383e;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}
.dropdown-item:hover, .dropdown-item:focus {
  color: #16181b;
  text-decoration: none;
  background-color: #f7f7f7;
}
.dropdown-item.active, .dropdown-item:active {
  color: #fff;
  text-decoration: none;
  background-color: #007bff;
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: #adb5bd;
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: 0.5rem 1.5rem;
  margin-bottom: 0;
  font-size: 0.875rem;
  color: #2e383e;
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: 0.25rem 1.5rem;
  color: #2e383e;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn:hover,
.btn-group-vertical > .btn:hover {
  z-index: 1;
}
.btn-group > .btn:focus, .btn-group > .btn:active, .btn-group > .btn.active,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) {
  margin-left: -1px;
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropright .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropleft .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 2.25rem;
  padding-left: 2.25rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: -1px;
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.btn-group-toggle > .btn,
.btn-group-toggle > .btn-group > .btn {
  margin-bottom: 0;
}
.btn-group-toggle > .btn input[type=radio],
.btn-group-toggle > .btn input[type=checkbox],
.btn-group-toggle > .btn-group > .btn input[type=radio],
.btn-group-toggle > .btn-group > .btn input[type=checkbox] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-control-plaintext,
.input-group > .custom-select,
.input-group > .custom-file {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
  margin-bottom: 0;
}
.input-group > .form-control + .form-control,
.input-group > .form-control + .custom-select,
.input-group > .form-control + .custom-file,
.input-group > .form-control-plaintext + .form-control,
.input-group > .form-control-plaintext + .custom-select,
.input-group > .form-control-plaintext + .custom-file,
.input-group > .custom-select + .form-control,
.input-group > .custom-select + .custom-select,
.input-group > .custom-select + .custom-file,
.input-group > .custom-file + .form-control,
.input-group > .custom-file + .custom-select,
.input-group > .custom-file + .custom-file {
  margin-left: -1px;
}
.input-group > .form-control:focus,
.input-group > .custom-select:focus,
.input-group > .custom-file .custom-file-input:focus ~ .custom-file-label {
  z-index: 3;
}
.input-group > .custom-file .custom-file-input:focus {
  z-index: 4;
}
.input-group > .form-control:not(:first-child),
.input-group > .custom-select:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .custom-file {
  display: flex;
  align-items: center;
}
.input-group > .custom-file:not(:last-child) .custom-file-label, .input-group > .custom-file:not(:last-child) .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > .custom-file:not(:first-child) .custom-file-label {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group:not(.has-validation) > .form-control:not(:last-child),
.input-group:not(.has-validation) > .custom-select:not(:last-child),
.input-group:not(.has-validation) > .custom-file:not(:last-child) .custom-file-label,
.input-group:not(.has-validation) > .custom-file:not(:last-child) .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > .form-control:nth-last-child(n+3),
.input-group.has-validation > .custom-select:nth-last-child(n+3),
.input-group.has-validation > .custom-file:nth-last-child(n+3) .custom-file-label,
.input-group.has-validation > .custom-file:nth-last-child(n+3) .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group-prepend,
.input-group-append {
  display: flex;
}
.input-group-prepend .btn,
.input-group-append .btn {
  position: relative;
  z-index: 2;
}
.input-group-prepend .btn:focus,
.input-group-append .btn:focus {
  z-index: 3;
}
.input-group-prepend .btn + .btn,
.input-group-prepend .btn + .input-group-text,
.input-group-prepend .input-group-text + .input-group-text,
.input-group-prepend .input-group-text + .btn,
.input-group-append .btn + .btn,
.input-group-append .btn + .input-group-text,
.input-group-append .input-group-text + .input-group-text,
.input-group-append .input-group-text + .btn {
  margin-left: -1px;
}

.input-group-prepend {
  margin-right: -1px;
}

.input-group-append {
  margin-left: -1px;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.56rem 0.75rem;
  margin-bottom: 0;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 2px;
}
.input-group-text input[type=radio],
.input-group-text input[type=checkbox] {
  margin-top: 0;
}

.input-group-lg > .form-control:not(textarea),
.input-group-lg > .custom-select {
  height: 3.175rem;
}

.input-group-lg > .form-control,
.input-group-lg > .custom-select,
.input-group-lg > .input-group-prepend > .input-group-text,
.input-group-lg > .input-group-append > .input-group-text,
.input-group-lg > .input-group-prepend > .btn,
.input-group-lg > .input-group-append > .btn {
  padding: 0.94rem 1.94rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.3rem;
}

.input-group-sm > .form-control:not(textarea),
.input-group-sm > .custom-select {
  height: 2.575rem;
}

.input-group-sm > .form-control,
.input-group-sm > .custom-select,
.input-group-sm > .input-group-prepend > .input-group-text,
.input-group-sm > .input-group-append > .input-group-text,
.input-group-sm > .input-group-prepend > .btn,
.input-group-sm > .input-group-append > .btn {
  padding: 0.5rem 0.81rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}

.input-group-lg > .custom-select,
.input-group-sm > .custom-select {
  padding-right: 1.75rem;
}

.input-group > .input-group-prepend > .btn,
.input-group > .input-group-prepend > .input-group-text,
.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .btn,
.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .input-group-text,
.input-group.has-validation > .input-group-append:nth-last-child(n+3) > .btn,
.input-group.has-validation > .input-group-append:nth-last-child(n+3) > .input-group-text,
.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),
.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group > .input-group-append > .btn,
.input-group > .input-group-append > .input-group-text,
.input-group > .input-group-prepend:not(:first-child) > .btn,
.input-group > .input-group-prepend:not(:first-child) > .input-group-text,
.input-group > .input-group-prepend:first-child > .btn:not(:first-child),
.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.custom-control {
  position: relative;
  z-index: 1;
  display: block;
  min-height: 1.5rem;
  padding-left: 1.5rem;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}

.custom-control-inline {
  display: inline-flex;
  margin-right: 1rem;
}

.custom-control-input {
  position: absolute;
  left: 0;
  z-index: -1;
  width: 1rem;
  height: 1.25rem;
  opacity: 0;
}
.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #007bff;
  background-color: #007bff;
}
.custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #80bdff;
}
.custom-control-input:not(:disabled):active ~ .custom-control-label::before {
  color: #fff;
  background-color: #b3d7ff;
  border-color: #b3d7ff;
}
.custom-control-input[disabled] ~ .custom-control-label, .custom-control-input:disabled ~ .custom-control-label {
  color: #6c757d;
}
.custom-control-input[disabled] ~ .custom-control-label::before, .custom-control-input:disabled ~ .custom-control-label::before {
  background-color: #e9ecef;
}

.custom-control-label {
  position: relative;
  margin-bottom: 0;
  vertical-align: top;
}
.custom-control-label::before {
  position: absolute;
  top: 0.25rem;
  left: -1.5rem;
  display: block;
  width: 1rem;
  height: 1rem;
  pointer-events: none;
  content: "";
  background-color: #fff;
  border: 1px solid #adb5bd;
}
.custom-control-label::after {
  position: absolute;
  top: 0.25rem;
  left: -1.5rem;
  display: block;
  width: 1rem;
  height: 1rem;
  content: "";
  background: 50%/50% 50% no-repeat;
}

.custom-checkbox .custom-control-label::before {
  border-radius: 0.25rem;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {
  border-color: #007bff;
  background-color: #007bff;
}
.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(0, 123, 255, 0.5);
}
.custom-checkbox .custom-control-input:disabled:indeterminate ~ .custom-control-label::before {
  background-color: rgba(0, 123, 255, 0.5);
}

.custom-radio .custom-control-label::before {
  border-radius: 50%;
}
.custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(0, 123, 255, 0.5);
}

.custom-switch {
  padding-left: 2.25rem;
}
.custom-switch .custom-control-label::before {
  left: -2.25rem;
  width: 1.75rem;
  pointer-events: all;
  border-radius: 0.5rem;
}
.custom-switch .custom-control-label::after {
  top: calc(0.25rem + 2px);
  left: calc(-2.25rem + 2px);
  width: calc(1rem - 4px);
  height: calc(1rem - 4px);
  background-color: #adb5bd;
  border-radius: 0.5rem;
  transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .custom-switch .custom-control-label::after {
    transition: none;
  }
}
.custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  background-color: #fff;
  transform: translateX(0.75rem);
}
.custom-switch .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(0, 123, 255, 0.5);
}

.custom-select {
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_1___}) right 0.75rem center/8px 10px no-repeat;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  appearance: none;
}
.custom-select:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.custom-select:focus::-ms-value {
  color: #495057;
  background-color: #fff;
}
.custom-select[multiple], .custom-select[size]:not([size="1"]) {
  height: auto;
  padding-right: 0.75rem;
  background-image: none;
}
.custom-select:disabled {
  color: #6c757d;
  background-color: #e9ecef;
}
.custom-select::-ms-expand {
  display: none;
}
.custom-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #495057;
}

.custom-select-sm {
  height: calc(1.5em + 0.5rem + 2px);
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.875rem;
}

.custom-select-lg {
  height: calc(1.5em + 1rem + 2px);
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.25rem;
}

.custom-file {
  position: relative;
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  margin-bottom: 0;
}

.custom-file-input {
  position: relative;
  z-index: 2;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  margin: 0;
  overflow: hidden;
  opacity: 0;
}
.custom-file-input:focus ~ .custom-file-label {
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.custom-file-input[disabled] ~ .custom-file-label, .custom-file-input:disabled ~ .custom-file-label {
  background-color: #e9ecef;
}
.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: "Browse";
}
.custom-file-input ~ .custom-file-label[data-browse]::after {
  content: attr(data-browse);
}

.custom-file-label {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  overflow: hidden;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
.custom-file-label::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  display: block;
  height: calc(1.5em + 0.75rem);
  padding: 0.375rem 0.75rem;
  line-height: 1.5;
  color: #495057;
  content: "Browse";
  background-color: #e9ecef;
  border-left: inherit;
  border-radius: 0 0.25rem 0.25rem 0;
}

.custom-range {
  width: 100%;
  height: 1.4rem;
  padding: 0;
  background-color: transparent;
  appearance: none;
}
.custom-range:focus {
  outline: 0;
}
.custom-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.custom-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.custom-range:focus::-ms-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.custom-range::-moz-focus-outer {
  border: 0;
}
.custom-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  background-color: #007bff;
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .custom-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.custom-range::-webkit-slider-thumb:active {
  background-color: #b3d7ff;
}
.custom-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  border-color: transparent;
  border-radius: 1rem;
}
.custom-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  background-color: #007bff;
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .custom-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.custom-range::-moz-range-thumb:active {
  background-color: #b3d7ff;
}
.custom-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  border-color: transparent;
  border-radius: 1rem;
}
.custom-range::-ms-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: 0;
  margin-right: 0.2rem;
  margin-left: 0.2rem;
  background-color: #007bff;
  border: 0;
  border-radius: 1rem;
  -ms-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .custom-range::-ms-thumb {
    -ms-transition: none;
    transition: none;
  }
}
.custom-range::-ms-thumb:active {
  background-color: #b3d7ff;
}
.custom-range::-ms-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: transparent;
  border-color: transparent;
  border-width: 0.5rem;
}
.custom-range::-ms-fill-lower {
  background-color: #dee2e6;
  border-radius: 1rem;
}
.custom-range::-ms-fill-upper {
  margin-right: 15px;
  background-color: #dee2e6;
  border-radius: 1rem;
}
.custom-range:disabled::-webkit-slider-thumb {
  background-color: #adb5bd;
}
.custom-range:disabled::-webkit-slider-runnable-track {
  cursor: default;
}
.custom-range:disabled::-moz-range-thumb {
  background-color: #adb5bd;
}
.custom-range:disabled::-moz-range-track {
  cursor: default;
}
.custom-range:disabled::-ms-thumb {
  background-color: #adb5bd;
}

.custom-control-label::before,
.custom-file-label,
.custom-select {
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .custom-control-label::before,
  .custom-file-label,
  .custom-select {
    transition: none;
  }
}

.nav {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: 0.5rem 1rem;
}
.nav-link:hover, .nav-link:focus {
  text-decoration: none;
}
.nav-link.disabled {
  color: #6c757d;
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  border-bottom: 1px solid #2c2e33;
}
.nav-tabs .nav-link {
  margin-bottom: -1px;
  background-color: transparent;
  border: 1px solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: #2c2e33 #2c2e33 #2c2e33;
}
.nav-tabs .nav-link.disabled {
  color: #6c757d;
  background-color: transparent;
  border-color: transparent;
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #2e383e;
  background-color: #ebebeb;
  border-color: #2c2e33 #2c2e33 #ebebeb;
}
.nav-tabs .dropdown-menu {
  margin-top: -1px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills .nav-link {
  background: none;
  border: 0;
  border-radius: 0.25rem;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
  background-color: #007bff;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem;
}
.navbar .container,
.navbar .container-fluid,
.navbar .container-sm,
.navbar .container-md,
.navbar .container-lg,
.navbar .container-xl {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  display: inline-block;
  padding-top: 0.3125rem;
  padding-bottom: 0.3125rem;
  margin-right: 1rem;
  font-size: 1.25rem;
  line-height: inherit;
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  text-decoration: none;
}

.navbar-nav {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link {
  padding-right: 0;
  padding-left: 0;
}
.navbar-nav .dropdown-menu {
  position: static;
  float: none;
}

.navbar-text {
  display: inline-block;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: 0.25rem 0.75rem;
  font-size: 1.25rem;
  line-height: 1;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}
.navbar-toggler:hover, .navbar-toggler:focus {
  text-decoration: none;
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  content: "";
  background: 50%/100% 100% no-repeat;
}

.navbar-nav-scroll {
  max-height: 75vh;
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .navbar-expand-sm > .container,
  .navbar-expand-sm > .container-fluid,
  .navbar-expand-sm > .container-sm,
  .navbar-expand-sm > .container-md,
  .navbar-expand-sm > .container-lg,
  .navbar-expand-sm > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-sm > .container,
  .navbar-expand-sm > .container-fluid,
  .navbar-expand-sm > .container-sm,
  .navbar-expand-sm > .container-md,
  .navbar-expand-sm > .container-lg,
  .navbar-expand-sm > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
}
@media (max-width: 767.98px) {
  .navbar-expand-md > .container,
  .navbar-expand-md > .container-fluid,
  .navbar-expand-md > .container-sm,
  .navbar-expand-md > .container-md,
  .navbar-expand-md > .container-lg,
  .navbar-expand-md > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-md > .container,
  .navbar-expand-md > .container-fluid,
  .navbar-expand-md > .container-sm,
  .navbar-expand-md > .container-md,
  .navbar-expand-md > .container-lg,
  .navbar-expand-md > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
}
@media (max-width: 991.98px) {
  .navbar-expand-lg > .container,
  .navbar-expand-lg > .container-fluid,
  .navbar-expand-lg > .container-sm,
  .navbar-expand-lg > .container-md,
  .navbar-expand-lg > .container-lg,
  .navbar-expand-lg > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-lg > .container,
  .navbar-expand-lg > .container-fluid,
  .navbar-expand-lg > .container-sm,
  .navbar-expand-lg > .container-md,
  .navbar-expand-lg > .container-lg,
  .navbar-expand-lg > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
}
@media (max-width: 1199.98px) {
  .navbar-expand-xl > .container,
  .navbar-expand-xl > .container-fluid,
  .navbar-expand-xl > .container-sm,
  .navbar-expand-xl > .container-md,
  .navbar-expand-xl > .container-lg,
  .navbar-expand-xl > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-xl > .container,
  .navbar-expand-xl > .container-fluid,
  .navbar-expand-xl > .container-sm,
  .navbar-expand-xl > .container-md,
  .navbar-expand-xl > .container-lg,
  .navbar-expand-xl > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
}
.navbar-expand {
  flex-flow: row nowrap;
  justify-content: flex-start;
}
.navbar-expand > .container,
.navbar-expand > .container-fluid,
.navbar-expand > .container-sm,
.navbar-expand > .container-md,
.navbar-expand > .container-lg,
.navbar-expand > .container-xl {
  padding-right: 0;
  padding-left: 0;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}
.navbar-expand > .container,
.navbar-expand > .container-fluid,
.navbar-expand > .container-sm,
.navbar-expand > .container-md,
.navbar-expand > .container-lg,
.navbar-expand > .container-xl {
  flex-wrap: nowrap;
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}

.navbar-light .navbar-brand {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-brand:hover, .navbar-light .navbar-brand:focus {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-nav .nav-link {
  color: rgba(0, 0, 0, 0.5);
}
.navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {
  color: rgba(0, 0, 0, 0.7);
}
.navbar-light .navbar-nav .nav-link.disabled {
  color: rgba(0, 0, 0, 0.3);
}
.navbar-light .navbar-nav .show > .nav-link,
.navbar-light .navbar-nav .active > .nav-link,
.navbar-light .navbar-nav .nav-link.show,
.navbar-light .navbar-nav .nav-link.active {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-toggler {
  color: rgba(0, 0, 0, 0.5);
  border-color: rgba(0, 0, 0, 0.1);
}
.navbar-light .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.navbar-light .navbar-text {
  color: rgba(0, 0, 0, 0.5);
}
.navbar-light .navbar-text a {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-text a:hover, .navbar-light .navbar-text a:focus {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-dark .navbar-brand {
  color: #fff;
}
.navbar-dark .navbar-brand:hover, .navbar-dark .navbar-brand:focus {
  color: #fff;
}
.navbar-dark .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.5);
}
.navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link:focus {
  color: rgba(255, 255, 255, 0.75);
}
.navbar-dark .navbar-nav .nav-link.disabled {
  color: rgba(255, 255, 255, 0.25);
}
.navbar-dark .navbar-nav .show > .nav-link,
.navbar-dark .navbar-nav .active > .nav-link,
.navbar-dark .navbar-nav .nav-link.show,
.navbar-dark .navbar-nav .nav-link.active {
  color: #fff;
}
.navbar-dark .navbar-toggler {
  color: rgba(255, 255, 255, 0.5);
  border-color: rgba(255, 255, 255, 0.1);
}
.navbar-dark .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
.navbar-dark .navbar-text {
  color: rgba(255, 255, 255, 0.5);
}
.navbar-dark .navbar-text a {
  color: #fff;
}
.navbar-dark .navbar-text a:hover, .navbar-dark .navbar-text a:focus {
  color: #fff;
}

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: calc(0.25rem - 1px);
  border-bottom-left-radius: calc(0.25rem - 1px);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 1.25rem;
}

.card-title {
  margin-bottom: 0.75rem;
}

.card-subtitle {
  margin-top: -0.375rem;
  margin-bottom: 0;
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link:hover {
  text-decoration: none;
}
.card-link + .card-link {
  margin-left: 1.25rem;
}

.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}
.card-header:first-child {
  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
}

.card-footer {
  padding: 0.75rem 1.25rem;
  background-color: rgba(0, 0, 0, 0.03);
  border-top: 1px solid rgba(0, 0, 0, 0.125);
}
.card-footer:last-child {
  border-radius: 0 0 calc(0.25rem - 1px) calc(0.25rem - 1px);
}

.card-header-tabs {
  margin-right: -0.625rem;
  margin-bottom: -0.75rem;
  margin-left: -0.625rem;
  border-bottom: 0;
}

.card-header-pills {
  margin-right: -0.625rem;
  margin-left: -0.625rem;
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 1.25rem;
  border-radius: calc(0.25rem - 1px);
}

.card-img,
.card-img-top,
.card-img-bottom {
  flex-shrink: 0;
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: calc(0.25rem - 1px);
  border-bottom-left-radius: calc(0.25rem - 1px);
}

.card-deck .card {
  margin-bottom: 15px;
}
@media (min-width: 576px) {
  .card-deck {
    display: flex;
    flex-flow: row wrap;
    margin-right: -15px;
    margin-left: -15px;
  }
  .card-deck .card {
    flex: 1 0;
    margin-right: 15px;
    margin-bottom: 0;
    margin-left: 15px;
  }
}

.card-group > .card {
  margin-bottom: 15px;
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
  .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
  .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
  .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
  .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.card-columns .card {
  margin-bottom: 0.75rem;
}
@media (min-width: 576px) {
  .card-columns {
    column-count: 3;
    column-gap: 1.25rem;
    orphans: 1;
    widows: 1;
  }
  .card-columns .card {
    display: inline-block;
    width: 100%;
  }
}

.accordion {
  overflow-anchor: none;
}
.accordion > .card {
  overflow: hidden;
}
.accordion > .card:not(:last-of-type) {
  border-bottom: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.accordion > .card:not(:first-of-type) {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.accordion > .card > .card-header {
  border-radius: 0;
  margin-bottom: -1px;
}

.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  padding: 0.56rem 1.13rem;
  margin-bottom: 1rem;
  font-size: 0.875rem;
  list-style: none;
  background-color: transparent;
  border-radius: 0.25rem;
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: 0.5rem;
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: 0.5rem;
  color: #6c757d;
  content: "/";
}
.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: underline;
}
.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: none;
}
.breadcrumb-item.active {
  color: #495057;
}

.pagination {
  display: flex;
  padding-left: 0;
  list-style: none;
  border-radius: 0.25rem;
}

.page-link {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #007bff;
  background-color: #f8f8f8;
  border: 1px solid #dee2e6;
}
.page-link:hover {
  z-index: 2;
  color: #0056b3;
  text-decoration: none;
  background-color: #e9ecef;
  border-color: #dee2e6;
}
.page-link:focus {
  z-index: 3;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.page-item:first-child .page-link {
  margin-left: 0;
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.page-item:last-child .page-link {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.page-item.active .page-link {
  z-index: 3;
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}
.page-item.disabled .page-link {
  color: #6c757d;
  pointer-events: none;
  cursor: auto;
  background-color: #fff;
  border-color: #dee2e6;
}

.pagination-lg .page-link {
  padding: 0.75rem 1.5rem;
  font-size: 1.25rem;
  line-height: 1.5;
}
.pagination-lg .page-item:first-child .page-link {
  border-top-left-radius: 0.3rem;
  border-bottom-left-radius: 0.3rem;
}
.pagination-lg .page-item:last-child .page-link {
  border-top-right-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
}

.pagination-sm .page-link {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
}
.pagination-sm .page-item:first-child .page-link {
  border-top-left-radius: 0.2rem;
  border-bottom-left-radius: 0.2rem;
}
.pagination-sm .page-item:last-child .page-link {
  border-top-right-radius: 0.2rem;
  border-bottom-right-radius: 0.2rem;
}

.badge {
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .badge {
    transition: none;
  }
}
a.badge:hover, a.badge:focus {
  text-decoration: none;
}

.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.badge-pill {
  padding-right: 0.6em;
  padding-left: 0.6em;
  border-radius: 10rem;
}

.badge-primary {
  color: #fff;
  background-color: #0090e7;
}
a.badge-primary:hover, a.badge-primary:focus {
  color: #fff;
  background-color: #0070b4;
}
a.badge-primary:focus, a.badge-primary.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 144, 231, 0.5);
}

.badge-secondary {
  color: #212529;
  background-color: #e4eaec;
}
a.badge-secondary:hover, a.badge-secondary:focus {
  color: #212529;
  background-color: #c6d3d7;
}
a.badge-secondary:focus, a.badge-secondary.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(228, 234, 236, 0.5);
}

.badge-success, .preview-list .preview-item .preview-thumbnail .badge.badge-online {
  color: #fff;
  background-color: #00d25b;
}
a.badge-success:hover, .preview-list .preview-item .preview-thumbnail a.badge.badge-online:hover, a.badge-success:focus, .preview-list .preview-item .preview-thumbnail a.badge.badge-online:focus {
  color: #fff;
  background-color: #009f45;
}
a.badge-success:focus, .preview-list .preview-item .preview-thumbnail a.badge.badge-online:focus, a.badge-success.focus, .preview-list .preview-item .preview-thumbnail a.focus.badge.badge-online {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 210, 91, 0.5);
}

.badge-info, .preview-list .preview-item .preview-thumbnail .badge.badge-offline {
  color: #fff;
  background-color: #8f5fe8;
}
a.badge-info:hover, .preview-list .preview-item .preview-thumbnail a.badge.badge-offline:hover, a.badge-info:focus, .preview-list .preview-item .preview-thumbnail a.badge.badge-offline:focus {
  color: #fff;
  background-color: #7032e2;
}
a.badge-info:focus, .preview-list .preview-item .preview-thumbnail a.badge.badge-offline:focus, a.badge-info.focus, .preview-list .preview-item .preview-thumbnail a.focus.badge.badge-offline {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(143, 95, 232, 0.5);
}

.badge-warning, .preview-list .preview-item .preview-thumbnail .badge.badge-busy {
  color: #212529;
  background-color: #ffab00;
}
a.badge-warning:hover, .preview-list .preview-item .preview-thumbnail a.badge.badge-busy:hover, a.badge-warning:focus, .preview-list .preview-item .preview-thumbnail a.badge.badge-busy:focus {
  color: #212529;
  background-color: #cc8900;
}
a.badge-warning:focus, .preview-list .preview-item .preview-thumbnail a.badge.badge-busy:focus, a.badge-warning.focus, .preview-list .preview-item .preview-thumbnail a.focus.badge.badge-busy {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(255, 171, 0, 0.5);
}

.badge-danger {
  color: #fff;
  background-color: #fc424a;
}
a.badge-danger:hover, a.badge-danger:focus {
  color: #fff;
  background-color: #fb101a;
}
a.badge-danger:focus, a.badge-danger.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(252, 66, 74, 0.5);
}

.badge-light {
  color: #212529;
  background-color: #ffffff;
}
a.badge-light:hover, a.badge-light:focus {
  color: #212529;
  background-color: #e6e6e6;
}
a.badge-light:focus, a.badge-light.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
}

.badge-dark {
  color: #fff;
  background-color: #0d0d0d;
}
a.badge-dark:hover, a.badge-dark:focus {
  color: #fff;
  background-color: black;
}
a.badge-dark:focus, a.badge-dark.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(13, 13, 13, 0.5);
}

.jumbotron {
  padding: 2rem 1rem;
  margin-bottom: 2rem;
  background-color: #e9ecef;
  border-radius: 0.3rem;
}
@media (min-width: 576px) {
  .jumbotron {
    padding: 4rem 2rem;
  }
}

.jumbotron-fluid {
  padding-right: 0;
  padding-left: 0;
  border-radius: 0;
}

.alert {
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
}

.alert-dismissible {
  padding-right: 4rem;
}
.alert-dismissible .close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 0.75rem 1.25rem;
  color: inherit;
}

.alert-primary {
  color: #004b78;
  background-color: #cce9fa;
  border-color: #b8e0f8;
}
.alert-primary hr {
  border-top-color: #a1d6f6;
}
.alert-primary .alert-link {
  color: #002b45;
}

.alert-secondary {
  color: #777a7b;
  background-color: #fafbfb;
  border-color: #f7f9fa;
}
.alert-secondary hr {
  border-top-color: #e7edf0;
}
.alert-secondary .alert-link {
  color: #5e6061;
}

.alert-success {
  color: #006d2f;
  background-color: #ccf6de;
  border-color: #b8f2d1;
}
.alert-success hr {
  border-top-color: #a2eec3;
}
.alert-success .alert-link {
  color: #003a19;
}

.alert-info {
  color: #4a3179;
  background-color: #e9dffa;
  border-color: #e0d2f9;
}
.alert-info hr {
  border-top-color: #d1bcf6;
}
.alert-info .alert-link {
  color: #342255;
}

.alert-warning {
  color: #855900;
  background-color: #ffeecc;
  border-color: #ffe7b8;
}
.alert-warning hr {
  border-top-color: #ffde9f;
}
.alert-warning .alert-link {
  color: #523700;
}

.alert-danger {
  color: #832226;
  background-color: #fed9db;
  border-color: #fecacc;
}
.alert-danger hr {
  border-top-color: #feb1b4;
}
.alert-danger .alert-link {
  color: #5b171a;
}

.alert-light {
  color: #858585;
  background-color: white;
  border-color: white;
}
.alert-light hr {
  border-top-color: #f2f2f2;
}
.alert-light .alert-link {
  color: #6c6c6c;
}

.alert-dark {
  color: #070707;
  background-color: #cfcfcf;
  border-color: #bbbbbb;
}
.alert-dark hr {
  border-top-color: #aeaeae;
}
.alert-dark .alert-link {
  color: black;
}

@keyframes progress-bar-stripes {
  from {
    background-position: 1rem 0;
  }
  to {
    background-position: 0 0;
  }
}
.progress {
  display: flex;
  height: 1rem;
  overflow: hidden;
  line-height: 0;
  font-size: 0.75rem;
  background-color: #2f323a;
  border-radius: 0.25rem;
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  background-color: #007bff;
  transition: width 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: 1rem 1rem;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.media {
  display: flex;
  align-items: flex-start;
}

.media-body {
  flex: 1 1;
}

.list-group {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: 0.25rem;
}

.list-group-item-action {
  width: 100%;
  color: #495057;
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: #495057;
  text-decoration: none;
  background-color: #f8f9fa;
}
.list-group-item-action:active {
  color: #212529;
  background-color: #e9ecef;
}

.list-group-item {
  position: relative;
  display: block;
  padding: 0.75rem 1.25rem;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.125);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: #6c757d;
  pointer-events: none;
  background-color: #fff;
}
.list-group-item.active {
  z-index: 2;
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: -1px;
  border-top-width: 1px;
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child {
  border-bottom-left-radius: 0.25rem;
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child {
  border-top-right-radius: 0.25rem;
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: 1px;
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: -1px;
  border-left-width: 1px;
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 1px;
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  color: #004b78;
  background-color: #b8e0f8;
}
.list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {
  color: #004b78;
  background-color: #a1d6f6;
}
.list-group-item-primary.list-group-item-action.active {
  color: #ffffff;
  background-color: #004b78;
  border-color: #004b78;
}

.list-group-item-secondary {
  color: #777a7b;
  background-color: #f7f9fa;
}
.list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {
  color: #777a7b;
  background-color: #e7edf0;
}
.list-group-item-secondary.list-group-item-action.active {
  color: #ffffff;
  background-color: #777a7b;
  border-color: #777a7b;
}

.list-group-item-success {
  color: #006d2f;
  background-color: #b8f2d1;
}
.list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {
  color: #006d2f;
  background-color: #a2eec3;
}
.list-group-item-success.list-group-item-action.active {
  color: #ffffff;
  background-color: #006d2f;
  border-color: #006d2f;
}

.list-group-item-info {
  color: #4a3179;
  background-color: #e0d2f9;
}
.list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {
  color: #4a3179;
  background-color: #d1bcf6;
}
.list-group-item-info.list-group-item-action.active {
  color: #ffffff;
  background-color: #4a3179;
  border-color: #4a3179;
}

.list-group-item-warning {
  color: #855900;
  background-color: #ffe7b8;
}
.list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {
  color: #855900;
  background-color: #ffde9f;
}
.list-group-item-warning.list-group-item-action.active {
  color: #ffffff;
  background-color: #855900;
  border-color: #855900;
}

.list-group-item-danger {
  color: #832226;
  background-color: #fecacc;
}
.list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {
  color: #832226;
  background-color: #feb1b4;
}
.list-group-item-danger.list-group-item-action.active {
  color: #ffffff;
  background-color: #832226;
  border-color: #832226;
}

.list-group-item-light {
  color: #858585;
  background-color: white;
}
.list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {
  color: #858585;
  background-color: #f2f2f2;
}
.list-group-item-light.list-group-item-action.active {
  color: #ffffff;
  background-color: #858585;
  border-color: #858585;
}

.list-group-item-dark {
  color: #070707;
  background-color: #bbbbbb;
}
.list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {
  color: #070707;
  background-color: #aeaeae;
}
.list-group-item-dark.list-group-item-action.active {
  color: #ffffff;
  background-color: #070707;
  border-color: #070707;
}

.close {
  float: right;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  opacity: 0.5;
}
.close:hover {
  color: #000;
  text-decoration: none;
}
.close:not(:disabled):not(.disabled):hover, .close:not(:disabled):not(.disabled):focus {
  opacity: 0.75;
}

button.close {
  padding: 0;
  background-color: transparent;
  border: 0;
}

a.close.disabled {
  pointer-events: none;
}

.toast {
  flex-basis: 350px;
  max-width: 350px;
  font-size: 0.875rem;
  background-color: rgba(255, 255, 255, 0.85);
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1);
  opacity: 0;
  border-radius: 0.25rem;
}
.toast:not(:last-child) {
  margin-bottom: 0.75rem;
}
.toast.showing {
  opacity: 1;
}
.toast.show {
  display: block;
  opacity: 1;
}
.toast.hide {
  display: none;
}

.toast-header {
  display: flex;
  align-items: center;
  padding: 0.25rem 0.75rem;
  color: #6c757d;
  background-color: rgba(255, 255, 255, 0.85);
  background-clip: padding-box;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}

.toast-body {
  padding: 0.75rem;
}

.modal-open {
  overflow: hidden;
}
.modal-open .modal {
  overflow-x: hidden;
  overflow-y: auto;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  display: none;
  width: 100%;
  height: 100%;
  overflow: hidden;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: 10px;
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.4s ease;
  transform: translate(0, -50px);
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  display: flex;
  max-height: calc(100% - 20px);
}
.modal-dialog-scrollable .modal-content {
  max-height: calc(100vh - 20px);
  overflow: hidden;
}
.modal-dialog-scrollable .modal-header,
.modal-dialog-scrollable .modal-footer {
  flex-shrink: 0;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - 20px);
}
.modal-dialog-centered::before {
  display: block;
  height: calc(100vh - 20px);
  height: min-content;
  content: "";
}
.modal-dialog-centered.modal-dialog-scrollable {
  flex-direction: column;
  justify-content: center;
  height: 100%;
}
.modal-dialog-centered.modal-dialog-scrollable .modal-content {
  max-height: none;
}
.modal-dialog-centered.modal-dialog-scrollable::before {
  content: none;
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #f8f8f8;
  background-clip: padding-box;
  border: 1px solid #2c2e33;
  border-radius: 0.3rem;
  outline: 0;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: 0.5;
}

.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1rem 1rem;
  border-bottom: 1px solid #2c2e33;
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
}
.modal-header .close {
  padding: 1rem 1rem;
  margin: -25px -26px -25px auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: 1.5;
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 0.9375rem;
}

.modal-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: 0.6875rem;
  border-top: 1px solid #2c2e33;
  border-bottom-right-radius: calc(0.3rem - 1px);
  border-bottom-left-radius: calc(0.3rem - 1px);
}
.modal-footer > * {
  margin: 0.25rem;
}

.modal-scrollbar-measure {
  position: absolute;
  top: -9999px;
  width: 50px;
  height: 50px;
  overflow: scroll;
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 500px;
    margin: 30px auto;
  }
  .modal-dialog-scrollable {
    max-height: calc(100% - 60px);
  }
  .modal-dialog-scrollable .modal-content {
    max-height: calc(100vh - 60px);
  }
  .modal-dialog-centered {
    min-height: calc(100% - 60px);
  }
  .modal-dialog-centered::before {
    height: calc(100vh - 60px);
    height: min-content;
  }
  .modal-sm {
    max-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    max-width: 90%;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    max-width: 1140px;
  }
}
.tooltip {
  position: absolute;
  z-index: 1070;
  display: block;
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: 0.75rem;
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: 0.9;
}
.tooltip .arrow {
  position: absolute;
  display: block;
  width: 0.8rem;
  height: 0.4rem;
}
.tooltip .arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top, .bs-tooltip-auto[x-placement^=top] {
  padding: 0.4rem 0;
}
.bs-tooltip-top .arrow, .bs-tooltip-auto[x-placement^=top] .arrow {
  bottom: 0;
}
.bs-tooltip-top .arrow::before, .bs-tooltip-auto[x-placement^=top] .arrow::before {
  top: 0;
  border-width: 0.4rem 0.4rem 0;
  border-top-color: #000;
}

.bs-tooltip-right, .bs-tooltip-auto[x-placement^=right] {
  padding: 0 0.4rem;
}
.bs-tooltip-right .arrow, .bs-tooltip-auto[x-placement^=right] .arrow {
  left: 0;
  width: 0.4rem;
  height: 0.8rem;
}
.bs-tooltip-right .arrow::before, .bs-tooltip-auto[x-placement^=right] .arrow::before {
  right: 0;
  border-width: 0.4rem 0.4rem 0.4rem 0;
  border-right-color: #000;
}

.bs-tooltip-bottom, .bs-tooltip-auto[x-placement^=bottom] {
  padding: 0.4rem 0;
}
.bs-tooltip-bottom .arrow, .bs-tooltip-auto[x-placement^=bottom] .arrow {
  top: 0;
}
.bs-tooltip-bottom .arrow::before, .bs-tooltip-auto[x-placement^=bottom] .arrow::before {
  bottom: 0;
  border-width: 0 0.4rem 0.4rem;
  border-bottom-color: #000;
}

.bs-tooltip-left, .bs-tooltip-auto[x-placement^=left] {
  padding: 0 0.4rem;
}
.bs-tooltip-left .arrow, .bs-tooltip-auto[x-placement^=left] .arrow {
  right: 0;
  width: 0.4rem;
  height: 0.8rem;
}
.bs-tooltip-left .arrow::before, .bs-tooltip-auto[x-placement^=left] .arrow::before {
  left: 0;
  border-width: 0.4rem 0 0.4rem 0.4rem;
  border-left-color: #000;
}

.tooltip-inner {
  max-width: 200px;
  padding: 0.4rem 0.75rem;
  color: #fff;
  text-align: center;
  background-color: #000;
  border-radius: 0.375rem;
}

.popover {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1060;
  display: block;
  max-width: 276px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: 0.875rem;
  word-wrap: break-word;
  background-color: #0d0d0d;
  background-clip: padding-box;
  border: 1px solid #2c2e33;
  border-radius: 0.3rem;
}
.popover .arrow {
  position: absolute;
  display: block;
  width: 1rem;
  height: 0.5rem;
  margin: 0 0.3rem;
}
.popover .arrow::before, .popover .arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-popover-top, .bs-popover-auto[x-placement^=top] {
  margin-bottom: 0.5rem;
}
.bs-popover-top > .arrow, .bs-popover-auto[x-placement^=top] > .arrow {
  bottom: calc(-0.5rem - 1px);
}
.bs-popover-top > .arrow::before, .bs-popover-auto[x-placement^=top] > .arrow::before {
  bottom: 0;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: #2c2e33;
}
.bs-popover-top > .arrow::after, .bs-popover-auto[x-placement^=top] > .arrow::after {
  bottom: 1px;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: #0d0d0d;
}

.bs-popover-right, .bs-popover-auto[x-placement^=right] {
  margin-left: 0.5rem;
}
.bs-popover-right > .arrow, .bs-popover-auto[x-placement^=right] > .arrow {
  left: calc(-0.5rem - 1px);
  width: 0.5rem;
  height: 1rem;
  margin: 0.3rem 0;
}
.bs-popover-right > .arrow::before, .bs-popover-auto[x-placement^=right] > .arrow::before {
  left: 0;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: #2c2e33;
}
.bs-popover-right > .arrow::after, .bs-popover-auto[x-placement^=right] > .arrow::after {
  left: 1px;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: #0d0d0d;
}

.bs-popover-bottom, .bs-popover-auto[x-placement^=bottom] {
  margin-top: 0.5rem;
}
.bs-popover-bottom > .arrow, .bs-popover-auto[x-placement^=bottom] > .arrow {
  top: calc(-0.5rem - 1px);
}
.bs-popover-bottom > .arrow::before, .bs-popover-auto[x-placement^=bottom] > .arrow::before {
  top: 0;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: #2c2e33;
}
.bs-popover-bottom > .arrow::after, .bs-popover-auto[x-placement^=bottom] > .arrow::after {
  top: 1px;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: #0d0d0d;
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[x-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: 1rem;
  margin-left: -0.5rem;
  content: "";
  border-bottom: 1px solid #0d0d0d;
}

.bs-popover-left, .bs-popover-auto[x-placement^=left] {
  margin-right: 0.5rem;
}
.bs-popover-left > .arrow, .bs-popover-auto[x-placement^=left] > .arrow {
  right: calc(-0.5rem - 1px);
  width: 0.5rem;
  height: 1rem;
  margin: 0.3rem 0;
}
.bs-popover-left > .arrow::before, .bs-popover-auto[x-placement^=left] > .arrow::before {
  right: 0;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: #2c2e33;
}
.bs-popover-left > .arrow::after, .bs-popover-auto[x-placement^=left] > .arrow::after {
  right: 1px;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: #0d0d0d;
}

.popover-header {
  padding: 0.5rem 0.75rem;
  margin-bottom: 0;
  font-size: 1rem;
  background-color: #0d0d0d;
  border-bottom: 1px solid black;
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: 0.5rem 0.75rem;
  color: #212529;
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-left),
.active.carousel-item-right {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-right),
.active.carousel-item-left {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-left,
.carousel-fade .carousel-item-prev.carousel-item-right {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-left,
.carousel-fade .active.carousel-item-right {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-left,
  .carousel-fade .active.carousel-item-right {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: 50%/100% 100% no-repeat;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 15;
  display: flex;
  justify-content: center;
  padding-left: 0;
  margin-right: 15%;
  margin-left: 15%;
  list-style: none;
}
.carousel-indicators li {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators li {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 20px;
  left: 15%;
  z-index: 10;
  padding-top: 20px;
  padding-bottom: 20px;
  color: #fff;
  text-align: center;
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}
.spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: -0.125em;
  border: 0.25em solid currentcolor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: 0.75s linear infinite spinner-border;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
  border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: -0.125em;
  background-color: currentcolor;
  border-radius: 50%;
  opacity: 0;
  animation: 0.75s linear infinite spinner-grow;
}

.spinner-grow-sm {
  width: 1rem;
  height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    animation-duration: 1.5s;
  }
}
.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.bg-primary {
  background-color: #0090e7 !important;
}

a.bg-primary:hover, a.bg-primary:focus,
button.bg-primary:hover,
button.bg-primary:focus {
  background-color: #0070b4 !important;
}

.bg-secondary {
  background-color: #e4eaec !important;
}

a.bg-secondary:hover, a.bg-secondary:focus,
button.bg-secondary:hover,
button.bg-secondary:focus {
  background-color: #c6d3d7 !important;
}

.bg-success {
  background-color: #00d25b !important;
}

a.bg-success:hover, a.bg-success:focus,
button.bg-success:hover,
button.bg-success:focus {
  background-color: #009f45 !important;
}

.bg-info {
  background-color: #8f5fe8 !important;
}

a.bg-info:hover, a.bg-info:focus,
button.bg-info:hover,
button.bg-info:focus {
  background-color: #7032e2 !important;
}

.bg-warning {
  background-color: #ffab00 !important;
}

a.bg-warning:hover, a.bg-warning:focus,
button.bg-warning:hover,
button.bg-warning:focus {
  background-color: #cc8900 !important;
}

.bg-danger {
  background-color: #fc424a !important;
}

a.bg-danger:hover, a.bg-danger:focus,
button.bg-danger:hover,
button.bg-danger:focus {
  background-color: #fb101a !important;
}

.bg-light {
  background-color: #ffffff !important;
}

a.bg-light:hover, a.bg-light:focus,
button.bg-light:hover,
button.bg-light:focus {
  background-color: #e6e6e6 !important;
}

.bg-dark {
  background-color: #0d0d0d !important;
}

a.bg-dark:hover, a.bg-dark:focus,
button.bg-dark:hover,
button.bg-dark:focus {
  background-color: black !important;
}

.bg-white {
  background-color: #ffffff !important;
}

.bg-transparent {
  background-color: transparent !important;
}

.border, .loader-demo-box {
  border: 1px solid #2c2e33 !important;
}

.border-top {
  border-top: 1px solid #2c2e33 !important;
}

.border-right {
  border-right: 1px solid #2c2e33 !important;
}

.border-bottom {
  border-bottom: 1px solid #2c2e33 !important;
}

.border-left {
  border-left: 1px solid #2c2e33 !important;
}

.border-0 {
  border: 0 !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-right-0 {
  border-right: 0 !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-left-0 {
  border-left: 0 !important;
}

.border-primary {
  border-color: #0090e7 !important;
}

.border-secondary, .loader-demo-box {
  border-color: #e4eaec !important;
}

.border-success {
  border-color: #00d25b !important;
}

.border-info {
  border-color: #8f5fe8 !important;
}

.border-warning {
  border-color: #ffab00 !important;
}

.border-danger {
  border-color: #fc424a !important;
}

.border-light {
  border-color: #ffffff !important;
}

.border-dark {
  border-color: #0d0d0d !important;
}

.border-white {
  border-color: #ffffff !important;
}

.rounded-sm {
  border-radius: 0.2rem !important;
}

.rounded, .loader-demo-box {
  border-radius: 0.25rem !important;
}

.rounded-top {
  border-top-left-radius: 0.25rem !important;
  border-top-right-radius: 0.25rem !important;
}

.rounded-right {
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important;
}

.rounded-bottom {
  border-bottom-right-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
}

.rounded-left {
  border-top-left-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
}

.rounded-lg {
  border-radius: 0.3rem !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: 50rem !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.d-none {
  display: none !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex, .list-wrapper ul li, .loader-demo-box, .page-header {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

@media (min-width: 576px) {
  .d-sm-none {
    display: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 768px) {
  .d-md-none {
    display: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 992px) {
  .d-lg-none {
    display: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 1200px) {
  .d-xl-none {
    display: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
}
@media print {
  .d-print-none {
    display: none !important;
  }
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
}
.embed-responsive {
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden;
}
.embed-responsive::before {
  display: block;
  content: "";
}
.embed-responsive .embed-responsive-item,
.embed-responsive iframe,
.embed-responsive embed,
.embed-responsive object,
.embed-responsive video {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.embed-responsive-21by9::before {
  padding-top: 42.85714286%;
}

.embed-responsive-16by9::before {
  padding-top: 56.25%;
}

.embed-responsive-4by3::before {
  padding-top: 75%;
}

.embed-responsive-1by1::before {
  padding-top: 100%;
}

.embed-responsive-21by9::before {
  padding-top: 42.85714286%;
}

.embed-responsive-16by9::before {
  padding-top: 56.25%;
}

.embed-responsive-4by3::before {
  padding-top: 75%;
}

.embed-responsive-1by1::before {
  padding-top: 100%;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.justify-content-start, .list-wrapper ul li {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between, .page-header {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center, .list-wrapper ul li, .loader-demo-box, .page-header {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

@media (min-width: 576px) {
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 768px) {
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 992px) {
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 1200px) {
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
}
.float-left {
  float: left !important;
}

.float-right {
  float: right !important;
}

.float-none {
  float: none !important;
}

@media (min-width: 576px) {
  .float-sm-left {
    float: left !important;
  }
  .float-sm-right {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
}
@media (min-width: 768px) {
  .float-md-left {
    float: left !important;
  }
  .float-md-right {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
}
@media (min-width: 992px) {
  .float-lg-left {
    float: left !important;
  }
  .float-lg-right {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-left {
    float: left !important;
  }
  .float-xl-right {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
}
.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

@supports (position: sticky) {
  .sticky-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.sr-only-focusable:active, .sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  overflow: visible;
  clip: auto;
  white-space: normal;
}

.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}

.shadow {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.shadow-lg {
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.mh-100 {
  max-height: 100% !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.vw-100 {
  width: 100vw !important;
}

.vh-100 {
  height: 100vh !important;
}

.m-0 {
  margin: 0 !important;
}

.mt-0, .demo-modal .modal-dialog,
.my-0 {
  margin-top: 0 !important;
}

.mr-0,
.mx-0 {
  margin-right: 0 !important;
}

.mb-0,
.my-0 {
  margin-bottom: 0 !important;
}

.ml-0, .rtl .list-wrapper .remove, .rtl .preview-list .preview-item .preview-thumbnail img i,
.rtl .preview-list .preview-item .preview-thumbnail .preview-icon i,
.mx-0 {
  margin-left: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.mt-1,
.my-1 {
  margin-top: 0.25rem !important;
}

.mr-1,
.mx-1 {
  margin-right: 0.25rem !important;
}

.mb-1,
.my-1 {
  margin-bottom: 0.25rem !important;
}

.ml-1,
.mx-1 {
  margin-left: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.mt-2, .template-demo .circle-progress, .template-demo > .btn-group,
.template-demo > .btn-group-vertical,
.my-2 {
  margin-top: 0.5rem !important;
}

.mr-2, .template-demo > .dropdown, .template-demo > .btn-group,
.template-demo > .btn-group-vertical,
.mx-2 {
  margin-right: 0.5rem !important;
}

.mb-2,
.my-2 {
  margin-bottom: 0.5rem !important;
}

.ml-2, .btn-toolbar .btn-group + .btn-group,
.mx-2 {
  margin-left: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.mt-3, .template-demo > .btn-toolbar, .template-demo > .btn,
.my-3 {
  margin-top: 1rem !important;
}

.mr-3, .template-demo > .btn-toolbar, .template-demo > .btn,
.mx-3 {
  margin-right: 1rem !important;
}

.mb-3, .template-demo .circle-progress-block,
.my-3 {
  margin-bottom: 1rem !important;
}

.ml-3,
.mx-3 {
  margin-left: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.mt-4,
.my-4 {
  margin-top: 1.5rem !important;
}

.mr-4,
.mx-4 {
  margin-right: 1.5rem !important;
}

.mb-4,
.my-4 {
  margin-bottom: 1.5rem !important;
}

.ml-4,
.mx-4 {
  margin-left: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.mt-5,
.my-5 {
  margin-top: 3rem !important;
}

.mr-5,
.mx-5 {
  margin-right: 3rem !important;
}

.mb-5,
.my-5 {
  margin-bottom: 3rem !important;
}

.ml-5,
.mx-5 {
  margin-left: 3rem !important;
}

.p-0 {
  padding: 0 !important;
}

.pt-0,
.py-0 {
  padding-top: 0 !important;
}

.pr-0,
.px-0 {
  padding-right: 0 !important;
}

.pb-0,
.py-0 {
  padding-bottom: 0 !important;
}

.pl-0,
.px-0 {
  padding-left: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.pt-1,
.py-1 {
  padding-top: 0.25rem !important;
}

.pr-1,
.px-1 {
  padding-right: 0.25rem !important;
}

.pb-1,
.py-1 {
  padding-bottom: 0.25rem !important;
}

.pl-1,
.px-1 {
  padding-left: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.pt-2,
.py-2 {
  padding-top: 0.5rem !important;
}

.pr-2,
.px-2,
.template-demo .circle-progress-block {
  padding-right: 0.5rem !important;
}

.pb-2,
.py-2 {
  padding-bottom: 0.5rem !important;
}

.pl-2,
.px-2,
.template-demo .circle-progress-block {
  padding-left: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.pt-3,
.py-3 {
  padding-top: 1rem !important;
}

.pr-3,
.px-3 {
  padding-right: 1rem !important;
}

.pb-3,
.py-3 {
  padding-bottom: 1rem !important;
}

.pl-3,
.px-3 {
  padding-left: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.pt-4,
.py-4 {
  padding-top: 1.5rem !important;
}

.pr-4,
.px-4 {
  padding-right: 1.5rem !important;
}

.pb-4,
.py-4 {
  padding-bottom: 1.5rem !important;
}

.pl-4,
.px-4 {
  padding-left: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.pt-5,
.py-5 {
  padding-top: 3rem !important;
}

.pr-5,
.px-5 {
  padding-right: 3rem !important;
}

.pb-5,
.py-5 {
  padding-bottom: 3rem !important;
}

.pl-5,
.px-5 {
  padding-left: 3rem !important;
}

.m-n1 {
  margin: -0.25rem !important;
}

.mt-n1,
.my-n1 {
  margin-top: -0.25rem !important;
}

.mr-n1,
.mx-n1 {
  margin-right: -0.25rem !important;
}

.mb-n1,
.my-n1 {
  margin-bottom: -0.25rem !important;
}

.ml-n1,
.mx-n1 {
  margin-left: -0.25rem !important;
}

.m-n2 {
  margin: -0.5rem !important;
}

.mt-n2,
.my-n2 {
  margin-top: -0.5rem !important;
}

.mr-n2,
.mx-n2 {
  margin-right: -0.5rem !important;
}

.mb-n2,
.my-n2 {
  margin-bottom: -0.5rem !important;
}

.ml-n2,
.mx-n2 {
  margin-left: -0.5rem !important;
}

.m-n3 {
  margin: -1rem !important;
}

.mt-n3,
.my-n3 {
  margin-top: -1rem !important;
}

.mr-n3,
.mx-n3 {
  margin-right: -1rem !important;
}

.mb-n3,
.my-n3 {
  margin-bottom: -1rem !important;
}

.ml-n3,
.mx-n3 {
  margin-left: -1rem !important;
}

.m-n4 {
  margin: -1.5rem !important;
}

.mt-n4,
.my-n4 {
  margin-top: -1.5rem !important;
}

.mr-n4,
.mx-n4 {
  margin-right: -1.5rem !important;
}

.mb-n4,
.my-n4 {
  margin-bottom: -1.5rem !important;
}

.ml-n4,
.mx-n4 {
  margin-left: -1.5rem !important;
}

.m-n5 {
  margin: -3rem !important;
}

.mt-n5,
.my-n5 {
  margin-top: -3rem !important;
}

.mr-n5,
.mx-n5 {
  margin-right: -3rem !important;
}

.mb-n5,
.my-n5 {
  margin-bottom: -3rem !important;
}

.ml-n5,
.mx-n5 {
  margin-left: -3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mt-auto,
.my-auto {
  margin-top: auto !important;
}

.mr-auto, .rtl .list-wrapper .remove,
.mx-auto {
  margin-right: auto !important;
}

.mb-auto,
.my-auto {
  margin-bottom: auto !important;
}

.ml-auto, .list-wrapper .remove,
.mx-auto {
  margin-left: auto !important;
}

@media (min-width: 576px) {
  .m-sm-0 {
    margin: 0 !important;
  }
  .mt-sm-0,
  .my-sm-0 {
    margin-top: 0 !important;
  }
  .mr-sm-0,
  .mx-sm-0 {
    margin-right: 0 !important;
  }
  .mb-sm-0,
  .my-sm-0 {
    margin-bottom: 0 !important;
  }
  .ml-sm-0,
  .mx-sm-0 {
    margin-left: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .mt-sm-1,
  .my-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mr-sm-1,
  .mx-sm-1 {
    margin-right: 0.25rem !important;
  }
  .mb-sm-1,
  .my-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-sm-1,
  .mx-sm-1 {
    margin-left: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .mt-sm-2,
  .my-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mr-sm-2,
  .mx-sm-2 {
    margin-right: 0.5rem !important;
  }
  .mb-sm-2,
  .my-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-sm-2,
  .mx-sm-2 {
    margin-left: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .mt-sm-3,
  .my-sm-3 {
    margin-top: 1rem !important;
  }
  .mr-sm-3,
  .mx-sm-3 {
    margin-right: 1rem !important;
  }
  .mb-sm-3,
  .my-sm-3 {
    margin-bottom: 1rem !important;
  }
  .ml-sm-3,
  .mx-sm-3 {
    margin-left: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .mt-sm-4,
  .my-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mr-sm-4,
  .mx-sm-4 {
    margin-right: 1.5rem !important;
  }
  .mb-sm-4,
  .my-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-sm-4,
  .mx-sm-4 {
    margin-left: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .mt-sm-5,
  .my-sm-5 {
    margin-top: 3rem !important;
  }
  .mr-sm-5,
  .mx-sm-5 {
    margin-right: 3rem !important;
  }
  .mb-sm-5,
  .my-sm-5 {
    margin-bottom: 3rem !important;
  }
  .ml-sm-5,
  .mx-sm-5 {
    margin-left: 3rem !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .pt-sm-0,
  .py-sm-0 {
    padding-top: 0 !important;
  }
  .pr-sm-0,
  .px-sm-0 {
    padding-right: 0 !important;
  }
  .pb-sm-0,
  .py-sm-0 {
    padding-bottom: 0 !important;
  }
  .pl-sm-0,
  .px-sm-0 {
    padding-left: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .pt-sm-1,
  .py-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pr-sm-1,
  .px-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pb-sm-1,
  .py-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-sm-1,
  .px-sm-1 {
    padding-left: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .pt-sm-2,
  .py-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pr-sm-2,
  .px-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pb-sm-2,
  .py-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-sm-2,
  .px-sm-2 {
    padding-left: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .pt-sm-3,
  .py-sm-3 {
    padding-top: 1rem !important;
  }
  .pr-sm-3,
  .px-sm-3 {
    padding-right: 1rem !important;
  }
  .pb-sm-3,
  .py-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pl-sm-3,
  .px-sm-3 {
    padding-left: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .pt-sm-4,
  .py-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pr-sm-4,
  .px-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pb-sm-4,
  .py-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-sm-4,
  .px-sm-4 {
    padding-left: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .pt-sm-5,
  .py-sm-5 {
    padding-top: 3rem !important;
  }
  .pr-sm-5,
  .px-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-5,
  .py-sm-5 {
    padding-bottom: 3rem !important;
  }
  .pl-sm-5,
  .px-sm-5 {
    padding-left: 3rem !important;
  }
  .m-sm-n1 {
    margin: -0.25rem !important;
  }
  .mt-sm-n1,
  .my-sm-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-sm-n1,
  .mx-sm-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-sm-n1,
  .my-sm-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-sm-n1,
  .mx-sm-n1 {
    margin-left: -0.25rem !important;
  }
  .m-sm-n2 {
    margin: -0.5rem !important;
  }
  .mt-sm-n2,
  .my-sm-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-sm-n2,
  .mx-sm-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-sm-n2,
  .my-sm-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-sm-n2,
  .mx-sm-n2 {
    margin-left: -0.5rem !important;
  }
  .m-sm-n3 {
    margin: -1rem !important;
  }
  .mt-sm-n3,
  .my-sm-n3 {
    margin-top: -1rem !important;
  }
  .mr-sm-n3,
  .mx-sm-n3 {
    margin-right: -1rem !important;
  }
  .mb-sm-n3,
  .my-sm-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-sm-n3,
  .mx-sm-n3 {
    margin-left: -1rem !important;
  }
  .m-sm-n4 {
    margin: -1.5rem !important;
  }
  .mt-sm-n4,
  .my-sm-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-sm-n4,
  .mx-sm-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-sm-n4,
  .my-sm-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-sm-n4,
  .mx-sm-n4 {
    margin-left: -1.5rem !important;
  }
  .m-sm-n5 {
    margin: -3rem !important;
  }
  .mt-sm-n5,
  .my-sm-n5 {
    margin-top: -3rem !important;
  }
  .mr-sm-n5,
  .mx-sm-n5 {
    margin-right: -3rem !important;
  }
  .mb-sm-n5,
  .my-sm-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-sm-n5,
  .mx-sm-n5 {
    margin-left: -3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mt-sm-auto,
  .my-sm-auto {
    margin-top: auto !important;
  }
  .mr-sm-auto,
  .mx-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-auto,
  .my-sm-auto {
    margin-bottom: auto !important;
  }
  .ml-sm-auto,
  .mx-sm-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 768px) {
  .m-md-0 {
    margin: 0 !important;
  }
  .mt-md-0,
  .my-md-0 {
    margin-top: 0 !important;
  }
  .mr-md-0,
  .mx-md-0 {
    margin-right: 0 !important;
  }
  .mb-md-0,
  .my-md-0 {
    margin-bottom: 0 !important;
  }
  .ml-md-0,
  .mx-md-0 {
    margin-left: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .mt-md-1,
  .my-md-1 {
    margin-top: 0.25rem !important;
  }
  .mr-md-1,
  .mx-md-1 {
    margin-right: 0.25rem !important;
  }
  .mb-md-1,
  .my-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-md-1,
  .mx-md-1 {
    margin-left: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .mt-md-2,
  .my-md-2 {
    margin-top: 0.5rem !important;
  }
  .mr-md-2,
  .mx-md-2 {
    margin-right: 0.5rem !important;
  }
  .mb-md-2,
  .my-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-md-2,
  .mx-md-2 {
    margin-left: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .mt-md-3,
  .my-md-3 {
    margin-top: 1rem !important;
  }
  .mr-md-3,
  .mx-md-3 {
    margin-right: 1rem !important;
  }
  .mb-md-3,
  .my-md-3 {
    margin-bottom: 1rem !important;
  }
  .ml-md-3,
  .mx-md-3 {
    margin-left: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .mt-md-4,
  .my-md-4 {
    margin-top: 1.5rem !important;
  }
  .mr-md-4,
  .mx-md-4 {
    margin-right: 1.5rem !important;
  }
  .mb-md-4,
  .my-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-md-4,
  .mx-md-4 {
    margin-left: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .mt-md-5,
  .my-md-5 {
    margin-top: 3rem !important;
  }
  .mr-md-5,
  .mx-md-5 {
    margin-right: 3rem !important;
  }
  .mb-md-5,
  .my-md-5 {
    margin-bottom: 3rem !important;
  }
  .ml-md-5,
  .mx-md-5 {
    margin-left: 3rem !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .pt-md-0,
  .py-md-0 {
    padding-top: 0 !important;
  }
  .pr-md-0,
  .px-md-0 {
    padding-right: 0 !important;
  }
  .pb-md-0,
  .py-md-0 {
    padding-bottom: 0 !important;
  }
  .pl-md-0,
  .px-md-0 {
    padding-left: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .pt-md-1,
  .py-md-1 {
    padding-top: 0.25rem !important;
  }
  .pr-md-1,
  .px-md-1 {
    padding-right: 0.25rem !important;
  }
  .pb-md-1,
  .py-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-md-1,
  .px-md-1 {
    padding-left: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .pt-md-2,
  .py-md-2 {
    padding-top: 0.5rem !important;
  }
  .pr-md-2,
  .px-md-2 {
    padding-right: 0.5rem !important;
  }
  .pb-md-2,
  .py-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-md-2,
  .px-md-2 {
    padding-left: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .pt-md-3,
  .py-md-3 {
    padding-top: 1rem !important;
  }
  .pr-md-3,
  .px-md-3 {
    padding-right: 1rem !important;
  }
  .pb-md-3,
  .py-md-3 {
    padding-bottom: 1rem !important;
  }
  .pl-md-3,
  .px-md-3 {
    padding-left: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .pt-md-4,
  .py-md-4 {
    padding-top: 1.5rem !important;
  }
  .pr-md-4,
  .px-md-4 {
    padding-right: 1.5rem !important;
  }
  .pb-md-4,
  .py-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-md-4,
  .px-md-4 {
    padding-left: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .pt-md-5,
  .py-md-5 {
    padding-top: 3rem !important;
  }
  .pr-md-5,
  .px-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-5,
  .py-md-5 {
    padding-bottom: 3rem !important;
  }
  .pl-md-5,
  .px-md-5 {
    padding-left: 3rem !important;
  }
  .m-md-n1 {
    margin: -0.25rem !important;
  }
  .mt-md-n1,
  .my-md-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-md-n1,
  .mx-md-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-md-n1,
  .my-md-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-md-n1,
  .mx-md-n1 {
    margin-left: -0.25rem !important;
  }
  .m-md-n2 {
    margin: -0.5rem !important;
  }
  .mt-md-n2,
  .my-md-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-md-n2,
  .mx-md-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-md-n2,
  .my-md-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-md-n2,
  .mx-md-n2 {
    margin-left: -0.5rem !important;
  }
  .m-md-n3 {
    margin: -1rem !important;
  }
  .mt-md-n3,
  .my-md-n3 {
    margin-top: -1rem !important;
  }
  .mr-md-n3,
  .mx-md-n3 {
    margin-right: -1rem !important;
  }
  .mb-md-n3,
  .my-md-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-md-n3,
  .mx-md-n3 {
    margin-left: -1rem !important;
  }
  .m-md-n4 {
    margin: -1.5rem !important;
  }
  .mt-md-n4,
  .my-md-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-md-n4,
  .mx-md-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-md-n4,
  .my-md-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-md-n4,
  .mx-md-n4 {
    margin-left: -1.5rem !important;
  }
  .m-md-n5 {
    margin: -3rem !important;
  }
  .mt-md-n5,
  .my-md-n5 {
    margin-top: -3rem !important;
  }
  .mr-md-n5,
  .mx-md-n5 {
    margin-right: -3rem !important;
  }
  .mb-md-n5,
  .my-md-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-md-n5,
  .mx-md-n5 {
    margin-left: -3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mt-md-auto,
  .my-md-auto {
    margin-top: auto !important;
  }
  .mr-md-auto,
  .mx-md-auto {
    margin-right: auto !important;
  }
  .mb-md-auto,
  .my-md-auto {
    margin-bottom: auto !important;
  }
  .ml-md-auto,
  .mx-md-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 992px) {
  .m-lg-0 {
    margin: 0 !important;
  }
  .mt-lg-0,
  .my-lg-0 {
    margin-top: 0 !important;
  }
  .mr-lg-0,
  .mx-lg-0 {
    margin-right: 0 !important;
  }
  .mb-lg-0,
  .my-lg-0 {
    margin-bottom: 0 !important;
  }
  .ml-lg-0,
  .mx-lg-0 {
    margin-left: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .mt-lg-1,
  .my-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mr-lg-1,
  .mx-lg-1 {
    margin-right: 0.25rem !important;
  }
  .mb-lg-1,
  .my-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-lg-1,
  .mx-lg-1 {
    margin-left: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .mt-lg-2,
  .my-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mr-lg-2,
  .mx-lg-2 {
    margin-right: 0.5rem !important;
  }
  .mb-lg-2,
  .my-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-lg-2,
  .mx-lg-2 {
    margin-left: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .mt-lg-3,
  .my-lg-3 {
    margin-top: 1rem !important;
  }
  .mr-lg-3,
  .mx-lg-3 {
    margin-right: 1rem !important;
  }
  .mb-lg-3,
  .my-lg-3 {
    margin-bottom: 1rem !important;
  }
  .ml-lg-3,
  .mx-lg-3 {
    margin-left: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .mt-lg-4,
  .my-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mr-lg-4,
  .mx-lg-4 {
    margin-right: 1.5rem !important;
  }
  .mb-lg-4,
  .my-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-lg-4,
  .mx-lg-4 {
    margin-left: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .mt-lg-5,
  .my-lg-5 {
    margin-top: 3rem !important;
  }
  .mr-lg-5,
  .mx-lg-5 {
    margin-right: 3rem !important;
  }
  .mb-lg-5,
  .my-lg-5 {
    margin-bottom: 3rem !important;
  }
  .ml-lg-5,
  .mx-lg-5 {
    margin-left: 3rem !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .pt-lg-0,
  .py-lg-0 {
    padding-top: 0 !important;
  }
  .pr-lg-0,
  .px-lg-0 {
    padding-right: 0 !important;
  }
  .pb-lg-0,
  .py-lg-0 {
    padding-bottom: 0 !important;
  }
  .pl-lg-0,
  .px-lg-0 {
    padding-left: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .pt-lg-1,
  .py-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pr-lg-1,
  .px-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pb-lg-1,
  .py-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-lg-1,
  .px-lg-1 {
    padding-left: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .pt-lg-2,
  .py-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pr-lg-2,
  .px-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pb-lg-2,
  .py-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-lg-2,
  .px-lg-2 {
    padding-left: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .pt-lg-3,
  .py-lg-3 {
    padding-top: 1rem !important;
  }
  .pr-lg-3,
  .px-lg-3 {
    padding-right: 1rem !important;
  }
  .pb-lg-3,
  .py-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pl-lg-3,
  .px-lg-3 {
    padding-left: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .pt-lg-4,
  .py-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pr-lg-4,
  .px-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pb-lg-4,
  .py-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-lg-4,
  .px-lg-4 {
    padding-left: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .pt-lg-5,
  .py-lg-5 {
    padding-top: 3rem !important;
  }
  .pr-lg-5,
  .px-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-5,
  .py-lg-5 {
    padding-bottom: 3rem !important;
  }
  .pl-lg-5,
  .px-lg-5 {
    padding-left: 3rem !important;
  }
  .m-lg-n1 {
    margin: -0.25rem !important;
  }
  .mt-lg-n1,
  .my-lg-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-lg-n1,
  .mx-lg-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-lg-n1,
  .my-lg-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-lg-n1,
  .mx-lg-n1 {
    margin-left: -0.25rem !important;
  }
  .m-lg-n2 {
    margin: -0.5rem !important;
  }
  .mt-lg-n2,
  .my-lg-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-lg-n2,
  .mx-lg-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-lg-n2,
  .my-lg-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-lg-n2,
  .mx-lg-n2 {
    margin-left: -0.5rem !important;
  }
  .m-lg-n3 {
    margin: -1rem !important;
  }
  .mt-lg-n3,
  .my-lg-n3 {
    margin-top: -1rem !important;
  }
  .mr-lg-n3,
  .mx-lg-n3 {
    margin-right: -1rem !important;
  }
  .mb-lg-n3,
  .my-lg-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-lg-n3,
  .mx-lg-n3 {
    margin-left: -1rem !important;
  }
  .m-lg-n4 {
    margin: -1.5rem !important;
  }
  .mt-lg-n4,
  .my-lg-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-lg-n4,
  .mx-lg-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-lg-n4,
  .my-lg-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-lg-n4,
  .mx-lg-n4 {
    margin-left: -1.5rem !important;
  }
  .m-lg-n5 {
    margin: -3rem !important;
  }
  .mt-lg-n5,
  .my-lg-n5 {
    margin-top: -3rem !important;
  }
  .mr-lg-n5,
  .mx-lg-n5 {
    margin-right: -3rem !important;
  }
  .mb-lg-n5,
  .my-lg-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-lg-n5,
  .mx-lg-n5 {
    margin-left: -3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mt-lg-auto,
  .my-lg-auto {
    margin-top: auto !important;
  }
  .mr-lg-auto,
  .mx-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-auto,
  .my-lg-auto {
    margin-bottom: auto !important;
  }
  .ml-lg-auto,
  .mx-lg-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 1200px) {
  .m-xl-0 {
    margin: 0 !important;
  }
  .mt-xl-0,
  .my-xl-0 {
    margin-top: 0 !important;
  }
  .mr-xl-0,
  .mx-xl-0 {
    margin-right: 0 !important;
  }
  .mb-xl-0,
  .my-xl-0 {
    margin-bottom: 0 !important;
  }
  .ml-xl-0,
  .mx-xl-0 {
    margin-left: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .mt-xl-1,
  .my-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mr-xl-1,
  .mx-xl-1 {
    margin-right: 0.25rem !important;
  }
  .mb-xl-1,
  .my-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-xl-1,
  .mx-xl-1 {
    margin-left: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .mt-xl-2,
  .my-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mr-xl-2,
  .mx-xl-2 {
    margin-right: 0.5rem !important;
  }
  .mb-xl-2,
  .my-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-xl-2,
  .mx-xl-2 {
    margin-left: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .mt-xl-3,
  .my-xl-3 {
    margin-top: 1rem !important;
  }
  .mr-xl-3,
  .mx-xl-3 {
    margin-right: 1rem !important;
  }
  .mb-xl-3,
  .my-xl-3 {
    margin-bottom: 1rem !important;
  }
  .ml-xl-3,
  .mx-xl-3 {
    margin-left: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .mt-xl-4,
  .my-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mr-xl-4,
  .mx-xl-4 {
    margin-right: 1.5rem !important;
  }
  .mb-xl-4,
  .my-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-xl-4,
  .mx-xl-4 {
    margin-left: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .mt-xl-5,
  .my-xl-5 {
    margin-top: 3rem !important;
  }
  .mr-xl-5,
  .mx-xl-5 {
    margin-right: 3rem !important;
  }
  .mb-xl-5,
  .my-xl-5 {
    margin-bottom: 3rem !important;
  }
  .ml-xl-5,
  .mx-xl-5 {
    margin-left: 3rem !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .pt-xl-0,
  .py-xl-0 {
    padding-top: 0 !important;
  }
  .pr-xl-0,
  .px-xl-0 {
    padding-right: 0 !important;
  }
  .pb-xl-0,
  .py-xl-0 {
    padding-bottom: 0 !important;
  }
  .pl-xl-0,
  .px-xl-0 {
    padding-left: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .pt-xl-1,
  .py-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pr-xl-1,
  .px-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pb-xl-1,
  .py-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-xl-1,
  .px-xl-1 {
    padding-left: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .pt-xl-2,
  .py-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pr-xl-2,
  .px-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pb-xl-2,
  .py-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-xl-2,
  .px-xl-2 {
    padding-left: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .pt-xl-3,
  .py-xl-3 {
    padding-top: 1rem !important;
  }
  .pr-xl-3,
  .px-xl-3 {
    padding-right: 1rem !important;
  }
  .pb-xl-3,
  .py-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pl-xl-3,
  .px-xl-3 {
    padding-left: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .pt-xl-4,
  .py-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pr-xl-4,
  .px-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pb-xl-4,
  .py-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-xl-4,
  .px-xl-4 {
    padding-left: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .pt-xl-5,
  .py-xl-5 {
    padding-top: 3rem !important;
  }
  .pr-xl-5,
  .px-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-5,
  .py-xl-5 {
    padding-bottom: 3rem !important;
  }
  .pl-xl-5,
  .px-xl-5 {
    padding-left: 3rem !important;
  }
  .m-xl-n1 {
    margin: -0.25rem !important;
  }
  .mt-xl-n1,
  .my-xl-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-xl-n1,
  .mx-xl-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-xl-n1,
  .my-xl-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-xl-n1,
  .mx-xl-n1 {
    margin-left: -0.25rem !important;
  }
  .m-xl-n2 {
    margin: -0.5rem !important;
  }
  .mt-xl-n2,
  .my-xl-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-xl-n2,
  .mx-xl-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-xl-n2,
  .my-xl-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-xl-n2,
  .mx-xl-n2 {
    margin-left: -0.5rem !important;
  }
  .m-xl-n3 {
    margin: -1rem !important;
  }
  .mt-xl-n3,
  .my-xl-n3 {
    margin-top: -1rem !important;
  }
  .mr-xl-n3,
  .mx-xl-n3 {
    margin-right: -1rem !important;
  }
  .mb-xl-n3,
  .my-xl-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-xl-n3,
  .mx-xl-n3 {
    margin-left: -1rem !important;
  }
  .m-xl-n4 {
    margin: -1.5rem !important;
  }
  .mt-xl-n4,
  .my-xl-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-xl-n4,
  .mx-xl-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-xl-n4,
  .my-xl-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-xl-n4,
  .mx-xl-n4 {
    margin-left: -1.5rem !important;
  }
  .m-xl-n5 {
    margin: -3rem !important;
  }
  .mt-xl-n5,
  .my-xl-n5 {
    margin-top: -3rem !important;
  }
  .mr-xl-n5,
  .mx-xl-n5 {
    margin-right: -3rem !important;
  }
  .mb-xl-n5,
  .my-xl-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-xl-n5,
  .mx-xl-n5 {
    margin-left: -3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mt-xl-auto,
  .my-xl-auto {
    margin-top: auto !important;
  }
  .mr-xl-auto,
  .mx-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-auto,
  .my-xl-auto {
    margin-bottom: auto !important;
  }
  .ml-xl-auto,
  .mx-xl-auto {
    margin-left: auto !important;
  }
}
.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  pointer-events: auto;
  content: "";
  background-color: rgba(0, 0, 0, 0);
}

.text-monospace {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important;
}

.text-justify {
  text-align: justify !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text-left {
  text-align: left !important;
}

.text-right {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

@media (min-width: 576px) {
  .text-sm-left {
    text-align: left !important;
  }
  .text-sm-right {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .text-md-left {
    text-align: left !important;
  }
  .text-md-right {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .text-lg-left {
    text-align: left !important;
  }
  .text-lg-right {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .text-xl-left {
    text-align: left !important;
  }
  .text-xl-right {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.font-weight-light {
  font-weight: 300 !important;
}

.font-weight-lighter {
  font-weight: lighter !important;
}

.font-weight-normal {
  font-weight: 400 !important;
}

.font-weight-bold {
  font-weight: 700 !important;
}

.font-weight-bolder {
  font-weight: bolder !important;
}

.font-italic {
  font-style: italic !important;
}

.text-white {
  color: #ffffff !important;
}

.text-primary, .list-wrapper .completed .remove {
  color: #0090e7 !important;
}

a.text-primary:hover, .list-wrapper .completed a.remove:hover, a.text-primary:focus, .list-wrapper .completed a.remove:focus {
  color: #00609b !important;
}

.text-secondary, .list-wrapper .remove {
  color: #e4eaec !important;
}

a.text-secondary:hover, .list-wrapper a.remove:hover, a.text-secondary:focus, .list-wrapper a.remove:focus {
  color: #b7c7cc !important;
}

.text-success {
  color: #00d25b !important;
}

a.text-success:hover, a.text-success:focus {
  color: #00863a !important;
}

.text-info {
  color: #8f5fe8 !important;
}

a.text-info:hover, a.text-info:focus {
  color: #611fdb !important;
}

.text-warning {
  color: #ffab00 !important;
}

a.text-warning:hover, a.text-warning:focus {
  color: #b37800 !important;
}

.text-danger {
  color: #fc424a !important;
}

a.text-danger:hover, a.text-danger:focus {
  color: #ee040e !important;
}

.text-light {
  color: #ffffff !important;
}

a.text-light:hover, a.text-light:focus {
  color: #d9d9d9 !important;
}

.text-dark {
  color: #0d0d0d !important;
}

a.text-dark:hover, a.text-dark:focus {
  color: black !important;
}

.text-body {
  color: #2e383e !important;
}

.text-muted, .preview-list .preview-item .preview-item-content p .content-category {
  color: #6c7293 !important;
}

.text-black-50 {
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-hide {
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-break {
  word-break: break-word !important;
  word-wrap: break-word !important;
}

.text-reset {
  color: inherit !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

@media print {
  *,
  *::before,
  *::after {
    text-shadow: none !important;
    box-shadow: none !important;
  }
  a:not(.btn) {
    text-decoration: underline;
  }
  abbr[title]::after {
    content: " (" attr(title) ")";
  }
  pre {
    white-space: pre-wrap !important;
  }
  pre,
  blockquote {
    border: 1px solid #adb5bd;
    page-break-inside: avoid;
  }
  tr,
  img {
    page-break-inside: avoid;
  }
  p,
  h2,
  h3 {
    orphans: 3;
    widows: 3;
  }
  h2,
  h3 {
    page-break-after: avoid;
  }
  @page {
    size: a3;
  }
  body {
    min-width: 992px !important;
  }
  .container {
    min-width: 992px !important;
  }
  .navbar {
    display: none;
  }
  .badge {
    border: 1px solid #000;
  }
  .table {
    border-collapse: collapse !important;
  }
  .table td,
  .table th {
    background-color: #ffffff !important;
  }
  .table-bordered th,
  .table-bordered td {
    border: 1px solid #dee2e6 !important;
  }
  .table-dark {
    color: inherit;
  }
  .table-dark th,
  .table-dark td,
  .table-dark thead th,
  .table-dark tbody + tbody {
    border-color: #2c2e33;
  }
  .table .thead-dark th {
    color: inherit;
    border-color: #2c2e33;
  }
}
/* MaterialDesignIcons.com */
@font-face {
  font-family: "Material Design Icons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
.mdi:before,
.mdi-set {
  display: inline-block;
  font: normal normal normal 24px/1 "Material Design Icons";
  font-size: inherit;
  text-rendering: auto;
  line-height: inherit;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.mdi-ab-testing::before {
  content: "\\F001C";
}

.mdi-abjad-arabic::before {
  content: "\\F0353";
}

.mdi-abjad-hebrew::before {
  content: "\\F0354";
}

.mdi-abugida-devanagari::before {
  content: "\\F0355";
}

.mdi-abugida-thai::before {
  content: "\\F0356";
}

.mdi-access-point::before {
  content: "\\F002";
}

.mdi-access-point-network::before {
  content: "\\F003";
}

.mdi-access-point-network-off::before {
  content: "\\FBBD";
}

.mdi-account::before {
  content: "\\F004";
}

.mdi-account-alert::before {
  content: "\\F005";
}

.mdi-account-alert-outline::before {
  content: "\\FB2C";
}

.mdi-account-arrow-left::before {
  content: "\\FB2D";
}

.mdi-account-arrow-left-outline::before {
  content: "\\FB2E";
}

.mdi-account-arrow-right::before {
  content: "\\FB2F";
}

.mdi-account-arrow-right-outline::before {
  content: "\\FB30";
}

.mdi-account-badge::before {
  content: "\\FD83";
}

.mdi-account-badge-alert::before {
  content: "\\FD84";
}

.mdi-account-badge-alert-outline::before {
  content: "\\FD85";
}

.mdi-account-badge-horizontal::before {
  content: "\\FDF0";
}

.mdi-account-badge-horizontal-outline::before {
  content: "\\FDF1";
}

.mdi-account-badge-outline::before {
  content: "\\FD86";
}

.mdi-account-box::before {
  content: "\\F006";
}

.mdi-account-box-multiple::before {
  content: "\\F933";
}

.mdi-account-box-multiple-outline::before {
  content: "\\F002C";
}

.mdi-account-box-outline::before {
  content: "\\F007";
}

.mdi-account-cancel::before {
  content: "\\F030A";
}

.mdi-account-cancel-outline::before {
  content: "\\F030B";
}

.mdi-account-card-details::before {
  content: "\\F5D2";
}

.mdi-account-card-details-outline::before {
  content: "\\FD87";
}

.mdi-account-cash::before {
  content: "\\F00C2";
}

.mdi-account-cash-outline::before {
  content: "\\F00C3";
}

.mdi-account-check::before {
  content: "\\F008";
}

.mdi-account-check-outline::before {
  content: "\\FBBE";
}

.mdi-account-child::before {
  content: "\\FA88";
}

.mdi-account-child-circle::before {
  content: "\\FA89";
}

.mdi-account-child-outline::before {
  content: "\\F00F3";
}

.mdi-account-circle::before {
  content: "\\F009";
}

.mdi-account-circle-outline::before {
  content: "\\FB31";
}

.mdi-account-clock::before {
  content: "\\FB32";
}

.mdi-account-clock-outline::before {
  content: "\\FB33";
}

.mdi-account-cog::before {
  content: "\\F039B";
}

.mdi-account-cog-outline::before {
  content: "\\F039C";
}

.mdi-account-convert::before {
  content: "\\F00A";
}

.mdi-account-convert-outline::before {
  content: "\\F032C";
}

.mdi-account-details::before {
  content: "\\F631";
}

.mdi-account-details-outline::before {
  content: "\\F039D";
}

.mdi-account-edit::before {
  content: "\\F6BB";
}

.mdi-account-edit-outline::before {
  content: "\\F001D";
}

.mdi-account-group::before {
  content: "\\F848";
}

.mdi-account-group-outline::before {
  content: "\\FB34";
}

.mdi-account-heart::before {
  content: "\\F898";
}

.mdi-account-heart-outline::before {
  content: "\\FBBF";
}

.mdi-account-key::before {
  content: "\\F00B";
}

.mdi-account-key-outline::before {
  content: "\\FBC0";
}

.mdi-account-lock::before {
  content: "\\F0189";
}

.mdi-account-lock-outline::before {
  content: "\\F018A";
}

.mdi-account-minus::before {
  content: "\\F00D";
}

.mdi-account-minus-outline::before {
  content: "\\FAEB";
}

.mdi-account-multiple::before {
  content: "\\F00E";
}

.mdi-account-multiple-check::before {
  content: "\\F8C4";
}

.mdi-account-multiple-check-outline::before {
  content: "\\F0229";
}

.mdi-account-multiple-minus::before {
  content: "\\F5D3";
}

.mdi-account-multiple-minus-outline::before {
  content: "\\FBC1";
}

.mdi-account-multiple-outline::before {
  content: "\\F00F";
}

.mdi-account-multiple-plus::before {
  content: "\\F010";
}

.mdi-account-multiple-plus-outline::before {
  content: "\\F7FF";
}

.mdi-account-multiple-remove::before {
  content: "\\F0235";
}

.mdi-account-multiple-remove-outline::before {
  content: "\\F0236";
}

.mdi-account-network::before {
  content: "\\F011";
}

.mdi-account-network-outline::before {
  content: "\\FBC2";
}

.mdi-account-off::before {
  content: "\\F012";
}

.mdi-account-off-outline::before {
  content: "\\FBC3";
}

.mdi-account-outline::before {
  content: "\\F013";
}

.mdi-account-plus::before {
  content: "\\F014";
}

.mdi-account-plus-outline::before {
  content: "\\F800";
}

.mdi-account-question::before {
  content: "\\FB35";
}

.mdi-account-question-outline::before {
  content: "\\FB36";
}

.mdi-account-remove::before {
  content: "\\F015";
}

.mdi-account-remove-outline::before {
  content: "\\FAEC";
}

.mdi-account-search::before {
  content: "\\F016";
}

.mdi-account-search-outline::before {
  content: "\\F934";
}

.mdi-account-settings::before {
  content: "\\F630";
}

.mdi-account-settings-outline::before {
  content: "\\F00F4";
}

.mdi-account-star::before {
  content: "\\F017";
}

.mdi-account-star-outline::before {
  content: "\\FBC4";
}

.mdi-account-supervisor::before {
  content: "\\FA8A";
}

.mdi-account-supervisor-circle::before {
  content: "\\FA8B";
}

.mdi-account-supervisor-outline::before {
  content: "\\F0158";
}

.mdi-account-switch::before {
  content: "\\F019";
}

.mdi-account-tie::before {
  content: "\\FCBF";
}

.mdi-account-tie-outline::before {
  content: "\\F00F5";
}

.mdi-account-tie-voice::before {
  content: "\\F0333";
}

.mdi-account-tie-voice-off::before {
  content: "\\F0335";
}

.mdi-account-tie-voice-off-outline::before {
  content: "\\F0336";
}

.mdi-account-tie-voice-outline::before {
  content: "\\F0334";
}

.mdi-accusoft::before {
  content: "\\F849";
}

.mdi-adjust::before {
  content: "\\F01A";
}

.mdi-adobe::before {
  content: "\\F935";
}

.mdi-adobe-acrobat::before {
  content: "\\FFBD";
}

.mdi-air-conditioner::before {
  content: "\\F01B";
}

.mdi-air-filter::before {
  content: "\\FD1F";
}

.mdi-air-horn::before {
  content: "\\FD88";
}

.mdi-air-humidifier::before {
  content: "\\F00C4";
}

.mdi-air-purifier::before {
  content: "\\FD20";
}

.mdi-airbag::before {
  content: "\\FBC5";
}

.mdi-airballoon::before {
  content: "\\F01C";
}

.mdi-airballoon-outline::before {
  content: "\\F002D";
}

.mdi-airplane::before {
  content: "\\F01D";
}

.mdi-airplane-landing::before {
  content: "\\F5D4";
}

.mdi-airplane-off::before {
  content: "\\F01E";
}

.mdi-airplane-takeoff::before {
  content: "\\F5D5";
}

.mdi-airplay::before {
  content: "\\F01F";
}

.mdi-airport::before {
  content: "\\F84A";
}

.mdi-alarm::before {
  content: "\\F020";
}

.mdi-alarm-bell::before {
  content: "\\F78D";
}

.mdi-alarm-check::before {
  content: "\\F021";
}

.mdi-alarm-light::before {
  content: "\\F78E";
}

.mdi-alarm-light-outline::before {
  content: "\\FBC6";
}

.mdi-alarm-multiple::before {
  content: "\\F022";
}

.mdi-alarm-note::before {
  content: "\\FE8E";
}

.mdi-alarm-note-off::before {
  content: "\\FE8F";
}

.mdi-alarm-off::before {
  content: "\\F023";
}

.mdi-alarm-plus::before {
  content: "\\F024";
}

.mdi-alarm-snooze::before {
  content: "\\F68D";
}

.mdi-album::before {
  content: "\\F025";
}

.mdi-alert::before {
  content: "\\F026";
}

.mdi-alert-box::before {
  content: "\\F027";
}

.mdi-alert-box-outline::before {
  content: "\\FCC0";
}

.mdi-alert-circle::before {
  content: "\\F028";
}

.mdi-alert-circle-check::before {
  content: "\\F0218";
}

.mdi-alert-circle-check-outline::before {
  content: "\\F0219";
}

.mdi-alert-circle-outline::before {
  content: "\\F5D6";
}

.mdi-alert-decagram::before {
  content: "\\F6BC";
}

.mdi-alert-decagram-outline::before {
  content: "\\FCC1";
}

.mdi-alert-octagon::before {
  content: "\\F029";
}

.mdi-alert-octagon-outline::before {
  content: "\\FCC2";
}

.mdi-alert-octagram::before {
  content: "\\F766";
}

.mdi-alert-octagram-outline::before {
  content: "\\FCC3";
}

.mdi-alert-outline::before {
  content: "\\F02A";
}

.mdi-alert-rhombus::before {
  content: "\\F01F9";
}

.mdi-alert-rhombus-outline::before {
  content: "\\F01FA";
}

.mdi-alien::before {
  content: "\\F899";
}

.mdi-alien-outline::before {
  content: "\\F00F6";
}

.mdi-align-horizontal-center::before {
  content: "\\F01EE";
}

.mdi-align-horizontal-left::before {
  content: "\\F01ED";
}

.mdi-align-horizontal-right::before {
  content: "\\F01EF";
}

.mdi-align-vertical-bottom::before {
  content: "\\F01F0";
}

.mdi-align-vertical-center::before {
  content: "\\F01F1";
}

.mdi-align-vertical-top::before {
  content: "\\F01F2";
}

.mdi-all-inclusive::before {
  content: "\\F6BD";
}

.mdi-allergy::before {
  content: "\\F0283";
}

.mdi-alpha::before {
  content: "\\F02B";
}

.mdi-alpha-a::before {
  content: "\\41";
}

.mdi-alpha-a-box::before {
  content: "\\FAED";
}

.mdi-alpha-a-box-outline::before {
  content: "\\FBC7";
}

.mdi-alpha-a-circle::before {
  content: "\\FBC8";
}

.mdi-alpha-a-circle-outline::before {
  content: "\\FBC9";
}

.mdi-alpha-b::before {
  content: "\\42";
}

.mdi-alpha-b-box::before {
  content: "\\FAEE";
}

.mdi-alpha-b-box-outline::before {
  content: "\\FBCA";
}

.mdi-alpha-b-circle::before {
  content: "\\FBCB";
}

.mdi-alpha-b-circle-outline::before {
  content: "\\FBCC";
}

.mdi-alpha-c::before {
  content: "\\43";
}

.mdi-alpha-c-box::before {
  content: "\\FAEF";
}

.mdi-alpha-c-box-outline::before {
  content: "\\FBCD";
}

.mdi-alpha-c-circle::before {
  content: "\\FBCE";
}

.mdi-alpha-c-circle-outline::before {
  content: "\\FBCF";
}

.mdi-alpha-d::before {
  content: "\\44";
}

.mdi-alpha-d-box::before {
  content: "\\FAF0";
}

.mdi-alpha-d-box-outline::before {
  content: "\\FBD0";
}

.mdi-alpha-d-circle::before {
  content: "\\FBD1";
}

.mdi-alpha-d-circle-outline::before {
  content: "\\FBD2";
}

.mdi-alpha-e::before {
  content: "\\45";
}

.mdi-alpha-e-box::before {
  content: "\\FAF1";
}

.mdi-alpha-e-box-outline::before {
  content: "\\FBD3";
}

.mdi-alpha-e-circle::before {
  content: "\\FBD4";
}

.mdi-alpha-e-circle-outline::before {
  content: "\\FBD5";
}

.mdi-alpha-f::before {
  content: "\\46";
}

.mdi-alpha-f-box::before {
  content: "\\FAF2";
}

.mdi-alpha-f-box-outline::before {
  content: "\\FBD6";
}

.mdi-alpha-f-circle::before {
  content: "\\FBD7";
}

.mdi-alpha-f-circle-outline::before {
  content: "\\FBD8";
}

.mdi-alpha-g::before {
  content: "\\47";
}

.mdi-alpha-g-box::before {
  content: "\\FAF3";
}

.mdi-alpha-g-box-outline::before {
  content: "\\FBD9";
}

.mdi-alpha-g-circle::before {
  content: "\\FBDA";
}

.mdi-alpha-g-circle-outline::before {
  content: "\\FBDB";
}

.mdi-alpha-h::before {
  content: "\\48";
}

.mdi-alpha-h-box::before {
  content: "\\FAF4";
}

.mdi-alpha-h-box-outline::before {
  content: "\\FBDC";
}

.mdi-alpha-h-circle::before {
  content: "\\FBDD";
}

.mdi-alpha-h-circle-outline::before {
  content: "\\FBDE";
}

.mdi-alpha-i::before {
  content: "\\49";
}

.mdi-alpha-i-box::before {
  content: "\\FAF5";
}

.mdi-alpha-i-box-outline::before {
  content: "\\FBDF";
}

.mdi-alpha-i-circle::before {
  content: "\\FBE0";
}

.mdi-alpha-i-circle-outline::before {
  content: "\\FBE1";
}

.mdi-alpha-j::before {
  content: "\\4A";
}

.mdi-alpha-j-box::before {
  content: "\\FAF6";
}

.mdi-alpha-j-box-outline::before {
  content: "\\FBE2";
}

.mdi-alpha-j-circle::before {
  content: "\\FBE3";
}

.mdi-alpha-j-circle-outline::before {
  content: "\\FBE4";
}

.mdi-alpha-k::before {
  content: "\\4B";
}

.mdi-alpha-k-box::before {
  content: "\\FAF7";
}

.mdi-alpha-k-box-outline::before {
  content: "\\FBE5";
}

.mdi-alpha-k-circle::before {
  content: "\\FBE6";
}

.mdi-alpha-k-circle-outline::before {
  content: "\\FBE7";
}

.mdi-alpha-l::before {
  content: "\\4C";
}

.mdi-alpha-l-box::before {
  content: "\\FAF8";
}

.mdi-alpha-l-box-outline::before {
  content: "\\FBE8";
}

.mdi-alpha-l-circle::before {
  content: "\\FBE9";
}

.mdi-alpha-l-circle-outline::before {
  content: "\\FBEA";
}

.mdi-alpha-m::before {
  content: "\\4D";
}

.mdi-alpha-m-box::before {
  content: "\\FAF9";
}

.mdi-alpha-m-box-outline::before {
  content: "\\FBEB";
}

.mdi-alpha-m-circle::before {
  content: "\\FBEC";
}

.mdi-alpha-m-circle-outline::before {
  content: "\\FBED";
}

.mdi-alpha-n::before {
  content: "\\4E";
}

.mdi-alpha-n-box::before {
  content: "\\FAFA";
}

.mdi-alpha-n-box-outline::before {
  content: "\\FBEE";
}

.mdi-alpha-n-circle::before {
  content: "\\FBEF";
}

.mdi-alpha-n-circle-outline::before {
  content: "\\FBF0";
}

.mdi-alpha-o::before {
  content: "\\4F";
}

.mdi-alpha-o-box::before {
  content: "\\FAFB";
}

.mdi-alpha-o-box-outline::before {
  content: "\\FBF1";
}

.mdi-alpha-o-circle::before {
  content: "\\FBF2";
}

.mdi-alpha-o-circle-outline::before {
  content: "\\FBF3";
}

.mdi-alpha-p::before {
  content: "\\50";
}

.mdi-alpha-p-box::before {
  content: "\\FAFC";
}

.mdi-alpha-p-box-outline::before {
  content: "\\FBF4";
}

.mdi-alpha-p-circle::before {
  content: "\\FBF5";
}

.mdi-alpha-p-circle-outline::before {
  content: "\\FBF6";
}

.mdi-alpha-q::before {
  content: "\\51";
}

.mdi-alpha-q-box::before {
  content: "\\FAFD";
}

.mdi-alpha-q-box-outline::before {
  content: "\\FBF7";
}

.mdi-alpha-q-circle::before {
  content: "\\FBF8";
}

.mdi-alpha-q-circle-outline::before {
  content: "\\FBF9";
}

.mdi-alpha-r::before {
  content: "\\52";
}

.mdi-alpha-r-box::before {
  content: "\\FAFE";
}

.mdi-alpha-r-box-outline::before {
  content: "\\FBFA";
}

.mdi-alpha-r-circle::before {
  content: "\\FBFB";
}

.mdi-alpha-r-circle-outline::before {
  content: "\\FBFC";
}

.mdi-alpha-s::before {
  content: "\\53";
}

.mdi-alpha-s-box::before {
  content: "\\FAFF";
}

.mdi-alpha-s-box-outline::before {
  content: "\\FBFD";
}

.mdi-alpha-s-circle::before {
  content: "\\FBFE";
}

.mdi-alpha-s-circle-outline::before {
  content: "\\FBFF";
}

.mdi-alpha-t::before {
  content: "\\54";
}

.mdi-alpha-t-box::before {
  content: "\\FB00";
}

.mdi-alpha-t-box-outline::before {
  content: "\\FC00";
}

.mdi-alpha-t-circle::before {
  content: "\\FC01";
}

.mdi-alpha-t-circle-outline::before {
  content: "\\FC02";
}

.mdi-alpha-u::before {
  content: "\\55";
}

.mdi-alpha-u-box::before {
  content: "\\FB01";
}

.mdi-alpha-u-box-outline::before {
  content: "\\FC03";
}

.mdi-alpha-u-circle::before {
  content: "\\FC04";
}

.mdi-alpha-u-circle-outline::before {
  content: "\\FC05";
}

.mdi-alpha-v::before {
  content: "\\56";
}

.mdi-alpha-v-box::before {
  content: "\\FB02";
}

.mdi-alpha-v-box-outline::before {
  content: "\\FC06";
}

.mdi-alpha-v-circle::before {
  content: "\\FC07";
}

.mdi-alpha-v-circle-outline::before {
  content: "\\FC08";
}

.mdi-alpha-w::before {
  content: "\\57";
}

.mdi-alpha-w-box::before {
  content: "\\FB03";
}

.mdi-alpha-w-box-outline::before {
  content: "\\FC09";
}

.mdi-alpha-w-circle::before {
  content: "\\FC0A";
}

.mdi-alpha-w-circle-outline::before {
  content: "\\FC0B";
}

.mdi-alpha-x::before {
  content: "\\58";
}

.mdi-alpha-x-box::before {
  content: "\\FB04";
}

.mdi-alpha-x-box-outline::before {
  content: "\\FC0C";
}

.mdi-alpha-x-circle::before {
  content: "\\FC0D";
}

.mdi-alpha-x-circle-outline::before {
  content: "\\FC0E";
}

.mdi-alpha-y::before {
  content: "\\59";
}

.mdi-alpha-y-box::before {
  content: "\\FB05";
}

.mdi-alpha-y-box-outline::before {
  content: "\\FC0F";
}

.mdi-alpha-y-circle::before {
  content: "\\FC10";
}

.mdi-alpha-y-circle-outline::before {
  content: "\\FC11";
}

.mdi-alpha-z::before {
  content: "\\5A";
}

.mdi-alpha-z-box::before {
  content: "\\FB06";
}

.mdi-alpha-z-box-outline::before {
  content: "\\FC12";
}

.mdi-alpha-z-circle::before {
  content: "\\FC13";
}

.mdi-alpha-z-circle-outline::before {
  content: "\\FC14";
}

.mdi-alphabet-aurebesh::before {
  content: "\\F0357";
}

.mdi-alphabet-cyrillic::before {
  content: "\\F0358";
}

.mdi-alphabet-greek::before {
  content: "\\F0359";
}

.mdi-alphabet-latin::before {
  content: "\\F035A";
}

.mdi-alphabet-piqad::before {
  content: "\\F035B";
}

.mdi-alphabet-tengwar::before {
  content: "\\F0362";
}

.mdi-alphabetical::before {
  content: "\\F02C";
}

.mdi-alphabetical-off::before {
  content: "\\F002E";
}

.mdi-alphabetical-variant::before {
  content: "\\F002F";
}

.mdi-alphabetical-variant-off::before {
  content: "\\F0030";
}

.mdi-altimeter::before {
  content: "\\F5D7";
}

.mdi-amazon::before {
  content: "\\F02D";
}

.mdi-amazon-alexa::before {
  content: "\\F8C5";
}

.mdi-amazon-drive::before {
  content: "\\F02E";
}

.mdi-ambulance::before {
  content: "\\F02F";
}

.mdi-ammunition::before {
  content: "\\FCC4";
}

.mdi-ampersand::before {
  content: "\\FA8C";
}

.mdi-amplifier::before {
  content: "\\F030";
}

.mdi-amplifier-off::before {
  content: "\\F01E0";
}

.mdi-anchor::before {
  content: "\\F031";
}

.mdi-android::before {
  content: "\\F032";
}

.mdi-android-auto::before {
  content: "\\FA8D";
}

.mdi-android-debug-bridge::before {
  content: "\\F033";
}

.mdi-android-head::before {
  content: "\\F78F";
}

.mdi-android-messages::before {
  content: "\\FD21";
}

.mdi-android-studio::before {
  content: "\\F034";
}

.mdi-angle-acute::before {
  content: "\\F936";
}

.mdi-angle-obtuse::before {
  content: "\\F937";
}

.mdi-angle-right::before {
  content: "\\F938";
}

.mdi-angular::before {
  content: "\\F6B1";
}

.mdi-angularjs::before {
  content: "\\F6BE";
}

.mdi-animation::before {
  content: "\\F5D8";
}

.mdi-animation-outline::before {
  content: "\\FA8E";
}

.mdi-animation-play::before {
  content: "\\F939";
}

.mdi-animation-play-outline::before {
  content: "\\FA8F";
}

.mdi-ansible::before {
  content: "\\F00C5";
}

.mdi-antenna::before {
  content: "\\F0144";
}

.mdi-anvil::before {
  content: "\\F89A";
}

.mdi-apache-kafka::before {
  content: "\\F0031";
}

.mdi-api::before {
  content: "\\F00C6";
}

.mdi-api-off::before {
  content: "\\F0282";
}

.mdi-apple::before {
  content: "\\F035";
}

.mdi-apple-finder::before {
  content: "\\F036";
}

.mdi-apple-icloud::before {
  content: "\\F038";
}

.mdi-apple-ios::before {
  content: "\\F037";
}

.mdi-apple-keyboard-caps::before {
  content: "\\F632";
}

.mdi-apple-keyboard-command::before {
  content: "\\F633";
}

.mdi-apple-keyboard-control::before {
  content: "\\F634";
}

.mdi-apple-keyboard-option::before {
  content: "\\F635";
}

.mdi-apple-keyboard-shift::before {
  content: "\\F636";
}

.mdi-apple-safari::before {
  content: "\\F039";
}

.mdi-application::before {
  content: "\\F614";
}

.mdi-application-export::before {
  content: "\\FD89";
}

.mdi-application-import::before {
  content: "\\FD8A";
}

.mdi-approximately-equal::before {
  content: "\\FFBE";
}

.mdi-approximately-equal-box::before {
  content: "\\FFBF";
}

.mdi-apps::before {
  content: "\\F03B";
}

.mdi-apps-box::before {
  content: "\\FD22";
}

.mdi-arch::before {
  content: "\\F8C6";
}

.mdi-archive::before {
  content: "\\F03C";
}

.mdi-archive-arrow-down::before {
  content: "\\F0284";
}

.mdi-archive-arrow-down-outline::before {
  content: "\\F0285";
}

.mdi-archive-arrow-up::before {
  content: "\\F0286";
}

.mdi-archive-arrow-up-outline::before {
  content: "\\F0287";
}

.mdi-archive-outline::before {
  content: "\\F0239";
}

.mdi-arm-flex::before {
  content: "\\F008F";
}

.mdi-arm-flex-outline::before {
  content: "\\F0090";
}

.mdi-arrange-bring-forward::before {
  content: "\\F03D";
}

.mdi-arrange-bring-to-front::before {
  content: "\\F03E";
}

.mdi-arrange-send-backward::before {
  content: "\\F03F";
}

.mdi-arrange-send-to-back::before {
  content: "\\F040";
}

.mdi-arrow-all::before {
  content: "\\F041";
}

.mdi-arrow-bottom-left::before {
  content: "\\F042";
}

.mdi-arrow-bottom-left-bold-outline::before {
  content: "\\F9B6";
}

.mdi-arrow-bottom-left-thick::before {
  content: "\\F9B7";
}

.mdi-arrow-bottom-right::before {
  content: "\\F043";
}

.mdi-arrow-bottom-right-bold-outline::before {
  content: "\\F9B8";
}

.mdi-arrow-bottom-right-thick::before {
  content: "\\F9B9";
}

.mdi-arrow-collapse::before {
  content: "\\F615";
}

.mdi-arrow-collapse-all::before {
  content: "\\F044";
}

.mdi-arrow-collapse-down::before {
  content: "\\F791";
}

.mdi-arrow-collapse-horizontal::before {
  content: "\\F84B";
}

.mdi-arrow-collapse-left::before {
  content: "\\F792";
}

.mdi-arrow-collapse-right::before {
  content: "\\F793";
}

.mdi-arrow-collapse-up::before {
  content: "\\F794";
}

.mdi-arrow-collapse-vertical::before {
  content: "\\F84C";
}

.mdi-arrow-decision::before {
  content: "\\F9BA";
}

.mdi-arrow-decision-auto::before {
  content: "\\F9BB";
}

.mdi-arrow-decision-auto-outline::before {
  content: "\\F9BC";
}

.mdi-arrow-decision-outline::before {
  content: "\\F9BD";
}

.mdi-arrow-down::before {
  content: "\\F045";
}

.mdi-arrow-down-bold::before {
  content: "\\F72D";
}

.mdi-arrow-down-bold-box::before {
  content: "\\F72E";
}

.mdi-arrow-down-bold-box-outline::before {
  content: "\\F72F";
}

.mdi-arrow-down-bold-circle::before {
  content: "\\F047";
}

.mdi-arrow-down-bold-circle-outline::before {
  content: "\\F048";
}

.mdi-arrow-down-bold-hexagon-outline::before {
  content: "\\F049";
}

.mdi-arrow-down-bold-outline::before {
  content: "\\F9BE";
}

.mdi-arrow-down-box::before {
  content: "\\F6BF";
}

.mdi-arrow-down-circle::before {
  content: "\\FCB7";
}

.mdi-arrow-down-circle-outline::before {
  content: "\\FCB8";
}

.mdi-arrow-down-drop-circle::before {
  content: "\\F04A";
}

.mdi-arrow-down-drop-circle-outline::before {
  content: "\\F04B";
}

.mdi-arrow-down-thick::before {
  content: "\\F046";
}

.mdi-arrow-expand::before {
  content: "\\F616";
}

.mdi-arrow-expand-all::before {
  content: "\\F04C";
}

.mdi-arrow-expand-down::before {
  content: "\\F795";
}

.mdi-arrow-expand-horizontal::before {
  content: "\\F84D";
}

.mdi-arrow-expand-left::before {
  content: "\\F796";
}

.mdi-arrow-expand-right::before {
  content: "\\F797";
}

.mdi-arrow-expand-up::before {
  content: "\\F798";
}

.mdi-arrow-expand-vertical::before {
  content: "\\F84E";
}

.mdi-arrow-horizontal-lock::before {
  content: "\\F0186";
}

.mdi-arrow-left::before {
  content: "\\F04D";
}

.mdi-arrow-left-bold::before {
  content: "\\F730";
}

.mdi-arrow-left-bold-box::before {
  content: "\\F731";
}

.mdi-arrow-left-bold-box-outline::before {
  content: "\\F732";
}

.mdi-arrow-left-bold-circle::before {
  content: "\\F04F";
}

.mdi-arrow-left-bold-circle-outline::before {
  content: "\\F050";
}

.mdi-arrow-left-bold-hexagon-outline::before {
  content: "\\F051";
}

.mdi-arrow-left-bold-outline::before {
  content: "\\F9BF";
}

.mdi-arrow-left-box::before {
  content: "\\F6C0";
}

.mdi-arrow-left-circle::before {
  content: "\\FCB9";
}

.mdi-arrow-left-circle-outline::before {
  content: "\\FCBA";
}

.mdi-arrow-left-drop-circle::before {
  content: "\\F052";
}

.mdi-arrow-left-drop-circle-outline::before {
  content: "\\F053";
}

.mdi-arrow-left-right::before {
  content: "\\FE90";
}

.mdi-arrow-left-right-bold::before {
  content: "\\FE91";
}

.mdi-arrow-left-right-bold-outline::before {
  content: "\\F9C0";
}

.mdi-arrow-left-thick::before {
  content: "\\F04E";
}

.mdi-arrow-right::before {
  content: "\\F054";
}

.mdi-arrow-right-bold::before {
  content: "\\F733";
}

.mdi-arrow-right-bold-box::before {
  content: "\\F734";
}

.mdi-arrow-right-bold-box-outline::before {
  content: "\\F735";
}

.mdi-arrow-right-bold-circle::before {
  content: "\\F056";
}

.mdi-arrow-right-bold-circle-outline::before {
  content: "\\F057";
}

.mdi-arrow-right-bold-hexagon-outline::before {
  content: "\\F058";
}

.mdi-arrow-right-bold-outline::before {
  content: "\\F9C1";
}

.mdi-arrow-right-box::before {
  content: "\\F6C1";
}

.mdi-arrow-right-circle::before {
  content: "\\FCBB";
}

.mdi-arrow-right-circle-outline::before {
  content: "\\FCBC";
}

.mdi-arrow-right-drop-circle::before {
  content: "\\F059";
}

.mdi-arrow-right-drop-circle-outline::before {
  content: "\\F05A";
}

.mdi-arrow-right-thick::before {
  content: "\\F055";
}

.mdi-arrow-split-horizontal::before {
  content: "\\F93A";
}

.mdi-arrow-split-vertical::before {
  content: "\\F93B";
}

.mdi-arrow-top-left::before {
  content: "\\F05B";
}

.mdi-arrow-top-left-bold-outline::before {
  content: "\\F9C2";
}

.mdi-arrow-top-left-bottom-right::before {
  content: "\\FE92";
}

.mdi-arrow-top-left-bottom-right-bold::before {
  content: "\\FE93";
}

.mdi-arrow-top-left-thick::before {
  content: "\\F9C3";
}

.mdi-arrow-top-right::before {
  content: "\\F05C";
}

.mdi-arrow-top-right-bold-outline::before {
  content: "\\F9C4";
}

.mdi-arrow-top-right-bottom-left::before {
  content: "\\FE94";
}

.mdi-arrow-top-right-bottom-left-bold::before {
  content: "\\FE95";
}

.mdi-arrow-top-right-thick::before {
  content: "\\F9C5";
}

.mdi-arrow-up::before {
  content: "\\F05D";
}

.mdi-arrow-up-bold::before {
  content: "\\F736";
}

.mdi-arrow-up-bold-box::before {
  content: "\\F737";
}

.mdi-arrow-up-bold-box-outline::before {
  content: "\\F738";
}

.mdi-arrow-up-bold-circle::before {
  content: "\\F05F";
}

.mdi-arrow-up-bold-circle-outline::before {
  content: "\\F060";
}

.mdi-arrow-up-bold-hexagon-outline::before {
  content: "\\F061";
}

.mdi-arrow-up-bold-outline::before {
  content: "\\F9C6";
}

.mdi-arrow-up-box::before {
  content: "\\F6C2";
}

.mdi-arrow-up-circle::before {
  content: "\\FCBD";
}

.mdi-arrow-up-circle-outline::before {
  content: "\\FCBE";
}

.mdi-arrow-up-down::before {
  content: "\\FE96";
}

.mdi-arrow-up-down-bold::before {
  content: "\\FE97";
}

.mdi-arrow-up-down-bold-outline::before {
  content: "\\F9C7";
}

.mdi-arrow-up-drop-circle::before {
  content: "\\F062";
}

.mdi-arrow-up-drop-circle-outline::before {
  content: "\\F063";
}

.mdi-arrow-up-thick::before {
  content: "\\F05E";
}

.mdi-arrow-vertical-lock::before {
  content: "\\F0187";
}

.mdi-artist::before {
  content: "\\F802";
}

.mdi-artist-outline::before {
  content: "\\FCC5";
}

.mdi-artstation::before {
  content: "\\FB37";
}

.mdi-aspect-ratio::before {
  content: "\\FA23";
}

.mdi-assistant::before {
  content: "\\F064";
}

.mdi-asterisk::before {
  content: "\\F6C3";
}

.mdi-at::before {
  content: "\\F065";
}

.mdi-atlassian::before {
  content: "\\F803";
}

.mdi-atm::before {
  content: "\\FD23";
}

.mdi-atom::before {
  content: "\\F767";
}

.mdi-atom-variant::before {
  content: "\\FE98";
}

.mdi-attachment::before {
  content: "\\F066";
}

.mdi-audio-video::before {
  content: "\\F93C";
}

.mdi-audio-video-off::before {
  content: "\\F01E1";
}

.mdi-audiobook::before {
  content: "\\F067";
}

.mdi-augmented-reality::before {
  content: "\\F84F";
}

.mdi-auto-download::before {
  content: "\\F03A9";
}

.mdi-auto-fix::before {
  content: "\\F068";
}

.mdi-auto-upload::before {
  content: "\\F069";
}

.mdi-autorenew::before {
  content: "\\F06A";
}

.mdi-av-timer::before {
  content: "\\F06B";
}

.mdi-aws::before {
  content: "\\FDF2";
}

.mdi-axe::before {
  content: "\\F8C7";
}

.mdi-axis::before {
  content: "\\FD24";
}

.mdi-axis-arrow::before {
  content: "\\FD25";
}

.mdi-axis-arrow-lock::before {
  content: "\\FD26";
}

.mdi-axis-lock::before {
  content: "\\FD27";
}

.mdi-axis-x-arrow::before {
  content: "\\FD28";
}

.mdi-axis-x-arrow-lock::before {
  content: "\\FD29";
}

.mdi-axis-x-rotate-clockwise::before {
  content: "\\FD2A";
}

.mdi-axis-x-rotate-counterclockwise::before {
  content: "\\FD2B";
}

.mdi-axis-x-y-arrow-lock::before {
  content: "\\FD2C";
}

.mdi-axis-y-arrow::before {
  content: "\\FD2D";
}

.mdi-axis-y-arrow-lock::before {
  content: "\\FD2E";
}

.mdi-axis-y-rotate-clockwise::before {
  content: "\\FD2F";
}

.mdi-axis-y-rotate-counterclockwise::before {
  content: "\\FD30";
}

.mdi-axis-z-arrow::before {
  content: "\\FD31";
}

.mdi-axis-z-arrow-lock::before {
  content: "\\FD32";
}

.mdi-axis-z-rotate-clockwise::before {
  content: "\\FD33";
}

.mdi-axis-z-rotate-counterclockwise::before {
  content: "\\FD34";
}

.mdi-azure::before {
  content: "\\F804";
}

.mdi-azure-devops::before {
  content: "\\F0091";
}

.mdi-babel::before {
  content: "\\FA24";
}

.mdi-baby::before {
  content: "\\F06C";
}

.mdi-baby-bottle::before {
  content: "\\FF56";
}

.mdi-baby-bottle-outline::before {
  content: "\\FF57";
}

.mdi-baby-carriage::before {
  content: "\\F68E";
}

.mdi-baby-carriage-off::before {
  content: "\\FFC0";
}

.mdi-baby-face::before {
  content: "\\FE99";
}

.mdi-baby-face-outline::before {
  content: "\\FE9A";
}

.mdi-backburger::before {
  content: "\\F06D";
}

.mdi-backspace::before {
  content: "\\F06E";
}

.mdi-backspace-outline::before {
  content: "\\FB38";
}

.mdi-backspace-reverse::before {
  content: "\\FE9B";
}

.mdi-backspace-reverse-outline::before {
  content: "\\FE9C";
}

.mdi-backup-restore::before {
  content: "\\F06F";
}

.mdi-bacteria::before {
  content: "\\FEF2";
}

.mdi-bacteria-outline::before {
  content: "\\FEF3";
}

.mdi-badminton::before {
  content: "\\F850";
}

.mdi-bag-carry-on::before {
  content: "\\FF58";
}

.mdi-bag-carry-on-check::before {
  content: "\\FD41";
}

.mdi-bag-carry-on-off::before {
  content: "\\FF59";
}

.mdi-bag-checked::before {
  content: "\\FF5A";
}

.mdi-bag-personal::before {
  content: "\\FDF3";
}

.mdi-bag-personal-off::before {
  content: "\\FDF4";
}

.mdi-bag-personal-off-outline::before {
  content: "\\FDF5";
}

.mdi-bag-personal-outline::before {
  content: "\\FDF6";
}

.mdi-baguette::before {
  content: "\\FF5B";
}

.mdi-balloon::before {
  content: "\\FA25";
}

.mdi-ballot::before {
  content: "\\F9C8";
}

.mdi-ballot-outline::before {
  content: "\\F9C9";
}

.mdi-ballot-recount::before {
  content: "\\FC15";
}

.mdi-ballot-recount-outline::before {
  content: "\\FC16";
}

.mdi-bandage::before {
  content: "\\FD8B";
}

.mdi-bandcamp::before {
  content: "\\F674";
}

.mdi-bank::before {
  content: "\\F070";
}

.mdi-bank-minus::before {
  content: "\\FD8C";
}

.mdi-bank-outline::before {
  content: "\\FE9D";
}

.mdi-bank-plus::before {
  content: "\\FD8D";
}

.mdi-bank-remove::before {
  content: "\\FD8E";
}

.mdi-bank-transfer::before {
  content: "\\FA26";
}

.mdi-bank-transfer-in::before {
  content: "\\FA27";
}

.mdi-bank-transfer-out::before {
  content: "\\FA28";
}

.mdi-barcode::before {
  content: "\\F071";
}

.mdi-barcode-off::before {
  content: "\\F0261";
}

.mdi-barcode-scan::before {
  content: "\\F072";
}

.mdi-barley::before {
  content: "\\F073";
}

.mdi-barley-off::before {
  content: "\\FB39";
}

.mdi-barn::before {
  content: "\\FB3A";
}

.mdi-barrel::before {
  content: "\\F074";
}

.mdi-baseball::before {
  content: "\\F851";
}

.mdi-baseball-bat::before {
  content: "\\F852";
}

.mdi-basecamp::before {
  content: "\\F075";
}

.mdi-bash::before {
  content: "\\F01AE";
}

.mdi-basket::before {
  content: "\\F076";
}

.mdi-basket-fill::before {
  content: "\\F077";
}

.mdi-basket-outline::before {
  content: "\\F01AC";
}

.mdi-basket-unfill::before {
  content: "\\F078";
}

.mdi-basketball::before {
  content: "\\F805";
}

.mdi-basketball-hoop::before {
  content: "\\FC17";
}

.mdi-basketball-hoop-outline::before {
  content: "\\FC18";
}

.mdi-bat::before {
  content: "\\FB3B";
}

.mdi-battery::before {
  content: "\\F079";
}

.mdi-battery-10::before {
  content: "\\F07A";
}

.mdi-battery-10-bluetooth::before {
  content: "\\F93D";
}

.mdi-battery-20::before {
  content: "\\F07B";
}

.mdi-battery-20-bluetooth::before {
  content: "\\F93E";
}

.mdi-battery-30::before {
  content: "\\F07C";
}

.mdi-battery-30-bluetooth::before {
  content: "\\F93F";
}

.mdi-battery-40::before {
  content: "\\F07D";
}

.mdi-battery-40-bluetooth::before {
  content: "\\F940";
}

.mdi-battery-50::before {
  content: "\\F07E";
}

.mdi-battery-50-bluetooth::before {
  content: "\\F941";
}

.mdi-battery-60::before {
  content: "\\F07F";
}

.mdi-battery-60-bluetooth::before {
  content: "\\F942";
}

.mdi-battery-70::before {
  content: "\\F080";
}

.mdi-battery-70-bluetooth::before {
  content: "\\F943";
}

.mdi-battery-80::before {
  content: "\\F081";
}

.mdi-battery-80-bluetooth::before {
  content: "\\F944";
}

.mdi-battery-90::before {
  content: "\\F082";
}

.mdi-battery-90-bluetooth::before {
  content: "\\F945";
}

.mdi-battery-alert::before {
  content: "\\F083";
}

.mdi-battery-alert-bluetooth::before {
  content: "\\F946";
}

.mdi-battery-alert-variant::before {
  content: "\\F00F7";
}

.mdi-battery-alert-variant-outline::before {
  content: "\\F00F8";
}

.mdi-battery-bluetooth::before {
  content: "\\F947";
}

.mdi-battery-bluetooth-variant::before {
  content: "\\F948";
}

.mdi-battery-charging::before {
  content: "\\F084";
}

.mdi-battery-charging-10::before {
  content: "\\F89B";
}

.mdi-battery-charging-100::before {
  content: "\\F085";
}

.mdi-battery-charging-20::before {
  content: "\\F086";
}

.mdi-battery-charging-30::before {
  content: "\\F087";
}

.mdi-battery-charging-40::before {
  content: "\\F088";
}

.mdi-battery-charging-50::before {
  content: "\\F89C";
}

.mdi-battery-charging-60::before {
  content: "\\F089";
}

.mdi-battery-charging-70::before {
  content: "\\F89D";
}

.mdi-battery-charging-80::before {
  content: "\\F08A";
}

.mdi-battery-charging-90::before {
  content: "\\F08B";
}

.mdi-battery-charging-high::before {
  content: "\\F02D1";
}

.mdi-battery-charging-low::before {
  content: "\\F02CF";
}

.mdi-battery-charging-medium::before {
  content: "\\F02D0";
}

.mdi-battery-charging-outline::before {
  content: "\\F89E";
}

.mdi-battery-charging-wireless::before {
  content: "\\F806";
}

.mdi-battery-charging-wireless-10::before {
  content: "\\F807";
}

.mdi-battery-charging-wireless-20::before {
  content: "\\F808";
}

.mdi-battery-charging-wireless-30::before {
  content: "\\F809";
}

.mdi-battery-charging-wireless-40::before {
  content: "\\F80A";
}

.mdi-battery-charging-wireless-50::before {
  content: "\\F80B";
}

.mdi-battery-charging-wireless-60::before {
  content: "\\F80C";
}

.mdi-battery-charging-wireless-70::before {
  content: "\\F80D";
}

.mdi-battery-charging-wireless-80::before {
  content: "\\F80E";
}

.mdi-battery-charging-wireless-90::before {
  content: "\\F80F";
}

.mdi-battery-charging-wireless-alert::before {
  content: "\\F810";
}

.mdi-battery-charging-wireless-outline::before {
  content: "\\F811";
}

.mdi-battery-heart::before {
  content: "\\F023A";
}

.mdi-battery-heart-outline::before {
  content: "\\F023B";
}

.mdi-battery-heart-variant::before {
  content: "\\F023C";
}

.mdi-battery-high::before {
  content: "\\F02CE";
}

.mdi-battery-low::before {
  content: "\\F02CC";
}

.mdi-battery-medium::before {
  content: "\\F02CD";
}

.mdi-battery-minus::before {
  content: "\\F08C";
}

.mdi-battery-negative::before {
  content: "\\F08D";
}

.mdi-battery-off::before {
  content: "\\F0288";
}

.mdi-battery-off-outline::before {
  content: "\\F0289";
}

.mdi-battery-outline::before {
  content: "\\F08E";
}

.mdi-battery-plus::before {
  content: "\\F08F";
}

.mdi-battery-positive::before {
  content: "\\F090";
}

.mdi-battery-unknown::before {
  content: "\\F091";
}

.mdi-battery-unknown-bluetooth::before {
  content: "\\F949";
}

.mdi-battlenet::before {
  content: "\\FB3C";
}

.mdi-beach::before {
  content: "\\F092";
}

.mdi-beaker::before {
  content: "\\FCC6";
}

.mdi-beaker-alert::before {
  content: "\\F0254";
}

.mdi-beaker-alert-outline::before {
  content: "\\F0255";
}

.mdi-beaker-check::before {
  content: "\\F0256";
}

.mdi-beaker-check-outline::before {
  content: "\\F0257";
}

.mdi-beaker-minus::before {
  content: "\\F0258";
}

.mdi-beaker-minus-outline::before {
  content: "\\F0259";
}

.mdi-beaker-outline::before {
  content: "\\F68F";
}

.mdi-beaker-plus::before {
  content: "\\F025A";
}

.mdi-beaker-plus-outline::before {
  content: "\\F025B";
}

.mdi-beaker-question::before {
  content: "\\F025C";
}

.mdi-beaker-question-outline::before {
  content: "\\F025D";
}

.mdi-beaker-remove::before {
  content: "\\F025E";
}

.mdi-beaker-remove-outline::before {
  content: "\\F025F";
}

.mdi-beats::before {
  content: "\\F097";
}

.mdi-bed-double::before {
  content: "\\F0092";
}

.mdi-bed-double-outline::before {
  content: "\\F0093";
}

.mdi-bed-empty::before {
  content: "\\F89F";
}

.mdi-bed-king::before {
  content: "\\F0094";
}

.mdi-bed-king-outline::before {
  content: "\\F0095";
}

.mdi-bed-queen::before {
  content: "\\F0096";
}

.mdi-bed-queen-outline::before {
  content: "\\F0097";
}

.mdi-bed-single::before {
  content: "\\F0098";
}

.mdi-bed-single-outline::before {
  content: "\\F0099";
}

.mdi-bee::before {
  content: "\\FFC1";
}

.mdi-bee-flower::before {
  content: "\\FFC2";
}

.mdi-beehive-outline::before {
  content: "\\F00F9";
}

.mdi-beer::before {
  content: "\\F098";
}

.mdi-beer-outline::before {
  content: "\\F0337";
}

.mdi-behance::before {
  content: "\\F099";
}

.mdi-bell::before {
  content: "\\F09A";
}

.mdi-bell-alert::before {
  content: "\\FD35";
}

.mdi-bell-alert-outline::before {
  content: "\\FE9E";
}

.mdi-bell-check::before {
  content: "\\F0210";
}

.mdi-bell-check-outline::before {
  content: "\\F0211";
}

.mdi-bell-circle::before {
  content: "\\FD36";
}

.mdi-bell-circle-outline::before {
  content: "\\FD37";
}

.mdi-bell-off::before {
  content: "\\F09B";
}

.mdi-bell-off-outline::before {
  content: "\\FA90";
}

.mdi-bell-outline::before {
  content: "\\F09C";
}

.mdi-bell-plus::before {
  content: "\\F09D";
}

.mdi-bell-plus-outline::before {
  content: "\\FA91";
}

.mdi-bell-ring::before {
  content: "\\F09E";
}

.mdi-bell-ring-outline::before {
  content: "\\F09F";
}

.mdi-bell-sleep::before {
  content: "\\F0A0";
}

.mdi-bell-sleep-outline::before {
  content: "\\FA92";
}

.mdi-beta::before {
  content: "\\F0A1";
}

.mdi-betamax::before {
  content: "\\F9CA";
}

.mdi-biathlon::before {
  content: "\\FDF7";
}

.mdi-bible::before {
  content: "\\F0A2";
}

.mdi-bicycle::before {
  content: "\\F00C7";
}

.mdi-bicycle-basket::before {
  content: "\\F0260";
}

.mdi-bike::before {
  content: "\\F0A3";
}

.mdi-bike-fast::before {
  content: "\\F014A";
}

.mdi-billboard::before {
  content: "\\F0032";
}

.mdi-billiards::before {
  content: "\\FB3D";
}

.mdi-billiards-rack::before {
  content: "\\FB3E";
}

.mdi-bing::before {
  content: "\\F0A4";
}

.mdi-binoculars::before {
  content: "\\F0A5";
}

.mdi-bio::before {
  content: "\\F0A6";
}

.mdi-biohazard::before {
  content: "\\F0A7";
}

.mdi-bitbucket::before {
  content: "\\F0A8";
}

.mdi-bitcoin::before {
  content: "\\F812";
}

.mdi-black-mesa::before {
  content: "\\F0A9";
}

.mdi-blackberry::before {
  content: "\\F0AA";
}

.mdi-blender::before {
  content: "\\FCC7";
}

.mdi-blender-software::before {
  content: "\\F0AB";
}

.mdi-blinds::before {
  content: "\\F0AC";
}

.mdi-blinds-open::before {
  content: "\\F0033";
}

.mdi-block-helper::before {
  content: "\\F0AD";
}

.mdi-blogger::before {
  content: "\\F0AE";
}

.mdi-blood-bag::before {
  content: "\\FCC8";
}

.mdi-bluetooth::before {
  content: "\\F0AF";
}

.mdi-bluetooth-audio::before {
  content: "\\F0B0";
}

.mdi-bluetooth-connect::before {
  content: "\\F0B1";
}

.mdi-bluetooth-off::before {
  content: "\\F0B2";
}

.mdi-bluetooth-settings::before {
  content: "\\F0B3";
}

.mdi-bluetooth-transfer::before {
  content: "\\F0B4";
}

.mdi-blur::before {
  content: "\\F0B5";
}

.mdi-blur-linear::before {
  content: "\\F0B6";
}

.mdi-blur-off::before {
  content: "\\F0B7";
}

.mdi-blur-radial::before {
  content: "\\F0B8";
}

.mdi-bolnisi-cross::before {
  content: "\\FCC9";
}

.mdi-bolt::before {
  content: "\\FD8F";
}

.mdi-bomb::before {
  content: "\\F690";
}

.mdi-bomb-off::before {
  content: "\\F6C4";
}

.mdi-bone::before {
  content: "\\F0B9";
}

.mdi-book::before {
  content: "\\F0BA";
}

.mdi-book-information-variant::before {
  content: "\\F009A";
}

.mdi-book-lock::before {
  content: "\\F799";
}

.mdi-book-lock-open::before {
  content: "\\F79A";
}

.mdi-book-minus::before {
  content: "\\F5D9";
}

.mdi-book-minus-multiple::before {
  content: "\\FA93";
}

.mdi-book-multiple::before {
  content: "\\F0BB";
}

.mdi-book-open::before {
  content: "\\F0BD";
}

.mdi-book-open-outline::before {
  content: "\\FB3F";
}

.mdi-book-open-page-variant::before {
  content: "\\F5DA";
}

.mdi-book-open-variant::before {
  content: "\\F0BE";
}

.mdi-book-outline::before {
  content: "\\FB40";
}

.mdi-book-play::before {
  content: "\\FE9F";
}

.mdi-book-play-outline::before {
  content: "\\FEA0";
}

.mdi-book-plus::before {
  content: "\\F5DB";
}

.mdi-book-plus-multiple::before {
  content: "\\FA94";
}

.mdi-book-remove::before {
  content: "\\FA96";
}

.mdi-book-remove-multiple::before {
  content: "\\FA95";
}

.mdi-book-search::before {
  content: "\\FEA1";
}

.mdi-book-search-outline::before {
  content: "\\FEA2";
}

.mdi-book-variant::before {
  content: "\\F0BF";
}

.mdi-book-variant-multiple::before {
  content: "\\F0BC";
}

.mdi-bookmark::before {
  content: "\\F0C0";
}

.mdi-bookmark-check::before {
  content: "\\F0C1";
}

.mdi-bookmark-check-outline::before {
  content: "\\F03A6";
}

.mdi-bookmark-minus::before {
  content: "\\F9CB";
}

.mdi-bookmark-minus-outline::before {
  content: "\\F9CC";
}

.mdi-bookmark-multiple::before {
  content: "\\FDF8";
}

.mdi-bookmark-multiple-outline::before {
  content: "\\FDF9";
}

.mdi-bookmark-music::before {
  content: "\\F0C2";
}

.mdi-bookmark-music-outline::before {
  content: "\\F03A4";
}

.mdi-bookmark-off::before {
  content: "\\F9CD";
}

.mdi-bookmark-off-outline::before {
  content: "\\F9CE";
}

.mdi-bookmark-outline::before {
  content: "\\F0C3";
}

.mdi-bookmark-plus::before {
  content: "\\F0C5";
}

.mdi-bookmark-plus-outline::before {
  content: "\\F0C4";
}

.mdi-bookmark-remove::before {
  content: "\\F0C6";
}

.mdi-bookmark-remove-outline::before {
  content: "\\F03A5";
}

.mdi-bookshelf::before {
  content: "\\F028A";
}

.mdi-boom-gate::before {
  content: "\\FEA3";
}

.mdi-boom-gate-alert::before {
  content: "\\FEA4";
}

.mdi-boom-gate-alert-outline::before {
  content: "\\FEA5";
}

.mdi-boom-gate-down::before {
  content: "\\FEA6";
}

.mdi-boom-gate-down-outline::before {
  content: "\\FEA7";
}

.mdi-boom-gate-outline::before {
  content: "\\FEA8";
}

.mdi-boom-gate-up::before {
  content: "\\FEA9";
}

.mdi-boom-gate-up-outline::before {
  content: "\\FEAA";
}

.mdi-boombox::before {
  content: "\\F5DC";
}

.mdi-boomerang::before {
  content: "\\F00FA";
}

.mdi-bootstrap::before {
  content: "\\F6C5";
}

.mdi-border-all::before {
  content: "\\F0C7";
}

.mdi-border-all-variant::before {
  content: "\\F8A0";
}

.mdi-border-bottom::before {
  content: "\\F0C8";
}

.mdi-border-bottom-variant::before {
  content: "\\F8A1";
}

.mdi-border-color::before {
  content: "\\F0C9";
}

.mdi-border-horizontal::before {
  content: "\\F0CA";
}

.mdi-border-inside::before {
  content: "\\F0CB";
}

.mdi-border-left::before {
  content: "\\F0CC";
}

.mdi-border-left-variant::before {
  content: "\\F8A2";
}

.mdi-border-none::before {
  content: "\\F0CD";
}

.mdi-border-none-variant::before {
  content: "\\F8A3";
}

.mdi-border-outside::before {
  content: "\\F0CE";
}

.mdi-border-right::before {
  content: "\\F0CF";
}

.mdi-border-right-variant::before {
  content: "\\F8A4";
}

.mdi-border-style::before {
  content: "\\F0D0";
}

.mdi-border-top::before {
  content: "\\F0D1";
}

.mdi-border-top-variant::before {
  content: "\\F8A5";
}

.mdi-border-vertical::before {
  content: "\\F0D2";
}

.mdi-bottle-soda::before {
  content: "\\F009B";
}

.mdi-bottle-soda-classic::before {
  content: "\\F009C";
}

.mdi-bottle-soda-classic-outline::before {
  content: "\\F038E";
}

.mdi-bottle-soda-outline::before {
  content: "\\F009D";
}

.mdi-bottle-tonic::before {
  content: "\\F0159";
}

.mdi-bottle-tonic-outline::before {
  content: "\\F015A";
}

.mdi-bottle-tonic-plus::before {
  content: "\\F015B";
}

.mdi-bottle-tonic-plus-outline::before {
  content: "\\F015C";
}

.mdi-bottle-tonic-skull::before {
  content: "\\F015D";
}

.mdi-bottle-tonic-skull-outline::before {
  content: "\\F015E";
}

.mdi-bottle-wine::before {
  content: "\\F853";
}

.mdi-bottle-wine-outline::before {
  content: "\\F033B";
}

.mdi-bow-tie::before {
  content: "\\F677";
}

.mdi-bowl::before {
  content: "\\F617";
}

.mdi-bowling::before {
  content: "\\F0D3";
}

.mdi-box::before {
  content: "\\F0D4";
}

.mdi-box-cutter::before {
  content: "\\F0D5";
}

.mdi-box-shadow::before {
  content: "\\F637";
}

.mdi-boxing-glove::before {
  content: "\\FB41";
}

.mdi-braille::before {
  content: "\\F9CF";
}

.mdi-brain::before {
  content: "\\F9D0";
}

.mdi-bread-slice::before {
  content: "\\FCCA";
}

.mdi-bread-slice-outline::before {
  content: "\\FCCB";
}

.mdi-bridge::before {
  content: "\\F618";
}

.mdi-briefcase::before {
  content: "\\F0D6";
}

.mdi-briefcase-account::before {
  content: "\\FCCC";
}

.mdi-briefcase-account-outline::before {
  content: "\\FCCD";
}

.mdi-briefcase-check::before {
  content: "\\F0D7";
}

.mdi-briefcase-check-outline::before {
  content: "\\F0349";
}

.mdi-briefcase-clock::before {
  content: "\\F00FB";
}

.mdi-briefcase-clock-outline::before {
  content: "\\F00FC";
}

.mdi-briefcase-download::before {
  content: "\\F0D8";
}

.mdi-briefcase-download-outline::before {
  content: "\\FC19";
}

.mdi-briefcase-edit::before {
  content: "\\FA97";
}

.mdi-briefcase-edit-outline::before {
  content: "\\FC1A";
}

.mdi-briefcase-minus::before {
  content: "\\FA29";
}

.mdi-briefcase-minus-outline::before {
  content: "\\FC1B";
}

.mdi-briefcase-outline::before {
  content: "\\F813";
}

.mdi-briefcase-plus::before {
  content: "\\FA2A";
}

.mdi-briefcase-plus-outline::before {
  content: "\\FC1C";
}

.mdi-briefcase-remove::before {
  content: "\\FA2B";
}

.mdi-briefcase-remove-outline::before {
  content: "\\FC1D";
}

.mdi-briefcase-search::before {
  content: "\\FA2C";
}

.mdi-briefcase-search-outline::before {
  content: "\\FC1E";
}

.mdi-briefcase-upload::before {
  content: "\\F0D9";
}

.mdi-briefcase-upload-outline::before {
  content: "\\FC1F";
}

.mdi-brightness-1::before {
  content: "\\F0DA";
}

.mdi-brightness-2::before {
  content: "\\F0DB";
}

.mdi-brightness-3::before {
  content: "\\F0DC";
}

.mdi-brightness-4::before {
  content: "\\F0DD";
}

.mdi-brightness-5::before {
  content: "\\F0DE";
}

.mdi-brightness-6::before {
  content: "\\F0DF";
}

.mdi-brightness-7::before {
  content: "\\F0E0";
}

.mdi-brightness-auto::before {
  content: "\\F0E1";
}

.mdi-brightness-percent::before {
  content: "\\FCCE";
}

.mdi-broom::before {
  content: "\\F0E2";
}

.mdi-brush::before {
  content: "\\F0E3";
}

.mdi-buddhism::before {
  content: "\\F94A";
}

.mdi-buffer::before {
  content: "\\F619";
}

.mdi-bug::before {
  content: "\\F0E4";
}

.mdi-bug-check::before {
  content: "\\FA2D";
}

.mdi-bug-check-outline::before {
  content: "\\FA2E";
}

.mdi-bug-outline::before {
  content: "\\FA2F";
}

.mdi-bugle::before {
  content: "\\FD90";
}

.mdi-bulldozer::before {
  content: "\\FB07";
}

.mdi-bullet::before {
  content: "\\FCCF";
}

.mdi-bulletin-board::before {
  content: "\\F0E5";
}

.mdi-bullhorn::before {
  content: "\\F0E6";
}

.mdi-bullhorn-outline::before {
  content: "\\FB08";
}

.mdi-bullseye::before {
  content: "\\F5DD";
}

.mdi-bullseye-arrow::before {
  content: "\\F8C8";
}

.mdi-bulma::before {
  content: "\\F0312";
}

.mdi-bunk-bed::before {
  content: "\\F032D";
}

.mdi-bus::before {
  content: "\\F0E7";
}

.mdi-bus-alert::before {
  content: "\\FA98";
}

.mdi-bus-articulated-end::before {
  content: "\\F79B";
}

.mdi-bus-articulated-front::before {
  content: "\\F79C";
}

.mdi-bus-clock::before {
  content: "\\F8C9";
}

.mdi-bus-double-decker::before {
  content: "\\F79D";
}

.mdi-bus-marker::before {
  content: "\\F023D";
}

.mdi-bus-multiple::before {
  content: "\\FF5C";
}

.mdi-bus-school::before {
  content: "\\F79E";
}

.mdi-bus-side::before {
  content: "\\F79F";
}

.mdi-bus-stop::before {
  content: "\\F0034";
}

.mdi-bus-stop-covered::before {
  content: "\\F0035";
}

.mdi-bus-stop-uncovered::before {
  content: "\\F0036";
}

.mdi-cached::before {
  content: "\\F0E8";
}

.mdi-cactus::before {
  content: "\\FD91";
}

.mdi-cake::before {
  content: "\\F0E9";
}

.mdi-cake-layered::before {
  content: "\\F0EA";
}

.mdi-cake-variant::before {
  content: "\\F0EB";
}

.mdi-calculator::before {
  content: "\\F0EC";
}

.mdi-calculator-variant::before {
  content: "\\FA99";
}

.mdi-calendar::before {
  content: "\\F0ED";
}

.mdi-calendar-account::before {
  content: "\\FEF4";
}

.mdi-calendar-account-outline::before {
  content: "\\FEF5";
}

.mdi-calendar-alert::before {
  content: "\\FA30";
}

.mdi-calendar-arrow-left::before {
  content: "\\F015F";
}

.mdi-calendar-arrow-right::before {
  content: "\\F0160";
}

.mdi-calendar-blank::before {
  content: "\\F0EE";
}

.mdi-calendar-blank-multiple::before {
  content: "\\F009E";
}

.mdi-calendar-blank-outline::before {
  content: "\\FB42";
}

.mdi-calendar-check::before {
  content: "\\F0EF";
}

.mdi-calendar-check-outline::before {
  content: "\\FC20";
}

.mdi-calendar-clock::before {
  content: "\\F0F0";
}

.mdi-calendar-edit::before {
  content: "\\F8A6";
}

.mdi-calendar-export::before {
  content: "\\FB09";
}

.mdi-calendar-heart::before {
  content: "\\F9D1";
}

.mdi-calendar-import::before {
  content: "\\FB0A";
}

.mdi-calendar-minus::before {
  content: "\\FD38";
}

.mdi-calendar-month::before {
  content: "\\FDFA";
}

.mdi-calendar-month-outline::before {
  content: "\\FDFB";
}

.mdi-calendar-multiple::before {
  content: "\\F0F1";
}

.mdi-calendar-multiple-check::before {
  content: "\\F0F2";
}

.mdi-calendar-multiselect::before {
  content: "\\FA31";
}

.mdi-calendar-outline::before {
  content: "\\FB43";
}

.mdi-calendar-plus::before {
  content: "\\F0F3";
}

.mdi-calendar-question::before {
  content: "\\F691";
}

.mdi-calendar-range::before {
  content: "\\F678";
}

.mdi-calendar-range-outline::before {
  content: "\\FB44";
}

.mdi-calendar-remove::before {
  content: "\\F0F4";
}

.mdi-calendar-remove-outline::before {
  content: "\\FC21";
}

.mdi-calendar-repeat::before {
  content: "\\FEAB";
}

.mdi-calendar-repeat-outline::before {
  content: "\\FEAC";
}

.mdi-calendar-search::before {
  content: "\\F94B";
}

.mdi-calendar-star::before {
  content: "\\F9D2";
}

.mdi-calendar-text::before {
  content: "\\F0F5";
}

.mdi-calendar-text-outline::before {
  content: "\\FC22";
}

.mdi-calendar-today::before {
  content: "\\F0F6";
}

.mdi-calendar-week::before {
  content: "\\FA32";
}

.mdi-calendar-week-begin::before {
  content: "\\FA33";
}

.mdi-calendar-weekend::before {
  content: "\\FEF6";
}

.mdi-calendar-weekend-outline::before {
  content: "\\FEF7";
}

.mdi-call-made::before {
  content: "\\F0F7";
}

.mdi-call-merge::before {
  content: "\\F0F8";
}

.mdi-call-missed::before {
  content: "\\F0F9";
}

.mdi-call-received::before {
  content: "\\F0FA";
}

.mdi-call-split::before {
  content: "\\F0FB";
}

.mdi-camcorder::before {
  content: "\\F0FC";
}

.mdi-camcorder-box::before {
  content: "\\F0FD";
}

.mdi-camcorder-box-off::before {
  content: "\\F0FE";
}

.mdi-camcorder-off::before {
  content: "\\F0FF";
}

.mdi-camera::before {
  content: "\\F100";
}

.mdi-camera-account::before {
  content: "\\F8CA";
}

.mdi-camera-burst::before {
  content: "\\F692";
}

.mdi-camera-control::before {
  content: "\\FB45";
}

.mdi-camera-enhance::before {
  content: "\\F101";
}

.mdi-camera-enhance-outline::before {
  content: "\\FB46";
}

.mdi-camera-front::before {
  content: "\\F102";
}

.mdi-camera-front-variant::before {
  content: "\\F103";
}

.mdi-camera-gopro::before {
  content: "\\F7A0";
}

.mdi-camera-image::before {
  content: "\\F8CB";
}

.mdi-camera-iris::before {
  content: "\\F104";
}

.mdi-camera-metering-center::before {
  content: "\\F7A1";
}

.mdi-camera-metering-matrix::before {
  content: "\\F7A2";
}

.mdi-camera-metering-partial::before {
  content: "\\F7A3";
}

.mdi-camera-metering-spot::before {
  content: "\\F7A4";
}

.mdi-camera-off::before {
  content: "\\F5DF";
}

.mdi-camera-outline::before {
  content: "\\FD39";
}

.mdi-camera-party-mode::before {
  content: "\\F105";
}

.mdi-camera-plus::before {
  content: "\\FEF8";
}

.mdi-camera-plus-outline::before {
  content: "\\FEF9";
}

.mdi-camera-rear::before {
  content: "\\F106";
}

.mdi-camera-rear-variant::before {
  content: "\\F107";
}

.mdi-camera-retake::before {
  content: "\\FDFC";
}

.mdi-camera-retake-outline::before {
  content: "\\FDFD";
}

.mdi-camera-switch::before {
  content: "\\F108";
}

.mdi-camera-timer::before {
  content: "\\F109";
}

.mdi-camera-wireless::before {
  content: "\\FD92";
}

.mdi-camera-wireless-outline::before {
  content: "\\FD93";
}

.mdi-campfire::before {
  content: "\\FEFA";
}

.mdi-cancel::before {
  content: "\\F739";
}

.mdi-candle::before {
  content: "\\F5E2";
}

.mdi-candycane::before {
  content: "\\F10A";
}

.mdi-cannabis::before {
  content: "\\F7A5";
}

.mdi-caps-lock::before {
  content: "\\FA9A";
}

.mdi-car::before {
  content: "\\F10B";
}

.mdi-car-2-plus::before {
  content: "\\F0037";
}

.mdi-car-3-plus::before {
  content: "\\F0038";
}

.mdi-car-back::before {
  content: "\\FDFE";
}

.mdi-car-battery::before {
  content: "\\F10C";
}

.mdi-car-brake-abs::before {
  content: "\\FC23";
}

.mdi-car-brake-alert::before {
  content: "\\FC24";
}

.mdi-car-brake-hold::before {
  content: "\\FD3A";
}

.mdi-car-brake-parking::before {
  content: "\\FD3B";
}

.mdi-car-brake-retarder::before {
  content: "\\F0039";
}

.mdi-car-child-seat::before {
  content: "\\FFC3";
}

.mdi-car-clutch::before {
  content: "\\F003A";
}

.mdi-car-connected::before {
  content: "\\F10D";
}

.mdi-car-convertible::before {
  content: "\\F7A6";
}

.mdi-car-coolant-level::before {
  content: "\\F003B";
}

.mdi-car-cruise-control::before {
  content: "\\FD3C";
}

.mdi-car-defrost-front::before {
  content: "\\FD3D";
}

.mdi-car-defrost-rear::before {
  content: "\\FD3E";
}

.mdi-car-door::before {
  content: "\\FB47";
}

.mdi-car-door-lock::before {
  content: "\\F00C8";
}

.mdi-car-electric::before {
  content: "\\FB48";
}

.mdi-car-esp::before {
  content: "\\FC25";
}

.mdi-car-estate::before {
  content: "\\F7A7";
}

.mdi-car-hatchback::before {
  content: "\\F7A8";
}

.mdi-car-info::before {
  content: "\\F01E9";
}

.mdi-car-key::before {
  content: "\\FB49";
}

.mdi-car-light-dimmed::before {
  content: "\\FC26";
}

.mdi-car-light-fog::before {
  content: "\\FC27";
}

.mdi-car-light-high::before {
  content: "\\FC28";
}

.mdi-car-limousine::before {
  content: "\\F8CC";
}

.mdi-car-multiple::before {
  content: "\\FB4A";
}

.mdi-car-off::before {
  content: "\\FDFF";
}

.mdi-car-parking-lights::before {
  content: "\\FD3F";
}

.mdi-car-pickup::before {
  content: "\\F7A9";
}

.mdi-car-seat::before {
  content: "\\FFC4";
}

.mdi-car-seat-cooler::before {
  content: "\\FFC5";
}

.mdi-car-seat-heater::before {
  content: "\\FFC6";
}

.mdi-car-shift-pattern::before {
  content: "\\FF5D";
}

.mdi-car-side::before {
  content: "\\F7AA";
}

.mdi-car-sports::before {
  content: "\\F7AB";
}

.mdi-car-tire-alert::before {
  content: "\\FC29";
}

.mdi-car-traction-control::before {
  content: "\\FD40";
}

.mdi-car-turbocharger::before {
  content: "\\F003C";
}

.mdi-car-wash::before {
  content: "\\F10E";
}

.mdi-car-windshield::before {
  content: "\\F003D";
}

.mdi-car-windshield-outline::before {
  content: "\\F003E";
}

.mdi-caravan::before {
  content: "\\F7AC";
}

.mdi-card::before {
  content: "\\FB4B";
}

.mdi-card-bulleted::before {
  content: "\\FB4C";
}

.mdi-card-bulleted-off::before {
  content: "\\FB4D";
}

.mdi-card-bulleted-off-outline::before {
  content: "\\FB4E";
}

.mdi-card-bulleted-outline::before {
  content: "\\FB4F";
}

.mdi-card-bulleted-settings::before {
  content: "\\FB50";
}

.mdi-card-bulleted-settings-outline::before {
  content: "\\FB51";
}

.mdi-card-outline::before {
  content: "\\FB52";
}

.mdi-card-plus::before {
  content: "\\F022A";
}

.mdi-card-plus-outline::before {
  content: "\\F022B";
}

.mdi-card-search::before {
  content: "\\F009F";
}

.mdi-card-search-outline::before {
  content: "\\F00A0";
}

.mdi-card-text::before {
  content: "\\FB53";
}

.mdi-card-text-outline::before {
  content: "\\FB54";
}

.mdi-cards::before {
  content: "\\F638";
}

.mdi-cards-club::before {
  content: "\\F8CD";
}

.mdi-cards-diamond::before {
  content: "\\F8CE";
}

.mdi-cards-diamond-outline::before {
  content: "\\F003F";
}

.mdi-cards-heart::before {
  content: "\\F8CF";
}

.mdi-cards-outline::before {
  content: "\\F639";
}

.mdi-cards-playing-outline::before {
  content: "\\F63A";
}

.mdi-cards-spade::before {
  content: "\\F8D0";
}

.mdi-cards-variant::before {
  content: "\\F6C6";
}

.mdi-carrot::before {
  content: "\\F10F";
}

.mdi-cart::before {
  content: "\\F110";
}

.mdi-cart-arrow-down::before {
  content: "\\FD42";
}

.mdi-cart-arrow-right::before {
  content: "\\FC2A";
}

.mdi-cart-arrow-up::before {
  content: "\\FD43";
}

.mdi-cart-minus::before {
  content: "\\FD44";
}

.mdi-cart-off::before {
  content: "\\F66B";
}

.mdi-cart-outline::before {
  content: "\\F111";
}

.mdi-cart-plus::before {
  content: "\\F112";
}

.mdi-cart-remove::before {
  content: "\\FD45";
}

.mdi-case-sensitive-alt::before {
  content: "\\F113";
}

.mdi-cash::before {
  content: "\\F114";
}

.mdi-cash-100::before {
  content: "\\F115";
}

.mdi-cash-marker::before {
  content: "\\FD94";
}

.mdi-cash-minus::before {
  content: "\\F028B";
}

.mdi-cash-multiple::before {
  content: "\\F116";
}

.mdi-cash-plus::before {
  content: "\\F028C";
}

.mdi-cash-refund::before {
  content: "\\FA9B";
}

.mdi-cash-register::before {
  content: "\\FCD0";
}

.mdi-cash-remove::before {
  content: "\\F028D";
}

.mdi-cash-usd::before {
  content: "\\F01A1";
}

.mdi-cash-usd-outline::before {
  content: "\\F117";
}

.mdi-cassette::before {
  content: "\\F9D3";
}

.mdi-cast::before {
  content: "\\F118";
}

.mdi-cast-audio::before {
  content: "\\F0040";
}

.mdi-cast-connected::before {
  content: "\\F119";
}

.mdi-cast-education::before {
  content: "\\FE6D";
}

.mdi-cast-off::before {
  content: "\\F789";
}

.mdi-castle::before {
  content: "\\F11A";
}

.mdi-cat::before {
  content: "\\F11B";
}

.mdi-cctv::before {
  content: "\\F7AD";
}

.mdi-ceiling-light::before {
  content: "\\F768";
}

.mdi-cellphone::before {
  content: "\\F11C";
}

.mdi-cellphone-android::before {
  content: "\\F11D";
}

.mdi-cellphone-arrow-down::before {
  content: "\\F9D4";
}

.mdi-cellphone-basic::before {
  content: "\\F11E";
}

.mdi-cellphone-dock::before {
  content: "\\F11F";
}

.mdi-cellphone-erase::before {
  content: "\\F94C";
}

.mdi-cellphone-information::before {
  content: "\\FF5E";
}

.mdi-cellphone-iphone::before {
  content: "\\F120";
}

.mdi-cellphone-key::before {
  content: "\\F94D";
}

.mdi-cellphone-link::before {
  content: "\\F121";
}

.mdi-cellphone-link-off::before {
  content: "\\F122";
}

.mdi-cellphone-lock::before {
  content: "\\F94E";
}

.mdi-cellphone-message::before {
  content: "\\F8D2";
}

.mdi-cellphone-message-off::before {
  content: "\\F00FD";
}

.mdi-cellphone-nfc::before {
  content: "\\FEAD";
}

.mdi-cellphone-nfc-off::before {
  content: "\\F0303";
}

.mdi-cellphone-off::before {
  content: "\\F94F";
}

.mdi-cellphone-play::before {
  content: "\\F0041";
}

.mdi-cellphone-screenshot::before {
  content: "\\FA34";
}

.mdi-cellphone-settings::before {
  content: "\\F123";
}

.mdi-cellphone-settings-variant::before {
  content: "\\F950";
}

.mdi-cellphone-sound::before {
  content: "\\F951";
}

.mdi-cellphone-text::before {
  content: "\\F8D1";
}

.mdi-cellphone-wireless::before {
  content: "\\F814";
}

.mdi-celtic-cross::before {
  content: "\\FCD1";
}

.mdi-centos::before {
  content: "\\F0145";
}

.mdi-certificate::before {
  content: "\\F124";
}

.mdi-certificate-outline::before {
  content: "\\F01B3";
}

.mdi-chair-rolling::before {
  content: "\\FFBA";
}

.mdi-chair-school::before {
  content: "\\F125";
}

.mdi-charity::before {
  content: "\\FC2B";
}

.mdi-chart-arc::before {
  content: "\\F126";
}

.mdi-chart-areaspline::before {
  content: "\\F127";
}

.mdi-chart-areaspline-variant::before {
  content: "\\FEAE";
}

.mdi-chart-bar::before {
  content: "\\F128";
}

.mdi-chart-bar-stacked::before {
  content: "\\F769";
}

.mdi-chart-bell-curve::before {
  content: "\\FC2C";
}

.mdi-chart-bell-curve-cumulative::before {
  content: "\\FFC7";
}

.mdi-chart-bubble::before {
  content: "\\F5E3";
}

.mdi-chart-donut::before {
  content: "\\F7AE";
}

.mdi-chart-donut-variant::before {
  content: "\\F7AF";
}

.mdi-chart-gantt::before {
  content: "\\F66C";
}

.mdi-chart-histogram::before {
  content: "\\F129";
}

.mdi-chart-line::before {
  content: "\\F12A";
}

.mdi-chart-line-stacked::before {
  content: "\\F76A";
}

.mdi-chart-line-variant::before {
  content: "\\F7B0";
}

.mdi-chart-multiline::before {
  content: "\\F8D3";
}

.mdi-chart-multiple::before {
  content: "\\F023E";
}

.mdi-chart-pie::before {
  content: "\\F12B";
}

.mdi-chart-ppf::before {
  content: "\\F03AB";
}

.mdi-chart-scatter-plot::before {
  content: "\\FEAF";
}

.mdi-chart-scatter-plot-hexbin::before {
  content: "\\F66D";
}

.mdi-chart-snakey::before {
  content: "\\F020A";
}

.mdi-chart-snakey-variant::before {
  content: "\\F020B";
}

.mdi-chart-timeline::before {
  content: "\\F66E";
}

.mdi-chart-timeline-variant::before {
  content: "\\FEB0";
}

.mdi-chart-tree::before {
  content: "\\FEB1";
}

.mdi-chat::before {
  content: "\\FB55";
}

.mdi-chat-alert::before {
  content: "\\FB56";
}

.mdi-chat-alert-outline::before {
  content: "\\F02F4";
}

.mdi-chat-outline::before {
  content: "\\FEFB";
}

.mdi-chat-processing::before {
  content: "\\FB57";
}

.mdi-chat-processing-outline::before {
  content: "\\F02F5";
}

.mdi-chat-sleep::before {
  content: "\\F02FC";
}

.mdi-chat-sleep-outline::before {
  content: "\\F02FD";
}

.mdi-check::before {
  content: "\\F12C";
}

.mdi-check-all::before {
  content: "\\F12D";
}

.mdi-check-bold::before {
  content: "\\FE6E";
}

.mdi-check-box-multiple-outline::before {
  content: "\\FC2D";
}

.mdi-check-box-outline::before {
  content: "\\FC2E";
}

.mdi-check-circle::before {
  content: "\\F5E0";
}

.mdi-check-circle-outline::before {
  content: "\\F5E1";
}

.mdi-check-decagram::before {
  content: "\\F790";
}

.mdi-check-network::before {
  content: "\\FC2F";
}

.mdi-check-network-outline::before {
  content: "\\FC30";
}

.mdi-check-outline::before {
  content: "\\F854";
}

.mdi-check-underline::before {
  content: "\\FE70";
}

.mdi-check-underline-circle::before {
  content: "\\FE71";
}

.mdi-check-underline-circle-outline::before {
  content: "\\FE72";
}

.mdi-checkbook::before {
  content: "\\FA9C";
}

.mdi-checkbox-blank::before {
  content: "\\F12E";
}

.mdi-checkbox-blank-circle::before {
  content: "\\F12F";
}

.mdi-checkbox-blank-circle-outline::before {
  content: "\\F130";
}

.mdi-checkbox-blank-off::before {
  content: "\\F0317";
}

.mdi-checkbox-blank-off-outline::before {
  content: "\\F0318";
}

.mdi-checkbox-blank-outline::before {
  content: "\\F131";
}

.mdi-checkbox-intermediate::before {
  content: "\\F855";
}

.mdi-checkbox-marked::before {
  content: "\\F132";
}

.mdi-checkbox-marked-circle::before {
  content: "\\F133";
}

.mdi-checkbox-marked-circle-outline::before {
  content: "\\F134";
}

.mdi-checkbox-marked-outline::before {
  content: "\\F135";
}

.mdi-checkbox-multiple-blank::before {
  content: "\\F136";
}

.mdi-checkbox-multiple-blank-circle::before {
  content: "\\F63B";
}

.mdi-checkbox-multiple-blank-circle-outline::before {
  content: "\\F63C";
}

.mdi-checkbox-multiple-blank-outline::before {
  content: "\\F137";
}

.mdi-checkbox-multiple-marked::before {
  content: "\\F138";
}

.mdi-checkbox-multiple-marked-circle::before {
  content: "\\F63D";
}

.mdi-checkbox-multiple-marked-circle-outline::before {
  content: "\\F63E";
}

.mdi-checkbox-multiple-marked-outline::before {
  content: "\\F139";
}

.mdi-checkerboard::before {
  content: "\\F13A";
}

.mdi-checkerboard-minus::before {
  content: "\\F022D";
}

.mdi-checkerboard-plus::before {
  content: "\\F022C";
}

.mdi-checkerboard-remove::before {
  content: "\\F022E";
}

.mdi-cheese::before {
  content: "\\F02E4";
}

.mdi-chef-hat::before {
  content: "\\FB58";
}

.mdi-chemical-weapon::before {
  content: "\\F13B";
}

.mdi-chess-bishop::before {
  content: "\\F85B";
}

.mdi-chess-king::before {
  content: "\\F856";
}

.mdi-chess-knight::before {
  content: "\\F857";
}

.mdi-chess-pawn::before {
  content: "\\F858";
}

.mdi-chess-queen::before {
  content: "\\F859";
}

.mdi-chess-rook::before {
  content: "\\F85A";
}

.mdi-chevron-double-down::before {
  content: "\\F13C";
}

.mdi-chevron-double-left::before {
  content: "\\F13D";
}

.mdi-chevron-double-right::before {
  content: "\\F13E";
}

.mdi-chevron-double-up::before {
  content: "\\F13F";
}

.mdi-chevron-down::before {
  content: "\\F140";
}

.mdi-chevron-down-box::before {
  content: "\\F9D5";
}

.mdi-chevron-down-box-outline::before {
  content: "\\F9D6";
}

.mdi-chevron-down-circle::before {
  content: "\\FB0B";
}

.mdi-chevron-down-circle-outline::before {
  content: "\\FB0C";
}

.mdi-chevron-left::before {
  content: "\\F141";
}

.mdi-chevron-left-box::before {
  content: "\\F9D7";
}

.mdi-chevron-left-box-outline::before {
  content: "\\F9D8";
}

.mdi-chevron-left-circle::before {
  content: "\\FB0D";
}

.mdi-chevron-left-circle-outline::before {
  content: "\\FB0E";
}

.mdi-chevron-right::before {
  content: "\\F142";
}

.mdi-chevron-right-box::before {
  content: "\\F9D9";
}

.mdi-chevron-right-box-outline::before {
  content: "\\F9DA";
}

.mdi-chevron-right-circle::before {
  content: "\\FB0F";
}

.mdi-chevron-right-circle-outline::before {
  content: "\\FB10";
}

.mdi-chevron-triple-down::before {
  content: "\\FD95";
}

.mdi-chevron-triple-left::before {
  content: "\\FD96";
}

.mdi-chevron-triple-right::before {
  content: "\\FD97";
}

.mdi-chevron-triple-up::before {
  content: "\\FD98";
}

.mdi-chevron-up::before {
  content: "\\F143";
}

.mdi-chevron-up-box::before {
  content: "\\F9DB";
}

.mdi-chevron-up-box-outline::before {
  content: "\\F9DC";
}

.mdi-chevron-up-circle::before {
  content: "\\FB11";
}

.mdi-chevron-up-circle-outline::before {
  content: "\\FB12";
}

.mdi-chili-hot::before {
  content: "\\F7B1";
}

.mdi-chili-medium::before {
  content: "\\F7B2";
}

.mdi-chili-mild::before {
  content: "\\F7B3";
}

.mdi-chip::before {
  content: "\\F61A";
}

.mdi-christianity::before {
  content: "\\F952";
}

.mdi-christianity-outline::before {
  content: "\\FCD2";
}

.mdi-church::before {
  content: "\\F144";
}

.mdi-cigar::before {
  content: "\\F01B4";
}

.mdi-circle::before {
  content: "\\F764";
}

.mdi-circle-double::before {
  content: "\\FEB2";
}

.mdi-circle-edit-outline::before {
  content: "\\F8D4";
}

.mdi-circle-expand::before {
  content: "\\FEB3";
}

.mdi-circle-medium::before {
  content: "\\F9DD";
}

.mdi-circle-off-outline::before {
  content: "\\F00FE";
}

.mdi-circle-outline::before {
  content: "\\F765";
}

.mdi-circle-slice-1::before {
  content: "\\FA9D";
}

.mdi-circle-slice-2::before {
  content: "\\FA9E";
}

.mdi-circle-slice-3::before {
  content: "\\FA9F";
}

.mdi-circle-slice-4::before {
  content: "\\FAA0";
}

.mdi-circle-slice-5::before {
  content: "\\FAA1";
}

.mdi-circle-slice-6::before {
  content: "\\FAA2";
}

.mdi-circle-slice-7::before {
  content: "\\FAA3";
}

.mdi-circle-slice-8::before {
  content: "\\FAA4";
}

.mdi-circle-small::before {
  content: "\\F9DE";
}

.mdi-circular-saw::before {
  content: "\\FE73";
}

.mdi-cisco-webex::before {
  content: "\\F145";
}

.mdi-city::before {
  content: "\\F146";
}

.mdi-city-variant::before {
  content: "\\FA35";
}

.mdi-city-variant-outline::before {
  content: "\\FA36";
}

.mdi-clipboard::before {
  content: "\\F147";
}

.mdi-clipboard-account::before {
  content: "\\F148";
}

.mdi-clipboard-account-outline::before {
  content: "\\FC31";
}

.mdi-clipboard-alert::before {
  content: "\\F149";
}

.mdi-clipboard-alert-outline::before {
  content: "\\FCD3";
}

.mdi-clipboard-arrow-down::before {
  content: "\\F14A";
}

.mdi-clipboard-arrow-down-outline::before {
  content: "\\FC32";
}

.mdi-clipboard-arrow-left::before {
  content: "\\F14B";
}

.mdi-clipboard-arrow-left-outline::before {
  content: "\\FCD4";
}

.mdi-clipboard-arrow-right::before {
  content: "\\FCD5";
}

.mdi-clipboard-arrow-right-outline::before {
  content: "\\FCD6";
}

.mdi-clipboard-arrow-up::before {
  content: "\\FC33";
}

.mdi-clipboard-arrow-up-outline::before {
  content: "\\FC34";
}

.mdi-clipboard-check::before {
  content: "\\F14C";
}

.mdi-clipboard-check-multiple::before {
  content: "\\F028E";
}

.mdi-clipboard-check-multiple-outline::before {
  content: "\\F028F";
}

.mdi-clipboard-check-outline::before {
  content: "\\F8A7";
}

.mdi-clipboard-file::before {
  content: "\\F0290";
}

.mdi-clipboard-file-outline::before {
  content: "\\F0291";
}

.mdi-clipboard-flow::before {
  content: "\\F6C7";
}

.mdi-clipboard-flow-outline::before {
  content: "\\F0142";
}

.mdi-clipboard-list::before {
  content: "\\F00FF";
}

.mdi-clipboard-list-outline::before {
  content: "\\F0100";
}

.mdi-clipboard-multiple::before {
  content: "\\F0292";
}

.mdi-clipboard-multiple-outline::before {
  content: "\\F0293";
}

.mdi-clipboard-outline::before {
  content: "\\F14D";
}

.mdi-clipboard-play::before {
  content: "\\FC35";
}

.mdi-clipboard-play-multiple::before {
  content: "\\F0294";
}

.mdi-clipboard-play-multiple-outline::before {
  content: "\\F0295";
}

.mdi-clipboard-play-outline::before {
  content: "\\FC36";
}

.mdi-clipboard-plus::before {
  content: "\\F750";
}

.mdi-clipboard-plus-outline::before {
  content: "\\F034A";
}

.mdi-clipboard-pulse::before {
  content: "\\F85C";
}

.mdi-clipboard-pulse-outline::before {
  content: "\\F85D";
}

.mdi-clipboard-text::before {
  content: "\\F14E";
}

.mdi-clipboard-text-multiple::before {
  content: "\\F0296";
}

.mdi-clipboard-text-multiple-outline::before {
  content: "\\F0297";
}

.mdi-clipboard-text-outline::before {
  content: "\\FA37";
}

.mdi-clipboard-text-play::before {
  content: "\\FC37";
}

.mdi-clipboard-text-play-outline::before {
  content: "\\FC38";
}

.mdi-clippy::before {
  content: "\\F14F";
}

.mdi-clock::before {
  content: "\\F953";
}

.mdi-clock-alert::before {
  content: "\\F954";
}

.mdi-clock-alert-outline::before {
  content: "\\F5CE";
}

.mdi-clock-check::before {
  content: "\\FFC8";
}

.mdi-clock-check-outline::before {
  content: "\\FFC9";
}

.mdi-clock-digital::before {
  content: "\\FEB4";
}

.mdi-clock-end::before {
  content: "\\F151";
}

.mdi-clock-fast::before {
  content: "\\F152";
}

.mdi-clock-in::before {
  content: "\\F153";
}

.mdi-clock-out::before {
  content: "\\F154";
}

.mdi-clock-outline::before {
  content: "\\F150";
}

.mdi-clock-start::before {
  content: "\\F155";
}

.mdi-close::before {
  content: "\\F156";
}

.mdi-close-box::before {
  content: "\\F157";
}

.mdi-close-box-multiple::before {
  content: "\\FC39";
}

.mdi-close-box-multiple-outline::before {
  content: "\\FC3A";
}

.mdi-close-box-outline::before {
  content: "\\F158";
}

.mdi-close-circle::before {
  content: "\\F159";
}

.mdi-close-circle-outline::before {
  content: "\\F15A";
}

.mdi-close-network::before {
  content: "\\F15B";
}

.mdi-close-network-outline::before {
  content: "\\FC3B";
}

.mdi-close-octagon::before {
  content: "\\F15C";
}

.mdi-close-octagon-outline::before {
  content: "\\F15D";
}

.mdi-close-outline::before {
  content: "\\F6C8";
}

.mdi-closed-caption::before {
  content: "\\F15E";
}

.mdi-closed-caption-outline::before {
  content: "\\FD99";
}

.mdi-cloud::before {
  content: "\\F15F";
}

.mdi-cloud-alert::before {
  content: "\\F9DF";
}

.mdi-cloud-braces::before {
  content: "\\F7B4";
}

.mdi-cloud-check::before {
  content: "\\F160";
}

.mdi-cloud-check-outline::before {
  content: "\\F02F7";
}

.mdi-cloud-circle::before {
  content: "\\F161";
}

.mdi-cloud-download::before {
  content: "\\F162";
}

.mdi-cloud-download-outline::before {
  content: "\\FB59";
}

.mdi-cloud-lock::before {
  content: "\\F021C";
}

.mdi-cloud-lock-outline::before {
  content: "\\F021D";
}

.mdi-cloud-off-outline::before {
  content: "\\F164";
}

.mdi-cloud-outline::before {
  content: "\\F163";
}

.mdi-cloud-print::before {
  content: "\\F165";
}

.mdi-cloud-print-outline::before {
  content: "\\F166";
}

.mdi-cloud-question::before {
  content: "\\FA38";
}

.mdi-cloud-search::before {
  content: "\\F955";
}

.mdi-cloud-search-outline::before {
  content: "\\F956";
}

.mdi-cloud-sync::before {
  content: "\\F63F";
}

.mdi-cloud-sync-outline::before {
  content: "\\F0301";
}

.mdi-cloud-tags::before {
  content: "\\F7B5";
}

.mdi-cloud-upload::before {
  content: "\\F167";
}

.mdi-cloud-upload-outline::before {
  content: "\\FB5A";
}

.mdi-clover::before {
  content: "\\F815";
}

.mdi-coach-lamp::before {
  content: "\\F0042";
}

.mdi-coat-rack::before {
  content: "\\F00C9";
}

.mdi-code-array::before {
  content: "\\F168";
}

.mdi-code-braces::before {
  content: "\\F169";
}

.mdi-code-braces-box::before {
  content: "\\F0101";
}

.mdi-code-brackets::before {
  content: "\\F16A";
}

.mdi-code-equal::before {
  content: "\\F16B";
}

.mdi-code-greater-than::before {
  content: "\\F16C";
}

.mdi-code-greater-than-or-equal::before {
  content: "\\F16D";
}

.mdi-code-less-than::before {
  content: "\\F16E";
}

.mdi-code-less-than-or-equal::before {
  content: "\\F16F";
}

.mdi-code-not-equal::before {
  content: "\\F170";
}

.mdi-code-not-equal-variant::before {
  content: "\\F171";
}

.mdi-code-parentheses::before {
  content: "\\F172";
}

.mdi-code-parentheses-box::before {
  content: "\\F0102";
}

.mdi-code-string::before {
  content: "\\F173";
}

.mdi-code-tags::before {
  content: "\\F174";
}

.mdi-code-tags-check::before {
  content: "\\F693";
}

.mdi-codepen::before {
  content: "\\F175";
}

.mdi-coffee::before {
  content: "\\F176";
}

.mdi-coffee-maker::before {
  content: "\\F00CA";
}

.mdi-coffee-off::before {
  content: "\\FFCA";
}

.mdi-coffee-off-outline::before {
  content: "\\FFCB";
}

.mdi-coffee-outline::before {
  content: "\\F6C9";
}

.mdi-coffee-to-go::before {
  content: "\\F177";
}

.mdi-coffee-to-go-outline::before {
  content: "\\F0339";
}

.mdi-coffin::before {
  content: "\\FB5B";
}

.mdi-cog-clockwise::before {
  content: "\\F0208";
}

.mdi-cog-counterclockwise::before {
  content: "\\F0209";
}

.mdi-cogs::before {
  content: "\\F8D5";
}

.mdi-coin::before {
  content: "\\F0196";
}

.mdi-coin-outline::before {
  content: "\\F178";
}

.mdi-coins::before {
  content: "\\F694";
}

.mdi-collage::before {
  content: "\\F640";
}

.mdi-collapse-all::before {
  content: "\\FAA5";
}

.mdi-collapse-all-outline::before {
  content: "\\FAA6";
}

.mdi-color-helper::before {
  content: "\\F179";
}

.mdi-comma::before {
  content: "\\FE74";
}

.mdi-comma-box::before {
  content: "\\FE75";
}

.mdi-comma-box-outline::before {
  content: "\\FE76";
}

.mdi-comma-circle::before {
  content: "\\FE77";
}

.mdi-comma-circle-outline::before {
  content: "\\FE78";
}

.mdi-comment::before {
  content: "\\F17A";
}

.mdi-comment-account::before {
  content: "\\F17B";
}

.mdi-comment-account-outline::before {
  content: "\\F17C";
}

.mdi-comment-alert::before {
  content: "\\F17D";
}

.mdi-comment-alert-outline::before {
  content: "\\F17E";
}

.mdi-comment-arrow-left::before {
  content: "\\F9E0";
}

.mdi-comment-arrow-left-outline::before {
  content: "\\F9E1";
}

.mdi-comment-arrow-right::before {
  content: "\\F9E2";
}

.mdi-comment-arrow-right-outline::before {
  content: "\\F9E3";
}

.mdi-comment-check::before {
  content: "\\F17F";
}

.mdi-comment-check-outline::before {
  content: "\\F180";
}

.mdi-comment-edit::before {
  content: "\\F01EA";
}

.mdi-comment-edit-outline::before {
  content: "\\F02EF";
}

.mdi-comment-eye::before {
  content: "\\FA39";
}

.mdi-comment-eye-outline::before {
  content: "\\FA3A";
}

.mdi-comment-multiple::before {
  content: "\\F85E";
}

.mdi-comment-multiple-outline::before {
  content: "\\F181";
}

.mdi-comment-outline::before {
  content: "\\F182";
}

.mdi-comment-plus::before {
  content: "\\F9E4";
}

.mdi-comment-plus-outline::before {
  content: "\\F183";
}

.mdi-comment-processing::before {
  content: "\\F184";
}

.mdi-comment-processing-outline::before {
  content: "\\F185";
}

.mdi-comment-question::before {
  content: "\\F816";
}

.mdi-comment-question-outline::before {
  content: "\\F186";
}

.mdi-comment-quote::before {
  content: "\\F0043";
}

.mdi-comment-quote-outline::before {
  content: "\\F0044";
}

.mdi-comment-remove::before {
  content: "\\F5DE";
}

.mdi-comment-remove-outline::before {
  content: "\\F187";
}

.mdi-comment-search::before {
  content: "\\FA3B";
}

.mdi-comment-search-outline::before {
  content: "\\FA3C";
}

.mdi-comment-text::before {
  content: "\\F188";
}

.mdi-comment-text-multiple::before {
  content: "\\F85F";
}

.mdi-comment-text-multiple-outline::before {
  content: "\\F860";
}

.mdi-comment-text-outline::before {
  content: "\\F189";
}

.mdi-compare::before {
  content: "\\F18A";
}

.mdi-compass::before {
  content: "\\F18B";
}

.mdi-compass-off::before {
  content: "\\FB5C";
}

.mdi-compass-off-outline::before {
  content: "\\FB5D";
}

.mdi-compass-outline::before {
  content: "\\F18C";
}

.mdi-compass-rose::before {
  content: "\\F03AD";
}

.mdi-concourse-ci::before {
  content: "\\F00CB";
}

.mdi-console::before {
  content: "\\F18D";
}

.mdi-console-line::before {
  content: "\\F7B6";
}

.mdi-console-network::before {
  content: "\\F8A8";
}

.mdi-console-network-outline::before {
  content: "\\FC3C";
}

.mdi-consolidate::before {
  content: "\\F0103";
}

.mdi-contact-mail::before {
  content: "\\F18E";
}

.mdi-contact-mail-outline::before {
  content: "\\FEB5";
}

.mdi-contact-phone::before {
  content: "\\FEB6";
}

.mdi-contact-phone-outline::before {
  content: "\\FEB7";
}

.mdi-contactless-payment::before {
  content: "\\FD46";
}

.mdi-contacts::before {
  content: "\\F6CA";
}

.mdi-contain::before {
  content: "\\FA3D";
}

.mdi-contain-end::before {
  content: "\\FA3E";
}

.mdi-contain-start::before {
  content: "\\FA3F";
}

.mdi-content-copy::before {
  content: "\\F18F";
}

.mdi-content-cut::before {
  content: "\\F190";
}

.mdi-content-duplicate::before {
  content: "\\F191";
}

.mdi-content-paste::before {
  content: "\\F192";
}

.mdi-content-save::before {
  content: "\\F193";
}

.mdi-content-save-alert::before {
  content: "\\FF5F";
}

.mdi-content-save-alert-outline::before {
  content: "\\FF60";
}

.mdi-content-save-all::before {
  content: "\\F194";
}

.mdi-content-save-all-outline::before {
  content: "\\FF61";
}

.mdi-content-save-edit::before {
  content: "\\FCD7";
}

.mdi-content-save-edit-outline::before {
  content: "\\FCD8";
}

.mdi-content-save-move::before {
  content: "\\FE79";
}

.mdi-content-save-move-outline::before {
  content: "\\FE7A";
}

.mdi-content-save-outline::before {
  content: "\\F817";
}

.mdi-content-save-settings::before {
  content: "\\F61B";
}

.mdi-content-save-settings-outline::before {
  content: "\\FB13";
}

.mdi-contrast::before {
  content: "\\F195";
}

.mdi-contrast-box::before {
  content: "\\F196";
}

.mdi-contrast-circle::before {
  content: "\\F197";
}

.mdi-controller-classic::before {
  content: "\\FB5E";
}

.mdi-controller-classic-outline::before {
  content: "\\FB5F";
}

.mdi-cookie::before {
  content: "\\F198";
}

.mdi-coolant-temperature::before {
  content: "\\F3C8";
}

.mdi-copyright::before {
  content: "\\F5E6";
}

.mdi-cordova::before {
  content: "\\F957";
}

.mdi-corn::before {
  content: "\\F7B7";
}

.mdi-counter::before {
  content: "\\F199";
}

.mdi-cow::before {
  content: "\\F19A";
}

.mdi-cowboy::before {
  content: "\\FEB8";
}

.mdi-cpu-32-bit::before {
  content: "\\FEFC";
}

.mdi-cpu-64-bit::before {
  content: "\\FEFD";
}

.mdi-crane::before {
  content: "\\F861";
}

.mdi-creation::before {
  content: "\\F1C9";
}

.mdi-creative-commons::before {
  content: "\\FD47";
}

.mdi-credit-card::before {
  content: "\\F0010";
}

.mdi-credit-card-clock::before {
  content: "\\FEFE";
}

.mdi-credit-card-clock-outline::before {
  content: "\\FFBC";
}

.mdi-credit-card-marker::before {
  content: "\\F6A7";
}

.mdi-credit-card-marker-outline::before {
  content: "\\FD9A";
}

.mdi-credit-card-minus::before {
  content: "\\FFCC";
}

.mdi-credit-card-minus-outline::before {
  content: "\\FFCD";
}

.mdi-credit-card-multiple::before {
  content: "\\F0011";
}

.mdi-credit-card-multiple-outline::before {
  content: "\\F19C";
}

.mdi-credit-card-off::before {
  content: "\\F0012";
}

.mdi-credit-card-off-outline::before {
  content: "\\F5E4";
}

.mdi-credit-card-outline::before {
  content: "\\F19B";
}

.mdi-credit-card-plus::before {
  content: "\\F0013";
}

.mdi-credit-card-plus-outline::before {
  content: "\\F675";
}

.mdi-credit-card-refund::before {
  content: "\\F0014";
}

.mdi-credit-card-refund-outline::before {
  content: "\\FAA7";
}

.mdi-credit-card-remove::before {
  content: "\\FFCE";
}

.mdi-credit-card-remove-outline::before {
  content: "\\FFCF";
}

.mdi-credit-card-scan::before {
  content: "\\F0015";
}

.mdi-credit-card-scan-outline::before {
  content: "\\F19D";
}

.mdi-credit-card-settings::before {
  content: "\\F0016";
}

.mdi-credit-card-settings-outline::before {
  content: "\\F8D6";
}

.mdi-credit-card-wireless::before {
  content: "\\F801";
}

.mdi-credit-card-wireless-outline::before {
  content: "\\FD48";
}

.mdi-cricket::before {
  content: "\\FD49";
}

.mdi-crop::before {
  content: "\\F19E";
}

.mdi-crop-free::before {
  content: "\\F19F";
}

.mdi-crop-landscape::before {
  content: "\\F1A0";
}

.mdi-crop-portrait::before {
  content: "\\F1A1";
}

.mdi-crop-rotate::before {
  content: "\\F695";
}

.mdi-crop-square::before {
  content: "\\F1A2";
}

.mdi-crosshairs::before {
  content: "\\F1A3";
}

.mdi-crosshairs-gps::before {
  content: "\\F1A4";
}

.mdi-crosshairs-off::before {
  content: "\\FF62";
}

.mdi-crosshairs-question::before {
  content: "\\F0161";
}

.mdi-crown::before {
  content: "\\F1A5";
}

.mdi-crown-outline::before {
  content: "\\F01FB";
}

.mdi-cryengine::before {
  content: "\\F958";
}

.mdi-crystal-ball::before {
  content: "\\FB14";
}

.mdi-cube::before {
  content: "\\F1A6";
}

.mdi-cube-outline::before {
  content: "\\F1A7";
}

.mdi-cube-scan::before {
  content: "\\FB60";
}

.mdi-cube-send::before {
  content: "\\F1A8";
}

.mdi-cube-unfolded::before {
  content: "\\F1A9";
}

.mdi-cup::before {
  content: "\\F1AA";
}

.mdi-cup-off::before {
  content: "\\F5E5";
}

.mdi-cup-off-outline::before {
  content: "\\F03A8";
}

.mdi-cup-outline::before {
  content: "\\F033A";
}

.mdi-cup-water::before {
  content: "\\F1AB";
}

.mdi-cupboard::before {
  content: "\\FF63";
}

.mdi-cupboard-outline::before {
  content: "\\FF64";
}

.mdi-cupcake::before {
  content: "\\F959";
}

.mdi-curling::before {
  content: "\\F862";
}

.mdi-currency-bdt::before {
  content: "\\F863";
}

.mdi-currency-brl::before {
  content: "\\FB61";
}

.mdi-currency-btc::before {
  content: "\\F1AC";
}

.mdi-currency-cny::before {
  content: "\\F7B9";
}

.mdi-currency-eth::before {
  content: "\\F7BA";
}

.mdi-currency-eur::before {
  content: "\\F1AD";
}

.mdi-currency-eur-off::before {
  content: "\\F0340";
}

.mdi-currency-gbp::before {
  content: "\\F1AE";
}

.mdi-currency-ils::before {
  content: "\\FC3D";
}

.mdi-currency-inr::before {
  content: "\\F1AF";
}

.mdi-currency-jpy::before {
  content: "\\F7BB";
}

.mdi-currency-krw::before {
  content: "\\F7BC";
}

.mdi-currency-kzt::before {
  content: "\\F864";
}

.mdi-currency-ngn::before {
  content: "\\F1B0";
}

.mdi-currency-php::before {
  content: "\\F9E5";
}

.mdi-currency-rial::before {
  content: "\\FEB9";
}

.mdi-currency-rub::before {
  content: "\\F1B1";
}

.mdi-currency-sign::before {
  content: "\\F7BD";
}

.mdi-currency-try::before {
  content: "\\F1B2";
}

.mdi-currency-twd::before {
  content: "\\F7BE";
}

.mdi-currency-usd::before {
  content: "\\F1B3";
}

.mdi-currency-usd-off::before {
  content: "\\F679";
}

.mdi-current-ac::before {
  content: "\\F95A";
}

.mdi-current-dc::before {
  content: "\\F95B";
}

.mdi-cursor-default::before {
  content: "\\F1B4";
}

.mdi-cursor-default-click::before {
  content: "\\FCD9";
}

.mdi-cursor-default-click-outline::before {
  content: "\\FCDA";
}

.mdi-cursor-default-gesture::before {
  content: "\\F0152";
}

.mdi-cursor-default-gesture-outline::before {
  content: "\\F0153";
}

.mdi-cursor-default-outline::before {
  content: "\\F1B5";
}

.mdi-cursor-move::before {
  content: "\\F1B6";
}

.mdi-cursor-pointer::before {
  content: "\\F1B7";
}

.mdi-cursor-text::before {
  content: "\\F5E7";
}

.mdi-database::before {
  content: "\\F1B8";
}

.mdi-database-check::before {
  content: "\\FAA8";
}

.mdi-database-edit::before {
  content: "\\FB62";
}

.mdi-database-export::before {
  content: "\\F95D";
}

.mdi-database-import::before {
  content: "\\F95C";
}

.mdi-database-lock::before {
  content: "\\FAA9";
}

.mdi-database-marker::before {
  content: "\\F0321";
}

.mdi-database-minus::before {
  content: "\\F1B9";
}

.mdi-database-plus::before {
  content: "\\F1BA";
}

.mdi-database-refresh::before {
  content: "\\FCDB";
}

.mdi-database-remove::before {
  content: "\\FCDC";
}

.mdi-database-search::before {
  content: "\\F865";
}

.mdi-database-settings::before {
  content: "\\FCDD";
}

.mdi-death-star::before {
  content: "\\F8D7";
}

.mdi-death-star-variant::before {
  content: "\\F8D8";
}

.mdi-deathly-hallows::before {
  content: "\\FB63";
}

.mdi-debian::before {
  content: "\\F8D9";
}

.mdi-debug-step-into::before {
  content: "\\F1BB";
}

.mdi-debug-step-out::before {
  content: "\\F1BC";
}

.mdi-debug-step-over::before {
  content: "\\F1BD";
}

.mdi-decagram::before {
  content: "\\F76B";
}

.mdi-decagram-outline::before {
  content: "\\F76C";
}

.mdi-decimal::before {
  content: "\\F00CC";
}

.mdi-decimal-comma::before {
  content: "\\F00CD";
}

.mdi-decimal-comma-decrease::before {
  content: "\\F00CE";
}

.mdi-decimal-comma-increase::before {
  content: "\\F00CF";
}

.mdi-decimal-decrease::before {
  content: "\\F1BE";
}

.mdi-decimal-increase::before {
  content: "\\F1BF";
}

.mdi-delete::before {
  content: "\\F1C0";
}

.mdi-delete-alert::before {
  content: "\\F00D0";
}

.mdi-delete-alert-outline::before {
  content: "\\F00D1";
}

.mdi-delete-circle::before {
  content: "\\F682";
}

.mdi-delete-circle-outline::before {
  content: "\\FB64";
}

.mdi-delete-empty::before {
  content: "\\F6CB";
}

.mdi-delete-empty-outline::before {
  content: "\\FEBA";
}

.mdi-delete-forever::before {
  content: "\\F5E8";
}

.mdi-delete-forever-outline::before {
  content: "\\FB65";
}

.mdi-delete-off::before {
  content: "\\F00D2";
}

.mdi-delete-off-outline::before {
  content: "\\F00D3";
}

.mdi-delete-outline::before {
  content: "\\F9E6";
}

.mdi-delete-restore::before {
  content: "\\F818";
}

.mdi-delete-sweep::before {
  content: "\\F5E9";
}

.mdi-delete-sweep-outline::before {
  content: "\\FC3E";
}

.mdi-delete-variant::before {
  content: "\\F1C1";
}

.mdi-delta::before {
  content: "\\F1C2";
}

.mdi-desk::before {
  content: "\\F0264";
}

.mdi-desk-lamp::before {
  content: "\\F95E";
}

.mdi-deskphone::before {
  content: "\\F1C3";
}

.mdi-desktop-classic::before {
  content: "\\F7BF";
}

.mdi-desktop-mac::before {
  content: "\\F1C4";
}

.mdi-desktop-mac-dashboard::before {
  content: "\\F9E7";
}

.mdi-desktop-tower::before {
  content: "\\F1C5";
}

.mdi-desktop-tower-monitor::before {
  content: "\\FAAA";
}

.mdi-details::before {
  content: "\\F1C6";
}

.mdi-dev-to::before {
  content: "\\FD4A";
}

.mdi-developer-board::before {
  content: "\\F696";
}

.mdi-deviantart::before {
  content: "\\F1C7";
}

.mdi-devices::before {
  content: "\\FFD0";
}

.mdi-diabetes::before {
  content: "\\F0151";
}

.mdi-dialpad::before {
  content: "\\F61C";
}

.mdi-diameter::before {
  content: "\\FC3F";
}

.mdi-diameter-outline::before {
  content: "\\FC40";
}

.mdi-diameter-variant::before {
  content: "\\FC41";
}

.mdi-diamond::before {
  content: "\\FB66";
}

.mdi-diamond-outline::before {
  content: "\\FB67";
}

.mdi-diamond-stone::before {
  content: "\\F1C8";
}

.mdi-dice-1::before {
  content: "\\F1CA";
}

.mdi-dice-1-outline::before {
  content: "\\F0175";
}

.mdi-dice-2::before {
  content: "\\F1CB";
}

.mdi-dice-2-outline::before {
  content: "\\F0176";
}

.mdi-dice-3::before {
  content: "\\F1CC";
}

.mdi-dice-3-outline::before {
  content: "\\F0177";
}

.mdi-dice-4::before {
  content: "\\F1CD";
}

.mdi-dice-4-outline::before {
  content: "\\F0178";
}

.mdi-dice-5::before {
  content: "\\F1CE";
}

.mdi-dice-5-outline::before {
  content: "\\F0179";
}

.mdi-dice-6::before {
  content: "\\F1CF";
}

.mdi-dice-6-outline::before {
  content: "\\F017A";
}

.mdi-dice-d10::before {
  content: "\\F017E";
}

.mdi-dice-d10-outline::before {
  content: "\\F76E";
}

.mdi-dice-d12::before {
  content: "\\F017F";
}

.mdi-dice-d12-outline::before {
  content: "\\F866";
}

.mdi-dice-d20::before {
  content: "\\F0180";
}

.mdi-dice-d20-outline::before {
  content: "\\F5EA";
}

.mdi-dice-d4::before {
  content: "\\F017B";
}

.mdi-dice-d4-outline::before {
  content: "\\F5EB";
}

.mdi-dice-d6::before {
  content: "\\F017C";
}

.mdi-dice-d6-outline::before {
  content: "\\F5EC";
}

.mdi-dice-d8::before {
  content: "\\F017D";
}

.mdi-dice-d8-outline::before {
  content: "\\F5ED";
}

.mdi-dice-multiple::before {
  content: "\\F76D";
}

.mdi-dice-multiple-outline::before {
  content: "\\F0181";
}

.mdi-dictionary::before {
  content: "\\F61D";
}

.mdi-digital-ocean::before {
  content: "\\F0262";
}

.mdi-dip-switch::before {
  content: "\\F7C0";
}

.mdi-directions::before {
  content: "\\F1D0";
}

.mdi-directions-fork::before {
  content: "\\F641";
}

.mdi-disc::before {
  content: "\\F5EE";
}

.mdi-disc-alert::before {
  content: "\\F1D1";
}

.mdi-disc-player::before {
  content: "\\F95F";
}

.mdi-discord::before {
  content: "\\F66F";
}

.mdi-dishwasher::before {
  content: "\\FAAB";
}

.mdi-dishwasher-alert::before {
  content: "\\F01E3";
}

.mdi-dishwasher-off::before {
  content: "\\F01E4";
}

.mdi-disqus::before {
  content: "\\F1D2";
}

.mdi-disqus-outline::before {
  content: "\\F1D3";
}

.mdi-distribute-horizontal-center::before {
  content: "\\F01F4";
}

.mdi-distribute-horizontal-left::before {
  content: "\\F01F3";
}

.mdi-distribute-horizontal-right::before {
  content: "\\F01F5";
}

.mdi-distribute-vertical-bottom::before {
  content: "\\F01F6";
}

.mdi-distribute-vertical-center::before {
  content: "\\F01F7";
}

.mdi-distribute-vertical-top::before {
  content: "\\F01F8";
}

.mdi-diving-flippers::before {
  content: "\\FD9B";
}

.mdi-diving-helmet::before {
  content: "\\FD9C";
}

.mdi-diving-scuba::before {
  content: "\\FD9D";
}

.mdi-diving-scuba-flag::before {
  content: "\\FD9E";
}

.mdi-diving-scuba-tank::before {
  content: "\\FD9F";
}

.mdi-diving-scuba-tank-multiple::before {
  content: "\\FDA0";
}

.mdi-diving-snorkel::before {
  content: "\\FDA1";
}

.mdi-division::before {
  content: "\\F1D4";
}

.mdi-division-box::before {
  content: "\\F1D5";
}

.mdi-dlna::before {
  content: "\\FA40";
}

.mdi-dna::before {
  content: "\\F683";
}

.mdi-dns::before {
  content: "\\F1D6";
}

.mdi-dns-outline::before {
  content: "\\FB68";
}

.mdi-do-not-disturb::before {
  content: "\\F697";
}

.mdi-do-not-disturb-off::before {
  content: "\\F698";
}

.mdi-dock-bottom::before {
  content: "\\F00D4";
}

.mdi-dock-left::before {
  content: "\\F00D5";
}

.mdi-dock-right::before {
  content: "\\F00D6";
}

.mdi-dock-window::before {
  content: "\\F00D7";
}

.mdi-docker::before {
  content: "\\F867";
}

.mdi-doctor::before {
  content: "\\FA41";
}

.mdi-dog::before {
  content: "\\FA42";
}

.mdi-dog-service::before {
  content: "\\FAAC";
}

.mdi-dog-side::before {
  content: "\\FA43";
}

.mdi-dolby::before {
  content: "\\F6B2";
}

.mdi-dolly::before {
  content: "\\FEBB";
}

.mdi-domain::before {
  content: "\\F1D7";
}

.mdi-domain-off::before {
  content: "\\FD4B";
}

.mdi-domain-plus::before {
  content: "\\F00D8";
}

.mdi-domain-remove::before {
  content: "\\F00D9";
}

.mdi-domino-mask::before {
  content: "\\F0045";
}

.mdi-donkey::before {
  content: "\\F7C1";
}

.mdi-door::before {
  content: "\\F819";
}

.mdi-door-closed::before {
  content: "\\F81A";
}

.mdi-door-closed-lock::before {
  content: "\\F00DA";
}

.mdi-door-open::before {
  content: "\\F81B";
}

.mdi-doorbell::before {
  content: "\\F0311";
}

.mdi-doorbell-video::before {
  content: "\\F868";
}

.mdi-dot-net::before {
  content: "\\FAAD";
}

.mdi-dots-horizontal::before {
  content: "\\F1D8";
}

.mdi-dots-horizontal-circle::before {
  content: "\\F7C2";
}

.mdi-dots-horizontal-circle-outline::before {
  content: "\\FB69";
}

.mdi-dots-vertical::before {
  content: "\\F1D9";
}

.mdi-dots-vertical-circle::before {
  content: "\\F7C3";
}

.mdi-dots-vertical-circle-outline::before {
  content: "\\FB6A";
}

.mdi-douban::before {
  content: "\\F699";
}

.mdi-download::before {
  content: "\\F1DA";
}

.mdi-download-lock::before {
  content: "\\F034B";
}

.mdi-download-lock-outline::before {
  content: "\\F034C";
}

.mdi-download-multiple::before {
  content: "\\F9E8";
}

.mdi-download-network::before {
  content: "\\F6F3";
}

.mdi-download-network-outline::before {
  content: "\\FC42";
}

.mdi-download-off::before {
  content: "\\F00DB";
}

.mdi-download-off-outline::before {
  content: "\\F00DC";
}

.mdi-download-outline::before {
  content: "\\FB6B";
}

.mdi-drag::before {
  content: "\\F1DB";
}

.mdi-drag-horizontal::before {
  content: "\\F1DC";
}

.mdi-drag-horizontal-variant::before {
  content: "\\F031B";
}

.mdi-drag-variant::before {
  content: "\\FB6C";
}

.mdi-drag-vertical::before {
  content: "\\F1DD";
}

.mdi-drag-vertical-variant::before {
  content: "\\F031C";
}

.mdi-drama-masks::before {
  content: "\\FCDE";
}

.mdi-draw::before {
  content: "\\FF66";
}

.mdi-drawing::before {
  content: "\\F1DE";
}

.mdi-drawing-box::before {
  content: "\\F1DF";
}

.mdi-dresser::before {
  content: "\\FF67";
}

.mdi-dresser-outline::before {
  content: "\\FF68";
}

.mdi-dribbble::before {
  content: "\\F1E0";
}

.mdi-dribbble-box::before {
  content: "\\F1E1";
}

.mdi-drone::before {
  content: "\\F1E2";
}

.mdi-dropbox::before {
  content: "\\F1E3";
}

.mdi-drupal::before {
  content: "\\F1E4";
}

.mdi-duck::before {
  content: "\\F1E5";
}

.mdi-dumbbell::before {
  content: "\\F1E6";
}

.mdi-dump-truck::before {
  content: "\\FC43";
}

.mdi-ear-hearing::before {
  content: "\\F7C4";
}

.mdi-ear-hearing-off::before {
  content: "\\FA44";
}

.mdi-earth::before {
  content: "\\F1E7";
}

.mdi-earth-arrow-right::before {
  content: "\\F033C";
}

.mdi-earth-box::before {
  content: "\\F6CC";
}

.mdi-earth-box-off::before {
  content: "\\F6CD";
}

.mdi-earth-off::before {
  content: "\\F1E8";
}

.mdi-edge::before {
  content: "\\F1E9";
}

.mdi-edge-legacy::before {
  content: "\\F027B";
}

.mdi-egg::before {
  content: "\\FAAE";
}

.mdi-egg-easter::before {
  content: "\\FAAF";
}

.mdi-eight-track::before {
  content: "\\F9E9";
}

.mdi-eject::before {
  content: "\\F1EA";
}

.mdi-eject-outline::before {
  content: "\\FB6D";
}

.mdi-electric-switch::before {
  content: "\\FEBC";
}

.mdi-electric-switch-closed::before {
  content: "\\F0104";
}

.mdi-electron-framework::before {
  content: "\\F0046";
}

.mdi-elephant::before {
  content: "\\F7C5";
}

.mdi-elevation-decline::before {
  content: "\\F1EB";
}

.mdi-elevation-rise::before {
  content: "\\F1EC";
}

.mdi-elevator::before {
  content: "\\F1ED";
}

.mdi-elevator-down::before {
  content: "\\F02ED";
}

.mdi-elevator-passenger::before {
  content: "\\F03AC";
}

.mdi-elevator-up::before {
  content: "\\F02EC";
}

.mdi-ellipse::before {
  content: "\\FEBD";
}

.mdi-ellipse-outline::before {
  content: "\\FEBE";
}

.mdi-email::before {
  content: "\\F1EE";
}

.mdi-email-alert::before {
  content: "\\F6CE";
}

.mdi-email-alert-outline::before {
  content: "\\FD1E";
}

.mdi-email-box::before {
  content: "\\FCDF";
}

.mdi-email-check::before {
  content: "\\FAB0";
}

.mdi-email-check-outline::before {
  content: "\\FAB1";
}

.mdi-email-edit::before {
  content: "\\FF00";
}

.mdi-email-edit-outline::before {
  content: "\\FF01";
}

.mdi-email-lock::before {
  content: "\\F1F1";
}

.mdi-email-mark-as-unread::before {
  content: "\\FB6E";
}

.mdi-email-minus::before {
  content: "\\FF02";
}

.mdi-email-minus-outline::before {
  content: "\\FF03";
}

.mdi-email-multiple::before {
  content: "\\FF04";
}

.mdi-email-multiple-outline::before {
  content: "\\FF05";
}

.mdi-email-newsletter::before {
  content: "\\FFD1";
}

.mdi-email-open::before {
  content: "\\F1EF";
}

.mdi-email-open-multiple::before {
  content: "\\FF06";
}

.mdi-email-open-multiple-outline::before {
  content: "\\FF07";
}

.mdi-email-open-outline::before {
  content: "\\F5EF";
}

.mdi-email-outline::before {
  content: "\\F1F0";
}

.mdi-email-plus::before {
  content: "\\F9EA";
}

.mdi-email-plus-outline::before {
  content: "\\F9EB";
}

.mdi-email-receive::before {
  content: "\\F0105";
}

.mdi-email-receive-outline::before {
  content: "\\F0106";
}

.mdi-email-search::before {
  content: "\\F960";
}

.mdi-email-search-outline::before {
  content: "\\F961";
}

.mdi-email-send::before {
  content: "\\F0107";
}

.mdi-email-send-outline::before {
  content: "\\F0108";
}

.mdi-email-sync::before {
  content: "\\F02F2";
}

.mdi-email-sync-outline::before {
  content: "\\F02F3";
}

.mdi-email-variant::before {
  content: "\\F5F0";
}

.mdi-ember::before {
  content: "\\FB15";
}

.mdi-emby::before {
  content: "\\F6B3";
}

.mdi-emoticon::before {
  content: "\\FC44";
}

.mdi-emoticon-angry::before {
  content: "\\FC45";
}

.mdi-emoticon-angry-outline::before {
  content: "\\FC46";
}

.mdi-emoticon-confused::before {
  content: "\\F0109";
}

.mdi-emoticon-confused-outline::before {
  content: "\\F010A";
}

.mdi-emoticon-cool::before {
  content: "\\FC47";
}

.mdi-emoticon-cool-outline::before {
  content: "\\F1F3";
}

.mdi-emoticon-cry::before {
  content: "\\FC48";
}

.mdi-emoticon-cry-outline::before {
  content: "\\FC49";
}

.mdi-emoticon-dead::before {
  content: "\\FC4A";
}

.mdi-emoticon-dead-outline::before {
  content: "\\F69A";
}

.mdi-emoticon-devil::before {
  content: "\\FC4B";
}

.mdi-emoticon-devil-outline::before {
  content: "\\F1F4";
}

.mdi-emoticon-excited::before {
  content: "\\FC4C";
}

.mdi-emoticon-excited-outline::before {
  content: "\\F69B";
}

.mdi-emoticon-frown::before {
  content: "\\FF69";
}

.mdi-emoticon-frown-outline::before {
  content: "\\FF6A";
}

.mdi-emoticon-happy::before {
  content: "\\FC4D";
}

.mdi-emoticon-happy-outline::before {
  content: "\\F1F5";
}

.mdi-emoticon-kiss::before {
  content: "\\FC4E";
}

.mdi-emoticon-kiss-outline::before {
  content: "\\FC4F";
}

.mdi-emoticon-lol::before {
  content: "\\F023F";
}

.mdi-emoticon-lol-outline::before {
  content: "\\F0240";
}

.mdi-emoticon-neutral::before {
  content: "\\FC50";
}

.mdi-emoticon-neutral-outline::before {
  content: "\\F1F6";
}

.mdi-emoticon-outline::before {
  content: "\\F1F2";
}

.mdi-emoticon-poop::before {
  content: "\\F1F7";
}

.mdi-emoticon-poop-outline::before {
  content: "\\FC51";
}

.mdi-emoticon-sad::before {
  content: "\\FC52";
}

.mdi-emoticon-sad-outline::before {
  content: "\\F1F8";
}

.mdi-emoticon-tongue::before {
  content: "\\F1F9";
}

.mdi-emoticon-tongue-outline::before {
  content: "\\FC53";
}

.mdi-emoticon-wink::before {
  content: "\\FC54";
}

.mdi-emoticon-wink-outline::before {
  content: "\\FC55";
}

.mdi-engine::before {
  content: "\\F1FA";
}

.mdi-engine-off::before {
  content: "\\FA45";
}

.mdi-engine-off-outline::before {
  content: "\\FA46";
}

.mdi-engine-outline::before {
  content: "\\F1FB";
}

.mdi-epsilon::before {
  content: "\\F010B";
}

.mdi-equal::before {
  content: "\\F1FC";
}

.mdi-equal-box::before {
  content: "\\F1FD";
}

.mdi-equalizer::before {
  content: "\\FEBF";
}

.mdi-equalizer-outline::before {
  content: "\\FEC0";
}

.mdi-eraser::before {
  content: "\\F1FE";
}

.mdi-eraser-variant::before {
  content: "\\F642";
}

.mdi-escalator::before {
  content: "\\F1FF";
}

.mdi-escalator-down::before {
  content: "\\F02EB";
}

.mdi-escalator-up::before {
  content: "\\F02EA";
}

.mdi-eslint::before {
  content: "\\FC56";
}

.mdi-et::before {
  content: "\\FAB2";
}

.mdi-ethereum::before {
  content: "\\F869";
}

.mdi-ethernet::before {
  content: "\\F200";
}

.mdi-ethernet-cable::before {
  content: "\\F201";
}

.mdi-ethernet-cable-off::before {
  content: "\\F202";
}

.mdi-etsy::before {
  content: "\\F203";
}

.mdi-ev-station::before {
  content: "\\F5F1";
}

.mdi-eventbrite::before {
  content: "\\F7C6";
}

.mdi-evernote::before {
  content: "\\F204";
}

.mdi-excavator::before {
  content: "\\F0047";
}

.mdi-exclamation::before {
  content: "\\F205";
}

.mdi-exclamation-thick::before {
  content: "\\F0263";
}

.mdi-exit-run::before {
  content: "\\FA47";
}

.mdi-exit-to-app::before {
  content: "\\F206";
}

.mdi-expand-all::before {
  content: "\\FAB3";
}

.mdi-expand-all-outline::before {
  content: "\\FAB4";
}

.mdi-expansion-card::before {
  content: "\\F8AD";
}

.mdi-expansion-card-variant::before {
  content: "\\FFD2";
}

.mdi-exponent::before {
  content: "\\F962";
}

.mdi-exponent-box::before {
  content: "\\F963";
}

.mdi-export::before {
  content: "\\F207";
}

.mdi-export-variant::before {
  content: "\\FB6F";
}

.mdi-eye::before {
  content: "\\F208";
}

.mdi-eye-check::before {
  content: "\\FCE0";
}

.mdi-eye-check-outline::before {
  content: "\\FCE1";
}

.mdi-eye-circle::before {
  content: "\\FB70";
}

.mdi-eye-circle-outline::before {
  content: "\\FB71";
}

.mdi-eye-minus::before {
  content: "\\F0048";
}

.mdi-eye-minus-outline::before {
  content: "\\F0049";
}

.mdi-eye-off::before {
  content: "\\F209";
}

.mdi-eye-off-outline::before {
  content: "\\F6D0";
}

.mdi-eye-outline::before {
  content: "\\F6CF";
}

.mdi-eye-plus::before {
  content: "\\F86A";
}

.mdi-eye-plus-outline::before {
  content: "\\F86B";
}

.mdi-eye-settings::before {
  content: "\\F86C";
}

.mdi-eye-settings-outline::before {
  content: "\\F86D";
}

.mdi-eyedropper::before {
  content: "\\F20A";
}

.mdi-eyedropper-variant::before {
  content: "\\F20B";
}

.mdi-face::before {
  content: "\\F643";
}

.mdi-face-agent::before {
  content: "\\FD4C";
}

.mdi-face-outline::before {
  content: "\\FB72";
}

.mdi-face-profile::before {
  content: "\\F644";
}

.mdi-face-profile-woman::before {
  content: "\\F00A1";
}

.mdi-face-recognition::before {
  content: "\\FC57";
}

.mdi-face-woman::before {
  content: "\\F00A2";
}

.mdi-face-woman-outline::before {
  content: "\\F00A3";
}

.mdi-facebook::before {
  content: "\\F20C";
}

.mdi-facebook-box::before {
  content: "\\F20D";
}

.mdi-facebook-messenger::before {
  content: "\\F20E";
}

.mdi-facebook-workplace::before {
  content: "\\FB16";
}

.mdi-factory::before {
  content: "\\F20F";
}

.mdi-fan::before {
  content: "\\F210";
}

.mdi-fan-off::before {
  content: "\\F81C";
}

.mdi-fast-forward::before {
  content: "\\F211";
}

.mdi-fast-forward-10::before {
  content: "\\FD4D";
}

.mdi-fast-forward-30::before {
  content: "\\FCE2";
}

.mdi-fast-forward-5::before {
  content: "\\F0223";
}

.mdi-fast-forward-outline::before {
  content: "\\F6D1";
}

.mdi-fax::before {
  content: "\\F212";
}

.mdi-feather::before {
  content: "\\F6D2";
}

.mdi-feature-search::before {
  content: "\\FA48";
}

.mdi-feature-search-outline::before {
  content: "\\FA49";
}

.mdi-fedora::before {
  content: "\\F8DA";
}

.mdi-ferris-wheel::before {
  content: "\\FEC1";
}

.mdi-ferry::before {
  content: "\\F213";
}

.mdi-file::before {
  content: "\\F214";
}

.mdi-file-account::before {
  content: "\\F73A";
}

.mdi-file-account-outline::before {
  content: "\\F004A";
}

.mdi-file-alert::before {
  content: "\\FA4A";
}

.mdi-file-alert-outline::before {
  content: "\\FA4B";
}

.mdi-file-cabinet::before {
  content: "\\FAB5";
}

.mdi-file-cad::before {
  content: "\\FF08";
}

.mdi-file-cad-box::before {
  content: "\\FF09";
}

.mdi-file-cancel::before {
  content: "\\FDA2";
}

.mdi-file-cancel-outline::before {
  content: "\\FDA3";
}

.mdi-file-certificate::before {
  content: "\\F01B1";
}

.mdi-file-certificate-outline::before {
  content: "\\F01B2";
}

.mdi-file-chart::before {
  content: "\\F215";
}

.mdi-file-chart-outline::before {
  content: "\\F004B";
}

.mdi-file-check::before {
  content: "\\F216";
}

.mdi-file-check-outline::before {
  content: "\\FE7B";
}

.mdi-file-clock::before {
  content: "\\F030C";
}

.mdi-file-clock-outline::before {
  content: "\\F030D";
}

.mdi-file-cloud::before {
  content: "\\F217";
}

.mdi-file-cloud-outline::before {
  content: "\\F004C";
}

.mdi-file-code::before {
  content: "\\F22E";
}

.mdi-file-code-outline::before {
  content: "\\F004D";
}

.mdi-file-compare::before {
  content: "\\F8A9";
}

.mdi-file-delimited::before {
  content: "\\F218";
}

.mdi-file-delimited-outline::before {
  content: "\\FEC2";
}

.mdi-file-document::before {
  content: "\\F219";
}

.mdi-file-document-box::before {
  content: "\\F21A";
}

.mdi-file-document-box-check::before {
  content: "\\FEC3";
}

.mdi-file-document-box-check-outline::before {
  content: "\\FEC4";
}

.mdi-file-document-box-minus::before {
  content: "\\FEC5";
}

.mdi-file-document-box-minus-outline::before {
  content: "\\FEC6";
}

.mdi-file-document-box-multiple::before {
  content: "\\FAB6";
}

.mdi-file-document-box-multiple-outline::before {
  content: "\\FAB7";
}

.mdi-file-document-box-outline::before {
  content: "\\F9EC";
}

.mdi-file-document-box-plus::before {
  content: "\\FEC7";
}

.mdi-file-document-box-plus-outline::before {
  content: "\\FEC8";
}

.mdi-file-document-box-remove::before {
  content: "\\FEC9";
}

.mdi-file-document-box-remove-outline::before {
  content: "\\FECA";
}

.mdi-file-document-box-search::before {
  content: "\\FECB";
}

.mdi-file-document-box-search-outline::before {
  content: "\\FECC";
}

.mdi-file-document-edit::before {
  content: "\\FDA4";
}

.mdi-file-document-edit-outline::before {
  content: "\\FDA5";
}

.mdi-file-document-outline::before {
  content: "\\F9ED";
}

.mdi-file-download::before {
  content: "\\F964";
}

.mdi-file-download-outline::before {
  content: "\\F965";
}

.mdi-file-edit::before {
  content: "\\F0212";
}

.mdi-file-edit-outline::before {
  content: "\\F0213";
}

.mdi-file-excel::before {
  content: "\\F21B";
}

.mdi-file-excel-box::before {
  content: "\\F21C";
}

.mdi-file-excel-box-outline::before {
  content: "\\F004E";
}

.mdi-file-excel-outline::before {
  content: "\\F004F";
}

.mdi-file-export::before {
  content: "\\F21D";
}

.mdi-file-export-outline::before {
  content: "\\F0050";
}

.mdi-file-eye::before {
  content: "\\FDA6";
}

.mdi-file-eye-outline::before {
  content: "\\FDA7";
}

.mdi-file-find::before {
  content: "\\F21E";
}

.mdi-file-find-outline::before {
  content: "\\FB73";
}

.mdi-file-hidden::before {
  content: "\\F613";
}

.mdi-file-image::before {
  content: "\\F21F";
}

.mdi-file-image-outline::before {
  content: "\\FECD";
}

.mdi-file-import::before {
  content: "\\F220";
}

.mdi-file-import-outline::before {
  content: "\\F0051";
}

.mdi-file-key::before {
  content: "\\F01AF";
}

.mdi-file-key-outline::before {
  content: "\\F01B0";
}

.mdi-file-link::before {
  content: "\\F01A2";
}

.mdi-file-link-outline::before {
  content: "\\F01A3";
}

.mdi-file-lock::before {
  content: "\\F221";
}

.mdi-file-lock-outline::before {
  content: "\\F0052";
}

.mdi-file-move::before {
  content: "\\FAB8";
}

.mdi-file-move-outline::before {
  content: "\\F0053";
}

.mdi-file-multiple::before {
  content: "\\F222";
}

.mdi-file-multiple-outline::before {
  content: "\\F0054";
}

.mdi-file-music::before {
  content: "\\F223";
}

.mdi-file-music-outline::before {
  content: "\\FE7C";
}

.mdi-file-outline::before {
  content: "\\F224";
}

.mdi-file-pdf::before {
  content: "\\F225";
}

.mdi-file-pdf-box::before {
  content: "\\F226";
}

.mdi-file-pdf-box-outline::before {
  content: "\\FFD3";
}

.mdi-file-pdf-outline::before {
  content: "\\FE7D";
}

.mdi-file-percent::before {
  content: "\\F81D";
}

.mdi-file-percent-outline::before {
  content: "\\F0055";
}

.mdi-file-phone::before {
  content: "\\F01A4";
}

.mdi-file-phone-outline::before {
  content: "\\F01A5";
}

.mdi-file-plus::before {
  content: "\\F751";
}

.mdi-file-plus-outline::before {
  content: "\\FF0A";
}

.mdi-file-powerpoint::before {
  content: "\\F227";
}

.mdi-file-powerpoint-box::before {
  content: "\\F228";
}

.mdi-file-powerpoint-box-outline::before {
  content: "\\F0056";
}

.mdi-file-powerpoint-outline::before {
  content: "\\F0057";
}

.mdi-file-presentation-box::before {
  content: "\\F229";
}

.mdi-file-question::before {
  content: "\\F86E";
}

.mdi-file-question-outline::before {
  content: "\\F0058";
}

.mdi-file-remove::before {
  content: "\\FB74";
}

.mdi-file-remove-outline::before {
  content: "\\F0059";
}

.mdi-file-replace::before {
  content: "\\FB17";
}

.mdi-file-replace-outline::before {
  content: "\\FB18";
}

.mdi-file-restore::before {
  content: "\\F670";
}

.mdi-file-restore-outline::before {
  content: "\\F005A";
}

.mdi-file-search::before {
  content: "\\FC58";
}

.mdi-file-search-outline::before {
  content: "\\FC59";
}

.mdi-file-send::before {
  content: "\\F22A";
}

.mdi-file-send-outline::before {
  content: "\\F005B";
}

.mdi-file-settings::before {
  content: "\\F00A4";
}

.mdi-file-settings-outline::before {
  content: "\\F00A5";
}

.mdi-file-settings-variant::before {
  content: "\\F00A6";
}

.mdi-file-settings-variant-outline::before {
  content: "\\F00A7";
}

.mdi-file-star::before {
  content: "\\F005C";
}

.mdi-file-star-outline::before {
  content: "\\F005D";
}

.mdi-file-swap::before {
  content: "\\FFD4";
}

.mdi-file-swap-outline::before {
  content: "\\FFD5";
}

.mdi-file-sync::before {
  content: "\\F0241";
}

.mdi-file-sync-outline::before {
  content: "\\F0242";
}

.mdi-file-table::before {
  content: "\\FC5A";
}

.mdi-file-table-box::before {
  content: "\\F010C";
}

.mdi-file-table-box-multiple::before {
  content: "\\F010D";
}

.mdi-file-table-box-multiple-outline::before {
  content: "\\F010E";
}

.mdi-file-table-box-outline::before {
  content: "\\F010F";
}

.mdi-file-table-outline::before {
  content: "\\FC5B";
}

.mdi-file-tree::before {
  content: "\\F645";
}

.mdi-file-undo::before {
  content: "\\F8DB";
}

.mdi-file-undo-outline::before {
  content: "\\F005E";
}

.mdi-file-upload::before {
  content: "\\FA4C";
}

.mdi-file-upload-outline::before {
  content: "\\FA4D";
}

.mdi-file-video::before {
  content: "\\F22B";
}

.mdi-file-video-outline::before {
  content: "\\FE10";
}

.mdi-file-word::before {
  content: "\\F22C";
}

.mdi-file-word-box::before {
  content: "\\F22D";
}

.mdi-file-word-box-outline::before {
  content: "\\F005F";
}

.mdi-file-word-outline::before {
  content: "\\F0060";
}

.mdi-film::before {
  content: "\\F22F";
}

.mdi-filmstrip::before {
  content: "\\F230";
}

.mdi-filmstrip-off::before {
  content: "\\F231";
}

.mdi-filter::before {
  content: "\\F232";
}

.mdi-filter-menu::before {
  content: "\\F0110";
}

.mdi-filter-menu-outline::before {
  content: "\\F0111";
}

.mdi-filter-minus::before {
  content: "\\FF0B";
}

.mdi-filter-minus-outline::before {
  content: "\\FF0C";
}

.mdi-filter-outline::before {
  content: "\\F233";
}

.mdi-filter-plus::before {
  content: "\\FF0D";
}

.mdi-filter-plus-outline::before {
  content: "\\FF0E";
}

.mdi-filter-remove::before {
  content: "\\F234";
}

.mdi-filter-remove-outline::before {
  content: "\\F235";
}

.mdi-filter-variant::before {
  content: "\\F236";
}

.mdi-filter-variant-minus::before {
  content: "\\F013D";
}

.mdi-filter-variant-plus::before {
  content: "\\F013E";
}

.mdi-filter-variant-remove::before {
  content: "\\F0061";
}

.mdi-finance::before {
  content: "\\F81E";
}

.mdi-find-replace::before {
  content: "\\F6D3";
}

.mdi-fingerprint::before {
  content: "\\F237";
}

.mdi-fingerprint-off::before {
  content: "\\FECE";
}

.mdi-fire::before {
  content: "\\F238";
}

.mdi-fire-extinguisher::before {
  content: "\\FF0F";
}

.mdi-fire-hydrant::before {
  content: "\\F0162";
}

.mdi-fire-hydrant-alert::before {
  content: "\\F0163";
}

.mdi-fire-hydrant-off::before {
  content: "\\F0164";
}

.mdi-fire-truck::before {
  content: "\\F8AA";
}

.mdi-firebase::before {
  content: "\\F966";
}

.mdi-firefox::before {
  content: "\\F239";
}

.mdi-fireplace::before {
  content: "\\FE11";
}

.mdi-fireplace-off::before {
  content: "\\FE12";
}

.mdi-firework::before {
  content: "\\FE13";
}

.mdi-fish::before {
  content: "\\F23A";
}

.mdi-fishbowl::before {
  content: "\\FF10";
}

.mdi-fishbowl-outline::before {
  content: "\\FF11";
}

.mdi-fit-to-page::before {
  content: "\\FF12";
}

.mdi-fit-to-page-outline::before {
  content: "\\FF13";
}

.mdi-flag::before {
  content: "\\F23B";
}

.mdi-flag-checkered::before {
  content: "\\F23C";
}

.mdi-flag-minus::before {
  content: "\\FB75";
}

.mdi-flag-minus-outline::before {
  content: "\\F00DD";
}

.mdi-flag-outline::before {
  content: "\\F23D";
}

.mdi-flag-plus::before {
  content: "\\FB76";
}

.mdi-flag-plus-outline::before {
  content: "\\F00DE";
}

.mdi-flag-remove::before {
  content: "\\FB77";
}

.mdi-flag-remove-outline::before {
  content: "\\F00DF";
}

.mdi-flag-triangle::before {
  content: "\\F23F";
}

.mdi-flag-variant::before {
  content: "\\F240";
}

.mdi-flag-variant-outline::before {
  content: "\\F23E";
}

.mdi-flare::before {
  content: "\\FD4E";
}

.mdi-flash::before {
  content: "\\F241";
}

.mdi-flash-alert::before {
  content: "\\FF14";
}

.mdi-flash-alert-outline::before {
  content: "\\FF15";
}

.mdi-flash-auto::before {
  content: "\\F242";
}

.mdi-flash-circle::before {
  content: "\\F81F";
}

.mdi-flash-off::before {
  content: "\\F243";
}

.mdi-flash-outline::before {
  content: "\\F6D4";
}

.mdi-flash-red-eye::before {
  content: "\\F67A";
}

.mdi-flashlight::before {
  content: "\\F244";
}

.mdi-flashlight-off::before {
  content: "\\F245";
}

.mdi-flask::before {
  content: "\\F093";
}

.mdi-flask-empty::before {
  content: "\\F094";
}

.mdi-flask-empty-minus::before {
  content: "\\F0265";
}

.mdi-flask-empty-minus-outline::before {
  content: "\\F0266";
}

.mdi-flask-empty-outline::before {
  content: "\\F095";
}

.mdi-flask-empty-plus::before {
  content: "\\F0267";
}

.mdi-flask-empty-plus-outline::before {
  content: "\\F0268";
}

.mdi-flask-empty-remove::before {
  content: "\\F0269";
}

.mdi-flask-empty-remove-outline::before {
  content: "\\F026A";
}

.mdi-flask-minus::before {
  content: "\\F026B";
}

.mdi-flask-minus-outline::before {
  content: "\\F026C";
}

.mdi-flask-outline::before {
  content: "\\F096";
}

.mdi-flask-plus::before {
  content: "\\F026D";
}

.mdi-flask-plus-outline::before {
  content: "\\F026E";
}

.mdi-flask-remove::before {
  content: "\\F026F";
}

.mdi-flask-remove-outline::before {
  content: "\\F0270";
}

.mdi-flask-round-bottom::before {
  content: "\\F0276";
}

.mdi-flask-round-bottom-empty::before {
  content: "\\F0277";
}

.mdi-flask-round-bottom-empty-outline::before {
  content: "\\F0278";
}

.mdi-flask-round-bottom-outline::before {
  content: "\\F0279";
}

.mdi-flattr::before {
  content: "\\F246";
}

.mdi-fleur-de-lis::before {
  content: "\\F032E";
}

.mdi-flickr::before {
  content: "\\FCE3";
}

.mdi-flip-horizontal::before {
  content: "\\F0112";
}

.mdi-flip-to-back::before {
  content: "\\F247";
}

.mdi-flip-to-front::before {
  content: "\\F248";
}

.mdi-flip-vertical::before {
  content: "\\F0113";
}

.mdi-floor-lamp::before {
  content: "\\F8DC";
}

.mdi-floor-lamp-dual::before {
  content: "\\F0062";
}

.mdi-floor-lamp-variant::before {
  content: "\\F0063";
}

.mdi-floor-plan::before {
  content: "\\F820";
}

.mdi-floppy::before {
  content: "\\F249";
}

.mdi-floppy-variant::before {
  content: "\\F9EE";
}

.mdi-flower::before {
  content: "\\F24A";
}

.mdi-flower-outline::before {
  content: "\\F9EF";
}

.mdi-flower-poppy::before {
  content: "\\FCE4";
}

.mdi-flower-tulip::before {
  content: "\\F9F0";
}

.mdi-flower-tulip-outline::before {
  content: "\\F9F1";
}

.mdi-focus-auto::before {
  content: "\\FF6B";
}

.mdi-focus-field::before {
  content: "\\FF6C";
}

.mdi-focus-field-horizontal::before {
  content: "\\FF6D";
}

.mdi-focus-field-vertical::before {
  content: "\\FF6E";
}

.mdi-folder::before {
  content: "\\F24B";
}

.mdi-folder-account::before {
  content: "\\F24C";
}

.mdi-folder-account-outline::before {
  content: "\\FB78";
}

.mdi-folder-alert::before {
  content: "\\FDA8";
}

.mdi-folder-alert-outline::before {
  content: "\\FDA9";
}

.mdi-folder-clock::before {
  content: "\\FAB9";
}

.mdi-folder-clock-outline::before {
  content: "\\FABA";
}

.mdi-folder-download::before {
  content: "\\F24D";
}

.mdi-folder-download-outline::before {
  content: "\\F0114";
}

.mdi-folder-edit::before {
  content: "\\F8DD";
}

.mdi-folder-edit-outline::before {
  content: "\\FDAA";
}

.mdi-folder-google-drive::before {
  content: "\\F24E";
}

.mdi-folder-heart::before {
  content: "\\F0115";
}

.mdi-folder-heart-outline::before {
  content: "\\F0116";
}

.mdi-folder-home::before {
  content: "\\F00E0";
}

.mdi-folder-home-outline::before {
  content: "\\F00E1";
}

.mdi-folder-image::before {
  content: "\\F24F";
}

.mdi-folder-information::before {
  content: "\\F00E2";
}

.mdi-folder-information-outline::before {
  content: "\\F00E3";
}

.mdi-folder-key::before {
  content: "\\F8AB";
}

.mdi-folder-key-network::before {
  content: "\\F8AC";
}

.mdi-folder-key-network-outline::before {
  content: "\\FC5C";
}

.mdi-folder-key-outline::before {
  content: "\\F0117";
}

.mdi-folder-lock::before {
  content: "\\F250";
}

.mdi-folder-lock-open::before {
  content: "\\F251";
}

.mdi-folder-marker::before {
  content: "\\F0298";
}

.mdi-folder-marker-outline::before {
  content: "\\F0299";
}

.mdi-folder-move::before {
  content: "\\F252";
}

.mdi-folder-move-outline::before {
  content: "\\F0271";
}

.mdi-folder-multiple::before {
  content: "\\F253";
}

.mdi-folder-multiple-image::before {
  content: "\\F254";
}

.mdi-folder-multiple-outline::before {
  content: "\\F255";
}

.mdi-folder-music::before {
  content: "\\F0384";
}

.mdi-folder-music-outline::before {
  content: "\\F0385";
}

.mdi-folder-network::before {
  content: "\\F86F";
}

.mdi-folder-network-outline::before {
  content: "\\FC5D";
}

.mdi-folder-open::before {
  content: "\\F76F";
}

.mdi-folder-open-outline::before {
  content: "\\FDAB";
}

.mdi-folder-outline::before {
  content: "\\F256";
}

.mdi-folder-plus::before {
  content: "\\F257";
}

.mdi-folder-plus-outline::before {
  content: "\\FB79";
}

.mdi-folder-pound::before {
  content: "\\FCE5";
}

.mdi-folder-pound-outline::before {
  content: "\\FCE6";
}

.mdi-folder-remove::before {
  content: "\\F258";
}

.mdi-folder-remove-outline::before {
  content: "\\FB7A";
}

.mdi-folder-search::before {
  content: "\\F967";
}

.mdi-folder-search-outline::before {
  content: "\\F968";
}

.mdi-folder-settings::before {
  content: "\\F00A8";
}

.mdi-folder-settings-outline::before {
  content: "\\F00A9";
}

.mdi-folder-settings-variant::before {
  content: "\\F00AA";
}

.mdi-folder-settings-variant-outline::before {
  content: "\\F00AB";
}

.mdi-folder-star::before {
  content: "\\F69C";
}

.mdi-folder-star-outline::before {
  content: "\\FB7B";
}

.mdi-folder-swap::before {
  content: "\\FFD6";
}

.mdi-folder-swap-outline::before {
  content: "\\FFD7";
}

.mdi-folder-sync::before {
  content: "\\FCE7";
}

.mdi-folder-sync-outline::before {
  content: "\\FCE8";
}

.mdi-folder-table::before {
  content: "\\F030E";
}

.mdi-folder-table-outline::before {
  content: "\\F030F";
}

.mdi-folder-text::before {
  content: "\\FC5E";
}

.mdi-folder-text-outline::before {
  content: "\\FC5F";
}

.mdi-folder-upload::before {
  content: "\\F259";
}

.mdi-folder-upload-outline::before {
  content: "\\F0118";
}

.mdi-folder-zip::before {
  content: "\\F6EA";
}

.mdi-folder-zip-outline::before {
  content: "\\F7B8";
}

.mdi-font-awesome::before {
  content: "\\F03A";
}

.mdi-food::before {
  content: "\\F25A";
}

.mdi-food-apple::before {
  content: "\\F25B";
}

.mdi-food-apple-outline::before {
  content: "\\FC60";
}

.mdi-food-croissant::before {
  content: "\\F7C7";
}

.mdi-food-fork-drink::before {
  content: "\\F5F2";
}

.mdi-food-off::before {
  content: "\\F5F3";
}

.mdi-food-variant::before {
  content: "\\F25C";
}

.mdi-foot-print::before {
  content: "\\FF6F";
}

.mdi-football::before {
  content: "\\F25D";
}

.mdi-football-australian::before {
  content: "\\F25E";
}

.mdi-football-helmet::before {
  content: "\\F25F";
}

.mdi-forklift::before {
  content: "\\F7C8";
}

.mdi-format-align-bottom::before {
  content: "\\F752";
}

.mdi-format-align-center::before {
  content: "\\F260";
}

.mdi-format-align-justify::before {
  content: "\\F261";
}

.mdi-format-align-left::before {
  content: "\\F262";
}

.mdi-format-align-middle::before {
  content: "\\F753";
}

.mdi-format-align-right::before {
  content: "\\F263";
}

.mdi-format-align-top::before {
  content: "\\F754";
}

.mdi-format-annotation-minus::before {
  content: "\\FABB";
}

.mdi-format-annotation-plus::before {
  content: "\\F646";
}

.mdi-format-bold::before {
  content: "\\F264";
}

.mdi-format-clear::before {
  content: "\\F265";
}

.mdi-format-color-fill::before {
  content: "\\F266";
}

.mdi-format-color-highlight::before {
  content: "\\FE14";
}

.mdi-format-color-marker-cancel::before {
  content: "\\F033E";
}

.mdi-format-color-text::before {
  content: "\\F69D";
}

.mdi-format-columns::before {
  content: "\\F8DE";
}

.mdi-format-float-center::before {
  content: "\\F267";
}

.mdi-format-float-left::before {
  content: "\\F268";
}

.mdi-format-float-none::before {
  content: "\\F269";
}

.mdi-format-float-right::before {
  content: "\\F26A";
}

.mdi-format-font::before {
  content: "\\F6D5";
}

.mdi-format-font-size-decrease::before {
  content: "\\F9F2";
}

.mdi-format-font-size-increase::before {
  content: "\\F9F3";
}

.mdi-format-header-1::before {
  content: "\\F26B";
}

.mdi-format-header-2::before {
  content: "\\F26C";
}

.mdi-format-header-3::before {
  content: "\\F26D";
}

.mdi-format-header-4::before {
  content: "\\F26E";
}

.mdi-format-header-5::before {
  content: "\\F26F";
}

.mdi-format-header-6::before {
  content: "\\F270";
}

.mdi-format-header-decrease::before {
  content: "\\F271";
}

.mdi-format-header-equal::before {
  content: "\\F272";
}

.mdi-format-header-increase::before {
  content: "\\F273";
}

.mdi-format-header-pound::before {
  content: "\\F274";
}

.mdi-format-horizontal-align-center::before {
  content: "\\F61E";
}

.mdi-format-horizontal-align-left::before {
  content: "\\F61F";
}

.mdi-format-horizontal-align-right::before {
  content: "\\F620";
}

.mdi-format-indent-decrease::before {
  content: "\\F275";
}

.mdi-format-indent-increase::before {
  content: "\\F276";
}

.mdi-format-italic::before {
  content: "\\F277";
}

.mdi-format-letter-case::before {
  content: "\\FB19";
}

.mdi-format-letter-case-lower::before {
  content: "\\FB1A";
}

.mdi-format-letter-case-upper::before {
  content: "\\FB1B";
}

.mdi-format-letter-ends-with::before {
  content: "\\FFD8";
}

.mdi-format-letter-matches::before {
  content: "\\FFD9";
}

.mdi-format-letter-starts-with::before {
  content: "\\FFDA";
}

.mdi-format-line-spacing::before {
  content: "\\F278";
}

.mdi-format-line-style::before {
  content: "\\F5C8";
}

.mdi-format-line-weight::before {
  content: "\\F5C9";
}

.mdi-format-list-bulleted::before {
  content: "\\F279";
}

.mdi-format-list-bulleted-square::before {
  content: "\\FDAC";
}

.mdi-format-list-bulleted-triangle::before {
  content: "\\FECF";
}

.mdi-format-list-bulleted-type::before {
  content: "\\F27A";
}

.mdi-format-list-checkbox::before {
  content: "\\F969";
}

.mdi-format-list-checks::before {
  content: "\\F755";
}

.mdi-format-list-numbered::before {
  content: "\\F27B";
}

.mdi-format-list-numbered-rtl::before {
  content: "\\FCE9";
}

.mdi-format-list-text::before {
  content: "\\F029A";
}

.mdi-format-overline::before {
  content: "\\FED0";
}

.mdi-format-page-break::before {
  content: "\\F6D6";
}

.mdi-format-paint::before {
  content: "\\F27C";
}

.mdi-format-paragraph::before {
  content: "\\F27D";
}

.mdi-format-pilcrow::before {
  content: "\\F6D7";
}

.mdi-format-quote-close::before {
  content: "\\F27E";
}

.mdi-format-quote-close-outline::before {
  content: "\\F01D3";
}

.mdi-format-quote-open::before {
  content: "\\F756";
}

.mdi-format-quote-open-outline::before {
  content: "\\F01D2";
}

.mdi-format-rotate-90::before {
  content: "\\F6A9";
}

.mdi-format-section::before {
  content: "\\F69E";
}

.mdi-format-size::before {
  content: "\\F27F";
}

.mdi-format-strikethrough::before {
  content: "\\F280";
}

.mdi-format-strikethrough-variant::before {
  content: "\\F281";
}

.mdi-format-subscript::before {
  content: "\\F282";
}

.mdi-format-superscript::before {
  content: "\\F283";
}

.mdi-format-text::before {
  content: "\\F284";
}

.mdi-format-text-rotation-angle-down::before {
  content: "\\FFDB";
}

.mdi-format-text-rotation-angle-up::before {
  content: "\\FFDC";
}

.mdi-format-text-rotation-down::before {
  content: "\\FD4F";
}

.mdi-format-text-rotation-down-vertical::before {
  content: "\\FFDD";
}

.mdi-format-text-rotation-none::before {
  content: "\\FD50";
}

.mdi-format-text-rotation-up::before {
  content: "\\FFDE";
}

.mdi-format-text-rotation-vertical::before {
  content: "\\FFDF";
}

.mdi-format-text-variant::before {
  content: "\\FE15";
}

.mdi-format-text-wrapping-clip::before {
  content: "\\FCEA";
}

.mdi-format-text-wrapping-overflow::before {
  content: "\\FCEB";
}

.mdi-format-text-wrapping-wrap::before {
  content: "\\FCEC";
}

.mdi-format-textbox::before {
  content: "\\FCED";
}

.mdi-format-textdirection-l-to-r::before {
  content: "\\F285";
}

.mdi-format-textdirection-r-to-l::before {
  content: "\\F286";
}

.mdi-format-title::before {
  content: "\\F5F4";
}

.mdi-format-underline::before {
  content: "\\F287";
}

.mdi-format-vertical-align-bottom::before {
  content: "\\F621";
}

.mdi-format-vertical-align-center::before {
  content: "\\F622";
}

.mdi-format-vertical-align-top::before {
  content: "\\F623";
}

.mdi-format-wrap-inline::before {
  content: "\\F288";
}

.mdi-format-wrap-square::before {
  content: "\\F289";
}

.mdi-format-wrap-tight::before {
  content: "\\F28A";
}

.mdi-format-wrap-top-bottom::before {
  content: "\\F28B";
}

.mdi-forum::before {
  content: "\\F28C";
}

.mdi-forum-outline::before {
  content: "\\F821";
}

.mdi-forward::before {
  content: "\\F28D";
}

.mdi-forwardburger::before {
  content: "\\FD51";
}

.mdi-fountain::before {
  content: "\\F96A";
}

.mdi-fountain-pen::before {
  content: "\\FCEE";
}

.mdi-fountain-pen-tip::before {
  content: "\\FCEF";
}

.mdi-foursquare::before {
  content: "\\F28E";
}

.mdi-freebsd::before {
  content: "\\F8DF";
}

.mdi-frequently-asked-questions::before {
  content: "\\FED1";
}

.mdi-fridge::before {
  content: "\\F290";
}

.mdi-fridge-alert::before {
  content: "\\F01DC";
}

.mdi-fridge-alert-outline::before {
  content: "\\F01DD";
}

.mdi-fridge-bottom::before {
  content: "\\F292";
}

.mdi-fridge-off::before {
  content: "\\F01DA";
}

.mdi-fridge-off-outline::before {
  content: "\\F01DB";
}

.mdi-fridge-outline::before {
  content: "\\F28F";
}

.mdi-fridge-top::before {
  content: "\\F291";
}

.mdi-fruit-cherries::before {
  content: "\\F0064";
}

.mdi-fruit-citrus::before {
  content: "\\F0065";
}

.mdi-fruit-grapes::before {
  content: "\\F0066";
}

.mdi-fruit-grapes-outline::before {
  content: "\\F0067";
}

.mdi-fruit-pineapple::before {
  content: "\\F0068";
}

.mdi-fruit-watermelon::before {
  content: "\\F0069";
}

.mdi-fuel::before {
  content: "\\F7C9";
}

.mdi-fullscreen::before {
  content: "\\F293";
}

.mdi-fullscreen-exit::before {
  content: "\\F294";
}

.mdi-function::before {
  content: "\\F295";
}

.mdi-function-variant::before {
  content: "\\F870";
}

.mdi-furigana-horizontal::before {
  content: "\\F00AC";
}

.mdi-furigana-vertical::before {
  content: "\\F00AD";
}

.mdi-fuse::before {
  content: "\\FC61";
}

.mdi-fuse-blade::before {
  content: "\\FC62";
}

.mdi-gamepad::before {
  content: "\\F296";
}

.mdi-gamepad-circle::before {
  content: "\\FE16";
}

.mdi-gamepad-circle-down::before {
  content: "\\FE17";
}

.mdi-gamepad-circle-left::before {
  content: "\\FE18";
}

.mdi-gamepad-circle-outline::before {
  content: "\\FE19";
}

.mdi-gamepad-circle-right::before {
  content: "\\FE1A";
}

.mdi-gamepad-circle-up::before {
  content: "\\FE1B";
}

.mdi-gamepad-down::before {
  content: "\\FE1C";
}

.mdi-gamepad-left::before {
  content: "\\FE1D";
}

.mdi-gamepad-right::before {
  content: "\\FE1E";
}

.mdi-gamepad-round::before {
  content: "\\FE1F";
}

.mdi-gamepad-round-down::before {
  content: "\\FE7E";
}

.mdi-gamepad-round-left::before {
  content: "\\FE7F";
}

.mdi-gamepad-round-outline::before {
  content: "\\FE80";
}

.mdi-gamepad-round-right::before {
  content: "\\FE81";
}

.mdi-gamepad-round-up::before {
  content: "\\FE82";
}

.mdi-gamepad-square::before {
  content: "\\FED2";
}

.mdi-gamepad-square-outline::before {
  content: "\\FED3";
}

.mdi-gamepad-up::before {
  content: "\\FE83";
}

.mdi-gamepad-variant::before {
  content: "\\F297";
}

.mdi-gamepad-variant-outline::before {
  content: "\\FED4";
}

.mdi-gamma::before {
  content: "\\F0119";
}

.mdi-gantry-crane::before {
  content: "\\FDAD";
}

.mdi-garage::before {
  content: "\\F6D8";
}

.mdi-garage-alert::before {
  content: "\\F871";
}

.mdi-garage-alert-variant::before {
  content: "\\F0300";
}

.mdi-garage-open::before {
  content: "\\F6D9";
}

.mdi-garage-open-variant::before {
  content: "\\F02FF";
}

.mdi-garage-variant::before {
  content: "\\F02FE";
}

.mdi-gas-cylinder::before {
  content: "\\F647";
}

.mdi-gas-station::before {
  content: "\\F298";
}

.mdi-gas-station-outline::before {
  content: "\\FED5";
}

.mdi-gate::before {
  content: "\\F299";
}

.mdi-gate-and::before {
  content: "\\F8E0";
}

.mdi-gate-arrow-right::before {
  content: "\\F0194";
}

.mdi-gate-nand::before {
  content: "\\F8E1";
}

.mdi-gate-nor::before {
  content: "\\F8E2";
}

.mdi-gate-not::before {
  content: "\\F8E3";
}

.mdi-gate-open::before {
  content: "\\F0195";
}

.mdi-gate-or::before {
  content: "\\F8E4";
}

.mdi-gate-xnor::before {
  content: "\\F8E5";
}

.mdi-gate-xor::before {
  content: "\\F8E6";
}

.mdi-gatsby::before {
  content: "\\FE84";
}

.mdi-gauge::before {
  content: "\\F29A";
}

.mdi-gauge-empty::before {
  content: "\\F872";
}

.mdi-gauge-full::before {
  content: "\\F873";
}

.mdi-gauge-low::before {
  content: "\\F874";
}

.mdi-gavel::before {
  content: "\\F29B";
}

.mdi-gender-female::before {
  content: "\\F29C";
}

.mdi-gender-male::before {
  content: "\\F29D";
}

.mdi-gender-male-female::before {
  content: "\\F29E";
}

.mdi-gender-male-female-variant::before {
  content: "\\F016A";
}

.mdi-gender-non-binary::before {
  content: "\\F016B";
}

.mdi-gender-transgender::before {
  content: "\\F29F";
}

.mdi-gentoo::before {
  content: "\\F8E7";
}

.mdi-gesture::before {
  content: "\\F7CA";
}

.mdi-gesture-double-tap::before {
  content: "\\F73B";
}

.mdi-gesture-pinch::before {
  content: "\\FABC";
}

.mdi-gesture-spread::before {
  content: "\\FABD";
}

.mdi-gesture-swipe::before {
  content: "\\FD52";
}

.mdi-gesture-swipe-down::before {
  content: "\\F73C";
}

.mdi-gesture-swipe-horizontal::before {
  content: "\\FABE";
}

.mdi-gesture-swipe-left::before {
  content: "\\F73D";
}

.mdi-gesture-swipe-right::before {
  content: "\\F73E";
}

.mdi-gesture-swipe-up::before {
  content: "\\F73F";
}

.mdi-gesture-swipe-vertical::before {
  content: "\\FABF";
}

.mdi-gesture-tap::before {
  content: "\\F740";
}

.mdi-gesture-tap-box::before {
  content: "\\F02D4";
}

.mdi-gesture-tap-button::before {
  content: "\\F02D3";
}

.mdi-gesture-tap-hold::before {
  content: "\\FD53";
}

.mdi-gesture-two-double-tap::before {
  content: "\\F741";
}

.mdi-gesture-two-tap::before {
  content: "\\F742";
}

.mdi-ghost::before {
  content: "\\F2A0";
}

.mdi-ghost-off::before {
  content: "\\F9F4";
}

.mdi-gif::before {
  content: "\\FD54";
}

.mdi-gift::before {
  content: "\\FE85";
}

.mdi-gift-outline::before {
  content: "\\F2A1";
}

.mdi-git::before {
  content: "\\F2A2";
}

.mdi-github-box::before {
  content: "\\F2A3";
}

.mdi-github-circle::before {
  content: "\\F2A4";
}

.mdi-github-face::before {
  content: "\\F6DA";
}

.mdi-gitlab::before {
  content: "\\FB7C";
}

.mdi-glass-cocktail::before {
  content: "\\F356";
}

.mdi-glass-flute::before {
  content: "\\F2A5";
}

.mdi-glass-mug::before {
  content: "\\F2A6";
}

.mdi-glass-mug-variant::before {
  content: "\\F0141";
}

.mdi-glass-pint-outline::before {
  content: "\\F0338";
}

.mdi-glass-stange::before {
  content: "\\F2A7";
}

.mdi-glass-tulip::before {
  content: "\\F2A8";
}

.mdi-glass-wine::before {
  content: "\\F875";
}

.mdi-glassdoor::before {
  content: "\\F2A9";
}

.mdi-glasses::before {
  content: "\\F2AA";
}

.mdi-globe-light::before {
  content: "\\F0302";
}

.mdi-globe-model::before {
  content: "\\F8E8";
}

.mdi-gmail::before {
  content: "\\F2AB";
}

.mdi-gnome::before {
  content: "\\F2AC";
}

.mdi-go-kart::before {
  content: "\\FD55";
}

.mdi-go-kart-track::before {
  content: "\\FD56";
}

.mdi-gog::before {
  content: "\\FB7D";
}

.mdi-gold::before {
  content: "\\F027A";
}

.mdi-golf::before {
  content: "\\F822";
}

.mdi-golf-cart::before {
  content: "\\F01CF";
}

.mdi-golf-tee::before {
  content: "\\F00AE";
}

.mdi-gondola::before {
  content: "\\F685";
}

.mdi-goodreads::before {
  content: "\\FD57";
}

.mdi-google::before {
  content: "\\F2AD";
}

.mdi-google-adwords::before {
  content: "\\FC63";
}

.mdi-google-analytics::before {
  content: "\\F7CB";
}

.mdi-google-assistant::before {
  content: "\\F7CC";
}

.mdi-google-cardboard::before {
  content: "\\F2AE";
}

.mdi-google-chrome::before {
  content: "\\F2AF";
}

.mdi-google-circles::before {
  content: "\\F2B0";
}

.mdi-google-circles-communities::before {
  content: "\\F2B1";
}

.mdi-google-circles-extended::before {
  content: "\\F2B2";
}

.mdi-google-circles-group::before {
  content: "\\F2B3";
}

.mdi-google-classroom::before {
  content: "\\F2C0";
}

.mdi-google-cloud::before {
  content: "\\F0221";
}

.mdi-google-controller::before {
  content: "\\F2B4";
}

.mdi-google-controller-off::before {
  content: "\\F2B5";
}

.mdi-google-downasaur::before {
  content: "\\F038D";
}

.mdi-google-drive::before {
  content: "\\F2B6";
}

.mdi-google-earth::before {
  content: "\\F2B7";
}

.mdi-google-fit::before {
  content: "\\F96B";
}

.mdi-google-glass::before {
  content: "\\F2B8";
}

.mdi-google-hangouts::before {
  content: "\\F2C9";
}

.mdi-google-home::before {
  content: "\\F823";
}

.mdi-google-keep::before {
  content: "\\F6DB";
}

.mdi-google-lens::before {
  content: "\\F9F5";
}

.mdi-google-maps::before {
  content: "\\F5F5";
}

.mdi-google-my-business::before {
  content: "\\F006A";
}

.mdi-google-nearby::before {
  content: "\\F2B9";
}

.mdi-google-pages::before {
  content: "\\F2BA";
}

.mdi-google-photos::before {
  content: "\\F6DC";
}

.mdi-google-physical-web::before {
  content: "\\F2BB";
}

.mdi-google-play::before {
  content: "\\F2BC";
}

.mdi-google-plus::before {
  content: "\\F2BD";
}

.mdi-google-plus-box::before {
  content: "\\F2BE";
}

.mdi-google-podcast::before {
  content: "\\FED6";
}

.mdi-google-spreadsheet::before {
  content: "\\F9F6";
}

.mdi-google-street-view::before {
  content: "\\FC64";
}

.mdi-google-translate::before {
  content: "\\F2BF";
}

.mdi-gradient::before {
  content: "\\F69F";
}

.mdi-grain::before {
  content: "\\FD58";
}

.mdi-graph::before {
  content: "\\F006B";
}

.mdi-graph-outline::before {
  content: "\\F006C";
}

.mdi-graphql::before {
  content: "\\F876";
}

.mdi-grave-stone::before {
  content: "\\FB7E";
}

.mdi-grease-pencil::before {
  content: "\\F648";
}

.mdi-greater-than::before {
  content: "\\F96C";
}

.mdi-greater-than-or-equal::before {
  content: "\\F96D";
}

.mdi-grid::before {
  content: "\\F2C1";
}

.mdi-grid-large::before {
  content: "\\F757";
}

.mdi-grid-off::before {
  content: "\\F2C2";
}

.mdi-grill::before {
  content: "\\FE86";
}

.mdi-grill-outline::before {
  content: "\\F01B5";
}

.mdi-group::before {
  content: "\\F2C3";
}

.mdi-guitar-acoustic::before {
  content: "\\F770";
}

.mdi-guitar-electric::before {
  content: "\\F2C4";
}

.mdi-guitar-pick::before {
  content: "\\F2C5";
}

.mdi-guitar-pick-outline::before {
  content: "\\F2C6";
}

.mdi-guy-fawkes-mask::before {
  content: "\\F824";
}

.mdi-hackernews::before {
  content: "\\F624";
}

.mdi-hail::before {
  content: "\\FAC0";
}

.mdi-hair-dryer::before {
  content: "\\F011A";
}

.mdi-hair-dryer-outline::before {
  content: "\\F011B";
}

.mdi-halloween::before {
  content: "\\FB7F";
}

.mdi-hamburger::before {
  content: "\\F684";
}

.mdi-hammer::before {
  content: "\\F8E9";
}

.mdi-hammer-screwdriver::before {
  content: "\\F034D";
}

.mdi-hammer-wrench::before {
  content: "\\F034E";
}

.mdi-hand::before {
  content: "\\FA4E";
}

.mdi-hand-heart::before {
  content: "\\F011C";
}

.mdi-hand-left::before {
  content: "\\FE87";
}

.mdi-hand-okay::before {
  content: "\\FA4F";
}

.mdi-hand-peace::before {
  content: "\\FA50";
}

.mdi-hand-peace-variant::before {
  content: "\\FA51";
}

.mdi-hand-pointing-down::before {
  content: "\\FA52";
}

.mdi-hand-pointing-left::before {
  content: "\\FA53";
}

.mdi-hand-pointing-right::before {
  content: "\\F2C7";
}

.mdi-hand-pointing-up::before {
  content: "\\FA54";
}

.mdi-hand-right::before {
  content: "\\FE88";
}

.mdi-hand-saw::before {
  content: "\\FE89";
}

.mdi-handball::before {
  content: "\\FF70";
}

.mdi-handcuffs::before {
  content: "\\F0169";
}

.mdi-handshake::before {
  content: "\\F0243";
}

.mdi-hanger::before {
  content: "\\F2C8";
}

.mdi-hard-hat::before {
  content: "\\F96E";
}

.mdi-harddisk::before {
  content: "\\F2CA";
}

.mdi-harddisk-plus::before {
  content: "\\F006D";
}

.mdi-harddisk-remove::before {
  content: "\\F006E";
}

.mdi-hat-fedora::before {
  content: "\\FB80";
}

.mdi-hazard-lights::before {
  content: "\\FC65";
}

.mdi-hdr::before {
  content: "\\FD59";
}

.mdi-hdr-off::before {
  content: "\\FD5A";
}

.mdi-head::before {
  content: "\\F0389";
}

.mdi-head-alert::before {
  content: "\\F0363";
}

.mdi-head-alert-outline::before {
  content: "\\F0364";
}

.mdi-head-check::before {
  content: "\\F0365";
}

.mdi-head-check-outline::before {
  content: "\\F0366";
}

.mdi-head-cog::before {
  content: "\\F0367";
}

.mdi-head-cog-outline::before {
  content: "\\F0368";
}

.mdi-head-dots-horizontal::before {
  content: "\\F0369";
}

.mdi-head-dots-horizontal-outline::before {
  content: "\\F036A";
}

.mdi-head-flash::before {
  content: "\\F036B";
}

.mdi-head-flash-outline::before {
  content: "\\F036C";
}

.mdi-head-heart::before {
  content: "\\F036D";
}

.mdi-head-heart-outline::before {
  content: "\\F036E";
}

.mdi-head-lightbulb::before {
  content: "\\F036F";
}

.mdi-head-lightbulb-outline::before {
  content: "\\F0370";
}

.mdi-head-minus::before {
  content: "\\F0371";
}

.mdi-head-minus-outline::before {
  content: "\\F0372";
}

.mdi-head-outline::before {
  content: "\\F038A";
}

.mdi-head-plus::before {
  content: "\\F0373";
}

.mdi-head-plus-outline::before {
  content: "\\F0374";
}

.mdi-head-question::before {
  content: "\\F0375";
}

.mdi-head-question-outline::before {
  content: "\\F0376";
}

.mdi-head-remove::before {
  content: "\\F0377";
}

.mdi-head-remove-outline::before {
  content: "\\F0378";
}

.mdi-head-snowflake::before {
  content: "\\F0379";
}

.mdi-head-snowflake-outline::before {
  content: "\\F037A";
}

.mdi-head-sync::before {
  content: "\\F037B";
}

.mdi-head-sync-outline::before {
  content: "\\F037C";
}

.mdi-headphones::before {
  content: "\\F2CB";
}

.mdi-headphones-bluetooth::before {
  content: "\\F96F";
}

.mdi-headphones-box::before {
  content: "\\F2CC";
}

.mdi-headphones-off::before {
  content: "\\F7CD";
}

.mdi-headphones-settings::before {
  content: "\\F2CD";
}

.mdi-headset::before {
  content: "\\F2CE";
}

.mdi-headset-dock::before {
  content: "\\F2CF";
}

.mdi-headset-off::before {
  content: "\\F2D0";
}

.mdi-heart::before {
  content: "\\F2D1";
}

.mdi-heart-box::before {
  content: "\\F2D2";
}

.mdi-heart-box-outline::before {
  content: "\\F2D3";
}

.mdi-heart-broken::before {
  content: "\\F2D4";
}

.mdi-heart-broken-outline::before {
  content: "\\FCF0";
}

.mdi-heart-circle::before {
  content: "\\F970";
}

.mdi-heart-circle-outline::before {
  content: "\\F971";
}

.mdi-heart-flash::before {
  content: "\\FF16";
}

.mdi-heart-half::before {
  content: "\\F6DE";
}

.mdi-heart-half-full::before {
  content: "\\F6DD";
}

.mdi-heart-half-outline::before {
  content: "\\F6DF";
}

.mdi-heart-multiple::before {
  content: "\\FA55";
}

.mdi-heart-multiple-outline::before {
  content: "\\FA56";
}

.mdi-heart-off::before {
  content: "\\F758";
}

.mdi-heart-outline::before {
  content: "\\F2D5";
}

.mdi-heart-pulse::before {
  content: "\\F5F6";
}

.mdi-helicopter::before {
  content: "\\FAC1";
}

.mdi-help::before {
  content: "\\F2D6";
}

.mdi-help-box::before {
  content: "\\F78A";
}

.mdi-help-circle::before {
  content: "\\F2D7";
}

.mdi-help-circle-outline::before {
  content: "\\F625";
}

.mdi-help-network::before {
  content: "\\F6F4";
}

.mdi-help-network-outline::before {
  content: "\\FC66";
}

.mdi-help-rhombus::before {
  content: "\\FB81";
}

.mdi-help-rhombus-outline::before {
  content: "\\FB82";
}

.mdi-hexadecimal::before {
  content: "\\F02D2";
}

.mdi-hexagon::before {
  content: "\\F2D8";
}

.mdi-hexagon-multiple::before {
  content: "\\F6E0";
}

.mdi-hexagon-multiple-outline::before {
  content: "\\F011D";
}

.mdi-hexagon-outline::before {
  content: "\\F2D9";
}

.mdi-hexagon-slice-1::before {
  content: "\\FAC2";
}

.mdi-hexagon-slice-2::before {
  content: "\\FAC3";
}

.mdi-hexagon-slice-3::before {
  content: "\\FAC4";
}

.mdi-hexagon-slice-4::before {
  content: "\\FAC5";
}

.mdi-hexagon-slice-5::before {
  content: "\\FAC6";
}

.mdi-hexagon-slice-6::before {
  content: "\\FAC7";
}

.mdi-hexagram::before {
  content: "\\FAC8";
}

.mdi-hexagram-outline::before {
  content: "\\FAC9";
}

.mdi-high-definition::before {
  content: "\\F7CE";
}

.mdi-high-definition-box::before {
  content: "\\F877";
}

.mdi-highway::before {
  content: "\\F5F7";
}

.mdi-hiking::before {
  content: "\\FD5B";
}

.mdi-hinduism::before {
  content: "\\F972";
}

.mdi-history::before {
  content: "\\F2DA";
}

.mdi-hockey-puck::before {
  content: "\\F878";
}

.mdi-hockey-sticks::before {
  content: "\\F879";
}

.mdi-hololens::before {
  content: "\\F2DB";
}

.mdi-home::before {
  content: "\\F2DC";
}

.mdi-home-account::before {
  content: "\\F825";
}

.mdi-home-alert::before {
  content: "\\F87A";
}

.mdi-home-analytics::before {
  content: "\\FED7";
}

.mdi-home-assistant::before {
  content: "\\F7CF";
}

.mdi-home-automation::before {
  content: "\\F7D0";
}

.mdi-home-circle::before {
  content: "\\F7D1";
}

.mdi-home-circle-outline::before {
  content: "\\F006F";
}

.mdi-home-city::before {
  content: "\\FCF1";
}

.mdi-home-city-outline::before {
  content: "\\FCF2";
}

.mdi-home-currency-usd::before {
  content: "\\F8AE";
}

.mdi-home-edit::before {
  content: "\\F0184";
}

.mdi-home-edit-outline::before {
  content: "\\F0185";
}

.mdi-home-export-outline::before {
  content: "\\FFB8";
}

.mdi-home-flood::before {
  content: "\\FF17";
}

.mdi-home-floor-0::before {
  content: "\\FDAE";
}

.mdi-home-floor-1::before {
  content: "\\FD5C";
}

.mdi-home-floor-2::before {
  content: "\\FD5D";
}

.mdi-home-floor-3::before {
  content: "\\FD5E";
}

.mdi-home-floor-a::before {
  content: "\\FD5F";
}

.mdi-home-floor-b::before {
  content: "\\FD60";
}

.mdi-home-floor-g::before {
  content: "\\FD61";
}

.mdi-home-floor-l::before {
  content: "\\FD62";
}

.mdi-home-floor-negative-1::before {
  content: "\\FDAF";
}

.mdi-home-group::before {
  content: "\\FDB0";
}

.mdi-home-heart::before {
  content: "\\F826";
}

.mdi-home-import-outline::before {
  content: "\\FFB9";
}

.mdi-home-lightbulb::before {
  content: "\\F027C";
}

.mdi-home-lightbulb-outline::before {
  content: "\\F027D";
}

.mdi-home-lock::before {
  content: "\\F8EA";
}

.mdi-home-lock-open::before {
  content: "\\F8EB";
}

.mdi-home-map-marker::before {
  content: "\\F5F8";
}

.mdi-home-minus::before {
  content: "\\F973";
}

.mdi-home-modern::before {
  content: "\\F2DD";
}

.mdi-home-outline::before {
  content: "\\F6A0";
}

.mdi-home-plus::before {
  content: "\\F974";
}

.mdi-home-remove::before {
  content: "\\F0272";
}

.mdi-home-roof::before {
  content: "\\F0156";
}

.mdi-home-thermometer::before {
  content: "\\FF71";
}

.mdi-home-thermometer-outline::before {
  content: "\\FF72";
}

.mdi-home-variant::before {
  content: "\\F2DE";
}

.mdi-home-variant-outline::before {
  content: "\\FB83";
}

.mdi-hook::before {
  content: "\\F6E1";
}

.mdi-hook-off::before {
  content: "\\F6E2";
}

.mdi-hops::before {
  content: "\\F2DF";
}

.mdi-horizontal-rotate-clockwise::before {
  content: "\\F011E";
}

.mdi-horizontal-rotate-counterclockwise::before {
  content: "\\F011F";
}

.mdi-horseshoe::before {
  content: "\\FA57";
}

.mdi-hospital::before {
  content: "\\F0017";
}

.mdi-hospital-box::before {
  content: "\\F2E0";
}

.mdi-hospital-box-outline::before {
  content: "\\F0018";
}

.mdi-hospital-building::before {
  content: "\\F2E1";
}

.mdi-hospital-marker::before {
  content: "\\F2E2";
}

.mdi-hot-tub::before {
  content: "\\F827";
}

.mdi-hotel::before {
  content: "\\F2E3";
}

.mdi-houzz::before {
  content: "\\F2E4";
}

.mdi-houzz-box::before {
  content: "\\F2E5";
}

.mdi-hubspot::before {
  content: "\\FCF3";
}

.mdi-hulu::before {
  content: "\\F828";
}

.mdi-human::before {
  content: "\\F2E6";
}

.mdi-human-child::before {
  content: "\\F2E7";
}

.mdi-human-female::before {
  content: "\\F649";
}

.mdi-human-female-boy::before {
  content: "\\FA58";
}

.mdi-human-female-female::before {
  content: "\\FA59";
}

.mdi-human-female-girl::before {
  content: "\\FA5A";
}

.mdi-human-greeting::before {
  content: "\\F64A";
}

.mdi-human-handsdown::before {
  content: "\\F64B";
}

.mdi-human-handsup::before {
  content: "\\F64C";
}

.mdi-human-male::before {
  content: "\\F64D";
}

.mdi-human-male-boy::before {
  content: "\\FA5B";
}

.mdi-human-male-female::before {
  content: "\\F2E8";
}

.mdi-human-male-girl::before {
  content: "\\FA5C";
}

.mdi-human-male-height::before {
  content: "\\FF18";
}

.mdi-human-male-height-variant::before {
  content: "\\FF19";
}

.mdi-human-male-male::before {
  content: "\\FA5D";
}

.mdi-human-pregnant::before {
  content: "\\F5CF";
}

.mdi-humble-bundle::before {
  content: "\\F743";
}

.mdi-hvac::before {
  content: "\\F037D";
}

.mdi-hydraulic-oil-level::before {
  content: "\\F034F";
}

.mdi-hydraulic-oil-temperature::before {
  content: "\\F0350";
}

.mdi-hydro-power::before {
  content: "\\F0310";
}

.mdi-ice-cream::before {
  content: "\\F829";
}

.mdi-ice-pop::before {
  content: "\\FF1A";
}

.mdi-id-card::before {
  content: "\\FFE0";
}

.mdi-identifier::before {
  content: "\\FF1B";
}

.mdi-ideogram-cjk::before {
  content: "\\F035C";
}

.mdi-ideogram-cjk-variant::before {
  content: "\\F035D";
}

.mdi-iframe::before {
  content: "\\FC67";
}

.mdi-iframe-array::before {
  content: "\\F0120";
}

.mdi-iframe-array-outline::before {
  content: "\\F0121";
}

.mdi-iframe-braces::before {
  content: "\\F0122";
}

.mdi-iframe-braces-outline::before {
  content: "\\F0123";
}

.mdi-iframe-outline::before {
  content: "\\FC68";
}

.mdi-iframe-parentheses::before {
  content: "\\F0124";
}

.mdi-iframe-parentheses-outline::before {
  content: "\\F0125";
}

.mdi-iframe-variable::before {
  content: "\\F0126";
}

.mdi-iframe-variable-outline::before {
  content: "\\F0127";
}

.mdi-image::before {
  content: "\\F2E9";
}

.mdi-image-album::before {
  content: "\\F2EA";
}

.mdi-image-area::before {
  content: "\\F2EB";
}

.mdi-image-area-close::before {
  content: "\\F2EC";
}

.mdi-image-auto-adjust::before {
  content: "\\FFE1";
}

.mdi-image-broken::before {
  content: "\\F2ED";
}

.mdi-image-broken-variant::before {
  content: "\\F2EE";
}

.mdi-image-edit::before {
  content: "\\F020E";
}

.mdi-image-edit-outline::before {
  content: "\\F020F";
}

.mdi-image-filter::before {
  content: "\\F2EF";
}

.mdi-image-filter-black-white::before {
  content: "\\F2F0";
}

.mdi-image-filter-center-focus::before {
  content: "\\F2F1";
}

.mdi-image-filter-center-focus-strong::before {
  content: "\\FF1C";
}

.mdi-image-filter-center-focus-strong-outline::before {
  content: "\\FF1D";
}

.mdi-image-filter-center-focus-weak::before {
  content: "\\F2F2";
}

.mdi-image-filter-drama::before {
  content: "\\F2F3";
}

.mdi-image-filter-frames::before {
  content: "\\F2F4";
}

.mdi-image-filter-hdr::before {
  content: "\\F2F5";
}

.mdi-image-filter-none::before {
  content: "\\F2F6";
}

.mdi-image-filter-tilt-shift::before {
  content: "\\F2F7";
}

.mdi-image-filter-vintage::before {
  content: "\\F2F8";
}

.mdi-image-frame::before {
  content: "\\FE8A";
}

.mdi-image-move::before {
  content: "\\F9F7";
}

.mdi-image-multiple::before {
  content: "\\F2F9";
}

.mdi-image-off::before {
  content: "\\F82A";
}

.mdi-image-off-outline::before {
  content: "\\F01FC";
}

.mdi-image-outline::before {
  content: "\\F975";
}

.mdi-image-plus::before {
  content: "\\F87B";
}

.mdi-image-search::before {
  content: "\\F976";
}

.mdi-image-search-outline::before {
  content: "\\F977";
}

.mdi-image-size-select-actual::before {
  content: "\\FC69";
}

.mdi-image-size-select-large::before {
  content: "\\FC6A";
}

.mdi-image-size-select-small::before {
  content: "\\FC6B";
}

.mdi-import::before {
  content: "\\F2FA";
}

.mdi-inbox::before {
  content: "\\F686";
}

.mdi-inbox-arrow-down::before {
  content: "\\F2FB";
}

.mdi-inbox-arrow-down-outline::before {
  content: "\\F029B";
}

.mdi-inbox-arrow-up::before {
  content: "\\F3D1";
}

.mdi-inbox-arrow-up-outline::before {
  content: "\\F029C";
}

.mdi-inbox-full::before {
  content: "\\F029D";
}

.mdi-inbox-full-outline::before {
  content: "\\F029E";
}

.mdi-inbox-multiple::before {
  content: "\\F8AF";
}

.mdi-inbox-multiple-outline::before {
  content: "\\FB84";
}

.mdi-inbox-outline::before {
  content: "\\F029F";
}

.mdi-incognito::before {
  content: "\\F5F9";
}

.mdi-infinity::before {
  content: "\\F6E3";
}

.mdi-information::before {
  content: "\\F2FC";
}

.mdi-information-outline::before {
  content: "\\F2FD";
}

.mdi-information-variant::before {
  content: "\\F64E";
}

.mdi-instagram::before {
  content: "\\F2FE";
}

.mdi-instapaper::before {
  content: "\\F2FF";
}

.mdi-instrument-triangle::before {
  content: "\\F0070";
}

.mdi-internet-explorer::before {
  content: "\\F300";
}

.mdi-invert-colors::before {
  content: "\\F301";
}

.mdi-invert-colors-off::before {
  content: "\\FE8B";
}

.mdi-iobroker::before {
  content: "\\F0313";
}

.mdi-ip::before {
  content: "\\FA5E";
}

.mdi-ip-network::before {
  content: "\\FA5F";
}

.mdi-ip-network-outline::before {
  content: "\\FC6C";
}

.mdi-ipod::before {
  content: "\\FC6D";
}

.mdi-islam::before {
  content: "\\F978";
}

.mdi-island::before {
  content: "\\F0071";
}

.mdi-itunes::before {
  content: "\\F676";
}

.mdi-iv-bag::before {
  content: "\\F00E4";
}

.mdi-jabber::before {
  content: "\\FDB1";
}

.mdi-jeepney::before {
  content: "\\F302";
}

.mdi-jellyfish::before {
  content: "\\FF1E";
}

.mdi-jellyfish-outline::before {
  content: "\\FF1F";
}

.mdi-jira::before {
  content: "\\F303";
}

.mdi-jquery::before {
  content: "\\F87C";
}

.mdi-jsfiddle::before {
  content: "\\F304";
}

.mdi-json::before {
  content: "\\F626";
}

.mdi-judaism::before {
  content: "\\F979";
}

.mdi-jump-rope::before {
  content: "\\F032A";
}

.mdi-kabaddi::before {
  content: "\\FD63";
}

.mdi-karate::before {
  content: "\\F82B";
}

.mdi-keg::before {
  content: "\\F305";
}

.mdi-kettle::before {
  content: "\\F5FA";
}

.mdi-kettle-alert::before {
  content: "\\F0342";
}

.mdi-kettle-alert-outline::before {
  content: "\\F0343";
}

.mdi-kettle-off::before {
  content: "\\F0346";
}

.mdi-kettle-off-outline::before {
  content: "\\F0347";
}

.mdi-kettle-outline::before {
  content: "\\FF73";
}

.mdi-kettle-steam::before {
  content: "\\F0344";
}

.mdi-kettle-steam-outline::before {
  content: "\\F0345";
}

.mdi-kettlebell::before {
  content: "\\F032B";
}

.mdi-key::before {
  content: "\\F306";
}

.mdi-key-arrow-right::before {
  content: "\\F033D";
}

.mdi-key-change::before {
  content: "\\F307";
}

.mdi-key-link::before {
  content: "\\F01CA";
}

.mdi-key-minus::before {
  content: "\\F308";
}

.mdi-key-outline::before {
  content: "\\FDB2";
}

.mdi-key-plus::before {
  content: "\\F309";
}

.mdi-key-remove::before {
  content: "\\F30A";
}

.mdi-key-star::before {
  content: "\\F01C9";
}

.mdi-key-variant::before {
  content: "\\F30B";
}

.mdi-key-wireless::before {
  content: "\\FFE2";
}

.mdi-keyboard::before {
  content: "\\F30C";
}

.mdi-keyboard-backspace::before {
  content: "\\F30D";
}

.mdi-keyboard-caps::before {
  content: "\\F30E";
}

.mdi-keyboard-close::before {
  content: "\\F30F";
}

.mdi-keyboard-esc::before {
  content: "\\F02E2";
}

.mdi-keyboard-f1::before {
  content: "\\F02D6";
}

.mdi-keyboard-f10::before {
  content: "\\F02DF";
}

.mdi-keyboard-f11::before {
  content: "\\F02E0";
}

.mdi-keyboard-f12::before {
  content: "\\F02E1";
}

.mdi-keyboard-f2::before {
  content: "\\F02D7";
}

.mdi-keyboard-f3::before {
  content: "\\F02D8";
}

.mdi-keyboard-f4::before {
  content: "\\F02D9";
}

.mdi-keyboard-f5::before {
  content: "\\F02DA";
}

.mdi-keyboard-f6::before {
  content: "\\F02DB";
}

.mdi-keyboard-f7::before {
  content: "\\F02DC";
}

.mdi-keyboard-f8::before {
  content: "\\F02DD";
}

.mdi-keyboard-f9::before {
  content: "\\F02DE";
}

.mdi-keyboard-off::before {
  content: "\\F310";
}

.mdi-keyboard-off-outline::before {
  content: "\\FE8C";
}

.mdi-keyboard-outline::before {
  content: "\\F97A";
}

.mdi-keyboard-return::before {
  content: "\\F311";
}

.mdi-keyboard-settings::before {
  content: "\\F9F8";
}

.mdi-keyboard-settings-outline::before {
  content: "\\F9F9";
}

.mdi-keyboard-space::before {
  content: "\\F0072";
}

.mdi-keyboard-tab::before {
  content: "\\F312";
}

.mdi-keyboard-variant::before {
  content: "\\F313";
}

.mdi-khanda::before {
  content: "\\F0128";
}

.mdi-kickstarter::before {
  content: "\\F744";
}

.mdi-klingon::before {
  content: "\\F0386";
}

.mdi-knife::before {
  content: "\\F9FA";
}

.mdi-knife-military::before {
  content: "\\F9FB";
}

.mdi-kodi::before {
  content: "\\F314";
}

.mdi-kotlin::before {
  content: "\\F0244";
}

.mdi-kubernetes::before {
  content: "\\F0129";
}

.mdi-label::before {
  content: "\\F315";
}

.mdi-label-multiple::before {
  content: "\\F03A0";
}

.mdi-label-multiple-outline::before {
  content: "\\F03A1";
}

.mdi-label-off::before {
  content: "\\FACA";
}

.mdi-label-off-outline::before {
  content: "\\FACB";
}

.mdi-label-outline::before {
  content: "\\F316";
}

.mdi-label-percent::before {
  content: "\\F0315";
}

.mdi-label-percent-outline::before {
  content: "\\F0316";
}

.mdi-label-variant::before {
  content: "\\FACC";
}

.mdi-label-variant-outline::before {
  content: "\\FACD";
}

.mdi-ladybug::before {
  content: "\\F82C";
}

.mdi-lambda::before {
  content: "\\F627";
}

.mdi-lamp::before {
  content: "\\F6B4";
}

.mdi-lan::before {
  content: "\\F317";
}

.mdi-lan-check::before {
  content: "\\F02D5";
}

.mdi-lan-connect::before {
  content: "\\F318";
}

.mdi-lan-disconnect::before {
  content: "\\F319";
}

.mdi-lan-pending::before {
  content: "\\F31A";
}

.mdi-language-c::before {
  content: "\\F671";
}

.mdi-language-cpp::before {
  content: "\\F672";
}

.mdi-language-csharp::before {
  content: "\\F31B";
}

.mdi-language-css3::before {
  content: "\\F31C";
}

.mdi-language-fortran::before {
  content: "\\F0245";
}

.mdi-language-go::before {
  content: "\\F7D2";
}

.mdi-language-haskell::before {
  content: "\\FC6E";
}

.mdi-language-html5::before {
  content: "\\F31D";
}

.mdi-language-java::before {
  content: "\\FB1C";
}

.mdi-language-javascript::before {
  content: "\\F31E";
}

.mdi-language-lua::before {
  content: "\\F8B0";
}

.mdi-language-php::before {
  content: "\\F31F";
}

.mdi-language-python::before {
  content: "\\F320";
}

.mdi-language-python-text::before {
  content: "\\F321";
}

.mdi-language-r::before {
  content: "\\F7D3";
}

.mdi-language-ruby-on-rails::before {
  content: "\\FACE";
}

.mdi-language-swift::before {
  content: "\\F6E4";
}

.mdi-language-typescript::before {
  content: "\\F6E5";
}

.mdi-laptop::before {
  content: "\\F322";
}

.mdi-laptop-chromebook::before {
  content: "\\F323";
}

.mdi-laptop-mac::before {
  content: "\\F324";
}

.mdi-laptop-off::before {
  content: "\\F6E6";
}

.mdi-laptop-windows::before {
  content: "\\F325";
}

.mdi-laravel::before {
  content: "\\FACF";
}

.mdi-lasso::before {
  content: "\\FF20";
}

.mdi-lastfm::before {
  content: "\\F326";
}

.mdi-lastpass::before {
  content: "\\F446";
}

.mdi-latitude::before {
  content: "\\FF74";
}

.mdi-launch::before {
  content: "\\F327";
}

.mdi-lava-lamp::before {
  content: "\\F7D4";
}

.mdi-layers::before {
  content: "\\F328";
}

.mdi-layers-minus::before {
  content: "\\FE8D";
}

.mdi-layers-off::before {
  content: "\\F329";
}

.mdi-layers-off-outline::before {
  content: "\\F9FC";
}

.mdi-layers-outline::before {
  content: "\\F9FD";
}

.mdi-layers-plus::before {
  content: "\\FE30";
}

.mdi-layers-remove::before {
  content: "\\FE31";
}

.mdi-layers-search::before {
  content: "\\F0231";
}

.mdi-layers-search-outline::before {
  content: "\\F0232";
}

.mdi-layers-triple::before {
  content: "\\FF75";
}

.mdi-layers-triple-outline::before {
  content: "\\FF76";
}

.mdi-lead-pencil::before {
  content: "\\F64F";
}

.mdi-leaf::before {
  content: "\\F32A";
}

.mdi-leaf-maple::before {
  content: "\\FC6F";
}

.mdi-leaf-maple-off::before {
  content: "\\F0305";
}

.mdi-leaf-off::before {
  content: "\\F0304";
}

.mdi-leak::before {
  content: "\\FDB3";
}

.mdi-leak-off::before {
  content: "\\FDB4";
}

.mdi-led-off::before {
  content: "\\F32B";
}

.mdi-led-on::before {
  content: "\\F32C";
}

.mdi-led-outline::before {
  content: "\\F32D";
}

.mdi-led-strip::before {
  content: "\\F7D5";
}

.mdi-led-strip-variant::before {
  content: "\\F0073";
}

.mdi-led-variant-off::before {
  content: "\\F32E";
}

.mdi-led-variant-on::before {
  content: "\\F32F";
}

.mdi-led-variant-outline::before {
  content: "\\F330";
}

.mdi-leek::before {
  content: "\\F01A8";
}

.mdi-less-than::before {
  content: "\\F97B";
}

.mdi-less-than-or-equal::before {
  content: "\\F97C";
}

.mdi-library::before {
  content: "\\F331";
}

.mdi-library-books::before {
  content: "\\F332";
}

.mdi-library-movie::before {
  content: "\\FCF4";
}

.mdi-library-music::before {
  content: "\\F333";
}

.mdi-library-music-outline::before {
  content: "\\FF21";
}

.mdi-library-shelves::before {
  content: "\\FB85";
}

.mdi-library-video::before {
  content: "\\FCF5";
}

.mdi-license::before {
  content: "\\FFE3";
}

.mdi-lifebuoy::before {
  content: "\\F87D";
}

.mdi-light-switch::before {
  content: "\\F97D";
}

.mdi-lightbulb::before {
  content: "\\F335";
}

.mdi-lightbulb-cfl::before {
  content: "\\F0233";
}

.mdi-lightbulb-cfl-off::before {
  content: "\\F0234";
}

.mdi-lightbulb-cfl-spiral::before {
  content: "\\F02A0";
}

.mdi-lightbulb-cfl-spiral-off::before {
  content: "\\F02EE";
}

.mdi-lightbulb-group::before {
  content: "\\F027E";
}

.mdi-lightbulb-group-off::before {
  content: "\\F02F8";
}

.mdi-lightbulb-group-off-outline::before {
  content: "\\F02F9";
}

.mdi-lightbulb-group-outline::before {
  content: "\\F027F";
}

.mdi-lightbulb-multiple::before {
  content: "\\F0280";
}

.mdi-lightbulb-multiple-off::before {
  content: "\\F02FA";
}

.mdi-lightbulb-multiple-off-outline::before {
  content: "\\F02FB";
}

.mdi-lightbulb-multiple-outline::before {
  content: "\\F0281";
}

.mdi-lightbulb-off::before {
  content: "\\FE32";
}

.mdi-lightbulb-off-outline::before {
  content: "\\FE33";
}

.mdi-lightbulb-on::before {
  content: "\\F6E7";
}

.mdi-lightbulb-on-outline::before {
  content: "\\F6E8";
}

.mdi-lightbulb-outline::before {
  content: "\\F336";
}

.mdi-lighthouse::before {
  content: "\\F9FE";
}

.mdi-lighthouse-on::before {
  content: "\\F9FF";
}

.mdi-link::before {
  content: "\\F337";
}

.mdi-link-box::before {
  content: "\\FCF6";
}

.mdi-link-box-outline::before {
  content: "\\FCF7";
}

.mdi-link-box-variant::before {
  content: "\\FCF8";
}

.mdi-link-box-variant-outline::before {
  content: "\\FCF9";
}

.mdi-link-lock::before {
  content: "\\F00E5";
}

.mdi-link-off::before {
  content: "\\F338";
}

.mdi-link-plus::before {
  content: "\\FC70";
}

.mdi-link-variant::before {
  content: "\\F339";
}

.mdi-link-variant-minus::before {
  content: "\\F012A";
}

.mdi-link-variant-off::before {
  content: "\\F33A";
}

.mdi-link-variant-plus::before {
  content: "\\F012B";
}

.mdi-link-variant-remove::before {
  content: "\\F012C";
}

.mdi-linkedin::before {
  content: "\\F33B";
}

.mdi-linkedin-box::before {
  content: "\\F33C";
}

.mdi-linux::before {
  content: "\\F33D";
}

.mdi-linux-mint::before {
  content: "\\F8EC";
}

.mdi-litecoin::before {
  content: "\\FA60";
}

.mdi-loading::before {
  content: "\\F771";
}

.mdi-location-enter::before {
  content: "\\FFE4";
}

.mdi-location-exit::before {
  content: "\\FFE5";
}

.mdi-lock::before {
  content: "\\F33E";
}

.mdi-lock-alert::before {
  content: "\\F8ED";
}

.mdi-lock-clock::before {
  content: "\\F97E";
}

.mdi-lock-open::before {
  content: "\\F33F";
}

.mdi-lock-open-outline::before {
  content: "\\F340";
}

.mdi-lock-open-variant::before {
  content: "\\FFE6";
}

.mdi-lock-open-variant-outline::before {
  content: "\\FFE7";
}

.mdi-lock-outline::before {
  content: "\\F341";
}

.mdi-lock-pattern::before {
  content: "\\F6E9";
}

.mdi-lock-plus::before {
  content: "\\F5FB";
}

.mdi-lock-question::before {
  content: "\\F8EE";
}

.mdi-lock-reset::before {
  content: "\\F772";
}

.mdi-lock-smart::before {
  content: "\\F8B1";
}

.mdi-locker::before {
  content: "\\F7D6";
}

.mdi-locker-multiple::before {
  content: "\\F7D7";
}

.mdi-login::before {
  content: "\\F342";
}

.mdi-login-variant::before {
  content: "\\F5FC";
}

.mdi-logout::before {
  content: "\\F343";
}

.mdi-logout-variant::before {
  content: "\\F5FD";
}

.mdi-longitude::before {
  content: "\\FF77";
}

.mdi-looks::before {
  content: "\\F344";
}

.mdi-loupe::before {
  content: "\\F345";
}

.mdi-lumx::before {
  content: "\\F346";
}

.mdi-lungs::before {
  content: "\\F00AF";
}

.mdi-lyft::before {
  content: "\\FB1D";
}

.mdi-magnet::before {
  content: "\\F347";
}

.mdi-magnet-on::before {
  content: "\\F348";
}

.mdi-magnify::before {
  content: "\\F349";
}

.mdi-magnify-close::before {
  content: "\\F97F";
}

.mdi-magnify-minus::before {
  content: "\\F34A";
}

.mdi-magnify-minus-cursor::before {
  content: "\\FA61";
}

.mdi-magnify-minus-outline::before {
  content: "\\F6EB";
}

.mdi-magnify-plus::before {
  content: "\\F34B";
}

.mdi-magnify-plus-cursor::before {
  content: "\\FA62";
}

.mdi-magnify-plus-outline::before {
  content: "\\F6EC";
}

.mdi-magnify-remove-cursor::before {
  content: "\\F0237";
}

.mdi-magnify-remove-outline::before {
  content: "\\F0238";
}

.mdi-magnify-scan::before {
  content: "\\F02A1";
}

.mdi-mail::before {
  content: "\\FED8";
}

.mdi-mail-ru::before {
  content: "\\F34C";
}

.mdi-mailbox::before {
  content: "\\F6ED";
}

.mdi-mailbox-open::before {
  content: "\\FD64";
}

.mdi-mailbox-open-outline::before {
  content: "\\FD65";
}

.mdi-mailbox-open-up::before {
  content: "\\FD66";
}

.mdi-mailbox-open-up-outline::before {
  content: "\\FD67";
}

.mdi-mailbox-outline::before {
  content: "\\FD68";
}

.mdi-mailbox-up::before {
  content: "\\FD69";
}

.mdi-mailbox-up-outline::before {
  content: "\\FD6A";
}

.mdi-map::before {
  content: "\\F34D";
}

.mdi-map-check::before {
  content: "\\FED9";
}

.mdi-map-check-outline::before {
  content: "\\FEDA";
}

.mdi-map-clock::before {
  content: "\\FCFA";
}

.mdi-map-clock-outline::before {
  content: "\\FCFB";
}

.mdi-map-legend::before {
  content: "\\FA00";
}

.mdi-map-marker::before {
  content: "\\F34E";
}

.mdi-map-marker-alert::before {
  content: "\\FF22";
}

.mdi-map-marker-alert-outline::before {
  content: "\\FF23";
}

.mdi-map-marker-check::before {
  content: "\\FC71";
}

.mdi-map-marker-check-outline::before {
  content: "\\F0326";
}

.mdi-map-marker-circle::before {
  content: "\\F34F";
}

.mdi-map-marker-distance::before {
  content: "\\F8EF";
}

.mdi-map-marker-down::before {
  content: "\\F012D";
}

.mdi-map-marker-left::before {
  content: "\\F0306";
}

.mdi-map-marker-left-outline::before {
  content: "\\F0308";
}

.mdi-map-marker-minus::before {
  content: "\\F650";
}

.mdi-map-marker-minus-outline::before {
  content: "\\F0324";
}

.mdi-map-marker-multiple::before {
  content: "\\F350";
}

.mdi-map-marker-multiple-outline::before {
  content: "\\F02A2";
}

.mdi-map-marker-off::before {
  content: "\\F351";
}

.mdi-map-marker-off-outline::before {
  content: "\\F0328";
}

.mdi-map-marker-outline::before {
  content: "\\F7D8";
}

.mdi-map-marker-path::before {
  content: "\\FCFC";
}

.mdi-map-marker-plus::before {
  content: "\\F651";
}

.mdi-map-marker-plus-outline::before {
  content: "\\F0323";
}

.mdi-map-marker-question::before {
  content: "\\FF24";
}

.mdi-map-marker-question-outline::before {
  content: "\\FF25";
}

.mdi-map-marker-radius::before {
  content: "\\F352";
}

.mdi-map-marker-radius-outline::before {
  content: "\\F0327";
}

.mdi-map-marker-remove::before {
  content: "\\FF26";
}

.mdi-map-marker-remove-outline::before {
  content: "\\F0325";
}

.mdi-map-marker-remove-variant::before {
  content: "\\FF27";
}

.mdi-map-marker-right::before {
  content: "\\F0307";
}

.mdi-map-marker-right-outline::before {
  content: "\\F0309";
}

.mdi-map-marker-up::before {
  content: "\\F012E";
}

.mdi-map-minus::before {
  content: "\\F980";
}

.mdi-map-outline::before {
  content: "\\F981";
}

.mdi-map-plus::before {
  content: "\\F982";
}

.mdi-map-search::before {
  content: "\\F983";
}

.mdi-map-search-outline::before {
  content: "\\F984";
}

.mdi-mapbox::before {
  content: "\\FB86";
}

.mdi-margin::before {
  content: "\\F353";
}

.mdi-markdown::before {
  content: "\\F354";
}

.mdi-markdown-outline::before {
  content: "\\FF78";
}

.mdi-marker::before {
  content: "\\F652";
}

.mdi-marker-cancel::before {
  content: "\\FDB5";
}

.mdi-marker-check::before {
  content: "\\F355";
}

.mdi-mastodon::before {
  content: "\\FAD0";
}

.mdi-mastodon-variant::before {
  content: "\\FAD1";
}

.mdi-material-design::before {
  content: "\\F985";
}

.mdi-material-ui::before {
  content: "\\F357";
}

.mdi-math-compass::before {
  content: "\\F358";
}

.mdi-math-cos::before {
  content: "\\FC72";
}

.mdi-math-integral::before {
  content: "\\FFE8";
}

.mdi-math-integral-box::before {
  content: "\\FFE9";
}

.mdi-math-log::before {
  content: "\\F00B0";
}

.mdi-math-norm::before {
  content: "\\FFEA";
}

.mdi-math-norm-box::before {
  content: "\\FFEB";
}

.mdi-math-sin::before {
  content: "\\FC73";
}

.mdi-math-tan::before {
  content: "\\FC74";
}

.mdi-matrix::before {
  content: "\\F628";
}

.mdi-medal::before {
  content: "\\F986";
}

.mdi-medal-outline::before {
  content: "\\F0351";
}

.mdi-medical-bag::before {
  content: "\\F6EE";
}

.mdi-meditation::before {
  content: "\\F01A6";
}

.mdi-medium::before {
  content: "\\F35A";
}

.mdi-meetup::before {
  content: "\\FAD2";
}

.mdi-memory::before {
  content: "\\F35B";
}

.mdi-menu::before {
  content: "\\F35C";
}

.mdi-menu-down::before {
  content: "\\F35D";
}

.mdi-menu-down-outline::before {
  content: "\\F6B5";
}

.mdi-menu-left::before {
  content: "\\F35E";
}

.mdi-menu-left-outline::before {
  content: "\\FA01";
}

.mdi-menu-open::before {
  content: "\\FB87";
}

.mdi-menu-right::before {
  content: "\\F35F";
}

.mdi-menu-right-outline::before {
  content: "\\FA02";
}

.mdi-menu-swap::before {
  content: "\\FA63";
}

.mdi-menu-swap-outline::before {
  content: "\\FA64";
}

.mdi-menu-up::before {
  content: "\\F360";
}

.mdi-menu-up-outline::before {
  content: "\\F6B6";
}

.mdi-merge::before {
  content: "\\FF79";
}

.mdi-message::before {
  content: "\\F361";
}

.mdi-message-alert::before {
  content: "\\F362";
}

.mdi-message-alert-outline::before {
  content: "\\FA03";
}

.mdi-message-arrow-left::before {
  content: "\\F031D";
}

.mdi-message-arrow-left-outline::before {
  content: "\\F031E";
}

.mdi-message-arrow-right::before {
  content: "\\F031F";
}

.mdi-message-arrow-right-outline::before {
  content: "\\F0320";
}

.mdi-message-bulleted::before {
  content: "\\F6A1";
}

.mdi-message-bulleted-off::before {
  content: "\\F6A2";
}

.mdi-message-draw::before {
  content: "\\F363";
}

.mdi-message-image::before {
  content: "\\F364";
}

.mdi-message-image-outline::before {
  content: "\\F0197";
}

.mdi-message-lock::before {
  content: "\\FFEC";
}

.mdi-message-lock-outline::before {
  content: "\\F0198";
}

.mdi-message-minus::before {
  content: "\\F0199";
}

.mdi-message-minus-outline::before {
  content: "\\F019A";
}

.mdi-message-outline::before {
  content: "\\F365";
}

.mdi-message-plus::before {
  content: "\\F653";
}

.mdi-message-plus-outline::before {
  content: "\\F00E6";
}

.mdi-message-processing::before {
  content: "\\F366";
}

.mdi-message-processing-outline::before {
  content: "\\F019B";
}

.mdi-message-reply::before {
  content: "\\F367";
}

.mdi-message-reply-text::before {
  content: "\\F368";
}

.mdi-message-settings::before {
  content: "\\F6EF";
}

.mdi-message-settings-outline::before {
  content: "\\F019C";
}

.mdi-message-settings-variant::before {
  content: "\\F6F0";
}

.mdi-message-settings-variant-outline::before {
  content: "\\F019D";
}

.mdi-message-text::before {
  content: "\\F369";
}

.mdi-message-text-clock::before {
  content: "\\F019E";
}

.mdi-message-text-clock-outline::before {
  content: "\\F019F";
}

.mdi-message-text-lock::before {
  content: "\\FFED";
}

.mdi-message-text-lock-outline::before {
  content: "\\F01A0";
}

.mdi-message-text-outline::before {
  content: "\\F36A";
}

.mdi-message-video::before {
  content: "\\F36B";
}

.mdi-meteor::before {
  content: "\\F629";
}

.mdi-metronome::before {
  content: "\\F7D9";
}

.mdi-metronome-tick::before {
  content: "\\F7DA";
}

.mdi-micro-sd::before {
  content: "\\F7DB";
}

.mdi-microphone::before {
  content: "\\F36C";
}

.mdi-microphone-minus::before {
  content: "\\F8B2";
}

.mdi-microphone-off::before {
  content: "\\F36D";
}

.mdi-microphone-outline::before {
  content: "\\F36E";
}

.mdi-microphone-plus::before {
  content: "\\F8B3";
}

.mdi-microphone-settings::before {
  content: "\\F36F";
}

.mdi-microphone-variant::before {
  content: "\\F370";
}

.mdi-microphone-variant-off::before {
  content: "\\F371";
}

.mdi-microscope::before {
  content: "\\F654";
}

.mdi-microsoft::before {
  content: "\\F372";
}

.mdi-microsoft-dynamics::before {
  content: "\\F987";
}

.mdi-microwave::before {
  content: "\\FC75";
}

.mdi-middleware::before {
  content: "\\FF7A";
}

.mdi-middleware-outline::before {
  content: "\\FF7B";
}

.mdi-midi::before {
  content: "\\F8F0";
}

.mdi-midi-port::before {
  content: "\\F8F1";
}

.mdi-mine::before {
  content: "\\FDB6";
}

.mdi-minecraft::before {
  content: "\\F373";
}

.mdi-mini-sd::before {
  content: "\\FA04";
}

.mdi-minidisc::before {
  content: "\\FA05";
}

.mdi-minus::before {
  content: "\\F374";
}

.mdi-minus-box::before {
  content: "\\F375";
}

.mdi-minus-box-multiple::before {
  content: "\\F016C";
}

.mdi-minus-box-multiple-outline::before {
  content: "\\F016D";
}

.mdi-minus-box-outline::before {
  content: "\\F6F1";
}

.mdi-minus-circle::before {
  content: "\\F376";
}

.mdi-minus-circle-outline::before {
  content: "\\F377";
}

.mdi-minus-network::before {
  content: "\\F378";
}

.mdi-minus-network-outline::before {
  content: "\\FC76";
}

.mdi-mirror::before {
  content: "\\F0228";
}

.mdi-mixcloud::before {
  content: "\\F62A";
}

.mdi-mixed-martial-arts::before {
  content: "\\FD6B";
}

.mdi-mixed-reality::before {
  content: "\\F87E";
}

.mdi-mixer::before {
  content: "\\F7DC";
}

.mdi-molecule::before {
  content: "\\FB88";
}

.mdi-monitor::before {
  content: "\\F379";
}

.mdi-monitor-cellphone::before {
  content: "\\F988";
}

.mdi-monitor-cellphone-star::before {
  content: "\\F989";
}

.mdi-monitor-clean::before {
  content: "\\F012F";
}

.mdi-monitor-dashboard::before {
  content: "\\FA06";
}

.mdi-monitor-edit::before {
  content: "\\F02F1";
}

.mdi-monitor-lock::before {
  content: "\\FDB7";
}

.mdi-monitor-multiple::before {
  content: "\\F37A";
}

.mdi-monitor-off::before {
  content: "\\FD6C";
}

.mdi-monitor-screenshot::before {
  content: "\\FE34";
}

.mdi-monitor-speaker::before {
  content: "\\FF7C";
}

.mdi-monitor-speaker-off::before {
  content: "\\FF7D";
}

.mdi-monitor-star::before {
  content: "\\FDB8";
}

.mdi-moon-first-quarter::before {
  content: "\\FF7E";
}

.mdi-moon-full::before {
  content: "\\FF7F";
}

.mdi-moon-last-quarter::before {
  content: "\\FF80";
}

.mdi-moon-new::before {
  content: "\\FF81";
}

.mdi-moon-waning-crescent::before {
  content: "\\FF82";
}

.mdi-moon-waning-gibbous::before {
  content: "\\FF83";
}

.mdi-moon-waxing-crescent::before {
  content: "\\FF84";
}

.mdi-moon-waxing-gibbous::before {
  content: "\\FF85";
}

.mdi-moped::before {
  content: "\\F00B1";
}

.mdi-more::before {
  content: "\\F37B";
}

.mdi-mother-heart::before {
  content: "\\F033F";
}

.mdi-mother-nurse::before {
  content: "\\FCFD";
}

.mdi-motion-sensor::before {
  content: "\\FD6D";
}

.mdi-motorbike::before {
  content: "\\F37C";
}

.mdi-mouse::before {
  content: "\\F37D";
}

.mdi-mouse-bluetooth::before {
  content: "\\F98A";
}

.mdi-mouse-off::before {
  content: "\\F37E";
}

.mdi-mouse-variant::before {
  content: "\\F37F";
}

.mdi-mouse-variant-off::before {
  content: "\\F380";
}

.mdi-move-resize::before {
  content: "\\F655";
}

.mdi-move-resize-variant::before {
  content: "\\F656";
}

.mdi-movie::before {
  content: "\\F381";
}

.mdi-movie-edit::before {
  content: "\\F014D";
}

.mdi-movie-edit-outline::before {
  content: "\\F014E";
}

.mdi-movie-filter::before {
  content: "\\F014F";
}

.mdi-movie-filter-outline::before {
  content: "\\F0150";
}

.mdi-movie-open::before {
  content: "\\FFEE";
}

.mdi-movie-open-outline::before {
  content: "\\FFEF";
}

.mdi-movie-outline::before {
  content: "\\FDB9";
}

.mdi-movie-roll::before {
  content: "\\F7DD";
}

.mdi-movie-search::before {
  content: "\\F01FD";
}

.mdi-movie-search-outline::before {
  content: "\\F01FE";
}

.mdi-muffin::before {
  content: "\\F98B";
}

.mdi-multiplication::before {
  content: "\\F382";
}

.mdi-multiplication-box::before {
  content: "\\F383";
}

.mdi-mushroom::before {
  content: "\\F7DE";
}

.mdi-mushroom-outline::before {
  content: "\\F7DF";
}

.mdi-music::before {
  content: "\\F759";
}

.mdi-music-accidental-double-flat::before {
  content: "\\FF86";
}

.mdi-music-accidental-double-sharp::before {
  content: "\\FF87";
}

.mdi-music-accidental-flat::before {
  content: "\\FF88";
}

.mdi-music-accidental-natural::before {
  content: "\\FF89";
}

.mdi-music-accidental-sharp::before {
  content: "\\FF8A";
}

.mdi-music-box::before {
  content: "\\F384";
}

.mdi-music-box-outline::before {
  content: "\\F385";
}

.mdi-music-circle::before {
  content: "\\F386";
}

.mdi-music-circle-outline::before {
  content: "\\FAD3";
}

.mdi-music-clef-alto::before {
  content: "\\FF8B";
}

.mdi-music-clef-bass::before {
  content: "\\FF8C";
}

.mdi-music-clef-treble::before {
  content: "\\FF8D";
}

.mdi-music-note::before {
  content: "\\F387";
}

.mdi-music-note-bluetooth::before {
  content: "\\F5FE";
}

.mdi-music-note-bluetooth-off::before {
  content: "\\F5FF";
}

.mdi-music-note-eighth::before {
  content: "\\F388";
}

.mdi-music-note-eighth-dotted::before {
  content: "\\FF8E";
}

.mdi-music-note-half::before {
  content: "\\F389";
}

.mdi-music-note-half-dotted::before {
  content: "\\FF8F";
}

.mdi-music-note-off::before {
  content: "\\F38A";
}

.mdi-music-note-off-outline::before {
  content: "\\FF90";
}

.mdi-music-note-outline::before {
  content: "\\FF91";
}

.mdi-music-note-plus::before {
  content: "\\FDBA";
}

.mdi-music-note-quarter::before {
  content: "\\F38B";
}

.mdi-music-note-quarter-dotted::before {
  content: "\\FF92";
}

.mdi-music-note-sixteenth::before {
  content: "\\F38C";
}

.mdi-music-note-sixteenth-dotted::before {
  content: "\\FF93";
}

.mdi-music-note-whole::before {
  content: "\\F38D";
}

.mdi-music-note-whole-dotted::before {
  content: "\\FF94";
}

.mdi-music-off::before {
  content: "\\F75A";
}

.mdi-music-rest-eighth::before {
  content: "\\FF95";
}

.mdi-music-rest-half::before {
  content: "\\FF96";
}

.mdi-music-rest-quarter::before {
  content: "\\FF97";
}

.mdi-music-rest-sixteenth::before {
  content: "\\FF98";
}

.mdi-music-rest-whole::before {
  content: "\\FF99";
}

.mdi-nail::before {
  content: "\\FDBB";
}

.mdi-nas::before {
  content: "\\F8F2";
}

.mdi-nativescript::before {
  content: "\\F87F";
}

.mdi-nature::before {
  content: "\\F38E";
}

.mdi-nature-people::before {
  content: "\\F38F";
}

.mdi-navigation::before {
  content: "\\F390";
}

.mdi-near-me::before {
  content: "\\F5CD";
}

.mdi-necklace::before {
  content: "\\FF28";
}

.mdi-needle::before {
  content: "\\F391";
}

.mdi-netflix::before {
  content: "\\F745";
}

.mdi-network::before {
  content: "\\F6F2";
}

.mdi-network-off::before {
  content: "\\FC77";
}

.mdi-network-off-outline::before {
  content: "\\FC78";
}

.mdi-network-outline::before {
  content: "\\FC79";
}

.mdi-network-router::before {
  content: "\\F00B2";
}

.mdi-network-strength-1::before {
  content: "\\F8F3";
}

.mdi-network-strength-1-alert::before {
  content: "\\F8F4";
}

.mdi-network-strength-2::before {
  content: "\\F8F5";
}

.mdi-network-strength-2-alert::before {
  content: "\\F8F6";
}

.mdi-network-strength-3::before {
  content: "\\F8F7";
}

.mdi-network-strength-3-alert::before {
  content: "\\F8F8";
}

.mdi-network-strength-4::before {
  content: "\\F8F9";
}

.mdi-network-strength-4-alert::before {
  content: "\\F8FA";
}

.mdi-network-strength-off::before {
  content: "\\F8FB";
}

.mdi-network-strength-off-outline::before {
  content: "\\F8FC";
}

.mdi-network-strength-outline::before {
  content: "\\F8FD";
}

.mdi-new-box::before {
  content: "\\F394";
}

.mdi-newspaper::before {
  content: "\\F395";
}

.mdi-newspaper-minus::before {
  content: "\\FF29";
}

.mdi-newspaper-plus::before {
  content: "\\FF2A";
}

.mdi-newspaper-variant::before {
  content: "\\F0023";
}

.mdi-newspaper-variant-multiple::before {
  content: "\\F0024";
}

.mdi-newspaper-variant-multiple-outline::before {
  content: "\\F0025";
}

.mdi-newspaper-variant-outline::before {
  content: "\\F0026";
}

.mdi-nfc::before {
  content: "\\F396";
}

.mdi-nfc-off::before {
  content: "\\FE35";
}

.mdi-nfc-search-variant::before {
  content: "\\FE36";
}

.mdi-nfc-tap::before {
  content: "\\F397";
}

.mdi-nfc-variant::before {
  content: "\\F398";
}

.mdi-nfc-variant-off::before {
  content: "\\FE37";
}

.mdi-ninja::before {
  content: "\\F773";
}

.mdi-nintendo-switch::before {
  content: "\\F7E0";
}

.mdi-nix::before {
  content: "\\F0130";
}

.mdi-nodejs::before {
  content: "\\F399";
}

.mdi-noodles::before {
  content: "\\F01A9";
}

.mdi-not-equal::before {
  content: "\\F98C";
}

.mdi-not-equal-variant::before {
  content: "\\F98D";
}

.mdi-note::before {
  content: "\\F39A";
}

.mdi-note-multiple::before {
  content: "\\F6B7";
}

.mdi-note-multiple-outline::before {
  content: "\\F6B8";
}

.mdi-note-outline::before {
  content: "\\F39B";
}

.mdi-note-plus::before {
  content: "\\F39C";
}

.mdi-note-plus-outline::before {
  content: "\\F39D";
}

.mdi-note-text::before {
  content: "\\F39E";
}

.mdi-note-text-outline::before {
  content: "\\F0202";
}

.mdi-notebook::before {
  content: "\\F82D";
}

.mdi-notebook-multiple::before {
  content: "\\FE38";
}

.mdi-notebook-outline::before {
  content: "\\FEDC";
}

.mdi-notification-clear-all::before {
  content: "\\F39F";
}

.mdi-npm::before {
  content: "\\F6F6";
}

.mdi-npm-variant::before {
  content: "\\F98E";
}

.mdi-npm-variant-outline::before {
  content: "\\F98F";
}

.mdi-nuke::before {
  content: "\\F6A3";
}

.mdi-null::before {
  content: "\\F7E1";
}

.mdi-numeric::before {
  content: "\\F3A0";
}

.mdi-numeric-0::before {
  content: "\\30";
}

.mdi-numeric-0-box::before {
  content: "\\F3A1";
}

.mdi-numeric-0-box-multiple::before {
  content: "\\FF2B";
}

.mdi-numeric-0-box-multiple-outline::before {
  content: "\\F3A2";
}

.mdi-numeric-0-box-outline::before {
  content: "\\F3A3";
}

.mdi-numeric-0-circle::before {
  content: "\\FC7A";
}

.mdi-numeric-0-circle-outline::before {
  content: "\\FC7B";
}

.mdi-numeric-1::before {
  content: "\\31";
}

.mdi-numeric-1-box::before {
  content: "\\F3A4";
}

.mdi-numeric-1-box-multiple::before {
  content: "\\FF2C";
}

.mdi-numeric-1-box-multiple-outline::before {
  content: "\\F3A5";
}

.mdi-numeric-1-box-outline::before {
  content: "\\F3A6";
}

.mdi-numeric-1-circle::before {
  content: "\\FC7C";
}

.mdi-numeric-1-circle-outline::before {
  content: "\\FC7D";
}

.mdi-numeric-10::before {
  content: "\\F000A";
}

.mdi-numeric-10-box::before {
  content: "\\FF9A";
}

.mdi-numeric-10-box-multiple::before {
  content: "\\F000B";
}

.mdi-numeric-10-box-multiple-outline::before {
  content: "\\F000C";
}

.mdi-numeric-10-box-outline::before {
  content: "\\FF9B";
}

.mdi-numeric-10-circle::before {
  content: "\\F000D";
}

.mdi-numeric-10-circle-outline::before {
  content: "\\F000E";
}

.mdi-numeric-2::before {
  content: "\\32";
}

.mdi-numeric-2-box::before {
  content: "\\F3A7";
}

.mdi-numeric-2-box-multiple::before {
  content: "\\FF2D";
}

.mdi-numeric-2-box-multiple-outline::before {
  content: "\\F3A8";
}

.mdi-numeric-2-box-outline::before {
  content: "\\F3A9";
}

.mdi-numeric-2-circle::before {
  content: "\\FC7E";
}

.mdi-numeric-2-circle-outline::before {
  content: "\\FC7F";
}

.mdi-numeric-3::before {
  content: "\\33";
}

.mdi-numeric-3-box::before {
  content: "\\F3AA";
}

.mdi-numeric-3-box-multiple::before {
  content: "\\FF2E";
}

.mdi-numeric-3-box-multiple-outline::before {
  content: "\\F3AB";
}

.mdi-numeric-3-box-outline::before {
  content: "\\F3AC";
}

.mdi-numeric-3-circle::before {
  content: "\\FC80";
}

.mdi-numeric-3-circle-outline::before {
  content: "\\FC81";
}

.mdi-numeric-4::before {
  content: "\\34";
}

.mdi-numeric-4-box::before {
  content: "\\F3AD";
}

.mdi-numeric-4-box-multiple::before {
  content: "\\FF2F";
}

.mdi-numeric-4-box-multiple-outline::before {
  content: "\\F3AE";
}

.mdi-numeric-4-box-outline::before {
  content: "\\F3AF";
}

.mdi-numeric-4-circle::before {
  content: "\\FC82";
}

.mdi-numeric-4-circle-outline::before {
  content: "\\FC83";
}

.mdi-numeric-5::before {
  content: "\\35";
}

.mdi-numeric-5-box::before {
  content: "\\F3B0";
}

.mdi-numeric-5-box-multiple::before {
  content: "\\FF30";
}

.mdi-numeric-5-box-multiple-outline::before {
  content: "\\F3B1";
}

.mdi-numeric-5-box-outline::before {
  content: "\\F3B2";
}

.mdi-numeric-5-circle::before {
  content: "\\FC84";
}

.mdi-numeric-5-circle-outline::before {
  content: "\\FC85";
}

.mdi-numeric-6::before {
  content: "\\36";
}

.mdi-numeric-6-box::before {
  content: "\\F3B3";
}

.mdi-numeric-6-box-multiple::before {
  content: "\\FF31";
}

.mdi-numeric-6-box-multiple-outline::before {
  content: "\\F3B4";
}

.mdi-numeric-6-box-outline::before {
  content: "\\F3B5";
}

.mdi-numeric-6-circle::before {
  content: "\\FC86";
}

.mdi-numeric-6-circle-outline::before {
  content: "\\FC87";
}

.mdi-numeric-7::before {
  content: "\\37";
}

.mdi-numeric-7-box::before {
  content: "\\F3B6";
}

.mdi-numeric-7-box-multiple::before {
  content: "\\FF32";
}

.mdi-numeric-7-box-multiple-outline::before {
  content: "\\F3B7";
}

.mdi-numeric-7-box-outline::before {
  content: "\\F3B8";
}

.mdi-numeric-7-circle::before {
  content: "\\FC88";
}

.mdi-numeric-7-circle-outline::before {
  content: "\\FC89";
}

.mdi-numeric-8::before {
  content: "\\38";
}

.mdi-numeric-8-box::before {
  content: "\\F3B9";
}

.mdi-numeric-8-box-multiple::before {
  content: "\\FF33";
}

.mdi-numeric-8-box-multiple-outline::before {
  content: "\\F3BA";
}

.mdi-numeric-8-box-outline::before {
  content: "\\F3BB";
}

.mdi-numeric-8-circle::before {
  content: "\\FC8A";
}

.mdi-numeric-8-circle-outline::before {
  content: "\\FC8B";
}

.mdi-numeric-9::before {
  content: "\\39";
}

.mdi-numeric-9-box::before {
  content: "\\F3BC";
}

.mdi-numeric-9-box-multiple::before {
  content: "\\FF34";
}

.mdi-numeric-9-box-multiple-outline::before {
  content: "\\F3BD";
}

.mdi-numeric-9-box-outline::before {
  content: "\\F3BE";
}

.mdi-numeric-9-circle::before {
  content: "\\FC8C";
}

.mdi-numeric-9-circle-outline::before {
  content: "\\FC8D";
}

.mdi-numeric-9-plus::before {
  content: "\\F000F";
}

.mdi-numeric-9-plus-box::before {
  content: "\\F3BF";
}

.mdi-numeric-9-plus-box-multiple::before {
  content: "\\FF35";
}

.mdi-numeric-9-plus-box-multiple-outline::before {
  content: "\\F3C0";
}

.mdi-numeric-9-plus-box-outline::before {
  content: "\\F3C1";
}

.mdi-numeric-9-plus-circle::before {
  content: "\\FC8E";
}

.mdi-numeric-9-plus-circle-outline::before {
  content: "\\FC8F";
}

.mdi-numeric-negative-1::before {
  content: "\\F0074";
}

.mdi-nut::before {
  content: "\\F6F7";
}

.mdi-nutrition::before {
  content: "\\F3C2";
}

.mdi-nuxt::before {
  content: "\\F0131";
}

.mdi-oar::before {
  content: "\\F67B";
}

.mdi-ocarina::before {
  content: "\\FDBC";
}

.mdi-oci::before {
  content: "\\F0314";
}

.mdi-ocr::before {
  content: "\\F0165";
}

.mdi-octagon::before {
  content: "\\F3C3";
}

.mdi-octagon-outline::before {
  content: "\\F3C4";
}

.mdi-octagram::before {
  content: "\\F6F8";
}

.mdi-octagram-outline::before {
  content: "\\F774";
}

.mdi-odnoklassniki::before {
  content: "\\F3C5";
}

.mdi-offer::before {
  content: "\\F0246";
}

.mdi-office::before {
  content: "\\F3C6";
}

.mdi-office-building::before {
  content: "\\F990";
}

.mdi-oil::before {
  content: "\\F3C7";
}

.mdi-oil-lamp::before {
  content: "\\FF36";
}

.mdi-oil-level::before {
  content: "\\F0075";
}

.mdi-oil-temperature::before {
  content: "\\F0019";
}

.mdi-omega::before {
  content: "\\F3C9";
}

.mdi-one-up::before {
  content: "\\FB89";
}

.mdi-onedrive::before {
  content: "\\F3CA";
}

.mdi-onenote::before {
  content: "\\F746";
}

.mdi-onepassword::before {
  content: "\\F880";
}

.mdi-opacity::before {
  content: "\\F5CC";
}

.mdi-open-in-app::before {
  content: "\\F3CB";
}

.mdi-open-in-new::before {
  content: "\\F3CC";
}

.mdi-open-source-initiative::before {
  content: "\\FB8A";
}

.mdi-openid::before {
  content: "\\F3CD";
}

.mdi-opera::before {
  content: "\\F3CE";
}

.mdi-orbit::before {
  content: "\\F018";
}

.mdi-origin::before {
  content: "\\FB2B";
}

.mdi-ornament::before {
  content: "\\F3CF";
}

.mdi-ornament-variant::before {
  content: "\\F3D0";
}

.mdi-outdoor-lamp::before {
  content: "\\F0076";
}

.mdi-outlook::before {
  content: "\\FCFE";
}

.mdi-overscan::before {
  content: "\\F0027";
}

.mdi-owl::before {
  content: "\\F3D2";
}

.mdi-pac-man::before {
  content: "\\FB8B";
}

.mdi-package::before {
  content: "\\F3D3";
}

.mdi-package-down::before {
  content: "\\F3D4";
}

.mdi-package-up::before {
  content: "\\F3D5";
}

.mdi-package-variant::before {
  content: "\\F3D6";
}

.mdi-package-variant-closed::before {
  content: "\\F3D7";
}

.mdi-page-first::before {
  content: "\\F600";
}

.mdi-page-last::before {
  content: "\\F601";
}

.mdi-page-layout-body::before {
  content: "\\F6F9";
}

.mdi-page-layout-footer::before {
  content: "\\F6FA";
}

.mdi-page-layout-header::before {
  content: "\\F6FB";
}

.mdi-page-layout-header-footer::before {
  content: "\\FF9C";
}

.mdi-page-layout-sidebar-left::before {
  content: "\\F6FC";
}

.mdi-page-layout-sidebar-right::before {
  content: "\\F6FD";
}

.mdi-page-next::before {
  content: "\\FB8C";
}

.mdi-page-next-outline::before {
  content: "\\FB8D";
}

.mdi-page-previous::before {
  content: "\\FB8E";
}

.mdi-page-previous-outline::before {
  content: "\\FB8F";
}

.mdi-palette::before {
  content: "\\F3D8";
}

.mdi-palette-advanced::before {
  content: "\\F3D9";
}

.mdi-palette-outline::before {
  content: "\\FE6C";
}

.mdi-palette-swatch::before {
  content: "\\F8B4";
}

.mdi-palette-swatch-outline::before {
  content: "\\F0387";
}

.mdi-palm-tree::before {
  content: "\\F0077";
}

.mdi-pan::before {
  content: "\\FB90";
}

.mdi-pan-bottom-left::before {
  content: "\\FB91";
}

.mdi-pan-bottom-right::before {
  content: "\\FB92";
}

.mdi-pan-down::before {
  content: "\\FB93";
}

.mdi-pan-horizontal::before {
  content: "\\FB94";
}

.mdi-pan-left::before {
  content: "\\FB95";
}

.mdi-pan-right::before {
  content: "\\FB96";
}

.mdi-pan-top-left::before {
  content: "\\FB97";
}

.mdi-pan-top-right::before {
  content: "\\FB98";
}

.mdi-pan-up::before {
  content: "\\FB99";
}

.mdi-pan-vertical::before {
  content: "\\FB9A";
}

.mdi-panda::before {
  content: "\\F3DA";
}

.mdi-pandora::before {
  content: "\\F3DB";
}

.mdi-panorama::before {
  content: "\\F3DC";
}

.mdi-panorama-fisheye::before {
  content: "\\F3DD";
}

.mdi-panorama-horizontal::before {
  content: "\\F3DE";
}

.mdi-panorama-vertical::before {
  content: "\\F3DF";
}

.mdi-panorama-wide-angle::before {
  content: "\\F3E0";
}

.mdi-paper-cut-vertical::before {
  content: "\\F3E1";
}

.mdi-paper-roll::before {
  content: "\\F0182";
}

.mdi-paper-roll-outline::before {
  content: "\\F0183";
}

.mdi-paperclip::before {
  content: "\\F3E2";
}

.mdi-parachute::before {
  content: "\\FC90";
}

.mdi-parachute-outline::before {
  content: "\\FC91";
}

.mdi-parking::before {
  content: "\\F3E3";
}

.mdi-party-popper::before {
  content: "\\F0078";
}

.mdi-passport::before {
  content: "\\F7E2";
}

.mdi-passport-biometric::before {
  content: "\\FDBD";
}

.mdi-pasta::before {
  content: "\\F018B";
}

.mdi-patio-heater::before {
  content: "\\FF9D";
}

.mdi-patreon::before {
  content: "\\F881";
}

.mdi-pause::before {
  content: "\\F3E4";
}

.mdi-pause-circle::before {
  content: "\\F3E5";
}

.mdi-pause-circle-outline::before {
  content: "\\F3E6";
}

.mdi-pause-octagon::before {
  content: "\\F3E7";
}

.mdi-pause-octagon-outline::before {
  content: "\\F3E8";
}

.mdi-paw::before {
  content: "\\F3E9";
}

.mdi-paw-off::before {
  content: "\\F657";
}

.mdi-paypal::before {
  content: "\\F882";
}

.mdi-pdf-box::before {
  content: "\\FE39";
}

.mdi-peace::before {
  content: "\\F883";
}

.mdi-peanut::before {
  content: "\\F001E";
}

.mdi-peanut-off::before {
  content: "\\F001F";
}

.mdi-peanut-off-outline::before {
  content: "\\F0021";
}

.mdi-peanut-outline::before {
  content: "\\F0020";
}

.mdi-pen::before {
  content: "\\F3EA";
}

.mdi-pen-lock::before {
  content: "\\FDBE";
}

.mdi-pen-minus::before {
  content: "\\FDBF";
}

.mdi-pen-off::before {
  content: "\\FDC0";
}

.mdi-pen-plus::before {
  content: "\\FDC1";
}

.mdi-pen-remove::before {
  content: "\\FDC2";
}

.mdi-pencil::before {
  content: "\\F3EB";
}

.mdi-pencil-box::before {
  content: "\\F3EC";
}

.mdi-pencil-box-multiple::before {
  content: "\\F016F";
}

.mdi-pencil-box-multiple-outline::before {
  content: "\\F0170";
}

.mdi-pencil-box-outline::before {
  content: "\\F3ED";
}

.mdi-pencil-circle::before {
  content: "\\F6FE";
}

.mdi-pencil-circle-outline::before {
  content: "\\F775";
}

.mdi-pencil-lock::before {
  content: "\\F3EE";
}

.mdi-pencil-lock-outline::before {
  content: "\\FDC3";
}

.mdi-pencil-minus::before {
  content: "\\FDC4";
}

.mdi-pencil-minus-outline::before {
  content: "\\FDC5";
}

.mdi-pencil-off::before {
  content: "\\F3EF";
}

.mdi-pencil-off-outline::before {
  content: "\\FDC6";
}

.mdi-pencil-outline::before {
  content: "\\FC92";
}

.mdi-pencil-plus::before {
  content: "\\FDC7";
}

.mdi-pencil-plus-outline::before {
  content: "\\FDC8";
}

.mdi-pencil-remove::before {
  content: "\\FDC9";
}

.mdi-pencil-remove-outline::before {
  content: "\\FDCA";
}

.mdi-pencil-ruler::before {
  content: "\\F037E";
}

.mdi-penguin::before {
  content: "\\FEDD";
}

.mdi-pentagon::before {
  content: "\\F6FF";
}

.mdi-pentagon-outline::before {
  content: "\\F700";
}

.mdi-percent::before {
  content: "\\F3F0";
}

.mdi-percent-outline::before {
  content: "\\F02A3";
}

.mdi-periodic-table::before {
  content: "\\F8B5";
}

.mdi-periodic-table-co::before {
  content: "\\F0329";
}

.mdi-periodic-table-co2::before {
  content: "\\F7E3";
}

.mdi-periscope::before {
  content: "\\F747";
}

.mdi-perspective-less::before {
  content: "\\FCFF";
}

.mdi-perspective-more::before {
  content: "\\FD00";
}

.mdi-pharmacy::before {
  content: "\\F3F1";
}

.mdi-phone::before {
  content: "\\F3F2";
}

.mdi-phone-alert::before {
  content: "\\FF37";
}

.mdi-phone-alert-outline::before {
  content: "\\F01B9";
}

.mdi-phone-bluetooth::before {
  content: "\\F3F3";
}

.mdi-phone-bluetooth-outline::before {
  content: "\\F01BA";
}

.mdi-phone-cancel::before {
  content: "\\F00E7";
}

.mdi-phone-cancel-outline::before {
  content: "\\F01BB";
}

.mdi-phone-check::before {
  content: "\\F01D4";
}

.mdi-phone-check-outline::before {
  content: "\\F01D5";
}

.mdi-phone-classic::before {
  content: "\\F602";
}

.mdi-phone-classic-off::before {
  content: "\\F02A4";
}

.mdi-phone-forward::before {
  content: "\\F3F4";
}

.mdi-phone-forward-outline::before {
  content: "\\F01BC";
}

.mdi-phone-hangup::before {
  content: "\\F3F5";
}

.mdi-phone-hangup-outline::before {
  content: "\\F01BD";
}

.mdi-phone-in-talk::before {
  content: "\\F3F6";
}

.mdi-phone-in-talk-outline::before {
  content: "\\F01AD";
}

.mdi-phone-incoming::before {
  content: "\\F3F7";
}

.mdi-phone-incoming-outline::before {
  content: "\\F01BE";
}

.mdi-phone-lock::before {
  content: "\\F3F8";
}

.mdi-phone-lock-outline::before {
  content: "\\F01BF";
}

.mdi-phone-log::before {
  content: "\\F3F9";
}

.mdi-phone-log-outline::before {
  content: "\\F01C0";
}

.mdi-phone-message::before {
  content: "\\F01C1";
}

.mdi-phone-message-outline::before {
  content: "\\F01C2";
}

.mdi-phone-minus::before {
  content: "\\F658";
}

.mdi-phone-minus-outline::before {
  content: "\\F01C3";
}

.mdi-phone-missed::before {
  content: "\\F3FA";
}

.mdi-phone-missed-outline::before {
  content: "\\F01D0";
}

.mdi-phone-off::before {
  content: "\\FDCB";
}

.mdi-phone-off-outline::before {
  content: "\\F01D1";
}

.mdi-phone-outgoing::before {
  content: "\\F3FB";
}

.mdi-phone-outgoing-outline::before {
  content: "\\F01C4";
}

.mdi-phone-outline::before {
  content: "\\FDCC";
}

.mdi-phone-paused::before {
  content: "\\F3FC";
}

.mdi-phone-paused-outline::before {
  content: "\\F01C5";
}

.mdi-phone-plus::before {
  content: "\\F659";
}

.mdi-phone-plus-outline::before {
  content: "\\F01C6";
}

.mdi-phone-return::before {
  content: "\\F82E";
}

.mdi-phone-return-outline::before {
  content: "\\F01C7";
}

.mdi-phone-ring::before {
  content: "\\F01D6";
}

.mdi-phone-ring-outline::before {
  content: "\\F01D7";
}

.mdi-phone-rotate-landscape::before {
  content: "\\F884";
}

.mdi-phone-rotate-portrait::before {
  content: "\\F885";
}

.mdi-phone-settings::before {
  content: "\\F3FD";
}

.mdi-phone-settings-outline::before {
  content: "\\F01C8";
}

.mdi-phone-voip::before {
  content: "\\F3FE";
}

.mdi-pi::before {
  content: "\\F3FF";
}

.mdi-pi-box::before {
  content: "\\F400";
}

.mdi-pi-hole::before {
  content: "\\FDCD";
}

.mdi-piano::before {
  content: "\\F67C";
}

.mdi-pickaxe::before {
  content: "\\F8B6";
}

.mdi-picture-in-picture-bottom-right::before {
  content: "\\FE3A";
}

.mdi-picture-in-picture-bottom-right-outline::before {
  content: "\\FE3B";
}

.mdi-picture-in-picture-top-right::before {
  content: "\\FE3C";
}

.mdi-picture-in-picture-top-right-outline::before {
  content: "\\FE3D";
}

.mdi-pier::before {
  content: "\\F886";
}

.mdi-pier-crane::before {
  content: "\\F887";
}

.mdi-pig::before {
  content: "\\F401";
}

.mdi-pig-variant::before {
  content: "\\F0028";
}

.mdi-piggy-bank::before {
  content: "\\F0029";
}

.mdi-pill::before {
  content: "\\F402";
}

.mdi-pillar::before {
  content: "\\F701";
}

.mdi-pin::before {
  content: "\\F403";
}

.mdi-pin-off::before {
  content: "\\F404";
}

.mdi-pin-off-outline::before {
  content: "\\F92F";
}

.mdi-pin-outline::before {
  content: "\\F930";
}

.mdi-pine-tree::before {
  content: "\\F405";
}

.mdi-pine-tree-box::before {
  content: "\\F406";
}

.mdi-pinterest::before {
  content: "\\F407";
}

.mdi-pinterest-box::before {
  content: "\\F408";
}

.mdi-pinwheel::before {
  content: "\\FAD4";
}

.mdi-pinwheel-outline::before {
  content: "\\FAD5";
}

.mdi-pipe::before {
  content: "\\F7E4";
}

.mdi-pipe-disconnected::before {
  content: "\\F7E5";
}

.mdi-pipe-leak::before {
  content: "\\F888";
}

.mdi-pipe-wrench::before {
  content: "\\F037F";
}

.mdi-pirate::before {
  content: "\\FA07";
}

.mdi-pistol::before {
  content: "\\F702";
}

.mdi-piston::before {
  content: "\\F889";
}

.mdi-pizza::before {
  content: "\\F409";
}

.mdi-play::before {
  content: "\\F40A";
}

.mdi-play-box::before {
  content: "\\F02A5";
}

.mdi-play-box-outline::before {
  content: "\\F40B";
}

.mdi-play-circle::before {
  content: "\\F40C";
}

.mdi-play-circle-outline::before {
  content: "\\F40D";
}

.mdi-play-network::before {
  content: "\\F88A";
}

.mdi-play-network-outline::before {
  content: "\\FC93";
}

.mdi-play-outline::before {
  content: "\\FF38";
}

.mdi-play-pause::before {
  content: "\\F40E";
}

.mdi-play-protected-content::before {
  content: "\\F40F";
}

.mdi-play-speed::before {
  content: "\\F8FE";
}

.mdi-playlist-check::before {
  content: "\\F5C7";
}

.mdi-playlist-edit::before {
  content: "\\F8FF";
}

.mdi-playlist-minus::before {
  content: "\\F410";
}

.mdi-playlist-music::before {
  content: "\\FC94";
}

.mdi-playlist-music-outline::before {
  content: "\\FC95";
}

.mdi-playlist-play::before {
  content: "\\F411";
}

.mdi-playlist-plus::before {
  content: "\\F412";
}

.mdi-playlist-remove::before {
  content: "\\F413";
}

.mdi-playlist-star::before {
  content: "\\FDCE";
}

.mdi-playstation::before {
  content: "\\F414";
}

.mdi-plex::before {
  content: "\\F6B9";
}

.mdi-plus::before {
  content: "\\F415";
}

.mdi-plus-box::before {
  content: "\\F416";
}

.mdi-plus-box-multiple::before {
  content: "\\F334";
}

.mdi-plus-box-multiple-outline::before {
  content: "\\F016E";
}

.mdi-plus-box-outline::before {
  content: "\\F703";
}

.mdi-plus-circle::before {
  content: "\\F417";
}

.mdi-plus-circle-multiple-outline::before {
  content: "\\F418";
}

.mdi-plus-circle-outline::before {
  content: "\\F419";
}

.mdi-plus-minus::before {
  content: "\\F991";
}

.mdi-plus-minus-box::before {
  content: "\\F992";
}

.mdi-plus-network::before {
  content: "\\F41A";
}

.mdi-plus-network-outline::before {
  content: "\\FC96";
}

.mdi-plus-one::before {
  content: "\\F41B";
}

.mdi-plus-outline::before {
  content: "\\F704";
}

.mdi-plus-thick::before {
  content: "\\F0217";
}

.mdi-pocket::before {
  content: "\\F41C";
}

.mdi-podcast::before {
  content: "\\F993";
}

.mdi-podium::before {
  content: "\\FD01";
}

.mdi-podium-bronze::before {
  content: "\\FD02";
}

.mdi-podium-gold::before {
  content: "\\FD03";
}

.mdi-podium-silver::before {
  content: "\\FD04";
}

.mdi-point-of-sale::before {
  content: "\\FD6E";
}

.mdi-pokeball::before {
  content: "\\F41D";
}

.mdi-pokemon-go::before {
  content: "\\FA08";
}

.mdi-poker-chip::before {
  content: "\\F82F";
}

.mdi-polaroid::before {
  content: "\\F41E";
}

.mdi-police-badge::before {
  content: "\\F0192";
}

.mdi-police-badge-outline::before {
  content: "\\F0193";
}

.mdi-poll::before {
  content: "\\F41F";
}

.mdi-poll-box::before {
  content: "\\F420";
}

.mdi-poll-box-outline::before {
  content: "\\F02A6";
}

.mdi-polymer::before {
  content: "\\F421";
}

.mdi-pool::before {
  content: "\\F606";
}

.mdi-popcorn::before {
  content: "\\F422";
}

.mdi-post::before {
  content: "\\F002A";
}

.mdi-post-outline::before {
  content: "\\F002B";
}

.mdi-postage-stamp::before {
  content: "\\FC97";
}

.mdi-pot::before {
  content: "\\F65A";
}

.mdi-pot-mix::before {
  content: "\\F65B";
}

.mdi-pound::before {
  content: "\\F423";
}

.mdi-pound-box::before {
  content: "\\F424";
}

.mdi-pound-box-outline::before {
  content: "\\F01AA";
}

.mdi-power::before {
  content: "\\F425";
}

.mdi-power-cycle::before {
  content: "\\F900";
}

.mdi-power-off::before {
  content: "\\F901";
}

.mdi-power-on::before {
  content: "\\F902";
}

.mdi-power-plug::before {
  content: "\\F6A4";
}

.mdi-power-plug-off::before {
  content: "\\F6A5";
}

.mdi-power-settings::before {
  content: "\\F426";
}

.mdi-power-sleep::before {
  content: "\\F903";
}

.mdi-power-socket::before {
  content: "\\F427";
}

.mdi-power-socket-au::before {
  content: "\\F904";
}

.mdi-power-socket-de::before {
  content: "\\F0132";
}

.mdi-power-socket-eu::before {
  content: "\\F7E6";
}

.mdi-power-socket-fr::before {
  content: "\\F0133";
}

.mdi-power-socket-jp::before {
  content: "\\F0134";
}

.mdi-power-socket-uk::before {
  content: "\\F7E7";
}

.mdi-power-socket-us::before {
  content: "\\F7E8";
}

.mdi-power-standby::before {
  content: "\\F905";
}

.mdi-powershell::before {
  content: "\\FA09";
}

.mdi-prescription::before {
  content: "\\F705";
}

.mdi-presentation::before {
  content: "\\F428";
}

.mdi-presentation-play::before {
  content: "\\F429";
}

.mdi-printer::before {
  content: "\\F42A";
}

.mdi-printer-3d::before {
  content: "\\F42B";
}

.mdi-printer-3d-nozzle::before {
  content: "\\FE3E";
}

.mdi-printer-3d-nozzle-alert::before {
  content: "\\F01EB";
}

.mdi-printer-3d-nozzle-alert-outline::before {
  content: "\\F01EC";
}

.mdi-printer-3d-nozzle-outline::before {
  content: "\\FE3F";
}

.mdi-printer-alert::before {
  content: "\\F42C";
}

.mdi-printer-check::before {
  content: "\\F0171";
}

.mdi-printer-off::before {
  content: "\\FE40";
}

.mdi-printer-pos::before {
  content: "\\F0079";
}

.mdi-printer-settings::before {
  content: "\\F706";
}

.mdi-printer-wireless::before {
  content: "\\FA0A";
}

.mdi-priority-high::before {
  content: "\\F603";
}

.mdi-priority-low::before {
  content: "\\F604";
}

.mdi-professional-hexagon::before {
  content: "\\F42D";
}

.mdi-progress-alert::before {
  content: "\\FC98";
}

.mdi-progress-check::before {
  content: "\\F994";
}

.mdi-progress-clock::before {
  content: "\\F995";
}

.mdi-progress-close::before {
  content: "\\F0135";
}

.mdi-progress-download::before {
  content: "\\F996";
}

.mdi-progress-upload::before {
  content: "\\F997";
}

.mdi-progress-wrench::before {
  content: "\\FC99";
}

.mdi-projector::before {
  content: "\\F42E";
}

.mdi-projector-screen::before {
  content: "\\F42F";
}

.mdi-propane-tank::before {
  content: "\\F0382";
}

.mdi-propane-tank-outline::before {
  content: "\\F0383";
}

.mdi-protocol::before {
  content: "\\FFF9";
}

.mdi-publish::before {
  content: "\\F6A6";
}

.mdi-pulse::before {
  content: "\\F430";
}

.mdi-pumpkin::before {
  content: "\\FB9B";
}

.mdi-purse::before {
  content: "\\FF39";
}

.mdi-purse-outline::before {
  content: "\\FF3A";
}

.mdi-puzzle::before {
  content: "\\F431";
}

.mdi-puzzle-outline::before {
  content: "\\FA65";
}

.mdi-qi::before {
  content: "\\F998";
}

.mdi-qqchat::before {
  content: "\\F605";
}

.mdi-qrcode::before {
  content: "\\F432";
}

.mdi-qrcode-edit::before {
  content: "\\F8B7";
}

.mdi-qrcode-minus::before {
  content: "\\F01B7";
}

.mdi-qrcode-plus::before {
  content: "\\F01B6";
}

.mdi-qrcode-remove::before {
  content: "\\F01B8";
}

.mdi-qrcode-scan::before {
  content: "\\F433";
}

.mdi-quadcopter::before {
  content: "\\F434";
}

.mdi-quality-high::before {
  content: "\\F435";
}

.mdi-quality-low::before {
  content: "\\FA0B";
}

.mdi-quality-medium::before {
  content: "\\FA0C";
}

.mdi-quicktime::before {
  content: "\\F436";
}

.mdi-quora::before {
  content: "\\FD05";
}

.mdi-rabbit::before {
  content: "\\F906";
}

.mdi-racing-helmet::before {
  content: "\\FD6F";
}

.mdi-racquetball::before {
  content: "\\FD70";
}

.mdi-radar::before {
  content: "\\F437";
}

.mdi-radiator::before {
  content: "\\F438";
}

.mdi-radiator-disabled::before {
  content: "\\FAD6";
}

.mdi-radiator-off::before {
  content: "\\FAD7";
}

.mdi-radio::before {
  content: "\\F439";
}

.mdi-radio-am::before {
  content: "\\FC9A";
}

.mdi-radio-fm::before {
  content: "\\FC9B";
}

.mdi-radio-handheld::before {
  content: "\\F43A";
}

.mdi-radio-off::before {
  content: "\\F0247";
}

.mdi-radio-tower::before {
  content: "\\F43B";
}

.mdi-radioactive::before {
  content: "\\F43C";
}

.mdi-radioactive-off::before {
  content: "\\FEDE";
}

.mdi-radiobox-blank::before {
  content: "\\F43D";
}

.mdi-radiobox-marked::before {
  content: "\\F43E";
}

.mdi-radius::before {
  content: "\\FC9C";
}

.mdi-radius-outline::before {
  content: "\\FC9D";
}

.mdi-railroad-light::before {
  content: "\\FF3B";
}

.mdi-raspberry-pi::before {
  content: "\\F43F";
}

.mdi-ray-end::before {
  content: "\\F440";
}

.mdi-ray-end-arrow::before {
  content: "\\F441";
}

.mdi-ray-start::before {
  content: "\\F442";
}

.mdi-ray-start-arrow::before {
  content: "\\F443";
}

.mdi-ray-start-end::before {
  content: "\\F444";
}

.mdi-ray-vertex::before {
  content: "\\F445";
}

.mdi-react::before {
  content: "\\F707";
}

.mdi-read::before {
  content: "\\F447";
}

.mdi-receipt::before {
  content: "\\F449";
}

.mdi-record::before {
  content: "\\F44A";
}

.mdi-record-circle::before {
  content: "\\FEDF";
}

.mdi-record-circle-outline::before {
  content: "\\FEE0";
}

.mdi-record-player::before {
  content: "\\F999";
}

.mdi-record-rec::before {
  content: "\\F44B";
}

.mdi-rectangle::before {
  content: "\\FE41";
}

.mdi-rectangle-outline::before {
  content: "\\FE42";
}

.mdi-recycle::before {
  content: "\\F44C";
}

.mdi-reddit::before {
  content: "\\F44D";
}

.mdi-redhat::before {
  content: "\\F0146";
}

.mdi-redo::before {
  content: "\\F44E";
}

.mdi-redo-variant::before {
  content: "\\F44F";
}

.mdi-reflect-horizontal::before {
  content: "\\FA0D";
}

.mdi-reflect-vertical::before {
  content: "\\FA0E";
}

.mdi-refresh::before {
  content: "\\F450";
}

.mdi-refresh-circle::before {
  content: "\\F03A2";
}

.mdi-regex::before {
  content: "\\F451";
}

.mdi-registered-trademark::before {
  content: "\\FA66";
}

.mdi-relative-scale::before {
  content: "\\F452";
}

.mdi-reload::before {
  content: "\\F453";
}

.mdi-reload-alert::before {
  content: "\\F0136";
}

.mdi-reminder::before {
  content: "\\F88B";
}

.mdi-remote::before {
  content: "\\F454";
}

.mdi-remote-desktop::before {
  content: "\\F8B8";
}

.mdi-remote-off::before {
  content: "\\FEE1";
}

.mdi-remote-tv::before {
  content: "\\FEE2";
}

.mdi-remote-tv-off::before {
  content: "\\FEE3";
}

.mdi-rename-box::before {
  content: "\\F455";
}

.mdi-reorder-horizontal::before {
  content: "\\F687";
}

.mdi-reorder-vertical::before {
  content: "\\F688";
}

.mdi-repeat::before {
  content: "\\F456";
}

.mdi-repeat-off::before {
  content: "\\F457";
}

.mdi-repeat-once::before {
  content: "\\F458";
}

.mdi-replay::before {
  content: "\\F459";
}

.mdi-reply::before {
  content: "\\F45A";
}

.mdi-reply-all::before {
  content: "\\F45B";
}

.mdi-reply-all-outline::before {
  content: "\\FF3C";
}

.mdi-reply-circle::before {
  content: "\\F01D9";
}

.mdi-reply-outline::before {
  content: "\\FF3D";
}

.mdi-reproduction::before {
  content: "\\F45C";
}

.mdi-resistor::before {
  content: "\\FB1F";
}

.mdi-resistor-nodes::before {
  content: "\\FB20";
}

.mdi-resize::before {
  content: "\\FA67";
}

.mdi-resize-bottom-right::before {
  content: "\\F45D";
}

.mdi-responsive::before {
  content: "\\F45E";
}

.mdi-restart::before {
  content: "\\F708";
}

.mdi-restart-alert::before {
  content: "\\F0137";
}

.mdi-restart-off::before {
  content: "\\FD71";
}

.mdi-restore::before {
  content: "\\F99A";
}

.mdi-restore-alert::before {
  content: "\\F0138";
}

.mdi-rewind::before {
  content: "\\F45F";
}

.mdi-rewind-10::before {
  content: "\\FD06";
}

.mdi-rewind-30::before {
  content: "\\FD72";
}

.mdi-rewind-5::before {
  content: "\\F0224";
}

.mdi-rewind-outline::before {
  content: "\\F709";
}

.mdi-rhombus::before {
  content: "\\F70A";
}

.mdi-rhombus-medium::before {
  content: "\\FA0F";
}

.mdi-rhombus-outline::before {
  content: "\\F70B";
}

.mdi-rhombus-split::before {
  content: "\\FA10";
}

.mdi-ribbon::before {
  content: "\\F460";
}

.mdi-rice::before {
  content: "\\F7E9";
}

.mdi-ring::before {
  content: "\\F7EA";
}

.mdi-rivet::before {
  content: "\\FE43";
}

.mdi-road::before {
  content: "\\F461";
}

.mdi-road-variant::before {
  content: "\\F462";
}

.mdi-robber::before {
  content: "\\F007A";
}

.mdi-robot::before {
  content: "\\F6A8";
}

.mdi-robot-industrial::before {
  content: "\\FB21";
}

.mdi-robot-mower::before {
  content: "\\F0222";
}

.mdi-robot-mower-outline::before {
  content: "\\F021E";
}

.mdi-robot-vacuum::before {
  content: "\\F70C";
}

.mdi-robot-vacuum-variant::before {
  content: "\\F907";
}

.mdi-rocket::before {
  content: "\\F463";
}

.mdi-rodent::before {
  content: "\\F0352";
}

.mdi-roller-skate::before {
  content: "\\FD07";
}

.mdi-rollerblade::before {
  content: "\\FD08";
}

.mdi-rollupjs::before {
  content: "\\FB9C";
}

.mdi-roman-numeral-1::before {
  content: "\\F00B3";
}

.mdi-roman-numeral-10::before {
  content: "\\F00BC";
}

.mdi-roman-numeral-2::before {
  content: "\\F00B4";
}

.mdi-roman-numeral-3::before {
  content: "\\F00B5";
}

.mdi-roman-numeral-4::before {
  content: "\\F00B6";
}

.mdi-roman-numeral-5::before {
  content: "\\F00B7";
}

.mdi-roman-numeral-6::before {
  content: "\\F00B8";
}

.mdi-roman-numeral-7::before {
  content: "\\F00B9";
}

.mdi-roman-numeral-8::before {
  content: "\\F00BA";
}

.mdi-roman-numeral-9::before {
  content: "\\F00BB";
}

.mdi-room-service::before {
  content: "\\F88C";
}

.mdi-room-service-outline::before {
  content: "\\FD73";
}

.mdi-rotate-3d::before {
  content: "\\FEE4";
}

.mdi-rotate-3d-variant::before {
  content: "\\F464";
}

.mdi-rotate-left::before {
  content: "\\F465";
}

.mdi-rotate-left-variant::before {
  content: "\\F466";
}

.mdi-rotate-orbit::before {
  content: "\\FD74";
}

.mdi-rotate-right::before {
  content: "\\F467";
}

.mdi-rotate-right-variant::before {
  content: "\\F468";
}

.mdi-rounded-corner::before {
  content: "\\F607";
}

.mdi-router::before {
  content: "\\F020D";
}

.mdi-router-wireless::before {
  content: "\\F469";
}

.mdi-router-wireless-settings::before {
  content: "\\FA68";
}

.mdi-routes::before {
  content: "\\F46A";
}

.mdi-routes-clock::before {
  content: "\\F007B";
}

.mdi-rowing::before {
  content: "\\F608";
}

.mdi-rss::before {
  content: "\\F46B";
}

.mdi-rss-box::before {
  content: "\\F46C";
}

.mdi-rss-off::before {
  content: "\\FF3E";
}

.mdi-ruby::before {
  content: "\\FD09";
}

.mdi-rugby::before {
  content: "\\FD75";
}

.mdi-ruler::before {
  content: "\\F46D";
}

.mdi-ruler-square::before {
  content: "\\FC9E";
}

.mdi-ruler-square-compass::before {
  content: "\\FEDB";
}

.mdi-run::before {
  content: "\\F70D";
}

.mdi-run-fast::before {
  content: "\\F46E";
}

.mdi-rv-truck::before {
  content: "\\F01FF";
}

.mdi-sack::before {
  content: "\\FD0A";
}

.mdi-sack-percent::before {
  content: "\\FD0B";
}

.mdi-safe::before {
  content: "\\FA69";
}

.mdi-safe-square::before {
  content: "\\F02A7";
}

.mdi-safe-square-outline::before {
  content: "\\F02A8";
}

.mdi-safety-goggles::before {
  content: "\\FD0C";
}

.mdi-sailing::before {
  content: "\\FEE5";
}

.mdi-sale::before {
  content: "\\F46F";
}

.mdi-salesforce::before {
  content: "\\F88D";
}

.mdi-sass::before {
  content: "\\F7EB";
}

.mdi-satellite::before {
  content: "\\F470";
}

.mdi-satellite-uplink::before {
  content: "\\F908";
}

.mdi-satellite-variant::before {
  content: "\\F471";
}

.mdi-sausage::before {
  content: "\\F8B9";
}

.mdi-saw-blade::before {
  content: "\\FE44";
}

.mdi-saxophone::before {
  content: "\\F609";
}

.mdi-scale::before {
  content: "\\F472";
}

.mdi-scale-balance::before {
  content: "\\F5D1";
}

.mdi-scale-bathroom::before {
  content: "\\F473";
}

.mdi-scale-off::before {
  content: "\\F007C";
}

.mdi-scanner::before {
  content: "\\F6AA";
}

.mdi-scanner-off::before {
  content: "\\F909";
}

.mdi-scatter-plot::before {
  content: "\\FEE6";
}

.mdi-scatter-plot-outline::before {
  content: "\\FEE7";
}

.mdi-school::before {
  content: "\\F474";
}

.mdi-school-outline::before {
  content: "\\F01AB";
}

.mdi-scissors-cutting::before {
  content: "\\FA6A";
}

.mdi-scooter::before {
  content: "\\F0214";
}

.mdi-scoreboard::before {
  content: "\\F02A9";
}

.mdi-scoreboard-outline::before {
  content: "\\F02AA";
}

.mdi-screen-rotation::before {
  content: "\\F475";
}

.mdi-screen-rotation-lock::before {
  content: "\\F476";
}

.mdi-screw-flat-top::before {
  content: "\\FDCF";
}

.mdi-screw-lag::before {
  content: "\\FE54";
}

.mdi-screw-machine-flat-top::before {
  content: "\\FE55";
}

.mdi-screw-machine-round-top::before {
  content: "\\FE56";
}

.mdi-screw-round-top::before {
  content: "\\FE57";
}

.mdi-screwdriver::before {
  content: "\\F477";
}

.mdi-script::before {
  content: "\\FB9D";
}

.mdi-script-outline::before {
  content: "\\F478";
}

.mdi-script-text::before {
  content: "\\FB9E";
}

.mdi-script-text-outline::before {
  content: "\\FB9F";
}

.mdi-sd::before {
  content: "\\F479";
}

.mdi-seal::before {
  content: "\\F47A";
}

.mdi-seal-variant::before {
  content: "\\FFFA";
}

.mdi-search-web::before {
  content: "\\F70E";
}

.mdi-seat::before {
  content: "\\FC9F";
}

.mdi-seat-flat::before {
  content: "\\F47B";
}

.mdi-seat-flat-angled::before {
  content: "\\F47C";
}

.mdi-seat-individual-suite::before {
  content: "\\F47D";
}

.mdi-seat-legroom-extra::before {
  content: "\\F47E";
}

.mdi-seat-legroom-normal::before {
  content: "\\F47F";
}

.mdi-seat-legroom-reduced::before {
  content: "\\F480";
}

.mdi-seat-outline::before {
  content: "\\FCA0";
}

.mdi-seat-passenger::before {
  content: "\\F0274";
}

.mdi-seat-recline-extra::before {
  content: "\\F481";
}

.mdi-seat-recline-normal::before {
  content: "\\F482";
}

.mdi-seatbelt::before {
  content: "\\FCA1";
}

.mdi-security::before {
  content: "\\F483";
}

.mdi-security-network::before {
  content: "\\F484";
}

.mdi-seed::before {
  content: "\\FE45";
}

.mdi-seed-outline::before {
  content: "\\FE46";
}

.mdi-segment::before {
  content: "\\FEE8";
}

.mdi-select::before {
  content: "\\F485";
}

.mdi-select-all::before {
  content: "\\F486";
}

.mdi-select-color::before {
  content: "\\FD0D";
}

.mdi-select-compare::before {
  content: "\\FAD8";
}

.mdi-select-drag::before {
  content: "\\FA6B";
}

.mdi-select-group::before {
  content: "\\FF9F";
}

.mdi-select-inverse::before {
  content: "\\F487";
}

.mdi-select-marker::before {
  content: "\\F02AB";
}

.mdi-select-multiple::before {
  content: "\\F02AC";
}

.mdi-select-multiple-marker::before {
  content: "\\F02AD";
}

.mdi-select-off::before {
  content: "\\F488";
}

.mdi-select-place::before {
  content: "\\FFFB";
}

.mdi-select-search::before {
  content: "\\F022F";
}

.mdi-selection::before {
  content: "\\F489";
}

.mdi-selection-drag::before {
  content: "\\FA6C";
}

.mdi-selection-ellipse::before {
  content: "\\FD0E";
}

.mdi-selection-ellipse-arrow-inside::before {
  content: "\\FF3F";
}

.mdi-selection-marker::before {
  content: "\\F02AE";
}

.mdi-selection-multiple-marker::before {
  content: "\\F02AF";
}

.mdi-selection-mutliple::before {
  content: "\\F02B0";
}

.mdi-selection-off::before {
  content: "\\F776";
}

.mdi-selection-search::before {
  content: "\\F0230";
}

.mdi-semantic-web::before {
  content: "\\F0341";
}

.mdi-send::before {
  content: "\\F48A";
}

.mdi-send-check::before {
  content: "\\F018C";
}

.mdi-send-check-outline::before {
  content: "\\F018D";
}

.mdi-send-circle::before {
  content: "\\FE58";
}

.mdi-send-circle-outline::before {
  content: "\\FE59";
}

.mdi-send-clock::before {
  content: "\\F018E";
}

.mdi-send-clock-outline::before {
  content: "\\F018F";
}

.mdi-send-lock::before {
  content: "\\F7EC";
}

.mdi-send-lock-outline::before {
  content: "\\F0191";
}

.mdi-send-outline::before {
  content: "\\F0190";
}

.mdi-serial-port::before {
  content: "\\F65C";
}

.mdi-server::before {
  content: "\\F48B";
}

.mdi-server-minus::before {
  content: "\\F48C";
}

.mdi-server-network::before {
  content: "\\F48D";
}

.mdi-server-network-off::before {
  content: "\\F48E";
}

.mdi-server-off::before {
  content: "\\F48F";
}

.mdi-server-plus::before {
  content: "\\F490";
}

.mdi-server-remove::before {
  content: "\\F491";
}

.mdi-server-security::before {
  content: "\\F492";
}

.mdi-set-all::before {
  content: "\\F777";
}

.mdi-set-center::before {
  content: "\\F778";
}

.mdi-set-center-right::before {
  content: "\\F779";
}

.mdi-set-left::before {
  content: "\\F77A";
}

.mdi-set-left-center::before {
  content: "\\F77B";
}

.mdi-set-left-right::before {
  content: "\\F77C";
}

.mdi-set-none::before {
  content: "\\F77D";
}

.mdi-set-right::before {
  content: "\\F77E";
}

.mdi-set-top-box::before {
  content: "\\F99E";
}

.mdi-settings::before {
  content: "\\F493";
}

.mdi-settings-box::before {
  content: "\\F494";
}

.mdi-settings-helper::before {
  content: "\\FA6D";
}

.mdi-settings-outline::before {
  content: "\\F8BA";
}

.mdi-settings-transfer::before {
  content: "\\F007D";
}

.mdi-settings-transfer-outline::before {
  content: "\\F007E";
}

.mdi-shaker::before {
  content: "\\F0139";
}

.mdi-shaker-outline::before {
  content: "\\F013A";
}

.mdi-shape::before {
  content: "\\F830";
}

.mdi-shape-circle-plus::before {
  content: "\\F65D";
}

.mdi-shape-outline::before {
  content: "\\F831";
}

.mdi-shape-oval-plus::before {
  content: "\\F0225";
}

.mdi-shape-plus::before {
  content: "\\F495";
}

.mdi-shape-polygon-plus::before {
  content: "\\F65E";
}

.mdi-shape-rectangle-plus::before {
  content: "\\F65F";
}

.mdi-shape-square-plus::before {
  content: "\\F660";
}

.mdi-share::before {
  content: "\\F496";
}

.mdi-share-all::before {
  content: "\\F021F";
}

.mdi-share-all-outline::before {
  content: "\\F0220";
}

.mdi-share-circle::before {
  content: "\\F01D8";
}

.mdi-share-off::before {
  content: "\\FF40";
}

.mdi-share-off-outline::before {
  content: "\\FF41";
}

.mdi-share-outline::before {
  content: "\\F931";
}

.mdi-share-variant::before {
  content: "\\F497";
}

.mdi-sheep::before {
  content: "\\FCA2";
}

.mdi-shield::before {
  content: "\\F498";
}

.mdi-shield-account::before {
  content: "\\F88E";
}

.mdi-shield-account-outline::before {
  content: "\\FA11";
}

.mdi-shield-airplane::before {
  content: "\\F6BA";
}

.mdi-shield-airplane-outline::before {
  content: "\\FCA3";
}

.mdi-shield-alert::before {
  content: "\\FEE9";
}

.mdi-shield-alert-outline::before {
  content: "\\FEEA";
}

.mdi-shield-car::before {
  content: "\\FFA0";
}

.mdi-shield-check::before {
  content: "\\F565";
}

.mdi-shield-check-outline::before {
  content: "\\FCA4";
}

.mdi-shield-cross::before {
  content: "\\FCA5";
}

.mdi-shield-cross-outline::before {
  content: "\\FCA6";
}

.mdi-shield-edit::before {
  content: "\\F01CB";
}

.mdi-shield-edit-outline::before {
  content: "\\F01CC";
}

.mdi-shield-half::before {
  content: "\\F038B";
}

.mdi-shield-half-full::before {
  content: "\\F77F";
}

.mdi-shield-home::before {
  content: "\\F689";
}

.mdi-shield-home-outline::before {
  content: "\\FCA7";
}

.mdi-shield-key::before {
  content: "\\FBA0";
}

.mdi-shield-key-outline::before {
  content: "\\FBA1";
}

.mdi-shield-link-variant::before {
  content: "\\FD0F";
}

.mdi-shield-link-variant-outline::before {
  content: "\\FD10";
}

.mdi-shield-lock::before {
  content: "\\F99C";
}

.mdi-shield-lock-outline::before {
  content: "\\FCA8";
}

.mdi-shield-off::before {
  content: "\\F99D";
}

.mdi-shield-off-outline::before {
  content: "\\F99B";
}

.mdi-shield-outline::before {
  content: "\\F499";
}

.mdi-shield-plus::before {
  content: "\\FAD9";
}

.mdi-shield-plus-outline::before {
  content: "\\FADA";
}

.mdi-shield-refresh::before {
  content: "\\F01CD";
}

.mdi-shield-refresh-outline::before {
  content: "\\F01CE";
}

.mdi-shield-remove::before {
  content: "\\FADB";
}

.mdi-shield-remove-outline::before {
  content: "\\FADC";
}

.mdi-shield-search::before {
  content: "\\FD76";
}

.mdi-shield-star::before {
  content: "\\F0166";
}

.mdi-shield-star-outline::before {
  content: "\\F0167";
}

.mdi-shield-sun::before {
  content: "\\F007F";
}

.mdi-shield-sun-outline::before {
  content: "\\F0080";
}

.mdi-ship-wheel::before {
  content: "\\F832";
}

.mdi-shoe-formal::before {
  content: "\\FB22";
}

.mdi-shoe-heel::before {
  content: "\\FB23";
}

.mdi-shoe-print::before {
  content: "\\FE5A";
}

.mdi-shopify::before {
  content: "\\FADD";
}

.mdi-shopping::before {
  content: "\\F49A";
}

.mdi-shopping-music::before {
  content: "\\F49B";
}

.mdi-shopping-outline::before {
  content: "\\F0200";
}

.mdi-shopping-search::before {
  content: "\\FFA1";
}

.mdi-shovel::before {
  content: "\\F70F";
}

.mdi-shovel-off::before {
  content: "\\F710";
}

.mdi-shower::before {
  content: "\\F99F";
}

.mdi-shower-head::before {
  content: "\\F9A0";
}

.mdi-shredder::before {
  content: "\\F49C";
}

.mdi-shuffle::before {
  content: "\\F49D";
}

.mdi-shuffle-disabled::before {
  content: "\\F49E";
}

.mdi-shuffle-variant::before {
  content: "\\F49F";
}

.mdi-shuriken::before {
  content: "\\F03AA";
}

.mdi-sigma::before {
  content: "\\F4A0";
}

.mdi-sigma-lower::before {
  content: "\\F62B";
}

.mdi-sign-caution::before {
  content: "\\F4A1";
}

.mdi-sign-direction::before {
  content: "\\F780";
}

.mdi-sign-direction-minus::before {
  content: "\\F0022";
}

.mdi-sign-direction-plus::before {
  content: "\\FFFD";
}

.mdi-sign-direction-remove::before {
  content: "\\FFFE";
}

.mdi-sign-real-estate::before {
  content: "\\F0143";
}

.mdi-sign-text::before {
  content: "\\F781";
}

.mdi-signal::before {
  content: "\\F4A2";
}

.mdi-signal-2g::before {
  content: "\\F711";
}

.mdi-signal-3g::before {
  content: "\\F712";
}

.mdi-signal-4g::before {
  content: "\\F713";
}

.mdi-signal-5g::before {
  content: "\\FA6E";
}

.mdi-signal-cellular-1::before {
  content: "\\F8BB";
}

.mdi-signal-cellular-2::before {
  content: "\\F8BC";
}

.mdi-signal-cellular-3::before {
  content: "\\F8BD";
}

.mdi-signal-cellular-outline::before {
  content: "\\F8BE";
}

.mdi-signal-distance-variant::before {
  content: "\\FE47";
}

.mdi-signal-hspa::before {
  content: "\\F714";
}

.mdi-signal-hspa-plus::before {
  content: "\\F715";
}

.mdi-signal-off::before {
  content: "\\F782";
}

.mdi-signal-variant::before {
  content: "\\F60A";
}

.mdi-signature::before {
  content: "\\FE5B";
}

.mdi-signature-freehand::before {
  content: "\\FE5C";
}

.mdi-signature-image::before {
  content: "\\FE5D";
}

.mdi-signature-text::before {
  content: "\\FE5E";
}

.mdi-silo::before {
  content: "\\FB24";
}

.mdi-silverware::before {
  content: "\\F4A3";
}

.mdi-silverware-clean::before {
  content: "\\FFFF";
}

.mdi-silverware-fork::before {
  content: "\\F4A4";
}

.mdi-silverware-fork-knife::before {
  content: "\\FA6F";
}

.mdi-silverware-spoon::before {
  content: "\\F4A5";
}

.mdi-silverware-variant::before {
  content: "\\F4A6";
}

.mdi-sim::before {
  content: "\\F4A7";
}

.mdi-sim-alert::before {
  content: "\\F4A8";
}

.mdi-sim-off::before {
  content: "\\F4A9";
}

.mdi-simple-icons::before {
  content: "\\F0348";
}

.mdi-sina-weibo::before {
  content: "\\FADE";
}

.mdi-sitemap::before {
  content: "\\F4AA";
}

.mdi-skate::before {
  content: "\\FD11";
}

.mdi-skew-less::before {
  content: "\\FD12";
}

.mdi-skew-more::before {
  content: "\\FD13";
}

.mdi-ski::before {
  content: "\\F032F";
}

.mdi-ski-cross-country::before {
  content: "\\F0330";
}

.mdi-ski-water::before {
  content: "\\F0331";
}

.mdi-skip-backward::before {
  content: "\\F4AB";
}

.mdi-skip-backward-outline::before {
  content: "\\FF42";
}

.mdi-skip-forward::before {
  content: "\\F4AC";
}

.mdi-skip-forward-outline::before {
  content: "\\FF43";
}

.mdi-skip-next::before {
  content: "\\F4AD";
}

.mdi-skip-next-circle::before {
  content: "\\F661";
}

.mdi-skip-next-circle-outline::before {
  content: "\\F662";
}

.mdi-skip-next-outline::before {
  content: "\\FF44";
}

.mdi-skip-previous::before {
  content: "\\F4AE";
}

.mdi-skip-previous-circle::before {
  content: "\\F663";
}

.mdi-skip-previous-circle-outline::before {
  content: "\\F664";
}

.mdi-skip-previous-outline::before {
  content: "\\FF45";
}

.mdi-skull::before {
  content: "\\F68B";
}

.mdi-skull-crossbones::before {
  content: "\\FBA2";
}

.mdi-skull-crossbones-outline::before {
  content: "\\FBA3";
}

.mdi-skull-outline::before {
  content: "\\FBA4";
}

.mdi-skype::before {
  content: "\\F4AF";
}

.mdi-skype-business::before {
  content: "\\F4B0";
}

.mdi-slack::before {
  content: "\\F4B1";
}

.mdi-slackware::before {
  content: "\\F90A";
}

.mdi-slash-forward::before {
  content: "\\F0000";
}

.mdi-slash-forward-box::before {
  content: "\\F0001";
}

.mdi-sleep::before {
  content: "\\F4B2";
}

.mdi-sleep-off::before {
  content: "\\F4B3";
}

.mdi-slope-downhill::before {
  content: "\\FE5F";
}

.mdi-slope-uphill::before {
  content: "\\FE60";
}

.mdi-slot-machine::before {
  content: "\\F013F";
}

.mdi-slot-machine-outline::before {
  content: "\\F0140";
}

.mdi-smart-card::before {
  content: "\\F00E8";
}

.mdi-smart-card-outline::before {
  content: "\\F00E9";
}

.mdi-smart-card-reader::before {
  content: "\\F00EA";
}

.mdi-smart-card-reader-outline::before {
  content: "\\F00EB";
}

.mdi-smog::before {
  content: "\\FA70";
}

.mdi-smoke-detector::before {
  content: "\\F392";
}

.mdi-smoking::before {
  content: "\\F4B4";
}

.mdi-smoking-off::before {
  content: "\\F4B5";
}

.mdi-snapchat::before {
  content: "\\F4B6";
}

.mdi-snowboard::before {
  content: "\\F0332";
}

.mdi-snowflake::before {
  content: "\\F716";
}

.mdi-snowflake-alert::before {
  content: "\\FF46";
}

.mdi-snowflake-melt::before {
  content: "\\F02F6";
}

.mdi-snowflake-variant::before {
  content: "\\FF47";
}

.mdi-snowman::before {
  content: "\\F4B7";
}

.mdi-soccer::before {
  content: "\\F4B8";
}

.mdi-soccer-field::before {
  content: "\\F833";
}

.mdi-sofa::before {
  content: "\\F4B9";
}

.mdi-solar-panel::before {
  content: "\\FD77";
}

.mdi-solar-panel-large::before {
  content: "\\FD78";
}

.mdi-solar-power::before {
  content: "\\FA71";
}

.mdi-soldering-iron::before {
  content: "\\F00BD";
}

.mdi-solid::before {
  content: "\\F68C";
}

.mdi-sort::before {
  content: "\\F4BA";
}

.mdi-sort-alphabetical::before {
  content: "\\F4BB";
}

.mdi-sort-alphabetical-ascending::before {
  content: "\\F0173";
}

.mdi-sort-alphabetical-descending::before {
  content: "\\F0174";
}

.mdi-sort-ascending::before {
  content: "\\F4BC";
}

.mdi-sort-descending::before {
  content: "\\F4BD";
}

.mdi-sort-numeric::before {
  content: "\\F4BE";
}

.mdi-sort-variant::before {
  content: "\\F4BF";
}

.mdi-sort-variant-lock::before {
  content: "\\FCA9";
}

.mdi-sort-variant-lock-open::before {
  content: "\\FCAA";
}

.mdi-sort-variant-remove::before {
  content: "\\F0172";
}

.mdi-soundcloud::before {
  content: "\\F4C0";
}

.mdi-source-branch::before {
  content: "\\F62C";
}

.mdi-source-commit::before {
  content: "\\F717";
}

.mdi-source-commit-end::before {
  content: "\\F718";
}

.mdi-source-commit-end-local::before {
  content: "\\F719";
}

.mdi-source-commit-local::before {
  content: "\\F71A";
}

.mdi-source-commit-next-local::before {
  content: "\\F71B";
}

.mdi-source-commit-start::before {
  content: "\\F71C";
}

.mdi-source-commit-start-next-local::before {
  content: "\\F71D";
}

.mdi-source-fork::before {
  content: "\\F4C1";
}

.mdi-source-merge::before {
  content: "\\F62D";
}

.mdi-source-pull::before {
  content: "\\F4C2";
}

.mdi-source-repository::before {
  content: "\\FCAB";
}

.mdi-source-repository-multiple::before {
  content: "\\FCAC";
}

.mdi-soy-sauce::before {
  content: "\\F7ED";
}

.mdi-spa::before {
  content: "\\FCAD";
}

.mdi-spa-outline::before {
  content: "\\FCAE";
}

.mdi-space-invaders::before {
  content: "\\FBA5";
}

.mdi-space-station::before {
  content: "\\F03AE";
}

.mdi-spade::before {
  content: "\\FE48";
}

.mdi-speaker::before {
  content: "\\F4C3";
}

.mdi-speaker-bluetooth::before {
  content: "\\F9A1";
}

.mdi-speaker-multiple::before {
  content: "\\FD14";
}

.mdi-speaker-off::before {
  content: "\\F4C4";
}

.mdi-speaker-wireless::before {
  content: "\\F71E";
}

.mdi-speedometer::before {
  content: "\\F4C5";
}

.mdi-speedometer-medium::before {
  content: "\\FFA2";
}

.mdi-speedometer-slow::before {
  content: "\\FFA3";
}

.mdi-spellcheck::before {
  content: "\\F4C6";
}

.mdi-spider::before {
  content: "\\F0215";
}

.mdi-spider-thread::before {
  content: "\\F0216";
}

.mdi-spider-web::before {
  content: "\\FBA6";
}

.mdi-spotify::before {
  content: "\\F4C7";
}

.mdi-spotlight::before {
  content: "\\F4C8";
}

.mdi-spotlight-beam::before {
  content: "\\F4C9";
}

.mdi-spray::before {
  content: "\\F665";
}

.mdi-spray-bottle::before {
  content: "\\FADF";
}

.mdi-sprinkler::before {
  content: "\\F0081";
}

.mdi-sprinkler-variant::before {
  content: "\\F0082";
}

.mdi-sprout::before {
  content: "\\FE49";
}

.mdi-sprout-outline::before {
  content: "\\FE4A";
}

.mdi-square::before {
  content: "\\F763";
}

.mdi-square-edit-outline::before {
  content: "\\F90B";
}

.mdi-square-inc::before {
  content: "\\F4CA";
}

.mdi-square-inc-cash::before {
  content: "\\F4CB";
}

.mdi-square-medium::before {
  content: "\\FA12";
}

.mdi-square-medium-outline::before {
  content: "\\FA13";
}

.mdi-square-off::before {
  content: "\\F0319";
}

.mdi-square-off-outline::before {
  content: "\\F031A";
}

.mdi-square-outline::before {
  content: "\\F762";
}

.mdi-square-root::before {
  content: "\\F783";
}

.mdi-square-root-box::before {
  content: "\\F9A2";
}

.mdi-square-small::before {
  content: "\\FA14";
}

.mdi-squeegee::before {
  content: "\\FAE0";
}

.mdi-ssh::before {
  content: "\\F8BF";
}

.mdi-stack-exchange::before {
  content: "\\F60B";
}

.mdi-stack-overflow::before {
  content: "\\F4CC";
}

.mdi-stackpath::before {
  content: "\\F359";
}

.mdi-stadium::before {
  content: "\\F001A";
}

.mdi-stadium-variant::before {
  content: "\\F71F";
}

.mdi-stairs::before {
  content: "\\F4CD";
}

.mdi-stairs-down::before {
  content: "\\F02E9";
}

.mdi-stairs-up::before {
  content: "\\F02E8";
}

.mdi-stamper::before {
  content: "\\FD15";
}

.mdi-standard-definition::before {
  content: "\\F7EE";
}

.mdi-star::before {
  content: "\\F4CE";
}

.mdi-star-box::before {
  content: "\\FA72";
}

.mdi-star-box-multiple::before {
  content: "\\F02B1";
}

.mdi-star-box-multiple-outline::before {
  content: "\\F02B2";
}

.mdi-star-box-outline::before {
  content: "\\FA73";
}

.mdi-star-circle::before {
  content: "\\F4CF";
}

.mdi-star-circle-outline::before {
  content: "\\F9A3";
}

.mdi-star-face::before {
  content: "\\F9A4";
}

.mdi-star-four-points::before {
  content: "\\FAE1";
}

.mdi-star-four-points-outline::before {
  content: "\\FAE2";
}

.mdi-star-half::before {
  content: "\\F4D0";
}

.mdi-star-off::before {
  content: "\\F4D1";
}

.mdi-star-outline::before {
  content: "\\F4D2";
}

.mdi-star-three-points::before {
  content: "\\FAE3";
}

.mdi-star-three-points-outline::before {
  content: "\\FAE4";
}

.mdi-state-machine::before {
  content: "\\F021A";
}

.mdi-steam::before {
  content: "\\F4D3";
}

.mdi-steam-box::before {
  content: "\\F90C";
}

.mdi-steering::before {
  content: "\\F4D4";
}

.mdi-steering-off::before {
  content: "\\F90D";
}

.mdi-step-backward::before {
  content: "\\F4D5";
}

.mdi-step-backward-2::before {
  content: "\\F4D6";
}

.mdi-step-forward::before {
  content: "\\F4D7";
}

.mdi-step-forward-2::before {
  content: "\\F4D8";
}

.mdi-stethoscope::before {
  content: "\\F4D9";
}

.mdi-sticker::before {
  content: "\\F038F";
}

.mdi-sticker-alert::before {
  content: "\\F0390";
}

.mdi-sticker-alert-outline::before {
  content: "\\F0391";
}

.mdi-sticker-check::before {
  content: "\\F0392";
}

.mdi-sticker-check-outline::before {
  content: "\\F0393";
}

.mdi-sticker-circle-outline::before {
  content: "\\F5D0";
}

.mdi-sticker-emoji::before {
  content: "\\F784";
}

.mdi-sticker-minus::before {
  content: "\\F0394";
}

.mdi-sticker-minus-outline::before {
  content: "\\F0395";
}

.mdi-sticker-outline::before {
  content: "\\F0396";
}

.mdi-sticker-plus::before {
  content: "\\F0397";
}

.mdi-sticker-plus-outline::before {
  content: "\\F0398";
}

.mdi-sticker-remove::before {
  content: "\\F0399";
}

.mdi-sticker-remove-outline::before {
  content: "\\F039A";
}

.mdi-stocking::before {
  content: "\\F4DA";
}

.mdi-stomach::before {
  content: "\\F00BE";
}

.mdi-stop::before {
  content: "\\F4DB";
}

.mdi-stop-circle::before {
  content: "\\F666";
}

.mdi-stop-circle-outline::before {
  content: "\\F667";
}

.mdi-store::before {
  content: "\\F4DC";
}

.mdi-store-24-hour::before {
  content: "\\F4DD";
}

.mdi-store-outline::before {
  content: "\\F038C";
}

.mdi-storefront::before {
  content: "\\F00EC";
}

.mdi-stove::before {
  content: "\\F4DE";
}

.mdi-strategy::before {
  content: "\\F0201";
}

.mdi-strava::before {
  content: "\\FB25";
}

.mdi-stretch-to-page::before {
  content: "\\FF48";
}

.mdi-stretch-to-page-outline::before {
  content: "\\FF49";
}

.mdi-string-lights::before {
  content: "\\F02E5";
}

.mdi-string-lights-off::before {
  content: "\\F02E6";
}

.mdi-subdirectory-arrow-left::before {
  content: "\\F60C";
}

.mdi-subdirectory-arrow-right::before {
  content: "\\F60D";
}

.mdi-subtitles::before {
  content: "\\FA15";
}

.mdi-subtitles-outline::before {
  content: "\\FA16";
}

.mdi-subway::before {
  content: "\\F6AB";
}

.mdi-subway-alert-variant::before {
  content: "\\FD79";
}

.mdi-subway-variant::before {
  content: "\\F4DF";
}

.mdi-summit::before {
  content: "\\F785";
}

.mdi-sunglasses::before {
  content: "\\F4E0";
}

.mdi-surround-sound::before {
  content: "\\F5C5";
}

.mdi-surround-sound-2-0::before {
  content: "\\F7EF";
}

.mdi-surround-sound-3-1::before {
  content: "\\F7F0";
}

.mdi-surround-sound-5-1::before {
  content: "\\F7F1";
}

.mdi-surround-sound-7-1::before {
  content: "\\F7F2";
}

.mdi-svg::before {
  content: "\\F720";
}

.mdi-swap-horizontal::before {
  content: "\\F4E1";
}

.mdi-swap-horizontal-bold::before {
  content: "\\FBA9";
}

.mdi-swap-horizontal-circle::before {
  content: "\\F0002";
}

.mdi-swap-horizontal-circle-outline::before {
  content: "\\F0003";
}

.mdi-swap-horizontal-variant::before {
  content: "\\F8C0";
}

.mdi-swap-vertical::before {
  content: "\\F4E2";
}

.mdi-swap-vertical-bold::before {
  content: "\\FBAA";
}

.mdi-swap-vertical-circle::before {
  content: "\\F0004";
}

.mdi-swap-vertical-circle-outline::before {
  content: "\\F0005";
}

.mdi-swap-vertical-variant::before {
  content: "\\F8C1";
}

.mdi-swim::before {
  content: "\\F4E3";
}

.mdi-switch::before {
  content: "\\F4E4";
}

.mdi-sword::before {
  content: "\\F4E5";
}

.mdi-sword-cross::before {
  content: "\\F786";
}

.mdi-syllabary-hangul::before {
  content: "\\F035E";
}

.mdi-syllabary-hiragana::before {
  content: "\\F035F";
}

.mdi-syllabary-katakana::before {
  content: "\\F0360";
}

.mdi-syllabary-katakana-half-width::before {
  content: "\\F0361";
}

.mdi-symfony::before {
  content: "\\FAE5";
}

.mdi-sync::before {
  content: "\\F4E6";
}

.mdi-sync-alert::before {
  content: "\\F4E7";
}

.mdi-sync-circle::before {
  content: "\\F03A3";
}

.mdi-sync-off::before {
  content: "\\F4E8";
}

.mdi-tab::before {
  content: "\\F4E9";
}

.mdi-tab-minus::before {
  content: "\\FB26";
}

.mdi-tab-plus::before {
  content: "\\F75B";
}

.mdi-tab-remove::before {
  content: "\\FB27";
}

.mdi-tab-unselected::before {
  content: "\\F4EA";
}

.mdi-table::before {
  content: "\\F4EB";
}

.mdi-table-border::before {
  content: "\\FA17";
}

.mdi-table-chair::before {
  content: "\\F0083";
}

.mdi-table-column::before {
  content: "\\F834";
}

.mdi-table-column-plus-after::before {
  content: "\\F4EC";
}

.mdi-table-column-plus-before::before {
  content: "\\F4ED";
}

.mdi-table-column-remove::before {
  content: "\\F4EE";
}

.mdi-table-column-width::before {
  content: "\\F4EF";
}

.mdi-table-edit::before {
  content: "\\F4F0";
}

.mdi-table-eye::before {
  content: "\\F00BF";
}

.mdi-table-headers-eye::before {
  content: "\\F0248";
}

.mdi-table-headers-eye-off::before {
  content: "\\F0249";
}

.mdi-table-large::before {
  content: "\\F4F1";
}

.mdi-table-large-plus::before {
  content: "\\FFA4";
}

.mdi-table-large-remove::before {
  content: "\\FFA5";
}

.mdi-table-merge-cells::before {
  content: "\\F9A5";
}

.mdi-table-of-contents::before {
  content: "\\F835";
}

.mdi-table-plus::before {
  content: "\\FA74";
}

.mdi-table-remove::before {
  content: "\\FA75";
}

.mdi-table-row::before {
  content: "\\F836";
}

.mdi-table-row-height::before {
  content: "\\F4F2";
}

.mdi-table-row-plus-after::before {
  content: "\\F4F3";
}

.mdi-table-row-plus-before::before {
  content: "\\F4F4";
}

.mdi-table-row-remove::before {
  content: "\\F4F5";
}

.mdi-table-search::before {
  content: "\\F90E";
}

.mdi-table-settings::before {
  content: "\\F837";
}

.mdi-table-tennis::before {
  content: "\\FE4B";
}

.mdi-tablet::before {
  content: "\\F4F6";
}

.mdi-tablet-android::before {
  content: "\\F4F7";
}

.mdi-tablet-cellphone::before {
  content: "\\F9A6";
}

.mdi-tablet-dashboard::before {
  content: "\\FEEB";
}

.mdi-tablet-ipad::before {
  content: "\\F4F8";
}

.mdi-taco::before {
  content: "\\F761";
}

.mdi-tag::before {
  content: "\\F4F9";
}

.mdi-tag-faces::before {
  content: "\\F4FA";
}

.mdi-tag-heart::before {
  content: "\\F68A";
}

.mdi-tag-heart-outline::before {
  content: "\\FBAB";
}

.mdi-tag-minus::before {
  content: "\\F90F";
}

.mdi-tag-minus-outline::before {
  content: "\\F024A";
}

.mdi-tag-multiple::before {
  content: "\\F4FB";
}

.mdi-tag-multiple-outline::before {
  content: "\\F0322";
}

.mdi-tag-off::before {
  content: "\\F024B";
}

.mdi-tag-off-outline::before {
  content: "\\F024C";
}

.mdi-tag-outline::before {
  content: "\\F4FC";
}

.mdi-tag-plus::before {
  content: "\\F721";
}

.mdi-tag-plus-outline::before {
  content: "\\F024D";
}

.mdi-tag-remove::before {
  content: "\\F722";
}

.mdi-tag-remove-outline::before {
  content: "\\F024E";
}

.mdi-tag-text::before {
  content: "\\F024F";
}

.mdi-tag-text-outline::before {
  content: "\\F4FD";
}

.mdi-tank::before {
  content: "\\FD16";
}

.mdi-tanker-truck::before {
  content: "\\F0006";
}

.mdi-tape-measure::before {
  content: "\\FB28";
}

.mdi-target::before {
  content: "\\F4FE";
}

.mdi-target-account::before {
  content: "\\FBAC";
}

.mdi-target-variant::before {
  content: "\\FA76";
}

.mdi-taxi::before {
  content: "\\F4FF";
}

.mdi-tea::before {
  content: "\\FD7A";
}

.mdi-tea-outline::before {
  content: "\\FD7B";
}

.mdi-teach::before {
  content: "\\F88F";
}

.mdi-teamviewer::before {
  content: "\\F500";
}

.mdi-telegram::before {
  content: "\\F501";
}

.mdi-telescope::before {
  content: "\\FB29";
}

.mdi-television::before {
  content: "\\F502";
}

.mdi-television-ambient-light::before {
  content: "\\F0381";
}

.mdi-television-box::before {
  content: "\\F838";
}

.mdi-television-classic::before {
  content: "\\F7F3";
}

.mdi-television-classic-off::before {
  content: "\\F839";
}

.mdi-television-clean::before {
  content: "\\F013B";
}

.mdi-television-guide::before {
  content: "\\F503";
}

.mdi-television-off::before {
  content: "\\F83A";
}

.mdi-television-pause::before {
  content: "\\FFA6";
}

.mdi-television-play::before {
  content: "\\FEEC";
}

.mdi-television-stop::before {
  content: "\\FFA7";
}

.mdi-temperature-celsius::before {
  content: "\\F504";
}

.mdi-temperature-fahrenheit::before {
  content: "\\F505";
}

.mdi-temperature-kelvin::before {
  content: "\\F506";
}

.mdi-tennis::before {
  content: "\\FD7C";
}

.mdi-tennis-ball::before {
  content: "\\F507";
}

.mdi-tent::before {
  content: "\\F508";
}

.mdi-terraform::before {
  content: "\\F0084";
}

.mdi-terrain::before {
  content: "\\F509";
}

.mdi-test-tube::before {
  content: "\\F668";
}

.mdi-test-tube-empty::before {
  content: "\\F910";
}

.mdi-test-tube-off::before {
  content: "\\F911";
}

.mdi-text::before {
  content: "\\F9A7";
}

.mdi-text-recognition::before {
  content: "\\F0168";
}

.mdi-text-shadow::before {
  content: "\\F669";
}

.mdi-text-short::before {
  content: "\\F9A8";
}

.mdi-text-subject::before {
  content: "\\F9A9";
}

.mdi-text-to-speech::before {
  content: "\\F50A";
}

.mdi-text-to-speech-off::before {
  content: "\\F50B";
}

.mdi-textarea::before {
  content: "\\F00C0";
}

.mdi-textbox::before {
  content: "\\F60E";
}

.mdi-textbox-lock::before {
  content: "\\F0388";
}

.mdi-textbox-password::before {
  content: "\\F7F4";
}

.mdi-texture::before {
  content: "\\F50C";
}

.mdi-texture-box::before {
  content: "\\F0007";
}

.mdi-theater::before {
  content: "\\F50D";
}

.mdi-theme-light-dark::before {
  content: "\\F50E";
}

.mdi-thermometer::before {
  content: "\\F50F";
}

.mdi-thermometer-alert::before {
  content: "\\FE61";
}

.mdi-thermometer-chevron-down::before {
  content: "\\FE62";
}

.mdi-thermometer-chevron-up::before {
  content: "\\FE63";
}

.mdi-thermometer-high::before {
  content: "\\F00ED";
}

.mdi-thermometer-lines::before {
  content: "\\F510";
}

.mdi-thermometer-low::before {
  content: "\\F00EE";
}

.mdi-thermometer-minus::before {
  content: "\\FE64";
}

.mdi-thermometer-plus::before {
  content: "\\FE65";
}

.mdi-thermostat::before {
  content: "\\F393";
}

.mdi-thermostat-box::before {
  content: "\\F890";
}

.mdi-thought-bubble::before {
  content: "\\F7F5";
}

.mdi-thought-bubble-outline::before {
  content: "\\F7F6";
}

.mdi-thumb-down::before {
  content: "\\F511";
}

.mdi-thumb-down-outline::before {
  content: "\\F512";
}

.mdi-thumb-up::before {
  content: "\\F513";
}

.mdi-thumb-up-outline::before {
  content: "\\F514";
}

.mdi-thumbs-up-down::before {
  content: "\\F515";
}

.mdi-ticket::before {
  content: "\\F516";
}

.mdi-ticket-account::before {
  content: "\\F517";
}

.mdi-ticket-confirmation::before {
  content: "\\F518";
}

.mdi-ticket-outline::before {
  content: "\\F912";
}

.mdi-ticket-percent::before {
  content: "\\F723";
}

.mdi-tie::before {
  content: "\\F519";
}

.mdi-tilde::before {
  content: "\\F724";
}

.mdi-timelapse::before {
  content: "\\F51A";
}

.mdi-timeline::before {
  content: "\\FBAD";
}

.mdi-timeline-alert::before {
  content: "\\FFB2";
}

.mdi-timeline-alert-outline::before {
  content: "\\FFB5";
}

.mdi-timeline-clock::before {
  content: "\\F0226";
}

.mdi-timeline-clock-outline::before {
  content: "\\F0227";
}

.mdi-timeline-help::before {
  content: "\\FFB6";
}

.mdi-timeline-help-outline::before {
  content: "\\FFB7";
}

.mdi-timeline-outline::before {
  content: "\\FBAE";
}

.mdi-timeline-plus::before {
  content: "\\FFB3";
}

.mdi-timeline-plus-outline::before {
  content: "\\FFB4";
}

.mdi-timeline-text::before {
  content: "\\FBAF";
}

.mdi-timeline-text-outline::before {
  content: "\\FBB0";
}

.mdi-timer::before {
  content: "\\F51B";
}

.mdi-timer-10::before {
  content: "\\F51C";
}

.mdi-timer-3::before {
  content: "\\F51D";
}

.mdi-timer-off::before {
  content: "\\F51E";
}

.mdi-timer-sand::before {
  content: "\\F51F";
}

.mdi-timer-sand-empty::before {
  content: "\\F6AC";
}

.mdi-timer-sand-full::before {
  content: "\\F78B";
}

.mdi-timetable::before {
  content: "\\F520";
}

.mdi-toaster::before {
  content: "\\F0085";
}

.mdi-toaster-off::before {
  content: "\\F01E2";
}

.mdi-toaster-oven::before {
  content: "\\FCAF";
}

.mdi-toggle-switch::before {
  content: "\\F521";
}

.mdi-toggle-switch-off::before {
  content: "\\F522";
}

.mdi-toggle-switch-off-outline::before {
  content: "\\FA18";
}

.mdi-toggle-switch-outline::before {
  content: "\\FA19";
}

.mdi-toilet::before {
  content: "\\F9AA";
}

.mdi-toolbox::before {
  content: "\\F9AB";
}

.mdi-toolbox-outline::before {
  content: "\\F9AC";
}

.mdi-tools::before {
  content: "\\F0086";
}

.mdi-tooltip::before {
  content: "\\F523";
}

.mdi-tooltip-account::before {
  content: "\\F00C";
}

.mdi-tooltip-edit::before {
  content: "\\F524";
}

.mdi-tooltip-edit-outline::before {
  content: "\\F02F0";
}

.mdi-tooltip-image::before {
  content: "\\F525";
}

.mdi-tooltip-image-outline::before {
  content: "\\FBB1";
}

.mdi-tooltip-outline::before {
  content: "\\F526";
}

.mdi-tooltip-plus::before {
  content: "\\FBB2";
}

.mdi-tooltip-plus-outline::before {
  content: "\\F527";
}

.mdi-tooltip-text::before {
  content: "\\F528";
}

.mdi-tooltip-text-outline::before {
  content: "\\FBB3";
}

.mdi-tooth::before {
  content: "\\F8C2";
}

.mdi-tooth-outline::before {
  content: "\\F529";
}

.mdi-toothbrush::before {
  content: "\\F0154";
}

.mdi-toothbrush-electric::before {
  content: "\\F0157";
}

.mdi-toothbrush-paste::before {
  content: "\\F0155";
}

.mdi-tor::before {
  content: "\\F52A";
}

.mdi-tortoise::before {
  content: "\\FD17";
}

.mdi-toslink::before {
  content: "\\F02E3";
}

.mdi-tournament::before {
  content: "\\F9AD";
}

.mdi-tower-beach::before {
  content: "\\F680";
}

.mdi-tower-fire::before {
  content: "\\F681";
}

.mdi-towing::before {
  content: "\\F83B";
}

.mdi-toy-brick::before {
  content: "\\F02B3";
}

.mdi-toy-brick-marker::before {
  content: "\\F02B4";
}

.mdi-toy-brick-marker-outline::before {
  content: "\\F02B5";
}

.mdi-toy-brick-minus::before {
  content: "\\F02B6";
}

.mdi-toy-brick-minus-outline::before {
  content: "\\F02B7";
}

.mdi-toy-brick-outline::before {
  content: "\\F02B8";
}

.mdi-toy-brick-plus::before {
  content: "\\F02B9";
}

.mdi-toy-brick-plus-outline::before {
  content: "\\F02BA";
}

.mdi-toy-brick-remove::before {
  content: "\\F02BB";
}

.mdi-toy-brick-remove-outline::before {
  content: "\\F02BC";
}

.mdi-toy-brick-search::before {
  content: "\\F02BD";
}

.mdi-toy-brick-search-outline::before {
  content: "\\F02BE";
}

.mdi-track-light::before {
  content: "\\F913";
}

.mdi-trackpad::before {
  content: "\\F7F7";
}

.mdi-trackpad-lock::before {
  content: "\\F932";
}

.mdi-tractor::before {
  content: "\\F891";
}

.mdi-trademark::before {
  content: "\\FA77";
}

.mdi-traffic-cone::before {
  content: "\\F03A7";
}

.mdi-traffic-light::before {
  content: "\\F52B";
}

.mdi-train::before {
  content: "\\F52C";
}

.mdi-train-car::before {
  content: "\\FBB4";
}

.mdi-train-variant::before {
  content: "\\F8C3";
}

.mdi-tram::before {
  content: "\\F52D";
}

.mdi-tram-side::before {
  content: "\\F0008";
}

.mdi-transcribe::before {
  content: "\\F52E";
}

.mdi-transcribe-close::before {
  content: "\\F52F";
}

.mdi-transfer::before {
  content: "\\F0087";
}

.mdi-transfer-down::before {
  content: "\\FD7D";
}

.mdi-transfer-left::before {
  content: "\\FD7E";
}

.mdi-transfer-right::before {
  content: "\\F530";
}

.mdi-transfer-up::before {
  content: "\\FD7F";
}

.mdi-transit-connection::before {
  content: "\\FD18";
}

.mdi-transit-connection-variant::before {
  content: "\\FD19";
}

.mdi-transit-detour::before {
  content: "\\FFA8";
}

.mdi-transit-transfer::before {
  content: "\\F6AD";
}

.mdi-transition::before {
  content: "\\F914";
}

.mdi-transition-masked::before {
  content: "\\F915";
}

.mdi-translate::before {
  content: "\\F5CA";
}

.mdi-translate-off::before {
  content: "\\FE66";
}

.mdi-transmission-tower::before {
  content: "\\FD1A";
}

.mdi-trash-can::before {
  content: "\\FA78";
}

.mdi-trash-can-outline::before {
  content: "\\FA79";
}

.mdi-tray::before {
  content: "\\F02BF";
}

.mdi-tray-alert::before {
  content: "\\F02C0";
}

.mdi-tray-full::before {
  content: "\\F02C1";
}

.mdi-tray-minus::before {
  content: "\\F02C2";
}

.mdi-tray-plus::before {
  content: "\\F02C3";
}

.mdi-tray-remove::before {
  content: "\\F02C4";
}

.mdi-treasure-chest::before {
  content: "\\F725";
}

.mdi-tree::before {
  content: "\\F531";
}

.mdi-tree-outline::before {
  content: "\\FE4C";
}

.mdi-trello::before {
  content: "\\F532";
}

.mdi-trending-down::before {
  content: "\\F533";
}

.mdi-trending-neutral::before {
  content: "\\F534";
}

.mdi-trending-up::before {
  content: "\\F535";
}

.mdi-triangle::before {
  content: "\\F536";
}

.mdi-triangle-outline::before {
  content: "\\F537";
}

.mdi-triforce::before {
  content: "\\FBB5";
}

.mdi-trophy::before {
  content: "\\F538";
}

.mdi-trophy-award::before {
  content: "\\F539";
}

.mdi-trophy-broken::before {
  content: "\\FD80";
}

.mdi-trophy-outline::before {
  content: "\\F53A";
}

.mdi-trophy-variant::before {
  content: "\\F53B";
}

.mdi-trophy-variant-outline::before {
  content: "\\F53C";
}

.mdi-truck::before {
  content: "\\F53D";
}

.mdi-truck-check::before {
  content: "\\FCB0";
}

.mdi-truck-check-outline::before {
  content: "\\F02C5";
}

.mdi-truck-delivery::before {
  content: "\\F53E";
}

.mdi-truck-delivery-outline::before {
  content: "\\F02C6";
}

.mdi-truck-fast::before {
  content: "\\F787";
}

.mdi-truck-fast-outline::before {
  content: "\\F02C7";
}

.mdi-truck-outline::before {
  content: "\\F02C8";
}

.mdi-truck-trailer::before {
  content: "\\F726";
}

.mdi-trumpet::before {
  content: "\\F00C1";
}

.mdi-tshirt-crew::before {
  content: "\\FA7A";
}

.mdi-tshirt-crew-outline::before {
  content: "\\F53F";
}

.mdi-tshirt-v::before {
  content: "\\FA7B";
}

.mdi-tshirt-v-outline::before {
  content: "\\F540";
}

.mdi-tumble-dryer::before {
  content: "\\F916";
}

.mdi-tumble-dryer-alert::before {
  content: "\\F01E5";
}

.mdi-tumble-dryer-off::before {
  content: "\\F01E6";
}

.mdi-tumblr::before {
  content: "\\F541";
}

.mdi-tumblr-box::before {
  content: "\\F917";
}

.mdi-tumblr-reblog::before {
  content: "\\F542";
}

.mdi-tune::before {
  content: "\\F62E";
}

.mdi-tune-vertical::before {
  content: "\\F66A";
}

.mdi-turnstile::before {
  content: "\\FCB1";
}

.mdi-turnstile-outline::before {
  content: "\\FCB2";
}

.mdi-turtle::before {
  content: "\\FCB3";
}

.mdi-twitch::before {
  content: "\\F543";
}

.mdi-twitter::before {
  content: "\\F544";
}

.mdi-twitter-box::before {
  content: "\\F545";
}

.mdi-twitter-circle::before {
  content: "\\F546";
}

.mdi-twitter-retweet::before {
  content: "\\F547";
}

.mdi-two-factor-authentication::before {
  content: "\\F9AE";
}

.mdi-typewriter::before {
  content: "\\FF4A";
}

.mdi-uber::before {
  content: "\\F748";
}

.mdi-ubisoft::before {
  content: "\\FBB6";
}

.mdi-ubuntu::before {
  content: "\\F548";
}

.mdi-ufo::before {
  content: "\\F00EF";
}

.mdi-ufo-outline::before {
  content: "\\F00F0";
}

.mdi-ultra-high-definition::before {
  content: "\\F7F8";
}

.mdi-umbraco::before {
  content: "\\F549";
}

.mdi-umbrella::before {
  content: "\\F54A";
}

.mdi-umbrella-closed::before {
  content: "\\F9AF";
}

.mdi-umbrella-outline::before {
  content: "\\F54B";
}

.mdi-undo::before {
  content: "\\F54C";
}

.mdi-undo-variant::before {
  content: "\\F54D";
}

.mdi-unfold-less-horizontal::before {
  content: "\\F54E";
}

.mdi-unfold-less-vertical::before {
  content: "\\F75F";
}

.mdi-unfold-more-horizontal::before {
  content: "\\F54F";
}

.mdi-unfold-more-vertical::before {
  content: "\\F760";
}

.mdi-ungroup::before {
  content: "\\F550";
}

.mdi-unicode::before {
  content: "\\FEED";
}

.mdi-unity::before {
  content: "\\F6AE";
}

.mdi-unreal::before {
  content: "\\F9B0";
}

.mdi-untappd::before {
  content: "\\F551";
}

.mdi-update::before {
  content: "\\F6AF";
}

.mdi-upload::before {
  content: "\\F552";
}

.mdi-upload-lock::before {
  content: "\\F039E";
}

.mdi-upload-lock-outline::before {
  content: "\\F039F";
}

.mdi-upload-multiple::before {
  content: "\\F83C";
}

.mdi-upload-network::before {
  content: "\\F6F5";
}

.mdi-upload-network-outline::before {
  content: "\\FCB4";
}

.mdi-upload-off::before {
  content: "\\F00F1";
}

.mdi-upload-off-outline::before {
  content: "\\F00F2";
}

.mdi-upload-outline::before {
  content: "\\FE67";
}

.mdi-usb::before {
  content: "\\F553";
}

.mdi-usb-flash-drive::before {
  content: "\\F02C9";
}

.mdi-usb-flash-drive-outline::before {
  content: "\\F02CA";
}

.mdi-usb-port::before {
  content: "\\F021B";
}

.mdi-valve::before {
  content: "\\F0088";
}

.mdi-valve-closed::before {
  content: "\\F0089";
}

.mdi-valve-open::before {
  content: "\\F008A";
}

.mdi-van-passenger::before {
  content: "\\F7F9";
}

.mdi-van-utility::before {
  content: "\\F7FA";
}

.mdi-vanish::before {
  content: "\\F7FB";
}

.mdi-vanity-light::before {
  content: "\\F020C";
}

.mdi-variable::before {
  content: "\\FAE6";
}

.mdi-variable-box::before {
  content: "\\F013C";
}

.mdi-vector-arrange-above::before {
  content: "\\F554";
}

.mdi-vector-arrange-below::before {
  content: "\\F555";
}

.mdi-vector-bezier::before {
  content: "\\FAE7";
}

.mdi-vector-circle::before {
  content: "\\F556";
}

.mdi-vector-circle-variant::before {
  content: "\\F557";
}

.mdi-vector-combine::before {
  content: "\\F558";
}

.mdi-vector-curve::before {
  content: "\\F559";
}

.mdi-vector-difference::before {
  content: "\\F55A";
}

.mdi-vector-difference-ab::before {
  content: "\\F55B";
}

.mdi-vector-difference-ba::before {
  content: "\\F55C";
}

.mdi-vector-ellipse::before {
  content: "\\F892";
}

.mdi-vector-intersection::before {
  content: "\\F55D";
}

.mdi-vector-line::before {
  content: "\\F55E";
}

.mdi-vector-link::before {
  content: "\\F0009";
}

.mdi-vector-point::before {
  content: "\\F55F";
}

.mdi-vector-polygon::before {
  content: "\\F560";
}

.mdi-vector-polyline::before {
  content: "\\F561";
}

.mdi-vector-polyline-edit::before {
  content: "\\F0250";
}

.mdi-vector-polyline-minus::before {
  content: "\\F0251";
}

.mdi-vector-polyline-plus::before {
  content: "\\F0252";
}

.mdi-vector-polyline-remove::before {
  content: "\\F0253";
}

.mdi-vector-radius::before {
  content: "\\F749";
}

.mdi-vector-rectangle::before {
  content: "\\F5C6";
}

.mdi-vector-selection::before {
  content: "\\F562";
}

.mdi-vector-square::before {
  content: "\\F001";
}

.mdi-vector-triangle::before {
  content: "\\F563";
}

.mdi-vector-union::before {
  content: "\\F564";
}

.mdi-venmo::before {
  content: "\\F578";
}

.mdi-vhs::before {
  content: "\\FA1A";
}

.mdi-vibrate::before {
  content: "\\F566";
}

.mdi-vibrate-off::before {
  content: "\\FCB5";
}

.mdi-video::before {
  content: "\\F567";
}

.mdi-video-3d::before {
  content: "\\F7FC";
}

.mdi-video-3d-variant::before {
  content: "\\FEEE";
}

.mdi-video-4k-box::before {
  content: "\\F83D";
}

.mdi-video-account::before {
  content: "\\F918";
}

.mdi-video-check::before {
  content: "\\F008B";
}

.mdi-video-check-outline::before {
  content: "\\F008C";
}

.mdi-video-image::before {
  content: "\\F919";
}

.mdi-video-input-antenna::before {
  content: "\\F83E";
}

.mdi-video-input-component::before {
  content: "\\F83F";
}

.mdi-video-input-hdmi::before {
  content: "\\F840";
}

.mdi-video-input-scart::before {
  content: "\\FFA9";
}

.mdi-video-input-svideo::before {
  content: "\\F841";
}

.mdi-video-minus::before {
  content: "\\F9B1";
}

.mdi-video-off::before {
  content: "\\F568";
}

.mdi-video-off-outline::before {
  content: "\\FBB7";
}

.mdi-video-outline::before {
  content: "\\FBB8";
}

.mdi-video-plus::before {
  content: "\\F9B2";
}

.mdi-video-stabilization::before {
  content: "\\F91A";
}

.mdi-video-switch::before {
  content: "\\F569";
}

.mdi-video-vintage::before {
  content: "\\FA1B";
}

.mdi-video-wireless::before {
  content: "\\FEEF";
}

.mdi-video-wireless-outline::before {
  content: "\\FEF0";
}

.mdi-view-agenda::before {
  content: "\\F56A";
}

.mdi-view-agenda-outline::before {
  content: "\\F0203";
}

.mdi-view-array::before {
  content: "\\F56B";
}

.mdi-view-carousel::before {
  content: "\\F56C";
}

.mdi-view-column::before {
  content: "\\F56D";
}

.mdi-view-comfy::before {
  content: "\\FE4D";
}

.mdi-view-compact::before {
  content: "\\FE4E";
}

.mdi-view-compact-outline::before {
  content: "\\FE4F";
}

.mdi-view-dashboard::before {
  content: "\\F56E";
}

.mdi-view-dashboard-outline::before {
  content: "\\FA1C";
}

.mdi-view-dashboard-variant::before {
  content: "\\F842";
}

.mdi-view-day::before {
  content: "\\F56F";
}

.mdi-view-grid::before {
  content: "\\F570";
}

.mdi-view-grid-outline::before {
  content: "\\F0204";
}

.mdi-view-grid-plus::before {
  content: "\\FFAA";
}

.mdi-view-grid-plus-outline::before {
  content: "\\F0205";
}

.mdi-view-headline::before {
  content: "\\F571";
}

.mdi-view-list::before {
  content: "\\F572";
}

.mdi-view-module::before {
  content: "\\F573";
}

.mdi-view-parallel::before {
  content: "\\F727";
}

.mdi-view-quilt::before {
  content: "\\F574";
}

.mdi-view-sequential::before {
  content: "\\F728";
}

.mdi-view-split-horizontal::before {
  content: "\\FBA7";
}

.mdi-view-split-vertical::before {
  content: "\\FBA8";
}

.mdi-view-stream::before {
  content: "\\F575";
}

.mdi-view-week::before {
  content: "\\F576";
}

.mdi-vimeo::before {
  content: "\\F577";
}

.mdi-violin::before {
  content: "\\F60F";
}

.mdi-virtual-reality::before {
  content: "\\F893";
}

.mdi-visual-studio::before {
  content: "\\F610";
}

.mdi-visual-studio-code::before {
  content: "\\FA1D";
}

.mdi-vk::before {
  content: "\\F579";
}

.mdi-vk-box::before {
  content: "\\F57A";
}

.mdi-vk-circle::before {
  content: "\\F57B";
}

.mdi-vlc::before {
  content: "\\F57C";
}

.mdi-voice::before {
  content: "\\F5CB";
}

.mdi-voice-off::before {
  content: "\\FEF1";
}

.mdi-voicemail::before {
  content: "\\F57D";
}

.mdi-volleyball::before {
  content: "\\F9B3";
}

.mdi-volume-high::before {
  content: "\\F57E";
}

.mdi-volume-low::before {
  content: "\\F57F";
}

.mdi-volume-medium::before {
  content: "\\F580";
}

.mdi-volume-minus::before {
  content: "\\F75D";
}

.mdi-volume-mute::before {
  content: "\\F75E";
}

.mdi-volume-off::before {
  content: "\\F581";
}

.mdi-volume-plus::before {
  content: "\\F75C";
}

.mdi-volume-source::before {
  content: "\\F014B";
}

.mdi-volume-variant-off::before {
  content: "\\FE68";
}

.mdi-volume-vibrate::before {
  content: "\\F014C";
}

.mdi-vote::before {
  content: "\\FA1E";
}

.mdi-vote-outline::before {
  content: "\\FA1F";
}

.mdi-vpn::before {
  content: "\\F582";
}

.mdi-vuejs::before {
  content: "\\F843";
}

.mdi-vuetify::before {
  content: "\\FE50";
}

.mdi-walk::before {
  content: "\\F583";
}

.mdi-wall::before {
  content: "\\F7FD";
}

.mdi-wall-sconce::before {
  content: "\\F91B";
}

.mdi-wall-sconce-flat::before {
  content: "\\F91C";
}

.mdi-wall-sconce-variant::before {
  content: "\\F91D";
}

.mdi-wallet::before {
  content: "\\F584";
}

.mdi-wallet-giftcard::before {
  content: "\\F585";
}

.mdi-wallet-membership::before {
  content: "\\F586";
}

.mdi-wallet-outline::before {
  content: "\\FBB9";
}

.mdi-wallet-plus::before {
  content: "\\FFAB";
}

.mdi-wallet-plus-outline::before {
  content: "\\FFAC";
}

.mdi-wallet-travel::before {
  content: "\\F587";
}

.mdi-wallpaper::before {
  content: "\\FE69";
}

.mdi-wan::before {
  content: "\\F588";
}

.mdi-wardrobe::before {
  content: "\\FFAD";
}

.mdi-wardrobe-outline::before {
  content: "\\FFAE";
}

.mdi-warehouse::before {
  content: "\\FFBB";
}

.mdi-washing-machine::before {
  content: "\\F729";
}

.mdi-washing-machine-alert::before {
  content: "\\F01E7";
}

.mdi-washing-machine-off::before {
  content: "\\F01E8";
}

.mdi-watch::before {
  content: "\\F589";
}

.mdi-watch-export::before {
  content: "\\F58A";
}

.mdi-watch-export-variant::before {
  content: "\\F894";
}

.mdi-watch-import::before {
  content: "\\F58B";
}

.mdi-watch-import-variant::before {
  content: "\\F895";
}

.mdi-watch-variant::before {
  content: "\\F896";
}

.mdi-watch-vibrate::before {
  content: "\\F6B0";
}

.mdi-watch-vibrate-off::before {
  content: "\\FCB6";
}

.mdi-water::before {
  content: "\\F58C";
}

.mdi-water-boiler::before {
  content: "\\FFAF";
}

.mdi-water-boiler-alert::before {
  content: "\\F01DE";
}

.mdi-water-boiler-off::before {
  content: "\\F01DF";
}

.mdi-water-off::before {
  content: "\\F58D";
}

.mdi-water-outline::before {
  content: "\\FE6A";
}

.mdi-water-percent::before {
  content: "\\F58E";
}

.mdi-water-polo::before {
  content: "\\F02CB";
}

.mdi-water-pump::before {
  content: "\\F58F";
}

.mdi-water-pump-off::before {
  content: "\\FFB0";
}

.mdi-water-well::before {
  content: "\\F008D";
}

.mdi-water-well-outline::before {
  content: "\\F008E";
}

.mdi-watermark::before {
  content: "\\F612";
}

.mdi-wave::before {
  content: "\\FF4B";
}

.mdi-waves::before {
  content: "\\F78C";
}

.mdi-waze::before {
  content: "\\FBBA";
}

.mdi-weather-cloudy::before {
  content: "\\F590";
}

.mdi-weather-cloudy-alert::before {
  content: "\\FF4C";
}

.mdi-weather-cloudy-arrow-right::before {
  content: "\\FE51";
}

.mdi-weather-fog::before {
  content: "\\F591";
}

.mdi-weather-hail::before {
  content: "\\F592";
}

.mdi-weather-hazy::before {
  content: "\\FF4D";
}

.mdi-weather-hurricane::before {
  content: "\\F897";
}

.mdi-weather-lightning::before {
  content: "\\F593";
}

.mdi-weather-lightning-rainy::before {
  content: "\\F67D";
}

.mdi-weather-night::before {
  content: "\\F594";
}

.mdi-weather-night-partly-cloudy::before {
  content: "\\FF4E";
}

.mdi-weather-partly-cloudy::before {
  content: "\\F595";
}

.mdi-weather-partly-lightning::before {
  content: "\\FF4F";
}

.mdi-weather-partly-rainy::before {
  content: "\\FF50";
}

.mdi-weather-partly-snowy::before {
  content: "\\FF51";
}

.mdi-weather-partly-snowy-rainy::before {
  content: "\\FF52";
}

.mdi-weather-pouring::before {
  content: "\\F596";
}

.mdi-weather-rainy::before {
  content: "\\F597";
}

.mdi-weather-snowy::before {
  content: "\\F598";
}

.mdi-weather-snowy-heavy::before {
  content: "\\FF53";
}

.mdi-weather-snowy-rainy::before {
  content: "\\F67E";
}

.mdi-weather-sunny::before {
  content: "\\F599";
}

.mdi-weather-sunny-alert::before {
  content: "\\FF54";
}

.mdi-weather-sunset::before {
  content: "\\F59A";
}

.mdi-weather-sunset-down::before {
  content: "\\F59B";
}

.mdi-weather-sunset-up::before {
  content: "\\F59C";
}

.mdi-weather-tornado::before {
  content: "\\FF55";
}

.mdi-weather-windy::before {
  content: "\\F59D";
}

.mdi-weather-windy-variant::before {
  content: "\\F59E";
}

.mdi-web::before {
  content: "\\F59F";
}

.mdi-web-box::before {
  content: "\\FFB1";
}

.mdi-web-clock::before {
  content: "\\F0275";
}

.mdi-webcam::before {
  content: "\\F5A0";
}

.mdi-webhook::before {
  content: "\\F62F";
}

.mdi-webpack::before {
  content: "\\F72A";
}

.mdi-webrtc::before {
  content: "\\F0273";
}

.mdi-wechat::before {
  content: "\\F611";
}

.mdi-weight::before {
  content: "\\F5A1";
}

.mdi-weight-gram::before {
  content: "\\FD1B";
}

.mdi-weight-kilogram::before {
  content: "\\F5A2";
}

.mdi-weight-lifter::before {
  content: "\\F0188";
}

.mdi-weight-pound::before {
  content: "\\F9B4";
}

.mdi-whatsapp::before {
  content: "\\F5A3";
}

.mdi-wheelchair-accessibility::before {
  content: "\\F5A4";
}

.mdi-whistle::before {
  content: "\\F9B5";
}

.mdi-whistle-outline::before {
  content: "\\F02E7";
}

.mdi-white-balance-auto::before {
  content: "\\F5A5";
}

.mdi-white-balance-incandescent::before {
  content: "\\F5A6";
}

.mdi-white-balance-iridescent::before {
  content: "\\F5A7";
}

.mdi-white-balance-sunny::before {
  content: "\\F5A8";
}

.mdi-widgets::before {
  content: "\\F72B";
}

.mdi-widgets-outline::before {
  content: "\\F0380";
}

.mdi-wifi::before {
  content: "\\F5A9";
}

.mdi-wifi-off::before {
  content: "\\F5AA";
}

.mdi-wifi-star::before {
  content: "\\FE6B";
}

.mdi-wifi-strength-1::before {
  content: "\\F91E";
}

.mdi-wifi-strength-1-alert::before {
  content: "\\F91F";
}

.mdi-wifi-strength-1-lock::before {
  content: "\\F920";
}

.mdi-wifi-strength-2::before {
  content: "\\F921";
}

.mdi-wifi-strength-2-alert::before {
  content: "\\F922";
}

.mdi-wifi-strength-2-lock::before {
  content: "\\F923";
}

.mdi-wifi-strength-3::before {
  content: "\\F924";
}

.mdi-wifi-strength-3-alert::before {
  content: "\\F925";
}

.mdi-wifi-strength-3-lock::before {
  content: "\\F926";
}

.mdi-wifi-strength-4::before {
  content: "\\F927";
}

.mdi-wifi-strength-4-alert::before {
  content: "\\F928";
}

.mdi-wifi-strength-4-lock::before {
  content: "\\F929";
}

.mdi-wifi-strength-alert-outline::before {
  content: "\\F92A";
}

.mdi-wifi-strength-lock-outline::before {
  content: "\\F92B";
}

.mdi-wifi-strength-off::before {
  content: "\\F92C";
}

.mdi-wifi-strength-off-outline::before {
  content: "\\F92D";
}

.mdi-wifi-strength-outline::before {
  content: "\\F92E";
}

.mdi-wii::before {
  content: "\\F5AB";
}

.mdi-wiiu::before {
  content: "\\F72C";
}

.mdi-wikipedia::before {
  content: "\\F5AC";
}

.mdi-wind-turbine::before {
  content: "\\FD81";
}

.mdi-window-close::before {
  content: "\\F5AD";
}

.mdi-window-closed::before {
  content: "\\F5AE";
}

.mdi-window-closed-variant::before {
  content: "\\F0206";
}

.mdi-window-maximize::before {
  content: "\\F5AF";
}

.mdi-window-minimize::before {
  content: "\\F5B0";
}

.mdi-window-open::before {
  content: "\\F5B1";
}

.mdi-window-open-variant::before {
  content: "\\F0207";
}

.mdi-window-restore::before {
  content: "\\F5B2";
}

.mdi-window-shutter::before {
  content: "\\F0147";
}

.mdi-window-shutter-alert::before {
  content: "\\F0148";
}

.mdi-window-shutter-open::before {
  content: "\\F0149";
}

.mdi-windows::before {
  content: "\\F5B3";
}

.mdi-windows-classic::before {
  content: "\\FA20";
}

.mdi-wiper::before {
  content: "\\FAE8";
}

.mdi-wiper-wash::before {
  content: "\\FD82";
}

.mdi-wordpress::before {
  content: "\\F5B4";
}

.mdi-worker::before {
  content: "\\F5B5";
}

.mdi-wrap::before {
  content: "\\F5B6";
}

.mdi-wrap-disabled::before {
  content: "\\FBBB";
}

.mdi-wrench::before {
  content: "\\F5B7";
}

.mdi-wrench-outline::before {
  content: "\\FBBC";
}

.mdi-wunderlist::before {
  content: "\\F5B8";
}

.mdi-xamarin::before {
  content: "\\F844";
}

.mdi-xamarin-outline::before {
  content: "\\F845";
}

.mdi-xaml::before {
  content: "\\F673";
}

.mdi-xbox::before {
  content: "\\F5B9";
}

.mdi-xbox-controller::before {
  content: "\\F5BA";
}

.mdi-xbox-controller-battery-alert::before {
  content: "\\F74A";
}

.mdi-xbox-controller-battery-charging::before {
  content: "\\FA21";
}

.mdi-xbox-controller-battery-empty::before {
  content: "\\F74B";
}

.mdi-xbox-controller-battery-full::before {
  content: "\\F74C";
}

.mdi-xbox-controller-battery-low::before {
  content: "\\F74D";
}

.mdi-xbox-controller-battery-medium::before {
  content: "\\F74E";
}

.mdi-xbox-controller-battery-unknown::before {
  content: "\\F74F";
}

.mdi-xbox-controller-menu::before {
  content: "\\FE52";
}

.mdi-xbox-controller-off::before {
  content: "\\F5BB";
}

.mdi-xbox-controller-view::before {
  content: "\\FE53";
}

.mdi-xda::before {
  content: "\\F5BC";
}

.mdi-xing::before {
  content: "\\F5BD";
}

.mdi-xing-box::before {
  content: "\\F5BE";
}

.mdi-xing-circle::before {
  content: "\\F5BF";
}

.mdi-xml::before {
  content: "\\F5C0";
}

.mdi-xmpp::before {
  content: "\\F7FE";
}

.mdi-yahoo::before {
  content: "\\FB2A";
}

.mdi-yammer::before {
  content: "\\F788";
}

.mdi-yeast::before {
  content: "\\F5C1";
}

.mdi-yelp::before {
  content: "\\F5C2";
}

.mdi-yin-yang::before {
  content: "\\F67F";
}

.mdi-yoga::before {
  content: "\\F01A7";
}

.mdi-youtube::before {
  content: "\\F5C3";
}

.mdi-youtube-creator-studio::before {
  content: "\\F846";
}

.mdi-youtube-gaming::before {
  content: "\\F847";
}

.mdi-youtube-subscription::before {
  content: "\\FD1C";
}

.mdi-youtube-tv::before {
  content: "\\F448";
}

.mdi-z-wave::before {
  content: "\\FAE9";
}

.mdi-zend::before {
  content: "\\FAEA";
}

.mdi-zigbee::before {
  content: "\\FD1D";
}

.mdi-zip-box::before {
  content: "\\F5C4";
}

.mdi-zip-box-outline::before {
  content: "\\F001B";
}

.mdi-zip-disk::before {
  content: "\\FA22";
}

.mdi-zodiac-aquarius::before {
  content: "\\FA7C";
}

.mdi-zodiac-aries::before {
  content: "\\FA7D";
}

.mdi-zodiac-cancer::before {
  content: "\\FA7E";
}

.mdi-zodiac-capricorn::before {
  content: "\\FA7F";
}

.mdi-zodiac-gemini::before {
  content: "\\FA80";
}

.mdi-zodiac-leo::before {
  content: "\\FA81";
}

.mdi-zodiac-libra::before {
  content: "\\FA82";
}

.mdi-zodiac-pisces::before {
  content: "\\FA83";
}

.mdi-zodiac-sagittarius::before {
  content: "\\FA84";
}

.mdi-zodiac-scorpio::before {
  content: "\\FA85";
}

.mdi-zodiac-taurus::before {
  content: "\\FA86";
}

.mdi-zodiac-virgo::before {
  content: "\\FA87";
}

.mdi-blank::before {
  content: "\\f68c";
  visibility: hidden;
}

.mdi-18px.mdi-set, .mdi-18px.mdi:before {
  font-size: 18px;
}

.mdi-24px.mdi-set, .mdi-24px.mdi:before {
  font-size: 24px;
}

.mdi-36px.mdi-set, .mdi-36px.mdi:before {
  font-size: 36px;
}

.mdi-48px.mdi-set, .mdi-48px.mdi:before {
  font-size: 48px;
}

.mdi-dark:before {
  color: rgba(0, 0, 0, 0.54);
}
.mdi-dark.mdi-inactive:before {
  color: rgba(0, 0, 0, 0.26);
}

.mdi-light:before {
  color: rgb(255, 255, 255);
}
.mdi-light.mdi-inactive:before {
  color: rgba(255, 255, 255, 0.3);
}

.mdi-rotate-45 {
  /*
  // Not included in production
  &.mdi-flip-h:before {
      -webkit-transform: scaleX(-1) rotate(45deg);
      transform: scaleX(-1) rotate(45deg);
      filter: FlipH;
      -ms-filter: "FlipH";
  }
  &.mdi-flip-v:before {
      -webkit-transform: scaleY(-1) rotate(45deg);
      -ms-transform: rotate(45deg);
      transform: scaleY(-1) rotate(45deg);
      filter: FlipV;
      -ms-filter: "FlipV";
  }
  */
}
.mdi-rotate-45:before {
  transform: rotate(45deg);
}

.mdi-rotate-90 {
  /*
  // Not included in production
  &.mdi-flip-h:before {
      -webkit-transform: scaleX(-1) rotate(90deg);
      transform: scaleX(-1) rotate(90deg);
      filter: FlipH;
      -ms-filter: "FlipH";
  }
  &.mdi-flip-v:before {
      -webkit-transform: scaleY(-1) rotate(90deg);
      -ms-transform: rotate(90deg);
      transform: scaleY(-1) rotate(90deg);
      filter: FlipV;
      -ms-filter: "FlipV";
  }
  */
}
.mdi-rotate-90:before {
  transform: rotate(90deg);
}

.mdi-rotate-135 {
  /*
  // Not included in production
  &.mdi-flip-h:before {
      -webkit-transform: scaleX(-1) rotate(135deg);
      transform: scaleX(-1) rotate(135deg);
      filter: FlipH;
      -ms-filter: "FlipH";
  }
  &.mdi-flip-v:before {
      -webkit-transform: scaleY(-1) rotate(135deg);
      -ms-transform: rotate(135deg);
      transform: scaleY(-1) rotate(135deg);
      filter: FlipV;
      -ms-filter: "FlipV";
  }
  */
}
.mdi-rotate-135:before {
  transform: rotate(135deg);
}

.mdi-rotate-180 {
  /*
  // Not included in production
  &.mdi-flip-h:before {
      -webkit-transform: scaleX(-1) rotate(180deg);
      transform: scaleX(-1) rotate(180deg);
      filter: FlipH;
      -ms-filter: "FlipH";
  }
  &.mdi-flip-v:before {
      -webkit-transform: scaleY(-1) rotate(180deg);
      -ms-transform: rotate(180deg);
      transform: scaleY(-1) rotate(180deg);
      filter: FlipV;
      -ms-filter: "FlipV";
  }
  */
}
.mdi-rotate-180:before {
  transform: rotate(180deg);
}

.mdi-rotate-225 {
  /*
  // Not included in production
  &.mdi-flip-h:before {
      -webkit-transform: scaleX(-1) rotate(225deg);
      transform: scaleX(-1) rotate(225deg);
      filter: FlipH;
      -ms-filter: "FlipH";
  }
  &.mdi-flip-v:before {
      -webkit-transform: scaleY(-1) rotate(225deg);
      -ms-transform: rotate(225deg);
      transform: scaleY(-1) rotate(225deg);
      filter: FlipV;
      -ms-filter: "FlipV";
  }
  */
}
.mdi-rotate-225:before {
  transform: rotate(225deg);
}

.mdi-rotate-270 {
  /*
  // Not included in production
  &.mdi-flip-h:before {
      -webkit-transform: scaleX(-1) rotate(270deg);
      transform: scaleX(-1) rotate(270deg);
      filter: FlipH;
      -ms-filter: "FlipH";
  }
  &.mdi-flip-v:before {
      -webkit-transform: scaleY(-1) rotate(270deg);
      -ms-transform: rotate(270deg);
      transform: scaleY(-1) rotate(270deg);
      filter: FlipV;
      -ms-filter: "FlipV";
  }
  */
}
.mdi-rotate-270:before {
  transform: rotate(270deg);
}

.mdi-rotate-315 {
  /*
  // Not included in production
  &.mdi-flip-h:before {
      -webkit-transform: scaleX(-1) rotate(315deg);
      transform: scaleX(-1) rotate(315deg);
      filter: FlipH;
      -ms-filter: "FlipH";
  }
  &.mdi-flip-v:before {
      -webkit-transform: scaleY(-1) rotate(315deg);
      -ms-transform: rotate(315deg);
      transform: scaleY(-1) rotate(315deg);
      filter: FlipV;
      -ms-filter: "FlipV";
  }
  */
}
.mdi-rotate-315:before {
  transform: rotate(315deg);
}

.mdi-flip-h:before {
  transform: scaleX(-1);
  filter: FlipH;
  -ms-filter: "FlipH";
}

.mdi-flip-v:before {
  transform: scaleY(-1);
  filter: FlipV;
  -ms-filter: "FlipV";
}

.mdi-spin:before {
  animation: mdi-spin 2s infinite linear;
}
@keyframes mdi-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(359deg);
  }
}
/* Animation Mixins */
@keyframes dropdownAnimation {
  from {
    opacity: 0;
    transition: all 0.3s;
  }
  to {
    opacity: 1;
    transition: all 0.3s;
  }
}
.dropdownAnimation {
  animation-name: dropdownAnimation;
  animation-duration: 0.25s;
  animation-fill-mode: both;
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
.fadeOut {
  animation-name: fadeOut;
}

.infinite-spin {
  animation-name: spin;
  animation-duration: 3s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.fadeInUp {
  animation-name: fadeInUp;
}

/* Miscellaneous Mixins */
.list-wrapper ul li .form-check .form-check-label, .list-wrapper ul li .form-check {
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100%;
  white-space: nowrap;
}

/* Typography */
body {
  font-size: 1rem;
  font-weight: normal;
  font-weight: initial;
  line-height: 1.5;
  font-family: "Rubik", sans-serif;
  -webkit-font-smoothing: antialiased;
}

h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
  font-weight: 500;
}

p {
  font-size: 0.875rem;
}

h1,
.h1 {
  font-size: 2.19rem;
}

h2,
.h2 {
  font-size: 1.875rem;
}

h3,
.h3 {
  font-size: 1.5rem;
}

h4,
.h4 {
  font-size: 1.125rem;
}

h5,
.h5 {
  font-size: 1rem;
}

h6,
.h6 {
  font-size: 0.9375rem;
}

p {
  font-size: 0.875rem;
}

.display-1 {
  font-size: 3.75rem;
}
@media (max-width: 991px) {
  .display-1 {
    font-size: 3rem;
  }
}

.display-2 {
  font-size: 3.125rem;
}
@media (max-width: 991px) {
  .display-2 {
    font-size: 2.5rem;
  }
}

.display-3 {
  font-size: 2.5rem;
}
@media (max-width: 991px) {
  .display-3 {
    font-size: 2rem;
  }
}

.display-4 {
  font-size: 1.875rem;
}
@media (max-width: 991px) {
  .display-4 {
    font-size: 1.5rem;
  }
}

.display-5 {
  font-size: 1.25rem;
}
@media (max-width: 991px) {
  .display-5 {
    font-size: 1rem;
  }
}

.blockquote {
  padding: 1.25rem;
  border: 1px solid #2c2e33;
}

address p {
  margin-bottom: 0;
}

.blockquote-primary {
  border-color: #0090e7;
}
.blockquote-primary .blockquote-footer {
  color: #0090e7;
}

.blockquote-secondary {
  border-color: #e4eaec;
}
.blockquote-secondary .blockquote-footer {
  color: #e4eaec;
}

.blockquote-success {
  border-color: #00d25b;
}
.blockquote-success .blockquote-footer {
  color: #00d25b;
}

.blockquote-info {
  border-color: #8f5fe8;
}
.blockquote-info .blockquote-footer {
  color: #8f5fe8;
}

.blockquote-warning {
  border-color: #ffab00;
}
.blockquote-warning .blockquote-footer {
  color: #ffab00;
}

.blockquote-danger {
  border-color: #fc424a;
}
.blockquote-danger .blockquote-footer {
  color: #fc424a;
}

.blockquote-light {
  border-color: #ffffff;
}
.blockquote-light .blockquote-footer {
  color: #ffffff;
}

.blockquote-dark {
  border-color: #0d0d0d;
}
.blockquote-dark .blockquote-footer {
  color: #0d0d0d;
}

.error-page h1 {
  font-size: 12rem;
}
@media (max-width: 991px) {
  .error-page h1 {
    font-size: 8rem;
  }
}

.icon-lg {
  font-size: 3.75rem;
}

.icon-md {
  font-size: 1.875rem;
}

.icon-sm {
  font-size: 1rem;
}

/* Reset Styles */
body {
  padding: 0;
  margin: 0;
  overflow-x: hidden;
}

.form-control,
.form-control:focus {
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
}

.form-control {
  box-shadow: none;
}

.form-control:focus {
  outline: 0;
  box-shadow: none;
}

a,
div,
h1,
h2,
h3,
h4,
h5,
p,
span {
  text-shadow: none;
}

[type=button]:focus,
a:active,
a:focus,
a:visited,
button::-moz-focus-inner,
input[type=reset]::-moz-focus-inner,
input[type=button]::-moz-focus-inner,
input[type=submit]::-moz-focus-inner,
input[type=file] > input[type=button]::-moz-focus-inner,
select::-moz-focus-inner {
  outline: 0;
}

input,
.form-control:focus,
input:focus,
select:focus,
textarea:focus,
button:focus {
  outline: none;
  outline-width: 0;
  outline-color: transparent;
  box-shadow: none;
  outline-style: none;
}

textarea {
  resize: none;
  overflow-x: hidden;
}

.btn,
.btn-group.open .dropdown-toggle,
.btn:active,
.btn:focus,
.btn:hover,
.btn:visited,
a,
a:active,
a:checked,
a:focus,
a:hover,
a:visited,
body,
button,
button:active,
button:hover,
button:visited,
div,
input,
input:active,
input:focus,
input:hover,
input:visited,
select,
select:active,
select:focus,
select:visited,
textarea,
textarea:active,
textarea:focus,
textarea:hover,
textarea:visited {
  box-shadow: none;
}

.btn.active.focus,
.btn.active:focus,
.btn.focus,
.btn:active.focus,
.btn:active:focus,
.btn:focus,
button,
button:active,
button:checked,
button:focus,
button:hover,
button:visited {
  outline: 0;
  outline-offset: 0;
}

.bootstrap-select .dropdown-toggle:focus {
  outline: 0;
  outline-offset: 0;
}

.dropdown-menu > li > a:active,
.dropdown-menu > li > a:focus,
.dropdown-menu > li > a:hover,
.dropdown-menu > li > a:visited {
  outline: 0;
}

a:focus,
input:focus {
  border-color: transparent;
  outline: none;
}

@media (max-width: 991px) {
  .navbar .navbar-brand-wrapper .brand-logo {
    display: none;
  }
  .navbar .navbar-brand-wrapper .brand-logo-mini {
    display: inline-block;
  }
}
@media screen and (max-width: 991px) {
  .row-offcanvas {
    position: relative;
    transition: all 0.25s ease-out;
  }
  .row-offcanvas.row-offcanvas-right {
    right: 0;
  }
  .row-offcanvas.row-offcanvas-right .sidebar-offcanvas {
    right: -100%;
  }
  .row-offcanvas.row-offcanvas-right.active {
    right: calc(50% + 30px);
  }
  .row-offcanvas.row-offcanvas-right.active .sidebar-offcanvas {
    right: calc(-50% - 15px);
  }
  .row-offcanvas.row-offcanvas-left {
    left: 0;
  }
  .row-offcanvas.row-offcanvas-left .sidebar-offcanvas {
    left: -100%;
  }
  .row-offcanvas.row-offcanvas-left.active {
    left: 50%;
  }
  .row-offcanvas.row-offcanvas-left.active .sidebar-offcanvas {
    left: -50%;
  }
  .row-offcanvas .sidebar-offcanvas {
    position: absolute;
    top: 0;
    width: calc(50% + 30px);
  }
}
/* Miscellanoeous */
body,
html {
  overflow-x: hidden;
  padding-right: 0;
}

body {
  background: #f8f8f8;
}

*:-moz-full-screen,
*:-webkit-full-screen,
*:fullscreen *:-ms-fullscreen {
  overflow: auto;
}

.page-body-wrapper {
  min-height: calc(100vh - 70px);
  display: flex;
  flex-direction: row;
  padding-left: 0;
  padding-right: 0;
  width: calc(100% - 244px);
  transition: width 0.25s ease, margin 0.25s ease;
}
.page-body-wrapper.full-page-wrapper {
  min-height: 100vh;
  width: 100%;
  padding-top: 0;
}
.page-body-wrapper.full-page-wrapper .main-panel {
  padding-top: 0;
}
.page-body-wrapper.full-page-wrapper .main-panel .content-wrapper {
  padding: 0;
}
.page-body-wrapper.full-page-wrapper .main-panel .content-wrapper > div {
  height: 100%;
}
@media (max-width: 992px) {
  .page-body-wrapper {
    width: 100%;
  }
}

.main-panel {
  transition: width 0.25s ease, margin 0.25s ease;
  width: 100%;
  min-height: calc(100vh - 70px);
  padding-top: 70px;
  display: flex;
  flex-direction: column;
}
@media (max-width: 991px) {
  .main-panel {
    margin-left: 0;
    width: 100%;
  }
}
.main-panel.main-panel-only {
  transition: none;
}

.content-wrapper {
  background: #f8f8f8;
  padding: 1.875rem 1.75rem;
  width: 100%;
  flex-grow: 1;
}

.container-scroller {
  overflow: hidden;
  display: flex;
  position: relative;
}

pre {
  background: #e8eff4;
  padding: 15px;
  font-size: 14px;
}

code {
  padding: 5px;
  color: #fc424a;
  font-family: "Rubik", sans-serif;
  font-weight: 300;
  font-size: 0.875rem;
  border-radius: 4px;
}

.page-header {
  margin: 0 0 2.5rem 0;
}
.page-header .breadcrumb {
  border: 0;
  margin-bottom: 0;
}

.page-title {
  color: #2e383e;
  font-size: 1.125rem;
  margin-bottom: 0;
}
.page-title .page-title-icon {
  display: inline-block;
  width: 36px;
  height: 36px;
  border-radius: 4px;
  text-align: center;
  box-shadow: 0px 3px 8.3px 0.7px rgba(163, 93, 255, 0.35);
}
.page-title .page-title-icon i {
  font-size: 0.9375rem;
  line-height: 36px;
}

/* Utilities */
.grid-margin {
  margin-bottom: 1.5rem;
}

@media (min-width: 576px) {
  .grid-margin-sm-0 {
    margin-bottom: 0;
  }
}

@media (min-width: 768px) {
  .grid-margin-md-0 {
    margin-bottom: 0;
  }
}

@media (min-width: 992px) {
  .grid-margin-lg-0 {
    margin-bottom: 0;
  }
}

@media (min-width: 1200px) {
  .grid-margin-xl-0 {
    margin-bottom: 0;
  }
}

.img-lg {
  width: 92px;
  height: 92px;
}

.img-sm {
  width: 43px;
  height: 43px;
}

.img-xs {
  width: 35px;
  height: 35px;
}

.img-ss, .image-grouped .text-avatar,
.image-grouped img {
  width: 26px;
  height: 26px;
}

.stretch-card {
  display: flex;
  align-items: stretch;
  justify-content: stretch;
}
.stretch-card > .card {
  width: 100%;
  min-width: 100%;
}

@media (min-width: 576px) {
  .border-right-sm {
    border-right: 1px solid #2c2e33;
  }
}

@media (min-width: 768px) {
  .border-right-md {
    border-right: 1px solid #2c2e33;
  }
}

@media (min-width: 992px) {
  .border-right-lg {
    border-right: 1px solid #2c2e33;
  }
}

@media (min-width: 576px) {
  .border-left-sm {
    border-left: 1px solid #2c2e33;
  }
}

@media (min-width: 768px) {
  .border-left-md {
    border-left: 1px solid #2c2e33;
  }
}

@media (min-width: 992px) {
  .border-left-lg {
    border-left: 1px solid #2c2e33;
  }
}

.text-gray, .card .card-subtitle {
  color: #8c8c8c;
}

.text-black {
  color: #000;
}

.text-small {
  font-size: 12px;
}

.flex-grow {
  flex-grow: 1;
}

.font-weight-light {
  font-weight: 300;
}

.font-weight-light {
  font-weight: 500;
}

.font-weight-bold {
  font-weight: 700;
}

.font-weight-normal {
  font-weight: normal;
}

.cursor-pointer {
  cursor: pointer;
}

.image-grouped {
  display: flex;
}
.image-grouped .text-avatar,
.image-grouped img {
  border-radius: 100%;
  margin-left: -10px;
  z-index: 0;
  border: 4px solid #fff;
  transform: scale(1);
  transition-duration: 0.3s;
  transition-timing-function: ease;
  transition-property: "box-shadow", "z-index", "transform", "border-width";
}
.image-grouped .text-avatar:first-child,
.image-grouped img:first-child {
  margin-left: 0;
}
.image-grouped .text-avatar:hover,
.image-grouped img:hover {
  z-index: 1;
  box-shadow: 0 0 5px -2px rgba(0, 0, 0, 0.5);
  transform: scale(1.05);
  border-width: 0;
}
.image-grouped .text-avatar {
  color: #0090e7;
  font-size: 11px;
  font-weight: 600;
}

.dot-indicator {
  width: 10px;
  height: 10px;
  border-radius: 100%;
}

.aligner-wrapper {
  position: relative;
}
.aligner-wrapper .absolute {
  position: absolute;
}
.aligner-wrapper .absolute.absolute-center {
  top: 50%;
  transform: translateY(-50%);
  bottom: 0;
  right: 0;
  left: 0;
  margin: auto;
}
.aligner-wrapper .absolute.left {
  left: 0;
}
.aligner-wrapper .absolute.right {
  right: 0;
}
.aligner-wrapper .absolute.bottom {
  bottom: 0;
}
.aligner-wrapper .absolute.top {
  top: 0;
}
.aligner-wrapper .absolute.center-content {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.v-strock-2 {
  width: 3px;
}

.bg-gray-dark {
  background: #12151e;
}

.bg-gray-lightest {
  background: #e6e9ed;
}

/* Demo Styles */
.template-demo .slider-wrap {
  height: 100px;
}
.template-demo .progress {
  margin-top: 1.5rem;
}
.template-demo > h2,
.template-demo > h3,
.template-demo > h4,
.template-demo > h5,
.template-demo > h6,
.template-demo > h1 {
  border-top: 1px solid #2c2e33;
  padding: 0.5rem 0 0;
}
.template-demo .noUi-horizontal {
  margin-top: 2rem;
}
.template-demo .noUi-vertical {
  margin-right: 2rem;
}
.template-demo > .dropdown {
  display: inline-block;
  margin-bottom: 0.5rem;
}
.template-demo nav .breadcrumb {
  margin-bottom: 1.375rem;
}
.template-demo nav:last-child .breadcrumb {
  margin-bottom: 0;
}
.template-demo .editable-form > .form-group {
  border-bottom: 1px solid #2c2e33;
  padding-bottom: 0.8rem;
  margin-bottom: 0.8rem;
}
.template-demo .circle-progress {
  padding: 15px;
}
.demo-modal {
  position: static;
  display: block;
}
.demo-modal .modal-dialog.modal-lg {
  max-width: 100%;
}

.loader-demo-box {
  width: 100%;
  height: 200px;
}

.dropdown-menu-static-demo {
  height: 250px;
  margin-bottom: 20px;
}

.rounded-legend ul li {
  list-style-type: none;
  color: #6c7293;
  font-size: 0.75rem;
}
.rounded-legend ul li .legend-dots {
  width: 1rem;
  height: 1rem;
  border-radius: 100%;
  display: inline-block;
  vertical-align: text-bottom;
  margin-right: 0.5rem;
}
.rtl .rounded-legend ul li .legend-dots {
  margin-left: 0.5rem;
}
.rounded-legend.legend-horizontal {
  display: flex;
}
.rounded-legend.legend-horizontal ul li {
  display: inline-block;
  margin-right: 1.5rem;
}
.rtl .rounded-legend.legend-horizontal ul li {
  margin-right: auto;
  margin-left: 1.5rem;
}
.rounded-legend.legend-top-right ul {
  float: right;
}
.rtl .rounded-legend.legend-top-right ul {
  float: left;
}
.rounded-legend.legend-vertical ul li {
  margin-top: 1rem;
}

.main-spinner-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: #eee;
}
.main-spinner-wrapper .donut {
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  border: 0.3rem solid rgba(151, 159, 208, 0.3);
  border-top-color: #979fd0;
  animation: 1.5s spin infinite linear;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
/* Dashboard */
.dashboard-vector-map {
  width: 100%;
  height: 300px;
  background-color: #f9f9f9; /* Light background for a cleaner look */
  border: 1px solid #ddd;
  border-radius: 5px;
}

.proBanner {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 9999;
  background: linear-gradient(90deg, #4a90e2, #50c4ab); /* Gradient background */
  color: #fff;
  padding: 20px 25px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
}
.proBanner .purchase-popup {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(255, 255, 255, 0.1);
  padding: 15px 20px;
  border-radius: 8px;
  animation: fadeIn 0.5s ease-in-out;
}
.proBanner .purchase-popup .btn {
  margin-right: 20px;
  font-weight: 600;
  padding: 10px 20px;
  border-radius: 6px;
  transition: all 0.3s ease;
}
.proBanner .purchase-popup .btn.download-button {
  background: rgba(255, 255, 255, 0.3);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.5);
}
.proBanner .purchase-popup .btn.download-button:hover {
  background: rgba(255, 255, 255, 0.5);
}
.proBanner .purchase-popup .btn.purchase-button {
  background-color: #ff6b6b;
  color: #fff;
  border: none;
  line-height: 1.2;
}
.proBanner .purchase-popup .btn.purchase-button:hover {
  background-color: #ff4c4c;
}
.proBanner .purchase-popup p {
  margin: 0;
  color: #f0f0f0;
  font-size: 1rem;
  line-height: 1.5;
}
.proBanner .purchase-popup i {
  font-size: 1.5rem;
  color: #fff;
  margin-left: 10px;
}
.proBanner .purchase-popup .bannerClose {
  cursor: pointer;
  font-size: 1.2rem;
  color: #fff;
}
.proBanner .purchase-popup .bannerClose:hover {
  color: #ff6b6b;
}
.proBanner.hide {
  display: none;
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
/* Checkboxes and Radios */
.form-check {
  position: relative;
  display: block;
  margin-top: 15px;
  margin-bottom: 10px;
  padding-left: 0;
}
.form-check .form-check-label {
  display: block;
  padding-left: 0.625rem;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #6c7293;
}
.rtl .form-check .form-check-label {
  padding-left: 0;
  padding-right: 1.875rem;
}
.form-check .form-check-label input {
  position: absolute;
  top: 0;
  left: 0;
  margin-left: 0;
  margin-top: 0;
  z-index: 1;
  cursor: pointer;
  opacity: 0;
  filter: alpha(opacity=0);
}
.rtl .form-check .form-check-label input {
  left: auto;
  right: 0;
}
.form-check .form-check-label input[type=checkbox] + .input-helper:before, .form-check .form-check-label input[type=checkbox] + .input-helper:after {
  position: absolute;
  top: 0;
  left: 0;
}
.rtl .form-check .form-check-label input[type=checkbox] + .input-helper:before, .rtl .form-check .form-check-label input[type=checkbox] + .input-helper:after {
  left: auto;
  right: 0;
}
.form-check .form-check-label input[type=checkbox] + .input-helper:before {
  content: "";
  width: 16px;
  height: 16px;
  border-radius: 2px;
  border: solid #0090e7;
  border-width: 2px;
  transition: all;
  transition-duration: 0s;
  transition-duration: 250ms;
  position: absolute;
  top: 2px;
  left: 0;
}
.form-check .form-check-label input[type=checkbox] + .input-helper:after {
  transition: all;
  transition-duration: 0s;
  transition-duration: 250ms;
  font-family: Material Design Icons;
  opacity: 0;
  filter: alpha(opacity=0);
  transform: scale(0);
  content: "\\f12c";
  font-size: 0.875rem;
  font-weight: bold;
  color: #ffffff;
  top: 1px;
}
.form-check .form-check-label input[type=checkbox]:checked + .input-helper:before {
  background: #0090e7;
  border-width: 0;
}
.form-check .form-check-label input[type=checkbox]:checked + .input-helper:after {
  width: 18px;
  opacity: 1;
  line-height: 18px;
  filter: alpha(opacity=100);
  transform: scale(1);
  color: black;
}
.form-check .form-check-label input[type=checkbox]:disabled + .input-helper:before {
  border-color: #2c2e33;
}
.form-check .form-check-label input[type=checkbox]:disabled:checked + .input-helper:after {
  background: #2c2e33;
  color: #ffffff;
}
.form-check .form-check-label input[type=radio] + .input-helper:before {
  position: absolute;
  content: "";
  top: 0;
  left: 0;
  border: solid #0090e7;
  border-width: 2px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  transition: all;
  transition-duration: 0s;
  transition-duration: 250ms;
}
.rtl .form-check .form-check-label input[type=radio] + .input-helper:before {
  left: auto;
  right: 0;
}
.form-check .form-check-label input[type=radio] + .input-helper:after {
  content: "";
  width: 8px;
  height: 8px;
  background: #ffffff;
  border-radius: 50%;
  top: 6px;
  left: 6px;
  transition: all;
  transition-duration: 0s;
  transition-duration: 250ms;
  opacity: 0;
  filter: alpha(opacity=0);
  transform: scale(0);
  position: absolute;
}
.rtl .form-check .form-check-label input[type=radio] + .input-helper:after {
  left: auto;
  right: 6px;
}
.form-check .form-check-label input[type=radio]:checked + .input-helper:before {
  background: #0090e7;
  border-width: 0;
}
.form-check .form-check-label input[type=radio]:checked + .input-helper:after {
  opacity: 1;
  line-height: 1.5;
  filter: alpha(opacity=100);
  transform: scale(1);
}
.form-check .form-check-label input[type=radio]:disabled + .input-helper:before {
  border-color: #2c2e33;
}
.form-check .form-check-label input[type=radio]:disabled:checked + .input-helper:before {
  background: #2c2e33;
}
.form-check .form-check-label input[type=radio]:disabled:checked + .input-helper:after {
  background: #ffffff;
}

.form-check-primary.form-check label input[type=checkbox] + .input-helper:before,
.form-check-primary.form-check label input[type=radio] + .input-helper:before {
  border-color: #0090e7;
}
.form-check-primary.form-check label input[type=checkbox]:checked + .input-helper:before,
.form-check-primary.form-check label input[type=radio]:checked + .input-helper:before {
  background: #0090e7;
}

.form-check-secondary.form-check label input[type=checkbox] + .input-helper:before,
.form-check-secondary.form-check label input[type=radio] + .input-helper:before {
  border-color: #e4eaec;
}
.form-check-secondary.form-check label input[type=checkbox]:checked + .input-helper:before,
.form-check-secondary.form-check label input[type=radio]:checked + .input-helper:before {
  background: #e4eaec;
}

.form-check-success.form-check label input[type=checkbox] + .input-helper:before,
.form-check-success.form-check label input[type=radio] + .input-helper:before {
  border-color: #00d25b;
}
.form-check-success.form-check label input[type=checkbox]:checked + .input-helper:before,
.form-check-success.form-check label input[type=radio]:checked + .input-helper:before {
  background: #00d25b;
}

.form-check-info.form-check label input[type=checkbox] + .input-helper:before,
.form-check-info.form-check label input[type=radio] + .input-helper:before {
  border-color: #8f5fe8;
}
.form-check-info.form-check label input[type=checkbox]:checked + .input-helper:before,
.form-check-info.form-check label input[type=radio]:checked + .input-helper:before {
  background: #8f5fe8;
}

.form-check-warning.form-check label input[type=checkbox] + .input-helper:before,
.form-check-warning.form-check label input[type=radio] + .input-helper:before {
  border-color: #ffab00;
}
.form-check-warning.form-check label input[type=checkbox]:checked + .input-helper:before,
.form-check-warning.form-check label input[type=radio]:checked + .input-helper:before {
  background: #ffab00;
}

.form-check-danger.form-check label input[type=checkbox] + .input-helper:before,
.form-check-danger.form-check label input[type=radio] + .input-helper:before {
  border-color: #fc424a;
}
.form-check-danger.form-check label input[type=checkbox]:checked + .input-helper:before,
.form-check-danger.form-check label input[type=radio]:checked + .input-helper:before {
  background: #fc424a;
}

.form-check-light.form-check label input[type=checkbox] + .input-helper:before,
.form-check-light.form-check label input[type=radio] + .input-helper:before {
  border-color: #ffffff;
}
.form-check-light.form-check label input[type=checkbox]:checked + .input-helper:before,
.form-check-light.form-check label input[type=radio]:checked + .input-helper:before {
  background: #ffffff;
}

.form-check-dark.form-check label input[type=checkbox] + .input-helper:before,
.form-check-dark.form-check label input[type=radio] + .input-helper:before {
  border-color: #0d0d0d;
}
.form-check-dark.form-check label input[type=checkbox]:checked + .input-helper:before,
.form-check-dark.form-check label input[type=radio]:checked + .input-helper:before {
  background: #0d0d0d;
}

.form-check-muted.form-check label input[type=checkbox] + .input-helper:before,
.form-check-muted.form-check label input[type=radio] + .input-helper:before {
  border-color: #6c7293;
}
.form-check-muted.form-check label input[type=checkbox]:checked + .input-helper:before,
.form-check-muted.form-check label input[type=radio]:checked + .input-helper:before {
  background: #6c7293;
}

/* Forms */
.form-group {
  margin-bottom: 1rem;
}

label {
  color: #c4c4c4;
}

.input-group-append,
.input-group-prepend {
  color: #2e383e;
  width: auto;
  border: none;
}
.input-group-append .input-group-text,
.input-group-prepend .input-group-text {
  border-color: #2c2e33;
  padding: 0.56rem 0.75rem;
  color: #2e383e;
  background: none;
}

.form-control {
  border: 1px solid #2c2e33;
  height: calc(2.25rem + 2px);
  font-weight: normal;
  font-size: 0.875rem;
  padding: 0.625rem 0.6875rem;
  background-color: #fff;
  border-radius: 2px;
  color: #2e383e;
}
.form-control:focus {
  border: 1px solid rgba(71, 164, 71, 0.5);
  background-color: #fff;
}
.form-control.form-control-lg {
  padding: 0.94rem 0.75rem;
  height: calc(2.875rem + 2px);
}
.form-control.form-control-sm {
  padding: 0.5rem 0.75rem;
  height: calc(1.8125rem + 2px);
}
.form-control::placeholder {
  color: #6c7293;
  font-size: 0.875rem;
}

.navbar .form-control {
  width: 75%;
  border-radius: 6px;
}
.navbar .form-control:focus {
  border: none;
}

select.form-control {
  padding: 0.4375rem 0.75rem;
  border: 0;
  outline: 1px solid #322f2f;
  color: #2e383e;
}
select.form-control:focus {
  outline: 1px solid #2c2e33;
}
select.form-control.border-primary {
  outline: 1px solid #0090e7;
}
select.form-control.border-primary:focus {
  outline: 1px solid #0090e7;
}
select.form-control.border-secondary, select.form-control.loader-demo-box {
  outline: 1px solid #e4eaec;
}
select.form-control.border-secondary:focus, select.form-control.loader-demo-box:focus {
  outline: 1px solid #e4eaec;
}
select.form-control.border-success {
  outline: 1px solid #00d25b;
}
select.form-control.border-success:focus {
  outline: 1px solid #00d25b;
}
select.form-control.border-info {
  outline: 1px solid #8f5fe8;
}
select.form-control.border-info:focus {
  outline: 1px solid #8f5fe8;
}
select.form-control.border-warning {
  outline: 1px solid #ffab00;
}
select.form-control.border-warning:focus {
  outline: 1px solid #ffab00;
}
select.form-control.border-danger {
  outline: 1px solid #fc424a;
}
select.form-control.border-danger:focus {
  outline: 1px solid #fc424a;
}
select.form-control.border-light {
  outline: 1px solid #ffffff;
}
select.form-control.border-light:focus {
  outline: 1px solid #ffffff;
}
select.form-control.border-dark {
  outline: 1px solid #0d0d0d;
}
select.form-control.border-dark:focus {
  outline: 1px solid #0d0d0d;
}

.form-group label {
  font-size: 0.875rem;
  line-height: 1;
  vertical-align: top;
}
.form-group.has-danger .form-control {
  border-color: #fc424a;
}
.form-group .file-upload-default {
  visibility: hidden;
  position: absolute;
}
.form-group .file-upload-info {
  background: transparent;
}

.form-check {
  min-height: 18px;
  padding-left: 1.25rem;
}

div.tagsinput {
  background: transparent;
}

.custom-file .visibility-hidden {
  visibility: hidden;
}
.custom-file .custom-file-label {
  background: #fff;
  border: 1px solid #2c2e33;
  height: calc(2.25rem + 2px);
  font-weight: normal;
  font-size: 0.875rem;
  padding: 0.625rem 0.6875rem;
  border-radius: 2px;
}
.custom-file .custom-file-label:after {
  background-color: #0090e7;
  height: auto;
}

/* Icons */
.icons-list {
  border-left: 1px solid #2c2e33;
  border-bottom: 1px solid #2c2e33;
}
.icons-list > div {
  background: inherit;
  border-top: 1px solid #2c2e33;
  border-right: 1px solid #2c2e33;
  display: flex;
  align-items: center;
  padding: 15px 15px;
  font-family: "Rubik", sans-serif;
  font-size: 0.875rem;
}
.icons-list > div i {
  display: inline-block;
  font-size: 20px;
  width: 40px;
  text-align: left;
  color: #0090e7;
}

/* Tables */
.table {
  margin-bottom: 0;
  color: #6c7293;
}
.table thead th {
  border-top: 0;
  border-bottom-width: 1px;
  font-family: "Rubik", sans-serif;
  font-weight: 500;
}
.table thead th i {
  margin-left: 0.325rem;
}
.table th,
.table td {
  vertical-align: middle;
  font-size: 0.875rem;
  line-height: 1;
}
.table th img,
.table td img {
  width: 30px;
  height: 30px;
  border-radius: 100%;
}
.table th .badge,
.table td .badge {
  margin-bottom: 0;
}
.table.table-borderless {
  border: none;
}
.table.table-borderless tr, .table.table-borderless td, .table.table-borderless th {
  border: none;
}

/* Buttons */
.btn {
  font-size: 0.9375rem;
  line-height: 1;
  font-weight: normal;
  /* Buttons with only icons */
  /* Buttons with icon and text */
}
.btn i {
  margin-right: 0.3125rem;
}
.btn.btn-rounded {
  border-radius: 50px;
}
.btn.btn-fw {
  min-width: 150px;
}
.btn.btn-sm, .btn-group-sm > .btn {
  font-size: 0.875rem;
}
.btn.btn-lg, .btn-group-lg > .btn {
  font-size: 0.875rem;
}
.btn.btn-xs {
  padding: 0.5rem 0.75rem;
  font-size: 0.625rem;
}
.btn.btn-icon {
  width: 42px;
  height: 42px;
  padding: 0;
}
.btn.btn-icon-text .btn-icon-prepend {
  margin-right: 0.5rem;
}
.btn.btn-icon-text .btn-icon-append {
  margin-left: 0.5rem;
}
.btn.btn-social-icon {
  width: 50px;
  height: 50px;
  padding: 0;
}
.btn.get-started-btn {
  font-size: 0.75rem;
  border: 1px solid rgba(255, 255, 255, 0.3);
  font-weight: 500;
  padding: 0.9375rem 1.0625rem;
}
@media (max-width: 576px) {
  .btn.get-started-btn {
    font-size: 0.6rem;
    padding: 0.4375rem 0.6625rem;
  }
}

.btn-group .btn + .btn {
  border-left: 0;
}

/*social buttons*/
.btn-twitter {
  background: #2caae1;
  color: #ffffff;
}
.btn-twitter:hover, .btn-twitter:focus {
  background: #1b8dbf;
  color: #ffffff;
}
.btn-twitter.btn-social-icon-text {
  padding: 0 1.5rem 0 0;
  background: #59bce7;
}
.btn-twitter.btn-social-icon-text i {
  background: #2caae1;
  padding: 0.75rem;
  display: inline-block;
  margin-right: 1.5rem;
}

.btn-outline-twitter {
  border: 1px solid #2caae1;
  color: #2caae1;
}
.btn-outline-twitter:hover {
  background: #2caae1;
  color: #ffffff;
}

.btn-facebook {
  background: #3b579d;
  color: #ffffff;
}
.btn-facebook:hover, .btn-facebook:focus {
  background: #2d4278;
  color: #ffffff;
}
.btn-facebook.btn-social-icon-text {
  padding: 0 1.5rem 0 0;
  background: #4e6ebd;
}
.btn-facebook.btn-social-icon-text i {
  background: #3b579d;
  padding: 0.75rem;
  display: inline-block;
  margin-right: 1.5rem;
}

.btn-outline-facebook {
  border: 1px solid #3b579d;
  color: #3b579d;
}
.btn-outline-facebook:hover {
  background: #3b579d;
  color: #ffffff;
}

.btn-google {
  background: #dc4a38;
  color: #ffffff;
}
.btn-google:hover, .btn-google:focus {
  background: #bf3322;
  color: #ffffff;
}
.btn-google.btn-social-icon-text {
  padding: 0 1.5rem 0 0;
  background: #e47163;
}
.btn-google.btn-social-icon-text i {
  background: #dc4a38;
  padding: 0.75rem;
  display: inline-block;
  margin-right: 1.5rem;
}

.btn-outline-google {
  border: 1px solid #dc4a38;
  color: #dc4a38;
}
.btn-outline-google:hover {
  background: #dc4a38;
  color: #ffffff;
}

.btn-linkedin {
  background: #0177b5;
  color: #ffffff;
}
.btn-linkedin:hover, .btn-linkedin:focus {
  background: #015682;
  color: #ffffff;
}
.btn-linkedin.btn-social-icon-text {
  padding: 0 1.5rem 0 0;
  background: #0198e8;
}
.btn-linkedin.btn-social-icon-text i {
  background: #0177b5;
  padding: 0.75rem;
  display: inline-block;
  margin-right: 1.5rem;
}

.btn-outline-linkedin {
  border: 1px solid #0177b5;
  color: #0177b5;
}
.btn-outline-linkedin:hover {
  background: #0177b5;
  color: #ffffff;
}

.btn-pinterest {
  background: #cc2127;
  color: #ffffff;
}
.btn-pinterest:hover, .btn-pinterest:focus {
  background: #a01a1f;
  color: #ffffff;
}
.btn-pinterest.btn-social-icon-text {
  padding: 0 1.5rem 0 0;
  background: #e04046;
}
.btn-pinterest.btn-social-icon-text i {
  background: #cc2127;
  padding: 0.75rem;
  display: inline-block;
  margin-right: 1.5rem;
}

.btn-outline-pinterest {
  border: 1px solid #cc2127;
  color: #cc2127;
}
.btn-outline-pinterest:hover {
  background: #cc2127;
  color: #ffffff;
}

.btn-youtube {
  background: #e52d27;
  color: #ffffff;
}
.btn-youtube:hover, .btn-youtube:focus {
  background: #c21d17;
  color: #ffffff;
}
.btn-youtube.btn-social-icon-text {
  padding: 0 1.5rem 0 0;
  background: #ea5955;
}
.btn-youtube.btn-social-icon-text i {
  background: #e52d27;
  padding: 0.75rem;
  display: inline-block;
  margin-right: 1.5rem;
}

.btn-outline-youtube {
  border: 1px solid #e52d27;
  color: #e52d27;
}
.btn-outline-youtube:hover {
  background: #e52d27;
  color: #ffffff;
}

.btn-github {
  background: #333333;
  color: #ffffff;
}
.btn-github:hover, .btn-github:focus {
  background: #1a1a1a;
  color: #ffffff;
}
.btn-github.btn-social-icon-text {
  padding: 0 1.5rem 0 0;
  background: #4d4d4d;
}
.btn-github.btn-social-icon-text i {
  background: #333333;
  padding: 0.75rem;
  display: inline-block;
  margin-right: 1.5rem;
}

.btn-outline-github {
  border: 1px solid #333333;
  color: #333333;
}
.btn-outline-github:hover {
  background: #333333;
  color: #ffffff;
}

.btn-behance {
  background: #1769ff;
  color: #ffffff;
}
.btn-behance:hover, .btn-behance:focus {
  background: #0050e3;
  color: #ffffff;
}
.btn-behance.btn-social-icon-text {
  padding: 0 1.5rem 0 0;
  background: #4a8aff;
}
.btn-behance.btn-social-icon-text i {
  background: #1769ff;
  padding: 0.75rem;
  display: inline-block;
  margin-right: 1.5rem;
}

.btn-outline-behance {
  border: 1px solid #1769ff;
  color: #1769ff;
}
.btn-outline-behance:hover {
  background: #1769ff;
  color: #ffffff;
}

.btn-dribbble {
  background: #ea4c89;
  color: #ffffff;
}
.btn-dribbble:hover, .btn-dribbble:focus {
  background: #e51e6b;
  color: #ffffff;
}
.btn-dribbble.btn-social-icon-text {
  padding: 0 1.5rem 0 0;
  background: #ef7aa7;
}
.btn-dribbble.btn-social-icon-text i {
  background: #ea4c89;
  padding: 0.75rem;
  display: inline-block;
  margin-right: 1.5rem;
}

.btn-outline-dribbble {
  border: 1px solid #ea4c89;
  color: #ea4c89;
}
.btn-outline-dribbble:hover {
  background: #ea4c89;
  color: #ffffff;
}

.btn-reddit {
  background: #ff4500;
  color: #ffffff;
}
.btn-reddit:hover, .btn-reddit:focus {
  background: #cc3700;
  color: #ffffff;
}
.btn-reddit.btn-social-icon-text {
  padding: 0 1.5rem 0 0;
  background: #ff6a33;
}
.btn-reddit.btn-social-icon-text i {
  background: #ff4500;
  padding: 0.75rem;
  display: inline-block;
  margin-right: 1.5rem;
}

.btn-outline-reddit {
  border: 1px solid #ff4500;
  color: #ff4500;
}
.btn-outline-reddit:hover {
  background: #ff4500;
  color: #ffffff;
}

/* inverse buttons */
.btn-inverse-primary {
  background-color: rgba(0, 144, 231, 0.2);
  background-image: none;
  border-color: rgba(0, 144, 231, 0);
}
.btn-inverse-primary:not(.btn-inverse-light) {
  color: #0090e7;
}
.btn-inverse-primary:hover {
  color: #ffffff;
  background-color: #0090e7;
  border-color: #0090e7;
}
.btn-inverse-primary.focus, .btn-inverse-primary:focus {
  box-shadow: 0 0 0 3px rgba(0, 144, 231, 0.5);
}
.btn-inverse-primary.disabled, .btn-inverse-primary:disabled {
  color: #0090e7;
  background-color: transparent;
}
.btn-inverse-primary.active, .btn-inverse-primary:active, .show > .btn-inverse-primary.dropdown-toggle {
  color: #ffffff;
  background-color: #0090e7;
  border-color: #0090e7;
}

.btn-primary:not(.btn-light):not(.btn-secondary), .custom-file .custom-file-label:not(.btn-light):not(.btn-secondary):after {
  color: #ffffff;
}
.btn-primary:not(.btn-light):not(.btn-secondary):hover, .custom-file .custom-file-label:not(.btn-light):not(.btn-secondary):hover:after, .btn-primary:not(.btn-light):not(.btn-secondary):focus, .custom-file .custom-file-label:not(.btn-light):not(.btn-secondary):focus:after, .btn-primary:not(.btn-light):not(.btn-secondary):active, .custom-file .custom-file-label:not(.btn-light):not(.btn-secondary):active:after {
  color: #ffffff;
}
.btn-primary:not(.btn-light):not(.btn-secondary):focus, .custom-file .custom-file-label:not(.btn-light):not(.btn-secondary):focus:after, .btn-primary:not(.btn-light):not(.btn-secondary):active, .custom-file .custom-file-label:not(.btn-light):not(.btn-secondary):active:after {
  background: #0090e7;
  border-color: #0090e7;
}

.btn-inverse-secondary {
  background-color: rgba(228, 234, 236, 0.2);
  background-image: none;
  border-color: rgba(228, 234, 236, 0);
}
.btn-inverse-secondary:not(.btn-inverse-light) {
  color: #e4eaec;
}
.btn-inverse-secondary:hover {
  color: #ffffff;
  background-color: #e4eaec;
  border-color: #e4eaec;
}
.btn-inverse-secondary.focus, .btn-inverse-secondary:focus {
  box-shadow: 0 0 0 3px rgba(228, 234, 236, 0.5);
}
.btn-inverse-secondary.disabled, .btn-inverse-secondary:disabled {
  color: #e4eaec;
  background-color: transparent;
}
.btn-inverse-secondary.active, .btn-inverse-secondary:active, .show > .btn-inverse-secondary.dropdown-toggle {
  color: #ffffff;
  background-color: #e4eaec;
  border-color: #e4eaec;
}

.btn-secondary:not(.btn-light):not(.btn-secondary) {
  color: #ffffff;
}
.btn-secondary:not(.btn-light):not(.btn-secondary):hover, .btn-secondary:not(.btn-light):not(.btn-secondary):focus, .btn-secondary:not(.btn-light):not(.btn-secondary):active {
  color: #ffffff;
}
.btn-secondary:not(.btn-light):not(.btn-secondary):focus, .btn-secondary:not(.btn-light):not(.btn-secondary):active {
  background: #e4eaec;
  border-color: #e4eaec;
}

.btn-inverse-success {
  background-color: rgba(0, 210, 91, 0.2);
  background-image: none;
  border-color: rgba(0, 210, 91, 0);
}
.btn-inverse-success:not(.btn-inverse-light) {
  color: #00d25b;
}
.btn-inverse-success:hover {
  color: #ffffff;
  background-color: #00d25b;
  border-color: #00d25b;
}
.btn-inverse-success.focus, .btn-inverse-success:focus {
  box-shadow: 0 0 0 3px rgba(0, 210, 91, 0.5);
}
.btn-inverse-success.disabled, .btn-inverse-success:disabled {
  color: #00d25b;
  background-color: transparent;
}
.btn-inverse-success.active, .btn-inverse-success:active, .show > .btn-inverse-success.dropdown-toggle {
  color: #ffffff;
  background-color: #00d25b;
  border-color: #00d25b;
}

.btn-success:not(.btn-light):not(.btn-secondary) {
  color: #ffffff;
}
.btn-success:not(.btn-light):not(.btn-secondary):hover, .btn-success:not(.btn-light):not(.btn-secondary):focus, .btn-success:not(.btn-light):not(.btn-secondary):active {
  color: #ffffff;
}
.btn-success:not(.btn-light):not(.btn-secondary):focus, .btn-success:not(.btn-light):not(.btn-secondary):active {
  background: #00d25b;
  border-color: #00d25b;
}

.btn-inverse-info {
  background-color: rgba(143, 95, 232, 0.2);
  background-image: none;
  border-color: rgba(143, 95, 232, 0);
}
.btn-inverse-info:not(.btn-inverse-light) {
  color: #8f5fe8;
}
.btn-inverse-info:hover {
  color: #ffffff;
  background-color: #8f5fe8;
  border-color: #8f5fe8;
}
.btn-inverse-info.focus, .btn-inverse-info:focus {
  box-shadow: 0 0 0 3px rgba(143, 95, 232, 0.5);
}
.btn-inverse-info.disabled, .btn-inverse-info:disabled {
  color: #8f5fe8;
  background-color: transparent;
}
.btn-inverse-info.active, .btn-inverse-info:active, .show > .btn-inverse-info.dropdown-toggle {
  color: #ffffff;
  background-color: #8f5fe8;
  border-color: #8f5fe8;
}

.btn-info:not(.btn-light):not(.btn-secondary) {
  color: #ffffff;
}
.btn-info:not(.btn-light):not(.btn-secondary):hover, .btn-info:not(.btn-light):not(.btn-secondary):focus, .btn-info:not(.btn-light):not(.btn-secondary):active {
  color: #ffffff;
}
.btn-info:not(.btn-light):not(.btn-secondary):focus, .btn-info:not(.btn-light):not(.btn-secondary):active {
  background: #8f5fe8;
  border-color: #8f5fe8;
}

.btn-inverse-warning {
  background-color: rgba(255, 171, 0, 0.2);
  background-image: none;
  border-color: rgba(255, 171, 0, 0);
}
.btn-inverse-warning:not(.btn-inverse-light) {
  color: #ffab00;
}
.btn-inverse-warning:hover {
  color: #ffffff;
  background-color: #ffab00;
  border-color: #ffab00;
}
.btn-inverse-warning.focus, .btn-inverse-warning:focus {
  box-shadow: 0 0 0 3px rgba(255, 171, 0, 0.5);
}
.btn-inverse-warning.disabled, .btn-inverse-warning:disabled {
  color: #ffab00;
  background-color: transparent;
}
.btn-inverse-warning.active, .btn-inverse-warning:active, .show > .btn-inverse-warning.dropdown-toggle {
  color: #ffffff;
  background-color: #ffab00;
  border-color: #ffab00;
}

.btn-warning:not(.btn-light):not(.btn-secondary) {
  color: #ffffff;
}
.btn-warning:not(.btn-light):not(.btn-secondary):hover, .btn-warning:not(.btn-light):not(.btn-secondary):focus, .btn-warning:not(.btn-light):not(.btn-secondary):active {
  color: #ffffff;
}
.btn-warning:not(.btn-light):not(.btn-secondary):focus, .btn-warning:not(.btn-light):not(.btn-secondary):active {
  background: #ffab00;
  border-color: #ffab00;
}

.btn-inverse-danger {
  background-color: rgba(252, 66, 74, 0.2);
  background-image: none;
  border-color: rgba(252, 66, 74, 0);
}
.btn-inverse-danger:not(.btn-inverse-light) {
  color: #fc424a;
}
.btn-inverse-danger:hover {
  color: #ffffff;
  background-color: #fc424a;
  border-color: #fc424a;
}
.btn-inverse-danger.focus, .btn-inverse-danger:focus {
  box-shadow: 0 0 0 3px rgba(252, 66, 74, 0.5);
}
.btn-inverse-danger.disabled, .btn-inverse-danger:disabled {
  color: #fc424a;
  background-color: transparent;
}
.btn-inverse-danger.active, .btn-inverse-danger:active, .show > .btn-inverse-danger.dropdown-toggle {
  color: #ffffff;
  background-color: #fc424a;
  border-color: #fc424a;
}

.btn-danger:not(.btn-light):not(.btn-secondary) {
  color: #ffffff;
}
.btn-danger:not(.btn-light):not(.btn-secondary):hover, .btn-danger:not(.btn-light):not(.btn-secondary):focus, .btn-danger:not(.btn-light):not(.btn-secondary):active {
  color: #ffffff;
}
.btn-danger:not(.btn-light):not(.btn-secondary):focus, .btn-danger:not(.btn-light):not(.btn-secondary):active {
  background: #fc424a;
  border-color: #fc424a;
}

.btn-inverse-light {
  background-color: rgba(255, 255, 255, 0.2);
  background-image: none;
  border-color: rgba(255, 255, 255, 0);
}
.btn-inverse-light:not(.btn-inverse-light) {
  color: #ffffff;
}
.btn-inverse-light:hover {
  color: #ffffff;
  background-color: #ffffff;
  border-color: #ffffff;
}
.btn-inverse-light.focus, .btn-inverse-light:focus {
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.5);
}
.btn-inverse-light.disabled, .btn-inverse-light:disabled {
  color: #ffffff;
  background-color: transparent;
}
.btn-inverse-light.active, .btn-inverse-light:active, .show > .btn-inverse-light.dropdown-toggle {
  color: #ffffff;
  background-color: #ffffff;
  border-color: #ffffff;
}

.btn-light:not(.btn-light):not(.btn-secondary) {
  color: #ffffff;
}
.btn-light:not(.btn-light):not(.btn-secondary):hover, .btn-light:not(.btn-light):not(.btn-secondary):focus, .btn-light:not(.btn-light):not(.btn-secondary):active {
  color: #ffffff;
}
.btn-light:not(.btn-light):not(.btn-secondary):focus, .btn-light:not(.btn-light):not(.btn-secondary):active {
  background: #ffffff;
  border-color: #ffffff;
}

.btn-inverse-dark {
  background-color: rgba(13, 13, 13, 0.2);
  background-image: none;
  border-color: rgba(13, 13, 13, 0);
}
.btn-inverse-dark:not(.btn-inverse-light) {
  color: #0d0d0d;
}
.btn-inverse-dark:hover {
  color: #ffffff;
  background-color: #0d0d0d;
  border-color: #0d0d0d;
}
.btn-inverse-dark.focus, .btn-inverse-dark:focus {
  box-shadow: 0 0 0 3px rgba(13, 13, 13, 0.5);
}
.btn-inverse-dark.disabled, .btn-inverse-dark:disabled {
  color: #0d0d0d;
  background-color: transparent;
}
.btn-inverse-dark.active, .btn-inverse-dark:active, .show > .btn-inverse-dark.dropdown-toggle {
  color: #ffffff;
  background-color: #0d0d0d;
  border-color: #0d0d0d;
}

.btn-dark:not(.btn-light):not(.btn-secondary) {
  color: #ffffff;
}
.btn-dark:not(.btn-light):not(.btn-secondary):hover, .btn-dark:not(.btn-light):not(.btn-secondary):focus, .btn-dark:not(.btn-light):not(.btn-secondary):active {
  color: #ffffff;
}
.btn-dark:not(.btn-light):not(.btn-secondary):focus, .btn-dark:not(.btn-light):not(.btn-secondary):active {
  background: #0d0d0d;
  border-color: #0d0d0d;
}

/* Breadcrumbs */
.breadcrumb {
  border: 1px solid #2c2e33;
}
.breadcrumb .breadcrumb-item {
  font-size: 0.875rem;
}
.breadcrumb .breadcrumb-item.active {
  color: rgba(46, 56, 62, 0.8);
}
.breadcrumb.breadcrumb-custom {
  padding: 0 0;
  border-color: #141414;
}
.breadcrumb.breadcrumb-custom .breadcrumb-item {
  font-size: 0.875rem;
  background: #141414;
  padding: 0.56rem 10px;
  color: #FFFFF0;
  display: inline-block;
  vertical-align: top;
}
.breadcrumb.breadcrumb-custom .breadcrumb-item:last-child {
  background: transparent;
}
.breadcrumb.breadcrumb-custom .breadcrumb-item:before {
  content: "";
}
.breadcrumb.breadcrumb-custom .breadcrumb-item a {
  position: relative;
  color: inherit;
  border: 1px solid #141414;
  display: inline-block;
  vertical-align: top;
}
.breadcrumb.breadcrumb-custom .breadcrumb-item a:before, .breadcrumb.breadcrumb-custom .breadcrumb-item a:after {
  position: absolute;
  top: -9px;
  width: 0;
  height: 0;
  content: "";
  border-top: 21px solid transparent;
  border-bottom: 21px solid transparent;
}
.breadcrumb.breadcrumb-custom .breadcrumb-item a:before {
  right: -22px;
  z-index: 3;
  border-left-color: #141414;
  border-left-style: solid;
  border-left-width: 12px;
}
.breadcrumb.breadcrumb-custom .breadcrumb-item a:after {
  border-top: 21px solid transparent;
  border-bottom: 22px solid transparent;
  border-left: 12px solid rgba(255, 255, 255, 0.1);
  top: -9px;
  right: -23px;
}
.breadcrumb.breadcrumb-custom .breadcrumb-item span {
  display: inline-block;
  vertical-align: top;
}
.breadcrumb.breadcrumb-custom .breadcrumb-item.active {
  color: rgba(46, 56, 62, 0.8);
}

/* inverse breadcrumb */
.bg-inverse-primary, .image-grouped .text-avatar {
  background: rgba(0, 144, 231, 0.25);
  border-color: #0090e7;
}
.bg-inverse-primary .breadcrumb-item, .image-grouped .text-avatar .breadcrumb-item {
  color: #0090e7;
}
.bg-inverse-primary .breadcrumb-item:before, .image-grouped .text-avatar .breadcrumb-item:before {
  color: inherit;
}
.bg-inverse-primary .breadcrumb-item a, .image-grouped .text-avatar .breadcrumb-item a {
  color: inherit;
}
.bg-inverse-primary.breadcrumb-custom, .image-grouped .breadcrumb-custom.text-avatar {
  background: transparent;
}
.bg-inverse-primary.breadcrumb-custom .breadcrumb-item, .image-grouped .breadcrumb-custom.text-avatar .breadcrumb-item {
  background: #68c6ff;
}
.bg-inverse-primary.breadcrumb-custom .breadcrumb-item a, .image-grouped .breadcrumb-custom.text-avatar .breadcrumb-item a {
  color: #0090e7;
  border: none;
}
.bg-inverse-primary.breadcrumb-custom .breadcrumb-item a:before, .image-grouped .breadcrumb-custom.text-avatar .breadcrumb-item a:before {
  border-left-color: #68c6ff;
}
.bg-inverse-primary.breadcrumb-custom .breadcrumb-item span, .image-grouped .breadcrumb-custom.text-avatar .breadcrumb-item span {
  color: #0090e7;
}
.bg-inverse-primary.breadcrumb-custom .breadcrumb-item:last-child, .image-grouped .breadcrumb-custom.text-avatar .breadcrumb-item:last-child {
  background: transparent;
}

.bg-inverse-secondary {
  background: rgba(228, 234, 236, 0.25);
  border-color: #e4eaec;
}
.bg-inverse-secondary .breadcrumb-item {
  color: #e4eaec;
}
.bg-inverse-secondary .breadcrumb-item:before {
  color: inherit;
}
.bg-inverse-secondary .breadcrumb-item a {
  color: inherit;
}
.bg-inverse-secondary.breadcrumb-custom {
  background: transparent;
}
.bg-inverse-secondary.breadcrumb-custom .breadcrumb-item {
  background: white;
}
.bg-inverse-secondary.breadcrumb-custom .breadcrumb-item a {
  color: #e4eaec;
  border: none;
}
.bg-inverse-secondary.breadcrumb-custom .breadcrumb-item a:before {
  border-left-color: white;
}
.bg-inverse-secondary.breadcrumb-custom .breadcrumb-item span {
  color: #e4eaec;
}
.bg-inverse-secondary.breadcrumb-custom .breadcrumb-item:last-child {
  background: transparent;
}

.bg-inverse-success {
  background: rgba(0, 210, 91, 0.25);
  border-color: #00d25b;
}
.bg-inverse-success .breadcrumb-item {
  color: #00d25b;
}
.bg-inverse-success .breadcrumb-item:before {
  color: inherit;
}
.bg-inverse-success .breadcrumb-item a {
  color: inherit;
}
.bg-inverse-success.breadcrumb-custom {
  background: transparent;
}
.bg-inverse-success.breadcrumb-custom .breadcrumb-item {
  background: #53ff9d;
}
.bg-inverse-success.breadcrumb-custom .breadcrumb-item a {
  color: #00d25b;
  border: none;
}
.bg-inverse-success.breadcrumb-custom .breadcrumb-item a:before {
  border-left-color: #53ff9d;
}
.bg-inverse-success.breadcrumb-custom .breadcrumb-item span {
  color: #00d25b;
}
.bg-inverse-success.breadcrumb-custom .breadcrumb-item:last-child {
  background: transparent;
}

.bg-inverse-info {
  background: rgba(143, 95, 232, 0.25);
  border-color: #8f5fe8;
}
.bg-inverse-info .breadcrumb-item {
  color: #8f5fe8;
}
.bg-inverse-info .breadcrumb-item:before {
  color: inherit;
}
.bg-inverse-info .breadcrumb-item a {
  color: inherit;
}
.bg-inverse-info.breadcrumb-custom {
  background: transparent;
}
.bg-inverse-info.breadcrumb-custom .breadcrumb-item {
  background: #ddcef8;
}
.bg-inverse-info.breadcrumb-custom .breadcrumb-item a {
  color: #8f5fe8;
  border: none;
}
.bg-inverse-info.breadcrumb-custom .breadcrumb-item a:before {
  border-left-color: #ddcef8;
}
.bg-inverse-info.breadcrumb-custom .breadcrumb-item span {
  color: #8f5fe8;
}
.bg-inverse-info.breadcrumb-custom .breadcrumb-item:last-child {
  background: transparent;
}

.bg-inverse-warning {
  background: rgba(255, 171, 0, 0.25);
  border-color: #ffab00;
}
.bg-inverse-warning .breadcrumb-item {
  color: #ffab00;
}
.bg-inverse-warning .breadcrumb-item:before {
  color: inherit;
}
.bg-inverse-warning .breadcrumb-item a {
  color: inherit;
}
.bg-inverse-warning.breadcrumb-custom {
  background: transparent;
}
.bg-inverse-warning.breadcrumb-custom .breadcrumb-item {
  background: #ffd580;
}
.bg-inverse-warning.breadcrumb-custom .breadcrumb-item a {
  color: #ffab00;
  border: none;
}
.bg-inverse-warning.breadcrumb-custom .breadcrumb-item a:before {
  border-left-color: #ffd580;
}
.bg-inverse-warning.breadcrumb-custom .breadcrumb-item span {
  color: #ffab00;
}
.bg-inverse-warning.breadcrumb-custom .breadcrumb-item:last-child {
  background: transparent;
}

.bg-inverse-danger {
  background: rgba(252, 66, 74, 0.25);
  border-color: #fc424a;
}
.bg-inverse-danger .breadcrumb-item {
  color: #fc424a;
}
.bg-inverse-danger .breadcrumb-item:before {
  color: inherit;
}
.bg-inverse-danger .breadcrumb-item a {
  color: inherit;
}
.bg-inverse-danger.breadcrumb-custom {
  background: transparent;
}
.bg-inverse-danger.breadcrumb-custom .breadcrumb-item {
  background: #fec0c2;
}
.bg-inverse-danger.breadcrumb-custom .breadcrumb-item a {
  color: #fc424a;
  border: none;
}
.bg-inverse-danger.breadcrumb-custom .breadcrumb-item a:before {
  border-left-color: #fec0c2;
}
.bg-inverse-danger.breadcrumb-custom .breadcrumb-item span {
  color: #fc424a;
}
.bg-inverse-danger.breadcrumb-custom .breadcrumb-item:last-child {
  background: transparent;
}

.bg-inverse-light {
  background: rgba(255, 255, 255, 0.25);
  border-color: #ffffff;
}
.bg-inverse-light .breadcrumb-item {
  color: #ffffff;
}
.bg-inverse-light .breadcrumb-item:before {
  color: inherit;
}
.bg-inverse-light .breadcrumb-item a {
  color: inherit;
}
.bg-inverse-light.breadcrumb-custom {
  background: transparent;
}
.bg-inverse-light.breadcrumb-custom .breadcrumb-item {
  background: white;
}
.bg-inverse-light.breadcrumb-custom .breadcrumb-item a {
  color: #ffffff;
  border: none;
}
.bg-inverse-light.breadcrumb-custom .breadcrumb-item a:before {
  border-left-color: white;
}
.bg-inverse-light.breadcrumb-custom .breadcrumb-item span {
  color: #ffffff;
}
.bg-inverse-light.breadcrumb-custom .breadcrumb-item:last-child {
  background: transparent;
}

.bg-inverse-dark {
  background: rgba(13, 13, 13, 0.25);
  border-color: #0d0d0d;
}
.bg-inverse-dark .breadcrumb-item {
  color: #0d0d0d;
}
.bg-inverse-dark .breadcrumb-item:before {
  color: inherit;
}
.bg-inverse-dark .breadcrumb-item a {
  color: inherit;
}
.bg-inverse-dark.breadcrumb-custom {
  background: transparent;
}
.bg-inverse-dark.breadcrumb-custom .breadcrumb-item {
  background: #4d4d4d;
}
.bg-inverse-dark.breadcrumb-custom .breadcrumb-item a {
  color: #0d0d0d;
  border: none;
}
.bg-inverse-dark.breadcrumb-custom .breadcrumb-item a:before {
  border-left-color: #4d4d4d;
}
.bg-inverse-dark.breadcrumb-custom .breadcrumb-item span {
  color: #0d0d0d;
}
.bg-inverse-dark.breadcrumb-custom .breadcrumb-item:last-child {
  background: transparent;
}

.bg-primary:not(.bg-light) .breadcrumb-item {
  color: #ffffff;
}
.bg-primary:not(.bg-light) .breadcrumb-item:before {
  color: inherit;
}
.bg-primary:not(.bg-light) .breadcrumb-item a, .bg-primary:not(.bg-light) .breadcrumb-item span {
  color: inherit;
}

.bg-secondary:not(.bg-light) .breadcrumb-item {
  color: #ffffff;
}
.bg-secondary:not(.bg-light) .breadcrumb-item:before {
  color: inherit;
}
.bg-secondary:not(.bg-light) .breadcrumb-item a, .bg-secondary:not(.bg-light) .breadcrumb-item span {
  color: inherit;
}

.bg-success:not(.bg-light) .breadcrumb-item {
  color: #ffffff;
}
.bg-success:not(.bg-light) .breadcrumb-item:before {
  color: inherit;
}
.bg-success:not(.bg-light) .breadcrumb-item a, .bg-success:not(.bg-light) .breadcrumb-item span {
  color: inherit;
}

.bg-info:not(.bg-light) .breadcrumb-item {
  color: #ffffff;
}
.bg-info:not(.bg-light) .breadcrumb-item:before {
  color: inherit;
}
.bg-info:not(.bg-light) .breadcrumb-item a, .bg-info:not(.bg-light) .breadcrumb-item span {
  color: inherit;
}

.bg-warning:not(.bg-light) .breadcrumb-item {
  color: #ffffff;
}
.bg-warning:not(.bg-light) .breadcrumb-item:before {
  color: inherit;
}
.bg-warning:not(.bg-light) .breadcrumb-item a, .bg-warning:not(.bg-light) .breadcrumb-item span {
  color: inherit;
}

.bg-danger:not(.bg-light) .breadcrumb-item {
  color: #ffffff;
}
.bg-danger:not(.bg-light) .breadcrumb-item:before {
  color: inherit;
}
.bg-danger:not(.bg-light) .breadcrumb-item a, .bg-danger:not(.bg-light) .breadcrumb-item span {
  color: inherit;
}

.bg-light:not(.bg-light) .breadcrumb-item {
  color: #ffffff;
}
.bg-light:not(.bg-light) .breadcrumb-item:before {
  color: inherit;
}
.bg-light:not(.bg-light) .breadcrumb-item a, .bg-light:not(.bg-light) .breadcrumb-item span {
  color: inherit;
}

.bg-dark:not(.bg-light) .breadcrumb-item {
  color: #ffffff;
}
.bg-dark:not(.bg-light) .breadcrumb-item:before {
  color: inherit;
}
.bg-dark:not(.bg-light) .breadcrumb-item a, .bg-dark:not(.bg-light) .breadcrumb-item span {
  color: inherit;
}

/* Badges */
.badge {
  border-radius: 0.25rem;
  font-size: 0.75rem;
  font-weight: initial;
  line-height: 1;
  padding: 0.5rem 0.7rem;
  font-family: "Rubik", sans-serif;
  font-weight: 500;
}
.badge.badge-pill {
  border-radius: 10rem;
}

/*Badge variations*/
.badge-primary {
  background: #0090e7;
  color: #ffffff;
}

.badge-secondary {
  background: #e4eaec;
  color: #ffffff;
}

.badge-success, .preview-list .preview-item .preview-thumbnail .badge.badge-online {
  background: #00d25b;
  color: #ffffff;
}

.badge-info, .preview-list .preview-item .preview-thumbnail .badge.badge-offline {
  background: #8f5fe8;
  color: #ffffff;
}

.badge-warning, .preview-list .preview-item .preview-thumbnail .badge.badge-busy {
  background: #ffab00;
  color: #ffffff;
}

.badge-danger {
  background: #fc424a;
  color: #ffffff;
}

.badge-light {
  background: #ffffff;
  color: #ffffff;
}

.badge-dark {
  background: #0d0d0d;
  color: #ffffff;
}

/*Badge outlined variations*/
.badge-outline-primary {
  color: #0090e7;
  border: 1px solid #0090e7;
}

.badge-outline-secondary {
  color: #e4eaec;
  border: 1px solid #e4eaec;
}

.badge-outline-success {
  color: #00d25b;
  border: 1px solid #00d25b;
}

.badge-outline-info {
  color: #8f5fe8;
  border: 1px solid #8f5fe8;
}

.badge-outline-warning {
  color: #ffab00;
  border: 1px solid #ffab00;
}

.badge-outline-danger {
  color: #fc424a;
  border: 1px solid #fc424a;
}

.badge-outline-light {
  color: #ffffff;
  border: 1px solid #ffffff;
}

.badge-outline-dark {
  color: #0d0d0d;
  border: 1px solid #0d0d0d;
}

/* Cards */
.card {
  border: none;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.08) !important;
  border-radius: 0.25rem;
}
.card .card-body {
  padding: 1.75rem 1.5625rem;
}
.card .card-body + .card-body {
  padding-top: 1rem;
}
.card .card-title {
  color: #c4c4c4;
  margin-bottom: 1.125rem;
  text-transform: capitalize;
}
.card .card-subtitle {
  font-weight: normal;
  margin-top: 0.625rem;
  margin-bottom: 0.625rem;
}
.card .card-description {
  color: #76838f;
  font-weight: 300;
}
.card.card-outline-success {
  border: 1px solid #00d25b;
}
.card.card-outline-primary {
  border: 1px solid #0090e7;
}
.card.card-outline-warning {
  border: 1px solid #ffab00;
}
.card.card-outline-danger {
  border: 1px solid #fc424a;
}
.card.card-rounded {
  border-radius: 5px;
}
.card.card-faded {
  background: #b5b0b2;
  border-color: #b5b0b2;
}
.card.card-circle-progress {
  color: #ffffff;
  text-align: center;
}
.card.card-img-holder {
  position: relative;
}
.card.card-img-holder .card-img-absolute {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
}
.card.corona-gradient-card {
  background-image: linear-gradient(to left, #d41459, #911a6c);
  border-radius: 6px;
}
.card.corona-gradient-card .gradient-corona-img {
  height: 85px;
}
@media (max-width: 576px) {
  .card.corona-gradient-card .gradient-corona-img {
    height: auto;
    min-height: 50px;
    max-height: 85px;
  }
}
@media (max-width: 576px) {
  .card.corona-gradient-card h4 {
    font-size: 0.75rem;
  }
}

.card-inverse-primary {
  background: rgba(0, 144, 231, 0.2);
  border: 1px solid #0084d5;
  color: #006db0;
}

.card-inverse-secondary {
  background: rgba(228, 234, 236, 0.2);
  border: 1px solid #d2d7d9;
  color: #adb2b3;
}

.card-inverse-success {
  background: rgba(0, 210, 91, 0.2);
  border: 1px solid #00c154;
  color: #00a045;
}

.card-inverse-info {
  background: rgba(143, 95, 232, 0.2);
  border: 1px solid #8457d5;
  color: #6d48b0;
}

.card-inverse-warning {
  background: rgba(255, 171, 0, 0.2);
  border: 1px solid #eb9d00;
  color: #c28200;
}

.card-inverse-danger {
  background: rgba(252, 66, 74, 0.2);
  border: 1px solid #e83d44;
  color: #c03238;
}

.card-inverse-light {
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid #ebebeb;
  color: #c2c2c2;
}

.card-inverse-dark {
  background: rgba(13, 13, 13, 0.2);
  border: 1px solid #0c0c0c;
  color: #0a0a0a;
}

/* Preview */
.preview-list .preview-item {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 1rem 0rem;
  font-size: 0.875rem;
}
.preview-list .preview-item:last-child {
  border-bottom: 0;
}
.preview-list .preview-item .form-check {
  margin-top: 8px;
  margin-right: 1rem;
}
.preview-list .preview-item .preview-thumbnail {
  color: #ffffff;
  position: relative;
}
.preview-list .preview-item .preview-thumbnail img,
.preview-list .preview-item .preview-thumbnail .preview-icon {
  width: 40px;
  height: 40px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.preview-list .preview-item .preview-thumbnail img i,
.preview-list .preview-item .preview-thumbnail .preview-icon i {
  font-size: 1.125rem;
  margin: 0;
}
.preview-list .preview-item .preview-thumbnail .badge {
  border: 2px solid #ffffff;
  border-radius: 100%;
  bottom: 5px;
  display: block;
  height: 14px;
  left: -5px;
  padding: 0;
  position: absolute;
  width: 14px;
}
.preview-list .preview-item .preview-item-content {
  line-height: 1;
  padding-left: 15px;
}
.preview-list .preview-item .preview-item-content:first-child {
  padding-left: 0;
}
.preview-list .preview-item .preview-item-content p {
  margin-bottom: 10px;
  line-height: 1;
}
.preview-list .preview-item .preview-item-content p .content-category {
  font-family: "source-sans-pro-semibold", sans-serif;
  padding-right: 15px;
  border-right: 1px solid #2c2e33;
}
.rtl .preview-list .preview-item .preview-item-content {
  padding-left: 0;
  padding-right: 1rem;
  margin-right: 0;
  margin-left: auto;
}
.preview-list .preview-item .preview-actions {
  display: flex;
  flex-direction: row;
}
.preview-list .preview-item .preview-actions i {
  width: 29px;
  color: #e6e9ed;
  height: 29px;
  border: 2px solid #e6e9ed;
  border-radius: 100%;
  padding: 3px 6px;
  display: inline-block;
}
.preview-list .preview-item .preview-actions i:first-child {
  margin-right: 10px;
}
.preview-list.comment-preview .preview-item {
  padding: 0.87rem 0;
}
.preview-list.comment-preview .preview-item:first-child {
  padding-top: 0;
}
.preview-list.comment-preview .preview-item p {
  line-height: 27px;
}
.preview-list.bordered .preview-item {
  border-bottom: 1px solid #2c2e33;
}
.preview-list.bordered .preview-item:last-child {
  border-bottom: 0;
}

.icon {
  display: flex;
  align-items: center;
  justify-content: center;
}
.icon.icon-box-primary {
  width: 40px;
  height: 37px;
  background: rgba(0, 144, 231, 0.11);
  border-radius: 7px;
  color: #0090e7;
}
.icon .icon-item {
  font-size: 20px;
}

.icon {
  display: flex;
  align-items: center;
  justify-content: center;
}
.icon.icon-box-secondary {
  width: 40px;
  height: 37px;
  background: rgba(228, 234, 236, 0.11);
  border-radius: 7px;
  color: #e4eaec;
}
.icon .icon-item {
  font-size: 20px;
}

.icon {
  display: flex;
  align-items: center;
  justify-content: center;
}
.icon.icon-box-success {
  width: 40px;
  height: 37px;
  background: rgba(0, 210, 91, 0.11);
  border-radius: 7px;
  color: #00d25b;
}
.icon .icon-item {
  font-size: 20px;
}

.icon {
  display: flex;
  align-items: center;
  justify-content: center;
}
.icon.icon-box-info {
  width: 40px;
  height: 37px;
  background: rgba(143, 95, 232, 0.11);
  border-radius: 7px;
  color: #8f5fe8;
}
.icon .icon-item {
  font-size: 20px;
}

.icon {
  display: flex;
  align-items: center;
  justify-content: center;
}
.icon.icon-box-warning {
  width: 40px;
  height: 37px;
  background: rgba(255, 171, 0, 0.11);
  border-radius: 7px;
  color: #ffab00;
}
.icon .icon-item {
  font-size: 20px;
}

.icon {
  display: flex;
  align-items: center;
  justify-content: center;
}
.icon.icon-box-danger {
  width: 40px;
  height: 37px;
  background: rgba(252, 66, 74, 0.11);
  border-radius: 7px;
  color: #fc424a;
}
.icon .icon-item {
  font-size: 20px;
}

.icon {
  display: flex;
  align-items: center;
  justify-content: center;
}
.icon.icon-box-light {
  width: 40px;
  height: 37px;
  background: rgba(255, 255, 255, 0.11);
  border-radius: 7px;
  color: #ffffff;
}
.icon .icon-item {
  font-size: 20px;
}

.icon {
  display: flex;
  align-items: center;
  justify-content: center;
}
.icon.icon-box-dark {
  width: 40px;
  height: 37px;
  background: rgba(13, 13, 13, 0.11);
  border-radius: 7px;
  color: #0d0d0d;
}
.icon .icon-item {
  font-size: 20px;
}

/* Lists */
ul,
ol,
dl {
  padding-left: 1rem;
  font-size: 0.875rem;
}
ul li,
ol li,
dl li {
  line-height: 1.8;
}

.list-ticked,
.list-arrow,
.list-star {
  list-style: none;
  padding: 0;
}
.list-ticked li,
.list-arrow li,
.list-star li {
  padding-left: 1.5rem;
}
.list-ticked li:before,
.list-arrow li:before,
.list-star li:before {
  font-family: "Material Design Icons";
  margin-left: -1.5rem;
  width: 1.5rem;
  margin-right: 0.5rem;
}

.list-ticked li:before {
  content: "\\f12d";
  color: #fc424a;
}

.list-arrow li:before {
  content: "\\f142";
  color: #00d25b;
}

.list-star li:before {
  content: "\\f4ce";
  color: #ffab00;
}

.gradient-bullet-list {
  padding-left: 0;
}
.rtl .gradient-bullet-list {
  padding-right: 0;
}
.gradient-bullet-list li {
  position: relative;
  list-style-type: none;
  padding-left: 25px;
  line-height: 1;
  padding-bottom: 25px;
}
.gradient-bullet-list li:before, .gradient-bullet-list li:after {
  content: "";
  position: absolute;
}
.gradient-bullet-list li:before {
  top: 0;
  left: 0;
  width: 15px;
  height: 15px;
  border-radius: 100%;
}
.gradient-bullet-list li:after {
  width: 11px;
  height: 11px;
  top: 2px;
  left: 2px;
  background: #ffffff;
  border-radius: 100%;
}
.gradient-bullet-list li:nth-child(1):before {
  background: #fc424a;
}
.gradient-bullet-list li:nth-child(2):before {
  background: #8f5fe8;
}
.gradient-bullet-list li:nth-child(3):before {
  background: #ffab00;
}
.gradient-bullet-list li:nth-child(4):before {
  background: #00d25b;
}
.gradient-bullet-list li:nth-child(5):before {
  background: #0090e7;
}

.bullet-line-list {
  padding-left: 30px;
  margin-bottom: 0;
  position: relative;
  list-style-type: none;
}
.rtl .bullet-line-list {
  padding-right: 0px;
}
.bullet-line-list li {
  position: relative;
  line-height: 1;
  padding-bottom: 10px;
}
.bullet-line-list li:before {
  content: "";
  position: absolute;
  border-radius: 100%;
  width: 12px;
  height: 12px;
  left: -28px;
  top: 6px;
  border: 3px solid #0090e7;
  margin-right: 15px;
  z-index: 2;
  background: #ffffff;
}
.bullet-line-list li:after {
  content: "";
  border: 1px solid #2c2e33;
  position: absolute;
  bottom: 0;
  left: -23px;
  height: 100%;
}
.bullet-line-list li:first-child:after {
  content: "";
  height: 80%;
}
.bullet-line-list li:last-child {
  padding-bottom: 0;
}
.bullet-line-list li:last-child:after {
  content: "";
  top: 0;
  height: 30%;
}

/* Todo list */
.add-items {
  margin-bottom: 1.5rem;
  overflow: hidden;
}
.add-items input[type=text] {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  width: 100%;
  background: transparent;
}
.add-items .btn {
  margin-left: 0.5rem;
}
.rtl .add-items .btn {
  margin-left: auto;
  margin-right: 0.5rem;
}

.list-wrapper {
  height: 100%;
  max-height: 100%;
}
.list-wrapper ul {
  padding: 0;
  text-align: left;
  list-style: none;
  margin-bottom: 0;
}
.list-wrapper ul li {
  font-size: 0.9375rem;
  padding: 0.8rem 0;
  border-bottom: 1px solid #2c2e33;
}
.list-wrapper ul li:last-child {
  border-bottom: none;
}
.list-wrapper ul li .form-check {
  max-width: 90%;
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.list-wrapper ul li .form-check .form-check-label input {
  width: 20px;
  height: 20px;
}
.list-wrapper input[type=checkbox] {
  margin-right: 15px;
}
.list-wrapper .remove {
  cursor: pointer;
  font-size: 1.125rem;
  font-weight: 600;
  width: 1.25rem;
  height: 1.25rem;
  line-height: 20px;
  text-align: center;
}
.list-wrapper .completed {
  text-decoration: line-through;
  text-decoration-color: #0090e7;
}
.dropdown .dropdown-toggle.no-caret::after {
  display: none;
}
.dropdown .dropdown-menu {
  margin-top: 0.75rem;
  font-size: 0.875rem;
  box-shadow: none;
}
.dropdown .dropdown-menu .dropdown-item {
  font-size: 1rem;
  padding: 0.25rem 1.5rem;
}
.dropdown .dropdown-menu .dropdown-item:active {
  background: initial;
}
.dropdown .dropdown-menu .dropdown-item:hover {
  color: #ffffff;
}
.rtl .dropdown .dropdown-menu.sidebar-dropdown.dropdown-menu-right {
  left: 10rem !important;
}

/* Loaders */
#pgloading {
  position: static;
}
#pgloading .bokeh {
  font-size: 100px;
  width: 1em;
  height: 1em;
  position: relative;
  margin: 0 auto;
  border-radius: 50%;
  border: 0.01em solid #2c2e33;
  list-style: none;
  padding: 0;
}
#pgloading .bokeh li {
  position: absolute;
  width: 0.2em;
  height: 0.2em;
  border-radius: 50%;
}
#pgloading .bokeh li:nth-child(1) {
  left: 50%;
  top: 0;
  margin: 0 0 0 -0.1em;
  background: #00d25b;
  transform-origin: 50% 250%;
  animation: rota 1.13s linear infinite, opa 3.67s ease-in-out infinite alternate;
}
#pgloading .bokeh li:nth-child(2) {
  top: 50%;
  right: 0;
  margin: -0.1em 0 0 0;
  background: #fc424a;
  transform-origin: -150% 50%;
  animation: rota 1.86s linear infinite, opa 4.29s ease-in-out infinite alternate;
}
#pgloading .bokeh li:nth-child(3) {
  left: 50%;
  bottom: 0;
  margin: 0 0 0 -0.1em;
  background: #ffab00;
  transform-origin: 50% -150%;
  animation: rota 1.45s linear infinite, opa 5.12s ease-in-out infinite alternate;
}
#pgloading .bokeh li:nth-child(4) {
  top: 50%;
  left: 0;
  margin: -0.1em 0 0 0;
  background: #0090e7;
  transform-origin: 250% 50%;
  animation: rota 1.72s linear infinite, opa 5.25s ease-in-out infinite alternate;
}
@keyframes rota {
  to {
    transform: rotate(360deg);
  }
}
@keyframes opa {
  12.0% {
    opacity: 0.8;
  }
  19.5% {
    opacity: 0.88;
  }
  37.2% {
    opacity: 0.64;
  }
  40.5% {
    opacity: 0.52;
  }
  52.7% {
    opacity: 0.69;
  }
  60.2% {
    opacity: 0.6;
  }
  66.6% {
    opacity: 0.52;
  }
  70.0% {
    opacity: 0.63;
  }
  79.9% {
    opacity: 0.6;
  }
  84.2% {
    opacity: 0.75;
  }
  91.0% {
    opacity: 0.87;
  }
}
.glowing-loader {
  position: relative;
}

.s2 {
  position: absolute;
  height: 70px;
  width: 70px;
  top: 50px;
  background-color: transparent;
  left: 50%;
  transform: translate(-50%, -50%);
}

.s1 {
  position: absolute;
  height: 70px;
  width: 70px;
  left: 50%;
  top: 50px;
  transform-origin: center;
  transform: translate(-50%, -50%) rotate(45deg);
  background-color: transparent;
}

.bigcon {
  position: absolute;
  height: 75px;
  width: 75px;
  left: 50%;
  top: 50px;
  transform-origin: center;
  transform: translate(-50%, -50%) rotate(-45deg);
  background-color: transparent;
  animation: bigcon 2s infinite linear;
  animation-delay: 0.25s;
}

.b {
  border-radius: 50%;
  position: absolute;
}

.s {
  width: 15px;
  height: 15px;
  animation: small 2s infinite ease;
  box-shadow: 0px 2px rgba(0, 0, 0, 0.3);
  background-color: #0090e7;
}

.s:nth-child(1) {
  top: 0%;
  left: 0%;
}

.s:nth-child(2) {
  top: 0%;
  right: 0%;
}

.s:nth-child(3) {
  right: 0%;
  bottom: 0%;
}

.s:nth-child(4) {
  bottom: 0%;
  left: 0%;
}

.big {
  width: 15px;
  height: 15px;
  border-radius: 15px;
  box-shadow: 0px 0px 10px #0090e7, 0px 0px 20px #0090e7, 0px 0px 30px #0090e7, 0px 0px 50px #0090e7, 0px 0px 60px #0090e7;
  z-index: 1;
  background-color: #0090e7;
  animation: bigball 1s infinite linear;
}

.sb1 {
  animation-delay: -1.75s;
}

.sb6 {
  animation-delay: -1.5s;
}

.sb2 {
  animation-delay: -1.25s;
}

.sb7 {
  animation-delay: -1s;
}

.sb3 {
  animation-delay: -0.75s;
}

.sb8 {
  animation-delay: -0.5s;
}

.sb4 {
  animation-delay: -0.25s;
}

.sb5 {
  animation-delay: 0s;
}

@keyframes bigcon {
  0% {
    transform-origin: center;
    transform: translate(-50%, -50%) rotate(45deg);
  }
  100% {
    transform-origin: center;
    transform: translate(-50%, -50%) rotate(405deg);
  }
}
@keyframes small {
  0% {
    transform: scale(1);
    background-color: #4ebcff;
  }
  10% {
    transform: scale(1.3);
    background-color: #0090e7;
  }
  15% {
    transform: scale(1);
  }
  25% {
    transform: scale(1);
    background-color: #0090e7;
  }
  100% {
    transform: scale(1);
    background-color: #0090e7;
  }
}
/* Pixel loader */
.pixel-loader {
  width: 10px;
  height: 10px;
  background: #ffab00;
  color: #ffab00;
  margin: 80px auto;
  box-shadow: 15px 15px 0 0, -15px -15px 0 0, 15px -15px 0 0, -15px 15px 0 0, 0 15px 0 0, 15px 0 0 0, -15px 0 0 0, 0 -15px 0 0;
  animation: anim 2s linear infinite;
}

@keyframes anim {
  0% {
    -webkit-filter: hue-rotate(0deg);
  }
  50% {
    box-shadow: 20px 20px 0 0, -20px -20px 0 0, 20px -20px 0 0, -20px 20px 0 0, 0 10px 0 0, 10px 0 0 0, -10px 0 0 0, 0 -10px 0 0;
  }
  75% {
    box-shadow: 20px 20px 0 0, -20px -20px 0 0, 20px -20px 0 0, -20px 20px 0 0, 0 10px 0 0, 10px 0 0 0, -10px 0 0 0, 0 -10px 0 0;
  }
  100% {
    transform: rotate(360deg);
    -webkit-filter: hue-rotate(360deg);
  }
}
/* Square box loader */
@keyframes dyinglight {
  15% {
    transform: scale(1.6);
  }
  50% {
    transform: rotate(-89deg);
  }
  100% {
    transform: rotate(-90deg);
  }
}
.square-box-loader {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: inline-block;
}

.square-box-loader-square {
  display: block;
  width: 30px;
  height: 30px;
  background: #0090e7;
}

.square-box-loader-container {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  transform-origin: 50% 50% 0;
  animation: dyinglight 1s ease infinite;
  backface-visibility: hidden;
}

.square-box-loader-corner-top:before,
.square-box-loader-corner-top:after,
.square-box-loader-corner-bottom:before,
.square-box-loader-corner-bottom:after {
  position: absolute;
  width: 10px;
  height: 10px;
  color: #0090e7;
  content: "";
}

.square-box-loader-corner-top:before {
  border-left: 1px solid;
  border-top: 1px solid;
  top: -4px;
  left: -4px;
}
.square-box-loader-corner-top:after {
  border-right: 1px solid;
  border-top: 1px solid;
  top: -4px;
  right: -4px;
}

.square-box-loader-corner-bottom:before {
  border-left: 1px solid;
  border-bottom: 1px solid;
  bottom: -4px;
  left: -4px;
}
.square-box-loader-corner-bottom:after {
  border-right: 1px solid;
  border-bottom: 1px solid;
  bottom: -4px;
  right: -4px;
}

/* Circle loader */
.circle-loader {
  width: 70px;
  height: 70px;
  border-radius: 100%;
  position: relative;
  margin: 0 auto;
}

.circle-loader:before, .circle-loader:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 100%;
  border: 10px solid transparent;
  border-top-color: #ffab00;
}

.circle-loader:before {
  z-index: 10;
  animation: spin 1s infinite;
}

.circle-loader:after {
  border: 10px solid #e4eaec;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/* Jumping dots loader */
.jumping-dots-loader {
  width: 100px;
  height: 100px;
  border-radius: 100%;
  position: relative;
  margin: 0 auto;
}

.jumping-dots-loader span {
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 100%;
  background-color: rgba(252, 66, 74, 0.8);
  margin: 35px 5px;
}

.jumping-dots-loader span:nth-child(1) {
  animation: bounce 1s ease-in-out infinite;
}

.jumping-dots-loader span:nth-child(2) {
  animation: bounce 1s ease-in-out 0.33s infinite;
}

.jumping-dots-loader span:nth-child(3) {
  animation: bounce 1s ease-in-out 0.66s infinite;
}

@keyframes bounce {
  0%, 75%, 100% {
    transform: translateY(0);
  }
  25% {
    transform: translateY(-20px);
  }
}
/* Bar loader */
.bar-loader {
  width: 50px;
  height: 50px;
  border-radius: 100%;
  position: relative;
  margin: 0 auto;
}

.bar-loader span {
  display: inline-block;
  width: 5px;
  height: 30px;
  background-color: rgba(252, 66, 74, 0.7);
}

.bar-loader span:nth-child(1) {
  animation: grow 1s ease-in-out infinite;
}

.bar-loader span:nth-child(2) {
  animation: grow 1s ease-in-out 0.15s infinite;
}

.bar-loader span:nth-child(3) {
  animation: grow 1s ease-in-out 0.3s infinite;
}

.bar-loader span:nth-child(4) {
  animation: grow 1s ease-in-out 0.45s infinite;
}

@keyframes grow {
  0%, 100% {
    transform: scaleY(1);
  }
  50% {
    transform: scaleY(1.8);
  }
}
/* Square path loader */
.square-path-loader {
  width: 100px;
  height: 100px;
  border-radius: 100%;
  position: relative;
  margin: 0 auto;
}

.square-path-loader:before, .square-path-loader:after {
  content: "";
  width: 15px;
  height: 15px;
  position: absolute;
  top: 0;
  left: calc(50% - 10px);
  background-color: rgba(0, 210, 91, 0.7);
  animation: squaremove 1s ease-in-out infinite;
}

.square-path-loader:after {
  bottom: 0;
  animation-delay: 0.5s;
}

@keyframes squaremove {
  0%, 100% {
    transform: translate(0, 0) rotate(0);
  }
  25% {
    transform: translate(40px, 40px) rotate(45deg);
  }
  50% {
    transform: translate(0px, 80px) rotate(0deg);
  }
  75% {
    transform: translate(-40px, 40px) rotate(45deg);
  }
}
/* Dot opacity loader */
.dot-opacity-loader {
  width: 100px;
  height: 100px;
  border-radius: 100%;
  position: relative;
  margin: 0 auto;
}

.dot-opacity-loader span {
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 100%;
  background-color: #0090e7;
  margin: 35px 5px;
  opacity: 0;
}

.dot-opacity-loader span:nth-child(1) {
  animation: opacitychange 1s ease-in-out infinite;
}

.dot-opacity-loader span:nth-child(2) {
  animation: opacitychange 1s ease-in-out 0.33s infinite;
}

.dot-opacity-loader span:nth-child(3) {
  animation: opacitychange 1s ease-in-out 0.66s infinite;
}

@keyframes opacitychange {
  0%, 100% {
    opacity: 0;
  }
  60% {
    opacity: 1;
  }
}
/* Flip square */
.flip-square-loader {
  -ms-perspective: 120px;
  perspective: 120px;
  width: 100px;
  height: 100px;
  border-radius: 100%;
  position: relative;
  margin: 0 auto;
}

.flip-square-loader:before {
  content: "";
  position: absolute;
  left: 25px;
  top: 25px;
  width: 50px;
  height: 50px;
  background-color: rgba(0, 210, 91, 0.7);
  animation: flip 1s infinite;
}

@keyframes flip {
  0% {
    transform: rotate(0);
  }
  50% {
    transform: rotateY(180deg);
  }
  100% {
    transform: rotateY(180deg) rotateX(180deg);
  }
}
/* Moving square loader */
.moving-square-loader {
  width: 100px;
  height: 100px;
  border-radius: 100%;
  position: relative;
  margin: 0 auto;
}

.moving-square-loader:before {
  content: "";
  position: absolute;
  width: 10px;
  height: 10px;
  top: calc(50% - 10px);
  left: 0px;
  background-color: rgba(252, 66, 74, 0.7);
  animation: rotatemove 1s infinite;
}

@keyframes rotatemove {
  0% {
    transform: scale(1) translateX(0px);
  }
  100% {
    transform: scale(2) translateX(45px);
  }
}
/* Auth */
.auth {
  height: 100%;
}
.auth .login-half-bg {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  background-size: cover;
}
.auth .register-half-bg {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  background-size: cover;
}
.auth.lock-full-bg {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  background-size: cover;
}
.auth .lock-profile-img {
  width: 90px;
  height: 90px;
  border-radius: 100%;
}
.auth .auth-form-light {
  background: #ffffff;
}
.auth .auth-form-light select {
  color: #2e383e;
}
.auth .auth-form-light .input-group .form-control:focus, .auth .auth-form-light .input-group .form-control:active {
  border-color: #2c2e33;
}
.auth .auth-form-dark {
  background: #fff;
}
.auth .auth-form-dark select {
  color: #2e383e;
}
.auth .auth-form-dark .input-group .form-control:focus, .auth .auth-form-dark .input-group .form-control:active {
  border-color: #2c2e33;
}
.auth .auth-form-transparent {
  background: transparent;
}
.auth .auth-form-transparent .form-control,
.auth .auth-form-transparent .input-group-text {
  border-color: #e4eaec;
}
.auth .auth-form-transparent .form-control:focus, .auth .auth-form-transparent .form-control:active,
.auth .auth-form-transparent .input-group-text:focus,
.auth .auth-form-transparent .input-group-text:active {
  border-color: #e4eaec;
}
.auth .auth-form-transparent select {
  outline-color: #e4eaec;
}
.auth.auth-img-bg {
  padding: 0;
}
@media (min-width: 768px) {
  .auth.auth-img-bg .auth-form-transparent {
    width: 55%;
    margin: auto;
  }
}
.auth .brand-logo {
  margin-bottom: 2rem;
}
.auth .brand-logo img {
  width: 150px;
}
.auth form .form-group {
  margin-bottom: 1.5rem;
}
.auth form .form-group label {
  font-size: 0.8125rem;
}
.auth form .form-group .form-control {
  background: transparent;
  border-radius: 0;
  font-size: 0.9375rem;
}
.auth form .auth-form-btn {
  padding: 1rem 2rem;
  line-height: 1.5;
}
.auth form .auth-link {
  font-size: 0.875rem;
}
.auth form .auth-link:hover {
  color: initial;
}

/* Slick-carousel */
.slick-slider .slick-arrow.slick-prev, .slick-slider .slick-arrow.slick-next {
  z-index: 999;
  width: 60px;
  height: 60px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 100%;
  font-weight: bold;
  line-height: 2;
}
.slick-slider .slick-arrow.slick-prev::before, .slick-slider .slick-arrow.slick-next::before {
  font-family: "Material Design Icons";
  font-size: 1.875rem;
  font-weight: bold;
  opacity: 1;
}
.slick-slider .slick-arrow.slick-prev {
  left: 25px;
}
.slick-slider .slick-arrow.slick-prev::before {
  content: "\\f141";
}
.rtl .slick-slider .slick-arrow.slick-prev::before {
  content: "\\f142";
}
.slick-slider .slick-arrow.slick-next {
  right: 25px;
}
.slick-slider .slick-arrow.slick-next::before {
  content: "\\f142";
}
.rtl .slick-slider .slick-arrow.slick-next::before {
  content: "\\f141";
}
.slick-slider .slick-list .slick-track .slick-slide {
  position: relative;
  color: #ffffff;
}
.slick-slider .slick-dots li button::before {
  content: "";
  width: 10px;
  height: 10px;
  border-radius: 100%;
  background-color: #D6D6D6;
}
.slick-slider .slick-dots li.active button::before {
  background-color: #869791;
}
.slick-slider.portfolio-slider .slick-arrow.slick-prev, .slick-slider.portfolio-slider .slick-arrow.slick-next {
  height: 32px;
  width: 32px;
  bottom: 100%;
  top: auto;
}
.slick-slider.portfolio-slider .slick-arrow.slick-prev::before, .slick-slider.portfolio-slider .slick-arrow.slick-next::before {
  color: #a7afb7;
  font-size: 1.25rem;
  font-weight: normal;
}
.slick-slider.portfolio-slider .slick-arrow.slick-prev {
  right: 35px;
  left: auto;
}
.rtl .slick-slider.portfolio-slider .slick-arrow.slick-prev {
  left: 35px;
  right: auto;
}
.slick-slider.portfolio-slider .slick-arrow.slick-next {
  right: 0;
}
.rtl .slick-slider.portfolio-slider .slick-arrow.slick-next {
  left: 0;
  right: auto;
}
.slick-slider.portfolio-slider .slick-list .slick-track .slick-slide img {
  border-radius: 4px;
  width: 100%;
}

svg {
  touch-action: none;
}

.jvectormap-container {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  touch-action: none;
}

.jvectormap-tip {
  position: absolute;
  display: none;
  border: solid 1px #CDCDCD;
  border-radius: 3px;
  background: #292929;
  color: white;
  font-family: sans-serif, Verdana;
  font-size: smaller;
  padding: 3px;
}

.jvectormap-zoomin, .jvectormap-zoomout, .jvectormap-goback {
  position: absolute;
  left: 10px;
  border-radius: 3px;
  background: #292929;
  padding: 3px;
  color: white;
  cursor: pointer;
  line-height: 10px;
  text-align: center;
  box-sizing: content-box;
}

.jvectormap-zoomin, .jvectormap-zoomout {
  width: 10px;
  height: 10px;
}

.jvectormap-zoomin {
  top: 10px;
}

.jvectormap-zoomout {
  top: 30px;
}

.jvectormap-goback {
  bottom: 10px;
  z-index: 1000;
  padding: 6px;
}

.jvectormap-spinner {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: center no-repeat url(${___CSS_LOADER_URL_REPLACEMENT_18___});
}

.jvectormap-legend-title {
  font-weight: bold;
  font-size: 14px;
  text-align: center;
}

.jvectormap-legend-cnt {
  position: absolute;
}

.jvectormap-legend-cnt-h {
  bottom: 0;
  right: 0;
}

.jvectormap-legend-cnt-v {
  top: 0;
  right: 0;
}

.jvectormap-legend {
  background: black;
  color: white;
  border-radius: 3px;
}

.jvectormap-legend-cnt-h .jvectormap-legend {
  float: left;
  margin: 0 10px 10px 0;
  padding: 3px 3px 1px 3px;
}

.jvectormap-legend-cnt-h .jvectormap-legend .jvectormap-legend-tick {
  float: left;
}

.jvectormap-legend-cnt-v .jvectormap-legend {
  margin: 10px 10px 0 0;
  padding: 3px;
}

.jvectormap-legend-cnt-h .jvectormap-legend-tick {
  width: 40px;
}

.jvectormap-legend-cnt-h .jvectormap-legend-tick-sample {
  height: 15px;
}

.jvectormap-legend-cnt-v .jvectormap-legend-tick-sample {
  height: 20px;
  width: 20px;
  display: inline-block;
  vertical-align: middle;
}

.jvectormap-legend-tick-text {
  font-size: 12px;
}

.jvectormap-legend-cnt-h .jvectormap-legend-tick-text {
  text-align: center;
}

.jvectormap-legend-cnt-v .jvectormap-legend-tick-text {
  display: inline-block;
  vertical-align: middle;
  line-height: 20px;
  padding-left: 3px;
}

.map {
  width: 100%;
  height: 500px;
}
@media (max-width: 767px) {
  .map {
    height: 100px;
  }
}

.navbar {
  font-weight: normal;
  background-color: #fff;
  color: #000;
  left: 244px;
  transition: left 0.25s ease;
  -webkit-transition: left 0.25s ease;
  -moz-transition: left 0.25s ease;
  -ms-transition: left 0.25s ease;
}
@media (max-width: 992px) {
  .navbar {
    left: 0;
  }
}
.navbar .navbar-brand-wrapper {
  transition: width 0.25s ease, background 0.25s ease;
  -webkit-transition: width 0.25s ease, background 0.25s ease;
  -moz-transition: width 0.25s ease, background 0.25s ease;
  -ms-transition: width 0.25s ease, background 0.25s ease;
  background-color: #f8f9fa;
  width: 244px;
  height: 70px;
}
@media (max-width: 991px) {
  .navbar .navbar-brand-wrapper {
    width: 55px;
  }
}
.navbar .navbar-brand-wrapper .navbar-brand {
  color: #000;
  font-size: 1.5rem;
  line-height: 48px;
  margin-right: 0;
  padding: 0rem 0rem 0rem 1.3rem;
  width: 100%;
}
.navbar .navbar-brand-wrapper .navbar-brand:active, .navbar .navbar-brand-wrapper .navbar-brand:focus, .navbar .navbar-brand-wrapper .navbar-brand:hover {
  color: #fff;
}
.navbar .navbar-brand-wrapper .navbar-brand img {
  width: calc(244px - 120px);
  max-width: 100%;
  height: 28px;
  margin: auto;
  vertical-align: middle;
}
.navbar .navbar-brand-wrapper .navbar-brand.brand-logo-mini {
  display: none;
}
.navbar .navbar-brand-wrapper .navbar-brand.brand-logo-mini img {
  width: calc(70px - 50px);
  max-width: 100%;
  height: 28px;
  margin: auto;
}
.navbar .navbar-menu-wrapper {
  transition: width 0.25s ease;
  -webkit-transition: width 0.25s ease;
  -moz-transition: width 0.25s ease;
  -ms-transition: width 0.25s ease;
  box-shadow: none;
  color: #000;
  padding-left: 15px;
  padding-right: 15px;
  width: 100%;
  height: 70px;
}
@media (max-width: 991px) {
  .navbar .navbar-menu-wrapper {
    width: auto;
    padding-left: 15px;
    padding-right: 15px;
  }
}
.navbar .navbar-menu-wrapper .navbar-toggler {
  border: 0;
  color: #6c757d;
  height: 70px;
}
.navbar .navbar-menu-wrapper .navbar-toggler:not(.navbar-toggler-right) {
  font-size: 0.875rem;
}
@media (max-width: 991px) {
  .navbar .navbar-menu-wrapper .navbar-toggler:not(.navbar-toggler-right) {
    display: none;
  }
}
@media (max-width: 991px) {
  .navbar .navbar-menu-wrapper .navbar-toggler.navbar-toggler-right {
    padding-left: 15px;
    padding-right: 11px;
    border-right: none;
  }
}
.navbar .navbar-menu-wrapper .navbar-nav {
  flex-direction: row;
  align-items: center;
}
.navbar .navbar-menu-wrapper .navbar-nav .nav-item .nav-link {
  color: #000;
  font-size: 1rem;
  margin-left: 1rem;
  margin-right: 1rem;
  white-space: nowrap;
  line-height: 1;
}
@media (max-width: 767px) {
  .navbar .navbar-menu-wrapper .navbar-nav .nav-item .nav-link {
    margin-left: 0.8rem;
    margin-right: 0.8rem;
  }
}
.navbar .navbar-menu-wrapper .navbar-nav .nav-item .nav-link.create-new-button {
  padding: 0.375rem 0.75rem;
}
.navbar .navbar-menu-wrapper .navbar-nav .nav-item.dropdown .dropdown-menu {
  margin-top: 1.15rem;
  border: none;
  background-color: #f8f9fa;
}
.navbar .navbar-menu-wrapper .navbar-nav .nav-item.nav-profile .nav-link .nav-profile-img {
  position: relative;
  width: 32px;
  height: 32px;
}
.navbar .navbar-menu-wrapper .navbar-nav .nav-item.nav-profile .nav-link .nav-profile-img img {
  width: 32px;
  height: 32px;
  border-radius: 100%;
}

@media (max-width: 991px) {
  .navbar {
    flex-direction: row;
  }
  .navbar .navbar-brand-wrapper {
    width: 75px;
  }
  .navbar .navbar-brand-wrapper .navbar-brand.brand-logo {
    display: none;
  }
  .navbar .navbar-brand-wrapper .navbar-brand.brand-logo-mini {
    display: inline-block;
  }
}
@media (max-width: 480px) {
  .navbar .navbar-brand-wrapper {
    width: 55px;
  }
  .navbar .navbar-brand-wrapper .brand-logo-mini {
    padding-top: 0px;
  }
}
/* Sidebar */
.sidebar {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.08) !important;
  min-height: calc(100vh - 70px);
  background-color: black;
  color: #000;
  font-weight: normal;
  padding: 0;
  width: 244px;
  z-index: 11;
  transition: width 0.25s ease, background 0.25s ease;
  -webkit-transition: width 0.25s ease, background 0.25s ease;
  -moz-transition: width 0.25s ease, background 0.25s ease;
  -ms-transition: width 0.25s ease, background 0.25s ease;
}
.sidebar .sidebar-brand-wrapper {
  transition: width 0.25s ease, background 0.25s ease;
  -webkit-transition: width 0.25s ease, background 0.25s ease;
  -moz-transition: width 0.25s ease, background 0.25s ease;
  -ms-transition: width 0.25s ease, background 0.25s ease;
  background-color: rgba(0, 27, 11, 0.734);
  color: #d5d8db;
  width: 244px;
  height: 70px;
}
@media (max-width: 991px) {
  .sidebar .sidebar-brand-wrapper {
    width: 55px;
  }
}
.sidebar .sidebar-brand-wrapper .sidebar-brand {
  color: #38425e;
  font-size: 1.5rem;
  line-height: 48px;
  margin-right: 0;
  padding: 0rem 0rem 0rem 1.3rem;
  width: 100%;
}
.sidebar .sidebar-brand-wrapper .sidebar-brand:active, .sidebar .sidebar-brand-wrapper .sidebar-brand:focus, .sidebar .sidebar-brand-wrapper .sidebar-brand:hover {
  color: #252b3e;
}
.sidebar .sidebar-brand-wrapper .sidebar-brand img {
  width: calc(244px - 120px );
  max-width: 100%;
  height: 28px;
  margin: auto;
  vertical-align: middle;
}
.sidebar .sidebar-brand-wrapper .sidebar-brand.brand-logo-mini {
  display: none;
}
.sidebar .sidebar-brand-wrapper .sidebar-brand.brand-logo-mini img {
  width: calc(70px - 50px );
  max-width: 100%;
  height: 28px;
  margin: auto;
}
.sidebar .nav {
  overflow: hidden;
  flex-wrap: nowrap;
  flex-direction: column;
  margin-bottom: 60px;
  padding-top: 70px;
}
@media (max-width: 992px) {
  .sidebar .nav {
    padding-top: 0;
  }
}
.sidebar .nav .nav-item {
  transition-duration: 0.25s;
  transition-property: background;
  -webkit-transition-property: background;
  padding-right: 20px;
}
.sidebar .nav .nav-item .collapse {
  z-index: 999;
}
.sidebar .nav .nav-item .nav-link {
  display: flex;
  align-items: center;
  white-space: nowrap;
  padding: 0.8rem 10px 0.8rem 1.188rem;
  color: #6c7293;
  transition-duration: 0.45s;
  transition-property: color;
  -webkit-transition-property: color;
  height: 46px;
  border-radius: 0px 100px 100px 0px;
  cursor: pointer;
}
.sidebar .nav .nav-item .nav-link i {
  color: inherit;
}
.sidebar .nav .nav-item .nav-link i.menu-icon {
  font-size: 1rem;
  line-height: 1;
  margin-left: auto;
  color: rgba(187, 168, 191, 0.9607843137);
}
.rtl .sidebar .nav .nav-item .nav-link i.menu-icon {
  margin-left: 0;
  margin-right: auto;
}
.sidebar .nav .nav-item .nav-link i.menu-icon:before {
  vertical-align: middle;
}
.sidebar .nav .nav-item .nav-link i.menu-arrow {
  font: normal normal normal 24px/1 "Material Design Icons";
  line-height: 1;
  font-size: 1rem;
  margin-left: auto;
  color: rgba(108, 114, 147, 0.36);
}
.rtl .sidebar .nav .nav-item .nav-link i.menu-arrow {
  margin-left: 0;
  margin-right: auto;
}
.sidebar .nav .nav-item .nav-link i.menu-arrow:before {
  content: "\\f140";
  font-size: inherit;
  color: inherit;
}
.sidebar .nav .nav-item .nav-link .menu-title {
  color: inherit;
  display: inline-block;
  font-size: 0.9375rem;
  line-height: 1;
  vertical-align: middle;
}
.sidebar .nav .nav-item .nav-link .badge {
  margin-right: auto;
  margin-left: 1rem;
}
.sidebar .nav .nav-item.active > .nav-link {
  background: #f2f2f2;
  position: relative;
}
.sidebar .nav .nav-item.active > .nav-link:before {
  content: "";
  width: 3px;
  height: 100%;
  background: #0090e7;
  display: inline-block;
  position: absolute;
  left: 0;
  top: 0;
}
.sidebar .nav .nav-item.active > .nav-link .menu-title {
  color: #2e383e;
}
.sidebar .nav .nav-item.active > .nav-link i {
  color: #ffffff;
}
.sidebar .nav .nav-item.nav-profile .nav-link {
  height: auto;
  line-height: 1;
  border-top: 0;
  padding: 1.25rem 0;
}
.sidebar .nav .nav-item.nav-profile .nav-link .nav-profile-image {
  width: 44px;
  height: 44px;
}
.sidebar .nav .nav-item.nav-profile .nav-link .nav-profile-image img {
  width: 44px;
  height: 44px;
  border-radius: 100%;
}
.sidebar .nav .nav-item.nav-profile .nav-link .nav-profile-text {
  margin-left: 1rem;
}
.rtl .sidebar .nav .nav-item.nav-profile .nav-link .nav-profile-text {
  margin-left: auto;
  margin-right: 1rem;
}
.sidebar .nav .nav-item.nav-profile .nav-link .nav-profile-badge {
  font-size: 1.125rem;
  margin-left: auto;
}
.rtl .sidebar .nav .nav-item.nav-profile .nav-link .nav-profile-badge {
  margin-left: 0;
  margin-right: auto;
}
.sidebar .nav .nav-item.sidebar-actions {
  margin-top: 1rem;
}
.sidebar .nav .nav-item.sidebar-actions .nav-link {
  border-top: 0;
  display: block;
  height: auto;
}
.sidebar .nav .nav-item.sidebar-actions:hover {
  background: initial;
}
.sidebar .nav .nav-item.sidebar-actions:hover .nav-link {
  color: initial;
}
.sidebar .nav .nav-item.profile {
  padding-right: 0px;
}
.rtl .sidebar .nav .nav-item.profile {
  padding-right: 10px;
}
.sidebar .nav .nav-item.profile .profile-desc {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0.6rem 1.17rem;
  line-height: 1.25;
}
.sidebar .nav .nav-item.profile .profile-desc .profile-name {
  margin-left: 1rem;
}
.rtl .sidebar .nav .nav-item.profile .profile-desc .profile-name {
  margin-left: 0;
  margin-right: 1rem;
}
.sidebar .nav .nav-item.profile .profile-desc .profile-name span {
  font-size: 12px;
  color: #6c7293;
  white-space: nowrap;
}
.sidebar .nav .nav-item.profile .profile-desc .profile-name h5 {
  white-space: nowrap;
}
.sidebar .nav .nav-item.profile .profile-desc .profile-pic {
  display: flex;
  align-items: center;
}
.sidebar .nav .nav-item.profile .profile-desc .profile-pic .count-indicator {
  position: relative;
}
.sidebar .nav .nav-item.profile .profile-desc .profile-pic .count-indicator .count-symbol,
.sidebar .nav .nav-item.profile .profile-desc .profile-pic .count-indicator .count-number {
  position: absolute;
  border-radius: 100%;
  border: 2px solid #fff;
}
.sidebar .nav .nav-item.profile .profile-desc .profile-pic .count-indicator .count-symbol {
  top: 17px;
  right: -3px;
  width: 10px;
  height: 10px;
}
.sidebar .nav .nav-item.profile .profile-desc .profile-pic .count-indicator .count-number {
  min-width: 14px;
  height: 14px;
  font-size: 0.5rem;
  color: #ffffff;
  bottom: 16px;
  right: -5px;
  line-height: 1;
  text-align: center;
}
.sidebar .nav .nav-item.profile .profile-desc .profile-pic .count-indicator:after {
  display: none;
}
.sidebar .nav .nav-item.profile .profile-desc .profile-pic .count-indicator .count {
  position: absolute;
  left: 66%;
  width: 10px;
  height: 10px;
  color: #ffffff;
  border-radius: 100%;
  text-align: center;
  font-size: 0.625rem;
  line-height: 1.5;
  top: 26px;
  border: 2px solid #2c2e33;
}
.sidebar .nav .nav-item.profile .profile-desc .mdi-dots-vertical {
  font-size: 20px;
  color: #6c7293;
}
.sidebar .nav .nav-item.profile .profile-desc .dropdown-menu {
  padding: 0;
  margin-top: 1.25rem;
}
.sidebar .nav .nav-item.profile .profile-desc .dropdown-menu .dropdown-item {
  padding: 11px 13px;
}
.sidebar .nav .nav-item.profile .profile-desc .dropdown-menu .dropdown-item.preview-item {
  align-items: center;
}
.sidebar .nav .nav-item.profile .profile-desc .dropdown-menu .dropdown-item.preview-item .preview-thumbnail .preview-icon {
  width: 30px;
  height: 30px;
}
.sidebar .nav .nav-item.profile .profile-desc .dropdown-menu .dropdown-item.preview-item .preview-thumbnail .preview-icon i {
  font-size: 0.875rem;
}
.sidebar .nav .nav-item.profile .profile-desc .dropdown-menu .dropdown-item:hover {
  color: inherit;
}
.sidebar .nav .nav-item.profile .profile-desc .dropdown-menu .dropdown-divider {
  margin: 0;
}
.sidebar .nav .nav-item.nav-category {
  padding: 0.5rem 1.188rem;
  line-height: 1;
}
.sidebar .nav .nav-item.nav-category .nav-link {
  color: #6c7293;
  font-weight: 500;
  font-size: 14px;
  font-weight: 500;
  height: auto;
  padding-left: 0;
  cursor: default;
}
.sidebar .nav .nav-item .menu-icon {
  margin-right: 0.5rem;
  font-size: 0.8125rem;
  line-height: 1;
  background: rgba(108, 114, 147, 0.2);
  width: 31px;
  height: 31px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
}
.sidebar .nav .nav-item .menu-icon i {
  font-size: 0.875rem;
}
.sidebar .nav.sub-menu {
  margin-bottom: 0;
  margin-top: 0;
  padding: 0 0 0 3.25rem;
  list-style: none;
}
.sidebar .nav.sub-menu .nav-item {
  padding: 0;
}
.sidebar .nav.sub-menu .nav-item .nav-link {
  color: #6c7293;
  padding: 0.5rem 0.35rem;
  position: relative;
  font-size: 0.855rem;
  line-height: 1;
  height: auto;
  border-top: 0;
}
.sidebar .nav.sub-menu .nav-item .nav-link.active {
  color: #2e383e;
  background: transparent;
}
.sidebar .nav.sub-menu .nav-item .nav-link:hover {
  color: #2e383e;
}
.sidebar .nav.sub-menu .nav-item:hover {
  background: transparent;
}
.sidebar .nav:not(.sub-menu) > .nav-item:hover:not(.nav-category):not(.account-dropdown) > .nav-link {
  background: #f2f2f2;
}
.sidebar .nav .menu-items:nth-child(5n+1) .nav-link .menu-icon i {
  color: #0090e7;
}
.sidebar .nav .menu-items:nth-child(5n+2) .nav-link .menu-icon i {
  color: #00d25b;
}
.sidebar .nav .menu-items:nth-child(5n+3) .nav-link .menu-icon i {
  color: #8f5fe8;
}
.sidebar .nav .menu-items:nth-child(5n+4) .nav-link .menu-icon i {
  color: #ffab00;
}
.sidebar .nav .menu-items:nth-child(5n+5) .nav-link .menu-icon i {
  color: #fc424a;
}

/* style for off-canvas menu*/
@media screen and (max-width: 991px) {
  .sidebar-offcanvas {
    position: fixed;
    max-height: calc(100vh - 70px);
    top: 70px;
    bottom: 0;
    overflow: auto;
    right: -244px;
    transition: all 0.25s ease-out;
  }
  .sidebar-offcanvas.active {
    right: 0;
  }
}
.footer {
  background-color: rgba(0, 27, 11, 0.734);
  color: #d5d8db;
  padding: 20px 1rem;
  transition: all 0.25s ease;
  -moz-transition: all 0.25s ease;
  -webkit-transition: all 0.25s ease;
  -ms-transition: all 0.25s ease;
  width: 100%;
  font-size: calc(0.875rem - 0.05rem);
  font-family: "Rubik", sans-serif;
}
.footer a {
  color: #00d25b;
  font-size: inherit;
}
@media (max-width: 991px) {
  .footer {
    margin-left: 0;
    width: 100%;
  }
}

/* Layouts */
.navbar.fixed-top + .page-body-wrapper {
  padding-top: 70px;
}

@media (min-width: 992px) {
  .sidebar-mini .navbar {
    left: 185px;
  }
  .sidebar-mini .navbar .navbar-brand-wrapper {
    width: 185px;
  }
  .sidebar-mini .navbar .navbar-menu-wrapper {
    width: 100%;
  }
  .sidebar-mini .sidebar {
    width: 185px;
  }
  .sidebar-mini .sidebar .sidebar-brand-wrapper {
    width: 185px;
  }
  .sidebar-mini .sidebar .nav .nav-item {
    padding: 0;
    margin: 0;
  }
  .sidebar-mini .sidebar .nav .nav-item.menu-items .nav-link .menu-icon {
    margin-left: auto;
    margin-right: auto;
  }
  .sidebar-mini .sidebar .nav .nav-item .nav-link {
    text-align: center;
    position: relative;
  }
  .sidebar-mini .sidebar .nav .nav-item .nav-link .menu-title {
    display: inline-block;
  }
  .sidebar-mini .sidebar .nav .nav-item .nav-link .menu-sub-title {
    margin: auto;
  }
  .sidebar-mini .sidebar .nav .nav-item .nav-link .badge {
    margin-left: 5px;
    display: none;
  }
  .sidebar-mini .sidebar .nav .nav-item .nav-link i.menu-icon {
    display: block;
    margin-right: auto;
    margin-left: auto;
  }
  .sidebar-mini .sidebar .nav .nav-item .nav-link i.menu-arrow {
    display: inline-block;
    margin-left: 5px;
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
  }
  .sidebar-mini .sidebar .nav .nav-item .nav-link i.menu-arrow:before {
    content: "\\f140";
  }
  .sidebar-mini .sidebar .nav .nav-item .nav-link[aria-expanded=true] .menu-arrow:before {
    content: "\\f143";
  }
  .sidebar-mini .sidebar .nav .nav-item .nav-link .menu-icon {
    margin-right: 1.25rem;
    margin-left: 0;
  }
  .sidebar-mini .sidebar .nav .nav-item.nav-category {
    display: none;
  }
  .sidebar-mini .sidebar .nav .nav-item.profile .profile-desc {
    justify-content: center;
    position: relative;
  }
  .sidebar-mini .sidebar .nav .nav-item.profile .profile-desc .profile-pic {
    flex-direction: column;
  }
  .sidebar-mini .sidebar .nav .nav-item.profile .profile-desc .profile-name {
    margin-left: 0;
  }
  .sidebar-mini .sidebar .nav .nav-item.profile .profile-desc .profile-dropdown {
    position: absolute;
    right: 10px;
  }
  .sidebar-mini:not(.sidebar-icon-only) .sidebar .nav:not(.sub-menu) > .nav-item {
    border-bottom: 1px solid rgba(108, 114, 147, 0.2);
  }
  .sidebar-mini:not(.sidebar-icon-only) .sidebar .nav:not(.sub-menu) > .nav-item .nav-link {
    display: block;
    height: auto;
    padding: 0.8125rem 1rem 0.8125rem 1rem;
  }
  .sidebar-mini:not(.sidebar-icon-only) .sidebar .nav:not(.sub-menu) > .nav-item .nav-link i.menu-icon {
    margin-bottom: 0.5rem;
  }
  .sidebar-mini:not(.sidebar-icon-only) .sidebar .nav.sub-menu {
    padding: 0;
    border-top: none;
  }
  .sidebar-mini:not(.sidebar-icon-only) .sidebar .nav.sub-menu .nav-item .nav-link {
    padding: 1rem 0rem;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
  }
  .sidebar-mini:not(.sidebar-icon-only) .sidebar .nav .nav-item.account-dropdown p {
    margin-left: 0;
  }
  .sidebar-mini:not(.sidebar-icon-only) .sidebar .nav .nav-item.account-dropdown .sub-menu {
    padding: 0 0 1rem 0;
  }
  .sidebar-mini:not(.sidebar-icon-only) .sidebar .nav .nav-item.account-dropdown .sub-menu .nav-item .nav-link {
    display: flex;
    justify-content: flex-start;
    padding: 0.3rem 0;
  }
  .sidebar-mini .page-body-wrapper {
    width: calc(100% - 185px);
  }
}

@media (min-width: 992px) {
  .sidebar-icon-only .navbar {
    left: 70px;
  }
  .sidebar-icon-only .navbar .navbar-menu-wrapper {
    width: 100%;
  }
  .sidebar-icon-only .sidebar {
    width: 70px;
  }
  .sidebar-icon-only .sidebar .sidebar-brand-wrapper {
    width: 70px;
  }
  .sidebar-icon-only .sidebar .sidebar-brand-wrapper .brand-logo {
    display: none;
  }
  .sidebar-icon-only .sidebar .sidebar-brand-wrapper .brand-logo-mini {
    display: inline-block;
  }
  .sidebar-icon-only .sidebar .nav {
    overflow: visible;
  }
  .sidebar-icon-only .sidebar .nav .nav-item {
    position: relative;
    padding: 0;
  }
  .sidebar-icon-only .sidebar .nav .nav-item .profile-name {
    display: none;
  }
  .sidebar-icon-only .sidebar .nav .nav-item .mdi-dots-vertical {
    display: none;
  }
  .sidebar-icon-only .sidebar .nav .nav-item.account-dropdown {
    display: none;
  }
  .sidebar-icon-only .sidebar .nav .nav-item .nav-link {
    text-align: center;
  }
  .sidebar-icon-only .sidebar .nav .nav-item .nav-link .menu-title,
  .sidebar-icon-only .sidebar .nav .nav-item .nav-link .badge, .sidebar-icon-only .sidebar .nav .nav-item .nav-link .menu-sub-title {
    display: none;
  }
  .sidebar-icon-only .sidebar .nav .nav-item .nav-link .menu-title {
    border-radius: 0 5px 5px 0px;
  }
  .rtl.sidebar-icon-only .sidebar .nav .nav-item .nav-link .menu-title {
    border-radius: 5px 0 0 5px;
  }
  .sidebar-icon-only .sidebar .nav .nav-item .nav-link i.menu-icon {
    margin-right: 0;
    margin-left: 0;
  }
  .sidebar-icon-only .sidebar .nav .nav-item .nav-link i.menu-arrow {
    display: none;
  }
  .sidebar-icon-only .sidebar .nav .nav-item .nav-link[aria-expanded] .menu-title {
    border-radius: 0 5px 0 0px;
  }
  .rtl.sidebar-icon-only .sidebar .nav .nav-item .nav-link[aria-expanded] .menu-title {
    border-radius: 5px 0 0 0;
  }
  .sidebar-icon-only .sidebar .nav .nav-item.nav-profile {
    display: none;
  }
  .sidebar-icon-only .sidebar .nav .nav-item.nav-category {
    display: none;
  }
  .sidebar-icon-only .sidebar .nav .nav-item.nav-doc {
    margin: 0;
  }
  .sidebar-icon-only .sidebar .nav .nav-item.nav-doc i {
    display: block;
  }
  .sidebar-icon-only .sidebar .nav .nav-item .collapse {
    display: none;
  }
  .sidebar-icon-only .sidebar .nav .nav-item.hover-open .nav-link .menu-title {
    display: flex;
    align-items: center;
    background: #f2f2f2;
    padding: 0.5rem 1.4rem;
    left: 70px;
    position: absolute;
    text-align: left;
    top: 0;
    bottom: 0;
    width: 190px;
    z-index: 1;
    line-height: 1.8;
  }
  .rtl.sidebar-icon-only .sidebar .nav .nav-item.hover-open .nav-link .menu-title {
    left: auto;
    right: 70px;
    text-align: left;
  }
  .sidebar-icon-only .sidebar .nav .nav-item.hover-open .nav-link .menu-title:after {
    display: none;
  }
  .sidebar-icon-only .sidebar .nav .nav-item.hover-open .collapse,
  .sidebar-icon-only .sidebar .nav .nav-item.hover-open .collapsing {
    display: block;
    padding: 0.5rem 0;
    border-radius: 0 0 5px 0;
    background: #f2f2f2;
    position: absolute;
    left: 70px;
    width: 190px;
  }
  .rtl.sidebar-icon-only .sidebar .nav .nav-item.hover-open .collapse, .rtl.sidebar-icon-only .sidebar .nav .nav-item.hover-open .collapsing {
    left: auto;
    right: 70px;
    border-radius: 0 0 0 5px;
  }
  .sidebar-icon-only .sidebar .nav.sub-menu {
    padding: 0 0 0 1.5rem;
  }
  .sidebar-icon-only .sidebar .nav.sub-menu .nav-item .nav-link {
    text-align: left;
    padding-left: 20px;
  }
  .sidebar-icon-only .sidebar .nav.sub-menu .nav-item .nav-link:before {
    content: "";
    display: inline-block;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background-color: #6c7293;
    position: absolute;
    left: 0;
  }
  .sidebar-icon-only .sidebar .nav.sub-menu .nav-item .nav-link:hover:before {
    background-color: white;
  }
  .rtl.sidebar-icon-only .sidebar .nav.sub-menu .nav-item {
    margin-left: 0;
  }
  .rtl.sidebar-icon-only .sidebar .nav.sub-menu .nav-item .nav-link {
    text-align: right;
  }
  .rtl.sidebar-icon-only .sidebar .nav.sub-menu .nav-item .nav-link:before {
    left: 0;
    right: unset;
  }
  .sidebar-icon-only .sidebar .sidebar-actions {
    display: none;
  }
  .sidebar-icon-only.rtl .sidebar .nav .nav-item.profile {
    padding-right: 0;
  }
  .sidebar-icon-only .page-body-wrapper {
    width: calc(100% - 70px);
    transition: all 0.25s ease;
    -webkit-transition: all 0.25s ease;
    -moz-transition: all 0.25s ease;
    -ms-transition: all 0.25s ease;
  }
}

@media (min-width: 992px) {
  .sidebar-hidden .sidebar {
    transition: width 0.25s ease;
    -webkit-transition: width 0.25s ease;
    -moz-transition: width 0.25s ease;
    -ms-transition: width 0.25s ease;
    width: 0;
  }
  .sidebar-hidden .page-body-wrapper {
    width: 100%;
  }
}

@media (min-width: 992px) {
  .sidebar-absolute .page-body-wrapper {
    width: 100%;
    position: relative;
  }
  .sidebar-absolute:not(.sidebar-hidden) .sidebar {
    position: absolute;
    height: 100%;
    /* Safari 3-4, iOS 4.0.2 - 4.2, Android 2.3+ */
    /* Firefox 3.5 - 3.6 */
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8);
    /* Opera 10.5, IE 9, Firefox 4+, Chrome 6+, iOS 5 */
  }
  .sidebar-absolute .sidebar {
    transition: none;
  }
}

@media (min-width: 992px) {
  .sidebar-fixed .sidebar {
    position: fixed;
    max-height: auto;
  }
  .sidebar-fixed .sidebar .nav {
    max-height: 100vh;
    overflow: auto;
    position: relative;
  }
  .sidebar-fixed .sidebar .nav.sub-menu {
    max-height: none;
  }
  .sidebar-fixed .page-body-wrapper {
    margin-left: 244px;
  }
  .sidebar-fixed.sidebar-icon-only .page-body-wrapper {
    margin-left: 70px;
  }
}

@media (min-width: 1200px) {
  .boxed-layout .container-scroller {
    background: #737373;
    padding: 0 calc((100% - 1200px) / 2);
  }
  .boxed-layout .navbar {
    right: calc((100% - 1200px) / 2);
    left: calc(((100% - 1200px) / 2) + 244px);
  }
  .boxed-layout .navbar.fixed-top {
    margin: auto;
    max-width: 1200px;
  }
  .boxed-layout .sidebar .sidebar-brand-wrapper {
    left: calc((100% - 1200px) / 2);
  }
  .boxed-layout.sidebar-icon-only .navbar {
    left: calc(((100% - 1200px) / 2) + 70px);
  }
}

.rtl {
  direction: rtl;
  text-align: right;
}
.rtl .sidebar .sidebar-brand-wrapper .sidebar-brand {
  padding: 0.25rem 1.3rem 0rem 0rem;
}
.rtl .sidebar .nav {
  padding-right: 0;
}
.rtl .sidebar .nav .nav-item.account-dropdown .nav-link p {
  margin-right: 1rem;
}
.rtl .sidebar .nav .nav-item .nav-link .menu-icon {
  margin-right: 0;
  margin-left: 0.5em;
}
.rtl .sidebar .nav.sub-menu {
  padding: 0 1.5rem 0 0;
}
.rtl .product-chart-wrapper::-webkit-scrollbar,
.rtl .settings-panel .tab-content .tab-pane .scroll-wrapper::-webkit-scrollbar,
.rtl .sidebar-fixed .nav::-webkit-scrollbar,
.rtl .table-responsive::-webkit-scrollbar,
.rtl ul.chats::-webkit-scrollbar {
  width: 0.5em;
}
.rtl .product-chart-wrapper::-webkit-scrollbar-track,
.rtl .settings-panel .tab-content .tab-pane .scroll-wrapper::-webkit-scrollbar-track,
.rtl .sidebar-fixed .nav::-webkit-scrollbar-track,
.rtl .table-responsive::-webkit-scrollbar-track,
.rtl ul.chats::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
.rtl .product-chart-wrapper::-webkit-scrollbar-thumb,
.rtl .settings-panel .tab-content .tab-pane .scroll-wrapper::-webkit-scrollbar-thumb,
.rtl .sidebar-fixed .nav::-webkit-scrollbar-thumb,
.rtl .table-responsive::-webkit-scrollbar-thumb,
.rtl ul.chats::-webkit-scrollbar-thumb {
  background-color: darkgrey;
  outline: 1px solid slategrey;
}
@media (min-width: 992px) {
  .rtl .navbar {
    right: 244px;
    left: 0;
    transition: left 0.25s ease;
    -webkit-transition: right 0.25s ease;
    -moz-transition: right 0.25s ease;
    -ms-transition: right 0.25s ease;
  }
}
.rtl .navbar .navbar-brand-wrapper .navbar-brand {
  padding: 0.25rem 1.3rem 0rem 0rem;
}
.rtl .navbar .navbar-menu-wrapper .navbar-nav {
  padding: 0;
}
.rtl .navbar .navbar-menu-wrapper .navbar-nav .nav-item .nav-link .navbar-profile .navbar-profile-name {
  margin-right: 1rem;
}
.rtl .dropdown-menu {
  text-align: right;
}
.rtl.sidebar-icon-only .navbar {
  right: 70px;
}
.rtl.sidebar-icon-only .sidebar .nav.sub-menu .nav-item .nav-link {
  padding-right: 20px;
}
.rtl.sidebar-icon-only .sidebar .nav.sub-menu .nav-item .nav-link:before {
  right: 0;
  left: unset;
}

table td {
  border: none !important;
}

body {
  background-color: #f1f5f9;
  color: #1e293b;
}

.admin-app {
  min-height: 100vh;
  background: #f1f5f9;
}

.admin-layout-sidebar {
  width: 216px;
  min-height: 100vh;
  background: #ffffff;
  border-left: 1px solid #e2e8f0;
  border-right: none;
  box-shadow: -2px 0 12px rgba(0, 0, 0, 0.04);
  position: fixed;
  right: 0;
  top: 0;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.admin-layout-sidebar .admin-sidebar-logo {
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid #e2e8f0;
  background: #ffffff;
  flex-shrink: 0;
}

.admin-layout-sidebar .admin-sidebar-logo a {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  color: #1e293b;
  font-weight: 700;
  font-size: 1.15rem;
  letter-spacing: -0.02em;
}

.admin-layout-sidebar .admin-sidebar-logo a img {
  height: 38px;
  width: auto;
  max-width: 100px;
  object-fit: contain;
}

.admin-layout-sidebar .admin-sidebar-user {
  padding: 1rem 1.5rem;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  gap: 10px;
}

.admin-layout-sidebar .admin-sidebar-user .admin-sidebar-avatar {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  object-fit: cover;
  background: #e2e8f0;
}

.admin-layout-sidebar .admin-sidebar-user .admin-sidebar-user-info {
  flex: 1 1;
  min-width: 0;
}

.admin-layout-sidebar .admin-sidebar-user .admin-sidebar-user-info .admin-sidebar-user-role {
  font-size: 0.7rem;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 2px;
}

.admin-layout-sidebar .admin-sidebar-user .admin-sidebar-user-info .admin-sidebar-user-name {
  font-size: 0.9rem;
  font-weight: 600;
  color: #1e293b;
}

.admin-layout-sidebar .admin-sidebar-nav {
  flex: 1 1;
  overflow-y: auto;
  padding: 1rem 0.75rem;
}

.admin-layout-sidebar .admin-sidebar-nav .admin-sidebar-label {
  font-size: 0.7rem;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  padding: 0.5rem 1rem 0.35rem;
  margin-top: 0.5rem;
}

.admin-layout-sidebar .admin-sidebar-nav .admin-sidebar-label:first-child {
  margin-top: 0;
}

.admin-layout-sidebar .admin-sidebar-nav .admin-sidebar-item {
  display: block;
  padding: 0.65rem 1rem;
  border-radius: 8px;
  color: #475569;
  font-size: 0.9rem;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.15s ease;
  margin-bottom: 2px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.admin-layout-sidebar .admin-sidebar-nav .admin-sidebar-item .admin-sidebar-icon {
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  color: #64748b;
  flex-shrink: 0;
}

.admin-layout-sidebar .admin-sidebar-nav .admin-sidebar-item:hover {
  background: #f1f5f9;
  color: #334155;
}

.admin-layout-sidebar .admin-sidebar-nav .admin-sidebar-item:hover .admin-sidebar-icon {
  color: #4f46e5;
}

.admin-layout-sidebar .admin-sidebar-nav .admin-sidebar-item.active {
  background: linear-gradient(135deg, #eef2ff 0%, #e0e7ff 100%);
  color: #4f46e5;
}

.admin-layout-sidebar .admin-sidebar-nav .admin-sidebar-item.active .admin-sidebar-icon {
  color: #4f46e5;
}

.admin-layout-sidebar .admin-sidebar-nav .admin-sidebar-parent .admin-sidebar-item {
  cursor: pointer;
}

.admin-layout-sidebar .admin-sidebar-nav .admin-sidebar-parent .admin-sidebar-item .admin-sidebar-arrow {
  margin-left: auto;
  transition: transform 0.2s;
  color: #94a3b8;
  font-size: 0.85rem;
}

.admin-layout-sidebar .admin-sidebar-nav .admin-sidebar-parent.open .admin-sidebar-arrow {
  transform: rotate(180deg);
}

.admin-layout-sidebar .admin-sidebar-nav .admin-sidebar-sub {
  list-style: none;
  padding: 0.25rem 0 0.25rem 0.5rem;
  margin: 0 0 0 1rem;
  border-left: 2px solid #e2e8f0;
}

.admin-layout-sidebar .admin-sidebar-nav .admin-sidebar-sub li {
  list-style: none;
  margin: 0;
}

.admin-layout-sidebar .admin-sidebar-nav .admin-sidebar-sub .admin-sidebar-item {
  padding: 0.5rem 0.75rem;
  font-size: 0.85rem;
  font-weight: 400;
}

.admin-layout-sidebar .admin-sidebar-nav .collapse .admin-sidebar-sub {
  display: block;
}

.admin-layout-navbar {
  background: #ffffff !important;
  border-bottom: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  padding: 0.5rem 1.5rem;
  min-height: 60px;
}

.admin-layout-navbar .navbar-menu-wrapper {
  width: 100%;
}

.admin-layout-navbar .admin-navbar-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #1e293b;
}

.admin-layout-navbar .admin-navbar-user {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0.4rem 0.75rem;
  border-radius: 10px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  cursor: pointer;
}

.admin-layout-navbar .admin-navbar-user img {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  object-fit: cover;
}

.admin-layout-navbar .admin-navbar-user .admin-navbar-user-text {
  font-size: 0.85rem;
  font-weight: 500;
  color: #334155;
}

.admin-layout-navbar .admin-navbar-user .admin-navbar-user-role {
  font-size: 0.75rem;
  color: #64748b;
}

.admin-layout-navbar .dropdown-menu {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
  padding: 0.5rem;
}

.admin-layout-navbar .dropdown-item {
  border-radius: 6px;
  padding: 0.6rem 1rem;
  font-size: 0.9rem;
  color: #334155;
}

.admin-layout-navbar .dropdown-item:hover {
  background: #f1f5f9;
}

.admin-layout-navbar .navbar-toggler {
  color: #64748b;
  border-color: #e2e8f0;
}

.admin-layout-footer {
  background: #ffffff !important;
  border-top: 1px solid #e2e8f0;
  padding: 0.75rem 1.5rem;
}

.admin-layout-footer .text-muted, .admin-layout-footer .preview-list .preview-item .preview-item-content p .content-category, .preview-list .preview-item .preview-item-content p .admin-layout-footer .content-category {
  color: #64748b !important;
  font-size: 0.85rem;
}

.admin-layout-footer a {
  color: #4f46e5;
  text-decoration: none;
}

.admin-layout-footer a:hover {
  text-decoration: underline;
}

.admin-app .page-body-wrapper {
  margin-right: 216px;
  margin-left: 0;
  background: #f1f5f9;
  min-height: 100vh;
}

.admin-content {
  min-height: calc(100vh - 60px);
  padding: 1.5rem 1.5rem 2rem;
  background: radial-gradient(1200px 600px at 10% -10%, rgba(99, 102, 241, 0.06), transparent 55%), radial-gradient(900px 500px at 100% 0%, rgba(14, 165, 233, 0.05), transparent 50%), #f1f5f9;
}

.admin-content {
  --admin-bg: #f1f5f9;
  --admin-card-bg: #ffffff;
  --admin-border: #e2e8f0;
  --admin-text: #1e293b;
  --admin-text-muted: #64748b;
  --admin-primary: #4f46e5;
  --admin-primary-light: #eef2ff;
  --admin-success: #059669;
  --admin-danger: #dc2626;
  --admin-warning: #d97706;
  --admin-radius: 10px;
  --admin-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  --admin-shadow-card: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -2px rgba(0, 0, 0, 0.05);
}

.admin-content .admin-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: var(--admin-radius);
  box-shadow: var(--admin-shadow-card);
  margin-bottom: 1.5rem;
  overflow: hidden;
}

.admin-content .admin-card .card-header,
.admin-content .admin-card .admin-card-header {
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #e2e8f0;
  font-weight: 600;
  color: #1e293b;
  background: #fafafa;
  font-size: 0.95rem;
}

.admin-content .admin-card .card-body {
  padding: 1.25rem;
  color: #334155;
  background: #ffffff;
}

.admin-content .table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  max-width: 100%;
}

.admin-content .table-responsive .table {
  color: #334155;
}

.admin-content .table-responsive .table thead th {
  border-color: #e2e8f0;
  color: #64748b;
  font-weight: 600;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  background: #f8fafc;
  padding: 0.75rem 1rem;
}

.admin-content .table-responsive .table tbody td {
  border-color: #f1f5f9;
  vertical-align: middle;
  padding: 0.75rem 1rem;
}

.admin-content .table-responsive .table tbody tr:hover {
  background: #f8fafc;
}

.admin-content .table-dark {
  background: #ffffff;
  color: #334155;
}

.admin-content .table-dark thead th {
  background: #f8fafc;
  color: #64748b;
}

.admin-content .form-control {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  color: #1e293b;
  border-radius: 8px;
  padding: 0.5rem 0.75rem;
}

.admin-content .form-control:focus {
  border-color: #4f46e5;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.15);
}

.admin-content .form-control::placeholder {
  color: #94a3b8;
}

.admin-content .form-group label,
.admin-content .form-label {
  color: #475569;
  margin-bottom: 0.35rem;
  font-weight: 500;
  font-size: 0.9rem;
}

.admin-content .btn-success {
  background: #059669;
  border-color: #059669;
  color: #fff;
  border-radius: 8px;
  font-weight: 500;
}

.admin-content .btn-success:hover {
  background: #047857;
  border-color: #047857;
  color: #fff;
}

.admin-content .btn-primary, .admin-content .custom-file .custom-file-label:after, .custom-file .admin-content .custom-file-label:after {
  background: #4f46e5;
  border-color: #4f46e5;
  color: #fff;
  border-radius: 8px;
  font-weight: 500;
}

.admin-content .btn-primary:hover, .admin-content .custom-file .custom-file-label:hover:after, .custom-file .admin-content .custom-file-label:hover:after {
  background: #4338ca;
  border-color: #4338ca;
  color: #fff;
}

.admin-content .btn-danger {
  background: #dc2626;
  border-color: #dc2626;
  color: #fff;
  border-radius: 8px;
}

.admin-content .btn-danger:hover {
  background: #b91c1c;
  border-color: #b91c1c;
  color: #fff;
}

.admin-content .btn-info {
  border-radius: 8px;
}

.admin-content .badge {
  font-weight: 500;
  padding: 0.35em 0.65em;
  border-radius: 6px;
}

.admin-content .text-muted, .admin-content .preview-list .preview-item .preview-item-content p .content-category, .preview-list .preview-item .preview-item-content p .admin-content .content-category {
  color: #64748b !important;
}

/* ========== All logged-in admin pages (under .admin-content) ========== */
.admin-content .page-header {
  margin-bottom: 1.25rem;
  padding: 1rem 1.25rem;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 8px 24px rgba(15, 23, 42, 0.06);
}

.admin-content .page-header h3,
.admin-content .page-header h4 {
  margin: 0;
  font-size: 1.35rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #0f172a;
}

.admin-content .page-header .page-subtitle,
.admin-content p.page-subtitle {
  margin: 0.35rem 0 0;
  font-size: 0.875rem;
  color: #64748b;
  line-height: 1.45;
}

/*
 * Bootstrap cards (list / reports / legacy) — not .admin-card blocks.
 * Exclude .dashboard-card-link: those use gradient + .card-body.text-white;
 * forcing a white .card-body here made text stay white → invisible on white.
 */
.admin-content .card:not(.admin-card):not(.dashboard-card-link) {
  border-radius: 14px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 8px 24px rgba(15, 23, 42, 0.06);
  overflow: hidden;
  background: #ffffff;
}

.admin-content .card:not(.admin-card):not(.dashboard-card-link) .card-header {
  background: #f8fafc;
  color: #0f172a;
  font-weight: 600;
  border-bottom: 1px solid #e2e8f0;
  padding: 0.85rem 1.15rem;
}

.admin-content .card:not(.admin-card):not(.dashboard-card-link) .card-body {
  background: #ffffff;
  color: #334155;
}

.admin-content .card:not(.admin-card):not(.dashboard-card-link) .card-title {
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.01em;
}

/*
 * Today tab uses class "card" only (no .dashboard-card-link), so the rule above
 * still paints .card-body white while .text-white keeps labels white → invisible.
 * Gradient shows through parent .card; body stays transparent with white type.
 */
.admin-content .card:not(.admin-card) .card-body.text-white {
  background: transparent !important;
  background-color: transparent !important;
  color: #ffffff !important;
}

/* Legacy dark green panels → light (covers leftover inline + text-light) */
.admin-content .card-body.text-light,
.admin-content .card-body.text-light[style] {
  background: #ffffff !important;
  color: #334155 !important;
}

.admin-content .table.text-light {
  color: #334155 !important;
}

.admin-content .table.text-light thead th {
  background: #f8fafc !important;
  color: #64748b !important;
  border-color: #e2e8f0 !important;
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  font-weight: 600;
}

.admin-content .table.text-light tbody td {
  color: #334155 !important;
  border-color: #f1f5f9 !important;
  vertical-align: middle;
}

.admin-content .table.text-light tbody tr:hover {
  background: #f8fafc !important;
}

/* .text-light on light cards → readable slate */
.admin-content .card .text-light:not(.btn):not(.badge) {
  color: #64748b !important;
}

.admin-content select.form-control.bg-dark,
.admin-content .form-control.bg-dark {
  background-color: #ffffff !important;
  color: #1e293b !important;
  border-color: #e2e8f0 !important;
}

.admin-content .pagination .page-link {
  border-radius: 8px;
  margin: 0 2px;
  color: #475569;
  border-color: #e2e8f0;
}

.admin-content .pagination .page-item.active .page-link {
  background: #4f46e5;
  border-color: #4f46e5;
  color: #fff;
}

.admin-content .btn-outline-info {
  color: #0369a1;
  border-color: #7dd3fc;
  background: #f0f9ff;
  border-radius: 8px;
  font-weight: 500;
}

.admin-content .btn-outline-info:hover {
  color: #fff;
  background: #0284c7;
  border-color: #0284c7;
}

.admin-content .btn-outline-secondary,
.admin-content .btn-secondary {
  border-radius: 8px;
}

.admin-content .table thead th {
  border-color: #e2e8f0;
}

/* User view — dark grey profile cards → light */
.admin-content .lp-admin-detail-card {
  background: #ffffff !important;
  color: #334155 !important;
  border: 1px solid #e2e8f0 !important;
  border-radius: 14px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 8px 24px rgba(15, 23, 42, 0.06);
}

.admin-content .lp-admin-detail-card > .card-header {
  background: #f8fafc !important;
  color: #0f172a !important;
  border-bottom: 1px solid #e2e8f0 !important;
}

.admin-content .lp-admin-kv-item {
  background: #f8fafc !important;
  border-color: #e2e8f0 !important;
  color: #334155;
}

.admin-content .lp-admin-kv-item a {
  color: #4f46e5;
}

.admin-content .lp-admin-wa-link {
  color: #0284c7 !important;
  font-weight: 600;
}

.admin-content .lp-admin-otp {
  display: inline-block;
  padding: 0.2rem 0.55rem;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 0.95rem;
  letter-spacing: 0.08em;
  color: #0f172a;
}

.admin-content .lp-admin-form-page {
  background: #ffffff !important;
  color: #334155 !important;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 1.25rem;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 8px 24px rgba(15, 23, 42, 0.06);
}

/* User profile view (admin) */
.admin-content .lp-user-view {
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}

.admin-content .lp-user-view-hero {
  background: linear-gradient(135deg, #f8fafc 0%, #eef2ff 100%) !important;
}

.admin-content .lp-user-view-stat-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.65rem;
}

@media (min-width: 768px) {
  .admin-content .lp-user-view-stat-grid {
    grid-template-columns: repeat(4, minmax(5.5rem, 1fr));
  }
}
.admin-content .lp-user-view-stat {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 0.5rem 0.65rem;
  text-align: center;
}

.admin-content .lp-user-view-stat-label {
  display: block;
  font-size: 0.65rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #64748b;
  font-weight: 600;
}

.admin-content .lp-user-view-stat-value {
  display: block;
  font-size: 0.95rem;
  font-weight: 700;
  color: #0f172a;
}

.admin-content .lp-user-view-tab-group .btn {
  border-radius: 8px !important;
}

.admin-content .lp-user-view-table-wrap {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  overflow-x: auto;
  overflow-y: visible;
  -webkit-overflow-scrolling: touch;
  max-width: 100%;
}

.admin-content .lp-user-view-table thead th {
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #475569;
  border-bottom-width: 1px;
  white-space: nowrap;
}

.admin-content .lp-user-view-table tbody td {
  vertical-align: middle;
  font-size: 0.85rem;
}

.admin-app .sidebar.sidebar-offcanvas.admin-layout-sidebar {
  background: #ffffff !important;
  border-left: 1px solid #e2e8f0 !important;
  border-right: none !important;
}

@media (max-width: 991px) {
  .admin-app .page-body-wrapper {
    margin-right: 0 !important;
  }
  .admin-layout-sidebar {
    transform: translateX(100%);
    transition: transform 0.2s;
    box-shadow: none;
  }
  .admin-layout-sidebar.active {
    transform: translateX(0);
    box-shadow: -4px 0 20px rgba(0, 0, 0, 0.1);
  }
}
@media (min-width: 992px) {
  .admin-layout-sidebar {
    transform: translateX(0) !important;
    right: 0 !important;
    left: auto !important;
    display: flex !important;
  }
  .admin-app .page-body-wrapper {
    margin-right: 216px !important;
    margin-left: 0 !important;
  }
}
/**
 * Admin mobile-first theme v2 + horizontal table scroll fixes.
 * Scoped under .admin-theme-v2 on .admin-app
 */
@supports selector(:has(*)) {
  body:has(.admin-app.admin-theme-v2:not(.admin-theme-light)) {
    background-color: #010409;
    color: #e4e4e7;
  }
}
.admin-app.admin-theme-v2 {
  background: #020617;
  min-height: 100vh;
}

/* Login / full-page routes — same dark shell as panel; content is .lp-admin-login */
.admin-app.admin-theme-v2.admin-full-page {
  background: radial-gradient(900px 480px at 50% -15%, rgba(34, 211, 238, 0.1), transparent 55%), linear-gradient(165deg, #070b14 0%, #0f172a 50%, #0a1628 100%);
  min-height: 100vh;
}

.admin-app.admin-theme-v2.admin-full-page .page-body-wrapper,
.admin-app.admin-theme-v2.admin-full-page .main-panel {
  background: transparent;
}

.admin-app.admin-theme-v2.admin-full-page .content-wrapper.admin-content {
  padding: 0 !important;
  min-height: 100vh;
  background: transparent !important;
}

.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .page-body-wrapper {
  background: linear-gradient(180deg, #020617 0%, #030712 35%, #0c1526 100%);
}

.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .main-panel {
  background: transparent;
}

/* ——— Sidebar (mobile drawer + desktop) ——— */
.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-layout-sidebar {
  background: linear-gradient(195deg, #111827 0%, #0a0a0f 55%, #0f172a 100%) !important;
  border-left: 1px solid rgba(255, 255, 255, 0.06) !important;
  box-shadow: -8px 0 32px rgba(0, 0, 0, 0.45);
}

.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-layout-sidebar .admin-sidebar-logo {
  background: rgba(15, 23, 42, 0.6);
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-layout-sidebar .admin-sidebar-logo a {
  color: #e2e8f0;
}

.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-layout-sidebar .admin-sidebar-nav .admin-sidebar-label {
  color: #64748b;
}

.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-layout-sidebar .admin-sidebar-item {
  color: #94a3b8;
}

.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-layout-sidebar .admin-sidebar-item:hover {
  background: rgba(34, 211, 238, 0.08);
  color: #e2e8f0;
}

.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-layout-sidebar .admin-sidebar-item.active {
  background: rgba(34, 211, 238, 0.15);
  color: #22d3ee;
  border: 1px solid rgba(34, 211, 238, 0.25);
}

.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-layout-sidebar .admin-sidebar-sub {
  border-left-color: rgba(34, 211, 238, 0.2);
}

/* ——— Navbar ——— */
.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-layout-navbar {
  background: rgba(15, 23, 42, 0.92) !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  padding: calc(0.5rem + env(safe-area-inset-top, 0px)) 1rem 0.5rem;
}

@media (min-width: 576px) {
  .admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-layout-navbar {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}
.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-layout-navbar .admin-navbar-title {
  color: #e2e8f0;
}

.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-layout-navbar .admin-navbar-user {
  background: rgba(26, 39, 68, 0.9);
  border-color: rgba(255, 255, 255, 0.06);
}

.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-layout-navbar .admin-navbar-user-text {
  color: #e2e8f0;
}

.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-layout-navbar .navbar-toggler {
  color: #22d3ee;
  border-color: rgba(34, 211, 238, 0.35);
  border-radius: 10px;
  padding: 0.45rem 0.55rem;
}

/* ——— Footer ——— */
.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-layout-footer {
  background: rgba(15, 23, 42, 0.95) !important;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  color: #94a3b8;
}

.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-layout-footer a {
  color: #22d3ee;
}

/* ——— Main content shell ——— */
.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content {
  background: radial-gradient(900px 420px at 15% -5%, rgba(34, 211, 238, 0.09), transparent 50%), radial-gradient(700px 380px at 100% 10%, rgba(99, 102, 241, 0.08), transparent 45%), linear-gradient(180deg, transparent, rgba(10, 15, 26, 0.5));
  color: #e2e8f0;
  padding: 1rem 0.75rem calc(2rem + env(safe-area-inset-bottom, 0px));
}

@media (min-width: 768px) {
  .admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content {
    padding: 1.5rem 1.5rem calc(2rem + env(safe-area-inset-bottom, 0px));
  }
}
/* Cards & page headers */
.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .admin-card,
.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .card:not(.admin-card):not(.dashboard-card-link),
.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .page-header {
  background: #0c0f14 !important;
  border: 1px solid rgba(255, 255, 255, 0.06) !important;
  color: #e2e8f0;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.25);
}

.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .admin-card .card-header,
.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .admin-card .admin-card-header,
.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .card .card-header {
  background: rgba(17, 24, 39, 0.6) !important;
  color: #e2e8f0 !important;
  border-bottom-color: rgba(255, 255, 255, 0.06) !important;
}

.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .card-body,
.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .admin-card .card-body {
  background: #0c0f14 !important;
  color: #e2e8f0 !important;
}

.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .card-title,
.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .page-header h3,
.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .page-header h4 {
  color: #e2e8f0 !important;
}

.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .text-muted, .admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .preview-list .preview-item .preview-item-content p .content-category, .preview-list .preview-item .preview-item-content p .admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .content-category,
.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content p.page-subtitle {
  color: #94a3b8 !important;
}

/* Forms */
.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .form-control {
  background: rgba(10, 15, 26, 0.55);
  border-color: rgba(255, 255, 255, 0.06);
  color: #e2e8f0;
}

.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .form-group label,
.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .form-label {
  color: #94a3b8;
}

/* Tables — readable on dark */
.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .table {
  color: #e2e8f0;
}

.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .table thead th {
  background: rgba(17, 24, 39, 0.85) !important;
  color: #94a3b8 !important;
  border-color: rgba(255, 255, 255, 0.06) !important;
}

.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .table tbody td {
  border-color: rgba(148, 163, 184, 0.12) !important;
  color: #e2e8f0;
}

.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .table tbody tr:hover {
  background: rgba(34, 211, 238, 0.06) !important;
}

.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .table-striped tbody tr:nth-of-type(odd) {
  background: rgba(15, 23, 42, 0.35);
}

/* ========== Critical: horizontal scroll (game history, user tabs, etc.) ========== */
.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .table-responsive,
.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .lp-user-view-table-wrap {
  overflow-x: auto !important;
  overflow-y: visible !important;
  -webkit-overflow-scrolling: touch !important;
  max-width: 100%;
  width: 100%;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  background: rgba(10, 15, 26, 0.35);
}

.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .lp-user-view-table-wrap {
  /* override earlier overflow:hidden from App.scss */
  overflow-x: auto !important;
  overflow-y: visible !important;
}

.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .table-responsive .table,
.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .lp-user-view-table-wrap .table,
.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .lp-user-view-table .table {
  min-width: 640px;
  margin-bottom: 0;
}

/* Buttons */
.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .btn-primary, .admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .custom-file .custom-file-label:after, .custom-file .admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .custom-file-label:after {
  background: linear-gradient(135deg, #06b6d4, #0891b2) !important;
  border-color: transparent !important;
  color: #0f172a !important;
  font-weight: 600;
}

.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .btn-success {
  background: #059669 !important;
  border-color: #059669 !important;
}

.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .btn-danger {
  background: #dc2626 !important;
  border-color: #dc2626 !important;
}

.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .btn-outline-secondary,
.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .btn-secondary {
  border-color: rgba(255, 255, 255, 0.06);
  color: #e2e8f0;
  background: rgba(26, 39, 68, 0.5);
}

.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .btn-outline-info {
  color: #22d3ee;
  border-color: rgba(34, 211, 238, 0.45);
  background: rgba(34, 211, 238, 0.08);
}

/* User profile panels */
.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .lp-admin-detail-card,
.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .lp-user-view-hero {
  background: #0c0f14 !important;
  border-color: rgba(255, 255, 255, 0.06) !important;
  color: #e2e8f0 !important;
}

.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .lp-user-view-stat {
  background: rgba(10, 15, 26, 0.5);
  border-color: rgba(255, 255, 255, 0.06);
}

.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .lp-user-view-stat-label {
  color: #94a3b8;
}

.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .lp-user-view-stat-value {
  color: #e2e8f0;
}

.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .lp-admin-kv-item {
  background: rgba(10, 15, 26, 0.45) !important;
  border-color: rgba(255, 255, 255, 0.06) !important;
  color: #e2e8f0 !important;
}

/* Pagination */
.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .pagination .page-link {
  background: rgba(26, 39, 68, 0.8);
  border-color: rgba(255, 255, 255, 0.06);
  color: #e2e8f0;
}

.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .pagination .page-item.active .page-link {
  background: #06b6d4 !important;
  border-color: #22d3ee !important;
  color: #0f172a !important;
}

/* Mobile drawer backdrop */
.admin-sidebar-backdrop {
  display: none;
  position: fixed;
  inset: 0;
  z-index: 998;
  background: rgba(2, 6, 23, 0.55);
  -webkit-backdrop-filter: blur(2px);
          backdrop-filter: blur(2px);
}

body.admin-sidebar-open .admin-sidebar-backdrop {
  display: block;
}

@media (min-width: 992px) {
  .admin-sidebar-backdrop {
    display: none !important;
  }
}
/* Sidebar z-index above backdrop */
.admin-app.admin-theme-v2 .admin-layout-sidebar {
  z-index: 1001;
}

/* Body lock only on small screens when drawer open (keeps desktop browser zoom / scroll free) */
@media (max-width: 991.98px) {
  body.admin-sidebar-open {
    overflow: hidden;
  }
}
/* Content area min height on small screens */
.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .main-panel .content-wrapper.admin-content {
  min-height: calc(100vh - 60px);
}

/**
 * Light theme for admin panel (toggle: .admin-theme-light on .admin-app).
 * Polished sidebar + soft page background. Logged-in area only (not .admin-full-page).
 */
@supports selector(:has(*)) {
  body:has(.admin-app.admin-theme-v2.admin-theme-light) {
    background-color: #f4f4f5;
    color: #27272a;
  }
}
.admin-app.admin-theme-v2.admin-theme-light {
  background: #f4f4f5;
}

.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .page-body-wrapper {
  background: linear-gradient(180deg, #f8fafc 0%, #eef2f7 40%, #e8edf5 100%);
}

.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .main-panel {
  background: transparent;
}

/* ——— Sidebar (light, touch-friendly) ——— */
.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-layout-sidebar {
  background: linear-gradient(195deg, #ffffff 0%, #f8fafc 55%, #f1f5f9 100%) !important;
  border-left: 1px solid rgba(15, 23, 42, 0.08) !important;
  box-shadow: -6px 0 32px rgba(15, 23, 42, 0.06);
}

.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-layout-sidebar .admin-sidebar-logo {
  background: #fff;
  border-bottom: 1px solid #e2e8f0;
}

.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-layout-sidebar .admin-sidebar-logo a {
  color: #0f172a;
}

.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-layout-sidebar .admin-sidebar-nav {
  padding-bottom: calc(1rem + env(safe-area-inset-bottom, 0px));
}

.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-layout-sidebar .admin-sidebar-nav .admin-sidebar-label {
  color: #64748b;
  font-size: 0.68rem;
  letter-spacing: 0.1em;
}

.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-layout-sidebar .admin-sidebar-item {
  color: #334155;
  border-radius: 10px;
  margin-bottom: 2px;
}

.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-layout-sidebar .admin-sidebar-item:hover {
  background: #eef2ff;
  color: #4338ca;
}

.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-layout-sidebar .admin-sidebar-item.active {
  background: linear-gradient(135deg, #eef2ff 0%, #e0e7ff 100%);
  color: #4f46e5;
  border: 1px solid rgba(79, 70, 229, 0.2);
  font-weight: 600;
}

.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-layout-sidebar .admin-sidebar-sub {
  border-left-color: #e2e8f0;
}

/* ——— Navbar ——— */
.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-layout-navbar {
  background: rgba(255, 255, 255, 0.92) !important;
  border-bottom: 1px solid #e2e8f0;
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  padding: calc(0.5rem + env(safe-area-inset-top, 0px)) 1rem 0.5rem;
}

@media (min-width: 576px) {
  .admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-layout-navbar {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}
.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-layout-navbar .admin-navbar-title {
  color: #0f172a;
}

.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-layout-navbar .admin-navbar-user {
  background: #f8fafc;
  border-color: #e2e8f0;
}

.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-layout-navbar .admin-navbar-user-text {
  color: #334155;
}

.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-layout-navbar .navbar-toggler {
  color: #4f46e5;
  border-color: #e2e8f0;
  border-radius: 10px;
}

.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-layout-navbar .admin-theme-toggle,
.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-header-v3__icon-btn.admin-theme-toggle {
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #475569;
  padding: 0.4rem 0.55rem;
  line-height: 1;
}

.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-layout-navbar .admin-theme-toggle:hover,
.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-header-v3__icon-btn.admin-theme-toggle:hover {
  background: #f1f5f9;
  border-color: #cbd5e1;
  color: #0f172a;
}

/* ——— Footer ——— */
.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-layout-footer {
  background: #ffffff !important;
  border-top: 1px solid #e2e8f0;
}

.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-layout-footer a {
  color: #4f46e5;
}

/* ——— Content ——— */
.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content {
  background: radial-gradient(900px 400px at 12% -8%, rgba(99, 102, 241, 0.06), transparent 50%), radial-gradient(700px 360px at 100% 0%, rgba(14, 165, 233, 0.05), transparent 45%), transparent;
  color: #1e293b;
  padding: 1rem 0.75rem calc(1.5rem + env(safe-area-inset-bottom, 0px));
}

@media (min-width: 768px) {
  .admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content {
    padding: 1.5rem 1.5rem calc(2rem + env(safe-area-inset-bottom, 0px));
  }
}
.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .admin-card,
.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .card:not(.admin-card):not(.dashboard-card-link),
.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .page-header {
  background: #ffffff !important;
  border: 1px solid #e2e8f0 !important;
  color: #1e293b;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06), 0 8px 24px rgba(15, 23, 42, 0.04);
}

.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .admin-card .card-header,
.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .admin-card .admin-card-header,
.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .card .card-header {
  background: #f8fafc !important;
  color: #0f172a !important;
  border-bottom-color: #e2e8f0 !important;
}

.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .card-body,
.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .admin-card .card-body {
  background: #ffffff !important;
  color: #334155 !important;
}

.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .form-control {
  background: #ffffff;
  border-color: #e2e8f0;
  color: #1e293b;
}

.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .table {
  color: #334155;
}

.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .table thead th {
  background: #f8fafc !important;
  color: #64748b !important;
  border-color: #e2e8f0 !important;
}

.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .table tbody td {
  border-color: #f1f5f9 !important;
}

.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .table tbody tr:hover {
  background: #f8fafc !important;
}

.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .table-responsive,
.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .lp-user-view-table-wrap {
  overflow-x: auto !important;
  -webkit-overflow-scrolling: touch !important;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background: #fff;
}

.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .table-responsive .table,
.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .lp-user-view-table-wrap .table {
  min-width: 640px;
}

.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .btn-primary, .admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .custom-file .custom-file-label:after, .custom-file .admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .custom-file-label:after {
  background: #4f46e5 !important;
  border-color: #4f46e5 !important;
  color: #fff !important;
}

.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .pagination .page-link {
  background: #fff;
  border-color: #e2e8f0;
  color: #475569;
}

.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .pagination .page-item.active .page-link {
  background: #4f46e5 !important;
  border-color: #4f46e5 !important;
  color: #fff !important;
}

body.admin-sidebar-open .admin-sidebar-backdrop {
  background: rgba(15, 23, 42, 0.35);
}

.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .main-panel .content-wrapper.admin-content {
  min-height: calc(100vh - 60px);
}

/* Dark mode: theme toggle visible on dark navbar */
.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-layout-navbar .admin-theme-toggle,
.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-header-v3__icon-btn.admin-theme-toggle {
  border-radius: 10px;
  border: 1px solid rgba(148, 163, 184, 0.25);
  background: rgba(15, 23, 42, 0.5);
  color: #e2e8f0;
  padding: 0.4rem 0.55rem;
  line-height: 1;
}

.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-layout-navbar .admin-theme-toggle:hover,
.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-header-v3__icon-btn.admin-theme-toggle:hover {
  background: rgba(34, 211, 238, 0.12);
  border-color: rgba(34, 211, 238, 0.35);
  color: #fff;
}

/**
 * Pending / completed / rejected KYC tables — readable in light & dark theme.
 * Use wrapper .lp-kyc-page and table.lp-kyc-table (never .text-white on the whole table).
 */
.lp-kyc-page .card-title {
  color: inherit;
}

.lp-kyc-page .lp-kyc-table {
  color: #e4e4e7;
}

.lp-kyc-page .lp-kyc-table thead th {
  color: #a1a1aa !important;
  border-color: rgba(255, 255, 255, 0.08) !important;
  background: rgba(255, 255, 255, 0.04) !important;
}

.lp-kyc-page .lp-kyc-table tbody td {
  border-color: rgba(255, 255, 255, 0.06) !important;
  color: #e4e4e7;
  vertical-align: middle;
}

.lp-kyc-page .lp-kyc-table tbody tr:hover {
  background: rgba(255, 255, 255, 0.04) !important;
}

.lp-kyc-page .lp-kyc-table a:not(.btn) {
  color: #7dd3fc;
}

.lp-kyc-page .lp-kyc-table .btn-primary, .lp-kyc-page .lp-kyc-table .custom-file .custom-file-label:after, .custom-file .lp-kyc-page .lp-kyc-table .custom-file-label:after {
  color: #fff !important;
}

/* Light theme: dark text on white card */
.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .lp-kyc-page .lp-kyc-table,
.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .lp-kyc-page .lp-kyc-table tbody td {
  color: #334155 !important;
}

.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .lp-kyc-page .lp-kyc-table thead th {
  color: #64748b !important;
  background: #f8fafc !important;
  border-color: #e2e8f0 !important;
}

.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .lp-kyc-page .lp-kyc-table tbody td {
  border-color: #f1f5f9 !important;
}

.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .lp-kyc-page .lp-kyc-table tbody tr:hover {
  background: #f8fafc !important;
}

.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .lp-kyc-page .lp-kyc-table a:not(.btn) {
  color: #0369a1 !important;
}

/* Same contrast if table sits outside .admin-content wrapper */
.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .lp-kyc-page .lp-kyc-table,
.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .lp-kyc-page .lp-kyc-table tbody td {
  color: #334155 !important;
}

.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .lp-kyc-page .lp-kyc-table thead th {
  color: #64748b !important;
  background: #f8fafc !important;
}

/* User profile → KYC tab table */
.lp-user-view .lp-kyc-table.table {
  color: inherit;
}

.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .lp-user-view .lp-kyc-table.table,
.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .lp-user-view .lp-kyc-table.table td,
.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .lp-user-view .lp-kyc-table.table th {
  color: #334155 !important;
}

.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .lp-user-view .lp-kyc-table.table thead th {
  background: #f8fafc !important;
  color: #64748b !important;
}

.lp-kyc-otp-details {
  max-width: 280px;
  line-height: 1.45;
}

.lp-kyc-otp-details .badge-info, .lp-kyc-otp-details .preview-list .preview-item .preview-thumbnail .badge.badge-offline, .preview-list .preview-item .preview-thumbnail .lp-kyc-otp-details .badge.badge-offline {
  background: #0ea5e9;
  color: #fff;
}

/**
 * Slim compact UI: small radius cards, tight nav, black dark / clean light.
 * Load after theme files. Targets .admin-app.admin-theme-v2.
 */
/* ——— Shell width (align with App.scss 216px) ——— */
.admin-app.admin-theme-v2 .admin-layout-sidebar {
  width: 216px !important;
}

@media (min-width: 992px) {
  .admin-app.admin-theme-v2 .page-body-wrapper {
    margin-right: 216px !important;
  }
}
/* ——— Sidebar: slim type + compact logo ——— */
.admin-app.admin-theme-v2:not(.admin-full-page) .admin-layout-sidebar .admin-sidebar-logo {
  padding: 0.65rem 0.85rem !important;
}

.admin-app.admin-theme-v2:not(.admin-full-page) .admin-layout-sidebar .admin-sidebar-logo a {
  font-size: 0.82rem !important;
  font-weight: 600 !important;
  letter-spacing: 0.02em !important;
  gap: 6px !important;
}

.admin-app.admin-theme-v2:not(.admin-full-page) .admin-layout-sidebar .admin-sidebar-logo a img {
  height: 28px !important;
  max-width: 88px !important;
}

.admin-app.admin-theme-v2:not(.admin-full-page) .admin-layout-sidebar .admin-sidebar-nav {
  padding: 0.45rem 0.45rem 0.65rem !important;
}

.admin-app.admin-theme-v2:not(.admin-full-page) .admin-layout-sidebar .admin-sidebar-nav .admin-sidebar-label {
  font-size: 0.6rem !important;
  padding: 0.35rem 0.55rem 0.2rem !important;
  margin-top: 0.35rem !important;
  letter-spacing: 0.12em !important;
}

.admin-app.admin-theme-v2:not(.admin-full-page) .admin-layout-sidebar .admin-sidebar-item {
  padding: 0.4rem 0.55rem !important;
  font-size: 0.78rem !important;
  font-weight: 500 !important;
  border-radius: 10px !important;
  margin-bottom: 1px !important;
}

.admin-app.admin-theme-v2:not(.admin-full-page) .admin-layout-sidebar .admin-sidebar-item .admin-sidebar-icon {
  width: 18px !important;
  height: 18px !important;
  font-size: 0.95rem !important;
}

.admin-app.admin-theme-v2:not(.admin-full-page) .admin-layout-sidebar .admin-sidebar-sub .admin-sidebar-item {
  padding: 0.32rem 0.5rem !important;
  font-size: 0.74rem !important;
}

.admin-app.admin-theme-v2:not(.admin-full-page) .admin-layout-sidebar .admin-sidebar-sub {
  margin-left: 0.65rem !important;
  padding-left: 0.35rem !important;
  border-left-width: 1px !important;
}

/* ——— Navbar slim ——— */
.admin-app.admin-theme-v2:not(.admin-full-page) .admin-layout-navbar {
  min-height: 46px !important;
  padding-top: calc(0.32rem + env(safe-area-inset-top, 0px)) !important;
  padding-bottom: 0.32rem !important;
  padding-left: 0.65rem !important;
  padding-right: 0.65rem !important;
}

@media (min-width: 576px) {
  .admin-app.admin-theme-v2:not(.admin-full-page) .admin-layout-navbar {
    padding-left: 0.85rem !important;
    padding-right: 0.85rem !important;
  }
}
.admin-app.admin-theme-v2:not(.admin-full-page) .admin-layout-navbar .admin-navbar-title {
  font-size: 0.88rem !important;
  font-weight: 600 !important;
}

.admin-app.admin-theme-v2:not(.admin-full-page) .admin-layout-navbar .admin-navbar-user {
  padding: 0.28rem 0.5rem !important;
  border-radius: 10px !important;
}

.admin-app.admin-theme-v2:not(.admin-full-page) .admin-layout-navbar .admin-navbar-user img {
  width: 28px !important;
  height: 28px !important;
  border-radius: 6px !important;
}

.admin-app.admin-theme-v2:not(.admin-full-page) .admin-layout-navbar .admin-navbar-user-text {
  font-size: 0.78rem !important;
}

.admin-app.admin-theme-v2:not(.admin-full-page) .admin-layout-navbar .admin-navbar-user-role {
  font-size: 0.65rem !important;
}

.admin-app.admin-theme-v2:not(.admin-full-page) .admin-layout-navbar .admin-theme-toggle {
  padding: 0.28rem 0.42rem !important;
  border-radius: 10px !important;
}

.admin-app.admin-theme-v2:not(.admin-full-page) .admin-layout-navbar .navbar-toggler {
  padding: 0.3rem 0.4rem !important;
  border-radius: 10px !important;
}

/* ——— Content: tight cards + page header ——— */
.admin-app.admin-theme-v2:not(.admin-full-page) .admin-content {
  padding: 0.65rem 0.55rem calc(1rem + env(safe-area-inset-bottom, 0px)) !important;
}

@media (min-width: 768px) {
  .admin-app.admin-theme-v2:not(.admin-full-page) .admin-content {
    padding: 0.85rem 0.85rem calc(1.25rem + env(safe-area-inset-bottom, 0px)) !important;
  }
}
.admin-app.admin-theme-v2:not(.admin-full-page) .admin-content .page-header {
  border-radius: 10px !important;
  padding: 0.65rem 0.85rem !important;
  margin-bottom: 0.65rem !important;
}

.admin-app.admin-theme-v2:not(.admin-full-page) .admin-content .page-header h3,
.admin-app.admin-theme-v2:not(.admin-full-page) .admin-content .page-header h4 {
  font-size: 1rem !important;
}

.admin-app.admin-theme-v2:not(.admin-full-page) .admin-content .page-header .page-subtitle,
.admin-app.admin-theme-v2:not(.admin-full-page) .admin-content p.page-subtitle {
  font-size: 0.75rem !important;
  margin-top: 0.2rem !important;
}

.admin-app.admin-theme-v2:not(.admin-full-page) .admin-content .admin-card,
.admin-app.admin-theme-v2:not(.admin-full-page) .admin-content .card:not(.admin-card):not(.dashboard-card-link) {
  border-radius: 10px !important;
  margin-bottom: 0.65rem !important;
}

.admin-app.admin-theme-v2:not(.admin-full-page) .admin-content .admin-card .card-header,
.admin-app.admin-theme-v2:not(.admin-full-page) .admin-content .admin-card .admin-card-header,
.admin-app.admin-theme-v2:not(.admin-full-page) .admin-content .card .card-header {
  padding: 0.5rem 0.65rem !important;
  font-size: 0.8rem !important;
}

.admin-app.admin-theme-v2:not(.admin-full-page) .admin-content .admin-card .card-body,
.admin-app.admin-theme-v2:not(.admin-full-page) .admin-content .card .card-body {
  padding: 0.55rem 0.6rem !important;
}

.admin-app.admin-theme-v2:not(.admin-full-page) .admin-content .btn {
  border-radius: 10px !important;
  font-size: 0.78rem !important;
  padding: 0.35rem 0.55rem !important;
}

.admin-app.admin-theme-v2:not(.admin-full-page) .admin-content .btn-sm, .admin-app.admin-theme-v2:not(.admin-full-page) .admin-content .btn-group-sm > .btn {
  padding: 0.28rem 0.45rem !important;
  font-size: 0.72rem !important;
}

.admin-app.admin-theme-v2:not(.admin-full-page) .admin-content .form-control,
.admin-app.admin-theme-v2:not(.admin-full-page) .admin-content .form-control-sm {
  border-radius: 10px !important;
  font-size: 0.8rem !important;
  padding: 0.35rem 0.5rem !important;
  min-height: 34px !important;
}

.admin-app.admin-theme-v2:not(.admin-full-page) .admin-content .badge {
  font-size: 0.65rem !important;
  padding: 0.2em 0.45em !important;
  border-radius: 6px !important;
}

/* Dark: deeper black shell, slim card stroke */
.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .page-body-wrapper {
  background: linear-gradient(180deg, #010409 0%, #020617 40%, #030712 100%) !important;
}

.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-layout-sidebar {
  background: linear-gradient(200deg, #020202 0%, #0a0a0c 50%, #050508 100%) !important;
  border-left-color: rgba(255, 255, 255, 0.06) !important;
  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.65) !important;
}

.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-layout-navbar {
  background: rgba(2, 6, 23, 0.94) !important;
  border-bottom-color: rgba(255, 255, 255, 0.06) !important;
}

.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .admin-card,
.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .card:not(.admin-card):not(.dashboard-card-link),
.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .page-header {
  background: #0c0f14 !important;
  border: 1px solid rgba(255, 255, 255, 0.06) !important;
  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.03) inset !important;
}

.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .admin-card .card-header,
.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .card .card-header {
  background: rgba(0, 0, 0, 0.35) !important;
  border-bottom-color: rgba(255, 255, 255, 0.06) !important;
}

/* Light: airy minimal */
.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .page-body-wrapper {
  background: linear-gradient(180deg, #fafafa 0%, #f4f4f5 45%, #ececee 100%) !important;
}

.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-layout-sidebar {
  background: #ffffff !important;
  box-shadow: -2px 0 16px rgba(0, 0, 0, 0.04) !important;
  border-left: 1px solid #e4e4e7 !important;
}

.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-layout-navbar {
  background: rgba(255, 255, 255, 0.97) !important;
  border-bottom: 1px solid #e4e4e7 !important;
}

.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .admin-card,
.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .card:not(.admin-card):not(.dashboard-card-link),
.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .page-header {
  border: 1px solid #e4e4e7 !important;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04) !important;
  border-radius: 10px !important;
}

.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-layout-footer {
  padding: 0.45rem 0.85rem !important;
  font-size: 0.75rem !important;
}

/**
 * Pinch / browser zoom friendly + clearer mobile layout.
 * Import last. touch-action: auto on wide scrollers so zoom is not eaten.
 */
.admin-app.admin-theme-v2 .admin-content .table-responsive,
.admin-app.admin-theme-v2 .admin-content .lp-user-view-table-wrap {
  touch-action: auto !important;
}

@media (max-width: 767.98px) {
  .admin-app.admin-theme-v2:not(.admin-full-page) .admin-content {
    font-size: 15px;
    line-height: 1.5;
    -webkit-text-size-adjust: 100%;
  }
  .admin-app.admin-theme-v2:not(.admin-full-page) .admin-content .page-header h3,
  .admin-app.admin-theme-v2:not(.admin-full-page) .admin-content .page-header h4 {
    font-size: 1.05rem !important;
    line-height: 1.3 !important;
  }
  .admin-app.admin-theme-v2:not(.admin-full-page) .admin-content .page-header .page-subtitle,
  .admin-app.admin-theme-v2:not(.admin-full-page) .admin-content p.page-subtitle {
    font-size: 0.8rem !important;
    line-height: 1.45 !important;
  }
  /* Dark: cards a bit lighter than pure black — easier to read */
  .admin-app.admin-theme-v2:not(.admin-theme-light) .lp-allusers-card,
  .admin-app.admin-theme-v2:not(.admin-theme-light) .lp-withdraw-card {
    background: #151a22 !important;
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
    border-radius: 12px !important;
    padding: 0.9rem 0.85rem !important;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.35);
  }
  .admin-app.admin-theme-v2:not(.admin-theme-light) .lp-allusers-card-name,
  .admin-app.admin-theme-v2:not(.admin-theme-light) .lp-withdraw-card-title {
    font-size: 0.95rem !important;
  }
  .admin-app.admin-theme-v2:not(.admin-theme-light) .lp-allusers-card-grid dd,
  .admin-app.admin-theme-v2:not(.admin-theme-light) .lp-withdraw-card-grid dd {
    font-size: 0.88rem !important;
  }
  /* Light: airy cards */
  .admin-app.admin-theme-v2.admin-theme-light .lp-allusers-card,
  .admin-app.admin-theme-v2.admin-theme-light .lp-withdraw-card {
    border-radius: 12px !important;
    padding: 0.9rem 0.85rem !important;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06) !important;
    border-color: #e4e4e7 !important;
  }
  .admin-app.admin-theme-v2:not(.admin-full-page) .lp-allusers-stats,
  .admin-app.admin-theme-v2:not(.admin-full-page) .lp-allusers-mobile,
  .admin-app.admin-theme-v2:not(.admin-full-page) .lp-withdraw-mobile {
    gap: 0.65rem;
  }
  .admin-app.admin-theme-v2:not(.admin-full-page) .lp-allusers-card-actions .btn,
  .admin-app.admin-theme-v2:not(.admin-full-page) .lp-withdraw-card-actions .btn {
    min-height: 40px;
    font-size: 0.82rem !important;
  }
}
/**
 * Admin shell v3 — left sidebar, offcanvas mobile, modern header.
 */
/* ——— Layout: sidebar LEFT (override legacy right rail) ——— */
.admin-app.admin-shell-v3 .admin-layout-sidebar {
  z-index: 1050;
  left: 0 !important;
  right: auto !important;
  width: 260px;
  transform: translateX(-100%);
  transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: none;
  border-left: none !important;
  border-right: 1px solid #e2e8f0;
}
.admin-app.admin-shell-v3 .admin-layout-sidebar.is-offcanvas-open {
  transform: translateX(0);
  box-shadow: 4px 0 24px rgba(15, 23, 42, 0.12);
}
@media (min-width: 992px) {
  .admin-app.admin-shell-v3 .admin-layout-sidebar {
    transform: translateX(0) !important;
    box-shadow: none !important;
  }
}
.admin-app.admin-shell-v3 .page-body-wrapper {
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding-top: 64px;
  min-height: 100vh;
}
@media (min-width: 992px) {
  .admin-app.admin-shell-v3 .page-body-wrapper {
    margin-left: 260px !important;
  }
}
.admin-app.admin-shell-v3 .main-panel {
  width: 100%;
  min-height: calc(100vh - 64px);
  /* Legacy _misc.scss adds padding-top: 70px — header offset is already on page-body-wrapper */
  padding-top: 0 !important;
}
.admin-app.admin-shell-v3 .content-wrapper.admin-content {
  padding: 0 !important;
}

/* Offcanvas backdrop */
.admin-offcanvas-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1040;
  background: rgba(15, 23, 42, 0.45);
  -webkit-backdrop-filter: blur(3px);
          backdrop-filter: blur(3px);
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.25s ease, visibility 0.25s ease;
}

.admin-offcanvas-backdrop.is-visible {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
}

@media (min-width: 992px) {
  .admin-offcanvas-backdrop {
    display: none !important;
  }
}
body.admin-offcanvas-open {
  overflow: hidden;
}

@media (min-width: 992px) {
  body.admin-offcanvas-open {
    overflow: auto;
  }
}
/* ——— Sidebar interior ——— */
.admin-layout-sidebar {
  display: flex;
  flex-direction: column;
  height: 100vh;
  height: 100dvh;
}

.admin-sidebar-top {
  flex-shrink: 0;
  padding: 1rem 1rem 0.75rem;
  border-bottom: 1px solid #e2e8f0;
}

.admin-sidebar-top-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
}

.admin-sidebar-brand {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  text-decoration: none !important;
  color: inherit;
  min-width: 0;
}

.admin-sidebar-brand-mark {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: linear-gradient(135deg, #4f46e5 0%, #6366f1 100%);
  color: #fff;
  font-weight: 800;
  font-size: 0.85rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  letter-spacing: -0.03em;
}

.admin-sidebar-brand-text {
  font-weight: 700;
  font-size: 0.95rem;
  letter-spacing: -0.02em;
  color: #0f172a;
  line-height: 1.2;
}

.admin-sidebar-brand-sub {
  font-size: 0.65rem;
  color: #64748b;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.admin-sidebar-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #f8fafc;
  color: #64748b;
  cursor: pointer;
  flex-shrink: 0;
}

@media (min-width: 992px) {
  .admin-sidebar-close {
    display: none;
  }
}
.admin-sidebar-search-wrap {
  position: relative;
}

.admin-sidebar-search {
  width: 100%;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 0.5rem 0.75rem 0.5rem 2.25rem;
  font-size: 0.85rem;
  background: #f8fafc;
  color: #0f172a;
}

.admin-sidebar-search:focus {
  outline: none;
  border-color: #4f46e5;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.12);
  background: #fff;
}

.admin-sidebar-search-icon {
  position: absolute;
  left: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  color: #94a3b8;
  font-size: 1rem;
  pointer-events: none;
}

.admin-sidebar-nav {
  flex: 1 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0.75rem 0.65rem 1rem;
  -webkit-overflow-scrolling: touch;
}

.admin-sidebar-nav.is-filter-empty::after {
  content: "No menu match";
  display: block;
  text-align: center;
  color: #94a3b8;
  font-size: 0.85rem;
  padding: 1.5rem 0.5rem;
}

.admin-sidebar-item.is-nav-hidden {
  display: none !important;
}

.admin-sidebar-parent.is-nav-hidden {
  display: none !important;
}

.admin-sidebar-label.is-nav-hidden {
  display: none !important;
}

/* ——— Header v3 ——— */
.admin-header-v3 {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1030;
  height: 64px;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0 1rem;
  background: rgba(255, 255, 255, 0.92);
  border-bottom: 1px solid #e2e8f0;
  -webkit-backdrop-filter: blur(12px);
          backdrop-filter: blur(12px);
  box-shadow: 0 1px 0 rgba(15, 23, 42, 0.04);
}

@media (min-width: 992px) {
  .admin-header-v3 {
    left: 260px;
    padding: 0 1.5rem;
  }
}
.admin-header-v3__menu {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #f8fafc;
  color: #475569;
  cursor: pointer;
  flex-shrink: 0;
}

@media (min-width: 992px) {
  .admin-header-v3__menu {
    display: none;
  }
}
.admin-header-v3__menu .mdi {
  font-size: 1.35rem;
}

.admin-header-v3__titles {
  flex: 1 1;
  min-width: 0;
}

.admin-header-v3__breadcrumb {
  font-size: 0.68rem;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.admin-header-v3__title {
  font-size: 1.05rem;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.02em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
  line-height: 1.25;
}

.admin-header-v3__actions {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  flex-shrink: 0;
}

.admin-header-v3__icon-btn,
.admin-header-v3__icon-btn.admin-theme-toggle {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #475569;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  line-height: 1;
}

.admin-header-v3__icon-btn .mdi {
  font-size: 1.25rem;
}

.admin-header-v3__icon-btn:hover {
  background: #eef2ff;
  border-color: rgba(79, 70, 229, 0.25);
  color: #4f46e5;
}

.admin-header-v3__user {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.35rem 0.5rem 0.35rem 0.35rem;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  cursor: pointer;
  max-width: 200px;
}

.admin-header-v3__user img {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  object-fit: cover;
}

.admin-header-v3__user-name {
  font-size: 0.8rem;
  font-weight: 600;
  color: #334155;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.admin-header-v3__user-role {
  font-size: 0.68rem;
  color: #64748b;
}

/* Dark theme shell */
.admin-app.admin-theme-v2.admin-shell-v3:not(.admin-theme-light):not(.admin-full-page) .admin-layout-sidebar {
  background: linear-gradient(195deg, #111827 0%, #0a0a0f 55%, #0f172a 100%) !important;
  border-right-color: rgba(255, 255, 255, 0.06) !important;
}
.admin-app.admin-theme-v2.admin-shell-v3:not(.admin-theme-light):not(.admin-full-page) .admin-sidebar-top {
  border-bottom-color: rgba(255, 255, 255, 0.06);
}
.admin-app.admin-theme-v2.admin-shell-v3:not(.admin-theme-light):not(.admin-full-page) .admin-sidebar-brand-text {
  color: #f4f4f5;
}
.admin-app.admin-theme-v2.admin-shell-v3:not(.admin-theme-light):not(.admin-full-page) .admin-sidebar-search {
  background: rgba(15, 23, 42, 0.6);
  border-color: rgba(255, 255, 255, 0.08);
  color: #e2e8f0;
}
.admin-app.admin-theme-v2.admin-shell-v3:not(.admin-theme-light):not(.admin-full-page) .admin-sidebar-close,
.admin-app.admin-theme-v2.admin-shell-v3:not(.admin-theme-light):not(.admin-full-page) .admin-header-v3__menu,
.admin-app.admin-theme-v2.admin-shell-v3:not(.admin-theme-light):not(.admin-full-page) .admin-header-v3__icon-btn {
  background: rgba(26, 39, 68, 0.8);
  border-color: rgba(255, 255, 255, 0.08);
  color: #94a3b8;
}
.admin-app.admin-theme-v2.admin-shell-v3:not(.admin-theme-light):not(.admin-full-page) .admin-header-v3 {
  background: rgba(15, 23, 42, 0.92);
  border-bottom-color: rgba(255, 255, 255, 0.06);
}
.admin-app.admin-theme-v2.admin-shell-v3:not(.admin-theme-light):not(.admin-full-page) .admin-header-v3__title {
  color: #f4f4f5;
}
.admin-app.admin-theme-v2.admin-shell-v3:not(.admin-theme-light):not(.admin-full-page) .admin-header-v3__user {
  background: rgba(26, 39, 68, 0.9);
  border-color: rgba(255, 255, 255, 0.08);
}
.admin-app.admin-theme-v2.admin-shell-v3:not(.admin-theme-light):not(.admin-full-page) .admin-header-v3__user-name {
  color: #e2e8f0;
}

/* Sidebar theme toggle (mobile + desktop) */
.admin-sidebar-footer {
  flex-shrink: 0;
  padding: 0.75rem 1rem 1rem;
  border-top: 1px solid #e2e8f0;
}

.admin-sidebar-theme-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.55rem 0.75rem;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #475569;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
}

.admin-sidebar-theme-btn:hover {
  background: #eef2ff;
  border-color: rgba(79, 70, 229, 0.25);
  color: #4f46e5;
}

.admin-sidebar-theme-btn .mdi {
  font-size: 1.1rem;
}

/* Light theme polish */
.admin-app.admin-shell-v3.admin-theme-light .admin-layout-sidebar {
  background: #ffffff !important;
}
.admin-app.admin-shell-v3.admin-theme-light .admin-sidebar-footer {
  border-top-color: #e2e8f0;
}
.admin-app.admin-shell-v3.admin-theme-light .admin-sidebar-theme-btn {
  background: #f8fafc;
  border-color: #e2e8f0;
  color: #475569;
}

/* Dark mode — main content (override App.scss light defaults) */
.admin-app.admin-theme-v2.admin-shell-v3:not(.admin-theme-light):not(.admin-full-page) .page-body-wrapper {
  background: #0b1220 !important;
}
.admin-app.admin-theme-v2.admin-shell-v3:not(.admin-theme-light):not(.admin-full-page) .main-panel {
  background: #0b1220;
}
.admin-app.admin-theme-v2.admin-shell-v3:not(.admin-theme-light):not(.admin-full-page) .admin-content {
  background: #0b1220 !important;
  color: #e2e8f0 !important;
  --admin-bg: #0b1220;
  --admin-card-bg: #1e293b;
  --admin-border: rgba(255, 255, 255, 0.08);
  --admin-text: #f1f5f9;
  --admin-text-muted: #94a3b8;
}
.admin-app.admin-theme-v2.admin-shell-v3:not(.admin-theme-light):not(.admin-full-page) .admin-content .card,
.admin-app.admin-theme-v2.admin-shell-v3:not(.admin-theme-light):not(.admin-full-page) .admin-content .admin-card,
.admin-app.admin-theme-v2.admin-shell-v3:not(.admin-theme-light):not(.admin-full-page) .admin-content .settings-card,
.admin-app.admin-theme-v2.admin-shell-v3:not(.admin-theme-light):not(.admin-full-page) .admin-content .fake-battle-card,
.admin-app.admin-theme-v2.admin-shell-v3:not(.admin-theme-light):not(.admin-full-page) .admin-content .danger-zone-card {
  background: #1e293b !important;
  border-color: rgba(255, 255, 255, 0.08) !important;
  color: #e2e8f0 !important;
}
.admin-app.admin-theme-v2.admin-shell-v3:not(.admin-theme-light):not(.admin-full-page) .admin-content .card-header,
.admin-app.admin-theme-v2.admin-shell-v3:not(.admin-theme-light):not(.admin-full-page) .admin-content .admin-card .card-header,
.admin-app.admin-theme-v2.admin-shell-v3:not(.admin-theme-light):not(.admin-full-page) .admin-content .admin-card-header {
  background: #111827 !important;
  color: #f1f5f9 !important;
  border-bottom-color: rgba(255, 255, 255, 0.08) !important;
}
.admin-app.admin-theme-v2.admin-shell-v3:not(.admin-theme-light):not(.admin-full-page) .admin-content .card-body {
  background: #1e293b !important;
  color: #cbd5e1 !important;
}
.admin-app.admin-theme-v2.admin-shell-v3:not(.admin-theme-light):not(.admin-full-page) .admin-content .form-control,
.admin-app.admin-theme-v2.admin-shell-v3:not(.admin-theme-light):not(.admin-full-page) .admin-content .form-select,
.admin-app.admin-theme-v2.admin-shell-v3:not(.admin-theme-light):not(.admin-full-page) .admin-content select.form-control {
  background: #0f172a !important;
  border-color: rgba(255, 255, 255, 0.12) !important;
  color: #f1f5f9 !important;
}
.admin-app.admin-theme-v2.admin-shell-v3:not(.admin-theme-light):not(.admin-full-page) .admin-content .table {
  color: #cbd5e1 !important;
}
.admin-app.admin-theme-v2.admin-shell-v3:not(.admin-theme-light):not(.admin-full-page) .admin-content .table thead th {
  background: #111827 !important;
  color: #94a3b8 !important;
  border-color: rgba(255, 255, 255, 0.08) !important;
}
.admin-app.admin-theme-v2.admin-shell-v3:not(.admin-theme-light):not(.admin-full-page) .admin-content .table tbody td {
  border-color: rgba(255, 255, 255, 0.06) !important;
  color: #e2e8f0 !important;
}
.admin-app.admin-theme-v2.admin-shell-v3:not(.admin-theme-light):not(.admin-full-page) .admin-content .table tbody tr:hover {
  background: rgba(255, 255, 255, 0.04) !important;
}
.admin-app.admin-theme-v2.admin-shell-v3:not(.admin-theme-light):not(.admin-full-page) .admin-content .text-muted, .admin-app.admin-theme-v2.admin-shell-v3:not(.admin-theme-light):not(.admin-full-page) .admin-content .preview-list .preview-item .preview-item-content p .content-category, .preview-list .preview-item .preview-item-content p .admin-app.admin-theme-v2.admin-shell-v3:not(.admin-theme-light):not(.admin-full-page) .admin-content .content-category,
.admin-app.admin-theme-v2.admin-shell-v3:not(.admin-theme-light):not(.admin-full-page) .admin-content .text-secondary,
.admin-app.admin-theme-v2.admin-shell-v3:not(.admin-theme-light):not(.admin-full-page) .admin-content .list-wrapper .remove,
.list-wrapper .admin-app.admin-theme-v2.admin-shell-v3:not(.admin-theme-light):not(.admin-full-page) .admin-content .remove {
  color: #94a3b8 !important;
}
.admin-app.admin-theme-v2.admin-shell-v3:not(.admin-theme-light):not(.admin-full-page) .admin-content h1,
.admin-app.admin-theme-v2.admin-shell-v3:not(.admin-theme-light):not(.admin-full-page) .admin-content h2,
.admin-app.admin-theme-v2.admin-shell-v3:not(.admin-theme-light):not(.admin-full-page) .admin-content h3,
.admin-app.admin-theme-v2.admin-shell-v3:not(.admin-theme-light):not(.admin-full-page) .admin-content h4,
.admin-app.admin-theme-v2.admin-shell-v3:not(.admin-theme-light):not(.admin-full-page) .admin-content h5,
.admin-app.admin-theme-v2.admin-shell-v3:not(.admin-theme-light):not(.admin-full-page) .admin-content .text-dark {
  color: #f1f5f9 !important;
}
.admin-app.admin-theme-v2.admin-shell-v3:not(.admin-theme-light):not(.admin-full-page) .admin-sidebar-footer {
  border-top-color: rgba(255, 255, 255, 0.06);
}
.admin-app.admin-theme-v2.admin-shell-v3:not(.admin-theme-light):not(.admin-full-page) .admin-sidebar-theme-btn {
  background: rgba(26, 39, 68, 0.9);
  border-color: rgba(255, 255, 255, 0.08);
  color: #cbd5e1;
}
.admin-app.admin-theme-v2.admin-shell-v3:not(.admin-theme-light):not(.admin-full-page) .admin-sidebar-theme-btn:hover {
  background: rgba(79, 70, 229, 0.2);
  border-color: rgba(129, 140, 248, 0.35);
  color: #e0e7ff;
}

/* Content padding — single top offset from fixed header (page-body-wrapper only) */
.admin-app.admin-shell-v3.admin-theme-v2:not(.admin-full-page) .admin-content {
  padding-top: 0.5rem !important;
  padding-left: 0.75rem !important;
  padding-right: 0.75rem !important;
  padding-bottom: calc(1.25rem + env(safe-area-inset-bottom, 0px)) !important;
}

@media (min-width: 768px) {
  .admin-app.admin-shell-v3.admin-theme-v2:not(.admin-full-page) .admin-content {
    padding-top: 0.65rem !important;
    padding-left: 1rem !important;
    padding-right: 1rem !important;
    padding-bottom: calc(1.5rem + env(safe-area-inset-bottom, 0px)) !important;
  }
}
.admin-shell-v3 .admin-layout-footer {
  margin-top: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/App.scss","webpack://./node_modules/compass-mixins/lib/animation/_core.scss","webpack://./node_modules/compass-mixins/lib/animation/animate/_attention-seekers.scss","webpack://./node_modules/compass-mixins/lib/compass/css3/_shared.scss","webpack://./node_modules/compass-mixins/lib/compass/css3/_transform.scss","webpack://./node_modules/compass-mixins/lib/animation/animate/bouncing/_bouncing-exits.scss","webpack://./node_modules/compass-mixins/lib/animation/animate/bouncing/_bouncing-entrances.scss","webpack://./node_modules/compass-mixins/lib/animation/animate/fading/_fading-exits.scss","webpack://./node_modules/compass-mixins/lib/animation/animate/fading/_fading-entrances.scss","webpack://./node_modules/compass-mixins/lib/animation/animate/_flippers.scss","webpack://./node_modules/compass-mixins/lib/compass/css3/_opacity.scss","webpack://./node_modules/compass-mixins/lib/animation/animate/_lightspeed.scss","webpack://./node_modules/compass-mixins/lib/animation/animate/rotating/_rotating-exits.scss","webpack://./node_modules/compass-mixins/lib/animation/animate/rotating/_rotating-entrances.scss","webpack://./node_modules/compass-mixins/lib/animation/animate/_specials.scss","webpack://./node_modules/bootstrap/scss/bootstrap.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./node_modules/bootstrap/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./src/assets/styles/_variables.scss","webpack://./node_modules/bootstrap/scss/mixins/_hover.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/_code.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid-framework.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-row.scss","webpack://./node_modules/bootstrap/scss/_forms.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/mixins/_caret.scss","webpack://./node_modules/bootstrap/scss/mixins/_nav-divider.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_input-group.scss","webpack://./node_modules/bootstrap/scss/_custom-forms.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/bootstrap/scss/mixins/_badge.scss","webpack://./node_modules/bootstrap/scss/_jumbotron.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./node_modules/bootstrap/scss/mixins/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_media.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_toasts.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./node_modules/bootstrap/scss/utilities/_align.scss","webpack://./node_modules/bootstrap/scss/mixins/_background-variant.scss","webpack://./node_modules/bootstrap/scss/utilities/_background.scss","webpack://./node_modules/bootstrap/scss/utilities/_borders.scss","webpack://./node_modules/bootstrap/scss/utilities/_display.scss","webpack://./node_modules/bootstrap/scss/utilities/_embed.scss","webpack://./node_modules/bootstrap/scss/utilities/_flex.scss","webpack://./node_modules/bootstrap/scss/utilities/_float.scss","webpack://./node_modules/bootstrap/scss/utilities/_interactions.scss","webpack://./node_modules/bootstrap/scss/utilities/_overflow.scss","webpack://./node_modules/bootstrap/scss/utilities/_position.scss","webpack://./node_modules/bootstrap/scss/utilities/_screenreaders.scss","webpack://./node_modules/bootstrap/scss/mixins/_screen-reader.scss","webpack://./node_modules/bootstrap/scss/utilities/_shadows.scss","webpack://./node_modules/bootstrap/scss/utilities/_sizing.scss","webpack://./node_modules/bootstrap/scss/utilities/_spacing.scss","webpack://./node_modules/bootstrap/scss/utilities/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/utilities/_text.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-emphasis.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-hide.scss","webpack://./node_modules/bootstrap/scss/utilities/_visibility.scss","webpack://./node_modules/bootstrap/scss/_print.scss","webpack://./node_modules/@mdi/font/scss/materialdesignicons.scss","webpack://./node_modules/@mdi/font/scss/_path.scss","webpack://./node_modules/@mdi/font/scss/_core.scss","webpack://./node_modules/@mdi/font/scss/_icons.scss","webpack://./node_modules/@mdi/font/scss/_extras.scss","webpack://./node_modules/@mdi/font/scss/_animated.scss","webpack://./src/assets/styles/mixins/_animation.scss","webpack://./src/assets/styles/mixins/_misc.scss","webpack://./src/assets/styles/_typography.scss","webpack://./src/assets/styles/mixins/_blockqoute.scss","webpack://./src/assets/styles/_reset.scss","webpack://./src/assets/styles/_responsive.scss","webpack://./src/assets/styles/_misc.scss","webpack://./node_modules/compass-mixins/lib/compass/css3/_flexbox.scss","webpack://./src/assets/styles/_utilities.scss","webpack://./src/assets/styles/_demo.scss","webpack://./src/assets/styles/_spinner.scss","webpack://./src/assets/styles/_dashboard.scss","webpack://./src/assets/styles/components/_checkbox-radio.scss","webpack://./src/assets/styles/components/_forms.scss","webpack://./src/assets/styles/components/_icons.scss","webpack://./src/assets/styles/components/_tables.scss","webpack://./src/assets/styles/components/_buttons.scss","webpack://./src/assets/styles/mixins/_buttons.scss","webpack://./src/assets/styles/components/_breadcrumbs.scss","webpack://./src/assets/styles/mixins/_color-functions.scss","webpack://./src/assets/styles/components/_badges.scss","webpack://./src/assets/styles/mixins/_badges.scss","webpack://./src/assets/styles/components/_cards.scss","webpack://./src/assets/styles/mixins/_cards.scss","webpack://./src/assets/styles/components/_preview.scss","webpack://./src/assets/styles/components/_lists.scss","webpack://./src/assets/styles/components/_todo-list.scss","webpack://./src/assets/styles/components/_dropdowns.scss","webpack://./src/assets/styles/components/loaders/_loaders.scss","webpack://./src/assets/styles/components/loaders/_colored-balls.scss","webpack://./src/assets/styles/components/loaders/_glowing-ball.scss","webpack://./src/assets/styles/components/loaders/_pixel-loader.scss","webpack://./src/assets/styles/components/loaders/_square-box.scss","webpack://./src/assets/styles/components/loaders/_variables.scss","webpack://./src/assets/styles/components/loaders/_circle-loader.scss","webpack://./src/assets/styles/components/loaders/_jumping-dots-loader.scss","webpack://./src/assets/styles/components/loaders/_bar-loader.scss","webpack://./src/assets/styles/components/loaders/_square-path-loader.scss","webpack://./src/assets/styles/components/loaders/_dot-opacity-loader.scss","webpack://./src/assets/styles/components/loaders/_flip-square-loader.scss","webpack://./src/assets/styles/components/loaders/_moving-square-loader.scss","webpack://./src/assets/styles/components/landing-screens/_auth.scss","webpack://./src/assets/styles/components/plugin-overrides/_slick-carousel.scss","webpack://./src/assets/styles/components/plugin-overrides/_jquery-jvectormap.scss","webpack://./src/assets/styles/_navbar.scss","webpack://./src/assets/styles/_sidebar.scss","webpack://./node_modules/compass-mixins/lib/compass/css3/_transition.scss","webpack://./src/assets/styles/_footer.scss","webpack://./src/assets/styles/_layout.scss","webpack://./src/assets/styles/admin-mobile-v2.scss","webpack://./src/assets/styles/admin-theme-light.scss","webpack://./src/assets/styles/admin-kyc-pages.scss","webpack://./src/assets/styles/admin-slim-ui.scss","webpack://./src/assets/styles/admin-mobile-readability.scss","webpack://./src/assets/styles/admin-shell-v3.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACwEV;ECtEJ;IACE,UAAA;EFwEF;EEvEA;IACE,UAAA;EFyEF;EExEA;IACE,UAAA;EF0EF;EEzEA;IACE,UAAA;EF2EF;EE1EA;IACE,UAAA;EF4EF;AACF;AChBM;ECxDJ;ICG+D,wBCqZvD;EJ5HR;EE1RA;ICC+D,wBCqZvD;EJrHR;EE/RA;ICD+D,4BCqZvD;EJ9GR;EEpSA;ICH+D,wBCqZvD;EJvGR;EEzSA;ICL+D,4BCqZvD;EJhGR;EE9SA;ICP+D,wBCqZvD;EJzFR;EEnTA;ICT+D,wBCqZvD;EJlFR;AACF;AC/QM;ECtCJ;ICf+D,wBCuYvD;EJiQR;EEvnBA;ICjB+D,4BCuYvD;EJwQR;EE5nBA;ICnB+D,2BCuYvD;EJ+QR;EEjoBA;ICrB+D,4BCuYvD;EJsRR;EEtoBA;ICvB+D,2BCuYvD;EJ6RR;EE3oBA;ICzB+D,4BCuYvD;EJoSR;EEhpBA;IC3B+D,2BCuYvD;EJ2SR;EErpBA;IC7B+D,4BCuYvD;EJkTR;EE1pBA;IC/B+D,2BCuYvD;EJyTR;EE/pBA;ICjC+D,4BCuYvD;EJgUR;EEpqBA;ICnC+D,wBCuYvD;EJuUR;AACF;AC1pBM;ECZJ;ICzC+D,sBCkOvD;EJizBR;EEx+BA;IC3C+D,mCD4C1C;EF8+BrB;EE7+BA;IC7C+D,mCD8C1C;EFm/BrB;EEl/BA;IC/C+D,kCDgD1C;EFw/BrB;EEv/BA;ICjD+D,mCDkD1C;EF6/BrB;EE5/BA;ICnD+D,kCDoD1C;EFkgCrB;EEjgCA;ICrD+D,mCDsD1C;EFugCrB;EEtgCA;ICvD+D,kCDwD1C;EF4gCrB;EE3gCA;ICzD+D,mCD0D1C;EFihCrB;EEhhCA;IC3D+D,kCD4D1C;EFshCrB;EErhCA;IC7D+D,6BD8D1C;EF2hCrB;AACF;ACriCM;ECcJ;ICnE+D,gCCgHpC;EJkqC3B;EE7sCA;ICrE+D,wBC6SvD;EJ4+BR;EEltCA;ICvE+D,yBC6SvD;EJm/BR;EEvtCA;ICzE+D,uBC6SvD;EJ0/BR;EE5tCA;IC3E+D,wBC6SvD;EJigCR;EEjuCA;IC7E+D,uBC6SvD;EJwgCR;AACF;ACjwCM;EC8BJ;ICnF+D,yBCuYvD;EJmoCR;EEr7CA;ICrF+D,yCDsF1C;EF27CrB;EE17CA;ICvF+D,uCDwF1C;EFg8CrB;EE/7CA;ICzF+D,yCD0F1C;EFq8CrB;EEp8CA;IC3F+D,uCD4F1C;EF08CrB;EEz8CA;IC7F+D,wCD8F1C;EF+8CrB;EE98CA;IC/F+D,yBDgG1C;EFo9CrB;AACF;AChgDM;ECgDJ;ICrG+D,sBCkOvD;EJu7CR;EEljDA;ICvG+D,0BCkOvD;EJ87CR;EEvjDA;ICzG+D,sBCkOvD;EJq8CR;AACF;ACnnDM;EC0DJ;IC/G+D,sBCmdvD;EJyhDR;EE33DA;ICjH+D,uBCmdvD;EJgiDR;EEh4DA;ICnH+D,sBCmdvD;EJuiDR;EEr4DA;ICrH+D,uBCmdvD;EJ8iDR;EE14DA;ICvH+D,sBCmdvD;EJqjDR;EE/4DA;ICzH+D,uBCmdvD;EJ4jDR;EEp5DA;IC3H+D,sBCmdvD;EJmkDR;EEz5DA;IC7H+D,uBCmdvD;EJ0kDR;EE95DA;IC/H+D,sBCmdvD;EJilDR;EEn6DA;ICjI+D,sBCmdvD;EJwlDR;EEx6DA;ICnI+D,sBCmdvD;EJ+lDR;AACF;AC9/DM;EItEJ;IFiB+D,sBCkOvD;EJy9DR;EK1sEA;IFe+D,4BCkOvD;EJg+DR;EK/sEA;IACE,UAAA;IFY6D,0BCkOvD;EJw+DR;EKptEA;IACE,UAAA;IFS6D,0BCkOvD;EJg/DR;AACF;AC9pEM;EIxDJ;IFG+D,wBCqZvD;EJ06DR;EKh0EA;IACE,UAAA;IFA6D,2BCqZvD;EJk7DR;EKr0EA;IACE,UAAA;IFH6D,8BCqZvD;EJ07DR;AACF;AC3xEM;EI5CJ;IFT+D,wBCqZvD;EJuiER;EKj7EA;IACE,UAAA;IFZ6D,4BCqZvD;EJ+iER;EKt7EA;IACE,UAAA;IFf6D,6BCqZvD;EJujER;AACF;ACx5EM;EIhCJ;IFrB+D,wBCuYvD;EJkrER;EKliFA;IACE,UAAA;IFxB6D,2BCuYvD;EJ0rER;EKviFA;IACE,UAAA;IF3B6D,8BCuYvD;EJksER;AACF;ACrhFM;EIpBJ;IFjC+D,wBCuYvD;EJ+yER;EKnpFA;IACE,UAAA;IFpC6D,4BCuYvD;EJuzER;EKxpFA;IACE,UAAA;IFvC6D,6BCuYvD;EJ+zER;AACF;AClpFM;EKtEJ;IACE,UAAA;IHgB6D,0BCkOvD;EJ8mFR;EM91FA;IACE,UAAA;IHa6D,4BCkOvD;EJsnFR;EMn2FA;IHW+D,0BCkOvD;EJ6nFR;EMx2FA;IHS+D,sBCkOvD;EJooFR;AACF;AClzFM;EKxDJ;IACE,UAAA;IHE6D,8BCqZvD;EJ2lFR;EMh/FA;IACE,UAAA;IHD6D,2BCqZvD;EJmmFR;EMr/FA;IHH+D,4BCqZvD;EJ0mFR;EM1/FA;IHL+D,wBCqZvD;EJinFR;AACF;ACl9FM;EK1CJ;IACE,UAAA;IHZ6D,6BCqZvD;EJ2vFR;EMloGA;IACE,UAAA;IHf6D,4BCqZvD;EJmwFR;EMvoGA;IHjB+D,2BCqZvD;EJ0wFR;EM5oGA;IHnB+D,wBCqZvD;EJixFR;AACF;AClnGM;EK5BJ;IACE,UAAA;IH1B6D,6BCuYvD;EJy6FR;EMpxGA;IACE,UAAA;IH7B6D,4BCuYvD;EJi7FR;EMzxGA;IH/B+D,2BCuYvD;EJw7FR;EM9xGA;IHjC+D,wBCuYvD;EJ+7FR;AACF;AClxGM;EKdJ;IACE,UAAA;IHxC6D,8BCuYvD;EJykGR;EMt6GA;IACE,UAAA;IH3C6D,2BCuYvD;EJilGR;EM36GA;IH7C+D,4BCuYvD;EJwlGR;EMh7GA;IH/C+D,wBCuYvD;EJ+lGR;AACF;ACl7GM;EMtEJ;IACE,UAAA;EP2hHF;EO1hHA;IACE,UAAA;EP4hHF;AACF;AC19GM;EM9DJ;IJS+D,wBCqZvD;IG5ZN,UAAA;EPumHF;EOtmHA;IJM+D,4BCqZvD;IGzZN,UAAA;EP4mHF;AACF;ACpjHM;EMpDJ;IJD+D,wBCqZvD;IGlZN,UAAA;EPurHF;EOtrHA;IJJ+D,2BCqZvD;IG/YN,UAAA;EP4rHF;AACF;AC9oHM;EM1CJ;IJX+D,wBCuYvD;IG1XN,UAAA;EPuwHF;EOtwHA;IJd+D,2BCuYvD;IGvXN,UAAA;EP4wHF;AACF;ACxuHM;EMhCJ;IJrB+D,wBCuYvD;IGhXN,UAAA;EPu1HF;EOt1HA;IJxB+D,4BCuYvD;IG7WN,UAAA;EP41HF;AACF;ACl0HM;EMtBJ;IJ/B+D,wBCqZvD;IGpXN,UAAA;EPu6HF;EOt6HA;IJlC+D,8BCqZvD;IGjXN,UAAA;EP46HF;AACF;AC55HM;EMZJ;IACE,UAAA;IJ1C6D,wBCqZvD;EJ6oHR;EOt/HA;IACE,UAAA;IJ7C6D,6BCqZvD;EJqpHR;AACF;ACt/HM;EMFJ;IACE,UAAA;IJpD6D,wBCuYvD;EJqvHR;EOtkIA;IACE,UAAA;IJvD6D,6BCuYvD;EJ6vHR;AACF;AChlIM;EMQJ;IACE,UAAA;IJ9D6D,wBCuYvD;EJ+0HR;EOtpIA;IACE,UAAA;IJjE6D,8BCuYvD;EJu1HR;AACF;AC1qIM;EOtEJ;IACE,UAAA;ERmxIF;EQlxIA;IACE,UAAA;ERoxIF;AACF;ACltIM;EO9DJ;ILS+D,2BCqZvD;II5ZN,UAAA;ER+1IF;EQ91IA;ILM+D,wBCqZvD;IIzZN,UAAA;ERo2IF;AACF;AC5yIM;EOpDJ;ILD+D,4BCqZvD;IIlZN,UAAA;ER+6IF;EQ96IA;ILJ+D,wBCqZvD;II/YN,UAAA;ERo7IF;AACF;ACt4IM;EO1CJ;ILX+D,2BCuYvD;II1XN,UAAA;ER+/IF;EQ9/IA;ILd+D,wBCuYvD;IIvXN,UAAA;ERogJF;AACF;ACh+IM;EOhCJ;ILrB+D,4BCuYvD;IIhXN,UAAA;ER+kJF;EQ9kJA;ILxB+D,wBCuYvD;II7WN,UAAA;ERolJF;AACF;AC1jJM;EOtBJ;IL/B+D,6BCqZvD;IIpXN,UAAA;ER+pJF;EQ9pJA;ILlC+D,wBCqZvD;IIjXN,UAAA;ERoqJF;AACF;ACppJM;EOZJ;IACE,UAAA;IL1C6D,8BCqZvD;EJq4IR;EQ9uJA;IACE,UAAA;IL7C6D,wBCqZvD;EJ64IR;AACF;AC9uJM;EOFJ;IACE,UAAA;ILpD6D,6BCuYvD;EJ6+IR;EQ9zJA;IACE,UAAA;ILvD6D,wBCuYvD;EJq/IR;AACF;ACx0JM;EOQJ;IACE,UAAA;IL9D6D,8BCuYvD;EJukJR;EQ94JA;IACE,UAAA;ILjE6D,wBCuYvD;EJ+kJR;AACF;ACl6JM;EQtEJ;INiB+D,wCMhB1C;INgB0C,mCF2EpD;EDipKX;ESzuKA;INa+D,+DMZ1C;INY0C,mCF2EpD;ED6pKX;ESjvKA;INS+D,wEMR1C;INQ0C,kCF2EpD;EDyqKX;ESzvKA;INK+D,yDMJ1C;INI0C,kCF2EpD;EDqrKX;ESjwKA;INC+D,sCAAA;IAAA,kCF2EpD;EDisKX;AACF;ACxtKM;EQ7CJ;INR+D,4CMS1C;ICnBnB,0DAAA;IAEF,UDkBmB;ETq5KnB;ESn5KA;INZ+D,6CMa1C;ETy5KrB;ESv5KA;INf+D,4CMgB1C;ET65KrB;ES35KA;INlB+D,2CMmB1C;IC7BnB,4DAAA;IAEF,UD4BmB;ETk6KnB;AACF;ACl4KM;EQ1BJ;IN3B+D,2CM4B1C;ICtCnB,4DAAA;IAEF,UDqCmB;ETo/KnB;ESl/KA;IN/B+D,4CMgC1C;IC1CnB,0DAAA;IAEF,UDyCmB;ETy/KnB;AACF;ACt+KM;EQbJ;INxC+D,4CMyC1C;ICnDnB,0DAAA;IAEF,UDkDmB;ETmoLnB;ESjoLA;IN5C+D,6CM6C1C;ETuoLrB;ESroLA;IN/C+D,4CMgD1C;ET2oLrB;ESzoLA;INlD+D,2CMmD1C;IC7DnB,4DAAA;IAEF,UD4DmB;ETgpLnB;AACF;AChpLM;EQMJ;IN3D+D,2CM4D1C;ICtEnB,4DAAA;IAEF,UDqEmB;ETkuLnB;EShuLA;IN/D+D,4CMgE1C;IC1EnB,0DAAA;IAEF,UDyEmB;ETuuLnB;AACF;ACpvLM;EUtEJ;IRiB+D,yCQhB1C;IDMnB,0DAAA;IAEF,UCPmB;EX09LnB;EWz9LA;IRc+D,wCQb1C;IDGnB,4DAAA;IAEF,UCJmB;EXg+LnB;EW/9LA;IRW+D,uCQV1C;IDAnB,4DAAA;IAEF,UCDmB;EXs+LnB;EWr+LA;IRQ+D,qCQP1C;IDHnB,4DAAA;IAEF,UCEmB;EX4+LnB;AACF;ACl7LM;EUtDJ;IRC+D,qCAAA;IOV7D,4DAAA;IAEF,UCSmB;EXgkMnB;EW/jMA;IRF+D,yCQG1C;IDbnB,0DAAA;IAEF,UCYmB;EXskMnB;AACF;ACthMM;EWtEJ;ITiB+D,mCCgHpC;IDhHoC,oBC6SvD;IQ3TN,UAAA;EZutMF;EYttMA;ITa+D,mCCgHpC;IDhHoC,yBC6SvD;IQvTN,UAAA;EZguMF;AACF;AClqMM;EW1DJ;ITK+D,iCCgHpC;IDhHoC,oBC6SvD;IQ/SN,UAAA;EZu1MF;EYt1MA;ITC+D,iCCgHpC;IDhHoC,wBC6SvD;IQ3SN,UAAA;EZg2MF;AACF;AC9yMM;EW9CJ;ITP+D,iCCgHpC;IDhHoC,oBC6SvD;IQnSN,UAAA;EZu9MF;EYt9MA;ITX+D,iCCgHpC;IDhHoC,yBC6SvD;IQ/RN,UAAA;EZg+MF;AACF;AC17MM;EWlCJ;ITnB+D,kCCgHpC;IDhHoC,oBC6SvD;IQvRN,UAAA;EZulNF;EYtlNA;ITvB+D,kCCgHpC;IDhHoC,yBC6SvD;IQnRN,UAAA;EZgmNF;AACF;ACtkNM;EWtBJ;IT/B+D,kCCgHpC;IDhHoC,oBC6SvD;IQ3QN,UAAA;EZutNF;EYttNA;ITnC+D,kCCgHpC;IDhHoC,wBC6SvD;IQvQN,UAAA;EZguNF;AACF;ACltNM;EYtEJ;IViB+D,mCCgHpC;IDhHoC,0BC6SvD;IS3TN,UAAA;Ebm5NF;Eal5NA;IVa+D,mCCgHpC;IDhHoC,oBC6SvD;ISvTN,UAAA;Eb45NF;AACF;AC91NM;EY1DJ;IVK+D,iCCgHpC;IDhHoC,yBC6SvD;IS/SN,UAAA;EbmhOF;EalhOA;IVC+D,iCCgHpC;IDhHoC,oBC6SvD;IS3SN,UAAA;Eb4hOF;AACF;AC1+NM;EY9CJ;IVP+D,iCCgHpC;IDhHoC,wBC6SvD;ISnSN,UAAA;EbmpOF;EalpOA;IVX+D,iCCgHpC;IDhHoC,oBC6SvD;IS/RN,UAAA;Eb4pOF;AACF;ACtnOM;EYlCJ;IVnB+D,kCCgHpC;IDhHoC,yBC6SvD;ISvRN,UAAA;EbmxOF;EalxOA;IVvB+D,kCCgHpC;IDhHoC,oBC6SvD;ISnRN,UAAA;Eb4xOF;AACF;AClwOM;EYtBJ;IV/B+D,kCCgHpC;IDhHoC,wBC6SvD;IS3QN,UAAA;Ebm5OF;Eal5OA;IVnC+D,kCCgHpC;IDhHoC,oBC6SvD;ISvQN,UAAA;Eb45OF;AACF;AC94OM;EatEJ;IXiB+D,oBC6SvD;ID7SuD,8BCgHpC;IDhHoC,sCF2EpD;ED8sPX;EctyPA;IXa+D,wBC6SvD;ID7SuD,8BCgHpC;IDhHoC,sCF2EpD;ED+tPX;EcnzPA;IXS+D,wBC6SvD;ID7SuD,8BCgHpC;IDhHoC,sCF2EpD;EDgvPX;Ech0PA;IXK+D,sCWJ1C;IJNnB,4DAAA;IAEF,UIKmB;IXG4C,8BCgHpC;IDhHoC,sCF2EpD;EDmwPX;Ec90PA;IXA+D,4BCqZvD;IM/ZN,0DAAA;IAEF,UIUmB;Edq1PnB;AACF;ACnyPM;Ea9CJ;IJjBE,0DAAA;IAEF,UIgBmB;IXR4C,4CWS1C;Edy6PrB;Ecx6PA;IJpBE,4DAAA;IAEF,UImBmB;IXX4C,uCWY1C;Ed+6PrB;AACF;ACv4PM;EapCJ;IJ3BE,4DAAA;IAEF,UI0BmB;IXlB4C,uCWmB1C;EdmgQrB;EclgQA;IJ9BE,0DAAA;IAEF,UI6BmB;IXrB4C,4CWsB1C;EdygQrB;AACF;AenjQA;;;;;EAAA;ACAA;EAGI,eAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,eAAA;EAAA,cAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,gBAAA;EAAA,eAAA;EAAA,eAAA;EAAA,gBAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,eAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,eAAA;EAAA,cAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,gBAAA;EAAA,eAAA;EAAA,eAAA;EAAA,gBAAA;EAAA,eAAA;EAAA,qBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,gBAAA;EAIA,kBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,eAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,gBAAA;EAAA,eAAA;EAIA,kBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,uBAAA;EAKF,kOAAA;EACA,6GAAA;AhBslQF;;AiBrlQA;;;EAGE,sBAAA;AjBwlQF;;AiBrlQA;EACE,uBAAA;EACA,iBAAA;EACA,8BAAA;EACA,6CAAA;AjBwlQF;;AiBllQA;EACE,cAAA;AjBqlQF;;AiB3kQA;EACE,SAAA;EACA,qNCsO4B;ECjGxB,eAAA;EFnIJ,gBC+O4B;ED9O5B,gBCmP4B;EDlP5B,cGlCkB;EHmClB,gBAAA;EACA,sBC9CS;AlB4nQX;;AiBlkQA;EACE,qBAAA;AjBqkQF;;AiB5jQA;EACE,uBAAA;EACA,SAAA;EACA,iBAAA;AjB+jQF;;AiBljQA;EACE,aAAA;EACA,qBCiN4B;AlBo2P9B;;AiB9iQA;EACE,aAAA;EACA,mBCoF0B;AlB69P5B;;AiBtiQA;;EAEE,0BAAA;EACA,yCAAA;UAAA,iCAAA;EACA,YAAA;EACA,gBAAA;EACA,8BAAA;AjByiQF;;AiBtiQA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;AjByiQF;;AiBtiQA;;;EAGE,aAAA;EACA,mBAAA;AjByiQF;;AiBtiQA;;;;EAIE,gBAAA;AjByiQF;;AiBtiQA;EACE,gBCkJ4B;AlBu5P9B;;AiBtiQA;EACE,qBAAA;EACA,cAAA;AjByiQF;;AiBtiQA;EACE,gBAAA;AjByiQF;;AiBtiQA;;EAEE,mBCqI4B;AlBo6P9B;;AiBtiQA;EEII,cAAA;AnBsiQJ;;AiBjiQA;;EAEE,kBAAA;EEPE,cAAA;EFSF,cAAA;EACA,wBAAA;AjBoiQF;;AiBjiQA;EAAM,eAAA;AjBqiQN;;AiBpiQA;EAAM,WAAA;AjBwiQN;;AiBjiQA;EACE,cCXwC;EDYxC,qBCXwC;EDYxC,6BAAA;AjBoiQF;AqBptQE;EJmLE,cCdsC;EDetC,0BCdsC;AlBkjQ1C;;AiB3hQA;EACE,cAAA;EACA,qBAAA;AjB8hQF;AqB7tQE;EJkME,cAAA;EACA,qBAAA;AjB8hQJ;;AiBrhQA;;;;EAIE,iGC0D4B;EClH1B,cAAA;AnBilQJ;;AiBrhQA;EAEE,aAAA;EAEA,mBAAA;EAEA,cAAA;EAGA,6BAAA;AjBmhQF;;AiB3gQA;EAEE,gBAAA;AjB6gQF;;AiBrgQA;EACE,sBAAA;EACA,kBAAA;AjBwgQF;;AiBrgQA;EAGE,gBAAA;EACA,sBAAA;AjBsgQF;;AiB9/PA;EACE,yBAAA;AjBigQF;;AiB9/PA;EACE,sBGXmB;EHYnB,yBGZmB;EHanB,cCtQS;EDuQT,gBAAA;EACA,oBAAA;AjBigQF;;AiB1/PA;EAEE,mBAAA;EACA,gCAAA;AjB4/PF;;AiBp/PA;EAEE,qBAAA;EACA,qBC4JsC;AlB01PxC;;AiBh/PA;EAEE,gBAAA;AjBk/PF;;AiB1+PA;EACE,UAAA;AjB6+PF;;AiB1+PA;;;;;EAKE,SAAA;EACA,oBAAA;EEhKE,kBAAA;EFkKF,oBAAA;AjB6+PF;;AiB1+PA;;EAEE,iBAAA;AjB6+PF;;AiB1+PA;;EAEE,oBAAA;AjB6+PF;;AiBv+PA;EACE,eAAA;AjB0+PF;;AiBp+PA;EACE,iBAAA;AjBu+PF;;AiBh+PA;;;;EAIE,0BAAA;AjBm+PF;;AiB19PI;;;;EACE,eAAA;AjBg+PN;;AiB19PA;;;;EAIE,UAAA;EACA,kBAAA;AjB69PF;;AiB19PA;;EAEE,sBAAA;EACA,UAAA;AjB69PF;;AiBz9PA;EACE,cAAA;EAEA,gBAAA;AjB29PF;;AiBx9PA;EAME,YAAA;EAEA,UAAA;EACA,SAAA;EACA,SAAA;AjBq9PF;;AiBh9PA;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;EACA,qBAAA;EE9OI,iBAAA;EFgPJ,oBAAA;EACA,cAAA;EACA,mBAAA;AjBm9PF;;AiBh9PA;EACE,wBAAA;AjBm9PF;;AiB/8PA;;EAEE,YAAA;AjBk9PF;;AiB/8PA;EAKE,oBAAA;EACA,wBAAA;AjB88PF;;AiBv8PA;EACE,wBAAA;AjB08PF;;AiBl8PA;EACE,aAAA;EACA,0BAAA;AjBq8PF;;AiB97PA;EACE,qBAAA;AjBi8PF;;AiB97PA;EACE,kBAAA;EACA,eAAA;AjBi8PF;;AiB97PA;EACE,aAAA;AjBi8PF;;AiB57PA;EACE,wBAAA;AjB+7PF;;AsB35QA;;EAEE,qBJsS4B;EIpS5B,gBJsS4B;EIrS5B,gBJsS4B;AlBunQ9B;;AsBz5QA;EHqKM,iBAAA;AnBwvQN;;AsB55QA;EHoKM,eAAA;AnB4vQN;;AsB/5QA;EHmKM,kBAAA;AnBgwQN;;AsBl6QA;EHkKM,iBAAA;AnBowQN;;AsBr6QA;EHiKM,kBAAA;AnBwwQN;;AsBx6QA;EHgKM,eAAA;AnB4wQN;;AsB16QA;EH8JM,kBAAA;EG5JJ,gBJwS4B;AlBqoQ9B;;AsBz6QA;EHwJM,eAAA;EGtJJ,gBJ2R4B;EI1R5B,gBJkR4B;AlB0pQ9B;;AsB16QA;EHmJM,iBAAA;EGjJJ,gBJuR4B;EItR5B,gBJ6Q4B;AlBgqQ9B;;AsB36QA;EH8IM,iBAAA;EG5IJ,gBJmR4B;EIlR5B,gBJwQ4B;AlBsqQ9B;;AsB56QA;EHyIM,iBAAA;EGvIJ,gBJ+Q4B;EI9Q5B,gBJmQ4B;AlB4qQ9B;;AsBv6QA;EACE,gBJgFO;EI/EP,mBJ+EO;EI9EP,SAAA;EACA,wCAAA;AtB06QF;;AsBl6QA;;EHkGI,kBAAA;EG/FF,gBJ2N4B;AlB0sQ9B;;AsBl6QA;;EAEE,cJmQ4B;EIlQ5B,yBJ2Q4B;AlB0pQ9B;;AsB75QA;EC/EE,eAAA;EACA,gBAAA;AvBg/QF;;AsB75QA;ECpFE,eAAA;EACA,gBAAA;AvBq/QF;;AsB/5QA;EACE,qBAAA;AtBk6QF;AsBh6QE;EACE,oBJqP0B;AlB6qQ9B;;AsBx5QA;EH2DI,cAAA;EGzDF,yBAAA;AtB25QF;;AsBv5QA;EACE,mBJuBO;EC6CH,kBAAA;AnBu1QN;;AsBv5QA;EACE,cAAA;EH+CE,kBAAA;EG7CF,cJ1GS;AlBogRX;AsBx5QE;EACE,aAAA;AtB05QJ;;AwB7gRA;ECIE,eAAA;EAGA,YAAA;AzB2gRF;;AwB5gRA;EACE,gBNqgCkC;EMpgClC,sBNRS;EMST,yBAAA;EEEE,sBAAA;EDPF,eAAA;EAGA,YAAA;AzBohRF;;AwBtgRA;EAEE,qBAAA;AxBwgRF;;AwBrgRA;EACE,qBAAA;EACA,cAAA;AxBwgRF;;AwBrgRA;EL8HI,cAAA;EK5HF,cN3BS;AlBmiRX;;A2B/iRA;ERmKI,gBAAA;EQjKF,cTmCQ;ESlCR,qBAAA;A3BkjRF;A2B/iRE;EACE,cAAA;A3BijRJ;;A2B5iRA;EACE,sBAAA;ERsJE,gBAAA;EQpJF,WTTS;ESUT,yBTDS;EQEP,qBAAA;A1B+iRJ;A2B5iRE;EACE,UAAA;ER8IA,eAAA;EQ5IA,gBTyQ0B;AlBqyQ9B;;A2BxiRA;EACE,cAAA;ERqIE,gBAAA;EQnIF,cTjBS;AlB4jRX;A2BxiRE;ERgIE,kBAAA;EQ9HA,cAAA;EACA,kBAAA;A3B0iRJ;;A2BriRA;EACE,iBTikCkC;EShkClC,kBAAA;A3BwiRF;;A4BhlRE;;;;;;ECDA,WAAA;EACA,sBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;A7B0lRF;;A8BviRI;EFzCE;IACE,gBV8Le;ElBs5QrB;AACF;A8B7iRI;EFzCE;IACE,gBV8Le;ElB25QrB;AACF;A8BljRI;EFzCE;IACE,gBV8Le;ElBg6QrB;AACF;A8BvjRI;EFzCE;IACE,iBV8Le;ElBq6QrB;AACF;A4BxkRE;ECnCA,aAAA;EACA,eAAA;EACA,sBAAA;EACA,qBAAA;A7B8mRF;;A4BxkRE;EACE,eAAA;EACA,cAAA;A5B2kRJ;A4BzkRI;;EAEE,gBAAA;EACA,eAAA;A5B2kRN;;A+BjoRE;;;;;;EACE,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,qBAAA;A/ByoRJ;;A+BnnRM;EACE,aAAA;EACA,YAAA;EACA,eAAA;A/BsnRR;;A6B1lRE;EACE,cAAA;EACA,eAAA;A7B6lRJ;;A6B/lRE;EACE,aAAA;EACA,cAAA;A7BkmRJ;;A6BpmRE;EACE,wBAAA;EACA,yBAAA;A7BumRJ;;A6BzmRE;EACE,aAAA;EACA,cAAA;A7B4mRJ;;A6B9mRE;EACE,aAAA;EACA,cAAA;A7BinRJ;;A6BnnRE;EACE,wBAAA;EACA,yBAAA;A7BsnRJ;;A+BzoRM;EFCJ,cAAA;EACA,WAAA;EACA,eAAA;A7B4oRF;;A+BzoRU;EFbR,qBAAA;EAIA,sBAAA;A7BupRF;;A+B9oRU;EFbR,sBAAA;EAIA,uBAAA;A7B4pRF;;A+BnpRU;EFbR,aAAA;EAIA,cAAA;A7BiqRF;;A+BxpRU;EFbR,sBAAA;EAIA,uBAAA;A7BsqRF;;A+B7pRU;EFbR,sBAAA;EAIA,uBAAA;A7B2qRF;;A+BlqRU;EFbR,aAAA;EAIA,cAAA;A7BgrRF;;A+BvqRU;EFbR,sBAAA;EAIA,uBAAA;A7BqrRF;;A+B5qRU;EFbR,sBAAA;EAIA,uBAAA;A7B0rRF;;A+BjrRU;EFbR,aAAA;EAIA,cAAA;A7B+rRF;;A+BtrRU;EFbR,sBAAA;EAIA,uBAAA;A7BosRF;;A+B3rRU;EFbR,sBAAA;EAIA,uBAAA;A7BysRF;;A+BhsRU;EFbR,cAAA;EAIA,eAAA;A7B8sRF;;A+B/rRM;EAAwB,SAAA;A/BmsR9B;;A+BjsRM;EAAuB,SAAA;A/BqsR7B;;A+BlsRQ;EAAwB,QADb;A/BusRnB;;A+BtsRQ;EAAwB,QADb;A/B2sRnB;;A+B1sRQ;EAAwB,QADb;A/B+sRnB;;A+B9sRQ;EAAwB,QADb;A/BmtRnB;;A+BltRQ;EAAwB,QADb;A/ButRnB;;A+BttRQ;EAAwB,QADb;A/B2tRnB;;A+B1tRQ;EAAwB,QADb;A/B+tRnB;;A+B9tRQ;EAAwB,QADb;A/BmuRnB;;A+BluRQ;EAAwB,QADb;A/BuuRnB;;A+BtuRQ;EAAwB,QADb;A/B2uRnB;;A+B1uRQ;EAAwB,SADb;A/B+uRnB;;A+B9uRQ;EAAwB,SADb;A/BmvRnB;;A+BlvRQ;EAAwB,SADb;A/BuvRnB;;A+B/uRY;EFhBV,wBAAA;A7BmwRF;;A+BnvRY;EFhBV,yBAAA;A7BuwRF;;A+BvvRY;EFhBV,gBAAA;A7B2wRF;;A+B3vRY;EFhBV,yBAAA;A7B+wRF;;A+B/vRY;EFhBV,yBAAA;A7BmxRF;;A+BnwRY;EFhBV,gBAAA;A7BuxRF;;A+BvwRY;EFhBV,yBAAA;A7B2xRF;;A+B3wRY;EFhBV,yBAAA;A7B+xRF;;A+B/wRY;EFhBV,gBAAA;A7BmyRF;;A+BnxRY;EFhBV,yBAAA;A7BuyRF;;A+BvxRY;EFhBV,yBAAA;A7B2yRF;;A8BtyRI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;E/Bq0RN;E6BzyRA;IACE,cAAA;IACA,eAAA;E7B2yRF;E6B7yRA;IACE,aAAA;IACA,cAAA;E7B+yRF;E6BjzRA;IACE,wBAAA;IACA,yBAAA;E7BmzRF;E6BrzRA;IACE,aAAA;IACA,cAAA;E7BuzRF;E6BzzRA;IACE,aAAA;IACA,cAAA;E7B2zRF;E6B7zRA;IACE,wBAAA;IACA,yBAAA;E7B+zRF;E+Bl1RI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;E7Bo1RA;E+Bj1RQ;IFbR,qBAAA;IAIA,sBAAA;E7B81RA;E+Br1RQ;IFbR,sBAAA;IAIA,uBAAA;E7Bk2RA;E+Bz1RQ;IFbR,aAAA;IAIA,cAAA;E7Bs2RA;E+B71RQ;IFbR,sBAAA;IAIA,uBAAA;E7B02RA;E+Bj2RQ;IFbR,sBAAA;IAIA,uBAAA;E7B82RA;E+Br2RQ;IFbR,aAAA;IAIA,cAAA;E7Bk3RA;E+Bz2RQ;IFbR,sBAAA;IAIA,uBAAA;E7Bs3RA;E+B72RQ;IFbR,sBAAA;IAIA,uBAAA;E7B03RA;E+Bj3RQ;IFbR,aAAA;IAIA,cAAA;E7B83RA;E+Br3RQ;IFbR,sBAAA;IAIA,uBAAA;E7Bk4RA;E+Bz3RQ;IFbR,sBAAA;IAIA,uBAAA;E7Bs4RA;E+B73RQ;IFbR,cAAA;IAIA,eAAA;E7B04RA;E+B33RI;IAAwB,SAAA;E/B83R5B;E+B53RI;IAAuB,SAAA;E/B+3R3B;E+B53RM;IAAwB,QADb;E/Bg4RjB;E+B/3RM;IAAwB,QADb;E/Bm4RjB;E+Bl4RM;IAAwB,QADb;E/Bs4RjB;E+Br4RM;IAAwB,QADb;E/By4RjB;E+Bx4RM;IAAwB,QADb;E/B44RjB;E+B34RM;IAAwB,QADb;E/B+4RjB;E+B94RM;IAAwB,QADb;E/Bk5RjB;E+Bj5RM;IAAwB,QADb;E/Bq5RjB;E+Bp5RM;IAAwB,QADb;E/Bw5RjB;E+Bv5RM;IAAwB,QADb;E/B25RjB;E+B15RM;IAAwB,SADb;E/B85RjB;E+B75RM;IAAwB,SADb;E/Bi6RjB;E+Bh6RM;IAAwB,SADb;E/Bo6RjB;E+B55RU;IFhBV,cAAA;E7B+6RA;E+B/5RU;IFhBV,wBAAA;E7Bk7RA;E+Bl6RU;IFhBV,yBAAA;E7Bq7RA;E+Br6RU;IFhBV,gBAAA;E7Bw7RA;E+Bx6RU;IFhBV,yBAAA;E7B27RA;E+B36RU;IFhBV,yBAAA;E7B87RA;E+B96RU;IFhBV,gBAAA;E7Bi8RA;E+Bj7RU;IFhBV,yBAAA;E7Bo8RA;E+Bp7RU;IFhBV,yBAAA;E7Bu8RA;E+Bv7RU;IFhBV,gBAAA;E7B08RA;E+B17RU;IFhBV,yBAAA;E7B68RA;E+B77RU;IFhBV,yBAAA;E7Bg9RA;AACF;A8B58RI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;E/B0+RN;E6B98RA;IACE,cAAA;IACA,eAAA;E7Bg9RF;E6Bl9RA;IACE,aAAA;IACA,cAAA;E7Bo9RF;E6Bt9RA;IACE,wBAAA;IACA,yBAAA;E7Bw9RF;E6B19RA;IACE,aAAA;IACA,cAAA;E7B49RF;E6B99RA;IACE,aAAA;IACA,cAAA;E7Bg+RF;E6Bl+RA;IACE,wBAAA;IACA,yBAAA;E7Bo+RF;E+Bv/RI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;E7By/RA;E+Bt/RQ;IFbR,qBAAA;IAIA,sBAAA;E7BmgSA;E+B1/RQ;IFbR,sBAAA;IAIA,uBAAA;E7BugSA;E+B9/RQ;IFbR,aAAA;IAIA,cAAA;E7B2gSA;E+BlgSQ;IFbR,sBAAA;IAIA,uBAAA;E7B+gSA;E+BtgSQ;IFbR,sBAAA;IAIA,uBAAA;E7BmhSA;E+B1gSQ;IFbR,aAAA;IAIA,cAAA;E7BuhSA;E+B9gSQ;IFbR,sBAAA;IAIA,uBAAA;E7B2hSA;E+BlhSQ;IFbR,sBAAA;IAIA,uBAAA;E7B+hSA;E+BthSQ;IFbR,aAAA;IAIA,cAAA;E7BmiSA;E+B1hSQ;IFbR,sBAAA;IAIA,uBAAA;E7BuiSA;E+B9hSQ;IFbR,sBAAA;IAIA,uBAAA;E7B2iSA;E+BliSQ;IFbR,cAAA;IAIA,eAAA;E7B+iSA;E+BhiSI;IAAwB,SAAA;E/BmiS5B;E+BjiSI;IAAuB,SAAA;E/BoiS3B;E+BjiSM;IAAwB,QADb;E/BqiSjB;E+BpiSM;IAAwB,QADb;E/BwiSjB;E+BviSM;IAAwB,QADb;E/B2iSjB;E+B1iSM;IAAwB,QADb;E/B8iSjB;E+B7iSM;IAAwB,QADb;E/BijSjB;E+BhjSM;IAAwB,QADb;E/BojSjB;E+BnjSM;IAAwB,QADb;E/BujSjB;E+BtjSM;IAAwB,QADb;E/B0jSjB;E+BzjSM;IAAwB,QADb;E/B6jSjB;E+B5jSM;IAAwB,QADb;E/BgkSjB;E+B/jSM;IAAwB,SADb;E/BmkSjB;E+BlkSM;IAAwB,SADb;E/BskSjB;E+BrkSM;IAAwB,SADb;E/BykSjB;E+BjkSU;IFhBV,cAAA;E7BolSA;E+BpkSU;IFhBV,wBAAA;E7BulSA;E+BvkSU;IFhBV,yBAAA;E7B0lSA;E+B1kSU;IFhBV,gBAAA;E7B6lSA;E+B7kSU;IFhBV,yBAAA;E7BgmSA;E+BhlSU;IFhBV,yBAAA;E7BmmSA;E+BnlSU;IFhBV,gBAAA;E7BsmSA;E+BtlSU;IFhBV,yBAAA;E7BymSA;E+BzlSU;IFhBV,yBAAA;E7B4mSA;E+B5lSU;IFhBV,gBAAA;E7B+mSA;E+B/lSU;IFhBV,yBAAA;E7BknSA;E+BlmSU;IFhBV,yBAAA;E7BqnSA;AACF;A8BjnSI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;E/B+oSN;E6BnnSA;IACE,cAAA;IACA,eAAA;E7BqnSF;E6BvnSA;IACE,aAAA;IACA,cAAA;E7BynSF;E6B3nSA;IACE,wBAAA;IACA,yBAAA;E7B6nSF;E6B/nSA;IACE,aAAA;IACA,cAAA;E7BioSF;E6BnoSA;IACE,aAAA;IACA,cAAA;E7BqoSF;E6BvoSA;IACE,wBAAA;IACA,yBAAA;E7ByoSF;E+B5pSI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;E7B8pSA;E+B3pSQ;IFbR,qBAAA;IAIA,sBAAA;E7BwqSA;E+B/pSQ;IFbR,sBAAA;IAIA,uBAAA;E7B4qSA;E+BnqSQ;IFbR,aAAA;IAIA,cAAA;E7BgrSA;E+BvqSQ;IFbR,sBAAA;IAIA,uBAAA;E7BorSA;E+B3qSQ;IFbR,sBAAA;IAIA,uBAAA;E7BwrSA;E+B/qSQ;IFbR,aAAA;IAIA,cAAA;E7B4rSA;E+BnrSQ;IFbR,sBAAA;IAIA,uBAAA;E7BgsSA;E+BvrSQ;IFbR,sBAAA;IAIA,uBAAA;E7BosSA;E+B3rSQ;IFbR,aAAA;IAIA,cAAA;E7BwsSA;E+B/rSQ;IFbR,sBAAA;IAIA,uBAAA;E7B4sSA;E+BnsSQ;IFbR,sBAAA;IAIA,uBAAA;E7BgtSA;E+BvsSQ;IFbR,cAAA;IAIA,eAAA;E7BotSA;E+BrsSI;IAAwB,SAAA;E/BwsS5B;E+BtsSI;IAAuB,SAAA;E/BysS3B;E+BtsSM;IAAwB,QADb;E/B0sSjB;E+BzsSM;IAAwB,QADb;E/B6sSjB;E+B5sSM;IAAwB,QADb;E/BgtSjB;E+B/sSM;IAAwB,QADb;E/BmtSjB;E+BltSM;IAAwB,QADb;E/BstSjB;E+BrtSM;IAAwB,QADb;E/BytSjB;E+BxtSM;IAAwB,QADb;E/B4tSjB;E+B3tSM;IAAwB,QADb;E/B+tSjB;E+B9tSM;IAAwB,QADb;E/BkuSjB;E+BjuSM;IAAwB,QADb;E/BquSjB;E+BpuSM;IAAwB,SADb;E/BwuSjB;E+BvuSM;IAAwB,SADb;E/B2uSjB;E+B1uSM;IAAwB,SADb;E/B8uSjB;E+BtuSU;IFhBV,cAAA;E7ByvSA;E+BzuSU;IFhBV,wBAAA;E7B4vSA;E+B5uSU;IFhBV,yBAAA;E7B+vSA;E+B/uSU;IFhBV,gBAAA;E7BkwSA;E+BlvSU;IFhBV,yBAAA;E7BqwSA;E+BrvSU;IFhBV,yBAAA;E7BwwSA;E+BxvSU;IFhBV,gBAAA;E7B2wSA;E+B3vSU;IFhBV,yBAAA;E7B8wSA;E+B9vSU;IFhBV,yBAAA;E7BixSA;E+BjwSU;IFhBV,gBAAA;E7BoxSA;E+BpwSU;IFhBV,yBAAA;E7BuxSA;E+BvwSU;IFhBV,yBAAA;E7B0xSA;AACF;A8BtxSI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;E/BozSN;E6BxxSA;IACE,cAAA;IACA,eAAA;E7B0xSF;E6B5xSA;IACE,aAAA;IACA,cAAA;E7B8xSF;E6BhySA;IACE,wBAAA;IACA,yBAAA;E7BkySF;E6BpySA;IACE,aAAA;IACA,cAAA;E7BsySF;E6BxySA;IACE,aAAA;IACA,cAAA;E7B0ySF;E6B5ySA;IACE,wBAAA;IACA,yBAAA;E7B8ySF;E+Bj0SI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;E7Bm0SA;E+Bh0SQ;IFbR,qBAAA;IAIA,sBAAA;E7B60SA;E+Bp0SQ;IFbR,sBAAA;IAIA,uBAAA;E7Bi1SA;E+Bx0SQ;IFbR,aAAA;IAIA,cAAA;E7Bq1SA;E+B50SQ;IFbR,sBAAA;IAIA,uBAAA;E7By1SA;E+Bh1SQ;IFbR,sBAAA;IAIA,uBAAA;E7B61SA;E+Bp1SQ;IFbR,aAAA;IAIA,cAAA;E7Bi2SA;E+Bx1SQ;IFbR,sBAAA;IAIA,uBAAA;E7Bq2SA;E+B51SQ;IFbR,sBAAA;IAIA,uBAAA;E7By2SA;E+Bh2SQ;IFbR,aAAA;IAIA,cAAA;E7B62SA;E+Bp2SQ;IFbR,sBAAA;IAIA,uBAAA;E7Bi3SA;E+Bx2SQ;IFbR,sBAAA;IAIA,uBAAA;E7Bq3SA;E+B52SQ;IFbR,cAAA;IAIA,eAAA;E7By3SA;E+B12SI;IAAwB,SAAA;E/B62S5B;E+B32SI;IAAuB,SAAA;E/B82S3B;E+B32SM;IAAwB,QADb;E/B+2SjB;E+B92SM;IAAwB,QADb;E/Bk3SjB;E+Bj3SM;IAAwB,QADb;E/Bq3SjB;E+Bp3SM;IAAwB,QADb;E/Bw3SjB;E+Bv3SM;IAAwB,QADb;E/B23SjB;E+B13SM;IAAwB,QADb;E/B83SjB;E+B73SM;IAAwB,QADb;E/Bi4SjB;E+Bh4SM;IAAwB,QADb;E/Bo4SjB;E+Bn4SM;IAAwB,QADb;E/Bu4SjB;E+Bt4SM;IAAwB,QADb;E/B04SjB;E+Bz4SM;IAAwB,SADb;E/B64SjB;E+B54SM;IAAwB,SADb;E/Bg5SjB;E+B/4SM;IAAwB,SADb;E/Bm5SjB;E+B34SU;IFhBV,cAAA;E7B85SA;E+B94SU;IFhBV,wBAAA;E7Bi6SA;E+Bj5SU;IFhBV,yBAAA;E7Bo6SA;E+Bp5SU;IFhBV,gBAAA;E7Bu6SA;E+Bv5SU;IFhBV,yBAAA;E7B06SA;E+B15SU;IFhBV,yBAAA;E7B66SA;E+B75SU;IFhBV,gBAAA;E7Bg7SA;E+Bh6SU;IFhBV,yBAAA;E7Bm7SA;E+Bn6SU;IFhBV,yBAAA;E7Bs7SA;E+Bt6SU;IFhBV,gBAAA;E7By7SA;E+Bz6SU;IFhBV,yBAAA;E7B47SA;E+B56SU;IFhBV,yBAAA;E7B+7SA;AACF;AgCn/SA;EACE,WAAA;EACA,mBdiIO;EchIP,cdSS;AlB4+SX;AgCl/SE;;EAEE,kBZ0PiB;EYzPjB,mBAAA;EACA,6BAAA;AhCo/SJ;AgCj/SE;EACE,sBAAA;EACA,gCAAA;AhCm/SJ;AgCh/SE;EACE,6BAAA;AhCk/SJ;;AgCx+SE;;EAEE,ed6T0B;AlB8qS9B;;AgCl+SA;EACE,yBAAA;AhCq+SF;AgCn+SE;;EAEE,yBAAA;AhCq+SJ;AgCj+SI;;EAEE,wBAAA;AhCm+SN;;AgC79SE;;;;EAIE,SAAA;AhCg+SJ;;AgCv9SE;EACE,yBZlBS;ApB4+Sb;;AqBzhTE;EW2EI,cdvEK;EcwEL,yBZ/BO;ApBi/Sb;;AiCpiTI;;;EAGE,yBD2F+B;AhC48SrC;AiCniTM;;;;EAIE,qBDmFyE;AhCk9SjF;;AqB1iTE;EYiBM,yBAJe;AjCiiTvB;AiC3hTQ;;EAEE,yBARa;AjCqiTvB;;AiCxjTI;;;EAGE,yBD2F+B;AhCg+SrC;AiCvjTM;;;;EAIE,qBDmFyE;AhCs+SjF;;AqB9jTE;EYiBM,yBAJe;AjCqjTvB;AiC/iTQ;;EAEE,yBARa;AjCyjTvB;;AiC5kTI;;;EAGE,yBD2F+B;AhCo/SrC;AiC3kTM;;;;EAIE,qBDmFyE;AhC0/SjF;;AqBllTE;EYiBM,yBAJe;AjCykTvB;AiCnkTQ;;EAEE,yBARa;AjC6kTvB;;AiChmTI;;;EAGE,yBD2F+B;AhCwgTrC;AiC/lTM;;;;EAIE,qBDmFyE;AhC8gTjF;;AqBtmTE;EYiBM,yBAJe;AjC6lTvB;AiCvlTQ;;EAEE,yBARa;AjCimTvB;;AiCpnTI;;;EAGE,yBD2F+B;AhC4hTrC;AiCnnTM;;;;EAIE,qBDmFyE;AhCkiTjF;;AqB1nTE;EYiBM,yBAJe;AjCinTvB;AiC3mTQ;;EAEE,yBARa;AjCqnTvB;;AiCxoTI;;;EAGE,yBD2F+B;AhCgjTrC;AiCvoTM;;;;EAIE,qBDmFyE;AhCsjTjF;;AqB9oTE;EYiBM,yBAJe;AjCqoTvB;AiC/nTQ;;EAEE,yBARa;AjCyoTvB;;AiC5pTI;;;EAGE,uBD2F+B;AhCokTrC;AiC3pTM;;;;EAIE,mBDmFyE;AhC0kTjF;;AqBlqTE;EYiBM,yBAJe;AjCypTvB;AiCnpTQ;;EAEE,yBARa;AjC6pTvB;;AiChrTI;;;EAGE,yBD2F+B;AhCwlTrC;AiC/qTM;;;;EAIE,qBDmFyE;AhC8lTjF;;AqBtrTE;EYiBM,yBAJe;AjC6qTvB;AiCvqTQ;;EAEE,yBARa;AjCirTvB;;AiCpsTI;;;EAGE,sCf6VwB;AlB02S9B;;AqBpsTE;EYiBM,sCAJe;AjC2rTvB;AiCrrTQ;;EAEE,sCARa;AjC+rTvB;;AgCvmTI;EACE,Wd3GK;Ec4GL,yBdpGK;EcqGL,qBdiQwB;AlBy2S9B;AgCrmTI;EACE,cd5GK;Ec6GL,yBdlHK;EcmHL,qBZhES;ApBuqTf;;AgClmTA;EACE,Wd3HS;Ec4HT,yBdpHS;AlBytTX;AgCnmTE;;;EAGE,qBd6O0B;AlBw3S9B;AgClmTE;EACE,SAAA;AhComTJ;AgChmTI;EACE,2CdiOwB;AlBi4S9B;AqBvuTE;EW4IM,WdjJG;EckJH,4Cd2NsB;AlBm4S9B;;A8B9qTI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;EhCglTN;EgC7kTM;IACE,SAAA;EhC+kTR;AACF;A8B1rTI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;EhC2lTN;EgCxlTM;IACE,SAAA;EhC0lTR;AACF;A8BrsTI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;EhCsmTN;EgCnmTM;IACE,SAAA;EhCqmTR;AACF;A8BhtTI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;EhCinTN;EgC9mTM;IACE,SAAA;EhCgnTR;AACF;AgC1nTI;EAEI,cAAA;EACA,WAAA;EACA,gBAAA;EACA,iCAAA;AhC2nTR;AgCxnTQ;EACE,SAAA;AhC0nTV;;AkCvyTA;EACE,cAAA;EACA,WAAA;EACA,gBdiOsB;EchOtB,wBAAA;Ef0KI,mBAAA;EevKJ,gBhBmR4B;EgBlR5B,cdgNkB;Ec/MlB,chBDS;EgBET,sBdqMS;EcpMT,4BAAA;EACA,yBAAA;ERAE,kBAAA;ESFE,wEDQJ;AlCqyTF;AmCzyTM;EDdN;ICeQ,gBAAA;EnC4yTN;AACF;AkCvyTE;EACE,6BAAA;EACA,SAAA;AlCyyTJ;AoCzzTE;EACE,cAAA;EACA,sBlBRO;EkBSP,qBlBsdoC;EkBrdpC,UAAA;EAKE,gDlBqXwB;AlBk8S9B;AkCzyTE;EACE,cdmLsB;EcjLtB,UAAA;AlC0yTJ;AkClyTE;EAEE,yBhBxCO;EgB0CP,UAAA;AlCkyTJ;;AkC1xTE;;;;EACE,gBAAA;AlCgyTJ;;AkC1xTE;EACE,kBAAA;EACA,0BAAA;AlC6xTJ;AkC1xTE;EAME,chB/DO;EgBgEP,sBduIO;ApBgpTX;;AkClxTA;;EAEE,cAAA;EACA,WAAA;AlCqxTF;;AkC3wTA;EACE,gCAAA;EACA,mCAAA;EACA,gBAAA;EfiEE,kBAAA;Ee/DF,cdyHkB;ApBqpTpB;;AkC3wTA;EACE,gCAAA;EACA,mCAAA;Ef0EI,kBAAA;EexEJ,gBhB6H4B;AlBipT9B;;AkC3wTA;EACE,+BAAA;EACA,kCAAA;EfmEI,mBAAA;EejEJ,gBhBuH4B;AlBupT9B;;AkCrwTA;EACE,cAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EfoDI,mBAAA;EelDJ,cd4FkB;Ec3FlB,chBnHS;EgBoHT,6BAAA;EACA,yBAAA;EACA,mBAAA;AlCwwTF;AkCtwTE;EAEE,gBAAA;EACA,eAAA;AlCuwTJ;;AkC3vTA;EACE,gBdmFsB;EclFtB,uBAAA;Ef2BI,mBAAA;EezBJ,gBhB+E4B;EQxN1B,qBAAA;A1Bw4TJ;;AkC3vTA;EACE,gBd4EsB;Ec3EtB,wBAAA;EfmBI,kBAAA;EejBJ,gBhBsE4B;EQvN1B,qBAAA;A1Bg5TJ;;AkCzvTE;EAEE,YAAA;AlC2vTJ;;AkCvvTA;EACE,YAAA;AlC0vTF;;AkClvTA;EACE,mBhB2UsC;AlB06SxC;;AkClvTA;EACE,cAAA;EACA,mBhB4TsC;AlBy7SxC;;AkC7uTA;EACE,aAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AlCgvTF;AkC9uTE;;EAEE,kBAAA;EACA,iBAAA;AlCgvTJ;;AkCvuTA;EACE,kBAAA;EACA,cAAA;EACA,qBhBiSsC;AlBy8SxC;;AkCvuTA;EACE,kBAAA;EACA,kBhB6RsC;EgB5RtC,qBAAA;AlC0uTF;AkCvuTE;EAEE,cdxIS;ApBg3Tb;;AkCpuTA;EACE,gBAAA;AlCuuTF;;AkCpuTA;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,qBhB8QsC;AlBy9SxC;AkCpuTE;EACE,gBAAA;EACA,aAAA;EACA,uBhByQoC;EgBxQpC,cAAA;AlCsuTJ;;AoCn7TE;EACE,aAAA;EACA,WAAA;EACA,mBlB2coC;ECtVpC,kBAAA;EiBnHA,cFqNqC;AlCiuTzC;;AoCn7TE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EjBwHE,mBAAA;EiBtHF,gBlBuO0B;EkBtO1B,WAAA;EACA,wCAAA;EV9CA,sBAAA;A1Bq+TJ;AoCl7TI;EAEE,SAAA;ApCm7TN;;AoC96TI;;;;EAEE,cAAA;ApCm7TN;;AoCj+TI;EAoDE,qBFkLmC;EE/KjC,+CAAA;EACA,yDAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;ApC+6TR;AoC56TM;EACE,qBFuKiC;EEtKjC,gDAAA;ApC86TR;;AoC9+TI;EAyEI,8BAAA;EACA,wCAAA;ApCy6TR;;AoCn/TI;EAmFI,oClB6XgC;EkB5XhC,kFAAA;ApCo6TR;;AoCx/TI;EA2FE,qBF2ImC;EExIjC,kDAAA;EACA,wNAAA;ApC+5TR;AoC55TM;EACE,qBFmIiC;EElIjC,gDAAA;ApC85TR;;AoCv5TM;EACE,cF0HiC;AlCgyTzC;AoCv5TM;;;EAEE,cAAA;ApC05TR;;AoCn5TM;EACE,cF6GiC;AlCyyTzC;AoCp5TQ;EACE,qBF0G+B;AlC4yTzC;AoCj5TQ;EACE,qBAAA;EC5JN,yBD6J2B;ApCm5T/B;AoC94TQ;EACE,gDAAA;ApCg5TV;AoC74TQ;EACE,qBFyF+B;AlCszTzC;;AoCt4TM;EACE,qBF+EiC;AlC0zTzC;AoCr4TQ;EACE,qBF0E+B;EEzE/B,gDAAA;ApCu4TV;;AoCxhUE;EACE,aAAA;EACA,WAAA;EACA,mBlB2coC;ECtVpC,kBAAA;EiBnHA,cFqNqC;AlCs0TzC;;AoCxhUE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EjBwHE,mBAAA;EiBtHF,gBlBuO0B;EkBtO1B,WAAA;EACA,wCAAA;EV9CA,sBAAA;A1B0kUJ;AoCvhUI;EAEE,SAAA;ApCwhUN;;AoCnhUI;;;;EAEE,cAAA;ApCwhUN;;AoCtkUI;EAoDE,qBFkLmC;EE/KjC,+CAAA;EACA,yDAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;ApCohUR;AoCjhUM;EACE,qBFuKiC;EEtKjC,gDAAA;ApCmhUR;;AoCnlUI;EAyEI,8BAAA;EACA,wCAAA;ApC8gUR;;AoCxlUI;EAmFI,oClB6XgC;EkB5XhC,kFAAA;ApCygUR;;AoC7lUI;EA2FE,qBF2ImC;EExIjC,kDAAA;EACA,wNAAA;ApCogUR;AoCjgUM;EACE,qBFmIiC;EElIjC,gDAAA;ApCmgUR;;AoC5/TM;EACE,cF0HiC;AlCq4TzC;AoC5/TM;;;EAEE,cAAA;ApC+/TR;;AoCx/TM;EACE,cF6GiC;AlC84TzC;AoCz/TQ;EACE,qBF0G+B;AlCi5TzC;AoCt/TQ;EACE,qBAAA;EC5JN,yBD6J2B;ApCw/T/B;AoCn/TQ;EACE,gDAAA;ApCq/TV;AoCl/TQ;EACE,qBFyF+B;AlC25TzC;;AoC3+TM;EACE,qBF+EiC;AlC+5TzC;AoC1+TQ;EACE,qBF0E+B;EEzE/B,gDAAA;ApC4+TV;;AkCv5TA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AlC05TF;AkCr5TE;EACE,WAAA;AlCu5TJ;A8BtnUI;EIoOA;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,gBAAA;ElCq5TJ;EkCj5TE;IACE,aAAA;IACA,cAAA;IACA,mBAAA;IACA,mBAAA;IACA,gBAAA;ElCm5TJ;EkC/4TE;IACE,qBAAA;IACA,WAAA;IACA,sBAAA;ElCi5TJ;EkC74TE;IACE,qBAAA;ElC+4TJ;EkC54TE;;IAEE,WAAA;ElC84TJ;EkCz4TE;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,WAAA;IACA,eAAA;ElC24TJ;EkCz4TE;IACE,kBAAA;IACA,cAAA;IACA,aAAA;IACA,qBhBgLkC;IgB/KlC,cAAA;ElC24TJ;EkCx4TE;IACE,mBAAA;IACA,uBAAA;ElC04TJ;EkCx4TE;IACE,gBAAA;ElC04TJ;AACF;;AsC5tUA;EACE,qBAAA;EAEA,gBpBuR4B;EoBtR5B,clBOkB;EkBNlB,kBAAA;EAGA,sBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6BAAA;EACA,6BAAA;ECuFA,yBAAA;EpB4EI,oBAAA;EoB1EJ,cnBgEgB;EMxJd,wBAAA;ESFE,qIGGJ;AtC+tUF;AmC9tUM;EGdN;IHeQ,gBAAA;EnCiuUN;AACF;AqB3uUE;EiBUE,clBLgB;EkBMhB,qBAAA;AtCouUJ;AsCjuUE;EAEE,UAAA;EACA,gDpB8W0B;AlBo3T9B;AsC9tUE;EAEE,apBkZ0B;AlB60T9B;AsC3tUE;EACE,eAAA;AtC6tUJ;AsC/sUA;;EAEE,oBAAA;AtCitUF;;AsCxsUE;EC3DA,WAAA;EFAE,yBnBsEW;EqBpEb,qBrBoEa;AlBmsUf;AqBnwUE;EkBAE,WAAA;EFNA,yBED2D;EAS3D,qBATqG;AvC+wUzG;AuCnwUE;EAEE,WAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EAqBnG,gDAAA;AvCgwUN;AuC3vUE;EAEE,WAAA;EACA,yBrB0CW;EqBzCX,qBrByCW;AlBmtUf;AuCrvUE;EAGE,WAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;AvC+xU7L;AuChvUI;EAKI,gDAAA;AvC8uUR;;AsCtuUE;EC3DA,cAAA;EFAE,yBnBsEW;EqBpEb,qBrBoEa;AlBiuUf;AqBjyUE;EkBAE,cAAA;EFNA,yBED2D;EAS3D,qBATqG;AvC6yUzG;AuCjyUE;EAEE,cAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EAqBnG,iDAAA;AvC8xUN;AuCzxUE;EAEE,cAAA;EACA,yBrB0CW;EqBzCX,qBrByCW;AlBivUf;AuCnxUE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;AvC6zU7L;AuC9wUI;EAKI,iDAAA;AvC4wUR;;AsCpwUE;EC3DA,WAAA;EFAE,yBnBsEW;EqBpEb,qBrBoEa;AlB+vUf;AqB/zUE;EkBAE,WAAA;EFNA,yBED2D;EAS3D,qBATqG;AvC20UzG;AuC/zUE;EAEE,WAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EAqBnG,gDAAA;AvC4zUN;AuCvzUE;EAEE,WAAA;EACA,yBrB0CW;EqBzCX,qBrByCW;AlB+wUf;AuCjzUE;EAGE,WAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;AvC21U7L;AuC5yUI;EAKI,gDAAA;AvC0yUR;;AsClyUE;EC3DA,WAAA;EFAE,yBnBsEW;EqBpEb,qBrBoEa;AlB6xUf;AqB71UE;EkBAE,WAAA;EFNA,yBED2D;EAS3D,qBATqG;AvCy2UzG;AuC71UE;EAEE,WAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EAqBnG,iDAAA;AvC01UN;AuCr1UE;EAEE,WAAA;EACA,yBrB0CW;EqBzCX,qBrByCW;AlB6yUf;AuC/0UE;EAGE,WAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;AvCy3U7L;AuC10UI;EAKI,iDAAA;AvCw0UR;;AsCh0UE;EC3DA,cAAA;EFAE,yBnBsEW;EqBpEb,qBrBoEa;AlB2zUf;AqB33UE;EkBAE,WAAA;EFNA,yBED2D;EAS3D,qBATqG;AvCu4UzG;AuC33UE;EAEE,WAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EAqBnG,+CAAA;AvCw3UN;AuCn3UE;EAEE,cAAA;EACA,yBrB0CW;EqBzCX,qBrByCW;AlB20Uf;AuC72UE;EAGE,WAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;AvCu5U7L;AuCx2UI;EAKI,+CAAA;AvCs2UR;;AsC91UE;EC3DA,WAAA;EFAE,yBnBsEW;EqBpEb,qBrBoEa;AlBy1Uf;AqBz5UE;EkBAE,WAAA;EFNA,yBED2D;EAS3D,qBATqG;AvCq6UzG;AuCz5UE;EAEE,WAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EAqBnG,gDAAA;AvCs5UN;AuCj5UE;EAEE,WAAA;EACA,yBrB0CW;EqBzCX,qBrByCW;AlBy2Uf;AuC34UE;EAGE,WAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;AvCq7U7L;AuCt4UI;EAKI,gDAAA;AvCo4UR;;AsC53UE;EC3DA,cAAA;EFAE,yBnBsEW;EqBpEb,qBrBoEa;AlBu3Uf;AqBv7UE;EkBAE,cAAA;EFNA,yBED2D;EAS3D,qBATqG;AvCm8UzG;AuCv7UE;EAEE,cAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EAqBnG,iDAAA;AvCo7UN;AuC/6UE;EAEE,cAAA;EACA,yBrB0CW;EqBzCX,qBrByCW;AlBu4Uf;AuCz6UE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;AvCm9U7L;AuCp6UI;EAKI,iDAAA;AvCk6UR;;AsC15UE;EC3DA,WAAA;EFAE,yBnBsEW;EqBpEb,qBrBoEa;AlBq5Uf;AqBr9UE;EkBAE,WAAA;EFNA,uBED2D;EAS3D,mBATqG;AvCi+UzG;AuCr9UE;EAEE,WAAA;EFbA,uBED2D;EAgB3D,mBAhBqG;EAqBnG,8CAAA;AvCk9UN;AuC78UE;EAEE,WAAA;EACA,yBrB0CW;EqBzCX,qBrByCW;AlBq6Uf;AuCv8UE;EAGE,WAAA;EACA,uBAzC+I;EA6C/I,mBA7CyL;AvCi/U7L;AuCl8UI;EAKI,8CAAA;AvCg8UR;;AsCl7UE;ECPA,crBYa;EqBXb,qBrBWa;AlBk7Uf;AqBl/UE;EkBwDE,WALgD;EAMhD,yBrBOW;EqBNX,qBrBMW;AlBu7Uf;AuC17UE;EAEE,+CAAA;AvC27UJ;AuCx7UE;EAEE,crBJW;EqBKX,6BAAA;AvCy7UJ;AuCt7UE;EAGE,WAAA;EACA,yBrBZW;EqBaX,qBrBbW;AlBm8Uf;AuCp7UI;EAKI,+CAAA;AvCk7UR;;AsC38UE;ECPA,crBYa;EqBXb,qBrBWa;AlB28Uf;AqB3gVE;EkBwDE,cALgD;EAMhD,yBrBOW;EqBNX,qBrBMW;AlBg9Uf;AuCn9UE;EAEE,iDAAA;AvCo9UJ;AuCj9UE;EAEE,crBJW;EqBKX,6BAAA;AvCk9UJ;AuC/8UE;EAGE,cAAA;EACA,yBrBZW;EqBaX,qBrBbW;AlB49Uf;AuC78UI;EAKI,iDAAA;AvC28UR;;AsCp+UE;ECPA,crBYa;EqBXb,qBrBWa;AlBo+Uf;AqBpiVE;EkBwDE,WALgD;EAMhD,yBrBOW;EqBNX,qBrBMW;AlBy+Uf;AuC5+UE;EAEE,8CAAA;AvC6+UJ;AuC1+UE;EAEE,crBJW;EqBKX,6BAAA;AvC2+UJ;AuCx+UE;EAGE,WAAA;EACA,yBrBZW;EqBaX,qBrBbW;AlBq/Uf;AuCt+UI;EAKI,8CAAA;AvCo+UR;;AsC7/UE;ECPA,crBYa;EqBXb,qBrBWa;AlB6/Uf;AqB7jVE;EkBwDE,WALgD;EAMhD,yBrBOW;EqBNX,qBrBMW;AlBkgVf;AuCrgVE;EAEE,gDAAA;AvCsgVJ;AuCngVE;EAEE,crBJW;EqBKX,6BAAA;AvCogVJ;AuCjgVE;EAGE,WAAA;EACA,yBrBZW;EqBaX,qBrBbW;AlB8gVf;AuC//UI;EAKI,gDAAA;AvC6/UR;;AsCthVE;ECPA,crBYa;EqBXb,qBrBWa;AlBshVf;AqBtlVE;EkBwDE,cALgD;EAMhD,yBrBOW;EqBNX,qBrBMW;AlB2hVf;AuC9hVE;EAEE,+CAAA;AvC+hVJ;AuC5hVE;EAEE,crBJW;EqBKX,6BAAA;AvC6hVJ;AuC1hVE;EAGE,cAAA;EACA,yBrBZW;EqBaX,qBrBbW;AlBuiVf;AuCxhVI;EAKI,+CAAA;AvCshVR;;AsC/iVE;ECPA,crBYa;EqBXb,qBrBWa;AlB+iVf;AqB/mVE;EkBwDE,WALgD;EAMhD,yBrBOW;EqBNX,qBrBMW;AlBojVf;AuCvjVE;EAEE,+CAAA;AvCwjVJ;AuCrjVE;EAEE,crBJW;EqBKX,6BAAA;AvCsjVJ;AuCnjVE;EAGE,WAAA;EACA,yBrBZW;EqBaX,qBrBbW;AlBgkVf;AuCjjVI;EAKI,+CAAA;AvC+iVR;;AsCxkVE;ECPA,crBYa;EqBXb,qBrBWa;AlBwkVf;AqBxoVE;EkBwDE,cALgD;EAMhD,yBrBOW;EqBNX,qBrBMW;AlB6kVf;AuChlVE;EAEE,iDAAA;AvCilVJ;AuC9kVE;EAEE,crBJW;EqBKX,6BAAA;AvC+kVJ;AuC5kVE;EAGE,cAAA;EACA,yBrBZW;EqBaX,qBrBbW;AlBylVf;AuC1kVI;EAKI,iDAAA;AvCwkVR;;AsCjmVE;ECPA,crBYa;EqBXb,qBrBWa;AlBimVf;AqBjqVE;EkBwDE,WALgD;EAMhD,yBrBOW;EqBNX,qBrBMW;AlBsmVf;AuCzmVE;EAEE,8CAAA;AvC0mVJ;AuCvmVE;EAEE,crBJW;EqBKX,6BAAA;AvCwmVJ;AuCrmVE;EAGE,WAAA;EACA,yBrBZW;EqBaX,qBrBbW;AlBknVf;AuCnmVI;EAKI,8CAAA;AvCimVR;;AsC/mVA;EACE,gBpB6M4B;EoB5M5B,cpB2FwC;EoB1FxC,qBpB2FwC;AlBuhV1C;AqB3rVE;EiB4EE,cpByFsC;EoBxFtC,0BpByFsC;AlByhV1C;AsC/mVE;EAEE,0BpBoFsC;AlB4hV1C;AsC7mVE;EAEE,cpBtFO;EoBuFP,oBAAA;AtC8mVJ;;AsCnmVA;ECPE,kBAAA;EpB4EI,mBAAA;EoB1EJ,gBrB+H4B;EQvN1B,wBAAA;A1BusVJ;;AsCtmVA;ECXE,uBAAA;EpB4EI,mBAAA;EoB1EJ,gBrBgI4B;EQxN1B,wBAAA;A1B8sVJ;;AsCpmVA;EACE,cAAA;EACA,WAAA;AtCumVF;AsCpmVE;EACE,kBpBwT0B;AlB8yU9B;;AsC9lVE;;;EACE,WAAA;AtCmmVJ;;AwC9uVA;ELgBM,gCKfJ;AxCivVF;AmC9tVM;EKpBN;ILqBQ,gBAAA;EnCiuVN;AACF;AwCpvVE;EACE,UAAA;AxCsvVJ;;AwCjvVE;EACE,aAAA;AxCovVJ;;AwChvVA;EACE,kBAAA;EACA,SAAA;EACA,gBAAA;ELDI,6BKEJ;AxCmvVF;AmCjvVM;EKNN;ILOQ,gBAAA;EnCovVN;AACF;AwCtvVE;EACE,QAAA;EACA,YAAA;ELNE,4BKOF;AxCwvVJ;AmC3vVM;EKAJ;ILCM,gBAAA;EnC8vVN;AACF;;AyCnxVA;;;;EAIE,kBAAA;AzCsxVF;;AyCnxVA;EACE,mBAAA;AzCsxVF;A0ClwVI;EACE,qBAAA;EACA,oBxB+NwB;EwB9NxB,uBxB6NwB;EwB5NxB,WAAA;EAhCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;A1CqyVF;A0ChvVI;EACE,cAAA;A1CkvVN;;AyC5xVA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,avBypBkC;EuBxpBlC,aAAA;EACA,WAAA;EACA,gBvBiuBkC;EuBhuBlC,iBAAA;EACA,oBAAA;EtB2JI,eAAA;EsBzJJ,crBVkB;EqBWlB,gBAAA;EACA,gBAAA;EACA,sBrBkIQ;EqBjIR,4BAAA;EACA,yBAAA;EfdE,sBAAA;A1B8yVJ;;AyCvxVI;EACE,WAAA;EACA,OAAA;AzC0xVN;;AyCvxVI;EACE,QAAA;EACA,UAAA;AzC0xVN;;A8B9wVI;EWnBA;IACE,WAAA;IACA,OAAA;EzCqyVJ;EyClyVE;IACE,QAAA;IACA,UAAA;EzCoyVJ;AACF;A8BzxVI;EWnBA;IACE,WAAA;IACA,OAAA;EzC+yVJ;EyC5yVE;IACE,QAAA;IACA,UAAA;EzC8yVJ;AACF;A8BnyVI;EWnBA;IACE,WAAA;IACA,OAAA;EzCyzVJ;EyCtzVE;IACE,QAAA;IACA,UAAA;EzCwzVJ;AACF;A8B7yVI;EWnBA;IACE,WAAA;IACA,OAAA;EzCm0VJ;EyCh0VE;IACE,QAAA;IACA,UAAA;EzCk0VJ;AACF;AyC3zVE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,uBvB+rBgC;AlB8nUpC;A0C51VI;EACE,qBAAA;EACA,oBxB+NwB;EwB9NxB,uBxB6NwB;EwB5NxB,WAAA;EAzBJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;A1Cw3VF;A0C10VI;EACE,cAAA;A1C40VN;;AyCj0VE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,qBvBirBgC;AlBmpUpC;A0Cj3VI;EACE,qBAAA;EACA,oBxB+NwB;EwB9NxB,uBxB6NwB;EwB5NxB,WAAA;EAlBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;A1Cs4VF;A0C/1VI;EACE,cAAA;A1Ci2VN;AyC50VI;EACE,iBAAA;AzC80VN;;AyCx0VE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sBvBgqBgC;AlB2qUpC;A0Cz4VI;EACE,qBAAA;EACA,oBxB+NwB;EwB9NxB,uBxB6NwB;EwB5NxB,WAAA;A1C24VN;A0Ch4VM;EACE,aAAA;A1Ck4VR;A0C/3VM;EACE,qBAAA;EACA,qBxB4MsB;EwB3MtB,uBxB0MsB;EwBzMtB,WAAA;EA9BN,mCAAA;EACA,yBAAA;EACA,sCAAA;A1Cg6VF;A0C/3VI;EACE,cAAA;A1Ci4VN;AyC31VI;EACE,iBAAA;AzC61VN;;AyCr1VE;EAIE,WAAA;EACA,YAAA;AzCq1VJ;;AyCh1VA;EE9GE,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;A3Ck8VF;;AyCh1VA;EACE,cAAA;EACA,WAAA;EACA,uBAAA;EACA,WAAA;EACA,gBvBiK4B;EuBhK5B,crB/GkB;EqBgHlB,mBAAA;EAEA,mBAAA;EACA,6BAAA;EACA,SAAA;AzCk1VF;AqBv8VE;EoBoIE,cvBonBgC;EuBnnBhC,qBAAA;EJ/IA,yBjBkPqB;ApBouVzB;AyCn0VE;EAEE,WvBpJO;EuBqJP,qBAAA;EJtJA,yBnBoP0B;AlBuuV9B;AyCj0VE;EAEE,cvBtJO;EuBuJP,oBAAA;EACA,6BAAA;AzCk0VJ;;AyC1zVA;EACE,cAAA;AzC6zVF;;AyCzzVA;EACE,cAAA;EACA,sBvBimBkC;EuBhmBlC,gBAAA;EtBAI,mBAAA;EsBEJ,crBrKkB;EqBsKlB,mBAAA;AzC4zVF;;AyCxzVA;EACE,cAAA;EACA,uBAAA;EACA,crB7KkB;ApBw+VpB;;A4Ct/VA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;A5Cy/VF;A4Cv/VE;;EACE,kBAAA;EACA,cAAA;A5C0/VJ;AqBz/VE;;EuBII,UAAA;A5Cy/VN;A4Cv/VI;;;;EAGE,UAAA;A5C0/VN;;A4Cp/VA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;A5Cu/VF;A4Cr/VE;EACE,WAAA;A5Cu/VJ;;A4Cj/VE;;EAEE,iBAAA;A5Co/VJ;A4Ch/VE;;ElBXE,0BAAA;EACA,6BAAA;A1B+/VJ;A4Ch/VE;;ElBFE,yBAAA;EACA,4BAAA;A1Bs/VJ;;A4Cn+VA;EACE,wBAAA;EACA,uBAAA;A5Cs+VF;A4Cp+VE;EAGE,cAAA;A5Co+VJ;A4Cj+VE;EACE,eAAA;A5Cm+VJ;;A4C/9VA;EACE,uBAAA;EACA,sBAAA;A5Ck+VF;;A4C/9VA;EACE,sBAAA;EACA,qBAAA;A5Ck+VF;;A4C98VA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;A5Ci9VF;A4C/8VE;;EAEE,WAAA;A5Ci9VJ;A4C98VE;;EAEE,gBAAA;A5Cg9VJ;A4C58VE;;ElBrFE,6BAAA;EACA,4BAAA;A1BqiWJ;A4C58VE;;ElBxGE,yBAAA;EACA,0BAAA;A1BwjWJ;;A4C77VE;;EAEE,gBAAA;A5Cg8VJ;A4C97VI;;;;EAEE,kBAAA;EACA,sBAAA;EACA,oBAAA;A5Ck8VN;;A6C3lWA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A7C8lWF;A6C5lWE;;;;EAIE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;A7C8lWJ;A6C5lWI;;;;;;;;;;;;EAGE,iBAAA;A7CumWN;A6ClmWE;;;EAGE,UAAA;A7ComWJ;A6ChmWE;EACE,UAAA;A7CkmWJ;A6C7lWI;;EnBIA,yBAAA;EACA,4BAAA;A1B6lWJ;A6C7lWE;EACE,aAAA;EACA,mBAAA;A7C+lWJ;A6C7lWI;EnBnBA,0BAAA;EACA,6BAAA;A1BmnWJ;A6C/lWI;EnBPA,yBAAA;EACA,4BAAA;A1BymWJ;A6C/lWI;;;;EnBzBA,0BAAA;EACA,6BAAA;A1B8nWJ;A6C7lWI;;;;EnBlCA,0BAAA;EACA,6BAAA;A1BqoWJ;;A6CplWA;;EAEE,aAAA;A7CulWF;A6CllWE;;EACE,kBAAA;EACA,UAAA;A7CqlWJ;A6CnlWI;;EACE,UAAA;A7CslWN;A6CllWE;;;;;;;;EAIE,iBAAA;A7CwlWJ;;A6CplWA;EAAuB,kBAAA;A7CwlWvB;;A6CvlWA;EAAsB,iBAAA;A7C2lWtB;;A6CnlWA;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,gBAAA;E1B2DI,mBAAA;E0BzDJ,gB3BqK4B;E2BpK5B,czBkGkB;EyBjGlB,c3B/GS;E2BgHT,kBAAA;EACA,mBAAA;EACA,yB3BvHS;E2BwHT,yBAAA;EnB/GE,kBAAA;A1BssWJ;A6CnlWE;;EAEE,aAAA;A7CqlWJ;;A6C3kWA;;EAEE,gBzByFsB;ApBq/VxB;;A6C3kWA;;;;;;EAME,wBAAA;E1BwBI,kBAAA;E0BtBJ,gB3B2E4B;EQvN1B,qBAAA;A1B2tWJ;;A6C3kWA;;EAEE,gBzBuEsB;ApBugWxB;;A6C3kWA;;;;;;EAME,uBAAA;E1BOI,mBAAA;E0BLJ,gB3B2D4B;EQxN1B,qBAAA;A1B4uWJ;;A6C3kWA;;EAEE,sBAAA;A7C8kWF;;A6CnkWA;;;;;;;;EnB9JI,0BAAA;EACA,6BAAA;A1B4uWJ;;A6CpkWA;;;;;;EnB3JI,yBAAA;EACA,4BAAA;A1BwuWJ;;A8ChxWA;EACE,kBAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,iCAAA;UAAA,yBAAA;A9CmxWF;;A8ChxWA;EACE,oBAAA;EACA,kB5ByfsC;AlB0xVxC;;A8ChxWA;EACE,kBAAA;EACA,OAAA;EACA,WAAA;EACA,W5BqfsC;E4BpftC,eAAA;EACA,UAAA;A9CmxWF;A8CjxWE;EACE,W5BzBO;E4B0BP,qB5ByN0B;EmBpP1B,yBnBoP0B;AlB2jW9B;A8C/wWE;EAKI,gD5BgWwB;AlB66V9B;A8CzwWE;EACE,qB5BsboC;AlBq1VxC;A8CxwWE;EACE,W5B7CO;E4B8CP,yB5Bkf4C;E4Bjf5C,qB5Bif4C;AlByxVhD;A8CnwWI;EACE,c5BjDK;AlBszWX;A8CnwWM;EACE,yB5BxDG;AlB6zWX;;A8C3vWA;EACE,kBAAA;EACA,gBAAA;EAEA,mBAAA;A9C6vWF;A8CzvWE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,W5BwboC;E4BvbpC,Y5BuboC;E4BtbpC,oBAAA;EACA,WAAA;EACA,sB5BrFO;E4BsFP,yBAAA;A9C2vWJ;A8CtvWE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,W5ByaoC;E4BxapC,Y5BwaoC;E4BvapC,WAAA;EACA,iCAAA;A9CwvWJ;;A8C9uWE;EpBlGE,sBAAA;A1Bo1WJ;A8C7uWI;EACE,yDAAA;A9C+uWN;A8C1uWI;EACE,qB5B0HwB;EmBpP1B,yBnBoP0B;AlBmnW9B;A8CzuWI;EACE,yDAAA;A9C2uWN;A8CtuWI;ETpIA,wCnByhB4C;AlBo1VhD;A8CtuWI;ETvIA,wCnByhB4C;AlBu1VhD;;A8C9tWE;EAEE,kB5B0Z4C;AlBs0VhD;A8C5tWI;EACE,yDAAA;A9C8tWN;A8CztWI;ET9JA,wCnByhB4C;AlBi2VhD;;A8CjtWA;EACE,qBAAA;A9CotWF;A8CjtWI;EACE,cAAA;EACA,c5BkY0C;E4BjY1C,mBAAA;EAEA,qB5BgY0C;AlBk1VhD;A8C/sWI;EACE,wBAAA;EACA,0BAAA;EACA,uB5B2X0C;E4B1X1C,wB5B0X0C;E4BzX1C,yB5BpLK;E4BsLL,qB5BsX0C;EiBxiB1C,yIWmLA;A9CgtWN;AmC/3WM;EWuKF;IXtKI,gBAAA;EnCk4WN;AACF;A8ChtWI;EACE,sB5BlMK;E4BmML,8BAAA;A9CktWN;A8C7sWI;ETzMA,wCnByhB4C;AlBg4VhD;;A8CnsWA;EACE,qBAAA;EACA,WAAA;EACA,mC5BqRsC;E4BpRtC,0CAAA;E3B5CI,eAAA;E2B+CJ,gB5B6D4B;E4B5D5B,gB5BiE4B;E4BhE5B,c5BvNS;E4BwNT,sBAAA;EACA,gGAAA;EACA,yBAAA;EpBtNE,sBAAA;EoByNF,gBAAA;A9CosWF;A8ClsWE;EACE,qB5BwPoC;E4BvPpC,UAAA;EAKE,gD5BmW8B;AlB61VpC;A8C7rWI;EAME,c5B/OK;E4BgPL,sB1BzCK;ApBmuWX;A8CtrWE;EAEE,YAAA;EACA,sB5B+H0B;E4B9H1B,sBAAA;A9CurWJ;A8CprWE;EACE,c5B7PO;E4B8PP,yB5BlQO;AlBw7WX;A8ClrWE;EACE,aAAA;A9CorWJ;A8ChrWE;EACE,kBAAA;EACA,0BAAA;A9CkrWJ;;A8C9qWA;EACE,kC5B0NsC;E4BzNtC,oB5BiH4B;E4BhH5B,uB5BgH4B;E4B/G5B,oB5BgH4B;EC1NxB,mBAAA;AnB4xWN;;A8C9qWA;EACE,gC5BmNsC;E4BlNtC,mB5B8G4B;E4B7G5B,sB5B6G4B;E4B5G5B,kB5B6G4B;EC/NxB,kBAAA;AnBoyWN;;A8CzqWA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,mC5BiMsC;E4BhMtC,gBAAA;A9C4qWF;;A8CzqWA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,mC5ByLsC;E4BxLtC,SAAA;EACA,gBAAA;EACA,UAAA;A9C4qWF;A8C1qWE;EACE,qB5BqKoC;E4BpKpC,gD5ByE0B;AlBmmW9B;A8CxqWE;EAEE,yB5B/TO;AlBw+WX;A8CrqWI;EACE,iB5B2Ta;AlB42VnB;A8CnqWE;EACE,0BAAA;A9CqqWJ;;A8CjqWA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,mC5BwJsC;E4BvJtC,yBAAA;EACA,gBAAA;EAEA,gB5BhE4B;E4BiE5B,gB5B5D4B;E4B6D5B,c5BpVS;E4BqVT,sB5B5VS;E4B6VT,yBAAA;EpBlVE,sBAAA;A1Bs/WJ;A8ChqWE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EACA,6B5BiIoC;E4BhIpC,yBAAA;EACA,gB5B5E0B;E4B6E1B,c5BpWO;E4BqWP,iBAAA;ET7WA,yBnBGO;E4B4WP,oBAAA;EpBnWA,kCAAA;A1BsgXJ;;A8CxpWA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,6BAAA;EACA,gBAAA;A9C2pWF;A8CzpWE;EACE,UAAA;A9C2pWJ;A8CvpWI;EAA0B,gE5BoOe;AlBs7V7C;A8CzpWI;EAA0B,gE5BmOe;AlBy7V7C;A8C3pWI;EAA0B,gE5BkOe;AlB47V7C;A8C3pWE;EACE,SAAA;A9C6pWJ;A8C1pWE;EACE,W5BoNyC;E4BnNzC,Y5BmNyC;E4BlNzC,oBAAA;ETlZA,yBnBoP0B;E4BgK1B,S5BmNyC;EQ3lBzC,mBAAA;ESFE,oHW6YF;EX7YE,4GW6YF;EACA,gBAAA;A9C2pWJ;AmCriXM;EWiYJ;IXhYM,wBAAA;IAAA,gBAAA;EnCwiXN;AACF;A8C9pWI;ET1ZA,yBnB4mByC;AlB+8V7C;A8C5pWE;EACE,W5B6LgC;E4B5LhC,c5B6LgC;E4B5LhC,kBAAA;EACA,e5B4LgC;E4B3LhC,yB5BhaO;E4BiaP,yBAAA;EpBzZA,mBAAA;A1BwjXJ;A8C1pWE;EACE,W5ByLyC;E4BxLzC,Y5BwLyC;EmBpmBzC,yBnBoP0B;E4B0L1B,S5ByLyC;EQ3lBzC,mBAAA;ESFE,iHWuaF;EXvaE,4GWuaF;EACA,gBAAA;A9C2pWJ;AmC/jXM;EW4ZJ;IX3ZM,qBAAA;IAAA,gBAAA;EnCkkXN;AACF;A8C9pWI;ETpbA,yBnB4mByC;AlBy+V7C;A8C5pWE;EACE,W5BmKgC;E4BlKhC,c5BmKgC;E4BlKhC,kBAAA;EACA,e5BkKgC;E4BjKhC,yB5B1bO;E4B2bP,yBAAA;EpBnbA,mBAAA;A1BklXJ;A8C1pWE;EACE,W5B+JyC;E4B9JzC,Y5B8JyC;E4B7JzC,aAAA;EACA,oB5BrE0B;E4BsE1B,mB5BtE0B;EmBnY1B,yBnBoP0B;E4BuN1B,S5B4JyC;EQ3lBzC,mBAAA;ESFE,gHWocF;EXpcE,4GWocF;EACA,gBAAA;A9C2pWJ;AmC5lXM;EWsbJ;IXrbM,oBAAA;IAAA,gBAAA;EnC+lXN;AACF;A8C9pWI;ETjdA,yBnB4mByC;AlBsgW7C;A8C5pWE;EACE,W5BsIgC;E4BrIhC,c5BsIgC;E4BrIhC,kBAAA;EACA,e5BqIgC;E4BpIhC,6BAAA;EACA,yBAAA;EACA,oBAAA;A9C8pWJ;A8C1pWE;EACE,yB5B9dO;EQQP,mBAAA;A1BmnXJ;A8CzpWE;EACE,kBAAA;EACA,yB5BpeO;EQQP,mBAAA;A1BwnXJ;A8CvpWI;EACE,yB5BxeK;AlBioXX;A8CtpWI;EACE,eAAA;A9CwpWN;A8CrpWI;EACE,yB5BhfK;AlBuoXX;A8CppWI;EACE,eAAA;A9CspWN;A8CnpWI;EACE,yB5BxfK;AlB6oXX;;A8ChpWA;;;EXzfM,4GW4fJ;A9CmpWF;AmC3oXM;EWqfN;;;IXpfQ,gBAAA;EnCgpXN;AACF;;A+CjqXA;EACE,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;A/CoqXF;;A+CjqXA;EACE,cAAA;EACA,oBAAA;A/CoqXF;AqBnqXE;E0BGE,qBAAA;A/CmqXJ;A+C/pXE;EACE,c7BXO;E6BYP,oBAAA;EACA,eAAA;A/CiqXJ;;A+CzpXA;EACE,gCAAA;A/C4pXF;A+C1pXE;EACE,mBAAA;EACA,6BAAA;EACA,6BAAA;ErBbA,+BAAA;EACA,gCAAA;A1B0qXJ;AqBtrXE;E0B6BI,kBAAA;EACA,qC3B0T8B;ApBk2WpC;A+CzpXI;EACE,c7BrCK;E6BsCL,6BAAA;EACA,yBAAA;A/C2pXN;A+CvpXE;;EAEE,c3BzCgB;E2B0ChB,yB3B+SgC;E2B9ShC,qC3B+SgC;ApB02WpC;A+CtpXE;EAEE,gBAAA;ErBtCA,yBAAA;EACA,0BAAA;A1B8rXJ;;A+C7oXE;EACE,gBAAA;EACA,SAAA;ErB7DA,sBAAA;A1B8sXJ;A+C7oXE;;EAEE,W7B9EO;E6B+EP,yB7BoK0B;AlB2+W9B;;A+CroXE;;EAEE,cAAA;EACA,kBAAA;A/CwoXJ;;A+CnoXE;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;A/CsoXJ;;A+C5nXE;EACE,aAAA;A/C+nXJ;A+C7nXE;EACE,cAAA;A/C+nXJ;;AgDxuXA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,oBAAA;AhD2uXF;AgDvuXE;;;;;;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;AhD8uXJ;AgD1tXA;EACE,qBAAA;EACA,sB9BkqBkC;E8BjqBlC,yB9BiqBkC;E8BhqBlC,kB9BgFO;EC6CH,kBAAA;E6B3HJ,oBAAA;EACA,mBAAA;AhD4tXF;AqBtwXE;E2B6CE,qBAAA;AhD4tXJ;;AgDntXA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AhDstXF;AgDptXE;EACE,gBAAA;EACA,eAAA;AhDstXJ;AgDntXE;EACE,gBAAA;EACA,WAAA;AhDqtXJ;;AgD5sXA;EACE,qBAAA;EACA,mB9BylBkC;E8BxlBlC,sB9BwlBkC;AlBunWpC;;AgDnsXA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;AhDosXF;;AgDhsXA;EACE,wBAAA;E7B8DI,kBAAA;E6B5DJ,cAAA;EACA,6BAAA;EACA,6BAAA;EtBxGE,sBAAA;A1B4yXJ;AqB9yXE;E2B8GE,qBAAA;AhDmsXJ;;AgD7rXA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mCAAA;AhDgsXF;;AgD7rXA;EACE,gB9BglBkC;E8B/kBlC,gBAAA;AhDgsXF;;A8BtwXI;EkBkFI;;;;;;IACE,gBAAA;IACA,eAAA;EhD6rXR;AACF;A8B/xXI;EkB6FA;IAoBI,qBAAA;IACA,2BAAA;EhDkrXN;EgDhrXM;IACE,mBAAA;EhDkrXR;EgDhrXQ;IACE,kBAAA;EhDkrXV;EgD/qXQ;IACE,qB9ByhBwB;I8BxhBxB,oB9BwhBwB;ElBypWlC;EgD5qXM;;;;;;IACE,iBAAA;EhDmrXR;EgDrqXM;IACE,iBAAA;EhDuqXR;EgDpqXM;IACE,wBAAA;IAGA,gBAAA;EhDoqXR;EgDjqXM;IACE,aAAA;EhDmqXR;AACF;A8BpzXI;EkBkFI;;;;;;IACE,gBAAA;IACA,eAAA;EhD0uXR;AACF;A8B50XI;EkB6FA;IAoBI,qBAAA;IACA,2BAAA;EhD+tXN;EgD7tXM;IACE,mBAAA;EhD+tXR;EgD7tXQ;IACE,kBAAA;EhD+tXV;EgD5tXQ;IACE,qB9ByhBwB;I8BxhBxB,oB9BwhBwB;ElBssWlC;EgDztXM;;;;;;IACE,iBAAA;EhDguXR;EgDltXM;IACE,iBAAA;EhDotXR;EgDjtXM;IACE,wBAAA;IAGA,gBAAA;EhDitXR;EgD9sXM;IACE,aAAA;EhDgtXR;AACF;A8Bj2XI;EkBkFI;;;;;;IACE,gBAAA;IACA,eAAA;EhDuxXR;AACF;A8Bz3XI;EkB6FA;IAoBI,qBAAA;IACA,2BAAA;EhD4wXN;EgD1wXM;IACE,mBAAA;EhD4wXR;EgD1wXQ;IACE,kBAAA;EhD4wXV;EgDzwXQ;IACE,qB9ByhBwB;I8BxhBxB,oB9BwhBwB;ElBmvWlC;EgDtwXM;;;;;;IACE,iBAAA;EhD6wXR;EgD/vXM;IACE,iBAAA;EhDiwXR;EgD9vXM;IACE,wBAAA;IAGA,gBAAA;EhD8vXR;EgD3vXM;IACE,aAAA;EhD6vXR;AACF;A8B94XI;EkBkFI;;;;;;IACE,gBAAA;IACA,eAAA;EhDo0XR;AACF;A8Bt6XI;EkB6FA;IAoBI,qBAAA;IACA,2BAAA;EhDyzXN;EgDvzXM;IACE,mBAAA;EhDyzXR;EgDvzXQ;IACE,kBAAA;EhDyzXV;EgDtzXQ;IACE,qB9ByhBwB;I8BxhBxB,oB9BwhBwB;ElBgyWlC;EgDnzXM;;;;;;IACE,iBAAA;EhD0zXR;EgD5yXM;IACE,iBAAA;EhD8yXR;EgD3yXM;IACE,wBAAA;IAGA,gBAAA;EhD2yXR;EgDxyXM;IACE,aAAA;EhD0yXR;AACF;AgD32XI;EAoBI,qBAAA;EACA,2BAAA;AhD01XR;AgD72XQ;;;;;;EACE,gBAAA;EACA,eAAA;AhDo3XV;AgDj2XQ;EACE,mBAAA;AhDm2XV;AgDj2XU;EACE,kBAAA;AhDm2XZ;AgDh2XU;EACE,qB9ByhBwB;E8BxhBxB,oB9BwhBwB;AlB00WpC;AgD71XQ;;;;;;EACE,iBAAA;AhDo2XV;AgDt1XQ;EACE,iBAAA;AhDw1XV;AgDr1XQ;EACE,wBAAA;EAGA,gBAAA;AhDq1XV;AgDl1XQ;EACE,aAAA;AhDo1XV;;AgDt0XE;EACE,yB9BigBgC;AlBw0WpC;AqBjiYE;E2B2NI,yB9B8f8B;AlB20WpC;AgDp0XI;EACE,yB9Bsf8B;AlBg1WpC;AqBviYE;E2BoOM,yB9Bof4B;AlBk1WpC;AgDn0XM;EACE,yB9Bkf4B;AlBm1WpC;AgDj0XI;;;;EAIE,yB9Bye8B;AlB01WpC;AgD/zXE;EACE,yB9BkegC;E8BjehC,gC9BsegC;AlB21WpC;AgD9zXE;EACE,yDAAA;AhDg0XJ;AgD7zXE;EACE,yB9BydgC;AlBs2WpC;AgD9zXI;EACE,yB9Byd8B;AlBu2WpC;AqBhkYE;E2BmQM,yB9Bsd4B;AlB02WpC;;AgDxzXE;EACE,W9BrRO;AlBglYX;AqBvkYE;E2B+QI,W9BxRK;AlBmlYX;AgDtzXI;EACE,+B9B2b8B;AlB63WpC;AqB7kYE;E2BwRM,gC9Byb4B;AlB+3WpC;AgDrzXM;EACE,gC9Bub4B;AlBg4WpC;AgDnzXI;;;;EAIE,W9B7SK;AlBkmYX;AgDjzXE;EACE,+B9BuagC;E8BtahC,sC9B2agC;AlBw4WpC;AgDhzXE;EACE,yDAAA;AhDkzXJ;AgD/yXE;EACE,+B9B8ZgC;AlBm5WpC;AgDhzXI;EACE,W9B7TK;AlB+mYX;AqBtmYE;E2BuTM,W9BhUG;AlBknYX;;AiDrnYA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EAEA,qBAAA;EACA,sB7BqJQ;E6BpJR,2BAAA;EACA,sCAAA;EvBKE,sBAAA;A1BmnYJ;AiDrnYE;EACE,eAAA;EACA,cAAA;AjDunYJ;AiDpnYE;EACE,mBAAA;EACA,sBAAA;AjDsnYJ;AiDpnYI;EACE,mBAAA;EvBCF,2CAAA;EACA,4CAAA;A1BsnYJ;AiDpnYI;EACE,sBAAA;EvBUF,+CAAA;EACA,8CAAA;A1B6mYJ;AiDjnYE;;EAEE,aAAA;AjDmnYJ;;AiD/mYA;EAGE,cAAA;EAGA,eAAA;EACA,gB/BgxBkC;AlB81WpC;;AiD1mYA;EACE,sB/B0wBkC;AlBm2WpC;;AiD1mYA;EACE,qBAAA;EACA,gBAAA;AjD6mYF;;AiD1mYA;EACE,gBAAA;AjD6mYF;;AqBlqYE;E4B0DE,qBAAA;AjD4mYJ;AiDzmYE;EACE,oB/ByvBgC;AlBk3WpC;;AiDnmYA;EACE,wBAAA;EACA,gBAAA;EAEA,qC/BkvBkC;E+BjvBlC,6CAAA;AjDqmYF;AiDnmYE;EvBvEE,0DAAA;A1B6qYJ;;AiDjmYA;EACE,wBAAA;EAEA,qC/BuuBkC;E+BtuBlC,0CAAA;AjDmmYF;AiDjmYE;EvBlFE,0DAAA;A1BsrYJ;;AiD1lYA;EACE,uBAAA;EACA,uBAAA;EACA,sBAAA;EACA,gBAAA;AjD6lYF;;AiD1lYA;EACE,uBAAA;EACA,sBAAA;AjD6lYF;;AiDzlYA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,gB/B6sBkC;EQ5zBhC,kCAAA;A1B4sYJ;;AiDzlYA;;;EAGE,cAAA;EACA,WAAA;AjD4lYF;;AiDzlYA;;EvBjHI,2CAAA;EACA,4CAAA;A1B+sYJ;;AiD1lYA;;EvBxGI,+CAAA;EACA,8CAAA;A1BusYJ;;AiDvlYE;EACE,mB/BqrBgC;AlBq6WpC;A8BzrYI;EmB6FJ;IAMI,aAAA;IACA,mBAAA;IACA,mBAAA;IACA,kBAAA;EjD0lYF;EiDxlYE;IAEE,SAAA;IACA,kB/ByqB8B;I+BxqB9B,gBAAA;IACA,iB/BuqB8B;ElBk7WlC;AACF;;AiD7kYE;EACE,mB/BypBgC;AlBu7WpC;A8B3sYI;EmBuHJ;IAQI,aAAA;IACA,mBAAA;EjDglYF;EiD7kYE;IAEE,SAAA;IACA,gBAAA;EjD8kYJ;EiD5kYI;IACE,cAAA;IACA,cAAA;EjD8kYN;EiDzkYM;IvBzKJ,0BAAA;IACA,6BAAA;E1BqvYF;EiD1kYQ;;IAGE,0BAAA;EjD2kYV;EiDzkYQ;;IAGE,6BAAA;EjD0kYV;EiDtkYM;IvB1KJ,yBAAA;IACA,4BAAA;E1BmvYF;EiDvkYQ;;IAGE,yBAAA;EjDwkYV;EiDtkYQ;;IAGE,4BAAA;EjDukYV;AACF;;AiD1jYE;EACE,sB/B8kBgC;AlB++WpC;A8BrvYI;EmBsLJ;IAMI,e/B2lBgC;I+B1lBhC,mB/B2lBgC;I+B1lBhC,UAAA;IACA,SAAA;EjD6jYF;EiD3jYE;IACE,qBAAA;IACA,WAAA;EjD6jYJ;AACF;;AiDpjYA;EACE,qBAAA;AjDujYF;AiDrjYE;EACE,gBAAA;AjDujYJ;AiDrjYI;EACE,gBAAA;EvBvOF,6BAAA;EACA,4BAAA;A1B+xYJ;AiDrjYI;EvBzPA,yBAAA;EACA,0BAAA;A1BizYJ;AiDrjYI;EvBtQA,gBAAA;EuBwQE,mBAAA;AjDujYN;;AkDj1YA;EACE,aAAA;EACA,eAAA;EACA,wBAAA;EACA,mB9BmSkC;EDnH9B,mBAAA;E+B9KJ,gBAAA;EACA,6B9BkSkC;EMvRhC,sBAAA;A1B00YJ;;AkD/0YE;EACE,oB9BwRgC;ApB0jYpC;AkDh1YI;EACE,WAAA;EACA,qB9BoR8B;E8BnR9B,chCNK;EgCOL,YAAA;AlDk1YN;AkDx0YE;EACE,0BAAA;AlD00YJ;AkDv0YE;EACE,qBAAA;AlDy0YJ;AkDt0YE;EACE,chCzBO;AlBi2YX;;AmD/2YA;EACE,aAAA;E5BGA,eAAA;EACA,gBAAA;EGaE,sBAAA;A1Bo2YJ;;AmDh3YA;EACE,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,iBAAA;EACA,iBjCoxBkC;EiCnxBlC,cjCmKwC;EiCjKxC,yB/B2CW;E+B1CX,yBAAA;AnDk3YF;AmDh3YE;EACE,UAAA;EACA,cjC8JsC;EiC7JtC,qBAAA;EACA,yBjCZO;EiCaP,qBjCZO;AlB83YX;AmD/2YE;EACE,UAAA;EACA,UjC4wBgC;EiC3wBhC,gDjC+W0B;AlBkgY9B;;AmD32YI;EACE,cAAA;EzBaF,+BAAA;EACA,kCAAA;A1Bk2YJ;AmD32YI;EzBNA,gCAAA;EACA,mCAAA;A1Bo3YJ;AmD12YE;EACE,UAAA;EACA,WjCxCO;EiCyCP,yBjC0M0B;EiCzM1B,qBjCyM0B;AlBmqY9B;AmDz2YE;EACE,cjCxCO;EiCyCP,oBAAA;EAEA,YAAA;EACA,sBjClDO;EiCmDP,qBjChDO;AlB05YX;;AoDj6YE;EACE,uBAAA;EjCgLE,kBAAA;EiC9KF,gBlCmO0B;AlBisY9B;AoD/5YM;E1BqCF,8BAAA;EACA,iCAAA;A1B63YJ;AoD95YM;E1BkBF,+BAAA;EACA,kCAAA;A1B+4YJ;;AoD/6YE;EACE,uBAAA;EjCgLE,mBAAA;EiC9KF,gBlCoO0B;AlB8sY9B;AoD76YM;E1BqCF,8BAAA;EACA,iCAAA;A1B24YJ;AoD56YM;E1BkBF,+BAAA;EACA,kCAAA;A1B65YJ;;AqD37YA;EACE,qBAAA;EACA,qBAAA;ElC6JE,cAAA;EkC3JF,gBnCwR4B;EmCvR5B,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;E3BKE,sBAAA;ESFE,qIkBDJ;ArD87YF;AmCz7YM;EkBfN;IlBgBQ,gBAAA;EnC47YN;AACF;AqBl8YE;EgCGI,qBAAA;ArDk8YN;;AqD77YE;EACE,aAAA;ArDg8YJ;;AqD37YA;EACE,kBAAA;EACA,SAAA;ArD87YF;;AqDv7YA;EACE,oBnCi4BkC;EmCh4BlC,mBnCg4BkC;EQv5BhC,oBAAA;A1Bk9YJ;;AqDl7YE;ECjDA,WAAA;EACA,yBpC0Ea;AlB65Yf;AqBz9YE;EiCVI,WAAA;EACA,yBAAA;AtDs+YN;AsDn+YI;EAEE,UAAA;EACA,+CAAA;AtDo+YN;;AqD/7YE;ECjDA,cAAA;EACA,yBpC0Ea;AlB06Yf;AqBt+YE;EiCVI,cAAA;EACA,yBAAA;AtDm/YN;AsDh/YI;EAEE,UAAA;EACA,iDAAA;AtDi/YN;;AqD58YE;ECjDA,WAAA;EACA,yBpC0Ea;AlBu7Yf;AqBn/YE;EiCVI,WAAA;EACA,yBAAA;AtDggZN;AsD7/YI;EAEE,UAAA;EACA,8CAAA;AtD8/YN;;AqDz9YE;ECjDA,WAAA;EACA,yBpC0Ea;AlBo8Yf;AqBhgZE;EiCVI,WAAA;EACA,yBAAA;AtD6gZN;AsD1gZI;EAEE,UAAA;EACA,gDAAA;AtD2gZN;;AqDt+YE;ECjDA,cAAA;EACA,yBpC0Ea;AlBi9Yf;AqB7gZE;EiCVI,cAAA;EACA,yBAAA;AtD0hZN;AsDvhZI;EAEE,UAAA;EACA,+CAAA;AtDwhZN;;AqDn/YE;ECjDA,WAAA;EACA,yBpC0Ea;AlB89Yf;AqB1hZE;EiCVI,WAAA;EACA,yBAAA;AtDuiZN;AsDpiZI;EAEE,UAAA;EACA,+CAAA;AtDqiZN;;AqDhgZE;ECjDA,cAAA;EACA,yBpC0Ea;AlB2+Yf;AqBviZE;EiCVI,cAAA;EACA,yBAAA;AtDojZN;AsDjjZI;EAEE,UAAA;EACA,iDAAA;AtDkjZN;;AqD7gZE;ECjDA,WAAA;EACA,yBpC0Ea;AlBw/Yf;AqBpjZE;EiCVI,WAAA;EACA,uBAAA;AtDikZN;AsD9jZI;EAEE,UAAA;EACA,8CAAA;AtD+jZN;;AuD5kZA;EACE,kBAAA;EACA,mBrCyzBkC;EqCvzBlC,yBrCKS;EQSP,qBAAA;A1BikZJ;A8BvhZI;EyB5DJ;IAQI,kBAAA;EvD+kZF;AACF;;AuD5kZA;EACE,gBAAA;EACA,eAAA;E7BIE,gBAAA;A1B4kZJ;;AwD1lZA;EACE,kBAAA;EACA,wBAAA;EACA,mBtCy9BkC;EsCx9BlC,6BAAA;E9BUE,sBAAA;A1BolZJ;;AwDzlZA;EAEE,cAAA;AxD2lZF;;AwDvlZA;EACE,gBtC6Q4B;AlB60Y9B;;AwDllZA;EACE,mBAAA;AxDqlZF;AwDllZE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,wBAAA;EACA,cAAA;AxDolZJ;;AwD1kZE;EC/CA,cDgDqH;EnB3CnH,yBmB2CuB;EC9CzB,qBD8CqE;AxD+kZvE;AyD3nZE;EACE,yBAAA;AzD6nZJ;AyD1nZE;EACE,cAAA;AzD4nZJ;;AwDtlZE;EC/CA,cDgDqH;EnB3CnH,yBmB2CuB;EC9CzB,qBD8CqE;AxD2lZvE;AyDvoZE;EACE,yBAAA;AzDyoZJ;AyDtoZE;EACE,cAAA;AzDwoZJ;;AwDlmZE;EC/CA,cDgDqH;EnB3CnH,yBmB2CuB;EC9CzB,qBD8CqE;AxDumZvE;AyDnpZE;EACE,yBAAA;AzDqpZJ;AyDlpZE;EACE,cAAA;AzDopZJ;;AwD9mZE;EC/CA,cDgDqH;EnB3CnH,yBmB2CuB;EC9CzB,qBD8CqE;AxDmnZvE;AyD/pZE;EACE,yBAAA;AzDiqZJ;AyD9pZE;EACE,cAAA;AzDgqZJ;;AwD1nZE;EC/CA,cDgDqH;EnB3CnH,yBmB2CuB;EC9CzB,qBD8CqE;AxD+nZvE;AyD3qZE;EACE,yBAAA;AzD6qZJ;AyD1qZE;EACE,cAAA;AzD4qZJ;;AwDtoZE;EC/CA,cDgDqH;EnB3CnH,yBmB2CuB;EC9CzB,qBD8CqE;AxD2oZvE;AyDvrZE;EACE,yBAAA;AzDyrZJ;AyDtrZE;EACE,cAAA;AzDwrZJ;;AwDlpZE;EC/CA,cDgDqH;EnB3CnH,uBmB2CuB;EC9CzB,mBD8CqE;AxDupZvE;AyDnsZE;EACE,yBAAA;AzDqsZJ;AyDlsZE;EACE,cAAA;AzDosZJ;;AwD9pZE;EC/CA,cDgDqH;EnB3CnH,yBmB2CuB;EC9CzB,qBD8CqE;AxDmqZvE;AyD/sZE;EACE,yBAAA;AzDitZJ;AyD9sZE;EACE,YAAA;AzDgtZJ;;A0DxtZE;EACE;IAAO,2BAAA;E1D4tZT;E0D3tZE;IAAK,wBAAA;E1D8tZP;AACF;A0D3tZA;EACE,aAAA;EACA,YxCk+BkC;EwCj+BlC,gBAAA;EACA,cAAA;EvCwKI,kBAAA;EuCtKJ,yBtCiPY;EM7OV,sBAAA;A1B0tZJ;;A0DztZA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,WxCjBS;EwCkBT,kBAAA;EACA,mBAAA;EACA,yBxCu9BkC;EiBl+B9B,2BuBYJ;A1D4tZF;AmCpuZM;EuBDN;IvBEQ,gBAAA;EnCuuZN;AACF;;A0D9tZA;ErBYE,qMAAA;EqBVA,0BAAA;A1DiuZF;;A0D7tZE;EACE,kDAAA;A1DguZJ;A0D7tZM;EAJJ;IAKM,eAAA;E1DguZN;AACF;;A2D3wZA;EACE,aAAA;EACA,uBAAA;A3D8wZF;;A2D3wZA;EACE,SAAA;A3D8wZF;;A4DhxZA;EACE,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;ElCQE,sBAAA;A1B0wZJ;;A4DxwZA;EACE,WAAA;EACA,c1CRS;E0CST,mBAAA;A5D2wZF;AqBlxZE;EuCWE,UAAA;EACA,c1CdO;E0CeP,qBAAA;EACA,yB1CtBO;AlBgyZX;A4DvwZE;EACE,c1ClBO;E0CmBP,yB1C1BO;AlBmyZX;;A4DhwZA;EACE,kBAAA;EACA,cAAA;EACA,wBAAA;EAGA,sB1C3CS;E0C4CT,sCAAA;A5DiwZF;A4D/vZE;ElC1BE,+BAAA;EACA,gCAAA;A1B4xZJ;A4D/vZE;ElChBE,mCAAA;EACA,kCAAA;A1BkxZJ;A4D/vZE;EAEE,c1ClDO;E0CmDP,oBAAA;EACA,sB1C1DO;AlB0zZX;A4D5vZE;EACE,UAAA;EACA,W1ChEO;E0CiEP,yB1CkL0B;E0CjL1B,qB1CiL0B;AlB6kZ9B;A4D3vZE;EACE,mBAAA;A5D6vZJ;A4D3vZI;EACE,gBAAA;EACA,qB1C2JwB;AlBkmZ9B;;A4D/uZI;EACE,mBAAA;A5DkvZN;A4D/uZQ;ElC1BJ,kCAAA;EAZA,0BAAA;A1ByxZJ;A4D9uZQ;ElC3CJ,gCAAA;EAYA,4BAAA;A1BixZJ;A4D7uZQ;EACE,aAAA;A5D+uZV;A4D5uZQ;EACE,qB1C0HoB;E0CzHpB,oBAAA;A5D8uZV;A4D5uZU;EACE,iBAAA;EACA,sB1CqHkB;AlBynZ9B;;A8BzyZI;E8BmCA;IACE,mBAAA;E5D0wZJ;E4DvwZM;IlC1BJ,kCAAA;IAZA,0BAAA;E1BizZF;E4DtwZM;IlC3CJ,gCAAA;IAYA,4BAAA;E1ByyZF;E4DrwZM;IACE,aAAA;E5DuwZR;E4DpwZM;IACE,qB1C0HoB;I0CzHpB,oBAAA;E5DswZR;E4DpwZQ;IACE,iBAAA;IACA,sB1CqHkB;ElBipZ5B;AACF;A8Bl0ZI;E8BmCA;IACE,mBAAA;E5DkyZJ;E4D/xZM;IlC1BJ,kCAAA;IAZA,0BAAA;E1By0ZF;E4D9xZM;IlC3CJ,gCAAA;IAYA,4BAAA;E1Bi0ZF;E4D7xZM;IACE,aAAA;E5D+xZR;E4D5xZM;IACE,qB1C0HoB;I0CzHpB,oBAAA;E5D8xZR;E4D5xZQ;IACE,iBAAA;IACA,sB1CqHkB;ElByqZ5B;AACF;A8B11ZI;E8BmCA;IACE,mBAAA;E5D0zZJ;E4DvzZM;IlC1BJ,kCAAA;IAZA,0BAAA;E1Bi2ZF;E4DtzZM;IlC3CJ,gCAAA;IAYA,4BAAA;E1By1ZF;E4DrzZM;IACE,aAAA;E5DuzZR;E4DpzZM;IACE,qB1C0HoB;I0CzHpB,oBAAA;E5DszZR;E4DpzZQ;IACE,iBAAA;IACA,sB1CqHkB;ElBisZ5B;AACF;A8Bl3ZI;E8BmCA;IACE,mBAAA;E5Dk1ZJ;E4D/0ZM;IlC1BJ,kCAAA;IAZA,0BAAA;E1By3ZF;E4D90ZM;IlC3CJ,gCAAA;IAYA,4BAAA;E1Bi3ZF;E4D70ZM;IACE,aAAA;E5D+0ZR;E4D50ZM;IACE,qB1C0HoB;I0CzHpB,oBAAA;E5D80ZR;E4D50ZQ;IACE,iBAAA;IACA,sB1CqHkB;ElBytZ5B;AACF;A4Dj0ZA;ElCnHI,gBAAA;A1Bu7ZJ;A4Dj0ZE;EACE,qBAAA;A5Dm0ZJ;A4Dj0ZI;EACE,sBAAA;A5Dm0ZN;;A6D58ZE;EACE,cDoJsE;ECnJtE,yBDmJuC;A5D4zZ3C;AqBp8ZE;EwCPM,cD+IkE;EC9IlE,yBAAA;A7D88ZR;A6D38ZM;EACE,cAAA;EACA,yBDyIkE;ECxIlE,qBDwIkE;A5Dq0Z1E;;A6D19ZE;EACE,cDoJsE;ECnJtE,yBDmJuC;A5D00Z3C;AqBl9ZE;EwCPM,cD+IkE;EC9IlE,yBAAA;A7D49ZR;A6Dz9ZM;EACE,cAAA;EACA,yBDyIkE;ECxIlE,qBDwIkE;A5Dm1Z1E;;A6Dx+ZE;EACE,cDoJsE;ECnJtE,yBDmJuC;A5Dw1Z3C;AqBh+ZE;EwCPM,cD+IkE;EC9IlE,yBAAA;A7D0+ZR;A6Dv+ZM;EACE,cAAA;EACA,yBDyIkE;ECxIlE,qBDwIkE;A5Di2Z1E;;A6Dt/ZE;EACE,cDoJsE;ECnJtE,yBDmJuC;A5Ds2Z3C;AqB9+ZE;EwCPM,cD+IkE;EC9IlE,yBAAA;A7Dw/ZR;A6Dr/ZM;EACE,cAAA;EACA,yBDyIkE;ECxIlE,qBDwIkE;A5D+2Z1E;;A6DpgaE;EACE,cDoJsE;ECnJtE,yBDmJuC;A5Do3Z3C;AqB5/ZE;EwCPM,cD+IkE;EC9IlE,yBAAA;A7DsgaR;A6DngaM;EACE,cAAA;EACA,yBDyIkE;ECxIlE,qBDwIkE;A5D63Z1E;;A6DlhaE;EACE,cDoJsE;ECnJtE,yBDmJuC;A5Dk4Z3C;AqB1gaE;EwCPM,cD+IkE;EC9IlE,yBAAA;A7DohaR;A6DjhaM;EACE,cAAA;EACA,yBDyIkE;ECxIlE,qBDwIkE;A5D24Z1E;;A6DhiaE;EACE,cDoJsE;ECnJtE,uBDmJuC;A5Dg5Z3C;AqBxhaE;EwCPM,cD+IkE;EC9IlE,yBAAA;A7DkiaR;A6D/haM;EACE,cAAA;EACA,yBDyIkE;ECxIlE,qBDwIkE;A5Dy5Z1E;;A6D9iaE;EACE,cDoJsE;ECnJtE,yBDmJuC;A5D85Z3C;AqBtiaE;EwCPM,cD+IkE;EC9IlE,yBAAA;A7DgjaR;A6D7iaM;EACE,cAAA;EACA,yBDyIkE;ECxIlE,qBDwIkE;A5Du6Z1E;;A8D/jaA;EACE,YAAA;E3CmLI,iBAAA;E2CjLJ,gB5C8R4B;E4C7R5B,cAAA;EACA,W5CYS;E4CXT,yB5CylCkC;E4CxlClC,YAAA;A9DkkaF;AqB7jaE;EyCDE,W5CMO;E4CLP,qBAAA;A9DikaJ;AqB7jaE;EyCCI,aAAA;A9D+jaN;;A8DpjaA;EACE,UAAA;EACA,6BAAA;EACA,SAAA;A9DujaF;;A8DjjaA;EACE,oBAAA;A9DojaF;;A+D1laA;EAGE,iB7C24BkC;E6C14BlC,gB7C04BkC;EC1tB9B,mBAAA;E4C7KJ,2C7C44BkC;E6C34BlC,4BAAA;EACA,oCAAA;EACA,gD7C64BkC;E6C54BlC,UAAA;ErCOE,sBAAA;A1BolaJ;A+DxlaE;EACE,sB7Cg4BgC;AlB0tYpC;A+DvlaE;EACE,UAAA;A/DylaJ;A+DtlaE;EACE,cAAA;EACA,UAAA;A/DwlaJ;A+DrlaE;EACE,aAAA;A/DulaJ;;A+DnlaA;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,c7CvBS;E6CwBT,2C7Cq3BkC;E6Cp3BlC,4BAAA;EACA,4CAAA;ErCZE,2CAAA;EACA,4CAAA;A1BmmaJ;;A+DplaA;EACE,gB7Cm2BkC;AlBovYpC;;AgE7naA;EAEE,gBAAA;AhE+naF;AgE7naE;EACE,kBAAA;EACA,gBAAA;AhE+naJ;;AgE1naA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a9C4pBkC;E8C3pBlC,aAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EAGA,UAAA;AhE2naF;;AgEpnaA;EACE,kBAAA;EACA,WAAA;EACA,Y5CwRkC;E4CtRlC,oBAAA;AhEsnaF;AgEnnaE;E7B3BI,+B6B4BF;EACA,8B9Cu6BgC;AlB8sYpC;AmC9oaM;E6BuBJ;I7BtBM,gBAAA;EnCipaN;AACF;AgExnaE;EACE,e9Cq6BgC;AlBqtYpC;AgEtnaE;EACE,sB9Ck6BgC;AlBstYpC;;AgEpnaA;EACE,aAAA;EACA,6BAAA;AhEunaF;AgErnaE;EACE,8BAAA;EACA,gBAAA;AhEunaJ;AgEpnaE;;EAEE,cAAA;AhEsnaJ;AgEnnaE;EACE,gBAAA;AhEqnaJ;;AgEjnaA;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;AhEonaF;AgEjnaE;EACE,cAAA;EACA,0BAAA;EACA,mBAAA;EACA,WAAA;AhEmnaJ;AgE/maE;EACE,sBAAA;EACA,uBAAA;EACA,YAAA;AhEinaJ;AgE/maI;EACE,gBAAA;AhEinaN;AgE9maI;EACE,aAAA;AhEgnaN;;AgE1maA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAGA,oBAAA;EACA,yB5CzDW;E4C0DX,4BAAA;EACA,yBAAA;EtClGE,qBAAA;EsCsGF,UAAA;AhEymaF;;AgErmaA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a9CgjBkC;E8C/iBlC,YAAA;EACA,aAAA;EACA,sB5CtHkB;ApB8tapB;AgErmaE;EAAS,UAAA;AhEwmaX;AgEvmaE;EAAS,Y5C+LyB;ApB26ZpC;;AgErmaA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,kB9C6zBkC;E8C5zBlC,gCAAA;EtCtHE,0CAAA;EACA,2CAAA;A1B+taJ;AgEvmaE;EACE,kB9CwzBgC;E8CtzBhC,8BAAA;AhEwmaJ;;AgEnmaA;EACE,gBAAA;EACA,gB9CuI4B;AlB+9Z9B;;AgEjmaA;EACE,kBAAA;EAGA,cAAA;EACA,kB5CqJkC;ApB68ZpC;;AgE9laA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,6BAAA;EtCzIE,8CAAA;EACA,6CAAA;A1B2uaJ;AgE7laE;EACE,eAAA;AhE+laJ;;AgE1laA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AhE6laF;;A8BpuaI;EkC6IF;IACE,gB5CgJgC;I4C/IhC,iBAAA;EhE2laF;EgExlaA;IACE,6BAAA;EhE0laF;EgExlaE;IACE,8BAAA;EhE0laJ;EgEtlaA;IACE,6BAAA;EhEwlaF;EgEtlaE;IACE,0BAAA;IACA,mBAAA;EhEwlaJ;EgEhlaA;IAAY,gB5CwHsB;EpB29ZlC;AACF;A8B3vaI;EkC2KF;;IAEE,c5CgHgC;EpBm+ZlC;AACF;A8BjwaI;EkCkLF;IAAY,iB9CiuBsB;ElBk3YlC;AACF;AiEj0aA;EACE,kBAAA;EACA,a/CgrBkC;E+C/qBlC,cAAA;EACA,S/C61BkC;EgDj2BlC,qNhDoR4B;EgDlR5B,kBAAA;EACA,gBhD4R4B;EgD3R5B,gBhDgS4B;EgD/R5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;E/CqKI,kBAAA;E8CzKJ,qBAAA;EACA,UAAA;AjE60aF;AiE30aE;EAAS,Y/Ci1ByB;AlB6/YpC;AiE50aE;EACE,kBAAA;EACA,cAAA;EACA,a/Ci1BgC;E+Ch1BhC,c/Ci1BgC;AlB6/YpC;AiE50aI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AjE80aN;;AiEz0aA;EACE,iBAAA;AjE40aF;AiE10aE;EACE,SAAA;AjE40aJ;AiE10aI;EACE,MAAA;EACA,6BAAA;EACA,sB/CvBK;AlBm2aX;;AiEv0aA;EACE,iBAAA;AjE00aF;AiEx0aE;EACE,OAAA;EACA,a/CmzBgC;E+ClzBhC,c/CizBgC;AlByhZpC;AiEx0aI;EACE,QAAA;EACA,oCAAA;EACA,wB/CvCK;AlBi3aX;;AiEr0aA;EACE,iBAAA;AjEw0aF;AiEt0aE;EACE,MAAA;AjEw0aJ;AiEt0aI;EACE,SAAA;EACA,6BAAA;EACA,yB/CrDK;AlB63aX;;AiEn0aA;EACE,iBAAA;AjEs0aF;AiEp0aE;EACE,QAAA;EACA,a/CqxBgC;E+CpxBhC,c/CmxBgC;AlBmjZpC;AiEp0aI;EACE,OAAA;EACA,oCAAA;EACA,uB/CrEK;AlB24aX;;AiEjzaA;EACE,gB/C+uBkC;E+C9uBlC,uBAAA;EACA,W/CvGS;E+CwGT,kBAAA;EACA,sB/C/FS;EQCP,uBAAA;A1Bm5aJ;;AmEr6aA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,ajD8qBkC;EiD7qBlC,cAAA;EACA,gBjD+2BkC;EgDp3BlC,qNhDoR4B;EgDlR5B,kBAAA;EACA,gBhD4R4B;EgD3R5B,gBhDgS4B;EgD/R5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;E/CqKI,mBAAA;EgDxKJ,qBAAA;EACA,yB/C+LW;E+C9LX,4BAAA;EACA,yBAAA;EzCGE,qBAAA;A1Bg7aJ;AmE/6aE;EACE,kBAAA;EACA,cAAA;EACA,WjD+2BgC;EiD92BhC,cjD+2BgC;EiD92BhC,gBAAA;AnEi7aJ;AmE/6aI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AnEg7aN;;AmE36aA;EACE,qBjDg2BkC;AlB8kZpC;AmE56aE;EACE,2BAAA;AnE86aJ;AmE56aI;EACE,SAAA;EACA,6BAAA;EACA,yB/CcS;ApBg6af;AmE36aI;EACE,WjD0LwB;EiDzLxB,6BAAA;EACA,yB/CwJO;ApBqxab;;AmEx6aA;EACE,mBjD40BkC;AlB+lZpC;AmEz6aE;EACE,yBAAA;EACA,ajDw0BgC;EiDv0BhC,YjDs0BgC;EiDr0BhC,gBAAA;AnE26aJ;AmEz6aI;EACE,OAAA;EACA,oCAAA;EACA,2B/CTS;ApBo7af;AmEx6aI;EACE,SjDmKwB;EiDlKxB,oCAAA;EACA,2B/CiIO;ApByyab;;AmEr6aA;EACE,kBjDqzBkC;AlBmnZpC;AmEt6aE;EACE,wBAAA;AnEw6aJ;AmEt6aI;EACE,MAAA;EACA,oCAAA;EACA,4B/C7BS;ApBq8af;AmEr6aI;EACE,QjD+IwB;EiD9IxB,oCAAA;EACA,4B/C6GO;ApB0zab;AmEl6aE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,WjD4xBgC;EiD3xBhC,oBAAA;EACA,WAAA;EACA,gCAAA;AnEo6aJ;;AmEh6aA;EACE,oBjDqxBkC;AlB8oZpC;AmEj6aE;EACE,0BAAA;EACA,ajDixBgC;EiDhxBhC,YjD+wBgC;EiD9wBhC,gBAAA;AnEm6aJ;AmEj6aI;EACE,QAAA;EACA,oCAAA;EACA,0B/ChES;ApBm+af;AmEh6aI;EACE,UjD4GwB;EiD3GxB,oCAAA;EACA,0B/C0EO;ApBw1ab;;AmE54aA;EACE,uBAAA;EACA,gBAAA;EhD0BI,eAAA;EgDvBJ,yB/C+CW;E+C9CX,8BAAA;EzCnIE,0CAAA;EACA,2CAAA;A1BkhbJ;AmE74aE;EACE,aAAA;AnE+4aJ;;AmE34aA;EACE,uBAAA;EACA,cjDxJS;AlBsibX;;AoEzibA;EACE,kBAAA;ApE4ibF;;AoEzibA;EACE,mBAAA;ApE4ibF;;AoEzibA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;ApE4ibF;AqEnkbE;EACE,cAAA;EACA,WAAA;EACA,WAAA;ArEqkbJ;;AoE7ibA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EjClBI,sCiCmBJ;ApEgjbF;AmC/jbM;EiCQN;IjCPQ,gBAAA;EnCkkbN;AACF;;AoEljbA;;;EAGE,cAAA;ApEqjbF;;AoEljbA;;EAEE,2BAAA;ApEqjbF;;AoEljbA;;EAEE,4BAAA;ApEqjbF;;AoE5ibE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;ApE+ibJ;AoE5ibE;;;EAGE,UAAA;EACA,UAAA;ApE8ibJ;AoE3ibE;;EAEE,UAAA;EACA,UAAA;EjC5DE,2BiC6DF;ApE6ibJ;AmCtmbM;EiCqDJ;;IjCpDM,gBAAA;EnC0mbN;AACF;;AoE1ibA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UlDs9BmC;EkDr9BnC,UAAA;EACA,WlD3FS;EkD4FT,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,YlDi9BmC;EiBviC/B,8BiCuFJ;ApE4ibF;AmC/nbM;EiCkEN;;IjCjEQ,gBAAA;EnCmobN;AACF;AqBzobE;;;E+C2FE,WlDpGO;EkDqGP,qBAAA;EACA,UAAA;EACA,YlD08BiC;AlBymZrC;;AoEhjbA;EACE,OAAA;ApEmjbF;;AoE9ibA;EACE,QAAA;ApEijbF;;AoE1ibA;;EAEE,qBAAA;EACA,WlDm8BmC;EkDl8BnC,YlDk8BmC;EkDj8BnC,mCAAA;ApE6ibF;;AoE3ibA;EACE,yDAAA;ApE8ibF;;AoE5ibA;EACE,yDAAA;ApE+ibF;;AoEtibA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EAEA,iBlDy5BmC;EkDx5BnC,gBlDw5BmC;EkDv5BnC,gBAAA;ApEwibF;AoEtibE;EACE,uBAAA;EACA,cAAA;EACA,WlDu5BiC;EkDt5BjC,WlDu5BiC;EkDt5BjC,iBlDw5BiC;EkDv5BjC,gBlDu5BiC;EkDt5BjC,mBAAA;EACA,eAAA;EACA,sBlDnKO;EkDoKP,4BAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YAAA;EjC/JE,6BiCgKF;ApEuibJ;AmCnsbM;EiC6IJ;IjC5IM,gBAAA;EnCssbN;AACF;AoEzibE;EACE,UAAA;ApE2ibJ;;AoElibA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,oBAAA;EACA,WlD9LS;EkD+LT,kBAAA;ApEqibF;;AsEvubA;EACE;IAAK,yBAAA;EtE2ubL;AACF;AsEzubA;EACE,qBAAA;EACA,WpDskCwB;EoDrkCxB,YpDqkCwB;EoDpkCxB,wBpDskCwB;EoDrkCxB,iCAAA;EACA,+BAAA;EAEA,kBAAA;EACA,+CAAA;AtE0ubF;;AsEvubA;EACE,WpDgkCwB;EoD/jCxB,YpD+jCwB;EoD9jCxB,mBpDgkCwB;AlB0qZ1B;;AsEnubA;EACE;IACE,mBAAA;EtEsubF;EsEpubA;IACE,UAAA;IACA,eAAA;EtEsubF;AACF;AsEnubA;EACE,qBAAA;EACA,WpDsiCwB;EoDriCxB,YpDqiCwB;EoDpiCxB,wBpDsiCwB;EoDriCxB,8BAAA;EAEA,kBAAA;EACA,UAAA;EACA,6CAAA;AtEoubF;;AsEjubA;EACE,WpDgiCwB;EoD/hCxB,YpD+hCwB;AlBqsZ1B;;AsEhubE;EACE;;IAEE,wBAAA;EtEmubJ;AACF;AuE/xbA;EAAqB,mCAAA;AvEkybrB;;AuEjybA;EAAqB,8BAAA;AvEqybrB;;AuEpybA;EAAqB,iCAAA;AvEwybrB;;AuEvybA;EAAqB,iCAAA;AvE2ybrB;;AuE1ybA;EAAqB,sCAAA;AvE8ybrB;;AuE7ybA;EAAqB,mCAAA;AvEizbrB;;AwEnzbE;EACE,oCAAA;AxEszbJ;;AqB5ybE;;;EmDLI,oCAAA;AxEuzbN;;AwE7zbE;EACE,oCAAA;AxEg0bJ;;AqBtzbE;;;EmDLI,oCAAA;AxEi0bN;;AwEv0bE;EACE,oCAAA;AxE00bJ;;AqBh0bE;;;EmDLI,oCAAA;AxE20bN;;AwEj1bE;EACE,oCAAA;AxEo1bJ;;AqB10bE;;;EmDLI,oCAAA;AxEq1bN;;AwE31bE;EACE,oCAAA;AxE81bJ;;AqBp1bE;;;EmDLI,oCAAA;AxE+1bN;;AwEr2bE;EACE,oCAAA;AxEw2bJ;;AqB91bE;;;EmDLI,oCAAA;AxEy2bN;;AwE/2bE;EACE,oCAAA;AxEk3bJ;;AqBx2bE;;;EmDLI,oCAAA;AxEm3bN;;AwEz3bE;EACE,oCAAA;AxE43bJ;;AqBl3bE;;;EmDLI,kCAAA;AxE63bN;;AyE53bA;EACE,oCAAA;AzE+3bF;;AyE53bA;EACE,wCAAA;AzE+3bF;;A0E14bA;EAAkB,oCAAA;A1E84blB;;A0E74bA;EAAkB,wCAAA;A1Ei5blB;;A0Eh5bA;EAAkB,0CAAA;A1Eo5blB;;A0En5bA;EAAkB,2CAAA;A1Eu5blB;;A0Et5bA;EAAkB,yCAAA;A1E05blB;;A0Ex5bA;EAAmB,oBAAA;A1E45bnB;;A0E35bA;EAAmB,wBAAA;A1E+5bnB;;A0E95bA;EAAmB,0BAAA;A1Ek6bnB;;A0Ej6bA;EAAmB,2BAAA;A1Eq6bnB;;A0Ep6bA;EAAmB,yBAAA;A1Ew6bnB;;A0Er6bE;EACE,gCAAA;A1Ew6bJ;;A0Ez6bE;EACE,gCAAA;A1E46bJ;;A0E76bE;EACE,gCAAA;A1Eg7bJ;;A0Ej7bE;EACE,gCAAA;A1Eo7bJ;;A0Er7bE;EACE,gCAAA;A1Ew7bJ;;A0Ez7bE;EACE,gCAAA;A1E47bJ;;A0E77bE;EACE,gCAAA;A1Eg8bJ;;A0Ej8bE;EACE,gCAAA;A1Eo8bJ;;A0Eh8bA;EACE,gCAAA;A1Em8bF;;A0E57bA;EACE,gCAAA;A1E+7bF;;A0E57bA;EACE,iCAAA;A1E+7bF;;A0E57bA;EACE,0CAAA;EACA,2CAAA;A1E+7bF;;A0E57bA;EACE,2CAAA;EACA,8CAAA;A1E+7bF;;A0E57bA;EACE,8CAAA;EACA,6CAAA;A1E+7bF;;A0E57bA;EACE,0CAAA;EACA,6CAAA;A1E+7bF;;A0E57bA;EACE,gCAAA;A1E+7bF;;A0E57bA;EACE,6BAAA;A1E+7bF;;A0E57bA;EACE,+BAAA;A1E+7bF;;A0E57bA;EACE,2BAAA;A1E+7bF;;AqEvgcE;EACE,cAAA;EACA,WAAA;EACA,WAAA;ArE0gcJ;;A2EngcM;EAAwB,wBAAA;A3Eugc9B;;A2EvgcM;EAAwB,0BAAA;A3E2gc9B;;A2E3gcM;EAAwB,gCAAA;A3E+gc9B;;A2E/gcM;EAAwB,yBAAA;A3Emhc9B;;A2EnhcM;EAAwB,yBAAA;A3Euhc9B;;A2EvhcM;EAAwB,6BAAA;A3E2hc9B;;A2E3hcM;EAAwB,8BAAA;A3E+hc9B;;A2E/hcM;EAAwB,wBAAA;A3Emic9B;;A2EnicM;EAAwB,+BAAA;A3Euic9B;;A8Bt/bI;E6CjDE;IAAwB,wBAAA;E3E4ic5B;E2E5icI;IAAwB,0BAAA;E3E+ic5B;E2E/icI;IAAwB,gCAAA;E3Ekjc5B;E2EljcI;IAAwB,yBAAA;E3Eqjc5B;E2ErjcI;IAAwB,yBAAA;E3Ewjc5B;E2ExjcI;IAAwB,6BAAA;E3E2jc5B;E2E3jcI;IAAwB,8BAAA;E3E8jc5B;E2E9jcI;IAAwB,wBAAA;E3Eikc5B;E2EjkcI;IAAwB,+BAAA;E3Eokc5B;AACF;A8BphcI;E6CjDE;IAAwB,wBAAA;E3Eykc5B;E2EzkcI;IAAwB,0BAAA;E3E4kc5B;E2E5kcI;IAAwB,gCAAA;E3E+kc5B;E2E/kcI;IAAwB,yBAAA;E3Eklc5B;E2EllcI;IAAwB,yBAAA;E3Eqlc5B;E2ErlcI;IAAwB,6BAAA;E3Ewlc5B;E2ExlcI;IAAwB,8BAAA;E3E2lc5B;E2E3lcI;IAAwB,wBAAA;E3E8lc5B;E2E9lcI;IAAwB,+BAAA;E3Eimc5B;AACF;A8BjjcI;E6CjDE;IAAwB,wBAAA;E3Esmc5B;E2EtmcI;IAAwB,0BAAA;E3Eymc5B;E2EzmcI;IAAwB,gCAAA;E3E4mc5B;E2E5mcI;IAAwB,yBAAA;E3E+mc5B;E2E/mcI;IAAwB,yBAAA;E3Eknc5B;E2ElncI;IAAwB,6BAAA;E3Eqnc5B;E2ErncI;IAAwB,8BAAA;E3Ewnc5B;E2ExncI;IAAwB,wBAAA;E3E2nc5B;E2E3ncI;IAAwB,+BAAA;E3E8nc5B;AACF;A8B9kcI;E6CjDE;IAAwB,wBAAA;E3Emoc5B;E2EnocI;IAAwB,0BAAA;E3Esoc5B;E2EtocI;IAAwB,gCAAA;E3Eyoc5B;E2EzocI;IAAwB,yBAAA;E3E4oc5B;E2E5ocI;IAAwB,yBAAA;E3E+oc5B;E2E/ocI;IAAwB,6BAAA;E3Ekpc5B;E2ElpcI;IAAwB,8BAAA;E3Eqpc5B;E2ErpcI;IAAwB,wBAAA;E3Ewpc5B;E2ExpcI;IAAwB,+BAAA;E3E2pc5B;AACF;A2ElpcA;EAEI;IAAqB,wBAAA;E3EopcvB;E2EppcE;IAAqB,0BAAA;E3EupcvB;E2EvpcE;IAAqB,gCAAA;E3E0pcvB;E2E1pcE;IAAqB,yBAAA;E3E6pcvB;E2E7pcE;IAAqB,yBAAA;E3EgqcvB;E2EhqcE;IAAqB,6BAAA;E3EmqcvB;E2EnqcE;IAAqB,8BAAA;E3EsqcvB;E2EtqcE;IAAqB,wBAAA;E3EyqcvB;E2EzqcE;IAAqB,+BAAA;E3E4qcvB;AACF;A4ElscA;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;A5EoscF;A4ElscE;EACE,cAAA;EACA,WAAA;A5EoscJ;A4EjscE;;;;;EAKE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;A5EmscJ;;A4E1rcI;EACE,yBAAA;A5E6rcN;;A4E9rcI;EACE,mBAAA;A5EiscN;;A4ElscI;EACE,gBAAA;A5EqscN;;A4EtscI;EACE,iBAAA;A5EyscN;;A4E1scI;EACE,yBAAA;A5E6scN;;A4E9scI;EACE,mBAAA;A5EitcN;;A4EltcI;EACE,gBAAA;A5EqtcN;;A4EttcI;EACE,iBAAA;A5EytcN;;A6ElvcI;EAAgC,8BAAA;A7EsvcpC;;A6ErvcI;EAAgC,iCAAA;A7EyvcpC;;A6ExvcI;EAAgC,sCAAA;A7E4vcpC;;A6E3vcI;EAAgC,yCAAA;A7E+vcpC;;A6E7vcI;EAA8B,0BAAA;A7EiwclC;;A6EhwcI;EAA8B,4BAAA;A7EowclC;;A6EnwcI;EAA8B,kCAAA;A7EuwclC;;A6EtwcI;EAA8B,yBAAA;A7E0wclC;;A6EzwcI;EAA8B,uBAAA;A7E6wclC;;A6E5wcI;EAA8B,uBAAA;A7EgxclC;;A6E/wcI;EAA8B,yBAAA;A7EmxclC;;A6ElxcI;EAA8B,yBAAA;A7EsxclC;;A6EpxcI;EAAoC,sCAAA;A7EwxcxC;;A6EvxcI;EAAoC,oCAAA;A7E2xcxC;;A6E1xcI;EAAoC,kCAAA;A7E8xcxC;;A6E7xcI;EAAoC,yCAAA;A7EiycxC;;A6EhycI;EAAoC,wCAAA;A7EoycxC;;A6ElycI;EAAiC,kCAAA;A7EsycrC;;A6ErycI;EAAiC,gCAAA;A7EyycrC;;A6ExycI;EAAiC,8BAAA;A7E4ycrC;;A6E3ycI;EAAiC,gCAAA;A7E+ycrC;;A6E9ycI;EAAiC,+BAAA;A7EkzcrC;;A6EhzcI;EAAkC,oCAAA;A7EozctC;;A6EnzcI;EAAkC,kCAAA;A7EuzctC;;A6EtzcI;EAAkC,gCAAA;A7E0zctC;;A6EzzcI;EAAkC,uCAAA;A7E6zctC;;A6E5zcI;EAAkC,sCAAA;A7Eg0ctC;;A6E/zcI;EAAkC,iCAAA;A7Em0ctC;;A6Ej0cI;EAAgC,2BAAA;A7Eq0cpC;;A6Ep0cI;EAAgC,iCAAA;A7Ew0cpC;;A6Ev0cI;EAAgC,+BAAA;A7E20cpC;;A6E10cI;EAAgC,6BAAA;A7E80cpC;;A6E70cI;EAAgC,+BAAA;A7Ei1cpC;;A6Eh1cI;EAAgC,8BAAA;A7Eo1cpC;;A8Bx0cI;E+ClDA;IAAgC,8BAAA;E7E+3clC;E6E93cE;IAAgC,iCAAA;E7Ei4clC;E6Eh4cE;IAAgC,sCAAA;E7Em4clC;E6El4cE;IAAgC,yCAAA;E7Eq4clC;E6En4cE;IAA8B,0BAAA;E7Es4chC;E6Er4cE;IAA8B,4BAAA;E7Ew4chC;E6Ev4cE;IAA8B,kCAAA;E7E04chC;E6Ez4cE;IAA8B,yBAAA;E7E44chC;E6E34cE;IAA8B,uBAAA;E7E84chC;E6E74cE;IAA8B,uBAAA;E7Eg5chC;E6E/4cE;IAA8B,yBAAA;E7Ek5chC;E6Ej5cE;IAA8B,yBAAA;E7Eo5chC;E6El5cE;IAAoC,sCAAA;E7Eq5ctC;E6Ep5cE;IAAoC,oCAAA;E7Eu5ctC;E6Et5cE;IAAoC,kCAAA;E7Ey5ctC;E6Ex5cE;IAAoC,yCAAA;E7E25ctC;E6E15cE;IAAoC,wCAAA;E7E65ctC;E6E35cE;IAAiC,kCAAA;E7E85cnC;E6E75cE;IAAiC,gCAAA;E7Eg6cnC;E6E/5cE;IAAiC,8BAAA;E7Ek6cnC;E6Ej6cE;IAAiC,gCAAA;E7Eo6cnC;E6En6cE;IAAiC,+BAAA;E7Es6cnC;E6Ep6cE;IAAkC,oCAAA;E7Eu6cpC;E6Et6cE;IAAkC,kCAAA;E7Ey6cpC;E6Ex6cE;IAAkC,gCAAA;E7E26cpC;E6E16cE;IAAkC,uCAAA;E7E66cpC;E6E56cE;IAAkC,sCAAA;E7E+6cpC;E6E96cE;IAAkC,iCAAA;E7Ei7cpC;E6E/6cE;IAAgC,2BAAA;E7Ek7clC;E6Ej7cE;IAAgC,iCAAA;E7Eo7clC;E6En7cE;IAAgC,+BAAA;E7Es7clC;E6Er7cE;IAAgC,6BAAA;E7Ew7clC;E6Ev7cE;IAAgC,+BAAA;E7E07clC;E6Ez7cE;IAAgC,8BAAA;E7E47clC;AACF;A8Bj7cI;E+ClDA;IAAgC,8BAAA;E7Eu+clC;E6Et+cE;IAAgC,iCAAA;E7Ey+clC;E6Ex+cE;IAAgC,sCAAA;E7E2+clC;E6E1+cE;IAAgC,yCAAA;E7E6+clC;E6E3+cE;IAA8B,0BAAA;E7E8+chC;E6E7+cE;IAA8B,4BAAA;E7Eg/chC;E6E/+cE;IAA8B,kCAAA;E7Ek/chC;E6Ej/cE;IAA8B,yBAAA;E7Eo/chC;E6En/cE;IAA8B,uBAAA;E7Es/chC;E6Er/cE;IAA8B,uBAAA;E7Ew/chC;E6Ev/cE;IAA8B,yBAAA;E7E0/chC;E6Ez/cE;IAA8B,yBAAA;E7E4/chC;E6E1/cE;IAAoC,sCAAA;E7E6/ctC;E6E5/cE;IAAoC,oCAAA;E7E+/ctC;E6E9/cE;IAAoC,kCAAA;E7EigdtC;E6EhgdE;IAAoC,yCAAA;E7EmgdtC;E6ElgdE;IAAoC,wCAAA;E7EqgdtC;E6EngdE;IAAiC,kCAAA;E7EsgdnC;E6ErgdE;IAAiC,gCAAA;E7EwgdnC;E6EvgdE;IAAiC,8BAAA;E7E0gdnC;E6EzgdE;IAAiC,gCAAA;E7E4gdnC;E6E3gdE;IAAiC,+BAAA;E7E8gdnC;E6E5gdE;IAAkC,oCAAA;E7E+gdpC;E6E9gdE;IAAkC,kCAAA;E7EihdpC;E6EhhdE;IAAkC,gCAAA;E7EmhdpC;E6ElhdE;IAAkC,uCAAA;E7EqhdpC;E6EphdE;IAAkC,sCAAA;E7EuhdpC;E6EthdE;IAAkC,iCAAA;E7EyhdpC;E6EvhdE;IAAgC,2BAAA;E7E0hdlC;E6EzhdE;IAAgC,iCAAA;E7E4hdlC;E6E3hdE;IAAgC,+BAAA;E7E8hdlC;E6E7hdE;IAAgC,6BAAA;E7EgidlC;E6E/hdE;IAAgC,+BAAA;E7EkidlC;E6EjidE;IAAgC,8BAAA;E7EoidlC;AACF;A8BzhdI;E+ClDA;IAAgC,8BAAA;E7E+kdlC;E6E9kdE;IAAgC,iCAAA;E7EildlC;E6EhldE;IAAgC,sCAAA;E7EmldlC;E6ElldE;IAAgC,yCAAA;E7EqldlC;E6EnldE;IAA8B,0BAAA;E7EsldhC;E6ErldE;IAA8B,4BAAA;E7EwldhC;E6EvldE;IAA8B,kCAAA;E7E0ldhC;E6EzldE;IAA8B,yBAAA;E7E4ldhC;E6E3ldE;IAA8B,uBAAA;E7E8ldhC;E6E7ldE;IAA8B,uBAAA;E7EgmdhC;E6E/ldE;IAA8B,yBAAA;E7EkmdhC;E6EjmdE;IAA8B,yBAAA;E7EomdhC;E6ElmdE;IAAoC,sCAAA;E7EqmdtC;E6EpmdE;IAAoC,oCAAA;E7EumdtC;E6EtmdE;IAAoC,kCAAA;E7EymdtC;E6ExmdE;IAAoC,yCAAA;E7E2mdtC;E6E1mdE;IAAoC,wCAAA;E7E6mdtC;E6E3mdE;IAAiC,kCAAA;E7E8mdnC;E6E7mdE;IAAiC,gCAAA;E7EgndnC;E6E/mdE;IAAiC,8BAAA;E7EkndnC;E6EjndE;IAAiC,gCAAA;E7EondnC;E6EnndE;IAAiC,+BAAA;E7EsndnC;E6EpndE;IAAkC,oCAAA;E7EundpC;E6EtndE;IAAkC,kCAAA;E7EyndpC;E6ExndE;IAAkC,gCAAA;E7E2ndpC;E6E1ndE;IAAkC,uCAAA;E7E6ndpC;E6E5ndE;IAAkC,sCAAA;E7E+ndpC;E6E9ndE;IAAkC,iCAAA;E7EiodpC;E6E/ndE;IAAgC,2BAAA;E7EkodlC;E6EjodE;IAAgC,iCAAA;E7EoodlC;E6EnodE;IAAgC,+BAAA;E7EsodlC;E6ErodE;IAAgC,6BAAA;E7EwodlC;E6EvodE;IAAgC,+BAAA;E7E0odlC;E6EzodE;IAAgC,8BAAA;E7E4odlC;AACF;A8BjodI;E+ClDA;IAAgC,8BAAA;E7EurdlC;E6EtrdE;IAAgC,iCAAA;E7EyrdlC;E6ExrdE;IAAgC,sCAAA;E7E2rdlC;E6E1rdE;IAAgC,yCAAA;E7E6rdlC;E6E3rdE;IAA8B,0BAAA;E7E8rdhC;E6E7rdE;IAA8B,4BAAA;E7EgsdhC;E6E/rdE;IAA8B,kCAAA;E7EksdhC;E6EjsdE;IAA8B,yBAAA;E7EosdhC;E6EnsdE;IAA8B,uBAAA;E7EssdhC;E6ErsdE;IAA8B,uBAAA;E7EwsdhC;E6EvsdE;IAA8B,yBAAA;E7E0sdhC;E6EzsdE;IAA8B,yBAAA;E7E4sdhC;E6E1sdE;IAAoC,sCAAA;E7E6sdtC;E6E5sdE;IAAoC,oCAAA;E7E+sdtC;E6E9sdE;IAAoC,kCAAA;E7EitdtC;E6EhtdE;IAAoC,yCAAA;E7EmtdtC;E6EltdE;IAAoC,wCAAA;E7EqtdtC;E6EntdE;IAAiC,kCAAA;E7EstdnC;E6ErtdE;IAAiC,gCAAA;E7EwtdnC;E6EvtdE;IAAiC,8BAAA;E7E0tdnC;E6EztdE;IAAiC,gCAAA;E7E4tdnC;E6E3tdE;IAAiC,+BAAA;E7E8tdnC;E6E5tdE;IAAkC,oCAAA;E7E+tdpC;E6E9tdE;IAAkC,kCAAA;E7EiudpC;E6EhudE;IAAkC,gCAAA;E7EmudpC;E6EludE;IAAkC,uCAAA;E7EqudpC;E6EpudE;IAAkC,sCAAA;E7EuudpC;E6EtudE;IAAkC,iCAAA;E7EyudpC;E6EvudE;IAAgC,2BAAA;E7E0udlC;E6EzudE;IAAgC,iCAAA;E7E4udlC;E6E3udE;IAAgC,+BAAA;E7E8udlC;E6E7udE;IAAgC,6BAAA;E7EgvdlC;E6E/udE;IAAgC,+BAAA;E7EkvdlC;E6EjvdE;IAAgC,8BAAA;E7EovdlC;AACF;A8E/xdI;EAAwB,sBAAA;A9Ekyd5B;;A8EjydI;EAAwB,uBAAA;A9Eqyd5B;;A8EpydI;EAAwB,sBAAA;A9Ewyd5B;;A8BpvdI;EgDtDA;IAAwB,sBAAA;E9E+yd1B;E8E9ydE;IAAwB,uBAAA;E9Eizd1B;E8EhzdE;IAAwB,sBAAA;E9Emzd1B;AACF;A8BhwdI;EgDtDA;IAAwB,sBAAA;E9E0zd1B;E8EzzdE;IAAwB,uBAAA;E9E4zd1B;E8E3zdE;IAAwB,sBAAA;E9E8zd1B;AACF;A8B3wdI;EgDtDA;IAAwB,sBAAA;E9Eq0d1B;E8Ep0dE;IAAwB,uBAAA;E9Eu0d1B;E8Et0dE;IAAwB,sBAAA;E9Ey0d1B;AACF;A8BtxdI;EgDtDA;IAAwB,sBAAA;E9Eg1d1B;E8E/0dE;IAAwB,uBAAA;E9Ek1d1B;E8Ej1dE;IAAwB,sBAAA;E9Eo1d1B;AACF;A+E11dE;EAAyB,mCAAA;UAAA,2BAAA;A/E61d3B;;A+E71dE;EAAyB,oCAAA;UAAA,4BAAA;A/Ei2d3B;;A+Ej2dE;EAAyB,oCAAA;UAAA,4BAAA;A/Eq2d3B;;AgFr2dE;EAAsB,yBAAA;AhFy2dxB;;AgFz2dE;EAAsB,2BAAA;AhF62dxB;;AiF52dE;EAAyB,2BAAA;AjFg3d3B;;AiFh3dE;EAAyB,6BAAA;AjFo3d3B;;AiFp3dE;EAAyB,6BAAA;AjFw3d3B;;AiFx3dE;EAAyB,0BAAA;AjF43d3B;;AiF53dE;EAAyB,2BAAA;AjFg4d3B;;AiF33dA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,a/DiqBkC;AlB6tcpC;;AiF33dA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a/DypBkC;AlBqucpC;;AiF13dE;EADF;IAEI,gBAAA;IACA,MAAA;IACA,a/DipBgC;ElB6uclC;AACF;;AkFx5dA;ECEE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AnF05dF;;AmFh5dE;EAEE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;AnFk5dJ;;AoF/6dA;EAAa,8DAAA;ApFm7db;;AoFl7dA;EAAU,wDAAA;ApFs7dV;;AoFr7dA;EAAa,uDAAA;ApFy7db;;AoFx7dA;EAAe,2BAAA;ApF47df;;AqF37dI;EAAuB,qBAAA;ArF+7d3B;;AqF/7dI;EAAuB,qBAAA;ArFm8d3B;;AqFn8dI;EAAuB,qBAAA;ArFu8d3B;;AqFv8dI;EAAuB,sBAAA;ArF28d3B;;AqF38dI;EAAuB,sBAAA;ArF+8d3B;;AqF/8dI;EAAuB,sBAAA;ArFm9d3B;;AqFn9dI;EAAuB,sBAAA;ArFu9d3B;;AqFv9dI;EAAuB,sBAAA;ArF29d3B;;AqF39dI;EAAuB,uBAAA;ArF+9d3B;;AqF/9dI;EAAuB,uBAAA;ArFm+d3B;;AqF/9dA;EAAU,0BAAA;ArFm+dV;;AqFl+dA;EAAU,2BAAA;ArFs+dV;;AqFl+dA;EAAc,2BAAA;ArFs+dd;;AqFr+dA;EAAc,4BAAA;ArFy+dd;;AqFv+dA;EAAU,uBAAA;ArF2+dV;;AqF1+dA;EAAU,wBAAA;ArF8+dV;;AsFv/dQ;EAAgC,oBAAA;AtF2/dxC;;AsF1/dQ;;EAEE,wBAAA;AtF6/dV;;AsF3/dQ;;EAEE,0BAAA;AtF8/dV;;AsF5/dQ;;EAEE,2BAAA;AtF+/dV;;AsF7/dQ;;;EAEE,yBAAA;AtFigeV;;AsFhheQ;EAAgC,0BAAA;AtFohexC;;AsFnheQ;;EAEE,8BAAA;AtFsheV;;AsFpheQ;;EAEE,gCAAA;AtFuheV;;AsFrheQ;;EAEE,iCAAA;AtFwheV;;AsFtheQ;;EAEE,+BAAA;AtFyheV;;AsFxieQ;EAAgC,yBAAA;AtF4iexC;;AsF3ieQ;;;EAEE,6BAAA;AtF+ieV;;AsF7ieQ;;;EAEE,+BAAA;AtFijeV;;AsF/ieQ;;EAEE,gCAAA;AtFkjeV;;AsFhjeQ;;EAEE,8BAAA;AtFmjeV;;AsFlkeQ;EAAgC,uBAAA;AtFskexC;;AsFrkeQ;;EAEE,2BAAA;AtFwkeV;;AsFtkeQ;;EAEE,6BAAA;AtFykeV;;AsFvkeQ;;EAEE,8BAAA;AtF0keV;;AsFxkeQ;;EAEE,4BAAA;AtF2keV;;AsF1leQ;EAAgC,yBAAA;AtF8lexC;;AsF7leQ;;EAEE,6BAAA;AtFgmeV;;AsF9leQ;;EAEE,+BAAA;AtFimeV;;AsF/leQ;;EAEE,gCAAA;AtFkmeV;;AsFhmeQ;;EAEE,8BAAA;AtFmmeV;;AsFlneQ;EAAgC,uBAAA;AtFsnexC;;AsFrneQ;;EAEE,2BAAA;AtFwneV;;AsFtneQ;;EAEE,6BAAA;AtFyneV;;AsFvneQ;;EAEE,8BAAA;AtF0neV;;AsFxneQ;;EAEE,4BAAA;AtF2neV;;AsF1oeQ;EAAgC,qBAAA;AtF8oexC;;AsF7oeQ;;EAEE,yBAAA;AtFgpeV;;AsF9oeQ;;EAEE,2BAAA;AtFipeV;;AsF/oeQ;;EAEE,4BAAA;AtFkpeV;;AsFhpeQ;;EAEE,0BAAA;AtFmpeV;;AsFlqeQ;EAAgC,2BAAA;AtFsqexC;;AsFrqeQ;;EAEE,+BAAA;AtFwqeV;;AsFtqeQ;;EAEE,iCAAA;AtFyqeV;;AsFvqeQ;;EAEE,kCAAA;AtF0qeV;;AsFxqeQ;;EAEE,gCAAA;AtF2qeV;;AsF1reQ;EAAgC,0BAAA;AtF8rexC;;AsF7reQ;;EAEE,8BAAA;AtFgseV;;AsF9reQ;;;EAEE,gCAAA;AtFkseV;;AsFhseQ;;EAEE,iCAAA;AtFmseV;;AsFjseQ;;;EAEE,+BAAA;AtFqseV;;AsFpteQ;EAAgC,wBAAA;AtFwtexC;;AsFvteQ;;EAEE,4BAAA;AtF0teV;;AsFxteQ;;EAEE,8BAAA;AtF2teV;;AsFzteQ;;EAEE,+BAAA;AtF4teV;;AsF1teQ;;EAEE,6BAAA;AtF6teV;;AsF5ueQ;EAAgC,0BAAA;AtFgvexC;;AsF/ueQ;;EAEE,8BAAA;AtFkveV;;AsFhveQ;;EAEE,gCAAA;AtFmveV;;AsFjveQ;;EAEE,iCAAA;AtFoveV;;AsFlveQ;;EAEE,+BAAA;AtFqveV;;AsFpweQ;EAAgC,wBAAA;AtFwwexC;;AsFvweQ;;EAEE,4BAAA;AtF0weV;;AsFxweQ;;EAEE,8BAAA;AtF2weV;;AsFzweQ;;EAEE,+BAAA;AtF4weV;;AsF1weQ;;EAEE,6BAAA;AtF6weV;;AsFrweQ;EAAwB,2BAAA;AtFywehC;;AsFxweQ;;EAEE,+BAAA;AtF2weV;;AsFzweQ;;EAEE,iCAAA;AtF4weV;;AsF1weQ;;EAEE,kCAAA;AtF6weV;;AsF3weQ;;EAEE,gCAAA;AtF8weV;;AsF7xeQ;EAAwB,0BAAA;AtFiyehC;;AsFhyeQ;;EAEE,8BAAA;AtFmyeV;;AsFjyeQ;;EAEE,gCAAA;AtFoyeV;;AsFlyeQ;;EAEE,iCAAA;AtFqyeV;;AsFnyeQ;;EAEE,+BAAA;AtFsyeV;;AsFrzeQ;EAAwB,wBAAA;AtFyzehC;;AsFxzeQ;;EAEE,4BAAA;AtF2zeV;;AsFzzeQ;;EAEE,8BAAA;AtF4zeV;;AsF1zeQ;;EAEE,+BAAA;AtF6zeV;;AsF3zeQ;;EAEE,6BAAA;AtF8zeV;;AsF70eQ;EAAwB,0BAAA;AtFi1ehC;;AsFh1eQ;;EAEE,8BAAA;AtFm1eV;;AsFj1eQ;;EAEE,gCAAA;AtFo1eV;;AsFl1eQ;;EAEE,iCAAA;AtFq1eV;;AsFn1eQ;;EAEE,+BAAA;AtFs1eV;;AsFr2eQ;EAAwB,wBAAA;AtFy2ehC;;AsFx2eQ;;EAEE,4BAAA;AtF22eV;;AsFz2eQ;;EAEE,8BAAA;AtF42eV;;AsF12eQ;;EAEE,+BAAA;AtF62eV;;AsF32eQ;;EAEE,6BAAA;AtF82eV;;AsFx2eI;EAAmB,uBAAA;AtF42evB;;AsF32eI;;EAEE,2BAAA;AtF82eN;;AsF52eI;;EAEE,6BAAA;AtF+2eN;;AsF72eI;;EAEE,8BAAA;AtFg3eN;;AsF92eI;;EAEE,4BAAA;AtFi3eN;;A8B13eI;EwDlDI;IAAgC,oBAAA;EtFi7etC;EsFh7eM;;IAEE,wBAAA;EtFk7eR;EsFh7eM;;IAEE,0BAAA;EtFk7eR;EsFh7eM;;IAEE,2BAAA;EtFk7eR;EsFh7eM;;IAEE,yBAAA;EtFk7eR;EsFj8eM;IAAgC,0BAAA;EtFo8etC;EsFn8eM;;IAEE,8BAAA;EtFq8eR;EsFn8eM;;IAEE,gCAAA;EtFq8eR;EsFn8eM;;IAEE,iCAAA;EtFq8eR;EsFn8eM;;IAEE,+BAAA;EtFq8eR;EsFp9eM;IAAgC,yBAAA;EtFu9etC;EsFt9eM;;IAEE,6BAAA;EtFw9eR;EsFt9eM;;IAEE,+BAAA;EtFw9eR;EsFt9eM;;IAEE,gCAAA;EtFw9eR;EsFt9eM;;IAEE,8BAAA;EtFw9eR;EsFv+eM;IAAgC,uBAAA;EtF0+etC;EsFz+eM;;IAEE,2BAAA;EtF2+eR;EsFz+eM;;IAEE,6BAAA;EtF2+eR;EsFz+eM;;IAEE,8BAAA;EtF2+eR;EsFz+eM;;IAEE,4BAAA;EtF2+eR;EsF1/eM;IAAgC,yBAAA;EtF6/etC;EsF5/eM;;IAEE,6BAAA;EtF8/eR;EsF5/eM;;IAEE,+BAAA;EtF8/eR;EsF5/eM;;IAEE,gCAAA;EtF8/eR;EsF5/eM;;IAEE,8BAAA;EtF8/eR;EsF7gfM;IAAgC,uBAAA;EtFghftC;EsF/gfM;;IAEE,2BAAA;EtFihfR;EsF/gfM;;IAEE,6BAAA;EtFihfR;EsF/gfM;;IAEE,8BAAA;EtFihfR;EsF/gfM;;IAEE,4BAAA;EtFihfR;EsFhifM;IAAgC,qBAAA;EtFmiftC;EsFlifM;;IAEE,yBAAA;EtFoifR;EsFlifM;;IAEE,2BAAA;EtFoifR;EsFlifM;;IAEE,4BAAA;EtFoifR;EsFlifM;;IAEE,0BAAA;EtFoifR;EsFnjfM;IAAgC,2BAAA;EtFsjftC;EsFrjfM;;IAEE,+BAAA;EtFujfR;EsFrjfM;;IAEE,iCAAA;EtFujfR;EsFrjfM;;IAEE,kCAAA;EtFujfR;EsFrjfM;;IAEE,gCAAA;EtFujfR;EsFtkfM;IAAgC,0BAAA;EtFykftC;EsFxkfM;;IAEE,8BAAA;EtF0kfR;EsFxkfM;;IAEE,gCAAA;EtF0kfR;EsFxkfM;;IAEE,iCAAA;EtF0kfR;EsFxkfM;;IAEE,+BAAA;EtF0kfR;EsFzlfM;IAAgC,wBAAA;EtF4lftC;EsF3lfM;;IAEE,4BAAA;EtF6lfR;EsF3lfM;;IAEE,8BAAA;EtF6lfR;EsF3lfM;;IAEE,+BAAA;EtF6lfR;EsF3lfM;;IAEE,6BAAA;EtF6lfR;EsF5mfM;IAAgC,0BAAA;EtF+mftC;EsF9mfM;;IAEE,8BAAA;EtFgnfR;EsF9mfM;;IAEE,gCAAA;EtFgnfR;EsF9mfM;;IAEE,iCAAA;EtFgnfR;EsF9mfM;;IAEE,+BAAA;EtFgnfR;EsF/nfM;IAAgC,wBAAA;EtFkoftC;EsFjofM;;IAEE,4BAAA;EtFmofR;EsFjofM;;IAEE,8BAAA;EtFmofR;EsFjofM;;IAEE,+BAAA;EtFmofR;EsFjofM;;IAEE,6BAAA;EtFmofR;EsF3nfM;IAAwB,2BAAA;EtF8nf9B;EsF7nfM;;IAEE,+BAAA;EtF+nfR;EsF7nfM;;IAEE,iCAAA;EtF+nfR;EsF7nfM;;IAEE,kCAAA;EtF+nfR;EsF7nfM;;IAEE,gCAAA;EtF+nfR;EsF9ofM;IAAwB,0BAAA;EtFipf9B;EsFhpfM;;IAEE,8BAAA;EtFkpfR;EsFhpfM;;IAEE,gCAAA;EtFkpfR;EsFhpfM;;IAEE,iCAAA;EtFkpfR;EsFhpfM;;IAEE,+BAAA;EtFkpfR;EsFjqfM;IAAwB,wBAAA;EtFoqf9B;EsFnqfM;;IAEE,4BAAA;EtFqqfR;EsFnqfM;;IAEE,8BAAA;EtFqqfR;EsFnqfM;;IAEE,+BAAA;EtFqqfR;EsFnqfM;;IAEE,6BAAA;EtFqqfR;EsFprfM;IAAwB,0BAAA;EtFurf9B;EsFtrfM;;IAEE,8BAAA;EtFwrfR;EsFtrfM;;IAEE,gCAAA;EtFwrfR;EsFtrfM;;IAEE,iCAAA;EtFwrfR;EsFtrfM;;IAEE,+BAAA;EtFwrfR;EsFvsfM;IAAwB,wBAAA;EtF0sf9B;EsFzsfM;;IAEE,4BAAA;EtF2sfR;EsFzsfM;;IAEE,8BAAA;EtF2sfR;EsFzsfM;;IAEE,+BAAA;EtF2sfR;EsFzsfM;;IAEE,6BAAA;EtF2sfR;EsFrsfE;IAAmB,uBAAA;EtFwsfrB;EsFvsfE;;IAEE,2BAAA;EtFysfJ;EsFvsfE;;IAEE,6BAAA;EtFysfJ;EsFvsfE;;IAEE,8BAAA;EtFysfJ;EsFvsfE;;IAEE,4BAAA;EtFysfJ;AACF;A8BntfI;EwDlDI;IAAgC,oBAAA;EtFywftC;EsFxwfM;;IAEE,wBAAA;EtF0wfR;EsFxwfM;;IAEE,0BAAA;EtF0wfR;EsFxwfM;;IAEE,2BAAA;EtF0wfR;EsFxwfM;;IAEE,yBAAA;EtF0wfR;EsFzxfM;IAAgC,0BAAA;EtF4xftC;EsF3xfM;;IAEE,8BAAA;EtF6xfR;EsF3xfM;;IAEE,gCAAA;EtF6xfR;EsF3xfM;;IAEE,iCAAA;EtF6xfR;EsF3xfM;;IAEE,+BAAA;EtF6xfR;EsF5yfM;IAAgC,yBAAA;EtF+yftC;EsF9yfM;;IAEE,6BAAA;EtFgzfR;EsF9yfM;;IAEE,+BAAA;EtFgzfR;EsF9yfM;;IAEE,gCAAA;EtFgzfR;EsF9yfM;;IAEE,8BAAA;EtFgzfR;EsF/zfM;IAAgC,uBAAA;EtFk0ftC;EsFj0fM;;IAEE,2BAAA;EtFm0fR;EsFj0fM;;IAEE,6BAAA;EtFm0fR;EsFj0fM;;IAEE,8BAAA;EtFm0fR;EsFj0fM;;IAEE,4BAAA;EtFm0fR;EsFl1fM;IAAgC,yBAAA;EtFq1ftC;EsFp1fM;;IAEE,6BAAA;EtFs1fR;EsFp1fM;;IAEE,+BAAA;EtFs1fR;EsFp1fM;;IAEE,gCAAA;EtFs1fR;EsFp1fM;;IAEE,8BAAA;EtFs1fR;EsFr2fM;IAAgC,uBAAA;EtFw2ftC;EsFv2fM;;IAEE,2BAAA;EtFy2fR;EsFv2fM;;IAEE,6BAAA;EtFy2fR;EsFv2fM;;IAEE,8BAAA;EtFy2fR;EsFv2fM;;IAEE,4BAAA;EtFy2fR;EsFx3fM;IAAgC,qBAAA;EtF23ftC;EsF13fM;;IAEE,yBAAA;EtF43fR;EsF13fM;;IAEE,2BAAA;EtF43fR;EsF13fM;;IAEE,4BAAA;EtF43fR;EsF13fM;;IAEE,0BAAA;EtF43fR;EsF34fM;IAAgC,2BAAA;EtF84ftC;EsF74fM;;IAEE,+BAAA;EtF+4fR;EsF74fM;;IAEE,iCAAA;EtF+4fR;EsF74fM;;IAEE,kCAAA;EtF+4fR;EsF74fM;;IAEE,gCAAA;EtF+4fR;EsF95fM;IAAgC,0BAAA;EtFi6ftC;EsFh6fM;;IAEE,8BAAA;EtFk6fR;EsFh6fM;;IAEE,gCAAA;EtFk6fR;EsFh6fM;;IAEE,iCAAA;EtFk6fR;EsFh6fM;;IAEE,+BAAA;EtFk6fR;EsFj7fM;IAAgC,wBAAA;EtFo7ftC;EsFn7fM;;IAEE,4BAAA;EtFq7fR;EsFn7fM;;IAEE,8BAAA;EtFq7fR;EsFn7fM;;IAEE,+BAAA;EtFq7fR;EsFn7fM;;IAEE,6BAAA;EtFq7fR;EsFp8fM;IAAgC,0BAAA;EtFu8ftC;EsFt8fM;;IAEE,8BAAA;EtFw8fR;EsFt8fM;;IAEE,gCAAA;EtFw8fR;EsFt8fM;;IAEE,iCAAA;EtFw8fR;EsFt8fM;;IAEE,+BAAA;EtFw8fR;EsFv9fM;IAAgC,wBAAA;EtF09ftC;EsFz9fM;;IAEE,4BAAA;EtF29fR;EsFz9fM;;IAEE,8BAAA;EtF29fR;EsFz9fM;;IAEE,+BAAA;EtF29fR;EsFz9fM;;IAEE,6BAAA;EtF29fR;EsFn9fM;IAAwB,2BAAA;EtFs9f9B;EsFr9fM;;IAEE,+BAAA;EtFu9fR;EsFr9fM;;IAEE,iCAAA;EtFu9fR;EsFr9fM;;IAEE,kCAAA;EtFu9fR;EsFr9fM;;IAEE,gCAAA;EtFu9fR;EsFt+fM;IAAwB,0BAAA;EtFy+f9B;EsFx+fM;;IAEE,8BAAA;EtF0+fR;EsFx+fM;;IAEE,gCAAA;EtF0+fR;EsFx+fM;;IAEE,iCAAA;EtF0+fR;EsFx+fM;;IAEE,+BAAA;EtF0+fR;EsFz/fM;IAAwB,wBAAA;EtF4/f9B;EsF3/fM;;IAEE,4BAAA;EtF6/fR;EsF3/fM;;IAEE,8BAAA;EtF6/fR;EsF3/fM;;IAEE,+BAAA;EtF6/fR;EsF3/fM;;IAEE,6BAAA;EtF6/fR;EsF5ggBM;IAAwB,0BAAA;EtF+ggB9B;EsF9ggBM;;IAEE,8BAAA;EtFghgBR;EsF9ggBM;;IAEE,gCAAA;EtFghgBR;EsF9ggBM;;IAEE,iCAAA;EtFghgBR;EsF9ggBM;;IAEE,+BAAA;EtFghgBR;EsF/hgBM;IAAwB,wBAAA;EtFkigB9B;EsFjigBM;;IAEE,4BAAA;EtFmigBR;EsFjigBM;;IAEE,8BAAA;EtFmigBR;EsFjigBM;;IAEE,+BAAA;EtFmigBR;EsFjigBM;;IAEE,6BAAA;EtFmigBR;EsF7hgBE;IAAmB,uBAAA;EtFgigBrB;EsF/hgBE;;IAEE,2BAAA;EtFiigBJ;EsF/hgBE;;IAEE,6BAAA;EtFiigBJ;EsF/hgBE;;IAEE,8BAAA;EtFiigBJ;EsF/hgBE;;IAEE,4BAAA;EtFiigBJ;AACF;A8B3igBI;EwDlDI;IAAgC,oBAAA;EtFimgBtC;EsFhmgBM;;IAEE,wBAAA;EtFkmgBR;EsFhmgBM;;IAEE,0BAAA;EtFkmgBR;EsFhmgBM;;IAEE,2BAAA;EtFkmgBR;EsFhmgBM;;IAEE,yBAAA;EtFkmgBR;EsFjngBM;IAAgC,0BAAA;EtFongBtC;EsFnngBM;;IAEE,8BAAA;EtFqngBR;EsFnngBM;;IAEE,gCAAA;EtFqngBR;EsFnngBM;;IAEE,iCAAA;EtFqngBR;EsFnngBM;;IAEE,+BAAA;EtFqngBR;EsFpogBM;IAAgC,yBAAA;EtFuogBtC;EsFtogBM;;IAEE,6BAAA;EtFwogBR;EsFtogBM;;IAEE,+BAAA;EtFwogBR;EsFtogBM;;IAEE,gCAAA;EtFwogBR;EsFtogBM;;IAEE,8BAAA;EtFwogBR;EsFvpgBM;IAAgC,uBAAA;EtF0pgBtC;EsFzpgBM;;IAEE,2BAAA;EtF2pgBR;EsFzpgBM;;IAEE,6BAAA;EtF2pgBR;EsFzpgBM;;IAEE,8BAAA;EtF2pgBR;EsFzpgBM;;IAEE,4BAAA;EtF2pgBR;EsF1qgBM;IAAgC,yBAAA;EtF6qgBtC;EsF5qgBM;;IAEE,6BAAA;EtF8qgBR;EsF5qgBM;;IAEE,+BAAA;EtF8qgBR;EsF5qgBM;;IAEE,gCAAA;EtF8qgBR;EsF5qgBM;;IAEE,8BAAA;EtF8qgBR;EsF7rgBM;IAAgC,uBAAA;EtFgsgBtC;EsF/rgBM;;IAEE,2BAAA;EtFisgBR;EsF/rgBM;;IAEE,6BAAA;EtFisgBR;EsF/rgBM;;IAEE,8BAAA;EtFisgBR;EsF/rgBM;;IAEE,4BAAA;EtFisgBR;EsFhtgBM;IAAgC,qBAAA;EtFmtgBtC;EsFltgBM;;IAEE,yBAAA;EtFotgBR;EsFltgBM;;IAEE,2BAAA;EtFotgBR;EsFltgBM;;IAEE,4BAAA;EtFotgBR;EsFltgBM;;IAEE,0BAAA;EtFotgBR;EsFnugBM;IAAgC,2BAAA;EtFsugBtC;EsFrugBM;;IAEE,+BAAA;EtFuugBR;EsFrugBM;;IAEE,iCAAA;EtFuugBR;EsFrugBM;;IAEE,kCAAA;EtFuugBR;EsFrugBM;;IAEE,gCAAA;EtFuugBR;EsFtvgBM;IAAgC,0BAAA;EtFyvgBtC;EsFxvgBM;;IAEE,8BAAA;EtF0vgBR;EsFxvgBM;;IAEE,gCAAA;EtF0vgBR;EsFxvgBM;;IAEE,iCAAA;EtF0vgBR;EsFxvgBM;;IAEE,+BAAA;EtF0vgBR;EsFzwgBM;IAAgC,wBAAA;EtF4wgBtC;EsF3wgBM;;IAEE,4BAAA;EtF6wgBR;EsF3wgBM;;IAEE,8BAAA;EtF6wgBR;EsF3wgBM;;IAEE,+BAAA;EtF6wgBR;EsF3wgBM;;IAEE,6BAAA;EtF6wgBR;EsF5xgBM;IAAgC,0BAAA;EtF+xgBtC;EsF9xgBM;;IAEE,8BAAA;EtFgygBR;EsF9xgBM;;IAEE,gCAAA;EtFgygBR;EsF9xgBM;;IAEE,iCAAA;EtFgygBR;EsF9xgBM;;IAEE,+BAAA;EtFgygBR;EsF/ygBM;IAAgC,wBAAA;EtFkzgBtC;EsFjzgBM;;IAEE,4BAAA;EtFmzgBR;EsFjzgBM;;IAEE,8BAAA;EtFmzgBR;EsFjzgBM;;IAEE,+BAAA;EtFmzgBR;EsFjzgBM;;IAEE,6BAAA;EtFmzgBR;EsF3ygBM;IAAwB,2BAAA;EtF8ygB9B;EsF7ygBM;;IAEE,+BAAA;EtF+ygBR;EsF7ygBM;;IAEE,iCAAA;EtF+ygBR;EsF7ygBM;;IAEE,kCAAA;EtF+ygBR;EsF7ygBM;;IAEE,gCAAA;EtF+ygBR;EsF9zgBM;IAAwB,0BAAA;EtFi0gB9B;EsFh0gBM;;IAEE,8BAAA;EtFk0gBR;EsFh0gBM;;IAEE,gCAAA;EtFk0gBR;EsFh0gBM;;IAEE,iCAAA;EtFk0gBR;EsFh0gBM;;IAEE,+BAAA;EtFk0gBR;EsFj1gBM;IAAwB,wBAAA;EtFo1gB9B;EsFn1gBM;;IAEE,4BAAA;EtFq1gBR;EsFn1gBM;;IAEE,8BAAA;EtFq1gBR;EsFn1gBM;;IAEE,+BAAA;EtFq1gBR;EsFn1gBM;;IAEE,6BAAA;EtFq1gBR;EsFp2gBM;IAAwB,0BAAA;EtFu2gB9B;EsFt2gBM;;IAEE,8BAAA;EtFw2gBR;EsFt2gBM;;IAEE,gCAAA;EtFw2gBR;EsFt2gBM;;IAEE,iCAAA;EtFw2gBR;EsFt2gBM;;IAEE,+BAAA;EtFw2gBR;EsFv3gBM;IAAwB,wBAAA;EtF03gB9B;EsFz3gBM;;IAEE,4BAAA;EtF23gBR;EsFz3gBM;;IAEE,8BAAA;EtF23gBR;EsFz3gBM;;IAEE,+BAAA;EtF23gBR;EsFz3gBM;;IAEE,6BAAA;EtF23gBR;EsFr3gBE;IAAmB,uBAAA;EtFw3gBrB;EsFv3gBE;;IAEE,2BAAA;EtFy3gBJ;EsFv3gBE;;IAEE,6BAAA;EtFy3gBJ;EsFv3gBE;;IAEE,8BAAA;EtFy3gBJ;EsFv3gBE;;IAEE,4BAAA;EtFy3gBJ;AACF;A8Bn4gBI;EwDlDI;IAAgC,oBAAA;EtFy7gBtC;EsFx7gBM;;IAEE,wBAAA;EtF07gBR;EsFx7gBM;;IAEE,0BAAA;EtF07gBR;EsFx7gBM;;IAEE,2BAAA;EtF07gBR;EsFx7gBM;;IAEE,yBAAA;EtF07gBR;EsFz8gBM;IAAgC,0BAAA;EtF48gBtC;EsF38gBM;;IAEE,8BAAA;EtF68gBR;EsF38gBM;;IAEE,gCAAA;EtF68gBR;EsF38gBM;;IAEE,iCAAA;EtF68gBR;EsF38gBM;;IAEE,+BAAA;EtF68gBR;EsF59gBM;IAAgC,yBAAA;EtF+9gBtC;EsF99gBM;;IAEE,6BAAA;EtFg+gBR;EsF99gBM;;IAEE,+BAAA;EtFg+gBR;EsF99gBM;;IAEE,gCAAA;EtFg+gBR;EsF99gBM;;IAEE,8BAAA;EtFg+gBR;EsF/+gBM;IAAgC,uBAAA;EtFk/gBtC;EsFj/gBM;;IAEE,2BAAA;EtFm/gBR;EsFj/gBM;;IAEE,6BAAA;EtFm/gBR;EsFj/gBM;;IAEE,8BAAA;EtFm/gBR;EsFj/gBM;;IAEE,4BAAA;EtFm/gBR;EsFlghBM;IAAgC,yBAAA;EtFqghBtC;EsFpghBM;;IAEE,6BAAA;EtFsghBR;EsFpghBM;;IAEE,+BAAA;EtFsghBR;EsFpghBM;;IAEE,gCAAA;EtFsghBR;EsFpghBM;;IAEE,8BAAA;EtFsghBR;EsFrhhBM;IAAgC,uBAAA;EtFwhhBtC;EsFvhhBM;;IAEE,2BAAA;EtFyhhBR;EsFvhhBM;;IAEE,6BAAA;EtFyhhBR;EsFvhhBM;;IAEE,8BAAA;EtFyhhBR;EsFvhhBM;;IAEE,4BAAA;EtFyhhBR;EsFxihBM;IAAgC,qBAAA;EtF2ihBtC;EsF1ihBM;;IAEE,yBAAA;EtF4ihBR;EsF1ihBM;;IAEE,2BAAA;EtF4ihBR;EsF1ihBM;;IAEE,4BAAA;EtF4ihBR;EsF1ihBM;;IAEE,0BAAA;EtF4ihBR;EsF3jhBM;IAAgC,2BAAA;EtF8jhBtC;EsF7jhBM;;IAEE,+BAAA;EtF+jhBR;EsF7jhBM;;IAEE,iCAAA;EtF+jhBR;EsF7jhBM;;IAEE,kCAAA;EtF+jhBR;EsF7jhBM;;IAEE,gCAAA;EtF+jhBR;EsF9khBM;IAAgC,0BAAA;EtFilhBtC;EsFhlhBM;;IAEE,8BAAA;EtFklhBR;EsFhlhBM;;IAEE,gCAAA;EtFklhBR;EsFhlhBM;;IAEE,iCAAA;EtFklhBR;EsFhlhBM;;IAEE,+BAAA;EtFklhBR;EsFjmhBM;IAAgC,wBAAA;EtFomhBtC;EsFnmhBM;;IAEE,4BAAA;EtFqmhBR;EsFnmhBM;;IAEE,8BAAA;EtFqmhBR;EsFnmhBM;;IAEE,+BAAA;EtFqmhBR;EsFnmhBM;;IAEE,6BAAA;EtFqmhBR;EsFpnhBM;IAAgC,0BAAA;EtFunhBtC;EsFtnhBM;;IAEE,8BAAA;EtFwnhBR;EsFtnhBM;;IAEE,gCAAA;EtFwnhBR;EsFtnhBM;;IAEE,iCAAA;EtFwnhBR;EsFtnhBM;;IAEE,+BAAA;EtFwnhBR;EsFvohBM;IAAgC,wBAAA;EtF0ohBtC;EsFzohBM;;IAEE,4BAAA;EtF2ohBR;EsFzohBM;;IAEE,8BAAA;EtF2ohBR;EsFzohBM;;IAEE,+BAAA;EtF2ohBR;EsFzohBM;;IAEE,6BAAA;EtF2ohBR;EsFnohBM;IAAwB,2BAAA;EtFsohB9B;EsFrohBM;;IAEE,+BAAA;EtFuohBR;EsFrohBM;;IAEE,iCAAA;EtFuohBR;EsFrohBM;;IAEE,kCAAA;EtFuohBR;EsFrohBM;;IAEE,gCAAA;EtFuohBR;EsFtphBM;IAAwB,0BAAA;EtFyphB9B;EsFxphBM;;IAEE,8BAAA;EtF0phBR;EsFxphBM;;IAEE,gCAAA;EtF0phBR;EsFxphBM;;IAEE,iCAAA;EtF0phBR;EsFxphBM;;IAEE,+BAAA;EtF0phBR;EsFzqhBM;IAAwB,wBAAA;EtF4qhB9B;EsF3qhBM;;IAEE,4BAAA;EtF6qhBR;EsF3qhBM;;IAEE,8BAAA;EtF6qhBR;EsF3qhBM;;IAEE,+BAAA;EtF6qhBR;EsF3qhBM;;IAEE,6BAAA;EtF6qhBR;EsF5rhBM;IAAwB,0BAAA;EtF+rhB9B;EsF9rhBM;;IAEE,8BAAA;EtFgshBR;EsF9rhBM;;IAEE,gCAAA;EtFgshBR;EsF9rhBM;;IAEE,iCAAA;EtFgshBR;EsF9rhBM;;IAEE,+BAAA;EtFgshBR;EsF/shBM;IAAwB,wBAAA;EtFkthB9B;EsFjthBM;;IAEE,4BAAA;EtFmthBR;EsFjthBM;;IAEE,8BAAA;EtFmthBR;EsFjthBM;;IAEE,+BAAA;EtFmthBR;EsFjthBM;;IAEE,6BAAA;EtFmthBR;EsF7shBE;IAAmB,uBAAA;EtFgthBrB;EsF/shBE;;IAEE,2BAAA;EtFithBJ;EsF/shBE;;IAEE,6BAAA;EtFithBJ;EsF/shBE;;IAEE,8BAAA;EtFithBJ;EsF/shBE;;IAEE,4BAAA;EtFithBJ;AACF;AuFlxhBE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EAEA,oBAAA;EACA,WAAA;EAEA,kCAAA;AvFkxhBJ;;AwF5xhBA;EAAkB,4GAAA;AxFgyhBlB;;AwF5xhBA;EAAiB,8BAAA;AxFgyhBjB;;AwF/xhBA;EAAiB,8BAAA;AxFmyhBjB;;AwFlyhBA;EAAiB,8BAAA;AxFsyhBjB;;AwFryhBA;ECTE,gBAAA;EACA,uBAAA;EACA,mBAAA;AzFkzhBF;;AwFnyhBI;EAAwB,2BAAA;AxFuyhB5B;;AwFtyhBI;EAAwB,4BAAA;AxF0yhB5B;;AwFzyhBI;EAAwB,6BAAA;AxF6yhB5B;;A8BxwhBI;E0DvCA;IAAwB,2BAAA;ExFozhB1B;EwFnzhBE;IAAwB,4BAAA;ExFszhB1B;EwFrzhBE;IAAwB,6BAAA;ExFwzhB1B;AACF;A8BpxhBI;E0DvCA;IAAwB,2BAAA;ExF+zhB1B;EwF9zhBE;IAAwB,4BAAA;ExFi0hB1B;EwFh0hBE;IAAwB,6BAAA;ExFm0hB1B;AACF;A8B/xhBI;E0DvCA;IAAwB,2BAAA;ExF00hB1B;EwFz0hBE;IAAwB,4BAAA;ExF40hB1B;EwF30hBE;IAAwB,6BAAA;ExF80hB1B;AACF;A8B1yhBI;E0DvCA;IAAwB,2BAAA;ExFq1hB1B;EwFp1hBE;IAAwB,4BAAA;ExFu1hB1B;EwFt1hBE;IAAwB,6BAAA;ExFy1hB1B;AACF;AwFp1hBA;EAAmB,oCAAA;AxFu1hBnB;;AwFt1hBA;EAAmB,oCAAA;AxF01hBnB;;AwFz1hBA;EAAmB,qCAAA;AxF61hBnB;;AwFz1hBA;EAAuB,2BAAA;AxF61hBvB;;AwF51hBA;EAAuB,+BAAA;AxFg2hBvB;;AwF/1hBA;EAAuB,2BAAA;AxFm2hBvB;;AwFl2hBA;EAAuB,2BAAA;AxFs2hBvB;;AwFr2hBA;EAAuB,8BAAA;AxFy2hBvB;;AwFx2hBA;EAAuB,6BAAA;AxF42hBvB;;AwFx2hBA;EAAc,yBAAA;AxF42hBd;;A0Fn5hBE;EACE,yBAAA;A1Fs5hBJ;;AqB54hBE;EqELM,yBAAA;A1Fq5hBR;;A0F35hBE;EACE,yBAAA;A1F85hBJ;;AqBp5hBE;EqELM,yBAAA;A1F65hBR;;A0Fn6hBE;EACE,yBAAA;A1Fs6hBJ;;AqB55hBE;EqELM,yBAAA;A1Fq6hBR;;A0F36hBE;EACE,yBAAA;A1F86hBJ;;AqBp6hBE;EqELM,yBAAA;A1F66hBR;;A0Fn7hBE;EACE,yBAAA;A1Fs7hBJ;;AqB56hBE;EqELM,yBAAA;A1Fq7hBR;;A0F37hBE;EACE,yBAAA;A1F87hBJ;;AqBp7hBE;EqELM,yBAAA;A1F67hBR;;A0Fn8hBE;EACE,yBAAA;A1Fs8hBJ;;AqB57hBE;EqELM,yBAAA;A1Fq8hBR;;A0F38hBE;EACE,yBAAA;A1F88hBJ;;AqBp8hBE;EqELM,uBAAA;A1F68hBR;;AwFt6hBA;EAAa,yBAAA;AxF06hBb;;AwFz6hBA;EAAc,yBAAA;AxF66hBd;;AwF36hBA;EAAiB,oCAAA;AxF+6hBjB;;AwF96hBA;EAAiB,0CAAA;AxFk7hBjB;;AwF96hBA;EGvDE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;EACA,SAAA;A3Fy+hBF;;AwFl7hBA;EAAwB,gCAAA;AxFs7hBxB;;AwFp7hBA;EACE,iCAAA;EACA,gCAAA;AxFu7hBF;;AwFl7hBA;EAAc,yBAAA;AxFs7hBd;;A4Fv/hBA;EACE,8BAAA;A5F0/hBF;;A4Fv/hBA;EACE,6BAAA;A5F0/hBF;;A6F1/hBE;EACE;;;IAKE,4BAAA;IAEA,2BAAA;E7F0/hBJ;E6Ft/hBI;IACE,0BAAA;E7Fw/hBN;E6F/+hBE;IACE,6BAAA;E7Fi/hBJ;E6Fn+hBE;IACE,gCAAA;E7Fq+hBJ;E6Fn+hBE;;IAEE,yBAAA;IACA,wBAAA;E7Fq+hBJ;E6Fl+hBE;;IAEE,wBAAA;E7Fo+hBJ;E6Fj+hBE;;;IAGE,UAAA;IACA,SAAA;E7Fm+hBJ;E6Fh+hBE;;IAEE,uBAAA;E7Fk+hBJ;E6F19hBE;IACE,Q3E2iC8B;ElBi7flC;E6F19hBE;IACE,2BAAA;E7F49hBJ;E6F19hBE;IACE,2BAAA;E7F49hBJ;E6Fx9hBE;IACE,aAAA;E7F09hBJ;E6Fx9hBE;IACE,sBAAA;E7F09hBJ;E6Fv9hBE;IACE,oCAAA;E7Fy9hBJ;E6Fv9hBI;;IAEE,oCAAA;E7Fy9hBN;E6Fp9hBI;;IAEE,oCAAA;E7Fs9hBN;E6Fl9hBE;IACE,cAAA;E7Fo9hBJ;E6Fl9hBI;;;;IAIE,qBzE5DO;EpBghiBb;E6Fh9hBE;IACE,cAAA;IACA,qBzElES;EpBohiBb;AACF;A8FjliBA,4BAAA;ACAA;EACE,oCAAA;EACA,6CAAA;EACA,yPAAA;EAIA,mBAAA;EACA,kBAAA;A/FiliBF;AgGzliBA;;EAEE,qBAAA;EACA,yDAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,mCAAA;EACA,kCAAA;AhG2liBF;;AiGlmiBI;EACI,iBAAA;AjGqmiBR;;AiGtmiBI;EACI,iBAAA;AjGymiBR;;AiG1miBI;EACI,iBAAA;AjG6miBR;;AiG9miBI;EACI,iBAAA;AjGiniBR;;AiGlniBI;EACI,iBAAA;AjGqniBR;;AiGtniBI;EACI,gBAAA;AjGyniBR;;AiG1niBI;EACI,gBAAA;AjG6niBR;;AiG9niBI;EACI,gBAAA;AjGioiBR;;AiGloiBI;EACI,gBAAA;AjGqoiBR;;AiGtoiBI;EACI,gBAAA;AjGyoiBR;;AiG1oiBI;EACI,gBAAA;AjG6oiBR;;AiG9oiBI;EACI,gBAAA;AjGipiBR;;AiGlpiBI;EACI,gBAAA;AjGqpiBR;;AiGtpiBI;EACI,gBAAA;AjGypiBR;;AiG1piBI;EACI,gBAAA;AjG6piBR;;AiG9piBI;EACI,gBAAA;AjGiqiBR;;AiGlqiBI;EACI,gBAAA;AjGqqiBR;;AiGtqiBI;EACI,gBAAA;AjGyqiBR;;AiG1qiBI;EACI,gBAAA;AjG6qiBR;;AiG9qiBI;EACI,gBAAA;AjGiriBR;;AiGlriBI;EACI,gBAAA;AjGqriBR;;AiGtriBI;EACI,gBAAA;AjGyriBR;;AiG1riBI;EACI,gBAAA;AjG6riBR;;AiG9riBI;EACI,iBAAA;AjGisiBR;;AiGlsiBI;EACI,gBAAA;AjGqsiBR;;AiGtsiBI;EACI,iBAAA;AjGysiBR;;AiG1siBI;EACI,iBAAA;AjG6siBR;;AiG9siBI;EACI,gBAAA;AjGitiBR;;AiGltiBI;EACI,gBAAA;AjGqtiBR;;AiGttiBI;EACI,iBAAA;AjGytiBR;;AiG1tiBI;EACI,iBAAA;AjG6tiBR;;AiG9tiBI;EACI,gBAAA;AjGiuiBR;;AiGluiBI;EACI,gBAAA;AjGquiBR;;AiGtuiBI;EACI,gBAAA;AjGyuiBR;;AiG1uiBI;EACI,gBAAA;AjG6uiBR;;AiG9uiBI;EACI,iBAAA;AjGiviBR;;AiGlviBI;EACI,gBAAA;AjGqviBR;;AiGtviBI;EACI,gBAAA;AjGyviBR;;AiG1viBI;EACI,gBAAA;AjG6viBR;;AiG9viBI;EACI,gBAAA;AjGiwiBR;;AiGlwiBI;EACI,iBAAA;AjGqwiBR;;AiGtwiBI;EACI,iBAAA;AjGywiBR;;AiG1wiBI;EACI,gBAAA;AjG6wiBR;;AiG9wiBI;EACI,iBAAA;AjGixiBR;;AiGlxiBI;EACI,gBAAA;AjGqxiBR;;AiGtxiBI;EACI,iBAAA;AjGyxiBR;;AiG1xiBI;EACI,gBAAA;AjG6xiBR;;AiG9xiBI;EACI,iBAAA;AjGiyiBR;;AiGlyiBI;EACI,gBAAA;AjGqyiBR;;AiGtyiBI;EACI,gBAAA;AjGyyiBR;;AiG1yiBI;EACI,gBAAA;AjG6yiBR;;AiG9yiBI;EACI,gBAAA;AjGiziBR;;AiGlziBI;EACI,gBAAA;AjGqziBR;;AiGtziBI;EACI,gBAAA;AjGyziBR;;AiG1ziBI;EACI,iBAAA;AjG6ziBR;;AiG9ziBI;EACI,iBAAA;AjGi0iBR;;AiGl0iBI;EACI,gBAAA;AjGq0iBR;;AiGt0iBI;EACI,gBAAA;AjGy0iBR;;AiG10iBI;EACI,gBAAA;AjG60iBR;;AiG90iBI;EACI,gBAAA;AjGi1iBR;;AiGl1iBI;EACI,iBAAA;AjGq1iBR;;AiGt1iBI;EACI,gBAAA;AjGy1iBR;;AiG11iBI;EACI,gBAAA;AjG61iBR;;AiG91iBI;EACI,gBAAA;AjGi2iBR;;AiGl2iBI;EACI,gBAAA;AjGq2iBR;;AiGt2iBI;EACI,gBAAA;AjGy2iBR;;AiG12iBI;EACI,iBAAA;AjG62iBR;;AiG92iBI;EACI,iBAAA;AjGi3iBR;;AiGl3iBI;EACI,gBAAA;AjGq3iBR;;AiGt3iBI;EACI,gBAAA;AjGy3iBR;;AiG13iBI;EACI,gBAAA;AjG63iBR;;AiG93iBI;EACI,gBAAA;AjGi4iBR;;AiGl4iBI;EACI,gBAAA;AjGq4iBR;;AiGt4iBI;EACI,gBAAA;AjGy4iBR;;AiG14iBI;EACI,gBAAA;AjG64iBR;;AiG94iBI;EACI,gBAAA;AjGi5iBR;;AiGl5iBI;EACI,gBAAA;AjGq5iBR;;AiGt5iBI;EACI,gBAAA;AjGy5iBR;;AiG15iBI;EACI,gBAAA;AjG65iBR;;AiG95iBI;EACI,gBAAA;AjGi6iBR;;AiGl6iBI;EACI,gBAAA;AjGq6iBR;;AiGt6iBI;EACI,gBAAA;AjGy6iBR;;AiG16iBI;EACI,iBAAA;AjG66iBR;;AiG96iBI;EACI,gBAAA;AjGi7iBR;;AiGl7iBI;EACI,gBAAA;AjGq7iBR;;AiGt7iBI;EACI,gBAAA;AjGy7iBR;;AiG17iBI;EACI,gBAAA;AjG67iBR;;AiG97iBI;EACI,iBAAA;AjGi8iBR;;AiGl8iBI;EACI,gBAAA;AjGq8iBR;;AiGt8iBI;EACI,gBAAA;AjGy8iBR;;AiG18iBI;EACI,iBAAA;AjG68iBR;;AiG98iBI;EACI,iBAAA;AjGi9iBR;;AiGl9iBI;EACI,iBAAA;AjGq9iBR;;AiGt9iBI;EACI,iBAAA;AjGy9iBR;;AiG19iBI;EACI,iBAAA;AjG69iBR;;AiG99iBI;EACI,gBAAA;AjGi+iBR;;AiGl+iBI;EACI,gBAAA;AjGq+iBR;;AiGt+iBI;EACI,gBAAA;AjGy+iBR;;AiG1+iBI;EACI,gBAAA;AjG6+iBR;;AiG9+iBI;EACI,gBAAA;AjGi/iBR;;AiGl/iBI;EACI,gBAAA;AjGq/iBR;;AiGt/iBI;EACI,gBAAA;AjGy/iBR;;AiG1/iBI;EACI,iBAAA;AjG6/iBR;;AiG9/iBI;EACI,gBAAA;AjGigjBR;;AiGlgjBI;EACI,gBAAA;AjGqgjBR;;AiGtgjBI;EACI,gBAAA;AjGygjBR;;AiG1gjBI;EACI,iBAAA;AjG6gjBR;;AiG9gjBI;EACI,gBAAA;AjGihjBR;;AiGlhjBI;EACI,gBAAA;AjGqhjBR;;AiGthjBI;EACI,gBAAA;AjGyhjBR;;AiG1hjBI;EACI,gBAAA;AjG6hjBR;;AiG9hjBI;EACI,gBAAA;AjGiijBR;;AiGlijBI;EACI,gBAAA;AjGqijBR;;AiGtijBI;EACI,gBAAA;AjGyijBR;;AiG1ijBI;EACI,gBAAA;AjG6ijBR;;AiG9ijBI;EACI,gBAAA;AjGijjBR;;AiGljjBI;EACI,gBAAA;AjGqjjBR;;AiGtjjBI;EACI,gBAAA;AjGyjjBR;;AiG1jjBI;EACI,gBAAA;AjG6jjBR;;AiG9jjBI;EACI,gBAAA;AjGikjBR;;AiGlkjBI;EACI,gBAAA;AjGqkjBR;;AiGtkjBI;EACI,gBAAA;AjGykjBR;;AiG1kjBI;EACI,gBAAA;AjG6kjBR;;AiG9kjBI;EACI,gBAAA;AjGiljBR;;AiGlljBI;EACI,gBAAA;AjGqljBR;;AiGtljBI;EACI,gBAAA;AjGyljBR;;AiG1ljBI;EACI,gBAAA;AjG6ljBR;;AiG9ljBI;EACI,gBAAA;AjGimjBR;;AiGlmjBI;EACI,gBAAA;AjGqmjBR;;AiGtmjBI;EACI,iBAAA;AjGymjBR;;AiG1mjBI;EACI,iBAAA;AjG6mjBR;;AiG9mjBI;EACI,gBAAA;AjGinjBR;;AiGlnjBI;EACI,gBAAA;AjGqnjBR;;AiGtnjBI;EACI,gBAAA;AjGynjBR;;AiG1njBI;EACI,gBAAA;AjG6njBR;;AiG9njBI;EACI,gBAAA;AjGiojBR;;AiGlojBI;EACI,gBAAA;AjGqojBR;;AiGtojBI;EACI,gBAAA;AjGyojBR;;AiG1ojBI;EACI,gBAAA;AjG6ojBR;;AiG9ojBI;EACI,iBAAA;AjGipjBR;;AiGlpjBI;EACI,iBAAA;AjGqpjBR;;AiGtpjBI;EACI,gBAAA;AjGypjBR;;AiG1pjBI;EACI,iBAAA;AjG6pjBR;;AiG9pjBI;EACI,iBAAA;AjGiqjBR;;AiGlqjBI;EACI,iBAAA;AjGqqjBR;;AiGtqjBI;EACI,iBAAA;AjGyqjBR;;AiG1qjBI;EACI,iBAAA;AjG6qjBR;;AiG9qjBI;EACI,iBAAA;AjGirjBR;;AiGlrjBI;EACI,iBAAA;AjGqrjBR;;AiGtrjBI;EACI,gBAAA;AjGyrjBR;;AiG1rjBI;EACI,iBAAA;AjG6rjBR;;AiG9rjBI;EACI,gBAAA;AjGisjBR;;AiGlsjBI;EACI,cAAA;AjGqsjBR;;AiGtsjBI;EACI,gBAAA;AjGysjBR;;AiG1sjBI;EACI,gBAAA;AjG6sjBR;;AiG9sjBI;EACI,gBAAA;AjGitjBR;;AiGltjBI;EACI,gBAAA;AjGqtjBR;;AiGttjBI;EACI,cAAA;AjGytjBR;;AiG1tjBI;EACI,gBAAA;AjG6tjBR;;AiG9tjBI;EACI,gBAAA;AjGiujBR;;AiGlujBI;EACI,gBAAA;AjGqujBR;;AiGtujBI;EACI,gBAAA;AjGyujBR;;AiG1ujBI;EACI,cAAA;AjG6ujBR;;AiG9ujBI;EACI,gBAAA;AjGivjBR;;AiGlvjBI;EACI,gBAAA;AjGqvjBR;;AiGtvjBI;EACI,gBAAA;AjGyvjBR;;AiG1vjBI;EACI,gBAAA;AjG6vjBR;;AiG9vjBI;EACI,cAAA;AjGiwjBR;;AiGlwjBI;EACI,gBAAA;AjGqwjBR;;AiGtwjBI;EACI,gBAAA;AjGywjBR;;AiG1wjBI;EACI,gBAAA;AjG6wjBR;;AiG9wjBI;EACI,gBAAA;AjGixjBR;;AiGlxjBI;EACI,cAAA;AjGqxjBR;;AiGtxjBI;EACI,gBAAA;AjGyxjBR;;AiG1xjBI;EACI,gBAAA;AjG6xjBR;;AiG9xjBI;EACI,gBAAA;AjGiyjBR;;AiGlyjBI;EACI,gBAAA;AjGqyjBR;;AiGtyjBI;EACI,cAAA;AjGyyjBR;;AiG1yjBI;EACI,gBAAA;AjG6yjBR;;AiG9yjBI;EACI,gBAAA;AjGizjBR;;AiGlzjBI;EACI,gBAAA;AjGqzjBR;;AiGtzjBI;EACI,gBAAA;AjGyzjBR;;AiG1zjBI;EACI,cAAA;AjG6zjBR;;AiG9zjBI;EACI,gBAAA;AjGi0jBR;;AiGl0jBI;EACI,gBAAA;AjGq0jBR;;AiGt0jBI;EACI,gBAAA;AjGy0jBR;;AiG10jBI;EACI,gBAAA;AjG60jBR;;AiG90jBI;EACI,cAAA;AjGi1jBR;;AiGl1jBI;EACI,gBAAA;AjGq1jBR;;AiGt1jBI;EACI,gBAAA;AjGy1jBR;;AiG11jBI;EACI,gBAAA;AjG61jBR;;AiG91jBI;EACI,gBAAA;AjGi2jBR;;AiGl2jBI;EACI,cAAA;AjGq2jBR;;AiGt2jBI;EACI,gBAAA;AjGy2jBR;;AiG12jBI;EACI,gBAAA;AjG62jBR;;AiG92jBI;EACI,gBAAA;AjGi3jBR;;AiGl3jBI;EACI,gBAAA;AjGq3jBR;;AiGt3jBI;EACI,cAAA;AjGy3jBR;;AiG13jBI;EACI,gBAAA;AjG63jBR;;AiG93jBI;EACI,gBAAA;AjGi4jBR;;AiGl4jBI;EACI,gBAAA;AjGq4jBR;;AiGt4jBI;EACI,gBAAA;AjGy4jBR;;AiG14jBI;EACI,cAAA;AjG64jBR;;AiG94jBI;EACI,gBAAA;AjGi5jBR;;AiGl5jBI;EACI,gBAAA;AjGq5jBR;;AiGt5jBI;EACI,gBAAA;AjGy5jBR;;AiG15jBI;EACI,gBAAA;AjG65jBR;;AiG95jBI;EACI,cAAA;AjGi6jBR;;AiGl6jBI;EACI,gBAAA;AjGq6jBR;;AiGt6jBI;EACI,gBAAA;AjGy6jBR;;AiG16jBI;EACI,gBAAA;AjG66jBR;;AiG96jBI;EACI,gBAAA;AjGi7jBR;;AiGl7jBI;EACI,cAAA;AjGq7jBR;;AiGt7jBI;EACI,gBAAA;AjGy7jBR;;AiG17jBI;EACI,gBAAA;AjG67jBR;;AiG97jBI;EACI,gBAAA;AjGi8jBR;;AiGl8jBI;EACI,gBAAA;AjGq8jBR;;AiGt8jBI;EACI,cAAA;AjGy8jBR;;AiG18jBI;EACI,gBAAA;AjG68jBR;;AiG98jBI;EACI,gBAAA;AjGi9jBR;;AiGl9jBI;EACI,gBAAA;AjGq9jBR;;AiGt9jBI;EACI,gBAAA;AjGy9jBR;;AiG19jBI;EACI,cAAA;AjG69jBR;;AiG99jBI;EACI,gBAAA;AjGi+jBR;;AiGl+jBI;EACI,gBAAA;AjGq+jBR;;AiGt+jBI;EACI,gBAAA;AjGy+jBR;;AiG1+jBI;EACI,gBAAA;AjG6+jBR;;AiG9+jBI;EACI,cAAA;AjGi/jBR;;AiGl/jBI;EACI,gBAAA;AjGq/jBR;;AiGt/jBI;EACI,gBAAA;AjGy/jBR;;AiG1/jBI;EACI,gBAAA;AjG6/jBR;;AiG9/jBI;EACI,gBAAA;AjGigkBR;;AiGlgkBI;EACI,cAAA;AjGqgkBR;;AiGtgkBI;EACI,gBAAA;AjGygkBR;;AiG1gkBI;EACI,gBAAA;AjG6gkBR;;AiG9gkBI;EACI,gBAAA;AjGihkBR;;AiGlhkBI;EACI,gBAAA;AjGqhkBR;;AiGthkBI;EACI,cAAA;AjGyhkBR;;AiG1hkBI;EACI,gBAAA;AjG6hkBR;;AiG9hkBI;EACI,gBAAA;AjGiikBR;;AiGlikBI;EACI,gBAAA;AjGqikBR;;AiGtikBI;EACI,gBAAA;AjGyikBR;;AiG1ikBI;EACI,cAAA;AjG6ikBR;;AiG9ikBI;EACI,gBAAA;AjGijkBR;;AiGljkBI;EACI,gBAAA;AjGqjkBR;;AiGtjkBI;EACI,gBAAA;AjGyjkBR;;AiG1jkBI;EACI,gBAAA;AjG6jkBR;;AiG9jkBI;EACI,cAAA;AjGikkBR;;AiGlkkBI;EACI,gBAAA;AjGqkkBR;;AiGtkkBI;EACI,gBAAA;AjGykkBR;;AiG1kkBI;EACI,gBAAA;AjG6kkBR;;AiG9kkBI;EACI,gBAAA;AjGilkBR;;AiGllkBI;EACI,cAAA;AjGqlkBR;;AiGtlkBI;EACI,gBAAA;AjGylkBR;;AiG1lkBI;EACI,gBAAA;AjG6lkBR;;AiG9lkBI;EACI,gBAAA;AjGimkBR;;AiGlmkBI;EACI,gBAAA;AjGqmkBR;;AiGtmkBI;EACI,cAAA;AjGymkBR;;AiG1mkBI;EACI,gBAAA;AjG6mkBR;;AiG9mkBI;EACI,gBAAA;AjGinkBR;;AiGlnkBI;EACI,gBAAA;AjGqnkBR;;AiGtnkBI;EACI,gBAAA;AjGynkBR;;AiG1nkBI;EACI,cAAA;AjG6nkBR;;AiG9nkBI;EACI,gBAAA;AjGiokBR;;AiGlokBI;EACI,gBAAA;AjGqokBR;;AiGtokBI;EACI,gBAAA;AjGyokBR;;AiG1okBI;EACI,gBAAA;AjG6okBR;;AiG9okBI;EACI,cAAA;AjGipkBR;;AiGlpkBI;EACI,gBAAA;AjGqpkBR;;AiGtpkBI;EACI,gBAAA;AjGypkBR;;AiG1pkBI;EACI,gBAAA;AjG6pkBR;;AiG9pkBI;EACI,gBAAA;AjGiqkBR;;AiGlqkBI;EACI,cAAA;AjGqqkBR;;AiGtqkBI;EACI,gBAAA;AjGyqkBR;;AiG1qkBI;EACI,gBAAA;AjG6qkBR;;AiG9qkBI;EACI,gBAAA;AjGirkBR;;AiGlrkBI;EACI,gBAAA;AjGqrkBR;;AiGtrkBI;EACI,cAAA;AjGyrkBR;;AiG1rkBI;EACI,gBAAA;AjG6rkBR;;AiG9rkBI;EACI,gBAAA;AjGiskBR;;AiGlskBI;EACI,gBAAA;AjGqskBR;;AiGtskBI;EACI,gBAAA;AjGyskBR;;AiG1skBI;EACI,iBAAA;AjG6skBR;;AiG9skBI;EACI,iBAAA;AjGitkBR;;AiGltkBI;EACI,iBAAA;AjGqtkBR;;AiGttkBI;EACI,iBAAA;AjGytkBR;;AiG1tkBI;EACI,iBAAA;AjG6tkBR;;AiG9tkBI;EACI,iBAAA;AjGiukBR;;AiGlukBI;EACI,gBAAA;AjGqukBR;;AiGtukBI;EACI,iBAAA;AjGyukBR;;AiG1ukBI;EACI,iBAAA;AjG6ukBR;;AiG9ukBI;EACI,iBAAA;AjGivkBR;;AiGlvkBI;EACI,gBAAA;AjGqvkBR;;AiGtvkBI;EACI,gBAAA;AjGyvkBR;;AiG1vkBI;EACI,gBAAA;AjG6vkBR;;AiG9vkBI;EACI,gBAAA;AjGiwkBR;;AiGlwkBI;EACI,gBAAA;AjGqwkBR;;AiGtwkBI;EACI,gBAAA;AjGywkBR;;AiG1wkBI;EACI,gBAAA;AjG6wkBR;;AiG9wkBI;EACI,gBAAA;AjGixkBR;;AiGlxkBI;EACI,iBAAA;AjGqxkBR;;AiGtxkBI;EACI,gBAAA;AjGyxkBR;;AiG1xkBI;EACI,gBAAA;AjG6xkBR;;AiG9xkBI;EACI,gBAAA;AjGiykBR;;AiGlykBI;EACI,gBAAA;AjGqykBR;;AiGtykBI;EACI,gBAAA;AjGyykBR;;AiG1ykBI;EACI,gBAAA;AjG6ykBR;;AiG9ykBI;EACI,gBAAA;AjGizkBR;;AiGlzkBI;EACI,gBAAA;AjGqzkBR;;AiGtzkBI;EACI,gBAAA;AjGyzkBR;;AiG1zkBI;EACI,gBAAA;AjG6zkBR;;AiG9zkBI;EACI,gBAAA;AjGi0kBR;;AiGl0kBI;EACI,gBAAA;AjGq0kBR;;AiGt0kBI;EACI,gBAAA;AjGy0kBR;;AiG10kBI;EACI,gBAAA;AjG60kBR;;AiG90kBI;EACI,gBAAA;AjGi1kBR;;AiGl1kBI;EACI,gBAAA;AjGq1kBR;;AiGt1kBI;EACI,iBAAA;AjGy1kBR;;AiG11kBI;EACI,iBAAA;AjG61kBR;;AiG91kBI;EACI,gBAAA;AjGi2kBR;;AiGl2kBI;EACI,iBAAA;AjGq2kBR;;AiGt2kBI;EACI,iBAAA;AjGy2kBR;;AiG12kBI;EACI,iBAAA;AjG62kBR;;AiG92kBI;EACI,gBAAA;AjGi3kBR;;AiGl3kBI;EACI,gBAAA;AjGq3kBR;;AiGt3kBI;EACI,gBAAA;AjGy3kBR;;AiG13kBI;EACI,gBAAA;AjG63kBR;;AiG93kBI;EACI,gBAAA;AjGi4kBR;;AiGl4kBI;EACI,gBAAA;AjGq4kBR;;AiGt4kBI;EACI,gBAAA;AjGy4kBR;;AiG14kBI;EACI,gBAAA;AjG64kBR;;AiG94kBI;EACI,gBAAA;AjGi5kBR;;AiGl5kBI;EACI,gBAAA;AjGq5kBR;;AiGt5kBI;EACI,gBAAA;AjGy5kBR;;AiG15kBI;EACI,gBAAA;AjG65kBR;;AiG95kBI;EACI,gBAAA;AjGi6kBR;;AiGl6kBI;EACI,gBAAA;AjGq6kBR;;AiGt6kBI;EACI,gBAAA;AjGy6kBR;;AiG16kBI;EACI,gBAAA;AjG66kBR;;AiG96kBI;EACI,gBAAA;AjGi7kBR;;AiGl7kBI;EACI,gBAAA;AjGq7kBR;;AiGt7kBI;EACI,gBAAA;AjGy7kBR;;AiG17kBI;EACI,iBAAA;AjG67kBR;;AiG97kBI;EACI,iBAAA;AjGi8kBR;;AiGl8kBI;EACI,iBAAA;AjGq8kBR;;AiGt8kBI;EACI,iBAAA;AjGy8kBR;;AiG18kBI;EACI,iBAAA;AjG68kBR;;AiG98kBI;EACI,iBAAA;AjGi9kBR;;AiGl9kBI;EACI,iBAAA;AjGq9kBR;;AiGt9kBI;EACI,gBAAA;AjGy9kBR;;AiG19kBI;EACI,gBAAA;AjG69kBR;;AiG99kBI;EACI,gBAAA;AjGi+kBR;;AiGl+kBI;EACI,gBAAA;AjGq+kBR;;AiGt+kBI;EACI,gBAAA;AjGy+kBR;;AiG1+kBI;EACI,gBAAA;AjG6+kBR;;AiG9+kBI;EACI,gBAAA;AjGi/kBR;;AiGl/kBI;EACI,gBAAA;AjGq/kBR;;AiGt/kBI;EACI,gBAAA;AjGy/kBR;;AiG1/kBI;EACI,gBAAA;AjG6/kBR;;AiG9/kBI;EACI,gBAAA;AjGiglBR;;AiGlglBI;EACI,gBAAA;AjGqglBR;;AiGtglBI;EACI,gBAAA;AjGyglBR;;AiG1glBI;EACI,gBAAA;AjG6glBR;;AiG9glBI;EACI,gBAAA;AjGihlBR;;AiGlhlBI;EACI,gBAAA;AjGqhlBR;;AiGthlBI;EACI,gBAAA;AjGyhlBR;;AiG1hlBI;EACI,gBAAA;AjG6hlBR;;AiG9hlBI;EACI,gBAAA;AjGiilBR;;AiGlilBI;EACI,gBAAA;AjGqilBR;;AiGtilBI;EACI,gBAAA;AjGyilBR;;AiG1ilBI;EACI,gBAAA;AjG6ilBR;;AiG9ilBI;EACI,gBAAA;AjGijlBR;;AiGljlBI;EACI,gBAAA;AjGqjlBR;;AiGtjlBI;EACI,gBAAA;AjGyjlBR;;AiG1jlBI;EACI,gBAAA;AjG6jlBR;;AiG9jlBI;EACI,gBAAA;AjGiklBR;;AiGlklBI;EACI,gBAAA;AjGqklBR;;AiGtklBI;EACI,gBAAA;AjGyklBR;;AiG1klBI;EACI,gBAAA;AjG6klBR;;AiG9klBI;EACI,gBAAA;AjGillBR;;AiGlllBI;EACI,gBAAA;AjGqllBR;;AiGtllBI;EACI,gBAAA;AjGyllBR;;AiG1llBI;EACI,gBAAA;AjG6llBR;;AiG9llBI;EACI,gBAAA;AjGimlBR;;AiGlmlBI;EACI,gBAAA;AjGqmlBR;;AiGtmlBI;EACI,gBAAA;AjGymlBR;;AiG1mlBI;EACI,gBAAA;AjG6mlBR;;AiG9mlBI;EACI,gBAAA;AjGinlBR;;AiGlnlBI;EACI,gBAAA;AjGqnlBR;;AiGtnlBI;EACI,gBAAA;AjGynlBR;;AiG1nlBI;EACI,gBAAA;AjG6nlBR;;AiG9nlBI;EACI,gBAAA;AjGiolBR;;AiGlolBI;EACI,gBAAA;AjGqolBR;;AiGtolBI;EACI,gBAAA;AjGyolBR;;AiG1olBI;EACI,iBAAA;AjG6olBR;;AiG9olBI;EACI,gBAAA;AjGiplBR;;AiGlplBI;EACI,gBAAA;AjGqplBR;;AiGtplBI;EACI,gBAAA;AjGyplBR;;AiG1plBI;EACI,gBAAA;AjG6plBR;;AiG9plBI;EACI,gBAAA;AjGiqlBR;;AiGlqlBI;EACI,gBAAA;AjGqqlBR;;AiGtqlBI;EACI,gBAAA;AjGyqlBR;;AiG1qlBI;EACI,gBAAA;AjG6qlBR;;AiG9qlBI;EACI,gBAAA;AjGirlBR;;AiGlrlBI;EACI,gBAAA;AjGqrlBR;;AiGtrlBI;EACI,gBAAA;AjGyrlBR;;AiG1rlBI;EACI,gBAAA;AjG6rlBR;;AiG9rlBI;EACI,gBAAA;AjGislBR;;AiGlslBI;EACI,gBAAA;AjGqslBR;;AiGtslBI;EACI,gBAAA;AjGyslBR;;AiG1slBI;EACI,gBAAA;AjG6slBR;;AiG9slBI;EACI,gBAAA;AjGitlBR;;AiGltlBI;EACI,gBAAA;AjGqtlBR;;AiGttlBI;EACI,gBAAA;AjGytlBR;;AiG1tlBI;EACI,gBAAA;AjG6tlBR;;AiG9tlBI;EACI,gBAAA;AjGiulBR;;AiGlulBI;EACI,gBAAA;AjGqulBR;;AiGtulBI;EACI,gBAAA;AjGyulBR;;AiG1ulBI;EACI,gBAAA;AjG6ulBR;;AiG9ulBI;EACI,gBAAA;AjGivlBR;;AiGlvlBI;EACI,gBAAA;AjGqvlBR;;AiGtvlBI;EACI,gBAAA;AjGyvlBR;;AiG1vlBI;EACI,gBAAA;AjG6vlBR;;AiG9vlBI;EACI,gBAAA;AjGiwlBR;;AiGlwlBI;EACI,gBAAA;AjGqwlBR;;AiGtwlBI;EACI,gBAAA;AjGywlBR;;AiG1wlBI;EACI,gBAAA;AjG6wlBR;;AiG9wlBI;EACI,gBAAA;AjGixlBR;;AiGlxlBI;EACI,gBAAA;AjGqxlBR;;AiGtxlBI;EACI,gBAAA;AjGyxlBR;;AiG1xlBI;EACI,gBAAA;AjG6xlBR;;AiG9xlBI;EACI,gBAAA;AjGiylBR;;AiGlylBI;EACI,gBAAA;AjGqylBR;;AiGtylBI;EACI,gBAAA;AjGyylBR;;AiG1ylBI;EACI,gBAAA;AjG6ylBR;;AiG9ylBI;EACI,gBAAA;AjGizlBR;;AiGlzlBI;EACI,gBAAA;AjGqzlBR;;AiGtzlBI;EACI,gBAAA;AjGyzlBR;;AiG1zlBI;EACI,gBAAA;AjG6zlBR;;AiG9zlBI;EACI,gBAAA;AjGi0lBR;;AiGl0lBI;EACI,gBAAA;AjGq0lBR;;AiGt0lBI;EACI,gBAAA;AjGy0lBR;;AiG10lBI;EACI,gBAAA;AjG60lBR;;AiG90lBI;EACI,gBAAA;AjGi1lBR;;AiGl1lBI;EACI,gBAAA;AjGq1lBR;;AiGt1lBI;EACI,gBAAA;AjGy1lBR;;AiG11lBI;EACI,gBAAA;AjG61lBR;;AiG91lBI;EACI,gBAAA;AjGi2lBR;;AiGl2lBI;EACI,gBAAA;AjGq2lBR;;AiGt2lBI;EACI,gBAAA;AjGy2lBR;;AiG12lBI;EACI,gBAAA;AjG62lBR;;AiG92lBI;EACI,gBAAA;AjGi3lBR;;AiGl3lBI;EACI,gBAAA;AjGq3lBR;;AiGt3lBI;EACI,gBAAA;AjGy3lBR;;AiG13lBI;EACI,gBAAA;AjG63lBR;;AiG93lBI;EACI,iBAAA;AjGi4lBR;;AiGl4lBI;EACI,gBAAA;AjGq4lBR;;AiGt4lBI;EACI,gBAAA;AjGy4lBR;;AiG14lBI;EACI,gBAAA;AjG64lBR;;AiG94lBI;EACI,gBAAA;AjGi5lBR;;AiGl5lBI;EACI,gBAAA;AjGq5lBR;;AiGt5lBI;EACI,gBAAA;AjGy5lBR;;AiG15lBI;EACI,gBAAA;AjG65lBR;;AiG95lBI;EACI,gBAAA;AjGi6lBR;;AiGl6lBI;EACI,gBAAA;AjGq6lBR;;AiGt6lBI;EACI,gBAAA;AjGy6lBR;;AiG16lBI;EACI,gBAAA;AjG66lBR;;AiG96lBI;EACI,gBAAA;AjGi7lBR;;AiGl7lBI;EACI,gBAAA;AjGq7lBR;;AiGt7lBI;EACI,iBAAA;AjGy7lBR;;AiG17lBI;EACI,gBAAA;AjG67lBR;;AiG97lBI;EACI,gBAAA;AjGi8lBR;;AiGl8lBI;EACI,iBAAA;AjGq8lBR;;AiGt8lBI;EACI,gBAAA;AjGy8lBR;;AiG18lBI;EACI,gBAAA;AjG68lBR;;AiG98lBI;EACI,gBAAA;AjGi9lBR;;AiGl9lBI;EACI,gBAAA;AjGq9lBR;;AiGt9lBI;EACI,gBAAA;AjGy9lBR;;AiG19lBI;EACI,gBAAA;AjG69lBR;;AiG99lBI;EACI,gBAAA;AjGi+lBR;;AiGl+lBI;EACI,gBAAA;AjGq+lBR;;AiGt+lBI;EACI,gBAAA;AjGy+lBR;;AiG1+lBI;EACI,gBAAA;AjG6+lBR;;AiG9+lBI;EACI,gBAAA;AjGi/lBR;;AiGl/lBI;EACI,gBAAA;AjGq/lBR;;AiGt/lBI;EACI,gBAAA;AjGy/lBR;;AiG1/lBI;EACI,gBAAA;AjG6/lBR;;AiG9/lBI;EACI,gBAAA;AjGigmBR;;AiGlgmBI;EACI,gBAAA;AjGqgmBR;;AiGtgmBI;EACI,gBAAA;AjGygmBR;;AiG1gmBI;EACI,gBAAA;AjG6gmBR;;AiG9gmBI;EACI,gBAAA;AjGihmBR;;AiGlhmBI;EACI,gBAAA;AjGqhmBR;;AiGthmBI;EACI,gBAAA;AjGyhmBR;;AiG1hmBI;EACI,gBAAA;AjG6hmBR;;AiG9hmBI;EACI,gBAAA;AjGiimBR;;AiGlimBI;EACI,gBAAA;AjGqimBR;;AiGtimBI;EACI,iBAAA;AjGyimBR;;AiG1imBI;EACI,gBAAA;AjG6imBR;;AiG9imBI;EACI,gBAAA;AjGijmBR;;AiGljmBI;EACI,gBAAA;AjGqjmBR;;AiGtjmBI;EACI,gBAAA;AjGyjmBR;;AiG1jmBI;EACI,gBAAA;AjG6jmBR;;AiG9jmBI;EACI,gBAAA;AjGikmBR;;AiGlkmBI;EACI,gBAAA;AjGqkmBR;;AiGtkmBI;EACI,gBAAA;AjGykmBR;;AiG1kmBI;EACI,gBAAA;AjG6kmBR;;AiG9kmBI;EACI,gBAAA;AjGilmBR;;AiGllmBI;EACI,gBAAA;AjGqlmBR;;AiGtlmBI;EACI,gBAAA;AjGylmBR;;AiG1lmBI;EACI,gBAAA;AjG6lmBR;;AiG9lmBI;EACI,gBAAA;AjGimmBR;;AiGlmmBI;EACI,gBAAA;AjGqmmBR;;AiGtmmBI;EACI,gBAAA;AjGymmBR;;AiG1mmBI;EACI,gBAAA;AjG6mmBR;;AiG9mmBI;EACI,gBAAA;AjGinmBR;;AiGlnmBI;EACI,gBAAA;AjGqnmBR;;AiGtnmBI;EACI,gBAAA;AjGynmBR;;AiG1nmBI;EACI,gBAAA;AjG6nmBR;;AiG9nmBI;EACI,gBAAA;AjGiomBR;;AiGlomBI;EACI,gBAAA;AjGqomBR;;AiGtomBI;EACI,gBAAA;AjGyomBR;;AiG1omBI;EACI,gBAAA;AjG6omBR;;AiG9omBI;EACI,gBAAA;AjGipmBR;;AiGlpmBI;EACI,gBAAA;AjGqpmBR;;AiGtpmBI;EACI,gBAAA;AjGypmBR;;AiG1pmBI;EACI,gBAAA;AjG6pmBR;;AiG9pmBI;EACI,gBAAA;AjGiqmBR;;AiGlqmBI;EACI,gBAAA;AjGqqmBR;;AiGtqmBI;EACI,gBAAA;AjGyqmBR;;AiG1qmBI;EACI,gBAAA;AjG6qmBR;;AiG9qmBI;EACI,gBAAA;AjGirmBR;;AiGlrmBI;EACI,gBAAA;AjGqrmBR;;AiGtrmBI;EACI,gBAAA;AjGyrmBR;;AiG1rmBI;EACI,gBAAA;AjG6rmBR;;AiG9rmBI;EACI,gBAAA;AjGismBR;;AiGlsmBI;EACI,gBAAA;AjGqsmBR;;AiGtsmBI;EACI,gBAAA;AjGysmBR;;AiG1smBI;EACI,gBAAA;AjG6smBR;;AiG9smBI;EACI,gBAAA;AjGitmBR;;AiGltmBI;EACI,iBAAA;AjGqtmBR;;AiGttmBI;EACI,gBAAA;AjGytmBR;;AiG1tmBI;EACI,gBAAA;AjG6tmBR;;AiG9tmBI;EACI,gBAAA;AjGiumBR;;AiGlumBI;EACI,gBAAA;AjGqumBR;;AiGtumBI;EACI,gBAAA;AjGyumBR;;AiG1umBI;EACI,gBAAA;AjG6umBR;;AiG9umBI;EACI,gBAAA;AjGivmBR;;AiGlvmBI;EACI,gBAAA;AjGqvmBR;;AiGtvmBI;EACI,iBAAA;AjGyvmBR;;AiG1vmBI;EACI,gBAAA;AjG6vmBR;;AiG9vmBI;EACI,gBAAA;AjGiwmBR;;AiGlwmBI;EACI,iBAAA;AjGqwmBR;;AiGtwmBI;EACI,gBAAA;AjGywmBR;;AiG1wmBI;EACI,gBAAA;AjG6wmBR;;AiG9wmBI;EACI,gBAAA;AjGixmBR;;AiGlxmBI;EACI,gBAAA;AjGqxmBR;;AiGtxmBI;EACI,gBAAA;AjGyxmBR;;AiG1xmBI;EACI,gBAAA;AjG6xmBR;;AiG9xmBI;EACI,gBAAA;AjGiymBR;;AiGlymBI;EACI,gBAAA;AjGqymBR;;AiGtymBI;EACI,gBAAA;AjGyymBR;;AiG1ymBI;EACI,gBAAA;AjG6ymBR;;AiG9ymBI;EACI,gBAAA;AjGizmBR;;AiGlzmBI;EACI,gBAAA;AjGqzmBR;;AiGtzmBI;EACI,gBAAA;AjGyzmBR;;AiG1zmBI;EACI,gBAAA;AjG6zmBR;;AiG9zmBI;EACI,gBAAA;AjGi0mBR;;AiGl0mBI;EACI,gBAAA;AjGq0mBR;;AiGt0mBI;EACI,gBAAA;AjGy0mBR;;AiG10mBI;EACI,gBAAA;AjG60mBR;;AiG90mBI;EACI,gBAAA;AjGi1mBR;;AiGl1mBI;EACI,gBAAA;AjGq1mBR;;AiGt1mBI;EACI,gBAAA;AjGy1mBR;;AiG11mBI;EACI,gBAAA;AjG61mBR;;AiG91mBI;EACI,gBAAA;AjGi2mBR;;AiGl2mBI;EACI,gBAAA;AjGq2mBR;;AiGt2mBI;EACI,gBAAA;AjGy2mBR;;AiG12mBI;EACI,gBAAA;AjG62mBR;;AiG92mBI;EACI,iBAAA;AjGi3mBR;;AiGl3mBI;EACI,iBAAA;AjGq3mBR;;AiGt3mBI;EACI,gBAAA;AjGy3mBR;;AiG13mBI;EACI,gBAAA;AjG63mBR;;AiG93mBI;EACI,gBAAA;AjGi4mBR;;AiGl4mBI;EACI,gBAAA;AjGq4mBR;;AiGt4mBI;EACI,gBAAA;AjGy4mBR;;AiG14mBI;EACI,gBAAA;AjG64mBR;;AiG94mBI;EACI,gBAAA;AjGi5mBR;;AiGl5mBI;EACI,gBAAA;AjGq5mBR;;AiGt5mBI;EACI,gBAAA;AjGy5mBR;;AiG15mBI;EACI,gBAAA;AjG65mBR;;AiG95mBI;EACI,gBAAA;AjGi6mBR;;AiGl6mBI;EACI,gBAAA;AjGq6mBR;;AiGt6mBI;EACI,gBAAA;AjGy6mBR;;AiG16mBI;EACI,iBAAA;AjG66mBR;;AiG96mBI;EACI,iBAAA;AjGi7mBR;;AiGl7mBI;EACI,iBAAA;AjGq7mBR;;AiGt7mBI;EACI,gBAAA;AjGy7mBR;;AiG17mBI;EACI,gBAAA;AjG67mBR;;AiG97mBI;EACI,gBAAA;AjGi8mBR;;AiGl8mBI;EACI,gBAAA;AjGq8mBR;;AiGt8mBI;EACI,gBAAA;AjGy8mBR;;AiG18mBI;EACI,gBAAA;AjG68mBR;;AiG98mBI;EACI,gBAAA;AjGi9mBR;;AiGl9mBI;EACI,gBAAA;AjGq9mBR;;AiGt9mBI;EACI,gBAAA;AjGy9mBR;;AiG19mBI;EACI,gBAAA;AjG69mBR;;AiG99mBI;EACI,gBAAA;AjGi+mBR;;AiGl+mBI;EACI,gBAAA;AjGq+mBR;;AiGt+mBI;EACI,gBAAA;AjGy+mBR;;AiG1+mBI;EACI,iBAAA;AjG6+mBR;;AiG9+mBI;EACI,iBAAA;AjGi/mBR;;AiGl/mBI;EACI,iBAAA;AjGq/mBR;;AiGt/mBI;EACI,iBAAA;AjGy/mBR;;AiG1/mBI;EACI,iBAAA;AjG6/mBR;;AiG9/mBI;EACI,iBAAA;AjGignBR;;AiGlgnBI;EACI,gBAAA;AjGqgnBR;;AiGtgnBI;EACI,gBAAA;AjGygnBR;;AiG1gnBI;EACI,iBAAA;AjG6gnBR;;AiG9gnBI;EACI,iBAAA;AjGihnBR;;AiGlhnBI;EACI,gBAAA;AjGqhnBR;;AiGthnBI;EACI,gBAAA;AjGyhnBR;;AiG1hnBI;EACI,gBAAA;AjG6hnBR;;AiG9hnBI;EACI,gBAAA;AjGiinBR;;AiGlinBI;EACI,gBAAA;AjGqinBR;;AiGtinBI;EACI,gBAAA;AjGyinBR;;AiG1inBI;EACI,gBAAA;AjG6inBR;;AiG9inBI;EACI,gBAAA;AjGijnBR;;AiGljnBI;EACI,iBAAA;AjGqjnBR;;AiGtjnBI;EACI,iBAAA;AjGyjnBR;;AiG1jnBI;EACI,iBAAA;AjG6jnBR;;AiG9jnBI;EACI,iBAAA;AjGiknBR;;AiGlknBI;EACI,iBAAA;AjGqknBR;;AiGtknBI;EACI,iBAAA;AjGyknBR;;AiG1knBI;EACI,gBAAA;AjG6knBR;;AiG9knBI;EACI,iBAAA;AjGilnBR;;AiGllnBI;EACI,iBAAA;AjGqlnBR;;AiGtlnBI;EACI,iBAAA;AjGylnBR;;AiG1lnBI;EACI,iBAAA;AjG6lnBR;;AiG9lnBI;EACI,iBAAA;AjGimnBR;;AiGlmnBI;EACI,iBAAA;AjGqmnBR;;AiGtmnBI;EACI,gBAAA;AjGymnBR;;AiG1mnBI;EACI,iBAAA;AjG6mnBR;;AiG9mnBI;EACI,iBAAA;AjGinnBR;;AiGlnnBI;EACI,gBAAA;AjGqnnBR;;AiGtnnBI;EACI,iBAAA;AjGynnBR;;AiG1nnBI;EACI,iBAAA;AjG6nnBR;;AiG9nnBI;EACI,iBAAA;AjGionBR;;AiGlonBI;EACI,iBAAA;AjGqonBR;;AiGtonBI;EACI,iBAAA;AjGyonBR;;AiG1onBI;EACI,iBAAA;AjG6onBR;;AiG9onBI;EACI,gBAAA;AjGipnBR;;AiGlpnBI;EACI,gBAAA;AjGqpnBR;;AiGtpnBI;EACI,iBAAA;AjGypnBR;;AiG1pnBI;EACI,gBAAA;AjG6pnBR;;AiG9pnBI;EACI,iBAAA;AjGiqnBR;;AiGlqnBI;EACI,gBAAA;AjGqqnBR;;AiGtqnBI;EACI,gBAAA;AjGyqnBR;;AiG1qnBI;EACI,gBAAA;AjG6qnBR;;AiG9qnBI;EACI,gBAAA;AjGirnBR;;AiGlrnBI;EACI,iBAAA;AjGqrnBR;;AiGtrnBI;EACI,iBAAA;AjGyrnBR;;AiG1rnBI;EACI,gBAAA;AjG6rnBR;;AiG9rnBI;EACI,gBAAA;AjGisnBR;;AiGlsnBI;EACI,gBAAA;AjGqsnBR;;AiGtsnBI;EACI,gBAAA;AjGysnBR;;AiG1snBI;EACI,gBAAA;AjG6snBR;;AiG9snBI;EACI,gBAAA;AjGitnBR;;AiGltnBI;EACI,gBAAA;AjGqtnBR;;AiGttnBI;EACI,gBAAA;AjGytnBR;;AiG1tnBI;EACI,gBAAA;AjG6tnBR;;AiG9tnBI;EACI,gBAAA;AjGiunBR;;AiGlunBI;EACI,gBAAA;AjGqunBR;;AiGtunBI;EACI,gBAAA;AjGyunBR;;AiG1unBI;EACI,gBAAA;AjG6unBR;;AiG9unBI;EACI,gBAAA;AjGivnBR;;AiGlvnBI;EACI,gBAAA;AjGqvnBR;;AiGtvnBI;EACI,iBAAA;AjGyvnBR;;AiG1vnBI;EACI,iBAAA;AjG6vnBR;;AiG9vnBI;EACI,gBAAA;AjGiwnBR;;AiGlwnBI;EACI,iBAAA;AjGqwnBR;;AiGtwnBI;EACI,iBAAA;AjGywnBR;;AiG1wnBI;EACI,gBAAA;AjG6wnBR;;AiG9wnBI;EACI,gBAAA;AjGixnBR;;AiGlxnBI;EACI,gBAAA;AjGqxnBR;;AiGtxnBI;EACI,gBAAA;AjGyxnBR;;AiG1xnBI;EACI,gBAAA;AjG6xnBR;;AiG9xnBI;EACI,gBAAA;AjGiynBR;;AiGlynBI;EACI,gBAAA;AjGqynBR;;AiGtynBI;EACI,gBAAA;AjGyynBR;;AiG1ynBI;EACI,gBAAA;AjG6ynBR;;AiG9ynBI;EACI,gBAAA;AjGiznBR;;AiGlznBI;EACI,gBAAA;AjGqznBR;;AiGtznBI;EACI,gBAAA;AjGyznBR;;AiG1znBI;EACI,gBAAA;AjG6znBR;;AiG9znBI;EACI,iBAAA;AjGi0nBR;;AiGl0nBI;EACI,gBAAA;AjGq0nBR;;AiGt0nBI;EACI,gBAAA;AjGy0nBR;;AiG10nBI;EACI,gBAAA;AjG60nBR;;AiG90nBI;EACI,gBAAA;AjGi1nBR;;AiGl1nBI;EACI,gBAAA;AjGq1nBR;;AiGt1nBI;EACI,gBAAA;AjGy1nBR;;AiG11nBI;EACI,gBAAA;AjG61nBR;;AiG91nBI;EACI,gBAAA;AjGi2nBR;;AiGl2nBI;EACI,gBAAA;AjGq2nBR;;AiGt2nBI;EACI,gBAAA;AjGy2nBR;;AiG12nBI;EACI,gBAAA;AjG62nBR;;AiG92nBI;EACI,gBAAA;AjGi3nBR;;AiGl3nBI;EACI,gBAAA;AjGq3nBR;;AiGt3nBI;EACI,gBAAA;AjGy3nBR;;AiG13nBI;EACI,gBAAA;AjG63nBR;;AiG93nBI;EACI,gBAAA;AjGi4nBR;;AiGl4nBI;EACI,gBAAA;AjGq4nBR;;AiGt4nBI;EACI,gBAAA;AjGy4nBR;;AiG14nBI;EACI,gBAAA;AjG64nBR;;AiG94nBI;EACI,iBAAA;AjGi5nBR;;AiGl5nBI;EACI,gBAAA;AjGq5nBR;;AiGt5nBI;EACI,gBAAA;AjGy5nBR;;AiG15nBI;EACI,gBAAA;AjG65nBR;;AiG95nBI;EACI,gBAAA;AjGi6nBR;;AiGl6nBI;EACI,gBAAA;AjGq6nBR;;AiGt6nBI;EACI,gBAAA;AjGy6nBR;;AiG16nBI;EACI,gBAAA;AjG66nBR;;AiG96nBI;EACI,gBAAA;AjGi7nBR;;AiGl7nBI;EACI,gBAAA;AjGq7nBR;;AiGt7nBI;EACI,gBAAA;AjGy7nBR;;AiG17nBI;EACI,gBAAA;AjG67nBR;;AiG97nBI;EACI,gBAAA;AjGi8nBR;;AiGl8nBI;EACI,gBAAA;AjGq8nBR;;AiGt8nBI;EACI,gBAAA;AjGy8nBR;;AiG18nBI;EACI,gBAAA;AjG68nBR;;AiG98nBI;EACI,gBAAA;AjGi9nBR;;AiGl9nBI;EACI,gBAAA;AjGq9nBR;;AiGt9nBI;EACI,gBAAA;AjGy9nBR;;AiG19nBI;EACI,gBAAA;AjG69nBR;;AiG99nBI;EACI,gBAAA;AjGi+nBR;;AiGl+nBI;EACI,gBAAA;AjGq+nBR;;AiGt+nBI;EACI,gBAAA;AjGy+nBR;;AiG1+nBI;EACI,iBAAA;AjG6+nBR;;AiG9+nBI;EACI,gBAAA;AjGi/nBR;;AiGl/nBI;EACI,gBAAA;AjGq/nBR;;AiGt/nBI;EACI,gBAAA;AjGy/nBR;;AiG1/nBI;EACI,gBAAA;AjG6/nBR;;AiG9/nBI;EACI,gBAAA;AjGigoBR;;AiGlgoBI;EACI,iBAAA;AjGqgoBR;;AiGtgoBI;EACI,gBAAA;AjGygoBR;;AiG1goBI;EACI,gBAAA;AjG6goBR;;AiG9goBI;EACI,gBAAA;AjGihoBR;;AiGlhoBI;EACI,gBAAA;AjGqhoBR;;AiGthoBI;EACI,gBAAA;AjGyhoBR;;AiG1hoBI;EACI,gBAAA;AjG6hoBR;;AiG9hoBI;EACI,iBAAA;AjGiioBR;;AiGlioBI;EACI,iBAAA;AjGqioBR;;AiGtioBI;EACI,gBAAA;AjGyioBR;;AiG1ioBI;EACI,gBAAA;AjG6ioBR;;AiG9ioBI;EACI,gBAAA;AjGijoBR;;AiGljoBI;EACI,gBAAA;AjGqjoBR;;AiGtjoBI;EACI,gBAAA;AjGyjoBR;;AiG1joBI;EACI,gBAAA;AjG6joBR;;AiG9joBI;EACI,gBAAA;AjGikoBR;;AiGlkoBI;EACI,gBAAA;AjGqkoBR;;AiGtkoBI;EACI,gBAAA;AjGykoBR;;AiG1koBI;EACI,iBAAA;AjG6koBR;;AiG9koBI;EACI,gBAAA;AjGiloBR;;AiGlloBI;EACI,gBAAA;AjGqloBR;;AiGtloBI;EACI,gBAAA;AjGyloBR;;AiG1loBI;EACI,gBAAA;AjG6loBR;;AiG9loBI;EACI,gBAAA;AjGimoBR;;AiGlmoBI;EACI,gBAAA;AjGqmoBR;;AiGtmoBI;EACI,gBAAA;AjGymoBR;;AiG1moBI;EACI,gBAAA;AjG6moBR;;AiG9moBI;EACI,gBAAA;AjGinoBR;;AiGlnoBI;EACI,gBAAA;AjGqnoBR;;AiGtnoBI;EACI,gBAAA;AjGynoBR;;AiG1noBI;EACI,gBAAA;AjG6noBR;;AiG9noBI;EACI,gBAAA;AjGiooBR;;AiGlooBI;EACI,gBAAA;AjGqooBR;;AiGtooBI;EACI,gBAAA;AjGyooBR;;AiG1ooBI;EACI,gBAAA;AjG6ooBR;;AiG9ooBI;EACI,gBAAA;AjGipoBR;;AiGlpoBI;EACI,gBAAA;AjGqpoBR;;AiGtpoBI;EACI,gBAAA;AjGypoBR;;AiG1poBI;EACI,iBAAA;AjG6poBR;;AiG9poBI;EACI,iBAAA;AjGiqoBR;;AiGlqoBI;EACI,iBAAA;AjGqqoBR;;AiGtqoBI;EACI,iBAAA;AjGyqoBR;;AiG1qoBI;EACI,iBAAA;AjG6qoBR;;AiG9qoBI;EACI,iBAAA;AjGiroBR;;AiGlroBI;EACI,iBAAA;AjGqroBR;;AiGtroBI;EACI,iBAAA;AjGyroBR;;AiG1roBI;EACI,iBAAA;AjG6roBR;;AiG9roBI;EACI,iBAAA;AjGisoBR;;AiGlsoBI;EACI,gBAAA;AjGqsoBR;;AiGtsoBI;EACI,iBAAA;AjGysoBR;;AiG1soBI;EACI,gBAAA;AjG6soBR;;AiG9soBI;EACI,gBAAA;AjGitoBR;;AiGltoBI;EACI,gBAAA;AjGqtoBR;;AiGttoBI;EACI,gBAAA;AjGytoBR;;AiG1toBI;EACI,gBAAA;AjG6toBR;;AiG9toBI;EACI,gBAAA;AjGiuoBR;;AiGluoBI;EACI,gBAAA;AjGquoBR;;AiGtuoBI;EACI,gBAAA;AjGyuoBR;;AiG1uoBI;EACI,gBAAA;AjG6uoBR;;AiG9uoBI;EACI,gBAAA;AjGivoBR;;AiGlvoBI;EACI,gBAAA;AjGqvoBR;;AiGtvoBI;EACI,gBAAA;AjGyvoBR;;AiG1voBI;EACI,gBAAA;AjG6voBR;;AiG9voBI;EACI,gBAAA;AjGiwoBR;;AiGlwoBI;EACI,gBAAA;AjGqwoBR;;AiGtwoBI;EACI,gBAAA;AjGywoBR;;AiG1woBI;EACI,iBAAA;AjG6woBR;;AiG9woBI;EACI,iBAAA;AjGixoBR;;AiGlxoBI;EACI,iBAAA;AjGqxoBR;;AiGtxoBI;EACI,gBAAA;AjGyxoBR;;AiG1xoBI;EACI,gBAAA;AjG6xoBR;;AiG9xoBI;EACI,gBAAA;AjGiyoBR;;AiGlyoBI;EACI,gBAAA;AjGqyoBR;;AiGtyoBI;EACI,gBAAA;AjGyyoBR;;AiG1yoBI;EACI,gBAAA;AjG6yoBR;;AiG9yoBI;EACI,gBAAA;AjGizoBR;;AiGlzoBI;EACI,gBAAA;AjGqzoBR;;AiGtzoBI;EACI,gBAAA;AjGyzoBR;;AiG1zoBI;EACI,gBAAA;AjG6zoBR;;AiG9zoBI;EACI,gBAAA;AjGi0oBR;;AiGl0oBI;EACI,gBAAA;AjGq0oBR;;AiGt0oBI;EACI,gBAAA;AjGy0oBR;;AiG10oBI;EACI,gBAAA;AjG60oBR;;AiG90oBI;EACI,gBAAA;AjGi1oBR;;AiGl1oBI;EACI,gBAAA;AjGq1oBR;;AiGt1oBI;EACI,gBAAA;AjGy1oBR;;AiG11oBI;EACI,gBAAA;AjG61oBR;;AiG91oBI;EACI,gBAAA;AjGi2oBR;;AiGl2oBI;EACI,gBAAA;AjGq2oBR;;AiGt2oBI;EACI,gBAAA;AjGy2oBR;;AiG12oBI;EACI,gBAAA;AjG62oBR;;AiG92oBI;EACI,gBAAA;AjGi3oBR;;AiGl3oBI;EACI,gBAAA;AjGq3oBR;;AiGt3oBI;EACI,gBAAA;AjGy3oBR;;AiG13oBI;EACI,gBAAA;AjG63oBR;;AiG93oBI;EACI,gBAAA;AjGi4oBR;;AiGl4oBI;EACI,gBAAA;AjGq4oBR;;AiGt4oBI;EACI,gBAAA;AjGy4oBR;;AiG14oBI;EACI,gBAAA;AjG64oBR;;AiG94oBI;EACI,gBAAA;AjGi5oBR;;AiGl5oBI;EACI,gBAAA;AjGq5oBR;;AiGt5oBI;EACI,gBAAA;AjGy5oBR;;AiG15oBI;EACI,gBAAA;AjG65oBR;;AiG95oBI;EACI,gBAAA;AjGi6oBR;;AiGl6oBI;EACI,gBAAA;AjGq6oBR;;AiGt6oBI;EACI,gBAAA;AjGy6oBR;;AiG16oBI;EACI,gBAAA;AjG66oBR;;AiG96oBI;EACI,gBAAA;AjGi7oBR;;AiGl7oBI;EACI,gBAAA;AjGq7oBR;;AiGt7oBI;EACI,iBAAA;AjGy7oBR;;AiG17oBI;EACI,iBAAA;AjG67oBR;;AiG97oBI;EACI,gBAAA;AjGi8oBR;;AiGl8oBI;EACI,gBAAA;AjGq8oBR;;AiGt8oBI;EACI,gBAAA;AjGy8oBR;;AiG18oBI;EACI,gBAAA;AjG68oBR;;AiG98oBI;EACI,gBAAA;AjGi9oBR;;AiGl9oBI;EACI,gBAAA;AjGq9oBR;;AiGt9oBI;EACI,iBAAA;AjGy9oBR;;AiG19oBI;EACI,gBAAA;AjG69oBR;;AiG99oBI;EACI,gBAAA;AjGi+oBR;;AiGl+oBI;EACI,gBAAA;AjGq+oBR;;AiGt+oBI;EACI,iBAAA;AjGy+oBR;;AiG1+oBI;EACI,iBAAA;AjG6+oBR;;AiG9+oBI;EACI,iBAAA;AjGi/oBR;;AiGl/oBI;EACI,gBAAA;AjGq/oBR;;AiGt/oBI;EACI,gBAAA;AjGy/oBR;;AiG1/oBI;EACI,gBAAA;AjG6/oBR;;AiG9/oBI;EACI,gBAAA;AjGigpBR;;AiGlgpBI;EACI,gBAAA;AjGqgpBR;;AiGtgpBI;EACI,gBAAA;AjGygpBR;;AiG1gpBI;EACI,gBAAA;AjG6gpBR;;AiG9gpBI;EACI,gBAAA;AjGihpBR;;AiGlhpBI;EACI,gBAAA;AjGqhpBR;;AiGthpBI;EACI,gBAAA;AjGyhpBR;;AiG1hpBI;EACI,gBAAA;AjG6hpBR;;AiG9hpBI;EACI,iBAAA;AjGiipBR;;AiGlipBI;EACI,iBAAA;AjGqipBR;;AiGtipBI;EACI,gBAAA;AjGyipBR;;AiG1ipBI;EACI,iBAAA;AjG6ipBR;;AiG9ipBI;EACI,gBAAA;AjGijpBR;;AiGljpBI;EACI,gBAAA;AjGqjpBR;;AiGtjpBI;EACI,gBAAA;AjGyjpBR;;AiG1jpBI;EACI,gBAAA;AjG6jpBR;;AiG9jpBI;EACI,gBAAA;AjGikpBR;;AiGlkpBI;EACI,gBAAA;AjGqkpBR;;AiGtkpBI;EACI,gBAAA;AjGykpBR;;AiG1kpBI;EACI,gBAAA;AjG6kpBR;;AiG9kpBI;EACI,gBAAA;AjGilpBR;;AiGllpBI;EACI,gBAAA;AjGqlpBR;;AiGtlpBI;EACI,gBAAA;AjGylpBR;;AiG1lpBI;EACI,gBAAA;AjG6lpBR;;AiG9lpBI;EACI,gBAAA;AjGimpBR;;AiGlmpBI;EACI,gBAAA;AjGqmpBR;;AiGtmpBI;EACI,gBAAA;AjGympBR;;AiG1mpBI;EACI,gBAAA;AjG6mpBR;;AiG9mpBI;EACI,gBAAA;AjGinpBR;;AiGlnpBI;EACI,gBAAA;AjGqnpBR;;AiGtnpBI;EACI,gBAAA;AjGynpBR;;AiG1npBI;EACI,gBAAA;AjG6npBR;;AiG9npBI;EACI,gBAAA;AjGiopBR;;AiGlopBI;EACI,gBAAA;AjGqopBR;;AiGtopBI;EACI,gBAAA;AjGyopBR;;AiG1opBI;EACI,gBAAA;AjG6opBR;;AiG9opBI;EACI,gBAAA;AjGippBR;;AiGlppBI;EACI,gBAAA;AjGqppBR;;AiGtppBI;EACI,gBAAA;AjGyppBR;;AiG1ppBI;EACI,gBAAA;AjG6ppBR;;AiG9ppBI;EACI,gBAAA;AjGiqpBR;;AiGlqpBI;EACI,gBAAA;AjGqqpBR;;AiGtqpBI;EACI,gBAAA;AjGyqpBR;;AiG1qpBI;EACI,gBAAA;AjG6qpBR;;AiG9qpBI;EACI,gBAAA;AjGirpBR;;AiGlrpBI;EACI,gBAAA;AjGqrpBR;;AiGtrpBI;EACI,gBAAA;AjGyrpBR;;AiG1rpBI;EACI,gBAAA;AjG6rpBR;;AiG9rpBI;EACI,gBAAA;AjGispBR;;AiGlspBI;EACI,gBAAA;AjGqspBR;;AiGtspBI;EACI,gBAAA;AjGyspBR;;AiG1spBI;EACI,gBAAA;AjG6spBR;;AiG9spBI;EACI,gBAAA;AjGitpBR;;AiGltpBI;EACI,gBAAA;AjGqtpBR;;AiGttpBI;EACI,gBAAA;AjGytpBR;;AiG1tpBI;EACI,gBAAA;AjG6tpBR;;AiG9tpBI;EACI,gBAAA;AjGiupBR;;AiGlupBI;EACI,gBAAA;AjGqupBR;;AiGtupBI;EACI,gBAAA;AjGyupBR;;AiG1upBI;EACI,gBAAA;AjG6upBR;;AiG9upBI;EACI,gBAAA;AjGivpBR;;AiGlvpBI;EACI,gBAAA;AjGqvpBR;;AiGtvpBI;EACI,gBAAA;AjGyvpBR;;AiG1vpBI;EACI,gBAAA;AjG6vpBR;;AiG9vpBI;EACI,gBAAA;AjGiwpBR;;AiGlwpBI;EACI,gBAAA;AjGqwpBR;;AiGtwpBI;EACI,gBAAA;AjGywpBR;;AiG1wpBI;EACI,gBAAA;AjG6wpBR;;AiG9wpBI;EACI,gBAAA;AjGixpBR;;AiGlxpBI;EACI,gBAAA;AjGqxpBR;;AiGtxpBI;EACI,gBAAA;AjGyxpBR;;AiG1xpBI;EACI,gBAAA;AjG6xpBR;;AiG9xpBI;EACI,gBAAA;AjGiypBR;;AiGlypBI;EACI,gBAAA;AjGqypBR;;AiGtypBI;EACI,gBAAA;AjGyypBR;;AiG1ypBI;EACI,gBAAA;AjG6ypBR;;AiG9ypBI;EACI,gBAAA;AjGizpBR;;AiGlzpBI;EACI,gBAAA;AjGqzpBR;;AiGtzpBI;EACI,gBAAA;AjGyzpBR;;AiG1zpBI;EACI,gBAAA;AjG6zpBR;;AiG9zpBI;EACI,gBAAA;AjGi0pBR;;AiGl0pBI;EACI,gBAAA;AjGq0pBR;;AiGt0pBI;EACI,gBAAA;AjGy0pBR;;AiG10pBI;EACI,gBAAA;AjG60pBR;;AiG90pBI;EACI,gBAAA;AjGi1pBR;;AiGl1pBI;EACI,gBAAA;AjGq1pBR;;AiGt1pBI;EACI,gBAAA;AjGy1pBR;;AiG11pBI;EACI,gBAAA;AjG61pBR;;AiG91pBI;EACI,iBAAA;AjGi2pBR;;AiGl2pBI;EACI,iBAAA;AjGq2pBR;;AiGt2pBI;EACI,gBAAA;AjGy2pBR;;AiG12pBI;EACI,gBAAA;AjG62pBR;;AiG92pBI;EACI,gBAAA;AjGi3pBR;;AiGl3pBI;EACI,gBAAA;AjGq3pBR;;AiGt3pBI;EACI,gBAAA;AjGy3pBR;;AiG13pBI;EACI,gBAAA;AjG63pBR;;AiG93pBI;EACI,iBAAA;AjGi4pBR;;AiGl4pBI;EACI,gBAAA;AjGq4pBR;;AiGt4pBI;EACI,iBAAA;AjGy4pBR;;AiG14pBI;EACI,gBAAA;AjG64pBR;;AiG94pBI;EACI,gBAAA;AjGi5pBR;;AiGl5pBI;EACI,iBAAA;AjGq5pBR;;AiGt5pBI;EACI,gBAAA;AjGy5pBR;;AiG15pBI;EACI,gBAAA;AjG65pBR;;AiG95pBI;EACI,gBAAA;AjGi6pBR;;AiGl6pBI;EACI,gBAAA;AjGq6pBR;;AiGt6pBI;EACI,iBAAA;AjGy6pBR;;AiG16pBI;EACI,gBAAA;AjG66pBR;;AiG96pBI;EACI,gBAAA;AjGi7pBR;;AiGl7pBI;EACI,gBAAA;AjGq7pBR;;AiGt7pBI;EACI,gBAAA;AjGy7pBR;;AiG17pBI;EACI,iBAAA;AjG67pBR;;AiG97pBI;EACI,gBAAA;AjGi8pBR;;AiGl8pBI;EACI,gBAAA;AjGq8pBR;;AiGt8pBI;EACI,gBAAA;AjGy8pBR;;AiG18pBI;EACI,gBAAA;AjG68pBR;;AiG98pBI;EACI,gBAAA;AjGi9pBR;;AiGl9pBI;EACI,gBAAA;AjGq9pBR;;AiGt9pBI;EACI,gBAAA;AjGy9pBR;;AiG19pBI;EACI,gBAAA;AjG69pBR;;AiG99pBI;EACI,gBAAA;AjGi+pBR;;AiGl+pBI;EACI,gBAAA;AjGq+pBR;;AiGt+pBI;EACI,gBAAA;AjGy+pBR;;AiG1+pBI;EACI,gBAAA;AjG6+pBR;;AiG9+pBI;EACI,gBAAA;AjGi/pBR;;AiGl/pBI;EACI,gBAAA;AjGq/pBR;;AiGt/pBI;EACI,gBAAA;AjGy/pBR;;AiG1/pBI;EACI,gBAAA;AjG6/pBR;;AiG9/pBI;EACI,gBAAA;AjGigqBR;;AiGlgqBI;EACI,iBAAA;AjGqgqBR;;AiGtgqBI;EACI,gBAAA;AjGygqBR;;AiG1gqBI;EACI,iBAAA;AjG6gqBR;;AiG9gqBI;EACI,iBAAA;AjGihqBR;;AiGlhqBI;EACI,gBAAA;AjGqhqBR;;AiGthqBI;EACI,gBAAA;AjGyhqBR;;AiG1hqBI;EACI,gBAAA;AjG6hqBR;;AiG9hqBI;EACI,gBAAA;AjGiiqBR;;AiGliqBI;EACI,gBAAA;AjGqiqBR;;AiGtiqBI;EACI,gBAAA;AjGyiqBR;;AiG1iqBI;EACI,gBAAA;AjG6iqBR;;AiG9iqBI;EACI,gBAAA;AjGijqBR;;AiGljqBI;EACI,gBAAA;AjGqjqBR;;AiGtjqBI;EACI,iBAAA;AjGyjqBR;;AiG1jqBI;EACI,iBAAA;AjG6jqBR;;AiG9jqBI;EACI,iBAAA;AjGikqBR;;AiGlkqBI;EACI,iBAAA;AjGqkqBR;;AiGtkqBI;EACI,gBAAA;AjGykqBR;;AiG1kqBI;EACI,gBAAA;AjG6kqBR;;AiG9kqBI;EACI,gBAAA;AjGilqBR;;AiGllqBI;EACI,gBAAA;AjGqlqBR;;AiGtlqBI;EACI,gBAAA;AjGylqBR;;AiG1lqBI;EACI,iBAAA;AjG6lqBR;;AiG9lqBI;EACI,gBAAA;AjGimqBR;;AiGlmqBI;EACI,gBAAA;AjGqmqBR;;AiGtmqBI;EACI,gBAAA;AjGymqBR;;AiG1mqBI;EACI,gBAAA;AjG6mqBR;;AiG9mqBI;EACI,gBAAA;AjGinqBR;;AiGlnqBI;EACI,gBAAA;AjGqnqBR;;AiGtnqBI;EACI,gBAAA;AjGynqBR;;AiG1nqBI;EACI,gBAAA;AjG6nqBR;;AiG9nqBI;EACI,gBAAA;AjGioqBR;;AiGloqBI;EACI,gBAAA;AjGqoqBR;;AiGtoqBI;EACI,gBAAA;AjGyoqBR;;AiG1oqBI;EACI,gBAAA;AjG6oqBR;;AiG9oqBI;EACI,gBAAA;AjGipqBR;;AiGlpqBI;EACI,gBAAA;AjGqpqBR;;AiGtpqBI;EACI,gBAAA;AjGypqBR;;AiG1pqBI;EACI,gBAAA;AjG6pqBR;;AiG9pqBI;EACI,gBAAA;AjGiqqBR;;AiGlqqBI;EACI,gBAAA;AjGqqqBR;;AiGtqqBI;EACI,gBAAA;AjGyqqBR;;AiG1qqBI;EACI,iBAAA;AjG6qqBR;;AiG9qqBI;EACI,gBAAA;AjGirqBR;;AiGlrqBI;EACI,iBAAA;AjGqrqBR;;AiGtrqBI;EACI,gBAAA;AjGyrqBR;;AiG1rqBI;EACI,gBAAA;AjG6rqBR;;AiG9rqBI;EACI,iBAAA;AjGisqBR;;AiGlsqBI;EACI,iBAAA;AjGqsqBR;;AiGtsqBI;EACI,gBAAA;AjGysqBR;;AiG1sqBI;EACI,gBAAA;AjG6sqBR;;AiG9sqBI;EACI,gBAAA;AjGitqBR;;AiGltqBI;EACI,iBAAA;AjGqtqBR;;AiGttqBI;EACI,gBAAA;AjGytqBR;;AiG1tqBI;EACI,gBAAA;AjG6tqBR;;AiG9tqBI;EACI,gBAAA;AjGiuqBR;;AiGluqBI;EACI,gBAAA;AjGquqBR;;AiGtuqBI;EACI,gBAAA;AjGyuqBR;;AiG1uqBI;EACI,gBAAA;AjG6uqBR;;AiG9uqBI;EACI,gBAAA;AjGivqBR;;AiGlvqBI;EACI,gBAAA;AjGqvqBR;;AiGtvqBI;EACI,gBAAA;AjGyvqBR;;AiG1vqBI;EACI,gBAAA;AjG6vqBR;;AiG9vqBI;EACI,gBAAA;AjGiwqBR;;AiGlwqBI;EACI,gBAAA;AjGqwqBR;;AiGtwqBI;EACI,gBAAA;AjGywqBR;;AiG1wqBI;EACI,gBAAA;AjG6wqBR;;AiG9wqBI;EACI,gBAAA;AjGixqBR;;AiGlxqBI;EACI,gBAAA;AjGqxqBR;;AiGtxqBI;EACI,gBAAA;AjGyxqBR;;AiG1xqBI;EACI,gBAAA;AjG6xqBR;;AiG9xqBI;EACI,gBAAA;AjGiyqBR;;AiGlyqBI;EACI,gBAAA;AjGqyqBR;;AiGtyqBI;EACI,iBAAA;AjGyyqBR;;AiG1yqBI;EACI,gBAAA;AjG6yqBR;;AiG9yqBI;EACI,iBAAA;AjGizqBR;;AiGlzqBI;EACI,gBAAA;AjGqzqBR;;AiGtzqBI;EACI,iBAAA;AjGyzqBR;;AiG1zqBI;EACI,gBAAA;AjG6zqBR;;AiG9zqBI;EACI,gBAAA;AjGi0qBR;;AiGl0qBI;EACI,gBAAA;AjGq0qBR;;AiGt0qBI;EACI,gBAAA;AjGy0qBR;;AiG10qBI;EACI,gBAAA;AjG60qBR;;AiG90qBI;EACI,gBAAA;AjGi1qBR;;AiGl1qBI;EACI,gBAAA;AjGq1qBR;;AiGt1qBI;EACI,iBAAA;AjGy1qBR;;AiG11qBI;EACI,gBAAA;AjG61qBR;;AiG91qBI;EACI,iBAAA;AjGi2qBR;;AiGl2qBI;EACI,gBAAA;AjGq2qBR;;AiGt2qBI;EACI,gBAAA;AjGy2qBR;;AiG12qBI;EACI,gBAAA;AjG62qBR;;AiG92qBI;EACI,gBAAA;AjGi3qBR;;AiGl3qBI;EACI,gBAAA;AjGq3qBR;;AiGt3qBI;EACI,gBAAA;AjGy3qBR;;AiG13qBI;EACI,gBAAA;AjG63qBR;;AiG93qBI;EACI,gBAAA;AjGi4qBR;;AiGl4qBI;EACI,gBAAA;AjGq4qBR;;AiGt4qBI;EACI,gBAAA;AjGy4qBR;;AiG14qBI;EACI,gBAAA;AjG64qBR;;AiG94qBI;EACI,gBAAA;AjGi5qBR;;AiGl5qBI;EACI,gBAAA;AjGq5qBR;;AiGt5qBI;EACI,gBAAA;AjGy5qBR;;AiG15qBI;EACI,gBAAA;AjG65qBR;;AiG95qBI;EACI,gBAAA;AjGi6qBR;;AiGl6qBI;EACI,gBAAA;AjGq6qBR;;AiGt6qBI;EACI,gBAAA;AjGy6qBR;;AiG16qBI;EACI,gBAAA;AjG66qBR;;AiG96qBI;EACI,iBAAA;AjGi7qBR;;AiGl7qBI;EACI,gBAAA;AjGq7qBR;;AiGt7qBI;EACI,iBAAA;AjGy7qBR;;AiG17qBI;EACI,gBAAA;AjG67qBR;;AiG97qBI;EACI,gBAAA;AjGi8qBR;;AiGl8qBI;EACI,iBAAA;AjGq8qBR;;AiGt8qBI;EACI,iBAAA;AjGy8qBR;;AiG18qBI;EACI,gBAAA;AjG68qBR;;AiG98qBI;EACI,gBAAA;AjGi9qBR;;AiGl9qBI;EACI,gBAAA;AjGq9qBR;;AiGt9qBI;EACI,gBAAA;AjGy9qBR;;AiG19qBI;EACI,gBAAA;AjG69qBR;;AiG99qBI;EACI,iBAAA;AjGi+qBR;;AiGl+qBI;EACI,gBAAA;AjGq+qBR;;AiGt+qBI;EACI,gBAAA;AjGy+qBR;;AiG1+qBI;EACI,iBAAA;AjG6+qBR;;AiG9+qBI;EACI,iBAAA;AjGi/qBR;;AiGl/qBI;EACI,iBAAA;AjGq/qBR;;AiGt/qBI;EACI,gBAAA;AjGy/qBR;;AiG1/qBI;EACI,gBAAA;AjG6/qBR;;AiG9/qBI;EACI,gBAAA;AjGigrBR;;AiGlgrBI;EACI,gBAAA;AjGqgrBR;;AiGtgrBI;EACI,gBAAA;AjGygrBR;;AiG1grBI;EACI,gBAAA;AjG6grBR;;AiG9grBI;EACI,gBAAA;AjGihrBR;;AiGlhrBI;EACI,gBAAA;AjGqhrBR;;AiGthrBI;EACI,gBAAA;AjGyhrBR;;AiG1hrBI;EACI,gBAAA;AjG6hrBR;;AiG9hrBI;EACI,gBAAA;AjGiirBR;;AiGlirBI;EACI,gBAAA;AjGqirBR;;AiGtirBI;EACI,gBAAA;AjGyirBR;;AiG1irBI;EACI,gBAAA;AjG6irBR;;AiG9irBI;EACI,gBAAA;AjGijrBR;;AiGljrBI;EACI,gBAAA;AjGqjrBR;;AiGtjrBI;EACI,gBAAA;AjGyjrBR;;AiG1jrBI;EACI,gBAAA;AjG6jrBR;;AiG9jrBI;EACI,iBAAA;AjGikrBR;;AiGlkrBI;EACI,iBAAA;AjGqkrBR;;AiGtkrBI;EACI,gBAAA;AjGykrBR;;AiG1krBI;EACI,gBAAA;AjG6krBR;;AiG9krBI;EACI,gBAAA;AjGilrBR;;AiGllrBI;EACI,gBAAA;AjGqlrBR;;AiGtlrBI;EACI,gBAAA;AjGylrBR;;AiG1lrBI;EACI,gBAAA;AjG6lrBR;;AiG9lrBI;EACI,gBAAA;AjGimrBR;;AiGlmrBI;EACI,gBAAA;AjGqmrBR;;AiGtmrBI;EACI,gBAAA;AjGymrBR;;AiG1mrBI;EACI,gBAAA;AjG6mrBR;;AiG9mrBI;EACI,gBAAA;AjGinrBR;;AiGlnrBI;EACI,gBAAA;AjGqnrBR;;AiGtnrBI;EACI,gBAAA;AjGynrBR;;AiG1nrBI;EACI,gBAAA;AjG6nrBR;;AiG9nrBI;EACI,gBAAA;AjGiorBR;;AiGlorBI;EACI,iBAAA;AjGqorBR;;AiGtorBI;EACI,iBAAA;AjGyorBR;;AiG1orBI;EACI,iBAAA;AjG6orBR;;AiG9orBI;EACI,iBAAA;AjGiprBR;;AiGlprBI;EACI,gBAAA;AjGqprBR;;AiGtprBI;EACI,gBAAA;AjGyprBR;;AiG1prBI;EACI,gBAAA;AjG6prBR;;AiG9prBI;EACI,gBAAA;AjGiqrBR;;AiGlqrBI;EACI,gBAAA;AjGqqrBR;;AiGtqrBI;EACI,gBAAA;AjGyqrBR;;AiG1qrBI;EACI,gBAAA;AjG6qrBR;;AiG9qrBI;EACI,gBAAA;AjGirrBR;;AiGlrrBI;EACI,gBAAA;AjGqrrBR;;AiGtrrBI;EACI,gBAAA;AjGyrrBR;;AiG1rrBI;EACI,gBAAA;AjG6rrBR;;AiG9rrBI;EACI,gBAAA;AjGisrBR;;AiGlsrBI;EACI,gBAAA;AjGqsrBR;;AiGtsrBI;EACI,gBAAA;AjGysrBR;;AiG1srBI;EACI,gBAAA;AjG6srBR;;AiG9srBI;EACI,gBAAA;AjGitrBR;;AiGltrBI;EACI,gBAAA;AjGqtrBR;;AiGttrBI;EACI,gBAAA;AjGytrBR;;AiG1trBI;EACI,gBAAA;AjG6trBR;;AiG9trBI;EACI,gBAAA;AjGiurBR;;AiGlurBI;EACI,gBAAA;AjGqurBR;;AiGturBI;EACI,gBAAA;AjGyurBR;;AiG1urBI;EACI,gBAAA;AjG6urBR;;AiG9urBI;EACI,gBAAA;AjGivrBR;;AiGlvrBI;EACI,gBAAA;AjGqvrBR;;AiGtvrBI;EACI,gBAAA;AjGyvrBR;;AiG1vrBI;EACI,gBAAA;AjG6vrBR;;AiG9vrBI;EACI,gBAAA;AjGiwrBR;;AiGlwrBI;EACI,gBAAA;AjGqwrBR;;AiGtwrBI;EACI,gBAAA;AjGywrBR;;AiG1wrBI;EACI,gBAAA;AjG6wrBR;;AiG9wrBI;EACI,gBAAA;AjGixrBR;;AiGlxrBI;EACI,gBAAA;AjGqxrBR;;AiGtxrBI;EACI,gBAAA;AjGyxrBR;;AiG1xrBI;EACI,gBAAA;AjG6xrBR;;AiG9xrBI;EACI,gBAAA;AjGiyrBR;;AiGlyrBI;EACI,gBAAA;AjGqyrBR;;AiGtyrBI;EACI,gBAAA;AjGyyrBR;;AiG1yrBI;EACI,gBAAA;AjG6yrBR;;AiG9yrBI;EACI,gBAAA;AjGizrBR;;AiGlzrBI;EACI,gBAAA;AjGqzrBR;;AiGtzrBI;EACI,gBAAA;AjGyzrBR;;AiG1zrBI;EACI,gBAAA;AjG6zrBR;;AiG9zrBI;EACI,iBAAA;AjGi0rBR;;AiGl0rBI;EACI,gBAAA;AjGq0rBR;;AiGt0rBI;EACI,gBAAA;AjGy0rBR;;AiG10rBI;EACI,gBAAA;AjG60rBR;;AiG90rBI;EACI,gBAAA;AjGi1rBR;;AiGl1rBI;EACI,gBAAA;AjGq1rBR;;AiGt1rBI;EACI,iBAAA;AjGy1rBR;;AiG11rBI;EACI,gBAAA;AjG61rBR;;AiG91rBI;EACI,gBAAA;AjGi2rBR;;AiGl2rBI;EACI,gBAAA;AjGq2rBR;;AiGt2rBI;EACI,gBAAA;AjGy2rBR;;AiG12rBI;EACI,gBAAA;AjG62rBR;;AiG92rBI;EACI,gBAAA;AjGi3rBR;;AiGl3rBI;EACI,gBAAA;AjGq3rBR;;AiGt3rBI;EACI,gBAAA;AjGy3rBR;;AiG13rBI;EACI,gBAAA;AjG63rBR;;AiG93rBI;EACI,gBAAA;AjGi4rBR;;AiGl4rBI;EACI,gBAAA;AjGq4rBR;;AiGt4rBI;EACI,gBAAA;AjGy4rBR;;AiG14rBI;EACI,gBAAA;AjG64rBR;;AiG94rBI;EACI,gBAAA;AjGi5rBR;;AiGl5rBI;EACI,gBAAA;AjGq5rBR;;AiGt5rBI;EACI,gBAAA;AjGy5rBR;;AiG15rBI;EACI,gBAAA;AjG65rBR;;AiG95rBI;EACI,gBAAA;AjGi6rBR;;AiGl6rBI;EACI,gBAAA;AjGq6rBR;;AiGt6rBI;EACI,gBAAA;AjGy6rBR;;AiG16rBI;EACI,gBAAA;AjG66rBR;;AiG96rBI;EACI,gBAAA;AjGi7rBR;;AiGl7rBI;EACI,gBAAA;AjGq7rBR;;AiGt7rBI;EACI,gBAAA;AjGy7rBR;;AiG17rBI;EACI,gBAAA;AjG67rBR;;AiG97rBI;EACI,gBAAA;AjGi8rBR;;AiGl8rBI;EACI,gBAAA;AjGq8rBR;;AiGt8rBI;EACI,gBAAA;AjGy8rBR;;AiG18rBI;EACI,gBAAA;AjG68rBR;;AiG98rBI;EACI,iBAAA;AjGi9rBR;;AiGl9rBI;EACI,iBAAA;AjGq9rBR;;AiGt9rBI;EACI,gBAAA;AjGy9rBR;;AiG19rBI;EACI,iBAAA;AjG69rBR;;AiG99rBI;EACI,iBAAA;AjGi+rBR;;AiGl+rBI;EACI,gBAAA;AjGq+rBR;;AiGt+rBI;EACI,iBAAA;AjGy+rBR;;AiG1+rBI;EACI,iBAAA;AjG6+rBR;;AiG9+rBI;EACI,iBAAA;AjGi/rBR;;AiGl/rBI;EACI,iBAAA;AjGq/rBR;;AiGt/rBI;EACI,iBAAA;AjGy/rBR;;AiG1/rBI;EACI,gBAAA;AjG6/rBR;;AiG9/rBI;EACI,gBAAA;AjGigsBR;;AiGlgsBI;EACI,iBAAA;AjGqgsBR;;AiGtgsBI;EACI,iBAAA;AjGygsBR;;AiG1gsBI;EACI,gBAAA;AjG6gsBR;;AiG9gsBI;EACI,gBAAA;AjGihsBR;;AiGlhsBI;EACI,iBAAA;AjGqhsBR;;AiGthsBI;EACI,gBAAA;AjGyhsBR;;AiG1hsBI;EACI,gBAAA;AjG6hsBR;;AiG9hsBI;EACI,gBAAA;AjGiisBR;;AiGlisBI;EACI,iBAAA;AjGqisBR;;AiGtisBI;EACI,iBAAA;AjGyisBR;;AiG1isBI;EACI,gBAAA;AjG6isBR;;AiG9isBI;EACI,gBAAA;AjGijsBR;;AiGljsBI;EACI,gBAAA;AjGqjsBR;;AiGtjsBI;EACI,gBAAA;AjGyjsBR;;AiG1jsBI;EACI,gBAAA;AjG6jsBR;;AiG9jsBI;EACI,gBAAA;AjGiksBR;;AiGlksBI;EACI,gBAAA;AjGqksBR;;AiGtksBI;EACI,gBAAA;AjGyksBR;;AiG1ksBI;EACI,gBAAA;AjG6ksBR;;AiG9ksBI;EACI,gBAAA;AjGilsBR;;AiGllsBI;EACI,gBAAA;AjGqlsBR;;AiGtlsBI;EACI,gBAAA;AjGylsBR;;AiG1lsBI;EACI,gBAAA;AjG6lsBR;;AiG9lsBI;EACI,gBAAA;AjGimsBR;;AiGlmsBI;EACI,gBAAA;AjGqmsBR;;AiGtmsBI;EACI,gBAAA;AjGymsBR;;AiG1msBI;EACI,gBAAA;AjG6msBR;;AiG9msBI;EACI,gBAAA;AjGinsBR;;AiGlnsBI;EACI,gBAAA;AjGqnsBR;;AiGtnsBI;EACI,gBAAA;AjGynsBR;;AiG1nsBI;EACI,gBAAA;AjG6nsBR;;AiG9nsBI;EACI,gBAAA;AjGiosBR;;AiGlosBI;EACI,gBAAA;AjGqosBR;;AiGtosBI;EACI,gBAAA;AjGyosBR;;AiG1osBI;EACI,gBAAA;AjG6osBR;;AiG9osBI;EACI,gBAAA;AjGipsBR;;AiGlpsBI;EACI,gBAAA;AjGqpsBR;;AiGtpsBI;EACI,gBAAA;AjGypsBR;;AiG1psBI;EACI,gBAAA;AjG6psBR;;AiG9psBI;EACI,gBAAA;AjGiqsBR;;AiGlqsBI;EACI,gBAAA;AjGqqsBR;;AiGtqsBI;EACI,gBAAA;AjGyqsBR;;AiG1qsBI;EACI,gBAAA;AjG6qsBR;;AiG9qsBI;EACI,gBAAA;AjGirsBR;;AiGlrsBI;EACI,iBAAA;AjGqrsBR;;AiGtrsBI;EACI,gBAAA;AjGyrsBR;;AiG1rsBI;EACI,gBAAA;AjG6rsBR;;AiG9rsBI;EACI,gBAAA;AjGissBR;;AiGlssBI;EACI,iBAAA;AjGqssBR;;AiGtssBI;EACI,iBAAA;AjGyssBR;;AiG1ssBI;EACI,gBAAA;AjG6ssBR;;AiG9ssBI;EACI,gBAAA;AjGitsBR;;AiGltsBI;EACI,gBAAA;AjGqtsBR;;AiGttsBI;EACI,gBAAA;AjGytsBR;;AiG1tsBI;EACI,gBAAA;AjG6tsBR;;AiG9tsBI;EACI,gBAAA;AjGiusBR;;AiGlusBI;EACI,gBAAA;AjGqusBR;;AiGtusBI;EACI,gBAAA;AjGyusBR;;AiG1usBI;EACI,iBAAA;AjG6usBR;;AiG9usBI;EACI,gBAAA;AjGivsBR;;AiGlvsBI;EACI,gBAAA;AjGqvsBR;;AiGtvsBI;EACI,gBAAA;AjGyvsBR;;AiG1vsBI;EACI,gBAAA;AjG6vsBR;;AiG9vsBI;EACI,iBAAA;AjGiwsBR;;AiGlwsBI;EACI,iBAAA;AjGqwsBR;;AiGtwsBI;EACI,gBAAA;AjGywsBR;;AiG1wsBI;EACI,gBAAA;AjG6wsBR;;AiG9wsBI;EACI,iBAAA;AjGixsBR;;AiGlxsBI;EACI,gBAAA;AjGqxsBR;;AiGtxsBI;EACI,gBAAA;AjGyxsBR;;AiG1xsBI;EACI,gBAAA;AjG6xsBR;;AiG9xsBI;EACI,gBAAA;AjGiysBR;;AiGlysBI;EACI,gBAAA;AjGqysBR;;AiGtysBI;EACI,gBAAA;AjGyysBR;;AiG1ysBI;EACI,gBAAA;AjG6ysBR;;AiG9ysBI;EACI,gBAAA;AjGizsBR;;AiGlzsBI;EACI,gBAAA;AjGqzsBR;;AiGtzsBI;EACI,iBAAA;AjGyzsBR;;AiG1zsBI;EACI,gBAAA;AjG6zsBR;;AiG9zsBI;EACI,gBAAA;AjGi0sBR;;AiGl0sBI;EACI,gBAAA;AjGq0sBR;;AiGt0sBI;EACI,gBAAA;AjGy0sBR;;AiG10sBI;EACI,gBAAA;AjG60sBR;;AiG90sBI;EACI,iBAAA;AjGi1sBR;;AiGl1sBI;EACI,gBAAA;AjGq1sBR;;AiGt1sBI;EACI,gBAAA;AjGy1sBR;;AiG11sBI;EACI,gBAAA;AjG61sBR;;AiG91sBI;EACI,gBAAA;AjGi2sBR;;AiGl2sBI;EACI,iBAAA;AjGq2sBR;;AiGt2sBI;EACI,gBAAA;AjGy2sBR;;AiG12sBI;EACI,iBAAA;AjG62sBR;;AiG92sBI;EACI,iBAAA;AjGi3sBR;;AiGl3sBI;EACI,gBAAA;AjGq3sBR;;AiGt3sBI;EACI,iBAAA;AjGy3sBR;;AiG13sBI;EACI,gBAAA;AjG63sBR;;AiG93sBI;EACI,gBAAA;AjGi4sBR;;AiGl4sBI;EACI,gBAAA;AjGq4sBR;;AiGt4sBI;EACI,gBAAA;AjGy4sBR;;AiG14sBI;EACI,gBAAA;AjG64sBR;;AiG94sBI;EACI,gBAAA;AjGi5sBR;;AiGl5sBI;EACI,gBAAA;AjGq5sBR;;AiGt5sBI;EACI,gBAAA;AjGy5sBR;;AiG15sBI;EACI,gBAAA;AjG65sBR;;AiG95sBI;EACI,gBAAA;AjGi6sBR;;AiGl6sBI;EACI,gBAAA;AjGq6sBR;;AiGt6sBI;EACI,gBAAA;AjGy6sBR;;AiG16sBI;EACI,gBAAA;AjG66sBR;;AiG96sBI;EACI,gBAAA;AjGi7sBR;;AiGl7sBI;EACI,gBAAA;AjGq7sBR;;AiGt7sBI;EACI,gBAAA;AjGy7sBR;;AiG17sBI;EACI,gBAAA;AjG67sBR;;AiG97sBI;EACI,gBAAA;AjGi8sBR;;AiGl8sBI;EACI,gBAAA;AjGq8sBR;;AiGt8sBI;EACI,gBAAA;AjGy8sBR;;AiG18sBI;EACI,gBAAA;AjG68sBR;;AiG98sBI;EACI,gBAAA;AjGi9sBR;;AiGl9sBI;EACI,iBAAA;AjGq9sBR;;AiGt9sBI;EACI,iBAAA;AjGy9sBR;;AiG19sBI;EACI,gBAAA;AjG69sBR;;AiG99sBI;EACI,gBAAA;AjGi+sBR;;AiGl+sBI;EACI,gBAAA;AjGq+sBR;;AiGt+sBI;EACI,gBAAA;AjGy+sBR;;AiG1+sBI;EACI,gBAAA;AjG6+sBR;;AiG9+sBI;EACI,gBAAA;AjGi/sBR;;AiGl/sBI;EACI,gBAAA;AjGq/sBR;;AiGt/sBI;EACI,gBAAA;AjGy/sBR;;AiG1/sBI;EACI,gBAAA;AjG6/sBR;;AiG9/sBI;EACI,gBAAA;AjGigtBR;;AiGlgtBI;EACI,gBAAA;AjGqgtBR;;AiGtgtBI;EACI,iBAAA;AjGygtBR;;AiG1gtBI;EACI,iBAAA;AjG6gtBR;;AiG9gtBI;EACI,gBAAA;AjGihtBR;;AiGlhtBI;EACI,gBAAA;AjGqhtBR;;AiGthtBI;EACI,gBAAA;AjGyhtBR;;AiG1htBI;EACI,gBAAA;AjG6htBR;;AiG9htBI;EACI,gBAAA;AjGiitBR;;AiGlitBI;EACI,gBAAA;AjGqitBR;;AiGtitBI;EACI,gBAAA;AjGyitBR;;AiG1itBI;EACI,gBAAA;AjG6itBR;;AiG9itBI;EACI,gBAAA;AjGijtBR;;AiGljtBI;EACI,gBAAA;AjGqjtBR;;AiGtjtBI;EACI,gBAAA;AjGyjtBR;;AiG1jtBI;EACI,gBAAA;AjG6jtBR;;AiG9jtBI;EACI,gBAAA;AjGiktBR;;AiGlktBI;EACI,iBAAA;AjGqktBR;;AiGtktBI;EACI,iBAAA;AjGyktBR;;AiG1ktBI;EACI,gBAAA;AjG6ktBR;;AiG9ktBI;EACI,gBAAA;AjGiltBR;;AiGlltBI;EACI,gBAAA;AjGqltBR;;AiGtltBI;EACI,gBAAA;AjGyltBR;;AiG1ltBI;EACI,iBAAA;AjG6ltBR;;AiG9ltBI;EACI,gBAAA;AjGimtBR;;AiGlmtBI;EACI,gBAAA;AjGqmtBR;;AiGtmtBI;EACI,gBAAA;AjGymtBR;;AiG1mtBI;EACI,gBAAA;AjG6mtBR;;AiG9mtBI;EACI,gBAAA;AjGintBR;;AiGlntBI;EACI,gBAAA;AjGqntBR;;AiGtntBI;EACI,gBAAA;AjGyntBR;;AiG1ntBI;EACI,gBAAA;AjG6ntBR;;AiG9ntBI;EACI,gBAAA;AjGiotBR;;AiGlotBI;EACI,gBAAA;AjGqotBR;;AiGtotBI;EACI,gBAAA;AjGyotBR;;AiG1otBI;EACI,gBAAA;AjG6otBR;;AiG9otBI;EACI,gBAAA;AjGiptBR;;AiGlptBI;EACI,gBAAA;AjGqptBR;;AiGtptBI;EACI,gBAAA;AjGyptBR;;AiG1ptBI;EACI,gBAAA;AjG6ptBR;;AiG9ptBI;EACI,gBAAA;AjGiqtBR;;AiGlqtBI;EACI,gBAAA;AjGqqtBR;;AiGtqtBI;EACI,gBAAA;AjGyqtBR;;AiG1qtBI;EACI,gBAAA;AjG6qtBR;;AiG9qtBI;EACI,gBAAA;AjGirtBR;;AiGlrtBI;EACI,gBAAA;AjGqrtBR;;AiGtrtBI;EACI,gBAAA;AjGyrtBR;;AiG1rtBI;EACI,gBAAA;AjG6rtBR;;AiG9rtBI;EACI,gBAAA;AjGistBR;;AiGlstBI;EACI,gBAAA;AjGqstBR;;AiGtstBI;EACI,gBAAA;AjGystBR;;AiG1stBI;EACI,gBAAA;AjG6stBR;;AiG9stBI;EACI,gBAAA;AjGittBR;;AiGlttBI;EACI,gBAAA;AjGqttBR;;AiGtttBI;EACI,gBAAA;AjGyttBR;;AiG1ttBI;EACI,gBAAA;AjG6ttBR;;AiG9ttBI;EACI,gBAAA;AjGiutBR;;AiGlutBI;EACI,gBAAA;AjGqutBR;;AiGtutBI;EACI,gBAAA;AjGyutBR;;AiG1utBI;EACI,gBAAA;AjG6utBR;;AiG9utBI;EACI,gBAAA;AjGivtBR;;AiGlvtBI;EACI,gBAAA;AjGqvtBR;;AiGtvtBI;EACI,gBAAA;AjGyvtBR;;AiG1vtBI;EACI,gBAAA;AjG6vtBR;;AiG9vtBI;EACI,gBAAA;AjGiwtBR;;AiGlwtBI;EACI,gBAAA;AjGqwtBR;;AiGtwtBI;EACI,gBAAA;AjGywtBR;;AiG1wtBI;EACI,iBAAA;AjG6wtBR;;AiG9wtBI;EACI,gBAAA;AjGixtBR;;AiGlxtBI;EACI,gBAAA;AjGqxtBR;;AiGtxtBI;EACI,gBAAA;AjGyxtBR;;AiG1xtBI;EACI,gBAAA;AjG6xtBR;;AiG9xtBI;EACI,gBAAA;AjGiytBR;;AiGlytBI;EACI,gBAAA;AjGqytBR;;AiGtytBI;EACI,iBAAA;AjGyytBR;;AiG1ytBI;EACI,gBAAA;AjG6ytBR;;AiG9ytBI;EACI,iBAAA;AjGiztBR;;AiGlztBI;EACI,gBAAA;AjGqztBR;;AiGtztBI;EACI,gBAAA;AjGyztBR;;AiG1ztBI;EACI,iBAAA;AjG6ztBR;;AiG9ztBI;EACI,gBAAA;AjGi0tBR;;AiGl0tBI;EACI,iBAAA;AjGq0tBR;;AiGt0tBI;EACI,gBAAA;AjGy0tBR;;AiG10tBI;EACI,gBAAA;AjG60tBR;;AiG90tBI;EACI,gBAAA;AjGi1tBR;;AiGl1tBI;EACI,iBAAA;AjGq1tBR;;AiGt1tBI;EACI,gBAAA;AjGy1tBR;;AiG11tBI;EACI,iBAAA;AjG61tBR;;AiG91tBI;EACI,gBAAA;AjGi2tBR;;AiGl2tBI;EACI,gBAAA;AjGq2tBR;;AiGt2tBI;EACI,gBAAA;AjGy2tBR;;AiG12tBI;EACI,gBAAA;AjG62tBR;;AiG92tBI;EACI,gBAAA;AjGi3tBR;;AiGl3tBI;EACI,gBAAA;AjGq3tBR;;AiGt3tBI;EACI,gBAAA;AjGy3tBR;;AiG13tBI;EACI,gBAAA;AjG63tBR;;AiG93tBI;EACI,gBAAA;AjGi4tBR;;AiGl4tBI;EACI,gBAAA;AjGq4tBR;;AiGt4tBI;EACI,gBAAA;AjGy4tBR;;AiG14tBI;EACI,gBAAA;AjG64tBR;;AiG94tBI;EACI,gBAAA;AjGi5tBR;;AiGl5tBI;EACI,iBAAA;AjGq5tBR;;AiGt5tBI;EACI,gBAAA;AjGy5tBR;;AiG15tBI;EACI,iBAAA;AjG65tBR;;AiG95tBI;EACI,gBAAA;AjGi6tBR;;AiGl6tBI;EACI,gBAAA;AjGq6tBR;;AiGt6tBI;EACI,gBAAA;AjGy6tBR;;AiG16tBI;EACI,gBAAA;AjG66tBR;;AiG96tBI;EACI,gBAAA;AjGi7tBR;;AiGl7tBI;EACI,gBAAA;AjGq7tBR;;AiGt7tBI;EACI,gBAAA;AjGy7tBR;;AiG17tBI;EACI,gBAAA;AjG67tBR;;AiG97tBI;EACI,gBAAA;AjGi8tBR;;AiGl8tBI;EACI,iBAAA;AjGq8tBR;;AiGt8tBI;EACI,iBAAA;AjGy8tBR;;AiG18tBI;EACI,gBAAA;AjG68tBR;;AiG98tBI;EACI,gBAAA;AjGi9tBR;;AiGl9tBI;EACI,gBAAA;AjGq9tBR;;AiGt9tBI;EACI,gBAAA;AjGy9tBR;;AiG19tBI;EACI,gBAAA;AjG69tBR;;AiG99tBI;EACI,gBAAA;AjGi+tBR;;AiGl+tBI;EACI,gBAAA;AjGq+tBR;;AiGt+tBI;EACI,gBAAA;AjGy+tBR;;AiG1+tBI;EACI,gBAAA;AjG6+tBR;;AiG9+tBI;EACI,gBAAA;AjGi/tBR;;AiGl/tBI;EACI,gBAAA;AjGq/tBR;;AiGt/tBI;EACI,iBAAA;AjGy/tBR;;AiG1/tBI;EACI,gBAAA;AjG6/tBR;;AiG9/tBI;EACI,gBAAA;AjGiguBR;;AiGlguBI;EACI,gBAAA;AjGqguBR;;AiGtguBI;EACI,gBAAA;AjGyguBR;;AiG1guBI;EACI,gBAAA;AjG6guBR;;AiG9guBI;EACI,gBAAA;AjGihuBR;;AiGlhuBI;EACI,gBAAA;AjGqhuBR;;AiGthuBI;EACI,gBAAA;AjGyhuBR;;AiG1huBI;EACI,gBAAA;AjG6huBR;;AiG9huBI;EACI,gBAAA;AjGiiuBR;;AiGliuBI;EACI,gBAAA;AjGqiuBR;;AiGtiuBI;EACI,gBAAA;AjGyiuBR;;AiG1iuBI;EACI,gBAAA;AjG6iuBR;;AiG9iuBI;EACI,gBAAA;AjGijuBR;;AiGljuBI;EACI,gBAAA;AjGqjuBR;;AiGtjuBI;EACI,gBAAA;AjGyjuBR;;AiG1juBI;EACI,gBAAA;AjG6juBR;;AiG9juBI;EACI,gBAAA;AjGikuBR;;AiGlkuBI;EACI,gBAAA;AjGqkuBR;;AiGtkuBI;EACI,gBAAA;AjGykuBR;;AiG1kuBI;EACI,iBAAA;AjG6kuBR;;AiG9kuBI;EACI,iBAAA;AjGiluBR;;AiGlluBI;EACI,gBAAA;AjGqluBR;;AiGtluBI;EACI,gBAAA;AjGyluBR;;AiG1luBI;EACI,gBAAA;AjG6luBR;;AiG9luBI;EACI,gBAAA;AjGimuBR;;AiGlmuBI;EACI,gBAAA;AjGqmuBR;;AiGtmuBI;EACI,gBAAA;AjGymuBR;;AiG1muBI;EACI,gBAAA;AjG6muBR;;AiG9muBI;EACI,gBAAA;AjGinuBR;;AiGlnuBI;EACI,gBAAA;AjGqnuBR;;AiGtnuBI;EACI,gBAAA;AjGynuBR;;AiG1nuBI;EACI,iBAAA;AjG6nuBR;;AiG9nuBI;EACI,gBAAA;AjGiouBR;;AiGlouBI;EACI,gBAAA;AjGqouBR;;AiGtouBI;EACI,gBAAA;AjGyouBR;;AiG1ouBI;EACI,gBAAA;AjG6ouBR;;AiG9ouBI;EACI,gBAAA;AjGipuBR;;AiGlpuBI;EACI,gBAAA;AjGqpuBR;;AiGtpuBI;EACI,gBAAA;AjGypuBR;;AiG1puBI;EACI,gBAAA;AjG6puBR;;AiG9puBI;EACI,gBAAA;AjGiquBR;;AiGlquBI;EACI,gBAAA;AjGqquBR;;AiGtquBI;EACI,gBAAA;AjGyquBR;;AiG1quBI;EACI,gBAAA;AjG6quBR;;AiG9quBI;EACI,gBAAA;AjGiruBR;;AiGlruBI;EACI,gBAAA;AjGqruBR;;AiGtruBI;EACI,gBAAA;AjGyruBR;;AiG1ruBI;EACI,iBAAA;AjG6ruBR;;AiG9ruBI;EACI,iBAAA;AjGisuBR;;AiGlsuBI;EACI,iBAAA;AjGqsuBR;;AiGtsuBI;EACI,iBAAA;AjGysuBR;;AiG1suBI;EACI,gBAAA;AjG6suBR;;AiG9suBI;EACI,gBAAA;AjGituBR;;AiGltuBI;EACI,gBAAA;AjGqtuBR;;AiGttuBI;EACI,iBAAA;AjGytuBR;;AiG1tuBI;EACI,iBAAA;AjG6tuBR;;AiG9tuBI;EACI,gBAAA;AjGiuuBR;;AiGluuBI;EACI,gBAAA;AjGquuBR;;AiGtuuBI;EACI,gBAAA;AjGyuuBR;;AiG1uuBI;EACI,gBAAA;AjG6uuBR;;AiG9uuBI;EACI,gBAAA;AjGivuBR;;AiGlvuBI;EACI,gBAAA;AjGqvuBR;;AiGtvuBI;EACI,iBAAA;AjGyvuBR;;AiG1vuBI;EACI,iBAAA;AjG6vuBR;;AiG9vuBI;EACI,gBAAA;AjGiwuBR;;AiGlwuBI;EACI,gBAAA;AjGqwuBR;;AiGtwuBI;EACI,gBAAA;AjGywuBR;;AiG1wuBI;EACI,gBAAA;AjG6wuBR;;AiG9wuBI;EACI,gBAAA;AjGixuBR;;AiGlxuBI;EACI,gBAAA;AjGqxuBR;;AiGtxuBI;EACI,iBAAA;AjGyxuBR;;AiG1xuBI;EACI,gBAAA;AjG6xuBR;;AiG9xuBI;EACI,gBAAA;AjGiyuBR;;AiGlyuBI;EACI,gBAAA;AjGqyuBR;;AiGtyuBI;EACI,gBAAA;AjGyyuBR;;AiG1yuBI;EACI,gBAAA;AjG6yuBR;;AiG9yuBI;EACI,gBAAA;AjGizuBR;;AiGlzuBI;EACI,gBAAA;AjGqzuBR;;AiGtzuBI;EACI,gBAAA;AjGyzuBR;;AiG1zuBI;EACI,gBAAA;AjG6zuBR;;AiG9zuBI;EACI,gBAAA;AjGi0uBR;;AiGl0uBI;EACI,gBAAA;AjGq0uBR;;AiGt0uBI;EACI,gBAAA;AjGy0uBR;;AiG10uBI;EACI,iBAAA;AjG60uBR;;AiG90uBI;EACI,gBAAA;AjGi1uBR;;AiGl1uBI;EACI,gBAAA;AjGq1uBR;;AiGt1uBI;EACI,gBAAA;AjGy1uBR;;AiG11uBI;EACI,gBAAA;AjG61uBR;;AiG91uBI;EACI,gBAAA;AjGi2uBR;;AiGl2uBI;EACI,gBAAA;AjGq2uBR;;AiGt2uBI;EACI,gBAAA;AjGy2uBR;;AiG12uBI;EACI,gBAAA;AjG62uBR;;AiG92uBI;EACI,iBAAA;AjGi3uBR;;AiGl3uBI;EACI,gBAAA;AjGq3uBR;;AiGt3uBI;EACI,iBAAA;AjGy3uBR;;AiG13uBI;EACI,gBAAA;AjG63uBR;;AiG93uBI;EACI,iBAAA;AjGi4uBR;;AiGl4uBI;EACI,gBAAA;AjGq4uBR;;AiGt4uBI;EACI,iBAAA;AjGy4uBR;;AiG14uBI;EACI,gBAAA;AjG64uBR;;AiG94uBI;EACI,iBAAA;AjGi5uBR;;AiGl5uBI;EACI,gBAAA;AjGq5uBR;;AiGt5uBI;EACI,iBAAA;AjGy5uBR;;AiG15uBI;EACI,iBAAA;AjG65uBR;;AiG95uBI;EACI,gBAAA;AjGi6uBR;;AiGl6uBI;EACI,iBAAA;AjGq6uBR;;AiGt6uBI;EACI,gBAAA;AjGy6uBR;;AiG16uBI;EACI,iBAAA;AjG66uBR;;AiG96uBI;EACI,gBAAA;AjGi7uBR;;AiGl7uBI;EACI,iBAAA;AjGq7uBR;;AiGt7uBI;EACI,gBAAA;AjGy7uBR;;AiG17uBI;EACI,iBAAA;AjG67uBR;;AiG97uBI;EACI,gBAAA;AjGi8uBR;;AiGl8uBI;EACI,iBAAA;AjGq8uBR;;AiGt8uBI;EACI,gBAAA;AjGy8uBR;;AiG18uBI;EACI,gBAAA;AjG68uBR;;AiG98uBI;EACI,iBAAA;AjGi9uBR;;AiGl9uBI;EACI,gBAAA;AjGq9uBR;;AiGt9uBI;EACI,iBAAA;AjGy9uBR;;AiG19uBI;EACI,gBAAA;AjG69uBR;;AiG99uBI;EACI,gBAAA;AjGi+uBR;;AiGl+uBI;EACI,gBAAA;AjGq+uBR;;AiGt+uBI;EACI,gBAAA;AjGy+uBR;;AiG1+uBI;EACI,gBAAA;AjG6+uBR;;AiG9+uBI;EACI,gBAAA;AjGi/uBR;;AiGl/uBI;EACI,gBAAA;AjGq/uBR;;AiGt/uBI;EACI,gBAAA;AjGy/uBR;;AiG1/uBI;EACI,iBAAA;AjG6/uBR;;AiG9/uBI;EACI,iBAAA;AjGigvBR;;AiGlgvBI;EACI,gBAAA;AjGqgvBR;;AiGtgvBI;EACI,gBAAA;AjGygvBR;;AiG1gvBI;EACI,iBAAA;AjG6gvBR;;AiG9gvBI;EACI,iBAAA;AjGihvBR;;AiGlhvBI;EACI,iBAAA;AjGqhvBR;;AiGthvBI;EACI,iBAAA;AjGyhvBR;;AiG1hvBI;EACI,iBAAA;AjG6hvBR;;AiG9hvBI;EACI,iBAAA;AjGiivBR;;AiGlivBI;EACI,gBAAA;AjGqivBR;;AiGtivBI;EACI,gBAAA;AjGyivBR;;AiG1ivBI;EACI,gBAAA;AjG6ivBR;;AiG9ivBI;EACI,gBAAA;AjGijvBR;;AiGljvBI;EACI,gBAAA;AjGqjvBR;;AiGtjvBI;EACI,gBAAA;AjGyjvBR;;AiG1jvBI;EACI,gBAAA;AjG6jvBR;;AiG9jvBI;EACI,gBAAA;AjGikvBR;;AiGlkvBI;EACI,gBAAA;AjGqkvBR;;AiGtkvBI;EACI,gBAAA;AjGykvBR;;AiG1kvBI;EACI,gBAAA;AjG6kvBR;;AiG9kvBI;EACI,gBAAA;AjGilvBR;;AiGllvBI;EACI,gBAAA;AjGqlvBR;;AiGtlvBI;EACI,gBAAA;AjGylvBR;;AiG1lvBI;EACI,gBAAA;AjG6lvBR;;AiG9lvBI;EACI,iBAAA;AjGimvBR;;AiGlmvBI;EACI,iBAAA;AjGqmvBR;;AiGtmvBI;EACI,iBAAA;AjGymvBR;;AiG1mvBI;EACI,iBAAA;AjG6mvBR;;AiG9mvBI;EACI,gBAAA;AjGinvBR;;AiGlnvBI;EACI,gBAAA;AjGqnvBR;;AiGtnvBI;EACI,gBAAA;AjGynvBR;;AiG1nvBI;EACI,gBAAA;AjG6nvBR;;AiG9nvBI;EACI,gBAAA;AjGiovBR;;AiGlovBI;EACI,gBAAA;AjGqovBR;;AiGtovBI;EACI,gBAAA;AjGyovBR;;AiG1ovBI;EACI,gBAAA;AjG6ovBR;;AiG9ovBI;EACI,gBAAA;AjGipvBR;;AiGlpvBI;EACI,iBAAA;AjGqpvBR;;AiGtpvBI;EACI,iBAAA;AjGypvBR;;AiG1pvBI;EACI,iBAAA;AjG6pvBR;;AiG9pvBI;EACI,gBAAA;AjGiqvBR;;AiGlqvBI;EACI,gBAAA;AjGqqvBR;;AiGtqvBI;EACI,gBAAA;AjGyqvBR;;AiG1qvBI;EACI,iBAAA;AjG6qvBR;;AiG9qvBI;EACI,gBAAA;AjGirvBR;;AiGlrvBI;EACI,iBAAA;AjGqrvBR;;AiGtrvBI;EACI,gBAAA;AjGyrvBR;;AiG1rvBI;EACI,gBAAA;AjG6rvBR;;AiG9rvBI;EACI,gBAAA;AjGisvBR;;AiGlsvBI;EACI,gBAAA;AjGqsvBR;;AiGtsvBI;EACI,gBAAA;AjGysvBR;;AiG1svBI;EACI,gBAAA;AjG6svBR;;AiG9svBI;EACI,gBAAA;AjGitvBR;;AiGltvBI;EACI,gBAAA;AjGqtvBR;;AiGttvBI;EACI,gBAAA;AjGytvBR;;AiG1tvBI;EACI,gBAAA;AjG6tvBR;;AiG9tvBI;EACI,iBAAA;AjGiuvBR;;AiGluvBI;EACI,iBAAA;AjGquvBR;;AiGtuvBI;EACI,gBAAA;AjGyuvBR;;AiG1uvBI;EACI,gBAAA;AjG6uvBR;;AiG9uvBI;EACI,gBAAA;AjGivvBR;;AiGlvvBI;EACI,iBAAA;AjGqvvBR;;AiGtvvBI;EACI,iBAAA;AjGyvvBR;;AiG1vvBI;EACI,gBAAA;AjG6vvBR;;AiG9vvBI;EACI,gBAAA;AjGiwvBR;;AiGlwvBI;EACI,gBAAA;AjGqwvBR;;AiGtwvBI;EACI,iBAAA;AjGywvBR;;AiG1wvBI;EACI,gBAAA;AjG6wvBR;;AiG9wvBI;EACI,gBAAA;AjGixvBR;;AiGlxvBI;EACI,iBAAA;AjGqxvBR;;AiGtxvBI;EACI,gBAAA;AjGyxvBR;;AiG1xvBI;EACI,gBAAA;AjG6xvBR;;AiG9xvBI;EACI,gBAAA;AjGiyvBR;;AiGlyvBI;EACI,gBAAA;AjGqyvBR;;AiGtyvBI;EACI,gBAAA;AjGyyvBR;;AiG1yvBI;EACI,gBAAA;AjG6yvBR;;AiG9yvBI;EACI,gBAAA;AjGizvBR;;AiGlzvBI;EACI,gBAAA;AjGqzvBR;;AiGtzvBI;EACI,gBAAA;AjGyzvBR;;AiG1zvBI;EACI,gBAAA;AjG6zvBR;;AiG9zvBI;EACI,gBAAA;AjGi0vBR;;AiGl0vBI;EACI,gBAAA;AjGq0vBR;;AiGt0vBI;EACI,gBAAA;AjGy0vBR;;AiG10vBI;EACI,gBAAA;AjG60vBR;;AiG90vBI;EACI,gBAAA;AjGi1vBR;;AiGl1vBI;EACI,gBAAA;AjGq1vBR;;AiGt1vBI;EACI,gBAAA;AjGy1vBR;;AiG11vBI;EACI,iBAAA;AjG61vBR;;AiG91vBI;EACI,gBAAA;AjGi2vBR;;AiGl2vBI;EACI,gBAAA;AjGq2vBR;;AiGt2vBI;EACI,gBAAA;AjGy2vBR;;AiG12vBI;EACI,gBAAA;AjG62vBR;;AiG92vBI;EACI,iBAAA;AjGi3vBR;;AiGl3vBI;EACI,gBAAA;AjGq3vBR;;AiGt3vBI;EACI,gBAAA;AjGy3vBR;;AiG13vBI;EACI,gBAAA;AjG63vBR;;AiG93vBI;EACI,gBAAA;AjGi4vBR;;AiGl4vBI;EACI,gBAAA;AjGq4vBR;;AiGt4vBI;EACI,gBAAA;AjGy4vBR;;AiG14vBI;EACI,iBAAA;AjG64vBR;;AiG94vBI;EACI,iBAAA;AjGi5vBR;;AiGl5vBI;EACI,gBAAA;AjGq5vBR;;AiGt5vBI;EACI,gBAAA;AjGy5vBR;;AiG15vBI;EACI,gBAAA;AjG65vBR;;AiG95vBI;EACI,gBAAA;AjGi6vBR;;AiGl6vBI;EACI,iBAAA;AjGq6vBR;;AiGt6vBI;EACI,iBAAA;AjGy6vBR;;AiG16vBI;EACI,iBAAA;AjG66vBR;;AiG96vBI;EACI,gBAAA;AjGi7vBR;;AiGl7vBI;EACI,gBAAA;AjGq7vBR;;AiGt7vBI;EACI,gBAAA;AjGy7vBR;;AiG17vBI;EACI,gBAAA;AjG67vBR;;AiG97vBI;EACI,gBAAA;AjGi8vBR;;AiGl8vBI;EACI,gBAAA;AjGq8vBR;;AiGt8vBI;EACI,gBAAA;AjGy8vBR;;AiG18vBI;EACI,gBAAA;AjG68vBR;;AiG98vBI;EACI,gBAAA;AjGi9vBR;;AiGl9vBI;EACI,gBAAA;AjGq9vBR;;AiGt9vBI;EACI,gBAAA;AjGy9vBR;;AiG19vBI;EACI,gBAAA;AjG69vBR;;AiG99vBI;EACI,gBAAA;AjGi+vBR;;AiGl+vBI;EACI,gBAAA;AjGq+vBR;;AiGt+vBI;EACI,gBAAA;AjGy+vBR;;AiG1+vBI;EACI,gBAAA;AjG6+vBR;;AiG9+vBI;EACI,gBAAA;AjGi/vBR;;AiGl/vBI;EACI,gBAAA;AjGq/vBR;;AiGt/vBI;EACI,gBAAA;AjGy/vBR;;AiG1/vBI;EACI,gBAAA;AjG6/vBR;;AiG9/vBI;EACI,gBAAA;AjGigwBR;;AiGlgwBI;EACI,gBAAA;AjGqgwBR;;AiGtgwBI;EACI,gBAAA;AjGygwBR;;AiG1gwBI;EACI,gBAAA;AjG6gwBR;;AiG9gwBI;EACI,iBAAA;AjGihwBR;;AiGlhwBI;EACI,iBAAA;AjGqhwBR;;AiGthwBI;EACI,gBAAA;AjGyhwBR;;AiG1hwBI;EACI,gBAAA;AjG6hwBR;;AiG9hwBI;EACI,iBAAA;AjGiiwBR;;AiGliwBI;EACI,iBAAA;AjGqiwBR;;AiGtiwBI;EACI,iBAAA;AjGyiwBR;;AiG1iwBI;EACI,iBAAA;AjG6iwBR;;AiG9iwBI;EACI,gBAAA;AjGijwBR;;AiGljwBI;EACI,gBAAA;AjGqjwBR;;AiGtjwBI;EACI,gBAAA;AjGyjwBR;;AiG1jwBI;EACI,gBAAA;AjG6jwBR;;AiG9jwBI;EACI,gBAAA;AjGikwBR;;AiGlkwBI;EACI,gBAAA;AjGqkwBR;;AiGtkwBI;EACI,iBAAA;AjGykwBR;;AiG1kwBI;EACI,iBAAA;AjG6kwBR;;AiG9kwBI;EACI,gBAAA;AjGilwBR;;AiGllwBI;EACI,gBAAA;AjGqlwBR;;AiGtlwBI;EACI,gBAAA;AjGylwBR;;AiG1lwBI;EACI,gBAAA;AjG6lwBR;;AiG9lwBI;EACI,gBAAA;AjGimwBR;;AiGlmwBI;EACI,gBAAA;AjGqmwBR;;AiGtmwBI;EACI,gBAAA;AjGymwBR;;AiG1mwBI;EACI,gBAAA;AjG6mwBR;;AiG9mwBI;EACI,gBAAA;AjGinwBR;;AiGlnwBI;EACI,gBAAA;AjGqnwBR;;AiGtnwBI;EACI,gBAAA;AjGynwBR;;AiG1nwBI;EACI,gBAAA;AjG6nwBR;;AiG9nwBI;EACI,gBAAA;AjGiowBR;;AiGlowBI;EACI,gBAAA;AjGqowBR;;AiGtowBI;EACI,gBAAA;AjGyowBR;;AiG1owBI;EACI,gBAAA;AjG6owBR;;AiG9owBI;EACI,iBAAA;AjGipwBR;;AiGlpwBI;EACI,iBAAA;AjGqpwBR;;AiGtpwBI;EACI,gBAAA;AjGypwBR;;AiG1pwBI;EACI,gBAAA;AjG6pwBR;;AiG9pwBI;EACI,gBAAA;AjGiqwBR;;AiGlqwBI;EACI,gBAAA;AjGqqwBR;;AiGtqwBI;EACI,gBAAA;AjGyqwBR;;AiG1qwBI;EACI,gBAAA;AjG6qwBR;;AiG9qwBI;EACI,gBAAA;AjGirwBR;;AiGlrwBI;EACI,gBAAA;AjGqrwBR;;AiGtrwBI;EACI,gBAAA;AjGyrwBR;;AiG1rwBI;EACI,gBAAA;AjG6rwBR;;AiG9rwBI;EACI,gBAAA;AjGiswBR;;AiGlswBI;EACI,gBAAA;AjGqswBR;;AiGtswBI;EACI,gBAAA;AjGyswBR;;AiG1swBI;EACI,gBAAA;AjG6swBR;;AiG9swBI;EACI,gBAAA;AjGitwBR;;AiGltwBI;EACI,iBAAA;AjGqtwBR;;AiGttwBI;EACI,gBAAA;AjGytwBR;;AiG1twBI;EACI,gBAAA;AjG6twBR;;AiG9twBI;EACI,gBAAA;AjGiuwBR;;AiGluwBI;EACI,gBAAA;AjGquwBR;;AiGtuwBI;EACI,gBAAA;AjGyuwBR;;AiG1uwBI;EACI,gBAAA;AjG6uwBR;;AiG9uwBI;EACI,gBAAA;AjGivwBR;;AiGlvwBI;EACI,iBAAA;AjGqvwBR;;AiGtvwBI;EACI,iBAAA;AjGyvwBR;;AiG1vwBI;EACI,gBAAA;AjG6vwBR;;AiG9vwBI;EACI,gBAAA;AjGiwwBR;;AiGlwwBI;EACI,gBAAA;AjGqwwBR;;AiGtwwBI;EACI,gBAAA;AjGywwBR;;AiG1wwBI;EACI,gBAAA;AjG6wwBR;;AiG9wwBI;EACI,gBAAA;AjGixwBR;;AiGlxwBI;EACI,gBAAA;AjGqxwBR;;AiGtxwBI;EACI,gBAAA;AjGyxwBR;;AiG1xwBI;EACI,gBAAA;AjG6xwBR;;AiG9xwBI;EACI,gBAAA;AjGiywBR;;AiGlywBI;EACI,iBAAA;AjGqywBR;;AiGtywBI;EACI,gBAAA;AjGyywBR;;AiG1ywBI;EACI,iBAAA;AjG6ywBR;;AiG9ywBI;EACI,gBAAA;AjGizwBR;;AiGlzwBI;EACI,gBAAA;AjGqzwBR;;AiGtzwBI;EACI,gBAAA;AjGyzwBR;;AiG1zwBI;EACI,gBAAA;AjG6zwBR;;AiG9zwBI;EACI,gBAAA;AjGi0wBR;;AiGl0wBI;EACI,gBAAA;AjGq0wBR;;AiGt0wBI;EACI,gBAAA;AjGy0wBR;;AiG10wBI;EACI,gBAAA;AjG60wBR;;AiG90wBI;EACI,gBAAA;AjGi1wBR;;AiGl1wBI;EACI,gBAAA;AjGq1wBR;;AiGt1wBI;EACI,gBAAA;AjGy1wBR;;AiG11wBI;EACI,gBAAA;AjG61wBR;;AiG91wBI;EACI,gBAAA;AjGi2wBR;;AiGl2wBI;EACI,gBAAA;AjGq2wBR;;AiGt2wBI;EACI,gBAAA;AjGy2wBR;;AiG12wBI;EACI,iBAAA;AjG62wBR;;AiG92wBI;EACI,iBAAA;AjGi3wBR;;AiGl3wBI;EACI,gBAAA;AjGq3wBR;;AiGt3wBI;EACI,gBAAA;AjGy3wBR;;AiG13wBI;EACI,gBAAA;AjG63wBR;;AiG93wBI;EACI,gBAAA;AjGi4wBR;;AiGl4wBI;EACI,gBAAA;AjGq4wBR;;AiGt4wBI;EACI,gBAAA;AjGy4wBR;;AiG14wBI;EACI,gBAAA;AjG64wBR;;AiG94wBI;EACI,gBAAA;AjGi5wBR;;AiGl5wBI;EACI,gBAAA;AjGq5wBR;;AiGt5wBI;EACI,gBAAA;AjGy5wBR;;AiG15wBI;EACI,gBAAA;AjG65wBR;;AiG95wBI;EACI,gBAAA;AjGi6wBR;;AiGl6wBI;EACI,gBAAA;AjGq6wBR;;AiGt6wBI;EACI,iBAAA;AjGy6wBR;;AiG16wBI;EACI,gBAAA;AjG66wBR;;AiG96wBI;EACI,iBAAA;AjGi7wBR;;AiGl7wBI;EACI,iBAAA;AjGq7wBR;;AiGt7wBI;EACI,gBAAA;AjGy7wBR;;AiG17wBI;EACI,gBAAA;AjG67wBR;;AiG97wBI;EACI,gBAAA;AjGi8wBR;;AiGl8wBI;EACI,gBAAA;AjGq8wBR;;AiGt8wBI;EACI,gBAAA;AjGy8wBR;;AiG18wBI;EACI,gBAAA;AjG68wBR;;AiG98wBI;EACI,gBAAA;AjGi9wBR;;AiGl9wBI;EACI,gBAAA;AjGq9wBR;;AiGt9wBI;EACI,gBAAA;AjGy9wBR;;AiG19wBI;EACI,gBAAA;AjG69wBR;;AiG99wBI;EACI,iBAAA;AjGi+wBR;;AiGl+wBI;EACI,gBAAA;AjGq+wBR;;AiGt+wBI;EACI,gBAAA;AjGy+wBR;;AiG1+wBI;EACI,gBAAA;AjG6+wBR;;AiG9+wBI;EACI,gBAAA;AjGi/wBR;;AiGl/wBI;EACI,gBAAA;AjGq/wBR;;AiGt/wBI;EACI,gBAAA;AjGy/wBR;;AiG1/wBI;EACI,gBAAA;AjG6/wBR;;AiG9/wBI;EACI,gBAAA;AjGigxBR;;AiGlgxBI;EACI,gBAAA;AjGqgxBR;;AiGtgxBI;EACI,gBAAA;AjGygxBR;;AiG1gxBI;EACI,iBAAA;AjG6gxBR;;AiG9gxBI;EACI,gBAAA;AjGihxBR;;AiGlhxBI;EACI,gBAAA;AjGqhxBR;;AiGthxBI;EACI,gBAAA;AjGyhxBR;;AiG1hxBI;EACI,gBAAA;AjG6hxBR;;AiG9hxBI;EACI,gBAAA;AjGiixBR;;AiGlixBI;EACI,gBAAA;AjGqixBR;;AiGtixBI;EACI,gBAAA;AjGyixBR;;AiG1ixBI;EACI,iBAAA;AjG6ixBR;;AiG9ixBI;EACI,iBAAA;AjGijxBR;;AiGljxBI;EACI,gBAAA;AjGqjxBR;;AiGtjxBI;EACI,iBAAA;AjGyjxBR;;AiG1jxBI;EACI,gBAAA;AjG6jxBR;;AiG9jxBI;EACI,gBAAA;AjGikxBR;;AiGlkxBI;EACI,iBAAA;AjGqkxBR;;AiGtkxBI;EACI,iBAAA;AjGykxBR;;AiG1kxBI;EACI,gBAAA;AjG6kxBR;;AiG9kxBI;EACI,iBAAA;AjGilxBR;;AiGllxBI;EACI,gBAAA;AjGqlxBR;;AiGtlxBI;EACI,iBAAA;AjGylxBR;;AiG1lxBI;EACI,gBAAA;AjG6lxBR;;AiG9lxBI;EACI,gBAAA;AjGimxBR;;AiGlmxBI;EACI,gBAAA;AjGqmxBR;;AiGtmxBI;EACI,gBAAA;AjGymxBR;;AiG1mxBI;EACI,gBAAA;AjG6mxBR;;AiG9mxBI;EACI,gBAAA;AjGinxBR;;AiGlnxBI;EACI,gBAAA;AjGqnxBR;;AiGtnxBI;EACI,gBAAA;AjGynxBR;;AiG1nxBI;EACI,gBAAA;AjG6nxBR;;AiG9nxBI;EACI,gBAAA;AjGioxBR;;AiGloxBI;EACI,gBAAA;AjGqoxBR;;AiGtoxBI;EACI,gBAAA;AjGyoxBR;;AiG1oxBI;EACI,gBAAA;AjG6oxBR;;AiG9oxBI;EACI,gBAAA;AjGipxBR;;AiGlpxBI;EACI,gBAAA;AjGqpxBR;;AiGtpxBI;EACI,gBAAA;AjGypxBR;;AiG1pxBI;EACI,gBAAA;AjG6pxBR;;AiG9pxBI;EACI,gBAAA;AjGiqxBR;;AiGlqxBI;EACI,gBAAA;AjGqqxBR;;AiGtqxBI;EACI,gBAAA;AjGyqxBR;;AiG1qxBI;EACI,gBAAA;AjG6qxBR;;AiG9qxBI;EACI,gBAAA;AjGirxBR;;AiGlrxBI;EACI,gBAAA;AjGqrxBR;;AiGtrxBI;EACI,iBAAA;AjGyrxBR;;AiG1rxBI;EACI,iBAAA;AjG6rxBR;;AiG9rxBI;EACI,gBAAA;AjGisxBR;;AiGlsxBI;EACI,gBAAA;AjGqsxBR;;AiGtsxBI;EACI,iBAAA;AjGysxBR;;AiG1sxBI;EACI,iBAAA;AjG6sxBR;;AiG9sxBI;EACI,gBAAA;AjGitxBR;;AiGltxBI;EACI,iBAAA;AjGqtxBR;;AiGttxBI;EACI,gBAAA;AjGytxBR;;AiG1txBI;EACI,gBAAA;AjG6txBR;;AiG9txBI;EACI,gBAAA;AjGiuxBR;;AiGluxBI;EACI,gBAAA;AjGquxBR;;AiGtuxBI;EACI,gBAAA;AjGyuxBR;;AiG1uxBI;EACI,gBAAA;AjG6uxBR;;AiG9uxBI;EACI,gBAAA;AjGivxBR;;AiGlvxBI;EACI,gBAAA;AjGqvxBR;;AiGtvxBI;EACI,iBAAA;AjGyvxBR;;AiG1vxBI;EACI,iBAAA;AjG6vxBR;;AiG9vxBI;EACI,iBAAA;AjGiwxBR;;AiGlwxBI;EACI,iBAAA;AjGqwxBR;;AiGtwxBI;EACI,iBAAA;AjGywxBR;;AiG1wxBI;EACI,gBAAA;AjG6wxBR;;AiG9wxBI;EACI,iBAAA;AjGixxBR;;AiGlxxBI;EACI,gBAAA;AjGqxxBR;;AiGtxxBI;EACI,iBAAA;AjGyxxBR;;AiG1xxBI;EACI,gBAAA;AjG6xxBR;;AiG9xxBI;EACI,iBAAA;AjGiyxBR;;AiGlyxBI;EACI,gBAAA;AjGqyxBR;;AiGtyxBI;EACI,gBAAA;AjGyyxBR;;AiG1yxBI;EACI,gBAAA;AjG6yxBR;;AiG9yxBI;EACI,gBAAA;AjGizxBR;;AiGlzxBI;EACI,gBAAA;AjGqzxBR;;AiGtzxBI;EACI,gBAAA;AjGyzxBR;;AiG1zxBI;EACI,gBAAA;AjG6zxBR;;AiG9zxBI;EACI,gBAAA;AjGi0xBR;;AiGl0xBI;EACI,iBAAA;AjGq0xBR;;AiGt0xBI;EACI,iBAAA;AjGy0xBR;;AiG10xBI;EACI,iBAAA;AjG60xBR;;AiG90xBI;EACI,gBAAA;AjGi1xBR;;AiGl1xBI;EACI,gBAAA;AjGq1xBR;;AiGt1xBI;EACI,gBAAA;AjGy1xBR;;AiG11xBI;EACI,gBAAA;AjG61xBR;;AiG91xBI;EACI,iBAAA;AjGi2xBR;;AiGl2xBI;EACI,iBAAA;AjGq2xBR;;AiGt2xBI;EACI,gBAAA;AjGy2xBR;;AiG12xBI;EACI,gBAAA;AjG62xBR;;AiG92xBI;EACI,iBAAA;AjGi3xBR;;AiGl3xBI;EACI,gBAAA;AjGq3xBR;;AiGt3xBI;EACI,iBAAA;AjGy3xBR;;AiG13xBI;EACI,gBAAA;AjG63xBR;;AiG93xBI;EACI,gBAAA;AjGi4xBR;;AiGl4xBI;EACI,gBAAA;AjGq4xBR;;AiGt4xBI;EACI,iBAAA;AjGy4xBR;;AiG14xBI;EACI,gBAAA;AjG64xBR;;AiG94xBI;EACI,gBAAA;AjGi5xBR;;AiGl5xBI;EACI,gBAAA;AjGq5xBR;;AiGt5xBI;EACI,iBAAA;AjGy5xBR;;AiG15xBI;EACI,iBAAA;AjG65xBR;;AiG95xBI;EACI,iBAAA;AjGi6xBR;;AiGl6xBI;EACI,iBAAA;AjGq6xBR;;AiGt6xBI;EACI,iBAAA;AjGy6xBR;;AiG16xBI;EACI,iBAAA;AjG66xBR;;AiG96xBI;EACI,iBAAA;AjGi7xBR;;AiGl7xBI;EACI,gBAAA;AjGq7xBR;;AiGt7xBI;EACI,gBAAA;AjGy7xBR;;AiG17xBI;EACI,iBAAA;AjG67xBR;;AiG97xBI;EACI,iBAAA;AjGi8xBR;;AiGl8xBI;EACI,gBAAA;AjGq8xBR;;AiGt8xBI;EACI,iBAAA;AjGy8xBR;;AiG18xBI;EACI,iBAAA;AjG68xBR;;AiG98xBI;EACI,iBAAA;AjGi9xBR;;AiGl9xBI;EACI,iBAAA;AjGq9xBR;;AiGt9xBI;EACI,gBAAA;AjGy9xBR;;AiG19xBI;EACI,gBAAA;AjG69xBR;;AiG99xBI;EACI,gBAAA;AjGi+xBR;;AiGl+xBI;EACI,iBAAA;AjGq+xBR;;AiGt+xBI;EACI,gBAAA;AjGy+xBR;;AiG1+xBI;EACI,gBAAA;AjG6+xBR;;AiG9+xBI;EACI,gBAAA;AjGi/xBR;;AiGl/xBI;EACI,gBAAA;AjGq/xBR;;AiGt/xBI;EACI,gBAAA;AjGy/xBR;;AiG1/xBI;EACI,gBAAA;AjG6/xBR;;AiG9/xBI;EACI,iBAAA;AjGigyBR;;AiGlgyBI;EACI,iBAAA;AjGqgyBR;;AiGtgyBI;EACI,gBAAA;AjGygyBR;;AiG1gyBI;EACI,gBAAA;AjG6gyBR;;AiG9gyBI;EACI,gBAAA;AjGihyBR;;AiGlhyBI;EACI,gBAAA;AjGqhyBR;;AiGthyBI;EACI,iBAAA;AjGyhyBR;;AiG1hyBI;EACI,iBAAA;AjG6hyBR;;AiG9hyBI;EACI,gBAAA;AjGiiyBR;;AiGliyBI;EACI,gBAAA;AjGqiyBR;;AiGtiyBI;EACI,gBAAA;AjGyiyBR;;AiG1iyBI;EACI,gBAAA;AjG6iyBR;;AiG9iyBI;EACI,gBAAA;AjGijyBR;;AiGljyBI;EACI,gBAAA;AjGqjyBR;;AiGtjyBI;EACI,gBAAA;AjGyjyBR;;AiG1jyBI;EACI,gBAAA;AjG6jyBR;;AiG9jyBI;EACI,iBAAA;AjGikyBR;;AiGlkyBI;EACI,iBAAA;AjGqkyBR;;AiGtkyBI;EACI,iBAAA;AjGykyBR;;AiG1kyBI;EACI,gBAAA;AjG6kyBR;;AiG9kyBI;EACI,gBAAA;AjGilyBR;;AiGllyBI;EACI,gBAAA;AjGqlyBR;;AiGtlyBI;EACI,gBAAA;AjGylyBR;;AiG1lyBI;EACI,gBAAA;AjG6lyBR;;AiG9lyBI;EACI,gBAAA;AjGimyBR;;AiGlmyBI;EACI,iBAAA;AjGqmyBR;;AiGtmyBI;EACI,iBAAA;AjGymyBR;;AiG1myBI;EACI,iBAAA;AjG6myBR;;AiG9myBI;EACI,gBAAA;AjGinyBR;;AiGlnyBI;EACI,gBAAA;AjGqnyBR;;AiGtnyBI;EACI,gBAAA;AjGynyBR;;AiG1nyBI;EACI,gBAAA;AjG6nyBR;;AiG9nyBI;EACI,gBAAA;AjGioyBR;;AiGloyBI;EACI,gBAAA;AjGqoyBR;;AiGtoyBI;EACI,gBAAA;AjGyoyBR;;AiG1oyBI;EACI,gBAAA;AjG6oyBR;;AiG9oyBI;EACI,gBAAA;AjGipyBR;;AiGlpyBI;EACI,gBAAA;AjGqpyBR;;AiGtpyBI;EACI,gBAAA;AjGypyBR;;AiG1pyBI;EACI,gBAAA;AjG6pyBR;;AiG9pyBI;EACI,gBAAA;AjGiqyBR;;AiGlqyBI;EACI,gBAAA;AjGqqyBR;;AiGtqyBI;EACI,iBAAA;AjGyqyBR;;AiG1qyBI;EACI,gBAAA;AjG6qyBR;;AiG9qyBI;EACI,gBAAA;AjGiryBR;;AiGlryBI;EACI,iBAAA;AjGqryBR;;AiGtryBI;EACI,gBAAA;AjGyryBR;;AiG1ryBI;EACI,iBAAA;AjG6ryBR;;AiG9ryBI;EACI,gBAAA;AjGisyBR;;AiGlsyBI;EACI,gBAAA;AjGqsyBR;;AiGtsyBI;EACI,gBAAA;AjGysyBR;;AiG1syBI;EACI,gBAAA;AjG6syBR;;AiG9syBI;EACI,gBAAA;AjGityBR;;AiGltyBI;EACI,gBAAA;AjGqtyBR;;AiGttyBI;EACI,gBAAA;AjGytyBR;;AiG1tyBI;EACI,gBAAA;AjG6tyBR;;AiG9tyBI;EACI,gBAAA;AjGiuyBR;;AiGluyBI;EACI,gBAAA;AjGquyBR;;AiGtuyBI;EACI,gBAAA;AjGyuyBR;;AiG1uyBI;EACI,gBAAA;AjG6uyBR;;AiG9uyBI;EACI,gBAAA;AjGivyBR;;AiGlvyBI;EACI,gBAAA;AjGqvyBR;;AiGtvyBI;EACI,gBAAA;AjGyvyBR;;AiG1vyBI;EACI,gBAAA;AjG6vyBR;;AiG9vyBI;EACI,iBAAA;AjGiwyBR;;AiGlwyBI;EACI,iBAAA;AjGqwyBR;;AiGtwyBI;EACI,gBAAA;AjGywyBR;;AiG1wyBI;EACI,iBAAA;AjG6wyBR;;AiG9wyBI;EACI,iBAAA;AjGixyBR;;AiGlxyBI;EACI,iBAAA;AjGqxyBR;;AiGtxyBI;EACI,iBAAA;AjGyxyBR;;AiG1xyBI;EACI,iBAAA;AjG6xyBR;;AiG9xyBI;EACI,iBAAA;AjGiyyBR;;AiGlyyBI;EACI,gBAAA;AjGqyyBR;;AiGtyyBI;EACI,iBAAA;AjGyyyBR;;AiG1yyBI;EACI,iBAAA;AjG6yyBR;;AiG9yyBI;EACI,iBAAA;AjGizyBR;;AiGlzyBI;EACI,iBAAA;AjGqzyBR;;AiGtzyBI;EACI,iBAAA;AjGyzyBR;;AiG1zyBI;EACI,iBAAA;AjG6zyBR;;AiG9zyBI;EACI,iBAAA;AjGi0yBR;;AiGl0yBI;EACI,iBAAA;AjGq0yBR;;AiGt0yBI;EACI,gBAAA;AjGy0yBR;;AiG10yBI;EACI,iBAAA;AjG60yBR;;AiG90yBI;EACI,gBAAA;AjGi1yBR;;AiGl1yBI;EACI,iBAAA;AjGq1yBR;;AiGt1yBI;EACI,gBAAA;AjGy1yBR;;AiG11yBI;EACI,gBAAA;AjG61yBR;;AiG91yBI;EACI,iBAAA;AjGi2yBR;;AiGl2yBI;EACI,gBAAA;AjGq2yBR;;AiGt2yBI;EACI,iBAAA;AjGy2yBR;;AiG12yBI;EACI,iBAAA;AjG62yBR;;AiG92yBI;EACI,gBAAA;AjGi3yBR;;AiGl3yBI;EACI,gBAAA;AjGq3yBR;;AiGt3yBI;EACI,gBAAA;AjGy3yBR;;AiG13yBI;EACI,gBAAA;AjG63yBR;;AiG93yBI;EACI,gBAAA;AjGi4yBR;;AiGl4yBI;EACI,gBAAA;AjGq4yBR;;AiGt4yBI;EACI,gBAAA;AjGy4yBR;;AiG14yBI;EACI,gBAAA;AjG64yBR;;AiG94yBI;EACI,gBAAA;AjGi5yBR;;AiGl5yBI;EACI,gBAAA;AjGq5yBR;;AiGt5yBI;EACI,gBAAA;AjGy5yBR;;AiG15yBI;EACI,gBAAA;AjG65yBR;;AiG95yBI;EACI,gBAAA;AjGi6yBR;;AiGl6yBI;EACI,gBAAA;AjGq6yBR;;AiGt6yBI;EACI,gBAAA;AjGy6yBR;;AiG16yBI;EACI,gBAAA;AjG66yBR;;AiG96yBI;EACI,gBAAA;AjGi7yBR;;AiGl7yBI;EACI,gBAAA;AjGq7yBR;;AiGt7yBI;EACI,gBAAA;AjGy7yBR;;AiG17yBI;EACI,gBAAA;AjG67yBR;;AiG97yBI;EACI,iBAAA;AjGi8yBR;;AiGl8yBI;EACI,gBAAA;AjGq8yBR;;AiGt8yBI;EACI,gBAAA;AjGy8yBR;;AiG18yBI;EACI,gBAAA;AjG68yBR;;AiG98yBI;EACI,iBAAA;AjGi9yBR;;AiGl9yBI;EACI,iBAAA;AjGq9yBR;;AiGt9yBI;EACI,iBAAA;AjGy9yBR;;AiG19yBI;EACI,iBAAA;AjG69yBR;;AiG99yBI;EACI,gBAAA;AjGi+yBR;;AiGl+yBI;EACI,iBAAA;AjGq+yBR;;AiGt+yBI;EACI,iBAAA;AjGy+yBR;;AiG1+yBI;EACI,gBAAA;AjG6+yBR;;AiG9+yBI;EACI,gBAAA;AjGi/yBR;;AiGl/yBI;EACI,gBAAA;AjGq/yBR;;AiGt/yBI;EACI,iBAAA;AjGy/yBR;;AiG1/yBI;EACI,gBAAA;AjG6/yBR;;AiG9/yBI;EACI,gBAAA;AjGigzBR;;AiGlgzBI;EACI,iBAAA;AjGqgzBR;;AiGtgzBI;EACI,iBAAA;AjGygzBR;;AiG1gzBI;EACI,gBAAA;AjG6gzBR;;AiG9gzBI;EACI,iBAAA;AjGihzBR;;AiGlhzBI;EACI,gBAAA;AjGqhzBR;;AiGthzBI;EACI,gBAAA;AjGyhzBR;;AiG1hzBI;EACI,gBAAA;AjG6hzBR;;AiG9hzBI;EACI,iBAAA;AjGiizBR;;AiGlizBI;EACI,iBAAA;AjGqizBR;;AiGtizBI;EACI,gBAAA;AjGyizBR;;AiG1izBI;EACI,gBAAA;AjG6izBR;;AiG9izBI;EACI,gBAAA;AjGijzBR;;AiGljzBI;EACI,gBAAA;AjGqjzBR;;AiGtjzBI;EACI,gBAAA;AjGyjzBR;;AiG1jzBI;EACI,gBAAA;AjG6jzBR;;AiG9jzBI;EACI,gBAAA;AjGikzBR;;AiGlkzBI;EACI,gBAAA;AjGqkzBR;;AiGtkzBI;EACI,gBAAA;AjGykzBR;;AiG1kzBI;EACI,gBAAA;AjG6kzBR;;AiG9kzBI;EACI,gBAAA;AjGilzBR;;AiGllzBI;EACI,gBAAA;AjGqlzBR;;AiGtlzBI;EACI,gBAAA;AjGylzBR;;AiG1lzBI;EACI,iBAAA;AjG6lzBR;;AiG9lzBI;EACI,iBAAA;AjGimzBR;;AiGlmzBI;EACI,iBAAA;AjGqmzBR;;AiGtmzBI;EACI,iBAAA;AjGymzBR;;AiG1mzBI;EACI,gBAAA;AjG6mzBR;;AiG9mzBI;EACI,gBAAA;AjGinzBR;;AiGlnzBI;EACI,gBAAA;AjGqnzBR;;AiGtnzBI;EACI,gBAAA;AjGynzBR;;AiG1nzBI;EACI,gBAAA;AjG6nzBR;;AiG9nzBI;EACI,gBAAA;AjGiozBR;;AiGlozBI;EACI,iBAAA;AjGqozBR;;AiGtozBI;EACI,iBAAA;AjGyozBR;;AiG1ozBI;EACI,gBAAA;AjG6ozBR;;AiG9ozBI;EACI,gBAAA;AjGipzBR;;AiGlpzBI;EACI,gBAAA;AjGqpzBR;;AiGtpzBI;EACI,iBAAA;AjGypzBR;;AiG1pzBI;EACI,gBAAA;AjG6pzBR;;AiG9pzBI;EACI,gBAAA;AjGiqzBR;;AiGlqzBI;EACI,gBAAA;AjGqqzBR;;AiGtqzBI;EACI,gBAAA;AjGyqzBR;;AiG1qzBI;EACI,gBAAA;AjG6qzBR;;AiG9qzBI;EACI,gBAAA;AjGirzBR;;AiGlrzBI;EACI,gBAAA;AjGqrzBR;;AiGtrzBI;EACI,gBAAA;AjGyrzBR;;AiG1rzBI;EACI,gBAAA;AjG6rzBR;;AiG9rzBI;EACI,gBAAA;AjGiszBR;;AiGlszBI;EACI,gBAAA;AjGqszBR;;AiGtszBI;EACI,gBAAA;AjGyszBR;;AiG1szBI;EACI,gBAAA;AjG6szBR;;AiG9szBI;EACI,gBAAA;AjGitzBR;;AiGltzBI;EACI,gBAAA;AjGqtzBR;;AiGttzBI;EACI,gBAAA;AjGytzBR;;AiG1tzBI;EACI,gBAAA;AjG6tzBR;;AiG9tzBI;EACI,gBAAA;AjGiuzBR;;AiGluzBI;EACI,gBAAA;AjGquzBR;;AiGtuzBI;EACI,gBAAA;AjGyuzBR;;AiG1uzBI;EACI,gBAAA;AjG6uzBR;;AiG9uzBI;EACI,gBAAA;AjGivzBR;;AiGlvzBI;EACI,gBAAA;AjGqvzBR;;AiGtvzBI;EACI,gBAAA;AjGyvzBR;;AiG1vzBI;EACI,gBAAA;AjG6vzBR;;AiG9vzBI;EACI,gBAAA;AjGiwzBR;;AiGlwzBI;EACI,gBAAA;AjGqwzBR;;AiGtwzBI;EACI,gBAAA;AjGywzBR;;AiG1wzBI;EACI,iBAAA;AjG6wzBR;;AiG9wzBI;EACI,gBAAA;AjGixzBR;;AiGlxzBI;EACI,gBAAA;AjGqxzBR;;AiGtxzBI;EACI,gBAAA;AjGyxzBR;;AiG1xzBI;EACI,gBAAA;AjG6xzBR;;AiG9xzBI;EACI,gBAAA;AjGiyzBR;;AiGlyzBI;EACI,gBAAA;AjGqyzBR;;AiGtyzBI;EACI,gBAAA;AjGyyzBR;;AiG1yzBI;EACI,gBAAA;AjG6yzBR;;AiG9yzBI;EACI,gBAAA;AjGizzBR;;AiGlzzBI;EACI,gBAAA;AjGqzzBR;;AiGtzzBI;EACI,gBAAA;AjGyzzBR;;AiG1zzBI;EACI,gBAAA;AjG6zzBR;;AiG9zzBI;EACI,gBAAA;AjGi0zBR;;AiGl0zBI;EACI,gBAAA;AjGq0zBR;;AiGt0zBI;EACI,gBAAA;AjGy0zBR;;AiG10zBI;EACI,gBAAA;AjG60zBR;;AiG90zBI;EACI,gBAAA;AjGi1zBR;;AiGl1zBI;EACI,gBAAA;AjGq1zBR;;AiGt1zBI;EACI,gBAAA;AjGy1zBR;;AiG11zBI;EACI,gBAAA;AjG61zBR;;AiG91zBI;EACI,gBAAA;AjGi2zBR;;AiGl2zBI;EACI,gBAAA;AjGq2zBR;;AiGt2zBI;EACI,gBAAA;AjGy2zBR;;AiG12zBI;EACI,gBAAA;AjG62zBR;;AiG92zBI;EACI,gBAAA;AjGi3zBR;;AiGl3zBI;EACI,gBAAA;AjGq3zBR;;AiGt3zBI;EACI,gBAAA;AjGy3zBR;;AiG13zBI;EACI,gBAAA;AjG63zBR;;AiG93zBI;EACI,gBAAA;AjGi4zBR;;AiGl4zBI;EACI,gBAAA;AjGq4zBR;;AiGt4zBI;EACI,gBAAA;AjGy4zBR;;AiG14zBI;EACI,gBAAA;AjG64zBR;;AiG94zBI;EACI,gBAAA;AjGi5zBR;;AiGl5zBI;EACI,gBAAA;AjGq5zBR;;AiGt5zBI;EACI,gBAAA;AjGy5zBR;;AiG15zBI;EACI,gBAAA;AjG65zBR;;AiG95zBI;EACI,gBAAA;AjGi6zBR;;AiGl6zBI;EACI,gBAAA;AjGq6zBR;;AiGt6zBI;EACI,gBAAA;AjGy6zBR;;AiG16zBI;EACI,gBAAA;AjG66zBR;;AiG96zBI;EACI,gBAAA;AjGi7zBR;;AiGl7zBI;EACI,gBAAA;AjGq7zBR;;AiGt7zBI;EACI,iBAAA;AjGy7zBR;;AiG17zBI;EACI,gBAAA;AjG67zBR;;AiG97zBI;EACI,gBAAA;AjGi8zBR;;AiGl8zBI;EACI,gBAAA;AjGq8zBR;;AiGt8zBI;EACI,gBAAA;AjGy8zBR;;AiG18zBI;EACI,gBAAA;AjG68zBR;;AiG98zBI;EACI,gBAAA;AjGi9zBR;;AiGl9zBI;EACI,iBAAA;AjGq9zBR;;AiGt9zBI;EACI,gBAAA;AjGy9zBR;;AiG19zBI;EACI,iBAAA;AjG69zBR;;AiG99zBI;EACI,gBAAA;AjGi+zBR;;AiGl+zBI;EACI,gBAAA;AjGq+zBR;;AiGt+zBI;EACI,gBAAA;AjGy+zBR;;AiG1+zBI;EACI,gBAAA;AjG6+zBR;;AiG9+zBI;EACI,gBAAA;AjGi/zBR;;AiGl/zBI;EACI,gBAAA;AjGq/zBR;;AiGt/zBI;EACI,gBAAA;AjGy/zBR;;AiG1/zBI;EACI,gBAAA;AjG6/zBR;;AiG9/zBI;EACI,gBAAA;AjGig0BR;;AiGlg0BI;EACI,gBAAA;AjGqg0BR;;AiGtg0BI;EACI,gBAAA;AjGyg0BR;;AiG1g0BI;EACI,gBAAA;AjG6g0BR;;AiG9g0BI;EACI,gBAAA;AjGih0BR;;AiGlh0BI;EACI,gBAAA;AjGqh0BR;;AiGth0BI;EACI,gBAAA;AjGyh0BR;;AiG1h0BI;EACI,gBAAA;AjG6h0BR;;AiG9h0BI;EACI,gBAAA;AjGii0BR;;AiGli0BI;EACI,gBAAA;AjGqi0BR;;AiGti0BI;EACI,gBAAA;AjGyi0BR;;AiG1i0BI;EACI,gBAAA;AjG6i0BR;;AiG9i0BI;EACI,gBAAA;AjGij0BR;;AiGlj0BI;EACI,gBAAA;AjGqj0BR;;AiGtj0BI;EACI,gBAAA;AjGyj0BR;;AiG1j0BI;EACI,gBAAA;AjG6j0BR;;AiG9j0BI;EACI,gBAAA;AjGik0BR;;AiGlk0BI;EACI,gBAAA;AjGqk0BR;;AiGtk0BI;EACI,gBAAA;AjGyk0BR;;AiG1k0BI;EACI,gBAAA;AjG6k0BR;;AiG9k0BI;EACI,gBAAA;AjGil0BR;;AiGll0BI;EACI,gBAAA;AjGql0BR;;AiGtl0BI;EACI,gBAAA;AjGyl0BR;;AiG1l0BI;EACI,gBAAA;AjG6l0BR;;AiG9l0BI;EACI,gBAAA;AjGim0BR;;AiGlm0BI;EACI,gBAAA;AjGqm0BR;;AiGtm0BI;EACI,gBAAA;AjGym0BR;;AiG1m0BI;EACI,gBAAA;AjG6m0BR;;AiG9m0BI;EACI,gBAAA;AjGin0BR;;AiGln0BI;EACI,gBAAA;AjGqn0BR;;AiGtn0BI;EACI,gBAAA;AjGyn0BR;;AiG1n0BI;EACI,gBAAA;AjG6n0BR;;AiG9n0BI;EACI,gBAAA;AjGio0BR;;AiGlo0BI;EACI,gBAAA;AjGqo0BR;;AiGto0BI;EACI,iBAAA;AjGyo0BR;;AiG1o0BI;EACI,iBAAA;AjG6o0BR;;AiG9o0BI;EACI,gBAAA;AjGip0BR;;AiGlp0BI;EACI,iBAAA;AjGqp0BR;;AiGtp0BI;EACI,iBAAA;AjGyp0BR;;AiG1p0BI;EACI,gBAAA;AjG6p0BR;;AiG9p0BI;EACI,gBAAA;AjGiq0BR;;AiGlq0BI;EACI,iBAAA;AjGqq0BR;;AiGtq0BI;EACI,iBAAA;AjGyq0BR;;AiG1q0BI;EACI,iBAAA;AjG6q0BR;;AiG9q0BI;EACI,iBAAA;AjGir0BR;;AiGlr0BI;EACI,iBAAA;AjGqr0BR;;AiGtr0BI;EACI,iBAAA;AjGyr0BR;;AiG1r0BI;EACI,gBAAA;AjG6r0BR;;AiG9r0BI;EACI,gBAAA;AjGis0BR;;AiGls0BI;EACI,gBAAA;AjGqs0BR;;AiGts0BI;EACI,gBAAA;AjGys0BR;;AiG1s0BI;EACI,gBAAA;AjG6s0BR;;AiG9s0BI;EACI,iBAAA;AjGit0BR;;AiGlt0BI;EACI,iBAAA;AjGqt0BR;;AiGtt0BI;EACI,gBAAA;AjGyt0BR;;AiG1t0BI;EACI,gBAAA;AjG6t0BR;;AiG9t0BI;EACI,gBAAA;AjGiu0BR;;AiGlu0BI;EACI,gBAAA;AjGqu0BR;;AiGtu0BI;EACI,gBAAA;AjGyu0BR;;AiG1u0BI;EACI,gBAAA;AjG6u0BR;;AiG9u0BI;EACI,gBAAA;AjGiv0BR;;AiGlv0BI;EACI,gBAAA;AjGqv0BR;;AiGtv0BI;EACI,gBAAA;AjGyv0BR;;AiG1v0BI;EACI,gBAAA;AjG6v0BR;;AiG9v0BI;EACI,gBAAA;AjGiw0BR;;AiGlw0BI;EACI,gBAAA;AjGqw0BR;;AiGtw0BI;EACI,gBAAA;AjGyw0BR;;AiG1w0BI;EACI,gBAAA;AjG6w0BR;;AiG9w0BI;EACI,gBAAA;AjGix0BR;;AiGlx0BI;EACI,gBAAA;AjGqx0BR;;AiGtx0BI;EACI,gBAAA;AjGyx0BR;;AiG1x0BI;EACI,gBAAA;AjG6x0BR;;AiG9x0BI;EACI,gBAAA;AjGiy0BR;;AiGly0BI;EACI,gBAAA;AjGqy0BR;;AiGty0BI;EACI,gBAAA;AjGyy0BR;;AiG1y0BI;EACI,gBAAA;AjG6y0BR;;AiG9y0BI;EACI,gBAAA;AjGiz0BR;;AiGlz0BI;EACI,iBAAA;AjGqz0BR;;AiGtz0BI;EACI,gBAAA;AjGyz0BR;;AiG1z0BI;EACI,gBAAA;AjG6z0BR;;AiG9z0BI;EACI,gBAAA;AjGi00BR;;AiGl00BI;EACI,iBAAA;AjGq00BR;;AiGt00BI;EACI,gBAAA;AjGy00BR;;AiG100BI;EACI,iBAAA;AjG600BR;;AiG900BI;EACI,iBAAA;AjGi10BR;;AiGl10BI;EACI,gBAAA;AjGq10BR;;AiGt10BI;EACI,gBAAA;AjGy10BR;;AiG110BI;EACI,gBAAA;AjG610BR;;AiG910BI;EACI,gBAAA;AjGi20BR;;AiGl20BI;EACI,gBAAA;AjGq20BR;;AiGt20BI;EACI,iBAAA;AjGy20BR;;AiG120BI;EACI,gBAAA;AjG620BR;;AiG920BI;EACI,gBAAA;AjGi30BR;;AiGl30BI;EACI,gBAAA;AjGq30BR;;AiGt30BI;EACI,iBAAA;AjGy30BR;;AiG130BI;EACI,gBAAA;AjG630BR;;AiG930BI;EACI,gBAAA;AjGi40BR;;AiGl40BI;EACI,gBAAA;AjGq40BR;;AiGt40BI;EACI,gBAAA;AjGy40BR;;AiG140BI;EACI,gBAAA;AjG640BR;;AiG940BI;EACI,gBAAA;AjGi50BR;;AiGl50BI;EACI,gBAAA;AjGq50BR;;AiGt50BI;EACI,gBAAA;AjGy50BR;;AiG150BI;EACI,gBAAA;AjG650BR;;AiG950BI;EACI,gBAAA;AjGi60BR;;AiGl60BI;EACI,gBAAA;AjGq60BR;;AiGt60BI;EACI,gBAAA;AjGy60BR;;AiG160BI;EACI,iBAAA;AjG660BR;;AiG960BI;EACI,iBAAA;AjGi70BR;;AiGl70BI;EACI,gBAAA;AjGq70BR;;AiGt70BI;EACI,gBAAA;AjGy70BR;;AiG170BI;EACI,gBAAA;AjG670BR;;AiG970BI;EACI,gBAAA;AjGi80BR;;AiGl80BI;EACI,gBAAA;AjGq80BR;;AiGt80BI;EACI,gBAAA;AjGy80BR;;AiG180BI;EACI,gBAAA;AjG680BR;;AiG980BI;EACI,gBAAA;AjGi90BR;;AiGl90BI;EACI,gBAAA;AjGq90BR;;AiGt90BI;EACI,gBAAA;AjGy90BR;;AiG190BI;EACI,gBAAA;AjG690BR;;AiG990BI;EACI,gBAAA;AjGi+0BR;;AiGl+0BI;EACI,gBAAA;AjGq+0BR;;AiGt+0BI;EACI,gBAAA;AjGy+0BR;;AiG1+0BI;EACI,iBAAA;AjG6+0BR;;AiG9+0BI;EACI,iBAAA;AjGi/0BR;;AiGl/0BI;EACI,gBAAA;AjGq/0BR;;AiGt/0BI;EACI,gBAAA;AjGy/0BR;;AiG1/0BI;EACI,gBAAA;AjG6/0BR;;AiG9/0BI;EACI,gBAAA;AjGig1BR;;AiGlg1BI;EACI,gBAAA;AjGqg1BR;;AiGtg1BI;EACI,gBAAA;AjGyg1BR;;AiG1g1BI;EACI,gBAAA;AjG6g1BR;;AiG9g1BI;EACI,gBAAA;AjGih1BR;;AiGlh1BI;EACI,gBAAA;AjGqh1BR;;AiGth1BI;EACI,gBAAA;AjGyh1BR;;AiG1h1BI;EACI,gBAAA;AjG6h1BR;;AiG9h1BI;EACI,gBAAA;AjGii1BR;;AiGli1BI;EACI,gBAAA;AjGqi1BR;;AiGti1BI;EACI,gBAAA;AjGyi1BR;;AiG1i1BI;EACI,gBAAA;AjG6i1BR;;AiG9i1BI;EACI,gBAAA;AjGij1BR;;AiGlj1BI;EACI,iBAAA;AjGqj1BR;;AiGtj1BI;EACI,iBAAA;AjGyj1BR;;AiG1j1BI;EACI,gBAAA;AjG6j1BR;;AiG9j1BI;EACI,gBAAA;AjGik1BR;;AiGlk1BI;EACI,gBAAA;AjGqk1BR;;AiGtk1BI;EACI,gBAAA;AjGyk1BR;;AiG1k1BI;EACI,gBAAA;AjG6k1BR;;AiG9k1BI;EACI,iBAAA;AjGil1BR;;AiGll1BI;EACI,gBAAA;AjGql1BR;;AiGtl1BI;EACI,gBAAA;AjGyl1BR;;AiG1l1BI;EACI,gBAAA;AjG6l1BR;;AiG9l1BI;EACI,gBAAA;AjGim1BR;;AiGlm1BI;EACI,gBAAA;AjGqm1BR;;AiGtm1BI;EACI,gBAAA;AjGym1BR;;AiG1m1BI;EACI,iBAAA;AjG6m1BR;;AiG9m1BI;EACI,gBAAA;AjGin1BR;;AiGln1BI;EACI,iBAAA;AjGqn1BR;;AiGtn1BI;EACI,iBAAA;AjGyn1BR;;AiG1n1BI;EACI,gBAAA;AjG6n1BR;;AiG9n1BI;EACI,gBAAA;AjGio1BR;;AiGlo1BI;EACI,gBAAA;AjGqo1BR;;AiGto1BI;EACI,gBAAA;AjGyo1BR;;AiG1o1BI;EACI,gBAAA;AjG6o1BR;;AiG9o1BI;EACI,gBAAA;AjGip1BR;;AiGlp1BI;EACI,gBAAA;AjGqp1BR;;AiGtp1BI;EACI,gBAAA;AjGyp1BR;;AiG1p1BI;EACI,gBAAA;AjG6p1BR;;AiG9p1BI;EACI,gBAAA;AjGiq1BR;;AiGlq1BI;EACI,gBAAA;AjGqq1BR;;AiGtq1BI;EACI,gBAAA;AjGyq1BR;;AiG1q1BI;EACI,gBAAA;AjG6q1BR;;AiG9q1BI;EACI,iBAAA;AjGir1BR;;AiGlr1BI;EACI,gBAAA;AjGqr1BR;;AiGtr1BI;EACI,gBAAA;AjGyr1BR;;AiG1r1BI;EACI,iBAAA;AjG6r1BR;;AiG9r1BI;EACI,gBAAA;AjGis1BR;;AiGls1BI;EACI,gBAAA;AjGqs1BR;;AiGts1BI;EACI,gBAAA;AjGys1BR;;AiG1s1BI;EACI,gBAAA;AjG6s1BR;;AiG9s1BI;EACI,gBAAA;AjGit1BR;;AiGlt1BI;EACI,gBAAA;AjGqt1BR;;AiGtt1BI;EACI,gBAAA;AjGyt1BR;;AiG1t1BI;EACI,gBAAA;AjG6t1BR;;AiG9t1BI;EACI,gBAAA;AjGiu1BR;;AiGlu1BI;EACI,iBAAA;AjGqu1BR;;AiGtu1BI;EACI,gBAAA;AjGyu1BR;;AiG1u1BI;EACI,gBAAA;AjG6u1BR;;AiG9u1BI;EACI,gBAAA;AjGiv1BR;;AiGlv1BI;EACI,gBAAA;AjGqv1BR;;AiGtv1BI;EACI,gBAAA;AjGyv1BR;;AiG1v1BI;EACI,gBAAA;AjG6v1BR;;AiG9v1BI;EACI,gBAAA;AjGiw1BR;;AiGlw1BI;EACI,gBAAA;AjGqw1BR;;AiGtw1BI;EACI,gBAAA;AjGyw1BR;;AiG1w1BI;EACI,gBAAA;AjG6w1BR;;AiG9w1BI;EACI,gBAAA;AjGix1BR;;AiGlx1BI;EACI,gBAAA;AjGqx1BR;;AiGtx1BI;EACI,gBAAA;AjGyx1BR;;AiG1x1BI;EACI,iBAAA;AjG6x1BR;;AiG9x1BI;EACI,iBAAA;AjGiy1BR;;AiGly1BI;EACI,gBAAA;AjGqy1BR;;AiGty1BI;EACI,gBAAA;AjGyy1BR;;AiG1y1BI;EACI,gBAAA;AjG6y1BR;;AiG9y1BI;EACI,gBAAA;AjGiz1BR;;AiGlz1BI;EACI,gBAAA;AjGqz1BR;;AiGtz1BI;EACI,gBAAA;AjGyz1BR;;AiG1z1BI;EACI,gBAAA;AjG6z1BR;;AiG9z1BI;EACI,gBAAA;AjGi01BR;;AiGl01BI;EACI,gBAAA;AjGq01BR;;AiGt01BI;EACI,iBAAA;AjGy01BR;;AiG101BI;EACI,gBAAA;AjG601BR;;AiG901BI;EACI,gBAAA;AjGi11BR;;AiGl11BI;EACI,gBAAA;AjGq11BR;;AiGt11BI;EACI,gBAAA;AjGy11BR;;AiG111BI;EACI,gBAAA;AjG611BR;;AiG911BI;EACI,gBAAA;AjGi21BR;;AiGl21BI;EACI,gBAAA;AjGq21BR;;AiGt21BI;EACI,gBAAA;AjGy21BR;;AiG121BI;EACI,iBAAA;AjG621BR;;AiG921BI;EACI,iBAAA;AjGi31BR;;AiGl31BI;EACI,gBAAA;AjGq31BR;;AiGt31BI;EACI,gBAAA;AjGy31BR;;AiG131BI;EACI,gBAAA;AjG631BR;;AiG931BI;EACI,iBAAA;AjGi41BR;;AiGl41BI;EACI,iBAAA;AjGq41BR;;AiGt41BI;EACI,gBAAA;AjGy41BR;;AiG141BI;EACI,iBAAA;AjG641BR;;AiG941BI;EACI,gBAAA;AjGi51BR;;AiGl51BI;EACI,gBAAA;AjGq51BR;;AiGt51BI;EACI,gBAAA;AjGy51BR;;AiG151BI;EACI,gBAAA;AjG651BR;;AiG951BI;EACI,gBAAA;AjGi61BR;;AiGl61BI;EACI,gBAAA;AjGq61BR;;AiGt61BI;EACI,gBAAA;AjGy61BR;;AiG161BI;EACI,gBAAA;AjG661BR;;AiG961BI;EACI,gBAAA;AjGi71BR;;AiGl71BI;EACI,gBAAA;AjGq71BR;;AiGt71BI;EACI,gBAAA;AjGy71BR;;AiG171BI;EACI,iBAAA;AjG671BR;;AiG971BI;EACI,iBAAA;AjGi81BR;;AiGl81BI;EACI,gBAAA;AjGq81BR;;AiGt81BI;EACI,gBAAA;AjGy81BR;;AiG181BI;EACI,gBAAA;AjG681BR;;AiG981BI;EACI,iBAAA;AjGi91BR;;AiGl91BI;EACI,iBAAA;AjGq91BR;;AiGt91BI;EACI,gBAAA;AjGy91BR;;AiG191BI;EACI,gBAAA;AjG691BR;;AiG991BI;EACI,gBAAA;AjGi+1BR;;AiGl+1BI;EACI,gBAAA;AjGq+1BR;;AiGt+1BI;EACI,iBAAA;AjGy+1BR;;AiG1+1BI;EACI,iBAAA;AjG6+1BR;;AiG9+1BI;EACI,iBAAA;AjGi/1BR;;AiGl/1BI;EACI,iBAAA;AjGq/1BR;;AiGt/1BI;EACI,iBAAA;AjGy/1BR;;AiG1/1BI;EACI,iBAAA;AjG6/1BR;;AiG9/1BI;EACI,iBAAA;AjGig2BR;;AiGlg2BI;EACI,iBAAA;AjGqg2BR;;AiGtg2BI;EACI,iBAAA;AjGyg2BR;;AiG1g2BI;EACI,iBAAA;AjG6g2BR;;AiG9g2BI;EACI,iBAAA;AjGih2BR;;AiGlh2BI;EACI,iBAAA;AjGqh2BR;;AiGth2BI;EACI,iBAAA;AjGyh2BR;;AiG1h2BI;EACI,iBAAA;AjG6h2BR;;AiG9h2BI;EACI,iBAAA;AjGii2BR;;AiGli2BI;EACI,iBAAA;AjGqi2BR;;AiGti2BI;EACI,iBAAA;AjGyi2BR;;AiG1i2BI;EACI,iBAAA;AjG6i2BR;;AiG9i2BI;EACI,iBAAA;AjGij2BR;;AiGlj2BI;EACI,iBAAA;AjGqj2BR;;AiGtj2BI;EACI,iBAAA;AjGyj2BR;;AiG1j2BI;EACI,iBAAA;AjG6j2BR;;AiG9j2BI;EACI,iBAAA;AjGik2BR;;AiGlk2BI;EACI,iBAAA;AjGqk2BR;;AiGtk2BI;EACI,iBAAA;AjGyk2BR;;AiG1k2BI;EACI,iBAAA;AjG6k2BR;;AiG9k2BI;EACI,iBAAA;AjGil2BR;;AiGll2BI;EACI,iBAAA;AjGql2BR;;AiGtl2BI;EACI,gBAAA;AjGyl2BR;;AiG1l2BI;EACI,gBAAA;AjG6l2BR;;AiG9l2BI;EACI,gBAAA;AjGim2BR;;AiGlm2BI;EACI,gBAAA;AjGqm2BR;;AiGtm2BI;EACI,gBAAA;AjGym2BR;;AiG1m2BI;EACI,gBAAA;AjG6m2BR;;AiG9m2BI;EACI,gBAAA;AjGin2BR;;AiGln2BI;EACI,gBAAA;AjGqn2BR;;AiGtn2BI;EACI,gBAAA;AjGyn2BR;;AiG1n2BI;EACI,gBAAA;AjG6n2BR;;AiG9n2BI;EACI,gBAAA;AjGio2BR;;AiGlo2BI;EACI,gBAAA;AjGqo2BR;;AiGto2BI;EACI,gBAAA;AjGyo2BR;;AiG1o2BI;EACI,gBAAA;AjG6o2BR;;AiG9o2BI;EACI,gBAAA;AjGip2BR;;AiGlp2BI;EACI,gBAAA;AjGqp2BR;;AiGtp2BI;EACI,gBAAA;AjGyp2BR;;AiG1p2BI;EACI,gBAAA;AjG6p2BR;;AiG9p2BI;EACI,gBAAA;AjGiq2BR;;AiGlq2BI;EACI,gBAAA;AjGqq2BR;;AiGtq2BI;EACI,gBAAA;AjGyq2BR;;AiG1q2BI;EACI,gBAAA;AjG6q2BR;;AiG9q2BI;EACI,gBAAA;AjGir2BR;;AiGlr2BI;EACI,gBAAA;AjGqr2BR;;AiGtr2BI;EACI,gBAAA;AjGyr2BR;;AiG1r2BI;EACI,gBAAA;AjG6r2BR;;AiG9r2BI;EACI,gBAAA;AjGis2BR;;AiGls2BI;EACI,gBAAA;AjGqs2BR;;AiGts2BI;EACI,gBAAA;AjGys2BR;;AiG1s2BI;EACI,gBAAA;AjG6s2BR;;AiG9s2BI;EACI,gBAAA;AjGit2BR;;AiGlt2BI;EACI,gBAAA;AjGqt2BR;;AiGtt2BI;EACI,gBAAA;AjGyt2BR;;AiG1t2BI;EACI,iBAAA;AjG6t2BR;;AiG9t2BI;EACI,gBAAA;AjGiu2BR;;AiGlu2BI;EACI,gBAAA;AjGqu2BR;;AiGtu2BI;EACI,iBAAA;AjGyu2BR;;AiG1u2BI;EACI,gBAAA;AjG6u2BR;;AiG9u2BI;EACI,gBAAA;AjGiv2BR;;AiGlv2BI;EACI,gBAAA;AjGqv2BR;;AiGtv2BI;EACI,gBAAA;AjGyv2BR;;AiG1v2BI;EACI,gBAAA;AjG6v2BR;;AiG9v2BI;EACI,gBAAA;AjGiw2BR;;AiGlw2BI;EACI,gBAAA;AjGqw2BR;;AiGtw2BI;EACI,gBAAA;AjGyw2BR;;AiG1w2BI;EACI,gBAAA;AjG6w2BR;;AiG9w2BI;EACI,gBAAA;AjGix2BR;;AiGlx2BI;EACI,gBAAA;AjGqx2BR;;AiGtx2BI;EACI,gBAAA;AjGyx2BR;;AiG1x2BI;EACI,gBAAA;AjG6x2BR;;AiG9x2BI;EACI,gBAAA;AjGiy2BR;;AiGly2BI;EACI,gBAAA;AjGqy2BR;;AiGty2BI;EACI,gBAAA;AjGyy2BR;;AiG1y2BI;EACI,gBAAA;AjG6y2BR;;AiG9y2BI;EACI,gBAAA;AjGiz2BR;;AiGlz2BI;EACI,gBAAA;AjGqz2BR;;AiGtz2BI;EACI,gBAAA;AjGyz2BR;;AiG1z2BI;EACI,gBAAA;AjG6z2BR;;AiG9z2BI;EACI,gBAAA;AjGi02BR;;AiGl02BI;EACI,gBAAA;AjGq02BR;;AiGt02BI;EACI,gBAAA;AjGy02BR;;AiG102BI;EACI,gBAAA;AjG602BR;;AiG902BI;EACI,iBAAA;AjGi12BR;;AiGl12BI;EACI,gBAAA;AjGq12BR;;AiGt12BI;EACI,gBAAA;AjGy12BR;;AiG112BI;EACI,gBAAA;AjG612BR;;AiG912BI;EACI,iBAAA;AjGi22BR;;AiGl22BI;EACI,iBAAA;AjGq22BR;;AiGt22BI;EACI,gBAAA;AjGy22BR;;AiG122BI;EACI,gBAAA;AjG622BR;;AiG922BI;EACI,gBAAA;AjGi32BR;;AiGl32BI;EACI,gBAAA;AjGq32BR;;AiGt32BI;EACI,gBAAA;AjGy32BR;;AiG132BI;EACI,gBAAA;AjG632BR;;AiG932BI;EACI,gBAAA;AjGi42BR;;AiGl42BI;EACI,gBAAA;AjGq42BR;;AiGt42BI;EACI,gBAAA;AjGy42BR;;AiG142BI;EACI,gBAAA;AjG642BR;;AiG942BI;EACI,gBAAA;AjGi52BR;;AiGl52BI;EACI,gBAAA;AjGq52BR;;AiGt52BI;EACI,gBAAA;AjGy52BR;;AiG152BI;EACI,gBAAA;AjG652BR;;AiG952BI;EACI,iBAAA;AjGi62BR;;AiGl62BI;EACI,iBAAA;AjGq62BR;;AiGt62BI;EACI,gBAAA;AjGy62BR;;AiG162BI;EACI,gBAAA;AjG662BR;;AiG962BI;EACI,gBAAA;AjGi72BR;;AiGl72BI;EACI,gBAAA;AjGq72BR;;AiGt72BI;EACI,gBAAA;AjGy72BR;;AiG172BI;EACI,gBAAA;AjG672BR;;AiG972BI;EACI,gBAAA;AjGi82BR;;AiGl82BI;EACI,iBAAA;AjGq82BR;;AiGt82BI;EACI,iBAAA;AjGy82BR;;AiG182BI;EACI,gBAAA;AjG682BR;;AiG982BI;EACI,gBAAA;AjGi92BR;;AiGl92BI;EACI,gBAAA;AjGq92BR;;AiGt92BI;EACI,gBAAA;AjGy92BR;;AiG192BI;EACI,gBAAA;AjG692BR;;AiG992BI;EACI,gBAAA;AjGi+2BR;;AiGl+2BI;EACI,gBAAA;AjGq+2BR;;AiGt+2BI;EACI,iBAAA;AjGy+2BR;;AiG1+2BI;EACI,iBAAA;AjG6+2BR;;AiG9+2BI;EACI,gBAAA;AjGi/2BR;;AiGl/2BI;EACI,iBAAA;AjGq/2BR;;AiGt/2BI;EACI,gBAAA;AjGy/2BR;;AiG1/2BI;EACI,iBAAA;AjG6/2BR;;AiG9/2BI;EACI,gBAAA;AjGig3BR;;AiGlg3BI;EACI,gBAAA;AjGqg3BR;;AiGtg3BI;EACI,gBAAA;AjGyg3BR;;AiG1g3BI;EACI,gBAAA;AjG6g3BR;;AiG9g3BI;EACI,gBAAA;AjGih3BR;;AiGlh3BI;EACI,gBAAA;AjGqh3BR;;AiGth3BI;EACI,gBAAA;AjGyh3BR;;AiG1h3BI;EACI,gBAAA;AjG6h3BR;;AiG9h3BI;EACI,gBAAA;AjGii3BR;;AiGli3BI;EACI,gBAAA;AjGqi3BR;;AiGti3BI;EACI,gBAAA;AjGyi3BR;;AiG1i3BI;EACI,gBAAA;AjG6i3BR;;AiG9i3BI;EACI,gBAAA;AjGij3BR;;AiGlj3BI;EACI,gBAAA;AjGqj3BR;;AiGtj3BI;EACI,gBAAA;AjGyj3BR;;AiG1j3BI;EACI,gBAAA;AjG6j3BR;;AiG9j3BI;EACI,gBAAA;AjGik3BR;;AiGlk3BI;EACI,gBAAA;AjGqk3BR;;AiGtk3BI;EACI,gBAAA;AjGyk3BR;;AiG1k3BI;EACI,gBAAA;AjG6k3BR;;AiG9k3BI;EACI,gBAAA;AjGil3BR;;AiGll3BI;EACI,gBAAA;AjGql3BR;;AiGtl3BI;EACI,gBAAA;AjGyl3BR;;AiG1l3BI;EACI,gBAAA;AjG6l3BR;;AiG9l3BI;EACI,gBAAA;AjGim3BR;;AiGlm3BI;EACI,gBAAA;AjGqm3BR;;AiGtm3BI;EACI,iBAAA;AjGym3BR;;AiG1m3BI;EACI,iBAAA;AjG6m3BR;;AiG9m3BI;EACI,iBAAA;AjGin3BR;;AiGln3BI;EACI,iBAAA;AjGqn3BR;;AiGtn3BI;EACI,gBAAA;AjGyn3BR;;AiG1n3BI;EACI,gBAAA;AjG6n3BR;;AiG9n3BI;EACI,gBAAA;AjGio3BR;;AiGlo3BI;EACI,gBAAA;AjGqo3BR;;AiGto3BI;EACI,iBAAA;AjGyo3BR;;AiG1o3BI;EACI,iBAAA;AjG6o3BR;;AiG9o3BI;EACI,gBAAA;AjGip3BR;;AiGlp3BI;EACI,iBAAA;AjGqp3BR;;AiGtp3BI;EACI,iBAAA;AjGyp3BR;;AiG1p3BI;EACI,iBAAA;AjG6p3BR;;AiG9p3BI;EACI,iBAAA;AjGiq3BR;;AiGlq3BI;EACI,gBAAA;AjGqq3BR;;AiGtq3BI;EACI,iBAAA;AjGyq3BR;;AiG1q3BI;EACI,iBAAA;AjG6q3BR;;AiG9q3BI;EACI,iBAAA;AjGir3BR;;AiGlr3BI;EACI,iBAAA;AjGqr3BR;;AiGtr3BI;EACI,gBAAA;AjGyr3BR;;AiG1r3BI;EACI,gBAAA;AjG6r3BR;;AiG9r3BI;EACI,gBAAA;AjGis3BR;;AiGls3BI;EACI,gBAAA;AjGqs3BR;;AiGts3BI;EACI,gBAAA;AjGys3BR;;AiG1s3BI;EACI,gBAAA;AjG6s3BR;;AiG9s3BI;EACI,gBAAA;AjGit3BR;;AiGlt3BI;EACI,iBAAA;AjGqt3BR;;AiGtt3BI;EACI,iBAAA;AjGyt3BR;;AiG1t3BI;EACI,gBAAA;AjG6t3BR;;AiG9t3BI;EACI,gBAAA;AjGiu3BR;;AiGlu3BI;EACI,gBAAA;AjGqu3BR;;AiGtu3BI;EACI,gBAAA;AjGyu3BR;;AiG1u3BI;EACI,gBAAA;AjG6u3BR;;AiG9u3BI;EACI,gBAAA;AjGiv3BR;;AiGlv3BI;EACI,gBAAA;AjGqv3BR;;AiGtv3BI;EACI,gBAAA;AjGyv3BR;;AiG1v3BI;EACI,gBAAA;AjG6v3BR;;AiG9v3BI;EACI,gBAAA;AjGiw3BR;;AiGlw3BI;EACI,gBAAA;AjGqw3BR;;AiGtw3BI;EACI,gBAAA;AjGyw3BR;;AiG1w3BI;EACI,gBAAA;AjG6w3BR;;AiG9w3BI;EACI,gBAAA;AjGix3BR;;AiGlx3BI;EACI,gBAAA;AjGqx3BR;;AiGtx3BI;EACI,gBAAA;AjGyx3BR;;AiG1x3BI;EACI,iBAAA;AjG6x3BR;;AiG9x3BI;EACI,gBAAA;AjGiy3BR;;AiGly3BI;EACI,gBAAA;AjGqy3BR;;AiGty3BI;EACI,gBAAA;AjGyy3BR;;AiG1y3BI;EACI,gBAAA;AjG6y3BR;;AiG9y3BI;EACI,gBAAA;AjGiz3BR;;AiGlz3BI;EACI,gBAAA;AjGqz3BR;;AiGtz3BI;EACI,gBAAA;AjGyz3BR;;AiG1z3BI;EACI,gBAAA;AjG6z3BR;;AiG9z3BI;EACI,gBAAA;AjGi03BR;;AiGl03BI;EACI,gBAAA;AjGq03BR;;AiGt03BI;EACI,iBAAA;AjGy03BR;;AiG103BI;EACI,gBAAA;AjG603BR;;AiG903BI;EACI,iBAAA;AjGi13BR;;AiGl13BI;EACI,iBAAA;AjGq13BR;;AiGt13BI;EACI,iBAAA;AjGy13BR;;AiG113BI;EACI,gBAAA;AjG613BR;;AiG913BI;EACI,gBAAA;AjGi23BR;;AiGl23BI;EACI,iBAAA;AjGq23BR;;AiGt23BI;EACI,gBAAA;AjGy23BR;;AiG123BI;EACI,gBAAA;AjG623BR;;AiG923BI;EACI,gBAAA;AjGi33BR;;AiGl33BI;EACI,gBAAA;AjGq33BR;;AiGt33BI;EACI,gBAAA;AjGy33BR;;AiG133BI;EACI,gBAAA;AjG633BR;;AiG933BI;EACI,gBAAA;AjGi43BR;;AiGl43BI;EACI,iBAAA;AjGq43BR;;AiGt43BI;EACI,gBAAA;AjGy43BR;;AiG143BI;EACI,gBAAA;AjG643BR;;AiG943BI;EACI,gBAAA;AjGi53BR;;AiGl53BI;EACI,iBAAA;AjGq53BR;;AiGt53BI;EACI,gBAAA;AjGy53BR;;AiG153BI;EACI,gBAAA;AjG653BR;;AiG953BI;EACI,gBAAA;AjGi63BR;;AiGl63BI;EACI,gBAAA;AjGq63BR;;AiGt63BI;EACI,gBAAA;AjGy63BR;;AiG163BI;EACI,iBAAA;AjG663BR;;AiG963BI;EACI,gBAAA;AjGi73BR;;AiGl73BI;EACI,iBAAA;AjGq73BR;;AiGt73BI;EACI,gBAAA;AjGy73BR;;AiG173BI;EACI,gBAAA;AjG673BR;;AiG973BI;EACI,gBAAA;AjGi83BR;;AiGl83BI;EACI,gBAAA;AjGq83BR;;AiGt83BI;EACI,gBAAA;AjGy83BR;;AiG183BI;EACI,gBAAA;AjG683BR;;AiG983BI;EACI,gBAAA;AjGi93BR;;AiGl93BI;EACI,gBAAA;AjGq93BR;;AiGt93BI;EACI,gBAAA;AjGy93BR;;AiG193BI;EACI,iBAAA;AjG693BR;;AiG993BI;EACI,gBAAA;AjGi+3BR;;AiGl+3BI;EACI,gBAAA;AjGq+3BR;;AiGt+3BI;EACI,gBAAA;AjGy+3BR;;AiG1+3BI;EACI,gBAAA;AjG6+3BR;;AiG9+3BI;EACI,iBAAA;AjGi/3BR;;AiGl/3BI;EACI,iBAAA;AjGq/3BR;;AiGt/3BI;EACI,iBAAA;AjGy/3BR;;AiG1/3BI;EACI,iBAAA;AjG6/3BR;;AiG9/3BI;EACI,gBAAA;AjGig4BR;;AiGlg4BI;EACI,iBAAA;AjGqg4BR;;AiGtg4BI;EACI,iBAAA;AjGyg4BR;;AiG1g4BI;EACI,iBAAA;AjG6g4BR;;AiG9g4BI;EACI,gBAAA;AjGih4BR;;AiGlh4BI;EACI,iBAAA;AjGqh4BR;;AiGth4BI;EACI,gBAAA;AjGyh4BR;;AiG1h4BI;EACI,iBAAA;AjG6h4BR;;AiG9h4BI;EACI,gBAAA;AjGii4BR;;AiGli4BI;EACI,gBAAA;AjGqi4BR;;AiGti4BI;EACI,gBAAA;AjGyi4BR;;AiG1i4BI;EACI,gBAAA;AjG6i4BR;;AiG9i4BI;EACI,iBAAA;AjGij4BR;;AiGlj4BI;EACI,gBAAA;AjGqj4BR;;AiGtj4BI;EACI,gBAAA;AjGyj4BR;;AiG1j4BI;EACI,gBAAA;AjG6j4BR;;AiG9j4BI;EACI,gBAAA;AjGik4BR;;AiGlk4BI;EACI,gBAAA;AjGqk4BR;;AiGtk4BI;EACI,gBAAA;AjGyk4BR;;AiG1k4BI;EACI,iBAAA;AjG6k4BR;;AiG9k4BI;EACI,iBAAA;AjGil4BR;;AiGll4BI;EACI,iBAAA;AjGql4BR;;AiGtl4BI;EACI,iBAAA;AjGyl4BR;;AiG1l4BI;EACI,iBAAA;AjG6l4BR;;AiG9l4BI;EACI,iBAAA;AjGim4BR;;AiGlm4BI;EACI,iBAAA;AjGqm4BR;;AiGtm4BI;EACI,iBAAA;AjGym4BR;;AiG1m4BI;EACI,iBAAA;AjG6m4BR;;AiG9m4BI;EACI,iBAAA;AjGin4BR;;AiGln4BI;EACI,iBAAA;AjGqn4BR;;AiGtn4BI;EACI,iBAAA;AjGyn4BR;;AiG1n4BI;EACI,iBAAA;AjG6n4BR;;AiG9n4BI;EACI,gBAAA;AjGio4BR;;AiGlo4BI;EACI,gBAAA;AjGqo4BR;;AiGto4BI;EACI,gBAAA;AjGyo4BR;;AiG1o4BI;EACI,gBAAA;AjG6o4BR;;AiG9o4BI;EACI,gBAAA;AjGip4BR;;AiGlp4BI;EACI,gBAAA;AjGqp4BR;;AiGtp4BI;EACI,iBAAA;AjGyp4BR;;AiG1p4BI;EACI,gBAAA;AjG6p4BR;;AiG9p4BI;EACI,gBAAA;AjGiq4BR;;AiGlq4BI;EACI,iBAAA;AjGqq4BR;;AiGtq4BI;EACI,gBAAA;AjGyq4BR;;AiG1q4BI;EACI,iBAAA;AjG6q4BR;;AiG9q4BI;EACI,gBAAA;AjGir4BR;;AiGlr4BI;EACI,gBAAA;AjGqr4BR;;AiGtr4BI;EACI,gBAAA;AjGyr4BR;;AiG1r4BI;EACI,iBAAA;AjG6r4BR;;AiG9r4BI;EACI,iBAAA;AjGis4BR;;AiGls4BI;EACI,gBAAA;AjGqs4BR;;AiGts4BI;EACI,iBAAA;AjGys4BR;;AiG1s4BI;EACI,iBAAA;AjG6s4BR;;AiG9s4BI;EACI,gBAAA;AjGit4BR;;AiGlt4BI;EACI,gBAAA;AjGqt4BR;;AiGtt4BI;EACI,gBAAA;AjGyt4BR;;AiG1t4BI;EACI,iBAAA;AjG6t4BR;;AiG9t4BI;EACI,iBAAA;AjGiu4BR;;AiGlu4BI;EACI,gBAAA;AjGqu4BR;;AiGtu4BI;EACI,gBAAA;AjGyu4BR;;AiG1u4BI;EACI,gBAAA;AjG6u4BR;;AiG9u4BI;EACI,gBAAA;AjGiv4BR;;AiGlv4BI;EACI,gBAAA;AjGqv4BR;;AiGtv4BI;EACI,gBAAA;AjGyv4BR;;AiG1v4BI;EACI,iBAAA;AjG6v4BR;;AiG9v4BI;EACI,gBAAA;AjGiw4BR;;AiGlw4BI;EACI,gBAAA;AjGqw4BR;;AiGtw4BI;EACI,gBAAA;AjGyw4BR;;AiG1w4BI;EACI,gBAAA;AjG6w4BR;;AiG9w4BI;EACI,gBAAA;AjGix4BR;;AiGlx4BI;EACI,gBAAA;AjGqx4BR;;AiGtx4BI;EACI,gBAAA;AjGyx4BR;;AiG1x4BI;EACI,iBAAA;AjG6x4BR;;AiG9x4BI;EACI,gBAAA;AjGiy4BR;;AiGly4BI;EACI,gBAAA;AjGqy4BR;;AiGty4BI;EACI,gBAAA;AjGyy4BR;;AiG1y4BI;EACI,gBAAA;AjG6y4BR;;AiG9y4BI;EACI,gBAAA;AjGiz4BR;;AiGlz4BI;EACI,gBAAA;AjGqz4BR;;AiGtz4BI;EACI,gBAAA;AjGyz4BR;;AiG1z4BI;EACI,gBAAA;AjG6z4BR;;AiG9z4BI;EACI,gBAAA;AjGi04BR;;AiGl04BI;EACI,gBAAA;AjGq04BR;;AiGt04BI;EACI,gBAAA;AjGy04BR;;AiG104BI;EACI,gBAAA;AjG604BR;;AiG904BI;EACI,gBAAA;AjGi14BR;;AiGl14BI;EACI,gBAAA;AjGq14BR;;AiGt14BI;EACI,gBAAA;AjGy14BR;;AiG114BI;EACI,gBAAA;AjG614BR;;AiG914BI;EACI,gBAAA;AjGi24BR;;AiGl24BI;EACI,gBAAA;AjGq24BR;;AiGt24BI;EACI,gBAAA;AjGy24BR;;AiG124BI;EACI,gBAAA;AjG624BR;;AiG924BI;EACI,gBAAA;AjGi34BR;;AiGl34BI;EACI,gBAAA;AjGq34BR;;AiGt34BI;EACI,gBAAA;AjGy34BR;;AiG134BI;EACI,gBAAA;AjG634BR;;AiG934BI;EACI,gBAAA;AjGi44BR;;AiGl44BI;EACI,gBAAA;AjGq44BR;;AiGt44BI;EACI,gBAAA;AjGy44BR;;AiG144BI;EACI,gBAAA;AjG644BR;;AiG944BI;EACI,gBAAA;AjGi54BR;;AiGl54BI;EACI,gBAAA;AjGq54BR;;AiGt54BI;EACI,gBAAA;AjGy54BR;;AiG154BI;EACI,gBAAA;AjG654BR;;AiG954BI;EACI,iBAAA;AjGi64BR;;AiGl64BI;EACI,iBAAA;AjGq64BR;;AiGt64BI;EACI,gBAAA;AjGy64BR;;AiG164BI;EACI,gBAAA;AjG664BR;;AiG964BI;EACI,gBAAA;AjGi74BR;;AiGl74BI;EACI,gBAAA;AjGq74BR;;AiGt74BI;EACI,gBAAA;AjGy74BR;;AiG174BI;EACI,iBAAA;AjG674BR;;AiG974BI;EACI,iBAAA;AjGi84BR;;AiGl84BI;EACI,gBAAA;AjGq84BR;;AiGt84BI;EACI,gBAAA;AjGy84BR;;AiG184BI;EACI,gBAAA;AjG684BR;;AiG984BI;EACI,gBAAA;AjGi94BR;;AiGl94BI;EACI,gBAAA;AjGq94BR;;AiGt94BI;EACI,gBAAA;AjGy94BR;;AiG194BI;EACI,iBAAA;AjG694BR;;AiG994BI;EACI,gBAAA;AjGi+4BR;;AiGl+4BI;EACI,gBAAA;AjGq+4BR;;AiGt+4BI;EACI,gBAAA;AjGy+4BR;;AiG1+4BI;EACI,iBAAA;AjG6+4BR;;AiG9+4BI;EACI,gBAAA;AjGi/4BR;;AiGl/4BI;EACI,gBAAA;AjGq/4BR;;AiGt/4BI;EACI,gBAAA;AjGy/4BR;;AiG1/4BI;EACI,gBAAA;AjG6/4BR;;AiG9/4BI;EACI,gBAAA;AjGig5BR;;AiGlg5BI;EACI,gBAAA;AjGqg5BR;;AiGtg5BI;EACI,gBAAA;AjGyg5BR;;AiG1g5BI;EACI,gBAAA;AjG6g5BR;;AiG9g5BI;EACI,gBAAA;AjGih5BR;;AiGlh5BI;EACI,gBAAA;AjGqh5BR;;AiGth5BI;EACI,gBAAA;AjGyh5BR;;AiG1h5BI;EACI,gBAAA;AjG6h5BR;;AiG9h5BI;EACI,gBAAA;AjGii5BR;;AiGli5BI;EACI,iBAAA;AjGqi5BR;;AiGti5BI;EACI,iBAAA;AjGyi5BR;;AiG1i5BI;EACI,iBAAA;AjG6i5BR;;AiG9i5BI;EACI,iBAAA;AjGij5BR;;AiGlj5BI;EACI,iBAAA;AjGqj5BR;;AiGtj5BI;EACI,iBAAA;AjGyj5BR;;AiG1j5BI;EACI,iBAAA;AjG6j5BR;;AiG9j5BI;EACI,iBAAA;AjGik5BR;;AiGlk5BI;EACI,iBAAA;AjGqk5BR;;AiGtk5BI;EACI,iBAAA;AjGyk5BR;;AiG1k5BI;EACI,iBAAA;AjG6k5BR;;AiG9k5BI;EACI,iBAAA;AjGil5BR;;AiGll5BI;EACI,gBAAA;AjGql5BR;;AiGtl5BI;EACI,gBAAA;AjGyl5BR;;AiG1l5BI;EACI,gBAAA;AjG6l5BR;;AiG9l5BI;EACI,gBAAA;AjGim5BR;;AiGlm5BI;EACI,gBAAA;AjGqm5BR;;AiGtm5BI;EACI,gBAAA;AjGym5BR;;AiG1m5BI;EACI,gBAAA;AjG6m5BR;;AiG9m5BI;EACI,gBAAA;AjGin5BR;;AiGln5BI;EACI,gBAAA;AjGqn5BR;;AiGtn5BI;EACI,gBAAA;AjGyn5BR;;AiG1n5BI;EACI,gBAAA;AjG6n5BR;;AiG9n5BI;EACI,gBAAA;AjGio5BR;;AiGlo5BI;EACI,iBAAA;AjGqo5BR;;AiGto5BI;EACI,gBAAA;AjGyo5BR;;AiG1o5BI;EACI,gBAAA;AjG6o5BR;;AiG9o5BI;EACI,gBAAA;AjGip5BR;;AiGlp5BI;EACI,iBAAA;AjGqp5BR;;AiGtp5BI;EACI,gBAAA;AjGyp5BR;;AiG1p5BI;EACI,iBAAA;AjG6p5BR;;AiG9p5BI;EACI,iBAAA;AjGiq5BR;;AiGlq5BI;EACI,gBAAA;AjGqq5BR;;AiGtq5BI;EACI,gBAAA;AjGyq5BR;;AiG1q5BI;EACI,gBAAA;AjG6q5BR;;AiG9q5BI;EACI,gBAAA;AjGir5BR;;AiGlr5BI;EACI,gBAAA;AjGqr5BR;;AiGtr5BI;EACI,gBAAA;AjGyr5BR;;AiG1r5BI;EACI,gBAAA;AjG6r5BR;;AiG9r5BI;EACI,gBAAA;AjGis5BR;;AiGls5BI;EACI,gBAAA;AjGqs5BR;;AiGts5BI;EACI,gBAAA;AjGys5BR;;AiG1s5BI;EACI,gBAAA;AjG6s5BR;;AiG9s5BI;EACI,gBAAA;AjGit5BR;;AiGlt5BI;EACI,gBAAA;AjGqt5BR;;AiGtt5BI;EACI,gBAAA;AjGyt5BR;;AiG1t5BI;EACI,gBAAA;AjG6t5BR;;AiG9t5BI;EACI,gBAAA;AjGiu5BR;;AiGlu5BI;EACI,gBAAA;AjGqu5BR;;AiGtu5BI;EACI,gBAAA;AjGyu5BR;;AiG1u5BI;EACI,gBAAA;AjG6u5BR;;AiG9u5BI;EACI,gBAAA;AjGiv5BR;;AiGlv5BI;EACI,gBAAA;AjGqv5BR;;AiGtv5BI;EACI,gBAAA;AjGyv5BR;;AiG1v5BI;EACI,gBAAA;AjG6v5BR;;AiG9v5BI;EACI,gBAAA;AjGiw5BR;;AiGlw5BI;EACI,gBAAA;AjGqw5BR;;AiGtw5BI;EACI,gBAAA;AjGyw5BR;;AiG1w5BI;EACI,gBAAA;AjG6w5BR;;AiG9w5BI;EACI,gBAAA;AjGix5BR;;AiGlx5BI;EACI,gBAAA;AjGqx5BR;;AiGtx5BI;EACI,gBAAA;AjGyx5BR;;AiG1x5BI;EACI,gBAAA;AjG6x5BR;;AiG9x5BI;EACI,iBAAA;AjGiy5BR;;AiGly5BI;EACI,gBAAA;AjGqy5BR;;AiGty5BI;EACI,gBAAA;AjGyy5BR;;AiG1y5BI;EACI,gBAAA;AjG6y5BR;;AiG9y5BI;EACI,gBAAA;AjGiz5BR;;AiGlz5BI;EACI,gBAAA;AjGqz5BR;;AiGtz5BI;EACI,gBAAA;AjGyz5BR;;AiG1z5BI;EACI,gBAAA;AjG6z5BR;;AiG9z5BI;EACI,gBAAA;AjGi05BR;;AiGl05BI;EACI,gBAAA;AjGq05BR;;AiGt05BI;EACI,gBAAA;AjGy05BR;;AiG105BI;EACI,gBAAA;AjG605BR;;AiG905BI;EACI,iBAAA;AjGi15BR;;AiGl15BI;EACI,iBAAA;AjGq15BR;;AiGt15BI;EACI,iBAAA;AjGy15BR;;AiG115BI;EACI,gBAAA;AjG615BR;;AiG915BI;EACI,gBAAA;AjGi25BR;;AiGl25BI;EACI,gBAAA;AjGq25BR;;AiGt25BI;EACI,gBAAA;AjGy25BR;;AiG125BI;EACI,gBAAA;AjG625BR;;AiG925BI;EACI,gBAAA;AjGi35BR;;AiGl35BI;EACI,gBAAA;AjGq35BR;;AiGt35BI;EACI,gBAAA;AjGy35BR;;AiG135BI;EACI,gBAAA;AjG635BR;;AiG935BI;EACI,gBAAA;AjGi45BR;;AiGl45BI;EACI,gBAAA;AjGq45BR;;AiGt45BI;EACI,gBAAA;AjGy45BR;;AiG145BI;EACI,gBAAA;AjG645BR;;AiG945BI;EACI,gBAAA;AjGi55BR;;AiGl55BI;EACI,gBAAA;AjGq55BR;;AiGt55BI;EACI,gBAAA;AjGy55BR;;AiG155BI;EACI,gBAAA;AjG655BR;;AiG955BI;EACI,gBAAA;AjGi65BR;;AiGl65BI;EACI,gBAAA;AjGq65BR;;AiGt65BI;EACI,gBAAA;AjGy65BR;;AiG165BI;EACI,iBAAA;AjG665BR;;AiG965BI;EACI,gBAAA;AjGi75BR;;AiGl75BI;EACI,gBAAA;AjGq75BR;;AiGt75BI;EACI,iBAAA;AjGy75BR;;AiG175BI;EACI,iBAAA;AjG675BR;;AiG975BI;EACI,iBAAA;AjGi85BR;;AiGl85BI;EACI,gBAAA;AjGq85BR;;AiGt85BI;EACI,iBAAA;AjGy85BR;;AiG185BI;EACI,gBAAA;AjG685BR;;AiG985BI;EACI,iBAAA;AjGi95BR;;AiGl95BI;EACI,gBAAA;AjGq95BR;;AiGt95BI;EACI,iBAAA;AjGy95BR;;AiG195BI;EACI,gBAAA;AjG695BR;;AiG995BI;EACI,gBAAA;AjGi+5BR;;AiGl+5BI;EACI,gBAAA;AjGq+5BR;;AiGt+5BI;EACI,iBAAA;AjGy+5BR;;AiG1+5BI;EACI,gBAAA;AjG6+5BR;;AiG9+5BI;EACI,gBAAA;AjGi/5BR;;AiGl/5BI;EACI,gBAAA;AjGq/5BR;;AiGt/5BI;EACI,iBAAA;AjGy/5BR;;AiG1/5BI;EACI,gBAAA;AjG6/5BR;;AiG9/5BI;EACI,iBAAA;AjGig6BR;;AiGlg6BI;EACI,gBAAA;AjGqg6BR;;AiGtg6BI;EACI,iBAAA;AjGyg6BR;;AiG1g6BI;EACI,iBAAA;AjG6g6BR;;AiG9g6BI;EACI,iBAAA;AjGih6BR;;AiGlh6BI;EACI,gBAAA;AjGqh6BR;;AiGth6BI;EACI,gBAAA;AjGyh6BR;;AiG1h6BI;EACI,gBAAA;AjG6h6BR;;AiG9h6BI;EACI,gBAAA;AjGii6BR;;AiGli6BI;EACI,gBAAA;AjGqi6BR;;AiGti6BI;EACI,gBAAA;AjGyi6BR;;AiG1i6BI;EACI,gBAAA;AjG6i6BR;;AiG9i6BI;EACI,gBAAA;AjGij6BR;;AiGlj6BI;EACI,gBAAA;AjGqj6BR;;AiGtj6BI;EACI,gBAAA;AjGyj6BR;;AiG1j6BI;EACI,gBAAA;AjG6j6BR;;AiG9j6BI;EACI,gBAAA;AjGik6BR;;AiGlk6BI;EACI,gBAAA;AjGqk6BR;;AiGtk6BI;EACI,gBAAA;AjGyk6BR;;AiG1k6BI;EACI,gBAAA;AjG6k6BR;;AiG9k6BI;EACI,gBAAA;AjGil6BR;;AiGll6BI;EACI,gBAAA;AjGql6BR;;AiGtl6BI;EACI,gBAAA;AjGyl6BR;;AiG1l6BI;EACI,gBAAA;AjG6l6BR;;AiG9l6BI;EACI,gBAAA;AjGim6BR;;AiGlm6BI;EACI,iBAAA;AjGqm6BR;;AiGtm6BI;EACI,gBAAA;AjGym6BR;;AiG1m6BI;EACI,gBAAA;AjG6m6BR;;AiG9m6BI;EACI,gBAAA;AjGin6BR;;AiGln6BI;EACI,gBAAA;AjGqn6BR;;AiGtn6BI;EACI,gBAAA;AjGyn6BR;;AiG1n6BI;EACI,gBAAA;AjG6n6BR;;AiG9n6BI;EACI,iBAAA;AjGio6BR;;AiGlo6BI;EACI,gBAAA;AjGqo6BR;;AiGto6BI;EACI,iBAAA;AjGyo6BR;;AiG1o6BI;EACI,gBAAA;AjG6o6BR;;AiG9o6BI;EACI,gBAAA;AjGip6BR;;AiGlp6BI;EACI,gBAAA;AjGqp6BR;;AiGtp6BI;EACI,gBAAA;AjGyp6BR;;AiG1p6BI;EACI,gBAAA;AjG6p6BR;;AiG9p6BI;EACI,gBAAA;AjGiq6BR;;AiGlq6BI;EACI,gBAAA;AjGqq6BR;;AiGtq6BI;EACI,gBAAA;AjGyq6BR;;AiG1q6BI;EACI,gBAAA;AjG6q6BR;;AiG9q6BI;EACI,gBAAA;AjGir6BR;;AiGlr6BI;EACI,gBAAA;AjGqr6BR;;AiGtr6BI;EACI,gBAAA;AjGyr6BR;;AiG1r6BI;EACI,gBAAA;AjG6r6BR;;AiG9r6BI;EACI,gBAAA;AjGis6BR;;AiGls6BI;EACI,gBAAA;AjGqs6BR;;AiGts6BI;EACI,gBAAA;AjGys6BR;;AiG1s6BI;EACI,gBAAA;AjG6s6BR;;AiG9s6BI;EACI,gBAAA;AjGit6BR;;AiGlt6BI;EACI,gBAAA;AjGqt6BR;;AiGtt6BI;EACI,iBAAA;AjGyt6BR;;AiG1t6BI;EACI,iBAAA;AjG6t6BR;;AiG9t6BI;EACI,iBAAA;AjGiu6BR;;AiGlu6BI;EACI,iBAAA;AjGqu6BR;;AiGtu6BI;EACI,gBAAA;AjGyu6BR;;AiG1u6BI;EACI,gBAAA;AjG6u6BR;;AiG9u6BI;EACI,gBAAA;AjGiv6BR;;AiGlv6BI;EACI,gBAAA;AjGqv6BR;;AiGtv6BI;EACI,iBAAA;AjGyv6BR;;AiG1v6BI;EACI,gBAAA;AjG6v6BR;;AiG9v6BI;EACI,iBAAA;AjGiw6BR;;AiGlw6BI;EACI,iBAAA;AjGqw6BR;;AiGtw6BI;EACI,iBAAA;AjGyw6BR;;AiG1w6BI;EACI,gBAAA;AjG6w6BR;;AiG9w6BI;EACI,gBAAA;AjGix6BR;;AiGlx6BI;EACI,iBAAA;AjGqx6BR;;AiGtx6BI;EACI,gBAAA;AjGyx6BR;;AiG1x6BI;EACI,iBAAA;AjG6x6BR;;AiG9x6BI;EACI,gBAAA;AjGiy6BR;;AiGly6BI;EACI,gBAAA;AjGqy6BR;;AiGty6BI;EACI,gBAAA;AjGyy6BR;;AiG1y6BI;EACI,iBAAA;AjG6y6BR;;AiG9y6BI;EACI,gBAAA;AjGiz6BR;;AiGlz6BI;EACI,iBAAA;AjGqz6BR;;AiGtz6BI;EACI,gBAAA;AjGyz6BR;;AiG1z6BI;EACI,iBAAA;AjG6z6BR;;AiG9z6BI;EACI,iBAAA;AjGi06BR;;AiGl06BI;EACI,gBAAA;AjGq06BR;;AiGt06BI;EACI,iBAAA;AjGy06BR;;AiG106BI;EACI,gBAAA;AjG606BR;;AiG906BI;EACI,gBAAA;AjGi16BR;;AiGl16BI;EACI,gBAAA;AjGq16BR;;AiGt16BI;EACI,gBAAA;AjGy16BR;;AiG116BI;EACI,gBAAA;AjG616BR;;AiG916BI;EACI,gBAAA;AjGi26BR;;AiGl26BI;EACI,gBAAA;AjGq26BR;;AiGt26BI;EACI,gBAAA;AjGy26BR;;AiG126BI;EACI,gBAAA;AjG626BR;;AiG926BI;EACI,gBAAA;AjGi36BR;;AiGl36BI;EACI,gBAAA;AjGq36BR;;AiGt36BI;EACI,gBAAA;AjGy36BR;;AiG136BI;EACI,gBAAA;AjG636BR;;AiG936BI;EACI,gBAAA;AjGi46BR;;AiGl46BI;EACI,gBAAA;AjGq46BR;;AiGt46BI;EACI,gBAAA;AjGy46BR;;AiG146BI;EACI,gBAAA;AjG646BR;;AiG946BI;EACI,gBAAA;AjGi56BR;;AiGl56BI;EACI,gBAAA;AjGq56BR;;AiGt56BI;EACI,gBAAA;AjGy56BR;;AiG156BI;EACI,gBAAA;AjG656BR;;AiG956BI;EACI,gBAAA;AjGi66BR;;AiGl66BI;EACI,gBAAA;AjGq66BR;;AiGt66BI;EACI,gBAAA;AjGy66BR;;AiG166BI;EACI,gBAAA;AjG666BR;;AiG966BI;EACI,gBAAA;AjGi76BR;;AiGl76BI;EACI,gBAAA;AjGq76BR;;AiGt76BI;EACI,gBAAA;AjGy76BR;;AiG176BI;EACI,iBAAA;AjG676BR;;AiG976BI;EACI,iBAAA;AjGi86BR;;AiGl86BI;EACI,gBAAA;AjGq86BR;;AiGt86BI;EACI,gBAAA;AjGy86BR;;AiG186BI;EACI,gBAAA;AjG686BR;;AiG986BI;EACI,gBAAA;AjGi96BR;;AiGl96BI;EACI,gBAAA;AjGq96BR;;AiGt96BI;EACI,iBAAA;AjGy96BR;;AiG196BI;EACI,gBAAA;AjG696BR;;AiG996BI;EACI,gBAAA;AjGi+6BR;;AiGl+6BI;EACI,gBAAA;AjGq+6BR;;AiGt+6BI;EACI,gBAAA;AjGy+6BR;;AiG1+6BI;EACI,gBAAA;AjG6+6BR;;AiG9+6BI;EACI,gBAAA;AjGi/6BR;;AiGl/6BI;EACI,gBAAA;AjGq/6BR;;AiGt/6BI;EACI,gBAAA;AjGy/6BR;;AiG1/6BI;EACI,iBAAA;AjG6/6BR;;AiG9/6BI;EACI,gBAAA;AjGig7BR;;AiGlg7BI;EACI,iBAAA;AjGqg7BR;;AiGtg7BI;EACI,gBAAA;AjGyg7BR;;AiG1g7BI;EACI,gBAAA;AjG6g7BR;;AiG9g7BI;EACI,gBAAA;AjGih7BR;;AiGlh7BI;EACI,gBAAA;AjGqh7BR;;AiGth7BI;EACI,gBAAA;AjGyh7BR;;AiG1h7BI;EACI,gBAAA;AjG6h7BR;;AiG9h7BI;EACI,gBAAA;AjGii7BR;;AiGli7BI;EACI,gBAAA;AjGqi7BR;;AiGti7BI;EACI,gBAAA;AjGyi7BR;;AiG1i7BI;EACI,gBAAA;AjG6i7BR;;AiG9i7BI;EACI,gBAAA;AjGij7BR;;AiGlj7BI;EACI,gBAAA;AjGqj7BR;;AiGtj7BI;EACI,gBAAA;AjGyj7BR;;AiG1j7BI;EACI,gBAAA;AjG6j7BR;;AiG9j7BI;EACI,gBAAA;AjGik7BR;;AiGlk7BI;EACI,iBAAA;AjGqk7BR;;AiGtk7BI;EACI,gBAAA;AjGyk7BR;;AiG1k7BI;EACI,iBAAA;AjG6k7BR;;AiG9k7BI;EACI,gBAAA;AjGil7BR;;AiGll7BI;EACI,gBAAA;AjGql7BR;;AiGtl7BI;EACI,gBAAA;AjGyl7BR;;AiG1l7BI;EACI,gBAAA;AjG6l7BR;;AiG9l7BI;EACI,gBAAA;AjGim7BR;;AiGlm7BI;EACI,gBAAA;AjGqm7BR;;AiGtm7BI;EACI,gBAAA;AjGym7BR;;AiG1m7BI;EACI,gBAAA;AjG6m7BR;;AiG9m7BI;EACI,gBAAA;AjGin7BR;;AiGln7BI;EACI,gBAAA;AjGqn7BR;;AiGtn7BI;EACI,gBAAA;AjGyn7BR;;AiG1n7BI;EACI,iBAAA;AjG6n7BR;;AiG9n7BI;EACI,iBAAA;AjGio7BR;;AiGlo7BI;EACI,iBAAA;AjGqo7BR;;AiGto7BI;EACI,iBAAA;AjGyo7BR;;AiG1o7BI;EACI,gBAAA;AjG6o7BR;;AiG9o7BI;EACI,gBAAA;AjGip7BR;;AiGlp7BI;EACI,gBAAA;AjGqp7BR;;AiGtp7BI;EACI,gBAAA;AjGyp7BR;;AiG1p7BI;EACI,iBAAA;AjG6p7BR;;AiG9p7BI;EACI,iBAAA;AjGiq7BR;;AiGlq7BI;EACI,gBAAA;AjGqq7BR;;AiGtq7BI;EACI,gBAAA;AjGyq7BR;;AiG1q7BI;EACI,gBAAA;AjG6q7BR;;AiG9q7BI;EACI,gBAAA;AjGir7BR;;AiGlr7BI;EACI,gBAAA;AjGqr7BR;;AiGtr7BI;EACI,gBAAA;AjGyr7BR;;AiG1r7BI;EACI,gBAAA;AjG6r7BR;;AiG9r7BI;EACI,gBAAA;AjGis7BR;;AiGls7BI;EACI,gBAAA;AjGqs7BR;;AiGts7BI;EACI,gBAAA;AjGys7BR;;AiG1s7BI;EACI,gBAAA;AjG6s7BR;;AiG9s7BI;EACI,gBAAA;AjGit7BR;;AiGlt7BI;EACI,gBAAA;AjGqt7BR;;AiGtt7BI;EACI,gBAAA;AjGyt7BR;;AiG1t7BI;EACI,gBAAA;AjG6t7BR;;AiG9t7BI;EACI,gBAAA;AjGiu7BR;;AiGlu7BI;EACI,gBAAA;AjGqu7BR;;AiGtu7BI;EACI,gBAAA;AjGyu7BR;;AiG1u7BI;EACI,gBAAA;AjG6u7BR;;AiG9u7BI;EACI,gBAAA;AjGiv7BR;;AiGlv7BI;EACI,gBAAA;AjGqv7BR;;AiGtv7BI;EACI,gBAAA;AjGyv7BR;;AiG1v7BI;EACI,gBAAA;AjG6v7BR;;AiG9v7BI;EACI,gBAAA;AjGiw7BR;;AiGlw7BI;EACI,gBAAA;AjGqw7BR;;AiGtw7BI;EACI,gBAAA;AjGyw7BR;;AiG1w7BI;EACI,gBAAA;AjG6w7BR;;AiG9w7BI;EACI,gBAAA;AjGix7BR;;AiGlx7BI;EACI,gBAAA;AjGqx7BR;;AiGtx7BI;EACI,gBAAA;AjGyx7BR;;AiG1x7BI;EACI,gBAAA;AjG6x7BR;;AiG9x7BI;EACI,gBAAA;AjGiy7BR;;AiGly7BI;EACI,gBAAA;AjGqy7BR;;AiGty7BI;EACI,gBAAA;AjGyy7BR;;AiG1y7BI;EACI,gBAAA;AjG6y7BR;;AiG9y7BI;EACI,gBAAA;AjGiz7BR;;AiGlz7BI;EACI,gBAAA;AjGqz7BR;;AiGtz7BI;EACI,gBAAA;AjGyz7BR;;AiG1z7BI;EACI,gBAAA;AjG6z7BR;;AiG9z7BI;EACI,gBAAA;AjGi07BR;;AiGl07BI;EACI,gBAAA;AjGq07BR;;AiGt07BI;EACI,gBAAA;AjGy07BR;;AiG107BI;EACI,gBAAA;AjG607BR;;AiG907BI;EACI,gBAAA;AjGi17BR;;AiGl17BI;EACI,gBAAA;AjGq17BR;;AiGt17BI;EACI,gBAAA;AjGy17BR;;AiG117BI;EACI,gBAAA;AjG617BR;;AiG917BI;EACI,gBAAA;AjGi27BR;;AiGl27BI;EACI,gBAAA;AjGq27BR;;AiGt27BI;EACI,gBAAA;AjGy27BR;;AiG127BI;EACI,gBAAA;AjG627BR;;AiG927BI;EACI,gBAAA;AjGi37BR;;AiGl37BI;EACI,gBAAA;AjGq37BR;;AiGt37BI;EACI,gBAAA;AjGy37BR;;AiG137BI;EACI,gBAAA;AjG637BR;;AiG937BI;EACI,iBAAA;AjGi47BR;;AiGl47BI;EACI,gBAAA;AjGq47BR;;AiGt47BI;EACI,gBAAA;AjGy47BR;;AiG147BI;EACI,gBAAA;AjG647BR;;AiG947BI;EACI,gBAAA;AjGi57BR;;AiGl57BI;EACI,gBAAA;AjGq57BR;;AiGt57BI;EACI,gBAAA;AjGy57BR;;AiG157BI;EACI,gBAAA;AjG657BR;;AiG957BI;EACI,gBAAA;AjGi67BR;;AiGl67BI;EACI,gBAAA;AjGq67BR;;AiGt67BI;EACI,gBAAA;AjGy67BR;;AiG167BI;EACI,gBAAA;AjG667BR;;AiG967BI;EACI,gBAAA;AjGi77BR;;AiGl77BI;EACI,gBAAA;AjGq77BR;;AiGt77BI;EACI,gBAAA;AjGy77BR;;AiG177BI;EACI,gBAAA;AjG677BR;;AiG977BI;EACI,iBAAA;AjGi87BR;;AiGl87BI;EACI,iBAAA;AjGq87BR;;AiGt87BI;EACI,iBAAA;AjGy87BR;;AiG187BI;EACI,iBAAA;AjG687BR;;AiG987BI;EACI,gBAAA;AjGi97BR;;AiGl97BI;EACI,gBAAA;AjGq97BR;;AiGt97BI;EACI,gBAAA;AjGy97BR;;AiG197BI;EACI,gBAAA;AjG697BR;;AiG997BI;EACI,gBAAA;AjGi+7BR;;AiGl+7BI;EACI,gBAAA;AjGq+7BR;;AiGt+7BI;EACI,gBAAA;AjGy+7BR;;AiG1+7BI;EACI,gBAAA;AjG6+7BR;;AiG9+7BI;EACI,iBAAA;AjGi/7BR;;AiGl/7BI;EACI,gBAAA;AjGq/7BR;;AiGt/7BI;EACI,iBAAA;AjGy/7BR;;AiG1/7BI;EACI,gBAAA;AjG6/7BR;;AiG9/7BI;EACI,gBAAA;AjGig8BR;;AiGlg8BI;EACI,gBAAA;AjGqg8BR;;AiGtg8BI;EACI,gBAAA;AjGyg8BR;;AiG1g8BI;EACI,gBAAA;AjG6g8BR;;AiG9g8BI;EACI,gBAAA;AjGih8BR;;AiGlh8BI;EACI,gBAAA;AjGqh8BR;;AiGth8BI;EACI,gBAAA;AjGyh8BR;;AiG1h8BI;EACI,gBAAA;AjG6h8BR;;AiG9h8BI;EACI,iBAAA;AjGii8BR;;AiGli8BI;EACI,gBAAA;AjGqi8BR;;AiGti8BI;EACI,gBAAA;AjGyi8BR;;AiG1i8BI;EACI,gBAAA;AjG6i8BR;;AiG9i8BI;EACI,gBAAA;AjGij8BR;;AiGlj8BI;EACI,gBAAA;AjGqj8BR;;AiGtj8BI;EACI,gBAAA;AjGyj8BR;;AiG1j8BI;EACI,gBAAA;AjG6j8BR;;AiG9j8BI;EACI,gBAAA;AjGik8BR;;AiGlk8BI;EACI,gBAAA;AjGqk8BR;;AiGtk8BI;EACI,gBAAA;AjGyk8BR;;AiG1k8BI;EACI,cAAA;AjG6k8BR;;AiG9k8BI;EACI,gBAAA;AjGil8BR;;AiGll8BI;EACI,gBAAA;AjGql8BR;;AiGtl8BI;EACI,gBAAA;AjGyl8BR;;AiG1l8BI;EACI,gBAAA;AjG6l8BR;;AiG9l8BI;EACI,gBAAA;AjGim8BR;;AiGlm8BI;EACI,gBAAA;AjGqm8BR;;AiGtm8BI;EACI,cAAA;AjGym8BR;;AiG1m8BI;EACI,gBAAA;AjG6m8BR;;AiG9m8BI;EACI,gBAAA;AjGin8BR;;AiGln8BI;EACI,gBAAA;AjGqn8BR;;AiGtn8BI;EACI,gBAAA;AjGyn8BR;;AiG1n8BI;EACI,gBAAA;AjG6n8BR;;AiG9n8BI;EACI,gBAAA;AjGio8BR;;AiGlo8BI;EACI,iBAAA;AjGqo8BR;;AiGto8BI;EACI,gBAAA;AjGyo8BR;;AiG1o8BI;EACI,iBAAA;AjG6o8BR;;AiG9o8BI;EACI,iBAAA;AjGip8BR;;AiGlp8BI;EACI,gBAAA;AjGqp8BR;;AiGtp8BI;EACI,iBAAA;AjGyp8BR;;AiG1p8BI;EACI,iBAAA;AjG6p8BR;;AiG9p8BI;EACI,cAAA;AjGiq8BR;;AiGlq8BI;EACI,gBAAA;AjGqq8BR;;AiGtq8BI;EACI,gBAAA;AjGyq8BR;;AiG1q8BI;EACI,gBAAA;AjG6q8BR;;AiG9q8BI;EACI,gBAAA;AjGir8BR;;AiGlr8BI;EACI,gBAAA;AjGqr8BR;;AiGtr8BI;EACI,gBAAA;AjGyr8BR;;AiG1r8BI;EACI,cAAA;AjG6r8BR;;AiG9r8BI;EACI,gBAAA;AjGis8BR;;AiGls8BI;EACI,gBAAA;AjGqs8BR;;AiGts8BI;EACI,gBAAA;AjGys8BR;;AiG1s8BI;EACI,gBAAA;AjG6s8BR;;AiG9s8BI;EACI,gBAAA;AjGit8BR;;AiGlt8BI;EACI,gBAAA;AjGqt8BR;;AiGtt8BI;EACI,cAAA;AjGyt8BR;;AiG1t8BI;EACI,gBAAA;AjG6t8BR;;AiG9t8BI;EACI,gBAAA;AjGiu8BR;;AiGlu8BI;EACI,gBAAA;AjGqu8BR;;AiGtu8BI;EACI,gBAAA;AjGyu8BR;;AiG1u8BI;EACI,gBAAA;AjG6u8BR;;AiG9u8BI;EACI,gBAAA;AjGiv8BR;;AiGlv8BI;EACI,cAAA;AjGqv8BR;;AiGtv8BI;EACI,gBAAA;AjGyv8BR;;AiG1v8BI;EACI,gBAAA;AjG6v8BR;;AiG9v8BI;EACI,gBAAA;AjGiw8BR;;AiGlw8BI;EACI,gBAAA;AjGqw8BR;;AiGtw8BI;EACI,gBAAA;AjGyw8BR;;AiG1w8BI;EACI,gBAAA;AjG6w8BR;;AiG9w8BI;EACI,cAAA;AjGix8BR;;AiGlx8BI;EACI,gBAAA;AjGqx8BR;;AiGtx8BI;EACI,gBAAA;AjGyx8BR;;AiG1x8BI;EACI,gBAAA;AjG6x8BR;;AiG9x8BI;EACI,gBAAA;AjGiy8BR;;AiGly8BI;EACI,gBAAA;AjGqy8BR;;AiGty8BI;EACI,gBAAA;AjGyy8BR;;AiG1y8BI;EACI,cAAA;AjG6y8BR;;AiG9y8BI;EACI,gBAAA;AjGiz8BR;;AiGlz8BI;EACI,gBAAA;AjGqz8BR;;AiGtz8BI;EACI,gBAAA;AjGyz8BR;;AiG1z8BI;EACI,gBAAA;AjG6z8BR;;AiG9z8BI;EACI,gBAAA;AjGi08BR;;AiGl08BI;EACI,gBAAA;AjGq08BR;;AiGt08BI;EACI,cAAA;AjGy08BR;;AiG108BI;EACI,gBAAA;AjG608BR;;AiG908BI;EACI,gBAAA;AjGi18BR;;AiGl18BI;EACI,gBAAA;AjGq18BR;;AiGt18BI;EACI,gBAAA;AjGy18BR;;AiG118BI;EACI,gBAAA;AjG618BR;;AiG918BI;EACI,gBAAA;AjGi28BR;;AiGl28BI;EACI,cAAA;AjGq28BR;;AiGt28BI;EACI,gBAAA;AjGy28BR;;AiG128BI;EACI,gBAAA;AjG628BR;;AiG928BI;EACI,gBAAA;AjGi38BR;;AiGl38BI;EACI,gBAAA;AjGq38BR;;AiGt38BI;EACI,gBAAA;AjGy38BR;;AiG138BI;EACI,gBAAA;AjG638BR;;AiG938BI;EACI,iBAAA;AjGi48BR;;AiGl48BI;EACI,gBAAA;AjGq48BR;;AiGt48BI;EACI,gBAAA;AjGy48BR;;AiG148BI;EACI,gBAAA;AjG648BR;;AiG948BI;EACI,gBAAA;AjGi58BR;;AiGl58BI;EACI,gBAAA;AjGq58BR;;AiGt58BI;EACI,gBAAA;AjGy58BR;;AiG158BI;EACI,iBAAA;AjG658BR;;AiG958BI;EACI,gBAAA;AjGi68BR;;AiGl68BI;EACI,gBAAA;AjGq68BR;;AiGt68BI;EACI,iBAAA;AjGy68BR;;AiG168BI;EACI,gBAAA;AjG668BR;;AiG968BI;EACI,gBAAA;AjGi78BR;;AiGl78BI;EACI,iBAAA;AjGq78BR;;AiGt78BI;EACI,iBAAA;AjGy78BR;;AiG178BI;EACI,gBAAA;AjG678BR;;AiG978BI;EACI,gBAAA;AjGi88BR;;AiGl88BI;EACI,gBAAA;AjGq88BR;;AiGt88BI;EACI,gBAAA;AjGy88BR;;AiG188BI;EACI,gBAAA;AjG688BR;;AiG988BI;EACI,iBAAA;AjGi98BR;;AiGl98BI;EACI,gBAAA;AjGq98BR;;AiGt98BI;EACI,gBAAA;AjGy98BR;;AiG198BI;EACI,gBAAA;AjG698BR;;AiG998BI;EACI,gBAAA;AjGi+8BR;;AiGl+8BI;EACI,iBAAA;AjGq+8BR;;AiGt+8BI;EACI,iBAAA;AjGy+8BR;;AiG1+8BI;EACI,gBAAA;AjG6+8BR;;AiG9+8BI;EACI,gBAAA;AjGi/8BR;;AiGl/8BI;EACI,gBAAA;AjGq/8BR;;AiGt/8BI;EACI,gBAAA;AjGy/8BR;;AiG1/8BI;EACI,gBAAA;AjG6/8BR;;AiG9/8BI;EACI,gBAAA;AjGig9BR;;AiGlg9BI;EACI,gBAAA;AjGqg9BR;;AiGtg9BI;EACI,gBAAA;AjGyg9BR;;AiG1g9BI;EACI,gBAAA;AjG6g9BR;;AiG9g9BI;EACI,gBAAA;AjGih9BR;;AiGlh9BI;EACI,gBAAA;AjGqh9BR;;AiGth9BI;EACI,gBAAA;AjGyh9BR;;AiG1h9BI;EACI,gBAAA;AjG6h9BR;;AiG9h9BI;EACI,gBAAA;AjGii9BR;;AiGli9BI;EACI,gBAAA;AjGqi9BR;;AiGti9BI;EACI,iBAAA;AjGyi9BR;;AiG1i9BI;EACI,gBAAA;AjG6i9BR;;AiG9i9BI;EACI,iBAAA;AjGij9BR;;AiGlj9BI;EACI,gBAAA;AjGqj9BR;;AiGtj9BI;EACI,gBAAA;AjGyj9BR;;AiG1j9BI;EACI,gBAAA;AjG6j9BR;;AiG9j9BI;EACI,gBAAA;AjGik9BR;;AiGlk9BI;EACI,gBAAA;AjGqk9BR;;AiGtk9BI;EACI,gBAAA;AjGyk9BR;;AiG1k9BI;EACI,gBAAA;AjG6k9BR;;AiG9k9BI;EACI,gBAAA;AjGil9BR;;AiGll9BI;EACI,gBAAA;AjGql9BR;;AiGtl9BI;EACI,gBAAA;AjGyl9BR;;AiG1l9BI;EACI,gBAAA;AjG6l9BR;;AiG9l9BI;EACI,gBAAA;AjGim9BR;;AiGlm9BI;EACI,gBAAA;AjGqm9BR;;AiGtm9BI;EACI,gBAAA;AjGym9BR;;AiG1m9BI;EACI,gBAAA;AjG6m9BR;;AiG9m9BI;EACI,gBAAA;AjGin9BR;;AiGln9BI;EACI,gBAAA;AjGqn9BR;;AiGtn9BI;EACI,gBAAA;AjGyn9BR;;AiG1n9BI;EACI,gBAAA;AjG6n9BR;;AiG9n9BI;EACI,gBAAA;AjGio9BR;;AiGlo9BI;EACI,gBAAA;AjGqo9BR;;AiGto9BI;EACI,gBAAA;AjGyo9BR;;AiG1o9BI;EACI,gBAAA;AjG6o9BR;;AiG9o9BI;EACI,iBAAA;AjGip9BR;;AiGlp9BI;EACI,iBAAA;AjGqp9BR;;AiGtp9BI;EACI,gBAAA;AjGyp9BR;;AiG1p9BI;EACI,gBAAA;AjG6p9BR;;AiG9p9BI;EACI,gBAAA;AjGiq9BR;;AiGlq9BI;EACI,gBAAA;AjGqq9BR;;AiGtq9BI;EACI,gBAAA;AjGyq9BR;;AiG1q9BI;EACI,gBAAA;AjG6q9BR;;AiG9q9BI;EACI,gBAAA;AjGir9BR;;AiGlr9BI;EACI,gBAAA;AjGqr9BR;;AiGtr9BI;EACI,gBAAA;AjGyr9BR;;AiG1r9BI;EACI,gBAAA;AjG6r9BR;;AiG9r9BI;EACI,gBAAA;AjGis9BR;;AiGls9BI;EACI,gBAAA;AjGqs9BR;;AiGts9BI;EACI,gBAAA;AjGys9BR;;AiG1s9BI;EACI,gBAAA;AjG6s9BR;;AiG9s9BI;EACI,gBAAA;AjGit9BR;;AiGlt9BI;EACI,gBAAA;AjGqt9BR;;AiGtt9BI;EACI,gBAAA;AjGyt9BR;;AiG1t9BI;EACI,gBAAA;AjG6t9BR;;AiG9t9BI;EACI,gBAAA;AjGiu9BR;;AiGlu9BI;EACI,iBAAA;AjGqu9BR;;AiGtu9BI;EACI,iBAAA;AjGyu9BR;;AiG1u9BI;EACI,gBAAA;AjG6u9BR;;AiG9u9BI;EACI,gBAAA;AjGiv9BR;;AiGlv9BI;EACI,gBAAA;AjGqv9BR;;AiGtv9BI;EACI,gBAAA;AjGyv9BR;;AiG1v9BI;EACI,iBAAA;AjG6v9BR;;AiG9v9BI;EACI,gBAAA;AjGiw9BR;;AiGlw9BI;EACI,gBAAA;AjGqw9BR;;AiGtw9BI;EACI,iBAAA;AjGyw9BR;;AiG1w9BI;EACI,gBAAA;AjG6w9BR;;AiG9w9BI;EACI,gBAAA;AjGix9BR;;AiGlx9BI;EACI,gBAAA;AjGqx9BR;;AiGtx9BI;EACI,gBAAA;AjGyx9BR;;AiG1x9BI;EACI,gBAAA;AjG6x9BR;;AiG9x9BI;EACI,gBAAA;AjGiy9BR;;AiGly9BI;EACI,gBAAA;AjGqy9BR;;AiGty9BI;EACI,gBAAA;AjGyy9BR;;AiG1y9BI;EACI,gBAAA;AjG6y9BR;;AiG9y9BI;EACI,gBAAA;AjGiz9BR;;AiGlz9BI;EACI,gBAAA;AjGqz9BR;;AiGtz9BI;EACI,gBAAA;AjGyz9BR;;AiG1z9BI;EACI,iBAAA;AjG6z9BR;;AiG9z9BI;EACI,iBAAA;AjGi09BR;;AiGl09BI;EACI,iBAAA;AjGq09BR;;AiGt09BI;EACI,iBAAA;AjGy09BR;;AiG109BI;EACI,gBAAA;AjG609BR;;AiG909BI;EACI,gBAAA;AjGi19BR;;AiGl19BI;EACI,gBAAA;AjGq19BR;;AiGt19BI;EACI,gBAAA;AjGy19BR;;AiG119BI;EACI,gBAAA;AjG619BR;;AiG919BI;EACI,gBAAA;AjGi29BR;;AiGl29BI;EACI,gBAAA;AjGq29BR;;AiGt29BI;EACI,gBAAA;AjGy29BR;;AiG129BI;EACI,iBAAA;AjG629BR;;AiG929BI;EACI,iBAAA;AjGi39BR;;AiGl39BI;EACI,gBAAA;AjGq39BR;;AiGt39BI;EACI,gBAAA;AjGy39BR;;AiG139BI;EACI,gBAAA;AjG639BR;;AiG939BI;EACI,gBAAA;AjGi49BR;;AiGl49BI;EACI,gBAAA;AjGq49BR;;AiGt49BI;EACI,gBAAA;AjGy49BR;;AiG149BI;EACI,gBAAA;AjG649BR;;AiG949BI;EACI,gBAAA;AjGi59BR;;AiGl59BI;EACI,gBAAA;AjGq59BR;;AiGt59BI;EACI,gBAAA;AjGy59BR;;AiG159BI;EACI,gBAAA;AjG659BR;;AiG959BI;EACI,gBAAA;AjGi69BR;;AiGl69BI;EACI,gBAAA;AjGq69BR;;AiGt69BI;EACI,gBAAA;AjGy69BR;;AiG169BI;EACI,iBAAA;AjG669BR;;AiG969BI;EACI,gBAAA;AjGi79BR;;AiGl79BI;EACI,gBAAA;AjGq79BR;;AiGt79BI;EACI,gBAAA;AjGy79BR;;AiG179BI;EACI,gBAAA;AjG679BR;;AiG979BI;EACI,iBAAA;AjGi89BR;;AiGl89BI;EACI,gBAAA;AjGq89BR;;AiGt89BI;EACI,iBAAA;AjGy89BR;;AiG189BI;EACI,gBAAA;AjG689BR;;AiG989BI;EACI,gBAAA;AjGi99BR;;AiGl99BI;EACI,gBAAA;AjGq99BR;;AiGt99BI;EACI,gBAAA;AjGy99BR;;AiG199BI;EACI,gBAAA;AjG699BR;;AiG999BI;EACI,gBAAA;AjGi+9BR;;AiGl+9BI;EACI,gBAAA;AjGq+9BR;;AiGt+9BI;EACI,iBAAA;AjGy+9BR;;AiG1+9BI;EACI,gBAAA;AjG6+9BR;;AiG9+9BI;EACI,iBAAA;AjGi/9BR;;AiGl/9BI;EACI,iBAAA;AjGq/9BR;;AiGt/9BI;EACI,iBAAA;AjGy/9BR;;AiG1/9BI;EACI,iBAAA;AjG6/9BR;;AiG9/9BI;EACI,iBAAA;AjGig+BR;;AiGlg+BI;EACI,gBAAA;AjGqg+BR;;AiGtg+BI;EACI,iBAAA;AjGyg+BR;;AiG1g+BI;EACI,gBAAA;AjG6g+BR;;AiG9g+BI;EACI,iBAAA;AjGih+BR;;AiGlh+BI;EACI,gBAAA;AjGqh+BR;;AiGth+BI;EACI,iBAAA;AjGyh+BR;;AiG1h+BI;EACI,gBAAA;AjG6h+BR;;AiG9h+BI;EACI,iBAAA;AjGii+BR;;AiGli+BI;EACI,gBAAA;AjGqi+BR;;AiGti+BI;EACI,iBAAA;AjGyi+BR;;AiG1i+BI;EACI,gBAAA;AjG6i+BR;;AiG9i+BI;EACI,iBAAA;AjGij+BR;;AiGlj+BI;EACI,gBAAA;AjGqj+BR;;AiGtj+BI;EACI,iBAAA;AjGyj+BR;;AiG1j+BI;EACI,iBAAA;AjG6j+BR;;AiG9j+BI;EACI,iBAAA;AjGik+BR;;AiGlk+BI;EACI,gBAAA;AjGqk+BR;;AiGtk+BI;EACI,iBAAA;AjGyk+BR;;AiG1k+BI;EACI,gBAAA;AjG6k+BR;;AiG9k+BI;EACI,iBAAA;AjGil+BR;;AiGll+BI;EACI,gBAAA;AjGql+BR;;AiGtl+BI;EACI,iBAAA;AjGyl+BR;;AiG1l+BI;EACI,gBAAA;AjG6l+BR;;AiG9l+BI;EACI,iBAAA;AjGim+BR;;AiGlm+BI;EACI,gBAAA;AjGqm+BR;;AiGtm+BI;EACI,gBAAA;AjGym+BR;;AiG1m+BI;EACI,iBAAA;AjG6m+BR;;AiG9m+BI;EACI,gBAAA;AjGin+BR;;AiGln+BI;EACI,iBAAA;AjGqn+BR;;AiGtn+BI;EACI,gBAAA;AjGyn+BR;;AiG1n+BI;EACI,iBAAA;AjG6n+BR;;AiG9n+BI;EACI,iBAAA;AjGio+BR;;AiGlo+BI;EACI,iBAAA;AjGqo+BR;;AiGto+BI;EACI,gBAAA;AjGyo+BR;;AiG1o+BI;EACI,gBAAA;AjG6o+BR;;AiG9o+BI;EACI,gBAAA;AjGip+BR;;AiGlp+BI;EACI,iBAAA;AjGqp+BR;;AiGtp+BI;EACI,gBAAA;AjGyp+BR;;AiG1p+BI;EACI,gBAAA;AjG6p+BR;;AiG9p+BI;EACI,gBAAA;AjGiq+BR;;AiGlq+BI;EACI,gBAAA;AjGqq+BR;;AiGtq+BI;EACI,gBAAA;AjGyq+BR;;AiG1q+BI;EACI,gBAAA;AjG6q+BR;;AiG9q+BI;EACI,gBAAA;AjGir+BR;;AiGlr+BI;EACI,gBAAA;AjGqr+BR;;AiGtr+BI;EACI,gBAAA;AjGyr+BR;;AiG1r+BI;EACI,gBAAA;AjG6r+BR;;AiG9r+BI;EACI,gBAAA;AjGis+BR;;AiGls+BI;EACI,gBAAA;AjGqs+BR;;AiGts+BI;EACI,gBAAA;AjGys+BR;;AiG1s+BI;EACI,iBAAA;AjG6s+BR;;AiG9s+BI;EACI,iBAAA;AjGit+BR;;AiGlt+BI;EACI,gBAAA;AjGqt+BR;;AiGtt+BI;EACI,gBAAA;AjGyt+BR;;AiG1t+BI;EACI,gBAAA;AjG6t+BR;;AiG9t+BI;EACI,gBAAA;AjGiu+BR;;AiGlu+BI;EACI,gBAAA;AjGqu+BR;;AiGtu+BI;EACI,gBAAA;AjGyu+BR;;AiG1u+BI;EACI,gBAAA;AjG6u+BR;;AiG9u+BI;EACI,gBAAA;AjGiv+BR;;AiGlv+BI;EACI,gBAAA;AjGqv+BR;;AiGtv+BI;EACI,gBAAA;AjGyv+BR;;AiG1v+BI;EACI,gBAAA;AjG6v+BR;;AiG9v+BI;EACI,gBAAA;AjGiw+BR;;AiGlw+BI;EACI,gBAAA;AjGqw+BR;;AiGtw+BI;EACI,gBAAA;AjGyw+BR;;AiG1w+BI;EACI,gBAAA;AjG6w+BR;;AiG9w+BI;EACI,iBAAA;AjGix+BR;;AiGlx+BI;EACI,gBAAA;AjGqx+BR;;AiGtx+BI;EACI,gBAAA;AjGyx+BR;;AiG1x+BI;EACI,gBAAA;AjG6x+BR;;AiG9x+BI;EACI,gBAAA;AjGiy+BR;;AiGly+BI;EACI,gBAAA;AjGqy+BR;;AiGty+BI;EACI,iBAAA;AjGyy+BR;;AiG1y+BI;EACI,gBAAA;AjG6y+BR;;AiG9y+BI;EACI,gBAAA;AjGiz+BR;;AiGlz+BI;EACI,gBAAA;AjGqz+BR;;AiGtz+BI;EACI,gBAAA;AjGyz+BR;;AiG1z+BI;EACI,gBAAA;AjG6z+BR;;AiG9z+BI;EACI,gBAAA;AjGi0+BR;;AiGl0+BI;EACI,gBAAA;AjGq0+BR;;AiGt0+BI;EACI,gBAAA;AjGy0+BR;;AiG10+BI;EACI,gBAAA;AjG60+BR;;AiG90+BI;EACI,gBAAA;AjGi1+BR;;AiGl1+BI;EACI,gBAAA;AjGq1+BR;;AiGt1+BI;EACI,gBAAA;AjGy1+BR;;AiG11+BI;EACI,gBAAA;AjG61+BR;;AiG91+BI;EACI,gBAAA;AjGi2+BR;;AiGl2+BI;EACI,gBAAA;AjGq2+BR;;AiGt2+BI;EACI,gBAAA;AjGy2+BR;;AiG12+BI;EACI,gBAAA;AjG62+BR;;AiG92+BI;EACI,gBAAA;AjGi3+BR;;AiGl3+BI;EACI,gBAAA;AjGq3+BR;;AiGt3+BI;EACI,gBAAA;AjGy3+BR;;AiG13+BI;EACI,gBAAA;AjG63+BR;;AiG93+BI;EACI,gBAAA;AjGi4+BR;;AiGl4+BI;EACI,gBAAA;AjGq4+BR;;AiGt4+BI;EACI,iBAAA;AjGy4+BR;;AiG14+BI;EACI,gBAAA;AjG64+BR;;AiG94+BI;EACI,gBAAA;AjGi5+BR;;AiGl5+BI;EACI,gBAAA;AjGq5+BR;;AiGt5+BI;EACI,gBAAA;AjGy5+BR;;AiG15+BI;EACI,gBAAA;AjG65+BR;;AiG95+BI;EACI,gBAAA;AjGi6+BR;;AiGl6+BI;EACI,gBAAA;AjGq6+BR;;AiGt6+BI;EACI,gBAAA;AjGy6+BR;;AiG16+BI;EACI,gBAAA;AjG66+BR;;AiG96+BI;EACI,gBAAA;AjGi7+BR;;AiGl7+BI;EACI,iBAAA;AjGq7+BR;;AiGt7+BI;EACI,gBAAA;AjGy7+BR;;AiG17+BI;EACI,gBAAA;AjG67+BR;;AiG97+BI;EACI,gBAAA;AjGi8+BR;;AiGl8+BI;EACI,gBAAA;AjGq8+BR;;AiGt8+BI;EACI,gBAAA;AjGy8+BR;;AiG18+BI;EACI,gBAAA;AjG68+BR;;AiG98+BI;EACI,gBAAA;AjGi9+BR;;AiGl9+BI;EACI,gBAAA;AjGq9+BR;;AiGt9+BI;EACI,gBAAA;AjGy9+BR;;AiG19+BI;EACI,gBAAA;AjG69+BR;;AiG99+BI;EACI,gBAAA;AjGi++BR;;AiGl++BI;EACI,iBAAA;AjGq++BR;;AiGt++BI;EACI,iBAAA;AjGy++BR;;AiG1++BI;EACI,gBAAA;AjG6++BR;;AiG9++BI;EACI,gBAAA;AjGi/+BR;;AiGl/+BI;EACI,iBAAA;AjGq/+BR;;AiGt/+BI;EACI,gBAAA;AjGy/+BR;;AiG1/+BI;EACI,gBAAA;AjG6/+BR;;AiG9/+BI;EACI,gBAAA;AjGig/BR;;AiGlg/BI;EACI,iBAAA;AjGqg/BR;;AiGtg/BI;EACI,iBAAA;AjGyg/BR;;AiG1g/BI;EACI,gBAAA;AjG6g/BR;;AiG9g/BI;EACI,gBAAA;AjGih/BR;;AiGlh/BI;EACI,gBAAA;AjGqh/BR;;AiGth/BI;EACI,gBAAA;AjGyh/BR;;AiG1h/BI;EACI,gBAAA;AjG6h/BR;;AiG9h/BI;EACI,iBAAA;AjGii/BR;;AiGli/BI;EACI,gBAAA;AjGqi/BR;;AiGti/BI;EACI,gBAAA;AjGyi/BR;;AiG1i/BI;EACI,gBAAA;AjG6i/BR;;AiG9i/BI;EACI,gBAAA;AjGij/BR;;AiGlj/BI;EACI,gBAAA;AjGqj/BR;;AiGtj/BI;EACI,gBAAA;AjGyj/BR;;AiG1j/BI;EACI,gBAAA;AjG6j/BR;;AiG9j/BI;EACI,gBAAA;AjGik/BR;;AiGlk/BI;EACI,gBAAA;AjGqk/BR;;AiGtk/BI;EACI,gBAAA;AjGyk/BR;;AiG1k/BI;EACI,iBAAA;AjG6k/BR;;AiG9k/BI;EACI,gBAAA;AjGil/BR;;AiGll/BI;EACI,iBAAA;AjGql/BR;;AiGtl/BI;EACI,iBAAA;AjGyl/BR;;AiG1l/BI;EACI,gBAAA;AjG6l/BR;;AiG9l/BI;EACI,gBAAA;AjGim/BR;;AiGlm/BI;EACI,gBAAA;AjGqm/BR;;AiGtm/BI;EACI,gBAAA;AjGym/BR;;AiG1m/BI;EACI,gBAAA;AjG6m/BR;;AiG9m/BI;EACI,gBAAA;AjGin/BR;;AiGln/BI;EACI,gBAAA;AjGqn/BR;;AiGtn/BI;EACI,gBAAA;AjGyn/BR;;AiG1n/BI;EACI,gBAAA;AjG6n/BR;;AiG9n/BI;EACI,gBAAA;AjGio/BR;;AiGlo/BI;EACI,iBAAA;AjGqo/BR;;AiGto/BI;EACI,iBAAA;AjGyo/BR;;AiG1o/BI;EACI,gBAAA;AjG6o/BR;;AiG9o/BI;EACI,gBAAA;AjGip/BR;;AiGlp/BI;EACI,iBAAA;AjGqp/BR;;AiGtp/BI;EACI,gBAAA;AjGyp/BR;;AiG1p/BI;EACI,iBAAA;AjG6p/BR;;AiG9p/BI;EACI,gBAAA;AjGiq/BR;;AiGlq/BI;EACI,gBAAA;AjGqq/BR;;AiGtq/BI;EACI,gBAAA;AjGyq/BR;;AiG1q/BI;EACI,gBAAA;AjG6q/BR;;AiG9q/BI;EACI,gBAAA;AjGir/BR;;AiGlr/BI;EACI,gBAAA;AjGqr/BR;;AiGtr/BI;EACI,gBAAA;AjGyr/BR;;AiG1r/BI;EACI,gBAAA;AjG6r/BR;;AiG9r/BI;EACI,iBAAA;AjGis/BR;;AiGls/BI;EACI,gBAAA;AjGqs/BR;;AiGts/BI;EACI,gBAAA;AjGys/BR;;AiG1s/BI;EACI,gBAAA;AjG6s/BR;;AiG9s/BI;EACI,gBAAA;AjGit/BR;;AiGlt/BI;EACI,gBAAA;AjGqt/BR;;AiGtt/BI;EACI,iBAAA;AjGyt/BR;;AiG1t/BI;EACI,iBAAA;AjG6t/BR;;AiG9t/BI;EACI,gBAAA;AjGiu/BR;;AiGlu/BI;EACI,gBAAA;AjGqu/BR;;AiGtu/BI;EACI,gBAAA;AjGyu/BR;;AiG1u/BI;EACI,gBAAA;AjG6u/BR;;AiG9u/BI;EACI,gBAAA;AjGiv/BR;;AiGlv/BI;EACI,gBAAA;AjGqv/BR;;AiGtv/BI;EACI,gBAAA;AjGyv/BR;;AiG1v/BI;EACI,gBAAA;AjG6v/BR;;AiG9v/BI;EACI,gBAAA;AjGiw/BR;;AiGlw/BI;EACI,gBAAA;AjGqw/BR;;AiGtw/BI;EACI,gBAAA;AjGyw/BR;;AiG1w/BI;EACI,gBAAA;AjG6w/BR;;AiG9w/BI;EACI,iBAAA;AjGix/BR;;AiGlx/BI;EACI,iBAAA;AjGqx/BR;;AiGtx/BI;EACI,iBAAA;AjGyx/BR;;AiG1x/BI;EACI,gBAAA;AjG6x/BR;;AiG9x/BI;EACI,gBAAA;AjGiy/BR;;AiGly/BI;EACI,gBAAA;AjGqy/BR;;AiGty/BI;EACI,gBAAA;AjGyy/BR;;AiG1y/BI;EACI,gBAAA;AjG6y/BR;;AiG9y/BI;EACI,gBAAA;AjGiz/BR;;AiGlz/BI;EACI,gBAAA;AjGqz/BR;;AiGtz/BI;EACI,gBAAA;AjGyz/BR;;AiG1z/BI;EACI,gBAAA;AjG6z/BR;;AiG9z/BI;EACI,gBAAA;AjGi0/BR;;AiGl0/BI;EACI,gBAAA;AjGq0/BR;;AiGt0/BI;EACI,gBAAA;AjGy0/BR;;AiG10/BI;EACI,gBAAA;AjG60/BR;;AiG90/BI;EACI,gBAAA;AjGi1/BR;;AiGl1/BI;EACI,gBAAA;AjGq1/BR;;AiGt1/BI;EACI,gBAAA;AjGy1/BR;;AiG11/BI;EACI,gBAAA;AjG61/BR;;AiG91/BI;EACI,gBAAA;AjGi2/BR;;AiGl2/BI;EACI,iBAAA;AjGq2/BR;;AiGt2/BI;EACI,gBAAA;AjGy2/BR;;AiG12/BI;EACI,gBAAA;AjG62/BR;;AiG92/BI;EACI,gBAAA;AjGi3/BR;;AiGl3/BI;EACI,gBAAA;AjGq3/BR;;AiGt3/BI;EACI,gBAAA;AjGy3/BR;;AiG13/BI;EACI,gBAAA;AjG63/BR;;AiG93/BI;EACI,gBAAA;AjGi4/BR;;AiGl4/BI;EACI,gBAAA;AjGq4/BR;;AiGt4/BI;EACI,gBAAA;AjGy4/BR;;AiG14/BI;EACI,gBAAA;AjG64/BR;;AiG94/BI;EACI,gBAAA;AjGi5/BR;;AiGl5/BI;EACI,gBAAA;AjGq5/BR;;AiGt5/BI;EACI,gBAAA;AjGy5/BR;;AiG15/BI;EACI,gBAAA;AjG65/BR;;AiG95/BI;EACI,gBAAA;AjGi6/BR;;AiGl6/BI;EACI,gBAAA;AjGq6/BR;;AiGt6/BI;EACI,gBAAA;AjGy6/BR;;AiG16/BI;EACI,gBAAA;AjG66/BR;;AiG96/BI;EACI,gBAAA;AjGi7/BR;;AiGl7/BI;EACI,gBAAA;AjGq7/BR;;AiGt7/BI;EACI,gBAAA;AjGy7/BR;;AiG17/BI;EACI,gBAAA;AjG67/BR;;AiG97/BI;EACI,gBAAA;AjGi8/BR;;AiGl8/BI;EACI,gBAAA;AjGq8/BR;;AiGt8/BI;EACI,gBAAA;AjGy8/BR;;AiG18/BI;EACI,gBAAA;AjG68/BR;;AiG98/BI;EACI,gBAAA;AjGi9/BR;;AiGl9/BI;EACI,iBAAA;AjGq9/BR;;AiGt9/BI;EACI,gBAAA;AjGy9/BR;;AiG19/BI;EACI,gBAAA;AjG69/BR;;AiG99/BI;EACI,gBAAA;AjGi+/BR;;AiGl+/BI;EACI,gBAAA;AjGq+/BR;;AiGt+/BI;EACI,gBAAA;AjGy+/BR;;AiG1+/BI;EACI,iBAAA;AjG6+/BR;;AiG9+/BI;EACI,gBAAA;AjGi//BR;;AiGl//BI;EACI,gBAAA;AjGq//BR;;AiGt//BI;EACI,gBAAA;AjGy//BR;;AiG1//BI;EACI,gBAAA;AjG6//BR;;AiG9//BI;EACI,iBAAA;AjGiggCR;;AiGlggCI;EACI,gBAAA;AjGqggCR;;AiGtggCI;EACI,gBAAA;AjGyggCR;;AiG1ggCI;EACI,gBAAA;AjG6ggCR;;AiG9ggCI;EACI,gBAAA;AjGihgCR;;AiGlhgCI;EACI,gBAAA;AjGqhgCR;;AiGthgCI;EACI,gBAAA;AjGyhgCR;;AiG1hgCI;EACI,gBAAA;AjG6hgCR;;AiG9hgCI;EACI,gBAAA;AjGiigCR;;AiGligCI;EACI,gBAAA;AjGqigCR;;AiGtigCI;EACI,gBAAA;AjGyigCR;;AiG1igCI;EACI,gBAAA;AjG6igCR;;AiG9igCI;EACI,gBAAA;AjGijgCR;;AiGljgCI;EACI,gBAAA;AjGqjgCR;;AiGtjgCI;EACI,gBAAA;AjGyjgCR;;AiG1jgCI;EACI,gBAAA;AjG6jgCR;;AiG9jgCI;EACI,gBAAA;AjGikgCR;;AiGlkgCI;EACI,iBAAA;AjGqkgCR;;AiGtkgCI;EACI,gBAAA;AjGykgCR;;AiG1kgCI;EACI,gBAAA;AjG6kgCR;;AiG9kgCI;EACI,gBAAA;AjGilgCR;;AiGllgCI;EACI,gBAAA;AjGqlgCR;;AiGtlgCI;EACI,gBAAA;AjGylgCR;;AiG1lgCI;EACI,gBAAA;AjG6lgCR;;AiG9lgCI;EACI,gBAAA;AjGimgCR;;AiGlmgCI;EACI,gBAAA;AjGqmgCR;;AiGtmgCI;EACI,iBAAA;AjGymgCR;;AiG1mgCI;EACI,gBAAA;AjG6mgCR;;AiG9mgCI;EACI,gBAAA;AjGingCR;;AiGlngCI;EACI,iBAAA;AjGqngCR;;AiGtngCI;EACI,gBAAA;AjGyngCR;;AiG1ngCI;EACI,gBAAA;AjG6ngCR;;AiG9ngCI;EACI,gBAAA;AjGiogCR;;AiGlogCI;EACI,iBAAA;AjGqogCR;;AiGtogCI;EACI,gBAAA;AjGyogCR;;AiG1ogCI;EACI,gBAAA;AjG6ogCR;;AiG9ogCI;EACI,gBAAA;AjGipgCR;;AiGlpgCI;EACI,gBAAA;AjGqpgCR;;AiGtpgCI;EACI,gBAAA;AjGypgCR;;AiG1pgCI;EACI,gBAAA;AjG6pgCR;;AiG9pgCI;EACI,gBAAA;AjGiqgCR;;AiGlqgCI;EACI,gBAAA;AjGqqgCR;;AiGtqgCI;EACI,gBAAA;AjGyqgCR;;AiG1qgCI;EACI,gBAAA;AjG6qgCR;;AiG9qgCI;EACI,gBAAA;AjGirgCR;;AiGlrgCI;EACI,iBAAA;AjGqrgCR;;AiGtrgCI;EACI,gBAAA;AjGyrgCR;;AiG1rgCI;EACI,gBAAA;AjG6rgCR;;AiG9rgCI;EACI,iBAAA;AjGisgCR;;AiGlsgCI;EACI,iBAAA;AjGqsgCR;;AiGtsgCI;EACI,gBAAA;AjGysgCR;;AiG1sgCI;EACI,gBAAA;AjG6sgCR;;AiG9sgCI;EACI,gBAAA;AjGitgCR;;AiGltgCI;EACI,iBAAA;AjGqtgCR;;AiGttgCI;EACI,gBAAA;AjGytgCR;;AiG1tgCI;EACI,gBAAA;AjG6tgCR;;AiG9tgCI;EACI,gBAAA;AjGiugCR;;AiGlugCI;EACI,iBAAA;AjGqugCR;;AiGtugCI;EACI,iBAAA;AjGyugCR;;AiG1ugCI;EACI,iBAAA;AjG6ugCR;;AiG9ugCI;EACI,iBAAA;AjGivgCR;;AiGlvgCI;EACI,iBAAA;AjGqvgCR;;AiGtvgCI;EACI,iBAAA;AjGyvgCR;;AiG1vgCI;EACI,iBAAA;AjG6vgCR;;AiG9vgCI;EACI,iBAAA;AjGiwgCR;;AiGlwgCI;EACI,iBAAA;AjGqwgCR;;AiGtwgCI;EACI,iBAAA;AjGywgCR;;AiG1wgCI;EACI,gBAAA;AjG6wgCR;;AiG9wgCI;EACI,gBAAA;AjGixgCR;;AiGlxgCI;EACI,gBAAA;AjGqxgCR;;AiGtxgCI;EACI,gBAAA;AjGyxgCR;;AiG1xgCI;EACI,gBAAA;AjG6xgCR;;AiG9xgCI;EACI,gBAAA;AjGiygCR;;AiGlygCI;EACI,gBAAA;AjGqygCR;;AiGtygCI;EACI,gBAAA;AjGyygCR;;AiG1ygCI;EACI,gBAAA;AjG6ygCR;;AiG9ygCI;EACI,gBAAA;AjGizgCR;;AiGlzgCI;EACI,iBAAA;AjGqzgCR;;AiGtzgCI;EACI,gBAAA;AjGyzgCR;;AiG1zgCI;EACI,gBAAA;AjG6zgCR;;AiG9zgCI;EACI,gBAAA;AjGi0gCR;;AiGl0gCI;EACI,iBAAA;AjGq0gCR;;AiGt0gCI;EACI,gBAAA;AjGy0gCR;;AiG10gCI;EACI,gBAAA;AjG60gCR;;AiG90gCI;EACI,gBAAA;AjGi1gCR;;AiGl1gCI;EACI,gBAAA;AjGq1gCR;;AiGt1gCI;EACI,gBAAA;AjGy1gCR;;AiG11gCI;EACI,gBAAA;AjG61gCR;;AiG91gCI;EACI,gBAAA;AjGi2gCR;;AiGl2gCI;EACI,gBAAA;AjGq2gCR;;AiGt2gCI;EACI,gBAAA;AjGy2gCR;;AiG12gCI;EACI,gBAAA;AjG62gCR;;AiG92gCI;EACI,gBAAA;AjGi3gCR;;AiGl3gCI;EACI,iBAAA;AjGq3gCR;;AiGt3gCI;EACI,gBAAA;AjGy3gCR;;AiG13gCI;EACI,gBAAA;AjG63gCR;;AiG93gCI;EACI,gBAAA;AjGi4gCR;;AiGl4gCI;EACI,iBAAA;AjGq4gCR;;AiGt4gCI;EACI,iBAAA;AjGy4gCR;;AiG14gCI;EACI,gBAAA;AjG64gCR;;AiG94gCI;EACI,gBAAA;AjGi5gCR;;AiGl5gCI;EACI,gBAAA;AjGq5gCR;;AiGt5gCI;EACI,gBAAA;AjGy5gCR;;AiG15gCI;EACI,gBAAA;AjG65gCR;;AiG95gCI;EACI,gBAAA;AjGi6gCR;;AiGl6gCI;EACI,gBAAA;AjGq6gCR;;AiGt6gCI;EACI,gBAAA;AjGy6gCR;;AiG16gCI;EACI,gBAAA;AjG66gCR;;AiG96gCI;EACI,gBAAA;AjGi7gCR;;AiGl7gCI;EACI,gBAAA;AjGq7gCR;;AiGt7gCI;EACI,gBAAA;AjGy7gCR;;AiG17gCI;EACI,gBAAA;AjG67gCR;;AiG97gCI;EACI,gBAAA;AjGi8gCR;;AiGl8gCI;EACI,iBAAA;AjGq8gCR;;AiGt8gCI;EACI,gBAAA;AjGy8gCR;;AiG18gCI;EACI,gBAAA;AjG68gCR;;AiG98gCI;EACI,gBAAA;AjGi9gCR;;AiGl9gCI;EACI,gBAAA;AjGq9gCR;;AiGt9gCI;EACI,gBAAA;AjGy9gCR;;AiG19gCI;EACI,iBAAA;AjG69gCR;;AiG99gCI;EACI,gBAAA;AjGi+gCR;;AiGl+gCI;EACI,iBAAA;AjGq+gCR;;AiGt+gCI;EACI,iBAAA;AjGy+gCR;;AiG1+gCI;EACI,iBAAA;AjG6+gCR;;AiG9+gCI;EACI,gBAAA;AjGi/gCR;;AiGl/gCI;EACI,gBAAA;AjGq/gCR;;AiGt/gCI;EACI,gBAAA;AjGy/gCR;;AiG1/gCI;EACI,gBAAA;AjG6/gCR;;AiG9/gCI;EACI,gBAAA;AjGighCR;;AiGlghCI;EACI,gBAAA;AjGqghCR;;AiGtghCI;EACI,gBAAA;AjGyghCR;;AiG1ghCI;EACI,gBAAA;AjG6ghCR;;AiG9ghCI;EACI,gBAAA;AjGihhCR;;AiGlhhCI;EACI,gBAAA;AjGqhhCR;;AiGthhCI;EACI,gBAAA;AjGyhhCR;;AiG1hhCI;EACI,gBAAA;AjG6hhCR;;AiG9hhCI;EACI,gBAAA;AjGiihCR;;AiGlihCI;EACI,gBAAA;AjGqihCR;;AiGtihCI;EACI,gBAAA;AjGyihCR;;AiG1ihCI;EACI,gBAAA;AjG6ihCR;;AiG9ihCI;EACI,gBAAA;AjGijhCR;;AiGljhCI;EACI,gBAAA;AjGqjhCR;;AiGtjhCI;EACI,gBAAA;AjGyjhCR;;AiG1jhCI;EACI,gBAAA;AjG6jhCR;;AiG9jhCI;EACI,gBAAA;AjGikhCR;;AiGlkhCI;EACI,gBAAA;AjGqkhCR;;AiGtkhCI;EACI,gBAAA;AjGykhCR;;AiG1khCI;EACI,gBAAA;AjG6khCR;;AiG9khCI;EACI,iBAAA;AjGilhCR;;AiGllhCI;EACI,gBAAA;AjGqlhCR;;AiGtlhCI;EACI,gBAAA;AjGylhCR;;AiG1lhCI;EACI,gBAAA;AjG6lhCR;;AiG9lhCI;EACI,gBAAA;AjGimhCR;;AiGlmhCI;EACI,gBAAA;AjGqmhCR;;AiGtmhCI;EACI,gBAAA;AjGymhCR;;AiG1mhCI;EACI,gBAAA;AjG6mhCR;;AiG9mhCI;EACI,gBAAA;AjGinhCR;;AiGlnhCI;EACI,gBAAA;AjGqnhCR;;AiGtnhCI;EACI,gBAAA;AjGynhCR;;AiG1nhCI;EACI,gBAAA;AjG6nhCR;;AiG9nhCI;EACI,gBAAA;AjGiohCR;;AiGlohCI;EACI,gBAAA;AjGqohCR;;AiGtohCI;EACI,gBAAA;AjGyohCR;;AiG1ohCI;EACI,gBAAA;AjG6ohCR;;AiG9ohCI;EACI,iBAAA;AjGiphCR;;AiGlphCI;EACI,iBAAA;AjGqphCR;;AiGtphCI;EACI,iBAAA;AjGyphCR;;AiG1phCI;EACI,gBAAA;AjG6phCR;;AiG9phCI;EACI,gBAAA;AjGiqhCR;;AiGlqhCI;EACI,iBAAA;AjGqqhCR;;AiGtqhCI;EACI,gBAAA;AjGyqhCR;;AiG1qhCI;EACI,gBAAA;AjG6qhCR;;AiG9qhCI;EACI,gBAAA;AjGirhCR;;AiGlrhCI;EACI,gBAAA;AjGqrhCR;;AiGtrhCI;EACI,iBAAA;AjGyrhCR;;AiG1rhCI;EACI,iBAAA;AjG6rhCR;;AiG9rhCI;EACI,iBAAA;AjGishCR;;AiGlshCI;EACI,gBAAA;AjGqshCR;;AiGtshCI;EACI,iBAAA;AjGyshCR;;AiG1shCI;EACI,iBAAA;AjG6shCR;;AiG9shCI;EACI,gBAAA;AjGithCR;;AiGlthCI;EACI,iBAAA;AjGqthCR;;AiGtthCI;EACI,iBAAA;AjGythCR;;AiG1thCI;EACI,gBAAA;AjG6thCR;;AiG9thCI;EACI,gBAAA;AjGiuhCR;;AiGluhCI;EACI,iBAAA;AjGquhCR;;AiGtuhCI;EACI,iBAAA;AjGyuhCR;;AiG1uhCI;EACI,gBAAA;AjG6uhCR;;AiG9uhCI;EACI,iBAAA;AjGivhCR;;AiGlvhCI;EACI,iBAAA;AjGqvhCR;;AiGtvhCI;EACI,gBAAA;AjGyvhCR;;AiG1vhCI;EACI,gBAAA;AjG6vhCR;;AiG9vhCI;EACI,gBAAA;AjGiwhCR;;AiGlwhCI;EACI,gBAAA;AjGqwhCR;;AiGtwhCI;EACI,gBAAA;AjGywhCR;;AiG1whCI;EACI,gBAAA;AjG6whCR;;AiG9whCI;EACI,gBAAA;AjGixhCR;;AiGlxhCI;EACI,gBAAA;AjGqxhCR;;AiGtxhCI;EACI,gBAAA;AjGyxhCR;;AiG1xhCI;EACI,gBAAA;AjG6xhCR;;AiG9xhCI;EACI,gBAAA;AjGiyhCR;;AiGlyhCI;EACI,gBAAA;AjGqyhCR;;AiGtyhCI;EACI,gBAAA;AjGyyhCR;;AiG1yhCI;EACI,gBAAA;AjG6yhCR;;AiG9yhCI;EACI,gBAAA;AjGizhCR;;AiGlzhCI;EACI,gBAAA;AjGqzhCR;;AiGtzhCI;EACI,gBAAA;AjGyzhCR;;AiG1zhCI;EACI,gBAAA;AjG6zhCR;;AiG9zhCI;EACI,gBAAA;AjGi0hCR;;AiGl0hCI;EACI,gBAAA;AjGq0hCR;;AiGt0hCI;EACI,gBAAA;AjGy0hCR;;AiG10hCI;EACI,gBAAA;AjG60hCR;;AiG90hCI;EACI,iBAAA;AjGi1hCR;;AiGl1hCI;EACI,iBAAA;AjGq1hCR;;AiGt1hCI;EACI,iBAAA;AjGy1hCR;;AiG11hCI;EACI,iBAAA;AjG61hCR;;AiG91hCI;EACI,gBAAA;AjGi2hCR;;AiGl2hCI;EACI,gBAAA;AjGq2hCR;;AiGt2hCI;EACI,gBAAA;AjGy2hCR;;AiG12hCI;EACI,iBAAA;AjG62hCR;;AiG92hCI;EACI,gBAAA;AjGi3hCR;;AiGl3hCI;EACI,gBAAA;AjGq3hCR;;AiGt3hCI;EACI,gBAAA;AjGy3hCR;;AiG13hCI;EACI,gBAAA;AjG63hCR;;AiG93hCI;EACI,gBAAA;AjGi4hCR;;AiGl4hCI;EACI,iBAAA;AjGq4hCR;;AiGt4hCI;EACI,iBAAA;AjGy4hCR;;AiG14hCI;EACI,iBAAA;AjG64hCR;;AiG94hCI;EACI,gBAAA;AjGi5hCR;;AiGl5hCI;EACI,gBAAA;AjGq5hCR;;AiGt5hCI;EACI,gBAAA;AjGy5hCR;;AiG15hCI;EACI,gBAAA;AjG65hCR;;AiG95hCI;EACI,gBAAA;AjGi6hCR;;AiGl6hCI;EACI,gBAAA;AjGq6hCR;;AiGt6hCI;EACI,gBAAA;AjGy6hCR;;AiG16hCI;EACI,gBAAA;AjG66hCR;;AiG96hCI;EACI,gBAAA;AjGi7hCR;;AiGl7hCI;EACI,gBAAA;AjGq7hCR;;AiGt7hCI;EACI,gBAAA;AjGy7hCR;;AiG17hCI;EACI,gBAAA;AjG67hCR;;AiG97hCI;EACI,gBAAA;AjGi8hCR;;AiGl8hCI;EACI,gBAAA;AjGq8hCR;;AiGt8hCI;EACI,gBAAA;AjGy8hCR;;AiG18hCI;EACI,gBAAA;AjG68hCR;;AiG98hCI;EACI,gBAAA;AjGi9hCR;;AiGl9hCI;EACI,iBAAA;AjGq9hCR;;AiGt9hCI;EACI,iBAAA;AjGy9hCR;;AiG19hCI;EACI,iBAAA;AjG69hCR;;AiG99hCI;EACI,gBAAA;AjGi+hCR;;AiGl+hCI;EACI,gBAAA;AjGq+hCR;;AiGt+hCI;EACI,gBAAA;AjGy+hCR;;AiG1+hCI;EACI,gBAAA;AjG6+hCR;;AiG9+hCI;EACI,gBAAA;AjGi/hCR;;AiGl/hCI;EACI,gBAAA;AjGq/hCR;;AiGt/hCI;EACI,gBAAA;AjGy/hCR;;AiG1/hCI;EACI,gBAAA;AjG6/hCR;;AiG9/hCI;EACI,gBAAA;AjGigiCR;;AiGlgiCI;EACI,gBAAA;AjGqgiCR;;AiGtgiCI;EACI,gBAAA;AjGygiCR;;AiG1giCI;EACI,gBAAA;AjG6giCR;;AiG9giCI;EACI,gBAAA;AjGihiCR;;AiGlhiCI;EACI,gBAAA;AjGqhiCR;;AiGthiCI;EACI,iBAAA;AjGyhiCR;;AiG1hiCI;EACI,iBAAA;AjG6hiCR;;AiG9hiCI;EACI,gBAAA;AjGiiiCR;;AiGliiCI;EACI,gBAAA;AjGqiiCR;;AiGtiiCI;EACI,gBAAA;AjGyiiCR;;AiG1iiCI;EACI,iBAAA;AjG6iiCR;;AiG9iiCI;EACI,iBAAA;AjGijiCR;;AiGljiCI;EACI,iBAAA;AjGqjiCR;;AiGtjiCI;EACI,iBAAA;AjGyjiCR;;AiG1jiCI;EACI,gBAAA;AjG6jiCR;;AiG9jiCI;EACI,gBAAA;AjGikiCR;;AiGlkiCI;EACI,gBAAA;AjGqkiCR;;AiGtkiCI;EACI,gBAAA;AjGykiCR;;AiG1kiCI;EACI,gBAAA;AjG6kiCR;;AiG9kiCI;EACI,gBAAA;AjGiliCR;;AiGlliCI;EACI,gBAAA;AjGqliCR;;AiGtliCI;EACI,iBAAA;AjGyliCR;;AiG1liCI;EACI,gBAAA;AjG6liCR;;AiG9liCI;EACI,gBAAA;AjGimiCR;;AiGlmiCI;EACI,gBAAA;AjGqmiCR;;AiGtmiCI;EACI,gBAAA;AjGymiCR;;AiG1miCI;EACI,gBAAA;AjG6miCR;;AiG9miCI;EACI,gBAAA;AjGiniCR;;AiGlniCI;EACI,gBAAA;AjGqniCR;;AiGtniCI;EACI,gBAAA;AjGyniCR;;AiG1niCI;EACI,gBAAA;AjG6niCR;;AiG9niCI;EACI,iBAAA;AjGioiCR;;AiGloiCI;EACI,gBAAA;AjGqoiCR;;AiGtoiCI;EACI,gBAAA;AjGyoiCR;;AiG1oiCI;EACI,gBAAA;AjG6oiCR;;AiG9oiCI;EACI,gBAAA;AjGipiCR;;AiGlpiCI;EACI,iBAAA;AjGqpiCR;;AiGtpiCI;EACI,gBAAA;AjGypiCR;;AiG1piCI;EACI,gBAAA;AjG6piCR;;AiG9piCI;EACI,iBAAA;AjGiqiCR;;AiGlqiCI;EACI,gBAAA;AjGqqiCR;;AiGtqiCI;EACI,gBAAA;AjGyqiCR;;AiG1qiCI;EACI,gBAAA;AjG6qiCR;;AiG9qiCI;EACI,gBAAA;AjGiriCR;;AiGlriCI;EACI,gBAAA;AjGqriCR;;AiGtriCI;EACI,gBAAA;AjGyriCR;;AiG1riCI;EACI,gBAAA;AjG6riCR;;AiG9riCI;EACI,gBAAA;AjGisiCR;;AiGlsiCI;EACI,gBAAA;AjGqsiCR;;AiGtsiCI;EACI,gBAAA;AjGysiCR;;AiG1siCI;EACI,gBAAA;AjG6siCR;;AiG9siCI;EACI,gBAAA;AjGitiCR;;AiGltiCI;EACI,gBAAA;AjGqtiCR;;AiGttiCI;EACI,gBAAA;AjGytiCR;;AiG1tiCI;EACI,gBAAA;AjG6tiCR;;AiG9tiCI;EACI,gBAAA;AjGiuiCR;;AiGluiCI;EACI,gBAAA;AjGquiCR;;AiGtuiCI;EACI,gBAAA;AjGyuiCR;;AiG1uiCI;EACI,gBAAA;AjG6uiCR;;AiG9uiCI;EACI,gBAAA;AjGiviCR;;AiGlviCI;EACI,gBAAA;AjGqviCR;;AiGtviCI;EACI,gBAAA;AjGyviCR;;AiG1viCI;EACI,gBAAA;AjG6viCR;;AiG9viCI;EACI,gBAAA;AjGiwiCR;;AiGlwiCI;EACI,gBAAA;AjGqwiCR;;AiGtwiCI;EACI,gBAAA;AjGywiCR;;AiG1wiCI;EACI,gBAAA;AjG6wiCR;;AiG9wiCI;EACI,gBAAA;AjGixiCR;;AiGlxiCI;EACI,gBAAA;AjGqxiCR;;AiGtxiCI;EACI,iBAAA;AjGyxiCR;;AiG1xiCI;EACI,gBAAA;AjG6xiCR;;AiG9xiCI;EACI,gBAAA;AjGiyiCR;;AiGlyiCI;EACI,gBAAA;AjGqyiCR;;AiGtyiCI;EACI,gBAAA;AjGyyiCR;;AiG1yiCI;EACI,gBAAA;AjG6yiCR;;AiG9yiCI;EACI,iBAAA;AjGiziCR;;AiGlziCI;EACI,iBAAA;AjGqziCR;;AiGtziCI;EACI,iBAAA;AjGyziCR;;AiG1ziCI;EACI,gBAAA;AjG6ziCR;;AiG9ziCI;EACI,gBAAA;AjGi0iCR;;AiGl0iCI;EACI,gBAAA;AjGq0iCR;;AiGt0iCI;EACI,gBAAA;AjGy0iCR;;AiG10iCI;EACI,gBAAA;AjG60iCR;;AiG90iCI;EACI,gBAAA;AjGi1iCR;;AiGl1iCI;EACI,gBAAA;AjGq1iCR;;AiGt1iCI;EACI,gBAAA;AjGy1iCR;;AiG11iCI;EACI,gBAAA;AjG61iCR;;AiG91iCI;EACI,gBAAA;AjGi2iCR;;AiGl2iCI;EACI,gBAAA;AjGq2iCR;;AiGt2iCI;EACI,gBAAA;AjGy2iCR;;AiG12iCI;EACI,gBAAA;AjG62iCR;;AiG92iCI;EACI,gBAAA;AjGi3iCR;;AiGl3iCI;EACI,gBAAA;AjGq3iCR;;AiGt3iCI;EACI,gBAAA;AjGy3iCR;;AiG13iCI;EACI,gBAAA;AjG63iCR;;AiG93iCI;EACI,gBAAA;AjGi4iCR;;AiGl4iCI;EACI,gBAAA;AjGq4iCR;;AiGt4iCI;EACI,gBAAA;AjGy4iCR;;AiG14iCI;EACI,iBAAA;AjG64iCR;;AiG94iCI;EACI,iBAAA;AjGi5iCR;;AiGl5iCI;EACI,gBAAA;AjGq5iCR;;AiGt5iCI;EACI,gBAAA;AjGy5iCR;;AiG15iCI;EACI,gBAAA;AjG65iCR;;AiG95iCI;EACI,gBAAA;AjGi6iCR;;AiGl6iCI;EACI,iBAAA;AjGq6iCR;;AiGt6iCI;EACI,iBAAA;AjGy6iCR;;AiG16iCI;EACI,iBAAA;AjG66iCR;;AiG96iCI;EACI,iBAAA;AjGi7iCR;;AiGl7iCI;EACI,iBAAA;AjGq7iCR;;AiGt7iCI;EACI,iBAAA;AjGy7iCR;;AiG17iCI;EACI,gBAAA;AjG67iCR;;AiG97iCI;EACI,gBAAA;AjGi8iCR;;AiGl8iCI;EACI,gBAAA;AjGq8iCR;;AiGt8iCI;EACI,gBAAA;AjGy8iCR;;AiG18iCI;EACI,gBAAA;AjG68iCR;;AiG98iCI;EACI,iBAAA;AjGi9iCR;;AiGl9iCI;EACI,gBAAA;AjGq9iCR;;AiGt9iCI;EACI,gBAAA;AjGy9iCR;;AiG19iCI;EACI,iBAAA;AjG69iCR;;AiG99iCI;EACI,gBAAA;AjGi+iCR;;AiGl+iCI;EACI,gBAAA;AjGq+iCR;;AiGt+iCI;EACI,gBAAA;AjGy+iCR;;AiG1+iCI;EACI,gBAAA;AjG6+iCR;;AiG9+iCI;EACI,gBAAA;AjGi/iCR;;AiGl/iCI;EACI,gBAAA;AjGq/iCR;;AiGt/iCI;EACI,gBAAA;AjGy/iCR;;AiG1/iCI;EACI,gBAAA;AjG6/iCR;;AiG9/iCI;EACI,iBAAA;AjGigjCR;;AiGlgjCI;EACI,gBAAA;AjGqgjCR;;AiGtgjCI;EACI,gBAAA;AjGygjCR;;AiG1gjCI;EACI,gBAAA;AjG6gjCR;;AiG9gjCI;EACI,iBAAA;AjGihjCR;;AiGlhjCI;EACI,iBAAA;AjGqhjCR;;AiGthjCI;EACI,gBAAA;AjGyhjCR;;AiG1hjCI;EACI,gBAAA;AjG6hjCR;;AiG9hjCI;EACI,gBAAA;AjGiijCR;;AiGlijCI;EACI,gBAAA;AjGqijCR;;AiGtijCI;EACI,gBAAA;AjGyijCR;;AiG1ijCI;EACI,gBAAA;AjG6ijCR;;AiG9ijCI;EACI,iBAAA;AjGijjCR;;AiGljjCI;EACI,gBAAA;AjGqjjCR;;AiGtjjCI;EACI,gBAAA;AjGyjjCR;;AiG1jjCI;EACI,gBAAA;AjG6jjCR;;AiG9jjCI;EACI,gBAAA;AjGikjCR;;AiGlkjCI;EACI,gBAAA;AjGqkjCR;;AiGtkjCI;EACI,gBAAA;AjGykjCR;;AiG1kjCI;EACI,gBAAA;AjG6kjCR;;AiG9kjCI;EACI,gBAAA;AjGiljCR;;AiGlljCI;EACI,gBAAA;AjGqljCR;;AiGtljCI;EACI,gBAAA;AjGyljCR;;AiG1ljCI;EACI,gBAAA;AjG6ljCR;;AiG9ljCI;EACI,gBAAA;AjGimjCR;;AiGlmjCI;EACI,gBAAA;AjGqmjCR;;AiGtmjCI;EACI,gBAAA;AjGymjCR;;AiG1mjCI;EACI,gBAAA;AjG6mjCR;;AiG9mjCI;EACI,gBAAA;AjGinjCR;;AiGlnjCI;EACI,gBAAA;AjGqnjCR;;AiGtnjCI;EACI,gBAAA;AjGynjCR;;AiG1njCI;EACI,iBAAA;AjG6njCR;;AiG9njCI;EACI,gBAAA;AjGiojCR;;AiGlojCI;EACI,gBAAA;AjGqojCR;;AiGtojCI;EACI,gBAAA;AjGyojCR;;AiG1ojCI;EACI,gBAAA;AjG6ojCR;;AiG9ojCI;EACI,gBAAA;AjGipjCR;;AiGlpjCI;EACI,gBAAA;AjGqpjCR;;AiGtpjCI;EACI,gBAAA;AjGypjCR;;AiG1pjCI;EACI,gBAAA;AjG6pjCR;;AiG9pjCI;EACI,gBAAA;AjGiqjCR;;AiGlqjCI;EACI,gBAAA;AjGqqjCR;;AiGtqjCI;EACI,iBAAA;AjGyqjCR;;AiG1qjCI;EACI,iBAAA;AjG6qjCR;;AiG9qjCI;EACI,gBAAA;AjGirjCR;;AiGlrjCI;EACI,gBAAA;AjGqrjCR;;AiGtrjCI;EACI,gBAAA;AjGyrjCR;;AiG1rjCI;EACI,gBAAA;AjG6rjCR;;AiG9rjCI;EACI,gBAAA;AjGisjCR;;AiGlsjCI;EACI,gBAAA;AjGqsjCR;;AiGtsjCI;EACI,iBAAA;AjGysjCR;;AiG1sjCI;EACI,iBAAA;AjG6sjCR;;AiG9sjCI;EACI,gBAAA;AjGitjCR;;AiGltjCI;EACI,gBAAA;AjGqtjCR;;AiGttjCI;EACI,gBAAA;AjGytjCR;;AiG1tjCI;EACI,gBAAA;AjG6tjCR;;AiG9tjCI;EACI,gBAAA;AjGiujCR;;AiGlujCI;EACI,gBAAA;AjGqujCR;;AiGtujCI;EACI,gBAAA;AjGyujCR;;AiG1ujCI;EACI,gBAAA;AjG6ujCR;;AiG9ujCI;EACI,iBAAA;AjGivjCR;;AiGlvjCI;EACI,iBAAA;AjGqvjCR;;AiGtvjCI;EACI,gBAAA;AjGyvjCR;;AiG1vjCI;EACI,gBAAA;AjG6vjCR;;AiG9vjCI;EACI,gBAAA;AjGiwjCR;;AiGlwjCI;EACI,gBAAA;AjGqwjCR;;AiGtwjCI;EACI,gBAAA;AjGywjCR;;AiG1wjCI;EACI,gBAAA;AjG6wjCR;;AiG9wjCI;EACI,gBAAA;AjGixjCR;;AiGlxjCI;EACI,gBAAA;AjGqxjCR;;AiGtxjCI;EACI,gBAAA;AjGyxjCR;;AiG1xjCI;EACI,iBAAA;AjG6xjCR;;AiG9xjCI;EACI,gBAAA;AjGiyjCR;;AiGlyjCI;EACI,gBAAA;AjGqyjCR;;AiGtyjCI;EACI,iBAAA;AjGyyjCR;;AiG1yjCI;EACI,iBAAA;AjG6yjCR;;AiG9yjCI;EACI,gBAAA;AjGizjCR;;AiGlzjCI;EACI,gBAAA;AjGqzjCR;;AiGtzjCI;EACI,gBAAA;AjGyzjCR;;AiG1zjCI;EACI,gBAAA;AjG6zjCR;;AiG9zjCI;EACI,iBAAA;AjGi0jCR;;AiGl0jCI;EACI,iBAAA;AjGq0jCR;;AiGt0jCI;EACI,gBAAA;AjGy0jCR;;AiG10jCI;EACI,gBAAA;AjG60jCR;;AiG90jCI;EACI,gBAAA;AjGi1jCR;;AiGl1jCI;EACI,gBAAA;AjGq1jCR;;AiGt1jCI;EACI,gBAAA;AjGy1jCR;;AiG11jCI;EACI,gBAAA;AjG61jCR;;AiG91jCI;EACI,gBAAA;AjGi2jCR;;AiGl2jCI;EACI,gBAAA;AjGq2jCR;;AiGt2jCI;EACI,gBAAA;AjGy2jCR;;AiG12jCI;EACI,gBAAA;AjG62jCR;;AiG92jCI;EACI,gBAAA;AjGi3jCR;;AiGl3jCI;EACI,iBAAA;AjGq3jCR;;AiGt3jCI;EACI,gBAAA;AjGy3jCR;;AiG13jCI;EACI,gBAAA;AjG63jCR;;AiG93jCI;EACI,gBAAA;AjGi4jCR;;AiGl4jCI;EACI,gBAAA;AjGq4jCR;;AiGt4jCI;EACI,gBAAA;AjGy4jCR;;AiG14jCI;EACI,gBAAA;AjG64jCR;;AiG94jCI;EACI,gBAAA;AjGi5jCR;;AiGl5jCI;EACI,gBAAA;AjGq5jCR;;AiGt5jCI;EACI,gBAAA;AjGy5jCR;;AiG15jCI;EACI,iBAAA;AjG65jCR;;AiG95jCI;EACI,iBAAA;AjGi6jCR;;AiGl6jCI;EACI,iBAAA;AjGq6jCR;;AiGt6jCI;EACI,iBAAA;AjGy6jCR;;AiG16jCI;EACI,iBAAA;AjG66jCR;;AiG96jCI;EACI,gBAAA;AjGi7jCR;;AiGl7jCI;EACI,gBAAA;AjGq7jCR;;AiGt7jCI;EACI,iBAAA;AjGy7jCR;;AiG17jCI;EACI,iBAAA;AjG67jCR;;AiG97jCI;EACI,iBAAA;AjGi8jCR;;AiGl8jCI;EACI,iBAAA;AjGq8jCR;;AiGt8jCI;EACI,iBAAA;AjGy8jCR;;AiG18jCI;EACI,iBAAA;AjG68jCR;;AiG98jCI;EACI,iBAAA;AjGi9jCR;;AiGl9jCI;EACI,gBAAA;AjGq9jCR;;AiGt9jCI;EACI,iBAAA;AjGy9jCR;;AiG19jCI;EACI,gBAAA;AjG69jCR;;AiG99jCI;EACI,gBAAA;AjGi+jCR;;AiGl+jCI;EACI,gBAAA;AjGq+jCR;;AiGt+jCI;EACI,gBAAA;AjGy+jCR;;AiG1+jCI;EACI,gBAAA;AjG6+jCR;;AiG9+jCI;EACI,iBAAA;AjGi/jCR;;AiGl/jCI;EACI,iBAAA;AjGq/jCR;;AiGt/jCI;EACI,gBAAA;AjGy/jCR;;AiG1/jCI;EACI,iBAAA;AjG6/jCR;;AiG9/jCI;EACI,gBAAA;AjGigkCR;;AiGlgkCI;EACI,gBAAA;AjGqgkCR;;AiGtgkCI;EACI,gBAAA;AjGygkCR;;AiG1gkCI;EACI,iBAAA;AjG6gkCR;;AiG9gkCI;EACI,iBAAA;AjGihkCR;;AiGlhkCI;EACI,gBAAA;AjGqhkCR;;AiGthkCI;EACI,gBAAA;AjGyhkCR;;AiG1hkCI;EACI,gBAAA;AjG6hkCR;;AiG9hkCI;EACI,gBAAA;AjGiikCR;;AiGlikCI;EACI,gBAAA;AjGqikCR;;AiGtikCI;EACI,gBAAA;AjGyikCR;;AiG1ikCI;EACI,gBAAA;AjG6ikCR;;AiG9ikCI;EACI,gBAAA;AjGijkCR;;AiGljkCI;EACI,gBAAA;AjGqjkCR;;AiGtjkCI;EACI,gBAAA;AjGyjkCR;;AiG1jkCI;EACI,gBAAA;AjG6jkCR;;AiG9jkCI;EACI,gBAAA;AjGikkCR;;AiGlkkCI;EACI,gBAAA;AjGqkkCR;;AiGtkkCI;EACI,gBAAA;AjGykkCR;;AiG1kkCI;EACI,gBAAA;AjG6kkCR;;AiG9kkCI;EACI,gBAAA;AjGilkCR;;AiGllkCI;EACI,gBAAA;AjGqlkCR;;AiGtlkCI;EACI,iBAAA;AjGylkCR;;AiG1lkCI;EACI,iBAAA;AjG6lkCR;;AiG9lkCI;EACI,gBAAA;AjGimkCR;;AiGlmkCI;EACI,gBAAA;AjGqmkCR;;AiGtmkCI;EACI,gBAAA;AjGymkCR;;AiG1mkCI;EACI,iBAAA;AjG6mkCR;;AiG9mkCI;EACI,iBAAA;AjGinkCR;;AiGlnkCI;EACI,gBAAA;AjGqnkCR;;AiGtnkCI;EACI,gBAAA;AjGynkCR;;AiG1nkCI;EACI,gBAAA;AjG6nkCR;;AiG9nkCI;EACI,gBAAA;AjGiokCR;;AiGlokCI;EACI,gBAAA;AjGqokCR;;AiGtokCI;EACI,iBAAA;AjGyokCR;;AiG1okCI;EACI,iBAAA;AjG6okCR;;AiG9okCI;EACI,iBAAA;AjGipkCR;;AiGlpkCI;EACI,iBAAA;AjGqpkCR;;AiGtpkCI;EACI,gBAAA;AjGypkCR;;AiG1pkCI;EACI,gBAAA;AjG6pkCR;;AiG9pkCI;EACI,gBAAA;AjGiqkCR;;AiGlqkCI;EACI,iBAAA;AjGqqkCR;;AiGtqkCI;EACI,gBAAA;AjGyqkCR;;AiG1qkCI;EACI,gBAAA;AjG6qkCR;;AiG9qkCI;EACI,gBAAA;AjGirkCR;;AiGlrkCI;EACI,gBAAA;AjGqrkCR;;AiGtrkCI;EACI,gBAAA;AjGyrkCR;;AiG1rkCI;EACI,gBAAA;AjG6rkCR;;AiG9rkCI;EACI,gBAAA;AjGiskCR;;AiGlskCI;EACI,gBAAA;AjGqskCR;;AiGtskCI;EACI,iBAAA;AjGyskCR;;AiG1skCI;EACI,gBAAA;AjG6skCR;;AiG9skCI;EACI,gBAAA;AjGitkCR;;AiGltkCI;EACI,gBAAA;AjGqtkCR;;AiGttkCI;EACI,gBAAA;AjGytkCR;;AiG1tkCI;EACI,gBAAA;AjG6tkCR;;AiG9tkCI;EACI,gBAAA;AjGiukCR;;AiGlukCI;EACI,iBAAA;AjGqukCR;;AiGtukCI;EACI,iBAAA;AjGyukCR;;AiG1ukCI;EACI,iBAAA;AjG6ukCR;;AiG9ukCI;EACI,gBAAA;AjGivkCR;;AiGlvkCI;EACI,gBAAA;AjGqvkCR;;AiGtvkCI;EACI,gBAAA;AjGyvkCR;;AiG1vkCI;EACI,gBAAA;AjG6vkCR;;AiG9vkCI;EACI,gBAAA;AjGiwkCR;;AiGlwkCI;EACI,gBAAA;AjGqwkCR;;AiGtwkCI;EACI,gBAAA;AjGywkCR;;AiG1wkCI;EACI,gBAAA;AjG6wkCR;;AiG9wkCI;EACI,gBAAA;AjGixkCR;;AiGlxkCI;EACI,gBAAA;AjGqxkCR;;AiGtxkCI;EACI,gBAAA;AjGyxkCR;;AiG1xkCI;EACI,gBAAA;AjG6xkCR;;AiG9xkCI;EACI,gBAAA;AjGiykCR;;AiGlykCI;EACI,gBAAA;AjGqykCR;;AiGtykCI;EACI,gBAAA;AjGyykCR;;AiG1ykCI;EACI,gBAAA;AjG6ykCR;;AiG9ykCI;EACI,gBAAA;AjGizkCR;;AiGlzkCI;EACI,gBAAA;AjGqzkCR;;AiGtzkCI;EACI,gBAAA;AjGyzkCR;;AiG1zkCI;EACI,gBAAA;AjG6zkCR;;AiG9zkCI;EACI,gBAAA;AjGi0kCR;;AiGl0kCI;EACI,gBAAA;AjGq0kCR;;AiGt0kCI;EACI,gBAAA;AjGy0kCR;;AiG10kCI;EACI,gBAAA;AjG60kCR;;AiG90kCI;EACI,gBAAA;AjGi1kCR;;AiGl1kCI;EACI,gBAAA;AjGq1kCR;;AiGt1kCI;EACI,iBAAA;AjGy1kCR;;AiG11kCI;EACI,gBAAA;AjG61kCR;;AiG91kCI;EACI,iBAAA;AjGi2kCR;;AiGl2kCI;EACI,iBAAA;AjGq2kCR;;AiGt2kCI;EACI,iBAAA;AjGy2kCR;;AiG12kCI;EACI,gBAAA;AjG62kCR;;AiG92kCI;EACI,gBAAA;AjGi3kCR;;AiGl3kCI;EACI,iBAAA;AjGq3kCR;;AiGt3kCI;EACI,gBAAA;AjGy3kCR;;AiG13kCI;EACI,iBAAA;AjG63kCR;;AiG93kCI;EACI,iBAAA;AjGi4kCR;;AiGl4kCI;EACI,gBAAA;AjGq4kCR;;AiGt4kCI;EACI,gBAAA;AjGy4kCR;;AiG14kCI;EACI,iBAAA;AjG64kCR;;AiG94kCI;EACI,gBAAA;AjGi5kCR;;AiGl5kCI;EACI,gBAAA;AjGq5kCR;;AiGt5kCI;EACI,gBAAA;AjGy5kCR;;AiG15kCI;EACI,gBAAA;AjG65kCR;;AiG95kCI;EACI,gBAAA;AjGi6kCR;;AiGl6kCI;EACI,gBAAA;AjGq6kCR;;AiGt6kCI;EACI,gBAAA;AjGy6kCR;;AiG16kCI;EACI,gBAAA;AjG66kCR;;AiG96kCI;EACI,gBAAA;AjGi7kCR;;AiGl7kCI;EACI,gBAAA;AjGq7kCR;;AiGt7kCI;EACI,gBAAA;AjGy7kCR;;AiG17kCI;EACI,gBAAA;AjG67kCR;;AiG97kCI;EACI,iBAAA;AjGi8kCR;;AiGl8kCI;EACI,gBAAA;AjGq8kCR;;AiGt8kCI;EACI,gBAAA;AjGy8kCR;;AiG18kCI;EACI,gBAAA;AjG68kCR;;AiG98kCI;EACI,iBAAA;AjGi9kCR;;AiGl9kCI;EACI,gBAAA;AjGq9kCR;;AiGt9kCI;EACI,gBAAA;AjGy9kCR;;AiG19kCI;EACI,gBAAA;AjG69kCR;;AiG99kCI;EACI,gBAAA;AjGi+kCR;;AiGl+kCI;EACI,gBAAA;AjGq+kCR;;AiGt+kCI;EACI,gBAAA;AjGy+kCR;;AiG1+kCI;EACI,gBAAA;AjG6+kCR;;AiG9+kCI;EACI,gBAAA;AjGi/kCR;;AiGl/kCI;EACI,gBAAA;AjGq/kCR;;AiGt/kCI;EACI,gBAAA;AjGy/kCR;;AiG1/kCI;EACI,gBAAA;AjG6/kCR;;AiG9/kCI;EACI,iBAAA;AjGiglCR;;AiGlglCI;EACI,gBAAA;AjGqglCR;;AiGtglCI;EACI,gBAAA;AjGyglCR;;AiG1glCI;EACI,gBAAA;AjG6glCR;;AiG9glCI;EACI,gBAAA;AjGihlCR;;AiGlhlCI;EACI,gBAAA;AjGqhlCR;;AiGthlCI;EACI,iBAAA;AjGyhlCR;;AiG1hlCI;EACI,gBAAA;AjG6hlCR;;AiG9hlCI;EACI,gBAAA;AjGiilCR;;AiGlilCI;EACI,gBAAA;AjGqilCR;;AiGtilCI;EACI,gBAAA;AjGyilCR;;AiG1ilCI;EACI,gBAAA;AjG6ilCR;;AiG9ilCI;EACI,iBAAA;AjGijlCR;;AiGljlCI;EACI,gBAAA;AjGqjlCR;;AiGtjlCI;EACI,iBAAA;AjGyjlCR;;AiG1jlCI;EACI,gBAAA;AjG6jlCR;;AiG9jlCI;EACI,gBAAA;AjGiklCR;;AiGlklCI;EACI,iBAAA;AjGqklCR;;AiGtklCI;EACI,gBAAA;AjGyklCR;;AiG1klCI;EACI,gBAAA;AjG6klCR;;AiG9klCI;EACI,gBAAA;AjGillCR;;AiGlllCI;EACI,gBAAA;AjGqllCR;;AiGtllCI;EACI,gBAAA;AjGyllCR;;AiG1llCI;EACI,gBAAA;AjG6llCR;;AiG9llCI;EACI,iBAAA;AjGimlCR;;AiGlmlCI;EACI,gBAAA;AjGqmlCR;;AiGtmlCI;EACI,iBAAA;AjGymlCR;;AiG1mlCI;EACI,gBAAA;AjG6mlCR;;AiG9mlCI;EACI,gBAAA;AjGinlCR;;AiGlnlCI;EACI,gBAAA;AjGqnlCR;;AiGtnlCI;EACI,gBAAA;AjGynlCR;;AiG1nlCI;EACI,gBAAA;AjG6nlCR;;AiG9nlCI;EACI,gBAAA;AjGiolCR;;AiGlolCI;EACI,gBAAA;AjGqolCR;;AiGtolCI;EACI,gBAAA;AjGyolCR;;AiG1olCI;EACI,gBAAA;AjG6olCR;;AiG9olCI;EACI,gBAAA;AjGiplCR;;AiGlplCI;EACI,gBAAA;AjGqplCR;;AiGtplCI;EACI,gBAAA;AjGyplCR;;AiG1plCI;EACI,gBAAA;AjG6plCR;;AiG9plCI;EACI,gBAAA;AjGiqlCR;;AiGlqlCI;EACI,gBAAA;AjGqqlCR;;AiGtqlCI;EACI,gBAAA;AjGyqlCR;;AiG1qlCI;EACI,gBAAA;AjG6qlCR;;AiG9qlCI;EACI,gBAAA;AjGirlCR;;AiGlrlCI;EACI,gBAAA;AjGqrlCR;;AiGtrlCI;EACI,gBAAA;AjGyrlCR;;AiG1rlCI;EACI,gBAAA;AjG6rlCR;;AiG9rlCI;EACI,gBAAA;AjGislCR;;AiGlslCI;EACI,iBAAA;AjGqslCR;;AiGtslCI;EACI,iBAAA;AjGyslCR;;AiG1slCI;EACI,gBAAA;AjG6slCR;;AiG9slCI;EACI,gBAAA;AjGitlCR;;AiGltlCI;EACI,gBAAA;AjGqtlCR;;AiGttlCI;EACI,gBAAA;AjGytlCR;;AiG1tlCI;EACI,gBAAA;AjG6tlCR;;AiG9tlCI;EACI,gBAAA;AjGiulCR;;AiGlulCI;EACI,gBAAA;AjGqulCR;;AiGtulCI;EACI,gBAAA;AjGyulCR;;AiG1ulCI;EACI,gBAAA;AjG6ulCR;;AiG9ulCI;EACI,gBAAA;AjGivlCR;;AiGlvlCI;EACI,gBAAA;AjGqvlCR;;AiGtvlCI;EACI,gBAAA;AjGyvlCR;;AiG1vlCI;EACI,gBAAA;AjG6vlCR;;AiG9vlCI;EACI,gBAAA;AjGiwlCR;;AiGlwlCI;EACI,gBAAA;AjGqwlCR;;AiGtwlCI;EACI,iBAAA;AjGywlCR;;AiG1wlCI;EACI,iBAAA;AjG6wlCR;;AiG9wlCI;EACI,gBAAA;AjGixlCR;;AiGlxlCI;EACI,gBAAA;AjGqxlCR;;AiGtxlCI;EACI,gBAAA;AjGyxlCR;;AiG1xlCI;EACI,gBAAA;AjG6xlCR;;AiG9xlCI;EACI,gBAAA;AjGiylCR;;AiGlylCI;EACI,gBAAA;AjGqylCR;;AiGtylCI;EACI,gBAAA;AjGyylCR;;AiG1ylCI;EACI,gBAAA;AjG6ylCR;;AiG9ylCI;EACI,iBAAA;AjGizlCR;;AiGlzlCI;EACI,gBAAA;AjGqzlCR;;AiGtzlCI;EACI,gBAAA;AjGyzlCR;;AiG1zlCI;EACI,gBAAA;AjG6zlCR;;AiG9zlCI;EACI,iBAAA;AjGi0lCR;;AiGl0lCI;EACI,gBAAA;AjGq0lCR;;AiGt0lCI;EACI,gBAAA;AjGy0lCR;;AiG10lCI;EACI,gBAAA;AjG60lCR;;AiG90lCI;EACI,gBAAA;AjGi1lCR;;AiGl1lCI;EACI,gBAAA;AjGq1lCR;;AiGt1lCI;EACI,gBAAA;AjGy1lCR;;AiG11lCI;EACI,gBAAA;AjG61lCR;;AiG91lCI;EACI,gBAAA;AjGi2lCR;;AiGl2lCI;EACI,gBAAA;AjGq2lCR;;AiGt2lCI;EACI,iBAAA;AjGy2lCR;;AiG12lCI;EACI,iBAAA;AjG62lCR;;AiG92lCI;EACI,iBAAA;AjGi3lCR;;AiGl3lCI;EACI,gBAAA;AjGq3lCR;;AiGt3lCI;EACI,gBAAA;AjGy3lCR;;AiG13lCI;EACI,iBAAA;AjG63lCR;;AiG93lCI;EACI,gBAAA;AjGi4lCR;;AiGl4lCI;EACI,gBAAA;AjGq4lCR;;AiGt4lCI;EACI,gBAAA;AjGy4lCR;;AiG14lCI;EACI,gBAAA;AjG64lCR;;AiG94lCI;EACI,iBAAA;AjGi5lCR;;AiGl5lCI;EACI,iBAAA;AjGq5lCR;;AiGt5lCI;EACI,iBAAA;AjGy5lCR;;AiG15lCI;EACI,iBAAA;AjG65lCR;;AiG95lCI;EACI,iBAAA;AjGi6lCR;;AiGl6lCI;EACI,iBAAA;AjGq6lCR;;AiGt6lCI;EACI,iBAAA;AjGy6lCR;;AiG16lCI;EACI,iBAAA;AjG66lCR;;AiG96lCI;EACI,iBAAA;AjGi7lCR;;AiGl7lCI;EACI,iBAAA;AjGq7lCR;;AiGt7lCI;EACI,iBAAA;AjGy7lCR;;AiG17lCI;EACI,iBAAA;AjG67lCR;;AiG97lCI;EACI,gBAAA;AjGi8lCR;;AiGl8lCI;EACI,gBAAA;AjGq8lCR;;AiGt8lCI;EACI,gBAAA;AjGy8lCR;;AiG18lCI;EACI,gBAAA;AjG68lCR;;AiG98lCI;EACI,gBAAA;AjGi9lCR;;AiGl9lCI;EACI,iBAAA;AjGq9lCR;;AiGt9lCI;EACI,gBAAA;AjGy9lCR;;AiG19lCI;EACI,gBAAA;AjG69lCR;;AiG99lCI;EACI,gBAAA;AjGi+lCR;;AiGl+lCI;EACI,gBAAA;AjGq+lCR;;AiGt+lCI;EACI,gBAAA;AjGy+lCR;;AiG1+lCI;EACI,iBAAA;AjG6+lCR;;AiG9+lCI;EACI,gBAAA;AjGi/lCR;;AiGl/lCI;EACI,gBAAA;AjGq/lCR;;AiGt/lCI;EACI,iBAAA;AjGy/lCR;;AiG1/lCI;EACI,gBAAA;AjG6/lCR;;AiG9/lCI;EACI,gBAAA;AjGigmCR;;AiGlgmCI;EACI,gBAAA;AjGqgmCR;;AiGtgmCI;EACI,gBAAA;AjGygmCR;;AiG1gmCI;EACI,gBAAA;AjG6gmCR;;AiG9gmCI;EACI,gBAAA;AjGihmCR;;AiGlhmCI;EACI,gBAAA;AjGqhmCR;;AiGthmCI;EACI,gBAAA;AjGyhmCR;;AiG1hmCI;EACI,gBAAA;AjG6hmCR;;AiG9hmCI;EACI,gBAAA;AjGiimCR;;AiGlimCI;EACI,gBAAA;AjGqimCR;;AiGtimCI;EACI,gBAAA;AjGyimCR;;AiG1imCI;EACI,gBAAA;AjG6imCR;;AiG9imCI;EACI,gBAAA;AjGijmCR;;AiGljmCI;EACI,gBAAA;AjGqjmCR;;AiGtjmCI;EACI,iBAAA;AjGyjmCR;;AiG1jmCI;EACI,iBAAA;AjG6jmCR;;AiG9jmCI;EACI,iBAAA;AjGikmCR;;AiGlkmCI;EACI,iBAAA;AjGqkmCR;;AiGtkmCI;EACI,iBAAA;AjGykmCR;;AiG1kmCI;EACI,iBAAA;AjG6kmCR;;AiG9kmCI;EACI,gBAAA;AjGilmCR;;AiGllmCI;EACI,gBAAA;AjGqlmCR;;AiGtlmCI;EACI,gBAAA;AjGylmCR;;AiG1lmCI;EACI,gBAAA;AjG6lmCR;;AiG9lmCI;EACI,gBAAA;AjGimmCR;;AiGlmmCI;EACI,gBAAA;AjGqmmCR;;AiGtmmCI;EACI,gBAAA;AjGymmCR;;AiG1mmCI;EACI,gBAAA;AjG6mmCR;;AiG9mmCI;EACI,gBAAA;AjGinmCR;;AiGlnmCI;EACI,gBAAA;AjGqnmCR;;AiGtnmCI;EACI,gBAAA;AjGynmCR;;AiG1nmCI;EACI,gBAAA;AjG6nmCR;;AiG9nmCI;EACI,gBAAA;AjGiomCR;;AiGlomCI;EACI,gBAAA;AjGqomCR;;AiGtomCI;EACI,gBAAA;AjGyomCR;;AiG1omCI;EACI,gBAAA;AjG6omCR;;AiG9omCI;EACI,gBAAA;AjGipmCR;;AiGlpmCI;EACI,gBAAA;AjGqpmCR;;AiGtpmCI;EACI,iBAAA;AjGypmCR;;AiG1pmCI;EACI,gBAAA;AjG6pmCR;;AiG9pmCI;EACI,iBAAA;AjGiqmCR;;AiGlqmCI;EACI,gBAAA;AjGqqmCR;;AiGtqmCI;EACI,iBAAA;AjGyqmCR;;AiG1qmCI;EACI,iBAAA;AjG6qmCR;;AiG9qmCI;EACI,gBAAA;AjGirmCR;;AiGlrmCI;EACI,iBAAA;AjGqrmCR;;AiGtrmCI;EACI,gBAAA;AjGyrmCR;;AiG1rmCI;EACI,gBAAA;AjG6rmCR;;AiG9rmCI;EACI,gBAAA;AjGismCR;;AiGlsmCI;EACI,gBAAA;AjGqsmCR;;AiGtsmCI;EACI,gBAAA;AjGysmCR;;AiG1smCI;EACI,iBAAA;AjG6smCR;;AiG9smCI;EACI,iBAAA;AjGitmCR;;AiGltmCI;EACI,gBAAA;AjGqtmCR;;AiGttmCI;EACI,gBAAA;AjGytmCR;;AiG1tmCI;EACI,gBAAA;AjG6tmCR;;AiG9tmCI;EACI,gBAAA;AjGiumCR;;AiGlumCI;EACI,gBAAA;AjGqumCR;;AiGtumCI;EACI,gBAAA;AjGyumCR;;AiG1umCI;EACI,gBAAA;AjG6umCR;;AiG9umCI;EACI,gBAAA;AjGivmCR;;AiGlvmCI;EACI,gBAAA;AjGqvmCR;;AiGtvmCI;EACI,gBAAA;AjGyvmCR;;AiG1vmCI;EACI,gBAAA;AjG6vmCR;;AiG9vmCI;EACI,gBAAA;AjGiwmCR;;AiGlwmCI;EACI,gBAAA;AjGqwmCR;;AiGtwmCI;EACI,gBAAA;AjGywmCR;;AiG1wmCI;EACI,gBAAA;AjG6wmCR;;AiG9wmCI;EACI,gBAAA;AjGixmCR;;AiGlxmCI;EACI,gBAAA;AjGqxmCR;;AiGtxmCI;EACI,gBAAA;AjGyxmCR;;AiG1xmCI;EACI,iBAAA;AjG6xmCR;;AiG9xmCI;EACI,iBAAA;AjGiymCR;;AiGlymCI;EACI,gBAAA;AjGqymCR;;AiGtymCI;EACI,gBAAA;AjGyymCR;;AiG1ymCI;EACI,gBAAA;AjG6ymCR;;AiG9ymCI;EACI,gBAAA;AjGizmCR;;AiGlzmCI;EACI,gBAAA;AjGqzmCR;;AiGtzmCI;EACI,gBAAA;AjGyzmCR;;AiG1zmCI;EACI,gBAAA;AjG6zmCR;;AiG9zmCI;EACI,gBAAA;AjGi0mCR;;AiGl0mCI;EACI,gBAAA;AjGq0mCR;;AiGt0mCI;EACI,gBAAA;AjGy0mCR;;AiG10mCI;EACI,gBAAA;AjG60mCR;;AiG90mCI;EACI,gBAAA;AjGi1mCR;;AiGl1mCI;EACI,gBAAA;AjGq1mCR;;AiGt1mCI;EACI,gBAAA;AjGy1mCR;;AiG11mCI;EACI,gBAAA;AjG61mCR;;AiG91mCI;EACI,gBAAA;AjGi2mCR;;AiGl2mCI;EACI,gBAAA;AjGq2mCR;;AiGt2mCI;EACI,gBAAA;AjGy2mCR;;AiG12mCI;EACI,iBAAA;AjG62mCR;;AiG92mCI;EACI,iBAAA;AjGi3mCR;;AiGl3mCI;EACI,gBAAA;AjGq3mCR;;AiGt3mCI;EACI,gBAAA;AjGy3mCR;;AiG13mCI;EACI,gBAAA;AjG63mCR;;AiG93mCI;EACI,iBAAA;AjGi4mCR;;AiGl4mCI;EACI,iBAAA;AjGq4mCR;;AiGt4mCI;EACI,gBAAA;AjGy4mCR;;AiG14mCI;EACI,gBAAA;AjG64mCR;;AiG94mCI;EACI,iBAAA;AjGi5mCR;;AiGl5mCI;EACI,iBAAA;AjGq5mCR;;AiGt5mCI;EACI,iBAAA;AjGy5mCR;;AiG15mCI;EACI,iBAAA;AjG65mCR;;AiG95mCI;EACI,iBAAA;AjGi6mCR;;AiGl6mCI;EACI,iBAAA;AjGq6mCR;;AiGt6mCI;EACI,gBAAA;AjGy6mCR;;AiG16mCI;EACI,gBAAA;AjG66mCR;;AiG96mCI;EACI,gBAAA;AjGi7mCR;;AiGl7mCI;EACI,iBAAA;AjGq7mCR;;AiGt7mCI;EACI,gBAAA;AjGy7mCR;;AiG17mCI;EACI,iBAAA;AjG67mCR;;AiG97mCI;EACI,gBAAA;AjGi8mCR;;AiGl8mCI;EACI,gBAAA;AjGq8mCR;;AiGt8mCI;EACI,gBAAA;AjGy8mCR;;AiG18mCI;EACI,gBAAA;AjG68mCR;;AiG98mCI;EACI,gBAAA;AjGi9mCR;;AiGl9mCI;EACI,gBAAA;AjGq9mCR;;AiGt9mCI;EACI,gBAAA;AjGy9mCR;;AiG19mCI;EACI,gBAAA;AjG69mCR;;AiG99mCI;EACI,gBAAA;AjGi+mCR;;AiGl+mCI;EACI,gBAAA;AjGq+mCR;;AiGt+mCI;EACI,gBAAA;AjGy+mCR;;AiG1+mCI;EACI,gBAAA;AjG6+mCR;;AiG9+mCI;EACI,gBAAA;AjGi/mCR;;AiGl/mCI;EACI,iBAAA;AjGq/mCR;;AiGt/mCI;EACI,gBAAA;AjGy/mCR;;AiG1/mCI;EACI,gBAAA;AjG6/mCR;;AiG9/mCI;EACI,gBAAA;AjGignCR;;AiGlgnCI;EACI,iBAAA;AjGqgnCR;;AiGtgnCI;EACI,iBAAA;AjGygnCR;;AiG1gnCI;EACI,iBAAA;AjG6gnCR;;AiG9gnCI;EACI,iBAAA;AjGihnCR;;AiGlhnCI;EACI,gBAAA;AjGqhnCR;;AiGthnCI;EACI,gBAAA;AjGyhnCR;;AiG1hnCI;EACI,gBAAA;AjG6hnCR;;AiG9hnCI;EACI,gBAAA;AjGiinCR;;AiGlinCI;EACI,gBAAA;AjGqinCR;;AiGtinCI;EACI,gBAAA;AjGyinCR;;AiG1inCI;EACI,gBAAA;AjG6inCR;;AiG9inCI;EACI,gBAAA;AjGijnCR;;AiGljnCI;EACI,gBAAA;AjGqjnCR;;AiGtjnCI;EACI,gBAAA;AjGyjnCR;;AiG1jnCI;EACI,gBAAA;AjG6jnCR;;AiG9jnCI;EACI,gBAAA;AjGiknCR;;AiGlknCI;EACI,gBAAA;AjGqknCR;;AiGtknCI;EACI,gBAAA;AjGyknCR;;AiG1knCI;EACI,gBAAA;AjG6knCR;;AiG9knCI;EACI,iBAAA;AjGilnCR;;AiGllnCI;EACI,iBAAA;AjGqlnCR;;AiGtlnCI;EACI,gBAAA;AjGylnCR;;AiG1lnCI;EACI,gBAAA;AjG6lnCR;;AiG9lnCI;EACI,gBAAA;AjGimnCR;;AiGlmnCI;EACI,gBAAA;AjGqmnCR;;AiGtmnCI;EACI,gBAAA;AjGymnCR;;AiG1mnCI;EACI,gBAAA;AjG6mnCR;;AiG9mnCI;EACI,gBAAA;AjGinnCR;;AiGlnnCI;EACI,gBAAA;AjGqnnCR;;AiGtnnCI;EACI,gBAAA;AjGynnCR;;AiG1nnCI;EACI,gBAAA;AjG6nnCR;;AiG9nnCI;EACI,gBAAA;AjGionCR;;AiGlonCI;EACI,gBAAA;AjGqonCR;;AiGtonCI;EACI,gBAAA;AjGyonCR;;AiG1onCI;EACI,gBAAA;AjG6onCR;;AiG9onCI;EACI,gBAAA;AjGipnCR;;AiGlpnCI;EACI,gBAAA;AjGqpnCR;;AiGtpnCI;EACI,gBAAA;AjGypnCR;;AiG1pnCI;EACI,iBAAA;AjG6pnCR;;AiG9pnCI;EACI,gBAAA;AjGiqnCR;;AiGlqnCI;EACI,gBAAA;AjGqqnCR;;AiGtqnCI;EACI,gBAAA;AjGyqnCR;;AiG1qnCI;EACI,gBAAA;AjG6qnCR;;AiG9qnCI;EACI,gBAAA;AjGirnCR;;AiGlrnCI;EACI,gBAAA;AjGqrnCR;;AiGtrnCI;EACI,gBAAA;AjGyrnCR;;AiG1rnCI;EACI,gBAAA;AjG6rnCR;;AiG9rnCI;EACI,gBAAA;AjGisnCR;;AiGlsnCI;EACI,gBAAA;AjGqsnCR;;AiGtsnCI;EACI,gBAAA;AjGysnCR;;AiG1snCI;EACI,iBAAA;AjG6snCR;;AiG9snCI;EACI,gBAAA;AjGitnCR;;AiGltnCI;EACI,iBAAA;AjGqtnCR;;AiGttnCI;EACI,gBAAA;AjGytnCR;;AiG1tnCI;EACI,gBAAA;AjG6tnCR;;AiG9tnCI;EACI,gBAAA;AjGiunCR;;AiGlunCI;EACI,gBAAA;AjGqunCR;;AiGtunCI;EACI,gBAAA;AjGyunCR;;AiG1unCI;EACI,gBAAA;AjG6unCR;;AiG9unCI;EACI,gBAAA;AjGivnCR;;AiGlvnCI;EACI,gBAAA;AjGqvnCR;;AiGtvnCI;EACI,gBAAA;AjGyvnCR;;AiG1vnCI;EACI,gBAAA;AjG6vnCR;;AiG9vnCI;EACI,gBAAA;AjGiwnCR;;AiGlwnCI;EACI,gBAAA;AjGqwnCR;;AiGtwnCI;EACI,gBAAA;AjGywnCR;;AiG1wnCI;EACI,gBAAA;AjG6wnCR;;AiG9wnCI;EACI,gBAAA;AjGixnCR;;AiGlxnCI;EACI,gBAAA;AjGqxnCR;;AiGtxnCI;EACI,gBAAA;AjGyxnCR;;AiG1xnCI;EACI,gBAAA;AjG6xnCR;;AiG9xnCI;EACI,gBAAA;AjGiynCR;;AiGlynCI;EACI,gBAAA;AjGqynCR;;AiGtynCI;EACI,gBAAA;AjGyynCR;;AiG1ynCI;EACI,gBAAA;AjG6ynCR;;AiG9ynCI;EACI,gBAAA;AjGiznCR;;AiGlznCI;EACI,gBAAA;AjGqznCR;;AiGtznCI;EACI,gBAAA;AjGyznCR;;AiG1znCI;EACI,gBAAA;AjG6znCR;;AiG9znCI;EACI,gBAAA;AjGi0nCR;;AiGl0nCI;EACI,gBAAA;AjGq0nCR;;AiGt0nCI;EACI,gBAAA;AjGy0nCR;;AiG10nCI;EACI,gBAAA;AjG60nCR;;AiG90nCI;EACI,iBAAA;AjGi1nCR;;AiGl1nCI;EACI,gBAAA;AjGq1nCR;;AiGt1nCI;EACI,iBAAA;AjGy1nCR;;AiG11nCI;EACI,gBAAA;AjG61nCR;;AiG91nCI;EACI,gBAAA;AjGi2nCR;;AiGl2nCI;EACI,gBAAA;AjGq2nCR;;AiGt2nCI;EACI,gBAAA;AjGy2nCR;;AiG12nCI;EACI,gBAAA;AjG62nCR;;AiG92nCI;EACI,gBAAA;AjGi3nCR;;AiGl3nCI;EACI,gBAAA;AjGq3nCR;;AiGt3nCI;EACI,gBAAA;AjGy3nCR;;AiG13nCI;EACI,gBAAA;AjG63nCR;;AiG93nCI;EACI,gBAAA;AjGi4nCR;;AiGl4nCI;EACI,gBAAA;AjGq4nCR;;AiGt4nCI;EACI,gBAAA;AjGy4nCR;;AiG14nCI;EACI,gBAAA;AjG64nCR;;AiG94nCI;EACI,gBAAA;AjGi5nCR;;AiGl5nCI;EACI,gBAAA;AjGq5nCR;;AiGt5nCI;EACI,gBAAA;AjGy5nCR;;AiG15nCI;EACI,gBAAA;AjG65nCR;;AiG95nCI;EACI,gBAAA;AjGi6nCR;;AiGl6nCI;EACI,gBAAA;AjGq6nCR;;AiGt6nCI;EACI,gBAAA;AjGy6nCR;;AiG16nCI;EACI,gBAAA;AjG66nCR;;AiG96nCI;EACI,gBAAA;AjGi7nCR;;AiGl7nCI;EACI,gBAAA;AjGq7nCR;;AiGt7nCI;EACI,iBAAA;AjGy7nCR;;AiG17nCI;EACI,iBAAA;AjG67nCR;;AiG97nCI;EACI,gBAAA;AjGi8nCR;;AiGl8nCI;EACI,gBAAA;AjGq8nCR;;AiGt8nCI;EACI,gBAAA;AjGy8nCR;;AiG18nCI;EACI,gBAAA;AjG68nCR;;AiG98nCI;EACI,gBAAA;AjGi9nCR;;AiGl9nCI;EACI,gBAAA;AjGq9nCR;;AiGt9nCI;EACI,gBAAA;AjGy9nCR;;AiG19nCI;EACI,gBAAA;AjG69nCR;;AiG99nCI;EACI,gBAAA;AjGi+nCR;;AiGl+nCI;EACI,gBAAA;AjGq+nCR;;AiGt+nCI;EACI,iBAAA;AjGy+nCR;;AiG1+nCI;EACI,iBAAA;AjG6+nCR;;AiG9+nCI;EACI,gBAAA;AjGi/nCR;;AiGl/nCI;EACI,gBAAA;AjGq/nCR;;AiGt/nCI;EACI,gBAAA;AjGy/nCR;;AiG1/nCI;EACI,iBAAA;AjG6/nCR;;AiG9/nCI;EACI,gBAAA;AjGigoCR;;AiGlgoCI;EACI,gBAAA;AjGqgoCR;;AiGtgoCI;EACI,iBAAA;AjGygoCR;;AiG1goCI;EACI,iBAAA;AjG6goCR;;AiG9goCI;EACI,gBAAA;AjGihoCR;;AiGlhoCI;EACI,gBAAA;AjGqhoCR;;AiGthoCI;EACI,gBAAA;AjGyhoCR;;AiG1hoCI;EACI,gBAAA;AjG6hoCR;;AiG9hoCI;EACI,gBAAA;AjGiioCR;;AiGlioCI;EACI,gBAAA;AjGqioCR;;AiGtioCI;EACI,gBAAA;AjGyioCR;;AiG1ioCI;EACI,gBAAA;AjG6ioCR;;AiG9ioCI;EACI,gBAAA;AjGijoCR;;AiGljoCI;EACI,gBAAA;AjGqjoCR;;AiGtjoCI;EACI,gBAAA;AjGyjoCR;;AiG1joCI;EACI,gBAAA;AjG6joCR;;AiG9joCI;EACI,gBAAA;AjGikoCR;;AiGlkoCI;EACI,gBAAA;AjGqkoCR;;AiGtkoCI;EACI,gBAAA;AjGykoCR;;AiG1koCI;EACI,gBAAA;AjG6koCR;;AiG9koCI;EACI,gBAAA;AjGiloCR;;AiGlloCI;EACI,gBAAA;AjGqloCR;;AiGtloCI;EACI,gBAAA;AjGyloCR;;AiG1loCI;EACI,gBAAA;AjG6loCR;;AiG9loCI;EACI,gBAAA;AjGimoCR;;AiGlmoCI;EACI,gBAAA;AjGqmoCR;;AiGtmoCI;EACI,gBAAA;AjGymoCR;;AiG1moCI;EACI,gBAAA;AjG6moCR;;AiG9moCI;EACI,gBAAA;AjGinoCR;;AiGlnoCI;EACI,gBAAA;AjGqnoCR;;AiGtnoCI;EACI,gBAAA;AjGynoCR;;AiG1noCI;EACI,gBAAA;AjG6noCR;;AiG9noCI;EACI,gBAAA;AjGiooCR;;AiGlooCI;EACI,gBAAA;AjGqooCR;;AiGtooCI;EACI,gBAAA;AjGyooCR;;AiG1ooCI;EACI,gBAAA;AjG6ooCR;;AiG9ooCI;EACI,gBAAA;AjGipoCR;;AiGlpoCI;EACI,gBAAA;AjGqpoCR;;AiGtpoCI;EACI,gBAAA;AjGypoCR;;AiG1poCI;EACI,iBAAA;AjG6poCR;;AiG9poCI;EACI,gBAAA;AjGiqoCR;;AiGlqoCI;EACI,gBAAA;AjGqqoCR;;AiGtqoCI;EACI,gBAAA;AjGyqoCR;;AiG1qoCI;EACI,iBAAA;AjG6qoCR;;AiG9qoCI;EACI,gBAAA;AjGiroCR;;AiGlroCI;EACI,gBAAA;AjGqroCR;;AiGtroCI;EACI,gBAAA;AjGyroCR;;AiG1roCI;EACI,gBAAA;AjG6roCR;;AiG9roCI;EACI,iBAAA;AjGisoCR;;AiGlsoCI;EACI,gBAAA;AjGqsoCR;;AiGtsoCI;EACI,gBAAA;AjGysoCR;;AiG1soCI;EACI,gBAAA;AjG6soCR;;AiG9soCI;EACI,gBAAA;AjGitoCR;;AiGltoCI;EACI,iBAAA;AjGqtoCR;;AiGttoCI;EACI,gBAAA;AjGytoCR;;AiG1toCI;EACI,gBAAA;AjG6toCR;;AiG9toCI;EACI,gBAAA;AjGiuoCR;;AiGluoCI;EACI,gBAAA;AjGquoCR;;AiGtuoCI;EACI,gBAAA;AjGyuoCR;;AiG1uoCI;EACI,iBAAA;AjG6uoCR;;AiG9uoCI;EACI,gBAAA;AjGivoCR;;AiGlvoCI;EACI,gBAAA;AjGqvoCR;;AiGtvoCI;EACI,gBAAA;AjGyvoCR;;AiG1voCI;EACI,gBAAA;AjG6voCR;;AiG9voCI;EACI,gBAAA;AjGiwoCR;;AiGlwoCI;EACI,gBAAA;AjGqwoCR;;AiGtwoCI;EACI,gBAAA;AjGywoCR;;AiG1woCI;EACI,gBAAA;AjG6woCR;;AiG9woCI;EACI,gBAAA;AjGixoCR;;AiGlxoCI;EACI,gBAAA;AjGqxoCR;;AiGtxoCI;EACI,gBAAA;AjGyxoCR;;AiG1xoCI;EACI,gBAAA;AjG6xoCR;;AiG9xoCI;EACI,gBAAA;AjGiyoCR;;AiGlyoCI;EACI,gBAAA;AjGqyoCR;;AiGtyoCI;EACI,gBAAA;AjGyyoCR;;AiG1yoCI;EACI,gBAAA;AjG6yoCR;;AiG9yoCI;EACI,gBAAA;AjGizoCR;;AiGlzoCI;EACI,gBAAA;AjGqzoCR;;AiGtzoCI;EACI,gBAAA;AjGyzoCR;;AiG1zoCI;EACI,gBAAA;AjG6zoCR;;AiG9zoCI;EACI,gBAAA;AjGi0oCR;;AiGl0oCI;EACI,gBAAA;AjGq0oCR;;AiGt0oCI;EACI,gBAAA;AjGy0oCR;;AiG10oCI;EACI,gBAAA;AjG60oCR;;AiG90oCI;EACI,gBAAA;AjGi1oCR;;AiGl1oCI;EACI,gBAAA;AjGq1oCR;;AiGt1oCI;EACI,iBAAA;AjGy1oCR;;AiG11oCI;EACI,gBAAA;AjG61oCR;;AiG91oCI;EACI,gBAAA;AjGi2oCR;;AiGl2oCI;EACI,gBAAA;AjGq2oCR;;AiGt2oCI;EACI,iBAAA;AjGy2oCR;;AiG12oCI;EACI,gBAAA;AjG62oCR;;AiG92oCI;EACI,iBAAA;AjGi3oCR;;AiGl3oCI;EACI,iBAAA;AjGq3oCR;;AiGt3oCI;EACI,iBAAA;AjGy3oCR;;AiG13oCI;EACI,gBAAA;AjG63oCR;;AiG93oCI;EACI,gBAAA;AjGi4oCR;;AiGl4oCI;EACI,gBAAA;AjGq4oCR;;AiGt4oCI;EACI,gBAAA;AjGy4oCR;;AiG14oCI;EACI,gBAAA;AjG64oCR;;AiG94oCI;EACI,gBAAA;AjGi5oCR;;AiGl5oCI;EACI,gBAAA;AjGq5oCR;;AiGt5oCI;EACI,gBAAA;AjGy5oCR;;AiG15oCI;EACI,gBAAA;AjG65oCR;;AiG95oCI;EACI,gBAAA;AjGi6oCR;;AiGl6oCI;EACI,gBAAA;AjGq6oCR;;AiGt6oCI;EACI,gBAAA;AjGy6oCR;;AiG16oCI;EACI,gBAAA;AjG66oCR;;AiG96oCI;EACI,gBAAA;AjGi7oCR;;AiGl7oCI;EACI,gBAAA;AjGq7oCR;;AiGt7oCI;EACI,gBAAA;AjGy7oCR;;AiG17oCI;EACI,gBAAA;AjG67oCR;;AiG97oCI;EACI,gBAAA;AjGi8oCR;;AiGl8oCI;EACI,gBAAA;AjGq8oCR;;AiGt8oCI;EACI,gBAAA;AjGy8oCR;;AiG18oCI;EACI,gBAAA;AjG68oCR;;AiG98oCI;EACI,gBAAA;AjGi9oCR;;AiGl9oCI;EACI,gBAAA;AjGq9oCR;;AiGt9oCI;EACI,gBAAA;AjGy9oCR;;AiG19oCI;EACI,gBAAA;AjG69oCR;;AiG99oCI;EACI,gBAAA;AjGi+oCR;;AiGl+oCI;EACI,gBAAA;AjGq+oCR;;AiGt+oCI;EACI,gBAAA;AjGy+oCR;;AiG1+oCI;EACI,gBAAA;AjG6+oCR;;AiG9+oCI;EACI,gBAAA;AjGi/oCR;;AiGl/oCI;EACI,gBAAA;AjGq/oCR;;AiGt/oCI;EACI,gBAAA;AjGy/oCR;;AiG1/oCI;EACI,gBAAA;AjG6/oCR;;AiG9/oCI;EACI,gBAAA;AjGigpCR;;AiGlgpCI;EACI,gBAAA;AjGqgpCR;;AiGtgpCI;EACI,gBAAA;AjGygpCR;;AiG1gpCI;EACI,gBAAA;AjG6gpCR;;AiG9gpCI;EACI,iBAAA;AjGihpCR;;AiGlhpCI;EACI,gBAAA;AjGqhpCR;;AiGthpCI;EACI,gBAAA;AjGyhpCR;;AiG1hpCI;EACI,gBAAA;AjG6hpCR;;AiG9hpCI;EACI,gBAAA;AjGiipCR;;AiGlipCI;EACI,gBAAA;AjGqipCR;;AiGtipCI;EACI,gBAAA;AjGyipCR;;AiG1ipCI;EACI,gBAAA;AjG6ipCR;;AiG9ipCI;EACI,gBAAA;AjGijpCR;;AiGljpCI;EACI,gBAAA;AjGqjpCR;;AiGtjpCI;EACI,iBAAA;AjGyjpCR;;AiG1jpCI;EACI,gBAAA;AjG6jpCR;;AiG9jpCI;EACI,gBAAA;AjGikpCR;;AiGlkpCI;EACI,gBAAA;AjGqkpCR;;AiGtkpCI;EACI,gBAAA;AjGykpCR;;AiG1kpCI;EACI,gBAAA;AjG6kpCR;;AiG9kpCI;EACI,gBAAA;AjGilpCR;;AiGllpCI;EACI,gBAAA;AjGqlpCR;;AiGtlpCI;EACI,gBAAA;AjGylpCR;;AiG1lpCI;EACI,gBAAA;AjG6lpCR;;AiG9lpCI;EACI,gBAAA;AjGimpCR;;AiGlmpCI;EACI,gBAAA;AjGqmpCR;;AiGtmpCI;EACI,gBAAA;AjGympCR;;AiG1mpCI;EACI,gBAAA;AjG6mpCR;;AiGzmpCA;EACI,gBAAA;EACA,kBAAA;AjG4mpCJ;;AkGjnpCQ;EAEI,eAAA;AlGmnpCZ;;AkGrnpCQ;EAEI,eAAA;AlGunpCZ;;AkGznpCQ;EAEI,eAAA;AlG2npCZ;;AkG7npCQ;EAEI,eAAA;AlG+npCZ;;AkGznpCI;EACI,0BAAA;AlG4npCR;AkG1npCI;EACI,0BAAA;AlG4npCR;;AkGxnpCI;EACI,yBAAA;AlG2npCR;AkGznpCI;EACI,+BAAA;AlG2npCR;;AkGrnpCI;EAMI;;;;;;;;;;;;;;;GAAA;AlGkopCR;AkGvopCQ;EAGI,wBAAA;AlGyopCZ;;AkG7opCI;EAMI;;;;;;;;;;;;;;;GAAA;AlG0ppCR;AkG/ppCQ;EAGI,wBAAA;AlGiqpCZ;;AkGrqpCI;EAMI;;;;;;;;;;;;;;;GAAA;AlGkrpCR;AkGvrpCQ;EAGI,yBAAA;AlGyrpCZ;;AkG7rpCI;EAMI;;;;;;;;;;;;;;;GAAA;AlG0spCR;AkG/spCQ;EAGI,yBAAA;AlGitpCZ;;AkGrtpCI;EAMI;;;;;;;;;;;;;;;GAAA;AlGkupCR;AkGvupCQ;EAGI,yBAAA;AlGyupCZ;;AkG7upCI;EAMI;;;;;;;;;;;;;;;GAAA;AlG0vpCR;AkG/vpCQ;EAGI,yBAAA;AlGiwpCZ;;AkGrwpCI;EAMI;;;;;;;;;;;;;;;GAAA;AlGkxpCR;AkGvxpCQ;EAGI,yBAAA;AlGyxpCZ;;AkGrwpCA;EAEI,qBAAA;EACA,aAAA;EACA,mBAAA;AlGwwpCJ;;AkGtwpCA;EAEI,qBAAA;EACA,aAAA;EACA,mBAAA;AlGywpCJ;;AmGv0pCA;EAEY,sCAAA;AnG00pCZ;AmG5zpCA;EACI;IAEU,uBAAA;EnGy0pCZ;EmGv0pCE;IAEU,yBAAA;EnGy0pCZ;AACF;AoGl2pCA,qBAAA;AACA;EACE;IACE,UAAA;IAKA,oBAAA;EpGo2pCF;EoGj2pCA;IACE,UAAA;IAKA,oBAAA;EpGm2pCF;AACF;AoGh2pCA;EACE,iCAAA;EjGH+D,yBFiEpD;EEjEoD,yBF0FxD;ADqxpCT;;AoGj2pCA;EACE;IACE,UAAA;EpGo2pCF;EoGj2pCA;IACE,UAAA;EpGm2pCF;AACF;AoGh2pCA;EACE,uBAAA;ApGk2pCF;;AoG/1pCA;EAUE,oBAAA;EACA,sBAAA;EACA,mCAAA;EACA,iCAAA;ApGy1pCF;AoGr2pCE;EACE;IACE,uBAAA;EpGu2pCJ;EoGp2pCE;IACE,yBAAA;EpGs2pCJ;AACF;;AoG/1pCA;EACE;IACE,UAAA;IACA,kCAAA;EpGk2pCF;EoG/1pCA;IACE,UAAA;IACA,eAAA;EpGi2pCF;AACF;AoG91pCA;EACE,wBAAA;ApGg2pCF;;AqG36pCA,yBAAA;AAqCA;EACC,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;ArG04pCD;;AsGn7pCA,eAAA;AAEA;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,gClF+EM;EkF9EN,mCAAA;AtGq7pCF;;AsGn7pCA;;;;;;;;;;;;EAYE,gBlFmEmB;ApBm3pCrB;;AsGp7pCA;EACE,mBlFmEkB;ApBo3pCpB;;AsGr7pCA;;EAEE,kBAAA;AtGw7pCF;;AsGt7pCA;;EAEE,mBAAA;AtGy7pCF;;AsGv7pCA;;EAEE,iBAAA;AtG07pCF;;AsGx7pCA;;EAEE,mBAAA;AtG27pCF;;AsGz7pCA;;EAEE,eAAA;AtG47pCF;;AsG17pCA;;EAEE,oBAAA;AtG67pCF;;AsG37pCA;EACE,mBAAA;AtG87pCF;;AsG57pCA;EACE,kBAAA;AtG+7pCF;AsG97pCE;EAFF;IAGI,eAAA;EtGi8pCF;AACF;;AsG/7pCA;EACE,mBAAA;AtGk8pCF;AsGj8pCE;EAFF;IAGI,iBAAA;EtGo8pCF;AACF;;AsGl8pCA;EACE,iBAAA;AtGq8pCF;AsGp8pCE;EAFF;IAGI,eAAA;EtGu8pCF;AACF;;AsGr8pCA;EACE,mBAAA;AtGw8pCF;AsGv8pCE;EAFF;IAGI,iBAAA;EtG08pCF;AACF;;AsGx8pCA;EACE,kBAAA;AtG28pCF;AsG18pCE;EAFF;IAGI,eAAA;EtG68pCF;AACF;;AsG38pCA;EACE,gBAAA;EACA,yBAAA;AtG88pCF;;AsG18pCE;EACE,gBAAA;AtG68pCJ;;AsGv8pCE;EC9FA,qBrFyEa;AlBg+pCf;AuGxiqCE;EACE,crFuEW;AlBm+pCf;;AsG98pCE;EC9FA,qBrFyEa;AlBu+pCf;AuG/iqCE;EACE,crFuEW;AlB0+pCf;;AsGr9pCE;EC9FA,qBrFyEa;AlB8+pCf;AuGtjqCE;EACE,crFuEW;AlBi/pCf;;AsG59pCE;EC9FA,qBrFyEa;AlBq/pCf;AuG7jqCE;EACE,crFuEW;AlBw/pCf;;AsGn+pCE;EC9FA,qBrFyEa;AlB4/pCf;AuGpkqCE;EACE,crFuEW;AlB+/pCf;;AsG1+pCE;EC9FA,qBrFyEa;AlBmgqCf;AuG3kqCE;EACE,crFuEW;AlBsgqCf;;AsGj/pCE;EC9FA,qBrFyEa;AlB0gqCf;AuGllqCE;EACE,crFuEW;AlB6gqCf;;AsGx/pCE;EC9FA,qBrFyEa;AlBihqCf;AuGzlqCE;EACE,crFuEW;AlBohqCf;;AsG1/pCE;EACE,gBAAA;AtG6/pCJ;AsG5/pCI;EAFF;IAGI,eAAA;EtG+/pCJ;AACF;;AsG5/pCA;EACE,kBAAA;AtG+/pCF;;AsG7/pCA;EACE,mBAAA;AtGggqCF;;AsG9/pCA;EACE,eAAA;AtGigqCF;;AwGrnqCA,iBAAA;AAEA;EACI,UAAA;EACA,SAAA;EACA,kBAAA;AxGunqCJ;;AwGpnqCA;;EAEI,wBAAA;EACA,qBAAA;AxGunqCJ;;AwGpnqCA;EACI,gBAAA;AxGunqCJ;;AwGpnqCA;EACI,UAAA;EACA,gBAAA;AxGunqCJ;;AwGpnqCA;;;;;;;;;EASI,iBAAA;AxGunqCJ;;AwGpnqCA;;;;;;;;;;EAUI,UAAA;AxGunqCJ;;AwGpnqCA;;;;;;EAMI,aAAA;EACA,gBAAA;EACA,0BAAA;EACA,gBAAA;EACA,mBAAA;AxGunqCJ;;AwGpnqCA;EACI,YAAA;EACA,kBAAA;AxGunqCJ;;AwGpnqCA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAkCI,gBAAA;AxGunqCJ;;AwGpnqCA;;;;;;;;;;;;EAYI,UAAA;EACA,iBAAA;AxGunqCJ;;AwGpnqCA;EACI,UAAA;EACA,iBAAA;AxGunqCJ;;AwGpnqCA;;;;EAII,UAAA;AxGunqCJ;;AwGpnqCA;;EAEI,yBAAA;EACA,aAAA;AxGunqCJ;;AyG7vqCA;EAGM;IACE,aAAA;EzG8vqCN;EyG5vqCI;IACE,qBAAA;EzG8vqCN;AACF;AyG1vqCA;EACE;IACE,kBAAA;IAGA,8BAAA;EzG4vqCF;EyG1vqCE;IACE,QAAA;EzG4vqCJ;EyG1vqCI;IACE,YAAA;EzG4vqCN;EyGzvqCI;IACE,uBAAA;EzG2vqCN;EyGzvqCM;IACE,wBAAA;EzG2vqCR;EyGtvqCE;IACE,OAAA;EzGwvqCJ;EyGtvqCI;IACE,WAAA;EzGwvqCN;EyGrvqCI;IACE,SAAA;EzGuvqCN;EyGrvqCM;IACE,UAAA;EzGuvqCR;EyGlvqCE;IACE,kBAAA;IACA,MAAA;IACA,uBAAA;EzGovqCJ;AACF;A0G3yqCA,mBAAA;AACA;;EAEE,kBAAA;EACA,gBAAA;A1G6yqCF;;A0G1yqCA;EACE,mBtFiDW;ApB4vqCb;;A0G1yqCA;;;EAGE,cAAA;A1G6yqCF;;A0G1yqCA;EACE,8BAAA;EvGkBuD,aAAA;EAjBQ,mBwGS9C;EDPjB,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,+CAAA;A1G+yqCF;A0G7yqCE;EACE,iBAAA;EACA,WAAA;EACA,cAAA;A1G+yqCJ;A0G7yqCI;EACE,cAAA;A1G+yqCN;A0G7yqCM;EACE,UAAA;A1G+yqCR;A0G7yqCQ;EACE,YAAA;A1G+yqCV;A0GzyqCE;EA3BF;IA4BI,WAAA;E1G4yqCF;AACF;;A0GzyqCA;EACE,+CAAA;EACA,WAAA;EACA,8BAAA;EACA,iBtFiGc;EjBlHyC,aAAA;EAjBQ,sBwGS9C;A3Gy0qCnB;A0G7yqCE;EAPF;IAQI,cAAA;IACA,WAAA;E1GgzqCF;AACF;A0G/yqCE;EACE,gBAAA;A1GizqCJ;;A0G7yqCA;EACE,mBtFTW;EsFUX,yBtFmCgB;EsFlChB,WAAA;EvGjD+D,YwGmC9C;A3Gg0qCnB;;A0G9yqCA;EACE,gBAAA;EACA,aAAA;EACA,kBAAA;A1GizqCF;;A0G9yqCA;EACE,mBAAA;EACA,aAAA;EACA,eAAA;A1GizqCF;;A0G9yqCA;EACE,YAAA;EACA,cAAA;EACA,gCtFDM;EsFEN,gBAAA;EACA,mBtFGkB;EsFFlB,kBAAA;A1GizqCF;;A0G9yqCA;EAIE,oBAAA;A1G8yqCF;A0G7yqCE;EACE,SAAA;EACA,gBAAA;A1G+yqCJ;;A0G5yqCA;EACE,ctFvFkB;EsFwFlB,mBAAA;EACA,gBAAA;A1G+yqCF;A0G9yqCE;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,wDAAA;A1GgzqCJ;A0G/yqCI;EACE,oBAAA;EACA,iBAAA;A1GizqCN;;A4Gr6qCA,cAAA;AAEA;EACE,qBxFqRkB;ApBkpqCpB;;A4Gp6qCE;EADF;IAEI,gBAAA;E5Gw6qCF;AACF;;A4Gr6qCE;EADF;IAEI,gBAAA;E5Gy6qCF;AACF;;A4Gt6qCE;EADF;IAEI,gBAAA;E5G06qCF;AACF;;A4Gv6qCE;EADF;IAEI,gBAAA;E5G26qCF;AACF;;A4Gz6qCA;EACE,WAAA;EACA,YAAA;A5G46qCF;;A4G16qCA;EACE,WAAA;EACA,YAAA;A5G66qCF;;A4G36qCA;EACE,WAAA;EACA,YAAA;A5G86qCF;;A4G56qCA;;EACE,WAAA;EACA,YAAA;A5Gg7qCF;;A4G96qCA;EzGLyD,aAAA;EAjBQ,oBwGuD9C;ExGvD8C,wBwGkD9C;A3G25qCnB;A4Gn7qCE;EACE,WAAA;EACA,eAAA;A5Gq7qCJ;;A4Gh7qCE;EADF;IAEI,+BAAA;E5Go7qCF;AACF;;A4Gj7qCE;EADF;IAEI,+BAAA;E5Gq7qCF;AACF;;A4Gl7qCE;EADF;IAEI,+BAAA;E5Gs7qCF;AACF;;A4Gl7qCE;EADF;IAEI,8BAAA;E5Gs7qCF;AACF;;A4Gn7qCE;EADF;IAEI,8BAAA;E5Gu7qCF;AACF;;A4Gp7qCE;EADF;IAEI,8BAAA;E5Gw7qCF;AACF;;A4Gr7qCA;EACE,cAAA;A5Gw7qCF;;A4Gr7qCA;EACE,WxF3EkB;ApBmgrCpB;;A4Gr7qCA;EACE,eAAA;A5Gw7qCF;;A4Gr7qCA;EACE,YAAA;A5Gw7qCF;;A4Gr7qCA;EACE,gBxFZkB;ApBo8qCpB;;A4Gr7qCA;EACE,gBxFfmB;ApBu8qCrB;;A4Gr7qCA;EACE,gBxFlBiB;ApB08qCnB;;A4Gr7qCA;EACE,mBAAA;A5Gw7qCF;;A4Gr7qCA;EACE,eAAA;A5Gw7qCF;;A4Gt7qCA;EACE,aAAA;A5Gy7qCF;A4Gv7qCE;;EAGE,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gCAAA;EACA,yEAAA;A5Gw7qCJ;A4Gt7qCI;;EACE,cAAA;A5Gy7qCN;A4Gt7qCI;;EACE,UAAA;EACA,2CAAA;EACA,sBAAA;EACA,eAAA;A5Gy7qCN;A4Gp7qCE;EAEE,cAAA;EACA,eAAA;EACA,gBAAA;A5Gq7qCJ;;A4Gl7qCA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;A5Gq7qCF;;A4Gl7qCA;EACE,kBAAA;A5Gq7qCF;A4Gn7qCE;EACE,kBAAA;A5Gq7qCJ;A4Gn7qCI;EACE,QAAA;EACA,2BAAA;EACA,SAAA;EACA,QAAA;EACA,OAAA;EACA,YAAA;A5Gq7qCN;A4Gl7qCI;EACE,OAAA;A5Go7qCN;A4Gj7qCI;EACE,QAAA;A5Gm7qCN;A4Gh7qCI;EACE,SAAA;A5Gk7qCN;A4G/6qCI;EACE,MAAA;A5Gi7qCN;A4G96qCI;EACE,QAAA;EACA,SAAA;EACA,gCAAA;A5Gg7qCN;;A4G56qCA;EACE,UAAA;A5G+6qCF;;A4G56qCA;EACE,mBAAA;A5G+6qCF;;A4G76qCA;EACE,mBAAA;A5Gg7qCF;;A6G7nrCA,gBAAA;AAQE;EACE,aAAA;A7GynrCJ;A6G3mrCE;EACE,kBAAA;A7G6mrCJ;A6GtmrCE;;;;;;EAME,6BAAA;EACA,mBAAA;A7GwmrCJ;A6GpmrCE;EACE,gBAAA;A7GsmrCJ;A6GnmrCE;EACE,kBAAA;A7GqmrCJ;A6GlmrCE;EACE,qBAAA;EAEA,qBAAA;A7GmmrCJ;A6G/lrCI;EACE,uBAAA;A7GimrCN;A6G7lrCM;EACE,gBAAA;A7G+lrCR;A6GzlrCI;EACE,gCAAA;EACA,sBAAA;EACA,qBAAA;A7G2lrCN;A6GvlrCE;EACE,aAAA;A7GylrCJ;A6GhlrCA;EACE,gBAAA;EACA,cAAA;A7GklrCF;A6G7krCI;EACE,eAAA;A7G+krCN;;A6G1krCA;EAIE,WAAA;EACA,aAAA;A7G0krCF;;A6GrkrCA;EACE,aAAA;EACA,mBAAA;A7GwkrCF;;A6GnkrCI;EACE,qBAAA;EACA,czFxBO;EyFyBP,kBAAA;A7GskrCN;A6GrkrCM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,2BAAA;EACA,oBAAA;A7GukrCR;A6GtkrCQ;EACE,mBAAA;A7GwkrCV;A6GnkrCE;E1GjGuD,aAAA;AHwqrCzD;A6GpkrCM;EACE,qBAAA;EACA,oBAAA;A7GskrCR;A6GrkrCQ;EACE,kBAAA;EACA,mBAAA;A7GukrCV;A6GjkrCI;EACE,YAAA;A7GmkrCN;A6GlkrCM;EACE,WAAA;A7GokrCR;A6G9jrCM;EACE,gBAAA;A7GgkrCR;;A8G7trCA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;A9GgurCF;A8G/trCE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6CAAA;EACA,yBAAA;EACA,oCAAA;A9GiurCJ;;A8G7trCA;EACE;IACE,yBAAA;E9GgurCF;AACF;A+GpvrCA,cAAA;AACA;EACI,WAAA;EACA,aAAA;EACA,yBAAA,EAAA,wCAAA;EACA,sBAAA;EACA,kBAAA;A/GsvrCJ;;A+GnvrCA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,oDAAA,EAAA,wBAAA;EACA,WAAA;EACA,kBAAA;EACA,2CAAA;A/GsvrCJ;A+GpvrCI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,oCAAA;EACA,kBAAA;EACA,kBAAA;EACA,kCAAA;A/GsvrCR;A+GpvrCQ;EACI,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;A/GsvrCZ;A+GpvrCY;EACI,oCAAA;EACA,WAAA;EACA,0CAAA;A/GsvrChB;A+GrvrCgB;EACI,oCAAA;A/GuvrCpB;A+GnvrCY;EACI,yBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;A/GqvrChB;A+GpvrCgB;EACI,yBAAA;A/GsvrCpB;A+GjvrCQ;EACI,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;A/GmvrCZ;A+GhvrCQ;EACI,iBAAA;EACA,WAAA;EACA,iBAAA;A/GkvrCZ;A+G/urCQ;EACI,eAAA;EACA,iBAAA;EACA,WAAA;A/GivrCZ;A+GhvrCY;EACI,cAAA;A/GkvrChB;A+G7urCI;EACI,aAAA;A/G+urCR;;A+G3urCA,eAAA;AACA;EACI;IACI,UAAA;IACA,4BAAA;E/G8urCN;E+G5urCE;IACI,UAAA;IACA,wBAAA;E/G8urCN;AACF;AgH30rCA,0BAAA;AAEA;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AhH40rCF;AgH10rCE;EACE,cAAA;EACA,sBAAA;EACA,mB5FgFgB;E4F/EhB,gBAAA;EACA,c5FgFS;ApB4vrCb;AgH30rCI;EACE,eAAA;EACA,uBAAA;AhH60rCN;AgH10rCI;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EAKA,cAAA;EACA,aAAA;EACA,UAAA;EACA,eAAA;EACA,UAAA;EACA,wBAAA;AhHw0rCN;AgHj1rCM;EACE,UAAA;EACA,QAAA;AhHm1rCR;AgHx0rCQ;EAEE,kBAAA;EACA,MAAA;EACA,OAAA;AhHy0rCV;AgHx0rCU;EACE,UAAA;EACA,QAAA;AhH00rCZ;AgHv0rCQ;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;EZtBR,eYuB4B;EACpB,uBAAA;EAEA,0BAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;AhH60rCV;AgHz0rCQ;EZjCN,eYkC4B;EACpB,uBAAA;EAEA,0BAAA;EACA,kCAAA;EACA,UAAA;EACA,wBAAA;EAIA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,c5FjEU;E4FkEV,QAAA;AhH+0rCV;AgH10rCU;EACE,mBAAA;EACA,eAAA;AhH40rCZ;AgH10rCU;EACE,WAAA;EACA,UAAA;EACA,iBAAA;EACA,0BAAA;EAIA,mBAAA;EACA,YAAA;AhH40rCZ;AgHr0rCU;EACE,qB5F9CG;ApBq3rCf;AgHj0rCY;EACE,mB5FrDC;E4FsDD,c5FpGM;ApBu6rCpB;AgH3zrCQ;EACE,kBAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EAKA,qBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EZxGR,eYyG4B;EACpB,uBAAA;EAEA,0BAAA;AhH6zrCV;AgHz0rCU;EACE,UAAA;EACA,QAAA;AhH20rCZ;AgH9zrCQ;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,mB5FpIU;E4FqIV,kBAAA;EACA,QAAA;EACA,SAAA;EAOA,eAAA;EACA,uBAAA;EAEA,0BAAA;EACA,UAAA;EACA,wBAAA;EAIA,mBAAA;EACA,kBAAA;AhH4zrCV;AgH50rCU;EACE,UAAA;EACA,UAAA;AhH80rCZ;AgH1zrCU;EACE,mBAAA;EACA,eAAA;AhH4zrCZ;AgHzzrCU;EACE,UAAA;EACA,gBAAA;EACA,0BAAA;EAIA,mBAAA;AhH2zrCZ;AgHpzrCU;EACE,qB5FpIG;ApB07rCf;AgHhzrCY;EACE,mB5F3IC;ApB67rCf;AgH/yrCY;EACE,mB5F7LM;ApB8+rCpB;;AgHjyrCY;;EACE,qBAAA;AhHqyrCd;AgHhyrCc;;EACE,mB9FtJD;AlBy7rCf;;AgH1yrCY;;EACE,qBAAA;AhH8yrCd;AgHzyrCc;;EACE,mB9FtJD;AlBk8rCf;;AgHnzrCY;;EACE,qBAAA;AhHuzrCd;AgHlzrCc;;EACE,mB9FtJD;AlB28rCf;;AgH5zrCY;;EACE,qBAAA;AhHg0rCd;AgH3zrCc;;EACE,mB9FtJD;AlBo9rCf;;AgHr0rCY;;EACE,qBAAA;AhHy0rCd;AgHp0rCc;;EACE,mB9FtJD;AlB69rCf;;AgH90rCY;;EACE,qBAAA;AhHk1rCd;AgH70rCc;;EACE,mB9FtJD;AlBs+rCf;;AgHv1rCY;;EACE,qBAAA;AhH21rCd;AgHt1rCc;;EACE,mB9FtJD;AlB++rCf;;AgHh2rCY;;EACE,qBAAA;AhHo2rCd;AgH/1rCc;;EACE,mB9FtJD;AlBw/rCf;;AgHl1rCU;;EACE,qB5FrJC;ApB2+rCb;AgHj1rCY;;EACE,mB5F3JD;ApB++rCb;;AiH7ksCA,UAAA;AAEA;EACE,mBAAA;AjH+ksCF;;AiH7ksCA;EACE,cAAA;AjHglsCF;;AiH9ksCA;;EAEE,c7F8MwB;E6F7MxB,WAAA;EACA,YAAA;AjHilsCF;AiH/ksCE;;EACE,qB7F6CW;E6F5CX,wBAAA;EACA,c7FuMsB;E6FtMtB,gBAAA;AjHklsCJ;;AiH/ksCA;EACE,yBAAA;EACA,2BAAA;EACA,mBAAA;EACA,mB7FiMgB;E6FhMhB,2BAAA;EACA,sB7F0LS;E6FzLT,kBAAA;EACA,c7FZkB;ApB8lsCpB;AiHjlsCE;EACE,wCAAA;EACA,sB7FqLO;ApB85rCX;AiHjlsCE;EACE,wBAAA;EACA,4BAAA;AjHmlsCJ;AiHhlsCE;EACE,uBAAA;EACA,6BAAA;AjHklsCJ;AiHhlsCE;EACE,c7FkDS;E6FjDT,mB7F4K0B;ApBs6rC9B;;AiH9ksCE;EACE,UAAA;EACA,kBAAA;AjHilsCJ;AiHhlsCI;EACE,YAAA;AjHklsCN;;AiH5ksCE;EACE,0BAAA;EACA,SAAA;EACA,0BAAA;EACA,c7FyJsB;ApBs7rC1B;AiH9ksCI;EACE,0BAAA;AjHglsCN;AiH7ksCM;EACE,0BAAA;AjH+ksCR;AiH9ksCQ;EACE,0BAAA;AjHglsCV;AiHnlsCM;EACE,0BAAA;AjHqlsCR;AiHplsCQ;EACE,0BAAA;AjHslsCV;AiHzlsCM;EACE,0BAAA;AjH2lsCR;AiH1lsCQ;EACE,0BAAA;AjH4lsCV;AiH/lsCM;EACE,0BAAA;AjHimsCR;AiHhmsCQ;EACE,0BAAA;AjHkmsCV;AiHrmsCM;EACE,0BAAA;AjHumsCR;AiHtmsCQ;EACE,0BAAA;AjHwmsCV;AiH3msCM;EACE,0BAAA;AjH6msCR;AiH5msCQ;EACE,0BAAA;AjH8msCV;AiHjnsCM;EACE,0BAAA;AjHmnsCR;AiHlnsCQ;EACE,0BAAA;AjHonsCV;AiHvnsCM;EACE,0BAAA;AjHynsCR;AiHxnsCQ;EACE,0BAAA;AjH0nsCV;;AiHnnsCE;EACE,mB7FagB;E6FZhB,cAAA;EACA,mBAAA;AjHsnsCJ;AiHnnsCI;EACE,qBAAA;AjHqnsCN;AiHlnsCE;EACE,kBAAA;EACA,kBAAA;AjHonsCJ;AiHlnsCE;EACE,uBAAA;AjHonsCJ;;AiHhnsCA;EACE,gBAAA;EACA,qBAAA;AjHmnsCF;;AiH/msCE;EACE,uBAAA;AjHknsCJ;;AiH7msCE;EACA,kBAAA;AjHgnsCF;AiH9msCE;EACE,gB7FoGO;E6FnGP,yBAAA;EACA,2BAAA;EACA,mBAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;AjHgnsCJ;AiH/msCI;EACE,yBAAA;EACA,YAAA;AjHinsCN;;AkH3usCA,UAAA;AAEA;EACE,8BAAA;EACA,gCAAA;AlH6usCF;AkH5usCE;EACE,mBAAA;EACA,6BAAA;EACA,+BAAA;E/G4BqD,aAAA;EAjBQ,mBwGuD9C;EO/Df,kBAAA;EACA,gC9F0EI;E8FzEJ,mB9F+EgB;ApBiqsCpB;AkH9usCI;EACE,qBAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;AlHgvsCN;;AmHpwsCA,WAAA;AAEA;EACE,gBAAA;EACA,c/F0FW;ApB4qsCb;AmHpwsCI;EACE,aAAA;EACA,wBAAA;EACA,gC/F6EE;E+F5EF,gB/F+Ee;ApBursCrB;AmHrwsCM;EACE,qBAAA;AnHuwsCR;AmHnwsCE;;EAEE,sBAAA;EACA,mB/FyEgB;E+FxEhB,cAAA;AnHqwsCJ;AmHpwsCI;;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AnHuwsCN;AmHrwsCI;;EACE,gBAAA;AnHwwsCN;AmHrwsCE;EACE,YAAA;AnHuwsCJ;AmHtwsCI;EACE,YAAA;AnHwwsCN;;AoHzysCA,YAAA;AAEA;EACE,oBhGkLc;EgGjLd,cAAA;EACA,mBAAA;EAoBA,4BAAA;EAMA,+BAAA;ApHmxsCF;AoH5ysCE;EACE,uBAAA;ApH8ysCJ;AoH5ysCE;E1FSE,mBAAA;A1BsysCJ;AoH5ysCE;EACE,gBhG0JiB;ApBopsCrB;AoH5ysCE;EACE,mBhGuKe;ApBuosCnB;AoH5ysCE;EACE,mBhGqKe;ApByosCnB;AoH5ysCE;EACE,uBAAA;EACA,mBhG+Je;ApB+osCnB;AoH3ysCE;EACE,WAAA;EACA,YAAA;EACA,UAAA;ApH6ysCJ;AoHzysCI;EACE,oBAAA;ApH2ysCN;AoHzysCI;EACE,mBAAA;ApH2ysCN;AoHxysCE;EACE,WAAA;EACA,YAAA;EACA,UAAA;ApH0ysCJ;AoHxysCE;EACE,kBAAA;EACA,0CAAA;EACA,gBhGyCiB;EgGxCjB,4BAAA;ApH0ysCJ;AoHzysCI;EALF;IAMI,iBAAA;IACA,4BAAA;EpH4ysCJ;AACF;;AoHtysCI;EACE,cAAA;ApHyysCN;;AoH7xsCA,iBAAA;AAEE;ECzEA,mBD0EyB;ECzEzB,cjGYkB;ApB61sCpB;AqHv2sCE;EAEE,mBAAA;EACA,cjGOgB;ApBi2sCpB;AqHt2sCE;EACE,qBAAA;EACA,mBAAA;ArHw2sCJ;AqHv2sCI;EACE,mBD8DqB;EC7DrB,gBAAA;EACA,qBAAA;EACA,oBAAA;ArHy2sCN;;AoH5ysCE;ECxDF,yBAAA;EACA,cDwDmC;ApHgzsCnC;AqHv2sCA;EACE,mBDsDiC;ECrDjC,cjGXkB;ApBo3sCpB;;AoHxzsCE;ECzEA,mBD0EyB;ECzEzB,cjGYkB;ApBy3sCpB;AqHn4sCE;EAEE,mBAAA;EACA,cjGOgB;ApB63sCpB;AqHl4sCE;EACE,qBAAA;EACA,mBAAA;ArHo4sCJ;AqHn4sCI;EACE,mBD8DqB;EC7DrB,gBAAA;EACA,qBAAA;EACA,oBAAA;ArHq4sCN;;AoHx0sCE;ECxDF,yBAAA;EACA,cDwDmC;ApH40sCnC;AqHn4sCA;EACE,mBDsDiC;ECrDjC,cjGXkB;ApBg5sCpB;;AoHp1sCE;ECzEA,mBD0EyB;ECzEzB,cjGYkB;ApBq5sCpB;AqH/5sCE;EAEE,mBAAA;EACA,cjGOgB;ApBy5sCpB;AqH95sCE;EACE,qBAAA;EACA,mBAAA;ArHg6sCJ;AqH/5sCI;EACE,mBD8DqB;EC7DrB,gBAAA;EACA,qBAAA;EACA,oBAAA;ArHi6sCN;;AoHp2sCE;ECxDF,yBAAA;EACA,cDwDmC;ApHw2sCnC;AqH/5sCA;EACE,mBDsDiC;ECrDjC,cjGXkB;ApB46sCpB;;AoHh3sCE;ECzEA,mBD0EyB;ECzEzB,cjGYkB;ApBi7sCpB;AqH37sCE;EAEE,mBAAA;EACA,cjGOgB;ApBq7sCpB;AqH17sCE;EACE,qBAAA;EACA,mBAAA;ArH47sCJ;AqH37sCI;EACE,mBD8DqB;EC7DrB,gBAAA;EACA,qBAAA;EACA,oBAAA;ArH67sCN;;AoHh4sCE;ECxDF,yBAAA;EACA,cDwDmC;ApHo4sCnC;AqH37sCA;EACE,mBDsDiC;ECrDjC,cjGXkB;ApBw8sCpB;;AoH54sCE;ECzEA,mBD0EyB;ECzEzB,cjGYkB;ApB68sCpB;AqHv9sCE;EAEE,mBAAA;EACA,cjGOgB;ApBi9sCpB;AqHt9sCE;EACE,qBAAA;EACA,mBAAA;ArHw9sCJ;AqHv9sCI;EACE,mBD8DqB;EC7DrB,gBAAA;EACA,qBAAA;EACA,oBAAA;ArHy9sCN;;AoH55sCE;ECxDF,yBAAA;EACA,cDwDmC;ApHg6sCnC;AqHv9sCA;EACE,mBDsDiC;ECrDjC,cjGXkB;ApBo+sCpB;;AoHx6sCE;ECzEA,mBD0EyB;ECzEzB,cjGYkB;ApBy+sCpB;AqHn/sCE;EAEE,mBAAA;EACA,cjGOgB;ApB6+sCpB;AqHl/sCE;EACE,qBAAA;EACA,mBAAA;ArHo/sCJ;AqHn/sCI;EACE,mBD8DqB;EC7DrB,gBAAA;EACA,qBAAA;EACA,oBAAA;ArHq/sCN;;AoHx7sCE;ECxDF,yBAAA;EACA,cDwDmC;ApH47sCnC;AqHn/sCA;EACE,mBDsDiC;ECrDjC,cjGXkB;ApBggtCpB;;AoHp8sCE;ECzEA,mBD0EyB;ECzEzB,cjGYkB;ApBqgtCpB;AqH/gtCE;EAEE,mBAAA;EACA,cjGOgB;ApBygtCpB;AqH9gtCE;EACE,qBAAA;EACA,mBAAA;ArHghtCJ;AqH/gtCI;EACE,mBD8DqB;EC7DrB,gBAAA;EACA,qBAAA;EACA,oBAAA;ArHihtCN;;AoHp9sCE;ECxDF,yBAAA;EACA,cDwDmC;ApHw9sCnC;AqH/gtCA;EACE,mBDsDiC;ECrDjC,cjGXkB;ApB4htCpB;;AoHh+sCE;ECzEA,mBD0EyB;ECzEzB,cjGYkB;ApBiitCpB;AqH3itCE;EAEE,mBAAA;EACA,cjGOgB;ApBqitCpB;AqH1itCE;EACE,qBAAA;EACA,mBAAA;ArH4itCJ;AqH3itCI;EACE,mBD8DqB;EC7DrB,gBAAA;EACA,qBAAA;EACA,oBAAA;ArH6itCN;;AoHh/sCE;ECxDF,yBAAA;EACA,cDwDmC;ApHo/sCnC;AqH3itCA;EACE,mBDsDiC;ECrDjC,cjGXkB;ApBwjtCpB;;AoH5/sCE;ECzEA,mBD0EyB;ECzEzB,cjGYkB;ApB6jtCpB;AqHvktCE;EAEE,mBAAA;EACA,cjGOgB;ApBiktCpB;AqHtktCE;EACE,qBAAA;EACA,mBAAA;ArHwktCJ;AqHvktCI;EACE,mBD8DqB;EC7DrB,gBAAA;EACA,qBAAA;EACA,oBAAA;ArHyktCN;;AoH5gtCE;ECxDF,yBAAA;EACA,cDwDmC;ApHghtCnC;AqHvktCA;EACE,mBDsDiC;ECrDjC,cjGXkB;ApBoltCpB;;AoHxhtCE;ECzEA,mBD0EyB;ECzEzB,cjGYkB;ApByltCpB;AqHnmtCE;EAEE,mBAAA;EACA,cjGOgB;ApB6ltCpB;AqHlmtCE;EACE,qBAAA;EACA,mBAAA;ArHomtCJ;AqHnmtCI;EACE,mBD8DqB;EC7DrB,gBAAA;EACA,qBAAA;EACA,oBAAA;ArHqmtCN;;AoHxitCE;ECxDF,yBAAA;EACA,cDwDmC;ApH4itCnC;AqHnmtCA;EACE,mBDsDiC;ECrDjC,cjGXkB;ApBgntCpB;;AoH7itCA,oBAAA;AAEE;ECtDA,wCAAA;EACA,sBAAA;EACA,kCAAA;ArHsmtCF;AqHrmtCE;EACE,cnG2CW;AlB4jtCf;AqB5ntCE;EgGwBE,cjGtBgB;EiGuBhB,yBnGuCW;EmGtCX,qBnGsCW;AlBiktCf;AqHpmtCE;EAEE,4CAAA;ArHqmtCJ;AqHlmtCE;EAEE,cnG4BW;EmG3BX,6BAAA;ArHmmtCJ;AqHhmtCE;EAGE,cjGzCgB;EiG0ChB,yBnGoBW;EmGnBX,qBnGmBW;AlB6ktCf;;AoHlktCI;EACE,chG1Ec;ApB+otCpB;AoHpktCM;EAGE,chG9EY;ApBkptCpB;AoHlktCM;EAEE,mBlGpBO;EkGqBP,qBlGrBO;AlBwltCf;;AoHjltCE;ECtDA,0CAAA;EACA,sBAAA;EACA,oCAAA;ArH2otCF;AqH1otCE;EACE,cnG2CW;AlBimtCf;AqBjqtCE;EgGwBE,cjGtBgB;EiGuBhB,yBnGuCW;EmGtCX,qBnGsCW;AlBsmtCf;AqHzotCE;EAEE,8CAAA;ArH0otCJ;AqHvotCE;EAEE,cnG4BW;EmG3BX,6BAAA;ArHwotCJ;AqHrotCE;EAGE,cjGzCgB;EiG0ChB,yBnGoBW;EmGnBX,qBnGmBW;AlBkntCf;;AoHvmtCI;EACE,chG1Ec;ApBortCpB;AoHzmtCM;EAGE,chG9EY;ApBurtCpB;AoHvmtCM;EAEE,mBlGpBO;EkGqBP,qBlGrBO;AlB6ntCf;;AoHtntCE;ECtDA,uCAAA;EACA,sBAAA;EACA,iCAAA;ArHgrtCF;AqH/qtCE;EACE,cnG2CW;AlBsotCf;AqBtstCE;EgGwBE,cjGtBgB;EiGuBhB,yBnGuCW;EmGtCX,qBnGsCW;AlB2otCf;AqH9qtCE;EAEE,2CAAA;ArH+qtCJ;AqH5qtCE;EAEE,cnG4BW;EmG3BX,6BAAA;ArH6qtCJ;AqH1qtCE;EAGE,cjGzCgB;EiG0ChB,yBnGoBW;EmGnBX,qBnGmBW;AlBuptCf;;AoH5otCI;EACE,chG1Ec;ApByttCpB;AoH9otCM;EAGE,chG9EY;ApB4ttCpB;AoH5otCM;EAEE,mBlGpBO;EkGqBP,qBlGrBO;AlBkqtCf;;AoH3ptCE;ECtDA,yCAAA;EACA,sBAAA;EACA,mCAAA;ArHqttCF;AqHpttCE;EACE,cnG2CW;AlB2qtCf;AqB3utCE;EgGwBE,cjGtBgB;EiGuBhB,yBnGuCW;EmGtCX,qBnGsCW;AlBgrtCf;AqHnttCE;EAEE,6CAAA;ArHottCJ;AqHjttCE;EAEE,cnG4BW;EmG3BX,6BAAA;ArHkttCJ;AqH/stCE;EAGE,cjGzCgB;EiG0ChB,yBnGoBW;EmGnBX,qBnGmBW;AlB4rtCf;;AoHjrtCI;EACE,chG1Ec;ApB8vtCpB;AoHnrtCM;EAGE,chG9EY;ApBiwtCpB;AoHjrtCM;EAEE,mBlGpBO;EkGqBP,qBlGrBO;AlBustCf;;AoHhstCE;ECtDA,wCAAA;EACA,sBAAA;EACA,kCAAA;ArH0vtCF;AqHzvtCE;EACE,cnG2CW;AlBgttCf;AqBhxtCE;EgGwBE,cjGtBgB;EiGuBhB,yBnGuCW;EmGtCX,qBnGsCW;AlBqttCf;AqHxvtCE;EAEE,4CAAA;ArHyvtCJ;AqHtvtCE;EAEE,cnG4BW;EmG3BX,6BAAA;ArHuvtCJ;AqHpvtCE;EAGE,cjGzCgB;EiG0ChB,yBnGoBW;EmGnBX,qBnGmBW;AlBiutCf;;AoHtttCI;EACE,chG1Ec;ApBmytCpB;AoHxttCM;EAGE,chG9EY;ApBsytCpB;AoHtttCM;EAEE,mBlGpBO;EkGqBP,qBlGrBO;AlB4utCf;;AoHrutCE;ECtDA,wCAAA;EACA,sBAAA;EACA,kCAAA;ArH+xtCF;AqH9xtCE;EACE,cnG2CW;AlBqvtCf;AqBrztCE;EgGwBE,cjGtBgB;EiGuBhB,yBnGuCW;EmGtCX,qBnGsCW;AlB0vtCf;AqH7xtCE;EAEE,4CAAA;ArH8xtCJ;AqH3xtCE;EAEE,cnG4BW;EmG3BX,6BAAA;ArH4xtCJ;AqHzxtCE;EAGE,cjGzCgB;EiG0ChB,yBnGoBW;EmGnBX,qBnGmBW;AlBswtCf;;AoH3vtCI;EACE,chG1Ec;ApBw0tCpB;AoH7vtCM;EAGE,chG9EY;ApB20tCpB;AoH3vtCM;EAEE,mBlGpBO;EkGqBP,qBlGrBO;AlBixtCf;;AoH1wtCE;ECtDA,0CAAA;EACA,sBAAA;EACA,oCAAA;ArHo0tCF;AqHn0tCE;EACE,cnG2CW;AlB0xtCf;AqB11tCE;EgGwBE,cjGtBgB;EiGuBhB,yBnGuCW;EmGtCX,qBnGsCW;AlB+xtCf;AqHl0tCE;EAEE,8CAAA;ArHm0tCJ;AqHh0tCE;EAEE,cnG4BW;EmG3BX,6BAAA;ArHi0tCJ;AqH9ztCE;EAGE,cjGzCgB;EiG0ChB,yBnGoBW;EmGnBX,qBnGmBW;AlB2ytCf;;AoHhytCI;EACE,chG1Ec;ApB62tCpB;AoHlytCM;EAGE,chG9EY;ApBg3tCpB;AoHhytCM;EAEE,mBlGpBO;EkGqBP,qBlGrBO;AlBsztCf;;AoH/ytCE;ECtDA,uCAAA;EACA,sBAAA;EACA,iCAAA;ArHy2tCF;AqHx2tCE;EACE,cnG2CW;AlB+ztCf;AqB/3tCE;EgGwBE,cjGtBgB;EiGuBhB,yBnGuCW;EmGtCX,qBnGsCW;AlBo0tCf;AqHv2tCE;EAEE,2CAAA;ArHw2tCJ;AqHr2tCE;EAEE,cnG4BW;EmG3BX,6BAAA;ArHs2tCJ;AqHn2tCE;EAGE,cjGzCgB;EiG0ChB,yBnGoBW;EmGnBX,qBnGmBW;AlBg1tCf;;AoHr0tCI;EACE,chG1Ec;ApBk5tCpB;AoHv0tCM;EAGE,chG9EY;ApBq5tCpB;AoHr0tCM;EAEE,mBlGpBO;EkGqBP,qBlGrBO;AlB21tCf;;AsHv6tCA,gBAAA;AAEA;EACE,yBAAA;AtHy6tCF;AsHv6tCE;EACE,mBlGsFgB;ApBm1tCpB;AsHv6tCI;EACE,4BAAA;AtHy6tCN;AsHr6tCE;EACE,YAAA;EACA,qBlGsSgC;ApBiotCpC;AsHt6tCI;EACE,mBlG2Ec;EkG1Ed,mBlGmS8B;EkGlS9B,qBAAA;EACA,clGgS8B;EkG/R9B,qBAAA;EACA,mBAAA;AtHw6tCN;AsHv6tCM;EACE,uBAAA;AtHy6tCR;AsHv6tCM;EACE,WAAA;AtHy6tCR;AsHv6tCM;EACE,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;AtHy6tCR;AsHx6tCQ;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,kCAAA;EACA,qCAAA;AtH06tCV;AsHx6tCQ;EACE,YAAA;EACA,UAAA;EACA,0BlGsQ0B;EkGrQ1B,wBAAA;EACA,uBAAA;AtH06tCV;AsHx6tCQ;EACE,kCAAA;EACA,qCAAA;EACA,gDAAA;EACA,SAAA;EACA,YAAA;AtH06tCV;AsHv6tCM;EACE,qBAAA;EACA,mBAAA;AtHy6tCR;AsHv6tCM;EACE,4BAAA;AtHy6tCR;;AsHl6tCA,uBAAA;AAEE;EC1BA,mCAAA;EACA,qBrG4Ba;AlBm6tCf;AuH77tCE;EACE,crGyBW;AlBs6tCf;AuH77tCI;EACE,cAAA;AvH+7tCN;AuH57tCI;EACE,cAAA;AvH87tCN;AuH17tCE;EACE,uBAAA;AvH47tCJ;AuH17tCI;EACE,mBAAA;AvH47tCN;AuH17tCM;EACE,crGOO;EqGNP,YAAA;AvH47tCR;AuH17tCQ;EACE,0BAAA;AvH47tCV;AuHx7tCM;EACE,crGFO;AlB47tCf;AuHv7tCM;EACE,uBAAA;AvHy7tCR;;AsHl8tCE;EC1BA,qCAAA;EACA,qBrG4Ba;AlBo8tCf;AuH99tCE;EACE,crGyBW;AlBu8tCf;AuH99tCI;EACE,cAAA;AvHg+tCN;AuH79tCI;EACE,cAAA;AvH+9tCN;AuH39tCE;EACE,uBAAA;AvH69tCJ;AuH39tCI;EACE,iBAAA;AvH69tCN;AuH39tCM;EACE,crGOO;EqGNP,YAAA;AvH69tCR;AuH39tCQ;EACE,wBAAA;AvH69tCV;AuHz9tCM;EACE,crGFO;AlB69tCf;AuHx9tCM;EACE,uBAAA;AvH09tCR;;AsHn+tCE;EC1BA,kCAAA;EACA,qBrG4Ba;AlBq+tCf;AuH//tCE;EACE,crGyBW;AlBw+tCf;AuH//tCI;EACE,cAAA;AvHiguCN;AuH9/tCI;EACE,cAAA;AvHgguCN;AuH5/tCE;EACE,uBAAA;AvH8/tCJ;AuH5/tCI;EACE,mBAAA;AvH8/tCN;AuH5/tCM;EACE,crGOO;EqGNP,YAAA;AvH8/tCR;AuH5/tCQ;EACE,0BAAA;AvH8/tCV;AuH1/tCM;EACE,crGFO;AlB8/tCf;AuHz/tCM;EACE,uBAAA;AvH2/tCR;;AsHpguCE;EC1BA,oCAAA;EACA,qBrG4Ba;AlBsguCf;AuHhiuCE;EACE,crGyBW;AlByguCf;AuHhiuCI;EACE,cAAA;AvHkiuCN;AuH/huCI;EACE,cAAA;AvHiiuCN;AuH7huCE;EACE,uBAAA;AvH+huCJ;AuH7huCI;EACE,mBAAA;AvH+huCN;AuH7huCM;EACE,crGOO;EqGNP,YAAA;AvH+huCR;AuH7huCQ;EACE,0BAAA;AvH+huCV;AuH3huCM;EACE,crGFO;AlB+huCf;AuH1huCM;EACE,uBAAA;AvH4huCR;;AsHriuCE;EC1BA,mCAAA;EACA,qBrG4Ba;AlBuiuCf;AuHjkuCE;EACE,crGyBW;AlB0iuCf;AuHjkuCI;EACE,cAAA;AvHmkuCN;AuHhkuCI;EACE,cAAA;AvHkkuCN;AuH9juCE;EACE,uBAAA;AvHgkuCJ;AuH9juCI;EACE,mBAAA;AvHgkuCN;AuH9juCM;EACE,crGOO;EqGNP,YAAA;AvHgkuCR;AuH9juCQ;EACE,0BAAA;AvHgkuCV;AuH5juCM;EACE,crGFO;AlBgkuCf;AuH3juCM;EACE,uBAAA;AvH6juCR;;AsHtkuCE;EC1BA,mCAAA;EACA,qBrG4Ba;AlBwkuCf;AuHlmuCE;EACE,crGyBW;AlB2kuCf;AuHlmuCI;EACE,cAAA;AvHomuCN;AuHjmuCI;EACE,cAAA;AvHmmuCN;AuH/luCE;EACE,uBAAA;AvHimuCJ;AuH/luCI;EACE,mBAAA;AvHimuCN;AuH/luCM;EACE,crGOO;EqGNP,YAAA;AvHimuCR;AuH/luCQ;EACE,0BAAA;AvHimuCV;AuH7luCM;EACE,crGFO;AlBimuCf;AuH5luCM;EACE,uBAAA;AvH8luCR;;AsHvmuCE;EC1BA,qCAAA;EACA,qBrG4Ba;AlBymuCf;AuHnouCE;EACE,crGyBW;AlB4muCf;AuHnouCI;EACE,cAAA;AvHqouCN;AuHlouCI;EACE,cAAA;AvHoouCN;AuHhouCE;EACE,uBAAA;AvHkouCJ;AuHhouCI;EACE,iBAAA;AvHkouCN;AuHhouCM;EACE,crGOO;EqGNP,YAAA;AvHkouCR;AuHhouCQ;EACE,wBAAA;AvHkouCV;AuH9nuCM;EACE,crGFO;AlBkouCf;AuH7nuCM;EACE,uBAAA;AvH+nuCR;;AsHxouCE;EC1BA,kCAAA;EACA,qBrG4Ba;AlB0ouCf;AuHpquCE;EACE,crGyBW;AlB6ouCf;AuHpquCI;EACE,cAAA;AvHsquCN;AuHnquCI;EACE,cAAA;AvHqquCN;AuHjquCE;EACE,uBAAA;AvHmquCJ;AuHjquCI;EACE,mBAAA;AvHmquCN;AuHjquCM;EACE,crGOO;EqGNP,YAAA;AvHmquCR;AuHjquCQ;EACE,0BAAA;AvHmquCV;AuH/puCM;EACE,crGFO;AlBmquCf;AuH9puCM;EACE,uBAAA;AvHgquCR;;AsHjquCM;EACE,clGpEY;ApBwuuCpB;AsHnquCQ;EACE,cAAA;AtHqquCV;AsHnquCQ;EACE,cAAA;AtHqquCV;;AsH3quCM;EACE,clGpEY;ApBkvuCpB;AsH7quCQ;EACE,cAAA;AtH+quCV;AsH7quCQ;EACE,cAAA;AtH+quCV;;AsHrruCM;EACE,clGpEY;ApB4vuCpB;AsHvruCQ;EACE,cAAA;AtHyruCV;AsHvruCQ;EACE,cAAA;AtHyruCV;;AsH/ruCM;EACE,clGpEY;ApBswuCpB;AsHjsuCQ;EACE,cAAA;AtHmsuCV;AsHjsuCQ;EACE,cAAA;AtHmsuCV;;AsHzsuCM;EACE,clGpEY;ApBgxuCpB;AsH3suCQ;EACE,cAAA;AtH6suCV;AsH3suCQ;EACE,cAAA;AtH6suCV;;AsHntuCM;EACE,clGpEY;ApB0xuCpB;AsHrtuCQ;EACE,cAAA;AtHutuCV;AsHrtuCQ;EACE,cAAA;AtHutuCV;;AsH7tuCM;EACE,clGpEY;ApBoyuCpB;AsH/tuCQ;EACE,cAAA;AtHiuuCV;AsH/tuCQ;EACE,cAAA;AtHiuuCV;;AsHvuuCM;EACE,clGpEY;ApB8yuCpB;AsHzuuCQ;EACE,cAAA;AtH2uuCV;AsHzuuCQ;EACE,cAAA;AtH2uuCV;;AwHl0uCA,WAAA;AAEA;EACE,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,sBAAA;EACA,gCpG8EM;EoG7EN,gBpGgFmB;ApBovuCrB;AwHn0uCE;EACE,oBAAA;AxHq0uCJ;;AwHh0uCA,mBAAA;AAEE;ECdD,mBvGwEc;EuGvEd,crGSmB;ApBw0uCpB;;AwHp0uCE;ECdD,mBvGwEc;EuGvEd,crGSmB;ApB60uCpB;;AwHz0uCE;ECdD,mBvGwEc;EuGvEd,crGSmB;ApBk1uCpB;;AwH90uCE;ECdD,mBvGwEc;EuGvEd,crGSmB;ApBu1uCpB;;AwHn1uCE;ECdD,mBvGwEc;EuGvEd,crGSmB;ApB41uCpB;;AwHx1uCE;ECdD,mBvGwEc;EuGvEd,crGSmB;ApBi2uCpB;;AwH71uCE;ECdD,mBvGwEc;EuGvEd,crGSmB;ApBs2uCpB;;AwHl2uCE;ECdD,mBvGwEc;EuGvEd,crGSmB;ApB22uCpB;;AwHl2uCA,4BAAA;AAEE;EChBD,cvGmEc;EuGlEd,yBAAA;AzHq3uCD;;AwHt2uCE;EChBD,cvGmEc;EuGlEd,yBAAA;AzH03uCD;;AwH32uCE;EChBD,cvGmEc;EuGlEd,yBAAA;AzH+3uCD;;AwHh3uCE;EChBD,cvGmEc;EuGlEd,yBAAA;AzHo4uCD;;AwHr3uCE;EChBD,cvGmEc;EuGlEd,yBAAA;AzHy4uCD;;AwH13uCE;EChBD,cvGmEc;EuGlEd,yBAAA;AzH84uCD;;AwH/3uCE;EChBD,cvGmEc;EuGlEd,yBAAA;AzHm5uCD;;AwHp4uCE;EChBD,cvGmEc;EuGlEd,yBAAA;AzHw5uCD;;A0Hl6uCA,UAAA;AAEA;EACE,YAAA;EACA,6DAAA;EACA,sBtGiRmB;ApBmpuCrB;A0Hn6uCE;EACE,0BAAA;A1Hq6uCJ;A0Hp6uCI;EACE,iBAAA;A1Hs6uCN;A0Hn6uCE;EACE,cAAA;EACA,uBAAA;EACA,0BAAA;A1Hq6uCJ;A0Hn6uCE;EAEE,mBAAA;EACA,oBAAA;EACA,uBAAA;A1Ho6uCJ;A0Hj6uCE;EACE,ctG8PqB;EsG7PrB,gBtG8DgB;ApBq2uCpB;A0Hj6uCE;EACA,yBAAA;A1Hm6uCF;A0Hj6uCC;EACC,yBAAA;A1Hm6uCF;A0Hj6uCC;EACC,yBAAA;A1Hm6uCF;A0Hj6uCC;EACC,yBAAA;A1Hm6uCF;A0Hj6uCC;EhGtBG,kBAAA;A1B07uCJ;A0Hh6uCE;EACE,mBAAA;EACA,qBAAA;A1Hk6uCJ;A0Hh6uCE;EACE,ctGnCgB;EsGoChB,kBAAA;A1Hk6uCJ;A0Hh6uCE;EACE,kBAAA;A1Hk6uCJ;A0Hj6uCI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;A1Hm6uCN;A0Hh6uCE;EACE,4DAAA;EACA,kBAAA;A1Hk6uCJ;A0Hj6uCI;EACE,YAAA;A1Hm6uCN;A0Hl6uCM;EAFF;IAGI,YAAA;IACA,gBAAA;IACA,gBAAA;E1Hq6uCN;AACF;A0Hn6uCI;EACC;IACE,kBAAA;E1Hq6uCL;AACF;;A0H95uCE;EC/EA,kCDgFgC;EC/EhC,yBAAA;EACA,cD8E6F;A1Hm6uC/F;;A0Hp6uCE;EC/EA,oCDgFgC;EC/EhC,yBAAA;EACA,cD8E6F;A1Hy6uC/F;;A0H16uCE;EC/EA,iCDgFgC;EC/EhC,yBAAA;EACA,cD8E6F;A1H+6uC/F;;A0Hh7uCE;EC/EA,mCDgFgC;EC/EhC,yBAAA;EACA,cD8E6F;A1Hq7uC/F;;A0Ht7uCE;EC/EA,kCDgFgC;EC/EhC,yBAAA;EACA,cD8E6F;A1H27uC/F;;A0H57uCE;EC/EA,kCDgFgC;EC/EhC,yBAAA;EACA,cD8E6F;A1Hi8uC/F;;A0Hl8uCE;EC/EA,oCDgFgC;EC/EhC,yBAAA;EACA,cD8E6F;A1Hu8uC/F;;A0Hx8uCE;EC/EA,iCDgFgC;EC/EhC,yBAAA;EACA,cD8E6F;A1H68uC/F;;A4HhivCA,YAAA;AAGE;EzHiCuD,aAAA;EAjBQ,mBwGS9C;ExGT8C,uBwGuD9C;EiBnEf,kBAAA;EACA,mBAAA;A5HoivCJ;A4HnivCI;EACE,gBAAA;A5HqivCN;A4HnivCI;EACE,eAAA;EACA,kBAAA;A5HqivCN;A4HnivCI;EACE,cAAA;EACA,kBAAA;A5HqivCN;A4HpivCM;;EAEE,WAAA;EACA,YAAA;EACA,kBAAA;EzHaiD,aAAA;EAjBQ,mBwGuD9C;ExGvD8C,uBwGkD9C;A3G8/uCnB;A4HxivCQ;;EACE,mBAAA;EACA,SAAA;A5H2ivCV;A4HrivCM;EACE,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;A5HuivCR;A4H3hvCI;EACE,cAAA;EACA,kBAAA;A5H6hvCN;A4H5hvCM;EACE,eAAA;A5H8hvCR;A4H5hvCM;EACE,mBAAA;EACA,cAAA;A5H8hvCR;A4H7hvCQ;EACE,mDAAA;EACA,mBAAA;EACA,+BAAA;A5H+hvCV;A4H3hvCM;EACE,eAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;A5H6hvCR;A4H1hvCI;EzH3CqD,aAAA;EAjBQ,mBwGS9C;A3GmlvCnB;A4H7hvCM;EACE,WAAA;EACA,cAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;A5H+hvCR;A4H9hvCQ;EACE,kBAAA;A5HgivCV;A4H1hvCI;EACE,kBAAA;A5H4hvCN;A4H3hvCM;EACE,cAAA;A5H6hvCR;A4H3hvCM;EACE,iBAAA;A5H6hvCR;A4HxhvCI;EACE,gCAAA;A5H0hvCN;A4HzhvCM;EACE,gBAAA;A5H2hvCR;;A4HlhvCE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;A5HqhvCJ;A4HphvCI;EACE,WAAA;EACA,YAAA;EACA,mCAAA;EACA,kBAAA;EACA,c1GrDS;AlB2kvCf;A4HphvCI;EACE,eAAA;A5HshvCN;;A4HlivCE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;A5HqivCJ;A4HpivCI;EACE,WAAA;EACA,YAAA;EACA,qCAAA;EACA,kBAAA;EACA,c1GrDS;AlB2lvCf;A4HpivCI;EACE,eAAA;A5HsivCN;;A4HljvCE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;A5HqjvCJ;A4HpjvCI;EACE,WAAA;EACA,YAAA;EACA,kCAAA;EACA,kBAAA;EACA,c1GrDS;AlB2mvCf;A4HpjvCI;EACE,eAAA;A5HsjvCN;;A4HlkvCE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;A5HqkvCJ;A4HpkvCI;EACE,WAAA;EACA,YAAA;EACA,oCAAA;EACA,kBAAA;EACA,c1GrDS;AlB2nvCf;A4HpkvCI;EACE,eAAA;A5HskvCN;;A4HllvCE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;A5HqlvCJ;A4HplvCI;EACE,WAAA;EACA,YAAA;EACA,mCAAA;EACA,kBAAA;EACA,c1GrDS;AlB2ovCf;A4HplvCI;EACE,eAAA;A5HslvCN;;A4HlmvCE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;A5HqmvCJ;A4HpmvCI;EACE,WAAA;EACA,YAAA;EACA,mCAAA;EACA,kBAAA;EACA,c1GrDS;AlB2pvCf;A4HpmvCI;EACE,eAAA;A5HsmvCN;;A4HlnvCE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;A5HqnvCJ;A4HpnvCI;EACE,WAAA;EACA,YAAA;EACA,qCAAA;EACA,kBAAA;EACA,c1GrDS;AlB2qvCf;A4HpnvCI;EACE,eAAA;A5HsnvCN;;A4HlovCE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;A5HqovCJ;A4HpovCI;EACE,WAAA;EACA,YAAA;EACA,kCAAA;EACA,kBAAA;EACA,c1GrDS;AlB2rvCf;A4HpovCI;EACE,eAAA;A5HsovCN;;A6H1wvCA,UAAA;AAEA;;;EAGE,kBAAA;EACA,mBzGsFkB;ApBsrvCpB;A6H3wvCE;;;EACE,gBAAA;A7H+wvCJ;;A6H3wvCA;;;EAGE,gBAAA;EACA,UAAA;A7H8wvCF;A6H7wvCE;;;EACE,oBAAA;A7HixvCJ;A6HhxvCI;;;EACE,oCAAA;EACA,oBAAA;EACA,aAAA;EACA,oBAAA;A7HoxvCN;;A6H7wvCI;EACE,gBAAA;EACA,cAAA;A7HgxvCN;;A6HzwvCI;EACE,gBAAA;EACA,cAAA;A7H4wvCN;;A6HrwvCI;EACE,gBAAA;EACA,cAAA;A7HwwvCN;;A6HnwvCA;EACE,eAAA;A7HswvCF;A6HrwvCE;EACE,gBAAA;A7HuwvCJ;A6HrwvCE;EACE,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,cAAA;EACA,oBAAA;A7HuwvCJ;A6HtwvCI;EAEE,WAAA;EACA,kBAAA;A7HuwvCN;A6HrwvCI;EACE,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;A7HuwvCN;A6HrwvCI;EACE,WAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;EACA,mBzGrEc;EyGsEd,mBAAA;A7HuwvCN;A6HpwvCM;EACE,mBAAA;A7HswvCR;A6HlwvCM;EACE,mBAAA;A7HowvCR;A6HhwvCM;EACE,mBAAA;A7HkwvCR;A6H9vvCM;EACE,mBAAA;A7HgwvCR;A6H5vvCM;EACE,mBAAA;A7H8vvCR;;A6HxvvCA;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;A7H2vvCF;A6HzvvCE;EACE,kBAAA;A7H2vvCJ;A6HxvvCE;EACE,kBAAA;EACA,cAAA;EACA,oBAAA;A7H0vvCJ;A6HxvvCI;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,QAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,mBzGyQsB;ApBi/uC5B;A6HvvvCI;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;A7HyvvCN;A6HrvvCM;EACE,WAAA;EACA,WAAA;A7HuvvCR;A6HnvvCI;EACE,iBAAA;A7HqvvCN;A6HnvvCM;EACE,WAAA;EACA,MAAA;EACA,WAAA;A7HqvvCR;;A8H15vCA,cAAA;AAEA;EACE,qBAAA;EACA,gBAAA;A9H45vCF;A8H35vCE;EACE,0BAAA;EACA,6BAAA;EACA,WAAA;EACA,uBAAA;A9H65vCJ;A8H35vCE;EACE,mBAAA;A9H65vCJ;A8H55vCI;EACE,iBAAA;EACA,oBAAA;A9H85vCN;;A8Hz5vCA;EACE,YAAA;EACA,gBAAA;A9H45vCF;A8H35vCE;EACE,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;A9H65vCJ;A8H55vCI;EAIE,oBAAA;EACA,iBAAA;EACA,gCAAA;A9H25vCN;A8H15vCM;EACE,mBAAA;A9H45vCR;A8H15vCM;EAEE,cAAA;EACA,mBAAA;EACA,sBAAA;A9H25vCR;A8Hv5vCU;EACE,WAAA;EACA,YAAA;A9Hy5vCZ;A8Hl5vCE;EACE,kBAAA;A9Ho5vCJ;A8Hj5vCE;EAOE,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;A9H64vCJ;A8H14vCE;EACE,6BAAA;EACA,8BAAA;A9H44vCJ;A+Hp9vCM;EACE,aAAA;A/Hs9vCR;A+Hl9vCE;EACE,mBAAA;EACA,mB3GgFgB;E2G/EhB,gB3G6OuB;ApBuuvC3B;A+Hn9vCI;EACE,eAAA;EACA,uBAAA;A/Hq9vCN;A+Hp9vCM;EACE,mBAAA;A/Hs9vCR;A+Hp9vCM;EACE,c3GPY;ApB69vCpB;A+Hj9vCQ;EACE,sBAAA;A/Hm9vCV;;AgI9+vCA,YAAA;ACAA;EACC,gBAAA;AjIk/vCD;AiIj/vCC;EACG,gBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,4BAAA;EACA,gBAAA;EACF,UAAA;AjIm/vCF;AiIl/vCE;EACC,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AjIo/vCH;AiIn/vCG;EACC,SAAA;EACA,MAAA;EACA,oBAAA;EACA,mBAAA;EAEA,0BAAA;EAIA,+EACE;AjIk/vCN;AiI/+vCG;EACC,QAAA;EACA,QAAA;EACA,oBAAA;EACA,mBAAA;EAEA,2BAAA;EAIA,+EACE;AjI8+vCN;AiI3+vCG;EACC,SAAA;EACA,SAAA;EACA,oBAAA;EACA,mBAAA;EAEA,2BAAA;EAIA,+EACE;AjI0+vCN;AiIv+vCG;EACC,QAAA;EACA,OAAA;EACA,oBAAA;EACA,mBAAA;EAEA,0BAAA;EAIA,+EACE;AjIs+vCN;AiI19vCA;EAEI;IAAwC,yBAAA;EjIm+vC1C;AACF;AiIl9vCA;EAEI;IAAQ,YAAA;EjIu/vCV;EiIt/vCE;IAAQ,aAAA;EjIy/vCV;EiIx/vCE;IAAQ,aAAA;EjI2/vCV;EiI1/vCE;IAAQ,aAAA;EjI6/vCV;EiI5/vCE;IAAQ,aAAA;EjI+/vCV;EiI9/vCE;IAAQ,YAAA;EjIigwCV;EiIhgwCE;IAAQ,aAAA;EjImgwCV;EiIlgwCE;IAAQ,aAAA;EjIqgwCV;EiIpgwCE;IAAQ,YAAA;EjIugwCV;EiItgwCE;IAAQ,aAAA;EjIygwCV;EiIxgwCE;IAAQ,aAAA;EjI2gwCV;AACF;AkI9nwCA;EACC,kBAAA;AlIgowCD;;AkI9nwCA;EACE,kBAAA;EACA,YAAA;EACD,WAAA;EACA,SAAA;EACC,6BAAA;EACA,SAAA;EACA,gCAAA;AlIiowCF;;AkI9nwCA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACD,SAAA;EACA,SAAA;EACC,wBAAA;EACA,8CAAA;EACA,6BAAA;AlIiowCF;;AkI9nwCA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACD,SAAA;EACA,SAAA;EACC,wBAAA;EACA,+CAAA;EACA,6BAAA;EACA,oCAAA;EACA,sBAAA;AlIiowCF;;AkI9nwCA;EACE,kBAAA;EACA,kBAAA;AlIiowCF;;AkI9nwCA;EACE,WAAA;EACA,YAAA;EACA,iCAAA;EACA,sCAAA;EACC,yBAAA;AlIiowCH;;AkI9nwCA;EACE,OAAA;EACA,QAAA;AlIiowCF;;AkI9nwCA;EACE,OAAA;EACA,SAAA;AlIiowCF;;AkI9nwCA;EACE,SAAA;EACA,UAAA;AlIiowCF;;AkI9nwCA;EACE,UAAA;EACA,QAAA;AlIiowCF;;AkI9nwCA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wHAAA;EACA,UAAA;EACA,yBAAA;EACA,qCAAA;AlIiowCF;;AkI9nwCA;EACE,uBAAA;AlIiowCF;;AkI/nwCA;EACE,sBAAA;AlIkowCF;;AkIhowCA;EACE,uBAAA;AlImowCF;;AkIjowCA;EACE,oBAAA;AlIoowCF;;AkIlowCA;EACE,uBAAA;AlIqowCF;;AkInowCA;EACE,sBAAA;AlIsowCF;;AkIpowCA;EACE,uBAAA;AlIuowCF;;AkIrowCA;EACE,mBAAA;AlIwowCF;;AkIrowCA;EACE;IACE,wBAAA;IACA,8CAAA;ElIwowCF;EkItowCA;IACE,wBAAA;IACA,+CAAA;ElIwowCF;AACF;AkIrowCA;EACE;IACE,mBAAA;IACC,yBAAA;ElIuowCH;EkIrowCA;IACE,qBAAA;IACA,yBAAA;ElIuowCF;EkIrowCA;IACE,mBAAA;ElIuowCF;EkIrowCA;IACF,mBAAA;IACK,yBAAA;ElIuowCH;EkIrowCA;IACE,mBAAA;IACC,yBAAA;ElIuowCH;AACF;AmI9wwCA,iBAAA;AACA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,4HAAA;EAQA,kCAAA;AnIywwCJ;;AmItwwCE;EACE;IACE,gCAAA;EnIywwCJ;EmIvwwCE;IACE,4HAAA;EnIywwCJ;EmI/vwCE;IACE,4HAAA;EnIiwwCJ;EmIvvwCE;IACE,yBAAA;IACA,kCAAA;EnIyvwCJ;AACF;AoIxywCA,sBAAA;AAEA;EACC;IACC,qBAAA;EpIyywCA;EoIvywCD;IACC,yBAAA;EpIyywCA;EoIvywCD;IACC,yBAAA;EpIyywCA;AACF;AoIrywCA;EACA,kBAAA;EACE,SAAA;EACA,QAAA;EACA,gCAAA;EACA,qBAAA;ApIuywCF;;AoInywCA;EACE,cAAA;EACA,WCzBY;ED0BZ,YC1BY;ED2BZ,mBAAA;ApIsywCF;;AoIlywCA;EACA,kBAAA;EACE,OAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,2BAAA;EACA,sCAAA;EACA,2BAAA;ApIqywCF;;AoIjywCA;;;;EAIC,kBAAA;EACC,WC/CmB;EDgDnB,YChDmB;EDiDnB,cAAA;EACA,WAAA;ApIoywCF;;AoI/xwCC;EACC,sBAAA;EACA,qBAAA;EACA,SAAA;EACA,UAAA;ApIkywCF;AoI/xwCC;EACC,uBAAA;EACA,qBAAA;EACA,SAAA;EACA,WAAA;ApIiywCF;;AoI1xwCC;EACC,sBAAA;EACA,wBAAA;EACA,YAAA;EACA,UAAA;ApI6xwCF;AoI1xwCC;EACC,uBAAA;EACA,wBAAA;EACA,YAAA;EACA,WAAA;ApI4xwCF;;AsIl3wCA,kBAAA;AACA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AtIq3wCJ;;AsIn3wCA;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,8BAAA;EACA,yBAAA;AtIs3wCJ;;AsIn3wCE;EACE,WAAA;EACA,2BAAA;AtIs3wCJ;;AsIn3wCE;EACE,0BAAA;AtIs3wCJ;;AsIn3wCE;EACE;IAIE,uBAAA;EtIs3wCJ;EsIn3wCE;IAIE,yBAAA;EtIq3wCJ;AACF;AuI/5wCA,wBAAA;AACA;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AvIi6wCJ;;AuI/5wCA;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wCAAA;EACA,gBAAA;AvIk6wCJ;;AuI/5wCE;EACE,yCAAA;AvIk6wCJ;;AuI/5wCE;EACE,+CAAA;AvIk6wCJ;;AuI/5wCE;EACE,+CAAA;AvIk6wCJ;;AuI/5wCE;EACE;IAIE,wBAAA;EvIk6wCJ;EuI/5wCE;IAIE,4BAAA;EvIi6wCJ;AACF;AwI38wCA,eAAA;AACA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AxI68wCF;;AwI18wCA;EACE,qBAAA;EACA,UAAA;EACA,YAAA;EACA,wCAAA;AxI68wCF;;AwI18wCA;EACE,uCAAA;AxI68wCF;;AwI18wCA;EACE,6CAAA;AxI68wCF;;AwI18wCA;EACE,4CAAA;AxI68wCF;;AwI18wCA;EACE,6CAAA;AxI68wCF;;AwI18wCA;EACE;IAIE,oBAAA;ExI68wCF;EwI18wCA;IAIE,sBAAA;ExI48wCF;AACF;AyIz/wCA,uBAAA;AAEA;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AzI0/wCJ;;AyIx/wCA;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,sBAAA;EACA,uCAAA;EACA,6CAAA;AzI2/wCJ;;AyIx/wCE;EACE,SAAA;EACA,qBAAA;AzI2/wCJ;;AyIx/wCE;EACE;IAIE,oCAAA;EzI2/wCJ;EyIx/wCE;IAIE,8CAAA;EzI0/wCJ;EyIv/wCE;IAIE,4CAAA;EzIy/wCJ;EyIt/wCE;IAIE,+CAAA;EzIw/wCJ;AACF;A0I5ixCA,uBAAA;AAEA;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;A1I6ixCJ;;A0I1ixCA;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,UAAA;A1I6ixCJ;;A0I1ixCA;EACI,gDAAA;A1I6ixCJ;;A0I1ixCA;EACI,sDAAA;A1I6ixCJ;;A0I1ixCA;EACI,sDAAA;A1I6ixCJ;;A0I1ixCA;EACI;IACI,UAAA;E1I6ixCN;E0I1ixCE;IACI,UAAA;E1I4ixCN;AACF;A2InlxCA,gBAAA;AAEE;EAGE,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;A3IolxCJ;;A2IjlxCE;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,uCAAA;EACA,2BAAA;A3IolxCJ;;A2IjlxCE;EACE;IACE,oBAAA;E3IolxCJ;E2IjlxCE;IACE,0BAAA;E3ImlxCJ;E2IhlxCE;IACE,0CAAA;E3IklxCJ;AACF;A4ItnxCA,yBAAA;AAEA;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;A5IunxCJ;;A4IrnxCA;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,SAAA;EACA,wCAAA;EACA,iCAAA;A5IwnxCJ;;A4IrnxCE;EACE;IAIE,mCAAA;E5IwnxCJ;E4IrnxCE;IAIE,oCAAA;E5IunxCJ;AACF;A6IxpxCA,SAAA;AAEA;EACC,YAAA;A7IypxCD;A6IxpxCC;EACC,oDAAA;EACA,sBAAA;A7I0pxCF;A6IxpxCC;EACC,oDAAA;EACA,sBAAA;A7I0pxCF;A6IxpxCC;EACC,oDAAA;EACA,sBAAA;A7I0pxCF;A6IxpxCC;EACC,WAAA;EACA,YAAA;EACA,mBAAA;A7I0pxCF;A6IxpxCC;EACC,mBzHRkB;ApBkqxCpB;A6IzpxCE;EACC,czHgMuB;ApB29wC1B;A6IvpxCI;EAEC,qBzH8BU;ApB0nxCf;A6InpxCC;EACC,gBzH4HQ;ApByhxCV;A6IppxCE;EACC,czHkLuB;ApBo+wC1B;A6IlpxCI;EAEC,qBzHgBU;ApBmoxCf;A6I9oxCC;EACC,uBAAA;A7IgpxCF;A6I/oxCE;;EAEC,qBAAA;A7IipxCH;A6IhpxCG;;;EAEC,qBAAA;A7ImpxCJ;A6IhpxCE;EACC,sBAAA;A7IkpxCH;A6I/oxCC;EACC,UAAA;A7IipxCF;A6I/oxCG;EADD;IAEE,UAAA;IACA,YAAA;E7IkpxCF;AACF;A6I/oxCC;EACC,mBAAA;A7IipxCF;A6IhpxCE;EACC,YAAA;A7IkpxCH;A6I9oxCE;EACC,qBAAA;A7IgpxCH;A6I/oxCG;EACC,oBAAA;A7IipxCJ;A6I/oxCG;EACC,uBAAA;EACA,gBAAA;EACA,oBAAA;A7IipxCJ;A6I9oxCE;EACC,kBAAA;EACA,gBAAA;A7IgpxCH;A6I9oxCE;EACC,mBzHHiB;ApBmpxCpB;A6I/oxCG;EACC,cAAA;A7IipxCJ;;A8IlvxCA,mBAAA;AAII;EAEE,YAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;A9IivxCN;A8IhvxCM;EACE,oCAAA;EACA,mBAAA;EACA,iBAAA;EACA,UAAA;A9IkvxCR;A8I/uxCI;EACE,UAAA;A9IivxCN;A8I/uxCM;EACE,gBAAA;A9IivxCR;A8IhvxCQ;EACE,gBAAA;A9IkvxCV;A8I9uxCI;EACE,WAAA;A9IgvxCN;A8I/uxCM;EACE,gBAAA;A9IivxCR;A8IhvxCQ;EACE,gBAAA;A9IkvxCV;A8I3uxCM;EACE,kBAAA;EACA,c1H9BY;ApB2wxCpB;A8ItuxCQ;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;A9IwuxCV;A8IluxCU;EACE,yBAAA;A9IouxCZ;A8I3txCM;EAEE,YAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;A9I4txCR;A8I3txCQ;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;A9I6txCV;A8IztxCM;EACE,WAAA;EACA,UAAA;A9I2txCR;A8I1txCQ;EACE,UAAA;EACA,WAAA;A9I4txCV;A8IxtxCM;EACE,QAAA;A9I0txCR;A8IztxCQ;EACE,OAAA;EACA,WAAA;A9I2txCV;A8IptxCU;EACE,kBAAA;EACA,WAAA;A9IstxCZ;;A+Ij0xCA;EACI,kBAAA;A/Io0xCJ;;A+Ij0xCA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;A/Io0xCJ;;A+Ij0xCA;EACI,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,gCAAA;EACA,kBAAA;EACA,YAAA;A/Io0xCJ;;A+Ij0xCA;EACI,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;A/Io0xCJ;;A+Ij0xCA;EACI,WAAA;EACA,YAAA;A/Io0xCJ;;A+Ij0xCA;EACI,SAAA;A/Io0xCJ;;A+Ij0xCA;EACI,SAAA;A/Io0xCJ;;A+Ij0xCA;EACI,YAAA;EACA,aAAA;EACA,YAAA;A/Io0xCJ;;A+Ij0xCA;EACI,kBAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,qEAAA;A/Io0xCJ;;A+Ij0xCA;EACI,iBAAA;EACA,eAAA;EACA,kBAAA;A/Io0xCJ;;A+Ij0xCA;EACI,kBAAA;A/Io0xCJ;;A+Ij0xCA;EACI,SAAA;EACA,QAAA;A/Io0xCJ;;A+Ij0xCA;EACI,MAAA;EACA,QAAA;A/Io0xCJ;;A+Ij0xCA;EACI,iBAAA;EACA,YAAA;EACA,kBAAA;A/Io0xCJ;;A+Ij0xCA;EACI,WAAA;EACA,qBAAA;EACA,wBAAA;A/Io0xCJ;;A+Ij0xCA;EACI,WAAA;A/Io0xCJ;;A+Ij0xCA;EACI,qBAAA;EACA,YAAA;A/Io0xCJ;;A+Ij0xCA;EACI,WAAA;A/Io0xCJ;;A+Ij0xCA;EACI,YAAA;A/Io0xCJ;;A+Ij0xCA;EACI,YAAA;EACA,WAAA;EACA,qBAAA;EACA,sBAAA;A/Io0xCJ;;A+Ij0xCA;EACI,eAAA;A/Io0xCJ;;A+Ij0xCA;EACI,kBAAA;A/Io0xCJ;;A+Ij0xCA;EACI,qBAAA;EACA,sBAAA;EACA,iBAAA;EACA,iBAAA;A/Io0xCJ;;A+Il0xCA;EACE,WAAA;EACA,aAAA;A/Iq0xCF;A+Ip0xCE;EAHF;IAII,aAAA;E/Iu0xCF;AACF;;AgJn9xCA;EACE,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,W5HuGiB;E4HtGjB,2BAAA;EACA,mCAAA;EACA,gCAAA;EACA,+BAAA;AhJs9xCF;AgJr9xCE;EATF;IAUI,OAAA;EhJw9xCF;AACF;AgJt9xCE;EACE,mDAAA;EACA,2DAAA;EACA,wDAAA;EACA,uDAAA;EACA,yBAAA;EACA,Y5HwFe;E4HvFf,Y5HkIY;ApBs1xChB;AgJv9xCI;EARF;IASI,WAAA;EhJ09xCJ;AACF;AgJx9xCI;EACE,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,8BAAA;EACA,WAAA;AhJ09xCN;AgJx9xCM;EAGE,WAAA;AhJw9xCR;AgJr9xCM;EACE,0BAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;AhJu9xCR;AgJp9xCM;EACE,aAAA;AhJs9xCR;AgJp9xCQ;EACE,wBAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;AhJs9xCV;AgJh9xCE;EACE,4BAAA;EACA,oCAAA;EACA,iCAAA;EACA,gCAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,Y5HgFY;ApBk4xChB;AgJj9xCI;EAXF;IAYI,WAAA;IACA,kBAAA;IACA,mBAAA;EhJo9xCJ;AACF;AgJl9xCI;EACE,SAAA;EACA,cAAA;EACA,Y5HsEU;ApB84xChB;AgJl9xCM;EACE,mBAAA;AhJo9xCR;AgJn9xCQ;EAFF;IAGI,aAAA;EhJs9xCR;AACF;AgJl9xCQ;EADF;IAEI,kBAAA;IACA,mBAAA;IACA,kBAAA;EhJq9xCR;AACF;AgJj9xCI;EACE,mBAAA;EACA,mBAAA;AhJm9xCN;AgJh9xCQ;EACE,WAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AhJk9xCV;AgJh9xCU;EARF;IASI,mBAAA;IACA,oBAAA;EhJm9xCV;AACF;AgJj9xCU;EACE,yBAAA;AhJm9xCZ;AgJ98xCU;EACE,mBAAA;EACA,YAAA;EACA,yBAAA;AhJg9xCZ;AgJ18xCY;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AhJ48xCd;AgJ18xCc;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AhJ48xChB;;AgJl8xCA;EACE;IACE,mBAAA;EhJq8xCF;EgJn8xCE;IACE,WAAA;EhJq8xCJ;EgJl8xCM;IACE,aAAA;EhJo8xCR;EgJj8xCM;IACE,qBAAA;EhJm8xCR;AACF;AgJ77xCA;EAEI;IACE,WAAA;EhJ87xCJ;EgJ57xCI;IACE,gBAAA;EhJ87xCN;AACF;AiJ9myCA,YAAA;AAEA;EACE,6DAAA;EACA,8BAAA;EACA,uBAAA;EACA,WAAA;EACA,mBAAA;EACA,UAAA;EACA,Y7HkGiB;E6HjGjB,WAAA;EACA,mDAAA;EACA,2DAAA;EACA,wDAAA;EACA,uDAAA;AjJ+myCF;AiJ7myCE;EACE,mDAAA;EACA,2DAAA;EACA,wDAAA;EACA,uDAAA;EACA,wCAAA;EACF,cAAA;EACE,Y7HoFe;E6HnFf,Y7H8HY;ApBi/xChB;AiJ9myCI;EATF;IAUI,WAAA;EjJinyCJ;AACF;AiJhnyCI;EACE,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,8BAAA;EACA,WAAA;AjJknyCN;AiJhnyCM;EAGE,cAAA;AjJgnyCR;AiJ7myCM;EACE,2BAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;AjJ+myCR;AiJ7myCM;EACE,aAAA;AjJ+myCR;AiJ9myCQ;EACE,yBAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;AjJgnyCV;AiJ1myCE;EACE,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,iB7HoFY;ApBwhyChB;AiJ3myCI;EANF;IAOI,cAAA;EjJ8myCJ;AACF;AiJ5myCI;E9IpD6D,0B+IkDnD;EDIR,+BAAA;EACA,uCAAA;EACA,mBAAA;AjJinyCN;AiJhnyCM;EACE,YAAA;AjJknyCR;AiJ/myCM;E9I5CmD,aAAA;EAjBQ,mBwGuD9C;EsCSX,mBAAA;EACA,oCAAA;EACA,c7HSK;EjB3EoD,0B+IkDnD;EDkBN,0BAAA;EACA,kCAAA;EACA,YAAA;EACA,kCAAA;EACA,eAAA;AjJsnyCR;AiJpnyCQ;EACE,cAAA;AjJsnyCV;AiJrnyCU;EACE,e7HoCa;E6HnCb,cAAA;EACA,iBAAA;EAKA,wC7HkBc;ApBimyC1B;AiJvnyCY;EACE,cAAA;EACA,kBAAA;AjJynyCd;AiJtnyCY;EACE,sBAAA;AjJwnyCd;AiJrnyCU;EACE,yDAAA;EACA,cAAA;EACA,e7HqBa;E6HpBb,iBAAA;EAKA,gC7HKe;ApB8myC3B;AiJvnyCY;EACE,cAAA;EACA,kBAAA;AjJynyCd;AiJtnyCY;EACE,gBAAA;EACA,kBAAA;EACA,cAAA;AjJwnyCd;AiJpnyCQ;EACE,cAAA;EACA,qBAAA;EACA,oB7HJe;E6HKf,cAAA;EACA,sBAAA;AjJsnyCV;AiJpnyCQ;EACE,kBAAA;EACA,iBAAA;AjJsnyCV;AiJjnyCQ;EACE,mB7H3Be;E6H4Bf,kBAAA;AjJmnyCV;AiJlnyCU;EACE,WAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;AjJonyCZ;AiJlnyCU;EACE,c7HxIQ;ApB4vyCpB;AiJlnyCU;EACE,cAAA;AjJonyCZ;AiJ/myCQ;EACE,YAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;AjJinyCV;AiJhnyCU;EACE,WAAA;EACA,YAAA;AjJknyCZ;AiJjnyCY;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AjJmnyCd;AiJhnyCU;EACE,iBAAA;AjJknyCZ;AiJjnyCY;EACE,iBAAA;EACA,kBAAA;AjJmnyCd;AiJhnyCU;EACE,mBAAA;EACA,iBAAA;AjJknyCZ;AiJjnyCY;EACE,cAAA;EACA,kBAAA;AjJmnyCd;AiJ9myCM;EACE,gBAAA;AjJgnyCR;AiJ/myCQ;EACE,aAAA;EACA,cAAA;EACA,YAAA;AjJinyCV;AiJ/myCQ;EACE,mBAAA;AjJinyCV;AiJhnyCU;EACE,cAAA;AjJknyCZ;AiJ9myCM;EACE,kBAAA;AjJgnyCR;AiJ/myCQ;EACE,mBAAA;AjJinyCV;AiJ/myCQ;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;EACA,iBAAA;AjJinyCV;AiJhnyCU;EACE,iBAAA;AjJknyCZ;AiJjnyCY;EACE,cAAA;EACA,kBAAA;AjJmnyCd;AiJjnyCY;EACE,eAAA;EACA,c7HpID;E6HqIC,mBAAA;AjJmnyCd;AiJjnyCY;EACE,mBAAA;AjJmnyCd;AiJhnyCU;EACE,aAAA;EACA,mBAAA;AjJknyCZ;AiJjnyCY;EACE,kBAAA;AjJmnyCd;AiJlnyCc;;EAEE,kBAAA;EACA,mBAAA;EACA,sBAAA;AjJonyChB;AiJlnyCc;EACE,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;AjJonyChB;AiJlnyCc;EACE,eAAA;EACA,YAAA;EACA,iBAAA;EACA,c7HhPI;E6HiPJ,YAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;AjJonyChB;AiJlnyCc;EACE,aAAA;AjJonyChB;AiJlnyCc;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,c7H9PI;E6H+PJ,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;EACA,yBAAA;AjJonyChB;AiJhnyCU;EACE,eAAA;EACA,c7H1LC;ApB4yyCb;AiJhnyCU;EACE,UAAA;EACA,mBAAA;AjJknyCZ;AiJjnyCY;EACE,kBAAA;AjJmnyCd;AiJlnyCc;EACE,mBAAA;AjJonyChB;AiJlnyCkB;EACE,WAAA;EACA,YAAA;AjJonyCpB;AiJnnyCoB;EACE,mBAAA;AjJqnyCtB;AiJhnyCc;EACE,cAAA;AjJknyChB;AiJ/myCY;EACE,SAAA;AjJinyCd;AiJ5myCM;EACE,wBAAA;EACA,cAAA;AjJ8myCR;AiJ7myCQ;EACE,c7H3NG;E6H4NH,gB7HjOW;E6HkOX,eAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AjJ+myCV;AiJ5myCM;EACE,oBAAA;EACA,oBAAA;EACA,cAAA;EACA,oCAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AjJ8myCR;AiJ7myCQ;EACE,mBAAA;AjJ+myCV;AiJ3myCI;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AjJ6myCN;AiJ3myCM;EACE,UAAA;AjJ6myCR;AiJ5myCQ;EACE,c7H9PG;E6H+PH,uB7H3NqB;E6H4NrB,kBAAA;EACA,mB7H9NkB;E6H+NlB,cAAA;EACA,YAAA;EACA,aAAA;AjJ8myCV;AiJ7myCU;EACE,c7HnVQ;E6HoVR,uBAAA;AjJ+myCZ;AiJ7myCU;EACE,c7HvVQ;ApBs8yCpB;AiJ5myCQ;EACE,uBAAA;AjJ8myCV;AiJtmyCY;EACE,mB7HlQU;ApB02yCxB;AiJ7lyCc;EACE,cAAA;AjJ+lyChB;AiJtlyCc;EACE,cAAA;AjJwlyChB;AiJ/kyCc;EACE,cAAA;AjJilyChB;AiJxkyCc;EACE,cAAA;AjJ0kyChB;AiJjkyCc;EACE,cAAA;AjJmkyChB;;AiJtjyCA,6BAAA;AACA;EACE;IACE,eAAA;IACA,8BAAA;IACA,S7HrSY;I6HsSZ,SAAA;IACA,cAAA;IACA,aAAA;IAGA,8BAAA;EjJyjyCF;EiJxjyCE;IACE,QAAA;EjJ0jyCJ;AACF;AmJ9/yCA;EACE,wCAAA;EACA,cAAA;EACA,kBAAA;EACA,0BAAA;EACA,+BAAA;EACA,kCAAA;EACA,8BAAA;EACA,WAAA;EACA,mCAAA;EACA,gC/H4EM;ApBo7yCR;AmJ//yCE;EACE,cAAA;EACA,kBAAA;AnJigzCJ;AmJ//yCE;EAfF;IAgBI,cAAA;IACA,WAAA;EnJkgzCF;AACF;;AoJnhzCA,YAAA;AAII;EACE,iBhIgJU;ApBm4yChB;;AoJ5gzCE;EACE;IACE,WhI6Fe;EpBk7yCnB;EoJ9gzCI;IACE,YhI2Fa;EpBq7yCnB;EoJ9gzCI;IACE,WAAA;EpJghzCN;EoJ7gzCE;IACE,YhIoFe;EpB27yCnB;EoJ9gzCI;IACE,YhIkFa;EpB87yCnB;EoJ7gzCM;IACE,UAAA;IACA,SAAA;EpJ+gzCR;EoJ5gzCY;IACE,iBAAA;IACA,kBAAA;EpJ8gzCd;EoJ1gzCQ;IACE,kBAAA;IACA,kBAAA;EpJ4gzCV;EoJ3gzCU;IACE,qBAAA;EpJ6gzCZ;EoJ3gzCU;IACE,YAAA;EpJ6gzCZ;EoJ3gzCU;IACE,gBAAA;IACA,aAAA;EpJ6gzCZ;EoJ1gzCY;IACE,cAAA;IACA,kBAAA;IACA,iBAAA;EpJ4gzCd;EoJ1gzCY;IACE,qBAAA;IACA,gBAAA;IACA,kBAAA;IACA,QAAA;IACA,WAAA;I/CxDZ,2B+CyD+B;EpJghzCjC;EoJ/gzCc;IACE,gBAAA;EpJihzChB;EoJ3gzCc;IACE,gBAAA;EpJ6gzChB;EoJzgzCU;IACE,qBAAA;IACA,cAAA;EpJ2gzCZ;EoJxgzCQ;IACE,aAAA;EpJ0gzCV;EoJvgzCU;IACE,uBAAA;IACA,kBAAA;EpJygzCZ;EoJxgzCY;IACE,sBAAA;EpJ0gzCd;EoJxgzCY;IACE,cAAA;EpJ0gzCd;EoJxgzCY;IACE,kBAAA;IACA,WAAA;EpJ0gzCd;EoJ9/yCU;IACE,iDAAA;EpJggzCZ;EoJ//yCY;IACE,cAAA;IACA,YAAA;IACA,sChIuBY;EpB0+yC1B;EoJ//yCgB;IACE,qBAAA;EpJigzClB;EoJ3/yCQ;IACE,UAAA;IACA,gBAAA;EpJ6/yCV;EoJ3/yCY;IACE,kBAAA;IACA,iBAAA;IACA,kBAAA;IACA,kBAAA;EpJ6/yCd;EoJv/yCY;IACE,cAAA;EpJy/yCd;EoJv/yCY;IACE,mBAAA;EpJy/yCd;EoJv/yCgB;IACE,aAAA;IACA,2BAAA;IACA,iBAAA;EpJy/yClB;EoJh/yCE;IACE,yBAAA;EpJk/yCJ;AACF;;AoJ5+yCE;EACE;IACE,UhIzDe;EpBwizCnB;EoJ9+yCI;IACE,WAAA;EpJg/yCN;EoJ7+yCE;IACE,WhI/De;EpB8izCnB;EoJ9+yCI;IACE,WhIjEa;EpBijzCnB;EoJ/+yCM;IACE,aAAA;EpJi/yCR;EoJ/+yCM;IACE,qBAAA;EpJi/yCR;EoJ9+yCI;IACE,iBAAA;EpJg/yCN;EoJ/+yCM;IACE,kBAAA;IACA,UAAA;EpJi/yCR;EoJh/yCQ;IACE,aAAA;EpJk/yCV;EoJh/yCQ;IACE,aAAA;EpJk/yCV;EoJh/yCQ;IACE,aAAA;EpJk/yCV;EoJh/yCQ;IACE,kBAAA;EpJk/yCV;EoJj/yCU;;IAEE,aAAA;EpJm/yCZ;EoJj/yCU;I1HxLR,4BAAA;E1B4qzCF;EoJl/yCqB;I1H1LnB,0BAAA;E1B+qzCF;EoJh/yCY;IACE,eAAA;IACA,cAAA;EpJk/yCd;EoJh/yCY;IACE,aAAA;EpJk/yCd;EoJ9+yCY;I1HxMV,0BAAA;E1ByrzCF;EoJ/+yCuB;I1H1MrB,wBAAA;E1B4rzCF;EoJ5+yCQ;IACE,aAAA;EpJ8+yCV;EoJ5+yCQ;IACE,aAAA;EpJ8+yCV;EoJ5+yCQ;IACE,SAAA;EpJ8+yCV;EoJ7+yCU;IACE,cAAA;EpJ++yCZ;EoJ5+yCQ;IACE,aAAA;EpJ8+yCV;EoJ1+yCY;IjJ/M2C,aAAA;IAjBQ,mBwGuD9C;IyC4KH,mBhItGI;IgIuGJ,sBAAA;IACA,UhI3IK;IgI4IL,kBAAA;IACA,gBAAA;IACA,MAAA;IACA,SAAA;IACA,YhI9GW;IgI+GX,UAAA;IACA,gBAAA;EpJ8+yCd;EoJ7+yCuB;IACP,UAAA;IACA,WhIrJG;IgIsJH,gBAAA;EpJ++yChB;EoJ7+yCc;IACE,aAAA;EpJ++yChB;EoJ3+yCU;;IAEE,cAAA;IACA,iBAAA;I1H3PV,wBAAA;I0H6PU,mBhI/HM;IgIgIN,kBAAA;IACA,UhIpKO;IgIqKP,YhInIa;EpBgnzCzB;EoJ5+yCqB;IACL,UAAA;IACA,WhIxKG;IM3FjB,wBAAA;E1BkvzCF;EoJz+yCM;IACE,qBhI/I0B;EpB0nzClC;EoJz+yCU;IACE,gBAAA;IACA,kBAAA;EpJ2+yCZ;EoJ1+yCY;IACE,WAAA;IACA,qBAAA;IACA,UAAA;IACA,WAAA;IACA,kBAAA;IACA,yBhIzMH;IgI0MG,kBAAA;IACA,OAAA;EpJ4+yCd;EoJz+yCY;IACE,uBAAA;EpJ2+yCd;EoJr+yCU;IACE,cAAA;EpJu+yCZ;EoJt+yCY;IACE,iBAAA;EpJw+yCd;EoJv+yCc;IACE,OAAA;IACA,YAAA;EpJy+yChB;EoJl+yCI;IACE,aAAA;EpJo+yCN;EoJ79yCU;IACE,gBAAA;EpJ+9yCZ;EoJz9yCE;IACE,wBAAA;IACA,0BAAA;IACA,kCAAA;IACA,+BAAA;IACA,8BAAA;EpJ29yCJ;AACF;;AoJr9yCE;EACE;IACE,4BAAA;IACA,oCAAA;IACA,iCAAA;IACA,gCAAA;IACA,QAAA;EpJw9yCJ;EoJt9yCE;IACE,WAAA;EpJw9yCJ;AACF;;AoJl9yCE;EACE;IACE,WAAA;IACA,kBAAA;EpJq9yCJ;EoJl9yCI;IACE,kBAAA;IACA,YAAA;IAEA,8CAAA;IAEA,sBAAA;IACA,2CAAA;IACA,mDAAA;EpJo9yCN;EoJj9yCE;IACE,gBAAA;EpJm9yCJ;AACF;;AoJ58yCE;EACE;IACE,eAAA;IACA,gBAAA;EpJ+8yCJ;EoJ98yCI;IACE,iBAAA;IACA,cAAA;IACA,kBAAA;EpJg9yCN;EoJ/8yCM;IACE,gBAAA;EpJi9yCR;EoJ78yCE;IACE,kBhIxSa;EpBuvzCjB;EoJ58yCI;IACE,iBhI1Sa;EpBwvzCnB;AACF;;AoJv8yCE;EACE;IACE,mBAAA;IACA,oCAAA;EpJ08yCJ;EoJx8yCE;IACE,gCAAA;IACA,yCAAA;EpJ08yCJ;EoJz8yCI;IACE,YAAA;IACA,iBhIxCgB;EpBm/yCtB;EoJv8yCI;IACE,+BAAA;EpJy8yCN;EoJr8yCI;IACE,wCAAA;EpJu8yCN;AACF;;AoJj8yCA;EACE,cAAA;EACA,iBAAA;ApJo8yCF;AoJj8yCM;EACE,iCAAA;ApJm8yCR;AoJh8yCI;EACE,gBAAA;ApJk8yCN;AoJ97yCY;EACE,kBAAA;ApJg8yCd;AoJ37yCU;EACE,eAAA;EACA,kBAAA;ApJ67yCZ;AoJz7yCM;EACE,qBhItVsB;ApBixzC9B;AoJj7yCI;;;;;EACE,YAAA;ApJu7yCN;AoJr7yCI;;;;;EAEE,4CAAA;ApJ27yCN;AoJz7yCI;;;;;EACE,0BAAA;EACA,4BAAA;ApJ+7yCN;AoJ37yCI;EADF;IAEE,YhIlYe;IgImYf,OAAA;IACA,2BAAA;IACA,oCAAA;IACA,iCAAA;IACA,gCAAA;EpJ87yCF;AACF;AoJ57yCM;EACE,iCAAA;ApJ87yCR;AoJ17yCM;EACE,UAAA;ApJ47yCR;AoJx7yCc;EACE,kBAAA;ApJ07yChB;AoJl7yCE;EACE,iBAAA;ApJo7yCJ;AoJj7yCI;EACE,WhIhae;ApBm1zCrB;AoJ76yCY;EACE,mBAAA;ApJ+6yCd;AoJ96yCc;EACE,QAAA;EACA,WAAA;ApJg7yChB;;AAx5zCA;EACE,uBAAA;AA25zCF;;AAx5zCA;EACE,yBAAA;EACA,cAAA;AA25zCF;;AAx5zCA;EACE,iBAAA;EACA,mBAAA;AA25zCF;;AAx5zCA;EACE,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,2CAAA;EACA,eAAA;EACA,QAAA;EACA,MAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AA25zCF;;AAx5zCA;EACE,uBAAA;EACA,gCAAA;EACA,mBAAA;EACA,cAAA;AA25zCF;;AAx5zCA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;AA25zCF;;AAx5zCA;EACE,YAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;AA25zCF;;AAx5zCA;EACE,oBAAA;EACA,6DAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AA25zCF;;AAx5zCA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;AA25zCF;;AAx5zCA;EACE,SAAA;EACA,YAAA;AA25zCF;;AAx5zCA;EACE,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;AA25zCF;;AAx5zCA;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;AA25zCF;;AAx5zCA;EACE,SAAA;EACA,gBAAA;EACA,qBAAA;AA25zCF;;AAx5zCA;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,4BAAA;EACA,kBAAA;AA25zCF;;AAx5zCA;EACE,aAAA;AA25zCF;;AAx5zCA;EACE,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,0BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AA25zCF;;AAx5zCA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;AA25zCF;;AAx5zCA;EACE,mBAAA;EACA,cAAA;AA25zCF;;AAx5zCA;EACE,cAAA;AA25zCF;;AAx5zCA;EACE,6DAAA;EACA,cAAA;AA25zCF;;AAx5zCA;EACE,cAAA;AA25zCF;;AAx5zCA;EACE,eAAA;AA25zCF;;AAx5zCA;EACE,iBAAA;EACA,0BAAA;EACA,cAAA;EACA,kBAAA;AA25zCF;;AAx5zCA;EACE,yBAAA;AA25zCF;;AAx5zCA;EACE,gBAAA;EACA,iCAAA;EACA,kBAAA;EACA,8BAAA;AA25zCF;;AAx5zCA;EACE,gBAAA;EACA,SAAA;AA25zCF;;AAx5zCA;EACE,uBAAA;EACA,kBAAA;EACA,gBAAA;AA25zCF;;AAx5zCA;EACE,cAAA;AA25zCF;;AAx5zCA;EACE,8BAAA;EACA,gCAAA;EACA,yCAAA;EACA,sBAAA;EACA,gBAAA;AA25zCF;;AAx5zCA;EACE,WAAA;AA25zCF;;AAx5zCA;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;AA25zCF;;AAx5zCA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AA25zCF;;AAx5zCA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AA25zCF;;AAx5zCA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;AA25zCF;;AAx5zCA;EACE,kBAAA;EACA,cAAA;AA25zCF;;AAx5zCA;EACE,yBAAA;EACA,mBAAA;EACA,2CAAA;EACA,eAAA;AA25zCF;;AAx5zCA;EACE,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,cAAA;AA25zCF;;AAx5zCA;EACE,mBAAA;AA25zCF;;AAx5zCA;EACE,cAAA;EACA,qBAAA;AA25zCF;;AAx5zCA;EACE,8BAAA;EACA,6BAAA;EACA,uBAAA;AA25zCF;;AAx5zCA;EACE,yBAAA;EACA,kBAAA;AA25zCF;;AAx5zCA;EACE,cAAA;EACA,qBAAA;AA25zCF;;AAx5zCA;EACE,0BAAA;AA25zCF;;AAx5zCA;EACE,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;AA25zCF;;AAx5zCA;EACE,8BAAA;EACA,2BAAA;EACA,6LAAA;AA25zCF;;AAt5zCA;EACE,mBAAA;EACA,wBAAA;EACA,uBAAA;EACA,qBAAA;EACA,2BAAA;EACA,wBAAA;EACA,8BAAA;EACA,wBAAA;EACA,uBAAA;EACA,wBAAA;EACA,oBAAA;EACA,6CAAA;EACA,2FAAA;AAy5zCF;;AAt5zCA;EACE,mBAAA;EACA,yBAAA;EACA,kCAAA;EACA,oCAAA;EACA,qBAAA;EACA,gBAAA;AAy5zCF;;AAt5zCA;;EAEE,qBAAA;EACA,gCAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AAy5zCF;;AAt5zCA;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;AAy5zCF;;AAt5zCA;EACE,gBAAA;EACA,iCAAA;EACA,eAAA;AAy5zCF;;AAt5zCA;EACE,cAAA;AAy5zCF;;AAt5zCA;EACE,qBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,qBAAA;AAy5zCF;;AAt5zCA;EACE,qBAAA;EACA,sBAAA;EACA,qBAAA;AAy5zCF;;AAt5zCA;EACE,mBAAA;AAy5zCF;;AAt5zCA;EACE,mBAAA;EACA,cAAA;AAy5zCF;;AAt5zCA;EACE,mBAAA;EACA,cAAA;AAy5zCF;;AAt5zCA;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,uBAAA;AAy5zCF;;AAt5zCA;EACE,qBAAA;EACA,6CAAA;AAy5zCF;;AAt5zCA;EACE,cAAA;AAy5zCF;;AAt5zCA;;EAEE,cAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;AAy5zCF;;AAt5zCA;EACE,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AAy5zCF;;AAt5zCA;EACE,mBAAA;EACA,qBAAA;EACA,WAAA;AAy5zCF;;AAt5zCA;EACE,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AAy5zCF;;AAt5zCA;EACE,mBAAA;EACA,qBAAA;EACA,WAAA;AAy5zCF;;AAt5zCA;EACE,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,kBAAA;AAy5zCF;;AAt5zCA;EACE,mBAAA;EACA,qBAAA;EACA,WAAA;AAy5zCF;;AAt5zCA;EACE,kBAAA;AAy5zCF;;AAt5zCA;EACE,gBAAA;EACA,sBAAA;EACA,kBAAA;AAy5zCF;;AAt5zCA;EACE,yBAAA;AAy5zCF;;AAt5zCA,2EAAA;AAEA;EACE,sBAAA;EACA,qBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,+EAAA;AAw5zCF;;AAr5zCA;;EAEE,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;AAw5zCF;;AAr5zCA;;EAEE,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;AAw5zCF;;AAr5zCA;;;;EAAA;AAKA;EACE,mBAAA;EACA,yBAAA;EACA,+EAAA;EACA,gBAAA;EACA,mBAAA;AAw5zCF;;AAr5zCA;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,gCAAA;EACA,wBAAA;AAw5zCF;;AAr5zCA;EACE,mBAAA;EACA,cAAA;AAw5zCF;;AAr5zCA;EACE,gBAAA;EACA,cAAA;EACA,uBAAA;AAw5zCF;;AAr5zCA;;;;EAAA;AAKA;EACE,kCAAA;EACA,wCAAA;EACA,yBAAA;AAw5zCF;;AAr5zCA,2EAAA;AACA;;EAEE,8BAAA;EACA,yBAAA;AAw5zCF;;AAr5zCA;EACE,yBAAA;AAw5zCF;;AAr5zCA;EACE,8BAAA;EACA,yBAAA;EACA,gCAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;AAw5zCF;;AAr5zCA;EACE,yBAAA;EACA,gCAAA;EACA,sBAAA;AAw5zCF;;AAr5zCA;EACE,8BAAA;AAw5zCF;;AAr5zCA,gDAAA;AACA;EACE,yBAAA;AAw5zCF;;AAr5zCA;;EAEE,oCAAA;EACA,yBAAA;EACA,gCAAA;AAw5zCF;;AAr5zCA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,qBAAA;AAw5zCF;;AAr5zCA;EACE,mBAAA;EACA,qBAAA;EACA,WAAA;AAw5zCF;;AAr5zCA;EACE,cAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAw5zCF;;AAr5zCA;EACE,WAAA;EACA,mBAAA;EACA,qBAAA;AAw5zCF;;AAr5zCA;;EAEE,kBAAA;AAw5zCF;;AAr5zCA;EACE,qBAAA;AAw5zCF;;AAr5zCA,gDAAA;AACA;EACE,8BAAA;EACA,yBAAA;EACA,oCAAA;EACA,mBAAA;EACA,+EAAA;AAw5zCF;;AAr5zCA;EACE,8BAAA;EACA,yBAAA;EACA,2CAAA;AAw5zCF;;AAr5zCA;EACE,8BAAA;EACA,gCAAA;EACA,cAAA;AAw5zCF;;AAr5zCA;EACE,cAAA;AAw5zCF;;AAr5zCA;EACE,yBAAA;EACA,gBAAA;AAw5zCF;;AAr5zCA;EACE,qBAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;AAw5zCF;;AAr5zCA;EACE,8BAAA;EACA,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,+EAAA;AAw5zCF;;AAr5zCA,8BAAA;AACA;EACE,iBAAA;EACA,iBAAA;EACA,kBAAA;AAw5zCF;;AAr5zCA;EACE,wEAAA;AAw5zCF;;AAr5zCA;EACE,aAAA;EACA,gDAAA;EACA,YAAA;AAw5zCF;;AAr5zCA;EACE;IACE,qDAAA;EAw5zCF;AACF;AAr5zCA;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAu5zCF;;AAp5zCA;EACE,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,gBAAA;AAu5zCF;;AAp5zCA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAu5zCF;;AAp5zCA;EACE,6BAAA;AAu5zCF;;AAp5zCA;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iCAAA;EACA,eAAA;AAu5zCF;;AAp5zCA;EACE,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,wBAAA;EACA,mBAAA;AAu5zCF;;AAp5zCA;EACE,sBAAA;EACA,kBAAA;AAu5zCF;;AAp5zCA;EACE,8BAAA;EACA,yCAAA;EACA,6BAAA;AAu5zCF;;AAp5zCA;EACE;IACE,0BAAA;EAu5zCF;EAp5zCA;IACE,2BAAA;IACA,0BAAA;IACA,gBAAA;EAs5zCF;EAn5zCA;IACE,wBAAA;IACA,0CAAA;EAq5zCF;AACF;AAl5zCA;EACE;IACE,mCAAA;IACA,mBAAA;IACA,qBAAA;IACA,wBAAA;EAo5zCF;EAj5zCA;IACE,8BAAA;IACA,yBAAA;EAm5zCF;AACF;AqJjs1CA;;;EAAA;AAKA;EACE;IACE,yBAAA;IACA,cAAA;ErJks1CF;AACF;AqJlr1CA;EACE,mBAdW;EAeX,iBAAA;ArJor1CF;;AqJjr1CA,oFAAA;AACA;EACE,8JAAA;EAEA,iBAAA;ArJmr1CF;;AqJhr1CA;;EAEE,uBAAA;ArJmr1CF;;AqJhr1CA;EACE,qBAAA;EACA,iBAAA;EACA,kCAAA;ArJmr1CF;;AqJhr1CA;EACE,0EAAA;ArJmr1CF;;AqJhr1CA;EACE,uBAAA;ArJmr1CF;;AqJhr1CA,8CAAA;AACA;EACE,qFAAA;EACA,2DAAA;EACA,2CAAA;ArJmr1CF;;AqJhr1CA;EACE,iCAAA;EACA,kDAAA;ArJmr1CF;;AqJhr1CA;EACE,cApDQ;ArJuu1CV;;AqJhr1CA;EACE,cAAA;ArJmr1CF;;AqJhr1CA;EACE,cA3Dc;ArJ8u1ChB;;AqJhr1CA;EACE,oCAAA;EACA,cAjEQ;ArJov1CV;;AqJhr1CA;EACE,oCAlEc;EAmEd,cApEU;EAqEV,0CAAA;ArJmr1CF;;AqJhr1CA;EACE,0CAAA;ArJmr1CF;;AqJhr1CA,mBAAA;AACA;EACE,6CAAA;EACA,kDAAA;EACA,mCAAA;UAAA,2BAAA;EACA,iEAAA;ArJmr1CF;;AqJhr1CA;EACE;IACE,oBAAA;IACA,qBAAA;ErJmr1CF;AACF;AqJhr1CA;EACE,cA9FQ;ArJgx1CV;;AqJ/q1CA;EACE,iCAAA;EACA,uCApGU;ArJsx1CZ;;AqJ/q1CA;EACE,cAvGQ;ArJyx1CV;;AqJ/q1CA;EACE,cAzGU;EA0GV,sCAAA;EACA,mBAAA;EACA,wBAAA;ArJkr1CF;;AqJ/q1CA,mBAAA;AACA;EACE,6CAAA;EACA,+CAAA;EACA,cApHc;ArJsy1ChB;;AqJ/q1CA;EACE,cAvHU;ArJyy1CZ;;AqJ/q1CA,+BAAA;AACA;EACE,gPAAA;EAGA,cAjIQ;EAkIR,mEAAA;ArJgr1CF;;AqJ7q1CA;EACE;IACE,oEAAA;ErJgr1CF;AACF;AqJ7q1CA,yBAAA;AACA;;;EAGE,8BAAA;EACA,sDAAA;EACA,cAjJQ;EAkJR,0CAAA;ArJ+q1CF;;AqJ5q1CA;;;EAGE,4CAAA;EACA,yBAAA;EACA,yDAAA;ArJ+q1CF;;AqJ5q1CA;;EAEE,8BAAA;EACA,yBAAA;ArJ+q1CF;;AqJ5q1CA;;;EAGE,yBAAA;ArJ+q1CF;;AqJ5q1CA;;EAEE,yBAAA;ArJ+q1CF;;AqJ5q1CA,UAAA;AACA;EACE,kCAAA;EACA,uCAlLU;EAmLV,cAlLQ;ArJi21CV;;AqJ5q1CA;;EAEE,cAtLc;ArJq21ChB;;AqJ5q1CA,8BAAA;AACA;EACE,cA5LQ;ArJ221CV;;AqJ5q1CA;EACE,6CAAA;EACA,yBAAA;EACA,kDAAA;ArJ+q1CF;;AqJ5q1CA;EACE,kDAAA;EACA,cAvMQ;ArJs31CV;;AqJ5q1CA;EACE,+CAAA;ArJ+q1CF;;AqJ5q1CA;EACE,kCAAA;ArJ+q1CF;;AqJ5q1CA,sFAAA;AACA;;EAEE,2BAAA;EACA,8BAAA;EACA,4CAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,2CAAA;EACA,kCAAA;ArJ+q1CF;;AqJ5q1CA;EACE,mDAAA;EACA,2BAAA;EACA,8BAAA;ArJ+q1CF;;AqJ5q1CA;;;EAGE,gBAAA;EACA,gBAAA;ArJ+q1CF;;AqJ5q1CA,YAAA;AACA;EACE,gEAAA;EACA,oCAAA;EACA,yBAAA;EACA,gBAAA;ArJ+q1CF;;AqJ5q1CA;EACE,8BAAA;EACA,gCAAA;ArJ+q1CF;;AqJ5q1CA;EACE,8BAAA;EACA,gCAAA;ArJ+q1CF;;AqJ5q1CA;;EAEE,uCAjQU;EAkQV,cAjQQ;EAkQR,iCAAA;ArJ+q1CF;;AqJ5q1CA;EACE,cApQU;EAqQV,sCAAA;EACA,oCAAA;ArJ+q1CF;;AqJ5q1CA,wBAAA;AACA;;EAEE,8BAAA;EACA,kDAAA;EACA,yBAAA;ArJ+q1CF;;AqJ5q1CA;EACE,iCAAA;EACA,uCAtRU;ArJq81CZ;;AqJ5q1CA;EACE,cAxRc;ArJu81ChB;;AqJ5q1CA;EACE,cA7RQ;ArJ481CV;;AqJ5q1CA;EACE,6CAAA;EACA,kDAAA;EACA,yBAAA;ArJ+q1CF;;AqJ5q1CA,eAAA;AACA;EACE,iCAAA;EACA,uCA1SU;EA2SV,cA1SQ;ArJy91CV;;AqJ5q1CA;EACE,8BAAA;EACA,gCAAA;EACA,yBAAA;ArJ+q1CF;;AqJ5q1CA,2BAAA;AACA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,YAAA;EACA,gCAAA;EACA,kCAAA;UAAA,0BAAA;ArJ+q1CF;;AqJ5q1CA;EACE,cAAA;ArJ+q1CF;;AqJ5q1CA;EACE;IACE,wBAAA;ErJ+q1CF;AACF;AqJ5q1CA,mCAAA;AACA;EACE,aAAA;ArJ8q1CF;;AqJ3q1CA,gGAAA;AACA;EACE;IACE,gBAAA;ErJ8q1CF;AACF;AqJ3q1CA,6CAAA;AACA;EACE,8BAAA;ArJ6q1CF;;AsJnh2CA;;;EAAA;AAKA;EACE;IACE,yBAAA;IACA,cAAA;EtJqh2CF;AACF;AsJlh2CA;EACE,mBAAA;AtJoh2CF;;AsJjh2CA;EACE,0EAAA;AtJoh2CF;;AsJjh2CA;EACE,uBAAA;AtJoh2CF;;AsJjh2CA,4CAAA;AACA;EACE,qFAAA;EACA,wDAAA;EACA,8CAAA;AtJoh2CF;;AsJjh2CA;EACE,gBAAA;EACA,gCAAA;AtJoh2CF;;AsJjh2CA;EACE,cAAA;AtJoh2CF;;AsJjh2CA;EACE,6DAAA;AtJoh2CF;;AsJjh2CA;EACE,cAAA;EACA,kBAAA;EACA,qBAAA;AtJoh2CF;;AsJjh2CA;EACE,cAAA;EACA,mBAAA;EACA,kBAAA;AtJoh2CF;;AsJjh2CA;EACE,mBAAA;EACA,cAAA;AtJoh2CF;;AsJjh2CA;EACE,6DAAA;EACA,cAAA;EACA,wCAAA;EACA,gBAAA;AtJoh2CF;;AsJjh2CA;EACE,0BAAA;AtJoh2CF;;AsJjh2CA,mBAAA;AACA;EACE,gDAAA;EACA,gCAAA;EACA,mCAAA;UAAA,2BAAA;EACA,iEAAA;AtJoh2CF;;AsJjh2CA;EACE;IACE,oBAAA;IACA,qBAAA;EtJoh2CF;AACF;AsJjh2CA;EACE,cAAA;AtJmh2CF;;AsJhh2CA;EACE,mBAAA;EACA,qBAAA;AtJmh2CF;;AsJhh2CA;EACE,cAAA;AtJmh2CF;;AsJhh2CA;EACE,cAAA;EACA,qBAAA;EACA,mBAAA;AtJmh2CF;;AsJhh2CA;;EAEE,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;EACA,cAAA;AtJmh2CF;;AsJhh2CA;;EAEE,mBAAA;EACA,qBAAA;EACA,cAAA;AtJmh2CF;;AsJhh2CA,mBAAA;AACA;EACE,8BAAA;EACA,6BAAA;AtJmh2CF;;AsJhh2CA;EACE,cAAA;AtJmh2CF;;AsJhh2CA,oBAAA;AACA;EACE,+LAAA;EAGA,cAAA;EACA,qEAAA;AtJih2CF;;AsJ9g2CA;EACE;IACE,oEAAA;EtJih2CF;AACF;AsJ9g2CA;;;EAGE,8BAAA;EACA,oCAAA;EACA,cAAA;EACA,+EAAA;AtJgh2CF;;AsJ7g2CA;;;EAGE,8BAAA;EACA,yBAAA;EACA,uCAAA;AtJgh2CF;;AsJ7g2CA;;EAEE,8BAAA;EACA,yBAAA;AtJgh2CF;;AsJ7g2CA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AtJgh2CF;;AsJ7g2CA;EACE,cAAA;AtJgh2CF;;AsJ7g2CA;EACE,8BAAA;EACA,yBAAA;EACA,gCAAA;AtJgh2CF;;AsJ7g2CA;EACE,gCAAA;AtJgh2CF;;AsJ7g2CA;EACE,8BAAA;AtJgh2CF;;AsJ7g2CA;;EAEE,2BAAA;EACA,4CAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;AtJgh2CF;;AsJ7g2CA;;EAEE,gBAAA;AtJgh2CF;;AsJ7g2CA;EACE,8BAAA;EACA,gCAAA;EACA,sBAAA;AtJgh2CF;;AsJ7g2CA;EACE,gBAAA;EACA,qBAAA;EACA,cAAA;AtJgh2CF;;AsJ7g2CA;EACE,8BAAA;EACA,gCAAA;EACA,sBAAA;AtJgh2CF;;AsJ7g2CA;EACE,kCAAA;AtJgh2CF;;AsJ7g2CA;EACE,8BAAA;AtJgh2CF;;AsJ7g2CA,mDAAA;AACA;;EAEE,mBAAA;EACA,2CAAA;EACA,iCAAA;EACA,cAAA;EACA,uBAAA;EACA,cAAA;AtJgh2CF;;AsJ7g2CA;;EAEE,oCAAA;EACA,sCAAA;EACA,WAAA;AtJgh2CF;;AuJ1w2CA;;;EAAA;AAKA;EACE,cAAA;AvJ4w2CF;;AuJzw2CA;EACE,cAAA;AvJ4w2CF;;AuJzw2CA;EACE,yBAAA;EACA,kDAAA;EACA,gDAAA;AvJ4w2CF;;AuJzw2CA;EACE,kDAAA;EACA,cAAA;EACA,sBAAA;AvJ4w2CF;;AuJzw2CA;EACE,gDAAA;AvJ4w2CF;;AuJzw2CA;EACE,cAAA;AvJ4w2CF;;AuJzw2CA;EACE,sBAAA;AvJ4w2CF;;AuJzw2CA,yCAAA;AACA;;EAEE,yBAAA;AvJ4w2CF;;AuJzw2CA;EACE,yBAAA;EACA,8BAAA;EACA,gCAAA;AvJ4w2CF;;AuJzw2CA;EACE,gCAAA;AvJ4w2CF;;AuJzw2CA;EACE,8BAAA;AvJ4w2CF;;AuJzw2CA;EACE,yBAAA;AvJ4w2CF;;AuJzw2CA,+DAAA;AACA;;EAEE,yBAAA;AvJ4w2CF;;AuJzw2CA;EACE,yBAAA;EACA,8BAAA;AvJ4w2CF;;AuJzw2CA,iCAAA;AACA;EACE,cAAA;AvJ4w2CF;;AuJzw2CA;;;EAGE,yBAAA;AvJ4w2CF;;AuJzw2CA;EACE,8BAAA;EACA,yBAAA;AvJ4w2CF;;AuJzw2CA;EACE,gBAAA;EACA,iBAAA;AvJ4w2CF;;AuJzw2CA;EACE,mBAAA;EACA,WAAA;AvJ4w2CF;;AwJ322CA;;;EAAA;AAQA,oDAAA;AACA;EACE,uBAAA;AxJ022CF;;AwJv22CA;EACE;IACE,8BAAA;ExJ022CF;AACF;AwJv22CA,8CAAA;AACA;EACE,mCAAA;AxJy22CF;;AwJt22CA;EACE,6BAAA;EACA,2BAAA;EACA,iCAAA;EACA,mBAAA;AxJy22CF;;AwJt22CA;EACE,uBAAA;EACA,0BAAA;AxJy22CF;;AwJt22CA;EACE,2CAAA;AxJy22CF;;AwJt22CA;EACE,4BAAA;EACA,0CAAA;EACA,8BAAA;EACA,iCAAA;AxJy22CF;;AwJt22CA;EACE,kCAAA;EACA,6BAAA;EACA,2BAAA;EACA,8BAAA;EACA,6BAAA;AxJy22CF;;AwJt22CA;EACE,sBAAA;EACA,uBAAA;EACA,6BAAA;AxJy22CF;;AwJt22CA;EACE,kCAAA;EACA,6BAAA;AxJy22CF;;AwJt22CA;EACE,+BAAA;EACA,gCAAA;EACA,iCAAA;AxJy22CF;;AwJt22CA,wBAAA;AACA;EACE,2BAAA;EACA,qEAAA;EACA,kCAAA;EACA,gCAAA;EACA,iCAAA;AxJy22CF;;AwJt22CA;EACE;IACE,gCAAA;IACA,iCAAA;ExJy22CF;AACF;AwJt22CA;EACE,6BAAA;EACA,2BAAA;AxJw22CF;;AwJr22CA;EACE,kCAAA;EACA,8BAAA;AxJw22CF;;AwJr22CA;EACE,sBAAA;EACA,uBAAA;EACA,6BAAA;AxJw22CF;;AwJr22CA;EACE,6BAAA;AxJw22CF;;AwJr22CA;EACE,6BAAA;AxJw22CF;;AwJr22CA;EACE,mCAAA;EACA,8BAAA;AxJw22CF;;AwJr22CA;EACE,iCAAA;EACA,8BAAA;AxJw22CF;;AwJr22CA,+CAAA;AACA;EACE,iFAAA;AxJw22CF;;AwJr22CA;EACE;IACE,oFAAA;ExJw22CF;AACF;AwJr22CA;EACE,8BAAA;EACA,mCAAA;EACA,iCAAA;AxJu22CF;;AwJp22CA;;EAEE,0BAAA;AxJu22CF;;AwJp22CA;;EAEE,6BAAA;EACA,6BAAA;AxJu22CF;;AwJp22CA;;EAEE,8BAAA;EACA,iCAAA;AxJu22CF;;AwJp22CA;;;EAGE,kCAAA;EACA,4BAAA;AxJu22CF;;AwJp22CA;;EAEE,kCAAA;AxJu22CF;;AwJp22CA;EACE,8BAAA;EACA,6BAAA;EACA,mCAAA;AxJu22CF;;AwJp22CA;EACE,mCAAA;EACA,6BAAA;AxJu22CF;;AwJp22CA;;EAEE,8BAAA;EACA,4BAAA;EACA,kCAAA;EACA,2BAAA;AxJu22CF;;AwJp22CA;EACE,6BAAA;EACA,gCAAA;EACA,6BAAA;AxJu22CF;;AwJp22CA,+CAAA;AACA;EACE,qFAAA;AxJu22CF;;AwJp22CA;EACE,qFAAA;EACA,uDAAA;EACA,sDAAA;AxJu22CF;;AwJp22CA;EACE,2CAAA;EACA,yDAAA;AxJu22CF;;AwJp22CA;;;EAGE,8BAAA;EACA,sDAAA;EACA,8DAAA;AxJu22CF;;AwJp22CA;;EAEE,0CAAA;EACA,yDAAA;AxJu22CF;;AwJp22CA,wBAAA;AACA;EACE,qFAAA;AxJu22CF;;AwJp22CA;EACE,8BAAA;EACA,sDAAA;EACA,yCAAA;AxJu22CF;;AwJp22CA;EACE,gDAAA;EACA,2CAAA;AxJu22CF;;AwJp22CA;;;EAGE,oCAAA;EACA,oDAAA;EACA,8BAAA;AxJu22CF;;AwJp22CA;EACE,mCAAA;EACA,6BAAA;AxJu22CF;;AyJhm3CA;;;EAAA;AAKA;;EAEE,6BAAA;AzJkm3CF;;AyJ/l3CA;EACE;IACE,eAAA;IACA,gBAAA;IACA,8BAAA;EzJkm3CF;EyJ/l3CA;;IAEE,6BAAA;IACA,2BAAA;EzJim3CF;EyJ9l3CA;;IAEE,4BAAA;IACA,4BAAA;EzJgm3CF;EyJ7l3CA,+DAAA;EACA;;IAEE,8BAAA;IACA,qDAAA;IACA,8BAAA;IACA,kCAAA;IACA,0CAAA;EzJ+l3CF;EyJ5l3CA;;IAEE,6BAAA;EzJ8l3CF;EyJ3l3CA;;IAEE,6BAAA;EzJ6l3CF;EyJ1l3CA,sBAAA;EACA;;IAEE,8BAAA;IACA,kCAAA;IACA,qDAAA;IACA,gCAAA;EzJ4l3CF;EyJzl3CA;;;IAGE,YAAA;EzJ2l3CF;EyJxl3CA;;IAEE,gBAAA;IACA,6BAAA;EzJ0l3CF;AACF;A0J9p3CA;;EAAA;AASA,8DAAA;AAEE;EACE,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,YAXc;EAYd,4BAAA;EACA,wDAAA;EACA,gBAAA;EACA,4BAAA;EACA,+BAAA;A1Jyp3CJ;A0Jtp3CE;EACE,wBAAA;EACA,6CAAA;A1Jwp3CJ;A0Jrp3CE;EACE;IACE,mCAAA;IACA,2BAAA;E1Jup3CJ;AACF;A0Jpp3CE;EACE,yBAAA;EACA,0BAAA;EACA,iBAjCa;EAkCb,iBAAA;A1Jsp3CJ;A0Jnp3CE;EACE;IACE,6BAAA;E1Jqp3CJ;AACF;A0Jlp3CE;EACE,WAAA;EACA,8BAAA;EACA,6FAAA;EACA,yBAAA;A1Jop3CJ;A0Jjp3CE;EACE,qBAAA;A1Jmp3CJ;;A0J/o3CA,uBAAA;AACA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,kCAAA;EACA,kCAAA;UAAA,0BAAA;EACA,UAAA;EACA,kBAAA;EACA,oBAAA;EACA,qDAAA;A1Jkp3CF;;A0J/o3CA;EACE,UAAA;EACA,mBAAA;EACA,oBAAA;A1Jkp3CF;;A0J/o3CA;EACE;IACE,wBAAA;E1Jkp3CF;AACF;A0J/o3CA;EACE,gBAAA;A1Jip3CF;;A0J9o3CA;EACE;IACE,cAAA;E1Jip3CF;AACF;A0J9o3CA,6BAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,cAAA;A1Jgp3CF;;A0J7o3CA;EACE,cAAA;EACA,0BAAA;EACA,gCAAA;A1Jgp3CF;;A0J7o3CA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,sBAAA;A1Jgp3CF;;A0J7o3CA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,gCAAA;EACA,cAAA;EACA,YAAA;A1Jgp3CF;;A0J7o3CA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,6DAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,uBAAA;A1Jgp3CF;;A0J7o3CA;EACE,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;A1Jgp3CF;;A0J7o3CA;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;A1Jgp3CF;;A0J7o3CA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;A1Jgp3CF;;A0J7o3CA;EACE;IACE,aAAA;E1Jgp3CF;AACF;A0J7o3CA;EACE,kBAAA;A1J+o3CF;;A0J5o3CA;EACE,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,sCAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;A1J+o3CF;;A0J5o3CA;EACE,aAAA;EACA,qBA3La;EA4Lb,6CAAA;EACA,gBAAA;A1J+o3CF;;A0J5o3CA;EACE,kBAAA;EACA,aAAA;EACA,QAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;A1J+o3CF;;A0J5o3CA;EACE,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,6BAAA;EACA,iCAAA;A1J+o3CF;;A0J5o3CA;EACE,wBAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;A1J+o3CF;;A0J5o3CA;EACE,wBAAA;A1J+o3CF;;A0J5o3CA;EACE,wBAAA;A1J+o3CF;;A0J5o3CA;EACE,wBAAA;A1J+o3CF;;A0J5o3CA,sBAAA;AACA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,YA/Oe;EAgPf,aAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,qCAAA;EACA,gCAAA;EACA,mCAAA;UAAA,2BAAA;EACA,0CAAA;A1J+o3CF;;A0J5o3CA;EACE;IACE,WA7Pc;IA8Pd,iBAAA;E1J+o3CF;AACF;A0J5o3CA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;A1J8o3CF;;A0J3o3CA;EACE;IACE,aAAA;E1J8o3CF;AACF;A0J3o3CA;EACE,kBAAA;A1J6o3CF;;A0J1o3CA;EACE,SAAA;EACA,YAAA;A1J6o3CF;;A0J1o3CA;EACE,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;A1J6o3CF;;A0J1o3CA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,SAAA;EACA,iBAAA;A1J6o3CF;;A0J1o3CA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;A1J6o3CF;;A0J1o3CA;;EAEE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,UAAA;EACA,cAAA;A1J6o3CF;;A0J1o3CA;EACE,kBAAA;A1J6o3CF;;A0J1o3CA;EACE,mBA/UkB;EAgVlB,qCAAA;EACA,cAlVa;A1J+93Cf;;A0J1o3CA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uCAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;A1J6o3CF;;A0J1o3CA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;A1J6o3CF;;A0J1o3CA;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;A1J6o3CF;;A0J1o3CA;EACE,kBAAA;EACA,cAAA;A1J6o3CF;;A0J1o3CA,qBAAA;AAEE;EACE,qFAAA;EACA,wDAAA;A1J4o3CJ;A0Jzo3CE;EACE,8CAAA;A1J2o3CJ;A0Jxo3CE;EACE,cAAA;A1J0o3CJ;A0Jvo3CE;EACE,iCAAA;EACA,uCAAA;EACA,cAAA;A1Jyo3CJ;A0Jto3CE;;;EAGE,iCAAA;EACA,uCAAA;EACA,cAAA;A1Jwo3CJ;A0Jro3CE;EACE,kCAAA;EACA,8CAAA;A1Juo3CJ;A0Jpo3CE;EACE,cAAA;A1Jso3CJ;A0Jno3CE;EACE,iCAAA;EACA,uCAAA;A1Jqo3CJ;A0Jlo3CE;EACE,cAAA;A1Joo3CJ;;A0Jho3CA,4CAAA;AACA;EACE,cAAA;EACA,0BAAA;EACA,6BAAA;A1Jmo3CF;;A0Jho3CA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,wBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;A1Jmo3CF;;A0Jho3CA;EACE,mBA9bkB;EA+blB,qCAAA;EACA,cAjca;A1Jok4Cf;;A0Jho3CA;EACE,iBAAA;A1Jmo3CF;;A0Jho3CA,uBAAA;AAEE;EACE,8BAAA;A1Jko3CJ;A0J/n3CE;EACE,yBAAA;A1Jio3CJ;A0J9n3CE;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;A1Jgo3CJ;;A0J5n3CA,gEAAA;AAEE;EACE,8BAAA;A1J8n3CJ;A0J3n3CE;EACE,mBAAA;A1J6n3CJ;A0J1n3CE;EACE,8BAAA;EACA,yBAAA;EACA,mBAAA;EACA,wBAAA;EACA,yCAAA;EACA,qBAAA;EACA,2BAAA;A1J4n3CJ;A0Jzn3CE;;;;;EAKE,8BAAA;EACA,kDAAA;EACA,yBAAA;A1J2n3CJ;A0Jxn3CE;;;EAGE,8BAAA;EACA,yBAAA;EACA,yDAAA;A1J0n3CJ;A0Jvn3CE;EACE,8BAAA;EACA,yBAAA;A1Jyn3CJ;A0Jtn3CE;;;EAGE,8BAAA;EACA,kDAAA;EACA,yBAAA;A1Jwn3CJ;A0Jrn3CE;EACE,yBAAA;A1Jun3CJ;A0Jpn3CE;EACE,8BAAA;EACA,yBAAA;EACA,kDAAA;A1Jsn3CJ;A0Jnn3CE;EACE,kDAAA;EACA,yBAAA;A1Jqn3CJ;A0Jln3CE;EACE,gDAAA;A1Jon3CJ;A0Jjn3CE;;;;EAEE,yBAAA;A1Jqn3CJ;A0Jln3CE;;;;;;EAME,yBAAA;A1Jon3CJ;A0Jjn3CE;EACE,2CAAA;A1Jmn3CJ;A0Jhn3CE;EACE,iCAAA;EACA,uCAAA;EACA,cAAA;A1Jkn3CJ;A0J/m3CE;EACE,kCAAA;EACA,uCAAA;EACA,cAAA;A1Jin3CJ;;A0J7m3CA,mFAAA;AACA;EACE,8BAAA;EACA,gCAAA;EACA,iCAAA;EACA,2EAAA;A1Jgn3CF;;A0J7m3CA;EACE;IACE,+BAAA;IACA,6BAAA;IACA,8BAAA;IACA,0EAAA;E1Jgn3CF;AACF;A0J7m3CA;EACE,gBAAA;A1J+m3CF","sourcesContent":["@import \"~slick-carousel/slick/slick.css\";\n@import \"~slick-carousel/slick/slick-theme.css\";\n@import \"~bootstrap/scss/functions\";\n@import \"~bootstrap/scss/variables\";\n@import \"../assets/styles/variables\";\n@import \"~compass-mixins/lib/compass\";\n@import \"~compass-mixins/lib/animate\";\n@import \"~bootstrap/scss/bootstrap\";\n@import \"../assets/styles/fonts\";\n@import \"../assets/styles/functions\";\n@import \"~@mdi/font/scss/materialdesignicons\";\n@import \"../assets/styles/mixins/animation\";\n@import \"../assets/styles/mixins/badges\";\n@import \"../assets/styles/mixins/buttons\";\n@import \"../assets/styles/mixins/misc\";\n@import \"../assets/styles/mixins/color-functions\";\n@import \"../assets/styles/mixins/cards\";\n@import \"../assets/styles/mixins/blockqoute\";\n@import \"../assets/styles/typography\";\n@import \"../assets/styles/reset\";\n@import \"../assets/styles/responsive\";\n@import \"../assets/styles/misc\";\n@import \"../assets/styles/utilities\";\n@import \"../assets/styles/demo\";\n@import \"../assets/styles/spinner\";\n@import \"../assets/styles/dashboard\";\n@import \"../assets/styles/components/checkbox-radio\";\n@import \"../assets/styles/components/forms\";\n@import \"../assets/styles/components/icons\";\n@import \"../assets/styles/components/tables\";\n@import \"../assets/styles/components/buttons\";\n@import \"../assets/styles/components/breadcrumbs\";\n@import \"../assets/styles/components/badges\";\n@import \"../assets/styles/components/cards\";\n@import \"../assets/styles/components/preview\";\n@import \"../assets/styles/components/lists\";\n@import \"../assets/styles/components/todo-list\";\n@import \"../assets/styles/components/dropdowns\";\n@import \"../assets/styles/components/loaders/loaders\";\n@import \"../assets/styles/components/landing-screens/auth\";\n@import \"../assets/styles/components/plugin-overrides/slick-carousel\";\n@import \"../assets/styles/components/plugin-overrides/jquery-jvectormap\";\n@import \"../assets/styles/navbar\";\n@import \"../assets/styles/sidebar\";\n@import \"../assets/styles/footer\";\n@import \"../assets/styles/layout\";\n\ntable td {\n  border: none !important;\n}\n\nbody {\n  background-color: #f1f5f9;\n  color: #1e293b;\n}\n\n.admin-app {\n  min-height: 100vh;\n  background: #f1f5f9;\n}\n\n.admin-layout-sidebar {\n  width: 216px;\n  min-height: 100vh;\n  background: #ffffff;\n  border-left: 1px solid #e2e8f0;\n  border-right: none;\n  box-shadow: -2px 0 12px rgba(0, 0, 0, 0.04);\n  position: fixed;\n  right: 0;\n  top: 0;\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.admin-layout-sidebar .admin-sidebar-logo {\n  padding: 1.25rem 1.5rem;\n  border-bottom: 1px solid #e2e8f0;\n  background: #ffffff;\n  flex-shrink: 0;\n}\n\n.admin-layout-sidebar .admin-sidebar-logo a {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  text-decoration: none;\n  color: #1e293b;\n  font-weight: 700;\n  font-size: 1.15rem;\n  letter-spacing: -0.02em;\n}\n\n.admin-layout-sidebar .admin-sidebar-logo a img {\n  height: 38px;\n  width: auto;\n  max-width: 100px;\n  object-fit: contain;\n}\n\n.admin-layout-sidebar .admin-sidebar-user {\n  padding: 1rem 1.5rem;\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  border-bottom: 1px solid #e2e8f0;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.admin-layout-sidebar .admin-sidebar-user .admin-sidebar-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  object-fit: cover;\n  background: #e2e8f0;\n}\n\n.admin-layout-sidebar .admin-sidebar-user .admin-sidebar-user-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.admin-layout-sidebar .admin-sidebar-user .admin-sidebar-user-info .admin-sidebar-user-role {\n  font-size: 0.7rem;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-bottom: 2px;\n}\n\n.admin-layout-sidebar .admin-sidebar-user .admin-sidebar-user-info .admin-sidebar-user-name {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #1e293b;\n}\n\n.admin-layout-sidebar .admin-sidebar-nav {\n  flex: 1;\n  overflow-y: auto;\n  padding: 1rem 0.75rem;\n}\n\n.admin-layout-sidebar .admin-sidebar-nav .admin-sidebar-label {\n  font-size: 0.7rem;\n  font-weight: 600;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  padding: 0.5rem 1rem 0.35rem;\n  margin-top: 0.5rem;\n}\n\n.admin-layout-sidebar .admin-sidebar-nav .admin-sidebar-label:first-child {\n  margin-top: 0;\n}\n\n.admin-layout-sidebar .admin-sidebar-nav .admin-sidebar-item {\n  display: block;\n  padding: 0.65rem 1rem;\n  border-radius: 8px;\n  color: #475569;\n  font-size: 0.9rem;\n  font-weight: 500;\n  text-decoration: none;\n  transition: all 0.15s ease;\n  margin-bottom: 2px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.admin-layout-sidebar .admin-sidebar-nav .admin-sidebar-item .admin-sidebar-icon {\n  width: 22px;\n  height: 22px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.1rem;\n  color: #64748b;\n  flex-shrink: 0;\n}\n\n.admin-layout-sidebar .admin-sidebar-nav .admin-sidebar-item:hover {\n  background: #f1f5f9;\n  color: #334155;\n}\n\n.admin-layout-sidebar .admin-sidebar-nav .admin-sidebar-item:hover .admin-sidebar-icon {\n  color: #4f46e5;\n}\n\n.admin-layout-sidebar .admin-sidebar-nav .admin-sidebar-item.active {\n  background: linear-gradient(135deg, #eef2ff 0%, #e0e7ff 100%);\n  color: #4f46e5;\n}\n\n.admin-layout-sidebar .admin-sidebar-nav .admin-sidebar-item.active .admin-sidebar-icon {\n  color: #4f46e5;\n}\n\n.admin-layout-sidebar .admin-sidebar-nav .admin-sidebar-parent .admin-sidebar-item {\n  cursor: pointer;\n}\n\n.admin-layout-sidebar .admin-sidebar-nav .admin-sidebar-parent .admin-sidebar-item .admin-sidebar-arrow {\n  margin-left: auto;\n  transition: transform 0.2s;\n  color: #94a3b8;\n  font-size: 0.85rem;\n}\n\n.admin-layout-sidebar .admin-sidebar-nav .admin-sidebar-parent.open .admin-sidebar-arrow {\n  transform: rotate(180deg);\n}\n\n.admin-layout-sidebar .admin-sidebar-nav .admin-sidebar-sub {\n  list-style: none;\n  padding: 0.25rem 0 0.25rem 0.5rem;\n  margin: 0 0 0 1rem;\n  border-left: 2px solid #e2e8f0;\n}\n\n.admin-layout-sidebar .admin-sidebar-nav .admin-sidebar-sub li {\n  list-style: none;\n  margin: 0;\n}\n\n.admin-layout-sidebar .admin-sidebar-nav .admin-sidebar-sub .admin-sidebar-item {\n  padding: 0.5rem 0.75rem;\n  font-size: 0.85rem;\n  font-weight: 400;\n}\n\n.admin-layout-sidebar .admin-sidebar-nav .collapse .admin-sidebar-sub {\n  display: block;\n}\n\n.admin-layout-navbar {\n  background: #ffffff !important;\n  border-bottom: 1px solid #e2e8f0;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n  padding: 0.5rem 1.5rem;\n  min-height: 60px;\n}\n\n.admin-layout-navbar .navbar-menu-wrapper {\n  width: 100%;\n}\n\n.admin-layout-navbar .admin-navbar-title {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #1e293b;\n}\n\n.admin-layout-navbar .admin-navbar-user {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 0.4rem 0.75rem;\n  border-radius: 10px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  cursor: pointer;\n}\n\n.admin-layout-navbar .admin-navbar-user img {\n  width: 34px;\n  height: 34px;\n  border-radius: 8px;\n  object-fit: cover;\n}\n\n.admin-layout-navbar .admin-navbar-user .admin-navbar-user-text {\n  font-size: 0.85rem;\n  font-weight: 500;\n  color: #334155;\n}\n\n.admin-layout-navbar .admin-navbar-user .admin-navbar-user-role {\n  font-size: 0.75rem;\n  color: #64748b;\n}\n\n.admin-layout-navbar .dropdown-menu {\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);\n  padding: 0.5rem;\n}\n\n.admin-layout-navbar .dropdown-item {\n  border-radius: 6px;\n  padding: 0.6rem 1rem;\n  font-size: 0.9rem;\n  color: #334155;\n}\n\n.admin-layout-navbar .dropdown-item:hover {\n  background: #f1f5f9;\n}\n\n.admin-layout-navbar .navbar-toggler {\n  color: #64748b;\n  border-color: #e2e8f0;\n}\n\n.admin-layout-footer {\n  background: #ffffff !important;\n  border-top: 1px solid #e2e8f0;\n  padding: 0.75rem 1.5rem;\n}\n\n.admin-layout-footer .text-muted {\n  color: #64748b !important;\n  font-size: 0.85rem;\n}\n\n.admin-layout-footer a {\n  color: #4f46e5;\n  text-decoration: none;\n}\n\n.admin-layout-footer a:hover {\n  text-decoration: underline;\n}\n\n.admin-app .page-body-wrapper {\n  margin-right: 216px;\n  margin-left: 0;\n  background: #f1f5f9;\n  min-height: 100vh;\n}\n\n.admin-content {\n  min-height: calc(100vh - 60px);\n  padding: 1.5rem 1.5rem 2rem;\n  background: radial-gradient(1200px 600px at 10% -10%, rgba(99, 102, 241, 0.06), transparent 55%),\n    radial-gradient(900px 500px at 100% 0%, rgba(14, 165, 233, 0.05), transparent 50%),\n    #f1f5f9;\n}\n\n.admin-content {\n  --admin-bg: #f1f5f9;\n  --admin-card-bg: #ffffff;\n  --admin-border: #e2e8f0;\n  --admin-text: #1e293b;\n  --admin-text-muted: #64748b;\n  --admin-primary: #4f46e5;\n  --admin-primary-light: #eef2ff;\n  --admin-success: #059669;\n  --admin-danger: #dc2626;\n  --admin-warning: #d97706;\n  --admin-radius: 10px;\n  --admin-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n  --admin-shadow-card: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -2px rgba(0, 0, 0, 0.05);\n}\n\n.admin-content .admin-card {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: var(--admin-radius);\n  box-shadow: var(--admin-shadow-card);\n  margin-bottom: 1.5rem;\n  overflow: hidden;\n}\n\n.admin-content .admin-card .card-header,\n.admin-content .admin-card .admin-card-header {\n  padding: 1rem 1.25rem;\n  border-bottom: 1px solid #e2e8f0;\n  font-weight: 600;\n  color: #1e293b;\n  background: #fafafa;\n  font-size: 0.95rem;\n}\n\n.admin-content .admin-card .card-body {\n  padding: 1.25rem;\n  color: #334155;\n  background: #ffffff;\n}\n\n.admin-content .table-responsive {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  max-width: 100%;\n}\n\n.admin-content .table-responsive .table {\n  color: #334155;\n}\n\n.admin-content .table-responsive .table thead th {\n  border-color: #e2e8f0;\n  color: #64748b;\n  font-weight: 600;\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  background: #f8fafc;\n  padding: 0.75rem 1rem;\n}\n\n.admin-content .table-responsive .table tbody td {\n  border-color: #f1f5f9;\n  vertical-align: middle;\n  padding: 0.75rem 1rem;\n}\n\n.admin-content .table-responsive .table tbody tr:hover {\n  background: #f8fafc;\n}\n\n.admin-content .table-dark {\n  background: #ffffff;\n  color: #334155;\n}\n\n.admin-content .table-dark thead th {\n  background: #f8fafc;\n  color: #64748b;\n}\n\n.admin-content .form-control {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  color: #1e293b;\n  border-radius: 8px;\n  padding: 0.5rem 0.75rem;\n}\n\n.admin-content .form-control:focus {\n  border-color: #4f46e5;\n  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.15);\n}\n\n.admin-content .form-control::placeholder {\n  color: #94a3b8;\n}\n\n.admin-content .form-group label,\n.admin-content .form-label {\n  color: #475569;\n  margin-bottom: 0.35rem;\n  font-weight: 500;\n  font-size: 0.9rem;\n}\n\n.admin-content .btn-success {\n  background: #059669;\n  border-color: #059669;\n  color: #fff;\n  border-radius: 8px;\n  font-weight: 500;\n}\n\n.admin-content .btn-success:hover {\n  background: #047857;\n  border-color: #047857;\n  color: #fff;\n}\n\n.admin-content .btn-primary {\n  background: #4f46e5;\n  border-color: #4f46e5;\n  color: #fff;\n  border-radius: 8px;\n  font-weight: 500;\n}\n\n.admin-content .btn-primary:hover {\n  background: #4338ca;\n  border-color: #4338ca;\n  color: #fff;\n}\n\n.admin-content .btn-danger {\n  background: #dc2626;\n  border-color: #dc2626;\n  color: #fff;\n  border-radius: 8px;\n}\n\n.admin-content .btn-danger:hover {\n  background: #b91c1c;\n  border-color: #b91c1c;\n  color: #fff;\n}\n\n.admin-content .btn-info {\n  border-radius: 8px;\n}\n\n.admin-content .badge {\n  font-weight: 500;\n  padding: 0.35em 0.65em;\n  border-radius: 6px;\n}\n\n.admin-content .text-muted {\n  color: #64748b !important;\n}\n\n/* ========== All logged-in admin pages (under .admin-content) ========== */\n\n.admin-content .page-header {\n  margin-bottom: 1.25rem;\n  padding: 1rem 1.25rem;\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 14px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 8px 24px rgba(15, 23, 42, 0.06);\n}\n\n.admin-content .page-header h3,\n.admin-content .page-header h4 {\n  margin: 0;\n  font-size: 1.35rem;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: #0f172a;\n}\n\n.admin-content .page-header .page-subtitle,\n.admin-content p.page-subtitle {\n  margin: 0.35rem 0 0;\n  font-size: 0.875rem;\n  color: #64748b;\n  line-height: 1.45;\n}\n\n/*\n * Bootstrap cards (list / reports / legacy) — not .admin-card blocks.\n * Exclude .dashboard-card-link: those use gradient + .card-body.text-white;\n * forcing a white .card-body here made text stay white → invisible on white.\n */\n.admin-content .card:not(.admin-card):not(.dashboard-card-link) {\n  border-radius: 14px;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 8px 24px rgba(15, 23, 42, 0.06);\n  overflow: hidden;\n  background: #ffffff;\n}\n\n.admin-content .card:not(.admin-card):not(.dashboard-card-link) .card-header {\n  background: #f8fafc;\n  color: #0f172a;\n  font-weight: 600;\n  border-bottom: 1px solid #e2e8f0;\n  padding: 0.85rem 1.15rem;\n}\n\n.admin-content .card:not(.admin-card):not(.dashboard-card-link) .card-body {\n  background: #ffffff;\n  color: #334155;\n}\n\n.admin-content .card:not(.admin-card):not(.dashboard-card-link) .card-title {\n  font-weight: 700;\n  color: #0f172a;\n  letter-spacing: -0.01em;\n}\n\n/*\n * Today tab uses class \"card\" only (no .dashboard-card-link), so the rule above\n * still paints .card-body white while .text-white keeps labels white → invisible.\n * Gradient shows through parent .card; body stays transparent with white type.\n */\n.admin-content .card:not(.admin-card) .card-body.text-white {\n  background: transparent !important;\n  background-color: transparent !important;\n  color: #ffffff !important;\n}\n\n/* Legacy dark green panels → light (covers leftover inline + text-light) */\n.admin-content .card-body.text-light,\n.admin-content .card-body.text-light[style] {\n  background: #ffffff !important;\n  color: #334155 !important;\n}\n\n.admin-content .table.text-light {\n  color: #334155 !important;\n}\n\n.admin-content .table.text-light thead th {\n  background: #f8fafc !important;\n  color: #64748b !important;\n  border-color: #e2e8f0 !important;\n  font-size: 0.72rem;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  font-weight: 600;\n}\n\n.admin-content .table.text-light tbody td {\n  color: #334155 !important;\n  border-color: #f1f5f9 !important;\n  vertical-align: middle;\n}\n\n.admin-content .table.text-light tbody tr:hover {\n  background: #f8fafc !important;\n}\n\n/* .text-light on light cards → readable slate */\n.admin-content .card .text-light:not(.btn):not(.badge) {\n  color: #64748b !important;\n}\n\n.admin-content select.form-control.bg-dark,\n.admin-content .form-control.bg-dark {\n  background-color: #ffffff !important;\n  color: #1e293b !important;\n  border-color: #e2e8f0 !important;\n}\n\n.admin-content .pagination .page-link {\n  border-radius: 8px;\n  margin: 0 2px;\n  color: #475569;\n  border-color: #e2e8f0;\n}\n\n.admin-content .pagination .page-item.active .page-link {\n  background: #4f46e5;\n  border-color: #4f46e5;\n  color: #fff;\n}\n\n.admin-content .btn-outline-info {\n  color: #0369a1;\n  border-color: #7dd3fc;\n  background: #f0f9ff;\n  border-radius: 8px;\n  font-weight: 500;\n}\n\n.admin-content .btn-outline-info:hover {\n  color: #fff;\n  background: #0284c7;\n  border-color: #0284c7;\n}\n\n.admin-content .btn-outline-secondary,\n.admin-content .btn-secondary {\n  border-radius: 8px;\n}\n\n.admin-content .table thead th {\n  border-color: #e2e8f0;\n}\n\n/* User view — dark grey profile cards → light */\n.admin-content .lp-admin-detail-card {\n  background: #ffffff !important;\n  color: #334155 !important;\n  border: 1px solid #e2e8f0 !important;\n  border-radius: 14px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 8px 24px rgba(15, 23, 42, 0.06);\n}\n\n.admin-content .lp-admin-detail-card > .card-header {\n  background: #f8fafc !important;\n  color: #0f172a !important;\n  border-bottom: 1px solid #e2e8f0 !important;\n}\n\n.admin-content .lp-admin-kv-item {\n  background: #f8fafc !important;\n  border-color: #e2e8f0 !important;\n  color: #334155;\n}\n\n.admin-content .lp-admin-kv-item a {\n  color: #4f46e5;\n}\n\n.admin-content .lp-admin-wa-link {\n  color: #0284c7 !important;\n  font-weight: 600;\n}\n\n.admin-content .lp-admin-otp {\n  display: inline-block;\n  padding: 0.2rem 0.55rem;\n  background: #f1f5f9;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  font-size: 0.95rem;\n  letter-spacing: 0.08em;\n  color: #0f172a;\n}\n\n.admin-content .lp-admin-form-page {\n  background: #ffffff !important;\n  color: #334155 !important;\n  border: 1px solid #e2e8f0;\n  border-radius: 14px;\n  padding: 1.25rem;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 8px 24px rgba(15, 23, 42, 0.06);\n}\n\n/* User profile view (admin) */\n.admin-content .lp-user-view {\n  max-width: 1200px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.admin-content .lp-user-view-hero {\n  background: linear-gradient(135deg, #f8fafc 0%, #eef2ff 100%) !important;\n}\n\n.admin-content .lp-user-view-stat-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0.65rem;\n}\n\n@media (min-width: 768px) {\n  .admin-content .lp-user-view-stat-grid {\n    grid-template-columns: repeat(4, minmax(5.5rem, 1fr));\n  }\n}\n\n.admin-content .lp-user-view-stat {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 0.5rem 0.65rem;\n  text-align: center;\n}\n\n.admin-content .lp-user-view-stat-label {\n  display: block;\n  font-size: 0.65rem;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #64748b;\n  font-weight: 600;\n}\n\n.admin-content .lp-user-view-stat-value {\n  display: block;\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.admin-content .lp-user-view-tab-group .btn {\n  border-radius: 8px !important;\n}\n\n.admin-content .lp-user-view-table-wrap {\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  overflow-x: auto;\n  overflow-y: visible;\n  -webkit-overflow-scrolling: touch;\n  max-width: 100%;\n}\n\n.admin-content .lp-user-view-table thead th {\n  font-size: 0.72rem;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  color: #475569;\n  border-bottom-width: 1px;\n  white-space: nowrap;\n}\n\n.admin-content .lp-user-view-table tbody td {\n  vertical-align: middle;\n  font-size: 0.85rem;\n}\n\n.admin-app .sidebar.sidebar-offcanvas.admin-layout-sidebar {\n  background: #ffffff !important;\n  border-left: 1px solid #e2e8f0 !important;\n  border-right: none !important;\n}\n\n@media (max-width: 991px) {\n  .admin-app .page-body-wrapper {\n    margin-right: 0 !important;\n  }\n  \n  .admin-layout-sidebar {\n    transform: translateX(100%);\n    transition: transform 0.2s;\n    box-shadow: none;\n  }\n  \n  .admin-layout-sidebar.active {\n    transform: translateX(0);\n    box-shadow: -4px 0 20px rgba(0, 0, 0, 0.1);\n  }\n}\n\n@media (min-width: 992px) {\n  .admin-layout-sidebar {\n    transform: translateX(0) !important;\n    right: 0 !important;\n    left: auto !important;\n    display: flex !important;\n  }\n  \n  .admin-app .page-body-wrapper {\n    margin-right: 216px !important;\n    margin-left: 0 !important;\n  }\n}\n\n@import \"../assets/styles/admin-mobile-v2\";\n@import \"../assets/styles/admin-theme-light\";\n@import \"../assets/styles/admin-kyc-pages\";\n@import \"../assets/styles/admin-slim-ui\";\n@import \"../assets/styles/admin-mobile-readability\";\n@import \"../assets/styles/admin-shell-v3\";","@import \"shared\";\n\n// CSS Animations.\n\n// Apply an animation property and value with the correct browser support\n@mixin animation-support($property, $value) {\n  @include experimental($property, $value, -moz, -webkit, -o, -ms, not -khtml, official); }\n\n// Name of any animation as a string.\n$default-animation-name             : false !default;\n\n// Duration of the entire animation in seconds.\n$default-animation-duration         : false !default;\n\n// Delay for start of animation in seconds.\n$default-animation-delay            : false !default;\n\n// The timing function(s) to be used between keyframes. [ease | linear | ease-in | ease-out | ease-in-out | cubic-bezier($number, $number, $number, $number)]\n$default-animation-timing-function  : false !default;\n\n// The number of times an animation cycle is played. [infinite | $number]\n$default-animation-iteration-count  : false !default;\n\n// Whether or not the animation should play in reverse on alternate cycles. [normal | alternate]\n$default-animation-direction        : false !default;\n\n// What values are applied by the animation outside the time it is executing. [none | forwards | backwards | both]\n$default-animation-fill-mode        : false !default;\n\n// Whether the animation is running or paused. [running | paused]\n$default-animation-play-state       : false !default;\n\n// Create a named animation sequence that can be applied to elements later.\n//\n//     $name    - The name of your animation.\n//     @content - The keyframes of the animation.\n@mixin keyframes(\n  $name,\n  $moz: $experimental-support-for-mozilla,\n  $webkit: $experimental-support-for-webkit,\n  $o: $experimental-support-for-opera,\n  $ms: $experimental-support-for-microsoft,\n  $khtml: $experimental-support-for-khtml,\n  $official: true\n) {\n  @if $moz {\n    @include with-only-support-for($moz: true) {\n      @-moz-keyframes #{$name} { @content; }\n    }\n  }\n  @if $webkit {\n    @include with-only-support-for($webkit: true) {\n      @-webkit-keyframes #{$name} { @content; }\n    }\n  }\n  @if $o {\n    @include with-only-support-for($o: true) {\n      @-o-keyframes #{$name} { @content; }\n    }\n  }\n  @if $ms {\n    @include with-only-support-for($ms: true) {\n      @-ms-keyframes #{$name} { @content; }\n    }\n  }\n  @if $khtml {\n    @include with-only-support-for($khtml: true) {\n      @-khtml-keyframes #{$name} { @content; }\n    }\n  }\n  @if $official {\n    @include with-only-support-for {\n      @keyframes #{$name} { @content; }\n    }\n  }\n}\n\n// Apply 1-10 animation names.\n@mixin animation-name($name-1: $default-animation-name, $name-2: false, $name-3: false, $name-4: false, $name-5: false, $name-6: false, $name-7: false, $name-8: false, $name-9: false, $name-10: false) {\n  $name: compact($name-1, $name-2, $name-3, $name-4, $name-5, $name-6, $name-7, $name-8, $name-9, $name-10);\n  @include animation-support(animation-name, $name); }\n\n// Apply 1-10 animation durations.\n@mixin animation-duration($duration-1: $default-animation-duration, $duration-2: false, $duration-3: false, $duration-4: false, $duration-5: false, $duration-6: false, $duration-7: false, $duration-8: false, $duration-9: false, $duration-10: false) {\n  $duration: compact($duration-1, $duration-2, $duration-3, $duration-4, $duration-5, $duration-6, $duration-7, $duration-8, $duration-9, $duration-10);\n  @include animation-support(animation-duration, $duration); }\n\n// Apply 1-10 animation delays.\n@mixin animation-delay($delay-1: $default-animation-delay, $delay-2: false, $delay-3: false, $delay-4: false, $delay-5: false, $delay-6: false, $delay-7: false, $delay-8: false, $delay-9: false, $delay-10: false) {\n  $delay: compact($delay-1, $delay-2, $delay-3, $delay-4, $delay-5, $delay-6, $delay-7, $delay-8, $delay-9, $delay-10);\n  @include animation-support(animation-delay, $delay); }\n\n// Apply 1-10 animation timing functions.\n@mixin animation-timing-function($function-1: $default-animation-timing-function, $function-2: false, $function-3: false, $function-4: false, $function-5: false, $function-6: false, $function-7: false, $function-8: false, $function-9: false, $function-10: false) {\n  $function: compact($function-1, $function-2, $function-3, $function-4, $function-5, $function-6, $function-7, $function-8, $function-9, $function-10);\n  @include animation-support(animation-timing-function, $function); }\n\n// Apply 1-10 animation iteration counts.\n@mixin animation-iteration-count($count-1: $default-animation-iteration-count, $count-2: false, $count-3: false, $count-4: false, $count-5: false, $count-6: false, $count-7: false, $count-8: false, $count-9: false, $count-10: false) {\n  $count: compact($count-1, $count-2, $count-3, $count-4, $count-5, $count-6, $count-7, $count-8, $count-9, $count-10);\n  @include animation-support(animation-iteration-count, $count); }\n\n// Apply 1-10 animation directions.\n@mixin animation-direction($direction-1: $default-animation-direction, $direction-2: false, $direction-3: false, $direction-4: false, $direction-5: false, $direction-6: false, $direction-7: false, $direction-8: false, $direction-9: false, $direction-10: false) {\n  $direction: compact($direction-1, $direction-2, $direction-3, $direction-4, $direction-5, $direction-6, $direction-7, $direction-8, $direction-9, $direction-10);\n  @include animation-support(animation-direction, $direction); }\n\n// Apply 1-10 animation fill modes.\n@mixin animation-fill-mode($mode-1: $default-animation-fill-mode, $mode-2: false, $mode-3: false, $mode-4: false, $mode-5: false, $mode-6: false, $mode-7: false, $mode-8: false, $mode-9: false, $mode-10: false) {\n  $mode: compact($mode-1, $mode-2, $mode-3, $mode-4, $mode-5, $mode-6, $mode-7, $mode-8, $mode-9, $mode-10);\n  @include animation-support(animation-fill-mode, $mode); }\n\n// Apply 1-10 animation play states.\n@mixin animation-play-state($state-1: $default-animation-play-state, $state-2: false, $state-3: false, $state-4: false, $state-5: false, $state-6: false, $state-7: false, $state-8: false, $state-9: false, $state-10: false) {\n  $state: compact($state-1, $state-2, $state-3, $state-4, $state-5, $state-6, $state-7, $state-8, $state-9, $state-10);\n  @include animation-support(animation-play-state, $state); }\n\n// Shortcut to apply a named animation to an element, with all the settings.\n//\n//     $animation-1   : Name and settings for the first animation. [<values> | default]\n//     ...\n//     $animation-10  : Name and settings for the tenth animation. <values>\n@mixin animation($animation-1: default, $animation-2: false, $animation-3: false, $animation-4: false, $animation-5: false, $animation-6: false, $animation-7: false, $animation-8: false, $animation-9: false, $animation-10: false) {\n  @if $animation-1 == default {\n    $animation-1: -compass-space-list(compact($default-animation-name, $default-animation-duration, $default-animation-timing-function, $default-animation-delay, $default-animation-iteration-count, $default-animation-direction, $default-animation-fill-mode, $default-animation-play-state)); }\n  $animation: compact($animation-1, $animation-2, $animation-3, $animation-4, $animation-5, $animation-6, $animation-7, $animation-8, $animation-9, $animation-10);\n  @include animation-support(animation, $animation); }\n","// ---------------------------------------------------------------------------\n@include keyframes(flash) {\n  0% {\n    opacity: 1; }\n  25% {\n    opacity: 0; }\n  50% {\n    opacity: 1; }\n  75% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n\n// ---------------------------------------------------------------------------\n@include keyframes(bounce) {\n  0% {\n    @include translateY(0); }\n  20% {\n    @include translateY(0); }\n  40% {\n    @include translateY(-30px); }\n  50% {\n    @include translateY(0); }\n  60% {\n    @include translateY(-15px); }\n  80% {\n    @include translateY(0); }\n  100% {\n    @include translateY(0); } }\n\n\n// ---------------------------------------------------------------------------\n@include keyframes(shake) {\n  0% {\n    @include translateX(0); }\n  10% {\n    @include translateX(-10px); }\n  20% {\n    @include translateX(10px); }\n  30% {\n    @include translateX(-10px); }\n  40% {\n    @include translateX(10px); }\n  50% {\n    @include translateX(-10px); }\n  60% {\n    @include translateX(10px); }\n  70% {\n    @include translateX(-10px); }\n  80% {\n    @include translateX(10px); }\n  90% {\n    @include translateX(-10px); }\n  100% {\n    @include translateX(0); } }\n\n\n// ---------------------------------------------------------------------------\n@include keyframes(tada) {\n  0% {\n    @include scale(1); }\n  10% {\n    @include transform(scale(0.9) rotate(-3deg)); }\n  20% {\n    @include transform(scale(0.9) rotate(-3deg)); }\n  30% {\n    @include transform(scale(1.1) rotate(3deg)); }\n  40% {\n    @include transform(scale(1.1) rotate(-3deg)); }\n  50% {\n    @include transform(scale(1.1) rotate(3deg)); }\n  60% {\n    @include transform(scale(1.1) rotate(-3deg)); }\n  70% {\n    @include transform(scale(1.1) rotate(3deg)); }\n  80% {\n    @include transform(scale(1.1) rotate(-3deg)); }\n  90% {\n    @include transform(scale(1.1) rotate(3deg)); }\n  100% {\n    @include transform(scale(1) rotate(0)); } }\n\n\n// ---------------------------------------------------------------------------\n@include keyframes(swing) {\n  20%, 40%, 60%, 80%, 100% {\n    @include transform-origin(top center); }\n  20% {\n    @include rotate(15deg); }\n  40% {\n    @include rotate(-10deg); }\n  60% {\n    @include rotate(5deg); }\n  80% {\n    @include rotate(-5deg); }\n  100% {\n    @include rotate(0deg); } }\n\n\n// ---------------------------------------------------------------------------\n@include keyframes(wobble) {\n  0% {\n    @include translateX(0%); }\n  15% {\n    @include transform(translateX(-25%) rotate(-5deg)); }\n  30% {\n    @include transform(translateX(20%) rotate(3deg)); }\n  45% {\n    @include transform(translateX(-15%) rotate(-3deg)); }\n  60% {\n    @include transform(translateX(10%) rotate(2deg)); }\n  75% {\n    @include transform(translateX(-5%) rotate(-1deg)); }\n  100% {\n    @include transform(translateX(0%)); } }\n\n\n// ---------------------------------------------------------------------------\n@include keyframes(pulse) {\n  0% {\n    @include scale(1); }\n  50% {\n    @include scale(1.1); }\n  100% {\n    @include scale(1); } }\n    \n    \n// ---------------------------------------------------------------------------\n@include keyframes(wiggle) {\n  0% {\n    @include skewX(9deg); }\n  10% {\n    @include skewX(-8deg); }\n  20% {\n    @include skewX(7deg); }\n  30% {\n    @include skewX(-6deg); }\n  40% {\n    @include skewX(5deg); }\n  50% {\n    @include skewX(-4deg); }\n  60% {\n    @include skewX(3deg); }\n  70% {\n    @include skewX(-2deg); }\n  80% {\n    @include skewX(1deg); }\n  90% {\n    @include skewX(0deg); }\n  100% {\n    @include skewX(0deg); } }","@import \"../support\";\n\n// This mixin provides basic support for CSS3 properties and\n// their corresponding experimental CSS2 properties when\n// the implementations are identical except for the property\n// prefix.\n@mixin experimental($property, $value,\n  $moz      : $experimental-support-for-mozilla,\n  $webkit   : $experimental-support-for-webkit,\n  $o        : $experimental-support-for-opera,\n  $ms       : $experimental-support-for-microsoft,\n  $khtml    : $experimental-support-for-khtml,\n  $official : true\n) {\n  @if $webkit  and $experimental-support-for-webkit    { -webkit-#{$property} : $value; }\n  @if $khtml   and $experimental-support-for-khtml     {  -khtml-#{$property} : $value; }\n  @if $moz     and $experimental-support-for-mozilla   {    -moz-#{$property} : $value; }\n  @if $ms      and $experimental-support-for-microsoft {     -ms-#{$property} : $value; }\n  @if $o       and $experimental-support-for-opera     {      -o-#{$property} : $value; }\n  @if $official                                        {         #{$property} : $value; }\n}\n\n// Same as experimental(), but for cases when the property is the same and the value is vendorized\n@mixin experimental-value($property, $value,\n  $moz      : $experimental-support-for-mozilla,\n  $webkit   : $experimental-support-for-webkit,\n  $o        : $experimental-support-for-opera,\n  $ms       : $experimental-support-for-microsoft,\n  $khtml    : $experimental-support-for-khtml,\n  $official : true\n) {\n  @if $webkit  and $experimental-support-for-webkit    { #{$property} : -webkit-#{$value}; }\n  @if $khtml   and $experimental-support-for-khtml     { #{$property} :  -khtml-#{$value}; }\n  @if $moz     and $experimental-support-for-mozilla   { #{$property} :    -moz-#{$value}; }\n  @if $ms      and $experimental-support-for-microsoft { #{$property} :     -ms-#{$value}; }\n  @if $o       and $experimental-support-for-opera     { #{$property} :      -o-#{$value}; }\n  @if $official                                        { #{$property} :         #{$value}; }\n}\n","@import \"shared\";\n\n// @doc off\n// Note ----------------------------------------------------------------------\n// Safari, Chrome, and Firefox all support 3D transforms. However,\n// only in the most recent builds. You should also provide fallback 2d support for\n// Opera and IE. IE10 is slated to have 3d enabled, but is currently unreleased.\n// To make that easy, all 2D transforms include an browser-targeting toggle ($only3d)\n// to switch between the two support lists. The toggle defaults to 'false' (2D),\n// and also accepts 'true' (3D). Currently the lists are as follows:\n// 2D: Mozilla, Webkit, Opera, Official\n// 3D: Webkit, Firefox.\n\n// Available Transforms ------------------------------------------------------\n// - Scale (2d and 3d)\n// - Rotate (2d and 3d)\n// - Translate (2d and 3d)\n// - Skew (2d only)\n\n// Transform Parameters ------------------------------------------------------\n// - Transform Origin (2d and 3d)\n// - Perspective (3d)\n// - Perspective Origin (3d)\n// - Transform Style (3d)\n// - Backface Visibility (3d)\n\n// Mixins --------------------------------------------------------------------\n// transform-origin\n//  - shortcuts:  transform-origin2d, transform-origin3d\n//  - helpers:    apply-origin\n// transform\n//  - shortcuts:  transform2d, transform3d\n//  - helpers:    simple-transform, create-transform\n// perspective\n//  - helpers:    perspective-origin\n// transform-style\n// backface-visibility\n// scale\n//  - shortcuts:  scaleX, scaleY, scaleZ, scale3d\n// rotate\n//  - shortcuts:  rotateX, rotateY, rotate3d\n// translate\n//  - shortcuts:  translateX, translateY, translateZ, translate3d\n// skew\n//  - shortcuts:  skewX, skewY\n\n// Defaults ------------------------------------------------------------------\n// @doc on\n\n// The default x-origin for transforms\n$default-origin-x    : 50%                   !default;\n// The default y-origin for transforms\n$default-origin-y    : 50%                   !default;\n// The default z-origin for transforms\n$default-origin-z    : 50%                   !default;\n\n\n// The default x-multiplier for scaling\n$default-scale-x     : 1.25                  !default;\n// The default y-multiplier for scaling\n$default-scale-y     : $default-scale-x      !default;\n// The default z-multiplier for scaling\n$default-scale-z     : $default-scale-x      !default;\n\n\n// The default angle for rotations\n$default-rotate      : 45deg                 !default;\n\n\n// The default x-vector for the axis of 3d rotations\n$default-vector-x    : 1                     !default;\n// The default y-vector for the axis of 3d rotations\n$default-vector-y    : 1                     !default;\n// The default z-vector for the axis of 3d rotations\n$default-vector-z    : 1                     !default;\n\n\n// The default x-length for translations\n$default-translate-x : 1em                   !default;\n// The default y-length for translations\n$default-translate-y : $default-translate-x  !default;\n// The default z-length for translations\n$default-translate-z : $default-translate-x  !default;\n\n\n// The default x-angle for skewing\n$default-skew-x      : 5deg                  !default;\n// The default y-angle for skewing\n$default-skew-y      : 5deg                  !default;\n\n\n// **Transform-origin**\n// Transform-origin sent as a complete string\n//\n//     @include apply-origin( origin [, 3D-only ] )\n//\n// where 'origin' is a space separated list containing 1-3 (x/y/z) coordinates\n// in percentages, absolute (px, cm, in, em etc..) or relative\n// (left, top, right, bottom, center) units\n//\n// @param only3d Set this to true to only apply this\n// mixin where browsers have 3D support.\n@mixin apply-origin($origin, $only3d) {\n  $only3d: $only3d or -compass-list-size(-compass-list($origin)) > 2;\n  @if $only3d {\n    @include experimental(transform-origin, $origin,\n      -moz, -webkit, -o, -ms, not(-khtml), official\n    );\n  } @else {\n    @include experimental(transform-origin, $origin,\n      -moz, -webkit, -o, -ms, not(-khtml), official\n    );\n  }\n}\n\n// Transform-origin sent as individual arguments:\n//\n//     @include transform-origin( [ origin-x, origin-y, origin-z, 3D-only ] )\n//\n// where the 3 'origin-' arguments represent x/y/z coordinates.\n//\n// **NOTE:** setting z coordinates triggers 3D support list, leave false for 2D support\n@mixin transform-origin(\n  $origin-x: $default-origin-x,\n  $origin-y: $default-origin-y,\n  $origin-z: false,\n  $only3d:   if($origin-z, true, false)\n) {\n  $origin: unquote('');\n  @if $origin-x or $origin-y or $origin-z {\n    @if $origin-x { $origin: $origin-x; } @else { $origin: 50%; }\n    @if $origin-y { $origin: $origin $origin-y; } @else { @if $origin-z { $origin: $origin 50%; }}\n    @if $origin-z { $origin: $origin $origin-z; }\n    @include apply-origin($origin, $only3d);\n  }\n}\n\n\n// Transform sent as a complete string:\n//\n//     @include transform( transforms [, 3D-only ] )\n//\n// where 'transforms' is a space separated list of all the transforms to be applied.\n@mixin transform(\n  $transform,\n  $only3d: false\n) {\n  @if $only3d {\n    @include experimental(transform, $transform,\n      -moz, -webkit, -o, -ms, not(-khtml), official\n    );\n  } @else {\n    @include experimental(transform, $transform,\n      -moz, -webkit, -o, -ms, not(-khtml), official\n    );\n  }\n}\n\n// Shortcut to target all browsers with 2D transform support\n@mixin transform2d($trans) {\n  @include transform($trans, false);\n}\n\n// Shortcut to target only browsers with 3D transform support\n@mixin transform3d($trans) {\n  @include transform($trans, true);\n}\n\n// @doc off\n// 3D Parameters -------------------------------------------------------------\n// @doc on\n\n// Set the perspective of 3D transforms on the children of an element:\n//\n//      @include perspective( perspective )\n//\n// where 'perspective' is a unitless number representing the depth of the\n// z-axis. The higher the perspective, the more exaggerated the foreshortening.\n// values from 500 to 1000 are more-or-less \"normal\" - a good starting-point.\n@mixin perspective($p) {\n  @include experimental(perspective, $p,\n    -moz, -webkit, -o, -ms, not(-khtml), official\n  );\n}\n\n// Set the origin position for the perspective\n//\n//      @include perspective-origin(origin-x [origin-y])\n//\n// where the two arguments represent x/y coordinates\n@mixin perspective-origin($origin: 50%) {\n  @include experimental(perspective-origin, $origin,\n    -moz, -webkit, -o, -ms, not(-khtml), official\n  );\n}\n\n// Determine whether a 3D objects children also live in the given 3D space\n//\n//      @include transform-style( [ style ] )\n//\n// where `style` can be either `flat` or `preserve-3d`.\n// Browsers default to `flat`, mixin defaults to `preserve-3d`.\n@mixin transform-style($style: preserve-3d) {\n  @include experimental(transform-style, $style,\n    -moz, -webkit, -o, -ms, not(-khtml), official\n  );\n}\n\n// Determine the visibility of an element when it's back is turned\n//\n//     @include backface-visibility( [ visibility ] )\n//\n// where `visibility` can be either `visible` or `hidden`.\n// Browsers default to visible, mixin defaults to hidden\n@mixin backface-visibility($visibility: hidden) {\n  @include experimental(backface-visibility, $visibility,\n    -moz, -webkit, -o, -ms, not(-khtml), official\n  );\n}\n\n// @doc off\n// Transform Partials --------------------------------------------------------\n// These work well on their own, but they don't add to each other, they override.\n// Use along with transform parameter mixins to adjust origin, perspective and style\n// ---------------------------------------------------------------------------\n\n\n// Scale ---------------------------------------------------------------------\n// @doc on\n\n// Scale an object along the x and y axis:\n//\n//      @include scale( [ scale-x, scale-y, perspective, 3D-only ] )\n//\n// where the 'scale-' arguments are unitless multipliers of the x and y dimensions\n// and perspective, which works the same as the stand-alone perspective property/mixin\n// but applies to the individual element (multiplied with any parent perspective)\n//\n// **Note** This mixin cannot be combined with other transform mixins.\n@mixin scale(\n  $scale-x:     $default-scale-x,\n  $scale-y:     $scale-x,\n  $perspective: false,\n  $only3d:      false\n) {\n  $trans: scale($scale-x, $scale-y);\n  @if $perspective { $trans: perspective($perspective) $trans; }\n  @include transform($trans, $only3d);\n}\n\n// Scale an object along the x axis\n// @include scaleX( [ scale-x, perspective, 3D-only ] )\n//\n// **Note** This mixin cannot be combined with other transform mixins.\n@mixin scaleX(\n  $scale:       $default-scale-x,\n  $perspective: false,\n  $only3d:      false\n) {\n  $trans: scaleX($scale);\n  @if $perspective { $trans: perspective($perspective) $trans; }\n  @include transform($trans, $only3d);\n}\n\n// Scale an object along the y axis\n// @include scaleY( [ scale-y, perspective, 3D-only ] )\n//\n// **Note** This mixin cannot be combined with other transform mixins.\n@mixin scaleY(\n  $scale:       $default-scale-y,\n  $perspective: false,\n  $only3d:      false\n) {\n  $trans: scaleY($scale);\n  @if $perspective { $trans: perspective($perspective) $trans; }\n  @include transform($trans, $only3d);\n}\n\n// Scale an object along the z axis\n// @include scaleZ( [ scale-z, perspective ] )\n//\n// **Note** This mixin cannot be combined with other transform mixins.\n@mixin scaleZ(\n  $scale: $default-scale-z,\n  $perspective: false\n) {\n  $trans: scaleZ($scale);\n  @if $perspective { $trans: perspective($perspective) $trans; }\n  @include transform3d($trans);\n}\n\n// Scale and object along all three axis\n// @include scale3d( [ scale-x, scale-y, scale-z, perspective ] )\n//\n// **Note** This mixin cannot be combined with other transform mixins.\n@mixin scale3d(\n  $scale-x:     $default-scale-x,\n  $scale-y:     $default-scale-y,\n  $scale-z:     $default-scale-z,\n  $perspective: false\n) {\n  $trans: scale3d($scale-x, $scale-y, $scale-z);\n  @if $perspective { $trans: perspective($perspective) $trans; }\n  @include transform3d($trans);\n}\n\n// @doc off\n// Rotate --------------------------------------------------------------------\n// @doc on\n\n// Rotate an object around the z axis  (2D)\n// @include rotate( [ rotation, perspective, 3D-only ] )\n// where 'rotation' is an angle set in degrees (deg) or radian (rad) units\n//\n// **Note** This mixin cannot be combined with other transform mixins.\n@mixin rotate(\n  $rotate:      $default-rotate,\n  $perspective: false,\n  $only3d:      false\n) {\n  $trans: rotate($rotate);\n  @if $perspective { $trans: perspective($perspective) $trans; }\n  @include transform($trans, $only3d);\n}\n\n// A longcut for 'rotate' in case you forget that 'z' is implied\n//\n// **Note** This mixin cannot be combined with other transform mixins.\n@mixin rotateZ(\n  $rotate:      $default-rotate,\n  $perspective: false,\n  $only3d:      false\n) {\n  @include rotate($rotate, $perspective, $only3d);\n}\n\n// Rotate an object around the x axis (3D)\n// @include rotateX( [ rotation, perspective ] )\n//\n// **Note** This mixin cannot be combined with other transform mixins.\n@mixin rotateX(\n  $rotate: $default-rotate,\n  $perspective: false\n) {\n  $trans: rotateX($rotate);\n  @if $perspective { $trans: perspective($perspective) $trans; }\n  @include transform3d($trans);\n}\n\n// Rotate an object around the y axis (3D)\n// @include rotate( [ rotation, perspective ] )\n//\n// **Note** This mixin cannot be combined with other transform mixins.\n@mixin rotateY(\n  $rotate: $default-rotate,\n  $perspective: false\n) {\n  $trans: rotateY($rotate);\n  @if $perspective { $trans: perspective($perspective) $trans; }\n  @include transform3d($trans);\n}\n\n// Rotate an object around an arbitrary axis (3D)\n// @include rotate( [ vector-x, vector-y, vector-z, rotation, perspective ] )\n// where the 'vector-' arguments accept unitless numbers.\n// These numbers are not important on their own, but in relation to one another\n// creating an axis from your transform-origin, along the axis of Xx = Yy = Zz.\n//\n// **Note** This mixin cannot be combined with other transform mixins.\n@mixin rotate3d(\n  $vector-x: $default-vector-x,\n  $vector-y: $default-vector-y,\n  $vector-z: $default-vector-z,\n  $rotate: $default-rotate,\n  $perspective: false\n) {\n  $trans: rotate3d($vector-x, $vector-y, $vector-z, $rotate);\n  @if $perspective { $trans: perspective($perspective) $trans; }\n  @include transform3d($trans);\n}\n\n// @doc off\n// Translate -----------------------------------------------------------------\n// @doc on\n\n// Move an object along the x or y axis (2D)\n// @include translate( [ translate-x, translate-y, perspective, 3D-only ] )\n// where the 'translate-' arguments accept any distance in percentages or absolute (px, cm, in, em etc..) units.\n//\n// **Note** This mixin cannot be combined with other transform mixins.\n@mixin translate(\n  $translate-x: $default-translate-x,\n  $translate-y: $default-translate-y,\n  $perspective: false,\n  $only3d:      false\n) {\n  $trans: translate($translate-x, $translate-y);\n  @if $perspective { $trans: perspective($perspective) $trans; }\n  @include transform($trans, $only3d);\n}\n\n// Move an object along the x axis (2D)\n// @include translate( [ translate-x, perspective, 3D-only ] )\n//\n// **Note** This mixin cannot be combined with other transform mixins.\n@mixin translateX(\n  $trans-x:     $default-translate-x,\n  $perspective: false,\n  $only3d:      false\n) {\n  $trans: translateX($trans-x);\n  @if $perspective { $trans: perspective($perspective) $trans; }\n  @include transform($trans, $only3d);\n}\n\n// Move an object along the y axis (2D)\n// @include translate( [ translate-y, perspective, 3D-only ] )\n//\n// **Note** This mixin cannot be combined with other transform mixins.\n@mixin translateY(\n  $trans-y:     $default-translate-y,\n  $perspective: false,\n  $only3d:      false\n) {\n  $trans: translateY($trans-y);\n  @if $perspective { $trans: perspective($perspective) $trans; }\n  @include transform($trans, $only3d);\n}\n\n// Move an object along the z axis (3D)\n// @include translate( [ translate-z, perspective ] )\n//\n// **Note** This mixin cannot be combined with other transform mixins.\n@mixin translateZ(\n  $trans-z:     $default-translate-z,\n  $perspective: false\n) {\n  $trans: translateZ($trans-z);\n  @if $perspective { $trans: perspective($perspective) $trans; }\n  @include transform3d($trans);\n}\n\n// Move an object along the x, y and z axis (3D)\n// @include translate( [ translate-x, translate-y, translate-z, perspective ] )\n//\n// **Note** This mixin cannot be combined with other transform mixins.\n@mixin translate3d(\n  $translate-x: $default-translate-x,\n  $translate-y: $default-translate-y,\n  $translate-z: $default-translate-z,\n  $perspective: false\n) {\n  $trans: translate3d($translate-x, $translate-y, $translate-z);\n  @if $perspective { $trans: perspective($perspective) $trans; }\n  @include transform3d($trans);\n}\n\n// @doc off\n// Skew ----------------------------------------------------------------------\n// @doc on\n\n// Skew an element:\n//\n//     @include skew( [ skew-x, skew-y, 3D-only ] )\n//\n// where the 'skew-' arguments accept css angles in degrees (deg) or radian (rad) units.\n//\n// **Note** This mixin cannot be combined with other transform mixins.\n@mixin skew(\n  $skew-x: $default-skew-x,\n  $skew-y: $default-skew-y,\n  $only3d: false\n) {\n  $trans: skew($skew-x, $skew-y);\n  @include transform($trans, $only3d);\n}\n\n// Skew an element along the x axiz\n//\n//     @include skew( [ skew-x, 3D-only ] )\n//\n// **Note** This mixin cannot be combined with other transform mixins.\n@mixin skewX(\n  $skew-x: $default-skew-x,\n  $only3d: false\n) {\n  $trans: skewX($skew-x);\n  @include transform($trans, $only3d);\n}\n\n// Skew an element along the y axis\n//\n//     @include skew( [ skew-y, 3D-only ] )\n//\n// **Note** This mixin cannot be combined with other transform mixins.\n@mixin skewY(\n  $skew-y: $default-skew-y,\n  $only3d: false\n) {\n  $trans: skewY($skew-y);\n  @include transform($trans, $only3d);\n}\n\n\n// Full transform mixins\n// For settings any combination of transforms as arguments\n// These are complex and not highly recommended for daily use. They are mainly\n// here for backward-compatibility purposes.\n//\n// * they include origin adjustments\n// * scale takes a multiplier (unitless), rotate and skew take degrees (deg)\n//\n// **Note** This mixin cannot be combined with other transform mixins.\n@mixin create-transform(\n  $perspective: false,\n  $scale-x:     false,\n  $scale-y:     false,\n  $scale-z:     false,\n  $rotate-x:    false,\n  $rotate-y:    false,\n  $rotate-z:    false,\n  $rotate3d:    false,\n  $trans-x:     false,\n  $trans-y:     false,\n  $trans-z:     false,\n  $skew-x:      false,\n  $skew-y:      false,\n  $origin-x:    false,\n  $origin-y:    false,\n  $origin-z:    false,\n  $only3d:      false\n) {\n  $trans: unquote(\"\");\n\n  // perspective\n  @if $perspective { $trans: perspective($perspective) ; }\n\n  // scale\n  @if $scale-x and $scale-y {\n    @if $scale-z { $trans: $trans scale3d($scale-x, $scale-y, $scale-z); }\n    @else { $trans: $trans scale($scale-x, $scale-y); }\n  } @else {\n    @if $scale-x { $trans: $trans scaleX($scale-x); }\n    @if $scale-y { $trans: $trans scaleY($scale-y); }\n    @if $scale-z { $trans: $trans scaleZ($scale-z); }\n  }\n\n  // rotate\n  @if $rotate-x { $trans: $trans rotateX($rotate-x); }\n  @if $rotate-y { $trans: $trans rotateY($rotate-y); }\n  @if $rotate-z { $trans: $trans rotateZ($rotate-z); }\n  @if $rotate3d { $trans: $trans rotate3d($rotate3d); }\n\n  // translate\n  @if $trans-x and $trans-y {\n    @if $trans-z { $trans: $trans translate3d($trans-x, $trans-y, $trans-z); }\n    @else { $trans: $trans translate($trans-x, $trans-y); }\n  } @else {\n    @if $trans-x { $trans: $trans translateX($trans-x); }\n    @if $trans-y { $trans: $trans translateY($trans-y); }\n    @if $trans-z { $trans: $trans translateZ($trans-z); }\n  }\n\n  // skew\n  @if $skew-x and $skew-y { $trans: $trans skew($skew-x, $skew-y); }\n  @else {\n    @if $skew-x { $trans: $trans skewX($skew-x); }\n    @if $skew-y { $trans: $trans skewY($skew-y); }\n  }\n\n  // apply it!\n  @include transform($trans, $only3d);\n  @include transform-origin($origin-x, $origin-y, $origin-z, $only3d);\n}\n\n\n// A simplified set of options\n// backwards-compatible with the previous version of the 'transform' mixin\n@mixin simple-transform(\n  $scale:    false,\n  $rotate:   false,\n  $trans-x:  false,\n  $trans-y:  false,\n  $skew-x:   false,\n  $skew-y:   false,\n  $origin-x: false,\n  $origin-y: false\n) {\n  @include create-transform(\n    false,\n    $scale, $scale, false,\n    false, false, $rotate, false,\n    $trans-x, $trans-y, false,\n    $skew-x, $skew-y,\n    $origin-x, $origin-y, false,\n    false\n  );\n}\n","// ---------------------------------------------------------------------------\n@include keyframes(bounceOut) {\n  0% {\n    @include scale(1); }\n  25% {\n    @include scale(0.95); }\n  50% {\n    opacity: 1;\n    @include scale(1.1); }\n  100% {\n    opacity: 0;\n    @include scale(0.3); } }\n\n\n// ---------------------------------------------------------------------------\n@include keyframes(bounceOutUp) {\n  0% {\n    @include translateY(0); }\n  20% {\n    opacity: 1;\n    @include translateY(20px); }\n  100% {\n    opacity: 0;\n    @include translateY(-2000px); } }\n\n\n// ---------------------------------------------------------------------------\n@include keyframes(bounceOutDown) {\n  0% {\n    @include translateY(0); }\n  20% {\n    opacity: 1;\n    @include translateY(-20px); }\n  100% {\n    opacity: 0;\n    @include translateY(2000px); } }\n\n\n// ---------------------------------------------------------------------------\n@include keyframes(bounceOutLeft) {\n  0% {\n    @include translateX(0); }\n  20% {\n    opacity: 1;\n    @include translateX(20px); }\n  100% {\n    opacity: 0;\n    @include translateX(-2000px); } }\n\n\n// ---------------------------------------------------------------------------\n@include keyframes(bounceOutRight) {\n  0% {\n    @include translateX(0); }\n  20% {\n    opacity: 1;\n    @include translateX(-20px); }\n  100% {\n    opacity: 0;\n    @include translateX(2000px); } }\n","// ---------------------------------------------------------------------------\n@include keyframes(bounceIn) {\n  0% {\n    opacity: 0;\n    @include scale(0.3); }\n  50% {\n    opacity: 1;\n    @include scale(1.05); }\n  70% {\n    @include scale(0.9); }\n  100% {\n    @include scale(1); } }\n\n\n// ---------------------------------------------------------------------------\n@include keyframes(bounceInDown) {\n  0% {\n    opacity: 0;\n    @include translateY(-2000px); }\n  60% {\n    opacity: 1;\n    @include translateY(30px); }\n  80% {\n    @include translateY(-10px); }\n  100% {\n    @include translateY(0); } }\n\n\n// ---------------------------------------------------------------------------\n@include keyframes(bounceInUp) {\n  0% {\n    opacity: 0;\n    @include translateY(2000px); }\n  60% {\n    opacity: 1;\n    @include translateY(-30px); }\n  80% {\n    @include translateY(10px); }\n  100% {\n    @include translateY(0); } }\n\n\n// ---------------------------------------------------------------------------\n@include keyframes(bounceInRight) {\n  0% {\n    opacity: 0;\n    @include translateX(2000px); }\n  60% {\n    opacity: 1;\n    @include translateX(-30px); }\n  80% {\n    @include translateX(10px); }\n  100% {\n    @include translateX(0); } }\n\n\n// ---------------------------------------------------------------------------\n@include keyframes(bounceInLeft) {\n  0% {\n    opacity: 0;\n    @include translateX(-2000px); }\n  60% {\n    opacity: 1;\n    @include translateX(30px); }\n  80% {\n    @include translateX(-10px); }\n  100% {\n    @include translateX(0); } }\n","// ---------------------------------------------------------------------------\n@include keyframes(fadeOut) {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n\n// ---------------------------------------------------------------------------\n@include keyframes(fadeOutUp) {\n  0% {\n    @include translateY(0);\n    opacity: 1; }\n  100% {\n    @include translateY(-20px);\n    opacity: 0; } }\n\n\n// ---------------------------------------------------------------------------\n@include keyframes(fadeOutDown) {\n  0% {\n    @include translateY(0);\n    opacity: 1; }\n  100% {\n    @include translateY(20px);\n    opacity: 0; } }\n\n\n// ---------------------------------------------------------------------------\n@include keyframes(fadeOutRight) {\n  0% {\n    @include translateX(0);\n    opacity: 1; }\n  100% {\n    @include translateX(20px);\n    opacity: 0; } }\n\n\n// ---------------------------------------------------------------------------\n@include keyframes(fadeOutLeft) {\n  0% {\n    @include translateX(0);\n    opacity: 1; }\n  100% {\n    @include translateX(-20px);\n    opacity: 0; } }\n\n\n// ---------------------------------------------------------------------------\n@include keyframes(fadeOutUpBig) {\n  0% {\n    @include translateY(0);\n    opacity: 1; }\n  100% {\n    @include translateY(-2000px);\n    opacity: 0; } }\n\n\n// ---------------------------------------------------------------------------\n@include keyframes(fadeOutDownBig) {\n  0% {\n    opacity: 1;\n    @include translateY(0); }\n  100% {\n    opacity: 0;\n    @include translateY(2000px); } }\n\n\n// ---------------------------------------------------------------------------\n@include keyframes(fadeOutRightBig) {\n  0% {\n    opacity: 1;\n    @include translateX(0); }\n  100% {\n    opacity: 0;\n    @include translateX(2000px); } }\n\n\n// ---------------------------------------------------------------------------\n@include keyframes(fadeOutLeftBig) {\n  0% {\n    opacity: 1;\n    @include translateX(0); }\n  100% {\n    opacity: 0;\n    @include translateX(-2000px); } }\n","// ---------------------------------------------------------------------------\n@include keyframes(fadeIn) {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n\n// ---------------------------------------------------------------------------\n@include keyframes(fadeInUp) {\n  0% {\n    @include translateY(20px);\n    opacity: 0; }\n  100% {\n    @include translateY(0);\n    opacity: 1; } }\n\n\n// ---------------------------------------------------------------------------\n@include keyframes(fadeInDown) {\n  0% {\n    @include translateY(-20px);\n    opacity: 0; }\n  100% {\n    @include translateY(0);\n    opacity: 1; } }\n\n\n// ---------------------------------------------------------------------------\n@include keyframes(fadeInRight) {\n  0% {\n    @include translateX(20px);\n    opacity: 0; }\n  100% {\n    @include translateX(0);\n    opacity: 1; } }\n\n\n// ---------------------------------------------------------------------------\n@include keyframes(fadeInLeft) {\n  0% {\n    @include translateX(-20px);\n    opacity: 0; }\n  100% {\n    @include translateX(0);\n    opacity: 1; } }\n\n\n// ---------------------------------------------------------------------------\n@include keyframes(fadeInUpBig) {\n  0% {\n    @include translateY(2000px);\n    opacity: 0; }\n  100% {\n    @include translateY(0);\n    opacity: 1; } }\n\n\n// ---------------------------------------------------------------------------\n@include keyframes(fadeInDownBig) {\n  0% {\n    opacity: 0;\n    @include translateY(-2000px); }\n  100% {\n    opacity: 1;\n    @include translateY(0); } }\n\n\n// ---------------------------------------------------------------------------\n@include keyframes(fadeInRightBig) {\n  0% {\n    opacity: 0;\n    @include translateX(2000px); }\n  100% {\n    opacity: 1;\n    @include translateX(0); } }\n\n\n// ---------------------------------------------------------------------------\n@include keyframes(fadeInLeftBig) {\n  0% {\n    opacity: 0;\n    @include translateX(-2000px); }\n  100% {\n    opacity: 1;\n    @include translateX(0); } }\n","// ---------------------------------------------------------------------------\n@include keyframes(flip) {\n  0% {\n    @include transform(perspective(400px) rotateY(0));\n    @include animation-timing-function(ease-out);\n  }\n  40% {\n    @include transform(perspective(400px) translateZ(150px) rotateY(170deg));\n    @include animation-timing-function(ease-out);\n  }\n  50% {\n    @include transform(perspective(400px) translateZ(150px) rotateY(190deg) scale(1));\n    @include animation-timing-function(ease-in);\n  }\n  80% {\n    @include transform(perspective(400px) rotateY(360deg) scale(0.95));\n    @include animation-timing-function(ease-in);\n  }\n  100% {\n    @include transform(perspective(400px) scale(1));\n    @include animation-timing-function(ease-in);\n  }\n}\n\n\n// ---------------------------------------------------------------------------\n@include keyframes(flipInX) {\n  0% {\n    @include transform(perspective(400px) rotateX(90deg));\n    @include opacity(0);\n  }\n  40% {\n    @include transform(perspective(400px) rotateX(-10deg));\n  }\n  70% {\n    @include transform(perspective(400px) rotateX(10deg));\n  }\n  100% {\n    @include transform(perspective(400px) rotateX(0deg));\n    @include opacity(1);\n  }\n}\n\n\n// ---------------------------------------------------------------------------\n@include keyframes(flipOutX) {\n  0% {\n    @include transform(perspective(400px) rotateX(0deg));\n    @include opacity(1);\n  }\n  100% {\n    @include transform(perspective(400px) rotateX(90deg));\n    @include opacity(0);\n  }\n}\n\n\n// ---------------------------------------------------------------------------\n@include keyframes(flipInY) {\n  0% {\n    @include transform(perspective(400px) rotateY(90deg));\n    @include opacity(0);\n  }\n  40% {\n    @include transform(perspective(400px) rotateY(-10deg));\n  }\n  70% {\n    @include transform(perspective(400px) rotateY(10deg));\n  }\n  100% {\n    @include transform(perspective(400px) rotateY(0deg));\n    @include opacity(1);\n  }\n}\n\n\n// ---------------------------------------------------------------------------\n@include keyframes(flipOutY) {\n  0% {\n    @include transform(perspective(400px) rotateY(0deg));\n    @include opacity(1);\n  }\n  100% {\n    @include transform(perspective(400px) rotateY(90deg));\n    @include opacity(0);\n  }\n}\n","@import \"shared\";\n\n// Provides cross-browser CSS opacity. Takes a number between 0 and 1 as the argument, e.g. 0.5 for 50% opacity.\n//\n//     @param $opacity\n//         A number between 0 and 1, where 0 is transparent and 1 is opaque.\n\n@mixin opacity($opacity) {\n  @if $legacy-support-for-ie6 or $legacy-support-for-ie7 or $legacy-support-for-ie8 {\n    filter: unquote(\"progid:DXImageTransform.Microsoft.Alpha(Opacity=#{round($opacity * 100)})\");\n  }\n  opacity: $opacity;\n}\n\n// Make an element completely transparent.\n@mixin transparent { @include opacity(0); }\n\n// Make an element completely opaque.\n@mixin opaque { @include opacity(1); }\n","// ---------------------------------------------------------------------------\n@include keyframes(lightSpeedIn) {\n  0% {\n    @include transform(translateX(100%) skewX(-30deg));\n    @include opacity(0); }\n  60% {\n    @include transform(translateX(-20%) skewX(30deg));\n    @include opacity(1); }\n  80% {\n    @include transform(translateX(0%) skewX(-15deg));\n    @include opacity(1); }\n  100% {\n    @include transform(translateX(0%) skewX(0deg));\n    @include opacity(1); } }\n\n\n// ---------------------------------------------------------------------------\n@include keyframes(lightSpeedOut) {\n  0% {\n    @include transform(translateX(0%) skewX(0deg));\n    @include opacity(1); }\n  100% {\n    @include transform(translateX(100%) skewX(-30deg));\n    @include opacity(0); } }","// ---------------------------------------------------------------------------\n@include keyframes(rotateOut) {\n  0% {\n    @include transform-origin(center center);\n    @include rotate(0);\n    opacity: 1; }\n  100% {\n    @include transform-origin(center center);\n    @include rotate(200deg);\n    opacity: 0; } }\n\n\n// ---------------------------------------------------------------------------\n@include keyframes(rotateOutDownLeft) {\n  0% {\n    @include transform-origin(left bottom);\n    @include rotate(0);\n    opacity: 1; }\n  100% {\n    @include transform-origin(left bottom);\n    @include rotate(90deg);\n    opacity: 0; } }\n\n\n// ---------------------------------------------------------------------------\n@include keyframes(rotateOutUpLeft) {\n  0% {\n    @include transform-origin(left bottom);\n    @include rotate(0);\n    opacity: 1; }\n  100% {\n    @include transform-origin(left bottom);\n    @include rotate(-90deg);\n    opacity: 0; } }\n\n\n// ---------------------------------------------------------------------------\n@include keyframes(rotateOutDownRight) {\n  0% {\n    @include transform-origin(right bottom);\n    @include rotate(0);\n    opacity: 1; }\n  100% {\n    @include transform-origin(right bottom);\n    @include rotate(-90deg);\n    opacity: 0; } }\n\n\n// ---------------------------------------------------------------------------\n@include keyframes(rotateOutUpRight) {\n  0% {\n    @include transform-origin(right bottom);\n    @include rotate(0);\n    opacity: 1; }\n  100% {\n    @include transform-origin(right bottom);\n    @include rotate(90deg);\n    opacity: 0; } }\n","// ---------------------------------------------------------------------------\n@include keyframes(rotateIn) {\n  0% {\n    @include transform-origin(center center);\n    @include rotate(-200deg);\n    opacity: 0; }\n  100% {\n    @include transform-origin(center center);\n    @include rotate(0);\n    opacity: 1; } }\n\n\n// ---------------------------------------------------------------------------\n@include keyframes(rotateInDownLeft) {\n  0% {\n    @include transform-origin(left bottom);\n    @include rotate(-90deg);\n    opacity: 0; }\n  100% {\n    @include transform-origin(left bottom);\n    @include rotate(0);\n    opacity: 1; } }\n\n\n// ---------------------------------------------------------------------------\n@include keyframes(rotateInUpLeft) {\n  0% {\n    @include transform-origin(left bottom);\n    @include rotate(90deg);\n    opacity: 0; }\n  100% {\n    @include transform-origin(left bottom);\n    @include rotate(0);\n    opacity: 1; } }\n\n\n// ---------------------------------------------------------------------------\n@include keyframes(rotateInUpRight) {\n  0% {\n    @include transform-origin(right bottom);\n    @include rotate(-90deg);\n    opacity: 0; }\n  100% {\n    @include transform-origin(right bottom);\n    @include rotate(0);\n    opacity: 1; } }\n\n\n// ---------------------------------------------------------------------------\n@include keyframes(rotateInDownRight) {\n  0% {\n    @include transform-origin(right bottom);\n    @include rotate(90deg);\n    opacity: 0; }\n  100% {\n    @include transform-origin(right bottom);\n    @include rotate(0);\n    opacity: 1; } }\n","// ---------------------------------------------------------------------------\n@include keyframes(hinge) {\n  0% {\n    @include rotate(0);\n    @include transform-origin(top left);\n    @include animation-timing-function(ease-in-out); }\n  20%, 60% {\n    @include rotate(80deg);\n    @include transform-origin(top left);\n    @include animation-timing-function(ease-in-out); }\n  40% {\n    @include rotate(60deg);\n    @include transform-origin(top left);\n    @include animation-timing-function(ease-in-out); }\n  80% {\n    @include transform(rotate(60deg) translateY(0));\n    @include opacity(1);\n    @include transform-origin(top left);\n    @include animation-timing-function(ease-in-out); }\n  100% {\n    @include translateY(700px);\n    @include opacity(0); } }\n\n\n// ---------------------------------------------------------------------------\n@include keyframes(rollIn) {\n  0% {\n    @include opacity(0);\n    @include transform(translateX(-100%) rotate(-120deg)); }\n  100% {\n    @include opacity(1);\n    @include transform(translateX(0px) rotate(0deg)); } }\n\n\n// ---------------------------------------------------------------------------\n@include keyframes(rollOut) {\n  0% {\n    @include opacity(1);\n    @include transform(translateX(0px) rotate(0deg)); }\n  100% {\n    @include opacity(0);\n    @include transform(translateX(-100%) rotate(-120deg)); } }\n","/*!\n * Bootstrap v4.6.2 (https://getbootstrap.com/)\n * Copyright 2011-2022 The Bootstrap Authors\n * Copyright 2011-2022 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */\n\n@import \"functions\";\n@import \"variables\";\n@import \"mixins\";\n@import \"root\";\n@import \"reboot\";\n@import \"type\";\n@import \"images\";\n@import \"code\";\n@import \"grid\";\n@import \"tables\";\n@import \"forms\";\n@import \"buttons\";\n@import \"transitions\";\n@import \"dropdown\";\n@import \"button-group\";\n@import \"input-group\";\n@import \"custom-forms\";\n@import \"nav\";\n@import \"navbar\";\n@import \"card\";\n@import \"breadcrumb\";\n@import \"pagination\";\n@import \"badge\";\n@import \"jumbotron\";\n@import \"alert\";\n@import \"progress\";\n@import \"media\";\n@import \"list-group\";\n@import \"close\";\n@import \"toasts\";\n@import \"modal\";\n@import \"tooltip\";\n@import \"popover\";\n@import \"carousel\";\n@import \"spinners\";\n@import \"utilities\";\n@import \"print\";\n",":root {\n  // Custom variable values only support SassScript inside `#{}`.\n  @each $color, $value in $colors {\n    --#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$color}: #{$value};\n  }\n\n  @each $bp, $value in $grid-breakpoints {\n    --breakpoint-#{$bp}: #{$value};\n  }\n\n  // Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --font-family-sans-serif: #{inspect($font-family-sans-serif)};\n  --font-family-monospace: #{inspect($font-family-monospace)};\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// 1. Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n// 2. Change the default font family in all browsers.\n// 3. Correct the line height in all browsers.\n// 4. Prevent adjustments of font size after orientation changes in IE on Windows Phone and in iOS.\n// 5. Change the default tap highlight to be completely transparent in iOS.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box; // 1\n}\n\nhtml {\n  font-family: sans-serif; // 2\n  line-height: 1.15; // 3\n  -webkit-text-size-adjust: 100%; // 4\n  -webkit-tap-highlight-color: rgba($black, 0); // 5\n}\n\n// Shim for \"new\" HTML5 structural elements to display correctly (IE10, older browsers)\n// TODO: remove in v5\n// stylelint-disable-next-line selector-list-comma-newline-after\narticle, aside, figcaption, figure, footer, header, hgroup, main, nav, section {\n  display: block;\n}\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Set an explicit initial text-align value so that we can later use\n//    the `inherit` value on things like `<th>` elements.\n\nbody {\n  margin: 0; // 1\n  font-family: $font-family-base;\n  @include font-size($font-size-base);\n  font-weight: $font-weight-base;\n  line-height: $line-height-base;\n  color: $body-color;\n  text-align: left; // 3\n  background-color: $body-bg; // 2\n}\n\n// Future-proof rule: in browsers that support :focus-visible, suppress the focus outline\n// on elements that programmatically receive focus but wouldn't normally show a visible\n// focus outline. In general, this would mean that the outline is only applied if the\n// interaction that led to the element receiving programmatic focus was a keyboard interaction,\n// or the browser has somehow determined that the user is primarily a keyboard user and/or\n// wants focus outlines to always be presented.\n//\n// See https://developer.mozilla.org/en-US/docs/Web/CSS/:focus-visible\n// and https://developer.paciellogroup.com/blog/2018/03/focus-visible-and-backwards-compatibility/\n[tabindex=\"-1\"]:focus:not(:focus-visible) {\n  outline: 0 !important;\n}\n\n\n// Content grouping\n//\n// 1. Add the correct box sizing in Firefox.\n// 2. Show the overflow in Edge and IE.\n\nhr {\n  box-sizing: content-box; // 1\n  height: 0; // 1\n  overflow: visible; // 2\n}\n\n\n//\n// Typography\n//\n\n// Remove top margins from headings\n//\n// By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n// margin for easier control within type scales as it avoids margin collapsing.\n// stylelint-disable-next-line selector-list-comma-newline-after\nh1, h2, h3, h4, h5, h6 {\n  margin-top: 0;\n  margin-bottom: $headings-margin-bottom;\n}\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n// Abbreviations\n//\n// 1. Duplicate behavior to the data-* attribute for our tooltip plugin\n// 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n// 3. Add explicit cursor to indicate changed behavior.\n// 4. Remove the bottom border in Firefox 39-.\n// 5. Prevent the text-decoration to be skipped.\n\nabbr[title],\nabbr[data-original-title] { // 1\n  text-decoration: underline; // 2\n  text-decoration: underline dotted; // 2\n  cursor: help; // 3\n  border-bottom: 0; // 4\n  text-decoration-skip-ink: none; // 5\n}\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // Undo browser default\n}\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\nb,\nstrong {\n  font-weight: $font-weight-bolder; // Add the correct font weight in Chrome, Edge, and Safari\n}\n\nsmall {\n  @include font-size(80%); // Add the correct font size in all browsers\n}\n\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n//\n\nsub,\nsup {\n  position: relative;\n  @include font-size(75%);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n//\n// Links\n//\n\na {\n  color: $link-color;\n  text-decoration: $link-decoration;\n  background-color: transparent; // Remove the gray background on active links in IE 10.\n\n  @include hover() {\n    color: $link-hover-color;\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  color: inherit;\n  text-decoration: none;\n\n  @include hover() {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n//\n// Code\n//\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-monospace;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\npre {\n  // Remove browser default top margin\n  margin-top: 0;\n  // Reset browser default of `1em` to use `rem`s\n  margin-bottom: 1rem;\n  // Don't allow content to break outside\n  overflow: auto;\n  // Disable auto-hiding scrollbar in IE & legacy Edge to avoid overlap,\n  // making it impossible to interact with the content\n  -ms-overflow-style: scrollbar;\n}\n\n\n//\n// Figures\n//\n\nfigure {\n  // Apply a consistent margin strategy (matches our type styles).\n  margin: 0 0 1rem;\n}\n\n\n//\n// Images and content\n//\n\nimg {\n  vertical-align: middle;\n  border-style: none; // Remove the border on images inside links in IE 10-.\n}\n\nsvg {\n  // Workaround for the SVG overflow bug in IE10/11 is still required.\n  // See https://github.com/twbs/bootstrap/issues/26878\n  overflow: hidden;\n  vertical-align: middle;\n}\n\n\n//\n// Tables\n//\n\ntable {\n  border-collapse: collapse; // Prevent double borders\n}\n\ncaption {\n  padding-top: $table-cell-padding;\n  padding-bottom: $table-cell-padding;\n  color: $table-caption-color;\n  text-align: left;\n  caption-side: bottom;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\n\n//\n// Forms\n//\n\nlabel {\n  // Allow labels to use `margin` for spacing.\n  display: inline-block;\n  margin-bottom: $label-margin-bottom;\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n//\n// Details at https://github.com/twbs/bootstrap/issues/24093\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // Remove the margin in Firefox and Safari\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\nbutton,\ninput {\n  overflow: visible; // Show the overflow in Edge\n}\n\nbutton,\nselect {\n  text-transform: none; // Remove the inheritance of text transform in Firefox\n}\n\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\n// Remove the inheritance of word-wrap in Safari.\n//\n// Details at https://github.com/twbs/bootstrap/issues/24990\nselect {\n  word-wrap: normal;\n}\n\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n}\n\n// Opinionated: add \"hand\" cursor to non-disabled button elements.\n@if $enable-pointer-cursor-for-buttons {\n  button,\n  [type=\"button\"],\n  [type=\"reset\"],\n  [type=\"submit\"] {\n    &:not(:disabled) {\n      cursor: pointer;\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ninput[type=\"radio\"],\ninput[type=\"checkbox\"] {\n  box-sizing: border-box; // 1. Add the correct box sizing in IE 10-\n  padding: 0; // 2. Remove the padding in IE 10-\n}\n\n\ntextarea {\n  overflow: auto; // Remove the default vertical scrollbar in IE.\n  // Textareas should really only resize vertically so they don't break their (horizontal) containers.\n  resize: vertical;\n}\n\nfieldset {\n  // Browsers set a default `min-width: min-content;` on fieldsets,\n  // unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n  // So we reset that to ensure fieldsets behave more like a standard block element.\n  // See https://github.com/twbs/bootstrap/issues/12359\n  // and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n  min-width: 0;\n  // Reset the default outline behavior of fieldsets so they don't affect page layout.\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\n// 1. Correct the text wrapping in Edge and IE.\n// 2. Correct the color inheritance from `fieldset` elements in IE.\nlegend {\n  display: block;\n  width: 100%;\n  max-width: 100%; // 1\n  padding: 0;\n  margin-bottom: .5rem;\n  @include font-size(1.5rem);\n  line-height: inherit;\n  color: inherit; // 2\n  white-space: normal; // 1\n}\n\nprogress {\n  vertical-align: baseline; // Add the correct vertical alignment in Chrome, Firefox, and Opera.\n}\n\n// Correct the cursor style of increment and decrement buttons in Chrome.\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n[type=\"search\"] {\n  // This overrides the extra rounded corners on search inputs in iOS so that our\n  // `.form-control` class can properly style them. Note that this cannot simply\n  // be added to `.form-control` as it's not specific enough. For details, see\n  // https://github.com/twbs/bootstrap/issues/11586.\n  outline-offset: -2px; // 2. Correct the outline style in Safari.\n  -webkit-appearance: none;\n}\n\n//\n// Remove the inner padding in Chrome and Safari on macOS.\n//\n\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n//\n// 1. Correct the inability to style clickable types in iOS and Safari.\n// 2. Change font properties to `inherit` in Safari.\n//\n\n::-webkit-file-upload-button {\n  font: inherit; // 2\n  -webkit-appearance: button; // 1\n}\n\n//\n// Correct element displays\n//\n\noutput {\n  display: inline-block;\n}\n\nsummary {\n  display: list-item; // Add the correct display in all browsers\n  cursor: pointer;\n}\n\ntemplate {\n  display: none; // Add the correct display in IE\n}\n\n// Always hide an element with the `hidden` HTML attribute (from PureCSS).\n// Needed for proper display in IE 10-.\n[hidden] {\n  display: none !important;\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n\n$grays: () !default;\n$grays: map-merge(\n  (\n    \"100\": $gray-100,\n    \"200\": $gray-200,\n    \"300\": $gray-300,\n    \"400\": $gray-400,\n    \"500\": $gray-500,\n    \"600\": $gray-600,\n    \"700\": $gray-700,\n    \"800\": $gray-800,\n    \"900\": $gray-900\n  ),\n  $grays\n);\n\n$blue:    #007bff !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #e83e8c !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #28a745 !default;\n$teal:    #20c997 !default;\n$cyan:    #17a2b8 !default;\n\n$colors: () !default;\n$colors: map-merge(\n  (\n    \"blue\":       $blue,\n    \"indigo\":     $indigo,\n    \"purple\":     $purple,\n    \"pink\":       $pink,\n    \"red\":        $red,\n    \"orange\":     $orange,\n    \"yellow\":     $yellow,\n    \"green\":      $green,\n    \"teal\":       $teal,\n    \"cyan\":       $cyan,\n    \"white\":      $white,\n    \"gray\":       $gray-600,\n    \"gray-dark\":  $gray-800\n  ),\n  $colors\n);\n\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-800 !default;\n\n$theme-colors: () !default;\n$theme-colors: map-merge(\n  (\n    \"primary\":    $primary,\n    \"secondary\":  $secondary,\n    \"success\":    $success,\n    \"info\":       $info,\n    \"warning\":    $warning,\n    \"danger\":     $danger,\n    \"light\":      $light,\n    \"dark\":       $dark\n  ),\n  $theme-colors\n);\n\n// Set a specific jump point for requesting color jumps\n$theme-color-interval:      8% !default;\n\n// The yiq lightness value that determines when the lightness of color changes from \"dark\" to \"light\". Acceptable values are between 0 and 255.\n$yiq-contrasted-threshold:  150 !default;\n\n// Customize the light and dark text colors for use in our YIQ color contrast function.\n$yiq-text-dark:             $gray-900 !default;\n$yiq-text-light:            $white !default;\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                                true !default;\n$enable-rounded:                              true !default;\n$enable-shadows:                              false !default;\n$enable-gradients:                            false !default;\n$enable-transitions:                          true !default;\n$enable-prefers-reduced-motion-media-query:   true !default;\n$enable-hover-media-query:                    false !default; // Deprecated, no longer affects any compiled CSS\n$enable-grid-classes:                         true !default;\n$enable-pointer-cursor-for-buttons:           true !default;\n$enable-print-styles:                         true !default;\n$enable-responsive-font-sizes:                false !default;\n$enable-validation-icons:                     true !default;\n$enable-deprecation-messages:                 true !default;\n\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n$spacer: 1rem !default;\n$spacers: () !default;\n$spacers: map-merge(\n  (\n    0: 0,\n    1: ($spacer * .25),\n    2: ($spacer * .5),\n    3: $spacer,\n    4: ($spacer * 1.5),\n    5: ($spacer * 3)\n  ),\n  $spacers\n);\n\n// This variable affects the `.h-*` and `.w-*` classes.\n$sizes: () !default;\n$sizes: map-merge(\n  (\n    25: 25%,\n    50: 50%,\n    75: 75%,\n    100: 100%,\n    auto: auto\n  ),\n  $sizes\n);\n\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-bg:                   $white !default;\n$body-color:                $gray-900 !default;\n\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              theme-color(\"primary\") !default;\n$link-decoration:                         none !default;\n$link-hover-color:                        darken($link-color, 15%) !default;\n$link-hover-decoration:                   underline !default;\n// Darken percentage for links with `.text-*` class (e.g. `.text-success`)\n$emphasized-link-hover-darken-percentage: 15% !default;\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px\n) !default;\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px\n) !default;\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           30px !default;\n$grid-row-columns:            6 !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n$line-height-lg:              1.5 !default;\n$line-height-sm:              1.5 !default;\n\n$border-width:                1px !default;\n$border-color:                $gray-300 !default;\n\n$border-radius:               .25rem !default;\n$border-radius-lg:            .3rem !default;\n$border-radius-sm:            .2rem !default;\n\n$rounded-pill:                50rem !default;\n\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n\n$component-active-color:      $white !default;\n$component-active-bg:         theme-color(\"primary\") !default;\n\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n\n$embed-responsive-aspect-ratios: () !default;\n$embed-responsive-aspect-ratios: join(\n  (\n    (21 9),\n    (16 9),\n    (4 3),\n    (1 1),\n  ),\n  $embed-responsive-aspect-ratios\n);\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n$font-family-base:            $font-family-sans-serif !default;\n// stylelint-enable value-keyword-case\n\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-lg:                $font-size-base * 1.25 !default;\n$font-size-sm:                $font-size-base * .875 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n$line-height-base:            1.5 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              null !default;\n\n$display1-size:               6rem !default;\n$display2-size:               5.5rem !default;\n$display3-size:               4.5rem !default;\n$display4-size:               3.5rem !default;\n\n$display1-weight:             300 !default;\n$display2-weight:             300 !default;\n$display3-weight:             300 !default;\n$display4-weight:             300 !default;\n$display-line-height:         $headings-line-height !default;\n\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$text-muted:                  $gray-600 !default;\n\n$blockquote-small-color:      $gray-600 !default;\n$blockquote-small-font-size:  $small-font-size !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n\n$hr-border-color:             rgba($black, .1) !default;\n$hr-border-width:             $border-width !default;\n\n$mark-padding:                .2em !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$kbd-box-shadow:              inset 0 -.1rem 0 rgba($black, .25) !default;\n$nested-kbd-font-weight:      $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-bg:                     #fcf8e3 !default;\n\n$hr-margin-y:                 $spacer !default;\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n$table-cell-padding:          .75rem !default;\n$table-cell-padding-sm:       .3rem !default;\n\n$table-color:                 $body-color !default;\n$table-bg:                    null !default;\n$table-accent-bg:             rgba($black, .05) !default;\n$table-hover-color:           $table-color !default;\n$table-hover-bg:              rgba($black, .075) !default;\n$table-active-bg:             $table-hover-bg !default;\n\n$table-border-width:          $border-width !default;\n$table-border-color:          $border-color !default;\n\n$table-head-bg:               $gray-200 !default;\n$table-head-color:            $gray-700 !default;\n$table-th-font-weight:        null !default;\n\n$table-dark-color:            $white !default;\n$table-dark-bg:               $gray-800 !default;\n$table-dark-accent-bg:        rgba($white, .05) !default;\n$table-dark-hover-color:      $table-dark-color !default;\n$table-dark-hover-bg:         rgba($white, .075) !default;\n$table-dark-border-color:     lighten($table-dark-bg, 7.5%) !default;\n\n$table-striped-order:         odd !default;\n\n$table-caption-color:         $text-muted !default;\n\n$table-bg-level:              -9 !default;\n$table-border-level:          -6 !default;\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:       .2rem !default;\n$input-btn-focus-color:       rgba($component-active-bg, .25) !default;\n$input-btn-focus-box-shadow:  0 0 0 $input-btn-focus-width $input-btn-focus-color !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n$input-btn-line-height-sm:    $line-height-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n$input-btn-line-height-lg:    $line-height-lg !default;\n\n$input-btn-border-width:      $border-width !default;\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n$btn-line-height-sm:          $input-btn-line-height-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n$btn-line-height-lg:          $input-btn-line-height-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-disabled-color:     $gray-600 !default;\n\n$btn-block-spacing-y:         .5rem !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           $border-radius !default;\n$btn-border-radius-lg:        $border-radius-lg !default;\n$btn-border-radius-sm:        $border-radius-sm !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n\n// Forms\n\n$label-margin-bottom:                   .5rem !default;\n\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n$input-line-height-sm:                  $input-btn-line-height-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n$input-line-height-lg:                  $input-btn-line-height-lg !default;\n\n$input-bg:                              $white !default;\n$input-disabled-bg:                     $gray-200 !default;\n\n$input-color:                           $gray-700 !default;\n$input-border-color:                    $gray-400 !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      inset 0 1px 1px rgba($black, .075) !default;\n\n$input-border-radius:                   $border-radius !default;\n$input-border-radius-lg:                $border-radius-lg !default;\n$input-border-radius-sm:                $border-radius-sm !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              lighten($component-active-bg, 25%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               $gray-600 !default;\n$input-plaintext-color:                 $body-color !default;\n\n$input-height-border:                   $input-border-width * 2 !default;\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height-sm * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height-lg * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-text-margin-top:                  .25rem !default;\n\n$form-check-input-gutter:               1.25rem !default;\n$form-check-input-margin-y:             .3rem !default;\n$form-check-input-margin-x:             .25rem !default;\n\n$form-check-inline-margin-x:            .75rem !default;\n$form-check-inline-input-margin-x:      .3125rem !default;\n\n$form-grid-gutter-width:                10px !default;\n$form-group-margin-bottom:              1rem !default;\n\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  $gray-200 !default;\n$input-group-addon-border-color:        $input-border-color !default;\n\n$custom-forms-transition:               background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$custom-control-gutter:                 .5rem !default;\n$custom-control-spacer-x:               1rem !default;\n$custom-control-cursor:                 null !default;\n\n$custom-control-indicator-size:         1rem !default;\n$custom-control-indicator-bg:           $input-bg !default;\n\n$custom-control-indicator-bg-size:      50% 50% !default;\n$custom-control-indicator-box-shadow:   $input-box-shadow !default;\n$custom-control-indicator-border-color: $gray-500 !default;\n$custom-control-indicator-border-width: $input-border-width !default;\n\n$custom-control-label-color:            null !default;\n\n$custom-control-indicator-disabled-bg:          $input-disabled-bg !default;\n$custom-control-label-disabled-color:           $gray-600 !default;\n\n$custom-control-indicator-checked-color:        $component-active-color !default;\n$custom-control-indicator-checked-bg:           $component-active-bg !default;\n$custom-control-indicator-checked-disabled-bg:  rgba(theme-color(\"primary\"), .5) !default;\n$custom-control-indicator-checked-box-shadow:   null !default;\n$custom-control-indicator-checked-border-color: $custom-control-indicator-checked-bg !default;\n\n$custom-control-indicator-focus-box-shadow:     $input-focus-box-shadow !default;\n$custom-control-indicator-focus-border-color:   $input-focus-border-color !default;\n\n$custom-control-indicator-active-color:         $component-active-color !default;\n$custom-control-indicator-active-bg:            lighten($component-active-bg, 35%) !default;\n$custom-control-indicator-active-box-shadow:    null !default;\n$custom-control-indicator-active-border-color:  $custom-control-indicator-active-bg !default;\n\n$custom-checkbox-indicator-border-radius:       $border-radius !default;\n$custom-checkbox-indicator-icon-checked:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'><path fill='#{$custom-control-indicator-checked-color}' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/></svg>\") !default;\n\n$custom-checkbox-indicator-indeterminate-bg:           $component-active-bg !default;\n$custom-checkbox-indicator-indeterminate-color:        $custom-control-indicator-checked-color !default;\n$custom-checkbox-indicator-icon-indeterminate:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='4' height='4' viewBox='0 0 4 4'><path stroke='#{$custom-checkbox-indicator-indeterminate-color}' d='M0 2h4'/></svg>\") !default;\n$custom-checkbox-indicator-indeterminate-box-shadow:   null !default;\n$custom-checkbox-indicator-indeterminate-border-color: $custom-checkbox-indicator-indeterminate-bg !default;\n\n$custom-radio-indicator-border-radius:          50% !default;\n$custom-radio-indicator-icon-checked:           url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='-4 -4 8 8'><circle r='3' fill='#{$custom-control-indicator-checked-color}'/></svg>\") !default;\n\n$custom-switch-width:                           $custom-control-indicator-size * 1.75 !default;\n$custom-switch-indicator-border-radius:         $custom-control-indicator-size * .5 !default;\n$custom-switch-indicator-size:                  subtract($custom-control-indicator-size, $custom-control-indicator-border-width * 4) !default;\n\n$custom-select-padding-y:           $input-padding-y !default;\n$custom-select-padding-x:           $input-padding-x !default;\n$custom-select-font-family:         $input-font-family !default;\n$custom-select-font-size:           $input-font-size !default;\n$custom-select-height:              $input-height !default;\n$custom-select-indicator-padding:   1rem !default; // Extra padding to account for the presence of the background-image based indicator\n$custom-select-font-weight:         $input-font-weight !default;\n$custom-select-line-height:         $input-line-height !default;\n$custom-select-color:               $input-color !default;\n$custom-select-disabled-color:      $gray-600 !default;\n$custom-select-bg:                  $input-bg !default;\n$custom-select-disabled-bg:         $gray-200 !default;\n$custom-select-bg-size:             8px 10px !default; // In pixels because image dimensions\n$custom-select-indicator-color:     $gray-800 !default;\n$custom-select-indicator:           url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'><path fill='#{$custom-select-indicator-color}' d='M2 0L0 2h4zm0 5L0 3h4z'/></svg>\") !default;\n$custom-select-background:          escape-svg($custom-select-indicator) right $custom-select-padding-x center / $custom-select-bg-size no-repeat !default; // Used so we can have multiple background elements (e.g., arrow and feedback icon)\n\n$custom-select-feedback-icon-padding-right: add(1em * .75, (2 * $custom-select-padding-y * .75) + $custom-select-padding-x + $custom-select-indicator-padding) !default;\n$custom-select-feedback-icon-position:      center right ($custom-select-padding-x + $custom-select-indicator-padding) !default;\n$custom-select-feedback-icon-size:          $input-height-inner-half $input-height-inner-half !default;\n\n$custom-select-border-width:        $input-border-width !default;\n$custom-select-border-color:        $input-border-color !default;\n$custom-select-border-radius:       $border-radius !default;\n$custom-select-box-shadow:          inset 0 1px 2px rgba($black, .075) !default;\n\n$custom-select-focus-border-color:  $input-focus-border-color !default;\n$custom-select-focus-width:         $input-focus-width !default;\n$custom-select-focus-box-shadow:    0 0 0 $custom-select-focus-width $input-btn-focus-color !default;\n\n$custom-select-padding-y-sm:        $input-padding-y-sm !default;\n$custom-select-padding-x-sm:        $input-padding-x-sm !default;\n$custom-select-font-size-sm:        $input-font-size-sm !default;\n$custom-select-height-sm:           $input-height-sm !default;\n\n$custom-select-padding-y-lg:        $input-padding-y-lg !default;\n$custom-select-padding-x-lg:        $input-padding-x-lg !default;\n$custom-select-font-size-lg:        $input-font-size-lg !default;\n$custom-select-height-lg:           $input-height-lg !default;\n\n$custom-range-track-width:          100% !default;\n$custom-range-track-height:         .5rem !default;\n$custom-range-track-cursor:         pointer !default;\n$custom-range-track-bg:             $gray-300 !default;\n$custom-range-track-border-radius:  1rem !default;\n$custom-range-track-box-shadow:     inset 0 .25rem .25rem rgba($black, .1) !default;\n\n$custom-range-thumb-width:                   1rem !default;\n$custom-range-thumb-height:                  $custom-range-thumb-width !default;\n$custom-range-thumb-bg:                      $component-active-bg !default;\n$custom-range-thumb-border:                  0 !default;\n$custom-range-thumb-border-radius:           1rem !default;\n$custom-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$custom-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$custom-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in IE/Edge\n$custom-range-thumb-active-bg:               lighten($component-active-bg, 35%) !default;\n$custom-range-thumb-disabled-bg:             $gray-500 !default;\n\n$custom-file-height:                $input-height !default;\n$custom-file-height-inner:          $input-height-inner !default;\n$custom-file-focus-border-color:    $input-focus-border-color !default;\n$custom-file-focus-box-shadow:      $input-focus-box-shadow !default;\n$custom-file-disabled-bg:           $input-disabled-bg !default;\n\n$custom-file-padding-y:             $input-padding-y !default;\n$custom-file-padding-x:             $input-padding-x !default;\n$custom-file-line-height:           $input-line-height !default;\n$custom-file-font-family:           $input-font-family !default;\n$custom-file-font-weight:           $input-font-weight !default;\n$custom-file-color:                 $input-color !default;\n$custom-file-bg:                    $input-bg !default;\n$custom-file-border-width:          $input-border-width !default;\n$custom-file-border-color:          $input-border-color !default;\n$custom-file-border-radius:         $input-border-radius !default;\n$custom-file-box-shadow:            $input-box-shadow !default;\n$custom-file-button-color:          $custom-file-color !default;\n$custom-file-button-bg:             $input-group-addon-bg !default;\n$custom-file-text: (\n  en: \"Browse\"\n) !default;\n\n\n// Form validation\n\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $small-font-size !default;\n$form-feedback-valid-color:         theme-color(\"success\") !default;\n$form-feedback-invalid-color:       theme-color(\"danger\") !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}' viewBox='0 0 12 12'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n\n$form-validation-states: () !default;\n$form-validation-states: map-merge(\n  (\n    \"valid\": (\n      \"color\": $form-feedback-valid-color,\n      \"icon\": $form-feedback-icon-valid\n    ),\n    \"invalid\": (\n      \"color\": $form-feedback-invalid-color,\n      \"icon\": $form-feedback-icon-invalid\n    ),\n  ),\n  $form-validation-states\n);\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-modal-backdrop:             1040 !default;\n$zindex-modal:                      1050 !default;\n$zindex-popover:                    1060 !default;\n$zindex-tooltip:                    1070 !default;\n\n\n// Navs\n\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-disabled-color:           $gray-600 !default;\n\n$nav-tabs-border-color:             $gray-300 !default;\n$nav-tabs-border-width:             $border-width !default;\n$nav-tabs-border-radius:            $border-radius !default;\n$nav-tabs-link-hover-border-color:  $gray-200 $gray-200 $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        $gray-700 !default;\n$nav-tabs-link-active-bg:           $body-bg !default;\n$nav-tabs-link-active-border-color: $gray-300 $gray-300 $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           $border-radius !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-divider-color:                 $gray-200 !default;\n$nav-divider-margin-y:              $spacer * .5 !default;\n\n\n// Navbar\n\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  $spacer !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n\n$navbar-nav-scroll-max-height:      75vh !default;\n\n$navbar-dark-color:                 rgba($white, .5) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n\n$navbar-light-color:                rgba($black, .5) !default;\n$navbar-light-hover-color:          rgba($black, .7) !default;\n$navbar-light-active-color:         rgba($black, .9) !default;\n$navbar-light-disabled-color:       rgba($black, .3) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'><path stroke='#{$navbar-light-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba($black, .1) !default;\n\n$navbar-light-brand-color:                $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:          $navbar-light-active-color !default;\n$navbar-dark-brand-color:                 $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:           $navbar-dark-active-color !default;\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    $body-color !default;\n$dropdown-bg:                       $white !default;\n$dropdown-border-color:             rgba($black, .15) !default;\n$dropdown-border-radius:            $border-radius !default;\n$dropdown-border-width:             $border-width !default;\n$dropdown-inner-border-radius:      subtract($dropdown-border-radius, $dropdown-border-width) !default;\n$dropdown-divider-bg:               $gray-200 !default;\n$dropdown-divider-margin-y:         $nav-divider-margin-y !default;\n$dropdown-box-shadow:               0 .5rem 1rem rgba($black, .175) !default;\n\n$dropdown-link-color:               $gray-900 !default;\n$dropdown-link-hover-color:         darken($gray-900, 5%) !default;\n$dropdown-link-hover-bg:            $gray-200 !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      $gray-500 !default;\n\n$dropdown-item-padding-y:           .25rem !default;\n$dropdown-item-padding-x:           1.5rem !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding:           $dropdown-padding-y $dropdown-item-padding-x !default;\n\n\n// Pagination\n\n$pagination-padding-y:              .5rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n$pagination-line-height:            1.25 !default;\n\n$pagination-color:                  $link-color !default;\n$pagination-bg:                     $white !default;\n$pagination-border-width:           $border-width !default;\n$pagination-border-color:           $gray-300 !default;\n\n$pagination-focus-box-shadow:       $input-btn-focus-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            $link-hover-color !default;\n$pagination-hover-bg:               $gray-200 !default;\n$pagination-hover-border-color:     $gray-300 !default;\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $pagination-active-bg !default;\n\n$pagination-disabled-color:         $gray-600 !default;\n$pagination-disabled-bg:            $white !default;\n$pagination-disabled-border-color:  $gray-300 !default;\n\n$pagination-border-radius-sm:       $border-radius-sm !default;\n$pagination-border-radius-lg:       $border-radius-lg !default;\n\n\n// Jumbotron\n\n$jumbotron-padding:                 2rem !default;\n$jumbotron-color:                   null !default;\n$jumbotron-bg:                      $gray-200 !default;\n\n\n// Cards\n\n$card-spacer-y:                     .75rem !default;\n$card-spacer-x:                     1.25rem !default;\n$card-border-width:                 $border-width !default;\n$card-border-radius:                $border-radius !default;\n$card-border-color:                 rgba($black, .125) !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-bg:                       rgba($black, .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           $white !default;\n\n$card-img-overlay-padding:          1.25rem !default;\n\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n$card-deck-margin:                  $card-group-margin !default;\n\n$card-columns-count:                3 !default;\n$card-columns-gap:                  1.25rem !default;\n$card-columns-margin:               $card-spacer-y !default;\n\n\n// Tooltips\n\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     $white !default;\n$tooltip-bg:                        $black !default;\n$tooltip-border-radius:             $border-radius !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 .25rem !default;\n$tooltip-padding-x:                 .5rem !default;\n$tooltip-margin:                    0 !default;\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n$tooltip-arrow-color:               $tooltip-bg !default;\n\n// Form tooltips must come after regular tooltips\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   $line-height-base !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n\n\n// Popovers\n\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        $white !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              $border-width !default;\n$popover-border-color:              rgba($black, .2) !default;\n$popover-border-radius:             $border-radius-lg !default;\n$popover-inner-border-radius:       subtract($popover-border-radius, $popover-border-width) !default;\n$popover-box-shadow:                0 .25rem .5rem rgba($black, .2) !default;\n\n$popover-header-bg:                 darken($popover-bg, 3%) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          .75rem !default;\n\n$popover-body-color:                $body-color !default;\n$popover-body-padding-y:            $popover-header-padding-y !default;\n$popover-body-padding-x:            $popover-header-padding-x !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n$popover-arrow-color:               $popover-bg !default;\n\n$popover-arrow-outer-color:         fade-in($popover-border-color, .05) !default;\n\n\n// Toasts\n\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .25rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba($white, .85) !default;\n$toast-border-width:                1px !default;\n$toast-border-color:                rgba(0, 0, 0, .1) !default;\n$toast-border-radius:               .25rem !default;\n$toast-box-shadow:                  0 .25rem .75rem rgba($black, .1) !default;\n\n$toast-header-color:                $gray-600 !default;\n$toast-header-background-color:     rgba($white, .85) !default;\n$toast-header-border-color:         rgba(0, 0, 0, .05) !default;\n\n\n// Badges\n\n$badge-font-size:                   75% !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-padding-y:                   .25em !default;\n$badge-padding-x:                   .4em !default;\n$badge-border-radius:               $border-radius !default;\n\n$badge-transition:                  $btn-transition !default;\n$badge-focus-width:                 $input-btn-focus-width !default;\n\n$badge-pill-padding-x:              .6em !default;\n// Use a higher than normal value to ensure completely rounded edges when\n// customizing padding or font-size on labels.\n$badge-pill-border-radius:          10rem !default;\n\n\n// Modals\n\n// Padding applied to the modal body\n$modal-inner-padding:               1rem !default;\n\n// Margin between elements in footer, must be lower than or equal to 2 * $modal-inner-padding\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  $white !default;\n$modal-content-border-color:        rgba($black, .2) !default;\n$modal-content-border-width:        $border-width !default;\n$modal-content-border-radius:       $border-radius-lg !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       0 .25rem .5rem rgba($black, .5) !default;\n$modal-content-box-shadow-sm-up:    0 .5rem 1rem rgba($black, .5) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n$modal-header-border-color:         $border-color !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n$modal-header-padding-y:            1rem !default;\n$modal-header-padding-x:            1rem !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-xl:                          1140px !default;\n$modal-lg:                          800px !default;\n$modal-md:                          500px !default;\n$modal-sm:                          300px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n$alert-padding-y:                   .75rem !default;\n$alert-padding-x:                   1.25rem !default;\n$alert-margin-bottom:               1rem !default;\n$alert-border-radius:               $border-radius !default;\n$alert-link-font-weight:            $font-weight-bold !default;\n$alert-border-width:                $border-width !default;\n\n$alert-bg-level:                    -10 !default;\n$alert-border-level:                -9 !default;\n$alert-color-level:                 6 !default;\n\n\n// Progress bars\n\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       $gray-200 !default;\n$progress-border-radius:            $border-radius !default;\n$progress-box-shadow:               inset 0 .1rem .1rem rgba($black, .1) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   theme-color(\"primary\") !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n\n\n// List group\n\n$list-group-color:                  null !default;\n$list-group-bg:                     $white !default;\n$list-group-border-color:           rgba($black, .125) !default;\n$list-group-border-width:           $border-width !default;\n$list-group-border-radius:          $border-radius !default;\n\n$list-group-item-padding-y:         .75rem !default;\n$list-group-item-padding-x:         1.25rem !default;\n\n$list-group-hover-bg:               $gray-100 !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         $gray-600 !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           $gray-700 !default;\n$list-group-action-hover-color:     $list-group-action-color !default;\n\n$list-group-action-active-color:    $body-color !default;\n$list-group-action-active-bg:       $gray-200 !default;\n\n\n// Image thumbnails\n\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      $body-bg !default;\n$thumbnail-border-width:            $border-width !default;\n$thumbnail-border-color:            $gray-300 !default;\n$thumbnail-border-radius:           $border-radius !default;\n$thumbnail-box-shadow:              0 1px 2px rgba($black, .075) !default;\n\n\n// Figures\n\n$figure-caption-font-size:          90% !default;\n$figure-caption-color:              $gray-600 !default;\n\n\n// Breadcrumbs\n\n$breadcrumb-font-size:              null !default;\n\n$breadcrumb-padding-y:              .75rem !default;\n$breadcrumb-padding-x:              1rem !default;\n$breadcrumb-item-padding:           .5rem !default;\n\n$breadcrumb-margin-bottom:          1rem !default;\n\n$breadcrumb-bg:                     $gray-200 !default;\n$breadcrumb-divider-color:          $gray-600 !default;\n$breadcrumb-active-color:           $gray-600 !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n\n$breadcrumb-border-radius:          $border-radius !default;\n\n\n// Carousel\n\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n\n$carousel-control-icon-width:        20px !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' width='8' height='8' viewBox='0 0 8 8'><path d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' width='8' height='8' viewBox='0 0 8 8'><path d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n\n\n// Spinners\n\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n\n\n// Close\n\n$close-font-size:                   $font-size-base * 1.5 !default;\n$close-font-weight:                 $font-weight-bold !default;\n$close-color:                       $black !default;\n$close-text-shadow:                 0 1px 0 $white !default;\n\n\n// Code\n\n$code-font-size:                    87.5% !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .2rem !default;\n$kbd-padding-x:                     .4rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         $white !default;\n$kbd-bg:                            $gray-900 !default;\n\n$pre-color:                         $gray-900 !default;\n$pre-scrollable-max-height:         340px !default;\n\n\n// Utilities\n\n$displays: none, inline, inline-block, block, table, table-row, table-cell, flex, inline-flex !default;\n$overflows: auto, hidden !default;\n$positions: static, relative, absolute, fixed, sticky !default;\n$user-selects: all, auto, none !default;\n\n\n// Printing\n\n$print-page-size:                   a3 !default;\n$print-body-min-width:              map-get($grid-breakpoints, \"lg\") !default;\n","// stylelint-disable property-blacklist, scss/dollar-variable-default\n\n// SCSS RFS mixin\n//\n// Automated responsive font sizes\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/v8.x/LICENSE)\n\n// Configuration\n\n// Base font size\n$rfs-base-font-size: 1.25rem !default;\n$rfs-font-size-unit: rem !default;\n\n@if $rfs-font-size-unit != rem and $rfs-font-size-unit != px {\n  @error \"`#{$rfs-font-size-unit}` is not a valid unit for $rfs-font-size-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where font-size starts decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize font size based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != \"number\" or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-responsive-font-sizes to false\n$enable-responsive-font-sizes: true !default;\n\n// Cache $rfs-base-font-size unit\n$rfs-base-font-size-unit: unit($rfs-base-font-size);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-font-size for calculations\n@if $rfs-base-font-size-unit == \"px\" {\n  $rfs-base-font-size: divide($rfs-base-font-size, $rfs-base-font-size * 0 + 1);\n}\n@else if $rfs-base-font-size-unit == \"rem\" {\n  $rfs-base-font-size: divide($rfs-base-font-size, divide($rfs-base-font-size * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == \"px\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == \"rem\" or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-disable-class {\n  @if $rfs-class == \"disable\" {\n    // Adding an extra class increases specificity, which prevents the media query to override the font size\n    &,\n    .disable-responsive-font-size &,\n    &.disable-responsive-font-size {\n      @content;\n    }\n  }\n  @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-enable-class {\n  @if $rfs-class == \"enable\" {\n    .enable-responsive-font-size &,\n    &.enable-responsive-font-size {\n      @content;\n    }\n  }\n  @else {\n    @content;\n  }\n}\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query($mq-value) {\n  @if $rfs-two-dimensional {\n    @media (max-width: #{$mq-value}), (max-height: #{$mq-value}) {\n      @content;\n    }\n  }\n  @else {\n    @media (max-width: #{$mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Responsive font size mixin\n@mixin rfs($fs, $important: false) {\n  // Cache $fs unit\n  $fs-unit: if(type-of($fs) == \"number\", unit($fs), false);\n\n  // Add !important suffix if needed\n  $rfs-suffix: if($important, \" !important\", \"\");\n\n  // If $fs isn't a number (like inherit) or $fs has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n  @if not $fs-unit or $fs-unit != \"\" and $fs-unit != \"px\" and $fs-unit != \"rem\" or $fs == 0 {\n    font-size: #{$fs}#{$rfs-suffix};\n  }\n  @else {\n    // Remove unit from $fs for calculations\n    @if $fs-unit == \"px\" {\n      $fs: divide($fs, $fs * 0 + 1);\n    }\n    @else if $fs-unit == \"rem\" {\n      $fs: divide($fs, divide($fs * 0 + 1, $rfs-rem-value));\n    }\n\n    // Set default font size\n    $rfs-static: if($rfs-font-size-unit == rem, #{divide($fs, $rfs-rem-value)}rem, #{$fs}px);\n\n    // Only add the media query if the font size is bigger than the minimum font size\n    @if $fs <= $rfs-base-font-size or not $enable-responsive-font-sizes {\n      font-size: #{$rfs-static}#{$rfs-suffix};\n    }\n    @else {\n      // Calculate the minimum font size for $fs\n      $fs-min: $rfs-base-font-size + divide($fs - $rfs-base-font-size, $rfs-factor);\n\n      // Calculate difference between $fs and the minimum font size\n      $fs-diff: $fs - $fs-min;\n\n      // Base font-size formatting\n      $min-width: if($rfs-font-size-unit == rem, #{divide($fs-min, $rfs-rem-value)}rem, #{$fs-min}px);\n\n      // Use `vmin` if two-dimensional is enabled\n      $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n      // Calculate the variable width between 0 and $rfs-breakpoint\n      $variable-width: #{divide($fs-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n      // Set the calculated font-size\n      $rfs-fluid: calc(#{$min-width} + #{$variable-width}) #{$rfs-suffix};\n\n      // Breakpoint formatting\n      $mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n\n      @include _rfs-disable-class {\n        font-size: #{$rfs-static}#{$rfs-suffix};\n      }\n\n      @include _rfs-media-query($mq-value) {\n        @include _rfs-enable-class {\n          font-size: $rfs-fluid;\n        }\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n    }\n  }\n}\n\n// The font-size & responsive-font-size mixins use RFS to rescale the font size\n@mixin font-size($fs, $important: false) {\n  @include rfs($fs, $important);\n}\n\n@mixin responsive-font-size($fs, $important: false) {\n  @include rfs($fs, $important);\n}\n","\n////////// COLOR SYSTEM //////////\n\n$blue:              #5E50F9;\n$indigo:            #6610f2;\n$purple:            #6a008a;\n$pink:              #E91E63;\n$red:               #f96868;\n$orange:            #f2a654;\n$yellow:            #f6e84e;\n$green:             #46c35f;\n$teal:              #58d8a3;\n$cyan:              #57c7d4;\n$black:             #000;\n$white:             #ffffff;\n$white-smoke:       #f2f7f8;\n$violet:            #41478a;\n$darkslategray :    #2e383e;\n$dodger-blue :      #3498db;\n\n\n$colors: (\n  blue:             $blue,\n  indigo:           $indigo,\n  purple:           $purple,\n  pink:             $pink,\n  red:              $red,\n  orange:           $orange,\n  yellow:           $yellow,\n  green:            $green,\n  teal:             $teal,\n  cyan:             $cyan,\n  white:            $white,\n  gray:             #434a54,\n  gray-light:       #aab2bd,\n  gray-lighter:     #e8eff4,\n  gray-lightest:    #e6e9ed,\n  gray-dark:        #12151e,\n  black:            #000000\n);\n\n\n$theme-colors: (\n  primary:         #0090e7,\n  secondary:       #e4eaec,\n  success:         #00d25b,\n  info:            #8f5fe8,\n  warning:         #ffab00,\n  danger:          #fc424a,\n  light:           $white,\n  dark:            #0d0d0d\n);\n\n\n////////// COLOR SYSTEM //////////\n\n////////// COLOR VARIABLES //////////\n$content-bg: #f8f8f8;\n$footer-bg: transparent;\n$footer-color: color(dark);\n$border-color: #2c2e33;\n$circle-border: rgb(26, 57, 85); \n\n////////// COLOR VARIABLES //////////\n\n\n\n////////// SOCIAL COLORS //////////\n\n$social-colors: (\n  twitter: #2caae1,\n  facebook: #3b579d,\n  google: #dc4a38,\n  linkedin: #0177b5,\n  pinterest: #cc2127,\n  youtube: #e52d27,\n  github: #333333,\n  behance: #1769ff,\n  dribbble: #ea4c89,\n  reddit: #ff4500\n);\n\n////////// SOCIAL COLORS //////////\n\n////////// FONTS//\n\n$type1: 'Rubik', sans-serif;\n\n$font-weight-light: 300;\n$font-weight-medium: 500;\n$font-weight-bold: 700;\n\n$default-font-size: .875rem; // 14px as base font size\n\n$text-muted: #6c7293;\n$body-color: $darkslategray;\n\n////////// FONT VARIABLES //////////\n\n\n////////// CONTENT WRAPPER //////////\n\n$content-padding: 1.875rem 1.75rem;\n\n////////// CONTENT WRAPPER //////////\n\n////////// SIDEBAR ////////\n$sidebar-width-lg: 244px;\n$sidebar-width-mini: 185px;\n$sidebar-width-icon: 70px;\n\n$sidebar-bg: #fff;\n$sidebar-menu-color: $text-muted;\n$sidebar-menu-active-bg: darken($sidebar-bg, 5%);\n$sidebar-menu-active-color: $darkslategray;\n$sidebar-menu-hover-bg: darken($sidebar-bg, 5%);\n$sidebar-menu-hover-color: color($darkslategray);\n$sidebar-submenu-color: $sidebar-menu-color;\n$sidebar-submenu-hover-bg: initial;\n$sidebar-submenu-hover-color:$darkslategray;\n\n$sidebar-menu-icon-color: #bba8bff5;\n$sidebar-menu-arrow-color: rgba($text-muted, 0.36);\n\n$sidebar-menu-font-size: 0.9375rem;\n$sidebar-menu-padding-y: 0.8rem;\n$sidebar-menu-padding-x: 1.188rem;\n$rtl-sidebar-submenu-padding: 0 1.5rem 0 0;\n\n$sidebar-submenu-font-size: 0.855rem;\n$sidebar-submenu-item-padding: 0.5rem 0.35rem;\n\n$sidebar-icon-font-size: 1rem;\n$sidebar-arrow-font-size: .625rem;\n\n$sidebar-profile-bg: transparent;\n$sidebar-profile-padding: .75rem 1.625rem .75rem 1.188rem;\n\n$sidebar-mini-menu-padding: .8125rem 1rem .8125rem 1rem;\n\n$sidebar-icon-only-menu-padding: .5rem 1.625rem .5rem 1.188rem;\n$sidebar-icon-only-submenu-padding: 0 0 0 1.5rem;\n\n$icon-only-collapse-width: 190px;\n$icon-only-menu-bg: darken($sidebar-bg, 5%);\n\n///////// SIDEBAR ////////\n\n///////// NAVBAR ////////\n\n$navbar-height: 70px;\n$navbar-bg: #fff;\n$navbar-menu-color: $darkslategray;\n$navbar-font-size: .9375rem;\n$navbar-icon-font-size: 1.125rem;\n$navbar-box-shadow: 0 0.125rem 0 rgb(0 0 0 / 8%) !important;\n\n///////// NAVBAR ////////\n\n///////// CARD ////////\n$card-bg: #fff;\n$card-description-color: #bfbfbf;\n$card-title-color: #262b40;\n///////// CARD ////////\n\n///////// BUTTONS ////////\n\n$button-fixed-width: 150px;\n$btn-padding-y: .375rem;\n$btn-padding-x: .75rem;\n$btn-line-height: 1;\n\n$btn-padding-y-xs: .5rem;\n$btn-padding-x-xs: .75rem;\n\n$btn-padding-y-sm: .25rem;\n$btn-padding-x-sm: .5rem;\n\n$btn-padding-y-lg: 1rem;\n$btn-padding-x-lg: 3rem;\n\n$btn-font-size: 0.9375rem;\n$btn-font-size-xs: 0.625rem;\n$btn-font-size-sm: 0.875rem;\n$btn-font-size-lg: 0.875rem;\n\n$btn-border-radius: .1875rem;\n$btn-border-radius-xs: .1875rem;\n$btn-border-radius-sm: .1875rem;\n$btn-border-radius-lg: .1875rem;\n\n///////// BUTTONS ////////\n\n\n\n////////// TOOLTIP VARIABLES //////////\n\n//default styles\n$tooltip-font-size:     .75rem;\n$tooltip-padding-y:     .4rem;\n$tooltip-padding-x:     .75rem;\n$tooltip-border-radius: .375rem;\n\n////////// TOOLTIP VARIABLES //////////\n$popover-bg: theme-color(dark);\n$popover-border-color: $border-color;\n$popover-arrow-color: $popover-bg;\n$popover-arrow-outer-color: $popover-border-color;\n$popover-header-bg: $popover-bg;\n\n\n/////////  FORMS /////////\n\n$input-bg: #fff;\n$input-border-radius: 2px;\n$input-border-color: $border-color;\n$input-placeholder-color: #2e383e;\n$input-placeholder-font-size: 0.875rem;\n$input-font-size: 0.875rem;\n\n$input-padding-y: 0.56rem;\n$input-padding-x: 0.75rem;\n$input-line-height: 1;\n\n\n$input-padding-y-xs:    .5rem;\n$input-padding-x-xs:    .75rem;\n\n$input-padding-y-sm:    .50rem;\n$input-padding-x-sm:    .81rem;\n\n$input-padding-y-lg:    .94rem;\n$input-padding-x-lg:    1.94rem;\n\n$input-height:          2.875rem;\n$input-height-sm:       2.575rem;\n$input-height-lg:       3.175rem;\n\n///////// FORMS /////////\n\n////////  DROPDOWNS ///////\n\n$dropdown-bg: $card-bg;\n$dropdown-color: $body-color;\n$dropdown-item-hover-color: $white;\n$dropdown-border-color: $border-color;\n$dropdown-divider-bg: $border-color;\n$dropdown-link-color: $body-color;\n$dropdown-link-hover-bg: darken($card-bg, 3%);\n$dropdown-header-color: $body-color;\n$dropdown-menu-box-shadow: none;\n\n////////  DROPDOWNS ///////\n\n////////  PROGRESSBAR ///////\n$progress-bg: #2f323a;\n////////  PROGRESSBAR ///////\n\n//////// TABLES ////////\n\n$table-accent-bg: $content-bg;\n$table-hover-bg:  $content-bg;\n$table-cell-padding: .9375rem;\n$table-border-color: $border-color;\n\n$table-inverse-bg: #2a2b32;\n$table-inverse-color: color(white);\n\n//////// TABLES ////////\n\n\n\n////////// MEASUREMENT AND PROPERTY VARIABLES //////////\n\n$border-property: 1px solid $border-color;\n$card-spacing-y: 2.5rem;\n$card-padding-y: 1.75rem;\n$card-padding-x: 1.5625rem;\n$card-border-radius: 0.25rem;\n$card-description-color: #76838f;\n$grid-gutter-width: 1.5rem;\n$action-transition-duration: 0.25s;\n$action-transition-timing-function: ease;\n$card-bg-varient: #fff;\n$border-width: 1px;\n////////// OTHER VARIABLES //////////\n\n\n\n////////// BREAD CRUMBS VARIABLES //////////\n\n// default styles\n$breadcrumb-padding-y:              0.56rem;\n$breadcrumb-padding-x:              1.13rem;\n$breadcrumb-item-padding:           .5rem;\n$breadcrumb-margin-bottom:          1rem;\n$breadcrumb-font-size:              $default-font-size;\n$breadcrumb-bg:                     transparent;\n$breadcrumb-border-color:           $border-color;\n$breadcrumb-divider-color:          $gray-600;\n$breadcrumb-active-color:           $gray-700;\n$breadcrumb-divider:                \"/\";\n\n// custom styles\n$breadcrumb-custom-padding-y:       0;\n$breadcrumb-custom-padding-x:       0;\n$breadcrumb-custom-item-padding-y:  0.56rem;\n$breadcrumb-custom-item-padding-x:  10px;\n$breadcrumb-custom-item-color:      #FFFFF0;\n$breadcrumb-item-bg:                #141414;\n\n////////// BREAD CRUMBS VARIABLES //////////\n\n\n\n////////// MODALS VARIABLES //////////\n\n$modal-inner-padding:               0.9375rem;\n$modal-dialog-margin:               10px;\n$modal-dialog-margin-y-sm-up:       30px;\n$modal-title-line-height:           $line-height-base;\n$modal-content-bg:                  $content-bg;\n$modal-content-box-shadow-xs:       0 3px 9px rgba($black,.5);\n$modal-content-box-shadow-sm-up:    0 5px 15px rgba($black,.5);\n\n$modal-backdrop-bg:                 $black;\n$modal-backdrop-opacity:            .5;\n\n$modal-header-border-color:         $border-color;\n$modal-content-border-color:        $border-color;\n$modal-footer-border-color:         $border-color;\n\n$modal-header-border-width:         $border-width;\n$modal-content-border-width:        $border-width;\n$modal-footer-border-width:         $border-width;\n\n$modal-header-padding-x:              26px;\n$modal-header-padding-y:              25px;\n\n$modal-body-padding-x:                26px;\n$modal-body-padding-y:                35px;\n\n$modal-footer-padding-x:              31px;\n$modal-footer-padding-y:              15px;\n\n$modal-lg:                          90%;\n$modal-md:                          500px;\n$modal-sm:                          300px;\n$modal-transition:                  transform .4s ease;\n\n////////// MODALS VARIABLES //////////\n\n/////////  PAGINATION VARIABLES //////////\n$pagination-bg: $content-bg;\n/////////  PAGINATION VARIABLES //////////\n\n/////////  TABS VARIABLES //////////\n$nav-tabs-border-color:             $border-color;\n$nav-tabs-link-bg:                  $content-bg;\n$nav-tabs-link-color:               $body-color;\n$nav-tabs-link-hover-border-color:  $nav-tabs-border-color $nav-tabs-border-color $nav-tabs-border-color;\n$nav-tabs-link-active-color:        $body-color;\n$nav-tabs-link-active-bg:           darken($content-bg, 5%);\n$nav-tabs-link-active-border-color: $nav-tabs-border-color $nav-tabs-border-color $nav-tabs-link-active-bg;\n$nav-pills-custom-bg:               #8489ab;\n$text-gray:gray;\n$circle-img-border: $white;\n////////   TABS VARIABLES /////////\n\n////////   CALENDAR  //////////////\n$fullcalendar-color: #a8b2b9;\n////////   CALENDAR  //////////////\n\n///////// SETTINGS PANEL ////////\n$settings-panel-width: 300px;\n///////// SETTINGS PANEL ////////\n\n////////// Vendor file asset path //////////\n$mdi-font-path:        \"~@mdi/font/fonts\";\n$fa-font-path : '~font-awesome/fonts/';\n$flag-icon-css-path : '~flag-icon-css/flags/';\n$simple-line-font-path : '~simple-line-icons/fonts/';\n\n\n///////// BOXED LAYOUT ///////\n$boxed-container-width: 1200px;\n$boxed-layout-bg: #c6c8ca;\n///////// BOXED LAYOUT ///////\n\n///////// TICKETS-TAB ///////\n$tab-head-bg: #0f1015;\n$accent-color: $white; \n///////// TICKETS-TAB ///////\n\n///////// LANDING PAGE ///////\n$landing-bg:#1a142dfa;\n$landing-bg-color: $content-bg;\n///////// LANDING PAGE ///////\n\n///////// CHATS ///////\n$chat-container-height:100%;\n$chat-bottom-btn: $input-bg;\n$form-focus-bg: $white;\n///////// CHATS ///////\n\n$bullet-line-list-shape-bg: color(white) !default;","// Hover mixin and `$enable-hover-media-query` are deprecated.\n//\n// Originally added during our alphas and maintained during betas, this mixin was\n// designed to prevent `:hover` stickiness on iOS-an issue where hover styles\n// would persist after initial touch.\n//\n// For backward compatibility, we've kept these mixins and updated them to\n// always return their regular pseudo-classes instead of a shimmed media query.\n//\n// Issue: https://github.com/twbs/bootstrap/issues/25195\n\n@mixin hover() {\n  &:hover { @content; }\n}\n\n@mixin hover-focus() {\n  &:hover,\n  &:focus {\n    @content;\n  }\n}\n\n@mixin plain-hover-focus() {\n  &,\n  &:hover,\n  &:focus {\n    @content;\n  }\n}\n\n@mixin hover-focus-active() {\n  &:hover,\n  &:focus,\n  &:active {\n    @content;\n  }\n}\n","// stylelint-disable selector-list-comma-newline-after\n\n//\n// Headings\n//\n\nh1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: $headings-color;\n}\n\nh1, .h1 { @include font-size($h1-font-size); }\nh2, .h2 { @include font-size($h2-font-size); }\nh3, .h3 { @include font-size($h3-font-size); }\nh4, .h4 { @include font-size($h4-font-size); }\nh5, .h5 { @include font-size($h5-font-size); }\nh6, .h6 { @include font-size($h6-font-size); }\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n.display-1 {\n  @include font-size($display1-size);\n  font-weight: $display1-weight;\n  line-height: $display-line-height;\n}\n.display-2 {\n  @include font-size($display2-size);\n  font-weight: $display2-weight;\n  line-height: $display-line-height;\n}\n.display-3 {\n  @include font-size($display3-size);\n  font-weight: $display3-weight;\n  line-height: $display-line-height;\n}\n.display-4 {\n  @include font-size($display4-size);\n  font-weight: $display4-weight;\n  line-height: $display-line-height;\n}\n\n\n//\n// Horizontal rules\n//\n\nhr {\n  margin-top: $hr-margin-y;\n  margin-bottom: $hr-margin-y;\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n}\n\n\n//\n// Emphasis\n//\n\nsmall,\n.small {\n  @include font-size($small-font-size);\n  font-weight: $font-weight-normal;\n}\n\nmark,\n.mark {\n  padding: $mark-padding;\n  background-color: $mark-bg;\n}\n\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size(90%);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $spacer;\n  @include font-size($blockquote-font-size);\n}\n\n.blockquote-footer {\n  display: block;\n  @include font-size($blockquote-small-font-size);\n  color: $blockquote-small-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled() {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid() {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n\n\n// Retina image\n//\n// Short retina mixin for setting background-image and -size.\n\n@mixin img-retina($file-1x, $file-2x, $width-1x, $height-1x) {\n  background-image: url($file-1x);\n\n  // Autoprefixer takes care of adding -webkit-min-device-pixel-ratio and -o-min-device-pixel-ratio,\n  // but doesn't convert dppx=>dpi.\n  // There's no such thing as unprefixed min-device-pixel-ratio since it's nonstandard.\n  // Compatibility info: https://caniuse.com/css-media-resolution\n  @media only screen and (min-resolution: 192dpi), // IE9-11 don't support dppx\n    only screen and (min-resolution: 2dppx) { // Standardized\n    background-image: url($file-2x);\n    background-size: $width-1x $height-1x;\n  }\n  @include deprecate(\"`img-retina()`\", \"v4.3.0\", \"v5\");\n}\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-right-radius($radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-left-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-left-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-right-radius($radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-right-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-left-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n","// Inline code\ncode {\n  @include font-size($code-font-size);\n  color: $code-color;\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\n// User input typically entered via keyboard\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n  @include box-shadow($kbd-box-shadow);\n\n  kbd {\n    padding: 0;\n    @include font-size(100%);\n    font-weight: $nested-kbd-font-weight;\n    @include box-shadow(none);\n  }\n}\n\n// Blocks of code\npre {\n  display: block;\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\n// Enable scrollable blocks of code\n.pre-scrollable {\n  max-height: $pre-scrollable-max-height;\n  overflow-y: scroll;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-grid-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Row\n//\n// Rows contain your columns.\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n  }\n\n  // Remove the negative margin from default .row, then the horizontal padding\n  // from all immediate children columns (to prevent runaway style inheritance).\n  .no-gutters {\n    margin-right: 0;\n    margin-left: 0;\n\n    > .col,\n    > [class*=\"col-\"] {\n      padding-right: 0;\n      padding-left: 0;\n    }\n  }\n}\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","/// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-container($gutter: $grid-gutter-width) {\n  width: 100%;\n  padding-right: $gutter * .5;\n  padding-left: $gutter * .5;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -$gutter * .5;\n  margin-left: -$gutter * .5;\n}\n\n// For each breakpoint, define the maximum width of the container in a media query\n@mixin make-container-max-widths($max-widths: $container-max-widths, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint, $container-max-width in $max-widths {\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      max-width: $container-max-width;\n    }\n  }\n  @include deprecate(\"The `make-container-max-widths` mixin\", \"v4.5.2\", \"v5\");\n}\n\n@mixin make-col-ready($gutter: $grid-gutter-width) {\n  position: relative;\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we use `flex` values\n  // later on to override this initial width.\n  width: 100%;\n  padding-right: $gutter * .5;\n  padding-left: $gutter * .5;\n}\n\n@mixin make-col($size, $columns: $grid-columns) {\n  flex: 0 0 percentage(divide($size, $columns));\n  // Add a `max-width` to ensure content within each column does not blow out\n  // the width of the column. Applies to IE10+ and Firefox. Chrome and Safari\n  // do not appear to require this.\n  max-width: percentage(divide($size, $columns));\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n  max-width: 100%; // Reset earlier grid tiers\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// numberof columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 divide(100%, $count);\n    max-width: divide(100%, $count);\n  }\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @return if($n != null and $n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width. Null for the largest (last) breakpoint.\n// The maximum value is calculated as the minimum of the next one less 0.02px\n// to work around the limitations of `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $next: breakpoint-next($name, $breakpoints);\n  @return if($next, breakpoint-min($next, $breakpoints) - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  $max: breakpoint-max($name, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($name, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  // Common properties for all breakpoints\n  %grid-column {\n    position: relative;\n    width: 100%;\n    padding-right: $gutter * .5;\n    padding-left: $gutter * .5;\n  }\n\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @if $columns > 0 {\n      // Allow columns to stretch full width below their breakpoints\n      @for $i from 1 through $columns {\n        .col#{$infix}-#{$i} {\n          @extend %grid-column;\n        }\n      }\n    }\n\n    .col#{$infix},\n    .col#{$infix}-auto {\n      @extend %grid-column;\n    }\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex-basis: 0;\n        flex-grow: 1;\n        max-width: 100%;\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n      }\n\n      .order#{$infix}-first { order: -1; }\n\n      .order#{$infix}-last { order: $columns + 1; }\n\n      @for $i from 0 through $columns {\n        .order#{$infix}-#{$i} { order: $i; }\n      }\n\n      @if $columns > 0 {\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  width: 100%;\n  margin-bottom: $spacer;\n  color: $table-color;\n  background-color: $table-bg; // Reset for nesting within parents with `background-color`.\n\n  th,\n  td {\n    padding: $table-cell-padding;\n    vertical-align: top;\n    border-top: $table-border-width solid $table-border-color;\n  }\n\n  thead th {\n    vertical-align: bottom;\n    border-bottom: (2 * $table-border-width) solid $table-border-color;\n  }\n\n  tbody + tbody {\n    border-top: (2 * $table-border-width) solid $table-border-color;\n  }\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  th,\n  td {\n    padding: $table-cell-padding-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n\n.table-bordered {\n  border: $table-border-width solid $table-border-color;\n\n  th,\n  td {\n    border: $table-border-width solid $table-border-color;\n  }\n\n  thead {\n    th,\n    td {\n      border-bottom-width: 2 * $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  th,\n  td,\n  thead th,\n  tbody + tbody {\n    border: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n.table-striped {\n  tbody tr:nth-of-type(#{$table-striped-order}) {\n    background-color: $table-accent-bg;\n  }\n}\n\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  tbody tr {\n    @include hover() {\n      color: $table-hover-color;\n      background-color: $table-hover-bg;\n    }\n  }\n}\n\n\n// Table backgrounds\n//\n// Exact selectors below required to override `.table-striped` and prevent\n// inheritance to nested tables.\n\n@each $color, $value in $theme-colors {\n  @include table-row-variant($color, theme-color-level($color, $table-bg-level), theme-color-level($color, $table-border-level));\n}\n\n@include table-row-variant(active, $table-active-bg);\n\n\n// Dark styles\n//\n// Same table markup, but inverted color scheme: dark background and light text.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.table {\n  .thead-dark {\n    th {\n      color: $table-dark-color;\n      background-color: $table-dark-bg;\n      border-color: $table-dark-border-color;\n    }\n  }\n\n  .thead-light {\n    th {\n      color: $table-head-color;\n      background-color: $table-head-bg;\n      border-color: $table-border-color;\n    }\n  }\n}\n\n.table-dark {\n  color: $table-dark-color;\n  background-color: $table-dark-bg;\n\n  th,\n  td,\n  thead th {\n    border-color: $table-dark-border-color;\n  }\n\n  &.table-bordered {\n    border: 0;\n  }\n\n  &.table-striped {\n    tbody tr:nth-of-type(#{$table-striped-order}) {\n      background-color: $table-dark-accent-bg;\n    }\n  }\n\n  &.table-hover {\n    tbody tr {\n      @include hover() {\n        color: $table-dark-hover-color;\n        background-color: $table-dark-hover-bg;\n      }\n    }\n  }\n}\n\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n.table-responsive {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    &#{$infix} {\n      @include media-breakpoint-down($breakpoint) {\n        display: block;\n        width: 100%;\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n\n        // Prevent double border on horizontal scroll due to use of `display: block;`\n        > .table-bordered {\n          border: 0;\n        }\n      }\n    }\n  }\n}\n","// Tables\n\n@mixin table-row-variant($state, $background, $border: null) {\n  // Exact selectors below required to override `.table-striped` and prevent\n  // inheritance to nested tables.\n  .table-#{$state} {\n    &,\n    > th,\n    > td {\n      background-color: $background;\n    }\n\n    @if $border != null {\n      th,\n      td,\n      thead th,\n      tbody + tbody {\n        border-color: $border;\n      }\n    }\n  }\n\n  // Hover states for `.table-hover`\n  // Note: this is not available for cells or rows within `thead` or `tfoot`.\n  .table-hover {\n    $hover-background: darken($background, 5%);\n\n    .table-#{$state} {\n      @include hover() {\n        background-color: $hover-background;\n\n        > td,\n        > th {\n          background-color: $hover-background;\n        }\n      }\n    }\n  }\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Textual form controls\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  height: $input-height;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  // Unstyle the caret on `<select>`s in IE10+.\n  &::-ms-expand {\n    background-color: transparent;\n    border: 0;\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  @include form-control-focus($ignore-warning: true);\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled and read-only inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled,\n  &[readonly] {\n    background-color: $input-disabled-bg;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n}\n\ninput[type=\"date\"],\ninput[type=\"time\"],\ninput[type=\"datetime-local\"],\ninput[type=\"month\"] {\n  &.form-control {\n    appearance: none; // Fix appearance for date inputs in Safari\n  }\n}\n\nselect.form-control {\n  // Remove select outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $input-color;\n  }\n\n  &:focus::-ms-value {\n    // Suppress the nested default white text on blue background highlight given to\n    // the selected option text when the (still closed) <select> receives focus\n    // in IE and (under certain conditions) Edge, as it looks bad and cannot be made to\n    // match the appearance of the native widget.\n    // See https://github.com/twbs/bootstrap/issues/19398.\n    color: $input-color;\n    background-color: $input-bg;\n  }\n}\n\n// Make file inputs better match text inputs by forcing them to new lines.\n.form-control-file,\n.form-control-range {\n  display: block;\n  width: 100%;\n}\n\n\n//\n// Labels\n//\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<label>/<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  line-height: $input-line-height;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n}\n\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  @include font-size($input-font-size);\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n  @include border-radius($input-border-radius-sm);\n}\n\n.form-control-lg {\n  height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n  @include border-radius($input-border-radius-lg);\n}\n\n// stylelint-disable-next-line no-duplicate-selectors\nselect.form-control {\n  &[size],\n  &[multiple] {\n    height: auto;\n  }\n}\n\ntextarea.form-control {\n  height: auto;\n}\n\n// Form groups\n//\n// Designed to help with the organization and spacing of vertical forms. For\n// horizontal forms, use the predefined grid classes.\n\n.form-group {\n  margin-bottom: $form-group-margin-bottom;\n}\n\n.form-text {\n  display: block;\n  margin-top: $form-text-margin-top;\n}\n\n\n// Form grid\n//\n// Special replacement for our grid system's `.row` for tighter form layouts.\n\n.form-row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -$form-grid-gutter-width * .5;\n  margin-left: -$form-grid-gutter-width * .5;\n\n  > .col,\n  > [class*=\"col-\"] {\n    padding-right: $form-grid-gutter-width * .5;\n    padding-left: $form-grid-gutter-width * .5;\n  }\n}\n\n\n// Checkboxes and radios\n//\n// Indent the labels to position radios/checkboxes as hanging controls.\n\n.form-check {\n  position: relative;\n  display: block;\n  padding-left: $form-check-input-gutter;\n}\n\n.form-check-input {\n  position: absolute;\n  margin-top: $form-check-input-margin-y;\n  margin-left: -$form-check-input-gutter;\n\n  // Use [disabled] and :disabled for workaround https://github.com/twbs/bootstrap/issues/28247\n  &[disabled] ~ .form-check-label,\n  &:disabled ~ .form-check-label {\n    color: $text-muted;\n  }\n}\n\n.form-check-label {\n  margin-bottom: 0; // Override default `<label>` bottom margin\n}\n\n.form-check-inline {\n  display: inline-flex;\n  align-items: center;\n  padding-left: 0; // Override base .form-check\n  margin-right: $form-check-inline-margin-x;\n\n  // Undo .form-check-input defaults and add some `margin-right`.\n  .form-check-input {\n    position: static;\n    margin-top: 0;\n    margin-right: $form-check-inline-input-margin-x;\n    margin-left: 0;\n  }\n}\n\n\n// Form validation\n//\n// Provide feedback to users when form field values are valid or invalid. Works\n// primarily for client-side validation via scoped `:invalid` and `:valid`\n// pseudo-classes but also includes `.is-invalid` and `.is-valid` classes for\n// server side validation.\n\n@each $state, $data in $form-validation-states {\n  @include form-validation-state($state, map-get($data, color), map-get($data, icon));\n}\n\n// Inline forms\n//\n// Make forms appear inline(-block) by adding the `.form-inline` class. Inline\n// forms begin stacked on extra small (mobile) devices and then go inline when\n// viewports reach <768px.\n//\n// Requires wrapping inputs and labels with `.form-group` for proper display of\n// default HTML form controls and our custom form controls (e.g., input groups).\n\n.form-inline {\n  display: flex;\n  flex-flow: row wrap;\n  align-items: center; // Prevent shorter elements from growing to same height as others (e.g., small buttons growing to normal sized button height)\n\n  // Because we use flex, the initial sizing of checkboxes is collapsed and\n  // doesn't occupy the full-width (which is what we want for xs grid tier),\n  // so we force that here.\n  .form-check {\n    width: 100%;\n  }\n\n  // Kick in the inline\n  @include media-breakpoint-up(sm) {\n    label {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin-bottom: 0;\n    }\n\n    // Inline-block all the things for \"inline\"\n    .form-group {\n      display: flex;\n      flex: 0 0 auto;\n      flex-flow: row wrap;\n      align-items: center;\n      margin-bottom: 0;\n    }\n\n    // Allow folks to *not* use `.form-group`\n    .form-control {\n      display: inline-block;\n      width: auto; // Prevent labels from stacking above inputs in `.form-group`\n      vertical-align: middle;\n    }\n\n    // Make static controls behave like regular ones\n    .form-control-plaintext {\n      display: inline-block;\n    }\n\n    .input-group,\n    .custom-select {\n      width: auto;\n    }\n\n    // Remove default margin on radios/checkboxes that were used for stacking, and\n    // then undo the floating of radios and checkboxes to match.\n    .form-check {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: auto;\n      padding-left: 0;\n    }\n    .form-check-input {\n      position: relative;\n      flex-shrink: 0;\n      margin-top: 0;\n      margin-right: $form-check-input-margin-x;\n      margin-left: 0;\n    }\n\n    .custom-control {\n      align-items: center;\n      justify-content: center;\n    }\n    .custom-control-label {\n      margin-bottom: 0;\n    }\n  }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-prefers-reduced-motion-media-query and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Form control focus state\n//\n// Generate a customized focus state and for any input with the specified color,\n// which defaults to the `$input-focus-border-color` variable.\n//\n// We highly encourage you to not customize the default value, but instead use\n// this to tweak colors on an as-needed basis. This aesthetic change is based on\n// WebKit's default styles, but applicable to a wider range of browsers. Its\n// usability and accessibility should be taken into account with any change.\n//\n// Example usage: change the default blue border and shadow to white for better\n// contrast against a dark gray background.\n@mixin form-control-focus($ignore-warning: false) {\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n  @include deprecate(\"The `form-control-focus()` mixin\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n\n// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state($state, $color, $icon) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: color-yiq($color);\n    background-color: rgba($color, $form-feedback-tooltip-opacity);\n    @include border-radius($form-feedback-tooltip-border-radius);\n\n    // See https://github.com/twbs/bootstrap/pull/31557\n    // Align tooltip to form elements\n    .form-row > .col > &,\n    .form-row > [class*=\"col-\"] > & {\n      left: $form-grid-gutter-width * .5;\n    }\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner !important; // stylelint-disable-line declaration-no-important\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $color;\n        box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  select.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-padding-x * 4 !important; // stylelint-disable-line declaration-no-important\n        background-position: right $input-padding-x * 2 center;\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .custom-select {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      @if $enable-validation-icons {\n        padding-right: $custom-select-feedback-icon-padding-right !important; // stylelint-disable-line declaration-no-important\n        background: $custom-select-background, $custom-select-bg escape-svg($icon) $custom-select-feedback-icon-position / $custom-select-feedback-icon-size no-repeat;\n      }\n\n      &:focus {\n        border-color: $color;\n        box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      ~ .form-check-label {\n        color: $color;\n      }\n\n      ~ .#{$state}-feedback,\n      ~ .#{$state}-tooltip {\n        display: block;\n      }\n    }\n  }\n\n  .custom-control-input {\n    @include form-validation-state-selector($state) {\n      ~ .custom-control-label {\n        color: $color;\n\n        &::before {\n          border-color: $color;\n        }\n      }\n\n      &:checked {\n        ~ .custom-control-label::before {\n          border-color: lighten($color, 10%);\n          @include gradient-bg(lighten($color, 10%));\n        }\n      }\n\n      &:focus {\n        ~ .custom-control-label::before {\n          box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n        }\n\n        &:not(:checked) ~ .custom-control-label::before {\n          border-color: $color;\n        }\n      }\n    }\n  }\n\n  // custom file\n  .custom-file-input {\n    @include form-validation-state-selector($state) {\n      ~ .custom-file-label {\n        border-color: $color;\n      }\n\n      &:focus {\n        ~ .custom-file-label {\n          border-color: $color;\n          box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n        }\n      }\n    }\n  }\n}\n","// Gradients\n\n@mixin gradient-bg($color) {\n  @if $enable-gradients {\n    background: $color linear-gradient(180deg, mix($body-bg, $color, 15%), $color) repeat-x;\n  } @else {\n    background-color: $color;\n  }\n}\n\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n  background-repeat: repeat-x;\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n  background-repeat: repeat-x;\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n  background-repeat: repeat-x;\n}\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Base styles\n//\n\n.btn {\n  display: inline-block;\n  font-family: $btn-font-family;\n  font-weight: $btn-font-weight;\n  color: $body-color;\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  user-select: none;\n  background-color: transparent;\n  border: $btn-border-width solid transparent;\n  @include button-size($btn-padding-y, $btn-padding-x, $btn-font-size, $btn-line-height, $btn-border-radius);\n  @include transition($btn-transition);\n\n  @include hover() {\n    color: $body-color;\n    text-decoration: none;\n  }\n\n  &:focus,\n  &.focus {\n    outline: 0;\n    box-shadow: $btn-focus-box-shadow;\n  }\n\n  // Disabled comes first so active can properly restyle\n  &.disabled,\n  &:disabled {\n    opacity: $btn-disabled-opacity;\n    @include box-shadow(none);\n  }\n\n  &:not(:disabled):not(.disabled) {\n    cursor: if($enable-pointer-cursor-for-buttons, pointer, null);\n\n    &:active,\n    &.active {\n      @include box-shadow($btn-active-box-shadow);\n\n      &:focus {\n        @include box-shadow($btn-focus-box-shadow, $btn-active-box-shadow);\n      }\n    }\n  }\n}\n\n// Future-proof disabling of clicks on `<a>` elements\na.btn.disabled,\nfieldset:disabled a.btn {\n  pointer-events: none;\n}\n\n\n//\n// Alternate buttons\n//\n\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  font-weight: $font-weight-normal;\n  color: $link-color;\n  text-decoration: $link-decoration;\n\n  @include hover() {\n    color: $link-hover-color;\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus,\n  &.focus {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:disabled,\n  &.disabled {\n    color: $btn-link-disabled-color;\n    pointer-events: none;\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-line-height-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-line-height-sm, $btn-border-radius-sm);\n}\n\n\n//\n// Block button\n//\n\n.btn-block {\n  display: block;\n  width: 100%;\n\n  // Vertically space out multiple block buttons\n  + .btn-block {\n    margin-top: $btn-block-spacing-y;\n  }\n}\n\n// Specificity overrides\ninput[type=\"submit\"],\ninput[type=\"reset\"],\ninput[type=\"button\"] {\n  &.btn-block {\n    width: 100%;\n  }\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n@mixin button-variant($background, $border, $hover-background: darken($background, 7.5%), $hover-border: darken($border, 10%), $active-background: darken($background, 10%), $active-border: darken($border, 12.5%)) {\n  color: color-yiq($background);\n  @include gradient-bg($background);\n  border-color: $border;\n  @include box-shadow($btn-box-shadow);\n\n  @include hover() {\n    color: color-yiq($hover-background);\n    @include gradient-bg($hover-background);\n    border-color: $hover-border;\n  }\n\n  &:focus,\n  &.focus {\n    color: color-yiq($hover-background);\n    @include gradient-bg($hover-background);\n    border-color: $hover-border;\n    @if $enable-shadows {\n      @include box-shadow($btn-box-shadow, 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5));\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5);\n    }\n  }\n\n  // Disabled comes first so active can properly restyle\n  &.disabled,\n  &:disabled {\n    color: color-yiq($background);\n    background-color: $background;\n    border-color: $border;\n    // Remove CSS gradients if they're enabled\n    @if $enable-gradients {\n      background-image: none;\n    }\n  }\n\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: color-yiq($active-background);\n    background-color: $active-background;\n    @if $enable-gradients {\n      background-image: none; // Remove the gradient for the pressed/active state\n    }\n    border-color: $active-border;\n\n    &:focus {\n      @if $enable-shadows and $btn-active-box-shadow != none {\n        @include box-shadow($btn-active-box-shadow, 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5));\n      } @else {\n        // Avoid using mixin so we can pass custom focus shadow properly\n        box-shadow: 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5);\n      }\n    }\n  }\n}\n\n@mixin button-outline-variant($color, $color-hover: color-yiq($color), $active-background: $color, $active-border: $color) {\n  color: $color;\n  border-color: $color;\n\n  @include hover() {\n    color: $color-hover;\n    background-color: $active-background;\n    border-color: $active-border;\n  }\n\n  &:focus,\n  &.focus {\n    box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $color;\n    background-color: transparent;\n  }\n\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: color-yiq($active-background);\n    background-color: $active-background;\n    border-color: $active-border;\n\n    &:focus {\n      @if $enable-shadows and $btn-active-box-shadow != none {\n        @include box-shadow($btn-active-box-shadow, 0 0 0 $btn-focus-width rgba($color, .5));\n      } @else {\n        // Avoid using mixin so we can pass custom focus shadow properly\n        box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n      }\n    }\n  }\n}\n\n// Button sizes\n@mixin button-size($padding-y, $padding-x, $font-size, $line-height, $border-radius) {\n  padding: $padding-y $padding-x;\n  @include font-size($font-size);\n  line-height: $line-height;\n  // Manually declare to provide an override to the browser default\n  @include border-radius($border-radius, 0);\n}\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  position: relative;\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.width {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropright,\n.dropdown,\n.dropleft {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: $zindex-dropdown;\n  display: none; // none by default, but block on \"open\" of the menu\n  float: left;\n  min-width: $dropdown-min-width;\n  padding: $dropdown-padding-y $dropdown-padding-x;\n  margin: $dropdown-spacer 0 0; // override default ul\n  @include font-size($dropdown-font-size);\n  color: $dropdown-color;\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: $dropdown-bg;\n  background-clip: padding-box;\n  border: $dropdown-border-width solid $dropdown-border-color;\n  @include border-radius($dropdown-border-radius);\n  @include box-shadow($dropdown-box-shadow);\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-left {\n      right: auto;\n      left: 0;\n    }\n\n    .dropdown-menu#{$infix}-right {\n      right: 0;\n      left: auto;\n    }\n  }\n}\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropright {\n  .dropdown-menu {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(right);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropleft {\n  .dropdown-menu {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(left);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n// When Popper is enabled, reset the basic dropdown position\n// stylelint-disable-next-line no-duplicate-selectors\n.dropdown-menu {\n  &[x-placement^=\"top\"],\n  &[x-placement^=\"right\"],\n  &[x-placement^=\"bottom\"],\n  &[x-placement^=\"left\"] {\n    right: auto;\n    bottom: auto;\n  }\n}\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  @include nav-divider($dropdown-divider-bg, $dropdown-divider-margin-y, true);\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: $dropdown-link-color;\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n\n  // Prevent dropdown overflow if there's no padding\n  // See https://github.com/twbs/bootstrap/pull/27703\n  @if $dropdown-padding-y == 0 {\n    &:first-child {\n      @include border-top-radius($dropdown-inner-border-radius);\n    }\n\n    &:last-child {\n      @include border-bottom-radius($dropdown-inner-border-radius);\n    }\n  }\n\n  @include hover-focus() {\n    color: $dropdown-link-hover-color;\n    text-decoration: none;\n    @include gradient-bg($dropdown-link-hover-bg);\n  }\n\n  &.active,\n  &:active {\n    color: $dropdown-link-active-color;\n    text-decoration: none;\n    @include gradient-bg($dropdown-link-active-bg);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $dropdown-link-disabled-color;\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    @if $enable-gradients {\n      background-image: none;\n    }\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: $dropdown-header-padding;\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: $dropdown-header-color;\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n  color: $dropdown-link-color;\n}\n","@mixin caret-down() {\n  border-top: $caret-width solid;\n  border-right: $caret-width solid transparent;\n  border-bottom: 0;\n  border-left: $caret-width solid transparent;\n}\n\n@mixin caret-up() {\n  border-top: 0;\n  border-right: $caret-width solid transparent;\n  border-bottom: $caret-width solid;\n  border-left: $caret-width solid transparent;\n}\n\n@mixin caret-right() {\n  border-top: $caret-width solid transparent;\n  border-right: 0;\n  border-bottom: $caret-width solid transparent;\n  border-left: $caret-width solid;\n}\n\n@mixin caret-left() {\n  border-top: $caret-width solid transparent;\n  border-right: $caret-width solid;\n  border-bottom: $caret-width solid transparent;\n}\n\n@mixin caret($direction: down) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $caret-spacing;\n      vertical-align: $caret-vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down();\n      } @else if $direction == up {\n        @include caret-up();\n      } @else if $direction == right {\n        @include caret-right();\n      }\n    }\n\n    @if $direction == left {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $caret-spacing;\n        vertical-align: $caret-vertical-align;\n        content: \"\";\n        @include caret-left();\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n","// Horizontal dividers\n//\n// Dividers (basically an hr) within dropdowns and nav lists\n\n@mixin nav-divider($color: $nav-divider-color, $margin-y: $nav-divider-margin-y, $ignore-warning: false) {\n  height: 0;\n  margin: $margin-y 0;\n  overflow: hidden;\n  border-top: 1px solid $color;\n  @include deprecate(\"The `nav-divider()` mixin\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n","// stylelint-disable selector-no-qualifying-type\n\n// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n\n    // Bring the hover, focused, and \"active\" buttons to the front to overlay\n    // the borders properly\n    @include hover() {\n      z-index: 1;\n    }\n    &:focus,\n    &:active,\n    &.active {\n      z-index: 1;\n    }\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  // Prevent double borders when buttons are next to each other\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-left: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-right-radius(0);\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) > .btn {\n    @include border-left-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropright &::after {\n    margin-left: 0;\n  }\n\n  .dropleft &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n\n\n// Checkbox and radio options\n//\n// In order to support the browser's form validation feedback, powered by the\n// `required` attribute, we have to \"hide\" the inputs via `clip`. We cannot use\n// `display: none;` or `visibility: hidden;` as that also hides the popover.\n// Simply visually hiding the inputs via `opacity` would leave them clickable in\n// certain cases which is prevented by using `clip` and `pointer-events`.\n// This way, we ensure a DOM element is visible to position the popover from.\n//\n// See https://github.com/twbs/bootstrap/pull/12794 and\n// https://github.com/twbs/bootstrap/pull/14559 for more information.\n\n.btn-group-toggle {\n  > .btn,\n  > .btn-group > .btn {\n    margin-bottom: 0; // Override default `<label>` value\n\n    input[type=\"radio\"],\n    input[type=\"checkbox\"] {\n      position: absolute;\n      clip: rect(0, 0, 0, 0);\n      pointer-events: none;\n    }\n  }\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .custom-select,\n  > .custom-file {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n    margin-bottom: 0;\n\n    + .form-control,\n    + .custom-select,\n    + .custom-file {\n      margin-left: -$input-border-width;\n    }\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .custom-select:focus,\n  > .custom-file .custom-file-input:focus ~ .custom-file-label {\n    z-index: 3;\n  }\n\n  // Bring the custom file input above the label\n  > .custom-file .custom-file-input:focus {\n    z-index: 4;\n  }\n\n  > .form-control,\n  > .custom-select {\n    &:not(:first-child) { @include border-left-radius(0); }\n  }\n\n  // Custom file inputs have more complex markup, thus requiring different\n  // border-radius overrides.\n  > .custom-file {\n    display: flex;\n    align-items: center;\n\n    &:not(:last-child) .custom-file-label,\n    &:not(:last-child) .custom-file-label::after { @include border-right-radius(0); }\n    &:not(:first-child) .custom-file-label { @include border-left-radius(0); }\n  }\n\n  &:not(.has-validation) {\n    > .form-control:not(:last-child),\n    > .custom-select:not(:last-child),\n    > .custom-file:not(:last-child) .custom-file-label,\n    > .custom-file:not(:last-child) .custom-file-label::after {\n      @include border-right-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > .form-control:nth-last-child(n + 3),\n    > .custom-select:nth-last-child(n + 3),\n    > .custom-file:nth-last-child(n + 3) .custom-file-label,\n    > .custom-file:nth-last-child(n + 3) .custom-file-label::after {\n      @include border-right-radius(0);\n    }\n  }\n}\n\n\n// Prepend and append\n//\n// While it requires one extra layer of HTML for each, dedicated prepend and\n// append elements allow us to 1) be less clever, 2) simplify our selectors, and\n// 3) support HTML5 form validation.\n\n.input-group-prepend,\n.input-group-append {\n  display: flex;\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 3;\n    }\n  }\n\n  .btn + .btn,\n  .btn + .input-group-text,\n  .input-group-text + .input-group-text,\n  .input-group-text + .btn {\n    margin-left: -$input-border-width;\n  }\n}\n\n.input-group-prepend { margin-right: -$input-border-width; }\n.input-group-append { margin-left: -$input-border-width; }\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-padding-y $input-padding-x;\n  margin-bottom: 0; // Allow use of <label> elements by overriding our default margin-bottom\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $font-weight-normal;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n\n  // Nuke default margins from checkboxes and radios to vertically center within.\n  input[type=\"radio\"],\n  input[type=\"checkbox\"] {\n    margin-top: 0;\n  }\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control:not(textarea),\n.input-group-lg > .custom-select {\n  height: $input-height-lg;\n}\n\n.input-group-lg > .form-control,\n.input-group-lg > .custom-select,\n.input-group-lg > .input-group-prepend > .input-group-text,\n.input-group-lg > .input-group-append > .input-group-text,\n.input-group-lg > .input-group-prepend > .btn,\n.input-group-lg > .input-group-append > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control:not(textarea),\n.input-group-sm > .custom-select {\n  height: $input-height-sm;\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .custom-select,\n.input-group-sm > .input-group-prepend > .input-group-text,\n.input-group-sm > .input-group-append > .input-group-text,\n.input-group-sm > .input-group-prepend > .btn,\n.input-group-sm > .input-group-append > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .custom-select,\n.input-group-sm > .custom-select {\n  padding-right: $custom-select-padding-x + $custom-select-indicator-padding;\n}\n\n\n// Prepend and append rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n\n.input-group > .input-group-prepend > .btn,\n.input-group > .input-group-prepend > .input-group-text,\n.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .btn,\n.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .input-group-text,\n.input-group.has-validation > .input-group-append:nth-last-child(n + 3) > .btn,\n.input-group.has-validation > .input-group-append:nth-last-child(n + 3) > .input-group-text,\n.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),\n.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {\n  @include border-right-radius(0);\n}\n\n.input-group > .input-group-append > .btn,\n.input-group > .input-group-append > .input-group-text,\n.input-group > .input-group-prepend:not(:first-child) > .btn,\n.input-group > .input-group-prepend:not(:first-child) > .input-group-text,\n.input-group > .input-group-prepend:first-child > .btn:not(:first-child),\n.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {\n  @include border-left-radius(0);\n}\n","// Embedded icons from Open Iconic.\n// Released under MIT and copyright 2014 Waybury.\n// https://useiconic.com/open\n\n\n// Checkboxes and radios\n//\n// Base class takes care of all the key behavioral aspects.\n\n.custom-control {\n  position: relative;\n  z-index: 1;\n  display: block;\n  min-height: $font-size-base * $line-height-base;\n  padding-left: $custom-control-gutter + $custom-control-indicator-size;\n  print-color-adjust: exact; // Keep themed appearance for print\n}\n\n.custom-control-inline {\n  display: inline-flex;\n  margin-right: $custom-control-spacer-x;\n}\n\n.custom-control-input {\n  position: absolute;\n  left: 0;\n  z-index: -1; // Put the input behind the label so it doesn't overlay text\n  width: $custom-control-indicator-size;\n  height: ($font-size-base * $line-height-base + $custom-control-indicator-size) * .5;\n  opacity: 0;\n\n  &:checked ~ .custom-control-label::before {\n    color: $custom-control-indicator-checked-color;\n    border-color: $custom-control-indicator-checked-border-color;\n    @include gradient-bg($custom-control-indicator-checked-bg);\n    @include box-shadow($custom-control-indicator-checked-box-shadow);\n  }\n\n  &:focus ~ .custom-control-label::before {\n    // the mixin is not used here to make sure there is feedback\n    @if $enable-shadows {\n      box-shadow: $input-box-shadow, $custom-control-indicator-focus-box-shadow;\n    } @else {\n      box-shadow: $custom-control-indicator-focus-box-shadow;\n    }\n  }\n\n  &:focus:not(:checked) ~ .custom-control-label::before {\n    border-color: $custom-control-indicator-focus-border-color;\n  }\n\n  &:not(:disabled):active ~ .custom-control-label::before {\n    color: $custom-control-indicator-active-color;\n    background-color: $custom-control-indicator-active-bg;\n    border-color: $custom-control-indicator-active-border-color;\n    @include box-shadow($custom-control-indicator-active-box-shadow);\n  }\n\n  // Use [disabled] and :disabled to work around https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .custom-control-label {\n      color: $custom-control-label-disabled-color;\n\n      &::before {\n        background-color: $custom-control-indicator-disabled-bg;\n      }\n    }\n  }\n}\n\n// Custom control indicators\n//\n// Build the custom controls out of pseudo-elements.\n\n.custom-control-label {\n  position: relative;\n  margin-bottom: 0;\n  color: $custom-control-label-color;\n  vertical-align: top;\n  cursor: $custom-control-cursor;\n\n  // Background-color and (when enabled) gradient\n  &::before {\n    position: absolute;\n    top: ($font-size-base * $line-height-base - $custom-control-indicator-size) * .5;\n    left: -($custom-control-gutter + $custom-control-indicator-size);\n    display: block;\n    width: $custom-control-indicator-size;\n    height: $custom-control-indicator-size;\n    pointer-events: none;\n    content: \"\";\n    background-color: $custom-control-indicator-bg;\n    border: $custom-control-indicator-border-width solid $custom-control-indicator-border-color;\n    @include box-shadow($custom-control-indicator-box-shadow);\n  }\n\n  // Foreground (icon)\n  &::after {\n    position: absolute;\n    top: ($font-size-base * $line-height-base - $custom-control-indicator-size) * .5;\n    left: -($custom-control-gutter + $custom-control-indicator-size);\n    display: block;\n    width: $custom-control-indicator-size;\n    height: $custom-control-indicator-size;\n    content: \"\";\n    background: 50% / #{$custom-control-indicator-bg-size} no-repeat;\n  }\n}\n\n\n// Checkboxes\n//\n// Tweak just a few things for checkboxes.\n\n.custom-checkbox {\n  .custom-control-label::before {\n    @include border-radius($custom-checkbox-indicator-border-radius);\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-image: escape-svg($custom-checkbox-indicator-icon-checked);\n    }\n  }\n\n  .custom-control-input:indeterminate ~ .custom-control-label {\n    &::before {\n      border-color: $custom-checkbox-indicator-indeterminate-border-color;\n      @include gradient-bg($custom-checkbox-indicator-indeterminate-bg);\n      @include box-shadow($custom-checkbox-indicator-indeterminate-box-shadow);\n    }\n    &::after {\n      background-image: escape-svg($custom-checkbox-indicator-icon-indeterminate);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n    &:indeterminate ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n  }\n}\n\n// Radios\n//\n// Tweak just a few things for radios.\n\n.custom-radio {\n  .custom-control-label::before {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $custom-radio-indicator-border-radius;\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-image: escape-svg($custom-radio-indicator-icon-checked);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n  }\n}\n\n\n// switches\n//\n// Tweak a few things for switches\n\n.custom-switch {\n  padding-left: $custom-switch-width + $custom-control-gutter;\n\n  .custom-control-label {\n    &::before {\n      left: -($custom-switch-width + $custom-control-gutter);\n      width: $custom-switch-width;\n      pointer-events: all;\n      // stylelint-disable-next-line property-disallowed-list\n      border-radius: $custom-switch-indicator-border-radius;\n    }\n\n    &::after {\n      top: add(($font-size-base * $line-height-base - $custom-control-indicator-size) * .5, $custom-control-indicator-border-width * 2);\n      left: add(-($custom-switch-width + $custom-control-gutter), $custom-control-indicator-border-width * 2);\n      width: $custom-switch-indicator-size;\n      height: $custom-switch-indicator-size;\n      background-color: $custom-control-indicator-border-color;\n      // stylelint-disable-next-line property-disallowed-list\n      border-radius: $custom-switch-indicator-border-radius;\n      @include transition(transform .15s ease-in-out, $custom-forms-transition);\n    }\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-color: $custom-control-indicator-bg;\n      transform: translateX($custom-switch-width - $custom-control-indicator-size);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n  }\n}\n\n\n// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n//\n\n.custom-select {\n  display: inline-block;\n  width: 100%;\n  height: $custom-select-height;\n  padding: $custom-select-padding-y ($custom-select-padding-x + $custom-select-indicator-padding) $custom-select-padding-y $custom-select-padding-x;\n  font-family: $custom-select-font-family;\n  @include font-size($custom-select-font-size);\n  font-weight: $custom-select-font-weight;\n  line-height: $custom-select-line-height;\n  color: $custom-select-color;\n  vertical-align: middle;\n  background: $custom-select-bg $custom-select-background;\n  border: $custom-select-border-width solid $custom-select-border-color;\n  @include border-radius($custom-select-border-radius, 0);\n  @include box-shadow($custom-select-box-shadow);\n  appearance: none;\n\n  &:focus {\n    border-color: $custom-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($custom-select-box-shadow, $custom-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $custom-select-focus-box-shadow;\n    }\n\n    &::-ms-value {\n      // For visual consistency with other platforms/browsers,\n      // suppress the default white text on blue background highlight given to\n      // the selected option text when the (still closed) <select> receives focus\n      // in IE and (under certain conditions) Edge.\n      // See https://github.com/twbs/bootstrap/issues/19398.\n      color: $input-color;\n      background-color: $input-bg;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    height: auto;\n    padding-right: $custom-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $custom-select-disabled-color;\n    background-color: $custom-select-disabled-bg;\n  }\n\n  // Hides the default caret in IE11\n  &::-ms-expand {\n    display: none;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $custom-select-color;\n  }\n}\n\n.custom-select-sm {\n  height: $custom-select-height-sm;\n  padding-top: $custom-select-padding-y-sm;\n  padding-bottom: $custom-select-padding-y-sm;\n  padding-left: $custom-select-padding-x-sm;\n  @include font-size($custom-select-font-size-sm);\n}\n\n.custom-select-lg {\n  height: $custom-select-height-lg;\n  padding-top: $custom-select-padding-y-lg;\n  padding-bottom: $custom-select-padding-y-lg;\n  padding-left: $custom-select-padding-x-lg;\n  @include font-size($custom-select-font-size-lg);\n}\n\n\n// File\n//\n// Custom file input.\n\n.custom-file {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: $custom-file-height;\n  margin-bottom: 0;\n}\n\n.custom-file-input {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  height: $custom-file-height;\n  margin: 0;\n  overflow: hidden;\n  opacity: 0;\n\n  &:focus ~ .custom-file-label {\n    border-color: $custom-file-focus-border-color;\n    box-shadow: $custom-file-focus-box-shadow;\n  }\n\n  // Use [disabled] and :disabled to work around https://github.com/twbs/bootstrap/issues/28247\n  &[disabled] ~ .custom-file-label,\n  &:disabled ~ .custom-file-label {\n    background-color: $custom-file-disabled-bg;\n  }\n\n  @each $lang, $value in $custom-file-text {\n    &:lang(#{$lang}) ~ .custom-file-label::after {\n      content: $value;\n    }\n  }\n\n  ~ .custom-file-label[data-browse]::after {\n    content: attr(data-browse);\n  }\n}\n\n.custom-file-label {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1;\n  height: $custom-file-height;\n  padding: $custom-file-padding-y $custom-file-padding-x;\n  overflow: hidden;\n  font-family: $custom-file-font-family;\n  font-weight: $custom-file-font-weight;\n  line-height: $custom-file-line-height;\n  color: $custom-file-color;\n  background-color: $custom-file-bg;\n  border: $custom-file-border-width solid $custom-file-border-color;\n  @include border-radius($custom-file-border-radius);\n  @include box-shadow($custom-file-box-shadow);\n\n  &::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 3;\n    display: block;\n    height: $custom-file-height-inner;\n    padding: $custom-file-padding-y $custom-file-padding-x;\n    line-height: $custom-file-line-height;\n    color: $custom-file-button-color;\n    content: \"Browse\";\n    @include gradient-bg($custom-file-button-bg);\n    border-left: inherit;\n    @include border-radius(0 $custom-file-border-radius $custom-file-border-radius 0);\n  }\n}\n\n// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.custom-range {\n  width: 100%;\n  height: add($custom-range-thumb-height, $custom-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  background-color: transparent;\n  appearance: none;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $custom-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $custom-range-thumb-focus-box-shadow; }\n    &::-ms-thumb            { box-shadow: $custom-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    margin-top: ($custom-range-track-height - $custom-range-thumb-height) * .5; // Webkit specific\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent; // Why?\n    cursor: $custom-range-track-cursor;\n    background-color: $custom-range-track-bg;\n    border-color: transparent;\n    @include border-radius($custom-range-track-border-radius);\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent;\n    cursor: $custom-range-track-cursor;\n    background-color: $custom-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($custom-range-track-border-radius);\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-ms-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    margin-top: 0; // Edge specific\n    margin-right: $custom-range-thumb-focus-box-shadow-width; // Workaround that overflowed box-shadow is hidden.\n    margin-left: $custom-range-thumb-focus-box-shadow-width;  // Workaround that overflowed box-shadow is hidden.\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-ms-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent;\n    cursor: $custom-range-track-cursor;\n    background-color: transparent;\n    border-color: transparent;\n    border-width: $custom-range-thumb-height * .5;\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-ms-fill-lower {\n    background-color: $custom-range-track-bg;\n    @include border-radius($custom-range-track-border-radius);\n  }\n\n  &::-ms-fill-upper {\n    margin-right: 15px; // arbitrary?\n    background-color: $custom-range-track-bg;\n    @include border-radius($custom-range-track-border-radius);\n  }\n\n  &:disabled {\n    &::-webkit-slider-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n\n    &::-webkit-slider-runnable-track {\n      cursor: default;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-track {\n      cursor: default;\n    }\n\n    &::-ms-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n  }\n}\n\n.custom-control-label::before,\n.custom-file-label,\n.custom-select {\n  @include transition($custom-forms-transition);\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: $nav-link-padding-y $nav-link-padding-x;\n  text-decoration: if($link-decoration == none, null, none);\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n\n  // Disabled state lightens text\n  &.disabled {\n    color: $nav-link-disabled-color;\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  border-bottom: $nav-tabs-border-width solid $nav-tabs-border-color;\n\n  .nav-link {\n    margin-bottom: -$nav-tabs-border-width;\n    background-color: transparent;\n    border: $nav-tabs-border-width solid transparent;\n    @include border-top-radius($nav-tabs-border-radius);\n\n    @include hover-focus() {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: $nav-tabs-link-hover-border-color;\n    }\n\n    &.disabled {\n      color: $nav-link-disabled-color;\n      background-color: transparent;\n      border-color: transparent;\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: $nav-tabs-link-active-color;\n    background-color: $nav-tabs-link-active-bg;\n    border-color: $nav-tabs-link-active-border-color;\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: -$nav-tabs-border-width;\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  .nav-link {\n    background: none;\n    border: 0;\n    @include border-radius($nav-pills-border-radius);\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: $nav-pills-link-active-color;\n    background-color: $nav-pills-link-active-bg;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Contents\n//\n// Navbar\n// Navbar brand\n// Navbar nav\n// Navbar text\n// Navbar divider\n// Responsive navbar\n// Navbar position\n// Navbar themes\n\n\n// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: $navbar-padding-y $navbar-padding-x;\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .container,\n  .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  display: inline-block;\n  padding-top: $navbar-brand-padding-y;\n  padding-bottom: $navbar-brand-padding-y;\n  margin-right: $navbar-padding-x;\n  @include font-size($navbar-brand-font-size);\n  line-height: inherit;\n  white-space: nowrap;\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n  }\n\n  .dropdown-menu {\n    position: static;\n    float: none;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  display: inline-block;\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: $navbar-toggler-padding-y $navbar-toggler-padding-x;\n  @include font-size($navbar-toggler-font-size);\n  line-height: 1;\n  background-color: transparent; // remove default button style\n  border: $border-width solid transparent; // remove default button style\n  @include border-radius($navbar-toggler-border-radius);\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  content: \"\";\n  background: 50% / 100% 100% no-repeat;\n}\n\n.navbar-nav-scroll {\n  max-height: $navbar-nav-scroll-max-height;\n  overflow-y: auto;\n}\n\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    &#{$infix} {\n      @include media-breakpoint-down($breakpoint) {\n        %container-navbar-expand-#{$breakpoint} {\n          padding-right: 0;\n          padding-left: 0;\n        }\n\n        > .container,\n        > .container-fluid {\n          @extend %container-navbar-expand-#{$breakpoint};\n        }\n\n        @each $size, $container-max-width in $container-max-widths {\n          > .container#{breakpoint-infix($size, $container-max-widths)} {\n            @extend %container-navbar-expand-#{$breakpoint};\n          }\n        }\n      }\n\n      @include media-breakpoint-up($next) {\n        flex-flow: row nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: $navbar-nav-link-padding-x;\n            padding-left: $navbar-nav-link-padding-x;\n          }\n        }\n\n        // For nesting containers, have to redeclare for alignment purposes\n        %container-nesting-#{$breakpoint} {\n          flex-wrap: nowrap;\n        }\n\n        > .container,\n        > .container-fluid {\n          @extend %container-nesting-#{$breakpoint};\n        }\n\n        @each $size, $container-max-width in $container-max-widths {\n          > .container#{breakpoint-infix($size, $container-max-widths)} {\n            @extend %container-nesting-#{$breakpoint};\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n\n          // Changes flex-bases to auto because of an IE10 bug\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n      }\n    }\n  }\n}\n\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n// Dark links against a light background\n.navbar-light {\n  .navbar-brand {\n    color: $navbar-light-brand-color;\n\n    @include hover-focus() {\n      color: $navbar-light-brand-hover-color;\n    }\n  }\n\n  .navbar-nav {\n    .nav-link {\n      color: $navbar-light-color;\n\n      @include hover-focus() {\n        color: $navbar-light-hover-color;\n      }\n\n      &.disabled {\n        color: $navbar-light-disabled-color;\n      }\n    }\n\n    .show > .nav-link,\n    .active > .nav-link,\n    .nav-link.show,\n    .nav-link.active {\n      color: $navbar-light-active-color;\n    }\n  }\n\n  .navbar-toggler {\n    color: $navbar-light-color;\n    border-color: $navbar-light-toggler-border-color;\n  }\n\n  .navbar-toggler-icon {\n    background-image: escape-svg($navbar-light-toggler-icon-bg);\n  }\n\n  .navbar-text {\n    color: $navbar-light-color;\n    a {\n      color: $navbar-light-active-color;\n\n      @include hover-focus() {\n        color: $navbar-light-active-color;\n      }\n    }\n  }\n}\n\n// White links against a dark background\n.navbar-dark {\n  .navbar-brand {\n    color: $navbar-dark-brand-color;\n\n    @include hover-focus() {\n      color: $navbar-dark-brand-hover-color;\n    }\n  }\n\n  .navbar-nav {\n    .nav-link {\n      color: $navbar-dark-color;\n\n      @include hover-focus() {\n        color: $navbar-dark-hover-color;\n      }\n\n      &.disabled {\n        color: $navbar-dark-disabled-color;\n      }\n    }\n\n    .show > .nav-link,\n    .active > .nav-link,\n    .nav-link.show,\n    .nav-link.active {\n      color: $navbar-dark-active-color;\n    }\n  }\n\n  .navbar-toggler {\n    color: $navbar-dark-color;\n    border-color: $navbar-dark-toggler-border-color;\n  }\n\n  .navbar-toggler-icon {\n    background-image: escape-svg($navbar-dark-toggler-icon-bg);\n  }\n\n  .navbar-text {\n    color: $navbar-dark-color;\n    a {\n      color: $navbar-dark-active-color;\n\n      @include hover-focus() {\n        color: $navbar-dark-active-color;\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: $card-height;\n  word-wrap: break-word;\n  background-color: $card-bg;\n  background-clip: border-box;\n  border: $card-border-width solid $card-border-color;\n  @include border-radius($card-border-radius);\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius($card-inner-border-radius);\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius($card-inner-border-radius);\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  // Workaround for the image size bug in IE\n  // See: https://github.com/twbs/bootstrap/pull/28855\n  min-height: 1px;\n  padding: $card-spacer-x;\n  color: $card-color;\n}\n\n.card-title {\n  margin-bottom: $card-spacer-y;\n}\n\n.card-subtitle {\n  margin-top: -$card-spacer-y * .5;\n  margin-bottom: 0;\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  @include hover() {\n    text-decoration: none;\n  }\n\n  + .card-link {\n    margin-left: $card-spacer-x;\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: $card-spacer-y $card-spacer-x;\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: $card-cap-color;\n  background-color: $card-cap-bg;\n  border-bottom: $card-border-width solid $card-border-color;\n\n  &:first-child {\n    @include border-radius($card-inner-border-radius $card-inner-border-radius 0 0);\n  }\n}\n\n.card-footer {\n  padding: $card-spacer-y $card-spacer-x;\n  color: $card-cap-color;\n  background-color: $card-cap-bg;\n  border-top: $card-border-width solid $card-border-color;\n\n  &:last-child {\n    @include border-radius(0 0 $card-inner-border-radius $card-inner-border-radius);\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: -$card-spacer-x * .5;\n  margin-bottom: -$card-spacer-y;\n  margin-left: -$card-spacer-x * .5;\n  border-bottom: 0;\n}\n\n.card-header-pills {\n  margin-right: -$card-spacer-x * .5;\n  margin-left: -$card-spacer-x * .5;\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: $card-img-overlay-padding;\n  @include border-radius($card-inner-border-radius);\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  flex-shrink: 0; // For IE: https://github.com/twbs/bootstrap/issues/29396\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius($card-inner-border-radius);\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius($card-inner-border-radius);\n}\n\n\n// Card deck\n\n.card-deck {\n  .card {\n    margin-bottom: $card-deck-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    margin-right: -$card-deck-margin;\n    margin-left: -$card-deck-margin;\n\n    .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-right: $card-deck-margin;\n      margin-bottom: 0; // Override the default\n      margin-left: $card-deck-margin;\n    }\n  }\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: $card-group-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-right-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-left-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n//\n// Columns\n//\n\n.card-columns {\n  .card {\n    margin-bottom: $card-columns-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    column-count: $card-columns-count;\n    column-gap: $card-columns-gap;\n    orphans: 1;\n    widows: 1;\n\n    .card {\n      display: inline-block; // Don't let them vertically span multiple columns\n      width: 100%; // Don't let their width change\n    }\n  }\n}\n\n\n//\n// Accordion\n//\n\n.accordion {\n  overflow-anchor: none;\n\n  > .card {\n    overflow: hidden;\n\n    &:not(:last-of-type) {\n      border-bottom: 0;\n      @include border-bottom-radius(0);\n    }\n\n    &:not(:first-of-type) {\n      @include border-top-radius(0);\n    }\n\n    > .card-header {\n      @include border-radius(0);\n      margin-bottom: -$card-border-width;\n    }\n  }\n}\n",".breadcrumb {\n  display: flex;\n  flex-wrap: wrap;\n  padding: $breadcrumb-padding-y $breadcrumb-padding-x;\n  margin-bottom: $breadcrumb-margin-bottom;\n  @include font-size($breadcrumb-font-size);\n  list-style: none;\n  background-color: $breadcrumb-bg;\n  @include border-radius($breadcrumb-border-radius);\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: $breadcrumb-item-padding;\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: $breadcrumb-item-padding;\n      color: $breadcrumb-divider-color;\n      content: escape-svg($breadcrumb-divider);\n    }\n  }\n\n  // IE9-11 hack to properly handle hyperlink underlines for breadcrumbs built\n  // without `<ul>`s. The `::before` pseudo-element generates an element\n  // *within* the .breadcrumb-item and thereby inherits the `text-decoration`.\n  //\n  // To trick IE into suppressing the underline, we give the pseudo-element an\n  // underline and then immediately remove it.\n  + .breadcrumb-item:hover::before {\n    text-decoration: underline;\n  }\n  // stylelint-disable-next-line no-duplicate-selectors\n  + .breadcrumb-item:hover::before {\n    text-decoration: none;\n  }\n\n  &.active {\n    color: $breadcrumb-active-color;\n  }\n}\n",".pagination {\n  display: flex;\n  @include list-unstyled();\n  @include border-radius();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: $pagination-padding-y $pagination-padding-x;\n  margin-left: -$pagination-border-width;\n  line-height: $pagination-line-height;\n  color: $pagination-color;\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: $pagination-bg;\n  border: $pagination-border-width solid $pagination-border-color;\n\n  &:hover {\n    z-index: 2;\n    color: $pagination-hover-color;\n    text-decoration: none;\n    background-color: $pagination-hover-bg;\n    border-color: $pagination-hover-border-color;\n  }\n\n  &:focus {\n    z-index: 3;\n    outline: $pagination-focus-outline;\n    box-shadow: $pagination-focus-box-shadow;\n  }\n}\n\n.page-item {\n  &:first-child {\n    .page-link {\n      margin-left: 0;\n      @include border-left-radius($border-radius);\n    }\n  }\n  &:last-child {\n    .page-link {\n      @include border-right-radius($border-radius);\n    }\n  }\n\n  &.active .page-link {\n    z-index: 3;\n    color: $pagination-active-color;\n    background-color: $pagination-active-bg;\n    border-color: $pagination-active-border-color;\n  }\n\n  &.disabled .page-link {\n    color: $pagination-disabled-color;\n    pointer-events: none;\n    // Opinionated: remove the \"hand\" cursor set previously for .page-link\n    cursor: auto;\n    background-color: $pagination-disabled-bg;\n    border-color: $pagination-disabled-border-color;\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $line-height-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $line-height-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n@mixin pagination-size($padding-y, $padding-x, $font-size, $line-height, $border-radius) {\n  .page-link {\n    padding: $padding-y $padding-x;\n    @include font-size($font-size);\n    line-height: $line-height;\n  }\n\n  .page-item {\n    &:first-child {\n      .page-link {\n        @include border-left-radius($border-radius);\n      }\n    }\n    &:last-child {\n      .page-link {\n        @include border-right-radius($border-radius);\n      }\n    }\n  }\n}\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  display: inline-block;\n  padding: $badge-padding-y $badge-padding-x;\n  @include font-size($badge-font-size);\n  font-weight: $badge-font-weight;\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius($badge-border-radius);\n  @include transition($badge-transition);\n\n  @at-root a#{&} {\n    @include hover-focus() {\n      text-decoration: none;\n    }\n  }\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n// Pill badges\n//\n// Make them extra rounded with a modifier to replace v3's badges.\n\n.badge-pill {\n  padding-right: $badge-pill-padding-x;\n  padding-left: $badge-pill-padding-x;\n  @include border-radius($badge-pill-border-radius);\n}\n\n// Colors\n//\n// Contextual variations (linked badges get darker on :hover).\n\n@each $color, $value in $theme-colors {\n  .badge-#{$color} {\n    @include badge-variant($value);\n  }\n}\n","@mixin badge-variant($bg) {\n  color: color-yiq($bg);\n  background-color: $bg;\n\n  @at-root a#{&} {\n    @include hover-focus() {\n      color: color-yiq($bg);\n      background-color: darken($bg, 10%);\n    }\n\n    &:focus,\n    &.focus {\n      outline: 0;\n      box-shadow: 0 0 0 $badge-focus-width rgba($bg, .5);\n    }\n  }\n}\n",".jumbotron {\n  padding: $jumbotron-padding ($jumbotron-padding * .5);\n  margin-bottom: $jumbotron-padding;\n  color: $jumbotron-color;\n  background-color: $jumbotron-bg;\n  @include border-radius($border-radius-lg);\n\n  @include media-breakpoint-up(sm) {\n    padding: ($jumbotron-padding * 2) $jumbotron-padding;\n  }\n}\n\n.jumbotron-fluid {\n  padding-right: 0;\n  padding-left: 0;\n  @include border-radius(0);\n}\n","//\n// Base styles\n//\n\n.alert {\n  position: relative;\n  padding: $alert-padding-y $alert-padding-x;\n  margin-bottom: $alert-margin-bottom;\n  border: $alert-border-width solid transparent;\n  @include border-radius($alert-border-radius);\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $close-font-size + $alert-padding-x * 2;\n\n  // Adjust close link position\n  .close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: 2;\n    padding: $alert-padding-y $alert-padding-x;\n    color: inherit;\n  }\n}\n\n\n// Alternate styles\n//\n// Generate contextual modifier classes for colorizing the alert.\n\n@each $color, $value in $theme-colors {\n  .alert-#{$color} {\n    @include alert-variant(theme-color-level($color, $alert-bg-level), theme-color-level($color, $alert-border-level), theme-color-level($color, $alert-color-level));\n  }\n}\n","@mixin alert-variant($background, $border, $color) {\n  color: $color;\n  @include gradient-bg($background);\n  border-color: $border;\n\n  hr {\n    border-top-color: darken($border, 5%);\n  }\n\n  .alert-link {\n    color: darken($color, 10%);\n  }\n}\n","// Disable animation if transitions are disabled\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    from { background-position: $progress-height 0; }\n    to { background-position: 0 0; }\n  }\n}\n\n.progress {\n  display: flex;\n  height: $progress-height;\n  overflow: hidden; // force rounded corners by cropping it\n  line-height: 0;\n  @include font-size($progress-font-size);\n  background-color: $progress-bg;\n  @include border-radius($progress-border-radius);\n  @include box-shadow($progress-box-shadow);\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: $progress-bar-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $progress-bar-bg;\n  @include transition($progress-bar-transition);\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: $progress-height $progress-height;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-prefers-reduced-motion-media-query {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n",".media {\n  display: flex;\n  align-items: flex-start;\n}\n\n.media-body {\n  flex: 1;\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius($list-group-border-radius);\n}\n\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: $list-group-action-color;\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  @include hover-focus() {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: $list-group-action-hover-color;\n    text-decoration: none;\n    background-color: $list-group-hover-bg;\n  }\n\n  &:active {\n    color: $list-group-action-active-color;\n    background-color: $list-group-action-active-bg;\n  }\n}\n\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: $list-group-item-padding-y $list-group-item-padding-x;\n  color: $list-group-color;\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: $list-group-bg;\n  border: $list-group-border-width solid $list-group-border-color;\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $list-group-disabled-color;\n    pointer-events: none;\n    background-color: $list-group-disabled-bg;\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: $list-group-active-color;\n    background-color: $list-group-active-bg;\n    border-color: $list-group-active-border-color;\n  }\n\n  & + & {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: -$list-group-border-width;\n      border-top-width: $list-group-border-width;\n    }\n  }\n}\n\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child {\n          @include border-bottom-left-radius($list-group-border-radius);\n          @include border-top-right-radius(0);\n        }\n\n        &:last-child {\n          @include border-top-right-radius($list-group-border-radius);\n          @include border-bottom-left-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: $list-group-border-width;\n          border-left-width: 0;\n\n          &.active {\n            margin-left: -$list-group-border-width;\n            border-left-width: $list-group-border-width;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 $list-group-border-width;\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// Contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $color, $value in $theme-colors {\n  @include list-group-item-variant($color, theme-color-level($color, -9), theme-color-level($color, 6));\n}\n","// List Groups\n\n@mixin list-group-item-variant($state, $background, $color) {\n  .list-group-item-#{$state} {\n    color: $color;\n    background-color: $background;\n\n    &.list-group-item-action {\n      @include hover-focus() {\n        color: $color;\n        background-color: darken($background, 5%);\n      }\n\n      &.active {\n        color: $white;\n        background-color: $color;\n        border-color: $color;\n      }\n    }\n  }\n}\n",".close {\n  float: right;\n  @include font-size($close-font-size);\n  font-weight: $close-font-weight;\n  line-height: 1;\n  color: $close-color;\n  text-shadow: $close-text-shadow;\n  opacity: .5;\n\n  // Override <a>'s hover style\n  @include hover() {\n    color: $close-color;\n    text-decoration: none;\n  }\n\n  &:not(:disabled):not(.disabled) {\n    @include hover-focus() {\n      opacity: .75;\n    }\n  }\n}\n\n// Additional properties for button version\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n// stylelint-disable-next-line selector-no-qualifying-type\nbutton.close {\n  padding: 0;\n  background-color: transparent;\n  border: 0;\n}\n\n// Future-proof disabling of clicks on `<a>` elements\n\n// stylelint-disable-next-line selector-no-qualifying-type\na.close.disabled {\n  pointer-events: none;\n}\n",".toast {\n  // Prevents from shrinking in IE11, when in a flex container\n  // See https://github.com/twbs/bootstrap/issues/28341\n  flex-basis: $toast-max-width;\n  max-width: $toast-max-width;\n  @include font-size($toast-font-size);\n  color: $toast-color;\n  background-color: $toast-background-color;\n  background-clip: padding-box;\n  border: $toast-border-width solid $toast-border-color;\n  box-shadow: $toast-box-shadow;\n  opacity: 0;\n  @include border-radius($toast-border-radius);\n\n  &:not(:last-child) {\n    margin-bottom: $toast-padding-x;\n  }\n\n  &.showing {\n    opacity: 1;\n  }\n\n  &.show {\n    display: block;\n    opacity: 1;\n  }\n\n  &.hide {\n    display: none;\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: $toast-padding-y $toast-padding-x;\n  color: $toast-header-color;\n  background-color: $toast-header-background-color;\n  background-clip: padding-box;\n  border-bottom: $toast-border-width solid $toast-header-border-color;\n  @include border-top-radius(subtract($toast-border-radius, $toast-border-width));\n}\n\n.toast-body {\n  padding: $toast-padding-x; // apply to both vertical and horizontal\n}\n","// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n.modal-open {\n  // Kill the scroll on the body\n  overflow: hidden;\n\n  .modal {\n    overflow-x: hidden;\n    overflow-y: auto;\n  }\n}\n\n// Container that the modal scrolls within\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex-modal;\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: $modal-dialog-margin;\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  display: flex; // IE10/11\n  max-height: subtract(100%, $modal-dialog-margin * 2);\n\n  .modal-content {\n    max-height: subtract(100vh, $modal-dialog-margin * 2); // IE10/11\n    overflow: hidden;\n  }\n\n  .modal-header,\n  .modal-footer {\n    flex-shrink: 0;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: subtract(100%, $modal-dialog-margin * 2);\n\n  // Ensure `modal-dialog-centered` extends the full height of the view (IE10/11)\n  &::before {\n    display: block; // IE10\n    height: subtract(100vh, $modal-dialog-margin * 2);\n    height: min-content; // Reset height to 0 except on IE\n    content: \"\";\n  }\n\n  // Ensure `.modal-body` shows scrollbar (IE10/11)\n  &.modal-dialog-scrollable {\n    flex-direction: column;\n    justify-content: center;\n    height: 100%;\n\n    .modal-content {\n      max-height: none;\n    }\n\n    &::before {\n      content: none;\n    }\n  }\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: $modal-content-color;\n  pointer-events: auto;\n  background-color: $modal-content-bg;\n  background-clip: padding-box;\n  border: $modal-content-border-width solid $modal-content-border-color;\n  @include border-radius($modal-content-border-radius);\n  @include box-shadow($modal-content-box-shadow-xs);\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex-modal-backdrop;\n  width: 100vw;\n  height: 100vh;\n  background-color: $modal-backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $modal-backdrop-opacity; }\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  align-items: flex-start; // so the close btn always stays on the upper right corner\n  justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends\n  padding: $modal-header-padding;\n  border-bottom: $modal-header-border-width solid $modal-header-border-color;\n  @include border-top-radius($modal-content-inner-border-radius);\n\n  .close {\n    padding: $modal-header-padding;\n    // auto on the left force icon to the right even when there is no .modal-title\n    margin: (-$modal-header-padding-y) (-$modal-header-padding-x) (-$modal-header-padding-y) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: $modal-title-line-height;\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: $modal-inner-padding;\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: $modal-inner-padding - $modal-footer-margin-between * .5;\n  border-top: $modal-footer-border-width solid $modal-footer-border-color;\n  @include border-bottom-radius($modal-content-inner-border-radius);\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: $modal-footer-margin-between * .5;\n  }\n}\n\n// Measure scrollbar width for padding body during modal show/hide\n.modal-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll;\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: $modal-md;\n    margin: $modal-dialog-margin-y-sm-up auto;\n  }\n\n  .modal-dialog-scrollable {\n    max-height: subtract(100%, $modal-dialog-margin-y-sm-up * 2);\n\n    .modal-content {\n      max-height: subtract(100vh, $modal-dialog-margin-y-sm-up * 2);\n    }\n  }\n\n  .modal-dialog-centered {\n    min-height: subtract(100%, $modal-dialog-margin-y-sm-up * 2);\n\n    &::before {\n      height: subtract(100vh, $modal-dialog-margin-y-sm-up * 2);\n      height: min-content;\n    }\n  }\n\n  .modal-content {\n    @include box-shadow($modal-content-box-shadow-sm-up);\n  }\n\n  .modal-sm { max-width: $modal-sm; }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    max-width: $modal-lg;\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl { max-width: $modal-xl; }\n}\n","// Base class\n.tooltip {\n  position: absolute;\n  z-index: $zindex-tooltip;\n  display: block;\n  margin: $tooltip-margin;\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size($tooltip-font-size);\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: $tooltip-opacity; }\n\n  .arrow {\n    position: absolute;\n    display: block;\n    width: $tooltip-arrow-width;\n    height: $tooltip-arrow-height;\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top {\n  padding: $tooltip-arrow-height 0;\n\n  .arrow {\n    bottom: 0;\n\n    &::before {\n      top: 0;\n      border-width: $tooltip-arrow-height ($tooltip-arrow-width * .5) 0;\n      border-top-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-right {\n  padding: 0 $tooltip-arrow-height;\n\n  .arrow {\n    left: 0;\n    width: $tooltip-arrow-height;\n    height: $tooltip-arrow-width;\n\n    &::before {\n      right: 0;\n      border-width: ($tooltip-arrow-width * .5) $tooltip-arrow-height ($tooltip-arrow-width * .5) 0;\n      border-right-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-bottom {\n  padding: $tooltip-arrow-height 0;\n\n  .arrow {\n    top: 0;\n\n    &::before {\n      bottom: 0;\n      border-width: 0 ($tooltip-arrow-width * .5) $tooltip-arrow-height;\n      border-bottom-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-left {\n  padding: 0 $tooltip-arrow-height;\n\n  .arrow {\n    right: 0;\n    width: $tooltip-arrow-height;\n    height: $tooltip-arrow-width;\n\n    &::before {\n      left: 0;\n      border-width: ($tooltip-arrow-width * .5) 0 ($tooltip-arrow-width * .5) $tooltip-arrow-height;\n      border-left-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-auto {\n  &[x-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[x-placement^=\"right\"] {\n    @extend .bs-tooltip-right;\n  }\n  &[x-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[x-placement^=\"left\"] {\n    @extend .bs-tooltip-left;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: $tooltip-max-width;\n  padding: $tooltip-padding-y $tooltip-padding-x;\n  color: $tooltip-color;\n  text-align: center;\n  background-color: $tooltip-bg;\n  @include border-radius($tooltip-border-radius);\n}\n","@mixin reset-text() {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: $zindex-popover;\n  display: block;\n  max-width: $popover-max-width;\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size($popover-font-size);\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: $popover-bg;\n  background-clip: padding-box;\n  border: $popover-border-width solid $popover-border-color;\n  @include border-radius($popover-border-radius);\n  @include box-shadow($popover-box-shadow);\n\n  .arrow {\n    position: absolute;\n    display: block;\n    width: $popover-arrow-width;\n    height: $popover-arrow-height;\n    margin: 0 $popover-border-radius;\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-popover-top {\n  margin-bottom: $popover-arrow-height;\n\n  > .arrow {\n    bottom: subtract(-$popover-arrow-height, $popover-border-width);\n\n    &::before {\n      bottom: 0;\n      border-width: $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-top-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      bottom: $popover-border-width;\n      border-width: $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-top-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-right {\n  margin-left: $popover-arrow-height;\n\n  > .arrow {\n    left: subtract(-$popover-arrow-height, $popover-border-width);\n    width: $popover-arrow-height;\n    height: $popover-arrow-width;\n    margin: $popover-border-radius 0; // make sure the arrow does not touch the popover's rounded corners\n\n    &::before {\n      left: 0;\n      border-width: ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-right-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      left: $popover-border-width;\n      border-width: ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-right-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-bottom {\n  margin-top: $popover-arrow-height;\n\n  > .arrow {\n    top: subtract(-$popover-arrow-height, $popover-border-width);\n\n    &::before {\n      top: 0;\n      border-width: 0 ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5);\n      border-bottom-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      top: $popover-border-width;\n      border-width: 0 ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5);\n      border-bottom-color: $popover-arrow-color;\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: $popover-arrow-width;\n    margin-left: -$popover-arrow-width * .5;\n    content: \"\";\n    border-bottom: $popover-border-width solid $popover-header-bg;\n  }\n}\n\n.bs-popover-left {\n  margin-right: $popover-arrow-height;\n\n  > .arrow {\n    right: subtract(-$popover-arrow-height, $popover-border-width);\n    width: $popover-arrow-height;\n    height: $popover-arrow-width;\n    margin: $popover-border-radius 0; // make sure the arrow does not touch the popover's rounded corners\n\n    &::before {\n      right: 0;\n      border-width: ($popover-arrow-width * .5) 0 ($popover-arrow-width * .5) $popover-arrow-height;\n      border-left-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      right: $popover-border-width;\n      border-width: ($popover-arrow-width * .5) 0 ($popover-arrow-width * .5) $popover-arrow-height;\n      border-left-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-auto {\n  &[x-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[x-placement^=\"right\"] {\n    @extend .bs-popover-right;\n  }\n  &[x-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[x-placement^=\"left\"] {\n    @extend .bs-popover-left;\n  }\n}\n\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: $popover-header-padding-y $popover-header-padding-x;\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size($font-size-base);\n  color: $popover-header-color;\n  background-color: $popover-header-bg;\n  border-bottom: $popover-border-width solid darken($popover-header-bg, 5%);\n  @include border-top-radius($popover-inner-border-radius);\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: $popover-body-padding-y $popover-body-padding-x;\n  color: $popover-body-color;\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-left and .carousel-item-right is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-left and .active.carousel-item-right is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-left and .carousel-item-prev.carousel-item-right\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-left),\n.active.carousel-item-right {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-right),\n.active.carousel-item-left {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-left,\n  .carousel-item-prev.carousel-item-right {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-left,\n  .active.carousel-item-right {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  @include hover-focus() {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  @if $enable-gradients {\n    background-image: linear-gradient(90deg, rgba($black, .25), rgba($black, .001));\n  }\n}\n.carousel-control-next {\n  right: 0;\n  @if $enable-gradients {\n    background-image: linear-gradient(270deg, rgba($black, .25), rgba($black, .001));\n  }\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background: 50% / 100% 100% no-repeat;\n}\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg);\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg);\n}\n\n\n// Optional indicator pips\n//\n// Add an ordered list with the following class and add a list item for each\n// slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 15;\n  display: flex;\n  justify-content: center;\n  padding-left: 0; // override <ol> default\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-left: $carousel-control-width;\n  list-style: none;\n\n  li {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: .5;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: 1;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: 20px;\n  left: (100% - $carousel-caption-width) * .5;\n  z-index: 10;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n","@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n","//\n// Rotating border\n//\n\n@keyframes spinner-border {\n  to { transform: rotate(360deg); }\n}\n\n.spinner-border {\n  display: inline-block;\n  width: $spinner-width;\n  height: $spinner-height;\n  vertical-align: $spinner-vertical-align;\n  border: $spinner-border-width solid currentcolor;\n  border-right-color: transparent;\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: .75s linear infinite spinner-border;\n}\n\n.spinner-border-sm {\n  width: $spinner-width-sm;\n  height: $spinner-height-sm;\n  border-width: $spinner-border-width-sm;\n}\n\n//\n// Growing circle\n//\n\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n.spinner-grow {\n  display: inline-block;\n  width: $spinner-width;\n  height: $spinner-height;\n  vertical-align: $spinner-vertical-align;\n  background-color: currentcolor;\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  opacity: 0;\n  animation: .75s linear infinite spinner-grow;\n}\n\n.spinner-grow-sm {\n  width: $spinner-width-sm;\n  height: $spinner-height-sm;\n}\n\n@if $enable-prefers-reduced-motion-media-query {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      animation-duration: 1.5s;\n    }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n.align-baseline    { vertical-align: baseline !important; } // Browser default\n.align-top         { vertical-align: top !important; }\n.align-middle      { vertical-align: middle !important; }\n.align-bottom      { vertical-align: bottom !important; }\n.align-text-bottom { vertical-align: text-bottom !important; }\n.align-text-top    { vertical-align: text-top !important; }\n","// stylelint-disable declaration-no-important\n\n// Contextual backgrounds\n\n@mixin bg-variant($parent, $color, $ignore-warning: false) {\n  #{$parent} {\n    background-color: $color !important;\n  }\n  a#{$parent},\n  button#{$parent} {\n    @include hover-focus() {\n      background-color: darken($color, 10%) !important;\n    }\n  }\n  @include deprecate(\"The `bg-variant` mixin\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n\n@mixin bg-gradient-variant($parent, $color, $ignore-warning: false) {\n  #{$parent} {\n    background: $color linear-gradient(180deg, mix($body-bg, $color, 15%), $color) repeat-x !important;\n  }\n  @include deprecate(\"The `bg-gradient-variant` mixin\", \"v4.5.0\", \"v5\", $ignore-warning);\n}\n","// stylelint-disable declaration-no-important\n\n@each $color, $value in $theme-colors {\n  @include bg-variant(\".bg-#{$color}\", $value, true);\n}\n\n@if $enable-gradients {\n  @each $color, $value in $theme-colors {\n    @include bg-gradient-variant(\".bg-gradient-#{$color}\", $value, true);\n  }\n}\n\n.bg-white {\n  background-color: $white !important;\n}\n\n.bg-transparent {\n  background-color: transparent !important;\n}\n","// stylelint-disable property-disallowed-list, declaration-no-important\n\n//\n// Border\n//\n\n.border         { border: $border-width solid $border-color !important; }\n.border-top     { border-top: $border-width solid $border-color !important; }\n.border-right   { border-right: $border-width solid $border-color !important; }\n.border-bottom  { border-bottom: $border-width solid $border-color !important; }\n.border-left    { border-left: $border-width solid $border-color !important; }\n\n.border-0        { border: 0 !important; }\n.border-top-0    { border-top: 0 !important; }\n.border-right-0  { border-right: 0 !important; }\n.border-bottom-0 { border-bottom: 0 !important; }\n.border-left-0   { border-left: 0 !important; }\n\n@each $color, $value in $theme-colors {\n  .border-#{$color} {\n    border-color: $value !important;\n  }\n}\n\n.border-white {\n  border-color: $white !important;\n}\n\n//\n// Border-radius\n//\n\n.rounded-sm {\n  border-radius: $border-radius-sm !important;\n}\n\n.rounded {\n  border-radius: $border-radius !important;\n}\n\n.rounded-top {\n  border-top-left-radius: $border-radius !important;\n  border-top-right-radius: $border-radius !important;\n}\n\n.rounded-right {\n  border-top-right-radius: $border-radius !important;\n  border-bottom-right-radius: $border-radius !important;\n}\n\n.rounded-bottom {\n  border-bottom-right-radius: $border-radius !important;\n  border-bottom-left-radius: $border-radius !important;\n}\n\n.rounded-left {\n  border-top-left-radius: $border-radius !important;\n  border-bottom-left-radius: $border-radius !important;\n}\n\n.rounded-lg {\n  border-radius: $border-radius-lg !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-pill {\n  border-radius: $rounded-pill !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Utilities for common `display` values\n//\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @each $value in $displays {\n      .d#{$infix}-#{$value} { display: $value !important; }\n    }\n  }\n}\n\n\n//\n// Utilities for toggling `display` in print\n//\n\n@media print {\n  @each $value in $displays {\n    .d-print-#{$value} { display: $value !important; }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.embed-responsive {\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 0;\n  overflow: hidden;\n\n  &::before {\n    display: block;\n    content: \"\";\n  }\n\n  .embed-responsive-item,\n  iframe,\n  embed,\n  object,\n  video {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border: 0;\n  }\n}\n\n@each $embed-responsive-aspect-ratio in $embed-responsive-aspect-ratios {\n  $embed-responsive-aspect-ratio-x: nth($embed-responsive-aspect-ratio, 1);\n  $embed-responsive-aspect-ratio-y: nth($embed-responsive-aspect-ratio, 2);\n\n  .embed-responsive-#{$embed-responsive-aspect-ratio-x}by#{$embed-responsive-aspect-ratio-y} {\n    &::before {\n      padding-top: percentage(divide($embed-responsive-aspect-ratio-y, $embed-responsive-aspect-ratio-x));\n    }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n// Flex variation\n//\n// Custom styles for additional flex alignment options.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .flex#{$infix}-row            { flex-direction: row !important; }\n    .flex#{$infix}-column         { flex-direction: column !important; }\n    .flex#{$infix}-row-reverse    { flex-direction: row-reverse !important; }\n    .flex#{$infix}-column-reverse { flex-direction: column-reverse !important; }\n\n    .flex#{$infix}-wrap         { flex-wrap: wrap !important; }\n    .flex#{$infix}-nowrap       { flex-wrap: nowrap !important; }\n    .flex#{$infix}-wrap-reverse { flex-wrap: wrap-reverse !important; }\n    .flex#{$infix}-fill         { flex: 1 1 auto !important; }\n    .flex#{$infix}-grow-0       { flex-grow: 0 !important; }\n    .flex#{$infix}-grow-1       { flex-grow: 1 !important; }\n    .flex#{$infix}-shrink-0     { flex-shrink: 0 !important; }\n    .flex#{$infix}-shrink-1     { flex-shrink: 1 !important; }\n\n    .justify-content#{$infix}-start   { justify-content: flex-start !important; }\n    .justify-content#{$infix}-end     { justify-content: flex-end !important; }\n    .justify-content#{$infix}-center  { justify-content: center !important; }\n    .justify-content#{$infix}-between { justify-content: space-between !important; }\n    .justify-content#{$infix}-around  { justify-content: space-around !important; }\n\n    .align-items#{$infix}-start    { align-items: flex-start !important; }\n    .align-items#{$infix}-end      { align-items: flex-end !important; }\n    .align-items#{$infix}-center   { align-items: center !important; }\n    .align-items#{$infix}-baseline { align-items: baseline !important; }\n    .align-items#{$infix}-stretch  { align-items: stretch !important; }\n\n    .align-content#{$infix}-start   { align-content: flex-start !important; }\n    .align-content#{$infix}-end     { align-content: flex-end !important; }\n    .align-content#{$infix}-center  { align-content: center !important; }\n    .align-content#{$infix}-between { align-content: space-between !important; }\n    .align-content#{$infix}-around  { align-content: space-around !important; }\n    .align-content#{$infix}-stretch { align-content: stretch !important; }\n\n    .align-self#{$infix}-auto     { align-self: auto !important; }\n    .align-self#{$infix}-start    { align-self: flex-start !important; }\n    .align-self#{$infix}-end      { align-self: flex-end !important; }\n    .align-self#{$infix}-center   { align-self: center !important; }\n    .align-self#{$infix}-baseline { align-self: baseline !important; }\n    .align-self#{$infix}-stretch  { align-self: stretch !important; }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .float#{$infix}-left  { float: left !important; }\n    .float#{$infix}-right { float: right !important; }\n    .float#{$infix}-none  { float: none !important; }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n@each $value in $user-selects {\n  .user-select-#{$value} { user-select: $value !important; }\n}\n","// stylelint-disable declaration-no-important\n\n@each $value in $overflows {\n  .overflow-#{$value} { overflow: $value !important; }\n}\n","// stylelint-disable declaration-no-important\n\n// Common values\n@each $position in $positions {\n  .position-#{$position} { position: $position !important; }\n}\n\n// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.sticky-top {\n  @supports (position: sticky) {\n    position: sticky;\n    top: 0;\n    z-index: $zindex-sticky;\n  }\n}\n","//\n// Screenreaders\n//\n\n.sr-only {\n  @include sr-only();\n}\n\n.sr-only-focusable {\n  @include sr-only-focusable();\n}\n","// Only display content to screen readers\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin sr-only() {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n// Use in conjunction with .sr-only to only display content when it's focused.\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n//\n// Credit: HTML5 Boilerplate\n\n@mixin sr-only-focusable() {\n  &:active,\n  &:focus {\n    position: static;\n    width: auto;\n    height: auto;\n    overflow: visible;\n    clip: auto;\n    white-space: normal;\n  }\n}\n","// stylelint-disable declaration-no-important\n\n.shadow-sm { box-shadow: $box-shadow-sm !important; }\n.shadow { box-shadow: $box-shadow !important; }\n.shadow-lg { box-shadow: $box-shadow-lg !important; }\n.shadow-none { box-shadow: none !important; }\n","// stylelint-disable declaration-no-important\n\n// Width and height\n\n@each $prop, $abbrev in (width: w, height: h) {\n  @each $size, $length in $sizes {\n    .#{$abbrev}-#{$size} { #{$prop}: $length !important; }\n  }\n}\n\n.mw-100 { max-width: 100% !important; }\n.mh-100 { max-height: 100% !important; }\n\n// Viewport additional helpers\n\n.min-vw-100 { min-width: 100vw !important; }\n.min-vh-100 { min-height: 100vh !important; }\n\n.vw-100 { width: 100vw !important; }\n.vh-100 { height: 100vh !important; }\n","// stylelint-disable declaration-no-important\n\n// Margin and Padding\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @each $prop, $abbrev in (margin: m, padding: p) {\n      @each $size, $length in $spacers {\n        .#{$abbrev}#{$infix}-#{$size} { #{$prop}: $length !important; }\n        .#{$abbrev}t#{$infix}-#{$size},\n        .#{$abbrev}y#{$infix}-#{$size} {\n          #{$prop}-top: $length !important;\n        }\n        .#{$abbrev}r#{$infix}-#{$size},\n        .#{$abbrev}x#{$infix}-#{$size} {\n          #{$prop}-right: $length !important;\n        }\n        .#{$abbrev}b#{$infix}-#{$size},\n        .#{$abbrev}y#{$infix}-#{$size} {\n          #{$prop}-bottom: $length !important;\n        }\n        .#{$abbrev}l#{$infix}-#{$size},\n        .#{$abbrev}x#{$infix}-#{$size} {\n          #{$prop}-left: $length !important;\n        }\n      }\n    }\n\n    // Negative margins (e.g., where `.mb-n1` is negative version of `.mb-1`)\n    @each $size, $length in $spacers {\n      @if \"#{$size}\" != \"0\" {\n        .m#{$infix}-n#{$size} { margin: -$length !important; }\n        .mt#{$infix}-n#{$size},\n        .my#{$infix}-n#{$size} {\n          margin-top: -$length !important;\n        }\n        .mr#{$infix}-n#{$size},\n        .mx#{$infix}-n#{$size} {\n          margin-right: -$length !important;\n        }\n        .mb#{$infix}-n#{$size},\n        .my#{$infix}-n#{$size} {\n          margin-bottom: -$length !important;\n        }\n        .ml#{$infix}-n#{$size},\n        .mx#{$infix}-n#{$size} {\n          margin-left: -$length !important;\n        }\n      }\n    }\n\n    // Some special margin utils\n    .m#{$infix}-auto { margin: auto !important; }\n    .mt#{$infix}-auto,\n    .my#{$infix}-auto {\n      margin-top: auto !important;\n    }\n    .mr#{$infix}-auto,\n    .mx#{$infix}-auto {\n      margin-right: auto !important;\n    }\n    .mb#{$infix}-auto,\n    .my#{$infix}-auto {\n      margin-bottom: auto !important;\n    }\n    .ml#{$infix}-auto,\n    .mx#{$infix}-auto {\n      margin-left: auto !important;\n    }\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1;\n    // Just in case `pointer-events: none` is set on a parent\n    pointer-events: auto;\n    content: \"\";\n    // IE10 bugfix, see https://stackoverflow.com/questions/16947967/ie10-hover-pseudo-class-doesnt-work-without-background-color\n    background-color: rgba(0, 0, 0, 0);\n  }\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Text\n//\n\n.text-monospace { font-family: $font-family-monospace !important; }\n\n// Alignment\n\n.text-justify  { text-align: justify !important; }\n.text-wrap     { white-space: normal !important; }\n.text-nowrap   { white-space: nowrap !important; }\n.text-truncate { @include text-truncate(); }\n\n// Responsive alignment\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .text#{$infix}-left   { text-align: left !important; }\n    .text#{$infix}-right  { text-align: right !important; }\n    .text#{$infix}-center { text-align: center !important; }\n  }\n}\n\n// Transformation\n\n.text-lowercase  { text-transform: lowercase !important; }\n.text-uppercase  { text-transform: uppercase !important; }\n.text-capitalize { text-transform: capitalize !important; }\n\n// Weight and italics\n\n.font-weight-light   { font-weight: $font-weight-light !important; }\n.font-weight-lighter { font-weight: $font-weight-lighter !important; }\n.font-weight-normal  { font-weight: $font-weight-normal !important; }\n.font-weight-bold    { font-weight: $font-weight-bold !important; }\n.font-weight-bolder  { font-weight: $font-weight-bolder !important; }\n.font-italic         { font-style: italic !important; }\n\n// Contextual colors\n\n.text-white { color: $white !important; }\n\n@each $color, $value in $theme-colors {\n  @include text-emphasis-variant(\".text-#{$color}\", $value, true);\n}\n\n.text-body { color: $body-color !important; }\n.text-muted { color: $text-muted !important; }\n\n.text-black-50 { color: rgba($black, .5) !important; }\n.text-white-50 { color: rgba($white, .5) !important; }\n\n// Misc\n\n.text-hide {\n  @include text-hide($ignore-warning: true);\n}\n\n.text-decoration-none { text-decoration: none !important; }\n\n.text-break {\n  word-break: break-word !important; // Deprecated, but avoids issues with flex containers\n  word-wrap: break-word !important; // Used instead of `overflow-wrap` for IE & Edge Legacy\n}\n\n// Reset\n\n.text-reset { color: inherit !important; }\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n","// stylelint-disable declaration-no-important\n\n// Typography\n\n@mixin text-emphasis-variant($parent, $color, $ignore-warning: false) {\n  #{$parent} {\n    color: $color !important;\n  }\n  @if $emphasized-link-hover-darken-percentage != 0 {\n    a#{$parent} {\n      @include hover-focus() {\n        color: darken($color, $emphasized-link-hover-darken-percentage) !important;\n      }\n    }\n  }\n  @include deprecate(\"`text-emphasis-variant()`\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n","// CSS image replacement\n@mixin text-hide($ignore-warning: false) {\n  // stylelint-disable-next-line font-family-no-missing-generic-family-keyword\n  font: 0/0 a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0;\n\n  @include deprecate(\"`text-hide()`\", \"v4.1.0\", \"v5\", $ignore-warning);\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Visibility utilities\n//\n\n.visible {\n  visibility: visible !important;\n}\n\n.invisible {\n  visibility: hidden !important;\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type\n\n// Source: https://github.com/h5bp/main.css/blob/master/src/_print.css\n\n// ==========================================================================\n// Print styles.\n// Inlined to avoid the additional HTTP request:\n// https://www.phpied.com/delay-loading-your-print-css/\n// ==========================================================================\n\n@if $enable-print-styles {\n  @media print {\n    *,\n    *::before,\n    *::after {\n      // Bootstrap specific; comment out `color` and `background`\n      //color: $black !important; // Black prints faster\n      text-shadow: none !important;\n      //background: transparent !important;\n      box-shadow: none !important;\n    }\n\n    a {\n      &:not(.btn) {\n        text-decoration: underline;\n      }\n    }\n\n    // Bootstrap specific; comment the following selector out\n    //a[href]::after {\n    //  content: \" (\" attr(href) \")\";\n    //}\n\n    abbr[title]::after {\n      content: \" (\" attr(title) \")\";\n    }\n\n    // Bootstrap specific; comment the following selector out\n    //\n    // Don't show links that are fragment identifiers,\n    // or use the `javascript:` pseudo protocol\n    //\n\n    //a[href^=\"#\"]::after,\n    //a[href^=\"javascript:\"]::after {\n    // content: \"\";\n    //}\n\n    pre {\n      white-space: pre-wrap !important;\n    }\n    pre,\n    blockquote {\n      border: $border-width solid $gray-500; // Bootstrap custom code; using `$border-width` instead of 1px\n      page-break-inside: avoid;\n    }\n\n    tr,\n    img {\n      page-break-inside: avoid;\n    }\n\n    p,\n    h2,\n    h3 {\n      orphans: 3;\n      widows: 3;\n    }\n\n    h2,\n    h3 {\n      page-break-after: avoid;\n    }\n\n    // Bootstrap specific changes start\n\n    // Specify a size and min-width to make printing closer across browsers.\n    // We don't set margin here because it breaks `size` in Chrome. We also\n    // don't use `!important` on `size` as it breaks in Chrome.\n    @page {\n      size: $print-page-size;\n    }\n    body {\n      min-width: $print-body-min-width !important;\n    }\n    .container {\n      min-width: $print-body-min-width !important;\n    }\n\n    // Bootstrap components\n    .navbar {\n      display: none;\n    }\n    .badge {\n      border: $border-width solid $black;\n    }\n\n    .table {\n      border-collapse: collapse !important;\n\n      td,\n      th {\n        background-color: $white !important;\n      }\n    }\n\n    .table-bordered {\n      th,\n      td {\n        border: 1px solid $gray-300 !important;\n      }\n    }\n\n    .table-dark {\n      color: inherit;\n\n      th,\n      td,\n      thead th,\n      tbody + tbody {\n        border-color: $table-border-color;\n      }\n    }\n\n    .table .thead-dark th {\n      color: inherit;\n      border-color: $table-border-color;\n    }\n\n    // Bootstrap specific changes end\n  }\n}\n","/* MaterialDesignIcons.com */\r\n@import \"variables\";\r\n@import \"functions\";\r\n@import \"path\";\r\n@import \"core\";\r\n@import \"icons\";\r\n@import \"extras\";\r\n@import \"animated\";","@font-face {\r\n  font-family: '#{$mdi-font-name}';\r\n  src: url('#{$mdi-font-path}/#{$mdi-filename}-webfont.eot?v=#{$mdi-version}');\r\n  src: url('#{$mdi-font-path}/#{$mdi-filename}-webfont.eot?#iefix&v=#{$mdi-version}') format('embedded-opentype'),\r\n    url('#{$mdi-font-path}/#{$mdi-filename}-webfont.woff2?v=#{$mdi-version}') format('woff2'),\r\n    url('#{$mdi-font-path}/#{$mdi-filename}-webfont.woff?v=#{$mdi-version}') format('woff'),\r\n    url('#{$mdi-font-path}/#{$mdi-filename}-webfont.ttf?v=#{$mdi-version}') format('truetype');\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n",".#{$mdi-css-prefix}:before,\r\n.#{$mdi-css-prefix}-set {\r\n  display: inline-block;\r\n  font: normal normal normal #{$mdi-font-size-base}/1 '#{$mdi-font-name}'; // shortening font declaration\r\n  font-size: inherit; // can't have font-size inherit on line above, so need to override\r\n  text-rendering: auto; // optimizelegibility throws things off #1094\r\n  line-height: inherit;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}","@each $key, $value in $mdi-icons {\r\n    .#{$mdi-css-prefix}-#{$key}::before {\r\n        content: char($value);\r\n    }\r\n}\r\n\r\n.#{$mdi-css-prefix}-blank::before {\r\n    content: \"\\F68C\";\r\n    visibility: hidden;\r\n}","$mdi-sizes: 18 24 36 48;\r\n@each $mdi-size in $mdi-sizes {\r\n    .#{$mdi-css-prefix}-#{$mdi-size}px {\r\n        &.#{$mdi-css-prefix}-set,\r\n        &.#{$mdi-css-prefix}:before {\r\n            font-size: $mdi-size * 1px;\r\n        }\r\n    }\r\n}\r\n\r\n.#{$mdi-css-prefix}-dark {\r\n    &:before {\r\n        color: rgba(0, 0, 0, 0.54);\r\n    }\r\n    &.#{$mdi-css-prefix}-inactive:before {\r\n        color: rgba(0, 0, 0, 0.26);\r\n    }\r\n}\r\n.#{$mdi-css-prefix}-light {\r\n    &:before {\r\n        color: rgba(255, 255, 255, 1);\r\n    }\r\n    &.#{$mdi-css-prefix}-inactive:before {\r\n        color: rgba(255, 255, 255, 0.3);\r\n    }\r\n}\r\n\r\n$mdi-degrees: 45 90 135 180 225 270 315;\r\n@each $mdi-degree in $mdi-degrees {\r\n    .#{$mdi-css-prefix}-rotate-#{$mdi-degree}{\r\n        &:before {\r\n            -webkit-transform: rotate(#{$mdi-degree}deg);\r\n            -ms-transform: rotate(#{$mdi-degree}deg);\r\n            transform: rotate(#{$mdi-degree}deg);\r\n        }\r\n        /*\r\n        // Not included in production\r\n        &.#{$mdi-css-prefix}-flip-h:before {\r\n            -webkit-transform: scaleX(-1) rotate(#{$mdi-degree}deg);\r\n            transform: scaleX(-1) rotate(#{$mdi-degree}deg);\r\n            filter: FlipH;\r\n            -ms-filter: \"FlipH\";\r\n        }\r\n        &.#{$mdi-css-prefix}-flip-v:before {\r\n            -webkit-transform: scaleY(-1) rotate(#{$mdi-degree}deg);\r\n            -ms-transform: rotate(#{$mdi-degree}deg);\r\n            transform: scaleY(-1) rotate(#{$mdi-degree}deg);\r\n            filter: FlipV;\r\n            -ms-filter: \"FlipV\";\r\n        }\r\n        */\r\n    }\r\n}\r\n.#{$mdi-css-prefix}-flip-h:before {\r\n    -webkit-transform: scaleX(-1);\r\n    transform: scaleX(-1);\r\n    filter: FlipH;\r\n    -ms-filter: \"FlipH\";\r\n}\r\n.#{$mdi-css-prefix}-flip-v:before {\r\n    -webkit-transform: scaleY(-1);\r\n    transform: scaleY(-1);\r\n    filter: FlipV;\r\n    -ms-filter: \"FlipV\";\r\n}","// From Font Awesome\r\n.#{$mdi-css-prefix}-spin:before {\r\n    -webkit-animation: #{$mdi-css-prefix}-spin 2s infinite linear;\r\n            animation: #{$mdi-css-prefix}-spin 2s infinite linear;\r\n}\r\n\r\n@-webkit-keyframes #{$mdi-css-prefix}-spin {\r\n    0% {\r\n      -webkit-transform: rotate(0deg);\r\n              transform: rotate(0deg);\r\n    }\r\n    100% {\r\n      -webkit-transform: rotate(359deg);\r\n              transform: rotate(359deg);\r\n    }\r\n}\r\n\r\n@keyframes #{$mdi-css-prefix}-spin {\r\n    0% {\r\n      -webkit-transform: rotate(0deg);\r\n              transform: rotate(0deg);\r\n    }\r\n    100% {\r\n      -webkit-transform: rotate(359deg);\r\n              transform: rotate(359deg);\r\n    }\r\n}","/* Animation Mixins */\n@keyframes dropdownAnimation {\n  from {\n    opacity: 0;\n    -webkit-transition: all .3s;\n    -moz-transition: all .3s;\n    -ms-transition: all .3s;\n    -o-transition: all .3s;\n    transition: all .3s;\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transition: all .3s;\n    -moz-transition: all .3s;\n    -ms-transition: all .3s;\n    -o-transition: all .3s;\n    transition: all .3s;\n  }\n}\n\n.dropdownAnimation {\n  animation-name: dropdownAnimation;\n  @include animation-duration($action-transition-duration);\n  @include animation-fill-mode(both);\n}\n@mixin transition($settings) {\n  -webkit-transition: $settings;\n  -moz-transition: $settings;\n  -ms-transition: $settings;\n  -o-transition: $settings;\n  transition: $settings;\n}\n@keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n  }\n}\n\n.fadeOut {\n  animation-name: fadeOut;\n}\n\n.infinite-spin {\n  @keyframes spin {\n    from {\n      transform: rotate(0deg);\n    }\n\n    to {\n      transform: rotate(360deg);\n    }\n  }\n  animation-name: spin;\n  animation-duration: 3s;\n  animation-iteration-count: infinite;\n  animation-timing-function: linear;\n}\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translate3d(0, 100%, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n.fadeInUp {\n  animation-name: fadeInUp;\n}","/* Miscellaneous Mixins */\n\n// general transform\n@mixin transform($transforms) {\n\t-moz-transform: $transforms;\n\t  -o-transform: $transforms;\n\t -ms-transform: $transforms;\n -webkit-transform: $transforms;\n\t   transform: $transforms;\n}\n\n// rotate\n@mixin rotate ($deg) {\n@include transform(rotate(#{$deg}deg));\n}\n\n// scale\n@mixin scale($scale) {\n  @include transform(scale($scale));\n}\n// translate\n@mixin translate ($x, $y) {\n@include transform(translate($x, $y));\n}\n// skew\n@mixin skew ($x, $y) {\n@include transform(skew(#{$x}deg, #{$y}deg));\n}\n//transform origin\n@mixin transform-origin ($origin) {\n moz-transform-origin: $origin;\n\t  -o-transform-origin: $origin;\n\t -ms-transform-origin: $origin;\n -webkit-transform-origin: $origin;\n\t   transform-origin: $origin;\n}\n//Ellipsis\n%ellipsor{\n\ttext-overflow: ellipsis;\n\toverflow: hidden;\n\tmax-width:100%;\n\twhite-space: nowrap;\n}\n\n@mixin ellipsor {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 100%;\n  white-space: nowrap;\n}\n\n// Placeholder\n@mixin placeholder {\n &::-webkit-input-placeholder {\n\t @content\n }\n &:-moz-placeholder {\n\t @content\n }\n &::-moz-placeholder {\n\t @content\n }\n &:-ms-input-placeholder {\n\t @content\n }\n}","/* Typography */\n\nbody {\n  font-size: 1rem;\n  font-weight: normal;\n  font-weight: initial;\n  line-height: 1.5;\n  font-family: $type1;\n  -webkit-font-smoothing: antialiased;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6 {\n  font-weight: $font-weight-medium;\n}\np {\n  font-size: $default-font-size;\n}\nh1,\n.h1 {\n  font-size: 2.19rem;\n}\nh2,\n.h2 {\n  font-size: 1.875rem;\n}\nh3,\n.h3 {\n  font-size: 1.5rem;\n}\nh4,\n.h4 {\n  font-size: 1.125rem;\n}\nh5,\n.h5 {\n  font-size: 1rem;\n}\nh6,\n.h6 {\n  font-size: 0.9375rem;\n}\np {\n  font-size: 0.875rem;\n}\n.display-1 {\n  font-size: 3.75rem;\n  @media (max-width: 991px) {\n    font-size: 3rem;\n  }\n}\n.display-2 {\n  font-size: 3.125rem;\n  @media (max-width: 991px) {\n    font-size: 2.5rem;\n  }\n}\n.display-3 {\n  font-size: 2.5rem;\n  @media (max-width: 991px) {\n    font-size: 2rem;\n  }\n}\n.display-4 {\n  font-size: 1.875rem;\n  @media (max-width: 991px) {\n    font-size: 1.5rem;\n  }\n}\n.display-5 {\n  font-size: 1.25rem;\n  @media (max-width: 991px) {\n    font-size: 1rem;\n  }\n}\n.blockquote {\n  padding: 1.25rem;\n  border: 1px solid $border-color;\n}\n\naddress {\n  p {\n    margin-bottom: 0;\n  }\n}\n\n//blockqoute color variations\n@each $color, $value in $theme-colors {\n  .blockquote-#{$color} {\n    @include blockquote($value);\n  }\n}\n.error-page {\n  h1 {\n    font-size: 12rem;\n    @media (max-width: 991px) {\n      font-size: 8rem;\n    }\n  }\n}\n.icon-lg {\n  font-size: 3.75rem;\n}\n.icon-md {\n  font-size: 1.875rem;\n}\n.icon-sm {\n  font-size: 1rem;\n}\n","// BlockQuote Mixins //\n\n@mixin blockquote($color) {\n  border-color: $color;\n  .blockquote-footer {\n    color: $color;\n  }\n}\n","/* Reset Styles */\n\nbody {\n    padding: 0;\n    margin: 0;\n    overflow-x: hidden;\n}\n\n.form-control,\n.form-control:focus {\n    -webkit-box-shadow: none;\n    -moz-box-shadow: none\n}\n\n.form-control {\n    box-shadow: none\n}\n\n.form-control:focus {\n    outline: 0;\n    box-shadow: none\n}\n\na,\ndiv,\nh1,\nh2,\nh3,\nh4,\nh5,\np,\nspan {\n    text-shadow: none\n}\n\n[type=button]:focus,\na:active,\na:focus,\na:visited,\nbutton::-moz-focus-inner,\ninput[type=reset]::-moz-focus-inner,\ninput[type=button]::-moz-focus-inner,\ninput[type=submit]::-moz-focus-inner,\ninput[type=file]>input[type=button]::-moz-focus-inner,\nselect::-moz-focus-inner {\n    outline: 0\n}\n\ninput,\n.form-control:focus,\ninput:focus,\nselect:focus,\ntextarea:focus,\nbutton:focus {\n    outline: none;\n    outline-width: 0;\n    outline-color: transparent;\n    box-shadow: none;\n    outline-style: none;\n}\n\ntextarea {\n    resize: none;\n    overflow-x: hidden;\n}\n\n.btn,\n.btn-group.open .dropdown-toggle,\n.btn:active,\n.btn:focus,\n.btn:hover,\n.btn:visited,\na,\na:active,\na:checked,\na:focus,\na:hover,\na:visited,\nbody,\nbutton,\nbutton:active,\nbutton:hover,\nbutton:visited,\ndiv,\ninput,\ninput:active,\ninput:focus,\ninput:hover,\ninput:visited,\nselect,\nselect:active,\nselect:focus,\nselect:visited,\ntextarea,\ntextarea:active,\ntextarea:focus,\ntextarea:hover,\ntextarea:visited {\n    -webkit-box-shadow: none;\n    -moz-box-shadow: none;\n    box-shadow: none\n}\n\n.btn.active.focus,\n.btn.active:focus,\n.btn.focus,\n.btn:active.focus,\n.btn:active:focus,\n.btn:focus,\nbutton,\nbutton:active,\nbutton:checked,\nbutton:focus,\nbutton:hover,\nbutton:visited {\n    outline: 0;\n    outline-offset: 0\n}\n\n.bootstrap-select .dropdown-toggle:focus {\n    outline: 0;\n    outline-offset: 0\n}\n\n.dropdown-menu>li>a:active,\n.dropdown-menu>li>a:focus,\n.dropdown-menu>li>a:hover,\n.dropdown-menu>li>a:visited {\n    outline: 0\n}\n\na:focus,\ninput:focus {\n    border-color: transparent;\n    outline: none\n}\n","@media (max-width: 991px) {\n  .navbar {\n    .navbar-brand-wrapper {\n      .brand-logo {\n        display: none;\n      }\n      .brand-logo-mini {\n        display: inline-block;\n      }\n    }\n  }\n}\n@media screen and (max-width: 991px) {\n  .row-offcanvas {\n    position: relative;\n    -webkit-transition: all .25s ease-out;\n    -o-transition: all .25s ease-out;\n    transition: all .25s ease-out;\n\n    &.row-offcanvas-right {\n      right: 0;\n\n      .sidebar-offcanvas {\n        right: -100%; // 12 columns\n      }\n\n      &.active {\n        right: calc(50% + 30px); // 6 columns\n\n        .sidebar-offcanvas {\n          right: calc(-50% - 15px); // 6 columns\n        }\n      }\n    }\n\n    &.row-offcanvas-left {\n      left: 0;\n\n      .sidebar-offcanvas {\n        left: -100%; // 12 columns\n      }\n\n      &.active {\n        left: 50%; // 6 columns\n\n        .sidebar-offcanvas {\n          left: -50%; // 6 columns\n        }\n      }\n    }\n\n    .sidebar-offcanvas {\n      position: absolute;\n      top: 0;\n      width: calc( 50% + 30px); // 6 columns\n    }\n  }\n}\n","/* Miscellanoeous */\nbody,\nhtml {\n  overflow-x: hidden;\n  padding-right: 0; // resets padding right added by Bootstrap modal\n}\n\nbody {\n  background: $content-bg;\n}\n\n*:-moz-full-screen,\n*:-webkit-full-screen,\n*:fullscreen *:-ms-fullscreen {\n  overflow: auto;\n}\n\n.page-body-wrapper {\n  min-height: calc(100vh - #{$navbar-height});\n  @include display-flex();\n  @include flex-direction(row);\n  padding-left: 0;\n  padding-right: 0;\n  width: calc(100% - #{$sidebar-width-lg});\n  transition: width $action-transition-duration $action-transition-timing-function, margin $action-transition-duration $action-transition-timing-function;\n\n  &.full-page-wrapper {\n    min-height: 100vh;\n    width: 100%;\n    padding-top: 0;\n\n    .main-panel {\n      padding-top: 0;\n\n      .content-wrapper {\n        padding: 0;\n\n        > div {\n          height: 100%;\n        }\n      }\n    }\n  }\n\n  @media (max-width:992px) {\n    width: 100%;\n  }\n}\n\n.main-panel {\n  transition: width $action-transition-duration $action-transition-timing-function, margin $action-transition-duration $action-transition-timing-function;\n  width: 100%;\n  min-height: calc(100vh - #{$navbar-height});\n  padding-top: $navbar-height;\n  @include display-flex();\n  @include flex-direction(column);\n  @media (max-width: 991px) {\n    margin-left: 0;\n    width: 100%;\n  }\n  &.main-panel-only {\n    transition: none;\n  }\n}\n\n.content-wrapper {\n  background: $content-bg;\n  padding: $content-padding;\n  width: 100%;\n  @include flex-grow(1);\n}\n\n.container-scroller {\n  overflow: hidden;\n  display: flex;\n  position: relative;\n}\n\npre {\n  background: color(gray-lighter);\n  padding: 15px;\n  font-size: 14px;\n}\n\ncode {\n  padding: 5px;\n  color: theme-color(danger);\n  font-family: $type1;\n  font-weight: $font-weight-light;\n  font-size: $default-font-size;\n  border-radius: 4px;\n}\n\n.page-header {\n  @extend .d-flex;\n  @extend .justify-content-between;\n  @extend .align-items-center;\n  margin: 0 0 2.5rem 0;\n  .breadcrumb {\n    border: 0;\n    margin-bottom: 0;\n  }\n}\n.page-title {\n  color: $body-color;\n  font-size: 1.125rem;\n  margin-bottom: 0;\n  .page-title-icon {\n    display: inline-block;\n    width: 36px;\n    height: 36px;\n    border-radius: 4px;\n    text-align: center;\n    box-shadow: 0px 3px 8.3px 0.7px rgba(163, 93, 255, 0.35);\n    i {\n      font-size: .9375rem;\n      line-height: 36px;\n    }\n  }\n}","@import \"../support\";\n@import \"shared\";\n\n// This is the underlying implementation for all the other mixins in this module.\n// It is the only way to access prefix support for older versions of the spec.\n// Deviates from canonical Compass implementation by dropping support for\n// older versions of the Flexbox spec.\n//\n// `$properties`: map of property-value pairs that should be prefixed\n@mixin flexbox($properties) {\n  @each $prop, $value in $properties {\n    @if $prop == display {\n      @include experimental-value(display, $value, not(-moz), -webkit,\n                                  not(-o), not(-ms), not(-khtml), official);\n    } @else {\n      @include experimental($prop, $value, not(-moz), -webkit, not(-o),\n                            not(-ms), not(-khtml), official);\n    }\n  }\n}\n\n// Values for $display are: flex (default), inline-flex\n@mixin display-flex($display: flex) {\n  @include flexbox((display: $display));\n}\n\n// Values: row | row-reverse | column | column-reverse\n@mixin flex-direction($direction) {\n  @include flexbox((flex-direction: $direction));\n}\n\n// Values: nowrap | wrap | wrap-reverse\n@mixin flex-wrap($wrap) {\n  @include flexbox((flex-wrap: $wrap));\n}\n\n// Shorthand for flex-direction and flex-wrap.\n@mixin flex-flow($flow) {\n  @include flexbox((flex-flow: $flow));\n}\n\n// Accepts an integer\n@mixin order($order) {\n  @include flexbox((order: $order));\n}\n\n// Shorthand for flex-grow, flex-shrink and optionally flex-basis.\n// Space separated, in that order.\n@mixin flex($flex) {\n  @include flexbox((flex: $flex));\n}\n\n// Accepts a number.\n@mixin flex-grow($flex-grow) {\n  @include flexbox((flex-grow: $flex-grow));\n}\n\n// Accepts a number.\n@mixin flex-shrink($flex-shrink) {\n  @include flexbox((flex-shrink: $flex-shrink));\n}\n\n// Accepts any legal value for the width property.\n@mixin flex-basis($flex-basis) {\n  @include flexbox((flex-basis: $flex-basis));\n}\n\n// Legal values: flex-start | flex-end | center | space-between | space-around\n@mixin justify-content($justify-content) {\n  @include flexbox((justify-content: $justify-content));\n}\n\n// Legal values: flex-start | flex-end | center | baseline | stretch\n@mixin align-items($align-items) {\n  @include flexbox((align-items: $align-items));\n}\n\n// Legal values: auto | flex-start | flex-end | center | baseline | stretch\n@mixin align-self($align-self) {\n  @include flexbox((align-self: $align-self));\n}\n\n// Legal values: flex-start | flex-end | center | space-between | space-around | stretch\n@mixin align-content($align-content) {\n  @include flexbox((align-content: $align-content));\n}\n","/* Utilities */\n\n.grid-margin {\n  margin-bottom: $grid-gutter-width;\n}\n.grid-margin-sm-0 {\n  @media (min-width: 576px) {\n    margin-bottom: 0;\n  }\n}\n.grid-margin-md-0 {\n  @media (min-width: 768px) {\n    margin-bottom: 0;\n  }\n}\n.grid-margin-lg-0 {\n  @media (min-width: 992px) {\n    margin-bottom: 0;\n  }\n}\n.grid-margin-xl-0 {\n  @media (min-width: 1200px) {\n    margin-bottom: 0;\n  }\n}\n.img-lg {\n  width: 92px;\n  height: 92px;\n}\n.img-sm {\n  width: 43px;\n  height: 43px;\n}\n.img-xs {\n  width: 35px;\n  height: 35px;\n}\n.img-ss {\n  width: 26px;\n  height: 26px;\n}\n.stretch-card {\n  @include display-flex;\n  @include align-items(stretch);\n  @include justify-content(stretch);\n  >.card{\n    width: 100%;\n    min-width: 100%;\n  }\n}\n\n.border-right-sm {\n  @media (min-width: 576px) {\n    border-right: $border-width solid $border-color;\n  }\n}\n.border-right-md {\n  @media (min-width: 768px) {\n    border-right: $border-width solid $border-color;\n  }\n}\n.border-right-lg {\n  @media (min-width: 992px) {\n    border-right: $border-width solid $border-color;\n  }\n}\n\n.border-left-sm {\n  @media (min-width: 576px) {\n    border-left: $border-width solid $border-color;\n  }\n}\n.border-left-md {\n  @media (min-width: 768px) {\n    border-left: $border-width solid $border-color;\n  }\n}\n.border-left-lg {\n  @media (min-width: 992px) {\n    border-left: $border-width solid $border-color;\n  }\n}\n\n.text-gray {\n  color: #8c8c8c;\n}\n\n.text-black {\n  color: $black;\n}\n\n.text-small {\n  font-size: 12px;\n}\n\n.flex-grow {\n  flex-grow: 1;\n}\n\n.font-weight-light {\n  font-weight: $font-weight-light;\n}\n\n.font-weight-light {\n  font-weight: $font-weight-medium;\n}\n\n.font-weight-bold {\n  font-weight: $font-weight-bold;\n}\n\n.font-weight-normal {\n  font-weight: normal;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n.image-grouped {\n  display: flex;\n\n  .text-avatar,\n  img {\n    @extend .img-ss;\n    border-radius: 100%;\n    margin-left: -10px;\n    z-index: 0;\n    border: 4px solid $card-bg;\n    transform: scale(1);\n    transition-duration: 0.3s;\n    transition-timing-function: ease;\n    transition-property: \"box-shadow\", \"z-index\", \"transform\", \"border-width\";\n\n    &:first-child {\n      margin-left: 0;\n    }\n\n    &:hover {\n      z-index: 1;\n      box-shadow: 0 0 5px -2px rgba(0, 0, 0, 0.5);\n      transform: scale(1.05);\n      border-width: 0;\n\n    }\n  }\n\n  .text-avatar {\n    @extend .bg-inverse-primary;\n    color: theme-color(primary);\n    font-size: 11px;\n    font-weight: 600;\n  }\n}\n.dot-indicator {\n  width: 10px;\n  height: 10px;\n  border-radius: 100%;\n}\n\n.aligner-wrapper {\n  position: relative;\n  \n  .absolute {\n    position: absolute;\n  \n    &.absolute-center {\n      top: 50%;\n      transform: translateY(-50%);\n      bottom: 0;\n      right: 0;\n      left: 0;\n      margin: auto;\n    }\n    \n    &.left {\n      left: 0;\n    }\n    \n    &.right {\n      right: 0;\n    }\n    \n    &.bottom {\n      bottom: 0;\n    }\n    \n    &.top {\n      top: 0;\n    }\n\n    &.center-content {\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%,-50%);\n    }\n  }\n}\n.v-strock-2 {\n  width: 3px;\n}\n\n.bg-gray-dark {\n  background: color(gray-dark);\n}\n.bg-gray-lightest{\n  background: color(gray-lightest);\n}","/* Demo Styles */\n// Add spacing to Boostrap components for demo purpose\n.template-demo {\n  > .btn {\n    @extend .mt-3;\n    @extend .mr-3;\n  }\n\n  .slider-wrap {\n    height: 100px;\n  }\n\n  > .btn-toolbar {\n    @extend .mt-3;\n    @extend .mr-3;\n  }\n\n  > .btn-group,\n  >  .btn-group-vertical {\n    @extend .mt-2;\n    @extend .mr-2;\n  }\n\n  .progress {\n    margin-top: 1.5rem;\n  }\n\n  .circle-progress {\n    @extend .mt-2;\n  }\n\n  > h2,\n   > h3,\n   > h4,\n   > h5,\n   > h6,\n  > h1 {\n    border-top: 1px solid $border-color;\n    padding: 0.5rem 0 0;\n  }\n\n\n  .noUi-horizontal {\n    margin-top: 2rem;\n  }\n\n  .noUi-vertical {\n    margin-right: 2rem;\n  }\n\n  > .dropdown {\n    display: inline-block;\n    @extend .mr-2;\n    margin-bottom: 0.5rem;\n  }\n\n  nav {\n    .breadcrumb {\n      margin-bottom: 1.375rem;\n    }\n\n    &:last-child {\n      .breadcrumb {\n        margin-bottom: 0;\n      }\n    }\n  }\n\n  .editable-form {\n    > .form-group {\n      border-bottom: 1px solid $border-color;\n      padding-bottom: 0.8rem;\n      margin-bottom: 0.8rem;\n    }\n  }\n\n  .circle-progress {\n    padding: 15px;\n  }\n\n  .circle-progress-block {\n    @extend .mb-3;\n    @extend .px-2;\n  }\n}\n\n.demo-modal {\n  position: static;\n  display: block;\n\n  .modal-dialog {\n    @extend .mt-0;\n\n    &.modal-lg {\n      max-width: 100%;\n    }\n  }\n}\n\n.loader-demo-box {\n  @extend .border;\n  @extend .border-secondary;\n  @extend .rounded;\n  width: 100%;\n  height: 200px;\n  @extend .d-flex;\n  @extend .align-items-center;\n}\n\n.dropdown-menu-static-demo {\n  height: 250px;\n  margin-bottom: 20px;\n}\n\n.rounded-legend {\n  ul {\n    li {\n      list-style-type: none;\n      color: $text-muted;\n      font-size: .75rem;\n      .legend-dots {\n        width: 1rem;\n        height: 1rem;\n        border-radius: 100%;\n        display: inline-block;\n        vertical-align: text-bottom;\n        margin-right: .5rem;\n        .rtl & {\n          margin-left: .5rem;\n        }\n      }\n    }\n  }\n  &.legend-horizontal {\n    @include display-flex;\n    ul {\n      li {\n        display: inline-block;\n        margin-right: 1.5rem;\n        .rtl & {\n          margin-right: auto;\n          margin-left: 1.5rem;\n        }\n      }\n    }\n  }\n  &.legend-top-right {\n    ul {\n      float: right;\n      .rtl & {\n        float: left;\n      }\n    }\n  }\n  &.legend-vertical {\n    ul {\n      li {\n        margin-top: 1rem;\n      }\n    }\n  }\n}",".main-spinner-wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  background: #eee;\n  .donut {\n    width: 4rem;\n    height: 4rem;\n    border-radius: 50%;\n    border: 0.3rem solid rgba(#979fd0, 0.3);\n    border-top-color: #979fd0;\n    animation: 1.5s spin infinite linear;\n  }\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}","/* Dashboard */\n.dashboard-vector-map {\n    width: 100%;\n    height: 300px;\n    background-color: #f9f9f9; /* Light background for a cleaner look */\n    border: 1px solid #ddd;\n    border-radius: 5px;\n}\n\n.proBanner {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    z-index: 9999;\n    background: linear-gradient(90deg, #4a90e2, #50c4ab); /* Gradient background */\n    color: #fff;\n    padding: 20px 25px;\n    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n\n    .purchase-popup {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        background: rgba(255, 255, 255, 0.1);\n        padding: 15px 20px;\n        border-radius: 8px;\n        animation: fadeIn 0.5s ease-in-out;\n\n        .btn {\n            margin-right: 20px;\n            font-weight: 600;\n            padding: 10px 20px;\n            border-radius: 6px;\n            transition: all 0.3s ease;\n\n            &.download-button {\n                background: rgba(255, 255, 255, 0.3);\n                color: #fff;\n                border: 1px solid rgba(255, 255, 255, 0.5);\n                &:hover {\n                    background: rgba(255, 255, 255, 0.5);\n                }\n            }\n\n            &.purchase-button {\n                background-color: #ff6b6b;\n                color: #fff;\n                border: none;\n                line-height: 1.2;\n                &:hover {\n                    background-color: #ff4c4c;\n                }\n            }\n        }\n\n        p {\n            margin: 0;\n            color: #f0f0f0;\n            font-size: 1rem;\n            line-height: 1.5;\n        }\n\n        i {\n            font-size: 1.5rem;\n            color: #fff;\n            margin-left: 10px;\n        }\n\n        .bannerClose {\n            cursor: pointer;\n            font-size: 1.2rem;\n            color: #fff;\n            &:hover {\n                color: #ff6b6b;\n            }\n        }\n    }\n\n    &.hide {\n        display: none;\n    }\n}\n\n/* Animations */\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(-10px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}","/* Checkboxes and Radios */\n\n.form-check {\n  position: relative;\n  display: block;\n  margin-top: 15px;\n  margin-bottom: 10px;\n  padding-left: 0;\n\n  .form-check-label {\n    display: block;\n    padding-left: 0.625rem;\n    font-size: $default-font-size;\n    line-height: 1.5;\n    color: $text-muted;\n    .rtl & {\n      padding-left: 0;\n      padding-right: 1.875rem;\n    }\n\n    input {\n      position: absolute;\n      top: 0;\n      left: 0;\n      .rtl & {\n        left: auto;\n        right: 0;\n      }\n      margin-left: 0;\n      margin-top: 0;\n      z-index: 1;\n      cursor: pointer;\n      opacity: 0;\n      filter: alpha(opacity=0);\n    }\n    input[type=\"checkbox\"] {\n      + .input-helper {\n        &:before,\n        &:after {\n          position: absolute;\n          top: 0;\n          left: 0;\n          .rtl & {\n            left: auto;\n            right: 0;\n          }\n        }\n        &:before {\n          content: \"\";\n          width: 16px;\n          height: 16px;\n          border-radius: 2px;\n          border: solid theme-color(primary);\n          border-width: 2px;\n          @include transition(all);\n          transition-duration: 0s;\n          -webkit-transition-duration: 250ms;\n          transition-duration: 250ms;\n          position: absolute;\n          top: 2px;\n          left: 0;\n\n        }\n  \n        &:after {\n          @include transition(all);\n          transition-duration: 0s;\n          -webkit-transition-duration: 250ms;\n          transition-duration: 250ms;\n          font-family: Material Design Icons;\n          opacity: 0;\n          filter: alpha(opacity=0);\n          -webkit-transform: scale(0);\n          -ms-transform: scale(0);\n          -o-transform: scale(0);\n          transform: scale(0);\n          content: '\\F12C';\n          font-size: 0.875rem;\n          font-weight: bold;\n          color: $white;\n          top: 1px;\n        }\n      }\n      &:checked {\n        +.input-helper {\n          &:before {\n            background: theme-color(primary);\n            border-width: 0;\n          }\n          &:after {\n            width: 18px;\n            opacity: 1;\n            line-height: 18px;\n            filter: alpha(opacity=100);\n            -webkit-transform: scale(1);\n            -ms-transform: scale(1);\n            -o-transform: scale(1);\n            transform: scale(1);\n            color: black;\n          }\n        }\n      }\n\n      &:disabled {\n        + .input-helper {\n          &:before {\n            border-color: $border-color;\n          }\n        }\n\n        &:checked {\n          + .input-helper {\n            &:after {\n              background: $border-color;\n              color: $white;\n            }\n          }\n        }\n      }\n    }\n    input[type=\"radio\"] {\n      +.input-helper {\n        &:before {\n          position: absolute;\n          content: \"\";\n          top: 0;\n          left: 0;\n          .rtl & {\n            left: auto;\n            right: 0;\n          }\n          border: solid theme-color(primary);\n          border-width: 2px;\n          width: 20px;\n          height: 20px;\n          border-radius: 50%;\n          @include transition(all);\n          transition-duration: 0s;\n          -webkit-transition-duration: 250ms;\n          transition-duration: 250ms;\n        }\n\n        &:after {\n          content: \"\";\n          width: 8px;\n          height: 8px;\n          background: $white;\n          border-radius: 50%;\n          top: 6px;\n          left: 6px;\n          .rtl & {\n            left: auto;\n            right: 6px;\n          }\n          -webkit-transition: all;\n          -o-transition: all;\n          transition: all;\n          transition-duration: 0s;\n          -webkit-transition-duration: 250ms;\n          transition-duration: 250ms;\n          opacity: 0;\n          filter: alpha(opacity=0);\n          -webkit-transform: scale(0);\n          -ms-transform: scale(0);\n          -o-transform: scale(0);\n          transform: scale(0);\n          position: absolute;\n        }\n      }\n\n      &:checked {\n        +.input-helper {\n          &:before {\n            background: theme-color(primary);\n            border-width: 0;\n          }\n\n          &:after {\n            opacity: 1;\n            line-height: 1.5;\n            filter: alpha(opacity=100);\n            -webkit-transform: scale(1);\n            -ms-transform: scale(1);\n            -o-transform: scale(1);\n            transform: scale(1);\n          }\n        }\n      }\n\n      &:disabled {\n        + .input-helper {\n          &:before {\n            border-color: $border-color;\n          }\n        }\n\n        &:checked {\n          + .input-helper {\n            &:before {\n              background: $border-color;\n            }\n\n            &:after {\n              background: $white;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .form-check-#{$color} {\n    &.form-check {\n      label {\n        input[type=\"checkbox\"],\n        input[type=\"radio\"] {\n          +.input-helper {\n            &:before {\n              border-color: theme-color($color);\n            }\n          }\n          &:checked {\n            +.input-helper {\n              &:before {\n                background: $value;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.form-check-muted {\n  &.form-check {\n    label {\n      input[type=\"checkbox\"],\n      input[type=\"radio\"] {\n        +.input-helper {\n          &:before {\n            border-color: $text-muted;\n          }\n        }\n        &:checked {\n          +.input-helper {\n            &:before {\n              background: $text-muted;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n","/* Forms */\n\n.form-group {\n  margin-bottom: 1rem;\n}\nlabel{\n  color: #c4c4c4;\n}\n.input-group-append,\n.input-group-prepend {\n  color: $input-placeholder-color;\n  width: auto;\n  border: none;\n\n  .input-group-text {\n    border-color: $border-color;\n    padding: $input-padding-y .75rem;\n    color: $input-placeholder-color;\n    background: none;\n  }\n}\n.form-control {\n  border: 1px solid $border-color;\n  height: calc(2.25rem + 2px);\n  font-weight: normal;\n  font-size: $input-font-size; \n  padding: 0.625rem 0.6875rem;\n  background-color: $input-bg;\n  border-radius: 2px;\n  color: $darkslategray;\n  &:focus {\n    border: 1px solid rgba(71, 164, 71, 0.5);\n    background-color: $input-bg;\n  }\n  &.form-control-lg {\n    padding: 0.94rem .75rem;\n    height: calc(2.875rem + 2px);\n  }\n\n  &.form-control-sm {\n    padding: 0.5rem .75rem;\n    height: calc(1.8125rem + 2px);\n  }\n  &::placeholder {\n    color: $text-muted;\n    font-size: $input-placeholder-font-size;\n  }\n}\n.navbar {\n  .form-control {\n    width: 75%;\n    border-radius: 6px;\n    &:focus {\n      border: none;\n    }\n  }\n}\n\nselect {\n  &.form-control {\n    padding: .4375rem .75rem;\n    border: 0;\n    outline: 1px solid #322f2f;\n    color: $input-placeholder-color;\n    &:focus {\n      outline: 1px solid $border-color;\n    }\n    @each $color, $value in $theme-colors {\n      &.border-#{$color} {\n        outline: 1px solid $value;\n        &:focus {\n          outline: 1px solid $value;\n        }\n      }\n    }\n  }\n}\n.form-group {\n  label {\n    font-size: $default-font-size;\n    line-height: 1;\n    vertical-align: top;\n  }\n  &.has-danger {\n    .form-control {\n      border-color: theme-color(danger);\n    }\n  }\n  .file-upload-default {\n    visibility: hidden;\n    position: absolute;\n  }\n  .file-upload-info {\n    background: transparent;\n  }\n}\n\n.form-check {\n  min-height: 18px;\n  padding-left: 1.25rem;\n}\n\ndiv {\n  &.tagsinput {\n    background: transparent;\n  }\n}\n\n.custom-file {\n  .visibility-hidden {\n  visibility: hidden;\n  }\n  .custom-file-label {\n    background: $input-bg;;\n    border: 1px solid $border-color;\n    height: calc(2.25rem + 2px);\n    font-weight: normal;\n    font-size: 0.875rem;\n    padding: 0.625rem 0.6875rem;\n    border-radius: 2px;\n    &:after {\n      background-color: theme-color(primary);\n      height: auto;\n      @extend .btn-primary;\n    }\n  }\n}","/* Icons */\n\n.icons-list {\n  border-left: 1px solid $border-color;\n  border-bottom: 1px solid $border-color;\n  >div {\n    background: inherit;\n    border-top: 1px solid $border-color;\n    border-right: 1px solid $border-color;\n    @include display-flex;\n    @include align-items(center);\n    padding:15px 15px;\n    font-family: $type1;\n    font-size: $default-font-size;\n\n    i {\n      display: inline-block;\n      font-size: 20px;\n      width: 40px;\n      text-align: left;\n      color: theme-color(primary);\n    }\n  }\n}\n","/* Tables */\n\n.table {\n  margin-bottom: 0;\n  color: $text-muted; \n  thead {\n    th {\n      border-top: 0;\n      border-bottom-width: 1px;\n      font-family: $type1;\n      font-weight: $font-weight-medium;\n      i{\n        margin-left: 0.325rem;\n      }\n    }\n  }\n  th,\n  td {\n    vertical-align: middle;\n    font-size: $default-font-size;\n    line-height: 1;\n    img {\n      width: 30px;\n      height: 30px;\n      border-radius: 100%;\n    }\n    .badge {\n      margin-bottom: 0;\n    }\n  }\n  &.table-borderless{\n    border: none;\n    tr,td,th{\n      border: none;\n    }\n  }\n}\n","/* Buttons */\n\n.btn {\n  font-size: $btn-font-size;\n  line-height: 1;\n  font-weight: normal;\n  i {\n    margin-right: .3125rem;\n  }\n  &.btn-rounded {\n    @include border-radius(50px);\n  }\n  &.btn-fw {\n    min-width: $button-fixed-width;\n  }\n  &.btn-sm {\n    font-size: $btn-font-size-sm;\n  }\n  &.btn-lg {\n    font-size: $btn-font-size-lg;\n  }\n  &.btn-xs {\n    padding: $btn-padding-y-xs $btn-padding-x-xs;\n    font-size: $btn-font-size-xs;\n  }\n  /* Buttons with only icons */\n  &.btn-icon {\n    width: 42px;\n    height: 42px;\n    padding: 0;\n  }\n  /* Buttons with icon and text */\n  &.btn-icon-text {\n    .btn-icon-prepend {\n      margin-right: .5rem;\n    }\n    .btn-icon-append {\n      margin-left: .5rem;\n    }\n  }\n  &.btn-social-icon {\n    width: 50px;\n    height: 50px;\n    padding: 0;\n  }\n  &.get-started-btn {\n    font-size: 0.75rem;\n    border: 1px solid rgba(#ffffff, 0.3);\n    font-weight: $font-weight-medium;\n    padding: 0.9375rem 1.0625rem;\n    @media (max-width: 576px) {\n      font-size: 0.6rem;\n      padding: 0.4375rem 0.6625rem;\n    }\n  }\n}\n\n.btn-group {\n  .btn {\n    + .btn {\n      border-left: 0;\n    }\n  }\n}\n\n.btn-toolbar {\n  .btn-group {\n    +.btn-group {\n      @extend .ml-2;\n    }\n  }\n}\n/*social buttons*/\n@each $color, $value in $social-colors {\n  .btn-#{$color} {\n    @include social-button(social-color($color));\n  }\n  .btn-outline-#{$color} {\n    @include social-outline-button(social-color($color));\n  }\n}\n/* inverse buttons */\n@each $color, $value in $theme-colors {\n  .btn-inverse-#{$color} {\n    @include button-inverse-variant($value);\n  }\n  .btn-#{$color} {\n    &:not(.btn-light):not(.btn-secondary) {\n      color: $white;\n      &:hover,\n      &:focus,\n      &:active {\n        color: $white;\n      }\n      &:focus,\n      &:active {\n        background: $value;\n        border-color: $value;\n      }\n    }\n  }\n}","@mixin social-button($color) {\n  background: $color;\n  color: $white;\n\n  &:hover,\n  &:focus {\n    background: darken($color, 10%);\n    color: $white;\n  }\n  &.btn-social-icon-text {\n    padding: 0 1.5rem 0 0;\n    background: lighten($color, 10%);\n    i {\n      background: $color;\n      padding: .75rem;\n      display: inline-block;\n      margin-right: 1.5rem;\n    }\n  }\n}\n@mixin social-outline-button($color) {\nborder: 1px solid $color;\ncolor: $color;\n&:hover {\n  background: $color;\n  color: $white;\n}\n}\n@mixin button-inverse-variant($color, $color-hover: $white) {\n  background-color: rgba($color, 0.2);\n  background-image: none;\n  border-color: rgba($color, 0);\n  &:not(.btn-inverse-light) {\n    color: $color;      \n  }\n  @include hover {\n    color: $color-hover;\n    background-color: $color;\n    border-color: $color;\n  }\n\n  &.focus,\n  &:focus {\n    box-shadow: 0 0 0 3px rgba($color, .5);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $color;\n    background-color: transparent;\n  }\n\n  &.active,\n  &:active,\n  .show > &.dropdown-toggle {\n    color: $color-hover;\n    background-color: $color;\n    border-color: $color;\n  }\n}\n","/* Breadcrumbs */\n\n.breadcrumb {\n  border: $border-width solid $border-color;\n\n  .breadcrumb-item {\n    font-size: $breadcrumb-font-size;\n\n    &.active {\n      color: rgba($body-color, 0.8);\n    }\n  }\n\n  &.breadcrumb-custom {\n    padding: $breadcrumb-custom-padding-y $breadcrumb-custom-padding-x;\n    border-color: $breadcrumb-item-bg;\n    .breadcrumb-item {\n      font-size: $breadcrumb-font-size;\n      background: $breadcrumb-item-bg;\n      padding: $breadcrumb-custom-item-padding-y $breadcrumb-custom-item-padding-x;\n      color: $breadcrumb-custom-item-color;\n      display: inline-block;\n      vertical-align: top;\n      &:last-child {\n        background: transparent;\n      }\n      &:before{\n        content: \"\";\n      }\n      a {\n        position: relative;\n        color: inherit;\n        border: 1px solid $breadcrumb-item-bg;\n        display: inline-block;\n        vertical-align: top;\n        &:before,&:after{\n          position: absolute;\n          top: -9px;\n          width: 0;\n          height: 0;\n          content: \"\";\n          border-top: 21px solid transparent;\n          border-bottom: 21px solid transparent;\n        }\n        &:before{\n          right: -22px;\n          z-index: 3;\n          border-left-color: $breadcrumb-item-bg;\n          border-left-style: solid;\n          border-left-width: 12px;\n        }\n        &:after{\n          border-top: 21px solid transparent;\n          border-bottom: 22px solid transparent;\n          border-left: 12px solid rgba(255, 255, 255, 0.1);\n          top: -9px;\n          right: -23px;\n        }\n      }\n      span{\n        display: inline-block;\n        vertical-align: top;\n      }\n      &.active {\n        color: rgba($body-color, 0.8);\n      }\n    }\n  }\n}\n\n\n/* inverse breadcrumb */\n@each $color, $value in $theme-colors {\n  .bg-inverse-#{$color} {\n    @include breadcrumb-inverse-variant($value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .bg-#{$color} {\n    &:not(.bg-light) {\n      .breadcrumb-item{\n        color: $white;\n        &:before{\n          color: inherit;\n        }\n        a,span{\n          color: inherit;\n        }\n      }\n    }\n  }\n}","// Color Functions Mixins\n\n// Solid tab variations\n@mixin tab-solid-variant($color) {\n  .nav-link {\n    &.active {\n      background: $color;\n    }\n  }\n}\n// Minimal tab variations\n@mixin tab-minimal-variant($color) {\n  .nav-tabs {\n    .nav-item {\n      .nav-link {\n        &.active {\n          color: $color;\n        }\n      }\n    }\n  }\n}\n// Sider color variations\n@mixin slider-color-variant($color) {\n  .noUi-base {\n    .noUi-connect {\n      background: $color;\n    }\n\n    .noUi-origin {\n      background: $color;\n\n      .noUi-handle {\n        &:after {\n          background: $color;\n        }\n\n        .noUi-tooltip {\n          background: $color;\n          color: $white;\n        }\n      }\n    }\n  }\n}\n// Breadcrumb color variations\n@mixin breadcrumb-inverse-variant($color) {\n  background: rgba($color, 0.25);\n  border-color: $color;\n\n  .breadcrumb-item {\n    color: $color;\n\n    &:before {\n      color: inherit;\n    }\n\n    a {\n      color: inherit;\n    }\n  }\n\n  &.breadcrumb-custom {\n    background: transparent;\n\n    .breadcrumb-item {\n      background: lighten($color, 25%);\n\n      a {\n        color: $color;\n        border: none;\n\n        &:before {\n          border-left-color: lighten($color, 25%);\n        }\n      }\n\n      span {\n        color: $color;\n      }\n\n      &:last-child {\n        background: transparent;\n      }\n    }\n  }\n}\n// Pagination variations\n@mixin pagination-variants($color) {\n  .page-item {\n    &.active {\n      .page-link {\n        background: $color;\n        border-color: $color;\n      }\n    }\n\n    .page-link {\n      &:hover {\n        background: lighten($color,5%);\n        border-color: $color;\n        color: $white;\n      }\n    }\n  }\n}\n// Accordion Inverse variations\n@mixin accordion-inverse-variant($color) {\n  .card {\n    background: rgba($color, 0.16);\n    color: $color;\n    border: none;\n\n    .card-header {\n      color: $color;\n      border: none;\n\n      a,\n      h1,\n      h2,\n      h3,\n      h4,\n      h5,\n      h6,\n      p,\n      span {\n        color: $color;\n      }\n\n      a {\n        border-color: $color;\n\n        &:before {\n          color: $color;\n        }\n\n        &[aria-expanded=\"true\"] {\n          border-bottom: 1px solid rgba($color, 0.16);\n        }\n\n        &[aria-expanded=\"false\"] {\n          border-bottom: 1px solid transparent;\n        }\n      }\n    }\n  }\n}\n","/* Badges */\n\n.badge {\n  border-radius: .25rem;\n  font-size: 0.75rem;\n  font-weight: initial;\n  line-height: 1;\n  padding: .5rem .7rem;\n  font-family: $type1;\n  font-weight: $font-weight-medium;\n  &.badge-pill {\n    border-radius: 10rem;\n  }\n}\n\n\n/*Badge variations*/\n@each $color, $value in $theme-colors {\n  .badge-#{$color} {\n    @include badge-variations($value);\n  }\n}\n\n/*Badge outlined variations*/\n@each $color, $value in $theme-colors {\n  .badge-outline-#{$color} {\n    @include badge-outline-variations($value);\n  }\n}","//Badge Mixins\n\n//Badge vriations\n@mixin badge-variations($color) {\n\tbackground: $color;\n\tcolor: $white;\n}\n// Badge outlined variations\n@mixin badge-outline-variations($color) {\n\tcolor: $color;\n\tborder: 1px solid $color;\n}","/* Cards */\n\n.card {\n  border: none;\n  box-shadow: 0 0.125rem 0.25rem rgb(0 0 0 / 8%) !important;\n  border-radius: $card-border-radius;\n  .card-body {\n    padding: $card-padding-y $card-padding-x;\n    + .card-body {\n      padding-top: 1rem;\n    }\n  }\n  .card-title {\n    color: #c4c4c4;\n    margin-bottom: 1.125rem;\n    text-transform: capitalize;\n  }\n  .card-subtitle {\n    @extend .text-gray;\n    font-weight: normal;\n    margin-top: 0.625rem;\n    margin-bottom: 0.625rem;\n  \n  }\n  .card-description {\n    color: $card-description-color;\n    font-weight: $font-weight-light;\n  }\n  &.card-outline-success {\n\t\tborder: 1px solid theme-color(\"success\");\n\t}\n\t&.card-outline-primary {\n\t\tborder: 1px solid theme-color(\"primary\");\n\t}\n\t&.card-outline-warning {\n\t\tborder: 1px solid theme-color(\"warning\");\n\t}\n\t&.card-outline-danger {\n\t\tborder: 1px solid theme-color(\"danger\");\n\t}\n\t&.card-rounded {\n\t\t@include border-radius(5px);\n\t}\n\n  &.card-faded {\n    background: #b5b0b2;\n    border-color: #b5b0b2;\n  }\n  &.card-circle-progress {\n    color: $white;\n    text-align: center;\n  }\n  &.card-img-holder {\n    position: relative;\n    .card-img-absolute {\n      position: absolute;\n      top:0;\n      right: 0;\n      height: 100%;\n    }\n  }\n  &.corona-gradient-card {\n    background-image: linear-gradient(to left, #d41459, #911a6c);\n    border-radius: 6px;\n    .gradient-corona-img {\n      height: 85px;\n      @media (max-width: 576px) {\n        height: auto;\n        min-height: 50px;\n        max-height: 85px;\n      }\n    }\n    @media (max-width: 576px) {\n     h4 {\n       font-size: 0.75rem;\n     }\n    }\n  }\n}\n\n\n@each $color, $value in $theme-colors {\n  .card-inverse-#{$color} {\n    @include card-inverse-variant(rgba(theme-color($color), .2), theme-color-level($color, 1), theme-color-level($color, 3));\n  }\n}\n","// Cards Mixins \n\n@mixin card-inverse-variant($bg, $border, $color) {\n  background: $bg;\n  border: 1px solid $border;\n  color: $color;\n}\n","/* Preview */\n\n.preview-list {\n  .preview-item {\n    @include display-flex;\n    @include flex-direction(row);\n    @include align-items(flex-start);\n    padding: 1rem 0rem;\n    font-size: .875rem;\n    &:last-child {\n      border-bottom: 0;\n    }\n    .form-check {\n      margin-top: 8px;\n      margin-right: 1rem;\n    }\n    .preview-thumbnail {\n      color: color(white);\n      position: relative;\n      img,\n      .preview-icon {\n        width: 40px;\n        height: 40px;\n        text-align: center;\n        @include display-flex;\n        @include align-items(center);\n        @include justify-content(center);\n        i {\n          font-size: 1.125rem;\n          margin: 0;\n          .rtl & {\n            @extend .ml-0;\n          }\n        }\n      }\n      .badge {\n        border: 2px solid color(white);\n        border-radius: 100%;\n        bottom: 5px;\n        display: block;\n        height: 14px;\n        left: -5px;\n        padding: 0;\n        position: absolute;\n        width: 14px;\n        &.badge-online {\n          @extend .badge-success;\n        }\n        &.badge-offline {\n          @extend .badge-info;\n        }\n        &.badge-busy {\n          @extend .badge-warning;\n        }\n      }\n    }\n    .preview-item-content {\n      line-height: 1;\n      padding-left: 15px;\n      &:first-child {\n        padding-left: 0;\n      }\n      p {\n        margin-bottom: 10px;\n        line-height: 1;\n        .content-category {\n          font-family: 'source-sans-pro-semibold', sans-serif;\n          padding-right: 15px;\n          border-right: 1px solid $border-color;\n          @extend .text-muted;\n        }\n      }\n      .rtl & {\n        padding-left: 0;\n        padding-right: 1rem;\n        margin-right: 0;\n        margin-left: auto;\n      }\n    }\n    .preview-actions {\n      @include display-flex;\n      @include flex-direction(row);\n      i {\n        width: 29px;\n        color: color(gray-lightest);\n        height: 29px;\n        border: 2px solid color(gray-lightest);\n        border-radius: 100%;\n        padding: 3px 6px;\n        display: inline-block;\n        &:first-child {\n          margin-right: 10px;\n        }\n      }\n    }\n  }\n  &.comment-preview {\n    .preview-item {\n      padding: .87rem 0;\n      &:first-child {\n        padding-top: 0;\n      }\n      p {\n        line-height: 27px;\n      }\n    }\n  }\n  &.bordered {\n    .preview-item {\n      border-bottom: 1px solid $border-color;\n      &:last-child {\n        border-bottom: 0;\n      }\n    }\n  }\n}\n\n\n\n@each $color, $value in $theme-colors {\n  .icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    &.icon-box-#{$color} {\n      width: 40px;\n      height: 37px;\n      background: rgba($value, 0.11);\n      border-radius: 7px;\n      color: $value;\n    }\n    .icon-item {\n      font-size: 20px;\n    }\n  }\n}\n\n\n\n\n","/* Lists */\n\nul,\nol,\ndl {\n  padding-left: 1rem;\n  font-size: $default-font-size;\n  li {\n    line-height: 1.8;\n  }\n}\n\n.list-ticked,\n.list-arrow,\n.list-star {\n  list-style: none;\n  padding: 0;\n  li {\n    padding-left: 1.5rem;\n    &:before {\n      font-family: \"Material Design Icons\";\n      margin-left: -1.5rem;\n      width: 1.5rem;\n      margin-right: .5rem;\n    }\n  }\n}\n\n.list-ticked {\n  li {\n    &:before {\n      content: '\\F12D';\n      color: theme-color(danger);\n    }\n  }\n}\n\n.list-arrow {\n  li {\n    &:before {\n      content: '\\F142';\n      color: theme-color(success);\n    }\n  }\n}\n\n.list-star {\n  li {\n    &:before {\n      content: '\\F4CE';\n      color: theme-color(warning);\n    }\n  }\n}\n\n.gradient-bullet-list {\n  padding-left: 0;\n  .rtl & {\n    padding-right: 0;\n  }\n  li {\n    position: relative;\n    list-style-type: none;\n    padding-left: 25px;\n    line-height: 1;\n    padding-bottom: 25px;\n    &:before,\n    &:after {\n      content:\"\";\n      position: absolute;\n    }\n    &:before {\n      top: 0;\n      left: 0;\n      width: 15px;\n      height: 15px;\n      border-radius: 100%;\n    }\n    &:after {\n      width: 11px;\n      height: 11px;\n      top: 2px;\n      left: 2px;\n      background: $white;\n      border-radius: 100%;\n    }\n    &:nth-child(1) {\n      &:before {\n        background: theme-color(danger);        \n      }\n    }\n    &:nth-child(2) {\n      &:before {\n        background: theme-color(info);        \n      }\n    }\n    &:nth-child(3) {\n      &:before {\n        background: theme-color(warning);        \n      }\n    }\n    &:nth-child(4) {\n      &:before {\n        background: theme-color(success);        \n      }\n    }\n    &:nth-child(5) {\n      &:before {\n        background: theme-color(primary);        \n      }\n    }\n  }\n}\n\n.bullet-line-list {\n  padding-left: 30px;\n  margin-bottom: 0;\n  position: relative;\n  list-style-type: none;\n\n  .rtl & {\n    padding-right: 0px;\n  }\n\n  li {\n    position: relative;\n    line-height: 1;\n    padding-bottom: 10px;\n\n    &:before {\n      content: \"\";\n      position: absolute;\n      border-radius: 100%;\n      width: 12px;\n      height: 12px;\n      left: -28px;\n      top: 6px;\n      border: 3px solid theme-color(primary);\n      margin-right: 15px;\n      z-index: 2;\n      background: $bullet-line-list-shape-bg;\n    }\n\n    &:after {\n      content: \"\";\n      border: 1px solid $border-color;\n      position: absolute;\n      bottom: 0;\n      left: -23px;\n      height: 100%;\n    }\n\n    &:first-child {\n      &:after {\n        content: \"\";\n        height: 80%;\n      }\n    }\n\n    &:last-child {\n      padding-bottom: 0;\n\n      &:after {\n        content: \"\";\n        top: 0;\n        height: 30%;\n      }\n    }\n  }\n}","/* Todo list */\n\n.add-items {\n  margin-bottom: 1.5rem;\n  overflow: hidden;\n  input[type=\"text\"] {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n    width: 100%;\n    background: transparent;\n  }\n  .btn {\n    margin-left: .5rem;\n    .rtl & {\n      margin-left: auto;\n      margin-right: .5rem;\n    }\n  }\n}\n\n.list-wrapper {\n  height: 100%;\n  max-height: 100%;\n  ul {\n    padding: 0;\n    text-align: left;\n    list-style: none;\n    margin-bottom: 0;\n    li {\n      @extend .d-flex;\n      @extend .align-items-center;\n      @extend .justify-content-start;\n      font-size: .9375rem;\n      padding: .8rem 0;\n      border-bottom: 1px solid $border-color;\n      &:last-child {\n        border-bottom: none;\n      }\n      .form-check{\n        @extend %ellipsor;\n        max-width: 90%;\n        margin-top: .25rem;\n        margin-bottom: .25rem;\n        .form-check-label{\n          @extend%ellipsor;\n\n          input {\n            width: 20px;\n            height: 20px;\n          }\n        }\n      }\n    }\n  }\n\n  input[type=\"checkbox\"] {\n    margin-right: 15px;\n  }\n\n  .remove {\n    @extend .ml-auto;\n    @extend .text-secondary;\n    .rtl & {\n      @extend .ml-0;\n      @extend .mr-auto;\n    }\n    cursor: pointer;\n    font-size: 1.125rem;\n    font-weight: 600;\n    width: 1.25rem;\n    height: 1.25rem;\n    line-height: 20px;\n    text-align: center;\n  }\n\n  .completed {\n    text-decoration: line-through;\n    text-decoration-color: theme-color(primary);\n    .remove {\n      @extend .text-primary;\n    }\n  }\n}\n","// /* Dropdowns */\n\n.dropdown {\n  .dropdown-toggle{\n    &.no-caret {\n      &::after {\n        display: none;\n      }\n    }\n  }\n  .dropdown-menu {\n    margin-top: .75rem;\n    font-size: $default-font-size;\n    box-shadow: $dropdown-menu-box-shadow;\n    .dropdown-item {\n      font-size: 1rem;\n      padding: .25rem 1.5rem;\n      &:active {\n        background: initial;\n      }\n      &:hover {\n        color: $dropdown-item-hover-color;\n      }\n    }\n    &.sidebar-dropdown {\n      &.dropdown-menu-right {\n        .rtl & {\n          left: 10rem !important;\n        }\n      }\n    }\n  }\n}","/* Loaders */\n\n@import \"variables\";\n@import \"colored-balls\";\n@import \"glowing-ball\";\n@import \"pixel-loader\";\n@import \"square-box\";\n@import \"circle-loader\";\n@import \"jumping-dots-loader\";\n@import \"bar-loader\";\n@import \"square-path-loader\";\n@import \"dot-opacity-loader\";\n@import \"flip-square-loader\";\n@import \"moving-square-loader\";","#pgloading {\n\tposition: static; \n\t.bokeh {\n    font-size: 100px;\n    width: 1em;\n    height: 1em;\n    position: relative;\n    margin: 0 auto;\n    border-radius: 50%;\n    border: .01em solid $border-color;\n    list-style: none;\n\t\tpadding:0;\n\t\tli {\n\t\t\tposition: absolute;\n\t\t\twidth: .2em;\n\t\t\theight: .2em;\n\t\t\tborder-radius: 50%;\n\t\t\t&:nth-child(1) {\n\t\t\t\tleft: 50%;\n\t\t\t\ttop: 0;\n\t\t\t\tmargin: 0 0 0 -.1em;\n\t\t\t\tbackground: theme-color(success);\n\t\t\t\t-webkit-transform-origin: 50% 250%;\n\t\t\t\ttransform-origin: 50% 250%;\n\t\t\t\t-webkit-animation: \n\t\t\t\t\t\trota 1.13s linear infinite,\n\t\t\t\t\t\topa 3.67s ease-in-out infinite alternate;\n\t\t\t\tanimation: \n\t\t\t\t\t\trota 1.13s linear infinite,\n\t\t\t\t\t\topa 3.67s ease-in-out infinite alternate;\n\t\t\t}\n\t\t\t&:nth-child(2) {\n\t\t\t\ttop: 50%; \n\t\t\t\tright: 0;\n\t\t\t\tmargin: -.1em 0 0 0;\n\t\t\t\tbackground: theme-color(danger);\n\t\t\t\t-webkit-transform-origin: -150% 50%;\n\t\t\t\ttransform-origin: -150% 50%;\n\t\t\t\t-webkit-animation: \n\t\t\t\t\t\trota 1.86s linear infinite,\n\t\t\t\t\t\topa 4.29s ease-in-out infinite alternate;\n\t\t\t\tanimation: \n\t\t\t\t\t\trota 1.86s linear infinite,\n\t\t\t\t\t\topa 4.29s ease-in-out infinite alternate;\n\t\t\t}\n\t\t\t&:nth-child(3) {\n\t\t\t\tleft: 50%; \n\t\t\t\tbottom: 0;\n\t\t\t\tmargin: 0 0 0 -.1em;\n\t\t\t\tbackground: theme-color(warning);\n\t\t\t\t-webkit-transform-origin: 50% -150%;\n\t\t\t\ttransform-origin: 50% -150%;\n\t\t\t\t-webkit-animation: \n\t\t\t\t\t\trota 1.45s linear infinite,\n\t\t\t\t\t\topa 5.12s ease-in-out infinite alternate;\n\t\t\t\tanimation: \n\t\t\t\t\t\trota 1.45s linear infinite,\n\t\t\t\t\t\topa 5.12s ease-in-out infinite alternate;\n\t\t\t}\n\t\t\t&:nth-child(4) {\n\t\t\t\ttop: 50%; \n\t\t\t\tleft: 0;\n\t\t\t\tmargin: -.1em 0 0 0;\n\t\t\t\tbackground: theme-color(primary);\n\t\t\t\t-webkit-transform-origin: 250% 50%;\n\t\t\t\ttransform-origin: 250% 50%;\n\t\t\t\t-webkit-animation: \n\t\t\t\t\t\trota 1.72s linear infinite,\n\t\t\t\t\t\topa 5.25s ease-in-out infinite alternate;\n\t\t\t\tanimation: \n\t\t\t\t\t\trota 1.72s linear infinite,\n\t\t\t\t\t\topa 5.25s ease-in-out infinite alternate;\n\t\t\t}\n\t\t}\n\t}\n}\n\n@-webkit-keyframes rota {\n    from { }\n    to { -webkit-transform: rotate(360deg); }\n}\n\n@keyframes rota {\n    from { }\n    to { -webkit-transform: rotate(360deg); transform: rotate(360deg); }\n}\n\n@-webkit-keyframes opa {\n    0% { }\n    12.0% { opacity: 0.80; }\n    19.5% { opacity: 0.88; }\n    37.2% { opacity: 0.64; }\n    40.5% { opacity: 0.52; }\n    52.7% { opacity: 0.69; }\n    60.2% { opacity: 0.60; }\n    66.6% { opacity: 0.52; }\n    70.0% { opacity: 0.63; }\n    79.9% { opacity: 0.60; }\n    84.2% { opacity: 0.75; }\n    91.0% { opacity: 0.87; }\n}\n\n@keyframes opa {\n    0% { }\n    12.0% { opacity: 0.80; }\n    19.5% { opacity: 0.88; }\n    37.2% { opacity: 0.64; }\n    40.5% { opacity: 0.52; }\n    52.7% { opacity: 0.69; }\n    60.2% { opacity: 0.60; }\n    66.6% { opacity: 0.52; }\n    70.0% { opacity: 0.63; }\n    79.9% { opacity: 0.60; }\n    84.2% { opacity: 0.75; }\n    91.0% { opacity: 0.87; }\n}",".glowing-loader {\n\tposition: relative;\n}\n.s2 {\n  position: absolute;\n  height: 70px;\n\twidth: 70px;\n\ttop: 50px;\n  background-color: transparent;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.s1 {\n  position: absolute;\n  height: 70px;\n  width: 70px;\n\tleft: 50%;\n\ttop: 50px;\n  transform-origin: center;\n  transform: translate(-50%, -50%) rotate(45deg);\n  background-color: transparent;\n}\n\n.bigcon {\n  position: absolute;\n  height: 75px;\n  width: 75px;\n\tleft: 50%;\n\ttop: 50px;\n  transform-origin: center;\n  transform: translate(-50%, -50%) rotate(-45deg);\n  background-color: transparent;\n  animation: bigcon 2s infinite linear;\n  animation-delay: 0.25s;\n}\n\n.b {\n  border-radius: 50%;\n  position: absolute;\n}\n\n.s {\n  width: 15px;\n  height: 15px;\n  animation: small 2s infinite ease;\n  box-shadow: 0px 2px rgba($black, .3);\n   background-color: theme-color(primary);\n}\n\n.s:nth-child(1) {\n  top: 0%;\n  left: 0%;\n}\n\n.s:nth-child(2) {\n  top: 0%;\n  right: 0%;\n}\n\n.s:nth-child(3) {\n  right: 0%;\n  bottom: 0%;\n}\n\n.s:nth-child(4) {\n  bottom: 0%;\n  left: 0%;\n}\n\n.big {\n  width: 15px;\n  height: 15px;\n  border-radius: 15px;\n  box-shadow:0px 0px 10px theme-color(primary), 0px 0px 20px theme-color(primary), 0px 0px 30px theme-color(primary), 0px 0px 50px theme-color(primary), 0px 0px 60px theme-color(primary) ;\n  z-index: 1;\n  background-color: theme-color(primary);\n  animation: bigball 1s infinite linear;\n}\n\n.sb1{\n  animation-delay: -1.75s;\n}\n.sb6{\n  animation-delay: -1.5s;\n}\n.sb2{\n  animation-delay: -1.25s;\n}\n.sb7{\n  animation-delay: -1s;\n}\n.sb3{\n  animation-delay: -0.75s;\n}\n.sb8{\n  animation-delay: -0.5s;\n}\n.sb4{\n  animation-delay: -0.25s;\n}\n.sb5{\n  animation-delay: -0s;\n}\n\n@keyframes bigcon {\n  0% {\n    transform-origin: center;\n    transform: translate(-50%, -50%) rotate(45deg);\n  }\n  100% {\n    transform-origin: center;\n    transform: translate(-50%, -50%) rotate(405deg);\n  }\n}\n\n@keyframes small {\n  0% {\n    transform: scale(1);\n     background-color: lighten(theme-color(primary), 20%);\n  }\n  10% {\n    transform: scale(1.3);\n    background-color: theme-color(primary);\n  }\n  15% {\n    transform: scale(1);\n  }\n  25%{\ntransform: scale(1);\n     background-color: theme-color(primary);\n  }\n  100%{\n    transform: scale(1);\n     background-color: theme-color(primary);\n  }\n}","/* Pixel loader */\n.pixel-loader {\n    width: 10px;\n    height: 10px;\n    background: theme-color(warning);\n    color: theme-color(warning);\n    margin: 80px auto;\n    box-shadow: 15px 15px  0 0,\n                  -15px -15px  0 0,\n                  15px -15px  0 0,\n                  -15px 15px  0 0,\n                  0 15px  0 0,\n                  15px 0  0 0,\n                  -15px 0  0 0,\n                  0 -15px 0 0;\n    animation: anim 2s linear infinite;\n  }\n  \n  @keyframes anim {\n    0% {\n      -webkit-filter: hue-rotate(0deg);\n    }\n    50% {\n      box-shadow: 20px 20px  0 0,\n                  -20px -20px  0 0,\n                  20px -20px  0 0,\n                  -20px 20px  0 0,\n                  0 10px  0 0,\n                  10px 0  0 0,\n                  -10px 0  0 0,\n                  0 -10px 0 0;\n    }\n    \n    75% {\n      box-shadow: 20px 20px  0 0,\n                  -20px -20px  0 0,\n                  20px -20px  0 0,\n                  -20px 20px  0 0,\n                  0 10px  0 0,\n                  10px 0  0 0,\n                  -10px 0  0 0,\n                  0 -10px 0 0;\n    }\n    \n    100% {\n      transform: rotate(360deg);\n      -webkit-filter: hue-rotate(360deg);\n    }\n  }\n  ","/* Square box loader */\n\n@keyframes dyinglight {\n\t15% {\n\t\ttransform: scale(1.6)\n\t}\n\t50% {\n\t\ttransform: rotate(-89deg)\n\t}\n\t100% {\n\t\ttransform: rotate(-90deg)\n\t}\n}\n  \n  \n.square-box-loader {\nposition: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  display: inline-block;\n}\n  \n\n.square-box-loader-square {\n  display: block;\n  width: $square-size;\n  height: $square-size;\n  background: theme-color(primary);\n}\n  \n\n.square-box-loader-container {\nposition: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  transform-origin: 50% 50% 0;\n  animation: dyinglight 1s ease infinite;\n  backface-visibility: hidden;\n}\n  \n\n.square-box-loader-corner-top:before,\n.square-box-loader-corner-top:after,\n.square-box-loader-corner-bottom:before,\n.square-box-loader-corner-bottom:after {\n\tposition: absolute;\n  width: $square-corner-size;\n  height: $square-corner-size;\n  color: theme-color(primary);\n  content: '';\n}\n  \n\n.square-box-loader-corner-top {\n\t&:before {\n\t\tborder-left: 1px solid;\n\t\tborder-top: 1px solid;\n\t\ttop: -$square-corner-position;\n\t\tleft: -$square-corner-position;\n\t}\n\t\n\t&:after {\n\t\tborder-right: 1px solid;\n\t\tborder-top: 1px solid;\n\t\ttop: -$square-corner-position;\n\t\tright: -$square-corner-position;\n\t}\n\t\n}\n  \n\n.square-box-loader-corner-bottom {\n\t&:before {\n\t\tborder-left: 1px solid;\n\t\tborder-bottom: 1px solid;\n\t\tbottom: -$square-corner-position;\n\t\tleft: -$square-corner-position;\n\t}\n\t\n\t&:after {\n\t\tborder-right: 1px solid;\n\t\tborder-bottom: 1px solid;\n\t\tbottom: -$square-corner-position;\n\t\tright: -$square-corner-position;\n\t}\n\t\n}","$square-box-scale: 3;\n$square-size: 30px;\n$square-corner-size: ceil($square-size / $square-box-scale);\n$square-corner-position: ceil($square-corner-size / $square-box-scale);","/* Circle loader */\n.circle-loader {\n    width: 70px;\n    height: 70px;\n    border-radius: 100%;\n    position: relative;\n    margin: 0 auto;\n}\n.circle-loader:before, .circle-loader:after{\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border-radius: 100%;\n    border: 10px solid transparent;\n    border-top-color: theme-color(warning);\n  }\n  \n  .circle-loader:before{\n    z-index: 10;\n    animation: spin 1s infinite;\n  }\n  \n  .circle-loader:after{\n    border: 10px solid theme-color(secondary);\n  }\n  \n  @keyframes spin{\n    0%{\n      -webkit-transform: rotate(0deg);\n      -ms-transform: rotate(0deg);\n      -o-transform: rotate(0deg);\n      transform: rotate(0deg);\n    }\n  \n    100%{\n      -webkit-transform: rotate(360deg);\n      -ms-transform: rotate(360deg);\n      -o-transform: rotate(360deg);\n      transform: rotate(360deg);\n    }\n  }\n  ","/* Jumping dots loader */\n.jumping-dots-loader {\n    width: 100px;\n    height: 100px;\n    border-radius: 100%;\n    position: relative;\n    margin: 0 auto;\n}\n.jumping-dots-loader span{\n    display: inline-block;\n    width: 20px;\n    height: 20px;\n    border-radius: 100%;\n    background-color: rgba(theme-color(danger), .8);\n    margin: 35px 5px;\n  }\n  \n  .jumping-dots-loader span:nth-child(1){\n    animation: bounce 1s ease-in-out infinite;\n  }\n  \n  .jumping-dots-loader span:nth-child(2){\n    animation: bounce 1s ease-in-out 0.33s infinite;\n  }\n  \n  .jumping-dots-loader span:nth-child(3){\n    animation: bounce 1s ease-in-out 0.66s infinite;\n  }\n  \n  @keyframes bounce{\n    0%, 75%, 100%{\n      -webkit-transform: translateY(0);\n      -ms-transform: translateY(0);\n      -o-transform: translateY(0);\n      transform: translateY(0);\n    }\n  \n    25%{\n      -webkit-transform: translateY(-20px);\n      -ms-transform: translateY(-20px);\n      -o-transform: translateY(-20px);\n      transform: translateY(-20px);\n    }\n  }\n  ","/* Bar loader */\n.bar-loader{\n  width: 50px;\n  height: 50px;\n  border-radius: 100%;\n  position: relative;\n  margin: 0 auto;\n}\n\n.bar-loader span{\n  display: inline-block;\n  width: 5px;\n  height: 30px;\n  background-color: rgba(theme-color(danger), .7);\n}\n\n.bar-loader span:nth-child(1){\n  animation: grow 1s ease-in-out infinite;\n}\n\n.bar-loader span:nth-child(2){\n  animation: grow 1s ease-in-out 0.15s infinite;\n}\n\n.bar-loader span:nth-child(3){\n  animation: grow 1s ease-in-out 0.30s infinite;\n}\n\n.bar-loader span:nth-child(4){\n  animation: grow 1s ease-in-out 0.45s infinite;\n}\n\n@keyframes grow{\n  0%, 100%{\n    -webkit-transform: scaleY(1);\n    -ms-transform: scaleY(1);\n    -o-transform: scaleY(1);\n    transform: scaleY(1);\n  }\n\n  50%{\n    -webkit-transform: scaleY(1.8);\n    -ms-transform: scaleY(1.8);\n    -o-transform: scaleY(1.8);\n    transform: scaleY(1.8);\n  }\n}\n","/* Square path loader */\n\n.square-path-loader {\n    width: 100px;\n    height: 100px;\n    border-radius: 100%;\n    position: relative;\n    margin: 0 auto;\n}\n.square-path-loader:before, .square-path-loader:after{\n    content: \"\";\n    width: 15px;\n    height: 15px;\n    position: absolute;\n    top: 0;\n    left: calc(50% - 10px);\n    background-color: rgba(theme-color(success), .7);\n    animation: squaremove 1s ease-in-out infinite;\n  }\n  \n  .square-path-loader:after{\n    bottom: 0;\n    animation-delay: 0.5s;\n  }\n  \n  @keyframes squaremove{\n    0%, 100%{\n      -webkit-transform: translate(0,0) rotate(0);\n      -ms-transform: translate(0,0) rotate(0);\n      -o-transform: translate(0,0) rotate(0);\n      transform: translate(0,0) rotate(0);\n    }\n  \n    25%{\n      -webkit-transform: translate(40px,40px) rotate(45deg);\n      -ms-transform: translate(40px,40px) rotate(45deg);\n      -o-transform: translate(40px,40px) rotate(45deg);\n      transform: translate(40px,40px) rotate(45deg);\n    }\n  \n    50%{\n      -webkit-transform: translate(0px,80px) rotate(0deg);\n      -ms-transform: translate(0px,80px) rotate(0deg);\n      -o-transform: translate(0px,80px) rotate(0deg);\n      transform: translate(0px,80px) rotate(0deg);\n    }\n  \n    75%{\n      -webkit-transform: translate(-40px,40px) rotate(45deg);\n      -ms-transform: translate(-40px,40px) rotate(45deg);\n      -o-transform: translate(-40px,40px) rotate(45deg);\n      transform: translate(-40px,40px) rotate(45deg);\n    }\n  }\n  ","/* Dot opacity loader */\n\n.dot-opacity-loader {\n    width: 100px;\n    height: 100px;\n    border-radius: 100%;\n    position: relative;\n    margin: 0 auto;\n}\n\n.dot-opacity-loader span{\n    display: inline-block;\n    width: 20px;\n    height: 20px;\n    border-radius: 100%;\n    background-color: theme-color(primary);\n    margin: 35px 5px;\n    opacity: 0;\n}\n  \n.dot-opacity-loader span:nth-child(1){\n    animation: opacitychange 1s ease-in-out infinite;\n}\n\n.dot-opacity-loader span:nth-child(2){\n    animation: opacitychange 1s ease-in-out 0.33s infinite;\n}\n\n.dot-opacity-loader span:nth-child(3){\n    animation: opacitychange 1s ease-in-out 0.66s infinite;\n}\n  \n@keyframes opacitychange{\n    0%, 100%{\n        opacity: 0;\n    }\n\n    60%{\n        opacity: 1;\n    }\n}","/* Flip square */\n\n  .flip-square-loader{\n    -webkit-perspective: 120px;\n    -moz-perspective: 120px;\n    -ms-perspective: 120px;\n    perspective: 120px;\n    width: 100px;\n    height: 100px;\n    border-radius: 100%;\n    position: relative;\n    margin: 0 auto;\n  }\n  \n  .flip-square-loader:before{\n    content: \"\";\n    position: absolute;\n    left: 25px;\n    top: 25px;\n    width: 50px;\n    height: 50px;\n    background-color: rgba(theme-color(success), .7);\n    animation: flip 1s infinite;\n  }\n  \n  @keyframes flip {\n    0% {\n      transform: rotate(0);\n    }\n  \n    50% {\n      transform: rotateY(180deg);\n    }\n  \n    100% {\n      transform: rotateY(180deg)  rotateX(180deg);\n    }\n  }","/* Moving square loader */\n\n.moving-square-loader {\n    width: 100px;\n    height: 100px;\n    border-radius: 100%;\n    position: relative;\n    margin: 0 auto;\n}\n.moving-square-loader:before{\n    content: \"\";\n    position: absolute;\n    width: 10px;\n    height: 10px;\n    top: calc(50% - 10px);\n    left: 0px;\n    background-color: rgba(theme-color(danger), .7);\n    animation: rotatemove 1s infinite;\n  }\n  \n  @keyframes rotatemove{\n    0%{\n      -webkit-transform: scale(1) translateX(0px);\n      -ms-transform: scale(1) translateX(0px);\n      -o-transform: scale(1) translateX(0px);\n      transform: scale(1) translateX(0px);\n    }\n  \n    100%{\n      -webkit-transform: scale(2) translateX(45px);\n      -ms-transform: scale(2) translateX(45px);\n      -o-transform: scale(2) translateX(45px);\n      transform: scale(2) translateX(45px);\n    }\n  }\n  ","/* Auth */\n\n.auth {\n\theight: 100%;\n\t.login-half-bg {\n\t\tbackground: url(\"../../../images/auth/login-bg.jpg\");\n\t\tbackground-size: cover;\n\t}\n\t.register-half-bg {\n\t\tbackground: url(\"../../../images/auth/register-bg.jpg\");\n\t\tbackground-size: cover;\n\t}\n\t&.lock-full-bg {\n\t\tbackground: url(\"../../../images/auth/lockscreen-bg.jpg\");\n\t\tbackground-size: cover;\n\t}\n\t.lock-profile-img {\n\t\twidth: 90px;\n\t\theight: 90px;\n\t\tborder-radius: 100%;\n\t}\n\t.auth-form-light {\n\t\tbackground: $white;\n\t\tselect {\n\t\t\tcolor: $input-placeholder-color;\n\t\t}\n\t\t.input-group {\n\t\t\t.form-control {\n\t\t\t\t&:focus,\n\t\t\t\t&:active {\n\t\t\t\t\tborder-color: $border-color;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.auth-form-dark {\n\t\tbackground: $card-bg;\n\t\tselect {\n\t\t\tcolor: $input-placeholder-color;\n\t\t}\n\t\t.input-group {\n\t\t\t.form-control {\n\t\t\t\t&:focus,\n\t\t\t\t&:active {\n\t\t\t\t\tborder-color: $border-color;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.auth-form-transparent {\n\t\tbackground: transparent;\n\t\t.form-control,\n\t\t.input-group-text {\n\t\t\tborder-color: theme-color(secondary);\n\t\t\t&:focus,\n\t\t\t&:active {\n\t\t\t\tborder-color: theme-color(secondary);\n\t\t\t}\n\t\t}\n\t\tselect {\n\t\t\toutline-color: theme-color(secondary);\n\t\t}\n\t}\n\t&.auth-img-bg {\n\t\tpadding: 0;\n\t\t.auth-form-transparent {\n\t\t\t@media (min-width:768px) {\n\t\t\t\twidth: 55%;\n\t\t\t\tmargin: auto;\n\t\t\t}\n\t\t}\n\t}\n\t.brand-logo {\n\t\tmargin-bottom: 2rem;\n\t\timg {\n\t\t\twidth: 150px;\n\t\t}\n\t}\n\tform {\n\t\t.form-group {\n\t\t\tmargin-bottom: 1.5rem;\n\t\t\tlabel {\n\t\t\t\tfont-size: .8125rem;\n\t\t\t}\n\t\t\t.form-control {\n\t\t\t\tbackground: transparent;\n\t\t\t\tborder-radius: 0;\n\t\t\t\tfont-size: .9375rem;\n\t\t\t}\n\t\t}\n\t\t.auth-form-btn {\n\t\t\tpadding: 1rem 2rem;\n\t\t\tline-height: 1.5;\n\t\t}\n\t\t.auth-link {\n\t\t\tfont-size: $default-font-size;\n\t\t\t&:hover {\n\t\t\t\tcolor: initial;\n\t\t\t}\n\t\t}\n\t}\n}","/* Slick-carousel */\n\n.slick-slider {\n  .slick-arrow {\n    &.slick-prev,\n    &.slick-next {\n      z-index: 999;\n      width: 60px;\n      height: 60px;\n      background: rgba(0, 0, 0, 0.5);\n      border-radius: 100%;\n      font-weight: bold;\n      line-height: 2;\n      &::before {\n        font-family: \"Material Design Icons\";\n        font-size: 1.875rem;\n        font-weight: bold;\n        opacity: 1;\n      }\n    }\n    &.slick-prev {\n      left: 25px;\n\n      &::before {\n        content: \"\\F141\";\n        .rtl & {\n          content: \"\\F142\";\n        }\n      }\n    }\n    &.slick-next {\n      right: 25px;\n      &::before {\n        content: \"\\F142\";\n        .rtl & {\n          content: \"\\F141\";\n        }\n      }\n    }\n  }\n  .slick-list {\n    .slick-track {\n      .slick-slide {\n        position: relative;\n        color: $white;\n      }\n    }\n  }\n  .slick-dots {\n    li {\n      button {\n        &::before {\n          content: \"\";\n          width: 10px;\n          height: 10px;\n          border-radius: 100%;\n          background-color: #D6D6D6;\n        }\n      }\n\n      &.active {\n        button {\n          &::before {\n            background-color: #869791;\n          }\n        }\n      }\n    }\n  }\n\n  &.portfolio-slider {\n    .slick-arrow {\n      &.slick-prev,\n      &.slick-next {\n        height: 32px;\n        width: 32px;\n        bottom: 100%;\n        top: auto;\n        &::before{\n          color: #a7afb7;\n          font-size: 1.25rem;\n          font-weight: normal;\n        }\n      }\n  \n      &.slick-prev {\n        right: 35px;\n        left: auto;\n        .rtl & {\n          left: 35px;\n          right: auto;\n        }\n      }\n      \n      &.slick-next {\n        right: 0;\n        .rtl & {\n          left: 0;\n          right: auto;\n        }\n      }\n    }\n    .slick-list {\n      .slick-track {\n        .slick-slide {\n          img {\n            border-radius: 4px;\n            width: 100%;\n          }\n        }\n      }\n    }\n  }\n}","svg {\n    touch-action: none;\n}\n\n.jvectormap-container {\n    width: 100%;\n    height: 100%;\n    position: relative;\n    overflow: hidden;\n    touch-action: none;\n}\n\n.jvectormap-tip {\n    position: absolute;\n    display: none;\n    border: solid 1px #CDCDCD;\n    border-radius: 3px;\n    background: #292929;\n    color: white;\n    font-family: sans-serif, Verdana;\n    font-size: smaller;\n    padding: 3px;\n}\n\n.jvectormap-zoomin, .jvectormap-zoomout, .jvectormap-goback {\n    position: absolute;\n    left: 10px;\n    border-radius: 3px;\n    background: #292929;\n    padding: 3px;\n    color: white;\n    cursor: pointer;\n    line-height: 10px;\n    text-align: center;\n    box-sizing: content-box;\n}\n\n.jvectormap-zoomin, .jvectormap-zoomout {\n    width: 10px;\n    height: 10px;\n}\n\n.jvectormap-zoomin {\n    top: 10px;\n}\n\n.jvectormap-zoomout {\n    top: 30px;\n}\n\n.jvectormap-goback {\n    bottom: 10px;\n    z-index: 1000;\n    padding: 6px;\n}\n\n.jvectormap-spinner {\n    position: absolute;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    background: center no-repeat url(data:image/gif;base64,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);\n}\n\n.jvectormap-legend-title {\n    font-weight: bold;\n    font-size: 14px;\n    text-align: center;\n}\n\n.jvectormap-legend-cnt {\n    position: absolute;\n}\n\n.jvectormap-legend-cnt-h {\n    bottom: 0;\n    right: 0;\n}\n\n.jvectormap-legend-cnt-v {\n    top: 0;\n    right: 0;\n}\n\n.jvectormap-legend {\n    background: black;\n    color: white;\n    border-radius: 3px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend {\n    float: left;\n    margin: 0 10px 10px 0;\n    padding: 3px 3px 1px 3px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend .jvectormap-legend-tick {\n    float: left;\n}\n\n.jvectormap-legend-cnt-v .jvectormap-legend {\n    margin: 10px 10px 0 0;\n    padding: 3px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend-tick {\n    width: 40px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend-tick-sample {\n    height: 15px;\n}\n\n.jvectormap-legend-cnt-v .jvectormap-legend-tick-sample {\n    height: 20px;\n    width: 20px;\n    display: inline-block;\n    vertical-align: middle;\n}\n\n.jvectormap-legend-tick-text {\n    font-size: 12px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend-tick-text {\n    text-align: center;\n}\n\n.jvectormap-legend-cnt-v .jvectormap-legend-tick-text {\n    display: inline-block;\n    vertical-align: middle;\n    line-height: 20px;\n    padding-left: 3px;\n}\n.map {\n  width: 100%;\n  height: 500px;\n  @media (max-width: 767px) { \n    height: 100px;\n  }\n}",".navbar {\r\n  font-weight: normal;\r\n  background-color: #fff;\r\n  color: #000;\r\n  left: $sidebar-width-lg;\r\n  transition: left $action-transition-duration $action-transition-timing-function;\r\n  -webkit-transition: left $action-transition-duration $action-transition-timing-function;\r\n  -moz-transition: left $action-transition-duration $action-transition-timing-function;\r\n  -ms-transition: left $action-transition-duration $action-transition-timing-function;\r\n  @media (max-width: 992px) {\r\n    left: 0;\r\n  }\r\n\r\n  .navbar-brand-wrapper {\r\n    transition: width $action-transition-duration $action-transition-timing-function, background $action-transition-duration $action-transition-timing-function;\r\n    -webkit-transition: width $action-transition-duration $action-transition-timing-function, background $action-transition-duration $action-transition-timing-function;\r\n    -moz-transition: width $action-transition-duration $action-transition-timing-function, background $action-transition-duration $action-transition-timing-function;\r\n    -ms-transition: width $action-transition-duration $action-transition-timing-function, background $action-transition-duration $action-transition-timing-function;\r\n    background-color: #f8f9fa;\r\n    width: $sidebar-width-lg;\r\n    height: $navbar-height;\r\n    @media (max-width: 991px) {\r\n      width: 55px;\r\n    }\r\n\r\n    .navbar-brand {\r\n      color: #000;\r\n      font-size: 1.5rem;\r\n      line-height: 48px;\r\n      margin-right: 0;\r\n      padding: 0rem 0rem 0rem 1.3rem;\r\n      width: 100%;\r\n\r\n      &:active,\r\n      &:focus,\r\n      &:hover {\r\n        color: #fff;\r\n      }\r\n\r\n      img {\r\n        width: calc(#{$sidebar-width-lg} - 120px);\r\n        max-width: 100%;\r\n        height: 28px;\r\n        margin: auto;\r\n        vertical-align: middle;\r\n      }\r\n\r\n      &.brand-logo-mini {\r\n        display: none;\r\n\r\n        img {\r\n          width: calc(#{$sidebar-width-icon} - 50px);\r\n          max-width: 100%;\r\n          height: 28px;\r\n          margin: auto;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .navbar-menu-wrapper {\r\n    transition: width $action-transition-duration $action-transition-timing-function;\r\n    -webkit-transition: width $action-transition-duration $action-transition-timing-function;\r\n    -moz-transition: width $action-transition-duration $action-transition-timing-function;\r\n    -ms-transition: width $action-transition-duration $action-transition-timing-function;\r\n    box-shadow: none;\r\n    color: #000;\r\n    padding-left: 15px;\r\n    padding-right: 15px;\r\n    width: 100%;\r\n    height: $navbar-height;\r\n    @media (max-width: 991px) {\r\n      width: auto;\r\n      padding-left: 15px;\r\n      padding-right: 15px;\r\n    }\r\n\r\n    .navbar-toggler {\r\n      border: 0;\r\n      color: #6c757d;\r\n      height: $navbar-height;\r\n\r\n      &:not(.navbar-toggler-right) {\r\n        font-size: 0.875rem;\r\n        @media (max-width: 991px) {\r\n          display: none;\r\n        }\r\n      }\r\n\r\n      &.navbar-toggler-right {\r\n        @media (max-width: 991px) {\r\n          padding-left: 15px;\r\n          padding-right: 11px;\r\n          border-right: none;\r\n        }\r\n      }\r\n    }\r\n\r\n    .navbar-nav {\r\n      flex-direction: row;\r\n      align-items: center;\r\n\r\n      .nav-item {\r\n        .nav-link {\r\n          color: #000;\r\n          font-size: 1rem;\r\n          margin-left: 1rem;\r\n          margin-right: 1rem;\r\n          white-space: nowrap;\r\n          line-height: 1;\r\n\r\n          @media (max-width: 767px) {\r\n            margin-left: 0.8rem;\r\n            margin-right: 0.8rem;\r\n          }\r\n\r\n          &.create-new-button {\r\n            padding: 0.375rem 0.75rem;\r\n          }\r\n        }\r\n\r\n        &.dropdown {\r\n          .dropdown-menu {\r\n            margin-top: 1.15rem;\r\n            border: none;\r\n            background-color: #f8f9fa;\r\n          }\r\n        }\r\n\r\n        &.nav-profile {\r\n          .nav-link {\r\n            .nav-profile-img {\r\n              position: relative;\r\n              width: 32px;\r\n              height: 32px;\r\n\r\n              img {\r\n                width: 32px;\r\n                height: 32px;\r\n                border-radius: 100%;\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 991px) {\r\n  .navbar {\r\n    flex-direction: row;\r\n\r\n    .navbar-brand-wrapper {\r\n      width: 75px;\r\n\r\n      .navbar-brand {\r\n        &.brand-logo {\r\n          display: none;\r\n        }\r\n\r\n        &.brand-logo-mini {\r\n          display: inline-block;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .navbar {\r\n    .navbar-brand-wrapper {\r\n      width: 55px;\r\n\r\n      .brand-logo-mini {\r\n        padding-top: 0px;\r\n      }\r\n    }\r\n  }\r\n} ","/* Sidebar */\n\n.sidebar {\n  box-shadow:0 0.125rem 0.25rem rgb(0 0 0 / 8%) !important;\n  min-height: calc(100vh - #{$navbar-height});\n  background-color: black;\n  color: #000;\n  font-weight: normal;\n  padding: 0;\n  width: $sidebar-width-lg;\n  z-index: 11;\n  transition: width $action-transition-duration $action-transition-timing-function, background $action-transition-duration $action-transition-timing-function;\n  -webkit-transition: width $action-transition-duration $action-transition-timing-function, background $action-transition-duration $action-transition-timing-function;\n  -moz-transition: width $action-transition-duration $action-transition-timing-function, background $action-transition-duration $action-transition-timing-function;\n  -ms-transition: width $action-transition-duration $action-transition-timing-function, background $action-transition-duration $action-transition-timing-function;\n\n  .sidebar-brand-wrapper {\n    transition: width $action-transition-duration $action-transition-timing-function, background $action-transition-duration $action-transition-timing-function;\n    -webkit-transition: width $action-transition-duration $action-transition-timing-function, background $action-transition-duration $action-transition-timing-function;\n    -moz-transition: width $action-transition-duration $action-transition-timing-function, background $action-transition-duration $action-transition-timing-function;\n    -ms-transition: width $action-transition-duration $action-transition-timing-function, background $action-transition-duration $action-transition-timing-function;\n    background-color: rgba(0, 27, 11, 0.734);\n  color: #d5d8db;\n    width: $sidebar-width-lg;\n    height: $navbar-height;\n    @media (max-width: 991px) {\n      width: 55px;\n    }\n    .sidebar-brand {\n      color: lighten(color(gray-dark), 20%);\n      font-size: 1.5rem;\n      line-height: 48px;\n      margin-right: 0;\n      padding: 0rem 0rem 0rem 1.3rem;\n      width: 100%;\n\n      &:active,\n      &:focus,\n      &:hover {\n        color: lighten(color(gray-dark), 10%);\n      }\n\n      img {\n        width: calc(#{$sidebar-width-lg} - 120px );\n        max-width: 100%;\n        height: 28px;\n        margin: auto;\n        vertical-align: middle;\n      }\n      &.brand-logo-mini {\n        display: none;\n        img {\n          width: calc(#{$sidebar-width-icon} - 50px );\n          max-width: 100%;\n          height: 28px;\n          margin: auto;\n        }\n      }\n    }\n  }\n\n  .nav {\n    overflow: hidden;\n    flex-wrap: nowrap;\n    flex-direction: column;\n    margin-bottom: 60px;\n    padding-top: $navbar-height;\n    @media (max-width:992px) {\n      padding-top: 0;\n    }\n\n    .nav-item {\n      @include transition-duration(0.25s);\n      transition-property: background;\n      -webkit-transition-property: background;\n      padding-right: 20px;\n      .collapse {\n        z-index: 999;\n      }\n\n      .nav-link {\n        @include display-flex;\n        @include align-items(center);\n        white-space: nowrap;\n        padding: $sidebar-menu-padding-y 10px $sidebar-menu-padding-y $sidebar-menu-padding-x;\n        color: $sidebar-menu-color;\n        @include transition-duration(0.45s);\n        transition-property: color;\n        -webkit-transition-property: color;\n        height: 46px;\n        border-radius: 0px 100px 100px 0px;\n        cursor: pointer;\n        \n        i {\n          color: inherit;\n          &.menu-icon {\n            font-size: $sidebar-icon-font-size;\n            line-height: 1;\n            margin-left: auto;\n            .rtl & {\n              margin-left: 0;\n              margin-right: auto;\n            }\n            color: $sidebar-menu-icon-color;\n            &:before {\n              vertical-align: middle;\n            }\n          }\n          &.menu-arrow {\n            font: normal normal normal 24px/1 \"Material Design Icons\";\n            line-height: 1;\n            font-size: $sidebar-icon-font-size;\n            margin-left: auto;\n            .rtl & {\n              margin-left: 0;\n              margin-right: auto;\n            }\n            color: $sidebar-menu-arrow-color;\n            &:before{\n              content: \"\\f140\";\n              font-size: inherit;\n              color: inherit;\n            }\n          }\n        }\n        .menu-title {\n          color: inherit;\n          display: inline-block;\n          font-size: $sidebar-menu-font-size;\n          line-height: 1;\n          vertical-align: middle;\n        }\n        .badge {\n          margin-right: auto;\n          margin-left: 1rem;\n        }\n      }\n\n      &.active {\n        > .nav-link {\n          background: $sidebar-menu-active-bg;\n          position: relative;\n          &:before {\n            content: \"\";\n            width: 3px;\n            height: 100%;\n            background: theme-color(primary);\n            display: inline-block;\n            position: absolute;\n            left: 0;\n            top: 0;\n          }\n          .menu-title {\n            color: $sidebar-menu-active-color;        \n          }\n          i {\n            color: #ffffff;\n          }\n        }\n      }\n      &.nav-profile {\n        .nav-link {\n          height: auto;\n          line-height: 1;\n          border-top: 0;\n          padding: 1.25rem 0;\n          .nav-profile-image {\n            width: 44px;\n            height: 44px;\n            img {\n              width: 44px;\n              height: 44px;\n              border-radius: 100%;\n            }\n          }\n          .nav-profile-text {\n            margin-left: 1rem;\n            .rtl & {\n              margin-left: auto;\n              margin-right: 1rem;\n            }\n          }\n          .nav-profile-badge {\n            font-size: 1.125rem;\n            margin-left: auto;\n            .rtl & {\n              margin-left: 0;\n              margin-right: auto;\n            }\n          }\n        }\n      }\n      &.sidebar-actions {\n        margin-top: 1rem;\n        .nav-link {\n          border-top: 0;\n          display: block;\n          height: auto;\n        }\n        &:hover {\n          background: initial;\n          .nav-link {\n            color: initial;\n          }\n        }\n      }\n      &.profile {\n        padding-right: 0px;\n        .rtl & {\n          padding-right: 10px;\n        }\n        .profile-desc {\n          display: flex;\n          flex-direction: row;\n          align-items: center;\n          justify-content: space-between;\n          padding: 0.6rem 1.17rem;\n          line-height: 1.25;\n          .profile-name {\n            margin-left: 1rem;\n            .rtl & {\n              margin-left: 0;\n              margin-right: 1rem;\n            }\n            span {\n              font-size: 12px;\n              color: $text-muted;\n              white-space: nowrap;\n            }\n            h5 {\n              white-space: nowrap;\n            }\n          } \n          .profile-pic {\n            display: flex;\n            align-items: center;\n            .count-indicator {\n              position: relative;\n              .count-symbol,\n              .count-number {\n                position: absolute;\n                border-radius: 100%;\n                border: 2px solid $navbar-bg;\n              }\n              .count-symbol {\n                top: 17px;\n                right: -3px;\n                width: 10px;\n                height: 10px;\n              }\n              .count-number {\n                min-width: 14px;\n                height: 14px;\n                font-size: .5rem;\n                color: $white;\n                bottom: 16px;\n                right: -5px;\n                line-height: 1;\n                text-align: center;\n              }\n              &:after {\n                display: none;\n              }\n              .count {\n                position: absolute;\n                left: 66%;\n                width: 10px;\n                height: 10px;\n                color: $white;\n                border-radius: 100%;\n                text-align: center;\n                font-size: .625rem;\n                line-height: 1.5;\n                top: 26px;\n                border: 2px solid $border-color;\n              }\n            }\n          }\n          .mdi-dots-vertical {\n            font-size: 20px;\n            color: $text-muted;\n          }\n          .dropdown-menu {\n            padding: 0;\n            margin-top: 1.25rem;\n            .dropdown-item {\n              padding: 11px 13px;\n              &.preview-item {\n                align-items: center;\n                .preview-thumbnail {\n                  .preview-icon {\n                    width: 30px;\n                    height: 30px;\n                    i {\n                      font-size: 0.875rem;\n                    }\n                  }\n                }\n              }\n              &:hover {\n                color: inherit;\n              }\n            }\n            .dropdown-divider {\n              margin: 0;\n            }\n          }\n        }\n      }\n      &.nav-category {\n        padding: 0.5rem 1.188rem;\n        line-height: 1;\n        .nav-link {\n          color: $text-muted;\n          font-weight: $font-weight-medium;\n          font-size: 14px;\n          font-weight: 500;\n          height: auto;\n          padding-left: 0;\n          cursor: default;\n        }\n      }\n      .menu-icon {\n        margin-right: 0.5rem;\n        font-size: 0.8125rem;\n        line-height: 1;\n        background: rgba($text-muted, 0.2);\n        width: 31px;\n        height: 31px;\n        border-radius: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        color: #ffffff;\n        i {\n          font-size: 0.875rem;\n        }\n      }\n    }\n    &.sub-menu {\n      margin-bottom: 0;\n      margin-top:0;\n      padding: 0 0 0 3.25rem;\n      list-style: none;\n\n      .nav-item {\n        padding: 0;\n        .nav-link {\n          color: $sidebar-submenu-color;\n          padding: $sidebar-submenu-item-padding;\n          position: relative;\n          font-size: $sidebar-submenu-font-size;\n          line-height: 1;\n          height: auto;\n          border-top: 0;\n          &.active {\n            color: $sidebar-menu-active-color;\n            background: transparent;\n          }\n          &:hover {\n            color: $sidebar-submenu-hover-color;\n          }\n        }\n        &:hover {\n          background: transparent;\n        }\n      }\n    }\n    &:not(.sub-menu) {\n      >.nav-item {\n        &:hover {\n          &:not(.nav-category):not(.account-dropdown) {\n            >.nav-link {\n              background: $sidebar-menu-hover-bg;\n              color: $sidebar-menu-hover-color;\n            }\n          }\n        }\n      }\n    }\n      .menu-items {\n        &:nth-child(5n+1) {\n          .nav-link {\n            .menu-icon {\n              i {\n                color: theme-color(primary);\n              }\n            }\n          }\n        }\n  \n        &:nth-child(5n+2) {\n          .nav-link {\n            .menu-icon {\n              i {\n                color: theme-color(success);\n              }\n            }\n          }\n        }\n  \n        &:nth-child(5n+3) {\n          .nav-link {\n            .menu-icon {\n              i {\n                color: theme-color(info);\n              }\n            }\n          }\n        }\n  \n        &:nth-child(5n+4) {\n          .nav-link {\n            .menu-icon {\n              i {\n                color: theme-color(warning);\n              }\n            }\n          }\n        }\n  \n        &:nth-child(5n+5) {\n          .nav-link {\n            .menu-icon {\n              i {\n                color: theme-color(danger);\n              }\n            }\n          }\n        }\n      }\n    \n      \n    \n    \n  }\n}\n\n/* style for off-canvas menu*/\n@media screen and (max-width: 991px) {\n  .sidebar-offcanvas {\n    position: fixed;\n    max-height: calc(100vh - #{$navbar-height});\n    top: $navbar-height;\n    bottom: 0;\n    overflow: auto;\n    right: -$sidebar-width-lg;\n    -webkit-transition: all 0.25s ease-out;\n    -o-transition: all 0.25s ease-out;\n    transition: all 0.25s ease-out;\n    &.active {\n      right: 0;\n    }\n  }\n}","@import \"shared\";\n@import \"../functions\";\n\n// CSS Transitions\n// Currently only works in Webkit.\n//\n// * expected in CSS3, FireFox 3.6/7 and Opera Presto 2.3\n// * We'll be prepared.\n//\n// Including this submodule sets following defaults for the mixins:\n//\n//     $default-transition-property : all\n//     $default-transition-duration : 1s\n//     $default-transition-function : false\n//     $default-transition-delay    : false\n//\n// Override them if you like. Timing-function and delay are set to false for browser defaults (ease, 0s).\n\n$default-transition-property: all !default;\n\n$default-transition-duration: 1s !default;\n\n$default-transition-function: false !default;\n\n$default-transition-delay: false !default;\n\n$transitionable-prefixed-values: transform, transform-origin !default;\n\n// One or more properties to transition\n//\n// * for multiple, use a comma-delimited list\n// * also accepts \"all\" or \"none\"\n\n@mixin transition-property($property-1: $default-transition-property,\n  $property-2 : false,\n  $property-3 : false,\n  $property-4 : false,\n  $property-5 : false,\n  $property-6 : false,\n  $property-7 : false,\n  $property-8 : false,\n  $property-9 : false,\n  $property-10: false\n) {\n  @if type-of($property-1) == string { $property-1: unquote($property-1); }\n  $properties: compact($property-1, $property-2, $property-3, $property-4, $property-5, $property-6, $property-7, $property-8, $property-9, $property-10);\n  @if $experimental-support-for-webkit    {       -webkit-transition-property : prefixed-for-transition(-webkit, $properties); }\n  @if $experimental-support-for-mozilla   {          -moz-transition-property : prefixed-for-transition(-moz,    $properties); }\n  @if $experimental-support-for-opera     {            -o-transition-property : prefixed-for-transition(-o,      $properties); }\n                                                          transition-property : $properties;\n}\n\n// One or more durations in seconds\n//\n// * for multiple, use a comma-delimited list\n// * these durations will affect the properties in the same list position\n\n@mixin transition-duration($duration-1: $default-transition-duration,\n  $duration-2 : false,\n  $duration-3 : false,\n  $duration-4 : false,\n  $duration-5 : false,\n  $duration-6 : false,\n  $duration-7 : false,\n  $duration-8 : false,\n  $duration-9 : false,\n  $duration-10: false\n) {\n  @if type-of($duration-1) == string { $duration-1: unquote($duration-1); }\n  $durations: compact($duration-1, $duration-2, $duration-3, $duration-4, $duration-5, $duration-6, $duration-7, $duration-8, $duration-9, $duration-10);\n  @include experimental(transition-duration, $durations,\n    -moz, -webkit, -o, not(-ms), not(-khtml), official\n  );\n}\n\n// One or more timing functions\n//\n// * [ ease | linear | ease-in | ease-out | ease-in-out | cubic-bezier(x1, y1, x2, y2)]\n// * For multiple, use a comma-delimited list\n// * These functions will effect the properties in the same list position\n\n@mixin transition-timing-function($function-1: $default-transition-function,\n  $function-2 : false,\n  $function-3 : false,\n  $function-4 : false,\n  $function-5 : false,\n  $function-6 : false,\n  $function-7 : false,\n  $function-8 : false,\n  $function-9 : false,\n  $function-10: false\n) {\n  $function-1: unquote($function-1);\n  $functions: compact($function-1, $function-2, $function-3, $function-4, $function-5, $function-6, $function-7, $function-8, $function-9, $function-10);\n  @include experimental(transition-timing-function, $functions,\n    -moz, -webkit, -o, not(-ms), not(-khtml), official\n  );\n}\n\n// One or more transition-delays in seconds\n//\n// * for multiple, use a comma-delimited list\n// * these delays will effect the properties in the same list position\n\n@mixin transition-delay($delay-1: $default-transition-delay,\n  $delay-2 : false,\n  $delay-3 : false,\n  $delay-4 : false,\n  $delay-5 : false,\n  $delay-6 : false,\n  $delay-7 : false,\n  $delay-8 : false,\n  $delay-9 : false,\n  $delay-10: false\n) {\n  @if type-of($delay-1) == string { $delay-1: unquote($delay-1); }\n  $delays: compact($delay-1, $delay-2, $delay-3, $delay-4, $delay-5, $delay-6, $delay-7, $delay-8, $delay-9, $delay-10);\n  @include experimental(transition-delay, $delays,\n    -moz, -webkit, -o, not(-ms), not(-khtml), official\n  );\n}\n\n// Transition all-in-one shorthand\n\n@mixin single-transition(\n  $property: $default-transition-property,\n  $duration: $default-transition-duration,\n  $function: $default-transition-function,\n  $delay: $default-transition-delay\n) {\n  @include transition(compact($property $duration $function $delay));\n}\n\n@mixin transition(\n  $transition-1 : default,\n  $transition-2 : false,\n  $transition-3 : false,\n  $transition-4 : false,\n  $transition-5 : false,\n  $transition-6 : false,\n  $transition-7 : false,\n  $transition-8 : false,\n  $transition-9 : false,\n  $transition-10: false\n) {\n  @if $transition-1 == default {\n    $transition-1 : compact($default-transition-property $default-transition-duration $default-transition-function $default-transition-delay);\n  }\n  $transitions: false;\n  @if type-of($transition-1) == list and type-of(nth($transition-1,1)) == list {\n    $transitions: join($transition-1, compact($transition-2, $transition-3, $transition-4, $transition-5, $transition-6, $transition-7, $transition-8, $transition-9, $transition-10), comma);\n  } @else {\n    $transitions : compact($transition-1, $transition-2, $transition-3, $transition-4, $transition-5, $transition-6, $transition-7, $transition-8, $transition-9, $transition-10);\n  }\n  $delays: comma-list();\n  $has-delays: false;\n  $webkit-value: comma-list();\n  $moz-value: comma-list();\n  $o-value: comma-list();\n\n  // This block can be made considerably simpler at the point in time that\n  // we no longer need to deal with the differences in how delays are treated.\n  @each $transition in $transitions {\n    // Extract the values from the list\n    // (this would be cleaner if nth took a 3rd argument to provide a default value).\n    $property: nth($transition, 1);\n    $duration: false;\n    $timing-function: false;\n    $delay: false;\n    @if length($transition) > 1 { $duration:        nth($transition, 2); }\n    @if length($transition) > 2 { $timing-function: nth($transition, 3); }\n    @if length($transition) > 3 { $delay:           nth($transition, 4); $has-delays: true; }\n\n    // If a delay is provided without a timing function\n    @if is-time($timing-function) and not($delay) { $delay: $timing-function; $timing-function: false; $has-delays: true; }\n\n    // Keep a list of delays in case one is specified\n    $delays: append($delays, if($delay, $delay, 0s));\n\n    $webkit-value: append($webkit-value, compact((prefixed-for-transition(-webkit, $property) $duration $timing-function)...));\n       $moz-value: append(   $moz-value, compact((prefixed-for-transition(   -moz, $property) $duration $timing-function $delay)...));\n         $o-value: append(     $o-value, compact((prefixed-for-transition(     -o, $property) $duration $timing-function $delay)...));\n  }\n\n  @if $experimental-support-for-webkit    {       -webkit-transition : $webkit-value;\n    // old webkit doesn't support the delay parameter in the shorthand so we progressively enhance it.\n    @if $has-delays                       { -webkit-transition-delay : $delays;       } }\n  @if $experimental-support-for-mozilla   {          -moz-transition : $moz-value;    }\n  @if $experimental-support-for-opera     {            -o-transition : $o-value;      }\n                                                          transition : $transitions;\n}\n\n// coerce a list to be comma delimited or make a new, empty comma delimited list.\n@function comma-list($list: ()) {\n  @return join((), $list, comma);\n}\n\n// Returns `$property` with the given prefix if it is found in `$transitionable-prefixed-values`.\n@function prefixed-for-transition($prefix, $property) {\n  @if type-of($property) == list {\n    $new-list: comma-list();\n    @each $v in $property {\n      $new-list: append($new-list, prefixed-for-transition($prefix, $v));\n    }\n    @return $new-list;\n  } @else {\n    @if index($transitionable-prefixed-values, $property) {\n      @return #{$prefix}-#{$property};\n    } @else {\n      @return $property;\n    }\n  }\n}\n\n// Checks if the value given is a unit of time.\n@function is-time($value) {\n  @if type-of($value) == number {\n    @return not(not(index(s ms, unit($value))));\n  } @else {\n    @return false;\n  }\n}\n",".footer {\n  background-color: rgba(0, 27, 11, 0.734);\n  color: #d5d8db;\n  padding: 20px 1rem;\n  transition: all $action-transition-duration $action-transition-timing-function;\n  -moz-transition: all $action-transition-duration $action-transition-timing-function;\n  -webkit-transition: all $action-transition-duration $action-transition-timing-function;\n  -ms-transition: all $action-transition-duration $action-transition-timing-function;\n  width: 100%;\n  font-size: calc(#{$default-font-size} - 0.05rem);\n  font-family: $type1;\n  a {\n    color: theme-color(success);\n    font-size: inherit;\n  }\n  @media (max-width: 991px) {\n    margin-left: 0;\n    width: 100%;\n  }\n}\n","\n/* Layouts */\n\n.navbar {\n  &.fixed-top {\n    + .page-body-wrapper {\n      padding-top: $navbar-height;\n    }\n  }\n}\n\n// Sidebar Mini\n.sidebar-mini {\n  @media (min-width: 992px) {\n    .navbar {\n      left: $sidebar-width-mini;\n      .navbar-brand-wrapper {\n        width: $sidebar-width-mini;\n      }\n      .navbar-menu-wrapper {\n        width: 100%;\n      }\n    }\n    .sidebar {\n      width: $sidebar-width-mini;\n      .sidebar-brand-wrapper {\n        width: $sidebar-width-mini;\n      }\n      .nav {\n        .nav-item {\n          padding: 0;\n          margin: 0;\n          &.menu-items {\n            .nav-link {\n              .menu-icon {\n                margin-left: auto;\n                margin-right: auto;\n              }\n            }\n          }\n          .nav-link { \n            text-align: center;\n            position: relative;\n            .menu-title {\n              display: inline-block;\n            }\n            .menu-sub-title{\n              margin: auto;\n            }\n            .badge {\n              margin-left: 5px;\n              display: none;\n            }\n            i {\n              &.menu-icon {\n                display:block;\n                margin-right: auto;\n                margin-left: auto;\n              }\n              &.menu-arrow {\n                display: inline-block;\n                margin-left: 5px;\n                position: absolute;\n                top: 50%;\n                right: 10px;\n                @include transform(translateY(-50%));\n                &:before {\n                  content: \"\\F140\";\n                }\n              }\n            }\n            &[aria-expanded=\"true\"]{\n              .menu-arrow{\n                &:before{\n                  content: \"\\f143\";\n                }\n              }\n            }\n            .menu-icon {\n              margin-right: 1.25rem;\n              margin-left: 0;\n            }\n          }\n          &.nav-category {\n            display: none;\n          }\n          &.profile {\n            .profile-desc {\n              justify-content: center;\n              position: relative;\n              .profile-pic {\n                flex-direction: column;\n              }\n              .profile-name {\n                margin-left: 0;\n              }\n              .profile-dropdown {\n                position: absolute;\n                right: 10px;\n              }\n            }\n          }\n        }\n      }\n    }\n    &:not(.sidebar-icon-only) {\n      //Apply these styles only when sidebar-mini is not collapsed to icon-only mode\n      .sidebar {\n        .nav {\n          &:not(.sub-menu) {\n            > .nav-item {\n              border-bottom: 1px solid rgba($sidebar-menu-color, .2);\n              .nav-link {\n                display: block;\n                height: auto;\n                padding: $sidebar-mini-menu-padding;\n                i {\n                  &.menu-icon {\n                    margin-bottom: .5rem;\n                  }\n                }\n              }\n            }\n          }\n          &.sub-menu {\n            padding: 0;\n            border-top: none;\n            .nav-item {\n              .nav-link {\n                padding: 1rem 0rem;\n                margin-left: auto;\n                margin-right: auto;\n                text-align: center;\n              }\n            }\n          }\n          .nav-item {\n            &.account-dropdown {\n              p {\n                margin-left: 0;\n              }\n              .sub-menu {\n                padding: 0 0 1rem 0;\n                .nav-item {\n                  .nav-link {\n                    display: flex;\n                    justify-content: flex-start;\n                    padding: 0.3rem 0;\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    .page-body-wrapper {\n      width: calc(100% - #{$sidebar-width-mini});\n    }\n  }\n}\n\n// Sidebar Icon Only\n.sidebar-icon-only {\n  @media (min-width: 992px) {\n    .navbar {\n      left: $sidebar-width-icon;\n      .navbar-menu-wrapper {\n        width: 100%;\n      }\n    }\n    .sidebar {\n      width: $sidebar-width-icon;\n      .sidebar-brand-wrapper {\n        width: $sidebar-width-icon;\n        .brand-logo {\n          display: none;\n        }\n        .brand-logo-mini {\n          display: inline-block;\n        }\n      }\n      .nav {\n        overflow: visible;\n        .nav-item {\n          position: relative;\n          padding: 0;\n          .profile-name {\n            display: none;\n          }\n          .mdi-dots-vertical {\n            display: none;\n          }\n          &.account-dropdown {\n            display: none;\n          }\n          .nav-link {\n            text-align: center;\n            .menu-title,\n            .badge,.menu-sub-title {\n              display: none;\n            }\n            .menu-title {\n              @include border-radius(0 5px 5px 0px);\n              @at-root #{selector-append(\".rtl\", &)} {\n                @include border-radius(5px 0 0 5px);\n              }\n            }\n            i {\n              &.menu-icon {\n                margin-right: 0;\n                margin-left: 0;\n              }\n              &.menu-arrow {\n                display: none;\n              }\n            }\n            &[aria-expanded] {\n              .menu-title{\n                @include border-radius(0 5px 0 0px);\n                @at-root #{selector-append(\".rtl\", &)} {\n                  @include border-radius(5px 0 0 0);\n                }\n              }\n            }\n          }\n          &.nav-profile {\n            display: none;\n          }\n          &.nav-category {\n            display: none;\n          }\n          &.nav-doc {\n            margin: 0;\n            i {\n              display: block;\n            }\n          }\n          .collapse {\n            display: none;\n          }\n          &.hover-open {\n            .nav-link {\n              .menu-title {\n                @include display-flex;\n                @include align-items(center);\n                background: $icon-only-menu-bg;\n                padding: 0.5rem 1.4rem;\n                left: $sidebar-width-icon;\n                position: absolute;\n                text-align: left;\n                top: 0;\n                bottom: 0;\n                width: $icon-only-collapse-width;\n                z-index: 1;\n                line-height: 1.8;\n                @at-root #{selector-append(\".rtl\", &)} {\n                  left: auto;\n                  right: $sidebar-width-icon;\n                  text-align: left;\n                }\n                &:after {\n                  display: none;\n                }\n              }\n            }\n            .collapse,\n            .collapsing {\n              display: block;\n              padding: .5rem 0;\n              @include border-radius(0 0 5px 0);\n              background: $icon-only-menu-bg;\n              position: absolute;\n              left: $sidebar-width-icon;\n              width: $icon-only-collapse-width;\n              @at-root #{selector-append(\".rtl\", &)} {\n                  left: auto;\n                  right:$sidebar-width-icon;\n                  @include border-radius(0 0 0 5px);\n              }\n            }\n          }\n        }\n        &.sub-menu {\n          padding: $sidebar-icon-only-submenu-padding;\n          .nav-item {\n            .nav-link {\n              text-align: left;\n              padding-left: 20px;\n              &:before {\n                content: \"\";\n                display: inline-block;\n                width: 5px;\n                height: 5px;\n                border-radius: 50%;\n                background-color: $sidebar-submenu-color;\n                position: absolute;\n                left: 0;\n            }\n            &:hover {\n              &:before {\n                background-color: white;\n              }\n            }\n            }\n          }\n          @at-root #{selector-append(\".rtl\", &)} {\n            .nav-item {\n              margin-left: 0;\n              .nav-link {\n                text-align: right;\n                &:before{\n                  left: 0;\n                  right: unset;\n                }\n              }\n            }\n          }\n        }\n      }\n      .sidebar-actions {\n        display: none;\n      }\n    }\n    &.rtl {\n      .sidebar {\n        .nav {\n          .nav-item {\n            &.profile {\n              padding-right: 0;\n            }\n          }\n        }\n      }\n    }\n    .page-body-wrapper {\n      width: calc(100% - #{$sidebar-width-icon});\n      transition: all $action-transition-duration $action-transition-timing-function;\n      -webkit-transition: all $action-transition-duration $action-transition-timing-function;\n      -moz-transition: all $action-transition-duration $action-transition-timing-function;\n      -ms-transition: all $action-transition-duration $action-transition-timing-function;\n    }\n  }\n}\n\n// Hidden Sidebar\n.sidebar-hidden {\n  @media (min-width: 992px) {\n    .sidebar {\n      transition: width $action-transition-duration $action-transition-timing-function;\n      -webkit-transition: width $action-transition-duration $action-transition-timing-function;\n      -moz-transition: width $action-transition-duration $action-transition-timing-function;\n      -ms-transition: width $action-transition-duration $action-transition-timing-function;\n      width: 0;\n    }\n    .page-body-wrapper {\n      width: 100%;\n    }\n  }\n}\n\n// Absolute sidebar with overlay to content\n.sidebar-absolute {\n  @media (min-width: 992px) {\n    .page-body-wrapper {\n      width: 100%;\n      position: relative;\n    }\n    &:not(.sidebar-hidden) {\n      .sidebar {\n        position: absolute;\n        height: 100%;\n        -webkit-box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8);\n        /* Safari 3-4, iOS 4.0.2 - 4.2, Android 2.3+ */\n        -moz-box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8);\n        /* Firefox 3.5 - 3.6 */\n        box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8);\n        /* Opera 10.5, IE 9, Firefox 4+, Chrome 6+, iOS 5 */\n      }\n    }\n    .sidebar {\n      transition: none;\n    }\n  }\n}\n\n\n//Fixed sidebar\n.sidebar-fixed {\n  @media(min-width: 992px) {\n    .sidebar {\n      position: fixed;\n      max-height: auto;\n      .nav {\n        max-height: 100vh;\n        overflow: auto;\n        position: relative;\n        &.sub-menu {\n          max-height: none;\n        }\n      }\n    }\n    .page-body-wrapper {\n      margin-left: $sidebar-width-lg;\n    }\n    &.sidebar-icon-only {\n      .page-body-wrapper {\n        margin-left: $sidebar-width-icon;\n      }\n    }\n  }\n}\n\n//Boxed layout\n.boxed-layout {\n  @media (min-width: 1200px) {\n    .container-scroller {\n      background: #737373;\n      padding: 0 calc((100% - #{$boxed-container-width}) / 2);\n    }\n    .navbar {\n      right: calc((100% - #{$boxed-container-width}) / 2);\n      left:  calc(((100% - #{$boxed-container-width}) / 2) + #{$sidebar-width-lg});\n      &.fixed-top {\n        margin: auto;\n        max-width: $boxed-container-width;\n      }\n    }\n    .sidebar {\n      .sidebar-brand-wrapper {\n        left: calc((100% - #{$boxed-container-width}) / 2);\n      }\n    }\n    &.sidebar-icon-only {\n      .navbar{\n        left:  calc(((100% - #{$boxed-container-width}) / 2) + #{$sidebar-width-icon});\n      }\n    }\n  }\n}\n\n//RTL layout\n.rtl {\n  direction: rtl;\n  text-align: right;\n  .sidebar {\n    .sidebar-brand-wrapper {\n      .sidebar-brand {\n        padding: 0.25rem 1.3rem 0rem 0rem;\n      }\n    }\n    .nav {\n      padding-right: 0;\n      .nav-item {\n        &.account-dropdown {\n          .nav-link {\n            p {\n              margin-right: 1rem;\n            }\n          }\n        }\n        .nav-link {\n          .menu-icon {\n            margin-right: 0;\n            margin-left: .5em;\n          }\n        }\n      }\n      &.sub-menu {\n        padding: $rtl-sidebar-submenu-padding;\n      }\n    }\n  }\n\n  .product-chart-wrapper,\n  .settings-panel .tab-content .tab-pane .scroll-wrapper,\n  .sidebar-fixed .nav,\n  .table-responsive,\n  ul.chats {\n    &::-webkit-scrollbar {\n      width: 0.5em;\n    }\n    &::-webkit-scrollbar-track {\n      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);\n      box-shadow: inset 0 0 6px rgba(0,0,0,0.3);\n    }\n    &::-webkit-scrollbar-thumb {\n      background-color: darkgrey;\n      outline: 1px solid slategrey;\n    }\n  }\n  .navbar {\n    @media (min-width: 992px) {\n    right: $sidebar-width-lg;\n    left: 0;\n    transition:left $action-transition-duration $action-transition-timing-function;\n    -webkit-transition:right $action-transition-duration $action-transition-timing-function;\n    -moz-transition:right $action-transition-duration $action-transition-timing-function;\n    -ms-transition:right $action-transition-duration $action-transition-timing-function;\n    }\n    .navbar-brand-wrapper {\n      .navbar-brand {\n        padding: 0.25rem 1.3rem 0rem 0rem;\n      }\n    }\n    .navbar-menu-wrapper {\n      .navbar-nav {\n        padding: 0;\n        .nav-item {\n          .nav-link {\n            .navbar-profile {\n              .navbar-profile-name {\n                margin-right: 1rem;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  .dropdown-menu {\n    text-align: right;\n  }\n  &.sidebar-icon-only {\n    .navbar{\n      right: $sidebar-width-icon;\n    }\n    .sidebar {\n      .nav {\n        &.sub-menu {\n          .nav-item {\n            .nav-link {\n              padding-right: 20px;\n              &:before {\n                right: 0;\n                left: unset;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}","/**\n * Admin mobile-first theme v2 + horizontal table scroll fixes.\n * Scoped under .admin-theme-v2 on .admin-app\n */\n\n@supports selector(:has(*)) {\n  body:has(.admin-app.admin-theme-v2:not(.admin-theme-light)) {\n    background-color: #010409;\n    color: #e4e4e7;\n  }\n}\n\n$v2-bg-deep: #020617;\n$v2-bg-page: #030712;\n$v2-bg-panel: #0a0a0f;\n$v2-bg-card: #0c0f14;\n$v2-border: rgba(255, 255, 255, 0.06);\n$v2-text: #e2e8f0;\n$v2-text-muted: #94a3b8;\n$v2-accent: #22d3ee;\n$v2-accent-dim: rgba(34, 211, 238, 0.15);\n$v2-accent-strong: #06b6d4;\n$v2-danger: #f87171;\n$v2-success: #34d399;\n\n.admin-app.admin-theme-v2 {\n  background: $v2-bg-deep;\n  min-height: 100vh;\n}\n\n/* Login / full-page routes — same dark shell as panel; content is .lp-admin-login */\n.admin-app.admin-theme-v2.admin-full-page {\n  background: radial-gradient(900px 480px at 50% -15%, rgba(34, 211, 238, 0.1), transparent 55%),\n    linear-gradient(165deg, #070b14 0%, #0f172a 50%, #0a1628 100%);\n  min-height: 100vh;\n}\n\n.admin-app.admin-theme-v2.admin-full-page .page-body-wrapper,\n.admin-app.admin-theme-v2.admin-full-page .main-panel {\n  background: transparent;\n}\n\n.admin-app.admin-theme-v2.admin-full-page .content-wrapper.admin-content {\n  padding: 0 !important;\n  min-height: 100vh;\n  background: transparent !important;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .page-body-wrapper {\n  background: linear-gradient(180deg, $v2-bg-deep 0%, $v2-bg-page 35%, #0c1526 100%);\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .main-panel {\n  background: transparent;\n}\n\n/* ——— Sidebar (mobile drawer + desktop) ——— */\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-layout-sidebar {\n  background: linear-gradient(195deg, #111827 0%, $v2-bg-panel 55%, #0f172a 100%) !important;\n  border-left: 1px solid $v2-border !important;\n  box-shadow: -8px 0 32px rgba(0, 0, 0, 0.45);\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-layout-sidebar .admin-sidebar-logo {\n  background: rgba(15, 23, 42, 0.6);\n  border-bottom: 1px solid $v2-border;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-layout-sidebar .admin-sidebar-logo a {\n  color: $v2-text;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-layout-sidebar .admin-sidebar-nav .admin-sidebar-label {\n  color: #64748b;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-layout-sidebar .admin-sidebar-item {\n  color: $v2-text-muted;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-layout-sidebar .admin-sidebar-item:hover {\n  background: rgba(34, 211, 238, 0.08);\n  color: $v2-text;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-layout-sidebar .admin-sidebar-item.active {\n  background: $v2-accent-dim;\n  color: $v2-accent;\n  border: 1px solid rgba(34, 211, 238, 0.25);\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-layout-sidebar .admin-sidebar-sub {\n  border-left-color: rgba(34, 211, 238, 0.2);\n}\n\n/* ——— Navbar ——— */\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-layout-navbar {\n  background: rgba(15, 23, 42, 0.92) !important;\n  border-bottom: 1px solid $v2-border;\n  backdrop-filter: blur(10px);\n  padding: calc(0.5rem + env(safe-area-inset-top, 0px)) 1rem 0.5rem;\n}\n\n@media (min-width: 576px) {\n  .admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-layout-navbar {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-layout-navbar .admin-navbar-title {\n  color: $v2-text;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-layout-navbar .admin-navbar-user {\n  background: rgba(26, 39, 68, 0.9);\n  border-color: $v2-border;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-layout-navbar .admin-navbar-user-text {\n  color: $v2-text;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-layout-navbar .navbar-toggler {\n  color: $v2-accent;\n  border-color: rgba(34, 211, 238, 0.35);\n  border-radius: 10px;\n  padding: 0.45rem 0.55rem;\n}\n\n/* ——— Footer ——— */\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-layout-footer {\n  background: rgba(15, 23, 42, 0.95) !important;\n  border-top: 1px solid $v2-border;\n  color: $v2-text-muted;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-layout-footer a {\n  color: $v2-accent;\n}\n\n/* ——— Main content shell ——— */\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content {\n  background: radial-gradient(900px 420px at 15% -5%, rgba(34, 211, 238, 0.09), transparent 50%),\n    radial-gradient(700px 380px at 100% 10%, rgba(99, 102, 241, 0.08), transparent 45%),\n    linear-gradient(180deg, transparent, rgba(10, 15, 26, 0.5));\n  color: $v2-text;\n  padding: 1rem 0.75rem calc(2rem + env(safe-area-inset-bottom, 0px));\n}\n\n@media (min-width: 768px) {\n  .admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content {\n    padding: 1.5rem 1.5rem calc(2rem + env(safe-area-inset-bottom, 0px));\n  }\n}\n\n/* Cards & page headers */\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .admin-card,\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .card:not(.admin-card):not(.dashboard-card-link),\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .page-header {\n  background: $v2-bg-card !important;\n  border: 1px solid $v2-border !important;\n  color: $v2-text;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.25);\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .admin-card .card-header,\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .admin-card .admin-card-header,\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .card .card-header {\n  background: rgba(17, 24, 39, 0.6) !important;\n  color: $v2-text !important;\n  border-bottom-color: $v2-border !important;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .card-body,\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .admin-card .card-body {\n  background: $v2-bg-card !important;\n  color: $v2-text !important;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .card-title,\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .page-header h3,\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .page-header h4 {\n  color: $v2-text !important;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .text-muted,\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content p.page-subtitle {\n  color: $v2-text-muted !important;\n}\n\n/* Forms */\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .form-control {\n  background: rgba(10, 15, 26, 0.55);\n  border-color: $v2-border;\n  color: $v2-text;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .form-group label,\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .form-label {\n  color: $v2-text-muted;\n}\n\n/* Tables — readable on dark */\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .table {\n  color: $v2-text;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .table thead th {\n  background: rgba(17, 24, 39, 0.85) !important;\n  color: $v2-text-muted !important;\n  border-color: $v2-border !important;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .table tbody td {\n  border-color: rgba(148, 163, 184, 0.12) !important;\n  color: $v2-text;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .table tbody tr:hover {\n  background: rgba(34, 211, 238, 0.06) !important;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .table-striped tbody tr:nth-of-type(odd) {\n  background: rgba(15, 23, 42, 0.35);\n}\n\n/* ========== Critical: horizontal scroll (game history, user tabs, etc.) ========== */\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .table-responsive,\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .lp-user-view-table-wrap {\n  overflow-x: auto !important;\n  overflow-y: visible !important;\n  -webkit-overflow-scrolling: touch !important;\n  max-width: 100%;\n  width: 100%;\n  border-radius: 12px;\n  border: 1px solid $v2-border;\n  background: rgba(10, 15, 26, 0.35);\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .lp-user-view-table-wrap {\n  /* override earlier overflow:hidden from App.scss */\n  overflow-x: auto !important;\n  overflow-y: visible !important;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .table-responsive .table,\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .lp-user-view-table-wrap .table,\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .lp-user-view-table .table {\n  min-width: 640px;\n  margin-bottom: 0;\n}\n\n/* Buttons */\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .btn-primary {\n  background: linear-gradient(135deg, $v2-accent-strong, #0891b2) !important;\n  border-color: transparent !important;\n  color: #0f172a !important;\n  font-weight: 600;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .btn-success {\n  background: #059669 !important;\n  border-color: #059669 !important;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .btn-danger {\n  background: #dc2626 !important;\n  border-color: #dc2626 !important;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .btn-outline-secondary,\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .btn-secondary {\n  border-color: $v2-border;\n  color: $v2-text;\n  background: rgba(26, 39, 68, 0.5);\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .btn-outline-info {\n  color: $v2-accent;\n  border-color: rgba(34, 211, 238, 0.45);\n  background: rgba(34, 211, 238, 0.08);\n}\n\n/* User profile panels */\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .lp-admin-detail-card,\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .lp-user-view-hero {\n  background: $v2-bg-card !important;\n  border-color: $v2-border !important;\n  color: $v2-text !important;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .lp-user-view-stat {\n  background: rgba(10, 15, 26, 0.5);\n  border-color: $v2-border;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .lp-user-view-stat-label {\n  color: $v2-text-muted;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .lp-user-view-stat-value {\n  color: $v2-text;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .lp-admin-kv-item {\n  background: rgba(10, 15, 26, 0.45) !important;\n  border-color: $v2-border !important;\n  color: $v2-text !important;\n}\n\n/* Pagination */\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .pagination .page-link {\n  background: rgba(26, 39, 68, 0.8);\n  border-color: $v2-border;\n  color: $v2-text;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .pagination .page-item.active .page-link {\n  background: $v2-accent-strong !important;\n  border-color: $v2-accent !important;\n  color: #0f172a !important;\n}\n\n/* Mobile drawer backdrop */\n.admin-sidebar-backdrop {\n  display: none;\n  position: fixed;\n  inset: 0;\n  z-index: 998;\n  background: rgba(2, 6, 23, 0.55);\n  backdrop-filter: blur(2px);\n}\n\nbody.admin-sidebar-open .admin-sidebar-backdrop {\n  display: block;\n}\n\n@media (min-width: 992px) {\n  .admin-sidebar-backdrop {\n    display: none !important;\n  }\n}\n\n/* Sidebar z-index above backdrop */\n.admin-app.admin-theme-v2 .admin-layout-sidebar {\n  z-index: 1001;\n}\n\n/* Body lock only on small screens when drawer open (keeps desktop browser zoom / scroll free) */\n@media (max-width: 991.98px) {\n  body.admin-sidebar-open {\n    overflow: hidden;\n  }\n}\n\n/* Content area min height on small screens */\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .main-panel .content-wrapper.admin-content {\n  min-height: calc(100vh - 60px);\n}\n\n","/**\n * Light theme for admin panel (toggle: .admin-theme-light on .admin-app).\n * Polished sidebar + soft page background. Logged-in area only (not .admin-full-page).\n */\n\n@supports selector(:has(*)) {\n  body:has(.admin-app.admin-theme-v2.admin-theme-light) {\n    background-color: #f4f4f5;\n    color: #27272a;\n  }\n}\n\n.admin-app.admin-theme-v2.admin-theme-light {\n  background: #f4f4f5;\n}\n\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .page-body-wrapper {\n  background: linear-gradient(180deg, #f8fafc 0%, #eef2f7 40%, #e8edf5 100%);\n}\n\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .main-panel {\n  background: transparent;\n}\n\n/* ——— Sidebar (light, touch-friendly) ——— */\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-layout-sidebar {\n  background: linear-gradient(195deg, #ffffff 0%, #f8fafc 55%, #f1f5f9 100%) !important;\n  border-left: 1px solid rgba(15, 23, 42, 0.08) !important;\n  box-shadow: -6px 0 32px rgba(15, 23, 42, 0.06);\n}\n\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-layout-sidebar .admin-sidebar-logo {\n  background: #fff;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-layout-sidebar .admin-sidebar-logo a {\n  color: #0f172a;\n}\n\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-layout-sidebar .admin-sidebar-nav {\n  padding-bottom: calc(1rem + env(safe-area-inset-bottom, 0px));\n}\n\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-layout-sidebar .admin-sidebar-nav .admin-sidebar-label {\n  color: #64748b;\n  font-size: 0.68rem;\n  letter-spacing: 0.1em;\n}\n\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-layout-sidebar .admin-sidebar-item {\n  color: #334155;\n  border-radius: 10px;\n  margin-bottom: 2px;\n}\n\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-layout-sidebar .admin-sidebar-item:hover {\n  background: #eef2ff;\n  color: #4338ca;\n}\n\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-layout-sidebar .admin-sidebar-item.active {\n  background: linear-gradient(135deg, #eef2ff 0%, #e0e7ff 100%);\n  color: #4f46e5;\n  border: 1px solid rgba(79, 70, 229, 0.2);\n  font-weight: 600;\n}\n\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-layout-sidebar .admin-sidebar-sub {\n  border-left-color: #e2e8f0;\n}\n\n/* ——— Navbar ——— */\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-layout-navbar {\n  background: rgba(255, 255, 255, 0.92) !important;\n  border-bottom: 1px solid #e2e8f0;\n  backdrop-filter: blur(10px);\n  padding: calc(0.5rem + env(safe-area-inset-top, 0px)) 1rem 0.5rem;\n}\n\n@media (min-width: 576px) {\n  .admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-layout-navbar {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n}\n\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-layout-navbar .admin-navbar-title {\n  color: #0f172a;\n}\n\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-layout-navbar .admin-navbar-user {\n  background: #f8fafc;\n  border-color: #e2e8f0;\n}\n\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-layout-navbar .admin-navbar-user-text {\n  color: #334155;\n}\n\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-layout-navbar .navbar-toggler {\n  color: #4f46e5;\n  border-color: #e2e8f0;\n  border-radius: 10px;\n}\n\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-layout-navbar .admin-theme-toggle,\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-header-v3__icon-btn.admin-theme-toggle {\n  border-radius: 10px;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  color: #475569;\n  padding: 0.4rem 0.55rem;\n  line-height: 1;\n}\n\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-layout-navbar .admin-theme-toggle:hover,\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-header-v3__icon-btn.admin-theme-toggle:hover {\n  background: #f1f5f9;\n  border-color: #cbd5e1;\n  color: #0f172a;\n}\n\n/* ——— Footer ——— */\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-layout-footer {\n  background: #ffffff !important;\n  border-top: 1px solid #e2e8f0;\n}\n\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-layout-footer a {\n  color: #4f46e5;\n}\n\n/* ——— Content ——— */\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content {\n  background: radial-gradient(900px 400px at 12% -8%, rgba(99, 102, 241, 0.06), transparent 50%),\n    radial-gradient(700px 360px at 100% 0%, rgba(14, 165, 233, 0.05), transparent 45%),\n    transparent;\n  color: #1e293b;\n  padding: 1rem 0.75rem calc(1.5rem + env(safe-area-inset-bottom, 0px));\n}\n\n@media (min-width: 768px) {\n  .admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content {\n    padding: 1.5rem 1.5rem calc(2rem + env(safe-area-inset-bottom, 0px));\n  }\n}\n\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .admin-card,\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .card:not(.admin-card):not(.dashboard-card-link),\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .page-header {\n  background: #ffffff !important;\n  border: 1px solid #e2e8f0 !important;\n  color: #1e293b;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06), 0 8px 24px rgba(15, 23, 42, 0.04);\n}\n\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .admin-card .card-header,\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .admin-card .admin-card-header,\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .card .card-header {\n  background: #f8fafc !important;\n  color: #0f172a !important;\n  border-bottom-color: #e2e8f0 !important;\n}\n\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .card-body,\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .admin-card .card-body {\n  background: #ffffff !important;\n  color: #334155 !important;\n}\n\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .form-control {\n  background: #ffffff;\n  border-color: #e2e8f0;\n  color: #1e293b;\n}\n\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .table {\n  color: #334155;\n}\n\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .table thead th {\n  background: #f8fafc !important;\n  color: #64748b !important;\n  border-color: #e2e8f0 !important;\n}\n\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .table tbody td {\n  border-color: #f1f5f9 !important;\n}\n\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .table tbody tr:hover {\n  background: #f8fafc !important;\n}\n\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .table-responsive,\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .lp-user-view-table-wrap {\n  overflow-x: auto !important;\n  -webkit-overflow-scrolling: touch !important;\n  border-radius: 12px;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n}\n\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .table-responsive .table,\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .lp-user-view-table-wrap .table {\n  min-width: 640px;\n}\n\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .btn-primary {\n  background: #4f46e5 !important;\n  border-color: #4f46e5 !important;\n  color: #fff !important;\n}\n\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .pagination .page-link {\n  background: #fff;\n  border-color: #e2e8f0;\n  color: #475569;\n}\n\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .pagination .page-item.active .page-link {\n  background: #4f46e5 !important;\n  border-color: #4f46e5 !important;\n  color: #fff !important;\n}\n\nbody.admin-sidebar-open .admin-sidebar-backdrop {\n  background: rgba(15, 23, 42, 0.35);\n}\n\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .main-panel .content-wrapper.admin-content {\n  min-height: calc(100vh - 60px);\n}\n\n/* Dark mode: theme toggle visible on dark navbar */\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-layout-navbar .admin-theme-toggle,\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-header-v3__icon-btn.admin-theme-toggle {\n  border-radius: 10px;\n  border: 1px solid rgba(148, 163, 184, 0.25);\n  background: rgba(15, 23, 42, 0.5);\n  color: #e2e8f0;\n  padding: 0.4rem 0.55rem;\n  line-height: 1;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-layout-navbar .admin-theme-toggle:hover,\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-header-v3__icon-btn.admin-theme-toggle:hover {\n  background: rgba(34, 211, 238, 0.12);\n  border-color: rgba(34, 211, 238, 0.35);\n  color: #fff;\n}\n","/**\n * Pending / completed / rejected KYC tables — readable in light & dark theme.\n * Use wrapper .lp-kyc-page and table.lp-kyc-table (never .text-white on the whole table).\n */\n\n.lp-kyc-page .card-title {\n  color: inherit;\n}\n\n.lp-kyc-page .lp-kyc-table {\n  color: #e4e4e7;\n}\n\n.lp-kyc-page .lp-kyc-table thead th {\n  color: #a1a1aa !important;\n  border-color: rgba(255, 255, 255, 0.08) !important;\n  background: rgba(255, 255, 255, 0.04) !important;\n}\n\n.lp-kyc-page .lp-kyc-table tbody td {\n  border-color: rgba(255, 255, 255, 0.06) !important;\n  color: #e4e4e7;\n  vertical-align: middle;\n}\n\n.lp-kyc-page .lp-kyc-table tbody tr:hover {\n  background: rgba(255, 255, 255, 0.04) !important;\n}\n\n.lp-kyc-page .lp-kyc-table a:not(.btn) {\n  color: #7dd3fc;\n}\n\n.lp-kyc-page .lp-kyc-table .btn-primary {\n  color: #fff !important;\n}\n\n/* Light theme: dark text on white card */\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .lp-kyc-page .lp-kyc-table,\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .lp-kyc-page .lp-kyc-table tbody td {\n  color: #334155 !important;\n}\n\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .lp-kyc-page .lp-kyc-table thead th {\n  color: #64748b !important;\n  background: #f8fafc !important;\n  border-color: #e2e8f0 !important;\n}\n\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .lp-kyc-page .lp-kyc-table tbody td {\n  border-color: #f1f5f9 !important;\n}\n\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .lp-kyc-page .lp-kyc-table tbody tr:hover {\n  background: #f8fafc !important;\n}\n\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .lp-kyc-page .lp-kyc-table a:not(.btn) {\n  color: #0369a1 !important;\n}\n\n/* Same contrast if table sits outside .admin-content wrapper */\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .lp-kyc-page .lp-kyc-table,\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .lp-kyc-page .lp-kyc-table tbody td {\n  color: #334155 !important;\n}\n\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .lp-kyc-page .lp-kyc-table thead th {\n  color: #64748b !important;\n  background: #f8fafc !important;\n}\n\n/* User profile → KYC tab table */\n.lp-user-view .lp-kyc-table.table {\n  color: inherit;\n}\n\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .lp-user-view .lp-kyc-table.table,\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .lp-user-view .lp-kyc-table.table td,\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .lp-user-view .lp-kyc-table.table th {\n  color: #334155 !important;\n}\n\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .lp-user-view .lp-kyc-table.table thead th {\n  background: #f8fafc !important;\n  color: #64748b !important;\n}\n\n.lp-kyc-otp-details {\n  max-width: 280px;\n  line-height: 1.45;\n}\n\n.lp-kyc-otp-details .badge-info {\n  background: #0ea5e9;\n  color: #fff;\n}\n","/**\n * Slim compact UI: small radius cards, tight nav, black dark / clean light.\n * Load after theme files. Targets .admin-app.admin-theme-v2.\n */\n\n$slim-r: 10px;\n$slim-sidebar: 216px;\n\n/* ——— Shell width (align with App.scss 216px) ——— */\n.admin-app.admin-theme-v2 .admin-layout-sidebar {\n  width: $slim-sidebar !important;\n}\n\n@media (min-width: 992px) {\n  .admin-app.admin-theme-v2 .page-body-wrapper {\n    margin-right: $slim-sidebar !important;\n  }\n}\n\n/* ——— Sidebar: slim type + compact logo ——— */\n.admin-app.admin-theme-v2:not(.admin-full-page) .admin-layout-sidebar .admin-sidebar-logo {\n  padding: 0.65rem 0.85rem !important;\n}\n\n.admin-app.admin-theme-v2:not(.admin-full-page) .admin-layout-sidebar .admin-sidebar-logo a {\n  font-size: 0.82rem !important;\n  font-weight: 600 !important;\n  letter-spacing: 0.02em !important;\n  gap: 6px !important;\n}\n\n.admin-app.admin-theme-v2:not(.admin-full-page) .admin-layout-sidebar .admin-sidebar-logo a img {\n  height: 28px !important;\n  max-width: 88px !important;\n}\n\n.admin-app.admin-theme-v2:not(.admin-full-page) .admin-layout-sidebar .admin-sidebar-nav {\n  padding: 0.45rem 0.45rem 0.65rem !important;\n}\n\n.admin-app.admin-theme-v2:not(.admin-full-page) .admin-layout-sidebar .admin-sidebar-nav .admin-sidebar-label {\n  font-size: 0.6rem !important;\n  padding: 0.35rem 0.55rem 0.2rem !important;\n  margin-top: 0.35rem !important;\n  letter-spacing: 0.12em !important;\n}\n\n.admin-app.admin-theme-v2:not(.admin-full-page) .admin-layout-sidebar .admin-sidebar-item {\n  padding: 0.4rem 0.55rem !important;\n  font-size: 0.78rem !important;\n  font-weight: 500 !important;\n  border-radius: $slim-r !important;\n  margin-bottom: 1px !important;\n}\n\n.admin-app.admin-theme-v2:not(.admin-full-page) .admin-layout-sidebar .admin-sidebar-item .admin-sidebar-icon {\n  width: 18px !important;\n  height: 18px !important;\n  font-size: 0.95rem !important;\n}\n\n.admin-app.admin-theme-v2:not(.admin-full-page) .admin-layout-sidebar .admin-sidebar-sub .admin-sidebar-item {\n  padding: 0.32rem 0.5rem !important;\n  font-size: 0.74rem !important;\n}\n\n.admin-app.admin-theme-v2:not(.admin-full-page) .admin-layout-sidebar .admin-sidebar-sub {\n  margin-left: 0.65rem !important;\n  padding-left: 0.35rem !important;\n  border-left-width: 1px !important;\n}\n\n/* ——— Navbar slim ——— */\n.admin-app.admin-theme-v2:not(.admin-full-page) .admin-layout-navbar {\n  min-height: 46px !important;\n  padding-top: calc(0.32rem + env(safe-area-inset-top, 0px)) !important;\n  padding-bottom: 0.32rem !important;\n  padding-left: 0.65rem !important;\n  padding-right: 0.65rem !important;\n}\n\n@media (min-width: 576px) {\n  .admin-app.admin-theme-v2:not(.admin-full-page) .admin-layout-navbar {\n    padding-left: 0.85rem !important;\n    padding-right: 0.85rem !important;\n  }\n}\n\n.admin-app.admin-theme-v2:not(.admin-full-page) .admin-layout-navbar .admin-navbar-title {\n  font-size: 0.88rem !important;\n  font-weight: 600 !important;\n}\n\n.admin-app.admin-theme-v2:not(.admin-full-page) .admin-layout-navbar .admin-navbar-user {\n  padding: 0.28rem 0.5rem !important;\n  border-radius: $slim-r !important;\n}\n\n.admin-app.admin-theme-v2:not(.admin-full-page) .admin-layout-navbar .admin-navbar-user img {\n  width: 28px !important;\n  height: 28px !important;\n  border-radius: 6px !important;\n}\n\n.admin-app.admin-theme-v2:not(.admin-full-page) .admin-layout-navbar .admin-navbar-user-text {\n  font-size: 0.78rem !important;\n}\n\n.admin-app.admin-theme-v2:not(.admin-full-page) .admin-layout-navbar .admin-navbar-user-role {\n  font-size: 0.65rem !important;\n}\n\n.admin-app.admin-theme-v2:not(.admin-full-page) .admin-layout-navbar .admin-theme-toggle {\n  padding: 0.28rem 0.42rem !important;\n  border-radius: $slim-r !important;\n}\n\n.admin-app.admin-theme-v2:not(.admin-full-page) .admin-layout-navbar .navbar-toggler {\n  padding: 0.3rem 0.4rem !important;\n  border-radius: $slim-r !important;\n}\n\n/* ——— Content: tight cards + page header ——— */\n.admin-app.admin-theme-v2:not(.admin-full-page) .admin-content {\n  padding: 0.65rem 0.55rem calc(1rem + env(safe-area-inset-bottom, 0px)) !important;\n}\n\n@media (min-width: 768px) {\n  .admin-app.admin-theme-v2:not(.admin-full-page) .admin-content {\n    padding: 0.85rem 0.85rem calc(1.25rem + env(safe-area-inset-bottom, 0px)) !important;\n  }\n}\n\n.admin-app.admin-theme-v2:not(.admin-full-page) .admin-content .page-header {\n  border-radius: $slim-r !important;\n  padding: 0.65rem 0.85rem !important;\n  margin-bottom: 0.65rem !important;\n}\n\n.admin-app.admin-theme-v2:not(.admin-full-page) .admin-content .page-header h3,\n.admin-app.admin-theme-v2:not(.admin-full-page) .admin-content .page-header h4 {\n  font-size: 1rem !important;\n}\n\n.admin-app.admin-theme-v2:not(.admin-full-page) .admin-content .page-header .page-subtitle,\n.admin-app.admin-theme-v2:not(.admin-full-page) .admin-content p.page-subtitle {\n  font-size: 0.75rem !important;\n  margin-top: 0.2rem !important;\n}\n\n.admin-app.admin-theme-v2:not(.admin-full-page) .admin-content .admin-card,\n.admin-app.admin-theme-v2:not(.admin-full-page) .admin-content .card:not(.admin-card):not(.dashboard-card-link) {\n  border-radius: $slim-r !important;\n  margin-bottom: 0.65rem !important;\n}\n\n.admin-app.admin-theme-v2:not(.admin-full-page) .admin-content .admin-card .card-header,\n.admin-app.admin-theme-v2:not(.admin-full-page) .admin-content .admin-card .admin-card-header,\n.admin-app.admin-theme-v2:not(.admin-full-page) .admin-content .card .card-header {\n  padding: 0.5rem 0.65rem !important;\n  font-size: 0.8rem !important;\n}\n\n.admin-app.admin-theme-v2:not(.admin-full-page) .admin-content .admin-card .card-body,\n.admin-app.admin-theme-v2:not(.admin-full-page) .admin-content .card .card-body {\n  padding: 0.55rem 0.6rem !important;\n}\n\n.admin-app.admin-theme-v2:not(.admin-full-page) .admin-content .btn {\n  border-radius: $slim-r !important;\n  font-size: 0.78rem !important;\n  padding: 0.35rem 0.55rem !important;\n}\n\n.admin-app.admin-theme-v2:not(.admin-full-page) .admin-content .btn-sm {\n  padding: 0.28rem 0.45rem !important;\n  font-size: 0.72rem !important;\n}\n\n.admin-app.admin-theme-v2:not(.admin-full-page) .admin-content .form-control,\n.admin-app.admin-theme-v2:not(.admin-full-page) .admin-content .form-control-sm {\n  border-radius: $slim-r !important;\n  font-size: 0.8rem !important;\n  padding: 0.35rem 0.5rem !important;\n  min-height: 34px !important;\n}\n\n.admin-app.admin-theme-v2:not(.admin-full-page) .admin-content .badge {\n  font-size: 0.65rem !important;\n  padding: 0.2em 0.45em !important;\n  border-radius: 6px !important;\n}\n\n/* Dark: deeper black shell, slim card stroke */\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .page-body-wrapper {\n  background: linear-gradient(180deg, #010409 0%, #020617 40%, #030712 100%) !important;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-layout-sidebar {\n  background: linear-gradient(200deg, #020202 0%, #0a0a0c 50%, #050508 100%) !important;\n  border-left-color: rgba(255, 255, 255, 0.06) !important;\n  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.65) !important;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-layout-navbar {\n  background: rgba(2, 6, 23, 0.94) !important;\n  border-bottom-color: rgba(255, 255, 255, 0.06) !important;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .admin-card,\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .card:not(.admin-card):not(.dashboard-card-link),\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .page-header {\n  background: #0c0f14 !important;\n  border: 1px solid rgba(255, 255, 255, 0.06) !important;\n  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.03) inset !important;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .admin-card .card-header,\n.admin-app.admin-theme-v2:not(.admin-theme-light):not(.admin-full-page) .admin-content .card .card-header {\n  background: rgba(0, 0, 0, 0.35) !important;\n  border-bottom-color: rgba(255, 255, 255, 0.06) !important;\n}\n\n/* Light: airy minimal */\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .page-body-wrapper {\n  background: linear-gradient(180deg, #fafafa 0%, #f4f4f5 45%, #ececee 100%) !important;\n}\n\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-layout-sidebar {\n  background: #ffffff !important;\n  box-shadow: -2px 0 16px rgba(0, 0, 0, 0.04) !important;\n  border-left: 1px solid #e4e4e7 !important;\n}\n\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-layout-navbar {\n  background: rgba(255, 255, 255, 0.97) !important;\n  border-bottom: 1px solid #e4e4e7 !important;\n}\n\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .admin-card,\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .card:not(.admin-card):not(.dashboard-card-link),\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-content .page-header {\n  border: 1px solid #e4e4e7 !important;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04) !important;\n  border-radius: $slim-r !important;\n}\n\n.admin-app.admin-theme-v2.admin-theme-light:not(.admin-full-page) .admin-layout-footer {\n  padding: 0.45rem 0.85rem !important;\n  font-size: 0.75rem !important;\n}\n","/**\n * Pinch / browser zoom friendly + clearer mobile layout.\n * Import last. touch-action: auto on wide scrollers so zoom is not eaten.\n */\n\n.admin-app.admin-theme-v2 .admin-content .table-responsive,\n.admin-app.admin-theme-v2 .admin-content .lp-user-view-table-wrap {\n  touch-action: auto !important;\n}\n\n@media (max-width: 767.98px) {\n  .admin-app.admin-theme-v2:not(.admin-full-page) .admin-content {\n    font-size: 15px;\n    line-height: 1.5;\n    -webkit-text-size-adjust: 100%;\n  }\n\n  .admin-app.admin-theme-v2:not(.admin-full-page) .admin-content .page-header h3,\n  .admin-app.admin-theme-v2:not(.admin-full-page) .admin-content .page-header h4 {\n    font-size: 1.05rem !important;\n    line-height: 1.3 !important;\n  }\n\n  .admin-app.admin-theme-v2:not(.admin-full-page) .admin-content .page-header .page-subtitle,\n  .admin-app.admin-theme-v2:not(.admin-full-page) .admin-content p.page-subtitle {\n    font-size: 0.8rem !important;\n    line-height: 1.45 !important;\n  }\n\n  /* Dark: cards a bit lighter than pure black — easier to read */\n  .admin-app.admin-theme-v2:not(.admin-theme-light) .lp-allusers-card,\n  .admin-app.admin-theme-v2:not(.admin-theme-light) .lp-withdraw-card {\n    background: #151a22 !important;\n    border: 1px solid rgba(255, 255, 255, 0.1) !important;\n    border-radius: 12px !important;\n    padding: 0.9rem 0.85rem !important;\n    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.35);\n  }\n\n  .admin-app.admin-theme-v2:not(.admin-theme-light) .lp-allusers-card-name,\n  .admin-app.admin-theme-v2:not(.admin-theme-light) .lp-withdraw-card-title {\n    font-size: 0.95rem !important;\n  }\n\n  .admin-app.admin-theme-v2:not(.admin-theme-light) .lp-allusers-card-grid dd,\n  .admin-app.admin-theme-v2:not(.admin-theme-light) .lp-withdraw-card-grid dd {\n    font-size: 0.88rem !important;\n  }\n\n  /* Light: airy cards */\n  .admin-app.admin-theme-v2.admin-theme-light .lp-allusers-card,\n  .admin-app.admin-theme-v2.admin-theme-light .lp-withdraw-card {\n    border-radius: 12px !important;\n    padding: 0.9rem 0.85rem !important;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06) !important;\n    border-color: #e4e4e7 !important;\n  }\n\n  .admin-app.admin-theme-v2:not(.admin-full-page) .lp-allusers-stats,\n  .admin-app.admin-theme-v2:not(.admin-full-page) .lp-allusers-mobile,\n  .admin-app.admin-theme-v2:not(.admin-full-page) .lp-withdraw-mobile {\n    gap: 0.65rem;\n  }\n\n  .admin-app.admin-theme-v2:not(.admin-full-page) .lp-allusers-card-actions .btn,\n  .admin-app.admin-theme-v2:not(.admin-full-page) .lp-withdraw-card-actions .btn {\n    min-height: 40px;\n    font-size: 0.82rem !important;\n  }\n}\n","/**\n * Admin shell v3 — left sidebar, offcanvas mobile, modern header.\n */\n\n$admin-sidebar-w: 260px;\n$admin-header-h: 64px;\n$admin-accent: #4f46e5;\n$admin-accent-soft: #eef2ff;\n\n/* ——— Layout: sidebar LEFT (override legacy right rail) ——— */\n.admin-app.admin-shell-v3 {\n  .admin-layout-sidebar {\n    z-index: 1050;\n    left: 0 !important;\n    right: auto !important;\n    width: $admin-sidebar-w;\n    transform: translateX(-100%);\n    transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1);\n    box-shadow: none;\n    border-left: none !important;\n    border-right: 1px solid #e2e8f0;\n  }\n\n  .admin-layout-sidebar.is-offcanvas-open {\n    transform: translateX(0);\n    box-shadow: 4px 0 24px rgba(15, 23, 42, 0.12);\n  }\n\n  @media (min-width: 992px) {\n    .admin-layout-sidebar {\n      transform: translateX(0) !important;\n      box-shadow: none !important;\n    }\n  }\n\n  .page-body-wrapper {\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n    padding-top: $admin-header-h;\n    min-height: 100vh;\n  }\n\n  @media (min-width: 992px) {\n    .page-body-wrapper {\n      margin-left: $admin-sidebar-w !important;\n    }\n  }\n\n  .main-panel {\n    width: 100%;\n    min-height: calc(100vh - #{$admin-header-h});\n    /* Legacy _misc.scss adds padding-top: 70px — header offset is already on page-body-wrapper */\n    padding-top: 0 !important;\n  }\n\n  .content-wrapper.admin-content {\n    padding: 0 !important;\n  }\n}\n\n/* Offcanvas backdrop */\n.admin-offcanvas-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1040;\n  background: rgba(15, 23, 42, 0.45);\n  backdrop-filter: blur(3px);\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n  transition: opacity 0.25s ease, visibility 0.25s ease;\n}\n\n.admin-offcanvas-backdrop.is-visible {\n  opacity: 1;\n  visibility: visible;\n  pointer-events: auto;\n}\n\n@media (min-width: 992px) {\n  .admin-offcanvas-backdrop {\n    display: none !important;\n  }\n}\n\nbody.admin-offcanvas-open {\n  overflow: hidden;\n}\n\n@media (min-width: 992px) {\n  body.admin-offcanvas-open {\n    overflow: auto;\n  }\n}\n\n/* ——— Sidebar interior ——— */\n.admin-layout-sidebar {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  height: 100dvh;\n}\n\n.admin-sidebar-top {\n  flex-shrink: 0;\n  padding: 1rem 1rem 0.75rem;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.admin-sidebar-top-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n  margin-bottom: 0.75rem;\n}\n\n.admin-sidebar-brand {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  text-decoration: none !important;\n  color: inherit;\n  min-width: 0;\n}\n\n.admin-sidebar-brand-mark {\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  background: linear-gradient(135deg, $admin-accent 0%, #6366f1 100%);\n  color: #fff;\n  font-weight: 800;\n  font-size: 0.85rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  letter-spacing: -0.03em;\n}\n\n.admin-sidebar-brand-text {\n  font-weight: 700;\n  font-size: 0.95rem;\n  letter-spacing: -0.02em;\n  color: #0f172a;\n  line-height: 1.2;\n}\n\n.admin-sidebar-brand-sub {\n  font-size: 0.65rem;\n  color: #64748b;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n\n.admin-sidebar-close {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  background: #f8fafc;\n  color: #64748b;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n@media (min-width: 992px) {\n  .admin-sidebar-close {\n    display: none;\n  }\n}\n\n.admin-sidebar-search-wrap {\n  position: relative;\n}\n\n.admin-sidebar-search {\n  width: 100%;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 0.5rem 0.75rem 0.5rem 2.25rem;\n  font-size: 0.85rem;\n  background: #f8fafc;\n  color: #0f172a;\n}\n\n.admin-sidebar-search:focus {\n  outline: none;\n  border-color: $admin-accent;\n  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.12);\n  background: #fff;\n}\n\n.admin-sidebar-search-icon {\n  position: absolute;\n  left: 0.75rem;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #94a3b8;\n  font-size: 1rem;\n  pointer-events: none;\n}\n\n.admin-sidebar-nav {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 0.75rem 0.65rem 1rem;\n  -webkit-overflow-scrolling: touch;\n}\n\n.admin-sidebar-nav.is-filter-empty::after {\n  content: \"No menu match\";\n  display: block;\n  text-align: center;\n  color: #94a3b8;\n  font-size: 0.85rem;\n  padding: 1.5rem 0.5rem;\n}\n\n.admin-sidebar-item.is-nav-hidden {\n  display: none !important;\n}\n\n.admin-sidebar-parent.is-nav-hidden {\n  display: none !important;\n}\n\n.admin-sidebar-label.is-nav-hidden {\n  display: none !important;\n}\n\n/* ——— Header v3 ——— */\n.admin-header-v3 {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 1030;\n  height: $admin-header-h;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0 1rem;\n  background: rgba(255, 255, 255, 0.92);\n  border-bottom: 1px solid #e2e8f0;\n  backdrop-filter: blur(12px);\n  box-shadow: 0 1px 0 rgba(15, 23, 42, 0.04);\n}\n\n@media (min-width: 992px) {\n  .admin-header-v3 {\n    left: $admin-sidebar-w;\n    padding: 0 1.5rem;\n  }\n}\n\n.admin-header-v3__menu {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  background: #f8fafc;\n  color: #475569;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n@media (min-width: 992px) {\n  .admin-header-v3__menu {\n    display: none;\n  }\n}\n\n.admin-header-v3__menu .mdi {\n  font-size: 1.35rem;\n}\n\n.admin-header-v3__titles {\n  flex: 1;\n  min-width: 0;\n}\n\n.admin-header-v3__breadcrumb {\n  font-size: 0.68rem;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  font-weight: 600;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.admin-header-v3__title {\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: #0f172a;\n  letter-spacing: -0.02em;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin: 0;\n  line-height: 1.25;\n}\n\n.admin-header-v3__actions {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n  flex-shrink: 0;\n}\n\n.admin-header-v3__icon-btn,\n.admin-header-v3__icon-btn.admin-theme-toggle {\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  border: 1px solid #e2e8f0;\n  background: #f8fafc;\n  color: #475569;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  padding: 0;\n  line-height: 1;\n}\n\n.admin-header-v3__icon-btn .mdi {\n  font-size: 1.25rem;\n}\n\n.admin-header-v3__icon-btn:hover {\n  background: $admin-accent-soft;\n  border-color: rgba(79, 70, 229, 0.25);\n  color: $admin-accent;\n}\n\n.admin-header-v3__user {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.35rem 0.5rem 0.35rem 0.35rem;\n  border-radius: 12px;\n  border: 1px solid #e2e8f0;\n  background: #f8fafc;\n  cursor: pointer;\n  max-width: 200px;\n}\n\n.admin-header-v3__user img {\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  object-fit: cover;\n}\n\n.admin-header-v3__user-name {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: #334155;\n  line-height: 1.2;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.admin-header-v3__user-role {\n  font-size: 0.68rem;\n  color: #64748b;\n}\n\n/* Dark theme shell */\n.admin-app.admin-theme-v2.admin-shell-v3:not(.admin-theme-light):not(.admin-full-page) {\n  .admin-layout-sidebar {\n    background: linear-gradient(195deg, #111827 0%, #0a0a0f 55%, #0f172a 100%) !important;\n    border-right-color: rgba(255, 255, 255, 0.06) !important;\n  }\n\n  .admin-sidebar-top {\n    border-bottom-color: rgba(255, 255, 255, 0.06);\n  }\n\n  .admin-sidebar-brand-text {\n    color: #f4f4f5;\n  }\n\n  .admin-sidebar-search {\n    background: rgba(15, 23, 42, 0.6);\n    border-color: rgba(255, 255, 255, 0.08);\n    color: #e2e8f0;\n  }\n\n  .admin-sidebar-close,\n  .admin-header-v3__menu,\n  .admin-header-v3__icon-btn {\n    background: rgba(26, 39, 68, 0.8);\n    border-color: rgba(255, 255, 255, 0.08);\n    color: #94a3b8;\n  }\n\n  .admin-header-v3 {\n    background: rgba(15, 23, 42, 0.92);\n    border-bottom-color: rgba(255, 255, 255, 0.06);\n  }\n\n  .admin-header-v3__title {\n    color: #f4f4f5;\n  }\n\n  .admin-header-v3__user {\n    background: rgba(26, 39, 68, 0.9);\n    border-color: rgba(255, 255, 255, 0.08);\n  }\n\n  .admin-header-v3__user-name {\n    color: #e2e8f0;\n  }\n}\n\n/* Sidebar theme toggle (mobile + desktop) */\n.admin-sidebar-footer {\n  flex-shrink: 0;\n  padding: 0.75rem 1rem 1rem;\n  border-top: 1px solid #e2e8f0;\n}\n\n.admin-sidebar-theme-btn {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 0.55rem 0.75rem;\n  border-radius: 10px;\n  border: 1px solid #e2e8f0;\n  background: #f8fafc;\n  color: #475569;\n  font-size: 0.8rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.admin-sidebar-theme-btn:hover {\n  background: $admin-accent-soft;\n  border-color: rgba(79, 70, 229, 0.25);\n  color: $admin-accent;\n}\n\n.admin-sidebar-theme-btn .mdi {\n  font-size: 1.1rem;\n}\n\n/* Light theme polish */\n.admin-app.admin-shell-v3.admin-theme-light {\n  .admin-layout-sidebar {\n    background: #ffffff !important;\n  }\n\n  .admin-sidebar-footer {\n    border-top-color: #e2e8f0;\n  }\n\n  .admin-sidebar-theme-btn {\n    background: #f8fafc;\n    border-color: #e2e8f0;\n    color: #475569;\n  }\n}\n\n/* Dark mode — main content (override App.scss light defaults) */\n.admin-app.admin-theme-v2.admin-shell-v3:not(.admin-theme-light):not(.admin-full-page) {\n  .page-body-wrapper {\n    background: #0b1220 !important;\n  }\n\n  .main-panel {\n    background: #0b1220;\n  }\n\n  .admin-content {\n    background: #0b1220 !important;\n    color: #e2e8f0 !important;\n    --admin-bg: #0b1220;\n    --admin-card-bg: #1e293b;\n    --admin-border: rgba(255, 255, 255, 0.08);\n    --admin-text: #f1f5f9;\n    --admin-text-muted: #94a3b8;\n  }\n\n  .admin-content .card,\n  .admin-content .admin-card,\n  .admin-content .settings-card,\n  .admin-content .fake-battle-card,\n  .admin-content .danger-zone-card {\n    background: #1e293b !important;\n    border-color: rgba(255, 255, 255, 0.08) !important;\n    color: #e2e8f0 !important;\n  }\n\n  .admin-content .card-header,\n  .admin-content .admin-card .card-header,\n  .admin-content .admin-card-header {\n    background: #111827 !important;\n    color: #f1f5f9 !important;\n    border-bottom-color: rgba(255, 255, 255, 0.08) !important;\n  }\n\n  .admin-content .card-body {\n    background: #1e293b !important;\n    color: #cbd5e1 !important;\n  }\n\n  .admin-content .form-control,\n  .admin-content .form-select,\n  .admin-content select.form-control {\n    background: #0f172a !important;\n    border-color: rgba(255, 255, 255, 0.12) !important;\n    color: #f1f5f9 !important;\n  }\n\n  .admin-content .table {\n    color: #cbd5e1 !important;\n  }\n\n  .admin-content .table thead th {\n    background: #111827 !important;\n    color: #94a3b8 !important;\n    border-color: rgba(255, 255, 255, 0.08) !important;\n  }\n\n  .admin-content .table tbody td {\n    border-color: rgba(255, 255, 255, 0.06) !important;\n    color: #e2e8f0 !important;\n  }\n\n  .admin-content .table tbody tr:hover {\n    background: rgba(255, 255, 255, 0.04) !important;\n  }\n\n  .admin-content .text-muted,\n  .admin-content .text-secondary {\n    color: #94a3b8 !important;\n  }\n\n  .admin-content h1,\n  .admin-content h2,\n  .admin-content h3,\n  .admin-content h4,\n  .admin-content h5,\n  .admin-content .text-dark {\n    color: #f1f5f9 !important;\n  }\n\n  .admin-sidebar-footer {\n    border-top-color: rgba(255, 255, 255, 0.06);\n  }\n\n  .admin-sidebar-theme-btn {\n    background: rgba(26, 39, 68, 0.9);\n    border-color: rgba(255, 255, 255, 0.08);\n    color: #cbd5e1;\n  }\n\n  .admin-sidebar-theme-btn:hover {\n    background: rgba(79, 70, 229, 0.2);\n    border-color: rgba(129, 140, 248, 0.35);\n    color: #e0e7ff;\n  }\n}\n\n/* Content padding — single top offset from fixed header (page-body-wrapper only) */\n.admin-app.admin-shell-v3.admin-theme-v2:not(.admin-full-page) .admin-content {\n  padding-top: 0.5rem !important;\n  padding-left: 0.75rem !important;\n  padding-right: 0.75rem !important;\n  padding-bottom: calc(1.25rem + env(safe-area-inset-bottom, 0px)) !important;\n}\n\n@media (min-width: 768px) {\n  .admin-app.admin-shell-v3.admin-theme-v2:not(.admin-full-page) .admin-content {\n    padding-top: 0.65rem !important;\n    padding-left: 1rem !important;\n    padding-right: 1rem !important;\n    padding-bottom: calc(1.5rem + env(safe-area-inset-bottom, 0px)) !important;\n  }\n}\n\n.admin-shell-v3 .admin-layout-footer {\n  margin-top: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
